// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { accountingExportExportGcfAccounting, adminCheckEmailAvailable, adminCompanySecurityExportCompanySecurityAudit, adminCompanySecurityResetCompanySsoSessions, adminCompanySsoCheckCompanyDomainVerification, adminCompanySsoConfigureCompanySsoConnection, adminCompanySsoGetCompanySsoConfig, adminCompanySsoGetCompanySsoConnection, adminCompanySsoGetCompanySsoLockReadiness, adminCompanySsoGetCompanySsoTestConnection, adminCompanySsoRotateCompanyScimToken, adminCompanySsoStartCompanyDomainVerification, adminCompanySsoStartCompanySsoTestConnection, adminCompanySsoUpdateCompanyScimSettings, adminCompanySsoUpdateCompanySsoPolicy, aiGivingGetMyAiGivingLimit, aiGivingSetMyAiGivingLimit, apiCreatePaymentSessionFromUrl, apiTestFlight, appGetMinimumVersion, assistantCancelAssistantTurn, assistantConfirmAssistantEscalation, assistantCreateAssistantConversation, assistantDeleteAssistantConversation, assistantGetAssistantConfig, assistantGetAssistantConsent, assistantGetAssistantConversation, assistantGetAssistantEscalationAdmin, assistantGetAssistantSuperadminConfig, assistantGetAssistantUsageAdmin, assistantListAssistantConversations, assistantListAssistantEscalationsAdmin, assistantListAssistantFeedbackAdmin, assistantListAssistantTurnEventsAdmin, assistantListAssistantTurnsAdmin, assistantListAssistantTurnToolCallsAdmin, assistantProposeAssistantEscalation, assistantRecordAssistantConsent, assistantResolveAssistantEscalationAdmin, assistantSendAssistantMessage, assistantStreamAssistantTurn, assistantSubmitAssistantFeedback, assistantUpdateAssistantSuperadminConfig, birthdayGiftsCancelBirthdayGift, birthdayGiftsCreateBirthdayGift, birthdayGiftsGetBirthdayGift, birthdayGiftsListBirthdayGifts, birthdayGiftsUpdateBirthdayGift, boardDirectorAcknowledgeBoardRecord, boardDirectorCreateBoardDirectorAnnotation, boardDirectorDeleteBoardDirectorAnnotation, boardDirectorGetBoardAbout, boardDirectorGetBoardCompensationDocumentDownloadForDirector, boardDirectorGetBoardDirectorAttention, boardDirectorGetBoardDirectorAttentionCompleted, boardDirectorGetBoardDirectorConsent, boardDirectorGetBoardDirectorFilingReceiptDownloadUrl, boardDirectorGetBoardDirectorMe, boardDirectorGetBoardDirectorMeeting, boardDirectorGetBoardDirectorMeetingCalendar, boardDirectorGetBoardDirectorMeetingRecord, boardDirectorGetBoardDirectorPacket, boardDirectorGetBoardDirectorPacketDocumentDownloadUrl, boardDirectorGetBoardDirectorRecord, boardDirectorGetBoardReturnCopyForDirector, boardDirectorGetBoardSelfAssessmentResultsForDirector, boardDirectorGetOwnBoardCoiQuestionnaire, boardDirectorGetOwnBoardCoiResponse, boardDirectorGetOwnBoardCoiResponseChanges, boardDirectorGetOwnBoardCoiResponseDocument, boardDirectorGetOwnBoardGettingStarted, boardDirectorGetOwnBoardSelfAssessmentQuestions, boardDirectorListBoardDirectorAnnotations, boardDirectorListBoardDirectorConsents, boardDirectorListBoardDirectorMeetings, boardDirectorListBoardDirectorRecords, boardDirectorListBoardDirectorUpcomingMeetings, boardDirectorListOwnBoardCoiCycles, boardDirectorListOwnBoardConflictDisclosures, boardDirectorListOwnBoardSelfAssessments, boardDirectorMarkOwnBoardGettingStartedStep, boardDirectorOpenBoardReturnCopyForDirector, boardDirectorOrgAcknowledgeBoardRecord, boardDirectorOrgClaimBoardSeat, boardDirectorOrgCompleteBoardSeatMove, boardDirectorOrgCreateBoardDirectorAnnotation, boardDirectorOrgDeleteBoardDirectorAnnotation, boardDirectorOrgGetBoardAbout, boardDirectorOrgGetBoardCompensationDocumentDownloadForDirector, boardDirectorOrgGetBoardDirectorAttention, boardDirectorOrgGetBoardDirectorAttentionCompleted, boardDirectorOrgGetBoardDirectorConsent, boardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrl, boardDirectorOrgGetBoardDirectorMe, boardDirectorOrgGetBoardDirectorMeeting, boardDirectorOrgGetBoardDirectorMeetingCalendar, boardDirectorOrgGetBoardDirectorMeetingRecord, boardDirectorOrgGetBoardDirectorPacket, boardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrl, boardDirectorOrgGetBoardDirectorRecord, boardDirectorOrgGetBoardReturnCopyForDirector, boardDirectorOrgGetBoardSelfAssessmentResultsForDirector, boardDirectorOrgGetOwnBoardCoiQuestionnaire, boardDirectorOrgGetOwnBoardCoiResponse, boardDirectorOrgGetOwnBoardCoiResponseChanges, boardDirectorOrgGetOwnBoardCoiResponseDocument, boardDirectorOrgGetOwnBoardGettingStarted, boardDirectorOrgGetOwnBoardSelfAssessmentQuestions, boardDirectorOrgListBoardDirectorAnnotations, boardDirectorOrgListBoardDirectorConsents, boardDirectorOrgListBoardDirectorMeetings, boardDirectorOrgListBoardDirectorRecords, boardDirectorOrgListBoardDirectorUpcomingMeetings, boardDirectorOrgListOwnBoardCoiCycles, boardDirectorOrgListOwnBoardConflictDisclosures, boardDirectorOrgListOwnBoardSelfAssessments, boardDirectorOrgMarkOwnBoardGettingStartedStep, boardDirectorOrgOpenBoardReturnCopyForDirector, boardDirectorOrgPreviewBoardInvitation, boardDirectorOrgPreviewBoardSeatMove, boardDirectorOrgRecordBoardDirectorAttendanceIntent, boardDirectorOrgRecordOwnBoardConflictDisclosure, boardDirectorOrgRequestBoardSeatClaimCode, boardDirectorOrgRequestBoardSeatMoveCode, boardDirectorOrgRevokeBoardWrittenConsentSignature, boardDirectorOrgSaveOwnBoardSelfAssessmentAnswers, boardDirectorOrgSignBoardMinutes, boardDirectorOrgSignBoardMinutesToApprove, boardDirectorOrgSignBoardWrittenConsent, boardDirectorOrgStartBoardSeatMove, boardDirectorOrgSubmitOwnBoardCoiResponse, boardDirectorRecordBoardDirectorAttendanceIntent, boardDirectorRecordOwnBoardConflictDisclosure, boardDirectorRevokeBoardWrittenConsentSignature, boardDirectorSaveOwnBoardSelfAssessmentAnswers, boardDirectorSignBoardMinutes, boardDirectorSignBoardMinutesToApprove, boardDirectorSignBoardWrittenConsent, boardDirectorStartBoardSeatMove, boardDirectorSubmitOwnBoardCoiResponse, booksActivateBooks, booksGetBooks, campaignsAcceptCampaignLayerInvite, campaignsApproveCampaignJoinRequest, campaignsApproveCampaignLayerRequest, campaignsAttachCampaignLayer, campaignsCreateCampaignJoinInvite, campaignsCreateCampaignTeam, campaignsDeclineCampaignJoinRequest, campaignsDeclineCampaignLayerInvite, campaignsDeclineCampaignLayerRequest, campaignsEnableCampaign, campaignsGetCampaignLayerParent, campaignsGetCampaignLayerStructure, campaignsGetCampaignOverview, campaignsGetOwnCampaignLayerRequest, campaignsJoinCampaignParent, campaignsLeaveCampaignLayer, campaignsListCampaignJoinInvites, campaignsListCampaignJoinRequests, campaignsListCampaignLayerBoard, campaignsListCampaignLayerCandidates, campaignsListCampaignLayerRequests, campaignsListCampaignLayers, campaignsListCampaignSchedule, campaignsListCampaignStructureLayers, campaignsListReceivedCampaignLayerInvites, campaignsListSentCampaignLayerInvites, campaignsMoveCampaignLayer, campaignsPreviewCampaignJoinParent, campaignsRemoveCampaignLayer, campaignsRevokeCampaignJoinInvite, campaignsRevokeCampaignLayerInvite, campaignsSendCampaignLayerInvite, campaignsSetUpCampaignSeason, campaignsUpdateCampaign, campaignsUpdateCampaignSupporter, campaignsUpdateCampaignTeam, campaignsWithdrawCampaignLayerRequest, causeTagsCreateCauseTag, causeTagsDeleteCauseTag, causeTagsGetAllCauseTags, causeTagsUpdateCauseTag, celebrityCharitiesCreateCelebrityCharity, celebrityCharitiesDeleteCelebrityCharity, celebrityCharitiesGetCelebrityCharities, celebrityCharitiesGetCelebrityCharity, celebrityCharitiesUpdateCelebrityCharity, celebrityCharitiesUploadCelebrityCharityPoster, championsResolveChampionLanding, championsResolveChampionNative, charitiesAddCauseTagToCharity, charitiesCreateCharity, charitiesGetCauseTagsForCharity, charitiesGetCharities, charitiesGetCharitiesByCauseTag, charitiesGetCharity, charitiesGetCharityDomainCoverage, charitiesGetFollowsChampionedCharities, charitiesGetFollowsDonatedCharities, charitiesGetSuggestedCharities, charitiesLookupCharityByDomain, charitiesRemoveCauseTagFromCharity, charitiesUpdateCharity, charitiesUploadCharityProfilePicture, charityAdminAcceptCharityInvite, charityAdminAcceptCharityTerms, charityAdminAddCharityAdmin, charityAdminAddCrmDonorTag, charityAdminClearCharityDisplayName, charityAdminConfirmVerificationUpload, charityAdminCreateCharityInvite, charityAdminCreateCrmDonorNote, charityAdminCreateCrmImportedContact, charityAdminDeleteCrmDonorNote, charityAdminDeleteCrmImportedContact, charityAdminElectCharityCheck, charityAdminExportCrmAnalyticsCsv, charityAdminExportCrmDonorsCsv, charityAdminExportCrmImportedContactsCsv, charityAdminExportSection321StatementWorkbook, charityAdminGetCharityCheckAddress, charityAdminGetCharityFollowerCount, charityAdminGetCharityPaymentProfile, charityAdminGetCharityProfile, charityAdminGetCharityTerms, charityAdminGetCharityTermsAcceptanceState, charityAdminGetCharityTermsForClaim, charityAdminGetCrmAnalyticsSummary, charityAdminGetCrmDonor, charityAdminGetCrmRetention, charityAdminGetSection321ConsentingDonors, charityAdminGetSection321Dashboard, charityAdminGetSection321FundraiserDetail, charityAdminGetSection321GrantDetail, charityAdminGetSection321Statement, charityAdminListCharityAdmins, charityAdminListCharityInvites, charityAdminListCharityPaymentEvents, charityAdminListCharityRemovalRequests, charityAdminListCrmDonors, charityAdminListCrmImportedContacts, charityAdminListMyCharityClaims, charityAdminListMyMemberships, charityAdminListMyVerificationDocuments, charityAdminListSection321Fundraisers, charityAdminListSection321Grants, charityAdminObjectToFundraiserMessage, charityAdminProfilePageGetCharityPage, charityAdminProfilePageReplaceCharityPage, charityAdminProfilePageUploadCharityPageImage, charityAdminRemoveCharityAdmin, charityAdminRemoveCrmDonorTag, charityAdminRequestCharityRemoval, charityAdminRequestVerificationUploadUrl, charityAdminRevokeCharityInvite, charityAdminSetCharityDisplayName, charityAdminSubmitCharityAch, charityAdminSubmitCharityClaim, charityAdminUpdateCharityAdminRole, charityAdminUpdateCharityProfile, charityAdminUpdateCrmDonorNote, charityAdminUpdateCrmImportedContact, charityAdminUploadCharityProfileLogo, charityAdminWithdrawCharityDisplayNameRequest, charityAlternativesCreateCharityAlternativeRecommendation, charityBoardAddBoardCommitteeMember, charityBoardAddBoardCommitteeSuggestionItems, charityBoardAddBoardConsentCompensationDecision, charityBoardAddBoardMemberToBoard, charityBoardAddBoardMotionCompensationDecision, charityBoardAddBoardTermSuggestionItems, charityBoardAdoptBoardCalendarSettings, charityBoardAdoptBoardOfficerDuties, charityBoardAdoptBoardRetentionPolicy, charityBoardApplyBoardAgendaTemplate, charityBoardApplyBoardCalendarSettings, charityBoardApproveBoardMinutes, charityBoardApproveBoardRecord, charityBoardAskBoardMinutesApprovalSignatures, charityBoardCancelBoardCoiCycle, charityBoardCancelBoardMeeting, charityBoardCancelBoardSelfAssessment, charityBoardCheckBoardImportInboxFile, charityBoardCheckBoardProposalFile, charityBoardChooseBoardMemberBuddy, charityBoardCirculateBoardWrittenConsent, charityBoardCloseBoardCoiCycle, charityBoardCloseBoardImportBatch, charityBoardCloseBoardMemberGettingStarted, charityBoardCloseBoardSelfAssessment, charityBoardConfirmBoardCompensationDocument, charityBoardConfirmBoardDocument, charityBoardConfirmBoardPastRecordBatch, charityBoardConfirmBoardReturnCopy, charityBoardCorrectBoardCommitteeDissolution, charityBoardCreateBoardAgendaItem, charityBoardCreateBoardCommittee, charityBoardCreateBoardDirectorClass, charityBoardCreateBoardMeeting, charityBoardCreateBoardMeetingSegment, charityBoardCreateBoardMember, charityBoardCreateBoardMinutesApprovalConsent, charityBoardCreateBoardMotion, charityBoardCreateBoardOfficerTitle, charityBoardCreateBoardPacket, charityBoardCreateBoardPacketItem, charityBoardCreateBoardRecordDraft, charityBoardCreateBoardWrittenConsent, charityBoardDeleteBoardAgendaItem, charityBoardDeleteBoardConflictLink, charityBoardDeleteBoardImportFileUpload, charityBoardDeleteBoardImportRecordFileUpload, charityBoardDeleteBoardMeetingSegment, charityBoardDeleteBoardMotion, charityBoardDeleteBoardPacketItem, charityBoardDeleteBoardRecord, charityBoardDeleteBoardRecordChain, charityBoardDiscardBoardMemberProposal, charityBoardDiscardBoardPacket, charityBoardDiscardBoardPastRecordBatch, charityBoardDiscardBoardRecordDraft, charityBoardDismissBoardCommitteeSuggestion, charityBoardDismissBoardTermSuggestion, charityBoardDissolveBoardCommittee, charityBoardDistributeBoardPacket, charityBoardEmailBoardReturnAgain, charityBoardEndBoardCommitteeMember, charityBoardExportBoardMinuteBook, charityBoardExportBoardMinuteBookDocument, charityBoardGetBoardCalendarSettings, charityBoardGetBoardCoiCycle, charityBoardGetBoardCoiCycleDocument, charityBoardGetBoardCoiPaperForm, charityBoardGetBoardCoiPersonQuestionnaire, charityBoardGetBoardCoiQuestionnaire, charityBoardGetBoardCoiResponse, charityBoardGetBoardCoiResponseChanges, charityBoardGetBoardCoiResponseDocument, charityBoardGetBoardCommittee, charityBoardGetBoardCommitteeSuggestions, charityBoardGetBoardCompensationDecision, charityBoardGetBoardCompensationDecisionDocumentDownload, charityBoardGetBoardCompensationDocumentDownload, charityBoardGetBoardConsentTemplate, charityBoardGetBoardDirectorAccessPolicy, charityBoardGetBoardDocumentDownloadUrl, charityBoardGetBoardFilingGovernanceFeed, charityBoardGetBoardForm990, charityBoardGetBoardGettingStartedList, charityBoardGetBoardGoverningDocumentTemplate, charityBoardGetBoardImportBatch, charityBoardGetBoardImportInboxFileUrl, charityBoardGetBoardInMeetingRecord, charityBoardGetBoardLegalHoldReport, charityBoardGetBoardMeeting, charityBoardGetBoardMeetingCalendar, charityBoardGetBoardMeetingInvitations, charityBoardGetBoardMeetingPresiding, charityBoardGetBoardMember, charityBoardGetBoardMemberGettingStarted, charityBoardGetBoardMinutes, charityBoardGetBoardMinutesApprovalConsentForm, charityBoardGetBoardOfficerDuties, charityBoardGetBoardOfficerStatement, charityBoardGetBoardPacket, charityBoardGetBoardPastRecordBatch, charityBoardGetBoardProposalFileUrl, charityBoardGetBoardRecord, charityBoardGetBoardRecordFileUrl, charityBoardGetBoardReturnCopyUrl, charityBoardGetBoardReturnDistribution, charityBoardGetBoardScheduleODraft, charityBoardGetBoardSelfAssessment, charityBoardGetBoardSelfAssessmentInstrument, charityBoardGetBoardSelfAssessmentQuestions, charityBoardGetBoardSelfAssessmentResults, charityBoardGetBoardTermSuggestions, charityBoardGetBoardToDo, charityBoardGetBoardWrittenConsent, charityBoardImportBoardRecord, charityBoardIssueBoardCompensationDocumentUploadUrl, charityBoardIssueBoardDocumentUploadUrl, charityBoardIssueBoardImportFileUploadUrl, charityBoardIssueBoardImportInboxUploadUrl, charityBoardIssueBoardImportRecordFileUploadUrl, charityBoardIssueBoardProposalFileUploadUrl, charityBoardIssueBoardReturnCopyUploadUrl, charityBoardLeaveOutBoardPastRecord, charityBoardLinkBoardCommitteeCharter, charityBoardLinkBoardReturnReview, charityBoardLinkBoardSelfAssessmentPriorities, charityBoardListBoardAgendaItems, charityBoardListBoardAgendaTemplates, charityBoardListBoardApprovableMinutes, charityBoardListBoardAttendanceIntents, charityBoardListBoardCalendarConnections, charityBoardListBoardCalendarSenders, charityBoardListBoardCarryForwardItems, charityBoardListBoardCarryForwardMotions, charityBoardListBoardCoiCycles, charityBoardListBoardCoiQuestionnaires, charityBoardListBoardCommittees, charityBoardListBoardCommitteeSources, charityBoardListBoardCompensationDecisions, charityBoardListBoardConflictLinks, charityBoardListBoardConflictRegister, charityBoardListBoardConflictSuggestions, charityBoardListBoardConsentCompensationDecisions, charityBoardListBoardConsentTemplates, charityBoardListBoardContemporaneity, charityBoardListBoardDirectorClasses, charityBoardListBoardDocuments, charityBoardListBoardEngagement, charityBoardListBoardGettingStartedSteps, charityBoardListBoardGovernanceParameters, charityBoardListBoardGoverningDocuments, charityBoardListBoardGoverningDocumentTemplates, charityBoardListBoardImportBatches, charityBoardListBoardImportBatchRecords, charityBoardListBoardImportInbox, charityBoardListBoardLegalHolds, charityBoardListBoardMeetingAttendance, charityBoardListBoardMeetingCompensationDecisions, charityBoardListBoardMeetingEvents, charityBoardListBoardMeetings, charityBoardListBoardMeetingSegments, charityBoardListBoardMemberHistory, charityBoardListBoardMemberProposals, charityBoardListBoardMembers, charityBoardListBoardMotions, charityBoardListBoardOfficerTitles, charityBoardListBoardPacketComments, charityBoardListBoardPacketDistributions, charityBoardListBoardPackets, charityBoardListBoardPastRecordBatches, charityBoardListBoardRecordAcknowledgments, charityBoardListBoardRecordEvents, charityBoardListBoardRecords, charityBoardListBoardRetentionPolicies, charityBoardListBoardReturnDistributions, charityBoardListBoardReturnReviewCandidates, charityBoardListBoardSelfAssessmentInstruments, charityBoardListBoardSelfAssessments, charityBoardListBoardWrittenConsents, charityBoardMarkBoardMemberGettingStartedStep, charityBoardMarkBoardPastRecordConfidentiality, charityBoardMarkBoardSelfAssessmentPaperHandIn, charityBoardMintBoardAccessLink, charityBoardMoveBoardCalendarMeetings, charityBoardMoveBoardMeetingInvitations, charityBoardOpenBoardCoiCycle, charityBoardOpenBoardFilingReceipt, charityBoardOpenBoardImportBatch, charityBoardOpenBoardSelfAssessment, charityBoardPlaceBoardLegalHold, charityBoardPreviewBoardReturnRecipients, charityBoardProvideBoardReturn, charityBoardPublishBoardPacket, charityBoardRecordBoardAttendanceIntentOnBehalf, charityBoardRecordBoardCoiPaperResponse, charityBoardRecordBoardCommitteeRule, charityBoardRecordBoardCompensationIndexEntry, charityBoardRecordBoardConflictDisclosure, charityBoardRecordBoardConflictLink, charityBoardRecordBoardConsentRevocation, charityBoardRecordBoardConsentSignature, charityBoardRecordBoardDirectorsTold, charityBoardRecordBoardGovernanceParameter, charityBoardRecordBoardMeetingAttendance, charityBoardRecordBoardMeetingPresiding, charityBoardRecordBoardMemberTerm, charityBoardRecordBoardMinutesApprovalSignatureOnBehalf, charityBoardRecordBoardMinutesApprovalVote, charityBoardRecordBoardMotionRecusal, charityBoardRecordBoardMotionVote, charityBoardRecordBoardPacketSharedComment, charityBoardRecordBoardPaperAcknowledgments, charityBoardRecordBoardReturnPrintedCopy, charityBoardRecordBoardRosterResult, charityBoardRecordBoardSegmentParticipant, charityBoardRecordBoardSelfAssessmentPaperSheet, charityBoardRecordHistoricalBoardMember, charityBoardRefreshBoardFilingSnapshot, charityBoardReinviteBoardMeetingInvitee, charityBoardReleaseBoardLegalHold, charityBoardReleaseBoardMemberAccount, charityBoardRemindBoardCoiCycleRecipients, charityBoardRemindBoardSelfAssessmentRecipients, charityBoardRemoveBoardCompensationDocument, charityBoardRemoveBoardCompensationIndexEntry, charityBoardRemoveBoardConsentCompensationDecision, charityBoardRemoveBoardImportInboxFile, charityBoardRemoveBoardMember, charityBoardRemoveBoardMemberTerm, charityBoardRemoveBoardMotionCompensationDecision, charityBoardRemoveBoardMotionRecusal, charityBoardRemoveBoardSegmentParticipant, charityBoardReorderBoardAgenda, charityBoardReorderBoardMeetingSegments, charityBoardReorderBoardPacketItems, charityBoardReplaceBoardConsentCompensationDecision, charityBoardReplaceBoardMotionCompensationDecision, charityBoardRestoreBoardCommitteeSuggestion, charityBoardRestoreBoardTermSuggestion, charityBoardRetireBoardDirectorClass, charityBoardRetireBoardOfficerTitle, charityBoardReviseBoardWrittenConsent, charityBoardSaveBoardGettingStartedList, charityBoardSaveBoardMemberGettingStarted, charityBoardScheduleRestoredBoardMeeting, charityBoardSendBoardCoiCycleRequests, charityBoardSendBoardMeetingInvitations, charityBoardSendBoardMinutesReminder, charityBoardSendBoardSelfAssessmentRequests, charityBoardSetBoardCommitteeConfirmation, charityBoardSignBoardMinutesOnBehalf, charityBoardStartBoardMemberGettingStarted, charityBoardSubmitBoardRecord, charityBoardUnlinkBoardReturnReview, charityBoardUnmarkBoardSelfAssessmentPaperHandIn, charityBoardUpdateBoardAgendaItem, charityBoardUpdateBoardCoiCycle, charityBoardUpdateBoardCommittee, charityBoardUpdateBoardCommitteeMember, charityBoardUpdateBoardCompensationDecision, charityBoardUpdateBoardDirectorClass, charityBoardUpdateBoardImportBatch, charityBoardUpdateBoardMeeting, charityBoardUpdateBoardMeetingSegment, charityBoardUpdateBoardMember, charityBoardUpdateBoardMemberTerm, charityBoardUpdateBoardMotion, charityBoardUpdateBoardOfficerTitle, charityBoardUpdateBoardRecordDraft, charityBoardUpdateBoardWrittenConsent, charityBoardWithdrawBoardMinutesApprovalSignatures, charityBoardWithdrawBoardMotion, charityBoardWithdrawBoardReturn, charityBoardWithdrawBoardWrittenConsent, charityBoardWriteBoardMinutesDraft, charityCollectionsAddCharityToCollection, charityCollectionsCreateCharityCollection, charityCollectionsCreateCharityCollectionDonation, charityCollectionsCreateUnauthenticatedCharityCollectionDonation, charityCollectionsDeleteCharityCollection, charityCollectionsDiscoverCharityCollections, charityCollectionsGetCharityCollection, charityCollectionsGetCharityCollectionPosts, charityCollectionsGetOwnCharityCollection, charityCollectionsGetSuperAdminRecentCollections, charityCollectionsListUserCharityCollections, charityCollectionsRelistCharityCollection, charityCollectionsRemoveCharityFromCollection, charityCollectionsSetCharityCollectionVisibility, charityCollectionsUnlistCharityCollection, charityCollectionsUpdateCharityCollection, charityCollectionsUploadCharityCollectionPicture, charityComplianceAddComplianceEarlierRenewalCycle, charityComplianceAddComplianceObligationAttachment, charityComplianceAddComplianceOrganizationFiling, charityComplianceAddComplianceOrganizationFilingAttachment, charityComplianceAddComplianceOrganizationFilingCycle, charityComplianceAddComplianceRenewalAttachment, charityComplianceAmendComplianceRegistrationImport, charityComplianceAnswerComplianceFormItem, charityComplianceAnswerComplianceSubmissionEvidence, charityComplianceAskAboutComplianceReviewItem, charityComplianceAssembleCompliancePacket, charityComplianceAttachComplianceChecklistDocument, charityComplianceAttachComplianceFilingCaseDocument, charityComplianceAttachComplianceObligationFiledCopy, charityComplianceAttachComplianceOrganizationFilingFiledCopy, charityComplianceAttachComplianceRenewalFiledCopy, charityComplianceAuthorizeComplianceSubmission, charityComplianceCancelComplianceSigningRequest, charityComplianceConfirmComplianceArtifact, charityComplianceConfirmComplianceCandidate, charityComplianceCreateComplianceFilingDocument, charityComplianceCreateComplianceFilingGroup, charityComplianceDeclineComplianceSigningRequest, charityComplianceDeleteComplianceArtifact, charityComplianceDismissComplianceCandidate, charityComplianceDispatchComplianceSubmission, charityComplianceExtendComplianceSigningRequest, charityComplianceGenerateComplianceProposalRevision, charityComplianceGetComplianceAiSetting, charityComplianceGetComplianceArtifactDownload, charityComplianceGetComplianceDeskAuthorization, charityComplianceGetComplianceFilingCase, charityComplianceGetComplianceFilingCaseChecklist, charityComplianceGetComplianceFilingDocument, charityComplianceGetComplianceFilingDocumentSigningPlaces, charityComplianceGetComplianceFilingDocumentVersionDownload, charityComplianceGetComplianceFilingDocumentVersionRendition, charityComplianceGetComplianceFormPagePreview, charityComplianceGetComplianceFormPreparation, charityComplianceGetComplianceObligation, charityComplianceGetComplianceObligationRuleChange, charityComplianceGetComplianceOrganizationFiling, charityComplianceGetCompliancePacket, charityComplianceGetCompliancePacketChecklist, charityComplianceGetCompliancePacketRender, charityComplianceGetComplianceProfile, charityComplianceGetComplianceProposal, charityComplianceGetComplianceProposalReview, charityComplianceGetComplianceProposalRevision, charityComplianceGetComplianceRenewalCycle, charityComplianceGetComplianceSigningEvidence, charityComplianceGetComplianceSigningExport, charityComplianceGetComplianceSigningRecordLines, charityComplianceGetComplianceSigningRequest, charityComplianceGetComplianceSigningSetting, charityComplianceGetComplianceSubmission, charityComplianceGetComplianceSubmissionPackage, charityComplianceGetComplianceVendor, charityComplianceHandComplianceFilingToDesk, charityComplianceImportComplianceRegistration, charityComplianceIssueComplianceArtifactUploadUrl, charityComplianceIssueComplianceSigningRequest, charityComplianceLinkComplianceVendorFiling, charityComplianceListComplianceArtifacts, charityComplianceListComplianceCandidates, charityComplianceListComplianceFilingCases, charityComplianceListComplianceFilingDocuments, charityComplianceListComplianceFilingGroups, charityComplianceListComplianceFilingOptions, charityComplianceListComplianceFormAdapters, charityComplianceListComplianceFormPreparations, charityComplianceListComplianceObligationArtifacts, charityComplianceListComplianceObligations, charityComplianceListComplianceOccurrences, charityComplianceListComplianceOrganizationFilings, charityComplianceListCompliancePackets, charityComplianceListComplianceProfileParameters, charityComplianceListComplianceProfileReviewFlags, charityComplianceListComplianceProfileSuggestions, charityComplianceListComplianceProposalItems, charityComplianceListComplianceProposalResults, charityComplianceListComplianceRegistrationImportAmendments, charityComplianceListComplianceRegistrationImports, charityComplianceListComplianceRenewalCycles, charityComplianceListComplianceReviewAsks, charityComplianceListComplianceSigningPeople, charityComplianceListComplianceSigningRequests, charityComplianceListComplianceSubmissionFollowThrough, charityComplianceListComplianceVendors, charityComplianceMintComplianceFormVersion, charityComplianceMoveComplianceFilingGroup, charityComplianceMoveComplianceFilingToGroup, charityComplianceOpenComplianceFilingCase, charityComplianceReconcileComplianceSubmissionAttempt, charityComplianceRecordComplianceChecklistAct, charityComplianceRecordComplianceExecutedCopy, charityComplianceRecordComplianceFiling, charityComplianceRecordComplianceOrganizationFilingFiled, charityComplianceRecordComplianceOrganizationFilingSent, charityComplianceRecordComplianceProfileParameter, charityComplianceRecordComplianceProposalReview, charityComplianceRecordComplianceRegistrationDate, charityComplianceRecordComplianceRenewalFiling, charityComplianceRecordComplianceRenewalSubmission, charityComplianceRecordComplianceSubmission, charityComplianceRecordComplianceSubmissionEvidence, charityComplianceRecordComplianceSubmissionHandoff, charityComplianceRecordComplianceVendor, charityComplianceRecordComplianceWindowClosed, charityComplianceRegisterComplianceFilingDocumentVersion, charityComplianceRemoveComplianceFilingGroup, charityComplianceRemoveComplianceSigningIdentity, charityComplianceRenameComplianceFilingGroup, charityComplianceRepinComplianceObligation, charityComplianceResolveComplianceProfileReviewFlag, charityComplianceResolveComplianceProfileSuggestion, charityComplianceResumeComplianceDesk, charityComplianceResumeTrackingComplianceObligation, charityComplianceRetireComplianceOrganizationFiling, charityComplianceReviseComplianceSigningRequest, charityComplianceRevokeComplianceDeskAuthorization, charityComplianceRevokeComplianceSubmissionAuthorization, charityComplianceRunComplianceDerivation, charityComplianceSetComplianceAiSetting, charityComplianceSetComplianceSigningSetting, charityComplianceSignComplianceSigningRequest, charityComplianceStartComplianceFormPreparation, charityComplianceStopTrackingComplianceObligation, charityComplianceSwitchComplianceOrganizationFiling, charityComplianceTakeComplianceFilingFromDesk, charityComplianceUnlinkComplianceVendorFiling, charityComplianceUpdateComplianceOrganizationFiling, charityComplianceWithdrawComplianceFilingCase, charityComplianceWithdrawComplianceReviewAsk, charityComplianceWithdrawComplianceSignature, charityEnrollmentConfirmOpeningBalanceField, charityEnrollmentCreateEnrollmentDraft, charityEnrollmentGetEnrollment, charityEnrollmentListEnrollments, charityEnrollmentListMappingRows, charityEnrollmentListOnboardingRecords, charityEnrollmentListOpeningBalanceFields, charityEnrollmentRecordBackfillChoice, charityEnrollmentResolveMappingRow, charityEnrollmentSeedOpeningBalanceFields, charityEnrollmentStartImportRun, charityEnrollmentSubmitEnrollment, charityEnrollmentUpdateEnrollmentDraft, charityEnrollmentUpsertEntityMaps, charityEnrollmentWithdrawEnrollment, companiesActivateCompany, companiesApproveCompanyJoinRequest, companiesApproveDonationMatch, companiesChangeCompanyChampionHandle, companiesCreateCompany, companiesCreateCompanyAdmin, companiesCreateCompanyCard, companiesCreateCompanyCardV2, companiesCreateCompanyEmployeeInvites, companiesCreateCompanyFundraiser, companiesCreateCompanyJoinRequest, companiesCreateCompanyOccasionProgram, companiesDeactivateCompany, companiesDeleteCompanyCard, companiesDepositFundsCompany, companiesDownloadCompanyChampionQr, companiesEnableCompanyProduct, companiesExportCompanyImpactCsv, companiesExportCompanyTaxLinesCsv, companiesExportCompanyTransactionsCsv, companiesGetCompany, companiesGetCompanyAdmin, companiesGetCompanyAdmins, companiesGetCompanyAuthPolicy, companiesGetCompanyCards, companiesGetCompanyCardsV2, companiesGetCompanyChampion, companiesGetCompanyChampionHandleSuggestion, companiesGetCompanyDashboard, companiesGetCompanyDonationAmount, companiesGetCompanyDonationVolume, companiesGetCompanyEmployeeInviteCounts, companiesGetCompanyEmployees, companiesGetCompanyFundraiserReport, companiesGetCompanyGiftCardBatch, companiesGetCompanyGivingPublication, companiesGetCompanyMatchUtilization, companiesGetCompanyOccasionPreflight, companiesGetCompanyQrDesign, companiesGetCompanyTopCharities, companiesGetCompanyWallet, companiesGetMyCompany, companiesGetPublicCompany, companiesGetPublicCompanyStatistics, companiesGetUserLocation, companiesImportCompanyEmployeeOccasionDates, companiesListCompanyEmployeeInvites, companiesListCompanyFundraisers, companiesListCompanyGiftCardBatches, companiesListCompanyGiftCards, companiesListCompanyJoinRequests, companiesListCompanyOccasionExecutions, companiesListCompanyOccasionPrograms, companiesPauseCompanyOccasionProgram, companiesQuoteCompanyDeposit, companiesQuoteCompanyDonation, companiesRejectCompanyJoinRequest, companiesRejectDonationMatch, companiesRemoveAdminFromCompany, companiesRemoveEmployeesFromCompany, companiesResendCompanyEmployeeInvite, companiesResolveCompanyOnboardingRoute, companiesResumeCompanyOccasionProgram, companiesSaveCompanyGivingPublication, companiesSaveCompanyQrDesign, companiesSendCompanyGiftCard, companiesSendCompanyGiftCardBatch, companiesSetCompanyChampionCharity, companiesSetCompanyEmployeeOccasionDates, companiesUpdateCompanyAccountInfo, companiesUpdateCompanyActivityFeedVisibility, companiesUpdateCompanyAdminName, companiesUpdateCompanyAdminRole, companiesUpdateCompanyAuthPolicy, companiesUpdateCompanyCustomerId, companiesUpdateCompanyMatchPolicy, companiesUpdateCompanyOccasionProgram, companiesUpdateCompanyPaymentMethod, companiesUpdateCompanyPublicAmounts, companiesUpdateCompanyVisibility, companiesUploadCompanyCoverPicture, companiesUploadCompanyProfilePicture, companyAdminProfilePageGetCompanyPage, companyAdminProfilePageReplaceCompanyPage, companyAdminProfilePageUploadCompanyPageImage, connectDashboardInvitesCreateDashboardInvite, connectPartnerApplicationsCreatePartnerApplication, connectPartnerApplicationsDecidePartnerApplication, connectPartnerApplicationsGetPartnerApplication, connectPartnerApplicationsListPartnerApplications, connectPartnerApplicationsProvisionPartnerApplication, connectPartnerApplicationsUpdatePartnerApplication, connectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusion, connectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusion, connectPartnerCategoryExclusionsListCharityPartnerCategoryExclusions, connectPartnerPromotionsDecidePartnerPromotionReview, connectPartnerPromotionsGetPartnerPromotionReview, connectPartnerPromotionsListPartnerPromotionReviews, connectPartnerPromotionsOpenPartnerPromotionReview, connectPartnerPromotionsUpdatePartnerPromotionReviewItem, contentCategoriesCreateContentCategory, contentCategoriesDeleteContentCategory, contentCategoriesDeleteFeaturedItemImage, contentCategoriesDeleteFeaturedItemOverride, contentCategoriesGetCauseTagsCuratedContentItems, contentCategoriesGetCelebrityCharitiesCuratedContentItems, contentCategoriesGetCharitiesCuratedContentItems, contentCategoriesGetContentCategories, contentCategoriesGetContentCategoryItems, contentCategoriesGetEtfsCuratedContentItems, contentCategoriesGetFeaturedContentItems, contentCategoriesGetFundraisersCuratedContentItems, contentCategoriesUpdateCategoryItems, contentCategoriesUploadFeaturedItemImage, contentCategoriesUpsertFeaturedItemOverride, dafTransfersCancelDafTransferIntent, dafTransfersCreateDafTransferIntent, dafTransfersGetDafTransferTracker, dafTransfersListDafTransferIntents, disclaimersBundleDisclaimer, disclaimersDisclaimerVersions, disclaimersGetDisclaimerDetail, disclaimersListDisclaimers, disclaimersPatchDisclaimerDraft, disclaimersPatchDisclaimerDraftAtSuperAdmin, disclaimersPublishDisclaimer, disclaimersPublishDisclaimerAtSuperAdmin, disclaimersResolveDisclaimer, disclaimersSetDisclaimerEffective, disclaimersSetDisclaimerEffectiveAtSuperAdmin, donationMatchesApproveCompanyMatch, donationMatchesApproveGroupCompanyMatches, donationMatchesApproveGroupedCompanyMatches, donationMatchesApproveMatchRequest, donationMatchesCheckCompanyMatchAllowedAmount, donationMatchesCheckGroupedMatchesAllowedAmount, donationMatchesCheckMatchRequestAllowedAmount, donationMatchesCreateUserMatch, donationMatchesGetDonationMatches, donationMatchesGetMatchPaymentDisclosure, donationMatchesGetMatchRequestInbox, donationMatchesGetMyMatches, donationMatchesGetPendingGroupCompanyMatches, donationMatchesGetPendingMatchesGrouped, donationMatchesQuoteCompanyMatchPayment, donationMatchesRejectCompanyMatch, donationMatchesRejectGroupCompanyMatches, donationMatchesRejectGroupedCompanyMatches, donationMatchesRejectMatchRequest, donationsClaimDonation, donationsCreateCharityDonation, donationsCreateCharityRecurringDonation, donationsCreateEtfDonation, donationsCreateEtfRecurringDonation, donationsCreateExternalDonation, donationsCreateFundraiserDonation, donationsCreateUnauthenticatedDonation, donationsCreateUnauthenticatedEtfDonation, donationsCreateUnauthenticatedFundraiserDonation, donationsDownloadStatsReport, donationsGenerateCompanyStatsReport, donationsGenerateUserStatsReport, donationsGetDonationGrantConfirmation, donationsGetDonationJourney, donationsGetDonationReceipt, donationsGetUserCompanyDonations, donationsGetUserDonations, donationsListCompanyStatsReports, donationsListUserStatsReports, donationsResendDonationGrantConfirmation, donationsResendDonationReceipt, donationsResolveDonationLink, donationsRetryFailedReportGenerations, etfsAddCharityToEtf, etfsCreateEtf, etfsDeleteEtf, etfsGetEtf, etfsGetEtfs, etfsRemoveCharityFromEtf, etfsUpdateEtf, etfsUploadEtfProfilePicture, feesGetFees, feesGetProcessorFees, feesUpdateFee, followsFollowCharity, followsFollowCompanyEmployees, followsFollowUser, followsGetFollowedCharities, followsGetUserFollows, followsSyncUserFacebookContacts, followsSyncUserPhoneContacts, followsUnfollowCharity, followsUnfollowUser, fundraiserMatchOfferRequestsAcceptMatchOfferRequest, fundraiserMatchOfferRequestsCreateFundraiserMatchOffer, fundraiserMatchOfferRequestsCreateMatchOfferRequest, fundraiserMatchOfferRequestsDeclineMatchOfferRequest, fundraiserMatchOfferRequestsListFundraiserMatchOfferRequests, fundraiserMatchOfferRequestsListOwnMatchOfferRequests, fundraiserMatchOfferRequestsWithdrawMatchOfferRequest, fundraisersAcceptFundraiserMembership, fundraisersAddCharityToFundraiser, fundraisersAddCollectionToFundraiser, fundraisersAddEtfToFundraiser, fundraisersAdminDeactivateFundraiser, fundraisersAdminReinstateFundraiser, fundraisersCloseFundraiser, fundraisersCreateFundraiser, fundraisersDeclineOrLeaveFundraiserMembership, fundraisersDeleteFundraiser, fundraisersGetFundraiser, fundraisersGetFundraiserInvitation, fundraisersGetFundraiserInvitations, fundraisersGetFundraiserMembers, fundraisersGetFundraisers, fundraisersGetOwnFundraiser, fundraisersGetOwnFundraisers, fundraisersGetStartedByFriends, fundraisersGetSuperAdminFundraiserDonations, fundraisersGetSuperAdminFundraisers, fundraisersGetSupportedByFriends, fundraisersInviteFundraiserMember, fundraisersPublishFundraiser, fundraisersReactivateFundraiser, fundraisersRemoveCharityFromFundraiser, fundraisersRemoveCollectionFromFundraiser, fundraisersRemoveEtfFromFundraiser, fundraisersRemoveFundraiserMember, fundraisersReopenFundraiser, fundraisersTransferFundraiserOwnership, fundraisersUpdateFundraiser, fundraisersUploadFundraiserPicture, gameAwardGameTreats, gameCatchGameDog, gameClaimGameObject, gameClaimGameSurprise, gameCreateGameProfile, gameEarnGameCoins, gameGetGameCatalog, gameGetGameCharityFoundation, gameGetGameCoins, gameGetGameConfig, gameGetGameDogStatus, gameGetGameFoundation, gameGetGameMapEntities, gameGetGamePendingGifts, gameGetGameProfile, gameGetGameScrapbook, gameGetGameTreats, gameGetUserGameFoundation, gamePutGameFoundation, gameRemoveCharityFoundationReaction, gameRemoveUserFoundationReaction, gameSearchGameCities, gameSetCharityFoundationReaction, gameSetGameRescueVisitor, gameSetUserFoundationReaction, giftCardsClaimGiftCard, giftCardsListGiftCardsSuperAdmin, giftCardsListMyGiftCards, giftCardsManualIssueGiftCard, giftCardsPreviewGiftCard, giftCardsPreviewGiftCardClaim, giftCardsPurchaseGiftCard, giftCardsPurchaseGiftCardAuthenticated, giftCardsRedeemGiftCard, giftCardsReissueFailedBatchDeliveries, giftCardsReissueGiftCard, giftCardsSendGiftCardFromWallet, giftCardsVoidGiftCard, givingPacketListGivingPacketReports, givingPacketRequestGivingPacket, grantsGetGrant, grantsGetGrants, grantsGetGrantsByCharity, grantsGetSuperAdminGrantDonations, grantsGetSuperAdminGrants, grantsMarkGrantReturned, grantsMarkGrantSent, grantsMintCohort, grantsUnmintGrant, grantsUpdateGrant, groupsAcceptGroupInvite, groupsAcceptGroupInviteByToken, groupsAcceptGroupOwnershipTransfer, groupsApproveGroupDonationRequest, groupsApproveGroupJoinRequest, groupsApproveGuardianMembership, groupsCancelGroupRecurringContribution, groupsContributeToGroup, groupsCreateGroup, groupsCreateGroupDonationRequest, groupsCreateGroupFundraiser, groupsCreateGroupRecurringContribution, groupsDeleteGroup, groupsDeleteGroupInvite, groupsDiscoverGroups, groupsDonateFromGroup, groupsFollowGroup, groupsGetGroup, groupsGetGroupActivity, groupsGetGroupByHandle, groupsGetGroupOwnershipTransfer, groupsGetGroupWallet, groupsGetMyGroupContribution, groupsGetMyGroupStats, groupsInviteGroupMember, groupsLeaveGroup, groupsListGroupDonationRequests, groupsListGroupJoinRequests, groupsListGroupMembers, groupsListGuardianApprovals, groupsListGuardianMinors, groupsListMyGroupInvitations, groupsListMyGroups, groupsOfferGroupOwnershipTransfer, groupsPublishGroup, groupsRejectGroupDonationRequest, groupsRejectGroupJoinRequest, groupsRejectGuardianMembership, groupsRequestToJoinGroup, groupsRevokeGroupOwnershipTransfer, groupsUnfollowGroup, groupsUpdateGroup, groupsUpdateGroupMatchSetting, groupsUpdateGroupMember, groupsUpdateGuardianMinorSettings, groupsUploadGroupPicture, importedReceiptsConfirmImportedReceipt, importedReceiptsDeleteImportedDonation, importedReceiptsDeleteImportedReceipt, importedReceiptsExportImportedDonationsCsv, importedReceiptsGetImportedReceipt, importedReceiptsListImportedDonations, importedReceiptsListImportedReceipts, importedReceiptsRegisterImportedReceipt, importedReceiptsRequestImportedReceiptUploadUrl, matchOffersCancelMatchOffer, matchOffersCreateMatchOffer, matchOffersGetMyMatchOffer, matchOffersListCharityMatchOffers, matchOffersListMyMatchOffers, matchOffersRedirectMatchClaim, notificationsGetNotifications, notificationsGetUnreadCount, notificationsMarkAllNotificationsRead, notificationsMarkNotificationRead, notificationsRegisterDeviceToken, notificationsUnregisterDeviceToken, type Options, organizerMessagesGetOrganizerMessageUnsubscribe, organizerMessagesPostOrganizerMessageUnsubscribe, orgBoardOrgAddBoardCommitteeMember, orgBoardOrgAddBoardCommitteeSuggestionItems, orgBoardOrgAddBoardConsentCompensationDecision, orgBoardOrgAddBoardMemberToBoard, orgBoardOrgAddBoardMotionCompensationDecision, orgBoardOrgAddBoardTermSuggestionItems, orgBoardOrgAdoptBoardCalendarSettings, orgBoardOrgAdoptBoardOfficerDuties, orgBoardOrgAdoptBoardRetentionPolicy, orgBoardOrgApplyBoardAgendaTemplate, orgBoardOrgApplyBoardCalendarSettings, orgBoardOrgApproveBoardMinutes, orgBoardOrgApproveBoardRecord, orgBoardOrgAskBoardMinutesApprovalSignatures, orgBoardOrgCancelBoardCoiCycle, orgBoardOrgCancelBoardMeeting, orgBoardOrgCancelBoardSelfAssessment, orgBoardOrgCheckBoardImportInboxFile, orgBoardOrgCheckBoardProposalFile, orgBoardOrgChooseBoardMemberBuddy, orgBoardOrgCirculateBoardWrittenConsent, orgBoardOrgCloseBoardCoiCycle, orgBoardOrgCloseBoardImportBatch, orgBoardOrgCloseBoardMemberGettingStarted, orgBoardOrgCloseBoardSelfAssessment, orgBoardOrgConfirmBoardCompensationDocument, orgBoardOrgConfirmBoardDocument, orgBoardOrgConfirmBoardPastRecordBatch, orgBoardOrgConfirmBoardReturnCopy, orgBoardOrgCorrectBoardCommitteeDissolution, orgBoardOrgCreateBoardAgendaItem, orgBoardOrgCreateBoardCommittee, orgBoardOrgCreateBoardDirectorClass, orgBoardOrgCreateBoardMeeting, orgBoardOrgCreateBoardMeetingSegment, orgBoardOrgCreateBoardMember, orgBoardOrgCreateBoardMinutesApprovalConsent, orgBoardOrgCreateBoardMotion, orgBoardOrgCreateBoardOfficerTitle, orgBoardOrgCreateBoardPacket, orgBoardOrgCreateBoardPacketItem, orgBoardOrgCreateBoardRecordDraft, orgBoardOrgCreateBoardWrittenConsent, orgBoardOrgDeleteBoardAgendaItem, orgBoardOrgDeleteBoardConflictLink, orgBoardOrgDeleteBoardImportFileUpload, orgBoardOrgDeleteBoardImportRecordFileUpload, orgBoardOrgDeleteBoardMeetingSegment, orgBoardOrgDeleteBoardMotion, orgBoardOrgDeleteBoardPacketItem, orgBoardOrgDeleteBoardRecord, orgBoardOrgDeleteBoardRecordChain, orgBoardOrgDiscardBoardMemberProposal, orgBoardOrgDiscardBoardPacket, orgBoardOrgDiscardBoardPastRecordBatch, orgBoardOrgDiscardBoardRecordDraft, orgBoardOrgDismissBoardCommitteeSuggestion, orgBoardOrgDismissBoardTermSuggestion, orgBoardOrgDissolveBoardCommittee, orgBoardOrgDistributeBoardPacket, orgBoardOrgEmailBoardReturnAgain, orgBoardOrgEndBoardCommitteeMember, orgBoardOrgExportBoardMinuteBook, orgBoardOrgExportBoardMinuteBookDocument, orgBoardOrgGetBoardCalendarSettings, orgBoardOrgGetBoardCoiCycle, orgBoardOrgGetBoardCoiCycleDocument, orgBoardOrgGetBoardCoiPaperForm, orgBoardOrgGetBoardCoiPersonQuestionnaire, orgBoardOrgGetBoardCoiQuestionnaire, orgBoardOrgGetBoardCoiResponse, orgBoardOrgGetBoardCoiResponseChanges, orgBoardOrgGetBoardCoiResponseDocument, orgBoardOrgGetBoardCommittee, orgBoardOrgGetBoardCommitteeSuggestions, orgBoardOrgGetBoardCompensationDecision, orgBoardOrgGetBoardCompensationDecisionDocumentDownload, orgBoardOrgGetBoardCompensationDocumentDownload, orgBoardOrgGetBoardConsentTemplate, orgBoardOrgGetBoardDirectorAccessPolicy, orgBoardOrgGetBoardDocumentDownloadUrl, orgBoardOrgGetBoardFilingGovernanceFeed, orgBoardOrgGetBoardForm990, orgBoardOrgGetBoardGettingStartedList, orgBoardOrgGetBoardGoverningDocumentTemplate, orgBoardOrgGetBoardImportBatch, orgBoardOrgGetBoardImportInboxFileUrl, orgBoardOrgGetBoardInMeetingRecord, orgBoardOrgGetBoardLegalHoldReport, orgBoardOrgGetBoardMeeting, orgBoardOrgGetBoardMeetingCalendar, orgBoardOrgGetBoardMeetingInvitations, orgBoardOrgGetBoardMeetingPresiding, orgBoardOrgGetBoardMember, orgBoardOrgGetBoardMemberGettingStarted, orgBoardOrgGetBoardMinutes, orgBoardOrgGetBoardMinutesApprovalConsentForm, orgBoardOrgGetBoardOfficerDuties, orgBoardOrgGetBoardOfficerStatement, orgBoardOrgGetBoardPacket, orgBoardOrgGetBoardPastRecordBatch, orgBoardOrgGetBoardProposalFileUrl, orgBoardOrgGetBoardRecord, orgBoardOrgGetBoardRecordFileUrl, orgBoardOrgGetBoardReturnCopyUrl, orgBoardOrgGetBoardReturnDistribution, orgBoardOrgGetBoardScheduleODraft, orgBoardOrgGetBoardSelfAssessment, orgBoardOrgGetBoardSelfAssessmentInstrument, orgBoardOrgGetBoardSelfAssessmentQuestions, orgBoardOrgGetBoardSelfAssessmentResults, orgBoardOrgGetBoardTermSuggestions, orgBoardOrgGetBoardToDo, orgBoardOrgGetBoardWrittenConsent, orgBoardOrgImportBoardRecord, orgBoardOrgIssueBoardCompensationDocumentUploadUrl, orgBoardOrgIssueBoardDocumentUploadUrl, orgBoardOrgIssueBoardImportFileUploadUrl, orgBoardOrgIssueBoardImportInboxUploadUrl, orgBoardOrgIssueBoardImportRecordFileUploadUrl, orgBoardOrgIssueBoardProposalFileUploadUrl, orgBoardOrgIssueBoardReturnCopyUploadUrl, orgBoardOrgLeaveOutBoardPastRecord, orgBoardOrgLinkBoardCommitteeCharter, orgBoardOrgLinkBoardReturnReview, orgBoardOrgLinkBoardSelfAssessmentPriorities, orgBoardOrgListBoardAgendaItems, orgBoardOrgListBoardAgendaTemplates, orgBoardOrgListBoardApprovableMinutes, orgBoardOrgListBoardAttendanceIntents, orgBoardOrgListBoardCalendarConnections, orgBoardOrgListBoardCalendarSenders, orgBoardOrgListBoardCarryForwardItems, orgBoardOrgListBoardCarryForwardMotions, orgBoardOrgListBoardCoiCycles, orgBoardOrgListBoardCoiQuestionnaires, orgBoardOrgListBoardCommittees, orgBoardOrgListBoardCommitteeSources, orgBoardOrgListBoardCompensationDecisions, orgBoardOrgListBoardConflictLinks, orgBoardOrgListBoardConflictRegister, orgBoardOrgListBoardConflictSuggestions, orgBoardOrgListBoardConsentCompensationDecisions, orgBoardOrgListBoardConsentTemplates, orgBoardOrgListBoardContemporaneity, orgBoardOrgListBoardDirectorClasses, orgBoardOrgListBoardDocuments, orgBoardOrgListBoardEngagement, orgBoardOrgListBoardGettingStartedSteps, orgBoardOrgListBoardGovernanceParameters, orgBoardOrgListBoardGoverningDocuments, orgBoardOrgListBoardGoverningDocumentTemplates, orgBoardOrgListBoardImportBatches, orgBoardOrgListBoardImportBatchRecords, orgBoardOrgListBoardImportInbox, orgBoardOrgListBoardLegalHolds, orgBoardOrgListBoardMeetingAttendance, orgBoardOrgListBoardMeetingCompensationDecisions, orgBoardOrgListBoardMeetingEvents, orgBoardOrgListBoardMeetings, orgBoardOrgListBoardMeetingSegments, orgBoardOrgListBoardMemberHistory, orgBoardOrgListBoardMemberProposals, orgBoardOrgListBoardMembers, orgBoardOrgListBoardMotions, orgBoardOrgListBoardOfficerTitles, orgBoardOrgListBoardPacketComments, orgBoardOrgListBoardPacketDistributions, orgBoardOrgListBoardPackets, orgBoardOrgListBoardPastRecordBatches, orgBoardOrgListBoardRecordAcknowledgments, orgBoardOrgListBoardRecordEvents, orgBoardOrgListBoardRecords, orgBoardOrgListBoardRetentionPolicies, orgBoardOrgListBoardReturnDistributions, orgBoardOrgListBoardReturnReviewCandidates, orgBoardOrgListBoardSelfAssessmentInstruments, orgBoardOrgListBoardSelfAssessments, orgBoardOrgListBoardWrittenConsents, orgBoardOrgMarkBoardMemberGettingStartedStep, orgBoardOrgMarkBoardPastRecordConfidentiality, orgBoardOrgMarkBoardSelfAssessmentPaperHandIn, orgBoardOrgMintBoardAccessLink, orgBoardOrgMoveBoardCalendarMeetings, orgBoardOrgMoveBoardMeetingInvitations, orgBoardOrgOpenBoardCoiCycle, orgBoardOrgOpenBoardFilingReceipt, orgBoardOrgOpenBoardImportBatch, orgBoardOrgOpenBoardSelfAssessment, orgBoardOrgPlaceBoardLegalHold, orgBoardOrgPreviewBoardReturnRecipients, orgBoardOrgProvideBoardReturn, orgBoardOrgPublishBoardPacket, orgBoardOrgRecordBoardAttendanceIntentOnBehalf, orgBoardOrgRecordBoardCoiPaperResponse, orgBoardOrgRecordBoardCommitteeRule, orgBoardOrgRecordBoardCompensationIndexEntry, orgBoardOrgRecordBoardConflictDisclosure, orgBoardOrgRecordBoardConflictLink, orgBoardOrgRecordBoardConsentRevocation, orgBoardOrgRecordBoardConsentSignature, orgBoardOrgRecordBoardDirectorsTold, orgBoardOrgRecordBoardGovernanceParameter, orgBoardOrgRecordBoardMeetingAttendance, orgBoardOrgRecordBoardMeetingPresiding, orgBoardOrgRecordBoardMemberTerm, orgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalf, orgBoardOrgRecordBoardMinutesApprovalVote, orgBoardOrgRecordBoardMotionRecusal, orgBoardOrgRecordBoardMotionVote, orgBoardOrgRecordBoardPacketSharedComment, orgBoardOrgRecordBoardPaperAcknowledgments, orgBoardOrgRecordBoardReturnPrintedCopy, orgBoardOrgRecordBoardRosterResult, orgBoardOrgRecordBoardSegmentParticipant, orgBoardOrgRecordBoardSelfAssessmentPaperSheet, orgBoardOrgRecordHistoricalBoardMember, orgBoardOrgRefreshBoardFilingSnapshot, orgBoardOrgReinviteBoardMeetingInvitee, orgBoardOrgReleaseBoardLegalHold, orgBoardOrgReleaseBoardMemberAccount, orgBoardOrgRemindBoardCoiCycleRecipients, orgBoardOrgRemindBoardSelfAssessmentRecipients, orgBoardOrgRemoveBoardCompensationDocument, orgBoardOrgRemoveBoardCompensationIndexEntry, orgBoardOrgRemoveBoardConsentCompensationDecision, orgBoardOrgRemoveBoardImportInboxFile, orgBoardOrgRemoveBoardMember, orgBoardOrgRemoveBoardMemberTerm, orgBoardOrgRemoveBoardMotionCompensationDecision, orgBoardOrgRemoveBoardMotionRecusal, orgBoardOrgRemoveBoardSegmentParticipant, orgBoardOrgReorderBoardAgenda, orgBoardOrgReorderBoardMeetingSegments, orgBoardOrgReorderBoardPacketItems, orgBoardOrgReplaceBoardConsentCompensationDecision, orgBoardOrgReplaceBoardMotionCompensationDecision, orgBoardOrgRestoreBoardCommitteeSuggestion, orgBoardOrgRestoreBoardTermSuggestion, orgBoardOrgRetireBoardDirectorClass, orgBoardOrgRetireBoardOfficerTitle, orgBoardOrgReviseBoardWrittenConsent, orgBoardOrgSaveBoardGettingStartedList, orgBoardOrgSaveBoardMemberGettingStarted, orgBoardOrgScheduleRestoredBoardMeeting, orgBoardOrgSendBoardCoiCycleRequests, orgBoardOrgSendBoardMeetingInvitations, orgBoardOrgSendBoardMinutesReminder, orgBoardOrgSendBoardSelfAssessmentRequests, orgBoardOrgSetBoardCommitteeConfirmation, orgBoardOrgSignBoardMinutesOnBehalf, orgBoardOrgStartBoardMemberGettingStarted, orgBoardOrgSubmitBoardRecord, orgBoardOrgUnlinkBoardReturnReview, orgBoardOrgUnmarkBoardSelfAssessmentPaperHandIn, orgBoardOrgUpdateBoardAgendaItem, orgBoardOrgUpdateBoardCoiCycle, orgBoardOrgUpdateBoardCommittee, orgBoardOrgUpdateBoardCommitteeMember, orgBoardOrgUpdateBoardCompensationDecision, orgBoardOrgUpdateBoardDirectorClass, orgBoardOrgUpdateBoardImportBatch, orgBoardOrgUpdateBoardMeeting, orgBoardOrgUpdateBoardMeetingSegment, orgBoardOrgUpdateBoardMember, orgBoardOrgUpdateBoardMemberTerm, orgBoardOrgUpdateBoardMotion, orgBoardOrgUpdateBoardOfficerTitle, orgBoardOrgUpdateBoardRecordDraft, orgBoardOrgUpdateBoardWrittenConsent, orgBoardOrgWithdrawBoardMinutesApprovalSignatures, orgBoardOrgWithdrawBoardMotion, orgBoardOrgWithdrawBoardReturn, orgBoardOrgWithdrawBoardWrittenConsent, orgBoardOrgWriteBoardMinutesDraft, orgComplianceOrgAddComplianceEarlierRenewalCycle, orgComplianceOrgAddComplianceObligationAttachment, orgComplianceOrgAddComplianceOrganizationFiling, orgComplianceOrgAddComplianceOrganizationFilingAttachment, orgComplianceOrgAddComplianceOrganizationFilingCycle, orgComplianceOrgAddComplianceRenewalAttachment, orgComplianceOrgAmendComplianceRegistrationImport, orgComplianceOrgAnswerComplianceFormItem, orgComplianceOrgAnswerComplianceSubmissionEvidence, orgComplianceOrgAskAboutComplianceReviewItem, orgComplianceOrgAssembleCompliancePacket, orgComplianceOrgAttachComplianceChecklistDocument, orgComplianceOrgAttachComplianceFilingCaseDocument, orgComplianceOrgAttachComplianceObligationFiledCopy, orgComplianceOrgAttachComplianceOrganizationFilingFiledCopy, orgComplianceOrgAttachComplianceRenewalFiledCopy, orgComplianceOrgAuthorizeComplianceSubmission, orgComplianceOrgCancelComplianceSigningRequest, orgComplianceOrgConfirmComplianceArtifact, orgComplianceOrgConfirmComplianceCandidate, orgComplianceOrgCreateComplianceFilingDocument, orgComplianceOrgCreateComplianceFilingGroup, orgComplianceOrgDeclineComplianceSigningRequest, orgComplianceOrgDeleteComplianceArtifact, orgComplianceOrgDismissComplianceCandidate, orgComplianceOrgDispatchComplianceSubmission, orgComplianceOrgExtendComplianceSigningRequest, orgComplianceOrgGenerateComplianceProposalRevision, orgComplianceOrgGetComplianceAiSetting, orgComplianceOrgGetComplianceArtifactDownload, orgComplianceOrgGetComplianceDeskAuthorization, orgComplianceOrgGetComplianceFilingCase, orgComplianceOrgGetComplianceFilingCaseChecklist, orgComplianceOrgGetComplianceFilingDocument, orgComplianceOrgGetComplianceFilingDocumentSigningPlaces, orgComplianceOrgGetComplianceFilingDocumentVersionDownload, orgComplianceOrgGetComplianceFilingDocumentVersionRendition, orgComplianceOrgGetComplianceFormPagePreview, orgComplianceOrgGetComplianceFormPreparation, orgComplianceOrgGetComplianceObligation, orgComplianceOrgGetComplianceObligationRuleChange, orgComplianceOrgGetComplianceOrganizationFiling, orgComplianceOrgGetCompliancePacket, orgComplianceOrgGetCompliancePacketChecklist, orgComplianceOrgGetCompliancePacketRender, orgComplianceOrgGetComplianceProfile, orgComplianceOrgGetComplianceProposal, orgComplianceOrgGetComplianceProposalReview, orgComplianceOrgGetComplianceProposalRevision, orgComplianceOrgGetComplianceRenewalCycle, orgComplianceOrgGetComplianceSigningEvidence, orgComplianceOrgGetComplianceSigningExport, orgComplianceOrgGetComplianceSigningRecordLines, orgComplianceOrgGetComplianceSigningRequest, orgComplianceOrgGetComplianceSigningSetting, orgComplianceOrgGetComplianceSubmission, orgComplianceOrgGetComplianceSubmissionPackage, orgComplianceOrgGetComplianceVendor, orgComplianceOrgHandComplianceFilingToDesk, orgComplianceOrgImportComplianceRegistration, orgComplianceOrgIssueComplianceArtifactUploadUrl, orgComplianceOrgIssueComplianceSigningRequest, orgComplianceOrgLinkComplianceVendorFiling, orgComplianceOrgListComplianceArtifacts, orgComplianceOrgListComplianceCandidates, orgComplianceOrgListComplianceFilingCases, orgComplianceOrgListComplianceFilingDocuments, orgComplianceOrgListComplianceFilingGroups, orgComplianceOrgListComplianceFilingOptions, orgComplianceOrgListComplianceFormAdapters, orgComplianceOrgListComplianceFormPreparations, orgComplianceOrgListComplianceObligationArtifacts, orgComplianceOrgListComplianceObligations, orgComplianceOrgListComplianceOccurrences, orgComplianceOrgListComplianceOrganizationFilings, orgComplianceOrgListCompliancePackets, orgComplianceOrgListComplianceProfileParameters, orgComplianceOrgListComplianceProfileReviewFlags, orgComplianceOrgListComplianceProfileSuggestions, orgComplianceOrgListComplianceProposalItems, orgComplianceOrgListComplianceProposalResults, orgComplianceOrgListComplianceRegistrationImportAmendments, orgComplianceOrgListComplianceRegistrationImports, orgComplianceOrgListComplianceRenewalCycles, orgComplianceOrgListComplianceReviewAsks, orgComplianceOrgListComplianceSigningPeople, orgComplianceOrgListComplianceSigningRequests, orgComplianceOrgListComplianceSubmissionFollowThrough, orgComplianceOrgListComplianceVendors, orgComplianceOrgMintComplianceFormVersion, orgComplianceOrgMoveComplianceFilingGroup, orgComplianceOrgMoveComplianceFilingToGroup, orgComplianceOrgOpenComplianceFilingCase, orgComplianceOrgReconcileComplianceSubmissionAttempt, orgComplianceOrgRecordComplianceChecklistAct, orgComplianceOrgRecordComplianceExecutedCopy, orgComplianceOrgRecordComplianceFiling, orgComplianceOrgRecordComplianceOrganizationFilingFiled, orgComplianceOrgRecordComplianceOrganizationFilingSent, orgComplianceOrgRecordComplianceProfileParameter, orgComplianceOrgRecordComplianceProposalReview, orgComplianceOrgRecordComplianceRegistrationDate, orgComplianceOrgRecordComplianceRenewalFiling, orgComplianceOrgRecordComplianceRenewalSubmission, orgComplianceOrgRecordComplianceSubmission, orgComplianceOrgRecordComplianceSubmissionEvidence, orgComplianceOrgRecordComplianceSubmissionHandoff, orgComplianceOrgRecordComplianceVendor, orgComplianceOrgRecordComplianceWindowClosed, orgComplianceOrgRegisterComplianceFilingDocumentVersion, orgComplianceOrgRemoveComplianceFilingGroup, orgComplianceOrgRemoveComplianceSigningIdentity, orgComplianceOrgRenameComplianceFilingGroup, orgComplianceOrgRepinComplianceObligation, orgComplianceOrgResolveComplianceProfileReviewFlag, orgComplianceOrgResolveComplianceProfileSuggestion, orgComplianceOrgResumeComplianceDesk, orgComplianceOrgResumeTrackingComplianceObligation, orgComplianceOrgRetireComplianceOrganizationFiling, orgComplianceOrgReviseComplianceSigningRequest, orgComplianceOrgRevokeComplianceDeskAuthorization, orgComplianceOrgRevokeComplianceSubmissionAuthorization, orgComplianceOrgRunComplianceDerivation, orgComplianceOrgSetComplianceAiSetting, orgComplianceOrgSetComplianceSigningSetting, orgComplianceOrgSignComplianceSigningRequest, orgComplianceOrgStartComplianceFormPreparation, orgComplianceOrgStopTrackingComplianceObligation, orgComplianceOrgSwitchComplianceOrganizationFiling, orgComplianceOrgTakeComplianceFilingFromDesk, orgComplianceOrgUnlinkComplianceVendorFiling, orgComplianceOrgUpdateComplianceOrganizationFiling, orgComplianceOrgWithdrawComplianceFilingCase, orgComplianceOrgWithdrawComplianceReviewAsk, orgComplianceOrgWithdrawComplianceSignature, orgConfirmationRequestsConfirmOrgConfirmationRequest, orgConfirmationRequestsDeclineOrgConfirmationRequest, orgConfirmationRequestsGetOrgConfirmationRequest, orgConfirmationRequestsGetOrgMoneyFloors, orgConfirmationRequestsListOrgConfirmationRequests, orgConfirmationRequestsSaveOrgMoneyFloor, orgConsoleAcceptOrgAssistantConsent, orgConsoleAcceptOrgInvite, orgConsoleAcceptOrgModuleTerms, orgConsoleApproveOrgAccessRequest, orgConsoleCreateOrgAccessRequest, orgConsoleCreateOrgInvite, orgConsoleDeactivateOrg, orgConsoleDenyOrgAccessRequest, orgConsoleGetOrgAccessCatalog, orgConsoleGetOrgAccessSettings, orgConsoleGetOrgAdminPreferences, orgConsoleGetOrgAssistantConsent, orgConsoleGetOrgMeasurementConfig, orgConsoleGetOrgModuleTerms, orgConsoleGetOrgSelfAccess, orgConsoleListOrgAccessEvents, orgConsoleListOrgAccessRequests, orgConsoleListOrgConnectedAi, orgConsoleListOrgConsoleMembers, orgConsoleListOrgInvites, orgConsoleRemoveOrgMember, orgConsoleRemoveOrgMemberModuleAccess, orgConsoleRevokeOrgAssistantConsent, orgConsoleRevokeOrgConnectedAi, orgConsoleRevokeOrgInvite, orgConsoleUpdateOrgAccessSettings, orgConsoleUpdateOrgAdminPreferences, orgConsoleUpdateOrgMeasurementConfig, orgConsoleUpdateOrgMemberAccess, orgFundraisersCloseOrgFundraiser, orgFundraisersCreateOrgFundraiser, orgFundraisersDeactivateOrgFundraiser, orgFundraisersDeleteOrgFundraiser, orgFundraisersDownloadOrgFundraiserShareKitGraphics, orgFundraisersGetOrgFundraiser, orgFundraisersGetOrgFundraiserShare, orgFundraisersGetOrgFundraiserShareKit, orgFundraisersListOrgFundraiserDonorMessages, orgFundraisersListOrgFundraiserDonors, orgFundraisersListOrgFundraisers, orgFundraisersListOrgSupporterFundraisers, orgFundraisersPublishOrgFundraiser, orgFundraisersPutOrgFundraiserDesignations, orgFundraisersReactivateOrgFundraiser, orgFundraisersRenderOrgFundraiserShareQr, orgFundraisersRenderSuppliedOrgFundraiserShareQr, orgFundraisersReopenOrgFundraiser, orgFundraisersSendOrgFundraiserDonorMessage, orgFundraisersUpdateOrgFundraiser, orgIntegrationsCompleteOrgIntegrationOauth, orgIntegrationsDisconnectOrgIntegration, orgIntegrationsGetOrgIntegration, orgIntegrationsListOrgIntegrations, orgIntegrationsStartOrgIntegrationOauth, orgQrDesignGetOrgQrDesign, orgQrDesignRenderOrgPublicQr, orgQrDesignRenderSuppliedOrgPublicQr, orgQrDesignUpdateOrgQrDesign, p2pCheckCampaignJoin, p2pGetActivity, p2pGetCampaignP2P, p2pGetLeaderboard, p2pGetMyCampaignJoinRequest, p2pGetSupporter, p2pGetTeam, p2pJoinCampaign, p2pListGiveOptions, p2pListTeams, p2pRequestToJoinCampaign, p2pUpdateSupporter, p2pWithdrawMyCampaignJoinRequest, passkeysDeleteMyPasskey, passkeysFinishPasskeyReauthentication, passkeysFinishPasskeyRegistration, passkeysListMyPasskeys, passkeysRenameMyPasskey, passkeysStartPasskeyReauthentication, passkeysStartPasskeyRegistration, paymentsGetPaymentReconciliation, paymentsGetPaymentsConfig, paymentsListReconcileReviewChargeIntents, pledgesAcceptAttestation, pledgesCancelGuestPledge, pledgesCancelPledge, pledgesChooseGuestPledgeAmount, pledgesChoosePledgeAmount, pledgesClearPledgeTemplate, pledgesCreateGuestOfferPledge, pledgesCreateGuestPledge, pledgesCreatePledge, pledgesCreatePledgeCampaign, pledgesGetGuestPledge, pledgesGetPledgeCampaign, pledgesGetPledgeOffer, pledgesGetPledgeProjectedTotal, pledgesGetPledgesLive, pledgesGetPledgeTemplate, pledgesListFundraiserPledgeOffers, pledgesListOwnPledges, pledgesObjectToGuestPledge, pledgesObjectToPledge, pledgesPreviewPledgeOfferRule, pledgesSetPledgeTemplate, pledgesSubmitAttestation, postsCommentPost, postsDeleteComment, postsGetCharityPosts, postsGetCommentLikes, postsGetEtfPosts, postsGetFollowsPosts, postsGetFundraiserPosts, postsGetMyPosts, postsGetPost, postsGetPostComments, postsGetPostLikes, postsGetSuperAdminRecentPublicPosts, postsGetUsersPublicPosts, postsHideComment, postsHidePost, postsLikeComment, postsLikePost, postsReportPost, postsUnhideComment, postsUnhidePost, postsUnlikeComment, postsUnlikePost, postsUpdatePostMessage, postsUpdatePostVisibility, profilePagesGetConsumerPage, profilePagesPublicGetPublicProfilePage, profilePagesReplaceConsumerPage, profilePagesUploadConsumerPageImage, profileReportsReportProfileBlock, profileReportsReportUserProfile, receiptFinePrintGetReceiptFinePrintDetail, receiptFinePrintListReceiptFinePrint, receiptFinePrintSetReceiptFinePrintEffective, searchGetSearchFeed, shareKitDownloadMyShareKitGraphics, shareKitGetMyShareKit, shareKitRenderMyShareKitQr, stepsCompetitionsAdminCancelAdminStepsCompetition, stepsCompetitionsAdminCreateAdminStepsCompetition, stepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntry, stepsCompetitionsAdminGetAdminStepsCompetition, stepsCompetitionsAdminGetStepsSponsorDpa, stepsCompetitionsAdminListAdminStepsCompetitionEntries, stepsCompetitionsAdminListAdminStepsCompetitions, stepsCompetitionsAdminPublishAdminStepsCompetition, stepsCompetitionsAdminReinstateAdminStepsCompetitionEntry, stepsCompetitionsAdminRetryPayoutAdminStepsCompetition, stepsCompetitionsAdminUpdateAdminStepsCompetition, stepsCompetitionsGetCompanyPublicStepsCompetitions, stepsCompetitionsGetStepsCompetition, stepsCompetitionsGetStepsCompetitionLeaderboard, stepsCompetitionsJoinStepsCompetition, stepsCompetitionsListStepsCompetitions, stepsCompetitionsRestateMySteps, stepsCompetitionsUpdateMyStepsEntry, stepsCompetitionsWithdrawFromStepsCompetition, stepUpMintStepUpFromReauth, superAdminChampionOpsFileChampionReport, superAdminChampionOpsInspectChampion, superAdminChampionOpsInspectChampionByHandle, superAdminChampionOpsListChampions, superAdminChampionOpsReclaimChampionHandle, superAdminCharityClaimsApproveCharityClaim, superAdminCharityClaimsApproveCharityClaimTransfer, superAdminCharityClaimsGetCharityClaimDetail, superAdminCharityClaimsListPendingCharityClaims, superAdminCharityClaimsRejectCharityClaim, superAdminCharityConsentOpsGetCharityAuditTrail, superAdminCharityConsentOpsGetClaimVelocityReport, superAdminCharityConsentOpsListCharityConsentStates, superAdminCharityDisplayNamesApproveCharityDisplayName, superAdminCharityDisplayNamesEndCharityDisplayName, superAdminCharityDisplayNamesListCharityDisplayNames, superAdminCharityDisplayNamesRejectCharityDisplayName, superAdminCharityInstantClaimAllowCharityInstantClaim, superAdminCharityInstantClaimListCharityInstantClaimAllowances, superAdminCharityInstantClaimRevokeCharityInstantClaim, superAdminCharityOnboardingTestGetCharityOnboardingTest, superAdminCharityOnboardingTestResetCharityOnboardingTest, superAdminCharityPayeeFlagsApproveCharityPayeeFlag, superAdminCharityPayeeFlagsGetCharityPayeeFlagDetail, superAdminCharityPayeeFlagsListCharityPayeeFlags, superAdminCharityPayeeFlagsRejectCharityPayeeFlag, superAdminCharityRemovalsCancelCharityRemoval, superAdminCharityRemovalsGetCharityRemovalDetail, superAdminCharityRemovalsListCharityRemovalQueue, superAdminCharityRemovalsProcessCharityRemoval, superAdminCharityRemovalsVerifyCharityRemovalIdentity, superAdminContentReportsListContentReports, superAdminDafTransfersAppendDafTransferArrivalNote, superAdminDafTransfersAppendDafTransferEvent, superAdminDafTransfersCloseDafTransferIntent, superAdminDafTransfersCreditDafTransferArrival, superAdminDafTransfersGetDafTransferArrival, superAdminDafTransfersLinkDafTransferArrival, superAdminDafTransfersListDafTransferArrivalAging, superAdminDafTransfersListDafTransferArrivalCandidates, superAdminDafTransfersListDafTransferArrivalNotes, superAdminDafTransfersListDafTransferArrivals, superAdminDafTransfersListDafTransferIntentAging, superAdminDafTransfersRegisterDafTransferArrival, superAdminDafTransfersRegisterDafTransferIntent, superAdminDafTransfersRevokeDafTransferArrivalLink, superAdminDafTransfersSearchDafTransferUserCandidatesByName, superAdminDisbursementApprovalsListDisbursementApprovals, superAdminDisbursementApprovalsRecordDisbursementApproval, superAdminDisbursementApprovalsRecordManualPaymentConfirmation, superAdminDisbursementApprovalsRevokeDisbursementApproval, superAdminDonationOpsClearDonationDisbursementHold, superAdminDonationOpsCorrectUserBirthDate, superAdminDonationOpsCreateExternalDonationOnBehalf, superAdminDonationOpsGetClaimConversion, superAdminDonationOpsGetEmployerLinkage, superAdminDonationOpsGetPaymentMethodReport, superAdminDonationOpsGetUserProfile, superAdminDonationOpsLinkCompanyAttested, superAdminDonationOpsListUserDonations, superAdminDonationOpsReAdviseConnectDonationIntent, superAdminDonationOpsSearchUserByEmail, superAdminDonationOpsSearchUsersByName, superAdminDonationOpsSetDonationDisbursementHold, superAdminEntityEnrollmentsOperatorCreateForProfitEnrollment, superAdminEntityEnrollmentsOperatorGetEnrollment, superAdminEntityEnrollmentsOperatorListEnrollments, superAdminEntityEnrollmentsOperatorRedriveProvision, superAdminEntityEnrollmentsOperatorRedriveStoreCopy, superAdminEntityEnrollmentsOperatorRejectEnrollment, superAdminEntityEnrollmentsOperatorStartImportRun, superAdminFundraiserMessageObjectionsListFundraiserMessageObjections, superAdminFundraiserMessageObjectionsResolveFundraiserMessageObjection, superAdminGrantsOpsAttestGroupExemptionCure, superAdminGrantsOpsGetCharityBucket, superAdminGrantsOpsGetCohort, superAdminGrantsOpsGetDonationTrail, superAdminGrantsOpsGetEligibilityEvidence, superAdminGrantsOpsGetOpsStrip, superAdminGrantsOpsListCharityBuckets, superAdminGrantsOpsListCohorts, superAdminGrantsOpsListGroupExemptionCures, superAdminGrantsOpsRecordGroupRulingLetter, superAdminGrantsOpsRecordIneligibilityAlternate, superAdminGrantsOpsRecordIneligibilityDetermination, superAdminGrantsOpsRecordIneligibilityNotice, superAdminGrantsOpsRevokeGroupExemptionCure, superAdminGrantsOpsSearchDonations, superAdminGrantsOpsWithdrawGroupRulingLetter, superAdminGroupOpsEvacuateGroupFunds, superAdminGroupOpsGetGroupsForModeration, superAdminGroupOpsModerateGroup, superAdminGroupOpsRelistGroup, superAdminGroupOpsUnlistGroup, superAdminMatchOffersGetMatchOfferDetail, superAdminMatchOffersListMatchOfferClaims, superAdminMatchOffersListMatchOffers, superAdminMatchOffersRedirectMatchClaimAdmin, superAdminMatchOffersResumeMatchOffer, superAdminMatchOffersResumeMatchOfferLeg, superAdminMatchOffersSuspendMatchOffer, superAdminMatchOffersSuspendMatchOfferLeg, superAdminMatchOffersVoidMatchOffer, superAdminOperatorDashboardAcknowledgeMachineCreditAlarm, superAdminOperatorDashboardGetOperatorQueue, superAdminOperatorDashboardGetOperatorStats, superAdminOperatorDashboardGetTelemetryEventSummary, superAdminPlatformGrantFactsGetPlatformGrantFacts, superAdminPledgesAcceptCampaign, superAdminPledgesApprovePublishReview, superAdminPledgesCancelPledge, superAdminPledgesDismissObjection, superAdminPledgesGetReviewCampaignDetail, superAdminPledgesListHeldPledges, superAdminPledgesListPublishReviewCampaigns, superAdminPledgesListReviewCampaigns, superAdminPledgesPartialSettlePledge, superAdminPledgesRejectPublishReview, superAdminPledgesResolveHeldPledge, superAdminPledgesVoidCampaign, superAdminProfileBlocksListProfileBlocksForModeration, superAdminProfileBlocksRelistProfileBlock, superAdminProfileBlocksUnlistProfileBlock, surveysGetCharityRecommendations, surveysGetSavedRecommendations, surveysSubmitSurveyAnswer, telemetryEventsRecordTelemetryEvent, termsGetCurrentTerms, termsGetLatestTerms, termsGetNotificationStatus, termsGetRecentNotifications, termsGetTermsDetail, termsGetTermsNotifyAudienceCount, termsGetTermsNotifyPreview, termsGetTermsVersion, termsListTerms, termsNotifyTerms, termsNotifyTermsAtSuperAdmin, termsPatchTermsSummary, termsPatchTermsSummaryAtSuperAdmin, termsPostTermsNotifyTest, termsPostTermsNotifyTestAtSuperAdmin, termsPublishTerms, termsPublishTermsAtSuperAdmin, termsRetryFailedBatches, termsRetryFailedBatchesAtSuperAdmin, usersActivateMyRecurringDonation, usersBlockUser, usersCancelMyRecurringDonation, usersCheckEmailAvailable, usersCheckPhoneAvailable, usersCheckUsernameAvailable, usersCheckWorkEmail, usersConfirmUserEmail, usersCreateUser, usersCreateUserCard, usersCreateUserCardV2, usersDeleteMyConnectedApp, usersDeleteUser, usersDeleteUserCard, usersDepositFunds, usersDownloadMyChampionQr, userSecurityCancelMyFactorReset, userSecurityConfirmMySsoLink, userSecurityGetMySecurity, userSecurityMintMyRecoveryCodes, userSecurityOptInToMySmsNotices, userSecurityOptOutOfMySmsNotices, userSecurityReEnableMySmsNotices, userSecurityRegenerateMyRecoveryCodes, userSecuritySignOutEverywhere, userSecurityStartMySsoLink, userSecuritySyncMyFactors, usersGetMe, usersGetMyChampion, usersGetMyConnectedApps, usersGetMyGivingProfile, usersGetMyMemberships, usersGetMyQrDesign, usersGetMyRecurringDonations, usersGetUpcomingBirthdays, usersGetUser, usersGetUserCards, usersGetUserCardsV2, usersGetUserChampionedCharityDonatedAmount, usersGetUserImpact, usersGetUserImpactMethodology, usersGetUserPrivateStatistics, usersGetUsers, usersGetUserStatistics, usersGetUserWallet, usersGraduateUser, usersLinkCompany, usersListBlockedUsers, usersListStuckUserDeletions, usersMintMyShareRef, usersRetryFailedUserDeletions, usersSaveMyQrDesign, usersSendEmailVerification, usersSetMyChampionCharity, usersSetMyChampionTarget, usersUnblockUser, usersUnlinkCompany, usersUpdateBirthdayVisibility, usersUpdateMyGivingProfile, usersUpdateMyRecurringDonation, usersUpdateUser, usersUpdateUserById, usersUpdateUserChampionedCharity, usersUpdateUserCustomerId, usersUpdateUserFacebookId, usersUpdateUserPaymentMethod, usersUpdateUserPreferences, usersUploadUserProfilePicture, usersVerifyAccess, usersVerifyWorkEmail } from '../sdk.gen';
import type { AccountingExportExportGcfAccountingData, AccountingExportExportGcfAccountingError, AccountingExportExportGcfAccountingResponse, AdminCheckEmailAvailableData, AdminCheckEmailAvailableError, AdminCheckEmailAvailableResponse, AdminCompanySecurityExportCompanySecurityAuditData, AdminCompanySecurityExportCompanySecurityAuditError, AdminCompanySecurityExportCompanySecurityAuditResponse, AdminCompanySecurityResetCompanySsoSessionsData, AdminCompanySecurityResetCompanySsoSessionsResponse, AdminCompanySsoCheckCompanyDomainVerificationData, AdminCompanySsoCheckCompanyDomainVerificationResponse, AdminCompanySsoConfigureCompanySsoConnectionData, AdminCompanySsoConfigureCompanySsoConnectionError, AdminCompanySsoConfigureCompanySsoConnectionResponse, AdminCompanySsoGetCompanySsoConfigData, AdminCompanySsoGetCompanySsoConfigResponse, AdminCompanySsoGetCompanySsoConnectionData, AdminCompanySsoGetCompanySsoConnectionResponse, AdminCompanySsoGetCompanySsoLockReadinessData, AdminCompanySsoGetCompanySsoLockReadinessResponse, AdminCompanySsoGetCompanySsoTestConnectionData, AdminCompanySsoGetCompanySsoTestConnectionError, AdminCompanySsoGetCompanySsoTestConnectionResponse, AdminCompanySsoRotateCompanyScimTokenData, AdminCompanySsoRotateCompanyScimTokenResponse, AdminCompanySsoStartCompanyDomainVerificationData, AdminCompanySsoStartCompanyDomainVerificationResponse, AdminCompanySsoStartCompanySsoTestConnectionData, AdminCompanySsoStartCompanySsoTestConnectionError, AdminCompanySsoStartCompanySsoTestConnectionResponse, AdminCompanySsoUpdateCompanyScimSettingsData, AdminCompanySsoUpdateCompanyScimSettingsError, AdminCompanySsoUpdateCompanyScimSettingsResponse, AdminCompanySsoUpdateCompanySsoPolicyData, AdminCompanySsoUpdateCompanySsoPolicyError, AdminCompanySsoUpdateCompanySsoPolicyResponse, AiGivingGetMyAiGivingLimitData, AiGivingGetMyAiGivingLimitResponse, AiGivingSetMyAiGivingLimitData, AiGivingSetMyAiGivingLimitError, AiGivingSetMyAiGivingLimitResponse, ApiCreatePaymentSessionFromUrlData, ApiCreatePaymentSessionFromUrlError, ApiCreatePaymentSessionFromUrlResponse, ApiTestFlightData, ApiTestFlightResponse, AppGetMinimumVersionData, AppGetMinimumVersionError, AppGetMinimumVersionResponse, AssistantCancelAssistantTurnData, AssistantCancelAssistantTurnError, AssistantCancelAssistantTurnResponse, AssistantConfirmAssistantEscalationData, AssistantConfirmAssistantEscalationError, AssistantConfirmAssistantEscalationResponse, AssistantCreateAssistantConversationData, AssistantCreateAssistantConversationError, AssistantCreateAssistantConversationResponse, AssistantDeleteAssistantConversationData, AssistantDeleteAssistantConversationError, AssistantDeleteAssistantConversationResponse, AssistantGetAssistantConfigData, AssistantGetAssistantConfigResponse, AssistantGetAssistantConsentData, AssistantGetAssistantConsentResponse, AssistantGetAssistantConversationData, AssistantGetAssistantConversationError, AssistantGetAssistantConversationResponse, AssistantGetAssistantEscalationAdminData, AssistantGetAssistantEscalationAdminError, AssistantGetAssistantEscalationAdminResponse, AssistantGetAssistantSuperadminConfigData, AssistantGetAssistantSuperadminConfigResponse, AssistantGetAssistantUsageAdminData, AssistantGetAssistantUsageAdminError, AssistantGetAssistantUsageAdminResponse, AssistantListAssistantConversationsData, AssistantListAssistantConversationsError, AssistantListAssistantConversationsResponse, AssistantListAssistantEscalationsAdminData, AssistantListAssistantEscalationsAdminError, AssistantListAssistantEscalationsAdminResponse, AssistantListAssistantFeedbackAdminData, AssistantListAssistantFeedbackAdminError, AssistantListAssistantFeedbackAdminResponse, AssistantListAssistantTurnEventsAdminData, AssistantListAssistantTurnEventsAdminError, AssistantListAssistantTurnEventsAdminResponse, AssistantListAssistantTurnsAdminData, AssistantListAssistantTurnsAdminError, AssistantListAssistantTurnsAdminResponse, AssistantListAssistantTurnToolCallsAdminData, AssistantListAssistantTurnToolCallsAdminError, AssistantListAssistantTurnToolCallsAdminResponse, AssistantProposeAssistantEscalationData, AssistantProposeAssistantEscalationError, AssistantProposeAssistantEscalationResponse, AssistantRecordAssistantConsentData, AssistantRecordAssistantConsentError, AssistantRecordAssistantConsentResponse, AssistantResolveAssistantEscalationAdminData, AssistantResolveAssistantEscalationAdminError, AssistantResolveAssistantEscalationAdminResponse, AssistantSendAssistantMessageData, AssistantSendAssistantMessageError, AssistantSendAssistantMessageResponse, AssistantStreamAssistantTurnData, AssistantStreamAssistantTurnError, AssistantStreamAssistantTurnResponse, AssistantSubmitAssistantFeedbackData, AssistantSubmitAssistantFeedbackError, AssistantSubmitAssistantFeedbackResponse, AssistantUpdateAssistantSuperadminConfigData, AssistantUpdateAssistantSuperadminConfigError, AssistantUpdateAssistantSuperadminConfigResponse, BirthdayGiftsCancelBirthdayGiftData, BirthdayGiftsCancelBirthdayGiftError, BirthdayGiftsCancelBirthdayGiftResponse, BirthdayGiftsCreateBirthdayGiftData, BirthdayGiftsCreateBirthdayGiftError, BirthdayGiftsCreateBirthdayGiftResponse, BirthdayGiftsGetBirthdayGiftData, BirthdayGiftsGetBirthdayGiftError, BirthdayGiftsGetBirthdayGiftResponse, BirthdayGiftsListBirthdayGiftsData, BirthdayGiftsListBirthdayGiftsResponse, BirthdayGiftsUpdateBirthdayGiftData, BirthdayGiftsUpdateBirthdayGiftError, BirthdayGiftsUpdateBirthdayGiftResponse, BoardDirectorAcknowledgeBoardRecordData, BoardDirectorAcknowledgeBoardRecordError, BoardDirectorAcknowledgeBoardRecordResponse, BoardDirectorCreateBoardDirectorAnnotationData, BoardDirectorCreateBoardDirectorAnnotationError, BoardDirectorCreateBoardDirectorAnnotationResponse, BoardDirectorDeleteBoardDirectorAnnotationData, BoardDirectorDeleteBoardDirectorAnnotationError, BoardDirectorDeleteBoardDirectorAnnotationResponse, BoardDirectorGetBoardAboutData, BoardDirectorGetBoardAboutError, BoardDirectorGetBoardAboutResponse, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorData, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorError, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorResponse, BoardDirectorGetBoardDirectorAttentionCompletedData, BoardDirectorGetBoardDirectorAttentionCompletedError, BoardDirectorGetBoardDirectorAttentionCompletedResponse, BoardDirectorGetBoardDirectorAttentionData, BoardDirectorGetBoardDirectorAttentionError, BoardDirectorGetBoardDirectorAttentionResponse, BoardDirectorGetBoardDirectorConsentData, BoardDirectorGetBoardDirectorConsentError, BoardDirectorGetBoardDirectorConsentResponse, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlData, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlError, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlResponse, BoardDirectorGetBoardDirectorMeData, BoardDirectorGetBoardDirectorMeetingCalendarData, BoardDirectorGetBoardDirectorMeetingCalendarError, BoardDirectorGetBoardDirectorMeetingCalendarResponse, BoardDirectorGetBoardDirectorMeetingData, BoardDirectorGetBoardDirectorMeetingError, BoardDirectorGetBoardDirectorMeetingRecordData, BoardDirectorGetBoardDirectorMeetingRecordError, BoardDirectorGetBoardDirectorMeetingRecordResponse, BoardDirectorGetBoardDirectorMeetingResponse, BoardDirectorGetBoardDirectorMeResponse, BoardDirectorGetBoardDirectorPacketData, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlData, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlError, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlResponse, BoardDirectorGetBoardDirectorPacketError, BoardDirectorGetBoardDirectorPacketResponse, BoardDirectorGetBoardDirectorRecordData, BoardDirectorGetBoardDirectorRecordError, BoardDirectorGetBoardDirectorRecordResponse, BoardDirectorGetBoardReturnCopyForDirectorData, BoardDirectorGetBoardReturnCopyForDirectorError, BoardDirectorGetBoardReturnCopyForDirectorResponse, BoardDirectorGetBoardSelfAssessmentResultsForDirectorData, BoardDirectorGetBoardSelfAssessmentResultsForDirectorError, BoardDirectorGetBoardSelfAssessmentResultsForDirectorResponse, BoardDirectorGetOwnBoardCoiQuestionnaireData, BoardDirectorGetOwnBoardCoiQuestionnaireError, BoardDirectorGetOwnBoardCoiQuestionnaireResponse, BoardDirectorGetOwnBoardCoiResponseChangesData, BoardDirectorGetOwnBoardCoiResponseChangesError, BoardDirectorGetOwnBoardCoiResponseChangesResponse, BoardDirectorGetOwnBoardCoiResponseData, BoardDirectorGetOwnBoardCoiResponseDocumentData, BoardDirectorGetOwnBoardCoiResponseDocumentError, BoardDirectorGetOwnBoardCoiResponseDocumentResponse, BoardDirectorGetOwnBoardCoiResponseError, BoardDirectorGetOwnBoardCoiResponseResponse, BoardDirectorGetOwnBoardGettingStartedData, BoardDirectorGetOwnBoardGettingStartedError, BoardDirectorGetOwnBoardGettingStartedResponse, BoardDirectorGetOwnBoardSelfAssessmentQuestionsData, BoardDirectorGetOwnBoardSelfAssessmentQuestionsError, BoardDirectorGetOwnBoardSelfAssessmentQuestionsResponse, BoardDirectorListBoardDirectorAnnotationsData, BoardDirectorListBoardDirectorAnnotationsError, BoardDirectorListBoardDirectorAnnotationsResponse, BoardDirectorListBoardDirectorConsentsData, BoardDirectorListBoardDirectorConsentsError, BoardDirectorListBoardDirectorConsentsResponse, BoardDirectorListBoardDirectorMeetingsData, BoardDirectorListBoardDirectorMeetingsError, BoardDirectorListBoardDirectorMeetingsResponse, BoardDirectorListBoardDirectorRecordsData, BoardDirectorListBoardDirectorRecordsError, BoardDirectorListBoardDirectorRecordsResponse, BoardDirectorListBoardDirectorUpcomingMeetingsData, BoardDirectorListBoardDirectorUpcomingMeetingsResponse, BoardDirectorListOwnBoardCoiCyclesData, BoardDirectorListOwnBoardCoiCyclesError, BoardDirectorListOwnBoardCoiCyclesResponse, BoardDirectorListOwnBoardConflictDisclosuresData, BoardDirectorListOwnBoardConflictDisclosuresError, BoardDirectorListOwnBoardConflictDisclosuresResponse, BoardDirectorListOwnBoardSelfAssessmentsData, BoardDirectorListOwnBoardSelfAssessmentsError, BoardDirectorListOwnBoardSelfAssessmentsResponse, BoardDirectorMarkOwnBoardGettingStartedStepData, BoardDirectorMarkOwnBoardGettingStartedStepError, BoardDirectorMarkOwnBoardGettingStartedStepResponse, BoardDirectorOpenBoardReturnCopyForDirectorData, BoardDirectorOpenBoardReturnCopyForDirectorError, BoardDirectorOpenBoardReturnCopyForDirectorResponse, BoardDirectorOrgAcknowledgeBoardRecordData, BoardDirectorOrgAcknowledgeBoardRecordError, BoardDirectorOrgAcknowledgeBoardRecordResponse, BoardDirectorOrgClaimBoardSeatData, BoardDirectorOrgClaimBoardSeatError, BoardDirectorOrgClaimBoardSeatResponse, BoardDirectorOrgCompleteBoardSeatMoveData, BoardDirectorOrgCompleteBoardSeatMoveError, BoardDirectorOrgCompleteBoardSeatMoveResponse, BoardDirectorOrgCreateBoardDirectorAnnotationData, BoardDirectorOrgCreateBoardDirectorAnnotationError, BoardDirectorOrgCreateBoardDirectorAnnotationResponse, BoardDirectorOrgDeleteBoardDirectorAnnotationData, BoardDirectorOrgDeleteBoardDirectorAnnotationError, BoardDirectorOrgDeleteBoardDirectorAnnotationResponse, BoardDirectorOrgGetBoardAboutData, BoardDirectorOrgGetBoardAboutError, BoardDirectorOrgGetBoardAboutResponse, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorData, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorError, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorResponse, BoardDirectorOrgGetBoardDirectorAttentionCompletedData, BoardDirectorOrgGetBoardDirectorAttentionCompletedError, BoardDirectorOrgGetBoardDirectorAttentionCompletedResponse, BoardDirectorOrgGetBoardDirectorAttentionData, BoardDirectorOrgGetBoardDirectorAttentionError, BoardDirectorOrgGetBoardDirectorAttentionResponse, BoardDirectorOrgGetBoardDirectorConsentData, BoardDirectorOrgGetBoardDirectorConsentError, BoardDirectorOrgGetBoardDirectorConsentResponse, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlData, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlError, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlResponse, BoardDirectorOrgGetBoardDirectorMeData, BoardDirectorOrgGetBoardDirectorMeetingCalendarData, BoardDirectorOrgGetBoardDirectorMeetingCalendarError, BoardDirectorOrgGetBoardDirectorMeetingCalendarResponse, BoardDirectorOrgGetBoardDirectorMeetingData, BoardDirectorOrgGetBoardDirectorMeetingError, BoardDirectorOrgGetBoardDirectorMeetingRecordData, BoardDirectorOrgGetBoardDirectorMeetingRecordError, BoardDirectorOrgGetBoardDirectorMeetingRecordResponse, BoardDirectorOrgGetBoardDirectorMeetingResponse, BoardDirectorOrgGetBoardDirectorMeResponse, BoardDirectorOrgGetBoardDirectorPacketData, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlData, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlError, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlResponse, BoardDirectorOrgGetBoardDirectorPacketError, BoardDirectorOrgGetBoardDirectorPacketResponse, BoardDirectorOrgGetBoardDirectorRecordData, BoardDirectorOrgGetBoardDirectorRecordError, BoardDirectorOrgGetBoardDirectorRecordResponse, BoardDirectorOrgGetBoardReturnCopyForDirectorData, BoardDirectorOrgGetBoardReturnCopyForDirectorError, BoardDirectorOrgGetBoardReturnCopyForDirectorResponse, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorData, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorError, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorResponse, BoardDirectorOrgGetOwnBoardCoiQuestionnaireData, BoardDirectorOrgGetOwnBoardCoiQuestionnaireError, BoardDirectorOrgGetOwnBoardCoiQuestionnaireResponse, BoardDirectorOrgGetOwnBoardCoiResponseChangesData, BoardDirectorOrgGetOwnBoardCoiResponseChangesError, BoardDirectorOrgGetOwnBoardCoiResponseChangesResponse, BoardDirectorOrgGetOwnBoardCoiResponseData, BoardDirectorOrgGetOwnBoardCoiResponseDocumentData, BoardDirectorOrgGetOwnBoardCoiResponseDocumentError, BoardDirectorOrgGetOwnBoardCoiResponseDocumentResponse, BoardDirectorOrgGetOwnBoardCoiResponseError, BoardDirectorOrgGetOwnBoardCoiResponseResponse, BoardDirectorOrgGetOwnBoardGettingStartedData, BoardDirectorOrgGetOwnBoardGettingStartedError, BoardDirectorOrgGetOwnBoardGettingStartedResponse, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsData, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsError, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsResponse, BoardDirectorOrgListBoardDirectorAnnotationsData, BoardDirectorOrgListBoardDirectorAnnotationsError, BoardDirectorOrgListBoardDirectorAnnotationsResponse, BoardDirectorOrgListBoardDirectorConsentsData, BoardDirectorOrgListBoardDirectorConsentsError, BoardDirectorOrgListBoardDirectorConsentsResponse, BoardDirectorOrgListBoardDirectorMeetingsData, BoardDirectorOrgListBoardDirectorMeetingsError, BoardDirectorOrgListBoardDirectorMeetingsResponse, BoardDirectorOrgListBoardDirectorRecordsData, BoardDirectorOrgListBoardDirectorRecordsError, BoardDirectorOrgListBoardDirectorRecordsResponse, BoardDirectorOrgListBoardDirectorUpcomingMeetingsData, BoardDirectorOrgListBoardDirectorUpcomingMeetingsResponse, BoardDirectorOrgListOwnBoardCoiCyclesData, BoardDirectorOrgListOwnBoardCoiCyclesError, BoardDirectorOrgListOwnBoardCoiCyclesResponse, BoardDirectorOrgListOwnBoardConflictDisclosuresData, BoardDirectorOrgListOwnBoardConflictDisclosuresError, BoardDirectorOrgListOwnBoardConflictDisclosuresResponse, BoardDirectorOrgListOwnBoardSelfAssessmentsData, BoardDirectorOrgListOwnBoardSelfAssessmentsError, BoardDirectorOrgListOwnBoardSelfAssessmentsResponse, BoardDirectorOrgMarkOwnBoardGettingStartedStepData, BoardDirectorOrgMarkOwnBoardGettingStartedStepError, BoardDirectorOrgMarkOwnBoardGettingStartedStepResponse, BoardDirectorOrgOpenBoardReturnCopyForDirectorData, BoardDirectorOrgOpenBoardReturnCopyForDirectorError, BoardDirectorOrgOpenBoardReturnCopyForDirectorResponse, BoardDirectorOrgPreviewBoardInvitationData, BoardDirectorOrgPreviewBoardInvitationError, BoardDirectorOrgPreviewBoardInvitationResponse, BoardDirectorOrgPreviewBoardSeatMoveData, BoardDirectorOrgPreviewBoardSeatMoveError, BoardDirectorOrgPreviewBoardSeatMoveResponse, BoardDirectorOrgRecordBoardDirectorAttendanceIntentData, BoardDirectorOrgRecordBoardDirectorAttendanceIntentError, BoardDirectorOrgRecordBoardDirectorAttendanceIntentResponse, BoardDirectorOrgRecordOwnBoardConflictDisclosureData, BoardDirectorOrgRecordOwnBoardConflictDisclosureError, BoardDirectorOrgRecordOwnBoardConflictDisclosureResponse, BoardDirectorOrgRequestBoardSeatClaimCodeData, BoardDirectorOrgRequestBoardSeatClaimCodeError, BoardDirectorOrgRequestBoardSeatClaimCodeResponse, BoardDirectorOrgRequestBoardSeatMoveCodeData, BoardDirectorOrgRequestBoardSeatMoveCodeError, BoardDirectorOrgRequestBoardSeatMoveCodeResponse, BoardDirectorOrgRevokeBoardWrittenConsentSignatureData, BoardDirectorOrgRevokeBoardWrittenConsentSignatureError, BoardDirectorOrgRevokeBoardWrittenConsentSignatureResponse, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersData, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersError, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersResponse, BoardDirectorOrgSignBoardMinutesData, BoardDirectorOrgSignBoardMinutesError, BoardDirectorOrgSignBoardMinutesResponse, BoardDirectorOrgSignBoardMinutesToApproveData, BoardDirectorOrgSignBoardMinutesToApproveError, BoardDirectorOrgSignBoardMinutesToApproveResponse, BoardDirectorOrgSignBoardWrittenConsentData, BoardDirectorOrgSignBoardWrittenConsentError, BoardDirectorOrgSignBoardWrittenConsentResponse, BoardDirectorOrgStartBoardSeatMoveData, BoardDirectorOrgStartBoardSeatMoveError, BoardDirectorOrgStartBoardSeatMoveResponse, BoardDirectorOrgSubmitOwnBoardCoiResponseData, BoardDirectorOrgSubmitOwnBoardCoiResponseError, BoardDirectorOrgSubmitOwnBoardCoiResponseResponse, BoardDirectorRecordBoardDirectorAttendanceIntentData, BoardDirectorRecordBoardDirectorAttendanceIntentError, BoardDirectorRecordBoardDirectorAttendanceIntentResponse, BoardDirectorRecordOwnBoardConflictDisclosureData, BoardDirectorRecordOwnBoardConflictDisclosureError, BoardDirectorRecordOwnBoardConflictDisclosureResponse, BoardDirectorRevokeBoardWrittenConsentSignatureData, BoardDirectorRevokeBoardWrittenConsentSignatureError, BoardDirectorRevokeBoardWrittenConsentSignatureResponse, BoardDirectorSaveOwnBoardSelfAssessmentAnswersData, BoardDirectorSaveOwnBoardSelfAssessmentAnswersError, BoardDirectorSaveOwnBoardSelfAssessmentAnswersResponse, BoardDirectorSignBoardMinutesData, BoardDirectorSignBoardMinutesError, BoardDirectorSignBoardMinutesResponse, BoardDirectorSignBoardMinutesToApproveData, BoardDirectorSignBoardMinutesToApproveError, BoardDirectorSignBoardMinutesToApproveResponse, BoardDirectorSignBoardWrittenConsentData, BoardDirectorSignBoardWrittenConsentError, BoardDirectorSignBoardWrittenConsentResponse, BoardDirectorStartBoardSeatMoveData, BoardDirectorStartBoardSeatMoveError, BoardDirectorStartBoardSeatMoveResponse, BoardDirectorSubmitOwnBoardCoiResponseData, BoardDirectorSubmitOwnBoardCoiResponseError, BoardDirectorSubmitOwnBoardCoiResponseResponse, BooksActivateBooksData, BooksActivateBooksError, BooksActivateBooksResponse, BooksGetBooksData, BooksGetBooksError, BooksGetBooksResponse, CampaignsAcceptCampaignLayerInviteData, CampaignsAcceptCampaignLayerInviteError, CampaignsAcceptCampaignLayerInviteResponse, CampaignsApproveCampaignJoinRequestData, CampaignsApproveCampaignJoinRequestError, CampaignsApproveCampaignJoinRequestResponse, CampaignsApproveCampaignLayerRequestData, CampaignsApproveCampaignLayerRequestError, CampaignsApproveCampaignLayerRequestResponse, CampaignsAttachCampaignLayerData, CampaignsAttachCampaignLayerError, CampaignsAttachCampaignLayerResponse, CampaignsCreateCampaignJoinInviteData, CampaignsCreateCampaignJoinInviteError, CampaignsCreateCampaignJoinInviteResponse, CampaignsCreateCampaignTeamData, CampaignsCreateCampaignTeamError, CampaignsCreateCampaignTeamResponse, CampaignsDeclineCampaignJoinRequestData, CampaignsDeclineCampaignJoinRequestError, CampaignsDeclineCampaignJoinRequestResponse, CampaignsDeclineCampaignLayerInviteData, CampaignsDeclineCampaignLayerInviteError, CampaignsDeclineCampaignLayerInviteResponse, CampaignsDeclineCampaignLayerRequestData, CampaignsDeclineCampaignLayerRequestError, CampaignsDeclineCampaignLayerRequestResponse, CampaignsEnableCampaignData, CampaignsEnableCampaignError, CampaignsEnableCampaignResponse, CampaignsGetCampaignLayerParentData, CampaignsGetCampaignLayerParentError, CampaignsGetCampaignLayerParentResponse, CampaignsGetCampaignLayerStructureData, CampaignsGetCampaignLayerStructureError, CampaignsGetCampaignLayerStructureResponse, CampaignsGetCampaignOverviewData, CampaignsGetCampaignOverviewError, CampaignsGetCampaignOverviewResponse, CampaignsGetOwnCampaignLayerRequestData, CampaignsGetOwnCampaignLayerRequestError, CampaignsGetOwnCampaignLayerRequestResponse, CampaignsJoinCampaignParentData, CampaignsJoinCampaignParentError, CampaignsJoinCampaignParentResponse, CampaignsLeaveCampaignLayerData, CampaignsLeaveCampaignLayerError, CampaignsLeaveCampaignLayerResponse, CampaignsListCampaignJoinInvitesData, CampaignsListCampaignJoinInvitesError, CampaignsListCampaignJoinInvitesResponse, CampaignsListCampaignJoinRequestsData, CampaignsListCampaignJoinRequestsError, CampaignsListCampaignJoinRequestsResponse, CampaignsListCampaignLayerBoardData, CampaignsListCampaignLayerBoardError, CampaignsListCampaignLayerBoardResponse, CampaignsListCampaignLayerCandidatesData, CampaignsListCampaignLayerCandidatesError, CampaignsListCampaignLayerCandidatesResponse, CampaignsListCampaignLayerRequestsData, CampaignsListCampaignLayerRequestsError, CampaignsListCampaignLayerRequestsResponse, CampaignsListCampaignLayersData, CampaignsListCampaignLayersError, CampaignsListCampaignLayersResponse, CampaignsListCampaignScheduleData, CampaignsListCampaignScheduleError, CampaignsListCampaignScheduleResponse, CampaignsListCampaignStructureLayersData, CampaignsListCampaignStructureLayersError, CampaignsListCampaignStructureLayersResponse, CampaignsListReceivedCampaignLayerInvitesData, CampaignsListReceivedCampaignLayerInvitesError, CampaignsListReceivedCampaignLayerInvitesResponse, CampaignsListSentCampaignLayerInvitesData, CampaignsListSentCampaignLayerInvitesError, CampaignsListSentCampaignLayerInvitesResponse, CampaignsMoveCampaignLayerData, CampaignsMoveCampaignLayerError, CampaignsMoveCampaignLayerResponse, CampaignsPreviewCampaignJoinParentData, CampaignsPreviewCampaignJoinParentError, CampaignsPreviewCampaignJoinParentResponse, CampaignsRemoveCampaignLayerData, CampaignsRemoveCampaignLayerError, CampaignsRemoveCampaignLayerResponse, CampaignsRevokeCampaignJoinInviteData, CampaignsRevokeCampaignJoinInviteError, CampaignsRevokeCampaignJoinInviteResponse, CampaignsRevokeCampaignLayerInviteData, CampaignsRevokeCampaignLayerInviteError, CampaignsRevokeCampaignLayerInviteResponse, CampaignsSendCampaignLayerInviteData, CampaignsSendCampaignLayerInviteError, CampaignsSendCampaignLayerInviteResponse, CampaignsSetUpCampaignSeasonData, CampaignsSetUpCampaignSeasonError, CampaignsSetUpCampaignSeasonResponse, CampaignsUpdateCampaignData, CampaignsUpdateCampaignError, CampaignsUpdateCampaignResponse, CampaignsUpdateCampaignSupporterData, CampaignsUpdateCampaignSupporterError, CampaignsUpdateCampaignSupporterResponse, CampaignsUpdateCampaignTeamData, CampaignsUpdateCampaignTeamError, CampaignsUpdateCampaignTeamResponse, CampaignsWithdrawCampaignLayerRequestData, CampaignsWithdrawCampaignLayerRequestError, CampaignsWithdrawCampaignLayerRequestResponse, CauseTagsCreateCauseTagData, CauseTagsCreateCauseTagError, CauseTagsCreateCauseTagResponse, CauseTagsDeleteCauseTagData, CauseTagsDeleteCauseTagError, CauseTagsDeleteCauseTagResponse, CauseTagsGetAllCauseTagsData, CauseTagsGetAllCauseTagsResponse, CauseTagsUpdateCauseTagData, CauseTagsUpdateCauseTagError, CauseTagsUpdateCauseTagResponse, CelebrityCharitiesCreateCelebrityCharityData, CelebrityCharitiesCreateCelebrityCharityError, CelebrityCharitiesCreateCelebrityCharityResponse, CelebrityCharitiesDeleteCelebrityCharityData, CelebrityCharitiesDeleteCelebrityCharityError, CelebrityCharitiesDeleteCelebrityCharityResponse, CelebrityCharitiesGetCelebrityCharitiesData, CelebrityCharitiesGetCelebrityCharitiesError, CelebrityCharitiesGetCelebrityCharitiesResponse, CelebrityCharitiesGetCelebrityCharityData, CelebrityCharitiesGetCelebrityCharityError, CelebrityCharitiesGetCelebrityCharityResponse, CelebrityCharitiesUpdateCelebrityCharityData, CelebrityCharitiesUpdateCelebrityCharityError, CelebrityCharitiesUpdateCelebrityCharityResponse, CelebrityCharitiesUploadCelebrityCharityPosterData, CelebrityCharitiesUploadCelebrityCharityPosterError, CelebrityCharitiesUploadCelebrityCharityPosterResponse, ChampionsResolveChampionLandingData, ChampionsResolveChampionLandingError, ChampionsResolveChampionLandingResponse, ChampionsResolveChampionNativeData, ChampionsResolveChampionNativeError, ChampionsResolveChampionNativeResponse, CharitiesAddCauseTagToCharityData, CharitiesAddCauseTagToCharityError, CharitiesAddCauseTagToCharityResponse, CharitiesCreateCharityData, CharitiesCreateCharityError, CharitiesCreateCharityResponse, CharitiesGetCauseTagsForCharityData, CharitiesGetCauseTagsForCharityError, CharitiesGetCauseTagsForCharityResponse, CharitiesGetCharitiesByCauseTagData, CharitiesGetCharitiesByCauseTagError, CharitiesGetCharitiesByCauseTagResponse, CharitiesGetCharitiesData, CharitiesGetCharitiesError, CharitiesGetCharitiesResponse, CharitiesGetCharityData, CharitiesGetCharityDomainCoverageData, CharitiesGetCharityDomainCoverageResponse, CharitiesGetCharityError, CharitiesGetCharityResponse, CharitiesGetFollowsChampionedCharitiesData, CharitiesGetFollowsChampionedCharitiesError, CharitiesGetFollowsChampionedCharitiesResponse, CharitiesGetFollowsDonatedCharitiesData, CharitiesGetFollowsDonatedCharitiesError, CharitiesGetFollowsDonatedCharitiesResponse, CharitiesGetSuggestedCharitiesData, CharitiesGetSuggestedCharitiesResponse, CharitiesLookupCharityByDomainData, CharitiesLookupCharityByDomainError, CharitiesLookupCharityByDomainResponse, CharitiesRemoveCauseTagFromCharityData, CharitiesRemoveCauseTagFromCharityError, CharitiesRemoveCauseTagFromCharityResponse, CharitiesUpdateCharityData, CharitiesUpdateCharityError, CharitiesUpdateCharityResponse, CharitiesUploadCharityProfilePictureData, CharitiesUploadCharityProfilePictureError, CharitiesUploadCharityProfilePictureResponse, CharityAdminAcceptCharityInviteData, CharityAdminAcceptCharityInviteError, CharityAdminAcceptCharityInviteResponse, CharityAdminAcceptCharityTermsData, CharityAdminAcceptCharityTermsError, CharityAdminAcceptCharityTermsResponse, CharityAdminAddCharityAdminData, CharityAdminAddCharityAdminError, CharityAdminAddCharityAdminResponse, CharityAdminAddCrmDonorTagData, CharityAdminAddCrmDonorTagError, CharityAdminAddCrmDonorTagResponse, CharityAdminClearCharityDisplayNameData, CharityAdminClearCharityDisplayNameError, CharityAdminClearCharityDisplayNameResponse, CharityAdminConfirmVerificationUploadData, CharityAdminConfirmVerificationUploadError, CharityAdminConfirmVerificationUploadResponse, CharityAdminCreateCharityInviteData, CharityAdminCreateCharityInviteError, CharityAdminCreateCharityInviteResponse, CharityAdminCreateCrmDonorNoteData, CharityAdminCreateCrmDonorNoteError, CharityAdminCreateCrmDonorNoteResponse, CharityAdminCreateCrmImportedContactData, CharityAdminCreateCrmImportedContactError, CharityAdminCreateCrmImportedContactResponse, CharityAdminDeleteCrmDonorNoteData, CharityAdminDeleteCrmDonorNoteError, CharityAdminDeleteCrmDonorNoteResponse, CharityAdminDeleteCrmImportedContactData, CharityAdminDeleteCrmImportedContactError, CharityAdminDeleteCrmImportedContactResponse, CharityAdminElectCharityCheckData, CharityAdminElectCharityCheckError, CharityAdminElectCharityCheckResponse, CharityAdminExportCrmAnalyticsCsvData, CharityAdminExportCrmAnalyticsCsvError, CharityAdminExportCrmAnalyticsCsvResponse, CharityAdminExportCrmDonorsCsvData, CharityAdminExportCrmDonorsCsvError, CharityAdminExportCrmDonorsCsvResponse, CharityAdminExportCrmImportedContactsCsvData, CharityAdminExportCrmImportedContactsCsvError, CharityAdminExportCrmImportedContactsCsvResponse, CharityAdminExportSection321StatementWorkbookData, CharityAdminExportSection321StatementWorkbookError, CharityAdminExportSection321StatementWorkbookResponse, CharityAdminGetCharityCheckAddressData, CharityAdminGetCharityCheckAddressError, CharityAdminGetCharityCheckAddressResponse, CharityAdminGetCharityFollowerCountData, CharityAdminGetCharityFollowerCountError, CharityAdminGetCharityFollowerCountResponse, CharityAdminGetCharityPaymentProfileData, CharityAdminGetCharityPaymentProfileError, CharityAdminGetCharityPaymentProfileResponse, CharityAdminGetCharityProfileData, CharityAdminGetCharityProfileError, CharityAdminGetCharityProfileResponse, CharityAdminGetCharityTermsAcceptanceStateData, CharityAdminGetCharityTermsAcceptanceStateError, CharityAdminGetCharityTermsAcceptanceStateResponse, CharityAdminGetCharityTermsData, CharityAdminGetCharityTermsError, CharityAdminGetCharityTermsForClaimData, CharityAdminGetCharityTermsForClaimError, CharityAdminGetCharityTermsForClaimResponse, CharityAdminGetCharityTermsResponse, CharityAdminGetCrmAnalyticsSummaryData, CharityAdminGetCrmAnalyticsSummaryError, CharityAdminGetCrmAnalyticsSummaryResponse, CharityAdminGetCrmDonorData, CharityAdminGetCrmDonorError, CharityAdminGetCrmDonorResponse, CharityAdminGetCrmRetentionData, CharityAdminGetCrmRetentionError, CharityAdminGetCrmRetentionResponse, CharityAdminGetSection321ConsentingDonorsData, CharityAdminGetSection321ConsentingDonorsError, CharityAdminGetSection321ConsentingDonorsResponse, CharityAdminGetSection321DashboardData, CharityAdminGetSection321DashboardError, CharityAdminGetSection321DashboardResponse, CharityAdminGetSection321FundraiserDetailData, CharityAdminGetSection321FundraiserDetailError, CharityAdminGetSection321FundraiserDetailResponse, CharityAdminGetSection321GrantDetailData, CharityAdminGetSection321GrantDetailError, CharityAdminGetSection321GrantDetailResponse, CharityAdminGetSection321StatementData, CharityAdminGetSection321StatementError, CharityAdminGetSection321StatementResponse, CharityAdminListCharityAdminsData, CharityAdminListCharityAdminsError, CharityAdminListCharityAdminsResponse, CharityAdminListCharityInvitesData, CharityAdminListCharityInvitesError, CharityAdminListCharityInvitesResponse, CharityAdminListCharityPaymentEventsData, CharityAdminListCharityPaymentEventsError, CharityAdminListCharityPaymentEventsResponse, CharityAdminListCharityRemovalRequestsData, CharityAdminListCharityRemovalRequestsError, CharityAdminListCharityRemovalRequestsResponse, CharityAdminListCrmDonorsData, CharityAdminListCrmDonorsError, CharityAdminListCrmDonorsResponse, CharityAdminListCrmImportedContactsData, CharityAdminListCrmImportedContactsError, CharityAdminListCrmImportedContactsResponse, CharityAdminListMyCharityClaimsData, CharityAdminListMyCharityClaimsResponse, CharityAdminListMyMembershipsData, CharityAdminListMyMembershipsResponse, CharityAdminListMyVerificationDocumentsData, CharityAdminListMyVerificationDocumentsError, CharityAdminListMyVerificationDocumentsResponse, CharityAdminListSection321FundraisersData, CharityAdminListSection321FundraisersError, CharityAdminListSection321FundraisersResponse, CharityAdminListSection321GrantsData, CharityAdminListSection321GrantsError, CharityAdminListSection321GrantsResponse, CharityAdminObjectToFundraiserMessageData, CharityAdminObjectToFundraiserMessageError, CharityAdminObjectToFundraiserMessageResponse, CharityAdminProfilePageGetCharityPageData, CharityAdminProfilePageGetCharityPageError, CharityAdminProfilePageGetCharityPageResponse, CharityAdminProfilePageReplaceCharityPageData, CharityAdminProfilePageReplaceCharityPageError, CharityAdminProfilePageReplaceCharityPageResponse, CharityAdminProfilePageUploadCharityPageImageData, CharityAdminProfilePageUploadCharityPageImageError, CharityAdminProfilePageUploadCharityPageImageResponse, CharityAdminRemoveCharityAdminData, CharityAdminRemoveCharityAdminError, CharityAdminRemoveCharityAdminResponse, CharityAdminRemoveCrmDonorTagData, CharityAdminRemoveCrmDonorTagError, CharityAdminRemoveCrmDonorTagResponse, CharityAdminRequestCharityRemovalData, CharityAdminRequestCharityRemovalError, CharityAdminRequestCharityRemovalResponse, CharityAdminRequestVerificationUploadUrlData, CharityAdminRequestVerificationUploadUrlError, CharityAdminRequestVerificationUploadUrlResponse, CharityAdminRevokeCharityInviteData, CharityAdminRevokeCharityInviteError, CharityAdminRevokeCharityInviteResponse, CharityAdminSetCharityDisplayNameData, CharityAdminSetCharityDisplayNameError, CharityAdminSetCharityDisplayNameResponse, CharityAdminSubmitCharityAchData, CharityAdminSubmitCharityAchError, CharityAdminSubmitCharityAchResponse, CharityAdminSubmitCharityClaimData, CharityAdminSubmitCharityClaimError, CharityAdminSubmitCharityClaimResponse, CharityAdminUpdateCharityAdminRoleData, CharityAdminUpdateCharityAdminRoleError, CharityAdminUpdateCharityAdminRoleResponse, CharityAdminUpdateCharityProfileData, CharityAdminUpdateCharityProfileError, CharityAdminUpdateCharityProfileResponse, CharityAdminUpdateCrmDonorNoteData, CharityAdminUpdateCrmDonorNoteError, CharityAdminUpdateCrmDonorNoteResponse, CharityAdminUpdateCrmImportedContactData, CharityAdminUpdateCrmImportedContactError, CharityAdminUpdateCrmImportedContactResponse, CharityAdminUploadCharityProfileLogoData, CharityAdminUploadCharityProfileLogoError, CharityAdminUploadCharityProfileLogoResponse, CharityAdminWithdrawCharityDisplayNameRequestData, CharityAdminWithdrawCharityDisplayNameRequestError, CharityAdminWithdrawCharityDisplayNameRequestResponse, CharityAlternativesCreateCharityAlternativeRecommendationData, CharityAlternativesCreateCharityAlternativeRecommendationError, CharityAlternativesCreateCharityAlternativeRecommendationResponse, CharityBoardAddBoardCommitteeMemberData, CharityBoardAddBoardCommitteeMemberError, CharityBoardAddBoardCommitteeMemberResponse, CharityBoardAddBoardCommitteeSuggestionItemsData, CharityBoardAddBoardCommitteeSuggestionItemsError, CharityBoardAddBoardCommitteeSuggestionItemsResponse, CharityBoardAddBoardConsentCompensationDecisionData, CharityBoardAddBoardConsentCompensationDecisionError, CharityBoardAddBoardConsentCompensationDecisionResponse, CharityBoardAddBoardMemberToBoardData, CharityBoardAddBoardMemberToBoardError, CharityBoardAddBoardMemberToBoardResponse, CharityBoardAddBoardMotionCompensationDecisionData, CharityBoardAddBoardMotionCompensationDecisionError, CharityBoardAddBoardMotionCompensationDecisionResponse, CharityBoardAddBoardTermSuggestionItemsData, CharityBoardAddBoardTermSuggestionItemsError, CharityBoardAddBoardTermSuggestionItemsResponse, CharityBoardAdoptBoardCalendarSettingsData, CharityBoardAdoptBoardCalendarSettingsError, CharityBoardAdoptBoardCalendarSettingsResponse, CharityBoardAdoptBoardOfficerDutiesData, CharityBoardAdoptBoardOfficerDutiesError, CharityBoardAdoptBoardOfficerDutiesResponse, CharityBoardAdoptBoardRetentionPolicyData, CharityBoardAdoptBoardRetentionPolicyError, CharityBoardAdoptBoardRetentionPolicyResponse, CharityBoardApplyBoardAgendaTemplateData, CharityBoardApplyBoardAgendaTemplateError, CharityBoardApplyBoardAgendaTemplateResponse, CharityBoardApplyBoardCalendarSettingsData, CharityBoardApplyBoardCalendarSettingsError, CharityBoardApplyBoardCalendarSettingsResponse, CharityBoardApproveBoardMinutesData, CharityBoardApproveBoardMinutesError, CharityBoardApproveBoardMinutesResponse, CharityBoardApproveBoardRecordData, CharityBoardApproveBoardRecordError, CharityBoardApproveBoardRecordResponse, CharityBoardAskBoardMinutesApprovalSignaturesData, CharityBoardAskBoardMinutesApprovalSignaturesError, CharityBoardAskBoardMinutesApprovalSignaturesResponse, CharityBoardCancelBoardCoiCycleData, CharityBoardCancelBoardCoiCycleError, CharityBoardCancelBoardCoiCycleResponse, CharityBoardCancelBoardMeetingData, CharityBoardCancelBoardMeetingError, CharityBoardCancelBoardMeetingResponse, CharityBoardCancelBoardSelfAssessmentData, CharityBoardCancelBoardSelfAssessmentError, CharityBoardCancelBoardSelfAssessmentResponse, CharityBoardCheckBoardImportInboxFileData, CharityBoardCheckBoardImportInboxFileError, CharityBoardCheckBoardImportInboxFileResponse, CharityBoardCheckBoardProposalFileData, CharityBoardCheckBoardProposalFileError, CharityBoardCheckBoardProposalFileResponse, CharityBoardChooseBoardMemberBuddyData, CharityBoardChooseBoardMemberBuddyError, CharityBoardChooseBoardMemberBuddyResponse, CharityBoardCirculateBoardWrittenConsentData, CharityBoardCirculateBoardWrittenConsentError, CharityBoardCirculateBoardWrittenConsentResponse, CharityBoardCloseBoardCoiCycleData, CharityBoardCloseBoardCoiCycleError, CharityBoardCloseBoardCoiCycleResponse, CharityBoardCloseBoardImportBatchData, CharityBoardCloseBoardImportBatchError, CharityBoardCloseBoardImportBatchResponse, CharityBoardCloseBoardMemberGettingStartedData, CharityBoardCloseBoardMemberGettingStartedError, CharityBoardCloseBoardMemberGettingStartedResponse, CharityBoardCloseBoardSelfAssessmentData, CharityBoardCloseBoardSelfAssessmentError, CharityBoardCloseBoardSelfAssessmentResponse, CharityBoardConfirmBoardCompensationDocumentData, CharityBoardConfirmBoardCompensationDocumentError, CharityBoardConfirmBoardCompensationDocumentResponse, CharityBoardConfirmBoardDocumentData, CharityBoardConfirmBoardDocumentError, CharityBoardConfirmBoardDocumentResponse, CharityBoardConfirmBoardPastRecordBatchData, CharityBoardConfirmBoardPastRecordBatchError, CharityBoardConfirmBoardPastRecordBatchResponse, CharityBoardConfirmBoardReturnCopyData, CharityBoardConfirmBoardReturnCopyError, CharityBoardConfirmBoardReturnCopyResponse, CharityBoardCorrectBoardCommitteeDissolutionData, CharityBoardCorrectBoardCommitteeDissolutionError, CharityBoardCorrectBoardCommitteeDissolutionResponse, CharityBoardCreateBoardAgendaItemData, CharityBoardCreateBoardAgendaItemError, CharityBoardCreateBoardAgendaItemResponse, CharityBoardCreateBoardCommitteeData, CharityBoardCreateBoardCommitteeError, CharityBoardCreateBoardCommitteeResponse, CharityBoardCreateBoardDirectorClassData, CharityBoardCreateBoardDirectorClassError, CharityBoardCreateBoardDirectorClassResponse, CharityBoardCreateBoardMeetingData, CharityBoardCreateBoardMeetingError, CharityBoardCreateBoardMeetingResponse, CharityBoardCreateBoardMeetingSegmentData, CharityBoardCreateBoardMeetingSegmentError, CharityBoardCreateBoardMeetingSegmentResponse, CharityBoardCreateBoardMemberData, CharityBoardCreateBoardMemberError, CharityBoardCreateBoardMemberResponse, CharityBoardCreateBoardMinutesApprovalConsentData, CharityBoardCreateBoardMinutesApprovalConsentError, CharityBoardCreateBoardMinutesApprovalConsentResponse, CharityBoardCreateBoardMotionData, CharityBoardCreateBoardMotionError, CharityBoardCreateBoardMotionResponse, CharityBoardCreateBoardOfficerTitleData, CharityBoardCreateBoardOfficerTitleError, CharityBoardCreateBoardOfficerTitleResponse, CharityBoardCreateBoardPacketData, CharityBoardCreateBoardPacketError, CharityBoardCreateBoardPacketItemData, CharityBoardCreateBoardPacketItemError, CharityBoardCreateBoardPacketItemResponse, CharityBoardCreateBoardPacketResponse, CharityBoardCreateBoardRecordDraftData, CharityBoardCreateBoardRecordDraftError, CharityBoardCreateBoardRecordDraftResponse, CharityBoardCreateBoardWrittenConsentData, CharityBoardCreateBoardWrittenConsentError, CharityBoardCreateBoardWrittenConsentResponse, CharityBoardDeleteBoardAgendaItemData, CharityBoardDeleteBoardAgendaItemError, CharityBoardDeleteBoardAgendaItemResponse, CharityBoardDeleteBoardConflictLinkData, CharityBoardDeleteBoardConflictLinkError, CharityBoardDeleteBoardConflictLinkResponse, CharityBoardDeleteBoardImportFileUploadData, CharityBoardDeleteBoardImportFileUploadError, CharityBoardDeleteBoardImportFileUploadResponse, CharityBoardDeleteBoardImportRecordFileUploadData, CharityBoardDeleteBoardImportRecordFileUploadError, CharityBoardDeleteBoardImportRecordFileUploadResponse, CharityBoardDeleteBoardMeetingSegmentData, CharityBoardDeleteBoardMeetingSegmentError, CharityBoardDeleteBoardMeetingSegmentResponse, CharityBoardDeleteBoardMotionData, CharityBoardDeleteBoardMotionError, CharityBoardDeleteBoardMotionResponse, CharityBoardDeleteBoardPacketItemData, CharityBoardDeleteBoardPacketItemError, CharityBoardDeleteBoardPacketItemResponse, CharityBoardDeleteBoardRecordChainData, CharityBoardDeleteBoardRecordChainError, CharityBoardDeleteBoardRecordChainResponse, CharityBoardDeleteBoardRecordData, CharityBoardDeleteBoardRecordError, CharityBoardDeleteBoardRecordResponse, CharityBoardDiscardBoardMemberProposalData, CharityBoardDiscardBoardMemberProposalError, CharityBoardDiscardBoardMemberProposalResponse, CharityBoardDiscardBoardPacketData, CharityBoardDiscardBoardPacketError, CharityBoardDiscardBoardPacketResponse, CharityBoardDiscardBoardPastRecordBatchData, CharityBoardDiscardBoardPastRecordBatchError, CharityBoardDiscardBoardPastRecordBatchResponse, CharityBoardDiscardBoardRecordDraftData, CharityBoardDiscardBoardRecordDraftError, CharityBoardDiscardBoardRecordDraftResponse, CharityBoardDismissBoardCommitteeSuggestionData, CharityBoardDismissBoardCommitteeSuggestionError, CharityBoardDismissBoardCommitteeSuggestionResponse, CharityBoardDismissBoardTermSuggestionData, CharityBoardDismissBoardTermSuggestionError, CharityBoardDismissBoardTermSuggestionResponse, CharityBoardDissolveBoardCommitteeData, CharityBoardDissolveBoardCommitteeError, CharityBoardDissolveBoardCommitteeResponse, CharityBoardDistributeBoardPacketData, CharityBoardDistributeBoardPacketError, CharityBoardDistributeBoardPacketResponse, CharityBoardEmailBoardReturnAgainData, CharityBoardEmailBoardReturnAgainError, CharityBoardEmailBoardReturnAgainResponse, CharityBoardEndBoardCommitteeMemberData, CharityBoardEndBoardCommitteeMemberError, CharityBoardEndBoardCommitteeMemberResponse, CharityBoardExportBoardMinuteBookData, CharityBoardExportBoardMinuteBookDocumentData, CharityBoardExportBoardMinuteBookDocumentError, CharityBoardExportBoardMinuteBookDocumentResponse, CharityBoardExportBoardMinuteBookError, CharityBoardExportBoardMinuteBookResponse, CharityBoardGetBoardCalendarSettingsData, CharityBoardGetBoardCalendarSettingsError, CharityBoardGetBoardCalendarSettingsResponse, CharityBoardGetBoardCoiCycleData, CharityBoardGetBoardCoiCycleDocumentData, CharityBoardGetBoardCoiCycleDocumentError, CharityBoardGetBoardCoiCycleDocumentResponse, CharityBoardGetBoardCoiCycleError, CharityBoardGetBoardCoiCycleResponse, CharityBoardGetBoardCoiPaperFormData, CharityBoardGetBoardCoiPaperFormError, CharityBoardGetBoardCoiPaperFormResponse, CharityBoardGetBoardCoiPersonQuestionnaireData, CharityBoardGetBoardCoiPersonQuestionnaireError, CharityBoardGetBoardCoiPersonQuestionnaireResponse, CharityBoardGetBoardCoiQuestionnaireData, CharityBoardGetBoardCoiQuestionnaireError, CharityBoardGetBoardCoiQuestionnaireResponse, CharityBoardGetBoardCoiResponseChangesData, CharityBoardGetBoardCoiResponseChangesError, CharityBoardGetBoardCoiResponseChangesResponse, CharityBoardGetBoardCoiResponseData, CharityBoardGetBoardCoiResponseDocumentData, CharityBoardGetBoardCoiResponseDocumentError, CharityBoardGetBoardCoiResponseDocumentResponse, CharityBoardGetBoardCoiResponseError, CharityBoardGetBoardCoiResponseResponse, CharityBoardGetBoardCommitteeData, CharityBoardGetBoardCommitteeError, CharityBoardGetBoardCommitteeResponse, CharityBoardGetBoardCommitteeSuggestionsData, CharityBoardGetBoardCommitteeSuggestionsError, CharityBoardGetBoardCommitteeSuggestionsResponse, CharityBoardGetBoardCompensationDecisionData, CharityBoardGetBoardCompensationDecisionDocumentDownloadData, CharityBoardGetBoardCompensationDecisionDocumentDownloadError, CharityBoardGetBoardCompensationDecisionDocumentDownloadResponse, CharityBoardGetBoardCompensationDecisionError, CharityBoardGetBoardCompensationDecisionResponse, CharityBoardGetBoardCompensationDocumentDownloadData, CharityBoardGetBoardCompensationDocumentDownloadError, CharityBoardGetBoardCompensationDocumentDownloadResponse, CharityBoardGetBoardConsentTemplateData, CharityBoardGetBoardConsentTemplateError, CharityBoardGetBoardConsentTemplateResponse, CharityBoardGetBoardDirectorAccessPolicyData, CharityBoardGetBoardDirectorAccessPolicyError, CharityBoardGetBoardDirectorAccessPolicyResponse, CharityBoardGetBoardDocumentDownloadUrlData, CharityBoardGetBoardDocumentDownloadUrlError, CharityBoardGetBoardDocumentDownloadUrlResponse, CharityBoardGetBoardFilingGovernanceFeedData, CharityBoardGetBoardFilingGovernanceFeedError, CharityBoardGetBoardFilingGovernanceFeedResponse, CharityBoardGetBoardForm990Data, CharityBoardGetBoardForm990Error, CharityBoardGetBoardForm990Response, CharityBoardGetBoardGettingStartedListData, CharityBoardGetBoardGettingStartedListError, CharityBoardGetBoardGettingStartedListResponse, CharityBoardGetBoardGoverningDocumentTemplateData, CharityBoardGetBoardGoverningDocumentTemplateError, CharityBoardGetBoardGoverningDocumentTemplateResponse, CharityBoardGetBoardImportBatchData, CharityBoardGetBoardImportBatchError, CharityBoardGetBoardImportBatchResponse, CharityBoardGetBoardImportInboxFileUrlData, CharityBoardGetBoardImportInboxFileUrlError, CharityBoardGetBoardImportInboxFileUrlResponse, CharityBoardGetBoardInMeetingRecordData, CharityBoardGetBoardInMeetingRecordError, CharityBoardGetBoardInMeetingRecordResponse, CharityBoardGetBoardLegalHoldReportData, CharityBoardGetBoardLegalHoldReportError, CharityBoardGetBoardLegalHoldReportResponse, CharityBoardGetBoardMeetingCalendarData, CharityBoardGetBoardMeetingCalendarError, CharityBoardGetBoardMeetingCalendarResponse, CharityBoardGetBoardMeetingData, CharityBoardGetBoardMeetingError, CharityBoardGetBoardMeetingInvitationsData, CharityBoardGetBoardMeetingInvitationsError, CharityBoardGetBoardMeetingInvitationsResponse, CharityBoardGetBoardMeetingPresidingData, CharityBoardGetBoardMeetingPresidingError, CharityBoardGetBoardMeetingPresidingResponse, CharityBoardGetBoardMeetingResponse, CharityBoardGetBoardMemberData, CharityBoardGetBoardMemberError, CharityBoardGetBoardMemberGettingStartedData, CharityBoardGetBoardMemberGettingStartedError, CharityBoardGetBoardMemberGettingStartedResponse, CharityBoardGetBoardMemberResponse, CharityBoardGetBoardMinutesApprovalConsentFormData, CharityBoardGetBoardMinutesApprovalConsentFormError, CharityBoardGetBoardMinutesApprovalConsentFormResponse, CharityBoardGetBoardMinutesData, CharityBoardGetBoardMinutesError, CharityBoardGetBoardMinutesResponse, CharityBoardGetBoardOfficerDutiesData, CharityBoardGetBoardOfficerDutiesError, CharityBoardGetBoardOfficerDutiesResponse, CharityBoardGetBoardOfficerStatementData, CharityBoardGetBoardOfficerStatementError, CharityBoardGetBoardOfficerStatementResponse, CharityBoardGetBoardPacketData, CharityBoardGetBoardPacketError, CharityBoardGetBoardPacketResponse, CharityBoardGetBoardPastRecordBatchData, CharityBoardGetBoardPastRecordBatchError, CharityBoardGetBoardPastRecordBatchResponse, CharityBoardGetBoardProposalFileUrlData, CharityBoardGetBoardProposalFileUrlError, CharityBoardGetBoardProposalFileUrlResponse, CharityBoardGetBoardRecordData, CharityBoardGetBoardRecordError, CharityBoardGetBoardRecordFileUrlData, CharityBoardGetBoardRecordFileUrlError, CharityBoardGetBoardRecordFileUrlResponse, CharityBoardGetBoardRecordResponse, CharityBoardGetBoardReturnCopyUrlData, CharityBoardGetBoardReturnCopyUrlError, CharityBoardGetBoardReturnCopyUrlResponse, CharityBoardGetBoardReturnDistributionData, CharityBoardGetBoardReturnDistributionError, CharityBoardGetBoardReturnDistributionResponse, CharityBoardGetBoardScheduleODraftData, CharityBoardGetBoardScheduleODraftError, CharityBoardGetBoardScheduleODraftResponse, CharityBoardGetBoardSelfAssessmentData, CharityBoardGetBoardSelfAssessmentError, CharityBoardGetBoardSelfAssessmentInstrumentData, CharityBoardGetBoardSelfAssessmentInstrumentError, CharityBoardGetBoardSelfAssessmentInstrumentResponse, CharityBoardGetBoardSelfAssessmentQuestionsData, CharityBoardGetBoardSelfAssessmentQuestionsError, CharityBoardGetBoardSelfAssessmentQuestionsResponse, CharityBoardGetBoardSelfAssessmentResponse, CharityBoardGetBoardSelfAssessmentResultsData, CharityBoardGetBoardSelfAssessmentResultsError, CharityBoardGetBoardSelfAssessmentResultsResponse, CharityBoardGetBoardTermSuggestionsData, CharityBoardGetBoardTermSuggestionsError, CharityBoardGetBoardTermSuggestionsResponse, CharityBoardGetBoardToDoData, CharityBoardGetBoardToDoError, CharityBoardGetBoardToDoResponse, CharityBoardGetBoardWrittenConsentData, CharityBoardGetBoardWrittenConsentError, CharityBoardGetBoardWrittenConsentResponse, CharityBoardImportBoardRecordData, CharityBoardImportBoardRecordError, CharityBoardImportBoardRecordResponse, CharityBoardIssueBoardCompensationDocumentUploadUrlData, CharityBoardIssueBoardCompensationDocumentUploadUrlError, CharityBoardIssueBoardCompensationDocumentUploadUrlResponse, CharityBoardIssueBoardDocumentUploadUrlData, CharityBoardIssueBoardDocumentUploadUrlError, CharityBoardIssueBoardDocumentUploadUrlResponse, CharityBoardIssueBoardImportFileUploadUrlData, CharityBoardIssueBoardImportFileUploadUrlError, CharityBoardIssueBoardImportFileUploadUrlResponse, CharityBoardIssueBoardImportInboxUploadUrlData, CharityBoardIssueBoardImportInboxUploadUrlError, CharityBoardIssueBoardImportInboxUploadUrlResponse, CharityBoardIssueBoardImportRecordFileUploadUrlData, CharityBoardIssueBoardImportRecordFileUploadUrlError, CharityBoardIssueBoardImportRecordFileUploadUrlResponse, CharityBoardIssueBoardProposalFileUploadUrlData, CharityBoardIssueBoardProposalFileUploadUrlError, CharityBoardIssueBoardProposalFileUploadUrlResponse, CharityBoardIssueBoardReturnCopyUploadUrlData, CharityBoardIssueBoardReturnCopyUploadUrlError, CharityBoardIssueBoardReturnCopyUploadUrlResponse, CharityBoardLeaveOutBoardPastRecordData, CharityBoardLeaveOutBoardPastRecordError, CharityBoardLeaveOutBoardPastRecordResponse, CharityBoardLinkBoardCommitteeCharterData, CharityBoardLinkBoardCommitteeCharterError, CharityBoardLinkBoardCommitteeCharterResponse, CharityBoardLinkBoardReturnReviewData, CharityBoardLinkBoardReturnReviewError, CharityBoardLinkBoardReturnReviewResponse, CharityBoardLinkBoardSelfAssessmentPrioritiesData, CharityBoardLinkBoardSelfAssessmentPrioritiesError, CharityBoardLinkBoardSelfAssessmentPrioritiesResponse, CharityBoardListBoardAgendaItemsData, CharityBoardListBoardAgendaItemsError, CharityBoardListBoardAgendaItemsResponse, CharityBoardListBoardAgendaTemplatesData, CharityBoardListBoardAgendaTemplatesError, CharityBoardListBoardAgendaTemplatesResponse, CharityBoardListBoardApprovableMinutesData, CharityBoardListBoardApprovableMinutesError, CharityBoardListBoardApprovableMinutesResponse, CharityBoardListBoardAttendanceIntentsData, CharityBoardListBoardAttendanceIntentsError, CharityBoardListBoardAttendanceIntentsResponse, CharityBoardListBoardCalendarConnectionsData, CharityBoardListBoardCalendarConnectionsError, CharityBoardListBoardCalendarConnectionsResponse, CharityBoardListBoardCalendarSendersData, CharityBoardListBoardCalendarSendersError, CharityBoardListBoardCalendarSendersResponse, CharityBoardListBoardCarryForwardItemsData, CharityBoardListBoardCarryForwardItemsError, CharityBoardListBoardCarryForwardItemsResponse, CharityBoardListBoardCarryForwardMotionsData, CharityBoardListBoardCarryForwardMotionsError, CharityBoardListBoardCarryForwardMotionsResponse, CharityBoardListBoardCoiCyclesData, CharityBoardListBoardCoiCyclesError, CharityBoardListBoardCoiCyclesResponse, CharityBoardListBoardCoiQuestionnairesData, CharityBoardListBoardCoiQuestionnairesError, CharityBoardListBoardCoiQuestionnairesResponse, CharityBoardListBoardCommitteesData, CharityBoardListBoardCommitteesError, CharityBoardListBoardCommitteeSourcesData, CharityBoardListBoardCommitteeSourcesError, CharityBoardListBoardCommitteeSourcesResponse, CharityBoardListBoardCommitteesResponse, CharityBoardListBoardCompensationDecisionsData, CharityBoardListBoardCompensationDecisionsError, CharityBoardListBoardCompensationDecisionsResponse, CharityBoardListBoardConflictLinksData, CharityBoardListBoardConflictLinksError, CharityBoardListBoardConflictLinksResponse, CharityBoardListBoardConflictRegisterData, CharityBoardListBoardConflictRegisterError, CharityBoardListBoardConflictRegisterResponse, CharityBoardListBoardConflictSuggestionsData, CharityBoardListBoardConflictSuggestionsError, CharityBoardListBoardConflictSuggestionsResponse, CharityBoardListBoardConsentCompensationDecisionsData, CharityBoardListBoardConsentCompensationDecisionsError, CharityBoardListBoardConsentCompensationDecisionsResponse, CharityBoardListBoardConsentTemplatesData, CharityBoardListBoardConsentTemplatesError, CharityBoardListBoardConsentTemplatesResponse, CharityBoardListBoardContemporaneityData, CharityBoardListBoardContemporaneityError, CharityBoardListBoardContemporaneityResponse, CharityBoardListBoardDirectorClassesData, CharityBoardListBoardDirectorClassesError, CharityBoardListBoardDirectorClassesResponse, CharityBoardListBoardDocumentsData, CharityBoardListBoardDocumentsError, CharityBoardListBoardDocumentsResponse, CharityBoardListBoardEngagementData, CharityBoardListBoardEngagementError, CharityBoardListBoardEngagementResponse, CharityBoardListBoardGettingStartedStepsData, CharityBoardListBoardGettingStartedStepsError, CharityBoardListBoardGettingStartedStepsResponse, CharityBoardListBoardGovernanceParametersData, CharityBoardListBoardGovernanceParametersError, CharityBoardListBoardGovernanceParametersResponse, CharityBoardListBoardGoverningDocumentsData, CharityBoardListBoardGoverningDocumentsError, CharityBoardListBoardGoverningDocumentsResponse, CharityBoardListBoardGoverningDocumentTemplatesData, CharityBoardListBoardGoverningDocumentTemplatesError, CharityBoardListBoardGoverningDocumentTemplatesResponse, CharityBoardListBoardImportBatchesData, CharityBoardListBoardImportBatchesError, CharityBoardListBoardImportBatchesResponse, CharityBoardListBoardImportBatchRecordsData, CharityBoardListBoardImportBatchRecordsError, CharityBoardListBoardImportBatchRecordsResponse, CharityBoardListBoardImportInboxData, CharityBoardListBoardImportInboxError, CharityBoardListBoardImportInboxResponse, CharityBoardListBoardLegalHoldsData, CharityBoardListBoardLegalHoldsError, CharityBoardListBoardLegalHoldsResponse, CharityBoardListBoardMeetingAttendanceData, CharityBoardListBoardMeetingAttendanceError, CharityBoardListBoardMeetingAttendanceResponse, CharityBoardListBoardMeetingCompensationDecisionsData, CharityBoardListBoardMeetingCompensationDecisionsError, CharityBoardListBoardMeetingCompensationDecisionsResponse, CharityBoardListBoardMeetingEventsData, CharityBoardListBoardMeetingEventsError, CharityBoardListBoardMeetingEventsResponse, CharityBoardListBoardMeetingsData, CharityBoardListBoardMeetingSegmentsData, CharityBoardListBoardMeetingSegmentsError, CharityBoardListBoardMeetingSegmentsResponse, CharityBoardListBoardMeetingsError, CharityBoardListBoardMeetingsResponse, CharityBoardListBoardMemberHistoryData, CharityBoardListBoardMemberHistoryError, CharityBoardListBoardMemberHistoryResponse, CharityBoardListBoardMemberProposalsData, CharityBoardListBoardMemberProposalsError, CharityBoardListBoardMemberProposalsResponse, CharityBoardListBoardMembersData, CharityBoardListBoardMembersError, CharityBoardListBoardMembersResponse, CharityBoardListBoardMotionsData, CharityBoardListBoardMotionsError, CharityBoardListBoardMotionsResponse, CharityBoardListBoardOfficerTitlesData, CharityBoardListBoardOfficerTitlesError, CharityBoardListBoardOfficerTitlesResponse, CharityBoardListBoardPacketCommentsData, CharityBoardListBoardPacketCommentsError, CharityBoardListBoardPacketCommentsResponse, CharityBoardListBoardPacketDistributionsData, CharityBoardListBoardPacketDistributionsError, CharityBoardListBoardPacketDistributionsResponse, CharityBoardListBoardPacketsData, CharityBoardListBoardPacketsError, CharityBoardListBoardPacketsResponse, CharityBoardListBoardPastRecordBatchesData, CharityBoardListBoardPastRecordBatchesError, CharityBoardListBoardPastRecordBatchesResponse, CharityBoardListBoardRecordAcknowledgmentsData, CharityBoardListBoardRecordAcknowledgmentsError, CharityBoardListBoardRecordAcknowledgmentsResponse, CharityBoardListBoardRecordEventsData, CharityBoardListBoardRecordEventsError, CharityBoardListBoardRecordEventsResponse, CharityBoardListBoardRecordsData, CharityBoardListBoardRecordsError, CharityBoardListBoardRecordsResponse, CharityBoardListBoardRetentionPoliciesData, CharityBoardListBoardRetentionPoliciesError, CharityBoardListBoardRetentionPoliciesResponse, CharityBoardListBoardReturnDistributionsData, CharityBoardListBoardReturnDistributionsError, CharityBoardListBoardReturnDistributionsResponse, CharityBoardListBoardReturnReviewCandidatesData, CharityBoardListBoardReturnReviewCandidatesError, CharityBoardListBoardReturnReviewCandidatesResponse, CharityBoardListBoardSelfAssessmentInstrumentsData, CharityBoardListBoardSelfAssessmentInstrumentsError, CharityBoardListBoardSelfAssessmentInstrumentsResponse, CharityBoardListBoardSelfAssessmentsData, CharityBoardListBoardSelfAssessmentsError, CharityBoardListBoardSelfAssessmentsResponse, CharityBoardListBoardWrittenConsentsData, CharityBoardListBoardWrittenConsentsError, CharityBoardListBoardWrittenConsentsResponse, CharityBoardMarkBoardMemberGettingStartedStepData, CharityBoardMarkBoardMemberGettingStartedStepError, CharityBoardMarkBoardMemberGettingStartedStepResponse, CharityBoardMarkBoardPastRecordConfidentialityData, CharityBoardMarkBoardPastRecordConfidentialityError, CharityBoardMarkBoardPastRecordConfidentialityResponse, CharityBoardMarkBoardSelfAssessmentPaperHandInData, CharityBoardMarkBoardSelfAssessmentPaperHandInError, CharityBoardMarkBoardSelfAssessmentPaperHandInResponse, CharityBoardMintBoardAccessLinkData, CharityBoardMintBoardAccessLinkError, CharityBoardMintBoardAccessLinkResponse, CharityBoardMoveBoardCalendarMeetingsData, CharityBoardMoveBoardCalendarMeetingsError, CharityBoardMoveBoardCalendarMeetingsResponse, CharityBoardMoveBoardMeetingInvitationsData, CharityBoardMoveBoardMeetingInvitationsError, CharityBoardMoveBoardMeetingInvitationsResponse, CharityBoardOpenBoardCoiCycleData, CharityBoardOpenBoardCoiCycleError, CharityBoardOpenBoardCoiCycleResponse, CharityBoardOpenBoardFilingReceiptData, CharityBoardOpenBoardFilingReceiptError, CharityBoardOpenBoardFilingReceiptResponse, CharityBoardOpenBoardImportBatchData, CharityBoardOpenBoardImportBatchError, CharityBoardOpenBoardImportBatchResponse, CharityBoardOpenBoardSelfAssessmentData, CharityBoardOpenBoardSelfAssessmentError, CharityBoardOpenBoardSelfAssessmentResponse, CharityBoardPlaceBoardLegalHoldData, CharityBoardPlaceBoardLegalHoldError, CharityBoardPlaceBoardLegalHoldResponse, CharityBoardPreviewBoardReturnRecipientsData, CharityBoardPreviewBoardReturnRecipientsError, CharityBoardPreviewBoardReturnRecipientsResponse, CharityBoardProvideBoardReturnData, CharityBoardProvideBoardReturnError, CharityBoardProvideBoardReturnResponse, CharityBoardPublishBoardPacketData, CharityBoardPublishBoardPacketError, CharityBoardPublishBoardPacketResponse, CharityBoardRecordBoardAttendanceIntentOnBehalfData, CharityBoardRecordBoardAttendanceIntentOnBehalfError, CharityBoardRecordBoardAttendanceIntentOnBehalfResponse, CharityBoardRecordBoardCoiPaperResponseData, CharityBoardRecordBoardCoiPaperResponseError, CharityBoardRecordBoardCoiPaperResponseResponse, CharityBoardRecordBoardCommitteeRuleData, CharityBoardRecordBoardCommitteeRuleError, CharityBoardRecordBoardCommitteeRuleResponse, CharityBoardRecordBoardCompensationIndexEntryData, CharityBoardRecordBoardCompensationIndexEntryError, CharityBoardRecordBoardCompensationIndexEntryResponse, CharityBoardRecordBoardConflictDisclosureData, CharityBoardRecordBoardConflictDisclosureError, CharityBoardRecordBoardConflictDisclosureResponse, CharityBoardRecordBoardConflictLinkData, CharityBoardRecordBoardConflictLinkError, CharityBoardRecordBoardConflictLinkResponse, CharityBoardRecordBoardConsentRevocationData, CharityBoardRecordBoardConsentRevocationError, CharityBoardRecordBoardConsentRevocationResponse, CharityBoardRecordBoardConsentSignatureData, CharityBoardRecordBoardConsentSignatureError, CharityBoardRecordBoardConsentSignatureResponse, CharityBoardRecordBoardDirectorsToldData, CharityBoardRecordBoardDirectorsToldError, CharityBoardRecordBoardDirectorsToldResponse, CharityBoardRecordBoardGovernanceParameterData, CharityBoardRecordBoardGovernanceParameterError, CharityBoardRecordBoardGovernanceParameterResponse, CharityBoardRecordBoardMeetingAttendanceData, CharityBoardRecordBoardMeetingAttendanceError, CharityBoardRecordBoardMeetingAttendanceResponse, CharityBoardRecordBoardMeetingPresidingData, CharityBoardRecordBoardMeetingPresidingError, CharityBoardRecordBoardMeetingPresidingResponse, CharityBoardRecordBoardMemberTermData, CharityBoardRecordBoardMemberTermError, CharityBoardRecordBoardMemberTermResponse, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfData, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfError, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfResponse, CharityBoardRecordBoardMinutesApprovalVoteData, CharityBoardRecordBoardMinutesApprovalVoteError, CharityBoardRecordBoardMinutesApprovalVoteResponse, CharityBoardRecordBoardMotionRecusalData, CharityBoardRecordBoardMotionRecusalError, CharityBoardRecordBoardMotionRecusalResponse, CharityBoardRecordBoardMotionVoteData, CharityBoardRecordBoardMotionVoteError, CharityBoardRecordBoardMotionVoteResponse, CharityBoardRecordBoardPacketSharedCommentData, CharityBoardRecordBoardPacketSharedCommentError, CharityBoardRecordBoardPacketSharedCommentResponse, CharityBoardRecordBoardPaperAcknowledgmentsData, CharityBoardRecordBoardPaperAcknowledgmentsError, CharityBoardRecordBoardPaperAcknowledgmentsResponse, CharityBoardRecordBoardReturnPrintedCopyData, CharityBoardRecordBoardReturnPrintedCopyError, CharityBoardRecordBoardReturnPrintedCopyResponse, CharityBoardRecordBoardRosterResultData, CharityBoardRecordBoardRosterResultError, CharityBoardRecordBoardRosterResultResponse, CharityBoardRecordBoardSegmentParticipantData, CharityBoardRecordBoardSegmentParticipantError, CharityBoardRecordBoardSegmentParticipantResponse, CharityBoardRecordBoardSelfAssessmentPaperSheetData, CharityBoardRecordBoardSelfAssessmentPaperSheetError, CharityBoardRecordBoardSelfAssessmentPaperSheetResponse, CharityBoardRecordHistoricalBoardMemberData, CharityBoardRecordHistoricalBoardMemberError, CharityBoardRecordHistoricalBoardMemberResponse, CharityBoardRefreshBoardFilingSnapshotData, CharityBoardRefreshBoardFilingSnapshotError, CharityBoardRefreshBoardFilingSnapshotResponse, CharityBoardReinviteBoardMeetingInviteeData, CharityBoardReinviteBoardMeetingInviteeError, CharityBoardReinviteBoardMeetingInviteeResponse, CharityBoardReleaseBoardLegalHoldData, CharityBoardReleaseBoardLegalHoldError, CharityBoardReleaseBoardLegalHoldResponse, CharityBoardReleaseBoardMemberAccountData, CharityBoardReleaseBoardMemberAccountError, CharityBoardReleaseBoardMemberAccountResponse, CharityBoardRemindBoardCoiCycleRecipientsData, CharityBoardRemindBoardCoiCycleRecipientsError, CharityBoardRemindBoardCoiCycleRecipientsResponse, CharityBoardRemindBoardSelfAssessmentRecipientsData, CharityBoardRemindBoardSelfAssessmentRecipientsError, CharityBoardRemindBoardSelfAssessmentRecipientsResponse, CharityBoardRemoveBoardCompensationDocumentData, CharityBoardRemoveBoardCompensationDocumentError, CharityBoardRemoveBoardCompensationDocumentResponse, CharityBoardRemoveBoardCompensationIndexEntryData, CharityBoardRemoveBoardCompensationIndexEntryError, CharityBoardRemoveBoardCompensationIndexEntryResponse, CharityBoardRemoveBoardConsentCompensationDecisionData, CharityBoardRemoveBoardConsentCompensationDecisionError, CharityBoardRemoveBoardConsentCompensationDecisionResponse, CharityBoardRemoveBoardImportInboxFileData, CharityBoardRemoveBoardImportInboxFileError, CharityBoardRemoveBoardImportInboxFileResponse, CharityBoardRemoveBoardMemberData, CharityBoardRemoveBoardMemberError, CharityBoardRemoveBoardMemberResponse, CharityBoardRemoveBoardMemberTermData, CharityBoardRemoveBoardMemberTermError, CharityBoardRemoveBoardMemberTermResponse, CharityBoardRemoveBoardMotionCompensationDecisionData, CharityBoardRemoveBoardMotionCompensationDecisionError, CharityBoardRemoveBoardMotionCompensationDecisionResponse, CharityBoardRemoveBoardMotionRecusalData, CharityBoardRemoveBoardMotionRecusalError, CharityBoardRemoveBoardMotionRecusalResponse, CharityBoardRemoveBoardSegmentParticipantData, CharityBoardRemoveBoardSegmentParticipantError, CharityBoardRemoveBoardSegmentParticipantResponse, CharityBoardReorderBoardAgendaData, CharityBoardReorderBoardAgendaError, CharityBoardReorderBoardAgendaResponse, CharityBoardReorderBoardMeetingSegmentsData, CharityBoardReorderBoardMeetingSegmentsError, CharityBoardReorderBoardMeetingSegmentsResponse, CharityBoardReorderBoardPacketItemsData, CharityBoardReorderBoardPacketItemsError, CharityBoardReorderBoardPacketItemsResponse, CharityBoardReplaceBoardConsentCompensationDecisionData, CharityBoardReplaceBoardConsentCompensationDecisionError, CharityBoardReplaceBoardConsentCompensationDecisionResponse, CharityBoardReplaceBoardMotionCompensationDecisionData, CharityBoardReplaceBoardMotionCompensationDecisionError, CharityBoardReplaceBoardMotionCompensationDecisionResponse, CharityBoardRestoreBoardCommitteeSuggestionData, CharityBoardRestoreBoardCommitteeSuggestionError, CharityBoardRestoreBoardCommitteeSuggestionResponse, CharityBoardRestoreBoardTermSuggestionData, CharityBoardRestoreBoardTermSuggestionError, CharityBoardRestoreBoardTermSuggestionResponse, CharityBoardRetireBoardDirectorClassData, CharityBoardRetireBoardDirectorClassError, CharityBoardRetireBoardDirectorClassResponse, CharityBoardRetireBoardOfficerTitleData, CharityBoardRetireBoardOfficerTitleError, CharityBoardRetireBoardOfficerTitleResponse, CharityBoardReviseBoardWrittenConsentData, CharityBoardReviseBoardWrittenConsentError, CharityBoardReviseBoardWrittenConsentResponse, CharityBoardSaveBoardGettingStartedListData, CharityBoardSaveBoardGettingStartedListError, CharityBoardSaveBoardGettingStartedListResponse, CharityBoardSaveBoardMemberGettingStartedData, CharityBoardSaveBoardMemberGettingStartedError, CharityBoardSaveBoardMemberGettingStartedResponse, CharityBoardScheduleRestoredBoardMeetingData, CharityBoardScheduleRestoredBoardMeetingError, CharityBoardScheduleRestoredBoardMeetingResponse, CharityBoardSendBoardCoiCycleRequestsData, CharityBoardSendBoardCoiCycleRequestsError, CharityBoardSendBoardCoiCycleRequestsResponse, CharityBoardSendBoardMeetingInvitationsData, CharityBoardSendBoardMeetingInvitationsError, CharityBoardSendBoardMeetingInvitationsResponse, CharityBoardSendBoardMinutesReminderData, CharityBoardSendBoardMinutesReminderError, CharityBoardSendBoardMinutesReminderResponse, CharityBoardSendBoardSelfAssessmentRequestsData, CharityBoardSendBoardSelfAssessmentRequestsError, CharityBoardSendBoardSelfAssessmentRequestsResponse, CharityBoardSetBoardCommitteeConfirmationData, CharityBoardSetBoardCommitteeConfirmationError, CharityBoardSetBoardCommitteeConfirmationResponse, CharityBoardSignBoardMinutesOnBehalfData, CharityBoardSignBoardMinutesOnBehalfError, CharityBoardSignBoardMinutesOnBehalfResponse, CharityBoardStartBoardMemberGettingStartedData, CharityBoardStartBoardMemberGettingStartedError, CharityBoardStartBoardMemberGettingStartedResponse, CharityBoardSubmitBoardRecordData, CharityBoardSubmitBoardRecordError, CharityBoardSubmitBoardRecordResponse, CharityBoardUnlinkBoardReturnReviewData, CharityBoardUnlinkBoardReturnReviewError, CharityBoardUnlinkBoardReturnReviewResponse, CharityBoardUnmarkBoardSelfAssessmentPaperHandInData, CharityBoardUnmarkBoardSelfAssessmentPaperHandInError, CharityBoardUnmarkBoardSelfAssessmentPaperHandInResponse, CharityBoardUpdateBoardAgendaItemData, CharityBoardUpdateBoardAgendaItemError, CharityBoardUpdateBoardAgendaItemResponse, CharityBoardUpdateBoardCoiCycleData, CharityBoardUpdateBoardCoiCycleError, CharityBoardUpdateBoardCoiCycleResponse, CharityBoardUpdateBoardCommitteeData, CharityBoardUpdateBoardCommitteeError, CharityBoardUpdateBoardCommitteeMemberData, CharityBoardUpdateBoardCommitteeMemberError, CharityBoardUpdateBoardCommitteeMemberResponse, CharityBoardUpdateBoardCommitteeResponse, CharityBoardUpdateBoardCompensationDecisionData, CharityBoardUpdateBoardCompensationDecisionError, CharityBoardUpdateBoardCompensationDecisionResponse, CharityBoardUpdateBoardDirectorClassData, CharityBoardUpdateBoardDirectorClassError, CharityBoardUpdateBoardDirectorClassResponse, CharityBoardUpdateBoardImportBatchData, CharityBoardUpdateBoardImportBatchError, CharityBoardUpdateBoardImportBatchResponse, CharityBoardUpdateBoardMeetingData, CharityBoardUpdateBoardMeetingError, CharityBoardUpdateBoardMeetingResponse, CharityBoardUpdateBoardMeetingSegmentData, CharityBoardUpdateBoardMeetingSegmentError, CharityBoardUpdateBoardMeetingSegmentResponse, CharityBoardUpdateBoardMemberData, CharityBoardUpdateBoardMemberError, CharityBoardUpdateBoardMemberResponse, CharityBoardUpdateBoardMemberTermData, CharityBoardUpdateBoardMemberTermError, CharityBoardUpdateBoardMemberTermResponse, CharityBoardUpdateBoardMotionData, CharityBoardUpdateBoardMotionError, CharityBoardUpdateBoardMotionResponse, CharityBoardUpdateBoardOfficerTitleData, CharityBoardUpdateBoardOfficerTitleError, CharityBoardUpdateBoardOfficerTitleResponse, CharityBoardUpdateBoardRecordDraftData, CharityBoardUpdateBoardRecordDraftError, CharityBoardUpdateBoardRecordDraftResponse, CharityBoardUpdateBoardWrittenConsentData, CharityBoardUpdateBoardWrittenConsentError, CharityBoardUpdateBoardWrittenConsentResponse, CharityBoardWithdrawBoardMinutesApprovalSignaturesData, CharityBoardWithdrawBoardMinutesApprovalSignaturesError, CharityBoardWithdrawBoardMinutesApprovalSignaturesResponse, CharityBoardWithdrawBoardMotionData, CharityBoardWithdrawBoardMotionError, CharityBoardWithdrawBoardMotionResponse, CharityBoardWithdrawBoardReturnData, CharityBoardWithdrawBoardReturnError, CharityBoardWithdrawBoardReturnResponse, CharityBoardWithdrawBoardWrittenConsentData, CharityBoardWithdrawBoardWrittenConsentError, CharityBoardWithdrawBoardWrittenConsentResponse, CharityBoardWriteBoardMinutesDraftData, CharityBoardWriteBoardMinutesDraftError, CharityBoardWriteBoardMinutesDraftResponse, CharityCollectionsAddCharityToCollectionData, CharityCollectionsAddCharityToCollectionError, CharityCollectionsAddCharityToCollectionResponse, CharityCollectionsCreateCharityCollectionData, CharityCollectionsCreateCharityCollectionDonationData, CharityCollectionsCreateCharityCollectionDonationError, CharityCollectionsCreateCharityCollectionDonationResponse, CharityCollectionsCreateCharityCollectionError, CharityCollectionsCreateCharityCollectionResponse, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationData, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationError, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationResponse, CharityCollectionsDeleteCharityCollectionData, CharityCollectionsDeleteCharityCollectionError, CharityCollectionsDeleteCharityCollectionResponse, CharityCollectionsDiscoverCharityCollectionsData, CharityCollectionsDiscoverCharityCollectionsError, CharityCollectionsDiscoverCharityCollectionsResponse, CharityCollectionsGetCharityCollectionData, CharityCollectionsGetCharityCollectionError, CharityCollectionsGetCharityCollectionPostsData, CharityCollectionsGetCharityCollectionPostsError, CharityCollectionsGetCharityCollectionPostsResponse, CharityCollectionsGetCharityCollectionResponse, CharityCollectionsGetOwnCharityCollectionData, CharityCollectionsGetOwnCharityCollectionError, CharityCollectionsGetOwnCharityCollectionResponse, CharityCollectionsGetSuperAdminRecentCollectionsData, CharityCollectionsGetSuperAdminRecentCollectionsError, CharityCollectionsGetSuperAdminRecentCollectionsResponse, CharityCollectionsListUserCharityCollectionsData, CharityCollectionsListUserCharityCollectionsError, CharityCollectionsListUserCharityCollectionsResponse, CharityCollectionsRelistCharityCollectionData, CharityCollectionsRelistCharityCollectionError, CharityCollectionsRelistCharityCollectionResponse, CharityCollectionsRemoveCharityFromCollectionData, CharityCollectionsRemoveCharityFromCollectionError, CharityCollectionsRemoveCharityFromCollectionResponse, CharityCollectionsSetCharityCollectionVisibilityData, CharityCollectionsSetCharityCollectionVisibilityError, CharityCollectionsSetCharityCollectionVisibilityResponse, CharityCollectionsUnlistCharityCollectionData, CharityCollectionsUnlistCharityCollectionError, CharityCollectionsUnlistCharityCollectionResponse, CharityCollectionsUpdateCharityCollectionData, CharityCollectionsUpdateCharityCollectionError, CharityCollectionsUpdateCharityCollectionResponse, CharityCollectionsUploadCharityCollectionPictureData, CharityCollectionsUploadCharityCollectionPictureError, CharityCollectionsUploadCharityCollectionPictureResponse, CharityComplianceAddComplianceEarlierRenewalCycleData, CharityComplianceAddComplianceEarlierRenewalCycleError, CharityComplianceAddComplianceEarlierRenewalCycleResponse, CharityComplianceAddComplianceObligationAttachmentData, CharityComplianceAddComplianceObligationAttachmentError, CharityComplianceAddComplianceObligationAttachmentResponse, CharityComplianceAddComplianceOrganizationFilingAttachmentData, CharityComplianceAddComplianceOrganizationFilingAttachmentError, CharityComplianceAddComplianceOrganizationFilingAttachmentResponse, CharityComplianceAddComplianceOrganizationFilingCycleData, CharityComplianceAddComplianceOrganizationFilingCycleError, CharityComplianceAddComplianceOrganizationFilingCycleResponse, CharityComplianceAddComplianceOrganizationFilingData, CharityComplianceAddComplianceOrganizationFilingError, CharityComplianceAddComplianceOrganizationFilingResponse, CharityComplianceAddComplianceRenewalAttachmentData, CharityComplianceAddComplianceRenewalAttachmentError, CharityComplianceAddComplianceRenewalAttachmentResponse, CharityComplianceAmendComplianceRegistrationImportData, CharityComplianceAmendComplianceRegistrationImportError, CharityComplianceAmendComplianceRegistrationImportResponse, CharityComplianceAnswerComplianceFormItemData, CharityComplianceAnswerComplianceFormItemError, CharityComplianceAnswerComplianceFormItemResponse, CharityComplianceAnswerComplianceSubmissionEvidenceData, CharityComplianceAnswerComplianceSubmissionEvidenceError, CharityComplianceAnswerComplianceSubmissionEvidenceResponse, CharityComplianceAskAboutComplianceReviewItemData, CharityComplianceAskAboutComplianceReviewItemError, CharityComplianceAskAboutComplianceReviewItemResponse, CharityComplianceAssembleCompliancePacketData, CharityComplianceAssembleCompliancePacketError, CharityComplianceAssembleCompliancePacketResponse, CharityComplianceAttachComplianceChecklistDocumentData, CharityComplianceAttachComplianceChecklistDocumentError, CharityComplianceAttachComplianceChecklistDocumentResponse, CharityComplianceAttachComplianceFilingCaseDocumentData, CharityComplianceAttachComplianceFilingCaseDocumentError, CharityComplianceAttachComplianceFilingCaseDocumentResponse, CharityComplianceAttachComplianceObligationFiledCopyData, CharityComplianceAttachComplianceObligationFiledCopyError, CharityComplianceAttachComplianceObligationFiledCopyResponse, CharityComplianceAttachComplianceOrganizationFilingFiledCopyData, CharityComplianceAttachComplianceOrganizationFilingFiledCopyError, CharityComplianceAttachComplianceOrganizationFilingFiledCopyResponse, CharityComplianceAttachComplianceRenewalFiledCopyData, CharityComplianceAttachComplianceRenewalFiledCopyError, CharityComplianceAttachComplianceRenewalFiledCopyResponse, CharityComplianceAuthorizeComplianceSubmissionData, CharityComplianceAuthorizeComplianceSubmissionError, CharityComplianceAuthorizeComplianceSubmissionResponse, CharityComplianceCancelComplianceSigningRequestData, CharityComplianceCancelComplianceSigningRequestError, CharityComplianceCancelComplianceSigningRequestResponse, CharityComplianceConfirmComplianceArtifactData, CharityComplianceConfirmComplianceArtifactError, CharityComplianceConfirmComplianceArtifactResponse, CharityComplianceConfirmComplianceCandidateData, CharityComplianceConfirmComplianceCandidateError, CharityComplianceConfirmComplianceCandidateResponse, CharityComplianceCreateComplianceFilingDocumentData, CharityComplianceCreateComplianceFilingDocumentError, CharityComplianceCreateComplianceFilingDocumentResponse, CharityComplianceCreateComplianceFilingGroupData, CharityComplianceCreateComplianceFilingGroupError, CharityComplianceCreateComplianceFilingGroupResponse, CharityComplianceDeclineComplianceSigningRequestData, CharityComplianceDeclineComplianceSigningRequestError, CharityComplianceDeclineComplianceSigningRequestResponse, CharityComplianceDeleteComplianceArtifactData, CharityComplianceDeleteComplianceArtifactError, CharityComplianceDeleteComplianceArtifactResponse, CharityComplianceDismissComplianceCandidateData, CharityComplianceDismissComplianceCandidateError, CharityComplianceDismissComplianceCandidateResponse, CharityComplianceDispatchComplianceSubmissionData, CharityComplianceDispatchComplianceSubmissionError, CharityComplianceDispatchComplianceSubmissionResponse, CharityComplianceExtendComplianceSigningRequestData, CharityComplianceExtendComplianceSigningRequestError, CharityComplianceExtendComplianceSigningRequestResponse, CharityComplianceGenerateComplianceProposalRevisionData, CharityComplianceGenerateComplianceProposalRevisionError, CharityComplianceGenerateComplianceProposalRevisionResponse, CharityComplianceGetComplianceAiSettingData, CharityComplianceGetComplianceAiSettingError, CharityComplianceGetComplianceAiSettingResponse, CharityComplianceGetComplianceArtifactDownloadData, CharityComplianceGetComplianceArtifactDownloadError, CharityComplianceGetComplianceArtifactDownloadResponse, CharityComplianceGetComplianceDeskAuthorizationData, CharityComplianceGetComplianceDeskAuthorizationError, CharityComplianceGetComplianceDeskAuthorizationResponse, CharityComplianceGetComplianceFilingCaseChecklistData, CharityComplianceGetComplianceFilingCaseChecklistError, CharityComplianceGetComplianceFilingCaseChecklistResponse, CharityComplianceGetComplianceFilingCaseData, CharityComplianceGetComplianceFilingCaseError, CharityComplianceGetComplianceFilingCaseResponse, CharityComplianceGetComplianceFilingDocumentData, CharityComplianceGetComplianceFilingDocumentError, CharityComplianceGetComplianceFilingDocumentResponse, CharityComplianceGetComplianceFilingDocumentSigningPlacesData, CharityComplianceGetComplianceFilingDocumentSigningPlacesError, CharityComplianceGetComplianceFilingDocumentSigningPlacesResponse, CharityComplianceGetComplianceFilingDocumentVersionDownloadData, CharityComplianceGetComplianceFilingDocumentVersionDownloadError, CharityComplianceGetComplianceFilingDocumentVersionDownloadResponse, CharityComplianceGetComplianceFilingDocumentVersionRenditionData, CharityComplianceGetComplianceFilingDocumentVersionRenditionError, CharityComplianceGetComplianceFilingDocumentVersionRenditionResponse, CharityComplianceGetComplianceFormPagePreviewData, CharityComplianceGetComplianceFormPagePreviewError, CharityComplianceGetComplianceFormPagePreviewResponse, CharityComplianceGetComplianceFormPreparationData, CharityComplianceGetComplianceFormPreparationError, CharityComplianceGetComplianceFormPreparationResponse, CharityComplianceGetComplianceObligationData, CharityComplianceGetComplianceObligationError, CharityComplianceGetComplianceObligationResponse, CharityComplianceGetComplianceObligationRuleChangeData, CharityComplianceGetComplianceObligationRuleChangeError, CharityComplianceGetComplianceObligationRuleChangeResponse, CharityComplianceGetComplianceOrganizationFilingData, CharityComplianceGetComplianceOrganizationFilingError, CharityComplianceGetComplianceOrganizationFilingResponse, CharityComplianceGetCompliancePacketChecklistData, CharityComplianceGetCompliancePacketChecklistError, CharityComplianceGetCompliancePacketChecklistResponse, CharityComplianceGetCompliancePacketData, CharityComplianceGetCompliancePacketError, CharityComplianceGetCompliancePacketRenderData, CharityComplianceGetCompliancePacketRenderError, CharityComplianceGetCompliancePacketRenderResponse, CharityComplianceGetCompliancePacketResponse, CharityComplianceGetComplianceProfileData, CharityComplianceGetComplianceProfileError, CharityComplianceGetComplianceProfileResponse, CharityComplianceGetComplianceProposalData, CharityComplianceGetComplianceProposalError, CharityComplianceGetComplianceProposalResponse, CharityComplianceGetComplianceProposalReviewData, CharityComplianceGetComplianceProposalReviewError, CharityComplianceGetComplianceProposalReviewResponse, CharityComplianceGetComplianceProposalRevisionData, CharityComplianceGetComplianceProposalRevisionError, CharityComplianceGetComplianceProposalRevisionResponse, CharityComplianceGetComplianceRenewalCycleData, CharityComplianceGetComplianceRenewalCycleError, CharityComplianceGetComplianceRenewalCycleResponse, CharityComplianceGetComplianceSigningEvidenceData, CharityComplianceGetComplianceSigningEvidenceError, CharityComplianceGetComplianceSigningEvidenceResponse, CharityComplianceGetComplianceSigningExportData, CharityComplianceGetComplianceSigningExportError, CharityComplianceGetComplianceSigningExportResponse, CharityComplianceGetComplianceSigningRecordLinesData, CharityComplianceGetComplianceSigningRecordLinesError, CharityComplianceGetComplianceSigningRecordLinesResponse, CharityComplianceGetComplianceSigningRequestData, CharityComplianceGetComplianceSigningRequestError, CharityComplianceGetComplianceSigningRequestResponse, CharityComplianceGetComplianceSigningSettingData, CharityComplianceGetComplianceSigningSettingError, CharityComplianceGetComplianceSigningSettingResponse, CharityComplianceGetComplianceSubmissionData, CharityComplianceGetComplianceSubmissionError, CharityComplianceGetComplianceSubmissionPackageData, CharityComplianceGetComplianceSubmissionPackageError, CharityComplianceGetComplianceSubmissionPackageResponse, CharityComplianceGetComplianceSubmissionResponse, CharityComplianceGetComplianceVendorData, CharityComplianceGetComplianceVendorError, CharityComplianceGetComplianceVendorResponse, CharityComplianceHandComplianceFilingToDeskData, CharityComplianceHandComplianceFilingToDeskError, CharityComplianceHandComplianceFilingToDeskResponse, CharityComplianceImportComplianceRegistrationData, CharityComplianceImportComplianceRegistrationError, CharityComplianceImportComplianceRegistrationResponse, CharityComplianceIssueComplianceArtifactUploadUrlData, CharityComplianceIssueComplianceArtifactUploadUrlError, CharityComplianceIssueComplianceArtifactUploadUrlResponse, CharityComplianceIssueComplianceSigningRequestData, CharityComplianceIssueComplianceSigningRequestError, CharityComplianceIssueComplianceSigningRequestResponse, CharityComplianceLinkComplianceVendorFilingData, CharityComplianceLinkComplianceVendorFilingError, CharityComplianceLinkComplianceVendorFilingResponse, CharityComplianceListComplianceArtifactsData, CharityComplianceListComplianceArtifactsError, CharityComplianceListComplianceArtifactsResponse, CharityComplianceListComplianceCandidatesData, CharityComplianceListComplianceCandidatesError, CharityComplianceListComplianceCandidatesResponse, CharityComplianceListComplianceFilingCasesData, CharityComplianceListComplianceFilingCasesError, CharityComplianceListComplianceFilingCasesResponse, CharityComplianceListComplianceFilingDocumentsData, CharityComplianceListComplianceFilingDocumentsError, CharityComplianceListComplianceFilingDocumentsResponse, CharityComplianceListComplianceFilingGroupsData, CharityComplianceListComplianceFilingGroupsError, CharityComplianceListComplianceFilingGroupsResponse, CharityComplianceListComplianceFilingOptionsData, CharityComplianceListComplianceFilingOptionsError, CharityComplianceListComplianceFilingOptionsResponse, CharityComplianceListComplianceFormAdaptersData, CharityComplianceListComplianceFormAdaptersError, CharityComplianceListComplianceFormAdaptersResponse, CharityComplianceListComplianceFormPreparationsData, CharityComplianceListComplianceFormPreparationsError, CharityComplianceListComplianceFormPreparationsResponse, CharityComplianceListComplianceObligationArtifactsData, CharityComplianceListComplianceObligationArtifactsError, CharityComplianceListComplianceObligationArtifactsResponse, CharityComplianceListComplianceObligationsData, CharityComplianceListComplianceObligationsError, CharityComplianceListComplianceObligationsResponse, CharityComplianceListComplianceOccurrencesData, CharityComplianceListComplianceOccurrencesError, CharityComplianceListComplianceOccurrencesResponse, CharityComplianceListComplianceOrganizationFilingsData, CharityComplianceListComplianceOrganizationFilingsError, CharityComplianceListComplianceOrganizationFilingsResponse, CharityComplianceListCompliancePacketsData, CharityComplianceListCompliancePacketsError, CharityComplianceListCompliancePacketsResponse, CharityComplianceListComplianceProfileParametersData, CharityComplianceListComplianceProfileParametersError, CharityComplianceListComplianceProfileParametersResponse, CharityComplianceListComplianceProfileReviewFlagsData, CharityComplianceListComplianceProfileReviewFlagsError, CharityComplianceListComplianceProfileReviewFlagsResponse, CharityComplianceListComplianceProfileSuggestionsData, CharityComplianceListComplianceProfileSuggestionsError, CharityComplianceListComplianceProfileSuggestionsResponse, CharityComplianceListComplianceProposalItemsData, CharityComplianceListComplianceProposalItemsError, CharityComplianceListComplianceProposalItemsResponse, CharityComplianceListComplianceProposalResultsData, CharityComplianceListComplianceProposalResultsError, CharityComplianceListComplianceProposalResultsResponse, CharityComplianceListComplianceRegistrationImportAmendmentsData, CharityComplianceListComplianceRegistrationImportAmendmentsError, CharityComplianceListComplianceRegistrationImportAmendmentsResponse, CharityComplianceListComplianceRegistrationImportsData, CharityComplianceListComplianceRegistrationImportsError, CharityComplianceListComplianceRegistrationImportsResponse, CharityComplianceListComplianceRenewalCyclesData, CharityComplianceListComplianceRenewalCyclesError, CharityComplianceListComplianceRenewalCyclesResponse, CharityComplianceListComplianceReviewAsksData, CharityComplianceListComplianceReviewAsksError, CharityComplianceListComplianceReviewAsksResponse, CharityComplianceListComplianceSigningPeopleData, CharityComplianceListComplianceSigningPeopleError, CharityComplianceListComplianceSigningPeopleResponse, CharityComplianceListComplianceSigningRequestsData, CharityComplianceListComplianceSigningRequestsError, CharityComplianceListComplianceSigningRequestsResponse, CharityComplianceListComplianceSubmissionFollowThroughData, CharityComplianceListComplianceSubmissionFollowThroughError, CharityComplianceListComplianceSubmissionFollowThroughResponse, CharityComplianceListComplianceVendorsData, CharityComplianceListComplianceVendorsError, CharityComplianceListComplianceVendorsResponse, CharityComplianceMintComplianceFormVersionData, CharityComplianceMintComplianceFormVersionError, CharityComplianceMintComplianceFormVersionResponse, CharityComplianceMoveComplianceFilingGroupData, CharityComplianceMoveComplianceFilingGroupError, CharityComplianceMoveComplianceFilingGroupResponse, CharityComplianceMoveComplianceFilingToGroupData, CharityComplianceMoveComplianceFilingToGroupError, CharityComplianceMoveComplianceFilingToGroupResponse, CharityComplianceOpenComplianceFilingCaseData, CharityComplianceOpenComplianceFilingCaseError, CharityComplianceOpenComplianceFilingCaseResponse, CharityComplianceReconcileComplianceSubmissionAttemptData, CharityComplianceReconcileComplianceSubmissionAttemptError, CharityComplianceReconcileComplianceSubmissionAttemptResponse, CharityComplianceRecordComplianceChecklistActData, CharityComplianceRecordComplianceChecklistActError, CharityComplianceRecordComplianceChecklistActResponse, CharityComplianceRecordComplianceExecutedCopyData, CharityComplianceRecordComplianceExecutedCopyError, CharityComplianceRecordComplianceExecutedCopyResponse, CharityComplianceRecordComplianceFilingData, CharityComplianceRecordComplianceFilingError, CharityComplianceRecordComplianceFilingResponse, CharityComplianceRecordComplianceOrganizationFilingFiledData, CharityComplianceRecordComplianceOrganizationFilingFiledError, CharityComplianceRecordComplianceOrganizationFilingFiledResponse, CharityComplianceRecordComplianceOrganizationFilingSentData, CharityComplianceRecordComplianceOrganizationFilingSentError, CharityComplianceRecordComplianceOrganizationFilingSentResponse, CharityComplianceRecordComplianceProfileParameterData, CharityComplianceRecordComplianceProfileParameterError, CharityComplianceRecordComplianceProfileParameterResponse, CharityComplianceRecordComplianceProposalReviewData, CharityComplianceRecordComplianceProposalReviewError, CharityComplianceRecordComplianceProposalReviewResponse, CharityComplianceRecordComplianceRegistrationDateData, CharityComplianceRecordComplianceRegistrationDateError, CharityComplianceRecordComplianceRegistrationDateResponse, CharityComplianceRecordComplianceRenewalFilingData, CharityComplianceRecordComplianceRenewalFilingError, CharityComplianceRecordComplianceRenewalFilingResponse, CharityComplianceRecordComplianceRenewalSubmissionData, CharityComplianceRecordComplianceRenewalSubmissionError, CharityComplianceRecordComplianceRenewalSubmissionResponse, CharityComplianceRecordComplianceSubmissionData, CharityComplianceRecordComplianceSubmissionError, CharityComplianceRecordComplianceSubmissionEvidenceData, CharityComplianceRecordComplianceSubmissionEvidenceError, CharityComplianceRecordComplianceSubmissionEvidenceResponse, CharityComplianceRecordComplianceSubmissionHandoffData, CharityComplianceRecordComplianceSubmissionHandoffError, CharityComplianceRecordComplianceSubmissionHandoffResponse, CharityComplianceRecordComplianceSubmissionResponse, CharityComplianceRecordComplianceVendorData, CharityComplianceRecordComplianceVendorError, CharityComplianceRecordComplianceVendorResponse, CharityComplianceRecordComplianceWindowClosedData, CharityComplianceRecordComplianceWindowClosedError, CharityComplianceRecordComplianceWindowClosedResponse, CharityComplianceRegisterComplianceFilingDocumentVersionData, CharityComplianceRegisterComplianceFilingDocumentVersionError, CharityComplianceRegisterComplianceFilingDocumentVersionResponse, CharityComplianceRemoveComplianceFilingGroupData, CharityComplianceRemoveComplianceFilingGroupError, CharityComplianceRemoveComplianceFilingGroupResponse, CharityComplianceRemoveComplianceSigningIdentityData, CharityComplianceRemoveComplianceSigningIdentityError, CharityComplianceRemoveComplianceSigningIdentityResponse, CharityComplianceRenameComplianceFilingGroupData, CharityComplianceRenameComplianceFilingGroupError, CharityComplianceRenameComplianceFilingGroupResponse, CharityComplianceRepinComplianceObligationData, CharityComplianceRepinComplianceObligationError, CharityComplianceRepinComplianceObligationResponse, CharityComplianceResolveComplianceProfileReviewFlagData, CharityComplianceResolveComplianceProfileReviewFlagError, CharityComplianceResolveComplianceProfileReviewFlagResponse, CharityComplianceResolveComplianceProfileSuggestionData, CharityComplianceResolveComplianceProfileSuggestionError, CharityComplianceResolveComplianceProfileSuggestionResponse, CharityComplianceResumeComplianceDeskData, CharityComplianceResumeComplianceDeskError, CharityComplianceResumeComplianceDeskResponse, CharityComplianceResumeTrackingComplianceObligationData, CharityComplianceResumeTrackingComplianceObligationError, CharityComplianceResumeTrackingComplianceObligationResponse, CharityComplianceRetireComplianceOrganizationFilingData, CharityComplianceRetireComplianceOrganizationFilingError, CharityComplianceRetireComplianceOrganizationFilingResponse, CharityComplianceReviseComplianceSigningRequestData, CharityComplianceReviseComplianceSigningRequestError, CharityComplianceReviseComplianceSigningRequestResponse, CharityComplianceRevokeComplianceDeskAuthorizationData, CharityComplianceRevokeComplianceDeskAuthorizationError, CharityComplianceRevokeComplianceDeskAuthorizationResponse, CharityComplianceRevokeComplianceSubmissionAuthorizationData, CharityComplianceRevokeComplianceSubmissionAuthorizationError, CharityComplianceRevokeComplianceSubmissionAuthorizationResponse, CharityComplianceRunComplianceDerivationData, CharityComplianceRunComplianceDerivationError, CharityComplianceRunComplianceDerivationResponse, CharityComplianceSetComplianceAiSettingData, CharityComplianceSetComplianceAiSettingError, CharityComplianceSetComplianceAiSettingResponse, CharityComplianceSetComplianceSigningSettingData, CharityComplianceSetComplianceSigningSettingError, CharityComplianceSetComplianceSigningSettingResponse, CharityComplianceSignComplianceSigningRequestData, CharityComplianceSignComplianceSigningRequestError, CharityComplianceSignComplianceSigningRequestResponse, CharityComplianceStartComplianceFormPreparationData, CharityComplianceStartComplianceFormPreparationError, CharityComplianceStartComplianceFormPreparationResponse, CharityComplianceStopTrackingComplianceObligationData, CharityComplianceStopTrackingComplianceObligationError, CharityComplianceStopTrackingComplianceObligationResponse, CharityComplianceSwitchComplianceOrganizationFilingData, CharityComplianceSwitchComplianceOrganizationFilingError, CharityComplianceSwitchComplianceOrganizationFilingResponse, CharityComplianceTakeComplianceFilingFromDeskData, CharityComplianceTakeComplianceFilingFromDeskError, CharityComplianceTakeComplianceFilingFromDeskResponse, CharityComplianceUnlinkComplianceVendorFilingData, CharityComplianceUnlinkComplianceVendorFilingError, CharityComplianceUnlinkComplianceVendorFilingResponse, CharityComplianceUpdateComplianceOrganizationFilingData, CharityComplianceUpdateComplianceOrganizationFilingError, CharityComplianceUpdateComplianceOrganizationFilingResponse, CharityComplianceWithdrawComplianceFilingCaseData, CharityComplianceWithdrawComplianceFilingCaseError, CharityComplianceWithdrawComplianceFilingCaseResponse, CharityComplianceWithdrawComplianceReviewAskData, CharityComplianceWithdrawComplianceReviewAskError, CharityComplianceWithdrawComplianceReviewAskResponse, CharityComplianceWithdrawComplianceSignatureData, CharityComplianceWithdrawComplianceSignatureError, CharityComplianceWithdrawComplianceSignatureResponse, CharityEnrollmentConfirmOpeningBalanceFieldData, CharityEnrollmentConfirmOpeningBalanceFieldError, CharityEnrollmentConfirmOpeningBalanceFieldResponse, CharityEnrollmentCreateEnrollmentDraftData, CharityEnrollmentCreateEnrollmentDraftError, CharityEnrollmentCreateEnrollmentDraftResponse, CharityEnrollmentGetEnrollmentData, CharityEnrollmentGetEnrollmentError, CharityEnrollmentGetEnrollmentResponse, CharityEnrollmentListEnrollmentsData, CharityEnrollmentListEnrollmentsError, CharityEnrollmentListEnrollmentsResponse, CharityEnrollmentListMappingRowsData, CharityEnrollmentListMappingRowsError, CharityEnrollmentListMappingRowsResponse, CharityEnrollmentListOnboardingRecordsData, CharityEnrollmentListOnboardingRecordsError, CharityEnrollmentListOnboardingRecordsResponse, CharityEnrollmentListOpeningBalanceFieldsData, CharityEnrollmentListOpeningBalanceFieldsError, CharityEnrollmentListOpeningBalanceFieldsResponse, CharityEnrollmentRecordBackfillChoiceData, CharityEnrollmentRecordBackfillChoiceError, CharityEnrollmentRecordBackfillChoiceResponse, CharityEnrollmentResolveMappingRowData, CharityEnrollmentResolveMappingRowError, CharityEnrollmentResolveMappingRowResponse, CharityEnrollmentSeedOpeningBalanceFieldsData, CharityEnrollmentSeedOpeningBalanceFieldsError, CharityEnrollmentSeedOpeningBalanceFieldsResponse, CharityEnrollmentStartImportRunData, CharityEnrollmentStartImportRunError, CharityEnrollmentStartImportRunResponse, CharityEnrollmentSubmitEnrollmentData, CharityEnrollmentSubmitEnrollmentError, CharityEnrollmentSubmitEnrollmentResponse, CharityEnrollmentUpdateEnrollmentDraftData, CharityEnrollmentUpdateEnrollmentDraftError, CharityEnrollmentUpdateEnrollmentDraftResponse, CharityEnrollmentUpsertEntityMapsData, CharityEnrollmentUpsertEntityMapsError, CharityEnrollmentUpsertEntityMapsResponse, CharityEnrollmentWithdrawEnrollmentData, CharityEnrollmentWithdrawEnrollmentError, CharityEnrollmentWithdrawEnrollmentResponse, CompaniesActivateCompanyData, CompaniesActivateCompanyError, CompaniesActivateCompanyResponse, CompaniesApproveCompanyJoinRequestData, CompaniesApproveCompanyJoinRequestError, CompaniesApproveCompanyJoinRequestResponse, CompaniesApproveDonationMatchData, CompaniesApproveDonationMatchError, CompaniesApproveDonationMatchResponse, CompaniesChangeCompanyChampionHandleData, CompaniesChangeCompanyChampionHandleError, CompaniesChangeCompanyChampionHandleResponse, CompaniesCreateCompanyAdminData, CompaniesCreateCompanyAdminError, CompaniesCreateCompanyAdminResponse, CompaniesCreateCompanyCardData, CompaniesCreateCompanyCardError, CompaniesCreateCompanyCardResponse, CompaniesCreateCompanyCardV2Data, CompaniesCreateCompanyCardV2Error, CompaniesCreateCompanyCardV2Response, CompaniesCreateCompanyData, CompaniesCreateCompanyEmployeeInvitesData, CompaniesCreateCompanyEmployeeInvitesError, CompaniesCreateCompanyEmployeeInvitesResponse, CompaniesCreateCompanyError, CompaniesCreateCompanyFundraiserData, CompaniesCreateCompanyFundraiserError, CompaniesCreateCompanyFundraiserResponse, CompaniesCreateCompanyJoinRequestData, CompaniesCreateCompanyJoinRequestError, CompaniesCreateCompanyJoinRequestResponse, CompaniesCreateCompanyOccasionProgramData, CompaniesCreateCompanyOccasionProgramError, CompaniesCreateCompanyOccasionProgramResponse, CompaniesCreateCompanyResponse, CompaniesDeactivateCompanyData, CompaniesDeactivateCompanyResponse, CompaniesDeleteCompanyCardData, CompaniesDeleteCompanyCardError, CompaniesDeleteCompanyCardResponse, CompaniesDepositFundsCompanyData, CompaniesDepositFundsCompanyError, CompaniesDepositFundsCompanyResponse, CompaniesDownloadCompanyChampionQrData, CompaniesDownloadCompanyChampionQrError, CompaniesDownloadCompanyChampionQrResponse, CompaniesEnableCompanyProductData, CompaniesEnableCompanyProductError, CompaniesEnableCompanyProductResponse, CompaniesExportCompanyImpactCsvData, CompaniesExportCompanyImpactCsvResponse, CompaniesExportCompanyTaxLinesCsvData, CompaniesExportCompanyTaxLinesCsvError, CompaniesExportCompanyTaxLinesCsvResponse, CompaniesExportCompanyTransactionsCsvData, CompaniesExportCompanyTransactionsCsvError, CompaniesExportCompanyTransactionsCsvResponse, CompaniesGetCompanyAdminData, CompaniesGetCompanyAdminResponse, CompaniesGetCompanyAdminsData, CompaniesGetCompanyAdminsError, CompaniesGetCompanyAdminsResponse, CompaniesGetCompanyAuthPolicyData, CompaniesGetCompanyAuthPolicyResponse, CompaniesGetCompanyCardsData, CompaniesGetCompanyCardsResponse, CompaniesGetCompanyCardsV2Data, CompaniesGetCompanyCardsV2Response, CompaniesGetCompanyChampionData, CompaniesGetCompanyChampionHandleSuggestionData, CompaniesGetCompanyChampionHandleSuggestionResponse, CompaniesGetCompanyChampionResponse, CompaniesGetCompanyDashboardData, CompaniesGetCompanyDashboardError, CompaniesGetCompanyDashboardResponse, CompaniesGetCompanyData, CompaniesGetCompanyDonationAmountData, CompaniesGetCompanyDonationAmountError, CompaniesGetCompanyDonationAmountResponse, CompaniesGetCompanyDonationVolumeData, CompaniesGetCompanyDonationVolumeResponse, CompaniesGetCompanyEmployeeInviteCountsData, CompaniesGetCompanyEmployeeInviteCountsResponse, CompaniesGetCompanyEmployeesData, CompaniesGetCompanyEmployeesError, CompaniesGetCompanyEmployeesResponse, CompaniesGetCompanyFundraiserReportData, CompaniesGetCompanyFundraiserReportError, CompaniesGetCompanyFundraiserReportResponse, CompaniesGetCompanyGiftCardBatchData, CompaniesGetCompanyGiftCardBatchError, CompaniesGetCompanyGiftCardBatchResponse, CompaniesGetCompanyGivingPublicationData, CompaniesGetCompanyGivingPublicationResponse, CompaniesGetCompanyMatchUtilizationData, CompaniesGetCompanyMatchUtilizationResponse, CompaniesGetCompanyOccasionPreflightData, CompaniesGetCompanyOccasionPreflightError, CompaniesGetCompanyOccasionPreflightResponse, CompaniesGetCompanyQrDesignData, CompaniesGetCompanyQrDesignResponse, CompaniesGetCompanyResponse, CompaniesGetCompanyTopCharitiesData, CompaniesGetCompanyTopCharitiesError, CompaniesGetCompanyTopCharitiesResponse, CompaniesGetCompanyWalletData, CompaniesGetCompanyWalletResponse, CompaniesGetMyCompanyData, CompaniesGetMyCompanyResponse, CompaniesGetPublicCompanyData, CompaniesGetPublicCompanyError, CompaniesGetPublicCompanyResponse, CompaniesGetPublicCompanyStatisticsData, CompaniesGetPublicCompanyStatisticsError, CompaniesGetPublicCompanyStatisticsResponse, CompaniesGetUserLocationData, CompaniesGetUserLocationError, CompaniesGetUserLocationResponse, CompaniesImportCompanyEmployeeOccasionDatesData, CompaniesImportCompanyEmployeeOccasionDatesError, CompaniesImportCompanyEmployeeOccasionDatesResponse, CompaniesListCompanyEmployeeInvitesData, CompaniesListCompanyEmployeeInvitesError, CompaniesListCompanyEmployeeInvitesResponse, CompaniesListCompanyFundraisersData, CompaniesListCompanyFundraisersResponse, CompaniesListCompanyGiftCardBatchesData, CompaniesListCompanyGiftCardBatchesError, CompaniesListCompanyGiftCardBatchesResponse, CompaniesListCompanyGiftCardsData, CompaniesListCompanyGiftCardsError, CompaniesListCompanyGiftCardsResponse, CompaniesListCompanyJoinRequestsData, CompaniesListCompanyJoinRequestsError, CompaniesListCompanyJoinRequestsResponse, CompaniesListCompanyOccasionExecutionsData, CompaniesListCompanyOccasionExecutionsError, CompaniesListCompanyOccasionExecutionsResponse, CompaniesListCompanyOccasionProgramsData, CompaniesListCompanyOccasionProgramsError, CompaniesListCompanyOccasionProgramsResponse, CompaniesPauseCompanyOccasionProgramData, CompaniesPauseCompanyOccasionProgramError, CompaniesPauseCompanyOccasionProgramResponse, CompaniesQuoteCompanyDepositData, CompaniesQuoteCompanyDepositError, CompaniesQuoteCompanyDepositResponse, CompaniesQuoteCompanyDonationData, CompaniesQuoteCompanyDonationError, CompaniesQuoteCompanyDonationResponse, CompaniesRejectCompanyJoinRequestData, CompaniesRejectCompanyJoinRequestError, CompaniesRejectCompanyJoinRequestResponse, CompaniesRejectDonationMatchData, CompaniesRejectDonationMatchError, CompaniesRejectDonationMatchResponse, CompaniesRemoveAdminFromCompanyData, CompaniesRemoveAdminFromCompanyError, CompaniesRemoveAdminFromCompanyResponse, CompaniesRemoveEmployeesFromCompanyData, CompaniesRemoveEmployeesFromCompanyError, CompaniesRemoveEmployeesFromCompanyResponse, CompaniesResendCompanyEmployeeInviteData, CompaniesResendCompanyEmployeeInviteError, CompaniesResendCompanyEmployeeInviteResponse, CompaniesResolveCompanyOnboardingRouteData, CompaniesResolveCompanyOnboardingRouteResponse, CompaniesResumeCompanyOccasionProgramData, CompaniesResumeCompanyOccasionProgramError, CompaniesResumeCompanyOccasionProgramResponse, CompaniesSaveCompanyGivingPublicationData, CompaniesSaveCompanyGivingPublicationError, CompaniesSaveCompanyGivingPublicationResponse, CompaniesSaveCompanyQrDesignData, CompaniesSaveCompanyQrDesignError, CompaniesSaveCompanyQrDesignResponse, CompaniesSendCompanyGiftCardBatchData, CompaniesSendCompanyGiftCardBatchError, CompaniesSendCompanyGiftCardBatchResponse, CompaniesSendCompanyGiftCardData, CompaniesSendCompanyGiftCardError, CompaniesSendCompanyGiftCardResponse, CompaniesSetCompanyChampionCharityData, CompaniesSetCompanyChampionCharityError, CompaniesSetCompanyChampionCharityResponse, CompaniesSetCompanyEmployeeOccasionDatesData, CompaniesSetCompanyEmployeeOccasionDatesError, CompaniesSetCompanyEmployeeOccasionDatesResponse, CompaniesUpdateCompanyAccountInfoData, CompaniesUpdateCompanyAccountInfoError, CompaniesUpdateCompanyAccountInfoResponse, CompaniesUpdateCompanyActivityFeedVisibilityData, CompaniesUpdateCompanyActivityFeedVisibilityError, CompaniesUpdateCompanyActivityFeedVisibilityResponse, CompaniesUpdateCompanyAdminNameData, CompaniesUpdateCompanyAdminNameError, CompaniesUpdateCompanyAdminNameResponse, CompaniesUpdateCompanyAdminRoleData, CompaniesUpdateCompanyAdminRoleError, CompaniesUpdateCompanyAdminRoleResponse, CompaniesUpdateCompanyAuthPolicyData, CompaniesUpdateCompanyAuthPolicyError, CompaniesUpdateCompanyAuthPolicyResponse, CompaniesUpdateCompanyCustomerIdData, CompaniesUpdateCompanyCustomerIdError, CompaniesUpdateCompanyCustomerIdResponse, CompaniesUpdateCompanyMatchPolicyData, CompaniesUpdateCompanyMatchPolicyError, CompaniesUpdateCompanyMatchPolicyResponse, CompaniesUpdateCompanyOccasionProgramData, CompaniesUpdateCompanyOccasionProgramError, CompaniesUpdateCompanyOccasionProgramResponse, CompaniesUpdateCompanyPaymentMethodData, CompaniesUpdateCompanyPaymentMethodError, CompaniesUpdateCompanyPaymentMethodResponse, CompaniesUpdateCompanyPublicAmountsData, CompaniesUpdateCompanyPublicAmountsError, CompaniesUpdateCompanyPublicAmountsResponse, CompaniesUpdateCompanyVisibilityData, CompaniesUpdateCompanyVisibilityError, CompaniesUpdateCompanyVisibilityResponse, CompaniesUploadCompanyCoverPictureData, CompaniesUploadCompanyCoverPictureError, CompaniesUploadCompanyCoverPictureResponse, CompaniesUploadCompanyProfilePictureData, CompaniesUploadCompanyProfilePictureError, CompaniesUploadCompanyProfilePictureResponse, CompanyAdminProfilePageGetCompanyPageData, CompanyAdminProfilePageGetCompanyPageResponse, CompanyAdminProfilePageReplaceCompanyPageData, CompanyAdminProfilePageReplaceCompanyPageError, CompanyAdminProfilePageReplaceCompanyPageResponse, CompanyAdminProfilePageUploadCompanyPageImageData, CompanyAdminProfilePageUploadCompanyPageImageError, CompanyAdminProfilePageUploadCompanyPageImageResponse, ConnectDashboardInvitesCreateDashboardInviteData, ConnectDashboardInvitesCreateDashboardInviteError, ConnectDashboardInvitesCreateDashboardInviteResponse, ConnectPartnerApplicationsCreatePartnerApplicationData, ConnectPartnerApplicationsCreatePartnerApplicationError, ConnectPartnerApplicationsCreatePartnerApplicationResponse, ConnectPartnerApplicationsDecidePartnerApplicationData, ConnectPartnerApplicationsDecidePartnerApplicationError, ConnectPartnerApplicationsDecidePartnerApplicationResponse, ConnectPartnerApplicationsGetPartnerApplicationData, ConnectPartnerApplicationsGetPartnerApplicationError, ConnectPartnerApplicationsGetPartnerApplicationResponse, ConnectPartnerApplicationsListPartnerApplicationsData, ConnectPartnerApplicationsListPartnerApplicationsError, ConnectPartnerApplicationsListPartnerApplicationsResponse, ConnectPartnerApplicationsProvisionPartnerApplicationData, ConnectPartnerApplicationsProvisionPartnerApplicationError, ConnectPartnerApplicationsProvisionPartnerApplicationResponse, ConnectPartnerApplicationsUpdatePartnerApplicationData, ConnectPartnerApplicationsUpdatePartnerApplicationError, ConnectPartnerApplicationsUpdatePartnerApplicationResponse, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionData, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionError, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionResponse, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionData, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionError, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionResponse, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsData, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsError, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsResponse, ConnectPartnerPromotionsDecidePartnerPromotionReviewData, ConnectPartnerPromotionsDecidePartnerPromotionReviewError, ConnectPartnerPromotionsDecidePartnerPromotionReviewResponse, ConnectPartnerPromotionsGetPartnerPromotionReviewData, ConnectPartnerPromotionsGetPartnerPromotionReviewError, ConnectPartnerPromotionsGetPartnerPromotionReviewResponse, ConnectPartnerPromotionsListPartnerPromotionReviewsData, ConnectPartnerPromotionsListPartnerPromotionReviewsError, ConnectPartnerPromotionsListPartnerPromotionReviewsResponse, ConnectPartnerPromotionsOpenPartnerPromotionReviewData, ConnectPartnerPromotionsOpenPartnerPromotionReviewError, ConnectPartnerPromotionsOpenPartnerPromotionReviewResponse, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemData, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemError, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemResponse, ContentCategoriesCreateContentCategoryData, ContentCategoriesCreateContentCategoryError, ContentCategoriesCreateContentCategoryResponse, ContentCategoriesDeleteContentCategoryData, ContentCategoriesDeleteContentCategoryError, ContentCategoriesDeleteContentCategoryResponse, ContentCategoriesDeleteFeaturedItemImageData, ContentCategoriesDeleteFeaturedItemImageError, ContentCategoriesDeleteFeaturedItemImageResponse, ContentCategoriesDeleteFeaturedItemOverrideData, ContentCategoriesDeleteFeaturedItemOverrideError, ContentCategoriesDeleteFeaturedItemOverrideResponse, ContentCategoriesGetCauseTagsCuratedContentItemsData, ContentCategoriesGetCauseTagsCuratedContentItemsResponse, ContentCategoriesGetCelebrityCharitiesCuratedContentItemsData, ContentCategoriesGetCelebrityCharitiesCuratedContentItemsResponse, ContentCategoriesGetCharitiesCuratedContentItemsData, ContentCategoriesGetCharitiesCuratedContentItemsResponse, ContentCategoriesGetContentCategoriesData, ContentCategoriesGetContentCategoriesError, ContentCategoriesGetContentCategoriesResponse, ContentCategoriesGetContentCategoryItemsData, ContentCategoriesGetContentCategoryItemsError, ContentCategoriesGetContentCategoryItemsResponse, ContentCategoriesGetEtfsCuratedContentItemsData, ContentCategoriesGetEtfsCuratedContentItemsResponse, ContentCategoriesGetFeaturedContentItemsData, ContentCategoriesGetFeaturedContentItemsResponse, ContentCategoriesGetFundraisersCuratedContentItemsData, ContentCategoriesGetFundraisersCuratedContentItemsResponse, ContentCategoriesUpdateCategoryItemsData, ContentCategoriesUpdateCategoryItemsError, ContentCategoriesUpdateCategoryItemsResponse, ContentCategoriesUploadFeaturedItemImageData, ContentCategoriesUploadFeaturedItemImageError, ContentCategoriesUploadFeaturedItemImageResponse, ContentCategoriesUpsertFeaturedItemOverrideData, ContentCategoriesUpsertFeaturedItemOverrideError, ContentCategoriesUpsertFeaturedItemOverrideResponse, DafTransfersCancelDafTransferIntentData, DafTransfersCancelDafTransferIntentError, DafTransfersCancelDafTransferIntentResponse, DafTransfersCreateDafTransferIntentData, DafTransfersCreateDafTransferIntentError, DafTransfersCreateDafTransferIntentResponse, DafTransfersGetDafTransferTrackerData, DafTransfersGetDafTransferTrackerError, DafTransfersGetDafTransferTrackerResponse, DafTransfersListDafTransferIntentsData, DafTransfersListDafTransferIntentsError, DafTransfersListDafTransferIntentsResponse, DisclaimersBundleDisclaimerData, DisclaimersBundleDisclaimerError, DisclaimersBundleDisclaimerResponse, DisclaimersDisclaimerVersionsData, DisclaimersDisclaimerVersionsResponse, DisclaimersGetDisclaimerDetailData, DisclaimersGetDisclaimerDetailError, DisclaimersGetDisclaimerDetailResponse, DisclaimersListDisclaimersData, DisclaimersListDisclaimersError, DisclaimersListDisclaimersResponse, DisclaimersPatchDisclaimerDraftAtSuperAdminData, DisclaimersPatchDisclaimerDraftAtSuperAdminError, DisclaimersPatchDisclaimerDraftAtSuperAdminResponse, DisclaimersPatchDisclaimerDraftData, DisclaimersPatchDisclaimerDraftError, DisclaimersPatchDisclaimerDraftResponse, DisclaimersPublishDisclaimerAtSuperAdminData, DisclaimersPublishDisclaimerAtSuperAdminError, DisclaimersPublishDisclaimerAtSuperAdminResponse, DisclaimersPublishDisclaimerData, DisclaimersPublishDisclaimerError, DisclaimersPublishDisclaimerResponse, DisclaimersResolveDisclaimerData, DisclaimersResolveDisclaimerError, DisclaimersResolveDisclaimerResponse, DisclaimersSetDisclaimerEffectiveAtSuperAdminData, DisclaimersSetDisclaimerEffectiveAtSuperAdminError, DisclaimersSetDisclaimerEffectiveAtSuperAdminResponse, DisclaimersSetDisclaimerEffectiveData, DisclaimersSetDisclaimerEffectiveError, DisclaimersSetDisclaimerEffectiveResponse, DonationMatchesApproveCompanyMatchData, DonationMatchesApproveCompanyMatchError, DonationMatchesApproveCompanyMatchResponse, DonationMatchesApproveGroupCompanyMatchesData, DonationMatchesApproveGroupCompanyMatchesError, DonationMatchesApproveGroupCompanyMatchesResponse, DonationMatchesApproveGroupedCompanyMatchesData, DonationMatchesApproveGroupedCompanyMatchesError, DonationMatchesApproveGroupedCompanyMatchesResponse, DonationMatchesApproveMatchRequestData, DonationMatchesApproveMatchRequestError, DonationMatchesApproveMatchRequestResponse, DonationMatchesCheckCompanyMatchAllowedAmountData, DonationMatchesCheckCompanyMatchAllowedAmountError, DonationMatchesCheckCompanyMatchAllowedAmountResponse, DonationMatchesCheckGroupedMatchesAllowedAmountData, DonationMatchesCheckGroupedMatchesAllowedAmountError, DonationMatchesCheckGroupedMatchesAllowedAmountResponse, DonationMatchesCheckMatchRequestAllowedAmountData, DonationMatchesCheckMatchRequestAllowedAmountError, DonationMatchesCheckMatchRequestAllowedAmountResponse, DonationMatchesCreateUserMatchData, DonationMatchesCreateUserMatchError, DonationMatchesCreateUserMatchResponse, DonationMatchesGetDonationMatchesData, DonationMatchesGetDonationMatchesError, DonationMatchesGetDonationMatchesResponse, DonationMatchesGetMatchPaymentDisclosureData, DonationMatchesGetMatchPaymentDisclosureError, DonationMatchesGetMatchPaymentDisclosureResponse, DonationMatchesGetMatchRequestInboxData, DonationMatchesGetMatchRequestInboxResponse, DonationMatchesGetMyMatchesData, DonationMatchesGetMyMatchesResponse, DonationMatchesGetPendingGroupCompanyMatchesData, DonationMatchesGetPendingGroupCompanyMatchesError, DonationMatchesGetPendingGroupCompanyMatchesResponse, DonationMatchesGetPendingMatchesGroupedData, DonationMatchesGetPendingMatchesGroupedResponse, DonationMatchesQuoteCompanyMatchPaymentData, DonationMatchesQuoteCompanyMatchPaymentError, DonationMatchesQuoteCompanyMatchPaymentResponse, DonationMatchesRejectCompanyMatchData, DonationMatchesRejectCompanyMatchError, DonationMatchesRejectCompanyMatchResponse, DonationMatchesRejectGroupCompanyMatchesData, DonationMatchesRejectGroupCompanyMatchesError, DonationMatchesRejectGroupCompanyMatchesResponse, DonationMatchesRejectGroupedCompanyMatchesData, DonationMatchesRejectGroupedCompanyMatchesError, DonationMatchesRejectGroupedCompanyMatchesResponse, DonationMatchesRejectMatchRequestData, DonationMatchesRejectMatchRequestError, DonationMatchesRejectMatchRequestResponse, DonationsClaimDonationData, DonationsClaimDonationError, DonationsClaimDonationResponse, DonationsCreateCharityDonationData, DonationsCreateCharityDonationError, DonationsCreateCharityDonationResponse, DonationsCreateCharityRecurringDonationData, DonationsCreateCharityRecurringDonationError, DonationsCreateCharityRecurringDonationResponse, DonationsCreateEtfDonationData, DonationsCreateEtfDonationError, DonationsCreateEtfDonationResponse, DonationsCreateEtfRecurringDonationData, DonationsCreateEtfRecurringDonationError, DonationsCreateEtfRecurringDonationResponse, DonationsCreateExternalDonationData, DonationsCreateExternalDonationError, DonationsCreateExternalDonationResponse, DonationsCreateFundraiserDonationData, DonationsCreateFundraiserDonationError, DonationsCreateFundraiserDonationResponse, DonationsCreateUnauthenticatedDonationData, DonationsCreateUnauthenticatedDonationError, DonationsCreateUnauthenticatedDonationResponse, DonationsCreateUnauthenticatedEtfDonationData, DonationsCreateUnauthenticatedEtfDonationError, DonationsCreateUnauthenticatedEtfDonationResponse, DonationsCreateUnauthenticatedFundraiserDonationData, DonationsCreateUnauthenticatedFundraiserDonationError, DonationsCreateUnauthenticatedFundraiserDonationResponse, DonationsDownloadStatsReportData, DonationsDownloadStatsReportError, DonationsDownloadStatsReportResponse, DonationsGenerateCompanyStatsReportData, DonationsGenerateCompanyStatsReportError, DonationsGenerateCompanyStatsReportResponse, DonationsGenerateUserStatsReportData, DonationsGenerateUserStatsReportError, DonationsGenerateUserStatsReportResponse, DonationsGetDonationGrantConfirmationData, DonationsGetDonationGrantConfirmationError, DonationsGetDonationGrantConfirmationResponse, DonationsGetDonationJourneyData, DonationsGetDonationJourneyError, DonationsGetDonationJourneyResponse, DonationsGetDonationReceiptData, DonationsGetDonationReceiptError, DonationsGetDonationReceiptResponse, DonationsGetUserCompanyDonationsData, DonationsGetUserCompanyDonationsResponse, DonationsGetUserDonationsData, DonationsGetUserDonationsResponse, DonationsListCompanyStatsReportsData, DonationsListCompanyStatsReportsResponse, DonationsListUserStatsReportsData, DonationsListUserStatsReportsResponse, DonationsResendDonationGrantConfirmationData, DonationsResendDonationGrantConfirmationError, DonationsResendDonationGrantConfirmationResponse, DonationsResendDonationReceiptData, DonationsResendDonationReceiptError, DonationsResendDonationReceiptResponse, DonationsResolveDonationLinkData, DonationsResolveDonationLinkError, DonationsResolveDonationLinkResponse, DonationsRetryFailedReportGenerationsData, DonationsRetryFailedReportGenerationsResponse, EtfsAddCharityToEtfData, EtfsAddCharityToEtfError, EtfsAddCharityToEtfResponse, EtfsCreateEtfData, EtfsCreateEtfError, EtfsCreateEtfResponse, EtfsDeleteEtfData, EtfsDeleteEtfError, EtfsDeleteEtfResponse, EtfsGetEtfData, EtfsGetEtfError, EtfsGetEtfResponse, EtfsGetEtfsData, EtfsGetEtfsError, EtfsGetEtfsResponse, EtfsRemoveCharityFromEtfData, EtfsRemoveCharityFromEtfError, EtfsRemoveCharityFromEtfResponse, EtfsUpdateEtfData, EtfsUpdateEtfError, EtfsUpdateEtfResponse, EtfsUploadEtfProfilePictureData, EtfsUploadEtfProfilePictureError, EtfsUploadEtfProfilePictureResponse, FeesGetFeesData, FeesGetFeesResponse, FeesGetProcessorFeesData, FeesGetProcessorFeesResponse, FeesUpdateFeeData, FeesUpdateFeeError, FeesUpdateFeeResponse, FollowsFollowCharityData, FollowsFollowCharityError, FollowsFollowCharityResponse, FollowsFollowCompanyEmployeesData, FollowsFollowCompanyEmployeesResponse, FollowsFollowUserData, FollowsFollowUserError, FollowsFollowUserResponse, FollowsGetFollowedCharitiesData, FollowsGetFollowedCharitiesError, FollowsGetFollowedCharitiesResponse, FollowsGetUserFollowsData, FollowsGetUserFollowsError, FollowsGetUserFollowsResponse, FollowsSyncUserFacebookContactsData, FollowsSyncUserFacebookContactsError, FollowsSyncUserFacebookContactsResponse, FollowsSyncUserPhoneContactsData, FollowsSyncUserPhoneContactsError, FollowsSyncUserPhoneContactsResponse, FollowsUnfollowCharityData, FollowsUnfollowCharityError, FollowsUnfollowCharityResponse, FollowsUnfollowUserData, FollowsUnfollowUserError, FollowsUnfollowUserResponse, FundraiserMatchOfferRequestsAcceptMatchOfferRequestData, FundraiserMatchOfferRequestsAcceptMatchOfferRequestError, FundraiserMatchOfferRequestsAcceptMatchOfferRequestResponse, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferData, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferError, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferResponse, FundraiserMatchOfferRequestsCreateMatchOfferRequestData, FundraiserMatchOfferRequestsCreateMatchOfferRequestError, FundraiserMatchOfferRequestsCreateMatchOfferRequestResponse, FundraiserMatchOfferRequestsDeclineMatchOfferRequestData, FundraiserMatchOfferRequestsDeclineMatchOfferRequestError, FundraiserMatchOfferRequestsDeclineMatchOfferRequestResponse, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsData, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsError, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsResponse, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsData, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsError, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsResponse, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestData, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestError, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestResponse, FundraisersAcceptFundraiserMembershipData, FundraisersAcceptFundraiserMembershipError, FundraisersAcceptFundraiserMembershipResponse, FundraisersAddCharityToFundraiserData, FundraisersAddCharityToFundraiserError, FundraisersAddCollectionToFundraiserData, FundraisersAddCollectionToFundraiserError, FundraisersAddEtfToFundraiserData, FundraisersAddEtfToFundraiserError, FundraisersAdminDeactivateFundraiserData, FundraisersAdminDeactivateFundraiserError, FundraisersAdminDeactivateFundraiserResponse, FundraisersAdminReinstateFundraiserData, FundraisersAdminReinstateFundraiserError, FundraisersAdminReinstateFundraiserResponse, FundraisersCloseFundraiserData, FundraisersCloseFundraiserError, FundraisersCloseFundraiserResponse, FundraisersCreateFundraiserData, FundraisersCreateFundraiserError, FundraisersCreateFundraiserResponse, FundraisersDeclineOrLeaveFundraiserMembershipData, FundraisersDeclineOrLeaveFundraiserMembershipError, FundraisersDeclineOrLeaveFundraiserMembershipResponse, FundraisersDeleteFundraiserData, FundraisersDeleteFundraiserError, FundraisersDeleteFundraiserResponse, FundraisersGetFundraiserData, FundraisersGetFundraiserError, FundraisersGetFundraiserInvitationData, FundraisersGetFundraiserInvitationError, FundraisersGetFundraiserInvitationResponse, FundraisersGetFundraiserInvitationsData, FundraisersGetFundraiserInvitationsError, FundraisersGetFundraiserInvitationsResponse, FundraisersGetFundraiserMembersData, FundraisersGetFundraiserMembersError, FundraisersGetFundraiserMembersResponse, FundraisersGetFundraiserResponse, FundraisersGetFundraisersData, FundraisersGetFundraisersError, FundraisersGetFundraisersResponse, FundraisersGetOwnFundraiserData, FundraisersGetOwnFundraiserError, FundraisersGetOwnFundraiserResponse, FundraisersGetOwnFundraisersData, FundraisersGetOwnFundraisersError, FundraisersGetOwnFundraisersResponse, FundraisersGetStartedByFriendsData, FundraisersGetStartedByFriendsError, FundraisersGetStartedByFriendsResponse, FundraisersGetSuperAdminFundraiserDonationsData, FundraisersGetSuperAdminFundraiserDonationsError, FundraisersGetSuperAdminFundraiserDonationsResponse, FundraisersGetSuperAdminFundraisersData, FundraisersGetSuperAdminFundraisersError, FundraisersGetSuperAdminFundraisersResponse, FundraisersGetSupportedByFriendsData, FundraisersGetSupportedByFriendsError, FundraisersGetSupportedByFriendsResponse, FundraisersInviteFundraiserMemberData, FundraisersInviteFundraiserMemberError, FundraisersInviteFundraiserMemberResponse, FundraisersPublishFundraiserData, FundraisersPublishFundraiserError, FundraisersPublishFundraiserResponse, FundraisersReactivateFundraiserData, FundraisersReactivateFundraiserError, FundraisersReactivateFundraiserResponse, FundraisersRemoveCharityFromFundraiserData, FundraisersRemoveCharityFromFundraiserError, FundraisersRemoveCharityFromFundraiserResponse, FundraisersRemoveCollectionFromFundraiserData, FundraisersRemoveCollectionFromFundraiserError, FundraisersRemoveCollectionFromFundraiserResponse, FundraisersRemoveEtfFromFundraiserData, FundraisersRemoveEtfFromFundraiserError, FundraisersRemoveEtfFromFundraiserResponse, FundraisersRemoveFundraiserMemberData, FundraisersRemoveFundraiserMemberError, FundraisersRemoveFundraiserMemberResponse, FundraisersReopenFundraiserData, FundraisersReopenFundraiserError, FundraisersReopenFundraiserResponse, FundraisersTransferFundraiserOwnershipData, FundraisersTransferFundraiserOwnershipError, FundraisersTransferFundraiserOwnershipResponse, FundraisersUpdateFundraiserData, FundraisersUpdateFundraiserError, FundraisersUpdateFundraiserResponse, FundraisersUploadFundraiserPictureData, FundraisersUploadFundraiserPictureError, FundraisersUploadFundraiserPictureResponse, GameAwardGameTreatsData, GameAwardGameTreatsError, GameAwardGameTreatsResponse, GameCatchGameDogData, GameCatchGameDogResponse, GameClaimGameObjectData, GameClaimGameObjectError, GameClaimGameObjectResponse, GameClaimGameSurpriseData, GameClaimGameSurpriseError, GameClaimGameSurpriseResponse, GameCreateGameProfileData, GameCreateGameProfileError, GameCreateGameProfileResponse, GameEarnGameCoinsData, GameEarnGameCoinsError, GameEarnGameCoinsResponse, GameGetGameCatalogData, GameGetGameCatalogResponse, GameGetGameCharityFoundationData, GameGetGameCharityFoundationError, GameGetGameCharityFoundationResponse, GameGetGameCoinsData, GameGetGameCoinsError, GameGetGameCoinsResponse, GameGetGameConfigData, GameGetGameConfigResponse, GameGetGameDogStatusData, GameGetGameDogStatusResponse, GameGetGameFoundationData, GameGetGameFoundationResponse, GameGetGameMapEntitiesData, GameGetGameMapEntitiesError, GameGetGameMapEntitiesResponse, GameGetGamePendingGiftsData, GameGetGamePendingGiftsError, GameGetGamePendingGiftsResponse, GameGetGameProfileData, GameGetGameProfileResponse, GameGetGameScrapbookData, GameGetGameScrapbookError, GameGetGameScrapbookResponse, GameGetGameTreatsData, GameGetGameTreatsResponse, GameGetUserGameFoundationData, GameGetUserGameFoundationError, GameGetUserGameFoundationResponse, GamePutGameFoundationData, GamePutGameFoundationError, GamePutGameFoundationResponse, GameRemoveCharityFoundationReactionData, GameRemoveCharityFoundationReactionError, GameRemoveCharityFoundationReactionResponse, GameRemoveUserFoundationReactionData, GameRemoveUserFoundationReactionError, GameRemoveUserFoundationReactionResponse, GameSearchGameCitiesData, GameSearchGameCitiesError, GameSearchGameCitiesResponse, GameSetCharityFoundationReactionData, GameSetCharityFoundationReactionError, GameSetCharityFoundationReactionResponse, GameSetGameRescueVisitorData, GameSetGameRescueVisitorError, GameSetGameRescueVisitorResponse, GameSetUserFoundationReactionData, GameSetUserFoundationReactionError, GameSetUserFoundationReactionResponse, GiftCardsClaimGiftCardData, GiftCardsClaimGiftCardError, GiftCardsClaimGiftCardResponse, GiftCardsListGiftCardsSuperAdminData, GiftCardsListGiftCardsSuperAdminError, GiftCardsListGiftCardsSuperAdminResponse, GiftCardsListMyGiftCardsData, GiftCardsListMyGiftCardsError, GiftCardsListMyGiftCardsResponse, GiftCardsManualIssueGiftCardData, GiftCardsManualIssueGiftCardError, GiftCardsManualIssueGiftCardResponse, GiftCardsPreviewGiftCardClaimData, GiftCardsPreviewGiftCardClaimError, GiftCardsPreviewGiftCardClaimResponse, GiftCardsPreviewGiftCardData, GiftCardsPreviewGiftCardError, GiftCardsPreviewGiftCardResponse, GiftCardsPurchaseGiftCardAuthenticatedData, GiftCardsPurchaseGiftCardAuthenticatedError, GiftCardsPurchaseGiftCardAuthenticatedResponse, GiftCardsPurchaseGiftCardData, GiftCardsPurchaseGiftCardError, GiftCardsPurchaseGiftCardResponse, GiftCardsRedeemGiftCardData, GiftCardsRedeemGiftCardError, GiftCardsRedeemGiftCardResponse, GiftCardsReissueFailedBatchDeliveriesData, GiftCardsReissueFailedBatchDeliveriesError, GiftCardsReissueFailedBatchDeliveriesResponse, GiftCardsReissueGiftCardData, GiftCardsReissueGiftCardError, GiftCardsReissueGiftCardResponse, GiftCardsSendGiftCardFromWalletData, GiftCardsSendGiftCardFromWalletError, GiftCardsSendGiftCardFromWalletResponse, GiftCardsVoidGiftCardData, GiftCardsVoidGiftCardError, GiftCardsVoidGiftCardResponse, GivingPacketListGivingPacketReportsData, GivingPacketListGivingPacketReportsError, GivingPacketListGivingPacketReportsResponse, GivingPacketRequestGivingPacketData, GivingPacketRequestGivingPacketError, GivingPacketRequestGivingPacketResponse, GrantsGetGrantData, GrantsGetGrantError, GrantsGetGrantResponse, GrantsGetGrantsByCharityData, GrantsGetGrantsByCharityError, GrantsGetGrantsByCharityResponse, GrantsGetGrantsData, GrantsGetGrantsError, GrantsGetGrantsResponse, GrantsGetSuperAdminGrantDonationsData, GrantsGetSuperAdminGrantDonationsError, GrantsGetSuperAdminGrantDonationsResponse, GrantsGetSuperAdminGrantsData, GrantsGetSuperAdminGrantsError, GrantsGetSuperAdminGrantsResponse, GrantsMarkGrantReturnedData, GrantsMarkGrantReturnedError, GrantsMarkGrantReturnedResponse, GrantsMarkGrantSentData, GrantsMarkGrantSentError, GrantsMarkGrantSentResponse, GrantsMintCohortData, GrantsMintCohortError, GrantsMintCohortResponse, GrantsUnmintGrantData, GrantsUnmintGrantError, GrantsUnmintGrantResponse, GrantsUpdateGrantData, GrantsUpdateGrantError, GrantsUpdateGrantResponse, GroupsAcceptGroupInviteByTokenData, GroupsAcceptGroupInviteByTokenError, GroupsAcceptGroupInviteByTokenResponse, GroupsAcceptGroupInviteData, GroupsAcceptGroupInviteError, GroupsAcceptGroupInviteResponse, GroupsAcceptGroupOwnershipTransferData, GroupsAcceptGroupOwnershipTransferError, GroupsAcceptGroupOwnershipTransferResponse, GroupsApproveGroupDonationRequestData, GroupsApproveGroupDonationRequestError, GroupsApproveGroupDonationRequestResponse, GroupsApproveGroupJoinRequestData, GroupsApproveGroupJoinRequestError, GroupsApproveGroupJoinRequestResponse, GroupsApproveGuardianMembershipData, GroupsApproveGuardianMembershipError, GroupsApproveGuardianMembershipResponse, GroupsCancelGroupRecurringContributionData, GroupsCancelGroupRecurringContributionError, GroupsCancelGroupRecurringContributionResponse, GroupsContributeToGroupData, GroupsContributeToGroupError, GroupsContributeToGroupResponse, GroupsCreateGroupData, GroupsCreateGroupDonationRequestData, GroupsCreateGroupDonationRequestError, GroupsCreateGroupDonationRequestResponse, GroupsCreateGroupError, GroupsCreateGroupFundraiserData, GroupsCreateGroupFundraiserError, GroupsCreateGroupFundraiserResponse, GroupsCreateGroupRecurringContributionData, GroupsCreateGroupRecurringContributionError, GroupsCreateGroupRecurringContributionResponse, GroupsCreateGroupResponse, GroupsDeleteGroupData, GroupsDeleteGroupError, GroupsDeleteGroupInviteData, GroupsDeleteGroupInviteError, GroupsDeleteGroupInviteResponse, GroupsDeleteGroupResponse, GroupsDiscoverGroupsData, GroupsDiscoverGroupsError, GroupsDiscoverGroupsResponse, GroupsDonateFromGroupData, GroupsDonateFromGroupError, GroupsDonateFromGroupResponse, GroupsFollowGroupData, GroupsFollowGroupError, GroupsFollowGroupResponse, GroupsGetGroupActivityData, GroupsGetGroupActivityError, GroupsGetGroupActivityResponse, GroupsGetGroupByHandleData, GroupsGetGroupByHandleError, GroupsGetGroupByHandleResponse, GroupsGetGroupData, GroupsGetGroupError, GroupsGetGroupOwnershipTransferData, GroupsGetGroupOwnershipTransferError, GroupsGetGroupOwnershipTransferResponse, GroupsGetGroupResponse, GroupsGetGroupWalletData, GroupsGetGroupWalletError, GroupsGetGroupWalletResponse, GroupsGetMyGroupContributionData, GroupsGetMyGroupContributionError, GroupsGetMyGroupContributionResponse, GroupsGetMyGroupStatsData, GroupsGetMyGroupStatsError, GroupsGetMyGroupStatsResponse, GroupsInviteGroupMemberData, GroupsInviteGroupMemberError, GroupsInviteGroupMemberResponse, GroupsLeaveGroupData, GroupsLeaveGroupError, GroupsLeaveGroupResponse, GroupsListGroupDonationRequestsData, GroupsListGroupDonationRequestsError, GroupsListGroupDonationRequestsResponse, GroupsListGroupJoinRequestsData, GroupsListGroupJoinRequestsError, GroupsListGroupJoinRequestsResponse, GroupsListGroupMembersData, GroupsListGroupMembersError, GroupsListGroupMembersResponse, GroupsListGuardianApprovalsData, GroupsListGuardianApprovalsError, GroupsListGuardianApprovalsResponse, GroupsListGuardianMinorsData, GroupsListGuardianMinorsError, GroupsListGuardianMinorsResponse, GroupsListMyGroupInvitationsData, GroupsListMyGroupInvitationsError, GroupsListMyGroupInvitationsResponse, GroupsListMyGroupsData, GroupsListMyGroupsError, GroupsListMyGroupsResponse, GroupsOfferGroupOwnershipTransferData, GroupsOfferGroupOwnershipTransferError, GroupsOfferGroupOwnershipTransferResponse, GroupsPublishGroupData, GroupsPublishGroupError, GroupsPublishGroupResponse, GroupsRejectGroupDonationRequestData, GroupsRejectGroupDonationRequestError, GroupsRejectGroupDonationRequestResponse, GroupsRejectGroupJoinRequestData, GroupsRejectGroupJoinRequestError, GroupsRejectGroupJoinRequestResponse, GroupsRejectGuardianMembershipData, GroupsRejectGuardianMembershipError, GroupsRejectGuardianMembershipResponse, GroupsRequestToJoinGroupData, GroupsRequestToJoinGroupError, GroupsRequestToJoinGroupResponse, GroupsRevokeGroupOwnershipTransferData, GroupsRevokeGroupOwnershipTransferError, GroupsRevokeGroupOwnershipTransferResponse, GroupsUnfollowGroupData, GroupsUnfollowGroupError, GroupsUnfollowGroupResponse, GroupsUpdateGroupData, GroupsUpdateGroupError, GroupsUpdateGroupMatchSettingData, GroupsUpdateGroupMatchSettingError, GroupsUpdateGroupMatchSettingResponse, GroupsUpdateGroupMemberData, GroupsUpdateGroupMemberError, GroupsUpdateGroupMemberResponse, GroupsUpdateGroupResponse, GroupsUpdateGuardianMinorSettingsData, GroupsUpdateGuardianMinorSettingsError, GroupsUpdateGuardianMinorSettingsResponse, GroupsUploadGroupPictureData, GroupsUploadGroupPictureError, GroupsUploadGroupPictureResponse, ImportedReceiptsConfirmImportedReceiptData, ImportedReceiptsConfirmImportedReceiptError, ImportedReceiptsConfirmImportedReceiptResponse, ImportedReceiptsDeleteImportedDonationData, ImportedReceiptsDeleteImportedDonationError, ImportedReceiptsDeleteImportedDonationResponse, ImportedReceiptsDeleteImportedReceiptData, ImportedReceiptsDeleteImportedReceiptError, ImportedReceiptsDeleteImportedReceiptResponse, ImportedReceiptsExportImportedDonationsCsvData, ImportedReceiptsExportImportedDonationsCsvError, ImportedReceiptsExportImportedDonationsCsvResponse, ImportedReceiptsGetImportedReceiptData, ImportedReceiptsGetImportedReceiptError, ImportedReceiptsGetImportedReceiptResponse, ImportedReceiptsListImportedDonationsData, ImportedReceiptsListImportedDonationsError, ImportedReceiptsListImportedDonationsResponse, ImportedReceiptsListImportedReceiptsData, ImportedReceiptsListImportedReceiptsError, ImportedReceiptsListImportedReceiptsResponse, ImportedReceiptsRegisterImportedReceiptData, ImportedReceiptsRegisterImportedReceiptError, ImportedReceiptsRegisterImportedReceiptResponse, ImportedReceiptsRequestImportedReceiptUploadUrlData, ImportedReceiptsRequestImportedReceiptUploadUrlError, ImportedReceiptsRequestImportedReceiptUploadUrlResponse, MatchOffersCancelMatchOfferData, MatchOffersCancelMatchOfferError, MatchOffersCancelMatchOfferResponse, MatchOffersCreateMatchOfferData, MatchOffersCreateMatchOfferError, MatchOffersCreateMatchOfferResponse, MatchOffersGetMyMatchOfferData, MatchOffersGetMyMatchOfferError, MatchOffersGetMyMatchOfferResponse, MatchOffersListCharityMatchOffersData, MatchOffersListCharityMatchOffersError, MatchOffersListCharityMatchOffersResponse, MatchOffersListMyMatchOffersData, MatchOffersListMyMatchOffersError, MatchOffersListMyMatchOffersResponse, MatchOffersRedirectMatchClaimData, MatchOffersRedirectMatchClaimError, MatchOffersRedirectMatchClaimResponse, NotificationsGetNotificationsData, NotificationsGetNotificationsError, NotificationsGetNotificationsResponse, NotificationsGetUnreadCountData, NotificationsGetUnreadCountResponse, NotificationsMarkAllNotificationsReadData, NotificationsMarkAllNotificationsReadResponse, NotificationsMarkNotificationReadData, NotificationsMarkNotificationReadError, NotificationsMarkNotificationReadResponse, NotificationsRegisterDeviceTokenData, NotificationsRegisterDeviceTokenError, NotificationsRegisterDeviceTokenResponse, NotificationsUnregisterDeviceTokenData, NotificationsUnregisterDeviceTokenError, NotificationsUnregisterDeviceTokenResponse, OrganizerMessagesGetOrganizerMessageUnsubscribeData, OrganizerMessagesGetOrganizerMessageUnsubscribeError, OrganizerMessagesGetOrganizerMessageUnsubscribeResponse, OrganizerMessagesPostOrganizerMessageUnsubscribeData, OrganizerMessagesPostOrganizerMessageUnsubscribeError, OrganizerMessagesPostOrganizerMessageUnsubscribeResponse, OrgBoardOrgAddBoardCommitteeMemberData, OrgBoardOrgAddBoardCommitteeMemberError, OrgBoardOrgAddBoardCommitteeMemberResponse, OrgBoardOrgAddBoardCommitteeSuggestionItemsData, OrgBoardOrgAddBoardCommitteeSuggestionItemsError, OrgBoardOrgAddBoardCommitteeSuggestionItemsResponse, OrgBoardOrgAddBoardConsentCompensationDecisionData, OrgBoardOrgAddBoardConsentCompensationDecisionError, OrgBoardOrgAddBoardConsentCompensationDecisionResponse, OrgBoardOrgAddBoardMemberToBoardData, OrgBoardOrgAddBoardMemberToBoardError, OrgBoardOrgAddBoardMemberToBoardResponse, OrgBoardOrgAddBoardMotionCompensationDecisionData, OrgBoardOrgAddBoardMotionCompensationDecisionError, OrgBoardOrgAddBoardMotionCompensationDecisionResponse, OrgBoardOrgAddBoardTermSuggestionItemsData, OrgBoardOrgAddBoardTermSuggestionItemsError, OrgBoardOrgAddBoardTermSuggestionItemsResponse, OrgBoardOrgAdoptBoardCalendarSettingsData, OrgBoardOrgAdoptBoardCalendarSettingsError, OrgBoardOrgAdoptBoardCalendarSettingsResponse, OrgBoardOrgAdoptBoardOfficerDutiesData, OrgBoardOrgAdoptBoardOfficerDutiesError, OrgBoardOrgAdoptBoardOfficerDutiesResponse, OrgBoardOrgAdoptBoardRetentionPolicyData, OrgBoardOrgAdoptBoardRetentionPolicyError, OrgBoardOrgAdoptBoardRetentionPolicyResponse, OrgBoardOrgApplyBoardAgendaTemplateData, OrgBoardOrgApplyBoardAgendaTemplateError, OrgBoardOrgApplyBoardAgendaTemplateResponse, OrgBoardOrgApplyBoardCalendarSettingsData, OrgBoardOrgApplyBoardCalendarSettingsError, OrgBoardOrgApplyBoardCalendarSettingsResponse, OrgBoardOrgApproveBoardMinutesData, OrgBoardOrgApproveBoardMinutesError, OrgBoardOrgApproveBoardMinutesResponse, OrgBoardOrgApproveBoardRecordData, OrgBoardOrgApproveBoardRecordError, OrgBoardOrgApproveBoardRecordResponse, OrgBoardOrgAskBoardMinutesApprovalSignaturesData, OrgBoardOrgAskBoardMinutesApprovalSignaturesError, OrgBoardOrgAskBoardMinutesApprovalSignaturesResponse, OrgBoardOrgCancelBoardCoiCycleData, OrgBoardOrgCancelBoardCoiCycleError, OrgBoardOrgCancelBoardCoiCycleResponse, OrgBoardOrgCancelBoardMeetingData, OrgBoardOrgCancelBoardMeetingError, OrgBoardOrgCancelBoardMeetingResponse, OrgBoardOrgCancelBoardSelfAssessmentData, OrgBoardOrgCancelBoardSelfAssessmentError, OrgBoardOrgCancelBoardSelfAssessmentResponse, OrgBoardOrgCheckBoardImportInboxFileData, OrgBoardOrgCheckBoardImportInboxFileError, OrgBoardOrgCheckBoardImportInboxFileResponse, OrgBoardOrgCheckBoardProposalFileData, OrgBoardOrgCheckBoardProposalFileError, OrgBoardOrgCheckBoardProposalFileResponse, OrgBoardOrgChooseBoardMemberBuddyData, OrgBoardOrgChooseBoardMemberBuddyError, OrgBoardOrgChooseBoardMemberBuddyResponse, OrgBoardOrgCirculateBoardWrittenConsentData, OrgBoardOrgCirculateBoardWrittenConsentError, OrgBoardOrgCirculateBoardWrittenConsentResponse, OrgBoardOrgCloseBoardCoiCycleData, OrgBoardOrgCloseBoardCoiCycleError, OrgBoardOrgCloseBoardCoiCycleResponse, OrgBoardOrgCloseBoardImportBatchData, OrgBoardOrgCloseBoardImportBatchError, OrgBoardOrgCloseBoardImportBatchResponse, OrgBoardOrgCloseBoardMemberGettingStartedData, OrgBoardOrgCloseBoardMemberGettingStartedError, OrgBoardOrgCloseBoardMemberGettingStartedResponse, OrgBoardOrgCloseBoardSelfAssessmentData, OrgBoardOrgCloseBoardSelfAssessmentError, OrgBoardOrgCloseBoardSelfAssessmentResponse, OrgBoardOrgConfirmBoardCompensationDocumentData, OrgBoardOrgConfirmBoardCompensationDocumentError, OrgBoardOrgConfirmBoardCompensationDocumentResponse, OrgBoardOrgConfirmBoardDocumentData, OrgBoardOrgConfirmBoardDocumentError, OrgBoardOrgConfirmBoardDocumentResponse, OrgBoardOrgConfirmBoardPastRecordBatchData, OrgBoardOrgConfirmBoardPastRecordBatchError, OrgBoardOrgConfirmBoardPastRecordBatchResponse, OrgBoardOrgConfirmBoardReturnCopyData, OrgBoardOrgConfirmBoardReturnCopyError, OrgBoardOrgConfirmBoardReturnCopyResponse, OrgBoardOrgCorrectBoardCommitteeDissolutionData, OrgBoardOrgCorrectBoardCommitteeDissolutionError, OrgBoardOrgCorrectBoardCommitteeDissolutionResponse, OrgBoardOrgCreateBoardAgendaItemData, OrgBoardOrgCreateBoardAgendaItemError, OrgBoardOrgCreateBoardAgendaItemResponse, OrgBoardOrgCreateBoardCommitteeData, OrgBoardOrgCreateBoardCommitteeError, OrgBoardOrgCreateBoardCommitteeResponse, OrgBoardOrgCreateBoardDirectorClassData, OrgBoardOrgCreateBoardDirectorClassError, OrgBoardOrgCreateBoardDirectorClassResponse, OrgBoardOrgCreateBoardMeetingData, OrgBoardOrgCreateBoardMeetingError, OrgBoardOrgCreateBoardMeetingResponse, OrgBoardOrgCreateBoardMeetingSegmentData, OrgBoardOrgCreateBoardMeetingSegmentError, OrgBoardOrgCreateBoardMeetingSegmentResponse, OrgBoardOrgCreateBoardMemberData, OrgBoardOrgCreateBoardMemberError, OrgBoardOrgCreateBoardMemberResponse, OrgBoardOrgCreateBoardMinutesApprovalConsentData, OrgBoardOrgCreateBoardMinutesApprovalConsentError, OrgBoardOrgCreateBoardMinutesApprovalConsentResponse, OrgBoardOrgCreateBoardMotionData, OrgBoardOrgCreateBoardMotionError, OrgBoardOrgCreateBoardMotionResponse, OrgBoardOrgCreateBoardOfficerTitleData, OrgBoardOrgCreateBoardOfficerTitleError, OrgBoardOrgCreateBoardOfficerTitleResponse, OrgBoardOrgCreateBoardPacketData, OrgBoardOrgCreateBoardPacketError, OrgBoardOrgCreateBoardPacketItemData, OrgBoardOrgCreateBoardPacketItemError, OrgBoardOrgCreateBoardPacketItemResponse, OrgBoardOrgCreateBoardPacketResponse, OrgBoardOrgCreateBoardRecordDraftData, OrgBoardOrgCreateBoardRecordDraftError, OrgBoardOrgCreateBoardRecordDraftResponse, OrgBoardOrgCreateBoardWrittenConsentData, OrgBoardOrgCreateBoardWrittenConsentError, OrgBoardOrgCreateBoardWrittenConsentResponse, OrgBoardOrgDeleteBoardAgendaItemData, OrgBoardOrgDeleteBoardAgendaItemError, OrgBoardOrgDeleteBoardAgendaItemResponse, OrgBoardOrgDeleteBoardConflictLinkData, OrgBoardOrgDeleteBoardConflictLinkError, OrgBoardOrgDeleteBoardConflictLinkResponse, OrgBoardOrgDeleteBoardImportFileUploadData, OrgBoardOrgDeleteBoardImportFileUploadError, OrgBoardOrgDeleteBoardImportFileUploadResponse, OrgBoardOrgDeleteBoardImportRecordFileUploadData, OrgBoardOrgDeleteBoardImportRecordFileUploadError, OrgBoardOrgDeleteBoardImportRecordFileUploadResponse, OrgBoardOrgDeleteBoardMeetingSegmentData, OrgBoardOrgDeleteBoardMeetingSegmentError, OrgBoardOrgDeleteBoardMeetingSegmentResponse, OrgBoardOrgDeleteBoardMotionData, OrgBoardOrgDeleteBoardMotionError, OrgBoardOrgDeleteBoardMotionResponse, OrgBoardOrgDeleteBoardPacketItemData, OrgBoardOrgDeleteBoardPacketItemError, OrgBoardOrgDeleteBoardPacketItemResponse, OrgBoardOrgDeleteBoardRecordChainData, OrgBoardOrgDeleteBoardRecordChainError, OrgBoardOrgDeleteBoardRecordChainResponse, OrgBoardOrgDeleteBoardRecordData, OrgBoardOrgDeleteBoardRecordError, OrgBoardOrgDeleteBoardRecordResponse, OrgBoardOrgDiscardBoardMemberProposalData, OrgBoardOrgDiscardBoardMemberProposalError, OrgBoardOrgDiscardBoardMemberProposalResponse, OrgBoardOrgDiscardBoardPacketData, OrgBoardOrgDiscardBoardPacketError, OrgBoardOrgDiscardBoardPacketResponse, OrgBoardOrgDiscardBoardPastRecordBatchData, OrgBoardOrgDiscardBoardPastRecordBatchError, OrgBoardOrgDiscardBoardPastRecordBatchResponse, OrgBoardOrgDiscardBoardRecordDraftData, OrgBoardOrgDiscardBoardRecordDraftError, OrgBoardOrgDiscardBoardRecordDraftResponse, OrgBoardOrgDismissBoardCommitteeSuggestionData, OrgBoardOrgDismissBoardCommitteeSuggestionError, OrgBoardOrgDismissBoardCommitteeSuggestionResponse, OrgBoardOrgDismissBoardTermSuggestionData, OrgBoardOrgDismissBoardTermSuggestionError, OrgBoardOrgDismissBoardTermSuggestionResponse, OrgBoardOrgDissolveBoardCommitteeData, OrgBoardOrgDissolveBoardCommitteeError, OrgBoardOrgDissolveBoardCommitteeResponse, OrgBoardOrgDistributeBoardPacketData, OrgBoardOrgDistributeBoardPacketError, OrgBoardOrgDistributeBoardPacketResponse, OrgBoardOrgEmailBoardReturnAgainData, OrgBoardOrgEmailBoardReturnAgainError, OrgBoardOrgEmailBoardReturnAgainResponse, OrgBoardOrgEndBoardCommitteeMemberData, OrgBoardOrgEndBoardCommitteeMemberError, OrgBoardOrgEndBoardCommitteeMemberResponse, OrgBoardOrgExportBoardMinuteBookData, OrgBoardOrgExportBoardMinuteBookDocumentData, OrgBoardOrgExportBoardMinuteBookDocumentError, OrgBoardOrgExportBoardMinuteBookDocumentResponse, OrgBoardOrgExportBoardMinuteBookError, OrgBoardOrgExportBoardMinuteBookResponse, OrgBoardOrgGetBoardCalendarSettingsData, OrgBoardOrgGetBoardCalendarSettingsError, OrgBoardOrgGetBoardCalendarSettingsResponse, OrgBoardOrgGetBoardCoiCycleData, OrgBoardOrgGetBoardCoiCycleDocumentData, OrgBoardOrgGetBoardCoiCycleDocumentError, OrgBoardOrgGetBoardCoiCycleDocumentResponse, OrgBoardOrgGetBoardCoiCycleError, OrgBoardOrgGetBoardCoiCycleResponse, OrgBoardOrgGetBoardCoiPaperFormData, OrgBoardOrgGetBoardCoiPaperFormError, OrgBoardOrgGetBoardCoiPaperFormResponse, OrgBoardOrgGetBoardCoiPersonQuestionnaireData, OrgBoardOrgGetBoardCoiPersonQuestionnaireError, OrgBoardOrgGetBoardCoiPersonQuestionnaireResponse, OrgBoardOrgGetBoardCoiQuestionnaireData, OrgBoardOrgGetBoardCoiQuestionnaireError, OrgBoardOrgGetBoardCoiQuestionnaireResponse, OrgBoardOrgGetBoardCoiResponseChangesData, OrgBoardOrgGetBoardCoiResponseChangesError, OrgBoardOrgGetBoardCoiResponseChangesResponse, OrgBoardOrgGetBoardCoiResponseData, OrgBoardOrgGetBoardCoiResponseDocumentData, OrgBoardOrgGetBoardCoiResponseDocumentError, OrgBoardOrgGetBoardCoiResponseDocumentResponse, OrgBoardOrgGetBoardCoiResponseError, OrgBoardOrgGetBoardCoiResponseResponse, OrgBoardOrgGetBoardCommitteeData, OrgBoardOrgGetBoardCommitteeError, OrgBoardOrgGetBoardCommitteeResponse, OrgBoardOrgGetBoardCommitteeSuggestionsData, OrgBoardOrgGetBoardCommitteeSuggestionsError, OrgBoardOrgGetBoardCommitteeSuggestionsResponse, OrgBoardOrgGetBoardCompensationDecisionData, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadData, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadError, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadResponse, OrgBoardOrgGetBoardCompensationDecisionError, OrgBoardOrgGetBoardCompensationDecisionResponse, OrgBoardOrgGetBoardCompensationDocumentDownloadData, OrgBoardOrgGetBoardCompensationDocumentDownloadError, OrgBoardOrgGetBoardCompensationDocumentDownloadResponse, OrgBoardOrgGetBoardConsentTemplateData, OrgBoardOrgGetBoardConsentTemplateError, OrgBoardOrgGetBoardConsentTemplateResponse, OrgBoardOrgGetBoardDirectorAccessPolicyData, OrgBoardOrgGetBoardDirectorAccessPolicyError, OrgBoardOrgGetBoardDirectorAccessPolicyResponse, OrgBoardOrgGetBoardDocumentDownloadUrlData, OrgBoardOrgGetBoardDocumentDownloadUrlError, OrgBoardOrgGetBoardDocumentDownloadUrlResponse, OrgBoardOrgGetBoardFilingGovernanceFeedData, OrgBoardOrgGetBoardFilingGovernanceFeedError, OrgBoardOrgGetBoardFilingGovernanceFeedResponse, OrgBoardOrgGetBoardForm990Data, OrgBoardOrgGetBoardForm990Error, OrgBoardOrgGetBoardForm990Response, OrgBoardOrgGetBoardGettingStartedListData, OrgBoardOrgGetBoardGettingStartedListError, OrgBoardOrgGetBoardGettingStartedListResponse, OrgBoardOrgGetBoardGoverningDocumentTemplateData, OrgBoardOrgGetBoardGoverningDocumentTemplateError, OrgBoardOrgGetBoardGoverningDocumentTemplateResponse, OrgBoardOrgGetBoardImportBatchData, OrgBoardOrgGetBoardImportBatchError, OrgBoardOrgGetBoardImportBatchResponse, OrgBoardOrgGetBoardImportInboxFileUrlData, OrgBoardOrgGetBoardImportInboxFileUrlError, OrgBoardOrgGetBoardImportInboxFileUrlResponse, OrgBoardOrgGetBoardInMeetingRecordData, OrgBoardOrgGetBoardInMeetingRecordError, OrgBoardOrgGetBoardInMeetingRecordResponse, OrgBoardOrgGetBoardLegalHoldReportData, OrgBoardOrgGetBoardLegalHoldReportError, OrgBoardOrgGetBoardLegalHoldReportResponse, OrgBoardOrgGetBoardMeetingCalendarData, OrgBoardOrgGetBoardMeetingCalendarError, OrgBoardOrgGetBoardMeetingCalendarResponse, OrgBoardOrgGetBoardMeetingData, OrgBoardOrgGetBoardMeetingError, OrgBoardOrgGetBoardMeetingInvitationsData, OrgBoardOrgGetBoardMeetingInvitationsError, OrgBoardOrgGetBoardMeetingInvitationsResponse, OrgBoardOrgGetBoardMeetingPresidingData, OrgBoardOrgGetBoardMeetingPresidingError, OrgBoardOrgGetBoardMeetingPresidingResponse, OrgBoardOrgGetBoardMeetingResponse, OrgBoardOrgGetBoardMemberData, OrgBoardOrgGetBoardMemberError, OrgBoardOrgGetBoardMemberGettingStartedData, OrgBoardOrgGetBoardMemberGettingStartedError, OrgBoardOrgGetBoardMemberGettingStartedResponse, OrgBoardOrgGetBoardMemberResponse, OrgBoardOrgGetBoardMinutesApprovalConsentFormData, OrgBoardOrgGetBoardMinutesApprovalConsentFormError, OrgBoardOrgGetBoardMinutesApprovalConsentFormResponse, OrgBoardOrgGetBoardMinutesData, OrgBoardOrgGetBoardMinutesError, OrgBoardOrgGetBoardMinutesResponse, OrgBoardOrgGetBoardOfficerDutiesData, OrgBoardOrgGetBoardOfficerDutiesError, OrgBoardOrgGetBoardOfficerDutiesResponse, OrgBoardOrgGetBoardOfficerStatementData, OrgBoardOrgGetBoardOfficerStatementError, OrgBoardOrgGetBoardOfficerStatementResponse, OrgBoardOrgGetBoardPacketData, OrgBoardOrgGetBoardPacketError, OrgBoardOrgGetBoardPacketResponse, OrgBoardOrgGetBoardPastRecordBatchData, OrgBoardOrgGetBoardPastRecordBatchError, OrgBoardOrgGetBoardPastRecordBatchResponse, OrgBoardOrgGetBoardProposalFileUrlData, OrgBoardOrgGetBoardProposalFileUrlError, OrgBoardOrgGetBoardProposalFileUrlResponse, OrgBoardOrgGetBoardRecordData, OrgBoardOrgGetBoardRecordError, OrgBoardOrgGetBoardRecordFileUrlData, OrgBoardOrgGetBoardRecordFileUrlError, OrgBoardOrgGetBoardRecordFileUrlResponse, OrgBoardOrgGetBoardRecordResponse, OrgBoardOrgGetBoardReturnCopyUrlData, OrgBoardOrgGetBoardReturnCopyUrlError, OrgBoardOrgGetBoardReturnCopyUrlResponse, OrgBoardOrgGetBoardReturnDistributionData, OrgBoardOrgGetBoardReturnDistributionError, OrgBoardOrgGetBoardReturnDistributionResponse, OrgBoardOrgGetBoardScheduleODraftData, OrgBoardOrgGetBoardScheduleODraftError, OrgBoardOrgGetBoardScheduleODraftResponse, OrgBoardOrgGetBoardSelfAssessmentData, OrgBoardOrgGetBoardSelfAssessmentError, OrgBoardOrgGetBoardSelfAssessmentInstrumentData, OrgBoardOrgGetBoardSelfAssessmentInstrumentError, OrgBoardOrgGetBoardSelfAssessmentInstrumentResponse, OrgBoardOrgGetBoardSelfAssessmentQuestionsData, OrgBoardOrgGetBoardSelfAssessmentQuestionsError, OrgBoardOrgGetBoardSelfAssessmentQuestionsResponse, OrgBoardOrgGetBoardSelfAssessmentResponse, OrgBoardOrgGetBoardSelfAssessmentResultsData, OrgBoardOrgGetBoardSelfAssessmentResultsError, OrgBoardOrgGetBoardSelfAssessmentResultsResponse, OrgBoardOrgGetBoardTermSuggestionsData, OrgBoardOrgGetBoardTermSuggestionsError, OrgBoardOrgGetBoardTermSuggestionsResponse, OrgBoardOrgGetBoardToDoData, OrgBoardOrgGetBoardToDoError, OrgBoardOrgGetBoardToDoResponse, OrgBoardOrgGetBoardWrittenConsentData, OrgBoardOrgGetBoardWrittenConsentError, OrgBoardOrgGetBoardWrittenConsentResponse, OrgBoardOrgImportBoardRecordData, OrgBoardOrgImportBoardRecordError, OrgBoardOrgImportBoardRecordResponse, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlData, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlError, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlResponse, OrgBoardOrgIssueBoardDocumentUploadUrlData, OrgBoardOrgIssueBoardDocumentUploadUrlError, OrgBoardOrgIssueBoardDocumentUploadUrlResponse, OrgBoardOrgIssueBoardImportFileUploadUrlData, OrgBoardOrgIssueBoardImportFileUploadUrlError, OrgBoardOrgIssueBoardImportFileUploadUrlResponse, OrgBoardOrgIssueBoardImportInboxUploadUrlData, OrgBoardOrgIssueBoardImportInboxUploadUrlError, OrgBoardOrgIssueBoardImportInboxUploadUrlResponse, OrgBoardOrgIssueBoardImportRecordFileUploadUrlData, OrgBoardOrgIssueBoardImportRecordFileUploadUrlError, OrgBoardOrgIssueBoardImportRecordFileUploadUrlResponse, OrgBoardOrgIssueBoardProposalFileUploadUrlData, OrgBoardOrgIssueBoardProposalFileUploadUrlError, OrgBoardOrgIssueBoardProposalFileUploadUrlResponse, OrgBoardOrgIssueBoardReturnCopyUploadUrlData, OrgBoardOrgIssueBoardReturnCopyUploadUrlError, OrgBoardOrgIssueBoardReturnCopyUploadUrlResponse, OrgBoardOrgLeaveOutBoardPastRecordData, OrgBoardOrgLeaveOutBoardPastRecordError, OrgBoardOrgLeaveOutBoardPastRecordResponse, OrgBoardOrgLinkBoardCommitteeCharterData, OrgBoardOrgLinkBoardCommitteeCharterError, OrgBoardOrgLinkBoardCommitteeCharterResponse, OrgBoardOrgLinkBoardReturnReviewData, OrgBoardOrgLinkBoardReturnReviewError, OrgBoardOrgLinkBoardReturnReviewResponse, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesData, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesError, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesResponse, OrgBoardOrgListBoardAgendaItemsData, OrgBoardOrgListBoardAgendaItemsError, OrgBoardOrgListBoardAgendaItemsResponse, OrgBoardOrgListBoardAgendaTemplatesData, OrgBoardOrgListBoardAgendaTemplatesError, OrgBoardOrgListBoardAgendaTemplatesResponse, OrgBoardOrgListBoardApprovableMinutesData, OrgBoardOrgListBoardApprovableMinutesError, OrgBoardOrgListBoardApprovableMinutesResponse, OrgBoardOrgListBoardAttendanceIntentsData, OrgBoardOrgListBoardAttendanceIntentsError, OrgBoardOrgListBoardAttendanceIntentsResponse, OrgBoardOrgListBoardCalendarConnectionsData, OrgBoardOrgListBoardCalendarConnectionsError, OrgBoardOrgListBoardCalendarConnectionsResponse, OrgBoardOrgListBoardCalendarSendersData, OrgBoardOrgListBoardCalendarSendersError, OrgBoardOrgListBoardCalendarSendersResponse, OrgBoardOrgListBoardCarryForwardItemsData, OrgBoardOrgListBoardCarryForwardItemsError, OrgBoardOrgListBoardCarryForwardItemsResponse, OrgBoardOrgListBoardCarryForwardMotionsData, OrgBoardOrgListBoardCarryForwardMotionsError, OrgBoardOrgListBoardCarryForwardMotionsResponse, OrgBoardOrgListBoardCoiCyclesData, OrgBoardOrgListBoardCoiCyclesError, OrgBoardOrgListBoardCoiCyclesResponse, OrgBoardOrgListBoardCoiQuestionnairesData, OrgBoardOrgListBoardCoiQuestionnairesError, OrgBoardOrgListBoardCoiQuestionnairesResponse, OrgBoardOrgListBoardCommitteesData, OrgBoardOrgListBoardCommitteesError, OrgBoardOrgListBoardCommitteeSourcesData, OrgBoardOrgListBoardCommitteeSourcesError, OrgBoardOrgListBoardCommitteeSourcesResponse, OrgBoardOrgListBoardCommitteesResponse, OrgBoardOrgListBoardCompensationDecisionsData, OrgBoardOrgListBoardCompensationDecisionsError, OrgBoardOrgListBoardCompensationDecisionsResponse, OrgBoardOrgListBoardConflictLinksData, OrgBoardOrgListBoardConflictLinksError, OrgBoardOrgListBoardConflictLinksResponse, OrgBoardOrgListBoardConflictRegisterData, OrgBoardOrgListBoardConflictRegisterError, OrgBoardOrgListBoardConflictRegisterResponse, OrgBoardOrgListBoardConflictSuggestionsData, OrgBoardOrgListBoardConflictSuggestionsError, OrgBoardOrgListBoardConflictSuggestionsResponse, OrgBoardOrgListBoardConsentCompensationDecisionsData, OrgBoardOrgListBoardConsentCompensationDecisionsError, OrgBoardOrgListBoardConsentCompensationDecisionsResponse, OrgBoardOrgListBoardConsentTemplatesData, OrgBoardOrgListBoardConsentTemplatesError, OrgBoardOrgListBoardConsentTemplatesResponse, OrgBoardOrgListBoardContemporaneityData, OrgBoardOrgListBoardContemporaneityError, OrgBoardOrgListBoardContemporaneityResponse, OrgBoardOrgListBoardDirectorClassesData, OrgBoardOrgListBoardDirectorClassesError, OrgBoardOrgListBoardDirectorClassesResponse, OrgBoardOrgListBoardDocumentsData, OrgBoardOrgListBoardDocumentsError, OrgBoardOrgListBoardDocumentsResponse, OrgBoardOrgListBoardEngagementData, OrgBoardOrgListBoardEngagementError, OrgBoardOrgListBoardEngagementResponse, OrgBoardOrgListBoardGettingStartedStepsData, OrgBoardOrgListBoardGettingStartedStepsError, OrgBoardOrgListBoardGettingStartedStepsResponse, OrgBoardOrgListBoardGovernanceParametersData, OrgBoardOrgListBoardGovernanceParametersError, OrgBoardOrgListBoardGovernanceParametersResponse, OrgBoardOrgListBoardGoverningDocumentsData, OrgBoardOrgListBoardGoverningDocumentsError, OrgBoardOrgListBoardGoverningDocumentsResponse, OrgBoardOrgListBoardGoverningDocumentTemplatesData, OrgBoardOrgListBoardGoverningDocumentTemplatesError, OrgBoardOrgListBoardGoverningDocumentTemplatesResponse, OrgBoardOrgListBoardImportBatchesData, OrgBoardOrgListBoardImportBatchesError, OrgBoardOrgListBoardImportBatchesResponse, OrgBoardOrgListBoardImportBatchRecordsData, OrgBoardOrgListBoardImportBatchRecordsError, OrgBoardOrgListBoardImportBatchRecordsResponse, OrgBoardOrgListBoardImportInboxData, OrgBoardOrgListBoardImportInboxError, OrgBoardOrgListBoardImportInboxResponse, OrgBoardOrgListBoardLegalHoldsData, OrgBoardOrgListBoardLegalHoldsError, OrgBoardOrgListBoardLegalHoldsResponse, OrgBoardOrgListBoardMeetingAttendanceData, OrgBoardOrgListBoardMeetingAttendanceError, OrgBoardOrgListBoardMeetingAttendanceResponse, OrgBoardOrgListBoardMeetingCompensationDecisionsData, OrgBoardOrgListBoardMeetingCompensationDecisionsError, OrgBoardOrgListBoardMeetingCompensationDecisionsResponse, OrgBoardOrgListBoardMeetingEventsData, OrgBoardOrgListBoardMeetingEventsError, OrgBoardOrgListBoardMeetingEventsResponse, OrgBoardOrgListBoardMeetingsData, OrgBoardOrgListBoardMeetingSegmentsData, OrgBoardOrgListBoardMeetingSegmentsError, OrgBoardOrgListBoardMeetingSegmentsResponse, OrgBoardOrgListBoardMeetingsError, OrgBoardOrgListBoardMeetingsResponse, OrgBoardOrgListBoardMemberHistoryData, OrgBoardOrgListBoardMemberHistoryError, OrgBoardOrgListBoardMemberHistoryResponse, OrgBoardOrgListBoardMemberProposalsData, OrgBoardOrgListBoardMemberProposalsError, OrgBoardOrgListBoardMemberProposalsResponse, OrgBoardOrgListBoardMembersData, OrgBoardOrgListBoardMembersError, OrgBoardOrgListBoardMembersResponse, OrgBoardOrgListBoardMotionsData, OrgBoardOrgListBoardMotionsError, OrgBoardOrgListBoardMotionsResponse, OrgBoardOrgListBoardOfficerTitlesData, OrgBoardOrgListBoardOfficerTitlesError, OrgBoardOrgListBoardOfficerTitlesResponse, OrgBoardOrgListBoardPacketCommentsData, OrgBoardOrgListBoardPacketCommentsError, OrgBoardOrgListBoardPacketCommentsResponse, OrgBoardOrgListBoardPacketDistributionsData, OrgBoardOrgListBoardPacketDistributionsError, OrgBoardOrgListBoardPacketDistributionsResponse, OrgBoardOrgListBoardPacketsData, OrgBoardOrgListBoardPacketsError, OrgBoardOrgListBoardPacketsResponse, OrgBoardOrgListBoardPastRecordBatchesData, OrgBoardOrgListBoardPastRecordBatchesError, OrgBoardOrgListBoardPastRecordBatchesResponse, OrgBoardOrgListBoardRecordAcknowledgmentsData, OrgBoardOrgListBoardRecordAcknowledgmentsError, OrgBoardOrgListBoardRecordAcknowledgmentsResponse, OrgBoardOrgListBoardRecordEventsData, OrgBoardOrgListBoardRecordEventsError, OrgBoardOrgListBoardRecordEventsResponse, OrgBoardOrgListBoardRecordsData, OrgBoardOrgListBoardRecordsError, OrgBoardOrgListBoardRecordsResponse, OrgBoardOrgListBoardRetentionPoliciesData, OrgBoardOrgListBoardRetentionPoliciesError, OrgBoardOrgListBoardRetentionPoliciesResponse, OrgBoardOrgListBoardReturnDistributionsData, OrgBoardOrgListBoardReturnDistributionsError, OrgBoardOrgListBoardReturnDistributionsResponse, OrgBoardOrgListBoardReturnReviewCandidatesData, OrgBoardOrgListBoardReturnReviewCandidatesError, OrgBoardOrgListBoardReturnReviewCandidatesResponse, OrgBoardOrgListBoardSelfAssessmentInstrumentsData, OrgBoardOrgListBoardSelfAssessmentInstrumentsError, OrgBoardOrgListBoardSelfAssessmentInstrumentsResponse, OrgBoardOrgListBoardSelfAssessmentsData, OrgBoardOrgListBoardSelfAssessmentsError, OrgBoardOrgListBoardSelfAssessmentsResponse, OrgBoardOrgListBoardWrittenConsentsData, OrgBoardOrgListBoardWrittenConsentsError, OrgBoardOrgListBoardWrittenConsentsResponse, OrgBoardOrgMarkBoardMemberGettingStartedStepData, OrgBoardOrgMarkBoardMemberGettingStartedStepError, OrgBoardOrgMarkBoardMemberGettingStartedStepResponse, OrgBoardOrgMarkBoardPastRecordConfidentialityData, OrgBoardOrgMarkBoardPastRecordConfidentialityError, OrgBoardOrgMarkBoardPastRecordConfidentialityResponse, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInData, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInError, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInResponse, OrgBoardOrgMintBoardAccessLinkData, OrgBoardOrgMintBoardAccessLinkError, OrgBoardOrgMintBoardAccessLinkResponse, OrgBoardOrgMoveBoardCalendarMeetingsData, OrgBoardOrgMoveBoardCalendarMeetingsError, OrgBoardOrgMoveBoardCalendarMeetingsResponse, OrgBoardOrgMoveBoardMeetingInvitationsData, OrgBoardOrgMoveBoardMeetingInvitationsError, OrgBoardOrgMoveBoardMeetingInvitationsResponse, OrgBoardOrgOpenBoardCoiCycleData, OrgBoardOrgOpenBoardCoiCycleError, OrgBoardOrgOpenBoardCoiCycleResponse, OrgBoardOrgOpenBoardFilingReceiptData, OrgBoardOrgOpenBoardFilingReceiptError, OrgBoardOrgOpenBoardFilingReceiptResponse, OrgBoardOrgOpenBoardImportBatchData, OrgBoardOrgOpenBoardImportBatchError, OrgBoardOrgOpenBoardImportBatchResponse, OrgBoardOrgOpenBoardSelfAssessmentData, OrgBoardOrgOpenBoardSelfAssessmentError, OrgBoardOrgOpenBoardSelfAssessmentResponse, OrgBoardOrgPlaceBoardLegalHoldData, OrgBoardOrgPlaceBoardLegalHoldError, OrgBoardOrgPlaceBoardLegalHoldResponse, OrgBoardOrgPreviewBoardReturnRecipientsData, OrgBoardOrgPreviewBoardReturnRecipientsError, OrgBoardOrgPreviewBoardReturnRecipientsResponse, OrgBoardOrgProvideBoardReturnData, OrgBoardOrgProvideBoardReturnError, OrgBoardOrgProvideBoardReturnResponse, OrgBoardOrgPublishBoardPacketData, OrgBoardOrgPublishBoardPacketError, OrgBoardOrgPublishBoardPacketResponse, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfData, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfError, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfResponse, OrgBoardOrgRecordBoardCoiPaperResponseData, OrgBoardOrgRecordBoardCoiPaperResponseError, OrgBoardOrgRecordBoardCoiPaperResponseResponse, OrgBoardOrgRecordBoardCommitteeRuleData, OrgBoardOrgRecordBoardCommitteeRuleError, OrgBoardOrgRecordBoardCommitteeRuleResponse, OrgBoardOrgRecordBoardCompensationIndexEntryData, OrgBoardOrgRecordBoardCompensationIndexEntryError, OrgBoardOrgRecordBoardCompensationIndexEntryResponse, OrgBoardOrgRecordBoardConflictDisclosureData, OrgBoardOrgRecordBoardConflictDisclosureError, OrgBoardOrgRecordBoardConflictDisclosureResponse, OrgBoardOrgRecordBoardConflictLinkData, OrgBoardOrgRecordBoardConflictLinkError, OrgBoardOrgRecordBoardConflictLinkResponse, OrgBoardOrgRecordBoardConsentRevocationData, OrgBoardOrgRecordBoardConsentRevocationError, OrgBoardOrgRecordBoardConsentRevocationResponse, OrgBoardOrgRecordBoardConsentSignatureData, OrgBoardOrgRecordBoardConsentSignatureError, OrgBoardOrgRecordBoardConsentSignatureResponse, OrgBoardOrgRecordBoardDirectorsToldData, OrgBoardOrgRecordBoardDirectorsToldError, OrgBoardOrgRecordBoardDirectorsToldResponse, OrgBoardOrgRecordBoardGovernanceParameterData, OrgBoardOrgRecordBoardGovernanceParameterError, OrgBoardOrgRecordBoardGovernanceParameterResponse, OrgBoardOrgRecordBoardMeetingAttendanceData, OrgBoardOrgRecordBoardMeetingAttendanceError, OrgBoardOrgRecordBoardMeetingAttendanceResponse, OrgBoardOrgRecordBoardMeetingPresidingData, OrgBoardOrgRecordBoardMeetingPresidingError, OrgBoardOrgRecordBoardMeetingPresidingResponse, OrgBoardOrgRecordBoardMemberTermData, OrgBoardOrgRecordBoardMemberTermError, OrgBoardOrgRecordBoardMemberTermResponse, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfData, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfError, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfResponse, OrgBoardOrgRecordBoardMinutesApprovalVoteData, OrgBoardOrgRecordBoardMinutesApprovalVoteError, OrgBoardOrgRecordBoardMinutesApprovalVoteResponse, OrgBoardOrgRecordBoardMotionRecusalData, OrgBoardOrgRecordBoardMotionRecusalError, OrgBoardOrgRecordBoardMotionRecusalResponse, OrgBoardOrgRecordBoardMotionVoteData, OrgBoardOrgRecordBoardMotionVoteError, OrgBoardOrgRecordBoardMotionVoteResponse, OrgBoardOrgRecordBoardPacketSharedCommentData, OrgBoardOrgRecordBoardPacketSharedCommentError, OrgBoardOrgRecordBoardPacketSharedCommentResponse, OrgBoardOrgRecordBoardPaperAcknowledgmentsData, OrgBoardOrgRecordBoardPaperAcknowledgmentsError, OrgBoardOrgRecordBoardPaperAcknowledgmentsResponse, OrgBoardOrgRecordBoardReturnPrintedCopyData, OrgBoardOrgRecordBoardReturnPrintedCopyError, OrgBoardOrgRecordBoardReturnPrintedCopyResponse, OrgBoardOrgRecordBoardRosterResultData, OrgBoardOrgRecordBoardRosterResultError, OrgBoardOrgRecordBoardRosterResultResponse, OrgBoardOrgRecordBoardSegmentParticipantData, OrgBoardOrgRecordBoardSegmentParticipantError, OrgBoardOrgRecordBoardSegmentParticipantResponse, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetData, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetError, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetResponse, OrgBoardOrgRecordHistoricalBoardMemberData, OrgBoardOrgRecordHistoricalBoardMemberError, OrgBoardOrgRecordHistoricalBoardMemberResponse, OrgBoardOrgRefreshBoardFilingSnapshotData, OrgBoardOrgRefreshBoardFilingSnapshotError, OrgBoardOrgRefreshBoardFilingSnapshotResponse, OrgBoardOrgReinviteBoardMeetingInviteeData, OrgBoardOrgReinviteBoardMeetingInviteeError, OrgBoardOrgReinviteBoardMeetingInviteeResponse, OrgBoardOrgReleaseBoardLegalHoldData, OrgBoardOrgReleaseBoardLegalHoldError, OrgBoardOrgReleaseBoardLegalHoldResponse, OrgBoardOrgReleaseBoardMemberAccountData, OrgBoardOrgReleaseBoardMemberAccountError, OrgBoardOrgReleaseBoardMemberAccountResponse, OrgBoardOrgRemindBoardCoiCycleRecipientsData, OrgBoardOrgRemindBoardCoiCycleRecipientsError, OrgBoardOrgRemindBoardCoiCycleRecipientsResponse, OrgBoardOrgRemindBoardSelfAssessmentRecipientsData, OrgBoardOrgRemindBoardSelfAssessmentRecipientsError, OrgBoardOrgRemindBoardSelfAssessmentRecipientsResponse, OrgBoardOrgRemoveBoardCompensationDocumentData, OrgBoardOrgRemoveBoardCompensationDocumentError, OrgBoardOrgRemoveBoardCompensationDocumentResponse, OrgBoardOrgRemoveBoardCompensationIndexEntryData, OrgBoardOrgRemoveBoardCompensationIndexEntryError, OrgBoardOrgRemoveBoardCompensationIndexEntryResponse, OrgBoardOrgRemoveBoardConsentCompensationDecisionData, OrgBoardOrgRemoveBoardConsentCompensationDecisionError, OrgBoardOrgRemoveBoardConsentCompensationDecisionResponse, OrgBoardOrgRemoveBoardImportInboxFileData, OrgBoardOrgRemoveBoardImportInboxFileError, OrgBoardOrgRemoveBoardImportInboxFileResponse, OrgBoardOrgRemoveBoardMemberData, OrgBoardOrgRemoveBoardMemberError, OrgBoardOrgRemoveBoardMemberResponse, OrgBoardOrgRemoveBoardMemberTermData, OrgBoardOrgRemoveBoardMemberTermError, OrgBoardOrgRemoveBoardMemberTermResponse, OrgBoardOrgRemoveBoardMotionCompensationDecisionData, OrgBoardOrgRemoveBoardMotionCompensationDecisionError, OrgBoardOrgRemoveBoardMotionCompensationDecisionResponse, OrgBoardOrgRemoveBoardMotionRecusalData, OrgBoardOrgRemoveBoardMotionRecusalError, OrgBoardOrgRemoveBoardMotionRecusalResponse, OrgBoardOrgRemoveBoardSegmentParticipantData, OrgBoardOrgRemoveBoardSegmentParticipantError, OrgBoardOrgRemoveBoardSegmentParticipantResponse, OrgBoardOrgReorderBoardAgendaData, OrgBoardOrgReorderBoardAgendaError, OrgBoardOrgReorderBoardAgendaResponse, OrgBoardOrgReorderBoardMeetingSegmentsData, OrgBoardOrgReorderBoardMeetingSegmentsError, OrgBoardOrgReorderBoardMeetingSegmentsResponse, OrgBoardOrgReorderBoardPacketItemsData, OrgBoardOrgReorderBoardPacketItemsError, OrgBoardOrgReorderBoardPacketItemsResponse, OrgBoardOrgReplaceBoardConsentCompensationDecisionData, OrgBoardOrgReplaceBoardConsentCompensationDecisionError, OrgBoardOrgReplaceBoardConsentCompensationDecisionResponse, OrgBoardOrgReplaceBoardMotionCompensationDecisionData, OrgBoardOrgReplaceBoardMotionCompensationDecisionError, OrgBoardOrgReplaceBoardMotionCompensationDecisionResponse, OrgBoardOrgRestoreBoardCommitteeSuggestionData, OrgBoardOrgRestoreBoardCommitteeSuggestionError, OrgBoardOrgRestoreBoardCommitteeSuggestionResponse, OrgBoardOrgRestoreBoardTermSuggestionData, OrgBoardOrgRestoreBoardTermSuggestionError, OrgBoardOrgRestoreBoardTermSuggestionResponse, OrgBoardOrgRetireBoardDirectorClassData, OrgBoardOrgRetireBoardDirectorClassError, OrgBoardOrgRetireBoardDirectorClassResponse, OrgBoardOrgRetireBoardOfficerTitleData, OrgBoardOrgRetireBoardOfficerTitleError, OrgBoardOrgRetireBoardOfficerTitleResponse, OrgBoardOrgReviseBoardWrittenConsentData, OrgBoardOrgReviseBoardWrittenConsentError, OrgBoardOrgReviseBoardWrittenConsentResponse, OrgBoardOrgSaveBoardGettingStartedListData, OrgBoardOrgSaveBoardGettingStartedListError, OrgBoardOrgSaveBoardGettingStartedListResponse, OrgBoardOrgSaveBoardMemberGettingStartedData, OrgBoardOrgSaveBoardMemberGettingStartedError, OrgBoardOrgSaveBoardMemberGettingStartedResponse, OrgBoardOrgScheduleRestoredBoardMeetingData, OrgBoardOrgScheduleRestoredBoardMeetingError, OrgBoardOrgScheduleRestoredBoardMeetingResponse, OrgBoardOrgSendBoardCoiCycleRequestsData, OrgBoardOrgSendBoardCoiCycleRequestsError, OrgBoardOrgSendBoardCoiCycleRequestsResponse, OrgBoardOrgSendBoardMeetingInvitationsData, OrgBoardOrgSendBoardMeetingInvitationsError, OrgBoardOrgSendBoardMeetingInvitationsResponse, OrgBoardOrgSendBoardMinutesReminderData, OrgBoardOrgSendBoardMinutesReminderError, OrgBoardOrgSendBoardMinutesReminderResponse, OrgBoardOrgSendBoardSelfAssessmentRequestsData, OrgBoardOrgSendBoardSelfAssessmentRequestsError, OrgBoardOrgSendBoardSelfAssessmentRequestsResponse, OrgBoardOrgSetBoardCommitteeConfirmationData, OrgBoardOrgSetBoardCommitteeConfirmationError, OrgBoardOrgSetBoardCommitteeConfirmationResponse, OrgBoardOrgSignBoardMinutesOnBehalfData, OrgBoardOrgSignBoardMinutesOnBehalfError, OrgBoardOrgSignBoardMinutesOnBehalfResponse, OrgBoardOrgStartBoardMemberGettingStartedData, OrgBoardOrgStartBoardMemberGettingStartedError, OrgBoardOrgStartBoardMemberGettingStartedResponse, OrgBoardOrgSubmitBoardRecordData, OrgBoardOrgSubmitBoardRecordError, OrgBoardOrgSubmitBoardRecordResponse, OrgBoardOrgUnlinkBoardReturnReviewData, OrgBoardOrgUnlinkBoardReturnReviewError, OrgBoardOrgUnlinkBoardReturnReviewResponse, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInData, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInError, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInResponse, OrgBoardOrgUpdateBoardAgendaItemData, OrgBoardOrgUpdateBoardAgendaItemError, OrgBoardOrgUpdateBoardAgendaItemResponse, OrgBoardOrgUpdateBoardCoiCycleData, OrgBoardOrgUpdateBoardCoiCycleError, OrgBoardOrgUpdateBoardCoiCycleResponse, OrgBoardOrgUpdateBoardCommitteeData, OrgBoardOrgUpdateBoardCommitteeError, OrgBoardOrgUpdateBoardCommitteeMemberData, OrgBoardOrgUpdateBoardCommitteeMemberError, OrgBoardOrgUpdateBoardCommitteeMemberResponse, OrgBoardOrgUpdateBoardCommitteeResponse, OrgBoardOrgUpdateBoardCompensationDecisionData, OrgBoardOrgUpdateBoardCompensationDecisionError, OrgBoardOrgUpdateBoardCompensationDecisionResponse, OrgBoardOrgUpdateBoardDirectorClassData, OrgBoardOrgUpdateBoardDirectorClassError, OrgBoardOrgUpdateBoardDirectorClassResponse, OrgBoardOrgUpdateBoardImportBatchData, OrgBoardOrgUpdateBoardImportBatchError, OrgBoardOrgUpdateBoardImportBatchResponse, OrgBoardOrgUpdateBoardMeetingData, OrgBoardOrgUpdateBoardMeetingError, OrgBoardOrgUpdateBoardMeetingResponse, OrgBoardOrgUpdateBoardMeetingSegmentData, OrgBoardOrgUpdateBoardMeetingSegmentError, OrgBoardOrgUpdateBoardMeetingSegmentResponse, OrgBoardOrgUpdateBoardMemberData, OrgBoardOrgUpdateBoardMemberError, OrgBoardOrgUpdateBoardMemberResponse, OrgBoardOrgUpdateBoardMemberTermData, OrgBoardOrgUpdateBoardMemberTermError, OrgBoardOrgUpdateBoardMemberTermResponse, OrgBoardOrgUpdateBoardMotionData, OrgBoardOrgUpdateBoardMotionError, OrgBoardOrgUpdateBoardMotionResponse, OrgBoardOrgUpdateBoardOfficerTitleData, OrgBoardOrgUpdateBoardOfficerTitleError, OrgBoardOrgUpdateBoardOfficerTitleResponse, OrgBoardOrgUpdateBoardRecordDraftData, OrgBoardOrgUpdateBoardRecordDraftError, OrgBoardOrgUpdateBoardRecordDraftResponse, OrgBoardOrgUpdateBoardWrittenConsentData, OrgBoardOrgUpdateBoardWrittenConsentError, OrgBoardOrgUpdateBoardWrittenConsentResponse, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesData, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesError, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesResponse, OrgBoardOrgWithdrawBoardMotionData, OrgBoardOrgWithdrawBoardMotionError, OrgBoardOrgWithdrawBoardMotionResponse, OrgBoardOrgWithdrawBoardReturnData, OrgBoardOrgWithdrawBoardReturnError, OrgBoardOrgWithdrawBoardReturnResponse, OrgBoardOrgWithdrawBoardWrittenConsentData, OrgBoardOrgWithdrawBoardWrittenConsentError, OrgBoardOrgWithdrawBoardWrittenConsentResponse, OrgBoardOrgWriteBoardMinutesDraftData, OrgBoardOrgWriteBoardMinutesDraftError, OrgBoardOrgWriteBoardMinutesDraftResponse, OrgComplianceOrgAddComplianceEarlierRenewalCycleData, OrgComplianceOrgAddComplianceEarlierRenewalCycleError, OrgComplianceOrgAddComplianceEarlierRenewalCycleResponse, OrgComplianceOrgAddComplianceObligationAttachmentData, OrgComplianceOrgAddComplianceObligationAttachmentError, OrgComplianceOrgAddComplianceObligationAttachmentResponse, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentData, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentError, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentResponse, OrgComplianceOrgAddComplianceOrganizationFilingCycleData, OrgComplianceOrgAddComplianceOrganizationFilingCycleError, OrgComplianceOrgAddComplianceOrganizationFilingCycleResponse, OrgComplianceOrgAddComplianceOrganizationFilingData, OrgComplianceOrgAddComplianceOrganizationFilingError, OrgComplianceOrgAddComplianceOrganizationFilingResponse, OrgComplianceOrgAddComplianceRenewalAttachmentData, OrgComplianceOrgAddComplianceRenewalAttachmentError, OrgComplianceOrgAddComplianceRenewalAttachmentResponse, OrgComplianceOrgAmendComplianceRegistrationImportData, OrgComplianceOrgAmendComplianceRegistrationImportError, OrgComplianceOrgAmendComplianceRegistrationImportResponse, OrgComplianceOrgAnswerComplianceFormItemData, OrgComplianceOrgAnswerComplianceFormItemError, OrgComplianceOrgAnswerComplianceFormItemResponse, OrgComplianceOrgAnswerComplianceSubmissionEvidenceData, OrgComplianceOrgAnswerComplianceSubmissionEvidenceError, OrgComplianceOrgAnswerComplianceSubmissionEvidenceResponse, OrgComplianceOrgAskAboutComplianceReviewItemData, OrgComplianceOrgAskAboutComplianceReviewItemError, OrgComplianceOrgAskAboutComplianceReviewItemResponse, OrgComplianceOrgAssembleCompliancePacketData, OrgComplianceOrgAssembleCompliancePacketError, OrgComplianceOrgAssembleCompliancePacketResponse, OrgComplianceOrgAttachComplianceChecklistDocumentData, OrgComplianceOrgAttachComplianceChecklistDocumentError, OrgComplianceOrgAttachComplianceChecklistDocumentResponse, OrgComplianceOrgAttachComplianceFilingCaseDocumentData, OrgComplianceOrgAttachComplianceFilingCaseDocumentError, OrgComplianceOrgAttachComplianceFilingCaseDocumentResponse, OrgComplianceOrgAttachComplianceObligationFiledCopyData, OrgComplianceOrgAttachComplianceObligationFiledCopyError, OrgComplianceOrgAttachComplianceObligationFiledCopyResponse, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyData, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyError, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyResponse, OrgComplianceOrgAttachComplianceRenewalFiledCopyData, OrgComplianceOrgAttachComplianceRenewalFiledCopyError, OrgComplianceOrgAttachComplianceRenewalFiledCopyResponse, OrgComplianceOrgAuthorizeComplianceSubmissionData, OrgComplianceOrgAuthorizeComplianceSubmissionError, OrgComplianceOrgAuthorizeComplianceSubmissionResponse, OrgComplianceOrgCancelComplianceSigningRequestData, OrgComplianceOrgCancelComplianceSigningRequestError, OrgComplianceOrgCancelComplianceSigningRequestResponse, OrgComplianceOrgConfirmComplianceArtifactData, OrgComplianceOrgConfirmComplianceArtifactError, OrgComplianceOrgConfirmComplianceArtifactResponse, OrgComplianceOrgConfirmComplianceCandidateData, OrgComplianceOrgConfirmComplianceCandidateError, OrgComplianceOrgConfirmComplianceCandidateResponse, OrgComplianceOrgCreateComplianceFilingDocumentData, OrgComplianceOrgCreateComplianceFilingDocumentError, OrgComplianceOrgCreateComplianceFilingDocumentResponse, OrgComplianceOrgCreateComplianceFilingGroupData, OrgComplianceOrgCreateComplianceFilingGroupError, OrgComplianceOrgCreateComplianceFilingGroupResponse, OrgComplianceOrgDeclineComplianceSigningRequestData, OrgComplianceOrgDeclineComplianceSigningRequestError, OrgComplianceOrgDeclineComplianceSigningRequestResponse, OrgComplianceOrgDeleteComplianceArtifactData, OrgComplianceOrgDeleteComplianceArtifactError, OrgComplianceOrgDeleteComplianceArtifactResponse, OrgComplianceOrgDismissComplianceCandidateData, OrgComplianceOrgDismissComplianceCandidateError, OrgComplianceOrgDismissComplianceCandidateResponse, OrgComplianceOrgDispatchComplianceSubmissionData, OrgComplianceOrgDispatchComplianceSubmissionError, OrgComplianceOrgDispatchComplianceSubmissionResponse, OrgComplianceOrgExtendComplianceSigningRequestData, OrgComplianceOrgExtendComplianceSigningRequestError, OrgComplianceOrgExtendComplianceSigningRequestResponse, OrgComplianceOrgGenerateComplianceProposalRevisionData, OrgComplianceOrgGenerateComplianceProposalRevisionError, OrgComplianceOrgGenerateComplianceProposalRevisionResponse, OrgComplianceOrgGetComplianceAiSettingData, OrgComplianceOrgGetComplianceAiSettingError, OrgComplianceOrgGetComplianceAiSettingResponse, OrgComplianceOrgGetComplianceArtifactDownloadData, OrgComplianceOrgGetComplianceArtifactDownloadError, OrgComplianceOrgGetComplianceArtifactDownloadResponse, OrgComplianceOrgGetComplianceDeskAuthorizationData, OrgComplianceOrgGetComplianceDeskAuthorizationError, OrgComplianceOrgGetComplianceDeskAuthorizationResponse, OrgComplianceOrgGetComplianceFilingCaseChecklistData, OrgComplianceOrgGetComplianceFilingCaseChecklistError, OrgComplianceOrgGetComplianceFilingCaseChecklistResponse, OrgComplianceOrgGetComplianceFilingCaseData, OrgComplianceOrgGetComplianceFilingCaseError, OrgComplianceOrgGetComplianceFilingCaseResponse, OrgComplianceOrgGetComplianceFilingDocumentData, OrgComplianceOrgGetComplianceFilingDocumentError, OrgComplianceOrgGetComplianceFilingDocumentResponse, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesData, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesError, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesResponse, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadData, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadError, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadResponse, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionData, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionError, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionResponse, OrgComplianceOrgGetComplianceFormPagePreviewData, OrgComplianceOrgGetComplianceFormPagePreviewError, OrgComplianceOrgGetComplianceFormPagePreviewResponse, OrgComplianceOrgGetComplianceFormPreparationData, OrgComplianceOrgGetComplianceFormPreparationError, OrgComplianceOrgGetComplianceFormPreparationResponse, OrgComplianceOrgGetComplianceObligationData, OrgComplianceOrgGetComplianceObligationError, OrgComplianceOrgGetComplianceObligationResponse, OrgComplianceOrgGetComplianceObligationRuleChangeData, OrgComplianceOrgGetComplianceObligationRuleChangeError, OrgComplianceOrgGetComplianceObligationRuleChangeResponse, OrgComplianceOrgGetComplianceOrganizationFilingData, OrgComplianceOrgGetComplianceOrganizationFilingError, OrgComplianceOrgGetComplianceOrganizationFilingResponse, OrgComplianceOrgGetCompliancePacketChecklistData, OrgComplianceOrgGetCompliancePacketChecklistError, OrgComplianceOrgGetCompliancePacketChecklistResponse, OrgComplianceOrgGetCompliancePacketData, OrgComplianceOrgGetCompliancePacketError, OrgComplianceOrgGetCompliancePacketRenderData, OrgComplianceOrgGetCompliancePacketRenderError, OrgComplianceOrgGetCompliancePacketRenderResponse, OrgComplianceOrgGetCompliancePacketResponse, OrgComplianceOrgGetComplianceProfileData, OrgComplianceOrgGetComplianceProfileError, OrgComplianceOrgGetComplianceProfileResponse, OrgComplianceOrgGetComplianceProposalData, OrgComplianceOrgGetComplianceProposalError, OrgComplianceOrgGetComplianceProposalResponse, OrgComplianceOrgGetComplianceProposalReviewData, OrgComplianceOrgGetComplianceProposalReviewError, OrgComplianceOrgGetComplianceProposalReviewResponse, OrgComplianceOrgGetComplianceProposalRevisionData, OrgComplianceOrgGetComplianceProposalRevisionError, OrgComplianceOrgGetComplianceProposalRevisionResponse, OrgComplianceOrgGetComplianceRenewalCycleData, OrgComplianceOrgGetComplianceRenewalCycleError, OrgComplianceOrgGetComplianceRenewalCycleResponse, OrgComplianceOrgGetComplianceSigningEvidenceData, OrgComplianceOrgGetComplianceSigningEvidenceError, OrgComplianceOrgGetComplianceSigningEvidenceResponse, OrgComplianceOrgGetComplianceSigningExportData, OrgComplianceOrgGetComplianceSigningExportError, OrgComplianceOrgGetComplianceSigningExportResponse, OrgComplianceOrgGetComplianceSigningRecordLinesData, OrgComplianceOrgGetComplianceSigningRecordLinesError, OrgComplianceOrgGetComplianceSigningRecordLinesResponse, OrgComplianceOrgGetComplianceSigningRequestData, OrgComplianceOrgGetComplianceSigningRequestError, OrgComplianceOrgGetComplianceSigningRequestResponse, OrgComplianceOrgGetComplianceSigningSettingData, OrgComplianceOrgGetComplianceSigningSettingError, OrgComplianceOrgGetComplianceSigningSettingResponse, OrgComplianceOrgGetComplianceSubmissionData, OrgComplianceOrgGetComplianceSubmissionError, OrgComplianceOrgGetComplianceSubmissionPackageData, OrgComplianceOrgGetComplianceSubmissionPackageError, OrgComplianceOrgGetComplianceSubmissionPackageResponse, OrgComplianceOrgGetComplianceSubmissionResponse, OrgComplianceOrgGetComplianceVendorData, OrgComplianceOrgGetComplianceVendorError, OrgComplianceOrgGetComplianceVendorResponse, OrgComplianceOrgHandComplianceFilingToDeskData, OrgComplianceOrgHandComplianceFilingToDeskError, OrgComplianceOrgHandComplianceFilingToDeskResponse, OrgComplianceOrgImportComplianceRegistrationData, OrgComplianceOrgImportComplianceRegistrationError, OrgComplianceOrgImportComplianceRegistrationResponse, OrgComplianceOrgIssueComplianceArtifactUploadUrlData, OrgComplianceOrgIssueComplianceArtifactUploadUrlError, OrgComplianceOrgIssueComplianceArtifactUploadUrlResponse, OrgComplianceOrgIssueComplianceSigningRequestData, OrgComplianceOrgIssueComplianceSigningRequestError, OrgComplianceOrgIssueComplianceSigningRequestResponse, OrgComplianceOrgLinkComplianceVendorFilingData, OrgComplianceOrgLinkComplianceVendorFilingError, OrgComplianceOrgLinkComplianceVendorFilingResponse, OrgComplianceOrgListComplianceArtifactsData, OrgComplianceOrgListComplianceArtifactsError, OrgComplianceOrgListComplianceArtifactsResponse, OrgComplianceOrgListComplianceCandidatesData, OrgComplianceOrgListComplianceCandidatesError, OrgComplianceOrgListComplianceCandidatesResponse, OrgComplianceOrgListComplianceFilingCasesData, OrgComplianceOrgListComplianceFilingCasesError, OrgComplianceOrgListComplianceFilingCasesResponse, OrgComplianceOrgListComplianceFilingDocumentsData, OrgComplianceOrgListComplianceFilingDocumentsError, OrgComplianceOrgListComplianceFilingDocumentsResponse, OrgComplianceOrgListComplianceFilingGroupsData, OrgComplianceOrgListComplianceFilingGroupsError, OrgComplianceOrgListComplianceFilingGroupsResponse, OrgComplianceOrgListComplianceFilingOptionsData, OrgComplianceOrgListComplianceFilingOptionsError, OrgComplianceOrgListComplianceFilingOptionsResponse, OrgComplianceOrgListComplianceFormAdaptersData, OrgComplianceOrgListComplianceFormAdaptersError, OrgComplianceOrgListComplianceFormAdaptersResponse, OrgComplianceOrgListComplianceFormPreparationsData, OrgComplianceOrgListComplianceFormPreparationsError, OrgComplianceOrgListComplianceFormPreparationsResponse, OrgComplianceOrgListComplianceObligationArtifactsData, OrgComplianceOrgListComplianceObligationArtifactsError, OrgComplianceOrgListComplianceObligationArtifactsResponse, OrgComplianceOrgListComplianceObligationsData, OrgComplianceOrgListComplianceObligationsError, OrgComplianceOrgListComplianceObligationsResponse, OrgComplianceOrgListComplianceOccurrencesData, OrgComplianceOrgListComplianceOccurrencesError, OrgComplianceOrgListComplianceOccurrencesResponse, OrgComplianceOrgListComplianceOrganizationFilingsData, OrgComplianceOrgListComplianceOrganizationFilingsError, OrgComplianceOrgListComplianceOrganizationFilingsResponse, OrgComplianceOrgListCompliancePacketsData, OrgComplianceOrgListCompliancePacketsError, OrgComplianceOrgListCompliancePacketsResponse, OrgComplianceOrgListComplianceProfileParametersData, OrgComplianceOrgListComplianceProfileParametersError, OrgComplianceOrgListComplianceProfileParametersResponse, OrgComplianceOrgListComplianceProfileReviewFlagsData, OrgComplianceOrgListComplianceProfileReviewFlagsError, OrgComplianceOrgListComplianceProfileReviewFlagsResponse, OrgComplianceOrgListComplianceProfileSuggestionsData, OrgComplianceOrgListComplianceProfileSuggestionsError, OrgComplianceOrgListComplianceProfileSuggestionsResponse, OrgComplianceOrgListComplianceProposalItemsData, OrgComplianceOrgListComplianceProposalItemsError, OrgComplianceOrgListComplianceProposalItemsResponse, OrgComplianceOrgListComplianceProposalResultsData, OrgComplianceOrgListComplianceProposalResultsError, OrgComplianceOrgListComplianceProposalResultsResponse, OrgComplianceOrgListComplianceRegistrationImportAmendmentsData, OrgComplianceOrgListComplianceRegistrationImportAmendmentsError, OrgComplianceOrgListComplianceRegistrationImportAmendmentsResponse, OrgComplianceOrgListComplianceRegistrationImportsData, OrgComplianceOrgListComplianceRegistrationImportsError, OrgComplianceOrgListComplianceRegistrationImportsResponse, OrgComplianceOrgListComplianceRenewalCyclesData, OrgComplianceOrgListComplianceRenewalCyclesError, OrgComplianceOrgListComplianceRenewalCyclesResponse, OrgComplianceOrgListComplianceReviewAsksData, OrgComplianceOrgListComplianceReviewAsksError, OrgComplianceOrgListComplianceReviewAsksResponse, OrgComplianceOrgListComplianceSigningPeopleData, OrgComplianceOrgListComplianceSigningPeopleError, OrgComplianceOrgListComplianceSigningPeopleResponse, OrgComplianceOrgListComplianceSigningRequestsData, OrgComplianceOrgListComplianceSigningRequestsError, OrgComplianceOrgListComplianceSigningRequestsResponse, OrgComplianceOrgListComplianceSubmissionFollowThroughData, OrgComplianceOrgListComplianceSubmissionFollowThroughError, OrgComplianceOrgListComplianceSubmissionFollowThroughResponse, OrgComplianceOrgListComplianceVendorsData, OrgComplianceOrgListComplianceVendorsError, OrgComplianceOrgListComplianceVendorsResponse, OrgComplianceOrgMintComplianceFormVersionData, OrgComplianceOrgMintComplianceFormVersionError, OrgComplianceOrgMintComplianceFormVersionResponse, OrgComplianceOrgMoveComplianceFilingGroupData, OrgComplianceOrgMoveComplianceFilingGroupError, OrgComplianceOrgMoveComplianceFilingGroupResponse, OrgComplianceOrgMoveComplianceFilingToGroupData, OrgComplianceOrgMoveComplianceFilingToGroupError, OrgComplianceOrgMoveComplianceFilingToGroupResponse, OrgComplianceOrgOpenComplianceFilingCaseData, OrgComplianceOrgOpenComplianceFilingCaseError, OrgComplianceOrgOpenComplianceFilingCaseResponse, OrgComplianceOrgReconcileComplianceSubmissionAttemptData, OrgComplianceOrgReconcileComplianceSubmissionAttemptError, OrgComplianceOrgReconcileComplianceSubmissionAttemptResponse, OrgComplianceOrgRecordComplianceChecklistActData, OrgComplianceOrgRecordComplianceChecklistActError, OrgComplianceOrgRecordComplianceChecklistActResponse, OrgComplianceOrgRecordComplianceExecutedCopyData, OrgComplianceOrgRecordComplianceExecutedCopyError, OrgComplianceOrgRecordComplianceExecutedCopyResponse, OrgComplianceOrgRecordComplianceFilingData, OrgComplianceOrgRecordComplianceFilingError, OrgComplianceOrgRecordComplianceFilingResponse, OrgComplianceOrgRecordComplianceOrganizationFilingFiledData, OrgComplianceOrgRecordComplianceOrganizationFilingFiledError, OrgComplianceOrgRecordComplianceOrganizationFilingFiledResponse, OrgComplianceOrgRecordComplianceOrganizationFilingSentData, OrgComplianceOrgRecordComplianceOrganizationFilingSentError, OrgComplianceOrgRecordComplianceOrganizationFilingSentResponse, OrgComplianceOrgRecordComplianceProfileParameterData, OrgComplianceOrgRecordComplianceProfileParameterError, OrgComplianceOrgRecordComplianceProfileParameterResponse, OrgComplianceOrgRecordComplianceProposalReviewData, OrgComplianceOrgRecordComplianceProposalReviewError, OrgComplianceOrgRecordComplianceProposalReviewResponse, OrgComplianceOrgRecordComplianceRegistrationDateData, OrgComplianceOrgRecordComplianceRegistrationDateError, OrgComplianceOrgRecordComplianceRegistrationDateResponse, OrgComplianceOrgRecordComplianceRenewalFilingData, OrgComplianceOrgRecordComplianceRenewalFilingError, OrgComplianceOrgRecordComplianceRenewalFilingResponse, OrgComplianceOrgRecordComplianceRenewalSubmissionData, OrgComplianceOrgRecordComplianceRenewalSubmissionError, OrgComplianceOrgRecordComplianceRenewalSubmissionResponse, OrgComplianceOrgRecordComplianceSubmissionData, OrgComplianceOrgRecordComplianceSubmissionError, OrgComplianceOrgRecordComplianceSubmissionEvidenceData, OrgComplianceOrgRecordComplianceSubmissionEvidenceError, OrgComplianceOrgRecordComplianceSubmissionEvidenceResponse, OrgComplianceOrgRecordComplianceSubmissionHandoffData, OrgComplianceOrgRecordComplianceSubmissionHandoffError, OrgComplianceOrgRecordComplianceSubmissionHandoffResponse, OrgComplianceOrgRecordComplianceSubmissionResponse, OrgComplianceOrgRecordComplianceVendorData, OrgComplianceOrgRecordComplianceVendorError, OrgComplianceOrgRecordComplianceVendorResponse, OrgComplianceOrgRecordComplianceWindowClosedData, OrgComplianceOrgRecordComplianceWindowClosedError, OrgComplianceOrgRecordComplianceWindowClosedResponse, OrgComplianceOrgRegisterComplianceFilingDocumentVersionData, OrgComplianceOrgRegisterComplianceFilingDocumentVersionError, OrgComplianceOrgRegisterComplianceFilingDocumentVersionResponse, OrgComplianceOrgRemoveComplianceFilingGroupData, OrgComplianceOrgRemoveComplianceFilingGroupError, OrgComplianceOrgRemoveComplianceFilingGroupResponse, OrgComplianceOrgRemoveComplianceSigningIdentityData, OrgComplianceOrgRemoveComplianceSigningIdentityError, OrgComplianceOrgRemoveComplianceSigningIdentityResponse, OrgComplianceOrgRenameComplianceFilingGroupData, OrgComplianceOrgRenameComplianceFilingGroupError, OrgComplianceOrgRenameComplianceFilingGroupResponse, OrgComplianceOrgRepinComplianceObligationData, OrgComplianceOrgRepinComplianceObligationError, OrgComplianceOrgRepinComplianceObligationResponse, OrgComplianceOrgResolveComplianceProfileReviewFlagData, OrgComplianceOrgResolveComplianceProfileReviewFlagError, OrgComplianceOrgResolveComplianceProfileReviewFlagResponse, OrgComplianceOrgResolveComplianceProfileSuggestionData, OrgComplianceOrgResolveComplianceProfileSuggestionError, OrgComplianceOrgResolveComplianceProfileSuggestionResponse, OrgComplianceOrgResumeComplianceDeskData, OrgComplianceOrgResumeComplianceDeskError, OrgComplianceOrgResumeComplianceDeskResponse, OrgComplianceOrgResumeTrackingComplianceObligationData, OrgComplianceOrgResumeTrackingComplianceObligationError, OrgComplianceOrgResumeTrackingComplianceObligationResponse, OrgComplianceOrgRetireComplianceOrganizationFilingData, OrgComplianceOrgRetireComplianceOrganizationFilingError, OrgComplianceOrgRetireComplianceOrganizationFilingResponse, OrgComplianceOrgReviseComplianceSigningRequestData, OrgComplianceOrgReviseComplianceSigningRequestError, OrgComplianceOrgReviseComplianceSigningRequestResponse, OrgComplianceOrgRevokeComplianceDeskAuthorizationData, OrgComplianceOrgRevokeComplianceDeskAuthorizationError, OrgComplianceOrgRevokeComplianceDeskAuthorizationResponse, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationData, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationError, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationResponse, OrgComplianceOrgRunComplianceDerivationData, OrgComplianceOrgRunComplianceDerivationError, OrgComplianceOrgRunComplianceDerivationResponse, OrgComplianceOrgSetComplianceAiSettingData, OrgComplianceOrgSetComplianceAiSettingError, OrgComplianceOrgSetComplianceAiSettingResponse, OrgComplianceOrgSetComplianceSigningSettingData, OrgComplianceOrgSetComplianceSigningSettingError, OrgComplianceOrgSetComplianceSigningSettingResponse, OrgComplianceOrgSignComplianceSigningRequestData, OrgComplianceOrgSignComplianceSigningRequestError, OrgComplianceOrgSignComplianceSigningRequestResponse, OrgComplianceOrgStartComplianceFormPreparationData, OrgComplianceOrgStartComplianceFormPreparationError, OrgComplianceOrgStartComplianceFormPreparationResponse, OrgComplianceOrgStopTrackingComplianceObligationData, OrgComplianceOrgStopTrackingComplianceObligationError, OrgComplianceOrgStopTrackingComplianceObligationResponse, OrgComplianceOrgSwitchComplianceOrganizationFilingData, OrgComplianceOrgSwitchComplianceOrganizationFilingError, OrgComplianceOrgSwitchComplianceOrganizationFilingResponse, OrgComplianceOrgTakeComplianceFilingFromDeskData, OrgComplianceOrgTakeComplianceFilingFromDeskError, OrgComplianceOrgTakeComplianceFilingFromDeskResponse, OrgComplianceOrgUnlinkComplianceVendorFilingData, OrgComplianceOrgUnlinkComplianceVendorFilingError, OrgComplianceOrgUnlinkComplianceVendorFilingResponse, OrgComplianceOrgUpdateComplianceOrganizationFilingData, OrgComplianceOrgUpdateComplianceOrganizationFilingError, OrgComplianceOrgUpdateComplianceOrganizationFilingResponse, OrgComplianceOrgWithdrawComplianceFilingCaseData, OrgComplianceOrgWithdrawComplianceFilingCaseError, OrgComplianceOrgWithdrawComplianceFilingCaseResponse, OrgComplianceOrgWithdrawComplianceReviewAskData, OrgComplianceOrgWithdrawComplianceReviewAskError, OrgComplianceOrgWithdrawComplianceReviewAskResponse, OrgComplianceOrgWithdrawComplianceSignatureData, OrgComplianceOrgWithdrawComplianceSignatureError, OrgComplianceOrgWithdrawComplianceSignatureResponse, OrgConfirmationRequestsConfirmOrgConfirmationRequestData, OrgConfirmationRequestsConfirmOrgConfirmationRequestError, OrgConfirmationRequestsConfirmOrgConfirmationRequestResponse, OrgConfirmationRequestsDeclineOrgConfirmationRequestData, OrgConfirmationRequestsDeclineOrgConfirmationRequestError, OrgConfirmationRequestsDeclineOrgConfirmationRequestResponse, OrgConfirmationRequestsGetOrgConfirmationRequestData, OrgConfirmationRequestsGetOrgConfirmationRequestError, OrgConfirmationRequestsGetOrgConfirmationRequestResponse, OrgConfirmationRequestsGetOrgMoneyFloorsData, OrgConfirmationRequestsGetOrgMoneyFloorsError, OrgConfirmationRequestsGetOrgMoneyFloorsResponse, OrgConfirmationRequestsListOrgConfirmationRequestsData, OrgConfirmationRequestsListOrgConfirmationRequestsError, OrgConfirmationRequestsListOrgConfirmationRequestsResponse, OrgConfirmationRequestsSaveOrgMoneyFloorData, OrgConfirmationRequestsSaveOrgMoneyFloorError, OrgConfirmationRequestsSaveOrgMoneyFloorResponse, OrgConsoleAcceptOrgAssistantConsentData, OrgConsoleAcceptOrgAssistantConsentError, OrgConsoleAcceptOrgAssistantConsentResponse, OrgConsoleAcceptOrgInviteData, OrgConsoleAcceptOrgInviteError, OrgConsoleAcceptOrgInviteResponse, OrgConsoleAcceptOrgModuleTermsData, OrgConsoleAcceptOrgModuleTermsError, OrgConsoleAcceptOrgModuleTermsResponse, OrgConsoleApproveOrgAccessRequestData, OrgConsoleApproveOrgAccessRequestError, OrgConsoleApproveOrgAccessRequestResponse, OrgConsoleCreateOrgAccessRequestData, OrgConsoleCreateOrgAccessRequestError, OrgConsoleCreateOrgAccessRequestResponse, OrgConsoleCreateOrgInviteData, OrgConsoleCreateOrgInviteError, OrgConsoleCreateOrgInviteResponse, OrgConsoleDeactivateOrgData, OrgConsoleDeactivateOrgError, OrgConsoleDeactivateOrgResponse, OrgConsoleDenyOrgAccessRequestData, OrgConsoleDenyOrgAccessRequestError, OrgConsoleDenyOrgAccessRequestResponse, OrgConsoleGetOrgAccessCatalogData, OrgConsoleGetOrgAccessCatalogError, OrgConsoleGetOrgAccessCatalogResponse, OrgConsoleGetOrgAccessSettingsData, OrgConsoleGetOrgAccessSettingsError, OrgConsoleGetOrgAccessSettingsResponse, OrgConsoleGetOrgAdminPreferencesData, OrgConsoleGetOrgAdminPreferencesError, OrgConsoleGetOrgAdminPreferencesResponse, OrgConsoleGetOrgAssistantConsentData, OrgConsoleGetOrgAssistantConsentError, OrgConsoleGetOrgAssistantConsentResponse, OrgConsoleGetOrgMeasurementConfigData, OrgConsoleGetOrgMeasurementConfigError, OrgConsoleGetOrgMeasurementConfigResponse, OrgConsoleGetOrgModuleTermsData, OrgConsoleGetOrgModuleTermsError, OrgConsoleGetOrgModuleTermsResponse, OrgConsoleGetOrgSelfAccessData, OrgConsoleGetOrgSelfAccessError, OrgConsoleGetOrgSelfAccessResponse, OrgConsoleListOrgAccessEventsData, OrgConsoleListOrgAccessEventsError, OrgConsoleListOrgAccessEventsResponse, OrgConsoleListOrgAccessRequestsData, OrgConsoleListOrgAccessRequestsError, OrgConsoleListOrgAccessRequestsResponse, OrgConsoleListOrgConnectedAiData, OrgConsoleListOrgConnectedAiError, OrgConsoleListOrgConnectedAiResponse, OrgConsoleListOrgConsoleMembersData, OrgConsoleListOrgConsoleMembersError, OrgConsoleListOrgConsoleMembersResponse, OrgConsoleListOrgInvitesData, OrgConsoleListOrgInvitesError, OrgConsoleListOrgInvitesResponse, OrgConsoleRemoveOrgMemberData, OrgConsoleRemoveOrgMemberError, OrgConsoleRemoveOrgMemberModuleAccessData, OrgConsoleRemoveOrgMemberModuleAccessError, OrgConsoleRemoveOrgMemberModuleAccessResponse, OrgConsoleRemoveOrgMemberResponse, OrgConsoleRevokeOrgAssistantConsentData, OrgConsoleRevokeOrgAssistantConsentError, OrgConsoleRevokeOrgAssistantConsentResponse, OrgConsoleRevokeOrgConnectedAiData, OrgConsoleRevokeOrgConnectedAiError, OrgConsoleRevokeOrgConnectedAiResponse, OrgConsoleRevokeOrgInviteData, OrgConsoleRevokeOrgInviteError, OrgConsoleRevokeOrgInviteResponse, OrgConsoleUpdateOrgAccessSettingsData, OrgConsoleUpdateOrgAccessSettingsError, OrgConsoleUpdateOrgAccessSettingsResponse, OrgConsoleUpdateOrgAdminPreferencesData, OrgConsoleUpdateOrgAdminPreferencesError, OrgConsoleUpdateOrgAdminPreferencesResponse, OrgConsoleUpdateOrgMeasurementConfigData, OrgConsoleUpdateOrgMeasurementConfigError, OrgConsoleUpdateOrgMeasurementConfigResponse, OrgConsoleUpdateOrgMemberAccessData, OrgConsoleUpdateOrgMemberAccessError, OrgConsoleUpdateOrgMemberAccessResponse, OrgFundraisersCloseOrgFundraiserData, OrgFundraisersCloseOrgFundraiserError, OrgFundraisersCloseOrgFundraiserResponse, OrgFundraisersCreateOrgFundraiserData, OrgFundraisersCreateOrgFundraiserError, OrgFundraisersCreateOrgFundraiserResponse, OrgFundraisersDeactivateOrgFundraiserData, OrgFundraisersDeactivateOrgFundraiserError, OrgFundraisersDeactivateOrgFundraiserResponse, OrgFundraisersDeleteOrgFundraiserData, OrgFundraisersDeleteOrgFundraiserError, OrgFundraisersDeleteOrgFundraiserResponse, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsData, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsError, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsResponse, OrgFundraisersGetOrgFundraiserData, OrgFundraisersGetOrgFundraiserError, OrgFundraisersGetOrgFundraiserResponse, OrgFundraisersGetOrgFundraiserShareData, OrgFundraisersGetOrgFundraiserShareError, OrgFundraisersGetOrgFundraiserShareKitData, OrgFundraisersGetOrgFundraiserShareKitError, OrgFundraisersGetOrgFundraiserShareKitResponse, OrgFundraisersGetOrgFundraiserShareResponse, OrgFundraisersListOrgFundraiserDonorMessagesData, OrgFundraisersListOrgFundraiserDonorMessagesError, OrgFundraisersListOrgFundraiserDonorMessagesResponse, OrgFundraisersListOrgFundraiserDonorsData, OrgFundraisersListOrgFundraiserDonorsError, OrgFundraisersListOrgFundraiserDonorsResponse, OrgFundraisersListOrgFundraisersData, OrgFundraisersListOrgFundraisersError, OrgFundraisersListOrgFundraisersResponse, OrgFundraisersListOrgSupporterFundraisersData, OrgFundraisersListOrgSupporterFundraisersError, OrgFundraisersListOrgSupporterFundraisersResponse, OrgFundraisersPublishOrgFundraiserData, OrgFundraisersPublishOrgFundraiserError, OrgFundraisersPublishOrgFundraiserResponse, OrgFundraisersPutOrgFundraiserDesignationsData, OrgFundraisersPutOrgFundraiserDesignationsError, OrgFundraisersPutOrgFundraiserDesignationsResponse, OrgFundraisersReactivateOrgFundraiserData, OrgFundraisersReactivateOrgFundraiserError, OrgFundraisersReactivateOrgFundraiserResponse, OrgFundraisersRenderOrgFundraiserShareQrData, OrgFundraisersRenderOrgFundraiserShareQrError, OrgFundraisersRenderOrgFundraiserShareQrResponse, OrgFundraisersRenderSuppliedOrgFundraiserShareQrData, OrgFundraisersRenderSuppliedOrgFundraiserShareQrError, OrgFundraisersRenderSuppliedOrgFundraiserShareQrResponse, OrgFundraisersReopenOrgFundraiserData, OrgFundraisersReopenOrgFundraiserError, OrgFundraisersReopenOrgFundraiserResponse, OrgFundraisersSendOrgFundraiserDonorMessageData, OrgFundraisersSendOrgFundraiserDonorMessageError, OrgFundraisersSendOrgFundraiserDonorMessageResponse, OrgFundraisersUpdateOrgFundraiserData, OrgFundraisersUpdateOrgFundraiserError, OrgFundraisersUpdateOrgFundraiserResponse, OrgIntegrationsCompleteOrgIntegrationOauthData, OrgIntegrationsCompleteOrgIntegrationOauthError, OrgIntegrationsCompleteOrgIntegrationOauthResponse, OrgIntegrationsDisconnectOrgIntegrationData, OrgIntegrationsDisconnectOrgIntegrationError, OrgIntegrationsDisconnectOrgIntegrationResponse, OrgIntegrationsGetOrgIntegrationData, OrgIntegrationsGetOrgIntegrationError, OrgIntegrationsGetOrgIntegrationResponse, OrgIntegrationsListOrgIntegrationsData, OrgIntegrationsListOrgIntegrationsError, OrgIntegrationsListOrgIntegrationsResponse, OrgIntegrationsStartOrgIntegrationOauthData, OrgIntegrationsStartOrgIntegrationOauthError, OrgIntegrationsStartOrgIntegrationOauthResponse, OrgQrDesignGetOrgQrDesignData, OrgQrDesignGetOrgQrDesignError, OrgQrDesignGetOrgQrDesignResponse, OrgQrDesignRenderOrgPublicQrData, OrgQrDesignRenderOrgPublicQrError, OrgQrDesignRenderOrgPublicQrResponse, OrgQrDesignRenderSuppliedOrgPublicQrData, OrgQrDesignRenderSuppliedOrgPublicQrError, OrgQrDesignRenderSuppliedOrgPublicQrResponse, OrgQrDesignUpdateOrgQrDesignData, OrgQrDesignUpdateOrgQrDesignError, OrgQrDesignUpdateOrgQrDesignResponse, P2pCheckCampaignJoinData, P2pCheckCampaignJoinError, P2pCheckCampaignJoinResponse, P2pGetActivityData, P2pGetActivityError, P2pGetActivityResponse, P2pGetCampaignP2pData, P2pGetCampaignP2pError, P2pGetCampaignP2pResponse, P2pGetLeaderboardData, P2pGetLeaderboardError, P2pGetLeaderboardResponse, P2pGetMyCampaignJoinRequestData, P2pGetMyCampaignJoinRequestError, P2pGetMyCampaignJoinRequestResponse, P2pGetSupporterData, P2pGetSupporterError, P2pGetSupporterResponse, P2pGetTeamData, P2pGetTeamError, P2pGetTeamResponse, P2pJoinCampaignData, P2pJoinCampaignError, P2pJoinCampaignResponse, P2pListGiveOptionsData, P2pListGiveOptionsError, P2pListGiveOptionsResponse, P2pListTeamsData, P2pListTeamsError, P2pListTeamsResponse, P2pRequestToJoinCampaignData, P2pRequestToJoinCampaignError, P2pRequestToJoinCampaignResponse, P2pUpdateSupporterData, P2pUpdateSupporterError, P2pUpdateSupporterResponse, P2pWithdrawMyCampaignJoinRequestData, P2pWithdrawMyCampaignJoinRequestError, P2pWithdrawMyCampaignJoinRequestResponse, PasskeysDeleteMyPasskeyData, PasskeysDeleteMyPasskeyError, PasskeysDeleteMyPasskeyResponse, PasskeysFinishPasskeyReauthenticationData, PasskeysFinishPasskeyReauthenticationError, PasskeysFinishPasskeyReauthenticationResponse, PasskeysFinishPasskeyRegistrationData, PasskeysFinishPasskeyRegistrationError, PasskeysFinishPasskeyRegistrationResponse, PasskeysListMyPasskeysData, PasskeysListMyPasskeysResponse, PasskeysRenameMyPasskeyData, PasskeysRenameMyPasskeyError, PasskeysRenameMyPasskeyResponse, PasskeysStartPasskeyReauthenticationData, PasskeysStartPasskeyReauthenticationResponse, PasskeysStartPasskeyRegistrationData, PasskeysStartPasskeyRegistrationResponse, PaymentsGetPaymentReconciliationData, PaymentsGetPaymentReconciliationError, PaymentsGetPaymentReconciliationResponse, PaymentsGetPaymentsConfigData, PaymentsGetPaymentsConfigResponse, PaymentsListReconcileReviewChargeIntentsData, PaymentsListReconcileReviewChargeIntentsResponse, PledgesAcceptAttestationData, PledgesAcceptAttestationError, PledgesAcceptAttestationResponse, PledgesCancelGuestPledgeData, PledgesCancelGuestPledgeError, PledgesCancelGuestPledgeResponse, PledgesCancelPledgeData, PledgesCancelPledgeError, PledgesCancelPledgeResponse, PledgesChooseGuestPledgeAmountData, PledgesChooseGuestPledgeAmountError, PledgesChooseGuestPledgeAmountResponse, PledgesChoosePledgeAmountData, PledgesChoosePledgeAmountError, PledgesChoosePledgeAmountResponse, PledgesClearPledgeTemplateData, PledgesClearPledgeTemplateError, PledgesClearPledgeTemplateResponse, PledgesCreateGuestOfferPledgeData, PledgesCreateGuestOfferPledgeError, PledgesCreateGuestOfferPledgeResponse, PledgesCreateGuestPledgeData, PledgesCreateGuestPledgeError, PledgesCreateGuestPledgeResponse, PledgesCreatePledgeCampaignData, PledgesCreatePledgeCampaignError, PledgesCreatePledgeCampaignResponse, PledgesCreatePledgeData, PledgesCreatePledgeError, PledgesCreatePledgeResponse, PledgesGetGuestPledgeData, PledgesGetGuestPledgeError, PledgesGetGuestPledgeResponse, PledgesGetPledgeCampaignData, PledgesGetPledgeCampaignError, PledgesGetPledgeCampaignResponse, PledgesGetPledgeOfferData, PledgesGetPledgeOfferError, PledgesGetPledgeOfferResponse, PledgesGetPledgeProjectedTotalData, PledgesGetPledgeProjectedTotalError, PledgesGetPledgeProjectedTotalResponse, PledgesGetPledgesLiveData, PledgesGetPledgesLiveError, PledgesGetPledgesLiveResponse, PledgesGetPledgeTemplateData, PledgesGetPledgeTemplateError, PledgesGetPledgeTemplateResponse, PledgesListFundraiserPledgeOffersData, PledgesListFundraiserPledgeOffersError, PledgesListFundraiserPledgeOffersResponse, PledgesListOwnPledgesData, PledgesListOwnPledgesResponse, PledgesObjectToGuestPledgeData, PledgesObjectToGuestPledgeError, PledgesObjectToGuestPledgeResponse, PledgesObjectToPledgeData, PledgesObjectToPledgeError, PledgesObjectToPledgeResponse, PledgesPreviewPledgeOfferRuleData, PledgesPreviewPledgeOfferRuleError, PledgesPreviewPledgeOfferRuleResponse, PledgesSetPledgeTemplateData, PledgesSetPledgeTemplateError, PledgesSetPledgeTemplateResponse, PledgesSubmitAttestationData, PledgesSubmitAttestationError, PledgesSubmitAttestationResponse, PostsCommentPostData, PostsCommentPostError, PostsCommentPostResponse, PostsDeleteCommentData, PostsDeleteCommentError, PostsDeleteCommentResponse, PostsGetCharityPostsData, PostsGetCharityPostsError, PostsGetCharityPostsResponse, PostsGetCommentLikesData, PostsGetCommentLikesError, PostsGetCommentLikesResponse, PostsGetEtfPostsData, PostsGetEtfPostsError, PostsGetEtfPostsResponse, PostsGetFollowsPostsData, PostsGetFollowsPostsError, PostsGetFollowsPostsResponse, PostsGetFundraiserPostsData, PostsGetFundraiserPostsError, PostsGetFundraiserPostsResponse, PostsGetMyPostsData, PostsGetMyPostsError, PostsGetMyPostsResponse, PostsGetPostCommentsData, PostsGetPostCommentsError, PostsGetPostCommentsResponse, PostsGetPostData, PostsGetPostError, PostsGetPostLikesData, PostsGetPostLikesError, PostsGetPostLikesResponse, PostsGetPostResponse, PostsGetSuperAdminRecentPublicPostsData, PostsGetSuperAdminRecentPublicPostsError, PostsGetSuperAdminRecentPublicPostsResponse, PostsGetUsersPublicPostsData, PostsGetUsersPublicPostsError, PostsGetUsersPublicPostsResponse, PostsHideCommentData, PostsHideCommentError, PostsHideCommentResponse, PostsHidePostData, PostsHidePostError, PostsHidePostResponse, PostsLikeCommentData, PostsLikeCommentError, PostsLikeCommentResponse, PostsLikePostData, PostsLikePostError, PostsLikePostResponse, PostsReportPostData, PostsReportPostError, PostsReportPostResponse, PostsUnhideCommentData, PostsUnhideCommentError, PostsUnhideCommentResponse, PostsUnhidePostData, PostsUnhidePostError, PostsUnhidePostResponse, PostsUnlikeCommentData, PostsUnlikeCommentError, PostsUnlikeCommentResponse, PostsUnlikePostData, PostsUnlikePostError, PostsUnlikePostResponse, PostsUpdatePostMessageData, PostsUpdatePostMessageError, PostsUpdatePostMessageResponse, PostsUpdatePostVisibilityData, PostsUpdatePostVisibilityError, PostsUpdatePostVisibilityResponse, ProfilePagesGetConsumerPageData, ProfilePagesGetConsumerPageError, ProfilePagesGetConsumerPageResponse, ProfilePagesPublicGetPublicProfilePageData, ProfilePagesPublicGetPublicProfilePageError, ProfilePagesPublicGetPublicProfilePageResponse, ProfilePagesReplaceConsumerPageData, ProfilePagesReplaceConsumerPageError, ProfilePagesReplaceConsumerPageResponse, ProfilePagesUploadConsumerPageImageData, ProfilePagesUploadConsumerPageImageError, ProfilePagesUploadConsumerPageImageResponse, ProfileReportsReportProfileBlockData, ProfileReportsReportProfileBlockError, ProfileReportsReportProfileBlockResponse, ProfileReportsReportUserProfileData, ProfileReportsReportUserProfileError, ProfileReportsReportUserProfileResponse, ReceiptFinePrintGetReceiptFinePrintDetailData, ReceiptFinePrintGetReceiptFinePrintDetailError, ReceiptFinePrintGetReceiptFinePrintDetailResponse, ReceiptFinePrintListReceiptFinePrintData, ReceiptFinePrintListReceiptFinePrintResponse, ReceiptFinePrintSetReceiptFinePrintEffectiveData, ReceiptFinePrintSetReceiptFinePrintEffectiveError, ReceiptFinePrintSetReceiptFinePrintEffectiveResponse, SearchGetSearchFeedData, SearchGetSearchFeedError, SearchGetSearchFeedResponse, ShareKitDownloadMyShareKitGraphicsData, ShareKitDownloadMyShareKitGraphicsError, ShareKitDownloadMyShareKitGraphicsResponse, ShareKitGetMyShareKitData, ShareKitGetMyShareKitError, ShareKitGetMyShareKitResponse, ShareKitRenderMyShareKitQrData, ShareKitRenderMyShareKitQrError, ShareKitRenderMyShareKitQrResponse, StepsCompetitionsAdminCancelAdminStepsCompetitionData, StepsCompetitionsAdminCancelAdminStepsCompetitionError, StepsCompetitionsAdminCancelAdminStepsCompetitionResponse, StepsCompetitionsAdminCreateAdminStepsCompetitionData, StepsCompetitionsAdminCreateAdminStepsCompetitionError, StepsCompetitionsAdminCreateAdminStepsCompetitionResponse, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryData, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryError, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryResponse, StepsCompetitionsAdminGetAdminStepsCompetitionData, StepsCompetitionsAdminGetAdminStepsCompetitionError, StepsCompetitionsAdminGetAdminStepsCompetitionResponse, StepsCompetitionsAdminGetStepsSponsorDpaData, StepsCompetitionsAdminGetStepsSponsorDpaResponse, StepsCompetitionsAdminListAdminStepsCompetitionEntriesData, StepsCompetitionsAdminListAdminStepsCompetitionEntriesError, StepsCompetitionsAdminListAdminStepsCompetitionEntriesResponse, StepsCompetitionsAdminListAdminStepsCompetitionsData, StepsCompetitionsAdminListAdminStepsCompetitionsError, StepsCompetitionsAdminListAdminStepsCompetitionsResponse, StepsCompetitionsAdminPublishAdminStepsCompetitionData, StepsCompetitionsAdminPublishAdminStepsCompetitionError, StepsCompetitionsAdminPublishAdminStepsCompetitionResponse, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryData, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryError, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryResponse, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionData, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionError, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionResponse, StepsCompetitionsAdminUpdateAdminStepsCompetitionData, StepsCompetitionsAdminUpdateAdminStepsCompetitionError, StepsCompetitionsAdminUpdateAdminStepsCompetitionResponse, StepsCompetitionsGetCompanyPublicStepsCompetitionsData, StepsCompetitionsGetCompanyPublicStepsCompetitionsError, StepsCompetitionsGetCompanyPublicStepsCompetitionsResponse, StepsCompetitionsGetStepsCompetitionData, StepsCompetitionsGetStepsCompetitionError, StepsCompetitionsGetStepsCompetitionLeaderboardData, StepsCompetitionsGetStepsCompetitionLeaderboardError, StepsCompetitionsGetStepsCompetitionLeaderboardResponse, StepsCompetitionsGetStepsCompetitionResponse, StepsCompetitionsJoinStepsCompetitionData, StepsCompetitionsJoinStepsCompetitionError, StepsCompetitionsJoinStepsCompetitionResponse, StepsCompetitionsListStepsCompetitionsData, StepsCompetitionsListStepsCompetitionsError, StepsCompetitionsListStepsCompetitionsResponse, StepsCompetitionsRestateMyStepsData, StepsCompetitionsRestateMyStepsError, StepsCompetitionsRestateMyStepsResponse, StepsCompetitionsUpdateMyStepsEntryData, StepsCompetitionsUpdateMyStepsEntryError, StepsCompetitionsUpdateMyStepsEntryResponse, StepsCompetitionsWithdrawFromStepsCompetitionData, StepsCompetitionsWithdrawFromStepsCompetitionError, StepsCompetitionsWithdrawFromStepsCompetitionResponse, StepUpMintStepUpFromReauthData, StepUpMintStepUpFromReauthError, StepUpMintStepUpFromReauthResponse, SuperAdminChampionOpsFileChampionReportData, SuperAdminChampionOpsFileChampionReportError, SuperAdminChampionOpsFileChampionReportResponse, SuperAdminChampionOpsInspectChampionByHandleData, SuperAdminChampionOpsInspectChampionByHandleError, SuperAdminChampionOpsInspectChampionByHandleResponse, SuperAdminChampionOpsInspectChampionData, SuperAdminChampionOpsInspectChampionError, SuperAdminChampionOpsInspectChampionResponse, SuperAdminChampionOpsListChampionsData, SuperAdminChampionOpsListChampionsError, SuperAdminChampionOpsListChampionsResponse, SuperAdminChampionOpsReclaimChampionHandleData, SuperAdminChampionOpsReclaimChampionHandleError, SuperAdminChampionOpsReclaimChampionHandleResponse, SuperAdminCharityClaimsApproveCharityClaimData, SuperAdminCharityClaimsApproveCharityClaimError, SuperAdminCharityClaimsApproveCharityClaimResponse, SuperAdminCharityClaimsApproveCharityClaimTransferData, SuperAdminCharityClaimsApproveCharityClaimTransferError, SuperAdminCharityClaimsApproveCharityClaimTransferResponse, SuperAdminCharityClaimsGetCharityClaimDetailData, SuperAdminCharityClaimsGetCharityClaimDetailError, SuperAdminCharityClaimsGetCharityClaimDetailResponse, SuperAdminCharityClaimsListPendingCharityClaimsData, SuperAdminCharityClaimsListPendingCharityClaimsError, SuperAdminCharityClaimsListPendingCharityClaimsResponse, SuperAdminCharityClaimsRejectCharityClaimData, SuperAdminCharityClaimsRejectCharityClaimError, SuperAdminCharityClaimsRejectCharityClaimResponse, SuperAdminCharityConsentOpsGetCharityAuditTrailData, SuperAdminCharityConsentOpsGetCharityAuditTrailError, SuperAdminCharityConsentOpsGetCharityAuditTrailResponse, SuperAdminCharityConsentOpsGetClaimVelocityReportData, SuperAdminCharityConsentOpsGetClaimVelocityReportResponse, SuperAdminCharityConsentOpsListCharityConsentStatesData, SuperAdminCharityConsentOpsListCharityConsentStatesError, SuperAdminCharityConsentOpsListCharityConsentStatesResponse, SuperAdminCharityDisplayNamesApproveCharityDisplayNameData, SuperAdminCharityDisplayNamesApproveCharityDisplayNameError, SuperAdminCharityDisplayNamesApproveCharityDisplayNameResponse, SuperAdminCharityDisplayNamesEndCharityDisplayNameData, SuperAdminCharityDisplayNamesEndCharityDisplayNameError, SuperAdminCharityDisplayNamesEndCharityDisplayNameResponse, SuperAdminCharityDisplayNamesListCharityDisplayNamesData, SuperAdminCharityDisplayNamesListCharityDisplayNamesError, SuperAdminCharityDisplayNamesListCharityDisplayNamesResponse, SuperAdminCharityDisplayNamesRejectCharityDisplayNameData, SuperAdminCharityDisplayNamesRejectCharityDisplayNameError, SuperAdminCharityDisplayNamesRejectCharityDisplayNameResponse, SuperAdminCharityInstantClaimAllowCharityInstantClaimData, SuperAdminCharityInstantClaimAllowCharityInstantClaimError, SuperAdminCharityInstantClaimAllowCharityInstantClaimResponse, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesData, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesError, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesResponse, SuperAdminCharityInstantClaimRevokeCharityInstantClaimData, SuperAdminCharityInstantClaimRevokeCharityInstantClaimError, SuperAdminCharityInstantClaimRevokeCharityInstantClaimResponse, SuperAdminCharityOnboardingTestGetCharityOnboardingTestData, SuperAdminCharityOnboardingTestGetCharityOnboardingTestResponse, SuperAdminCharityOnboardingTestResetCharityOnboardingTestData, SuperAdminCharityOnboardingTestResetCharityOnboardingTestError, SuperAdminCharityOnboardingTestResetCharityOnboardingTestResponse, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagData, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagError, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagResponse, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailData, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailError, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailResponse, SuperAdminCharityPayeeFlagsListCharityPayeeFlagsData, SuperAdminCharityPayeeFlagsListCharityPayeeFlagsResponse, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagData, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagError, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagResponse, SuperAdminCharityRemovalsCancelCharityRemovalData, SuperAdminCharityRemovalsCancelCharityRemovalError, SuperAdminCharityRemovalsCancelCharityRemovalResponse, SuperAdminCharityRemovalsGetCharityRemovalDetailData, SuperAdminCharityRemovalsGetCharityRemovalDetailError, SuperAdminCharityRemovalsGetCharityRemovalDetailResponse, SuperAdminCharityRemovalsListCharityRemovalQueueData, SuperAdminCharityRemovalsListCharityRemovalQueueResponse, SuperAdminCharityRemovalsProcessCharityRemovalData, SuperAdminCharityRemovalsProcessCharityRemovalError, SuperAdminCharityRemovalsProcessCharityRemovalResponse, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityData, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityError, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityResponse, SuperAdminContentReportsListContentReportsData, SuperAdminContentReportsListContentReportsError, SuperAdminContentReportsListContentReportsResponse, SuperAdminDafTransfersAppendDafTransferArrivalNoteData, SuperAdminDafTransfersAppendDafTransferArrivalNoteError, SuperAdminDafTransfersAppendDafTransferArrivalNoteResponse, SuperAdminDafTransfersAppendDafTransferEventData, SuperAdminDafTransfersAppendDafTransferEventError, SuperAdminDafTransfersAppendDafTransferEventResponse, SuperAdminDafTransfersCloseDafTransferIntentData, SuperAdminDafTransfersCloseDafTransferIntentError, SuperAdminDafTransfersCloseDafTransferIntentResponse, SuperAdminDafTransfersCreditDafTransferArrivalData, SuperAdminDafTransfersCreditDafTransferArrivalError, SuperAdminDafTransfersCreditDafTransferArrivalResponse, SuperAdminDafTransfersGetDafTransferArrivalData, SuperAdminDafTransfersGetDafTransferArrivalError, SuperAdminDafTransfersGetDafTransferArrivalResponse, SuperAdminDafTransfersLinkDafTransferArrivalData, SuperAdminDafTransfersLinkDafTransferArrivalError, SuperAdminDafTransfersLinkDafTransferArrivalResponse, SuperAdminDafTransfersListDafTransferArrivalAgingData, SuperAdminDafTransfersListDafTransferArrivalAgingError, SuperAdminDafTransfersListDafTransferArrivalAgingResponse, SuperAdminDafTransfersListDafTransferArrivalCandidatesData, SuperAdminDafTransfersListDafTransferArrivalCandidatesError, SuperAdminDafTransfersListDafTransferArrivalCandidatesResponse, SuperAdminDafTransfersListDafTransferArrivalNotesData, SuperAdminDafTransfersListDafTransferArrivalNotesError, SuperAdminDafTransfersListDafTransferArrivalNotesResponse, SuperAdminDafTransfersListDafTransferArrivalsData, SuperAdminDafTransfersListDafTransferArrivalsError, SuperAdminDafTransfersListDafTransferArrivalsResponse, SuperAdminDafTransfersListDafTransferIntentAgingData, SuperAdminDafTransfersListDafTransferIntentAgingError, SuperAdminDafTransfersListDafTransferIntentAgingResponse, SuperAdminDafTransfersRegisterDafTransferArrivalData, SuperAdminDafTransfersRegisterDafTransferArrivalError, SuperAdminDafTransfersRegisterDafTransferArrivalResponse, SuperAdminDafTransfersRegisterDafTransferIntentData, SuperAdminDafTransfersRegisterDafTransferIntentError, SuperAdminDafTransfersRegisterDafTransferIntentResponse, SuperAdminDafTransfersRevokeDafTransferArrivalLinkData, SuperAdminDafTransfersRevokeDafTransferArrivalLinkError, SuperAdminDafTransfersRevokeDafTransferArrivalLinkResponse, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameData, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameError, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameResponse, SuperAdminDisbursementApprovalsListDisbursementApprovalsData, SuperAdminDisbursementApprovalsListDisbursementApprovalsError, SuperAdminDisbursementApprovalsListDisbursementApprovalsResponse, SuperAdminDisbursementApprovalsRecordDisbursementApprovalData, SuperAdminDisbursementApprovalsRecordDisbursementApprovalError, SuperAdminDisbursementApprovalsRecordDisbursementApprovalResponse, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationData, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationError, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationResponse, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalData, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalError, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalResponse, SuperAdminDonationOpsClearDonationDisbursementHoldData, SuperAdminDonationOpsClearDonationDisbursementHoldError, SuperAdminDonationOpsClearDonationDisbursementHoldResponse, SuperAdminDonationOpsCorrectUserBirthDateData, SuperAdminDonationOpsCorrectUserBirthDateError, SuperAdminDonationOpsCorrectUserBirthDateResponse, SuperAdminDonationOpsCreateExternalDonationOnBehalfData, SuperAdminDonationOpsCreateExternalDonationOnBehalfError, SuperAdminDonationOpsCreateExternalDonationOnBehalfResponse, SuperAdminDonationOpsGetClaimConversionData, SuperAdminDonationOpsGetClaimConversionError, SuperAdminDonationOpsGetClaimConversionResponse, SuperAdminDonationOpsGetEmployerLinkageData, SuperAdminDonationOpsGetEmployerLinkageError, SuperAdminDonationOpsGetEmployerLinkageResponse, SuperAdminDonationOpsGetPaymentMethodReportData, SuperAdminDonationOpsGetPaymentMethodReportError, SuperAdminDonationOpsGetPaymentMethodReportResponse, SuperAdminDonationOpsGetUserProfileData, SuperAdminDonationOpsGetUserProfileError, SuperAdminDonationOpsGetUserProfileResponse, SuperAdminDonationOpsLinkCompanyAttestedData, SuperAdminDonationOpsLinkCompanyAttestedError, SuperAdminDonationOpsLinkCompanyAttestedResponse, SuperAdminDonationOpsListUserDonationsData, SuperAdminDonationOpsListUserDonationsError, SuperAdminDonationOpsListUserDonationsResponse, SuperAdminDonationOpsReAdviseConnectDonationIntentData, SuperAdminDonationOpsReAdviseConnectDonationIntentError, SuperAdminDonationOpsReAdviseConnectDonationIntentResponse, SuperAdminDonationOpsSearchUserByEmailData, SuperAdminDonationOpsSearchUserByEmailError, SuperAdminDonationOpsSearchUserByEmailResponse, SuperAdminDonationOpsSearchUsersByNameData, SuperAdminDonationOpsSearchUsersByNameError, SuperAdminDonationOpsSearchUsersByNameResponse, SuperAdminDonationOpsSetDonationDisbursementHoldData, SuperAdminDonationOpsSetDonationDisbursementHoldError, SuperAdminDonationOpsSetDonationDisbursementHoldResponse, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentData, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentError, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentResponse, SuperAdminEntityEnrollmentsOperatorGetEnrollmentData, SuperAdminEntityEnrollmentsOperatorGetEnrollmentError, SuperAdminEntityEnrollmentsOperatorGetEnrollmentResponse, SuperAdminEntityEnrollmentsOperatorListEnrollmentsData, SuperAdminEntityEnrollmentsOperatorListEnrollmentsError, SuperAdminEntityEnrollmentsOperatorListEnrollmentsResponse, SuperAdminEntityEnrollmentsOperatorRedriveProvisionData, SuperAdminEntityEnrollmentsOperatorRedriveProvisionError, SuperAdminEntityEnrollmentsOperatorRedriveProvisionResponse, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyData, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyError, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyResponse, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentData, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentError, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentResponse, SuperAdminEntityEnrollmentsOperatorStartImportRunData, SuperAdminEntityEnrollmentsOperatorStartImportRunError, SuperAdminEntityEnrollmentsOperatorStartImportRunResponse, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsData, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsError, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsResponse, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionData, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionError, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionResponse, SuperAdminGrantsOpsAttestGroupExemptionCureData, SuperAdminGrantsOpsAttestGroupExemptionCureError, SuperAdminGrantsOpsAttestGroupExemptionCureResponse, SuperAdminGrantsOpsGetCharityBucketData, SuperAdminGrantsOpsGetCharityBucketError, SuperAdminGrantsOpsGetCharityBucketResponse, SuperAdminGrantsOpsGetCohortData, SuperAdminGrantsOpsGetCohortError, SuperAdminGrantsOpsGetCohortResponse, SuperAdminGrantsOpsGetDonationTrailData, SuperAdminGrantsOpsGetDonationTrailError, SuperAdminGrantsOpsGetDonationTrailResponse, SuperAdminGrantsOpsGetEligibilityEvidenceData, SuperAdminGrantsOpsGetEligibilityEvidenceError, SuperAdminGrantsOpsGetEligibilityEvidenceResponse, SuperAdminGrantsOpsGetOpsStripData, SuperAdminGrantsOpsGetOpsStripResponse, SuperAdminGrantsOpsListCharityBucketsData, SuperAdminGrantsOpsListCharityBucketsError, SuperAdminGrantsOpsListCharityBucketsResponse, SuperAdminGrantsOpsListCohortsData, SuperAdminGrantsOpsListCohortsError, SuperAdminGrantsOpsListCohortsResponse, SuperAdminGrantsOpsListGroupExemptionCuresData, SuperAdminGrantsOpsListGroupExemptionCuresError, SuperAdminGrantsOpsListGroupExemptionCuresResponse, SuperAdminGrantsOpsRecordGroupRulingLetterData, SuperAdminGrantsOpsRecordGroupRulingLetterError, SuperAdminGrantsOpsRecordGroupRulingLetterResponse, SuperAdminGrantsOpsRecordIneligibilityAlternateData, SuperAdminGrantsOpsRecordIneligibilityAlternateError, SuperAdminGrantsOpsRecordIneligibilityAlternateResponse, SuperAdminGrantsOpsRecordIneligibilityDeterminationData, SuperAdminGrantsOpsRecordIneligibilityDeterminationError, SuperAdminGrantsOpsRecordIneligibilityDeterminationResponse, SuperAdminGrantsOpsRecordIneligibilityNoticeData, SuperAdminGrantsOpsRecordIneligibilityNoticeError, SuperAdminGrantsOpsRecordIneligibilityNoticeResponse, SuperAdminGrantsOpsRevokeGroupExemptionCureData, SuperAdminGrantsOpsRevokeGroupExemptionCureError, SuperAdminGrantsOpsRevokeGroupExemptionCureResponse, SuperAdminGrantsOpsSearchDonationsData, SuperAdminGrantsOpsSearchDonationsError, SuperAdminGrantsOpsSearchDonationsResponse, SuperAdminGrantsOpsWithdrawGroupRulingLetterData, SuperAdminGrantsOpsWithdrawGroupRulingLetterError, SuperAdminGrantsOpsWithdrawGroupRulingLetterResponse, SuperAdminGroupOpsEvacuateGroupFundsData, SuperAdminGroupOpsEvacuateGroupFundsError, SuperAdminGroupOpsEvacuateGroupFundsResponse, SuperAdminGroupOpsGetGroupsForModerationData, SuperAdminGroupOpsGetGroupsForModerationError, SuperAdminGroupOpsGetGroupsForModerationResponse, SuperAdminGroupOpsModerateGroupData, SuperAdminGroupOpsModerateGroupError, SuperAdminGroupOpsModerateGroupResponse, SuperAdminGroupOpsRelistGroupData, SuperAdminGroupOpsRelistGroupError, SuperAdminGroupOpsRelistGroupResponse, SuperAdminGroupOpsUnlistGroupData, SuperAdminGroupOpsUnlistGroupError, SuperAdminGroupOpsUnlistGroupResponse, SuperAdminMatchOffersGetMatchOfferDetailData, SuperAdminMatchOffersGetMatchOfferDetailError, SuperAdminMatchOffersGetMatchOfferDetailResponse, SuperAdminMatchOffersListMatchOfferClaimsData, SuperAdminMatchOffersListMatchOfferClaimsError, SuperAdminMatchOffersListMatchOfferClaimsResponse, SuperAdminMatchOffersListMatchOffersData, SuperAdminMatchOffersListMatchOffersError, SuperAdminMatchOffersListMatchOffersResponse, SuperAdminMatchOffersRedirectMatchClaimAdminData, SuperAdminMatchOffersRedirectMatchClaimAdminError, SuperAdminMatchOffersRedirectMatchClaimAdminResponse, SuperAdminMatchOffersResumeMatchOfferData, SuperAdminMatchOffersResumeMatchOfferError, SuperAdminMatchOffersResumeMatchOfferLegData, SuperAdminMatchOffersResumeMatchOfferLegError, SuperAdminMatchOffersResumeMatchOfferLegResponse, SuperAdminMatchOffersResumeMatchOfferResponse, SuperAdminMatchOffersSuspendMatchOfferData, SuperAdminMatchOffersSuspendMatchOfferError, SuperAdminMatchOffersSuspendMatchOfferLegData, SuperAdminMatchOffersSuspendMatchOfferLegError, SuperAdminMatchOffersSuspendMatchOfferLegResponse, SuperAdminMatchOffersSuspendMatchOfferResponse, SuperAdminMatchOffersVoidMatchOfferData, SuperAdminMatchOffersVoidMatchOfferError, SuperAdminMatchOffersVoidMatchOfferResponse, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmData, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmError, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmResponse, SuperAdminOperatorDashboardGetOperatorQueueData, SuperAdminOperatorDashboardGetOperatorQueueError, SuperAdminOperatorDashboardGetOperatorQueueResponse, SuperAdminOperatorDashboardGetOperatorStatsData, SuperAdminOperatorDashboardGetOperatorStatsError, SuperAdminOperatorDashboardGetOperatorStatsResponse, SuperAdminOperatorDashboardGetTelemetryEventSummaryData, SuperAdminOperatorDashboardGetTelemetryEventSummaryError, SuperAdminOperatorDashboardGetTelemetryEventSummaryResponse, SuperAdminPlatformGrantFactsGetPlatformGrantFactsData, SuperAdminPlatformGrantFactsGetPlatformGrantFactsError, SuperAdminPlatformGrantFactsGetPlatformGrantFactsResponse, SuperAdminPledgesAcceptCampaignData, SuperAdminPledgesAcceptCampaignError, SuperAdminPledgesAcceptCampaignResponse, SuperAdminPledgesApprovePublishReviewData, SuperAdminPledgesApprovePublishReviewError, SuperAdminPledgesApprovePublishReviewResponse, SuperAdminPledgesCancelPledgeData, SuperAdminPledgesCancelPledgeError, SuperAdminPledgesCancelPledgeResponse, SuperAdminPledgesDismissObjectionData, SuperAdminPledgesDismissObjectionError, SuperAdminPledgesDismissObjectionResponse, SuperAdminPledgesGetReviewCampaignDetailData, SuperAdminPledgesGetReviewCampaignDetailError, SuperAdminPledgesGetReviewCampaignDetailResponse, SuperAdminPledgesListHeldPledgesData, SuperAdminPledgesListHeldPledgesError, SuperAdminPledgesListHeldPledgesResponse, SuperAdminPledgesListPublishReviewCampaignsData, SuperAdminPledgesListPublishReviewCampaignsError, SuperAdminPledgesListPublishReviewCampaignsResponse, SuperAdminPledgesListReviewCampaignsData, SuperAdminPledgesListReviewCampaignsError, SuperAdminPledgesListReviewCampaignsResponse, SuperAdminPledgesPartialSettlePledgeData, SuperAdminPledgesPartialSettlePledgeError, SuperAdminPledgesPartialSettlePledgeResponse, SuperAdminPledgesRejectPublishReviewData, SuperAdminPledgesRejectPublishReviewError, SuperAdminPledgesRejectPublishReviewResponse, SuperAdminPledgesResolveHeldPledgeData, SuperAdminPledgesResolveHeldPledgeError, SuperAdminPledgesResolveHeldPledgeResponse, SuperAdminPledgesVoidCampaignData, SuperAdminPledgesVoidCampaignError, SuperAdminPledgesVoidCampaignResponse, SuperAdminProfileBlocksListProfileBlocksForModerationData, SuperAdminProfileBlocksListProfileBlocksForModerationError, SuperAdminProfileBlocksListProfileBlocksForModerationResponse, SuperAdminProfileBlocksRelistProfileBlockData, SuperAdminProfileBlocksRelistProfileBlockError, SuperAdminProfileBlocksRelistProfileBlockResponse, SuperAdminProfileBlocksUnlistProfileBlockData, SuperAdminProfileBlocksUnlistProfileBlockError, SuperAdminProfileBlocksUnlistProfileBlockResponse, SurveysGetCharityRecommendationsData, SurveysGetCharityRecommendationsResponse, SurveysGetSavedRecommendationsData, SurveysGetSavedRecommendationsResponse, SurveysSubmitSurveyAnswerData, SurveysSubmitSurveyAnswerError, SurveysSubmitSurveyAnswerResponse, TelemetryEventsRecordTelemetryEventData, TelemetryEventsRecordTelemetryEventError, TelemetryEventsRecordTelemetryEventResponse, TermsGetCurrentTermsData, TermsGetCurrentTermsResponse, TermsGetLatestTermsData, TermsGetLatestTermsError, TermsGetLatestTermsResponse, TermsGetNotificationStatusData, TermsGetNotificationStatusError, TermsGetNotificationStatusResponse, TermsGetRecentNotificationsData, TermsGetRecentNotificationsError, TermsGetRecentNotificationsResponse, TermsGetTermsDetailData, TermsGetTermsDetailError, TermsGetTermsDetailResponse, TermsGetTermsNotifyAudienceCountData, TermsGetTermsNotifyAudienceCountError, TermsGetTermsNotifyAudienceCountResponse, TermsGetTermsNotifyPreviewData, TermsGetTermsNotifyPreviewError, TermsGetTermsNotifyPreviewResponse, TermsGetTermsVersionData, TermsGetTermsVersionError, TermsGetTermsVersionResponse, TermsListTermsData, TermsListTermsError, TermsListTermsResponse, TermsNotifyTermsAtSuperAdminData, TermsNotifyTermsAtSuperAdminError, TermsNotifyTermsAtSuperAdminResponse, TermsNotifyTermsData, TermsNotifyTermsError, TermsNotifyTermsResponse, TermsPatchTermsSummaryAtSuperAdminData, TermsPatchTermsSummaryAtSuperAdminError, TermsPatchTermsSummaryAtSuperAdminResponse, TermsPatchTermsSummaryData, TermsPatchTermsSummaryError, TermsPatchTermsSummaryResponse, TermsPostTermsNotifyTestAtSuperAdminData, TermsPostTermsNotifyTestAtSuperAdminError, TermsPostTermsNotifyTestAtSuperAdminResponse, TermsPostTermsNotifyTestData, TermsPostTermsNotifyTestError, TermsPostTermsNotifyTestResponse, TermsPublishTermsAtSuperAdminData, TermsPublishTermsAtSuperAdminError, TermsPublishTermsAtSuperAdminResponse, TermsPublishTermsData, TermsPublishTermsError, TermsPublishTermsResponse, TermsRetryFailedBatchesAtSuperAdminData, TermsRetryFailedBatchesAtSuperAdminError, TermsRetryFailedBatchesAtSuperAdminResponse, TermsRetryFailedBatchesData, TermsRetryFailedBatchesError, TermsRetryFailedBatchesResponse, UsersActivateMyRecurringDonationData, UsersActivateMyRecurringDonationError, UsersActivateMyRecurringDonationResponse, UsersBlockUserData, UsersBlockUserError, UsersBlockUserResponse, UsersCancelMyRecurringDonationData, UsersCancelMyRecurringDonationError, UsersCancelMyRecurringDonationResponse, UsersCheckEmailAvailableData, UsersCheckEmailAvailableError, UsersCheckEmailAvailableResponse, UsersCheckPhoneAvailableData, UsersCheckPhoneAvailableError, UsersCheckPhoneAvailableResponse, UsersCheckUsernameAvailableData, UsersCheckUsernameAvailableError, UsersCheckUsernameAvailableResponse, UsersCheckWorkEmailData, UsersCheckWorkEmailError, UsersCheckWorkEmailResponse, UsersConfirmUserEmailData, UsersConfirmUserEmailError, UsersConfirmUserEmailResponse, UsersCreateUserCardData, UsersCreateUserCardError, UsersCreateUserCardResponse, UsersCreateUserCardV2Data, UsersCreateUserCardV2Error, UsersCreateUserCardV2Response, UsersCreateUserData, UsersCreateUserError, UsersCreateUserResponse, UsersDeleteMyConnectedAppData, UsersDeleteMyConnectedAppError, UsersDeleteMyConnectedAppResponse, UsersDeleteUserCardData, UsersDeleteUserCardError, UsersDeleteUserCardResponse, UsersDeleteUserData, UsersDeleteUserError, UsersDeleteUserResponse, UsersDepositFundsData, UsersDepositFundsError, UsersDepositFundsResponse, UsersDownloadMyChampionQrData, UsersDownloadMyChampionQrError, UsersDownloadMyChampionQrResponse, UserSecurityCancelMyFactorResetData, UserSecurityCancelMyFactorResetResponse, UserSecurityConfirmMySsoLinkData, UserSecurityConfirmMySsoLinkError, UserSecurityConfirmMySsoLinkResponse, UserSecurityGetMySecurityData, UserSecurityGetMySecurityResponse, UserSecurityMintMyRecoveryCodesData, UserSecurityMintMyRecoveryCodesResponse, UserSecurityOptInToMySmsNoticesData, UserSecurityOptInToMySmsNoticesError, UserSecurityOptInToMySmsNoticesResponse, UserSecurityOptOutOfMySmsNoticesData, UserSecurityOptOutOfMySmsNoticesResponse, UserSecurityReEnableMySmsNoticesData, UserSecurityReEnableMySmsNoticesResponse, UserSecurityRegenerateMyRecoveryCodesData, UserSecurityRegenerateMyRecoveryCodesResponse, UserSecuritySignOutEverywhereData, UserSecuritySignOutEverywhereResponse, UserSecurityStartMySsoLinkData, UserSecurityStartMySsoLinkError, UserSecurityStartMySsoLinkResponse, UserSecuritySyncMyFactorsData, UserSecuritySyncMyFactorsResponse, UsersGetMeData, UsersGetMeResponse, UsersGetMyChampionData, UsersGetMyChampionResponse, UsersGetMyConnectedAppsData, UsersGetMyConnectedAppsResponse, UsersGetMyGivingProfileData, UsersGetMyGivingProfileResponse, UsersGetMyMembershipsData, UsersGetMyMembershipsResponse, UsersGetMyQrDesignData, UsersGetMyQrDesignResponse, UsersGetMyRecurringDonationsData, UsersGetMyRecurringDonationsResponse, UsersGetUpcomingBirthdaysData, UsersGetUpcomingBirthdaysResponse, UsersGetUserCardsData, UsersGetUserCardsResponse, UsersGetUserCardsV2Data, UsersGetUserCardsV2Response, UsersGetUserChampionedCharityDonatedAmountData, UsersGetUserChampionedCharityDonatedAmountResponse, UsersGetUserData, UsersGetUserError, UsersGetUserImpactData, UsersGetUserImpactMethodologyData, UsersGetUserImpactMethodologyResponse, UsersGetUserImpactResponse, UsersGetUserPrivateStatisticsData, UsersGetUserPrivateStatisticsResponse, UsersGetUserResponse, UsersGetUsersData, UsersGetUsersError, UsersGetUsersResponse, UsersGetUserStatisticsData, UsersGetUserStatisticsError, UsersGetUserStatisticsResponse, UsersGetUserWalletData, UsersGetUserWalletResponse, UsersGraduateUserData, UsersGraduateUserError, UsersGraduateUserResponse, UsersLinkCompanyData, UsersLinkCompanyError, UsersLinkCompanyResponse, UsersListBlockedUsersData, UsersListBlockedUsersError, UsersListBlockedUsersResponse, UsersListStuckUserDeletionsData, UsersListStuckUserDeletionsResponse, UsersMintMyShareRefData, UsersMintMyShareRefError, UsersMintMyShareRefResponse, UsersRetryFailedUserDeletionsData, UsersRetryFailedUserDeletionsResponse, UsersSaveMyQrDesignData, UsersSaveMyQrDesignError, UsersSaveMyQrDesignResponse, UsersSendEmailVerificationData, UsersSendEmailVerificationError, UsersSendEmailVerificationResponse, UsersSetMyChampionCharityData, UsersSetMyChampionCharityError, UsersSetMyChampionCharityResponse, UsersSetMyChampionTargetData, UsersSetMyChampionTargetError, UsersSetMyChampionTargetResponse, UsersUnblockUserData, UsersUnblockUserError, UsersUnblockUserResponse, UsersUnlinkCompanyData, UsersUnlinkCompanyResponse, UsersUpdateBirthdayVisibilityData, UsersUpdateBirthdayVisibilityError, UsersUpdateBirthdayVisibilityResponse, UsersUpdateMyGivingProfileData, UsersUpdateMyGivingProfileError, UsersUpdateMyGivingProfileResponse, UsersUpdateMyRecurringDonationData, UsersUpdateMyRecurringDonationError, UsersUpdateMyRecurringDonationResponse, UsersUpdateUserByIdData, UsersUpdateUserByIdError, UsersUpdateUserByIdResponse, UsersUpdateUserChampionedCharityData, UsersUpdateUserChampionedCharityError, UsersUpdateUserChampionedCharityResponse, UsersUpdateUserCustomerIdData, UsersUpdateUserCustomerIdError, UsersUpdateUserCustomerIdResponse, UsersUpdateUserData, UsersUpdateUserError, UsersUpdateUserFacebookIdData, UsersUpdateUserFacebookIdError, UsersUpdateUserFacebookIdResponse, UsersUpdateUserPaymentMethodData, UsersUpdateUserPaymentMethodError, UsersUpdateUserPaymentMethodResponse, UsersUpdateUserPreferencesData, UsersUpdateUserPreferencesError, UsersUpdateUserPreferencesResponse, UsersUpdateUserResponse, UsersUploadUserProfilePictureData, UsersUploadUserProfilePictureError, UsersUploadUserProfilePictureResponse, UsersVerifyAccessData, UsersVerifyAccessResponse, UsersVerifyWorkEmailData, UsersVerifyWorkEmailError, UsersVerifyWorkEmailResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const apiTestFlightQueryKey = (options?: Options<ApiTestFlightData>) => createQueryKey('api-test_flight', options);

/**
 * Test Flight
 */
export const apiTestFlightOptions = (options?: Options<ApiTestFlightData>) => queryOptions<ApiTestFlightResponse, DefaultError, ApiTestFlightResponse, ReturnType<typeof apiTestFlightQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiTestFlight({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiTestFlightQueryKey(options)
});

/**
 * Activate Company
 */
export const companiesActivateCompanyMutation = (options?: Partial<Options<CompaniesActivateCompanyData>>): UseMutationOptions<CompaniesActivateCompanyResponse, CompaniesActivateCompanyError, Options<CompaniesActivateCompanyData>> => {
    const mutationOptions: UseMutationOptions<CompaniesActivateCompanyResponse, CompaniesActivateCompanyError, Options<CompaniesActivateCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesActivateCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyQueryKey = (options?: Options<CompaniesGetCompanyData>) => createQueryKey('companies-get_company', options);

/**
 * Get Company
 */
export const companiesGetCompanyOptions = (options?: Options<CompaniesGetCompanyData>) => queryOptions<CompaniesGetCompanyResponse, DefaultError, CompaniesGetCompanyResponse, ReturnType<typeof companiesGetCompanyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompany({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyQueryKey(options)
});

/**
 * Create Company
 */
export const companiesCreateCompanyMutation = (options?: Partial<Options<CompaniesCreateCompanyData>>): UseMutationOptions<CompaniesCreateCompanyResponse, CompaniesCreateCompanyError, Options<CompaniesCreateCompanyData>> => {
    const mutationOptions: UseMutationOptions<CompaniesCreateCompanyResponse, CompaniesCreateCompanyError, Options<CompaniesCreateCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesCreateCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Company Account Info
 */
export const companiesUpdateCompanyAccountInfoMutation = (options?: Partial<Options<CompaniesUpdateCompanyAccountInfoData>>): UseMutationOptions<CompaniesUpdateCompanyAccountInfoResponse, CompaniesUpdateCompanyAccountInfoError, Options<CompaniesUpdateCompanyAccountInfoData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyAccountInfoResponse, CompaniesUpdateCompanyAccountInfoError, Options<CompaniesUpdateCompanyAccountInfoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyAccountInfo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyAdminsQueryKey = (options?: Options<CompaniesGetCompanyAdminsData>) => createQueryKey('companies-get_company_admins', options);

/**
 * Get Company Admins
 */
export const companiesGetCompanyAdminsOptions = (options?: Options<CompaniesGetCompanyAdminsData>) => queryOptions<CompaniesGetCompanyAdminsResponse, CompaniesGetCompanyAdminsError, CompaniesGetCompanyAdminsResponse, ReturnType<typeof companiesGetCompanyAdminsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyAdmins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyAdminsQueryKey(options)
});

/**
 * Create Company Admin
 */
export const companiesCreateCompanyAdminMutation = (options?: Partial<Options<CompaniesCreateCompanyAdminData>>): UseMutationOptions<CompaniesCreateCompanyAdminResponse, CompaniesCreateCompanyAdminError, Options<CompaniesCreateCompanyAdminData>> => {
    const mutationOptions: UseMutationOptions<CompaniesCreateCompanyAdminResponse, CompaniesCreateCompanyAdminError, Options<CompaniesCreateCompanyAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesCreateCompanyAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Admin From Company
 */
export const companiesRemoveAdminFromCompanyMutation = (options?: Partial<Options<CompaniesRemoveAdminFromCompanyData>>): UseMutationOptions<CompaniesRemoveAdminFromCompanyResponse, CompaniesRemoveAdminFromCompanyError, Options<CompaniesRemoveAdminFromCompanyData>> => {
    const mutationOptions: UseMutationOptions<CompaniesRemoveAdminFromCompanyResponse, CompaniesRemoveAdminFromCompanyError, Options<CompaniesRemoveAdminFromCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesRemoveAdminFromCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Company Admin Name
 */
export const companiesUpdateCompanyAdminNameMutation = (options?: Partial<Options<CompaniesUpdateCompanyAdminNameData>>): UseMutationOptions<CompaniesUpdateCompanyAdminNameResponse, CompaniesUpdateCompanyAdminNameError, Options<CompaniesUpdateCompanyAdminNameData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyAdminNameResponse, CompaniesUpdateCompanyAdminNameError, Options<CompaniesUpdateCompanyAdminNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyAdminName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Company Admin Role
 */
export const companiesUpdateCompanyAdminRoleMutation = (options?: Partial<Options<CompaniesUpdateCompanyAdminRoleData>>): UseMutationOptions<CompaniesUpdateCompanyAdminRoleResponse, CompaniesUpdateCompanyAdminRoleError, Options<CompaniesUpdateCompanyAdminRoleData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyAdminRoleResponse, CompaniesUpdateCompanyAdminRoleError, Options<CompaniesUpdateCompanyAdminRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyAdminRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyChampionQueryKey = (options?: Options<CompaniesGetCompanyChampionData>) => createQueryKey('companies-get_company_champion', options);

/**
 * Get Company Champion
 *
 * CQ2-BE1: the company's champion (get-or-create) — immutable slug + current
 * handle. Separate from the user surface; does NOT touch GET /admin/company /
 * CompanyDetailedOut.
 */
export const companiesGetCompanyChampionOptions = (options?: Options<CompaniesGetCompanyChampionData>) => queryOptions<CompaniesGetCompanyChampionResponse, DefaultError, CompaniesGetCompanyChampionResponse, ReturnType<typeof companiesGetCompanyChampionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyChampion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyChampionQueryKey(options)
});

/**
 * Set Company Champion Charity
 *
 * CQ2-BE1: the NEW company-admin championed-charity setter. Sets the
 * company's `championed_charity_id` (read by the resolver) and ensures a company
 * champion is minted, via the shared `ChampionService` helper. Owner =
 * (company, user.admin_company), router-injected — never spread from the body.
 * Deliberately a NEW route: the user route + UseDetailedOut stay untouched.
 */
export const companiesSetCompanyChampionCharityMutation = (options?: Partial<Options<CompaniesSetCompanyChampionCharityData>>): UseMutationOptions<CompaniesSetCompanyChampionCharityResponse, CompaniesSetCompanyChampionCharityError, Options<CompaniesSetCompanyChampionCharityData>> => {
    const mutationOptions: UseMutationOptions<CompaniesSetCompanyChampionCharityResponse, CompaniesSetCompanyChampionCharityError, Options<CompaniesSetCompanyChampionCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesSetCompanyChampionCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change Company Champion Handle
 *
 * CQ2-BE1: change the company champion's handle. Retires the current handle
 * (permanent-redirect) and mints the new one; reserved-word/charset validated,
 * never-recycle enforced, rate-limited.
 */
export const companiesChangeCompanyChampionHandleMutation = (options?: Partial<Options<CompaniesChangeCompanyChampionHandleData>>): UseMutationOptions<CompaniesChangeCompanyChampionHandleResponse, CompaniesChangeCompanyChampionHandleError, Options<CompaniesChangeCompanyChampionHandleData>> => {
    const mutationOptions: UseMutationOptions<CompaniesChangeCompanyChampionHandleResponse, CompaniesChangeCompanyChampionHandleError, Options<CompaniesChangeCompanyChampionHandleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesChangeCompanyChampionHandle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyChampionHandleSuggestionQueryKey = (options?: Options<CompaniesGetCompanyChampionHandleSuggestionData>) => createQueryKey('companies-get_company_champion_handle_suggestion', options);

/**
 * Get Company Champion Handle Suggestion
 *
 * CQ2-BE3: preview an admin-confirmable, brand-derived handle suggestion for
 * the company champion. Derives a candidate from the company's name (falling
 * back to its domain) and reports whether it is available against the
 * never-recycle store + reserved words. COMMITS NOTHING — the admin confirms by
 * claiming the suggested handle via PUT /admin/company/champion/handle. The
 * mint default is NOT changed: a brand handle is opt-in via this suggest→confirm
 * flow, never silently auto-claimed. Owner = (company, user.admin_company),
 * router-injected — never spread from the body.
 */
export const companiesGetCompanyChampionHandleSuggestionOptions = (options?: Options<CompaniesGetCompanyChampionHandleSuggestionData>) => queryOptions<CompaniesGetCompanyChampionHandleSuggestionResponse, DefaultError, CompaniesGetCompanyChampionHandleSuggestionResponse, ReturnType<typeof companiesGetCompanyChampionHandleSuggestionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyChampionHandleSuggestion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyChampionHandleSuggestionQueryKey(options)
});

export const companiesDownloadCompanyChampionQrQueryKey = (options: Options<CompaniesDownloadCompanyChampionQrData>) => createQueryKey('companies-download_company_champion_qr', options);

/**
 * Download Company Champion Qr
 *
 * CQ2-BE2b: render + download the company's OWN champion QR in
 * `{format}` ∈ {svg, png, pdf}. The company-admin analogue of
 * `download_my_champion_qr`: owner = (company, user.admin_company),
 * router-injected — never request-supplied. All three formats derive from the
 * one hand-built SVG. Gated dark by `CHAMPION_GIVE_HOST_ENABLED` (404 off);
 * per-IP rate limit FAILS CLOSED and runs BEFORE the render. With
 * `QR_ENTITY_LOGO_ENABLED` on, a design that chose the entity logo draws the
 * company's own stored logo (CQ3-BE6); off, the Givmo mark, as before.
 */
export const companiesDownloadCompanyChampionQrOptions = (options: Options<CompaniesDownloadCompanyChampionQrData>) => queryOptions<CompaniesDownloadCompanyChampionQrResponse, CompaniesDownloadCompanyChampionQrError, CompaniesDownloadCompanyChampionQrResponse, ReturnType<typeof companiesDownloadCompanyChampionQrQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesDownloadCompanyChampionQr({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesDownloadCompanyChampionQrQueryKey(options)
});

/**
 * Upload Company Cover Picture
 */
export const companiesUploadCompanyCoverPictureMutation = (options?: Partial<Options<CompaniesUploadCompanyCoverPictureData>>): UseMutationOptions<CompaniesUploadCompanyCoverPictureResponse, CompaniesUploadCompanyCoverPictureError, Options<CompaniesUploadCompanyCoverPictureData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUploadCompanyCoverPictureResponse, CompaniesUploadCompanyCoverPictureError, Options<CompaniesUploadCompanyCoverPictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUploadCompanyCoverPicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Company Customer Id
 */
export const companiesUpdateCompanyCustomerIdMutation = (options?: Partial<Options<CompaniesUpdateCompanyCustomerIdData>>): UseMutationOptions<CompaniesUpdateCompanyCustomerIdResponse, CompaniesUpdateCompanyCustomerIdError, Options<CompaniesUpdateCompanyCustomerIdData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyCustomerIdResponse, CompaniesUpdateCompanyCustomerIdError, Options<CompaniesUpdateCompanyCustomerIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyCustomerId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyDashboardQueryKey = (options?: Options<CompaniesGetCompanyDashboardData>) => createQueryKey('companies-get_company_dashboard', options);

/**
 * Get Company Dashboard
 */
export const companiesGetCompanyDashboardOptions = (options?: Options<CompaniesGetCompanyDashboardData>) => queryOptions<CompaniesGetCompanyDashboardResponse, CompaniesGetCompanyDashboardError, CompaniesGetCompanyDashboardResponse, ReturnType<typeof companiesGetCompanyDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyDashboardQueryKey(options)
});

export const companiesGetCompanyDonationVolumeQueryKey = (options?: Options<CompaniesGetCompanyDonationVolumeData>) => createQueryKey('companies-get_company_donation_volume', options);

/**
 * Get Company Donation Volume
 *
 * The company's matched-donation volume bucketed monthly (Jan → current
 * month, ET), current year vs prior year — its own endpoint so the heavier
 * group-by doesn't block the dashboard's first paint.
 */
export const companiesGetCompanyDonationVolumeOptions = (options?: Options<CompaniesGetCompanyDonationVolumeData>) => queryOptions<CompaniesGetCompanyDonationVolumeResponse, DefaultError, CompaniesGetCompanyDonationVolumeResponse, ReturnType<typeof companiesGetCompanyDonationVolumeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyDonationVolume({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyDonationVolumeQueryKey(options)
});

export const companiesGetCompanyTopCharitiesQueryKey = (options?: Options<CompaniesGetCompanyTopCharitiesData>) => createQueryKey('companies-get_company_top_charities', options);

/**
 * Get Company Top Charities
 *
 * The company's most contributed-to charities this year (matched union),
 * ranked by total contributed — its own endpoint for the same reason.
 */
export const companiesGetCompanyTopCharitiesOptions = (options?: Options<CompaniesGetCompanyTopCharitiesData>) => queryOptions<CompaniesGetCompanyTopCharitiesResponse, CompaniesGetCompanyTopCharitiesError, CompaniesGetCompanyTopCharitiesResponse, ReturnType<typeof companiesGetCompanyTopCharitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyTopCharities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyTopCharitiesQueryKey(options)
});

/**
 * Deactivate Company
 *
 * Deactivate the caller's company.
 *
 * OM-9 (D-CPO-32): once `ORG_DEACTIVATION_ENABLED` is on this is an ALIAS of
 * `POST /org/{org_ref}/deactivate` — the same service, the same act (every
 * administrator's standing ends, sessions revoked, the org plane emptied, the
 * `company.status` dual-write applied), the same `company:deactivate` authority —
 * keeping the wire the employer portal and folder 35 of the e2e suite call today:
 * 204, no body. While the flag is off it is byte-identical to the legacy status
 * flip.
 */
export const companiesDeactivateCompanyMutation = (options?: Partial<Options<CompaniesDeactivateCompanyData>>): UseMutationOptions<CompaniesDeactivateCompanyResponse, DefaultError, Options<CompaniesDeactivateCompanyData>> => {
    const mutationOptions: UseMutationOptions<CompaniesDeactivateCompanyResponse, DefaultError, Options<CompaniesDeactivateCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesDeactivateCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesQuoteCompanyDonationQueryKey = (options: Options<CompaniesQuoteCompanyDonationData>) => createQueryKey('companies-quote_company_donation', options);

/**
 * Quote Company Donation
 *
 * CAM-BE13 (D-CAM-40): what a company-funded gift of `amount` would charge,
 * covered and not, priced by the resolution the gift itself uses (the stored
 * card's brand, the company's own cover-fees setting, its platform rate) — a saved
 * company card (`Credit Card` + `card_id`) or the company wallet (`Wallet`). The
 * same for every recipient. Member or Owner, like the gift. Moves no money.
 */
export const companiesQuoteCompanyDonationOptions = (options: Options<CompaniesQuoteCompanyDonationData>) => queryOptions<CompaniesQuoteCompanyDonationResponse, CompaniesQuoteCompanyDonationError, CompaniesQuoteCompanyDonationResponse, ReturnType<typeof companiesQuoteCompanyDonationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesQuoteCompanyDonation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesQuoteCompanyDonationQueryKey(options)
});

export const companiesGetCompanyDonationAmountQueryKey = (options: Options<CompaniesGetCompanyDonationAmountData>) => createQueryKey('companies-get_company_donation_amount', options);

/**
 * Get Company Donation Amount
 */
export const companiesGetCompanyDonationAmountOptions = (options: Options<CompaniesGetCompanyDonationAmountData>) => queryOptions<CompaniesGetCompanyDonationAmountResponse, CompaniesGetCompanyDonationAmountError, CompaniesGetCompanyDonationAmountResponse, ReturnType<typeof companiesGetCompanyDonationAmountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyDonationAmount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyDonationAmountQueryKey(options)
});

/**
 * Approve Donation Match
 */
export const companiesApproveDonationMatchMutation = (options?: Partial<Options<CompaniesApproveDonationMatchData>>): UseMutationOptions<CompaniesApproveDonationMatchResponse, CompaniesApproveDonationMatchError, Options<CompaniesApproveDonationMatchData>> => {
    const mutationOptions: UseMutationOptions<CompaniesApproveDonationMatchResponse, CompaniesApproveDonationMatchError, Options<CompaniesApproveDonationMatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesApproveDonationMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Donation Match
 */
export const companiesRejectDonationMatchMutation = (options?: Partial<Options<CompaniesRejectDonationMatchData>>): UseMutationOptions<CompaniesRejectDonationMatchResponse, CompaniesRejectDonationMatchError, Options<CompaniesRejectDonationMatchData>> => {
    const mutationOptions: UseMutationOptions<CompaniesRejectDonationMatchResponse, CompaniesRejectDonationMatchError, Options<CompaniesRejectDonationMatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesRejectDonationMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Employees From Company
 */
export const companiesRemoveEmployeesFromCompanyMutation = (options?: Partial<Options<CompaniesRemoveEmployeesFromCompanyData>>): UseMutationOptions<CompaniesRemoveEmployeesFromCompanyResponse, CompaniesRemoveEmployeesFromCompanyError, Options<CompaniesRemoveEmployeesFromCompanyData>> => {
    const mutationOptions: UseMutationOptions<CompaniesRemoveEmployeesFromCompanyResponse, CompaniesRemoveEmployeesFromCompanyError, Options<CompaniesRemoveEmployeesFromCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesRemoveEmployeesFromCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyEmployeesQueryKey = (options?: Options<CompaniesGetCompanyEmployeesData>) => createQueryKey('companies-get_company_employees', options);

/**
 * Get Company Employees
 */
export const companiesGetCompanyEmployeesOptions = (options?: Options<CompaniesGetCompanyEmployeesData>) => queryOptions<CompaniesGetCompanyEmployeesResponse, CompaniesGetCompanyEmployeesError, CompaniesGetCompanyEmployeesResponse, ReturnType<typeof companiesGetCompanyEmployeesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyEmployees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyEmployeesQueryKey(options)
});

/**
 * Import Company Employee Occasion Dates
 *
 * **Company admin only** (`company:send_gift_cards`): mass-import
 * employer-entered occasion dates from an uploaded CSV.
 *
 * Header required: `work_email,birthday,hire_date`. `birthday` is `MM-DD` with NO
 * YEAR (a value carrying one is REFUSED rather than truncated — the employer must
 * not believe Givmo stored a birth year it deliberately does not keep); `hire_date`
 * is `YYYY-MM-DD`. A blank cell leaves that date alone; the literal `-` clears it.
 *
 * Every row is echoed with its own outcome (`created` / `updated` / `unchanged` /
 * `unmatched` / `invalid`, with a reason). `unchanged` covers both a row that asked
 * for nothing (all cells blank) and a row that asked for exactly what is already
 * stored — so re-running the same HR export reports no-ops rather than phantom
 * updates. Unmatched and invalid rows do NOT fail the request: re-uploading an HR
 * export that spans several employers, or that has a few malformed lines, is the
 * normal case, and discarding the good rows with the bad would make the feature
 * unusable on real HR data. Matching is by `work_email` against THIS company's
 * roster only. Structural problems (wrong header, no data rows, too many rows) are
 * 400 — the caller cannot have meant those.
 *
 * **Applied per row, not atomically.** Each applied row commits on its own, so a
 * request that dies mid-file leaves the rows it already applied in place and the
 * rest untouched — there is no rollback of the whole upload. Re-upload the same
 * file to converge: every write is idempotent, so rows already applied come back
 * as `unchanged`. A 2xx response's counts describe what was applied, not an
 * all-or-nothing outcome.
 */
export const companiesImportCompanyEmployeeOccasionDatesMutation = (options?: Partial<Options<CompaniesImportCompanyEmployeeOccasionDatesData>>): UseMutationOptions<CompaniesImportCompanyEmployeeOccasionDatesResponse, CompaniesImportCompanyEmployeeOccasionDatesError, Options<CompaniesImportCompanyEmployeeOccasionDatesData>> => {
    const mutationOptions: UseMutationOptions<CompaniesImportCompanyEmployeeOccasionDatesResponse, CompaniesImportCompanyEmployeeOccasionDatesError, Options<CompaniesImportCompanyEmployeeOccasionDatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesImportCompanyEmployeeOccasionDates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Company Employee Occasion Dates
 *
 * **Company admin only** (`company:send_gift_cards`): set or clear ONE roster
 * employee's employer-entered occasion dates.
 *
 * ★ These columns are the ONLY date source any occasion program reads. The consumer
 * profile birthday is never consulted and is never a fallback (D-EP-27).
 *
 * The birthday is MONTH + DAY only — there is no year to supply, because none is
 * stored: a gift needs no age, and a date of birth encodes age, which is a protected
 * characteristic in employment. Absent-vs-null: an absent key is untouched, an
 * explicit `null` clears. The month/day pair must be set or cleared together. Flag
 * off -> 404; an employee not on this company's roster -> 404; a malformed date ->
 * 422 (uniformly — the calendar check and the Field bounds return the same status).
 *
 * The two 404s are told apart by `error_code`: the roster miss carries
 * `EMPLOYEE_NOT_ON_ROSTER`, the flag-off route 404 carries none. That asymmetry is
 * the contract — a client reads the code rather than the English message.
 */
export const companiesSetCompanyEmployeeOccasionDatesMutation = (options?: Partial<Options<CompaniesSetCompanyEmployeeOccasionDatesData>>): UseMutationOptions<CompaniesSetCompanyEmployeeOccasionDatesResponse, CompaniesSetCompanyEmployeeOccasionDatesError, Options<CompaniesSetCompanyEmployeeOccasionDatesData>> => {
    const mutationOptions: UseMutationOptions<CompaniesSetCompanyEmployeeOccasionDatesResponse, CompaniesSetCompanyEmployeeOccasionDatesError, Options<CompaniesSetCompanyEmployeeOccasionDatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesSetCompanyEmployeeOccasionDates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesListCompanyFundraisersQueryKey = (options?: Options<CompaniesListCompanyFundraisersData>) => createQueryKey('companies-list_company_fundraisers', options);

/**
 * List Company Fundraisers
 *
 * **Company admin only** (`company:manage_fundraisers`, Member-level): the
 * fundraisers OWNED by the acting admin's company (all statuses — a management
 * view). Flag off → 404; a non-admin / a caller without the permission → 403.
 */
export const companiesListCompanyFundraisersOptions = (options?: Options<CompaniesListCompanyFundraisersData>) => queryOptions<CompaniesListCompanyFundraisersResponse, DefaultError, CompaniesListCompanyFundraisersResponse, ReturnType<typeof companiesListCompanyFundraisersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesListCompanyFundraisers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesListCompanyFundraisersQueryKey(options)
});

/**
 * Create Company Fundraiser
 *
 * **Company admin only** (`company:manage_fundraisers`, Member-level): create a
 * fundraiser OWNED by the acting admin's company (D-EP-9 = Path B). REUSES the
 * existing fundraiser creation lifecycle unmodified — same `FundraiserCreate` body,
 * same DRAFT + item-split + cardinality cap — only stamping `owner_company_id`
 * (router-injected from `user.admin_company`, never the body). The acting admin
 * remains the fundraiser's `creator_user_id` / OWNER member of record. The response
 * is the private owner shape `POST /fundraisers` answers (CAM-BE12), carrying the
 * `owner_company` byline, and the org contact offer while
 * `FUNDRAISER_ORG_CONTACT_ENABLED` is on. Flag off → 404; a non-admin / a caller
 * without the permission → 403. NOT a money route (fundraiser CRUD touches no
 * wallet).
 */
export const companiesCreateCompanyFundraiserMutation = (options?: Partial<Options<CompaniesCreateCompanyFundraiserData>>): UseMutationOptions<CompaniesCreateCompanyFundraiserResponse, CompaniesCreateCompanyFundraiserError, Options<CompaniesCreateCompanyFundraiserData>> => {
    const mutationOptions: UseMutationOptions<CompaniesCreateCompanyFundraiserResponse, CompaniesCreateCompanyFundraiserError, Options<CompaniesCreateCompanyFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesCreateCompanyFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesListCompanyGiftCardsQueryKey = (options?: Options<CompaniesListCompanyGiftCardsData>) => createQueryKey('companies-list_company_gift_cards', options);

/**
 * List Company Gift Cards
 *
 * **Company admin only** (`company:send_gift_cards`, Member-level): the gift
 * cards this company has sent (COMPANY_CARD + COMPANY_WALLET), newest-first by
 * default, with per-card status. Flag off → 404; a non-admin / a caller without
 * the permission → 403. The response maps each card to `CompanyGiftCardOut` and
 * NEVER carries a plaintext code / `code_hash` / the recipient's account id (mirrors
 * the consumer sent-list privacy scoping, GC2-BE3).
 */
export const companiesListCompanyGiftCardsOptions = (options?: Options<CompaniesListCompanyGiftCardsData>) => queryOptions<CompaniesListCompanyGiftCardsResponse, CompaniesListCompanyGiftCardsError, CompaniesListCompanyGiftCardsResponse, ReturnType<typeof companiesListCompanyGiftCardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesListCompanyGiftCards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesListCompanyGiftCardsQueryKey(options)
});

/**
 * Send Company Gift Card
 *
 * **Company admin only** (`company:send_gift_cards`, Member-level, D-EP-5):
 * send a company-funded gift card to a roster employee (EP-BE2 v1 — a SINGLE
 * recipient). `funding_source` selects COMPANY_CARD (charges the company's Shift4
 * customer; a company-named Variant-A receipt lands with the acting admin) or
 * COMPANY_WALLET (debits the company wallet; receipt-less). Floors ($15–$1,000) +
 * the employer per-company velocity cap (D-EP-6) bind; the recipient employee
 * never gets a receipt. Flag off → 404; a non-admin / a caller without the
 * permission → 403; a floor violation → 422 (a body-schema bound); an off-roster
 * recipient → 400. The response is privacy-scoped (`CompanyGiftCardOut`) and
 * NEVER carries the plaintext code.
 */
export const companiesSendCompanyGiftCardMutation = (options?: Partial<Options<CompaniesSendCompanyGiftCardData>>): UseMutationOptions<CompaniesSendCompanyGiftCardResponse, CompaniesSendCompanyGiftCardError, Options<CompaniesSendCompanyGiftCardData>> => {
    const mutationOptions: UseMutationOptions<CompaniesSendCompanyGiftCardResponse, CompaniesSendCompanyGiftCardError, Options<CompaniesSendCompanyGiftCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesSendCompanyGiftCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesListCompanyGiftCardBatchesQueryKey = (options?: Options<CompaniesListCompanyGiftCardBatchesData>) => createQueryKey('companies-list_company_gift_card_batches', options);

/**
 * List Company Gift Card Batches
 *
 * **Company admin only** (`company:send_gift_cards`): the bulk-gift batches this
 * company has created, newest-first by default. Flag off → 404; a non-admin → 403.
 * Each batch maps to `CompanyGiftCardBatchOut` (summary only — no charge/idempotency
 * internals) and carries its DERIVED per-status `delivery_counts` (EP-WEB-B8), so a
 * list-only client can spot failed deliveries without a detail call per batch.
 */
export const companiesListCompanyGiftCardBatchesOptions = (options?: Options<CompaniesListCompanyGiftCardBatchesData>) => queryOptions<CompaniesListCompanyGiftCardBatchesResponse, CompaniesListCompanyGiftCardBatchesError, CompaniesListCompanyGiftCardBatchesResponse, ReturnType<typeof companiesListCompanyGiftCardBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesListCompanyGiftCardBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesListCompanyGiftCardBatchesQueryKey(options)
});

/**
 * Send Company Gift Card Batch
 *
 * **Company admin only** (`company:send_gift_cards`, Member-level): bulk-send N
 * company-funded gift cards of a uniform `denomination` to roster employees (EP-BE3).
 * ALL-OR-NOTHING — every recipient is validated against the company roster BEFORE any
 * money moves, then ONE COMPANY_CARD charge (or ONE COMPANY_WALLET withdraw) for the
 * batch total mints all N cards; delivery is async per card. Flag off → 404; a
 * non-admin / a caller without the permission → 403; an off-roster recipient set →
 * 422 with a per-entry `invalid_recipients` list; the per-batch count cap or the
 * employer velocity cap → 429/400. The response is the batch summary
 * (`CompanyGiftCardBatchOut`) and NEVER carries a plaintext code.
 */
export const companiesSendCompanyGiftCardBatchMutation = (options?: Partial<Options<CompaniesSendCompanyGiftCardBatchData>>): UseMutationOptions<CompaniesSendCompanyGiftCardBatchResponse, CompaniesSendCompanyGiftCardBatchError, Options<CompaniesSendCompanyGiftCardBatchData>> => {
    const mutationOptions: UseMutationOptions<CompaniesSendCompanyGiftCardBatchResponse, CompaniesSendCompanyGiftCardBatchError, Options<CompaniesSendCompanyGiftCardBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesSendCompanyGiftCardBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyGiftCardBatchQueryKey = (options: Options<CompaniesGetCompanyGiftCardBatchData>) => createQueryKey('companies-get_company_gift_card_batch', options);

/**
 * Get Company Gift Card Batch
 *
 * **Company admin only** (`company:send_gift_cards`): a batch's detail — the
 * summary + the DERIVED per-status delivery counts + every card (reusing
 * `CompanyGiftCardOut`, which carries `delivery_status`). Flag off → 404; a
 * non-admin → 403; a missing / not-this-company's batch → 404 (cross-company
 * isolation). NEVER carries a plaintext code / `code_hash` / the recipient's account
 * id.
 */
export const companiesGetCompanyGiftCardBatchOptions = (options: Options<CompaniesGetCompanyGiftCardBatchData>) => queryOptions<CompaniesGetCompanyGiftCardBatchResponse, CompaniesGetCompanyGiftCardBatchError, CompaniesGetCompanyGiftCardBatchResponse, ReturnType<typeof companiesGetCompanyGiftCardBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyGiftCardBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyGiftCardBatchQueryKey(options)
});

export const companiesGetCompanyGivingPublicationQueryKey = (options?: Options<CompaniesGetCompanyGivingPublicationData>) => createQueryKey('companies-get_company_giving_publication', options);

/**
 * Get Company Giving Publication
 *
 * CW-BE6: what this company currently publishes about its giving.
 *
 * Returns the unpublished zero-state (default modules, `published=false`,
 * `widget_id=null`) when the company has never saved — the screen is always
 * reachable and a read never writes a row.
 */
export const companiesGetCompanyGivingPublicationOptions = (options?: Options<CompaniesGetCompanyGivingPublicationData>) => queryOptions<CompaniesGetCompanyGivingPublicationResponse, DefaultError, CompaniesGetCompanyGivingPublicationResponse, ReturnType<typeof companiesGetCompanyGivingPublicationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyGivingPublication({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyGivingPublicationQueryKey(options)
});

/**
 * Save Company Giving Publication
 *
 * CW-BE6: publish / unpublish and choose which blocks are disclosed.
 *
 * A whole-state PUT, not a PATCH: this is a consent screen, so an Owner
 * submitting it restates exactly what may be shown. The company is
 * router-injected from `user.admin_company` — never spread from the body.
 */
export const companiesSaveCompanyGivingPublicationMutation = (options?: Partial<Options<CompaniesSaveCompanyGivingPublicationData>>): UseMutationOptions<CompaniesSaveCompanyGivingPublicationResponse, CompaniesSaveCompanyGivingPublicationError, Options<CompaniesSaveCompanyGivingPublicationData>> => {
    const mutationOptions: UseMutationOptions<CompaniesSaveCompanyGivingPublicationResponse, CompaniesSaveCompanyGivingPublicationError, Options<CompaniesSaveCompanyGivingPublicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesSaveCompanyGivingPublication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesExportCompanyImpactCsvQueryKey = (options?: Options<CompaniesExportCompanyImpactCsvData>) => createQueryKey('companies-export_company_impact_csv', options);

/**
 * Export Company Impact Csv
 *
 * EP-WEB-B5: every charity the company contributed to this ET year to date,
 * ranked by total — UNCAPPED.
 *
 * The dashboard card's read is hard-bounded to `limit <= 50`, so a client-assembled
 * file would silently be a top-50 while a company can support more. This one takes
 * no limit, so it can honestly be titled "charities supported". Matched-union
 * basis, so the CSV and the dashboard card agree.
 */
export const companiesExportCompanyImpactCsvOptions = (options?: Options<CompaniesExportCompanyImpactCsvData>) => queryOptions<CompaniesExportCompanyImpactCsvResponse, DefaultError, CompaniesExportCompanyImpactCsvResponse, ReturnType<typeof companiesExportCompanyImpactCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesExportCompanyImpactCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesExportCompanyImpactCsvQueryKey(options)
});

export const companiesListCompanyEmployeeInvitesQueryKey = (options?: Options<CompaniesListCompanyEmployeeInvitesData>) => createQueryKey('companies-list_company_employee_invites', options);

/**
 * List Company Employee Invites
 *
 * EP-WEB-B7: the company's invites, newest-first with INVITED first, optionally
 * filtered to one status.
 *
 * The response is the standard paginated envelope plus a `counts` key carrying
 * per-status totals computed over ALL invites — deliberately independent of this
 * page and this filter, because a count derived from the returned rows would
 * understate the totals exactly when a summary row matters.
 */
export const companiesListCompanyEmployeeInvitesOptions = (options?: Options<CompaniesListCompanyEmployeeInvitesData>) => queryOptions<CompaniesListCompanyEmployeeInvitesResponse, CompaniesListCompanyEmployeeInvitesError, CompaniesListCompanyEmployeeInvitesResponse, ReturnType<typeof companiesListCompanyEmployeeInvitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesListCompanyEmployeeInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesListCompanyEmployeeInvitesQueryKey(options)
});

/**
 * Create Company Employee Invites
 *
 * EP-WEB-B7: bulk-invite email addresses to enrol as employees.
 *
 * Dedupes against BOTH the roster and existing live invites, and partitions the
 * result into `created` / `already_invited` / `already_enrolled` so the portal can
 * tell the admin exactly what happened. Re-pasting an overlapping spreadsheet is a
 * normal 201, not an error — and an address that already holds a live invite is
 * NOT re-emailed here (resend is its own cooldown-guarded route), so a re-paste
 * cannot mail-bomb anyone.
 *
 * An invite records that the company ASKED someone. It grants no membership and
 * shortcuts no work-email verification — the invitee still enrols through the
 * normal OTP flow.
 */
export const companiesCreateCompanyEmployeeInvitesMutation = (options?: Partial<Options<CompaniesCreateCompanyEmployeeInvitesData>>): UseMutationOptions<CompaniesCreateCompanyEmployeeInvitesResponse, CompaniesCreateCompanyEmployeeInvitesError, Options<CompaniesCreateCompanyEmployeeInvitesData>> => {
    const mutationOptions: UseMutationOptions<CompaniesCreateCompanyEmployeeInvitesResponse, CompaniesCreateCompanyEmployeeInvitesError, Options<CompaniesCreateCompanyEmployeeInvitesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesCreateCompanyEmployeeInvites({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyEmployeeInviteCountsQueryKey = (options?: Options<CompaniesGetCompanyEmployeeInviteCountsData>) => createQueryKey('companies-get_company_employee_invite_counts', options);

/**
 * Get Company Employee Invite Counts
 *
 * EP-WEB-B7: the per-status invite counts on their own.
 *
 * The list route above carries the same counts as a top-level sibling of the
 * pagination envelope, but a sibling key is not reliably reachable: the web
 * api-client middleware unwraps the envelope and drops everything beside it, so a
 * portal that wants only the summary would otherwise have to page the ENTIRE
 * invite list to add the rows up. This returns a PLAIN object — no pagination
 * envelope and no `data` wrapper — precisely so there is nothing for that
 * unwrapping to strip.
 *
 * Counts come from the SAME service helper the list uses, so the two routes can
 * never disagree, and like the list's they span ALL invites rather than a page.
 */
export const companiesGetCompanyEmployeeInviteCountsOptions = (options?: Options<CompaniesGetCompanyEmployeeInviteCountsData>) => queryOptions<CompaniesGetCompanyEmployeeInviteCountsResponse, DefaultError, CompaniesGetCompanyEmployeeInviteCountsResponse, ReturnType<typeof companiesGetCompanyEmployeeInviteCountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyEmployeeInviteCounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyEmployeeInviteCountsQueryKey(options)
});

/**
 * Resend Company Employee Invite
 *
 * EP-WEB-B7: re-send one invite's email.
 *
 * Only a pending (`INVITED`) invite can be resent, and a per-invite cooldown
 * measured from that invite's own `sent_at` stops a repeated click from
 * mail-bombing the invitee (400 inside the window). A missing invite and another
 * company's invite both return the same 404, so ids are not enumerable across
 * companies.
 */
export const companiesResendCompanyEmployeeInviteMutation = (options?: Partial<Options<CompaniesResendCompanyEmployeeInviteData>>): UseMutationOptions<CompaniesResendCompanyEmployeeInviteResponse, CompaniesResendCompanyEmployeeInviteError, Options<CompaniesResendCompanyEmployeeInviteData>> => {
    const mutationOptions: UseMutationOptions<CompaniesResendCompanyEmployeeInviteResponse, CompaniesResendCompanyEmployeeInviteError, Options<CompaniesResendCompanyEmployeeInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesResendCompanyEmployeeInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesListCompanyJoinRequestsQueryKey = (options?: Options<CompaniesListCompanyJoinRequestsData>) => createQueryKey('companies-list_company_join_requests', options);

/**
 * List Company Join Requests
 *
 * The Owner inbox — the company's join requests (PENDING first, paginated),
 * each enriched with the requester's identity. Owner-only (the service's
 * `company_admin:add` gate 403s a Member).
 */
export const companiesListCompanyJoinRequestsOptions = (options?: Options<CompaniesListCompanyJoinRequestsData>) => queryOptions<CompaniesListCompanyJoinRequestsResponse, CompaniesListCompanyJoinRequestsError, CompaniesListCompanyJoinRequestsResponse, ReturnType<typeof companiesListCompanyJoinRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesListCompanyJoinRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesListCompanyJoinRequestsQueryKey(options)
});

/**
 * Create Company Join Request
 *
 * File a PENDING request to join the company that owns the caller's verified
 * work-email domain (an Owner adjudicates — never auto-approved). Idempotent — an
 * existing PENDING request for this caller + company is returned unchanged. The
 * caller's Givmo user is provisioned inline when absent (the join half of the
 * create-or-join funnel).
 */
export const companiesCreateCompanyJoinRequestMutation = (options?: Partial<Options<CompaniesCreateCompanyJoinRequestData>>): UseMutationOptions<CompaniesCreateCompanyJoinRequestResponse, CompaniesCreateCompanyJoinRequestError, Options<CompaniesCreateCompanyJoinRequestData>> => {
    const mutationOptions: UseMutationOptions<CompaniesCreateCompanyJoinRequestResponse, CompaniesCreateCompanyJoinRequestError, Options<CompaniesCreateCompanyJoinRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesCreateCompanyJoinRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Company Join Request
 *
 * Approve one join request — the OWNER assigns the base role (Owner|Member).
 * Installs the requester as a company admin (+ the EP-SUITE1 dual-write mirror +
 * the requested product grant) atomically and idempotently.
 */
export const companiesApproveCompanyJoinRequestMutation = (options?: Partial<Options<CompaniesApproveCompanyJoinRequestData>>): UseMutationOptions<CompaniesApproveCompanyJoinRequestResponse, CompaniesApproveCompanyJoinRequestError, Options<CompaniesApproveCompanyJoinRequestData>> => {
    const mutationOptions: UseMutationOptions<CompaniesApproveCompanyJoinRequestResponse, CompaniesApproveCompanyJoinRequestError, Options<CompaniesApproveCompanyJoinRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesApproveCompanyJoinRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Company Join Request
 *
 * Reject one join request (optional Owner note). Owner-only.
 */
export const companiesRejectCompanyJoinRequestMutation = (options?: Partial<Options<CompaniesRejectCompanyJoinRequestData>>): UseMutationOptions<CompaniesRejectCompanyJoinRequestResponse, CompaniesRejectCompanyJoinRequestError, Options<CompaniesRejectCompanyJoinRequestData>> => {
    const mutationOptions: UseMutationOptions<CompaniesRejectCompanyJoinRequestResponse, CompaniesRejectCompanyJoinRequestError, Options<CompaniesRejectCompanyJoinRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesRejectCompanyJoinRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetUserLocationQueryKey = (options: Options<CompaniesGetUserLocationData>) => createQueryKey('companies-get_user_location', options);

/**
 * Get User Location
 */
export const companiesGetUserLocationOptions = (options: Options<CompaniesGetUserLocationData>) => queryOptions<CompaniesGetUserLocationResponse, CompaniesGetUserLocationError, CompaniesGetUserLocationResponse, ReturnType<typeof companiesGetUserLocationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetUserLocation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetUserLocationQueryKey(options)
});

export const companiesGetCompanyMatchUtilizationQueryKey = (options?: Options<CompaniesGetCompanyMatchUtilizationData>) => createQueryKey('companies-get_company_match_utilization', options);

/**
 * Get Company Match Utilization
 *
 * EP-WEB-B2: how much of the company's match budget is claimed this year.
 *
 * Read-only aggregation — no money moves. The numerator is the BUDGET-ENFORCEMENT
 * basis (approved matches only, the same tz-naive year the approval gate reads), NOT
 * the dashboard's ET-windowed `matched_ytd`, so this figure can never disagree with
 * the check that actually blocks an approval. `basis` names which denominator was
 * used (`aggregate_cap` | `per_employee_product` | `none`); `ratio` is null whenever
 * there is no denominator to divide by — a client must render an empty state, never
 * 0%. Its own endpoint (not a dashboard field) so the heavier approved-match scan
 * doesn't block the dashboard's first paint, matching the donation-volume and
 * top-charities reads.
 */
export const companiesGetCompanyMatchUtilizationOptions = (options?: Options<CompaniesGetCompanyMatchUtilizationData>) => queryOptions<CompaniesGetCompanyMatchUtilizationResponse, DefaultError, CompaniesGetCompanyMatchUtilizationResponse, ReturnType<typeof companiesGetCompanyMatchUtilizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyMatchUtilization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyMatchUtilizationQueryKey(options)
});

/**
 * Update Company Match Policy
 */
export const companiesUpdateCompanyMatchPolicyMutation = (options?: Partial<Options<CompaniesUpdateCompanyMatchPolicyData>>): UseMutationOptions<CompaniesUpdateCompanyMatchPolicyResponse, CompaniesUpdateCompanyMatchPolicyError, Options<CompaniesUpdateCompanyMatchPolicyData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyMatchPolicyResponse, CompaniesUpdateCompanyMatchPolicyError, Options<CompaniesUpdateCompanyMatchPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyMatchPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Group Company Matches
 */
export const donationMatchesApproveGroupCompanyMatchesMutation = (options?: Partial<Options<DonationMatchesApproveGroupCompanyMatchesData>>): UseMutationOptions<DonationMatchesApproveGroupCompanyMatchesResponse, DonationMatchesApproveGroupCompanyMatchesError, Options<DonationMatchesApproveGroupCompanyMatchesData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesApproveGroupCompanyMatchesResponse, DonationMatchesApproveGroupCompanyMatchesError, Options<DonationMatchesApproveGroupCompanyMatchesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesApproveGroupCompanyMatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationMatchesGetPendingGroupCompanyMatchesQueryKey = (options?: Options<DonationMatchesGetPendingGroupCompanyMatchesData>) => createQueryKey('donation-matches-get_pending_group_company_matches', options);

/**
 * Get Pending Group Company Matches
 */
export const donationMatchesGetPendingGroupCompanyMatchesOptions = (options?: Options<DonationMatchesGetPendingGroupCompanyMatchesData>) => queryOptions<DonationMatchesGetPendingGroupCompanyMatchesResponse, DonationMatchesGetPendingGroupCompanyMatchesError, DonationMatchesGetPendingGroupCompanyMatchesResponse, ReturnType<typeof donationMatchesGetPendingGroupCompanyMatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationMatchesGetPendingGroupCompanyMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationMatchesGetPendingGroupCompanyMatchesQueryKey(options)
});

/**
 * Reject Group Company Matches
 */
export const donationMatchesRejectGroupCompanyMatchesMutation = (options?: Partial<Options<DonationMatchesRejectGroupCompanyMatchesData>>): UseMutationOptions<DonationMatchesRejectGroupCompanyMatchesResponse, DonationMatchesRejectGroupCompanyMatchesError, Options<DonationMatchesRejectGroupCompanyMatchesData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesRejectGroupCompanyMatchesResponse, DonationMatchesRejectGroupCompanyMatchesError, Options<DonationMatchesRejectGroupCompanyMatchesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesRejectGroupCompanyMatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check Grouped Matches Allowed Amount
 */
export const donationMatchesCheckGroupedMatchesAllowedAmountMutation = (options?: Partial<Options<DonationMatchesCheckGroupedMatchesAllowedAmountData>>): UseMutationOptions<DonationMatchesCheckGroupedMatchesAllowedAmountResponse, DonationMatchesCheckGroupedMatchesAllowedAmountError, Options<DonationMatchesCheckGroupedMatchesAllowedAmountData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesCheckGroupedMatchesAllowedAmountResponse, DonationMatchesCheckGroupedMatchesAllowedAmountError, Options<DonationMatchesCheckGroupedMatchesAllowedAmountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesCheckGroupedMatchesAllowedAmount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Grouped Company Matches
 */
export const donationMatchesApproveGroupedCompanyMatchesMutation = (options?: Partial<Options<DonationMatchesApproveGroupedCompanyMatchesData>>): UseMutationOptions<DonationMatchesApproveGroupedCompanyMatchesResponse, DonationMatchesApproveGroupedCompanyMatchesError, Options<DonationMatchesApproveGroupedCompanyMatchesData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesApproveGroupedCompanyMatchesResponse, DonationMatchesApproveGroupedCompanyMatchesError, Options<DonationMatchesApproveGroupedCompanyMatchesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesApproveGroupedCompanyMatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Grouped Company Matches
 */
export const donationMatchesRejectGroupedCompanyMatchesMutation = (options?: Partial<Options<DonationMatchesRejectGroupedCompanyMatchesData>>): UseMutationOptions<DonationMatchesRejectGroupedCompanyMatchesResponse, DonationMatchesRejectGroupedCompanyMatchesError, Options<DonationMatchesRejectGroupedCompanyMatchesData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesRejectGroupedCompanyMatchesResponse, DonationMatchesRejectGroupedCompanyMatchesError, Options<DonationMatchesRejectGroupedCompanyMatchesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesRejectGroupedCompanyMatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationMatchesGetMatchRequestInboxQueryKey = (options?: Options<DonationMatchesGetMatchRequestInboxData>) => createQueryKey('donation-matches-get_match_request_inbox', options);

/**
 * Get Match Request Inbox
 *
 * Every pending match request of the admin's company, one row per request,
 * newest first, each naming its ``kind`` (``ordinary`` or ``group``).
 */
export const donationMatchesGetMatchRequestInboxOptions = (options?: Options<DonationMatchesGetMatchRequestInboxData>) => queryOptions<DonationMatchesGetMatchRequestInboxResponse, DefaultError, DonationMatchesGetMatchRequestInboxResponse, ReturnType<typeof donationMatchesGetMatchRequestInboxQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationMatchesGetMatchRequestInbox({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationMatchesGetMatchRequestInboxQueryKey(options)
});

/**
 * Check Match Request Allowed Amount
 */
export const donationMatchesCheckMatchRequestAllowedAmountMutation = (options?: Partial<Options<DonationMatchesCheckMatchRequestAllowedAmountData>>): UseMutationOptions<DonationMatchesCheckMatchRequestAllowedAmountResponse, DonationMatchesCheckMatchRequestAllowedAmountError, Options<DonationMatchesCheckMatchRequestAllowedAmountData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesCheckMatchRequestAllowedAmountResponse, DonationMatchesCheckMatchRequestAllowedAmountError, Options<DonationMatchesCheckMatchRequestAllowedAmountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesCheckMatchRequestAllowedAmount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Match Request
 *
 * Approve one inbox row; returns the company donations booked, one per match.
 */
export const donationMatchesApproveMatchRequestMutation = (options?: Partial<Options<DonationMatchesApproveMatchRequestData>>): UseMutationOptions<DonationMatchesApproveMatchRequestResponse, DonationMatchesApproveMatchRequestError, Options<DonationMatchesApproveMatchRequestData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesApproveMatchRequestResponse, DonationMatchesApproveMatchRequestError, Options<DonationMatchesApproveMatchRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesApproveMatchRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Match Request
 */
export const donationMatchesRejectMatchRequestMutation = (options?: Partial<Options<DonationMatchesRejectMatchRequestData>>): UseMutationOptions<DonationMatchesRejectMatchRequestResponse, DonationMatchesRejectMatchRequestError, Options<DonationMatchesRejectMatchRequestData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesRejectMatchRequestResponse, DonationMatchesRejectMatchRequestError, Options<DonationMatchesRejectMatchRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesRejectMatchRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationMatchesGetPendingMatchesGroupedQueryKey = (options?: Options<DonationMatchesGetPendingMatchesGroupedData>) => createQueryKey('donation-matches-get_pending_matches_grouped', options);

/**
 * Get Pending Matches Grouped
 *
 * Return the admin's pending match inbox grouped by ``post_id``.
 *
 * Non-grouped donations route to the per-donation endpoints; grouped
 * donations collapse to a single group whose ``match_ids`` covers every
 * sub-donation (route to the grouped batch endpoints below).
 */
export const donationMatchesGetPendingMatchesGroupedOptions = (options?: Options<DonationMatchesGetPendingMatchesGroupedData>) => queryOptions<DonationMatchesGetPendingMatchesGroupedResponse, DefaultError, DonationMatchesGetPendingMatchesGroupedResponse, ReturnType<typeof donationMatchesGetPendingMatchesGroupedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationMatchesGetPendingMatchesGrouped({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationMatchesGetPendingMatchesGroupedQueryKey(options)
});

/**
 * Quote Company Match Payment
 *
 * CAM-BE13 (D-CAM-40): what paying these approval units would charge, covered
 * and not, priced by the resolution the approvals themselves use (the stored
 * card's brand, the company's own cover-fees setting, its platform rate): the
 * totals, then each unit as its own approval charges it. A single or grouped
 * approval sends its one unit at the budget-capped amount, and Approve all every
 * unit at what approving them all in request order matches for it (EP-BE19's
 * `approvable`); its totals stay an upper bound, because a budget that moves while
 * the batch runs caps a leg again. A read that moves no money, so it claims no
 * idempotency key; POST only to carry the list.
 */
export const donationMatchesQuoteCompanyMatchPaymentMutation = (options?: Partial<Options<DonationMatchesQuoteCompanyMatchPaymentData>>): UseMutationOptions<DonationMatchesQuoteCompanyMatchPaymentResponse, DonationMatchesQuoteCompanyMatchPaymentError, Options<DonationMatchesQuoteCompanyMatchPaymentData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesQuoteCompanyMatchPaymentResponse, DonationMatchesQuoteCompanyMatchPaymentError, Options<DonationMatchesQuoteCompanyMatchPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesQuoteCompanyMatchPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationMatchesCheckCompanyMatchAllowedAmountQueryKey = (options: Options<DonationMatchesCheckCompanyMatchAllowedAmountData>) => createQueryKey('donation-matches-check_company_match_allowed_amount', options);

/**
 * Check Company Match Allowed Amount
 */
export const donationMatchesCheckCompanyMatchAllowedAmountOptions = (options: Options<DonationMatchesCheckCompanyMatchAllowedAmountData>) => queryOptions<DonationMatchesCheckCompanyMatchAllowedAmountResponse, DonationMatchesCheckCompanyMatchAllowedAmountError, DonationMatchesCheckCompanyMatchAllowedAmountResponse, ReturnType<typeof donationMatchesCheckCompanyMatchAllowedAmountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationMatchesCheckCompanyMatchAllowedAmount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationMatchesCheckCompanyMatchAllowedAmountQueryKey(options)
});

/**
 * Approve Company Match
 */
export const donationMatchesApproveCompanyMatchMutation = (options?: Partial<Options<DonationMatchesApproveCompanyMatchData>>): UseMutationOptions<DonationMatchesApproveCompanyMatchResponse, DonationMatchesApproveCompanyMatchError, Options<DonationMatchesApproveCompanyMatchData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesApproveCompanyMatchResponse, DonationMatchesApproveCompanyMatchError, Options<DonationMatchesApproveCompanyMatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesApproveCompanyMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationMatchesGetMatchPaymentDisclosureQueryKey = (options: Options<DonationMatchesGetMatchPaymentDisclosureData>) => createQueryKey('donation-matches-get_match_payment_disclosure', options);

/**
 * Get Match Payment Disclosure
 *
 * CAM-X3 — the donor disclosure an approver must be shown before paying this
 * match on ``funding`` (``card`` / ``wallet``): the company-payer body for the
 * match's target (charity → ``DONATE_CONFIRMATION``; ETF or collection →
 * ``CAUSE_ETF``; fundraiser → ``DONATE_CONFIRMATION`` by fundraiser id), derived
 * from the server's own records. Echo its ``id`` / ``content_hash`` on the approve
 * as ``shown_disclaimer_version_id`` / ``shown_disclaimer_content_hash``.
 *
 * Keyed by any of the request's match ids (a grouped request's legs share one
 * target; an inbox row's ``request_id`` is one of them). 404 when the match is not
 * this company's or nothing resolves. Same ``ETag`` / ``If-None-Match`` → 304 and
 * ``DisclaimerResolveOut`` shape as ``GET /disclaimers/resolve``.
 */
export const donationMatchesGetMatchPaymentDisclosureOptions = (options: Options<DonationMatchesGetMatchPaymentDisclosureData>) => queryOptions<DonationMatchesGetMatchPaymentDisclosureResponse, DonationMatchesGetMatchPaymentDisclosureError, DonationMatchesGetMatchPaymentDisclosureResponse, ReturnType<typeof donationMatchesGetMatchPaymentDisclosureQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationMatchesGetMatchPaymentDisclosure({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationMatchesGetMatchPaymentDisclosureQueryKey(options)
});

/**
 * Reject Company Match
 */
export const donationMatchesRejectCompanyMatchMutation = (options?: Partial<Options<DonationMatchesRejectCompanyMatchData>>): UseMutationOptions<DonationMatchesRejectCompanyMatchResponse, DonationMatchesRejectCompanyMatchError, Options<DonationMatchesRejectCompanyMatchData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesRejectCompanyMatchResponse, DonationMatchesRejectCompanyMatchError, Options<DonationMatchesRejectCompanyMatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesRejectCompanyMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyAdminQueryKey = (options?: Options<CompaniesGetCompanyAdminData>) => createQueryKey('companies-get_company_admin', options);

/**
 * Get Company Admin
 *
 * The caller's own company-admin record.
 *
 * EP-SUITE3 additions (`permissions`, `is_global_admin`, `product_access`) are
 * stamped onto the entity here rather than computed in `UserService`, because
 * they are a PROJECTION of the authorization seam rather than user state — the
 * same reason `admin_company_role` is stamped by `get_company_role`. They let a
 * client gate controls on what the caller may DO instead of inferring it from
 * the role string, which stopped being a sound inference once two Members of one
 * company could hold different permissions.
 *
 * Each `product_access` entry carries BOTH halves of the resolver's orthogonal
 * pair (see `ProductAccess`): `has_access` — does this admin hold the module —
 * and `enabled_for_company` — has the organization switched it on. Serializing
 * only the first collapses "you hold this, but the org turned it off" into an
 * ordinary link, so the console cannot render the state a Global Admin has to
 * see in order to know to flip it back. The org-level answer is resolved on
 * every path already; the wire name is the company instance's and matches what
 * the members roster serializes (`CompanyMemberProductAccessOut`) — the org
 * console renames the same fact to `enabled_for_org` at ITS projection.
 *
 * Deliberately NOT behind `COMPANY_CONSOLE_ENABLED`: the fields describe the
 * permissions the caller holds RIGHT NOW, which under default data are exactly
 * today's role set. Gating them would hide accurate information for no gain.
 *
 * OM-14 PR-BE1 (T5.4) adds the SAME three additive facts the org self read
 * carries, spelled into this projection so the company class — which reads its
 * standing here — gets them without a second observer: `capabilities` (the
 * class-independent capability names the caller satisfies), a top-level
 * `pending_access_requests` (OMITTED at zero authority), and per-module
 * `access_request` / `pending_access_requests` inside `product_access` (omitted
 * when they do not apply). They are computed by the org console service from the
 * resolution above — one computation, two standing reads. The route serializes
 * the model ITSELF so the omission idiom survives (`response_model_exclude_none`
 * would also drop this route's long-standing nulls, which is not additive).
 */
export const companiesGetCompanyAdminOptions = (options?: Options<CompaniesGetCompanyAdminData>) => queryOptions<CompaniesGetCompanyAdminResponse, DefaultError, CompaniesGetCompanyAdminResponse, ReturnType<typeof companiesGetCompanyAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyAdminQueryKey(options)
});

export const companiesListCompanyOccasionProgramsQueryKey = (options?: Options<CompaniesListCompanyOccasionProgramsData>) => createQueryKey('companies-list_company_occasion_programs', options);

/**
 * List Company Occasion Programs
 *
 * **Company admin only** (`company:send_gift_cards`): the company's occasion
 * programs (all statuses — a management view), ACTIVE first.
 *
 * A program is a RULE, so the response carries no employee data and in particular
 * no employee's date: the portal renders "on each employee's birthday", never a
 * list of birthdays.
 */
export const companiesListCompanyOccasionProgramsOptions = (options?: Options<CompaniesListCompanyOccasionProgramsData>) => queryOptions<CompaniesListCompanyOccasionProgramsResponse, CompaniesListCompanyOccasionProgramsError, CompaniesListCompanyOccasionProgramsResponse, ReturnType<typeof companiesListCompanyOccasionProgramsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesListCompanyOccasionPrograms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesListCompanyOccasionProgramsQueryKey(options)
});

/**
 * Create Company Occasion Program
 *
 * **Company admin only** (`company:send_gift_cards`, Member-level): author one
 * standing occasion rule (EP-BE8).
 *
 * A COMPANY_CARD program requires a saved `card_id` at authoring — no admin is
 * present when it charges, so "pick a card later" has no later. At most ONE ACTIVE
 * program per occasion type per company (409 otherwise): two live birthday rules
 * would silently double-spend on every birthday. Flag off -> 404; a non-admin /
 * a caller without the permission -> 403; a denomination outside $15-$1,000 -> 422
 * (a body-schema bound).
 */
export const companiesCreateCompanyOccasionProgramMutation = (options?: Partial<Options<CompaniesCreateCompanyOccasionProgramData>>): UseMutationOptions<CompaniesCreateCompanyOccasionProgramResponse, CompaniesCreateCompanyOccasionProgramError, Options<CompaniesCreateCompanyOccasionProgramData>> => {
    const mutationOptions: UseMutationOptions<CompaniesCreateCompanyOccasionProgramResponse, CompaniesCreateCompanyOccasionProgramError, Options<CompaniesCreateCompanyOccasionProgramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesCreateCompanyOccasionProgram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyOccasionPreflightQueryKey = (options?: Options<CompaniesGetCompanyOccasionPreflightData>) => createQueryKey('companies-get_company_occasion_preflight', options);

/**
 * Get Company Occasion Preflight
 *
 * **Company admin only** (`company:send_gift_cards`): upcoming-occasion funding
 * health, so the portal can warn BEFORE an occasion day fails.
 *
 * Per ACTIVE program: how many occasions fall in the horizon, what they will cost,
 * and whether the funding source can cover it (wallet available balance, or a saved
 * card's presence). Plus the count of executions currently HELD — money the company
 * still owes its employees, which the portal must not hide.
 *
 * A PURE READ: no lock, no reservation, no money. `sufficient` is therefore
 * ADVISORY — the real gate is the executor's own available-balance check under the
 * wallet row lock at spend time, and the shared employer velocity window can be
 * spent by an attended send in between.
 */
export const companiesGetCompanyOccasionPreflightOptions = (options?: Options<CompaniesGetCompanyOccasionPreflightData>) => queryOptions<CompaniesGetCompanyOccasionPreflightResponse, CompaniesGetCompanyOccasionPreflightError, CompaniesGetCompanyOccasionPreflightResponse, ReturnType<typeof companiesGetCompanyOccasionPreflightQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyOccasionPreflight({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyOccasionPreflightQueryKey(options)
});

/**
 * Update Company Occasion Program
 *
 * **Company admin only** (`company:send_gift_cards`): edit a program's
 * denomination, message, saved card, or receipt designee.
 *
 * PATCH absent-vs-null: an absent key is untouched, an explicit `null` clears the
 * value. The occasion TYPE and the funding SOURCE are deliberately not editable —
 * both change what the program fundamentally is (and funding changes the money rail
 * and the receipt disposition), so switching either means authoring a new program.
 * A card-funded program's card cannot be cleared (pause it instead). An edit never
 * reaches an occurrence already executed: that fence is terminal. Flag off -> 404;
 * a missing / another company's program -> 404.
 */
export const companiesUpdateCompanyOccasionProgramMutation = (options?: Partial<Options<CompaniesUpdateCompanyOccasionProgramData>>): UseMutationOptions<CompaniesUpdateCompanyOccasionProgramResponse, CompaniesUpdateCompanyOccasionProgramError, Options<CompaniesUpdateCompanyOccasionProgramData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyOccasionProgramResponse, CompaniesUpdateCompanyOccasionProgramError, Options<CompaniesUpdateCompanyOccasionProgramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyOccasionProgram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesListCompanyOccasionExecutionsQueryKey = (options: Options<CompaniesListCompanyOccasionExecutionsData>) => createQueryKey('companies-list_company_occasion_executions', options);

/**
 * List Company Occasion Executions
 *
 * **Company admin only** (`company:send_gift_cards`): one program's executions —
 * the HELD-state surface.
 *
 * An admin must be able to see that today's gifts did not go out and why, because
 * the money either moved or is still owed; a HELD row carries its typed
 * `held_reason` and is retried by every subsequent sweep.
 *
 * DELIVERY-ONLY (D-EP-17): rows carry `gift_card_id` / `batch_id` so the portal can
 * join to the existing delivery report, and carry NO redemption state — whether an
 * employee has spent their gift is not the employer's business, exactly as the
 * employer sent-list already establishes.
 */
export const companiesListCompanyOccasionExecutionsOptions = (options: Options<CompaniesListCompanyOccasionExecutionsData>) => queryOptions<CompaniesListCompanyOccasionExecutionsResponse, CompaniesListCompanyOccasionExecutionsError, CompaniesListCompanyOccasionExecutionsResponse, ReturnType<typeof companiesListCompanyOccasionExecutionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesListCompanyOccasionExecutions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesListCompanyOccasionExecutionsQueryKey(options)
});

/**
 * Pause Company Occasion Program
 *
 * **Company admin only** (`company:send_gift_cards`): stop the daily sweep
 * considering this program. Idempotent, so a double-click is safe.
 *
 * Pausing stops FUTURE occasions. It does not cancel money already owed: HELD
 * executions from earlier occasions stay HELD and stay visible, because the
 * employer still owes those gifts.
 */
export const companiesPauseCompanyOccasionProgramMutation = (options?: Partial<Options<CompaniesPauseCompanyOccasionProgramData>>): UseMutationOptions<CompaniesPauseCompanyOccasionProgramResponse, CompaniesPauseCompanyOccasionProgramError, Options<CompaniesPauseCompanyOccasionProgramData>> => {
    const mutationOptions: UseMutationOptions<CompaniesPauseCompanyOccasionProgramResponse, CompaniesPauseCompanyOccasionProgramError, Options<CompaniesPauseCompanyOccasionProgramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesPauseCompanyOccasionProgram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Company Occasion Program
 *
 * **Company admin only** (`company:send_gift_cards`): return the program to the
 * daily sweep. 409 when another ACTIVE program already covers that occasion.
 *
 * Resuming does not back-fill occasions that passed while paused — a pause is a
 * real stop, not a deferral.
 */
export const companiesResumeCompanyOccasionProgramMutation = (options?: Partial<Options<CompaniesResumeCompanyOccasionProgramData>>): UseMutationOptions<CompaniesResumeCompanyOccasionProgramResponse, CompaniesResumeCompanyOccasionProgramError, Options<CompaniesResumeCompanyOccasionProgramData>> => {
    const mutationOptions: UseMutationOptions<CompaniesResumeCompanyOccasionProgramResponse, CompaniesResumeCompanyOccasionProgramError, Options<CompaniesResumeCompanyOccasionProgramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesResumeCompanyOccasionProgram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companyAdminProfilePageGetCompanyPageQueryKey = (options?: Options<CompanyAdminProfilePageGetCompanyPageData>) => createQueryKey('company-admin-profile-page-get_company_page', options);

/**
 * Get Company Page
 *
 * The company's OWNER view of its page (``profile:read``).
 */
export const companyAdminProfilePageGetCompanyPageOptions = (options?: Options<CompanyAdminProfilePageGetCompanyPageData>) => queryOptions<CompanyAdminProfilePageGetCompanyPageResponse, DefaultError, CompanyAdminProfilePageGetCompanyPageResponse, ReturnType<typeof companyAdminProfilePageGetCompanyPageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companyAdminProfilePageGetCompanyPage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companyAdminProfilePageGetCompanyPageQueryKey(options)
});

/**
 * Replace Company Page
 *
 * The id-preserving full-list replace (``profile:write``; the company must be
 * ACTIVE).
 */
export const companyAdminProfilePageReplaceCompanyPageMutation = (options?: Partial<Options<CompanyAdminProfilePageReplaceCompanyPageData>>): UseMutationOptions<CompanyAdminProfilePageReplaceCompanyPageResponse, CompanyAdminProfilePageReplaceCompanyPageError, Options<CompanyAdminProfilePageReplaceCompanyPageData>> => {
    const mutationOptions: UseMutationOptions<CompanyAdminProfilePageReplaceCompanyPageResponse, CompanyAdminProfilePageReplaceCompanyPageError, Options<CompanyAdminProfilePageReplaceCompanyPageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companyAdminProfilePageReplaceCompanyPage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Company Page Image
 *
 * Upload one page image under ``company/{company_id}/page/…``.
 */
export const companyAdminProfilePageUploadCompanyPageImageMutation = (options?: Partial<Options<CompanyAdminProfilePageUploadCompanyPageImageData>>): UseMutationOptions<CompanyAdminProfilePageUploadCompanyPageImageResponse, CompanyAdminProfilePageUploadCompanyPageImageError, Options<CompanyAdminProfilePageUploadCompanyPageImageData>> => {
    const mutationOptions: UseMutationOptions<CompanyAdminProfilePageUploadCompanyPageImageResponse, CompanyAdminProfilePageUploadCompanyPageImageError, Options<CompanyAdminProfilePageUploadCompanyPageImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companyAdminProfilePageUploadCompanyPageImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Company Payment Method
 */
export const companiesUpdateCompanyPaymentMethodMutation = (options?: Partial<Options<CompaniesUpdateCompanyPaymentMethodData>>): UseMutationOptions<CompaniesUpdateCompanyPaymentMethodResponse, CompaniesUpdateCompanyPaymentMethodError, Options<CompaniesUpdateCompanyPaymentMethodData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyPaymentMethodResponse, CompaniesUpdateCompanyPaymentMethodError, Options<CompaniesUpdateCompanyPaymentMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyPaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable Company Product
 *
 * An Owner enables an additional Givmo product on their OWN company
 * membership (the first non-`employer` grant writer; BMC's business portal
 * consumes this). Idempotent. Owner-only (the service's `company:edit` gate).
 */
export const companiesEnableCompanyProductMutation = (options?: Partial<Options<CompaniesEnableCompanyProductData>>): UseMutationOptions<CompaniesEnableCompanyProductResponse, CompaniesEnableCompanyProductError, Options<CompaniesEnableCompanyProductData>> => {
    const mutationOptions: UseMutationOptions<CompaniesEnableCompanyProductResponse, CompaniesEnableCompanyProductError, Options<CompaniesEnableCompanyProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesEnableCompanyProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Company Profile Picture
 */
export const companiesUploadCompanyProfilePictureMutation = (options?: Partial<Options<CompaniesUploadCompanyProfilePictureData>>): UseMutationOptions<CompaniesUploadCompanyProfilePictureResponse, CompaniesUploadCompanyProfilePictureError, Options<CompaniesUploadCompanyProfilePictureData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUploadCompanyProfilePictureResponse, CompaniesUploadCompanyProfilePictureError, Options<CompaniesUploadCompanyProfilePictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUploadCompanyProfilePicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyQrDesignQueryKey = (options?: Options<CompaniesGetCompanyQrDesignData>) => createQueryKey('companies-get_company_qr_design', options);

/**
 * Get Company Qr Design
 *
 * CQ1-BE1: the company's saved QR design spec, or DEFAULT_GIVMO_PRESET when
 * none is saved. Separate from the user surface; does NOT touch
 * GET /admin/company / CompanyDetailedOut.
 */
export const companiesGetCompanyQrDesignOptions = (options?: Options<CompaniesGetCompanyQrDesignData>) => queryOptions<CompaniesGetCompanyQrDesignResponse, DefaultError, CompaniesGetCompanyQrDesignResponse, ReturnType<typeof companiesGetCompanyQrDesignQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyQrDesign({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyQrDesignQueryKey(options)
});

/**
 * Save Company Qr Design
 *
 * CQ1-BE1: upsert the company's QR design spec (validated by `QrDesignSpec`)
 * and return the stored spec. owner = (company, user.admin_company),
 * router-injected — never spread from the body.
 */
export const companiesSaveCompanyQrDesignMutation = (options?: Partial<Options<CompaniesSaveCompanyQrDesignData>>): UseMutationOptions<CompaniesSaveCompanyQrDesignResponse, CompaniesSaveCompanyQrDesignError, Options<CompaniesSaveCompanyQrDesignData>> => {
    const mutationOptions: UseMutationOptions<CompaniesSaveCompanyQrDesignResponse, CompaniesSaveCompanyQrDesignError, Options<CompaniesSaveCompanyQrDesignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesSaveCompanyQrDesign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyFundraiserReportQueryKey = (options?: Options<CompaniesGetCompanyFundraiserReportData>) => createQueryKey('companies-get_company_fundraiser_report', options);

/**
 * Get Company Fundraiser Report
 */
export const companiesGetCompanyFundraiserReportOptions = (options?: Options<CompaniesGetCompanyFundraiserReportData>) => queryOptions<CompaniesGetCompanyFundraiserReportResponse, CompaniesGetCompanyFundraiserReportError, CompaniesGetCompanyFundraiserReportResponse, ReturnType<typeof companiesGetCompanyFundraiserReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyFundraiserReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyFundraiserReportQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const companiesGetCompanyFundraiserReportInfiniteQueryKey = (options?: Options<CompaniesGetCompanyFundraiserReportData>): QueryKey<Options<CompaniesGetCompanyFundraiserReportData>> => createQueryKey('companies-get_company_fundraiser_report', options, true);

/**
 * Get Company Fundraiser Report
 */
export const companiesGetCompanyFundraiserReportInfiniteOptions = (options?: Options<CompaniesGetCompanyFundraiserReportData>) => {
    const opts = infiniteQueryOptions<CompaniesGetCompanyFundraiserReportResponse, CompaniesGetCompanyFundraiserReportError, InfiniteData<CompaniesGetCompanyFundraiserReportResponse>, QueryKey<Options<CompaniesGetCompanyFundraiserReportData>>, number | Pick<QueryKey<Options<CompaniesGetCompanyFundraiserReportData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CompaniesGetCompanyFundraiserReportData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await companiesGetCompanyFundraiserReport({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: companiesGetCompanyFundraiserReportInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Resolve Company Onboarding Route
 *
 * Resolve the onboarding branch for a signed-in caller (create / request
 * access / already-member / enable-product / blocked). The caller's VERIFIED
 * email is read from the Firebase ID token (`request.state.idp_user`), NEVER the
 * body; an unverified/absent email is a 403 (a verified work email is required
 * to resolve). For a request-access branch the response carries the target
 * company's display name + per-request signed logo ONLY — never its roster.
 */
export const companiesResolveCompanyOnboardingRouteMutation = (options?: Partial<Options<CompaniesResolveCompanyOnboardingRouteData>>): UseMutationOptions<CompaniesResolveCompanyOnboardingRouteResponse, DefaultError, Options<CompaniesResolveCompanyOnboardingRouteData>> => {
    const mutationOptions: UseMutationOptions<CompaniesResolveCompanyOnboardingRouteResponse, DefaultError, Options<CompaniesResolveCompanyOnboardingRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesResolveCompanyOnboardingRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCompanySecurityExportCompanySecurityAuditQueryKey = (options?: Options<AdminCompanySecurityExportCompanySecurityAuditData>) => createQueryKey('admin-company-security-export_company_security_audit', options);

/**
 * Export Company Security Audit
 *
 * AS-BE20 — "who changed what, when" for this employer's security posture.
 *
 * Four columns, and the header IS the contract (plan §5): `occurred_at`,
 * `event_type`, `actor_role`, `detail`. **PII-safe by construction** — no
 * identifier, no name, no address, no code can reach the grid, because the stored
 * row's every exportable value is a CHECK-constrained closed set and `detail` is
 * validated against one more before the insert
 * (`app/domain/entities/security_audit_entities.py`).
 *
 * Both dates are OPTIONAL and default to the whole retained window. A start
 * reaching past the retention floor is CLAMPED to it rather than served as an
 * empty prefix, and the effective window is reported in the response headers so
 * the clamp is visible — `employer_sso.md` §11's rule that a silent clamp is the
 * same dishonesty as a silent accept, applied to a read. An inverted range is
 * rejected, never swapped (the company transactions export's convention).
 *
 * `X-Givmo-Audit-Retention-Days` is THE retention statement on the wire. It is
 * served on every successful export so the artifact carries its own bound rather
 * than depending on the reader having found the documentation.
 */
export const adminCompanySecurityExportCompanySecurityAuditOptions = (options?: Options<AdminCompanySecurityExportCompanySecurityAuditData>) => queryOptions<AdminCompanySecurityExportCompanySecurityAuditResponse, AdminCompanySecurityExportCompanySecurityAuditError, AdminCompanySecurityExportCompanySecurityAuditResponse, ReturnType<typeof adminCompanySecurityExportCompanySecurityAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCompanySecurityExportCompanySecurityAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCompanySecurityExportCompanySecurityAuditQueryKey(options)
});

/**
 * Reset Company Sso Sessions
 *
 * AS-BE19 — end every live session across this employer's roster.
 *
 * The employer's blunt incident control: something happened, sign everybody out.
 * Under an SSO tier the freshness rule then forces each employee back through
 * the company's IdP; at L0 it is a workforce-wide sign-out and nothing more.
 *
 * **It touches sessions and NOTHING else** — no factor is unenrolled, no
 * provider unlinked, no recovery code spent, no lock claim written or cleared,
 * no employment ended. That boundary is plan §3.1 applied to the one employer
 * act that reaches into every employee's session at once. Since AS-BE55
 * (D-AS-32, D-AS-37) "sessions" includes the delegated credentials that outlive
 * them: each employee's AI connections and Connect partner links, and every AI
 * connection bound to the company; the person reconnects afterwards.
 *
 * Takes NO body. The act has no parameters, and giving it one (a subset of
 * employees, an "except me") would turn a blunt control into a targeting tool.
 * POST rather than DELETE because nothing is removed: the sessions expire, the
 * accounts do not.
 */
export const adminCompanySecurityResetCompanySsoSessionsMutation = (options?: Partial<Options<AdminCompanySecurityResetCompanySsoSessionsData>>): UseMutationOptions<AdminCompanySecurityResetCompanySsoSessionsResponse, DefaultError, Options<AdminCompanySecurityResetCompanySsoSessionsData>> => {
    const mutationOptions: UseMutationOptions<AdminCompanySecurityResetCompanySsoSessionsResponse, DefaultError, Options<AdminCompanySecurityResetCompanySsoSessionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCompanySecurityResetCompanySsoSessions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Company Activity Feed Visibility
 */
export const companiesUpdateCompanyActivityFeedVisibilityMutation = (options?: Partial<Options<CompaniesUpdateCompanyActivityFeedVisibilityData>>): UseMutationOptions<CompaniesUpdateCompanyActivityFeedVisibilityResponse, CompaniesUpdateCompanyActivityFeedVisibilityError, Options<CompaniesUpdateCompanyActivityFeedVisibilityData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyActivityFeedVisibilityResponse, CompaniesUpdateCompanyActivityFeedVisibilityError, Options<CompaniesUpdateCompanyActivityFeedVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyActivityFeedVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetCompanyAuthPolicyQueryKey = (options?: Options<CompaniesGetCompanyAuthPolicyData>) => createQueryKey('companies-get_company_auth_policy', options);

/**
 * Get Company Auth Policy
 *
 * AS-BE11 — read this company's stored employee authentication policy.
 *
 * THE ADMIN TAB'S REVEAL PROBE. It rides the SAME
 * `_require_employer_auth_policy_enabled` dependency as the PUT, so it 404s
 * while the surface is dark — and that is the point: `200 ⇒ show the Security
 * tab, 404 ⇒ hide it` is the only dark signal the web side has. The policy
 * fields on `GET /admin/company` cannot serve it, because AS-BE10 deliberately
 * serves those REGARDLESS of the flag (a key that appears and disappears under
 * a flip is the brittleness the frozen-client rules exist to avoid), so they
 * read the same zero-state dark or live and tell a client nothing.
 *
 * READ-GATED LIKE ITS SIBLING READS, not like the PUT. Any company admin —
 * Owner or Member — may read it, matching `GET /admin/company`'s inline
 * `user.admin_company` check; only the WRITE is Owner-only via
 * `@has_company_permission("company:edit")` on the service. A Member who can
 * see the tab but gets a 403 on save is the correct, legible split, and it is
 * the one the rest of the company-settings surface already uses.
 *
 * The company is router-injected from `user.admin_company` and never spread
 * from the request, so an admin can only ever read their own.
 *
 * AS-BE49: an Owner also reads `employees_without_second_factor` while the link
 * requirement is live — the heads-up count before saving Required.
 */
export const companiesGetCompanyAuthPolicyOptions = (options?: Options<CompaniesGetCompanyAuthPolicyData>) => queryOptions<CompaniesGetCompanyAuthPolicyResponse, DefaultError, CompaniesGetCompanyAuthPolicyResponse, ReturnType<typeof companiesGetCompanyAuthPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyAuthPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyAuthPolicyQueryKey(options)
});

/**
 * Update Company Auth Policy
 *
 * AS-BE10: set this company's employee authentication policy.
 *
 * Owner-only — `company:edit` is enforced by `@has_company_permission` on the
 * service method, so a Member company admin gets a 403 (the same split every
 * other company-settings write uses). The company is router-injected from
 * `user.admin_company` and never spread from the body, so an Owner can only
 * ever name their own company.
 *
 * A whole-state PUT: both the tier and the grace window are required, and
 * `extra="forbid"` refuses any key this backend cannot honor yet — a tier it
 * cannot enforce must be a 422, never a 200 that silently drops it.
 */
export const companiesUpdateCompanyAuthPolicyMutation = (options?: Partial<Options<CompaniesUpdateCompanyAuthPolicyData>>): UseMutationOptions<CompaniesUpdateCompanyAuthPolicyResponse, CompaniesUpdateCompanyAuthPolicyError, Options<CompaniesUpdateCompanyAuthPolicyData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyAuthPolicyResponse, CompaniesUpdateCompanyAuthPolicyError, Options<CompaniesUpdateCompanyAuthPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyAuthPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Company Public Amounts
 *
 * EP-MNT16 (D-EP-51) — the company profile's dollar amounts: who may see the
 * dollar figures (`public_amounts_audience`), and whether each gift the company makes
 * directly may show its amount (`public_direct_gift_amounts`). Stated whole, both
 * required; `company:edit_visibility`, the Company visibility card's one string.
 * Answers `CompanyDetailedOut`, whose additive fields echo both.
 */
export const companiesUpdateCompanyPublicAmountsMutation = (options?: Partial<Options<CompaniesUpdateCompanyPublicAmountsData>>): UseMutationOptions<CompaniesUpdateCompanyPublicAmountsResponse, CompaniesUpdateCompanyPublicAmountsError, Options<CompaniesUpdateCompanyPublicAmountsData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyPublicAmountsResponse, CompaniesUpdateCompanyPublicAmountsError, Options<CompaniesUpdateCompanyPublicAmountsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyPublicAmounts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCompanySsoGetCompanySsoConfigQueryKey = (options?: Options<AdminCompanySsoGetCompanySsoConfigData>) => createQueryKey('admin-company-sso-get_company_sso_config', options);

/**
 * Get Company Sso Config
 *
 * Read the whole SSO section of the admin Security tab.
 *
 * **Also the section's dark-reveal probe**, exactly as
 * `GET /admin/company/settings/auth-policy` is for the MFA section: it rides the
 * router's flag gate, so `200 ⇒ show the SSO section, 404 ⇒ hide it` is the only
 * signal the web side needs. Nothing in the response is a secret — the
 * verification token is published in public DNS by design, and the broker's API
 * key and URL never leave the adapter.
 */
export const adminCompanySsoGetCompanySsoConfigOptions = (options?: Options<AdminCompanySsoGetCompanySsoConfigData>) => queryOptions<AdminCompanySsoGetCompanySsoConfigResponse, DefaultError, AdminCompanySsoGetCompanySsoConfigResponse, ReturnType<typeof adminCompanySsoGetCompanySsoConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCompanySsoGetCompanySsoConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCompanySsoGetCompanySsoConfigQueryKey(options)
});

export const adminCompanySsoGetCompanySsoConnectionQueryKey = (options?: Options<AdminCompanySsoGetCompanySsoConnectionData>) => createQueryKey('admin-company-sso-get_company_sso_connection', options);

/**
 * Get Company Sso Connection
 *
 * AS-WEB25 — read back the two values the employer's IT admin pastes into
 * their own identity provider (the SP entity ID and the ACS URL), from the
 * broker's connection record, whenever a connection exists.
 *
 * The same `SsoConnectionOut` the PUT above answers, so a client can hold the
 * two interchangeably. The values are present exactly when the broker holds a
 * primary connection and ABSENT otherwise — `response_model_exclude_none`, so
 * "no connection" is `{"configured": false}` and never a null a client could
 * render as a value.
 *
 * **Not part of the section's read**, and that is the point: `GET …/sso` is the
 * dark-reveal probe and makes no broker call, so a broker outage cannot hide
 * the tab. This read asks the broker, and its failure is the typed
 * `SSO_BROKER_UNAVAILABLE` the writes use, which the screen shows in place of
 * the values alone.
 *
 * Read-gated like `GET …/sso` — any company admin, Owner or Member: the values
 * are not a secret, and the section that renders them is already theirs to
 * see.
 */
export const adminCompanySsoGetCompanySsoConnectionOptions = (options?: Options<AdminCompanySsoGetCompanySsoConnectionData>) => queryOptions<AdminCompanySsoGetCompanySsoConnectionResponse, DefaultError, AdminCompanySsoGetCompanySsoConnectionResponse, ReturnType<typeof adminCompanySsoGetCompanySsoConnectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCompanySsoGetCompanySsoConnection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCompanySsoGetCompanySsoConnectionQueryKey(options)
});

/**
 * Configure Company Sso Connection
 *
 * Create or update the employer's SAML connection through the broker seam.
 *
 * Returns the two values their IT admin must paste into their own identity
 * provider, plus the NameID setup guidance — which is not decoration: a
 * persistent/pairwise NameID is refused by the broker before the assertion ever
 * reaches us, and an admin who has not been told that will debug it in the wrong
 * system (plan §4).
 *
 * ⚠ **Pasted metadata XML is not accepted.** The field is absent from
 * `SsoConnectionIn` and the model forbids extras, so sending it is a 422 naming
 * the key; the seam refuses it independently and the service turns that into a
 * typed `SSO_METADATA_XML_UNSUPPORTED` telling the admin to supply a URL. The
 * broker's API-key-authenticated parse endpoint takes a URL only, and writing
 * our own SAML-metadata parser to fill that gap is refused — it would decide
 * which certificate and entity id we trust.
 *
 * Requires a verified domain: the organization's `domains` list is the broker's
 * own login-time and SCIM-time gate, not a label.
 */
export const adminCompanySsoConfigureCompanySsoConnectionMutation = (options?: Partial<Options<AdminCompanySsoConfigureCompanySsoConnectionData>>): UseMutationOptions<AdminCompanySsoConfigureCompanySsoConnectionResponse, AdminCompanySsoConfigureCompanySsoConnectionError, Options<AdminCompanySsoConfigureCompanySsoConnectionData>> => {
    const mutationOptions: UseMutationOptions<AdminCompanySsoConfigureCompanySsoConnectionResponse, AdminCompanySsoConfigureCompanySsoConnectionError, Options<AdminCompanySsoConfigureCompanySsoConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCompanySsoConfigureCompanySsoConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Company Domain Verification
 *
 * Mint the DNS TXT token and return the record the Owner must publish.
 *
 * Takes no body: the domain is the company's OWN stored `company.domain`, and
 * accepting one from a caller would be letting them choose which domain a
 * successful check proves.
 *
 * Re-running mints a NEW token and clears any existing verification — an
 * employer starting verification is re-proving the domain, and a stale stamp
 * must not keep an SSO tier alive against a proof being replaced. The screen
 * avoids needing that by rendering the existing token from the GET above.
 */
export const adminCompanySsoStartCompanyDomainVerificationMutation = (options?: Partial<Options<AdminCompanySsoStartCompanyDomainVerificationData>>): UseMutationOptions<AdminCompanySsoStartCompanyDomainVerificationResponse, DefaultError, Options<AdminCompanySsoStartCompanyDomainVerificationData>> => {
    const mutationOptions: UseMutationOptions<AdminCompanySsoStartCompanyDomainVerificationResponse, DefaultError, Options<AdminCompanySsoStartCompanyDomainVerificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCompanySsoStartCompanyDomainVerification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check Company Domain Verification
 *
 * Resolve the TXT record; on an exact match, stamp `domain_verified_at`.
 *
 * A POST rather than a GET because it WRITES on success — and because it makes
 * an outbound network call, which is not something a cache or a prefetch should
 * be free to trigger.
 *
 * Re-runnable by design: DNS propagates on its own schedule and a negative
 * answer can be cached, so the Owner's remedy for "not yet" is to press it
 * again. A failure is a typed 400 whose message distinguishes "we looked and it
 * is not there" from "we could not look" — the two have opposite remedies.
 */
export const adminCompanySsoCheckCompanyDomainVerificationMutation = (options?: Partial<Options<AdminCompanySsoCheckCompanyDomainVerificationData>>): UseMutationOptions<AdminCompanySsoCheckCompanyDomainVerificationResponse, DefaultError, Options<AdminCompanySsoCheckCompanyDomainVerificationData>> => {
    const mutationOptions: UseMutationOptions<AdminCompanySsoCheckCompanyDomainVerificationResponse, DefaultError, Options<AdminCompanySsoCheckCompanyDomainVerificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCompanySsoCheckCompanyDomainVerification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCompanySsoGetCompanySsoLockReadinessQueryKey = (options?: Options<AdminCompanySsoGetCompanySsoLockReadinessData>) => createQueryKey('admin-company-sso-get_company_sso_lock_readiness', options);

/**
 * Get Company Sso Lock Readiness
 *
 * AS-BE15 (f) — the counts AS-WEB6's L4 flip ceremony must show before an
 * Owner can confirm: how many employees the lock would catch, how many have no
 * work identity connected, and how many are on builds with no lock UX.
 *
 * Counts only, never a roster — see `SsoLockReadinessOut`. Readable at any
 * tier, because its whole job is to be read BEFORE the flip; at an
 * already-locked company it reads as a live who-is-affected report instead.
 *
 * `company:read` like the section's other GET, not Owner-only like the writes:
 * it is part of a screen a Member can already see, and hiding the warning while
 * showing the control would be the wrong half to gate.
 */
export const adminCompanySsoGetCompanySsoLockReadinessOptions = (options?: Options<AdminCompanySsoGetCompanySsoLockReadinessData>) => queryOptions<AdminCompanySsoGetCompanySsoLockReadinessResponse, DefaultError, AdminCompanySsoGetCompanySsoLockReadinessResponse, ReturnType<typeof adminCompanySsoGetCompanySsoLockReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCompanySsoGetCompanySsoLockReadiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCompanySsoGetCompanySsoLockReadinessQueryKey(options)
});

/**
 * Update Company Sso Policy
 *
 * Set the employer's SSO tier and assertion-freshness window.
 *
 * A whole-state PUT (both fields required), matching
 * `PUT /admin/company/settings/auth-policy`: the Security screen renders both
 * controls and an Owner submitting it is stating the whole policy.
 *
 * Two guards with deliberately different shapes, both documented on the service:
 * an UNAVAILABLE tier is **REFUSED** — today `signin_lock` wherever
 * `EMPLOYER_SSO_SIGNIN_LOCK_ENABLED` is dark, since telling an Owner their
 * company is locked when it is not is the dishonest claim the mission bar
 * forbids, and this is a fact about the deployment they cannot fix — while a
 * tier above `none` without a verified domain or a connection is **CLAMPED** to
 * `none`, because that one they CAN fix and should not lose a settings form
 * over. The clamp is reported, not silent — the response is
 * the full config, so the screen shows what was actually stored beside
 * `can_enable_sso: false`.
 */
export const adminCompanySsoUpdateCompanySsoPolicyMutation = (options?: Partial<Options<AdminCompanySsoUpdateCompanySsoPolicyData>>): UseMutationOptions<AdminCompanySsoUpdateCompanySsoPolicyResponse, AdminCompanySsoUpdateCompanySsoPolicyError, Options<AdminCompanySsoUpdateCompanySsoPolicyData>> => {
    const mutationOptions: UseMutationOptions<AdminCompanySsoUpdateCompanySsoPolicyResponse, AdminCompanySsoUpdateCompanySsoPolicyError, Options<AdminCompanySsoUpdateCompanySsoPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCompanySsoUpdateCompanySsoPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Company Scim Settings
 *
 * AS-BE18b — turn the employer's SCIM directory sync on or off.
 *
 * **THE WRITER of the per-employer switch `org_sso_config.scim_enabled`** (the
 * org-keyed row is the ONLY store since OM-1), which until this item had none:
 * §15's reconciliation shipped armed-but-fed-nothing precisely because the seam
 * exposed no directory provisioning, so every company read OFF.
 *
 * Enabling ensures a broker-side directory exists (reading first — the create
 * is additive and a second one would strand the employer's configuration) and,
 * when that directory has no token yet, mints one and returns it **show-once**.
 * Disabling stops the reconciliation and nothing else: the directory, its base
 * URL and its token all persist, so re-enabling costs the employer no
 * re-configuration.
 *
 * Owner-only via `@has_company_permission("company:edit")` on the service, like
 * every other write here. Gated twice — the router's `EMPLOYER_SSO_ENABLED` and
 * this route's `EMPLOYER_SCIM_ENABLED` — because what it arms is a sweep that
 * DELETES `company_employee` rows.
 */
export const adminCompanySsoUpdateCompanyScimSettingsMutation = (options?: Partial<Options<AdminCompanySsoUpdateCompanyScimSettingsData>>): UseMutationOptions<AdminCompanySsoUpdateCompanyScimSettingsResponse, AdminCompanySsoUpdateCompanyScimSettingsError, Options<AdminCompanySsoUpdateCompanyScimSettingsData>> => {
    const mutationOptions: UseMutationOptions<AdminCompanySsoUpdateCompanyScimSettingsResponse, AdminCompanySsoUpdateCompanyScimSettingsError, Options<AdminCompanySsoUpdateCompanyScimSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCompanySsoUpdateCompanyScimSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rotate Company Scim Token
 *
 * AS-BE18b — mint a replacement bearer token for the employer's directory.
 *
 * Takes no body: the directory is resolved from the caller's own company
 * through the broker, so there is nothing for a caller to name and no way to
 * aim this at another employer's directory.
 *
 * A POST rather than a PUT because it is not idempotent in the way that
 * matters — each call mints a NEW value and **immediately invalidates the
 * previous one**, so a retried request is a second rotation, not a repeat of
 * the first.
 *
 * ⚠ **Available whether or not sync is enabled.** The token authenticates the
 * employer's identity provider to the broker regardless of whether we are
 * reading the directory, so an Owner who suspects it is compromised must be
 * able to replace it without first turning a sync back on. It refuses only when
 * there is no directory at all.
 */
export const adminCompanySsoRotateCompanyScimTokenMutation = (options?: Partial<Options<AdminCompanySsoRotateCompanyScimTokenData>>): UseMutationOptions<AdminCompanySsoRotateCompanyScimTokenResponse, DefaultError, Options<AdminCompanySsoRotateCompanyScimTokenData>> => {
    const mutationOptions: UseMutationOptions<AdminCompanySsoRotateCompanyScimTokenResponse, DefaultError, Options<AdminCompanySsoRotateCompanyScimTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCompanySsoRotateCompanyScimToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Company Sso Test Connection
 *
 * Start a REAL SP-initiated login for the Owner's own browser.
 *
 * **Test-connection is ours** (plan §5 AS-BE17): rather than the broker's
 * built-in test mode, which needs an admin session and a container we do not
 * deploy, this starts the same ceremony an employee's sign-in starts and reads
 * what comes back. It exercises the exact path employees will take.
 *
 * It produces NOTHING: no credential, no `sso_subject` binding, no
 * `last_sso_assertion_at` stamp. The flow is tombstoned with a handoff
 * fingerprint no code can produce, and both mint paths refuse this purpose
 * independently.
 *
 * Requires a verified domain and a configured connection, but deliberately NOT a
 * tier — an Owner tests before choosing one.
 */
export const adminCompanySsoStartCompanySsoTestConnectionMutation = (options?: Partial<Options<AdminCompanySsoStartCompanySsoTestConnectionData>>): UseMutationOptions<AdminCompanySsoStartCompanySsoTestConnectionResponse, AdminCompanySsoStartCompanySsoTestConnectionError, Options<AdminCompanySsoStartCompanySsoTestConnectionData>> => {
    const mutationOptions: UseMutationOptions<AdminCompanySsoStartCompanySsoTestConnectionResponse, AdminCompanySsoStartCompanySsoTestConnectionError, Options<AdminCompanySsoStartCompanySsoTestConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCompanySsoStartCompanySsoTestConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCompanySsoGetCompanySsoTestConnectionQueryKey = (options: Options<AdminCompanySsoGetCompanySsoTestConnectionData>) => createQueryKey('admin-company-sso-get_company_sso_test_connection', options);

/**
 * Get Company Sso Test Connection
 *
 * Report what the test asserted, in terms an IT admin can act on.
 *
 * The Owner's screen polls this after starting a test. Five outcomes, with the
 * three failures kept separate because each has a different fix — the
 * Entra pairwise-identifier case in particular must render as a specific
 * configuration instruction, never a generic failure (plan §4).
 *
 * A `test_id` belonging to another company answers the same not-found as one
 * that does not exist, so this cannot be used to probe for other employers'
 * ceremonies.
 *
 * Owner-gated rather than read-gated like the other GET here: this returns the
 * NameID an identity provider asserted for a real person at the company, which
 * is a narrower thing than the configuration state a Member may see.
 */
export const adminCompanySsoGetCompanySsoTestConnectionOptions = (options: Options<AdminCompanySsoGetCompanySsoTestConnectionData>) => queryOptions<AdminCompanySsoGetCompanySsoTestConnectionResponse, AdminCompanySsoGetCompanySsoTestConnectionError, AdminCompanySsoGetCompanySsoTestConnectionResponse, ReturnType<typeof adminCompanySsoGetCompanySsoTestConnectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCompanySsoGetCompanySsoTestConnection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCompanySsoGetCompanySsoTestConnectionQueryKey(options)
});

/**
 * Update Company Visibility
 */
export const companiesUpdateCompanyVisibilityMutation = (options?: Partial<Options<CompaniesUpdateCompanyVisibilityData>>): UseMutationOptions<CompaniesUpdateCompanyVisibilityResponse, CompaniesUpdateCompanyVisibilityError, Options<CompaniesUpdateCompanyVisibilityData>> => {
    const mutationOptions: UseMutationOptions<CompaniesUpdateCompanyVisibilityResponse, CompaniesUpdateCompanyVisibilityError, Options<CompaniesUpdateCompanyVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesUpdateCompanyVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stepsCompetitionsAdminListAdminStepsCompetitionsQueryKey = (options?: Options<StepsCompetitionsAdminListAdminStepsCompetitionsData>) => createQueryKey('steps-competitions-admin-list_admin_steps_competitions', options);

/**
 * List Admin Steps Competitions
 *
 * List the company's competitions (§2.4). DRAFTs included. Read permission
 * (Owner or Member).
 */
export const stepsCompetitionsAdminListAdminStepsCompetitionsOptions = (options?: Options<StepsCompetitionsAdminListAdminStepsCompetitionsData>) => queryOptions<StepsCompetitionsAdminListAdminStepsCompetitionsResponse, StepsCompetitionsAdminListAdminStepsCompetitionsError, StepsCompetitionsAdminListAdminStepsCompetitionsResponse, ReturnType<typeof stepsCompetitionsAdminListAdminStepsCompetitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepsCompetitionsAdminListAdminStepsCompetitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepsCompetitionsAdminListAdminStepsCompetitionsQueryKey(options)
});

/**
 * Create Admin Steps Competition
 *
 * Create a DRAFT competition (§2.4). Manage permission (Owner).
 */
export const stepsCompetitionsAdminCreateAdminStepsCompetitionMutation = (options?: Partial<Options<StepsCompetitionsAdminCreateAdminStepsCompetitionData>>): UseMutationOptions<StepsCompetitionsAdminCreateAdminStepsCompetitionResponse, StepsCompetitionsAdminCreateAdminStepsCompetitionError, Options<StepsCompetitionsAdminCreateAdminStepsCompetitionData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsAdminCreateAdminStepsCompetitionResponse, StepsCompetitionsAdminCreateAdminStepsCompetitionError, Options<StepsCompetitionsAdminCreateAdminStepsCompetitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsAdminCreateAdminStepsCompetition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stepsCompetitionsAdminGetStepsSponsorDpaQueryKey = (options?: Options<StepsCompetitionsAdminGetStepsSponsorDpaData>) => createQueryKey('steps-competitions-admin-get_steps_sponsor_dpa', options);

/**
 * Get Steps Sponsor Dpa
 *
 * The CURRENT effective Steps Competition Company Sponsor &
 * Consumer-Health-Data Processing Addendum plus whether this company has
 * accepted it (SC-GO2 / GC packet 2026-07-06 §C). Read permission (Owner or
 * Member). The client reads this BEFORE submitting a create, to decide whether
 * to render the click-through; the same shape also rides the create's 422
 * ``context.sponsor_dpa``, so one decoder serves both.
 */
export const stepsCompetitionsAdminGetStepsSponsorDpaOptions = (options?: Options<StepsCompetitionsAdminGetStepsSponsorDpaData>) => queryOptions<StepsCompetitionsAdminGetStepsSponsorDpaResponse, DefaultError, StepsCompetitionsAdminGetStepsSponsorDpaResponse, ReturnType<typeof stepsCompetitionsAdminGetStepsSponsorDpaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepsCompetitionsAdminGetStepsSponsorDpa({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepsCompetitionsAdminGetStepsSponsorDpaQueryKey(options)
});

export const stepsCompetitionsAdminGetAdminStepsCompetitionQueryKey = (options: Options<StepsCompetitionsAdminGetAdminStepsCompetitionData>) => createQueryKey('steps-competitions-admin-get_admin_steps_competition', options);

/**
 * Get Admin Steps Competition
 *
 * Admin detail (§2.4) with the company-wallet money context (held/available)
 * for the publish UI. Read permission.
 */
export const stepsCompetitionsAdminGetAdminStepsCompetitionOptions = (options: Options<StepsCompetitionsAdminGetAdminStepsCompetitionData>) => queryOptions<StepsCompetitionsAdminGetAdminStepsCompetitionResponse, StepsCompetitionsAdminGetAdminStepsCompetitionError, StepsCompetitionsAdminGetAdminStepsCompetitionResponse, ReturnType<typeof stepsCompetitionsAdminGetAdminStepsCompetitionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepsCompetitionsAdminGetAdminStepsCompetition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepsCompetitionsAdminGetAdminStepsCompetitionQueryKey(options)
});

/**
 * Update Admin Steps Competition
 *
 * Edit a DRAFT competition (§2.4). Manage permission. The prize is immutable.
 */
export const stepsCompetitionsAdminUpdateAdminStepsCompetitionMutation = (options?: Partial<Options<StepsCompetitionsAdminUpdateAdminStepsCompetitionData>>): UseMutationOptions<StepsCompetitionsAdminUpdateAdminStepsCompetitionResponse, StepsCompetitionsAdminUpdateAdminStepsCompetitionError, Options<StepsCompetitionsAdminUpdateAdminStepsCompetitionData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsAdminUpdateAdminStepsCompetitionResponse, StepsCompetitionsAdminUpdateAdminStepsCompetitionError, Options<StepsCompetitionsAdminUpdateAdminStepsCompetitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsAdminUpdateAdminStepsCompetition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Admin Steps Competition
 *
 * Cancel = release the prize hold (§1.2). Manage permission. Idempotent.
 */
export const stepsCompetitionsAdminCancelAdminStepsCompetitionMutation = (options?: Partial<Options<StepsCompetitionsAdminCancelAdminStepsCompetitionData>>): UseMutationOptions<StepsCompetitionsAdminCancelAdminStepsCompetitionResponse, StepsCompetitionsAdminCancelAdminStepsCompetitionError, Options<StepsCompetitionsAdminCancelAdminStepsCompetitionData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsAdminCancelAdminStepsCompetitionResponse, StepsCompetitionsAdminCancelAdminStepsCompetitionError, Options<StepsCompetitionsAdminCancelAdminStepsCompetitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsAdminCancelAdminStepsCompetition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stepsCompetitionsAdminListAdminStepsCompetitionEntriesQueryKey = (options: Options<StepsCompetitionsAdminListAdminStepsCompetitionEntriesData>) => createQueryKey('steps-competitions-admin-list_admin_steps_competition_entries', options);

/**
 * List Admin Steps Competition Entries
 *
 * List the competition's entries with TRUE identities + flagged-day counts
 * (§1.4/§1.6). Read permission.
 */
export const stepsCompetitionsAdminListAdminStepsCompetitionEntriesOptions = (options: Options<StepsCompetitionsAdminListAdminStepsCompetitionEntriesData>) => queryOptions<StepsCompetitionsAdminListAdminStepsCompetitionEntriesResponse, StepsCompetitionsAdminListAdminStepsCompetitionEntriesError, StepsCompetitionsAdminListAdminStepsCompetitionEntriesResponse, ReturnType<typeof stepsCompetitionsAdminListAdminStepsCompetitionEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepsCompetitionsAdminListAdminStepsCompetitionEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepsCompetitionsAdminListAdminStepsCompetitionEntriesQueryKey(options)
});

/**
 * Disqualify Admin Steps Competition Entry
 *
 * Disqualify an entrant (§1.6). Manage permission. Idempotent.
 */
export const stepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryMutation = (options?: Partial<Options<StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryData>>): UseMutationOptions<StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryResponse, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryError, Options<StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryResponse, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryError, Options<StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reinstate Admin Steps Competition Entry
 *
 * Reinstate a disqualified entrant (§1.6). Manage permission. Idempotent.
 */
export const stepsCompetitionsAdminReinstateAdminStepsCompetitionEntryMutation = (options?: Partial<Options<StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryData>>): UseMutationOptions<StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryResponse, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryError, Options<StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryResponse, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryError, Options<StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsAdminReinstateAdminStepsCompetitionEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Admin Steps Competition
 *
 * Publish = place the prize hold (§2.6). Manage permission. 409
 * (DEPOSIT_FUNDS_REQUIRED) when the wallet's available_balance is short — the
 * client routes into the CAM deposit flow. Idempotent.
 */
export const stepsCompetitionsAdminPublishAdminStepsCompetitionMutation = (options?: Partial<Options<StepsCompetitionsAdminPublishAdminStepsCompetitionData>>): UseMutationOptions<StepsCompetitionsAdminPublishAdminStepsCompetitionResponse, StepsCompetitionsAdminPublishAdminStepsCompetitionError, Options<StepsCompetitionsAdminPublishAdminStepsCompetitionData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsAdminPublishAdminStepsCompetitionResponse, StepsCompetitionsAdminPublishAdminStepsCompetitionError, Options<StepsCompetitionsAdminPublishAdminStepsCompetitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsAdminPublishAdminStepsCompetition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry Payout Admin Steps Competition
 *
 * Retry a stalled payout (§2.6). Manage permission. Re-enters the SAME fenced
 * finalize flow the cron uses; only a PAYOUT_PENDING competition is retryable
 * (409 otherwise). If the winner's charity is now available the competition
 * FINALIZEs and the prize is paid; if still unavailable it stays PAYOUT_PENDING.
 * Returns the competition's post-retry state (the client reads ``status`` to know
 * which).
 */
export const stepsCompetitionsAdminRetryPayoutAdminStepsCompetitionMutation = (options?: Partial<Options<StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionData>>): UseMutationOptions<StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionResponse, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionError, Options<StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionResponse, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionError, Options<StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsAdminRetryPayoutAdminStepsCompetition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesExportCompanyTaxLinesCsvQueryKey = (options: Options<CompaniesExportCompanyTaxLinesCsvData>) => createQueryKey('companies-export_company_tax_lines_csv', options);

/**
 * Export Company Tax Lines Csv
 *
 * EP-WEB-B4: the company's Variant-A (CWA) deductible tax lines for `year`.
 *
 * These are the SAME lines the annual-report PDF renders — the export calls the
 * identical assembly rather than reimplementing it, because a company holding a PDF
 * and a CSV that disagreed about its deduction is a tax problem, not a display bug.
 * Amounts are refund-netted (R3/D13); a fully-reversed charge is absent, because a
 * fully refunded charge is not a contribution.
 */
export const companiesExportCompanyTaxLinesCsvOptions = (options: Options<CompaniesExportCompanyTaxLinesCsvData>) => queryOptions<CompaniesExportCompanyTaxLinesCsvResponse, CompaniesExportCompanyTaxLinesCsvError, CompaniesExportCompanyTaxLinesCsvResponse, ReturnType<typeof companiesExportCompanyTaxLinesCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesExportCompanyTaxLinesCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesExportCompanyTaxLinesCsvQueryKey(options)
});

export const companiesExportCompanyTransactionsCsvQueryKey = (options: Options<CompaniesExportCompanyTransactionsCsvData>) => createQueryKey('companies-export_company_transactions_csv', options);

/**
 * Export Company Transactions Csv
 *
 * EP-WEB-B3: the company's money events over `[from, to]` (inclusive ET days) —
 * deposits, match charges, direct gives, gift-card purchases, and wallet-funded
 * spends, one row each.
 *
 * There was no company transaction ledger before this: the wallet read returns
 * balances only, and the dashboard activity feed mixes two windows by design. Each
 * row names its own `amount_basis` because the sources do not share a money column
 * (card-funded = GROSS charged, wallet-funded = entered/face), so a reader can
 * never silently sum across bases. Refunds are NOT netted — that is the tax
 * export's job, and the two are different artifacts on purpose. An inverted or
 * over-long window is rejected, never clamped.
 */
export const companiesExportCompanyTransactionsCsvOptions = (options: Options<CompaniesExportCompanyTransactionsCsvData>) => queryOptions<CompaniesExportCompanyTransactionsCsvResponse, CompaniesExportCompanyTransactionsCsvError, CompaniesExportCompanyTransactionsCsvResponse, ReturnType<typeof companiesExportCompanyTransactionsCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesExportCompanyTransactionsCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesExportCompanyTransactionsCsvQueryKey(options)
});

export const companiesGetCompanyWalletQueryKey = (options?: Options<CompaniesGetCompanyWalletData>) => createQueryKey('companies-get_company_wallet', options);

/**
 * Get Company Wallet
 */
export const companiesGetCompanyWalletOptions = (options?: Options<CompaniesGetCompanyWalletData>) => queryOptions<CompaniesGetCompanyWalletResponse, DefaultError, CompaniesGetCompanyWalletResponse, ReturnType<typeof companiesGetCompanyWalletQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyWallet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyWalletQueryKey(options)
});

export const companiesGetCompanyCardsQueryKey = (options?: Options<CompaniesGetCompanyCardsData>) => createQueryKey('companies-get_company_cards', options);

/**
 * Get Company Cards
 */
export const companiesGetCompanyCardsOptions = (options?: Options<CompaniesGetCompanyCardsData>) => queryOptions<CompaniesGetCompanyCardsResponse, DefaultError, CompaniesGetCompanyCardsResponse, ReturnType<typeof companiesGetCompanyCardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyCards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyCardsQueryKey(options)
});

/**
 * Create Company Card
 */
export const companiesCreateCompanyCardMutation = (options?: Partial<Options<CompaniesCreateCompanyCardData>>): UseMutationOptions<CompaniesCreateCompanyCardResponse, CompaniesCreateCompanyCardError, Options<CompaniesCreateCompanyCardData>> => {
    const mutationOptions: UseMutationOptions<CompaniesCreateCompanyCardResponse, CompaniesCreateCompanyCardError, Options<CompaniesCreateCompanyCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesCreateCompanyCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Company Card
 */
export const companiesDeleteCompanyCardMutation = (options?: Partial<Options<CompaniesDeleteCompanyCardData>>): UseMutationOptions<CompaniesDeleteCompanyCardResponse, CompaniesDeleteCompanyCardError, Options<CompaniesDeleteCompanyCardData>> => {
    const mutationOptions: UseMutationOptions<CompaniesDeleteCompanyCardResponse, CompaniesDeleteCompanyCardError, Options<CompaniesDeleteCompanyCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesDeleteCompanyCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deposit Funds Company
 */
export const companiesDepositFundsCompanyMutation = (options?: Partial<Options<CompaniesDepositFundsCompanyData>>): UseMutationOptions<CompaniesDepositFundsCompanyResponse, CompaniesDepositFundsCompanyError, Options<CompaniesDepositFundsCompanyData>> => {
    const mutationOptions: UseMutationOptions<CompaniesDepositFundsCompanyResponse, CompaniesDepositFundsCompanyError, Options<CompaniesDepositFundsCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesDepositFundsCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesQuoteCompanyDepositQueryKey = (options: Options<CompaniesQuoteCompanyDepositData>) => createQueryKey('companies-quote_company_deposit', options);

/**
 * Quote Company Deposit
 *
 * CAM-BE11 review F1(a): what a saved-card deposit of `amount` would charge and
 * credit, covered and not, priced by the resolution the deposit itself uses (the
 * stored card's brand, the company's own cover-fees setting). Owner-only, like the
 * deposit. Moves no money.
 */
export const companiesQuoteCompanyDepositOptions = (options: Options<CompaniesQuoteCompanyDepositData>) => queryOptions<CompaniesQuoteCompanyDepositResponse, CompaniesQuoteCompanyDepositError, CompaniesQuoteCompanyDepositResponse, ReturnType<typeof companiesQuoteCompanyDepositQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesQuoteCompanyDeposit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesQuoteCompanyDepositQueryKey(options)
});

/**
 * Publish Disclaimer
 *
 * Create a DRAFT disclaimer. Publisher-gated (TERMS_PUBLISHERS_WHITE_LIST,
 * enforced at the service layer).
 */
export const disclaimersPublishDisclaimerMutation = (options?: Partial<Options<DisclaimersPublishDisclaimerData>>): UseMutationOptions<DisclaimersPublishDisclaimerResponse, DisclaimersPublishDisclaimerError, Options<DisclaimersPublishDisclaimerData>> => {
    const mutationOptions: UseMutationOptions<DisclaimersPublishDisclaimerResponse, DisclaimersPublishDisclaimerError, Options<DisclaimersPublishDisclaimerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disclaimersPublishDisclaimer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch Disclaimer Draft
 *
 * Update a DRAFT document's content. Immutable once LIVE (409).
 */
export const disclaimersPatchDisclaimerDraftMutation = (options?: Partial<Options<DisclaimersPatchDisclaimerDraftData>>): UseMutationOptions<DisclaimersPatchDisclaimerDraftResponse, DisclaimersPatchDisclaimerDraftError, Options<DisclaimersPatchDisclaimerDraftData>> => {
    const mutationOptions: UseMutationOptions<DisclaimersPatchDisclaimerDraftResponse, DisclaimersPatchDisclaimerDraftError, Options<DisclaimersPatchDisclaimerDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disclaimersPatchDisclaimerDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Disclaimer Effective
 *
 * Flip a DRAFT document LIVE. Requires a non-empty sign-off.
 */
export const disclaimersSetDisclaimerEffectiveMutation = (options?: Partial<Options<DisclaimersSetDisclaimerEffectiveData>>): UseMutationOptions<DisclaimersSetDisclaimerEffectiveResponse, DisclaimersSetDisclaimerEffectiveError, Options<DisclaimersSetDisclaimerEffectiveData>> => {
    const mutationOptions: UseMutationOptions<DisclaimersSetDisclaimerEffectiveResponse, DisclaimersSetDisclaimerEffectiveError, Options<DisclaimersSetDisclaimerEffectiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disclaimersSetDisclaimerEffective({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const paymentsListReconcileReviewChargeIntentsQueryKey = (options?: Options<PaymentsListReconcileReviewChargeIntentsData>) => createQueryKey('payments-list_reconcile_review_charge_intents', options);

/**
 * List Reconcile Review Charge Intents
 *
 * Super-admin read of the durable NEEDS_REVIEW queue (recon/05 §6): the
 * charge-intents the corrective pass could not auto-complete, each carrying its
 * machine ``review_reason``. The minimal reviewable surface — resolution is a
 * separate operator action (out of slice-1 scope).
 */
export const paymentsListReconcileReviewChargeIntentsOptions = (options?: Options<PaymentsListReconcileReviewChargeIntentsData>) => queryOptions<PaymentsListReconcileReviewChargeIntentsResponse, DefaultError, PaymentsListReconcileReviewChargeIntentsResponse, ReturnType<typeof paymentsListReconcileReviewChargeIntentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await paymentsListReconcileReviewChargeIntents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: paymentsListReconcileReviewChargeIntentsQueryKey(options)
});

/**
 * Set Receipt Fine Print Effective
 *
 * Flip a DRAFT receipt-fine-print document LIVE. Publisher-gated
 * (TERMS_PUBLISHERS_WHITE_LIST, enforced at the service layer). Requires a
 * non-empty sign-off.
 */
export const receiptFinePrintSetReceiptFinePrintEffectiveMutation = (options?: Partial<Options<ReceiptFinePrintSetReceiptFinePrintEffectiveData>>): UseMutationOptions<ReceiptFinePrintSetReceiptFinePrintEffectiveResponse, ReceiptFinePrintSetReceiptFinePrintEffectiveError, Options<ReceiptFinePrintSetReceiptFinePrintEffectiveData>> => {
    const mutationOptions: UseMutationOptions<ReceiptFinePrintSetReceiptFinePrintEffectiveResponse, ReceiptFinePrintSetReceiptFinePrintEffectiveError, Options<ReceiptFinePrintSetReceiptFinePrintEffectiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await receiptFinePrintSetReceiptFinePrintEffective({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Terms
 */
export const termsPublishTermsMutation = (options?: Partial<Options<TermsPublishTermsData>>): UseMutationOptions<TermsPublishTermsResponse, TermsPublishTermsError, Options<TermsPublishTermsData>> => {
    const mutationOptions: UseMutationOptions<TermsPublishTermsResponse, TermsPublishTermsError, Options<TermsPublishTermsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsPublishTerms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Notify Terms
 *
 * Plan §3.5. Cloud Tasks fan-out notify. Requires Idempotency-Key
 * header (UUIDv4). Auth, rate-limit, env gate, and kill switch are all
 * enforced at the service layer.
 */
export const termsNotifyTermsMutation = (options?: Partial<Options<TermsNotifyTermsData>>): UseMutationOptions<TermsNotifyTermsResponse, TermsNotifyTermsError, Options<TermsNotifyTermsData>> => {
    const mutationOptions: UseMutationOptions<TermsNotifyTermsResponse, TermsNotifyTermsError, Options<TermsNotifyTermsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsNotifyTerms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry Failed Batches
 *
 * Plan §3.10 (v7). Re-enqueue all status='failed' batches for this
 * document. In-flight (pending/in_progress) batches are untouched.
 */
export const termsRetryFailedBatchesMutation = (options?: Partial<Options<TermsRetryFailedBatchesData>>): UseMutationOptions<TermsRetryFailedBatchesResponse, TermsRetryFailedBatchesError, Options<TermsRetryFailedBatchesData>> => {
    const mutationOptions: UseMutationOptions<TermsRetryFailedBatchesResponse, TermsRetryFailedBatchesError, Options<TermsRetryFailedBatchesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsRetryFailedBatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post Terms Notify Test
 *
 * Plan §3.11. Send the rendered email to the caller's own email only.
 */
export const termsPostTermsNotifyTestMutation = (options?: Partial<Options<TermsPostTermsNotifyTestData>>): UseMutationOptions<TermsPostTermsNotifyTestResponse, TermsPostTermsNotifyTestError, Options<TermsPostTermsNotifyTestData>> => {
    const mutationOptions: UseMutationOptions<TermsPostTermsNotifyTestResponse, TermsPostTermsNotifyTestError, Options<TermsPostTermsNotifyTestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsPostTermsNotifyTest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch Terms Summary
 *
 * Plan §3.1. Update summary_of_changes and/or effective_at on a
 * not-yet-notified document. Auth, 14-day gate, bleach sanitization, and
 * post-notify lock are all enforced at the service layer.
 */
export const termsPatchTermsSummaryMutation = (options?: Partial<Options<TermsPatchTermsSummaryData>>): UseMutationOptions<TermsPatchTermsSummaryResponse, TermsPatchTermsSummaryError, Options<TermsPatchTermsSummaryData>> => {
    const mutationOptions: UseMutationOptions<TermsPatchTermsSummaryResponse, TermsPatchTermsSummaryError, Options<TermsPatchTermsSummaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsPatchTermsSummary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCheckEmailAvailableQueryKey = (options: Options<AdminCheckEmailAvailableData>) => createQueryKey('admin-check_email_available', options);

/**
 * Check Email Available
 */
export const adminCheckEmailAvailableOptions = (options: Options<AdminCheckEmailAvailableData>) => queryOptions<AdminCheckEmailAvailableResponse, AdminCheckEmailAvailableError, AdminCheckEmailAvailableResponse, ReturnType<typeof adminCheckEmailAvailableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCheckEmailAvailable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCheckEmailAvailableQueryKey(options)
});

export const appGetMinimumVersionQueryKey = (options?: Options<AppGetMinimumVersionData>) => createQueryKey('app-get_minimum_version', options);

/**
 * Get Minimum Version
 */
export const appGetMinimumVersionOptions = (options?: Options<AppGetMinimumVersionData>) => queryOptions<AppGetMinimumVersionResponse, AppGetMinimumVersionError, AppGetMinimumVersionResponse, ReturnType<typeof appGetMinimumVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await appGetMinimumVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: appGetMinimumVersionQueryKey(options)
});

export const apiCreatePaymentSessionFromUrlQueryKey = (options: Options<ApiCreatePaymentSessionFromUrlData>) => createQueryKey('api-create_payment_session_from_url', options);

/**
 * Create Payment Session From Url
 */
export const apiCreatePaymentSessionFromUrlOptions = (options: Options<ApiCreatePaymentSessionFromUrlData>) => queryOptions<ApiCreatePaymentSessionFromUrlResponse, ApiCreatePaymentSessionFromUrlError, ApiCreatePaymentSessionFromUrlResponse, ReturnType<typeof apiCreatePaymentSessionFromUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiCreatePaymentSessionFromUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiCreatePaymentSessionFromUrlQueryKey(options)
});

export const assistantGetAssistantConfigQueryKey = (options?: Options<AssistantGetAssistantConfigData>) => createQueryKey('assistant-get_assistant_config', options);

/**
 * Get Assistant Config
 *
 * Runtime config + kill switch for the assistant (combined plan 02 §C2).
 *
 * Behind the global Firebase/App Check auth. Returns the dark defaults until
 * a super-admin writes the config row. `rollout_bucket_ok` / `min_client_version`
 * are frozen-client compatibility keys pinned to `true` / `null` — the assistant
 * has no cohort and no per-feature version floor (2026-07-30 ruling).
 */
export const assistantGetAssistantConfigOptions = (options?: Options<AssistantGetAssistantConfigData>) => queryOptions<AssistantGetAssistantConfigResponse, DefaultError, AssistantGetAssistantConfigResponse, ReturnType<typeof assistantGetAssistantConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantGetAssistantConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantGetAssistantConfigQueryKey(options)
});

export const assistantGetAssistantConsentQueryKey = (options?: Options<AssistantGetAssistantConsentData>) => createQueryKey('assistant-get_assistant_consent', options);

/**
 * Get Assistant Consent
 *
 * The caller's third-party-AI consent state + the current disclosure (02
 * §C1-3). The client shows the consent sheet when `required and not satisfied`.
 * Always available (a user can read their consent state regardless of the kill
 * switch).
 */
export const assistantGetAssistantConsentOptions = (options?: Options<AssistantGetAssistantConsentData>) => queryOptions<AssistantGetAssistantConsentResponse, DefaultError, AssistantGetAssistantConsentResponse, ReturnType<typeof assistantGetAssistantConsentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantGetAssistantConsent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantGetAssistantConsentQueryKey(options)
});

/**
 * Record Assistant Consent
 *
 * Record the caller's consent to the current disclosure version (02 §C1-3).
 * The body carries the `version` the client displayed; a stale version → 409
 * (re-fetch the disclosure). Idempotent at the current version.
 */
export const assistantRecordAssistantConsentMutation = (options?: Partial<Options<AssistantRecordAssistantConsentData>>): UseMutationOptions<AssistantRecordAssistantConsentResponse, AssistantRecordAssistantConsentError, Options<AssistantRecordAssistantConsentData>> => {
    const mutationOptions: UseMutationOptions<AssistantRecordAssistantConsentResponse, AssistantRecordAssistantConsentError, Options<AssistantRecordAssistantConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantRecordAssistantConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assistantListAssistantConversationsQueryKey = (options?: Options<AssistantListAssistantConversationsData>) => createQueryKey('assistant-list_assistant_conversations', options);

/**
 * List Assistant Conversations
 *
 * Paginated conversation history, newest activity first (02 §C2). Always
 * available (a user can read their history even when the assistant is off).
 */
export const assistantListAssistantConversationsOptions = (options?: Options<AssistantListAssistantConversationsData>) => queryOptions<AssistantListAssistantConversationsResponse, AssistantListAssistantConversationsError, AssistantListAssistantConversationsResponse, ReturnType<typeof assistantListAssistantConversationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantListAssistantConversations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantListAssistantConversationsQueryKey(options)
});

/**
 * Create Assistant Conversation
 *
 * Create a conversation (combined plan 02 §C2). Returns the conversation with
 * its server-generated opening message (the interim AI disclosure) — or with
 * `messages: []` on the employer surface, which is seeded with no opening at all
 * (the consumer string promises a "Talk to a human" control that surface lacks;
 * see `assistant.conversation_service`). Gated server-side on the assistant being
 * enabled for the caller (the kill switch) → 403 when dark/disabled.
 */
export const assistantCreateAssistantConversationMutation = (options?: Partial<Options<AssistantCreateAssistantConversationData>>): UseMutationOptions<AssistantCreateAssistantConversationResponse, AssistantCreateAssistantConversationError, Options<AssistantCreateAssistantConversationData>> => {
    const mutationOptions: UseMutationOptions<AssistantCreateAssistantConversationResponse, AssistantCreateAssistantConversationError, Options<AssistantCreateAssistantConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantCreateAssistantConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Assistant Conversation
 *
 * Hard-delete a conversation + its messages (CCPA; 02 §C2). Cross-user/
 * missing → 404 (constant detail). Always available to the owner.
 */
export const assistantDeleteAssistantConversationMutation = (options?: Partial<Options<AssistantDeleteAssistantConversationData>>): UseMutationOptions<AssistantDeleteAssistantConversationResponse, AssistantDeleteAssistantConversationError, Options<AssistantDeleteAssistantConversationData>> => {
    const mutationOptions: UseMutationOptions<AssistantDeleteAssistantConversationResponse, AssistantDeleteAssistantConversationError, Options<AssistantDeleteAssistantConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantDeleteAssistantConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assistantGetAssistantConversationQueryKey = (options: Options<AssistantGetAssistantConversationData>) => createQueryKey('assistant-get_assistant_conversation', options);

/**
 * Get Assistant Conversation
 *
 * Conversation detail + messages (02 §C2). Cross-user/missing → 404 with a
 * constant detail (no id echo). Always available to the owner.
 */
export const assistantGetAssistantConversationOptions = (options: Options<AssistantGetAssistantConversationData>) => queryOptions<AssistantGetAssistantConversationResponse, AssistantGetAssistantConversationError, AssistantGetAssistantConversationResponse, ReturnType<typeof assistantGetAssistantConversationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantGetAssistantConversation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantGetAssistantConversationQueryKey(options)
});

/**
 * Cancel Assistant Turn
 *
 * Cancel the conversation's in-flight assistant turn (combined plan 02 §C10).
 *
 * Conversation-level (one active turn per conversation is DB-enforced, so the
 * target is unambiguous and the client needn't track the turn id). Sets the turn
 * `cancel_requested`; the worker stops cooperatively at its next agent-loop round
 * boundary, finalizes the turn CANCELLED with its partial spend still accounted,
 * and streams a terminal `turn_cancelled` event the client tails on the SSE
 * stream. **Idempotent** — a second cancel while still `cancel_requested` returns
 * the same 200. Nothing in progress to cancel (latest turn terminal / no turn) →
 * 409; cross-user/missing conversation → 404 (constant detail).
 */
export const assistantCancelAssistantTurnMutation = (options?: Partial<Options<AssistantCancelAssistantTurnData>>): UseMutationOptions<AssistantCancelAssistantTurnResponse, AssistantCancelAssistantTurnError, Options<AssistantCancelAssistantTurnData>> => {
    const mutationOptions: UseMutationOptions<AssistantCancelAssistantTurnResponse, AssistantCancelAssistantTurnError, Options<AssistantCancelAssistantTurnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantCancelAssistantTurn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Propose Assistant Escalation
 *
 * Phase 1 — the user-initiated "talk to a human" handoff (02 §C7 L6). Records
 * a `proposed` escalation; sends NOTHING (only the confirm endpoint sends).
 * Gated on the assistant being available for the caller (403) and owning the
 * conversation (cross-user/missing → 404).
 */
export const assistantProposeAssistantEscalationMutation = (options?: Partial<Options<AssistantProposeAssistantEscalationData>>): UseMutationOptions<AssistantProposeAssistantEscalationResponse, AssistantProposeAssistantEscalationError, Options<AssistantProposeAssistantEscalationData>> => {
    const mutationOptions: UseMutationOptions<AssistantProposeAssistantEscalationResponse, AssistantProposeAssistantEscalationError, Options<AssistantProposeAssistantEscalationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantProposeAssistantEscalation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Assistant Message
 *
 * Send a message (combined plan 02 §C1).
 *
 * **Default:** the turn is queued and generation is dispatched off the request
 * → `202 {turn_id, stream_path}`; the client opens `stream_path` (SSE) for the
 * reply. **`Accept: application/json`:** the turn runs inline and the final
 * message is returned `200` (the Newman/testing affordance). Idempotent on
 * `(conversation_id, client_msg_id)`; one active turn per conversation (409);
 * gated on the kill switch (403); cross-user/missing → 404.
 */
export const assistantSendAssistantMessageMutation = (options?: Partial<Options<AssistantSendAssistantMessageData>>): UseMutationOptions<AssistantSendAssistantMessageResponse, AssistantSendAssistantMessageError, Options<AssistantSendAssistantMessageData>> => {
    const mutationOptions: UseMutationOptions<AssistantSendAssistantMessageResponse, AssistantSendAssistantMessageError, Options<AssistantSendAssistantMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantSendAssistantMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Assistant Feedback
 *
 * Record a thumbs rating + the in-app AI-content report on a message (02 §C2;
 * 05 §4-§5 — the report control required by Google Play AI-Generated Content +
 * Apple 1.2). Append-only: each POST inserts one feedback row (a rating and a
 * report may be filed separately). Requires auth + ownership only — it is NOT
 * gated on the kill switch, so the compliance control always
 * works for a message the user already has. The message must belong to a
 * conversation owned by the caller; cross-user / missing conversation /
 * message-not-in-conversation → 404 (constant detail, no enumeration oracle).
 * An invalid rating / off-set report_category / unknown field / over-long
 * comment → 422 at the schema layer.
 */
export const assistantSubmitAssistantFeedbackMutation = (options?: Partial<Options<AssistantSubmitAssistantFeedbackData>>): UseMutationOptions<AssistantSubmitAssistantFeedbackResponse, AssistantSubmitAssistantFeedbackError, Options<AssistantSubmitAssistantFeedbackData>> => {
    const mutationOptions: UseMutationOptions<AssistantSubmitAssistantFeedbackResponse, AssistantSubmitAssistantFeedbackError, Options<AssistantSubmitAssistantFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantSubmitAssistantFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assistantStreamAssistantTurnQueryKey = (options: Options<AssistantStreamAssistantTurnData>) => createQueryKey('assistant-stream_assistant_turn', options);

/**
 * Stream Assistant Turn
 *
 * Resumable SSE tail of a conversation's turn (combined plan 02 §C1/§C3).
 *
 * Streams `message_start` → `text_delta*` → `message_complete` (or
 * `turn_failed`), tailing the durable `assistant_event` log so disconnect/
 * reconnect replays losslessly via `Last-Event-ID`. `?format=json` returns the
 * persisted event array (e2e / poll-until-persisted). Cross-user/missing/
 * no-turn → 404 (constant detail). The reader never queries the request
 * session; it tails via short-lived `independent_session` reads (C0 shape).
 */
export const assistantStreamAssistantTurnOptions = (options: Options<AssistantStreamAssistantTurnData>) => queryOptions<AssistantStreamAssistantTurnResponse, AssistantStreamAssistantTurnError, AssistantStreamAssistantTurnResponse, ReturnType<typeof assistantStreamAssistantTurnQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantStreamAssistantTurn({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantStreamAssistantTurnQueryKey(options)
});

/**
 * Confirm Assistant Escalation
 *
 * Phase 2 — the deterministic, user-confirmed endpoint that sends the handoff
 * email (02 §C7 L6 — the model can never send email). Transitions
 * `proposed → confirmed → sent`/`failed`; idempotent (a row past `proposed` is
 * returned unchanged). Cross-user/missing → 404.
 */
export const assistantConfirmAssistantEscalationMutation = (options?: Partial<Options<AssistantConfirmAssistantEscalationData>>): UseMutationOptions<AssistantConfirmAssistantEscalationResponse, AssistantConfirmAssistantEscalationError, Options<AssistantConfirmAssistantEscalationData>> => {
    const mutationOptions: UseMutationOptions<AssistantConfirmAssistantEscalationResponse, AssistantConfirmAssistantEscalationError, Options<AssistantConfirmAssistantEscalationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantConfirmAssistantEscalation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetBoardAboutQueryKey = (options: Options<BoardDirectorGetBoardAboutData>) => createQueryKey('board-director-get_board_about', options);

/**
 * Get Board About
 *
 * About the board, from its own records: who serves and in what role, the duties the board
 * recorded for its officers, its recorded meeting rules and next meeting, its governing documents
 * in force, and its minutes and written consents of the last twelve months. Nothing from a
 * closed session.
 */
export const boardDirectorGetBoardAboutOptions = (options: Options<BoardDirectorGetBoardAboutData>) => queryOptions<BoardDirectorGetBoardAboutResponse, BoardDirectorGetBoardAboutError, BoardDirectorGetBoardAboutResponse, ReturnType<typeof boardDirectorGetBoardAboutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardAbout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardAboutQueryKey(options)
});

export const boardDirectorGetBoardDirectorAttentionQueryKey = (options: Options<BoardDirectorGetBoardDirectorAttentionData>) => createQueryKey('board-director-get_board_director_attention', options);

/**
 * Get Board Director Attention
 *
 * What is waiting for this director on this board.
 *
 * Three kinds share one list, each narrowable on its ``kind`` discriminator: an
 * unanswered meeting, a consent awaiting this seat's signature, and approved minutes
 * awaiting it. Only what this director can ACT on appears, so an empty list is an
 * honest "nothing is waiting".
 */
export const boardDirectorGetBoardDirectorAttentionOptions = (options: Options<BoardDirectorGetBoardDirectorAttentionData>) => queryOptions<BoardDirectorGetBoardDirectorAttentionResponse, BoardDirectorGetBoardDirectorAttentionError, BoardDirectorGetBoardDirectorAttentionResponse, ReturnType<typeof boardDirectorGetBoardDirectorAttentionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorAttention({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorAttentionQueryKey(options)
});

export const boardDirectorGetBoardDirectorAttentionCompletedQueryKey = (options: Options<BoardDirectorGetBoardDirectorAttentionCompletedData>) => createQueryKey('board-director-get_board_director_attention_completed', options);

/**
 * Get Board Director Attention Completed
 *
 * What you did on this board in the last 90 days, newest first: written consents you signed,
 * minutes you signed, meetings you answered for, questionnaires and self-assessments you
 * answered, copies of the return you opened. Your own acts only, scoped as what waits for you
 * is: a closed session's minutes only once you've confirmed it's you.
 */
export const boardDirectorGetBoardDirectorAttentionCompletedOptions = (options: Options<BoardDirectorGetBoardDirectorAttentionCompletedData>) => queryOptions<BoardDirectorGetBoardDirectorAttentionCompletedResponse, BoardDirectorGetBoardDirectorAttentionCompletedError, BoardDirectorGetBoardDirectorAttentionCompletedResponse, ReturnType<typeof boardDirectorGetBoardDirectorAttentionCompletedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorAttentionCompleted({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorAttentionCompletedQueryKey(options)
});

export const boardDirectorListOwnBoardCoiCyclesQueryKey = (options: Options<BoardDirectorListOwnBoardCoiCyclesData>) => createQueryKey('board-director-list_own_board_coi_cycles', options);

/**
 * List Own Board Coi Cycles
 *
 * The years you were asked for your conflict-of-interest answers on this board, newest
 * first, with your own answers where you've sent them.
 */
export const boardDirectorListOwnBoardCoiCyclesOptions = (options: Options<BoardDirectorListOwnBoardCoiCyclesData>) => queryOptions<BoardDirectorListOwnBoardCoiCyclesResponse, BoardDirectorListOwnBoardCoiCyclesError, BoardDirectorListOwnBoardCoiCyclesResponse, ReturnType<typeof boardDirectorListOwnBoardCoiCyclesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorListOwnBoardCoiCycles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorListOwnBoardCoiCyclesQueryKey(options)
});

export const boardDirectorGetOwnBoardCoiQuestionnaireQueryKey = (options: Options<BoardDirectorGetOwnBoardCoiQuestionnaireData>) => createQueryKey('board-director-get_own_board_coi_questionnaire', options);

/**
 * Get Own Board Coi Questionnaire
 *
 * Your questionnaire for the year: the questions as you're asked them, your board's policy,
 * your answers from last year filled in, and the single disclosures you've made since.
 */
export const boardDirectorGetOwnBoardCoiQuestionnaireOptions = (options: Options<BoardDirectorGetOwnBoardCoiQuestionnaireData>) => queryOptions<BoardDirectorGetOwnBoardCoiQuestionnaireResponse, BoardDirectorGetOwnBoardCoiQuestionnaireError, BoardDirectorGetOwnBoardCoiQuestionnaireResponse, ReturnType<typeof boardDirectorGetOwnBoardCoiQuestionnaireQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetOwnBoardCoiQuestionnaire({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetOwnBoardCoiQuestionnaireQueryKey(options)
});

export const boardDirectorGetOwnBoardCoiResponseQueryKey = (options: Options<BoardDirectorGetOwnBoardCoiResponseData>) => createQueryKey('board-director-get_own_board_coi_response', options);

/**
 * Get Own Board Coi Response
 *
 * Your answers for the year as recorded, with any correction you've made.
 */
export const boardDirectorGetOwnBoardCoiResponseOptions = (options: Options<BoardDirectorGetOwnBoardCoiResponseData>) => queryOptions<BoardDirectorGetOwnBoardCoiResponseResponse, BoardDirectorGetOwnBoardCoiResponseError, BoardDirectorGetOwnBoardCoiResponseResponse, ReturnType<typeof boardDirectorGetOwnBoardCoiResponseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetOwnBoardCoiResponse({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetOwnBoardCoiResponseQueryKey(options)
});

/**
 * Submit Own Board Coi Response
 *
 * Sign your answers for the year. A signature-class act: it needs your signing window open,
 * and `intent_statement_id` echoes the words beside Sign (a stale id is a typed 409). Your
 * signed answers become your disclosure in the board's records, in place of last year's.
 * `corrects_record_id` adds a correction beside answers you've already signed.
 */
export const boardDirectorSubmitOwnBoardCoiResponseMutation = (options?: Partial<Options<BoardDirectorSubmitOwnBoardCoiResponseData>>): UseMutationOptions<BoardDirectorSubmitOwnBoardCoiResponseResponse, BoardDirectorSubmitOwnBoardCoiResponseError, Options<BoardDirectorSubmitOwnBoardCoiResponseData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorSubmitOwnBoardCoiResponseResponse, BoardDirectorSubmitOwnBoardCoiResponseError, Options<BoardDirectorSubmitOwnBoardCoiResponseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorSubmitOwnBoardCoiResponse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetOwnBoardCoiResponseChangesQueryKey = (options: Options<BoardDirectorGetOwnBoardCoiResponseChangesData>) => createQueryKey('board-director-get_own_board_coi_response_changes', options);

/**
 * Get Own Board Coi Response Changes
 *
 * Your answers for the year against your answers from the year before, question by
 * question.
 */
export const boardDirectorGetOwnBoardCoiResponseChangesOptions = (options: Options<BoardDirectorGetOwnBoardCoiResponseChangesData>) => queryOptions<BoardDirectorGetOwnBoardCoiResponseChangesResponse, BoardDirectorGetOwnBoardCoiResponseChangesError, BoardDirectorGetOwnBoardCoiResponseChangesResponse, ReturnType<typeof boardDirectorGetOwnBoardCoiResponseChangesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetOwnBoardCoiResponseChanges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetOwnBoardCoiResponseChangesQueryKey(options)
});

export const boardDirectorGetOwnBoardCoiResponseDocumentQueryKey = (options: Options<BoardDirectorGetOwnBoardCoiResponseDocumentData>) => createQueryKey('board-director-get_own_board_coi_response_document', options);

/**
 * Get Own Board Coi Response Document
 *
 * Your copy of your answers for the year, as a PDF: as recorded, or the changes from the
 * year before.
 */
export const boardDirectorGetOwnBoardCoiResponseDocumentOptions = (options: Options<BoardDirectorGetOwnBoardCoiResponseDocumentData>) => queryOptions<BoardDirectorGetOwnBoardCoiResponseDocumentResponse, BoardDirectorGetOwnBoardCoiResponseDocumentError, BoardDirectorGetOwnBoardCoiResponseDocumentResponse, ReturnType<typeof boardDirectorGetOwnBoardCoiResponseDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetOwnBoardCoiResponseDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetOwnBoardCoiResponseDocumentQueryKey(options)
});

export const boardDirectorListOwnBoardConflictDisclosuresQueryKey = (options: Options<BoardDirectorListOwnBoardConflictDisclosuresData>) => createQueryKey('board-director-list_own_board_conflict_disclosures', options);

/**
 * List Own Board Conflict Disclosures
 *
 * Your own recorded disclosures on this board — what the book says about you.
 *
 * Never another director's: the seat is the one your account claimed, and this route takes
 * no id that could name someone else. `status` on each entry says whether it still stands
 * or a later disclosure of yours replaced it.
 */
export const boardDirectorListOwnBoardConflictDisclosuresOptions = (options: Options<BoardDirectorListOwnBoardConflictDisclosuresData>) => queryOptions<BoardDirectorListOwnBoardConflictDisclosuresResponse, BoardDirectorListOwnBoardConflictDisclosuresError, BoardDirectorListOwnBoardConflictDisclosuresResponse, ReturnType<typeof boardDirectorListOwnBoardConflictDisclosuresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorListOwnBoardConflictDisclosures({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorListOwnBoardConflictDisclosuresQueryKey(options)
});

/**
 * Record Own Board Conflict Disclosure
 *
 * Record your own conflict-of-interest disclosure.
 *
 * Describe the interest in your own words and, where there is one, name the counterparty
 * — the person or organization on the other side of it. The name is what lets the
 * recording officer be shown this disclosure beside an agenda item or motion that
 * mentions it, before the board votes.
 *
 * A signature-class act: it needs the director's signing window, for the same reason a
 * consent signature does. Without it the answer is the typed 400
 * `board_director_signing_required` the console turns into its confirm sheet, never a 401.
 * `intent_statement_id` echoes the words beside the button.
 *
 * `supersedes_record_id` records that your position has CHANGED — the earlier disclosure
 * stays an accurate record of what was true at its time, which is usually what you mean.
 * `corrects_record_id` records that the earlier one was wrong.
 *
 * Recording this does not decide anything: whether you stand out of a vote is the
 * board's determination, recorded in the minutes as a recusal.
 */
export const boardDirectorRecordOwnBoardConflictDisclosureMutation = (options?: Partial<Options<BoardDirectorRecordOwnBoardConflictDisclosureData>>): UseMutationOptions<BoardDirectorRecordOwnBoardConflictDisclosureResponse, BoardDirectorRecordOwnBoardConflictDisclosureError, Options<BoardDirectorRecordOwnBoardConflictDisclosureData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorRecordOwnBoardConflictDisclosureResponse, BoardDirectorRecordOwnBoardConflictDisclosureError, Options<BoardDirectorRecordOwnBoardConflictDisclosureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorRecordOwnBoardConflictDisclosure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetOwnBoardGettingStartedQueryKey = (options: Options<BoardDirectorGetOwnBoardGettingStartedData>) => createQueryKey('board-director-get_own_board_getting_started', options);

/**
 * Get Own Board Getting Started
 *
 * Your getting-started list on this board: the documents to read and confirm, your first
 * conflict-of-interest disclosure, the board's own steps, and your board buddy.
 */
export const boardDirectorGetOwnBoardGettingStartedOptions = (options: Options<BoardDirectorGetOwnBoardGettingStartedData>) => queryOptions<BoardDirectorGetOwnBoardGettingStartedResponse, BoardDirectorGetOwnBoardGettingStartedError, BoardDirectorGetOwnBoardGettingStartedResponse, ReturnType<typeof boardDirectorGetOwnBoardGettingStartedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetOwnBoardGettingStarted({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetOwnBoardGettingStartedQueryKey(options)
});

/**
 * Mark Own Board Getting Started Step
 *
 * Mark one of your board's steps on your list done, with the date, or clear it.
 */
export const boardDirectorMarkOwnBoardGettingStartedStepMutation = (options?: Partial<Options<BoardDirectorMarkOwnBoardGettingStartedStepData>>): UseMutationOptions<BoardDirectorMarkOwnBoardGettingStartedStepResponse, BoardDirectorMarkOwnBoardGettingStartedStepError, Options<BoardDirectorMarkOwnBoardGettingStartedStepData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorMarkOwnBoardGettingStartedStepResponse, BoardDirectorMarkOwnBoardGettingStartedStepError, Options<BoardDirectorMarkOwnBoardGettingStartedStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorMarkOwnBoardGettingStartedStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorListBoardDirectorMeetingsQueryKey = (options: Options<BoardDirectorListBoardDirectorMeetingsData>) => createQueryKey('board-director-list_board_director_meetings', options);

/**
 * List Board Director Meetings
 *
 * This board's meetings, soonest first, with this seat's own answer on each.
 *
 * Defaults to upcoming only: a director opening the surface is looking at what is ahead.
 * Past meetings are available by asking for them.
 */
export const boardDirectorListBoardDirectorMeetingsOptions = (options: Options<BoardDirectorListBoardDirectorMeetingsData>) => queryOptions<BoardDirectorListBoardDirectorMeetingsResponse, BoardDirectorListBoardDirectorMeetingsError, BoardDirectorListBoardDirectorMeetingsResponse, ReturnType<typeof boardDirectorListBoardDirectorMeetingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorListBoardDirectorMeetings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorListBoardDirectorMeetingsQueryKey(options)
});

export const boardDirectorGetBoardDirectorMeetingQueryKey = (options: Options<BoardDirectorGetBoardDirectorMeetingData>) => createQueryKey('board-director-get_board_director_meeting', options);

/**
 * Get Board Director Meeting
 *
 * One meeting, with its agenda and the current published packet's id.
 *
 * The notice block is included: it is the charity's own recorded parameter and the
 * arithmetic against it, and the sentence names the section the charity attributed the
 * period to — so a director can read it against the instrument themselves rather than
 * take the product's word for anything.
 */
export const boardDirectorGetBoardDirectorMeetingOptions = (options: Options<BoardDirectorGetBoardDirectorMeetingData>) => queryOptions<BoardDirectorGetBoardDirectorMeetingResponse, BoardDirectorGetBoardDirectorMeetingError, BoardDirectorGetBoardDirectorMeetingResponse, ReturnType<typeof boardDirectorGetBoardDirectorMeetingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorMeeting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorMeetingQueryKey(options)
});

/**
 * Record Board Director Attendance Intent
 *
 * Answer whether this director expects to attend.
 *
 * Rides the account's sign-in and needs no signing window: how strongly a director must
 * confirm it's them is tiered by the weight of the act, and an answer about attendance
 * binds nobody to anything. A vote, a written consent, or e-signing minutes does need one.
 *
 * A PUT because there is one current answer per director per meeting; changing it
 * replaces it, and when the answer was FIRST given is kept either way.
 */
export const boardDirectorRecordBoardDirectorAttendanceIntentMutation = (options?: Partial<Options<BoardDirectorRecordBoardDirectorAttendanceIntentData>>): UseMutationOptions<BoardDirectorRecordBoardDirectorAttendanceIntentResponse, BoardDirectorRecordBoardDirectorAttendanceIntentError, Options<BoardDirectorRecordBoardDirectorAttendanceIntentData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorRecordBoardDirectorAttendanceIntentResponse, BoardDirectorRecordBoardDirectorAttendanceIntentError, Options<BoardDirectorRecordBoardDirectorAttendanceIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorRecordBoardDirectorAttendanceIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetBoardDirectorMeetingCalendarQueryKey = (options: Options<BoardDirectorGetBoardDirectorMeetingCalendarData>) => createQueryKey('board-director-get_board_director_meeting_calendar', options);

/**
 * Get Board Director Meeting Calendar
 *
 * The meeting as an iCalendar file, for the director's own calendar.
 */
export const boardDirectorGetBoardDirectorMeetingCalendarOptions = (options: Options<BoardDirectorGetBoardDirectorMeetingCalendarData>) => queryOptions<BoardDirectorGetBoardDirectorMeetingCalendarResponse, BoardDirectorGetBoardDirectorMeetingCalendarError, BoardDirectorGetBoardDirectorMeetingCalendarResponse, ReturnType<typeof boardDirectorGetBoardDirectorMeetingCalendarQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorMeetingCalendar({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorMeetingCalendarQueryKey(options)
});

/**
 * Sign Board Minutes
 *
 * Sign approved minutes.
 *
 * A signature-class act: it needs the director's signing window open (CBG-SEC2), and the
 * factor that opened it, when it was confirmed and the words affirmed are recorded beside
 * the signature. Reading and answering an invitation do not — the weight of the act sets the
 * bar. `intent_statement_id` echoes the words beside the button; a stale id is a typed 409.
 *
 * `content_hash` is the address of the exact minutes being signed. If they changed since
 * they were read, the signature is refused rather than attached to different words.
 *
 * `capacity_title_id` (optional) records the title this person signs as: one of the titles
 * their seat holds now, kept with the signature in the words it has today. A title the seat
 * doesn't hold is a 409 `board_signature_capacity_not_held`.
 *
 * A signature follows the board's approval; minutes still in draft cannot be signed.
 */
export const boardDirectorSignBoardMinutesMutation = (options?: Partial<Options<BoardDirectorSignBoardMinutesData>>): UseMutationOptions<BoardDirectorSignBoardMinutesResponse, BoardDirectorSignBoardMinutesError, Options<BoardDirectorSignBoardMinutesData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorSignBoardMinutesResponse, BoardDirectorSignBoardMinutesError, Options<BoardDirectorSignBoardMinutesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorSignBoardMinutes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetBoardDirectorMeetingRecordQueryKey = (options: Options<BoardDirectorGetBoardDirectorMeetingRecordData>) => createQueryKey('board-director-get_board_director_meeting_record', options);

/**
 * Get Board Director Meeting Record
 *
 * What the charity recorded about one meeting, as this director may see it.
 *
 * Who was present, the parts of the meeting, and the motions with their recorded votes,
 * recusals, and the quorum figures taken at each — plus this seat's own votes and recusals,
 * so a director can see what the book says about them without reading every motion.
 *
 * A closed session this director was not part of is absent, and so is everything recorded
 * inside it. Nothing on the wire counts what was withheld.
 */
export const boardDirectorGetBoardDirectorMeetingRecordOptions = (options: Options<BoardDirectorGetBoardDirectorMeetingRecordData>) => queryOptions<BoardDirectorGetBoardDirectorMeetingRecordResponse, BoardDirectorGetBoardDirectorMeetingRecordError, BoardDirectorGetBoardDirectorMeetingRecordResponse, ReturnType<typeof boardDirectorGetBoardDirectorMeetingRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorMeetingRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorMeetingRecordQueryKey(options)
});

export const boardDirectorGetBoardDirectorPacketQueryKey = (options: Options<BoardDirectorGetBoardDirectorPacketData>) => createQueryKey('board-director-get_board_director_packet', options);

/**
 * Get Board Director Packet
 *
 * One published packet version, and a recorded open for the chair's view.
 *
 * A version still being assembled answers exactly as a missing one does — a director
 * reads what the board was sent. An entry pointing at a closed session this director was
 * not part of is absent from the entries. The open is recorded only after the read is
 * allowed, so the chair's view never shows something that did not happen.
 */
export const boardDirectorGetBoardDirectorPacketOptions = (options: Options<BoardDirectorGetBoardDirectorPacketData>) => queryOptions<BoardDirectorGetBoardDirectorPacketResponse, BoardDirectorGetBoardDirectorPacketError, BoardDirectorGetBoardDirectorPacketResponse, ReturnType<typeof boardDirectorGetBoardDirectorPacketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorPacket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorPacketQueryKey(options)
});

export const boardDirectorListBoardDirectorAnnotationsQueryKey = (options: Options<BoardDirectorListBoardDirectorAnnotationsData>) => createQueryKey('board-director-list_board_director_annotations', options);

/**
 * List Board Director Annotations
 *
 * This director's own notes plus every board-visible comment on this version.
 *
 * Another director's personal note is absent, not refused, so the list cannot be used to
 * learn that one exists.
 */
export const boardDirectorListBoardDirectorAnnotationsOptions = (options: Options<BoardDirectorListBoardDirectorAnnotationsData>) => queryOptions<BoardDirectorListBoardDirectorAnnotationsResponse, BoardDirectorListBoardDirectorAnnotationsError, BoardDirectorListBoardDirectorAnnotationsResponse, ReturnType<typeof boardDirectorListBoardDirectorAnnotationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorListBoardDirectorAnnotations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorListBoardDirectorAnnotationsQueryKey(options)
});

/**
 * Create Board Director Annotation
 *
 * Write a note on this packet version, or on one of its entries.
 *
 * `visibility` has no default: a personal note and something the whole board will read
 * are different things, and choosing between them is the director's to make explicitly.
 * A personal note is readable by this seat and by nobody else — not another director, and
 * not the charity's own administrators.
 */
export const boardDirectorCreateBoardDirectorAnnotationMutation = (options?: Partial<Options<BoardDirectorCreateBoardDirectorAnnotationData>>): UseMutationOptions<BoardDirectorCreateBoardDirectorAnnotationResponse, BoardDirectorCreateBoardDirectorAnnotationError, Options<BoardDirectorCreateBoardDirectorAnnotationData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorCreateBoardDirectorAnnotationResponse, BoardDirectorCreateBoardDirectorAnnotationError, Options<BoardDirectorCreateBoardDirectorAnnotationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorCreateBoardDirectorAnnotation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Director Annotation
 *
 * Delete one of this director's own notes.
 *
 * Naming another director's note answers exactly as naming one that does not exist.
 * There is no edit: a comment the rest of the board has read must not change under them,
 * and a personal note costs nothing to write again.
 */
export const boardDirectorDeleteBoardDirectorAnnotationMutation = (options?: Partial<Options<BoardDirectorDeleteBoardDirectorAnnotationData>>): UseMutationOptions<BoardDirectorDeleteBoardDirectorAnnotationResponse, BoardDirectorDeleteBoardDirectorAnnotationError, Options<BoardDirectorDeleteBoardDirectorAnnotationData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorDeleteBoardDirectorAnnotationResponse, BoardDirectorDeleteBoardDirectorAnnotationError, Options<BoardDirectorDeleteBoardDirectorAnnotationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorDeleteBoardDirectorAnnotation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetBoardDirectorPacketDocumentDownloadUrlQueryKey = (options: Options<BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlData>) => createQueryKey('board-director-get_board_director_packet_document_download_url', options);

/**
 * Get Board Director Packet Document Download Url
 *
 * A short-lived read URL for one attachment in this packet version.
 *
 * Reachable only because the attachment is IN a packet this director may read. An
 * attachment uploaded against the meeting but never placed in a published version is not
 * something the board was sent, so it answers as absent.
 */
export const boardDirectorGetBoardDirectorPacketDocumentDownloadUrlOptions = (options: Options<BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlData>) => queryOptions<BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlResponse, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlError, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlResponse, ReturnType<typeof boardDirectorGetBoardDirectorPacketDocumentDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorPacketDocumentDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorPacketDocumentDownloadUrlQueryKey(options)
});

export const boardDirectorGetBoardDirectorFilingReceiptDownloadUrlQueryKey = (options: Options<BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlData>) => createQueryKey('board-director-get_board_director_filing_receipt_download_url', options);

/**
 * Get Board Director Filing Receipt Download Url
 *
 * Authorize this seat to the exact published snapshot before a URL is signed.
 */
export const boardDirectorGetBoardDirectorFilingReceiptDownloadUrlOptions = (options: Options<BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlData>) => queryOptions<BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlResponse, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlError, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlResponse, ReturnType<typeof boardDirectorGetBoardDirectorFilingReceiptDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorFilingReceiptDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorFilingReceiptDownloadUrlQueryKey(options)
});

export const boardDirectorListBoardDirectorRecordsQueryKey = (options: Options<BoardDirectorListBoardDirectorRecordsData>) => createQueryKey('board-director-list_board_director_records', options);

/**
 * List Board Director Records
 *
 * This board's records, scoped to what this director may read.
 *
 * A closed session the director did not attend is ABSENT from the page and from
 * `meta.total` — scoped together in SQL, so an offset walk cannot map the number or
 * position of the records withheld.
 */
export const boardDirectorListBoardDirectorRecordsOptions = (options: Options<BoardDirectorListBoardDirectorRecordsData>) => queryOptions<BoardDirectorListBoardDirectorRecordsResponse, BoardDirectorListBoardDirectorRecordsError, BoardDirectorListBoardDirectorRecordsResponse, ReturnType<typeof boardDirectorListBoardDirectorRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorListBoardDirectorRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorListBoardDirectorRecordsQueryKey(options)
});

export const boardDirectorGetBoardDirectorRecordQueryKey = (options: Options<BoardDirectorGetBoardDirectorRecordData>) => createQueryKey('board-director-get_board_director_record', options);

/**
 * Get Board Director Record
 *
 * One record, and a recorded open for the chair's engagement view.
 *
 * A record this director may not read answers exactly as a record that does not exist
 * does, and the open is recorded only after the read is allowed.
 */
export const boardDirectorGetBoardDirectorRecordOptions = (options: Options<BoardDirectorGetBoardDirectorRecordData>) => queryOptions<BoardDirectorGetBoardDirectorRecordResponse, BoardDirectorGetBoardDirectorRecordError, BoardDirectorGetBoardDirectorRecordResponse, ReturnType<typeof boardDirectorGetBoardDirectorRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorRecordQueryKey(options)
});

/**
 * Acknowledge Board Record
 *
 * Record this director's acknowledgment of a record — a signature-class act.
 *
 * Needs the director's signing window open (their passkey, or on an account with no passkey
 * their authenticator app, confirmed in this sign-in within the hour); without it the answer
 * is the typed 400 `board_director_signing_required` the console turns into its confirm
 * sheet, never a 401 that would read as "sign in again".
 *
 * `content_hash` is a required echo of what the director read: the act's whole value is
 * that it names the exact bytes a human saw, so a mismatch is refused rather than
 * recorded. `intent_statement_id` echoes the words beside the button (`/me` lists the
 * current ones); a stale id is a typed 409. The response carries the recorded capture back —
 * which seat, what identity it asserted, the factor that opened the window and when it was
 * confirmed, the words affirmed, and when the act happened.
 */
export const boardDirectorAcknowledgeBoardRecordMutation = (options?: Partial<Options<BoardDirectorAcknowledgeBoardRecordData>>): UseMutationOptions<BoardDirectorAcknowledgeBoardRecordResponse, BoardDirectorAcknowledgeBoardRecordError, Options<BoardDirectorAcknowledgeBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorAcknowledgeBoardRecordResponse, BoardDirectorAcknowledgeBoardRecordError, Options<BoardDirectorAcknowledgeBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorAcknowledgeBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign Board Minutes To Approve
 *
 * Sign to approve a closed session's minutes, as one of the directors who were in it.
 *
 * Only where the board's rule approves a closed session's minutes by the signatures of the
 * directors who were there, and only for a director its open request asked: the seat recorded as
 * in the session whose account it was at the meeting's start. Anyone else gets the not-found, as
 * a record that does not exist does. A signature-class act: it needs the director's signing
 * window, and records the factor, when it was confirmed and the words affirmed
 * (`intent_statement_id`; a stale id is a typed 409). `content_hash` is the bytes read: minutes
 * that changed since are refused rather than signed. The last asked signature on the current
 * bytes approves the minutes (`approved`).
 */
export const boardDirectorSignBoardMinutesToApproveMutation = (options?: Partial<Options<BoardDirectorSignBoardMinutesToApproveData>>): UseMutationOptions<BoardDirectorSignBoardMinutesToApproveResponse, BoardDirectorSignBoardMinutesToApproveError, Options<BoardDirectorSignBoardMinutesToApproveData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorSignBoardMinutesToApproveResponse, BoardDirectorSignBoardMinutesToApproveError, Options<BoardDirectorSignBoardMinutesToApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorSignBoardMinutesToApprove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetBoardReturnCopyForDirectorQueryKey = (options: Options<BoardDirectorGetBoardReturnCopyForDirectorData>) => createQueryKey('board-director-get_board_return_copy_for_director', options);

/**
 * Get Board Return Copy For Director
 *
 * A copy of the organization's return provided to the board: the tax year, who provided it
 * and when, the file's name, size and pages, when you opened it, and your recorded reading of
 * it. Nothing about anyone else.
 */
export const boardDirectorGetBoardReturnCopyForDirectorOptions = (options: Options<BoardDirectorGetBoardReturnCopyForDirectorData>) => queryOptions<BoardDirectorGetBoardReturnCopyForDirectorResponse, BoardDirectorGetBoardReturnCopyForDirectorError, BoardDirectorGetBoardReturnCopyForDirectorResponse, ReturnType<typeof boardDirectorGetBoardReturnCopyForDirectorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardReturnCopyForDirector({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardReturnCopyForDirectorQueryKey(options)
});

export const boardDirectorOpenBoardReturnCopyForDirectorQueryKey = (options: Options<BoardDirectorOpenBoardReturnCopyForDirectorData>) => createQueryKey('board-director-open_board_return_copy_for_director', options);

/**
 * Open Board Return Copy For Director
 *
 * A link to open the copy, valid for 15 minutes. If it was sent to you, the first time you
 * open it is recorded first, so the board can see you received it.
 */
export const boardDirectorOpenBoardReturnCopyForDirectorOptions = (options: Options<BoardDirectorOpenBoardReturnCopyForDirectorData>) => queryOptions<BoardDirectorOpenBoardReturnCopyForDirectorResponse, BoardDirectorOpenBoardReturnCopyForDirectorError, BoardDirectorOpenBoardReturnCopyForDirectorResponse, ReturnType<typeof boardDirectorOpenBoardReturnCopyForDirectorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOpenBoardReturnCopyForDirector({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOpenBoardReturnCopyForDirectorQueryKey(options)
});

/**
 * Start Board Seat Move
 *
 * Start moving your seat on this board to another of your Givmo accounts.
 *
 * Answers a single-use ticket, ONCE, for this page to keep in its own tab — never in an
 * address or a mail — with when it stops working (30 minutes) and the seat's address,
 * masked. The ticket is the move's first proof: this account, which holds the seat, was
 * signed in when the move began. It moves nothing by itself: the move finishes signed in to
 * the other account, which proves the seat's address (its own confirmed email is that
 * address, or a code mailed there). Starting a move is capped per seat per day
 * (`board_seat_claim_code_throttled`).
 */
export const boardDirectorStartBoardSeatMoveMutation = (options?: Partial<Options<BoardDirectorStartBoardSeatMoveData>>): UseMutationOptions<BoardDirectorStartBoardSeatMoveResponse, BoardDirectorStartBoardSeatMoveError, Options<BoardDirectorStartBoardSeatMoveData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorStartBoardSeatMoveResponse, BoardDirectorStartBoardSeatMoveError, Options<BoardDirectorStartBoardSeatMoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorStartBoardSeatMove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorListOwnBoardSelfAssessmentsQueryKey = (options: Options<BoardDirectorListOwnBoardSelfAssessmentsData>) => createQueryKey('board-director-list_own_board_self_assessments', options);

/**
 * List Own Board Self Assessments
 *
 * The board's self-assessments you were asked to answer, newest first, with your own part in
 * each: whether you've answered, and whether the results are in.
 */
export const boardDirectorListOwnBoardSelfAssessmentsOptions = (options: Options<BoardDirectorListOwnBoardSelfAssessmentsData>) => queryOptions<BoardDirectorListOwnBoardSelfAssessmentsResponse, BoardDirectorListOwnBoardSelfAssessmentsError, BoardDirectorListOwnBoardSelfAssessmentsResponse, ReturnType<typeof boardDirectorListOwnBoardSelfAssessmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorListOwnBoardSelfAssessments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorListOwnBoardSelfAssessmentsQueryKey(options)
});

/**
 * Save Own Board Self Assessment Answers
 *
 * Send your answers. They replace your earlier ones until the self-assessment closes, and
 * stay private to you: the board sees only the results, together and without names.
 */
export const boardDirectorSaveOwnBoardSelfAssessmentAnswersMutation = (options?: Partial<Options<BoardDirectorSaveOwnBoardSelfAssessmentAnswersData>>): UseMutationOptions<BoardDirectorSaveOwnBoardSelfAssessmentAnswersResponse, BoardDirectorSaveOwnBoardSelfAssessmentAnswersError, Options<BoardDirectorSaveOwnBoardSelfAssessmentAnswersData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorSaveOwnBoardSelfAssessmentAnswersResponse, BoardDirectorSaveOwnBoardSelfAssessmentAnswersError, Options<BoardDirectorSaveOwnBoardSelfAssessmentAnswersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorSaveOwnBoardSelfAssessmentAnswers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetOwnBoardSelfAssessmentQuestionsQueryKey = (options: Options<BoardDirectorGetOwnBoardSelfAssessmentQuestionsData>) => createQueryKey('board-director-get_own_board_self_assessment_questions', options);

/**
 * Get Own Board Self Assessment Questions
 *
 * The self-assessment's statements, each with its source, and your own answers while it's
 * open. No one else sees your answers.
 */
export const boardDirectorGetOwnBoardSelfAssessmentQuestionsOptions = (options: Options<BoardDirectorGetOwnBoardSelfAssessmentQuestionsData>) => queryOptions<BoardDirectorGetOwnBoardSelfAssessmentQuestionsResponse, BoardDirectorGetOwnBoardSelfAssessmentQuestionsError, BoardDirectorGetOwnBoardSelfAssessmentQuestionsResponse, ReturnType<typeof boardDirectorGetOwnBoardSelfAssessmentQuestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetOwnBoardSelfAssessmentQuestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetOwnBoardSelfAssessmentQuestionsQueryKey(options)
});

export const boardDirectorGetBoardSelfAssessmentResultsForDirectorQueryKey = (options: Options<BoardDirectorGetBoardSelfAssessmentResultsForDirectorData>) => createQueryKey('board-director-get_board_self_assessment_results_for_director', options);

/**
 * Get Board Self Assessment Results For Director
 *
 * A closed self-assessment's results: how many people chose each answer and the comments
 * without names, or, with fewer than three answers, only how many were asked and answered.
 */
export const boardDirectorGetBoardSelfAssessmentResultsForDirectorOptions = (options: Options<BoardDirectorGetBoardSelfAssessmentResultsForDirectorData>) => queryOptions<BoardDirectorGetBoardSelfAssessmentResultsForDirectorResponse, BoardDirectorGetBoardSelfAssessmentResultsForDirectorError, BoardDirectorGetBoardSelfAssessmentResultsForDirectorResponse, ReturnType<typeof boardDirectorGetBoardSelfAssessmentResultsForDirectorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardSelfAssessmentResultsForDirector({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardSelfAssessmentResultsForDirectorQueryKey(options)
});

export const boardDirectorListBoardDirectorConsentsQueryKey = (options: Options<BoardDirectorListBoardDirectorConsentsData>) => createQueryKey('board-director-list_board_director_consents', options);

/**
 * List Board Director Consents
 *
 * The consents this director is being asked to sign.
 *
 * Scoped to the roster the consent currently before the board went out to, so a
 * consent this director was not asked to sign is ABSENT — from the page and from
 * `meta.total` together.
 */
export const boardDirectorListBoardDirectorConsentsOptions = (options: Options<BoardDirectorListBoardDirectorConsentsData>) => queryOptions<BoardDirectorListBoardDirectorConsentsResponse, BoardDirectorListBoardDirectorConsentsError, BoardDirectorListBoardDirectorConsentsResponse, ReturnType<typeof boardDirectorListBoardDirectorConsentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorListBoardDirectorConsents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorListBoardDirectorConsentsQueryKey(options)
});

export const boardDirectorGetBoardDirectorConsentQueryKey = (options: Options<BoardDirectorGetBoardDirectorConsentData>) => createQueryKey('board-director-get_board_director_consent', options);

/**
 * Get Board Director Consent
 *
 * One consent, with its full text and this director's own standing.
 *
 * `content_hash` is the address of the text shown here, and it is what a signature has
 * to echo — so a director who signs is signing exactly what they were shown.
 */
export const boardDirectorGetBoardDirectorConsentOptions = (options: Options<BoardDirectorGetBoardDirectorConsentData>) => queryOptions<BoardDirectorGetBoardDirectorConsentResponse, BoardDirectorGetBoardDirectorConsentError, BoardDirectorGetBoardDirectorConsentResponse, ReturnType<typeof boardDirectorGetBoardDirectorConsentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorConsent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorConsentQueryKey(options)
});

export const boardDirectorGetBoardCompensationDocumentDownloadForDirectorQueryKey = (options: Options<BoardDirectorGetBoardCompensationDocumentDownloadForDirectorData>) => createQueryKey('board-director-get_board_compensation_document_download_for_director', options);

/**
 * Get Board Compensation Document Download For Director
 *
 * A short-lived link to read one document a consent's compensation details name, for anyone
 * on the board's roster once the consent has gone out — so each document the text names can be
 * opened before signing. Made for this request and never stored.
 */
export const boardDirectorGetBoardCompensationDocumentDownloadForDirectorOptions = (options: Options<BoardDirectorGetBoardCompensationDocumentDownloadForDirectorData>) => queryOptions<BoardDirectorGetBoardCompensationDocumentDownloadForDirectorResponse, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorError, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorResponse, ReturnType<typeof boardDirectorGetBoardCompensationDocumentDownloadForDirectorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardCompensationDocumentDownloadForDirector({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardCompensationDocumentDownloadForDirectorQueryKey(options)
});

/**
 * Sign Board Written Consent
 *
 * Sign the consent.
 *
 * Needs the director's signing window open; without it the answer is the typed 400
 * `board_director_signing_required` the console turns into its confirm sheet.
 * `intent_statement_id` echoes the words beside the button; a stale id is a typed 409.
 *
 * `content_hash` is a required echo of the text this director read, so a signature can
 * never land on text that changed after they read it. If this is the last outstanding
 * signature, the same request records the consent in the charity's board records.
 */
export const boardDirectorSignBoardWrittenConsentMutation = (options?: Partial<Options<BoardDirectorSignBoardWrittenConsentData>>): UseMutationOptions<BoardDirectorSignBoardWrittenConsentResponse, BoardDirectorSignBoardWrittenConsentError, Options<BoardDirectorSignBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorSignBoardWrittenConsentResponse, BoardDirectorSignBoardWrittenConsentError, Options<BoardDirectorSignBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorSignBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Board Written Consent Signature
 *
 * Withdraw a signature already given, while the consent is still pending.
 *
 * A director who has second thoughts sends the matter to a meeting instead, and this
 * is how. It is appended as its own act — the signature it withdraws stays in the
 * record — and it needs the signing window for the same reason giving the signature did.
 *
 * Once the consent has been signed by every seat it went out to, it is the board's act
 * and this is no longer available.
 */
export const boardDirectorRevokeBoardWrittenConsentSignatureMutation = (options?: Partial<Options<BoardDirectorRevokeBoardWrittenConsentSignatureData>>): UseMutationOptions<BoardDirectorRevokeBoardWrittenConsentSignatureResponse, BoardDirectorRevokeBoardWrittenConsentSignatureError, Options<BoardDirectorRevokeBoardWrittenConsentSignatureData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorRevokeBoardWrittenConsentSignatureResponse, BoardDirectorRevokeBoardWrittenConsentSignatureError, Options<BoardDirectorRevokeBoardWrittenConsentSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorRevokeBoardWrittenConsentSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorGetBoardDirectorMeQueryKey = (options?: Options<BoardDirectorGetBoardDirectorMeData>) => createQueryKey('board-director-get_board_director_me', options);

/**
 * Get Board Director Me
 *
 * The director's directory: every board this account holds a claimed seat on, the
 * account's signing window, and the words each signature-class act affirms.
 *
 * The board list — organization, role, seat, the board's adopted mode — carries nothing
 * about any board's content, and it is by ACCOUNT only (CBG-SEC2; CBG-FIX17 subsumed):
 * nothing joins by address, so no officer can make anyone's seats appear here. `signing`
 * says whether this sign-in may sign now and, when not, why (`closed_reason`); the console
 * counts down from `closes_at`. The one director read a board that asks for confirmation
 * before anything opens still answers.
 */
export const boardDirectorGetBoardDirectorMeOptions = (options?: Options<BoardDirectorGetBoardDirectorMeData>) => queryOptions<BoardDirectorGetBoardDirectorMeResponse, DefaultError, BoardDirectorGetBoardDirectorMeResponse, ReturnType<typeof boardDirectorGetBoardDirectorMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorGetBoardDirectorMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorGetBoardDirectorMeQueryKey(options)
});

/**
 * Org Claim Board Seat
 *
 * Claim the invited seat into the signed-in Givmo account: automatically when the
 * account's email, confirmed by its sign-in provider, matches the seat's address, otherwise
 * with the code that account asked for (`board_seat_claim_code_required` names where it
 * would go, masked). Answers the seat as `/me` lists it; claiming a seat the account already
 * holds answers the same. An account that already holds another seat on this board is
 * refused (`board_account_already_seated_here`), and so is an account another organization's
 * sign-in lock binds (`board_another_account_required`).
 */
export const boardDirectorOrgClaimBoardSeatMutation = (options?: Partial<Options<BoardDirectorOrgClaimBoardSeatData>>): UseMutationOptions<BoardDirectorOrgClaimBoardSeatResponse, BoardDirectorOrgClaimBoardSeatError, Options<BoardDirectorOrgClaimBoardSeatData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgClaimBoardSeatResponse, BoardDirectorOrgClaimBoardSeatError, Options<BoardDirectorOrgClaimBoardSeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgClaimBoardSeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Request Board Seat Claim Code
 *
 * Email a six-digit code to the invited seat's address, for the signed-in account to
 * claim the seat with when its own email does not match. The code is spendable only by the
 * account that asked, for 10 minutes and 5 tries, and appears in no response. `email_sent`
 * false means this environment sends no such mail (no code exists); a send that failed is
 * the typed 503 `board_seat_claim_code_not_sent`. Throttled per seat and capped per
 * invitation (`board_seat_claim_code_throttled`). An account another organization's sign-in
 * lock binds is refused before any code exists (`board_another_account_required`).
 */
export const boardDirectorOrgRequestBoardSeatClaimCodeMutation = (options?: Partial<Options<BoardDirectorOrgRequestBoardSeatClaimCodeData>>): UseMutationOptions<BoardDirectorOrgRequestBoardSeatClaimCodeResponse, BoardDirectorOrgRequestBoardSeatClaimCodeError, Options<BoardDirectorOrgRequestBoardSeatClaimCodeData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgRequestBoardSeatClaimCodeResponse, BoardDirectorOrgRequestBoardSeatClaimCodeError, Options<BoardDirectorOrgRequestBoardSeatClaimCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgRequestBoardSeatClaimCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Preview Board Invitation
 *
 * What a board invitation is for, before it is used: the organization, the seat's name,
 * and where a code would go — masked. When the signed-in account already holds the seat,
 * `claimed_by_you` is true and the landing opens the board instead. Nothing is written, and
 * no account is needed. A link that can't be used — unknown, spent, expired, retired, its
 * seat removed or claimed by another account — gets one constant refusal,
 * `board_invitation_unavailable`. For a signed-in account whose answer is known,
 * `another_account_required` is true when another organization's sign-in lock binds the
 * account (today, an employer's company-only sign-in), so it can't join this board and the
 * landing offers another Givmo account.
 */
export const boardDirectorOrgPreviewBoardInvitationMutation = (options?: Partial<Options<BoardDirectorOrgPreviewBoardInvitationData>>): UseMutationOptions<BoardDirectorOrgPreviewBoardInvitationResponse, BoardDirectorOrgPreviewBoardInvitationError, Options<BoardDirectorOrgPreviewBoardInvitationData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgPreviewBoardInvitationResponse, BoardDirectorOrgPreviewBoardInvitationError, Options<BoardDirectorOrgPreviewBoardInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgPreviewBoardInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgGetBoardDirectorMeQueryKey = (options?: Options<BoardDirectorOrgGetBoardDirectorMeData>) => createQueryKey('board-director-org_get_board_director_me', options);

/**
 * Org Get Board Director Me
 *
 * The director's directory: every board this account holds a claimed seat on, the
 * account's signing window, and the words each signature-class act affirms.
 *
 * The board list — organization, role, seat, the board's adopted mode — carries nothing
 * about any board's content, and it is by ACCOUNT only (CBG-SEC2; CBG-FIX17 subsumed):
 * nothing joins by address, so no officer can make anyone's seats appear here. `signing`
 * says whether this sign-in may sign now and, when not, why (`closed_reason`); the console
 * counts down from `closes_at`. The one director read a board that asks for confirmation
 * before anything opens still answers.
 */
export const boardDirectorOrgGetBoardDirectorMeOptions = (options?: Options<BoardDirectorOrgGetBoardDirectorMeData>) => queryOptions<BoardDirectorOrgGetBoardDirectorMeResponse, DefaultError, BoardDirectorOrgGetBoardDirectorMeResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorMeQueryKey(options)
});

/**
 * Org Request Board Seat Move Code
 *
 * Email a six-digit code to the moving seat's address, for the signed-in account to finish
 * the move with when its own email does not match. The code is spendable only by the account
 * that asked, for 10 minutes and 5 tries, and appears in no response; it shares the claim
 * code's caps, counted per seat (`board_seat_claim_code_throttled`). `email_sent` false means
 * this environment sends no such mail (no code exists); a send that failed is the typed 503
 * `board_seat_claim_code_not_sent`. Refused before any code exists for the account the seat is
 * on (`board_seat_move_same_account`), an account another organization's sign-in lock binds
 * (`board_another_account_required`) and one that already holds a seat on this board
 * (`board_account_already_seated_here`).
 */
export const boardDirectorOrgRequestBoardSeatMoveCodeMutation = (options?: Partial<Options<BoardDirectorOrgRequestBoardSeatMoveCodeData>>): UseMutationOptions<BoardDirectorOrgRequestBoardSeatMoveCodeResponse, BoardDirectorOrgRequestBoardSeatMoveCodeError, Options<BoardDirectorOrgRequestBoardSeatMoveCodeData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgRequestBoardSeatMoveCodeResponse, BoardDirectorOrgRequestBoardSeatMoveCodeError, Options<BoardDirectorOrgRequestBoardSeatMoveCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgRequestBoardSeatMoveCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Complete Board Seat Move
 *
 * Move the seat into the signed-in Givmo account: automatically when the account's email,
 * confirmed by its sign-in provider, is the seat's address, otherwise with the code that
 * account asked for (`board_seat_claim_code_required` names where it would go, masked). One
 * step that can't half-happen: the seat, the ticket and the code, and the seat's history line.
 * Both the account the seat left and the seat's address get an email. Answers the seat as
 * `/me` lists it; finishing a move that already finished here answers the same. Refused for
 * the account the seat is on (`board_seat_move_same_account`), an account another
 * organization's sign-in lock binds (`board_another_account_required`) and one that already
 * holds a seat on this board (`board_account_already_seated_here`).
 */
export const boardDirectorOrgCompleteBoardSeatMoveMutation = (options?: Partial<Options<BoardDirectorOrgCompleteBoardSeatMoveData>>): UseMutationOptions<BoardDirectorOrgCompleteBoardSeatMoveResponse, BoardDirectorOrgCompleteBoardSeatMoveError, Options<BoardDirectorOrgCompleteBoardSeatMoveData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgCompleteBoardSeatMoveResponse, BoardDirectorOrgCompleteBoardSeatMoveError, Options<BoardDirectorOrgCompleteBoardSeatMoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgCompleteBoardSeatMove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Preview Board Seat Move
 *
 * What a seat move is for, before it finishes: the organization, the seat's name, the
 * seat's address and the account it moves from — both masked. Nothing is written. For a
 * signed-in account: `from_this_account` (it is the account the seat is on, so it can't take
 * the seat), `email_matches_seat` (its confirmed email is the seat's address, so no code is
 * needed) and, when known, `another_account_required` (another organization's sign-in lock
 * binds it, so it can't hold the seat either). A ticket that can't be used — unknown, spent,
 * expired, retired, or its seat removed, released or moved meanwhile — gets one constant
 * refusal, `board_seat_move_unavailable`.
 */
export const boardDirectorOrgPreviewBoardSeatMoveMutation = (options?: Partial<Options<BoardDirectorOrgPreviewBoardSeatMoveData>>): UseMutationOptions<BoardDirectorOrgPreviewBoardSeatMoveResponse, BoardDirectorOrgPreviewBoardSeatMoveError, Options<BoardDirectorOrgPreviewBoardSeatMoveData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgPreviewBoardSeatMoveResponse, BoardDirectorOrgPreviewBoardSeatMoveError, Options<BoardDirectorOrgPreviewBoardSeatMoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgPreviewBoardSeatMove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgListBoardDirectorUpcomingMeetingsQueryKey = (options?: Options<BoardDirectorOrgListBoardDirectorUpcomingMeetingsData>) => createQueryKey('board-director-org_list_board_director_upcoming_meetings', options);

/**
 * Org List Board Director Upcoming Meetings
 *
 * Upcoming meetings across every board this account holds a claimed seat on.
 *
 * It carries a directory's restraint — which board, which seat, when, and this seat's own
 * answer; deliberately no title, no location and no agenda, because a meeting's title is
 * content. It spans the account's OWN claimed seats only (CBG-SEC2; CBG-FIX17 subsumed), so
 * no officer can make anyone's schedule appear by seating an address; a board that asks for
 * confirmation before anything opens is left out while this sign-in's signing window is shut.
 */
export const boardDirectorOrgListBoardDirectorUpcomingMeetingsOptions = (options?: Options<BoardDirectorOrgListBoardDirectorUpcomingMeetingsData>) => queryOptions<BoardDirectorOrgListBoardDirectorUpcomingMeetingsResponse, DefaultError, BoardDirectorOrgListBoardDirectorUpcomingMeetingsResponse, ReturnType<typeof boardDirectorOrgListBoardDirectorUpcomingMeetingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgListBoardDirectorUpcomingMeetings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgListBoardDirectorUpcomingMeetingsQueryKey(options)
});

export const boardDirectorOrgGetBoardAboutQueryKey = (options: Options<BoardDirectorOrgGetBoardAboutData>) => createQueryKey('board-director-org_get_board_about', options);

/**
 * Org Get Board About
 *
 * About the board, from its own records: who serves and in what role, the duties the board
 * recorded for its officers, its recorded meeting rules and next meeting, its governing documents
 * in force, and its minutes and written consents of the last twelve months. Nothing from a
 * closed session.
 */
export const boardDirectorOrgGetBoardAboutOptions = (options: Options<BoardDirectorOrgGetBoardAboutData>) => queryOptions<BoardDirectorOrgGetBoardAboutResponse, BoardDirectorOrgGetBoardAboutError, BoardDirectorOrgGetBoardAboutResponse, ReturnType<typeof boardDirectorOrgGetBoardAboutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardAbout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardAboutQueryKey(options)
});

export const boardDirectorOrgGetBoardDirectorAttentionQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorAttentionData>) => createQueryKey('board-director-org_get_board_director_attention', options);

/**
 * Org Get Board Director Attention
 *
 * What is waiting for this director on this board.
 *
 * Three kinds share one list, each narrowable on its ``kind`` discriminator: an
 * unanswered meeting, a consent awaiting this seat's signature, and approved minutes
 * awaiting it. Only what this director can ACT on appears, so an empty list is an
 * honest "nothing is waiting".
 */
export const boardDirectorOrgGetBoardDirectorAttentionOptions = (options: Options<BoardDirectorOrgGetBoardDirectorAttentionData>) => queryOptions<BoardDirectorOrgGetBoardDirectorAttentionResponse, BoardDirectorOrgGetBoardDirectorAttentionError, BoardDirectorOrgGetBoardDirectorAttentionResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorAttentionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorAttention({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorAttentionQueryKey(options)
});

export const boardDirectorOrgGetBoardDirectorAttentionCompletedQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorAttentionCompletedData>) => createQueryKey('board-director-org_get_board_director_attention_completed', options);

/**
 * Org Get Board Director Attention Completed
 *
 * What you did on this board in the last 90 days, newest first: written consents you signed,
 * minutes you signed, meetings you answered for, questionnaires and self-assessments you
 * answered, copies of the return you opened. Your own acts only, scoped as what waits for you
 * is: a closed session's minutes only once you've confirmed it's you.
 */
export const boardDirectorOrgGetBoardDirectorAttentionCompletedOptions = (options: Options<BoardDirectorOrgGetBoardDirectorAttentionCompletedData>) => queryOptions<BoardDirectorOrgGetBoardDirectorAttentionCompletedResponse, BoardDirectorOrgGetBoardDirectorAttentionCompletedError, BoardDirectorOrgGetBoardDirectorAttentionCompletedResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorAttentionCompletedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorAttentionCompleted({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorAttentionCompletedQueryKey(options)
});

export const boardDirectorOrgListOwnBoardCoiCyclesQueryKey = (options: Options<BoardDirectorOrgListOwnBoardCoiCyclesData>) => createQueryKey('board-director-org_list_own_board_coi_cycles', options);

/**
 * Org List Own Board Coi Cycles
 *
 * The years you were asked for your conflict-of-interest answers on this board, newest
 * first, with your own answers where you've sent them.
 */
export const boardDirectorOrgListOwnBoardCoiCyclesOptions = (options: Options<BoardDirectorOrgListOwnBoardCoiCyclesData>) => queryOptions<BoardDirectorOrgListOwnBoardCoiCyclesResponse, BoardDirectorOrgListOwnBoardCoiCyclesError, BoardDirectorOrgListOwnBoardCoiCyclesResponse, ReturnType<typeof boardDirectorOrgListOwnBoardCoiCyclesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgListOwnBoardCoiCycles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgListOwnBoardCoiCyclesQueryKey(options)
});

export const boardDirectorOrgGetOwnBoardCoiQuestionnaireQueryKey = (options: Options<BoardDirectorOrgGetOwnBoardCoiQuestionnaireData>) => createQueryKey('board-director-org_get_own_board_coi_questionnaire', options);

/**
 * Org Get Own Board Coi Questionnaire
 *
 * Your questionnaire for the year: the questions as you're asked them, your board's policy,
 * your answers from last year filled in, and the single disclosures you've made since.
 */
export const boardDirectorOrgGetOwnBoardCoiQuestionnaireOptions = (options: Options<BoardDirectorOrgGetOwnBoardCoiQuestionnaireData>) => queryOptions<BoardDirectorOrgGetOwnBoardCoiQuestionnaireResponse, BoardDirectorOrgGetOwnBoardCoiQuestionnaireError, BoardDirectorOrgGetOwnBoardCoiQuestionnaireResponse, ReturnType<typeof boardDirectorOrgGetOwnBoardCoiQuestionnaireQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetOwnBoardCoiQuestionnaire({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetOwnBoardCoiQuestionnaireQueryKey(options)
});

export const boardDirectorOrgGetOwnBoardCoiResponseQueryKey = (options: Options<BoardDirectorOrgGetOwnBoardCoiResponseData>) => createQueryKey('board-director-org_get_own_board_coi_response', options);

/**
 * Org Get Own Board Coi Response
 *
 * Your answers for the year as recorded, with any correction you've made.
 */
export const boardDirectorOrgGetOwnBoardCoiResponseOptions = (options: Options<BoardDirectorOrgGetOwnBoardCoiResponseData>) => queryOptions<BoardDirectorOrgGetOwnBoardCoiResponseResponse, BoardDirectorOrgGetOwnBoardCoiResponseError, BoardDirectorOrgGetOwnBoardCoiResponseResponse, ReturnType<typeof boardDirectorOrgGetOwnBoardCoiResponseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetOwnBoardCoiResponse({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetOwnBoardCoiResponseQueryKey(options)
});

/**
 * Org Submit Own Board Coi Response
 *
 * Sign your answers for the year. A signature-class act: it needs your signing window open,
 * and `intent_statement_id` echoes the words beside Sign (a stale id is a typed 409). Your
 * signed answers become your disclosure in the board's records, in place of last year's.
 * `corrects_record_id` adds a correction beside answers you've already signed.
 */
export const boardDirectorOrgSubmitOwnBoardCoiResponseMutation = (options?: Partial<Options<BoardDirectorOrgSubmitOwnBoardCoiResponseData>>): UseMutationOptions<BoardDirectorOrgSubmitOwnBoardCoiResponseResponse, BoardDirectorOrgSubmitOwnBoardCoiResponseError, Options<BoardDirectorOrgSubmitOwnBoardCoiResponseData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgSubmitOwnBoardCoiResponseResponse, BoardDirectorOrgSubmitOwnBoardCoiResponseError, Options<BoardDirectorOrgSubmitOwnBoardCoiResponseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgSubmitOwnBoardCoiResponse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgGetOwnBoardCoiResponseChangesQueryKey = (options: Options<BoardDirectorOrgGetOwnBoardCoiResponseChangesData>) => createQueryKey('board-director-org_get_own_board_coi_response_changes', options);

/**
 * Org Get Own Board Coi Response Changes
 *
 * Your answers for the year against your answers from the year before, question by
 * question.
 */
export const boardDirectorOrgGetOwnBoardCoiResponseChangesOptions = (options: Options<BoardDirectorOrgGetOwnBoardCoiResponseChangesData>) => queryOptions<BoardDirectorOrgGetOwnBoardCoiResponseChangesResponse, BoardDirectorOrgGetOwnBoardCoiResponseChangesError, BoardDirectorOrgGetOwnBoardCoiResponseChangesResponse, ReturnType<typeof boardDirectorOrgGetOwnBoardCoiResponseChangesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetOwnBoardCoiResponseChanges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetOwnBoardCoiResponseChangesQueryKey(options)
});

export const boardDirectorOrgGetOwnBoardCoiResponseDocumentQueryKey = (options: Options<BoardDirectorOrgGetOwnBoardCoiResponseDocumentData>) => createQueryKey('board-director-org_get_own_board_coi_response_document', options);

/**
 * Org Get Own Board Coi Response Document
 *
 * Your copy of your answers for the year, as a PDF: as recorded, or the changes from the
 * year before.
 */
export const boardDirectorOrgGetOwnBoardCoiResponseDocumentOptions = (options: Options<BoardDirectorOrgGetOwnBoardCoiResponseDocumentData>) => queryOptions<BoardDirectorOrgGetOwnBoardCoiResponseDocumentResponse, BoardDirectorOrgGetOwnBoardCoiResponseDocumentError, BoardDirectorOrgGetOwnBoardCoiResponseDocumentResponse, ReturnType<typeof boardDirectorOrgGetOwnBoardCoiResponseDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetOwnBoardCoiResponseDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetOwnBoardCoiResponseDocumentQueryKey(options)
});

export const boardDirectorOrgListOwnBoardConflictDisclosuresQueryKey = (options: Options<BoardDirectorOrgListOwnBoardConflictDisclosuresData>) => createQueryKey('board-director-org_list_own_board_conflict_disclosures', options);

/**
 * Org List Own Board Conflict Disclosures
 *
 * Your own recorded disclosures on this board — what the book says about you.
 *
 * Never another director's: the seat is the one your account claimed, and this route takes
 * no id that could name someone else. `status` on each entry says whether it still stands
 * or a later disclosure of yours replaced it.
 */
export const boardDirectorOrgListOwnBoardConflictDisclosuresOptions = (options: Options<BoardDirectorOrgListOwnBoardConflictDisclosuresData>) => queryOptions<BoardDirectorOrgListOwnBoardConflictDisclosuresResponse, BoardDirectorOrgListOwnBoardConflictDisclosuresError, BoardDirectorOrgListOwnBoardConflictDisclosuresResponse, ReturnType<typeof boardDirectorOrgListOwnBoardConflictDisclosuresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgListOwnBoardConflictDisclosures({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgListOwnBoardConflictDisclosuresQueryKey(options)
});

/**
 * Org Record Own Board Conflict Disclosure
 *
 * Record your own conflict-of-interest disclosure.
 *
 * Describe the interest in your own words and, where there is one, name the counterparty
 * — the person or organization on the other side of it. The name is what lets the
 * recording officer be shown this disclosure beside an agenda item or motion that
 * mentions it, before the board votes.
 *
 * A signature-class act: it needs the director's signing window, for the same reason a
 * consent signature does. Without it the answer is the typed 400
 * `board_director_signing_required` the console turns into its confirm sheet, never a 401.
 * `intent_statement_id` echoes the words beside the button.
 *
 * `supersedes_record_id` records that your position has CHANGED — the earlier disclosure
 * stays an accurate record of what was true at its time, which is usually what you mean.
 * `corrects_record_id` records that the earlier one was wrong.
 *
 * Recording this does not decide anything: whether you stand out of a vote is the
 * board's determination, recorded in the minutes as a recusal.
 */
export const boardDirectorOrgRecordOwnBoardConflictDisclosureMutation = (options?: Partial<Options<BoardDirectorOrgRecordOwnBoardConflictDisclosureData>>): UseMutationOptions<BoardDirectorOrgRecordOwnBoardConflictDisclosureResponse, BoardDirectorOrgRecordOwnBoardConflictDisclosureError, Options<BoardDirectorOrgRecordOwnBoardConflictDisclosureData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgRecordOwnBoardConflictDisclosureResponse, BoardDirectorOrgRecordOwnBoardConflictDisclosureError, Options<BoardDirectorOrgRecordOwnBoardConflictDisclosureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgRecordOwnBoardConflictDisclosure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgGetOwnBoardGettingStartedQueryKey = (options: Options<BoardDirectorOrgGetOwnBoardGettingStartedData>) => createQueryKey('board-director-org_get_own_board_getting_started', options);

/**
 * Org Get Own Board Getting Started
 *
 * Your getting-started list on this board: the documents to read and confirm, your first
 * conflict-of-interest disclosure, the board's own steps, and your board buddy.
 */
export const boardDirectorOrgGetOwnBoardGettingStartedOptions = (options: Options<BoardDirectorOrgGetOwnBoardGettingStartedData>) => queryOptions<BoardDirectorOrgGetOwnBoardGettingStartedResponse, BoardDirectorOrgGetOwnBoardGettingStartedError, BoardDirectorOrgGetOwnBoardGettingStartedResponse, ReturnType<typeof boardDirectorOrgGetOwnBoardGettingStartedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetOwnBoardGettingStarted({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetOwnBoardGettingStartedQueryKey(options)
});

/**
 * Org Mark Own Board Getting Started Step
 *
 * Mark one of your board's steps on your list done, with the date, or clear it.
 */
export const boardDirectorOrgMarkOwnBoardGettingStartedStepMutation = (options?: Partial<Options<BoardDirectorOrgMarkOwnBoardGettingStartedStepData>>): UseMutationOptions<BoardDirectorOrgMarkOwnBoardGettingStartedStepResponse, BoardDirectorOrgMarkOwnBoardGettingStartedStepError, Options<BoardDirectorOrgMarkOwnBoardGettingStartedStepData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgMarkOwnBoardGettingStartedStepResponse, BoardDirectorOrgMarkOwnBoardGettingStartedStepError, Options<BoardDirectorOrgMarkOwnBoardGettingStartedStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgMarkOwnBoardGettingStartedStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgListBoardDirectorMeetingsQueryKey = (options: Options<BoardDirectorOrgListBoardDirectorMeetingsData>) => createQueryKey('board-director-org_list_board_director_meetings', options);

/**
 * Org List Board Director Meetings
 *
 * This board's meetings, soonest first, with this seat's own answer on each.
 *
 * Defaults to upcoming only: a director opening the surface is looking at what is ahead.
 * Past meetings are available by asking for them.
 */
export const boardDirectorOrgListBoardDirectorMeetingsOptions = (options: Options<BoardDirectorOrgListBoardDirectorMeetingsData>) => queryOptions<BoardDirectorOrgListBoardDirectorMeetingsResponse, BoardDirectorOrgListBoardDirectorMeetingsError, BoardDirectorOrgListBoardDirectorMeetingsResponse, ReturnType<typeof boardDirectorOrgListBoardDirectorMeetingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgListBoardDirectorMeetings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgListBoardDirectorMeetingsQueryKey(options)
});

export const boardDirectorOrgGetBoardDirectorMeetingQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorMeetingData>) => createQueryKey('board-director-org_get_board_director_meeting', options);

/**
 * Org Get Board Director Meeting
 *
 * One meeting, with its agenda and the current published packet's id.
 *
 * The notice block is included: it is the charity's own recorded parameter and the
 * arithmetic against it, and the sentence names the section the charity attributed the
 * period to — so a director can read it against the instrument themselves rather than
 * take the product's word for anything.
 */
export const boardDirectorOrgGetBoardDirectorMeetingOptions = (options: Options<BoardDirectorOrgGetBoardDirectorMeetingData>) => queryOptions<BoardDirectorOrgGetBoardDirectorMeetingResponse, BoardDirectorOrgGetBoardDirectorMeetingError, BoardDirectorOrgGetBoardDirectorMeetingResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorMeetingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorMeeting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorMeetingQueryKey(options)
});

/**
 * Org Record Board Director Attendance Intent
 *
 * Answer whether this director expects to attend.
 *
 * Rides the account's sign-in and needs no signing window: how strongly a director must
 * confirm it's them is tiered by the weight of the act, and an answer about attendance
 * binds nobody to anything. A vote, a written consent, or e-signing minutes does need one.
 *
 * A PUT because there is one current answer per director per meeting; changing it
 * replaces it, and when the answer was FIRST given is kept either way.
 */
export const boardDirectorOrgRecordBoardDirectorAttendanceIntentMutation = (options?: Partial<Options<BoardDirectorOrgRecordBoardDirectorAttendanceIntentData>>): UseMutationOptions<BoardDirectorOrgRecordBoardDirectorAttendanceIntentResponse, BoardDirectorOrgRecordBoardDirectorAttendanceIntentError, Options<BoardDirectorOrgRecordBoardDirectorAttendanceIntentData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgRecordBoardDirectorAttendanceIntentResponse, BoardDirectorOrgRecordBoardDirectorAttendanceIntentError, Options<BoardDirectorOrgRecordBoardDirectorAttendanceIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgRecordBoardDirectorAttendanceIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgGetBoardDirectorMeetingCalendarQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorMeetingCalendarData>) => createQueryKey('board-director-org_get_board_director_meeting_calendar', options);

/**
 * Org Get Board Director Meeting Calendar
 *
 * The meeting as an iCalendar file, for the director's own calendar.
 */
export const boardDirectorOrgGetBoardDirectorMeetingCalendarOptions = (options: Options<BoardDirectorOrgGetBoardDirectorMeetingCalendarData>) => queryOptions<BoardDirectorOrgGetBoardDirectorMeetingCalendarResponse, BoardDirectorOrgGetBoardDirectorMeetingCalendarError, BoardDirectorOrgGetBoardDirectorMeetingCalendarResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorMeetingCalendarQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorMeetingCalendar({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorMeetingCalendarQueryKey(options)
});

/**
 * Org Sign Board Minutes
 *
 * Sign approved minutes.
 *
 * A signature-class act: it needs the director's signing window open (CBG-SEC2), and the
 * factor that opened it, when it was confirmed and the words affirmed are recorded beside
 * the signature. Reading and answering an invitation do not — the weight of the act sets the
 * bar. `intent_statement_id` echoes the words beside the button; a stale id is a typed 409.
 *
 * `content_hash` is the address of the exact minutes being signed. If they changed since
 * they were read, the signature is refused rather than attached to different words.
 *
 * `capacity_title_id` (optional) records the title this person signs as: one of the titles
 * their seat holds now, kept with the signature in the words it has today. A title the seat
 * doesn't hold is a 409 `board_signature_capacity_not_held`.
 *
 * A signature follows the board's approval; minutes still in draft cannot be signed.
 */
export const boardDirectorOrgSignBoardMinutesMutation = (options?: Partial<Options<BoardDirectorOrgSignBoardMinutesData>>): UseMutationOptions<BoardDirectorOrgSignBoardMinutesResponse, BoardDirectorOrgSignBoardMinutesError, Options<BoardDirectorOrgSignBoardMinutesData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgSignBoardMinutesResponse, BoardDirectorOrgSignBoardMinutesError, Options<BoardDirectorOrgSignBoardMinutesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgSignBoardMinutes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgGetBoardDirectorMeetingRecordQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorMeetingRecordData>) => createQueryKey('board-director-org_get_board_director_meeting_record', options);

/**
 * Org Get Board Director Meeting Record
 *
 * What the charity recorded about one meeting, as this director may see it.
 *
 * Who was present, the parts of the meeting, and the motions with their recorded votes,
 * recusals, and the quorum figures taken at each — plus this seat's own votes and recusals,
 * so a director can see what the book says about them without reading every motion.
 *
 * A closed session this director was not part of is absent, and so is everything recorded
 * inside it. Nothing on the wire counts what was withheld.
 */
export const boardDirectorOrgGetBoardDirectorMeetingRecordOptions = (options: Options<BoardDirectorOrgGetBoardDirectorMeetingRecordData>) => queryOptions<BoardDirectorOrgGetBoardDirectorMeetingRecordResponse, BoardDirectorOrgGetBoardDirectorMeetingRecordError, BoardDirectorOrgGetBoardDirectorMeetingRecordResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorMeetingRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorMeetingRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorMeetingRecordQueryKey(options)
});

export const boardDirectorOrgGetBoardDirectorPacketQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorPacketData>) => createQueryKey('board-director-org_get_board_director_packet', options);

/**
 * Org Get Board Director Packet
 *
 * One published packet version, and a recorded open for the chair's view.
 *
 * A version still being assembled answers exactly as a missing one does — a director
 * reads what the board was sent. An entry pointing at a closed session this director was
 * not part of is absent from the entries. The open is recorded only after the read is
 * allowed, so the chair's view never shows something that did not happen.
 */
export const boardDirectorOrgGetBoardDirectorPacketOptions = (options: Options<BoardDirectorOrgGetBoardDirectorPacketData>) => queryOptions<BoardDirectorOrgGetBoardDirectorPacketResponse, BoardDirectorOrgGetBoardDirectorPacketError, BoardDirectorOrgGetBoardDirectorPacketResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorPacketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorPacket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorPacketQueryKey(options)
});

export const boardDirectorOrgListBoardDirectorAnnotationsQueryKey = (options: Options<BoardDirectorOrgListBoardDirectorAnnotationsData>) => createQueryKey('board-director-org_list_board_director_annotations', options);

/**
 * Org List Board Director Annotations
 *
 * This director's own notes plus every board-visible comment on this version.
 *
 * Another director's personal note is absent, not refused, so the list cannot be used to
 * learn that one exists.
 */
export const boardDirectorOrgListBoardDirectorAnnotationsOptions = (options: Options<BoardDirectorOrgListBoardDirectorAnnotationsData>) => queryOptions<BoardDirectorOrgListBoardDirectorAnnotationsResponse, BoardDirectorOrgListBoardDirectorAnnotationsError, BoardDirectorOrgListBoardDirectorAnnotationsResponse, ReturnType<typeof boardDirectorOrgListBoardDirectorAnnotationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgListBoardDirectorAnnotations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgListBoardDirectorAnnotationsQueryKey(options)
});

/**
 * Org Create Board Director Annotation
 *
 * Write a note on this packet version, or on one of its entries.
 *
 * `visibility` has no default: a personal note and something the whole board will read
 * are different things, and choosing between them is the director's to make explicitly.
 * A personal note is readable by this seat and by nobody else — not another director, and
 * not the charity's own administrators.
 */
export const boardDirectorOrgCreateBoardDirectorAnnotationMutation = (options?: Partial<Options<BoardDirectorOrgCreateBoardDirectorAnnotationData>>): UseMutationOptions<BoardDirectorOrgCreateBoardDirectorAnnotationResponse, BoardDirectorOrgCreateBoardDirectorAnnotationError, Options<BoardDirectorOrgCreateBoardDirectorAnnotationData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgCreateBoardDirectorAnnotationResponse, BoardDirectorOrgCreateBoardDirectorAnnotationError, Options<BoardDirectorOrgCreateBoardDirectorAnnotationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgCreateBoardDirectorAnnotation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Director Annotation
 *
 * Delete one of this director's own notes.
 *
 * Naming another director's note answers exactly as naming one that does not exist.
 * There is no edit: a comment the rest of the board has read must not change under them,
 * and a personal note costs nothing to write again.
 */
export const boardDirectorOrgDeleteBoardDirectorAnnotationMutation = (options?: Partial<Options<BoardDirectorOrgDeleteBoardDirectorAnnotationData>>): UseMutationOptions<BoardDirectorOrgDeleteBoardDirectorAnnotationResponse, BoardDirectorOrgDeleteBoardDirectorAnnotationError, Options<BoardDirectorOrgDeleteBoardDirectorAnnotationData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgDeleteBoardDirectorAnnotationResponse, BoardDirectorOrgDeleteBoardDirectorAnnotationError, Options<BoardDirectorOrgDeleteBoardDirectorAnnotationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgDeleteBoardDirectorAnnotation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlData>) => createQueryKey('board-director-org_get_board_director_packet_document_download_url', options);

/**
 * Org Get Board Director Packet Document Download Url
 *
 * A short-lived read URL for one attachment in this packet version.
 *
 * Reachable only because the attachment is IN a packet this director may read. An
 * attachment uploaded against the meeting but never placed in a published version is not
 * something the board was sent, so it answers as absent.
 */
export const boardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlOptions = (options: Options<BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlData>) => queryOptions<BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlResponse, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlError, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlQueryKey(options)
});

export const boardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlData>) => createQueryKey('board-director-org_get_board_director_filing_receipt_download_url', options);

/**
 * Org Get Board Director Filing Receipt Download Url
 *
 * Authorize this seat to the exact published snapshot before a URL is signed.
 */
export const boardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlOptions = (options: Options<BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlData>) => queryOptions<BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlResponse, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlError, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlQueryKey(options)
});

export const boardDirectorOrgListBoardDirectorRecordsQueryKey = (options: Options<BoardDirectorOrgListBoardDirectorRecordsData>) => createQueryKey('board-director-org_list_board_director_records', options);

/**
 * Org List Board Director Records
 *
 * This board's records, scoped to what this director may read.
 *
 * A closed session the director did not attend is ABSENT from the page and from
 * `meta.total` — scoped together in SQL, so an offset walk cannot map the number or
 * position of the records withheld.
 */
export const boardDirectorOrgListBoardDirectorRecordsOptions = (options: Options<BoardDirectorOrgListBoardDirectorRecordsData>) => queryOptions<BoardDirectorOrgListBoardDirectorRecordsResponse, BoardDirectorOrgListBoardDirectorRecordsError, BoardDirectorOrgListBoardDirectorRecordsResponse, ReturnType<typeof boardDirectorOrgListBoardDirectorRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgListBoardDirectorRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgListBoardDirectorRecordsQueryKey(options)
});

export const boardDirectorOrgGetBoardDirectorRecordQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorRecordData>) => createQueryKey('board-director-org_get_board_director_record', options);

/**
 * Org Get Board Director Record
 *
 * One record, and a recorded open for the chair's engagement view.
 *
 * A record this director may not read answers exactly as a record that does not exist
 * does, and the open is recorded only after the read is allowed.
 */
export const boardDirectorOrgGetBoardDirectorRecordOptions = (options: Options<BoardDirectorOrgGetBoardDirectorRecordData>) => queryOptions<BoardDirectorOrgGetBoardDirectorRecordResponse, BoardDirectorOrgGetBoardDirectorRecordError, BoardDirectorOrgGetBoardDirectorRecordResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorRecordQueryKey(options)
});

/**
 * Org Acknowledge Board Record
 *
 * Record this director's acknowledgment of a record — a signature-class act.
 *
 * Needs the director's signing window open (their passkey, or on an account with no passkey
 * their authenticator app, confirmed in this sign-in within the hour); without it the answer
 * is the typed 400 `board_director_signing_required` the console turns into its confirm
 * sheet, never a 401 that would read as "sign in again".
 *
 * `content_hash` is a required echo of what the director read: the act's whole value is
 * that it names the exact bytes a human saw, so a mismatch is refused rather than
 * recorded. `intent_statement_id` echoes the words beside the button (`/me` lists the
 * current ones); a stale id is a typed 409. The response carries the recorded capture back —
 * which seat, what identity it asserted, the factor that opened the window and when it was
 * confirmed, the words affirmed, and when the act happened.
 */
export const boardDirectorOrgAcknowledgeBoardRecordMutation = (options?: Partial<Options<BoardDirectorOrgAcknowledgeBoardRecordData>>): UseMutationOptions<BoardDirectorOrgAcknowledgeBoardRecordResponse, BoardDirectorOrgAcknowledgeBoardRecordError, Options<BoardDirectorOrgAcknowledgeBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgAcknowledgeBoardRecordResponse, BoardDirectorOrgAcknowledgeBoardRecordError, Options<BoardDirectorOrgAcknowledgeBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgAcknowledgeBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Sign Board Minutes To Approve
 *
 * Sign to approve a closed session's minutes, as one of the directors who were in it.
 *
 * Only where the board's rule approves a closed session's minutes by the signatures of the
 * directors who were there, and only for a director its open request asked: the seat recorded as
 * in the session whose account it was at the meeting's start. Anyone else gets the not-found, as
 * a record that does not exist does. A signature-class act: it needs the director's signing
 * window, and records the factor, when it was confirmed and the words affirmed
 * (`intent_statement_id`; a stale id is a typed 409). `content_hash` is the bytes read: minutes
 * that changed since are refused rather than signed. The last asked signature on the current
 * bytes approves the minutes (`approved`).
 */
export const boardDirectorOrgSignBoardMinutesToApproveMutation = (options?: Partial<Options<BoardDirectorOrgSignBoardMinutesToApproveData>>): UseMutationOptions<BoardDirectorOrgSignBoardMinutesToApproveResponse, BoardDirectorOrgSignBoardMinutesToApproveError, Options<BoardDirectorOrgSignBoardMinutesToApproveData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgSignBoardMinutesToApproveResponse, BoardDirectorOrgSignBoardMinutesToApproveError, Options<BoardDirectorOrgSignBoardMinutesToApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgSignBoardMinutesToApprove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgGetBoardReturnCopyForDirectorQueryKey = (options: Options<BoardDirectorOrgGetBoardReturnCopyForDirectorData>) => createQueryKey('board-director-org_get_board_return_copy_for_director', options);

/**
 * Org Get Board Return Copy For Director
 *
 * A copy of the organization's return provided to the board: the tax year, who provided it
 * and when, the file's name, size and pages, when you opened it, and your recorded reading of
 * it. Nothing about anyone else.
 */
export const boardDirectorOrgGetBoardReturnCopyForDirectorOptions = (options: Options<BoardDirectorOrgGetBoardReturnCopyForDirectorData>) => queryOptions<BoardDirectorOrgGetBoardReturnCopyForDirectorResponse, BoardDirectorOrgGetBoardReturnCopyForDirectorError, BoardDirectorOrgGetBoardReturnCopyForDirectorResponse, ReturnType<typeof boardDirectorOrgGetBoardReturnCopyForDirectorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardReturnCopyForDirector({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardReturnCopyForDirectorQueryKey(options)
});

export const boardDirectorOrgOpenBoardReturnCopyForDirectorQueryKey = (options: Options<BoardDirectorOrgOpenBoardReturnCopyForDirectorData>) => createQueryKey('board-director-org_open_board_return_copy_for_director', options);

/**
 * Org Open Board Return Copy For Director
 *
 * A link to open the copy, valid for 15 minutes. If it was sent to you, the first time you
 * open it is recorded first, so the board can see you received it.
 */
export const boardDirectorOrgOpenBoardReturnCopyForDirectorOptions = (options: Options<BoardDirectorOrgOpenBoardReturnCopyForDirectorData>) => queryOptions<BoardDirectorOrgOpenBoardReturnCopyForDirectorResponse, BoardDirectorOrgOpenBoardReturnCopyForDirectorError, BoardDirectorOrgOpenBoardReturnCopyForDirectorResponse, ReturnType<typeof boardDirectorOrgOpenBoardReturnCopyForDirectorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgOpenBoardReturnCopyForDirector({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgOpenBoardReturnCopyForDirectorQueryKey(options)
});

/**
 * Org Start Board Seat Move
 *
 * Start moving your seat on this board to another of your Givmo accounts.
 *
 * Answers a single-use ticket, ONCE, for this page to keep in its own tab — never in an
 * address or a mail — with when it stops working (30 minutes) and the seat's address,
 * masked. The ticket is the move's first proof: this account, which holds the seat, was
 * signed in when the move began. It moves nothing by itself: the move finishes signed in to
 * the other account, which proves the seat's address (its own confirmed email is that
 * address, or a code mailed there). Starting a move is capped per seat per day
 * (`board_seat_claim_code_throttled`).
 */
export const boardDirectorOrgStartBoardSeatMoveMutation = (options?: Partial<Options<BoardDirectorOrgStartBoardSeatMoveData>>): UseMutationOptions<BoardDirectorOrgStartBoardSeatMoveResponse, BoardDirectorOrgStartBoardSeatMoveError, Options<BoardDirectorOrgStartBoardSeatMoveData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgStartBoardSeatMoveResponse, BoardDirectorOrgStartBoardSeatMoveError, Options<BoardDirectorOrgStartBoardSeatMoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgStartBoardSeatMove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgListOwnBoardSelfAssessmentsQueryKey = (options: Options<BoardDirectorOrgListOwnBoardSelfAssessmentsData>) => createQueryKey('board-director-org_list_own_board_self_assessments', options);

/**
 * Org List Own Board Self Assessments
 *
 * The board's self-assessments you were asked to answer, newest first, with your own part in
 * each: whether you've answered, and whether the results are in.
 */
export const boardDirectorOrgListOwnBoardSelfAssessmentsOptions = (options: Options<BoardDirectorOrgListOwnBoardSelfAssessmentsData>) => queryOptions<BoardDirectorOrgListOwnBoardSelfAssessmentsResponse, BoardDirectorOrgListOwnBoardSelfAssessmentsError, BoardDirectorOrgListOwnBoardSelfAssessmentsResponse, ReturnType<typeof boardDirectorOrgListOwnBoardSelfAssessmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgListOwnBoardSelfAssessments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgListOwnBoardSelfAssessmentsQueryKey(options)
});

/**
 * Org Save Own Board Self Assessment Answers
 *
 * Send your answers. They replace your earlier ones until the self-assessment closes, and
 * stay private to you: the board sees only the results, together and without names.
 */
export const boardDirectorOrgSaveOwnBoardSelfAssessmentAnswersMutation = (options?: Partial<Options<BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersData>>): UseMutationOptions<BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersResponse, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersError, Options<BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersResponse, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersError, Options<BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgSaveOwnBoardSelfAssessmentAnswers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorOrgGetOwnBoardSelfAssessmentQuestionsQueryKey = (options: Options<BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsData>) => createQueryKey('board-director-org_get_own_board_self_assessment_questions', options);

/**
 * Org Get Own Board Self Assessment Questions
 *
 * The self-assessment's statements, each with its source, and your own answers while it's
 * open. No one else sees your answers.
 */
export const boardDirectorOrgGetOwnBoardSelfAssessmentQuestionsOptions = (options: Options<BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsData>) => queryOptions<BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsResponse, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsError, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsResponse, ReturnType<typeof boardDirectorOrgGetOwnBoardSelfAssessmentQuestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetOwnBoardSelfAssessmentQuestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetOwnBoardSelfAssessmentQuestionsQueryKey(options)
});

export const boardDirectorOrgGetBoardSelfAssessmentResultsForDirectorQueryKey = (options: Options<BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorData>) => createQueryKey('board-director-org_get_board_self_assessment_results_for_director', options);

/**
 * Org Get Board Self Assessment Results For Director
 *
 * A closed self-assessment's results: how many people chose each answer and the comments
 * without names, or, with fewer than three answers, only how many were asked and answered.
 */
export const boardDirectorOrgGetBoardSelfAssessmentResultsForDirectorOptions = (options: Options<BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorData>) => queryOptions<BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorResponse, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorError, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorResponse, ReturnType<typeof boardDirectorOrgGetBoardSelfAssessmentResultsForDirectorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardSelfAssessmentResultsForDirector({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardSelfAssessmentResultsForDirectorQueryKey(options)
});

export const boardDirectorOrgListBoardDirectorConsentsQueryKey = (options: Options<BoardDirectorOrgListBoardDirectorConsentsData>) => createQueryKey('board-director-org_list_board_director_consents', options);

/**
 * Org List Board Director Consents
 *
 * The consents this director is being asked to sign.
 *
 * Scoped to the roster the consent currently before the board went out to, so a
 * consent this director was not asked to sign is ABSENT — from the page and from
 * `meta.total` together.
 */
export const boardDirectorOrgListBoardDirectorConsentsOptions = (options: Options<BoardDirectorOrgListBoardDirectorConsentsData>) => queryOptions<BoardDirectorOrgListBoardDirectorConsentsResponse, BoardDirectorOrgListBoardDirectorConsentsError, BoardDirectorOrgListBoardDirectorConsentsResponse, ReturnType<typeof boardDirectorOrgListBoardDirectorConsentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgListBoardDirectorConsents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgListBoardDirectorConsentsQueryKey(options)
});

export const boardDirectorOrgGetBoardDirectorConsentQueryKey = (options: Options<BoardDirectorOrgGetBoardDirectorConsentData>) => createQueryKey('board-director-org_get_board_director_consent', options);

/**
 * Org Get Board Director Consent
 *
 * One consent, with its full text and this director's own standing.
 *
 * `content_hash` is the address of the text shown here, and it is what a signature has
 * to echo — so a director who signs is signing exactly what they were shown.
 */
export const boardDirectorOrgGetBoardDirectorConsentOptions = (options: Options<BoardDirectorOrgGetBoardDirectorConsentData>) => queryOptions<BoardDirectorOrgGetBoardDirectorConsentResponse, BoardDirectorOrgGetBoardDirectorConsentError, BoardDirectorOrgGetBoardDirectorConsentResponse, ReturnType<typeof boardDirectorOrgGetBoardDirectorConsentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardDirectorConsent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardDirectorConsentQueryKey(options)
});

export const boardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorQueryKey = (options: Options<BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorData>) => createQueryKey('board-director-org_get_board_compensation_document_download_for_director', options);

/**
 * Org Get Board Compensation Document Download For Director
 *
 * A short-lived link to read one document a consent's compensation details name, for anyone
 * on the board's roster once the consent has gone out — so each document the text names can be
 * opened before signing. Made for this request and never stored.
 */
export const boardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorOptions = (options: Options<BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorData>) => queryOptions<BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorResponse, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorError, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorResponse, ReturnType<typeof boardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorOrgGetBoardCompensationDocumentDownloadForDirector({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorQueryKey(options)
});

/**
 * Org Sign Board Written Consent
 *
 * Sign the consent.
 *
 * Needs the director's signing window open; without it the answer is the typed 400
 * `board_director_signing_required` the console turns into its confirm sheet.
 * `intent_statement_id` echoes the words beside the button; a stale id is a typed 409.
 *
 * `content_hash` is a required echo of the text this director read, so a signature can
 * never land on text that changed after they read it. If this is the last outstanding
 * signature, the same request records the consent in the charity's board records.
 */
export const boardDirectorOrgSignBoardWrittenConsentMutation = (options?: Partial<Options<BoardDirectorOrgSignBoardWrittenConsentData>>): UseMutationOptions<BoardDirectorOrgSignBoardWrittenConsentResponse, BoardDirectorOrgSignBoardWrittenConsentError, Options<BoardDirectorOrgSignBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgSignBoardWrittenConsentResponse, BoardDirectorOrgSignBoardWrittenConsentError, Options<BoardDirectorOrgSignBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgSignBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Revoke Board Written Consent Signature
 *
 * Withdraw a signature already given, while the consent is still pending.
 *
 * A director who has second thoughts sends the matter to a meeting instead, and this
 * is how. It is appended as its own act — the signature it withdraws stays in the
 * record — and it needs the signing window for the same reason giving the signature did.
 *
 * Once the consent has been signed by every seat it went out to, it is the board's act
 * and this is no longer available.
 */
export const boardDirectorOrgRevokeBoardWrittenConsentSignatureMutation = (options?: Partial<Options<BoardDirectorOrgRevokeBoardWrittenConsentSignatureData>>): UseMutationOptions<BoardDirectorOrgRevokeBoardWrittenConsentSignatureResponse, BoardDirectorOrgRevokeBoardWrittenConsentSignatureError, Options<BoardDirectorOrgRevokeBoardWrittenConsentSignatureData>> => {
    const mutationOptions: UseMutationOptions<BoardDirectorOrgRevokeBoardWrittenConsentSignatureResponse, BoardDirectorOrgRevokeBoardWrittenConsentSignatureError, Options<BoardDirectorOrgRevokeBoardWrittenConsentSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boardDirectorOrgRevokeBoardWrittenConsentSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const boardDirectorListBoardDirectorUpcomingMeetingsQueryKey = (options?: Options<BoardDirectorListBoardDirectorUpcomingMeetingsData>) => createQueryKey('board-director-list_board_director_upcoming_meetings', options);

/**
 * List Board Director Upcoming Meetings
 *
 * Upcoming meetings across every board this account holds a claimed seat on.
 *
 * It carries a directory's restraint — which board, which seat, when, and this seat's own
 * answer; deliberately no title, no location and no agenda, because a meeting's title is
 * content. It spans the account's OWN claimed seats only (CBG-SEC2; CBG-FIX17 subsumed), so
 * no officer can make anyone's schedule appear by seating an address; a board that asks for
 * confirmation before anything opens is left out while this sign-in's signing window is shut.
 */
export const boardDirectorListBoardDirectorUpcomingMeetingsOptions = (options?: Options<BoardDirectorListBoardDirectorUpcomingMeetingsData>) => queryOptions<BoardDirectorListBoardDirectorUpcomingMeetingsResponse, DefaultError, BoardDirectorListBoardDirectorUpcomingMeetingsResponse, ReturnType<typeof boardDirectorListBoardDirectorUpcomingMeetingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await boardDirectorListBoardDirectorUpcomingMeetings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: boardDirectorListBoardDirectorUpcomingMeetingsQueryKey(options)
});

export const orgBoardOrgListBoardAgendaTemplatesQueryKey = (options: Options<OrgBoardOrgListBoardAgendaTemplatesData>) => createQueryKey('org-board-org_list_board_agenda_templates', options);

/**
 * Org List Board Agenda Templates
 *
 * The neutral agenda templates a charity may select.
 *
 * Structural sections only. Nothing in a template is drawn from any charity's own
 * documents, calendar, or history, and nothing applies one — the charity names the
 * template it wants. `suggested_for` orders a human's picker and is read by nothing.
 */
export const orgBoardOrgListBoardAgendaTemplatesOptions = (options: Options<OrgBoardOrgListBoardAgendaTemplatesData>) => queryOptions<OrgBoardOrgListBoardAgendaTemplatesResponse, OrgBoardOrgListBoardAgendaTemplatesError, OrgBoardOrgListBoardAgendaTemplatesResponse, ReturnType<typeof orgBoardOrgListBoardAgendaTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardAgendaTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardAgendaTemplatesQueryKey(options)
});

export const orgBoardOrgListBoardCalendarConnectionsQueryKey = (options: Options<OrgBoardOrgListBoardCalendarConnectionsData>) => createQueryKey('org-board-org_list_board_calendar_connections', options);

/**
 * Org List Board Calendar Connections
 *
 * Every calendar connected for the board, with the upcoming meetings each one sends (the
 * handover view), in the canonical `{data, meta, links}` envelope.
 */
export const orgBoardOrgListBoardCalendarConnectionsOptions = (options: Options<OrgBoardOrgListBoardCalendarConnectionsData>) => queryOptions<OrgBoardOrgListBoardCalendarConnectionsResponse, OrgBoardOrgListBoardCalendarConnectionsError, OrgBoardOrgListBoardCalendarConnectionsResponse, ReturnType<typeof orgBoardOrgListBoardCalendarConnectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCalendarConnections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCalendarConnectionsQueryKey(options)
});

/**
 * Org Move Board Calendar Meetings
 *
 * Move every upcoming meeting one calendar sends to another sender in one act (directors
 * get one cancellation and one new invitation each), or stop keeping them in step.
 */
export const orgBoardOrgMoveBoardCalendarMeetingsMutation = (options?: Partial<Options<OrgBoardOrgMoveBoardCalendarMeetingsData>>): UseMutationOptions<OrgBoardOrgMoveBoardCalendarMeetingsResponse, OrgBoardOrgMoveBoardCalendarMeetingsError, Options<OrgBoardOrgMoveBoardCalendarMeetingsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgMoveBoardCalendarMeetingsResponse, OrgBoardOrgMoveBoardCalendarMeetingsError, Options<OrgBoardOrgMoveBoardCalendarMeetingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgMoveBoardCalendarMeetings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardCalendarSendersQueryKey = (options: Options<OrgBoardOrgListBoardCalendarSendersData>) => createQueryKey('org-board-org_list_board_calendar_senders', options);

/**
 * Org List Board Calendar Senders
 *
 * Who can send this charity's meeting invitations, in order: the officer's own connected
 * calendar, then the board account — and whether the officer can connect their own calendar
 * here.
 */
export const orgBoardOrgListBoardCalendarSendersOptions = (options: Options<OrgBoardOrgListBoardCalendarSendersData>) => queryOptions<OrgBoardOrgListBoardCalendarSendersResponse, OrgBoardOrgListBoardCalendarSendersError, OrgBoardOrgListBoardCalendarSendersResponse, ReturnType<typeof orgBoardOrgListBoardCalendarSendersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCalendarSenders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCalendarSendersQueryKey(options)
});

export const orgBoardOrgGetBoardCalendarSettingsQueryKey = (options: Options<OrgBoardOrgGetBoardCalendarSettingsData>) => createQueryKey('org-board-org_get_board_calendar_settings', options);

/**
 * Org Get Board Calendar Settings
 *
 * The board's calendar settings: whether directors may change a meeting's details in
 * their calendar, propose new times and see the guest list, and whether invitations use the
 * meetings' own titles. The shipped defaults until an Owner adopts settings.
 */
export const orgBoardOrgGetBoardCalendarSettingsOptions = (options: Options<OrgBoardOrgGetBoardCalendarSettingsData>) => queryOptions<OrgBoardOrgGetBoardCalendarSettingsResponse, OrgBoardOrgGetBoardCalendarSettingsError, OrgBoardOrgGetBoardCalendarSettingsResponse, ReturnType<typeof orgBoardOrgGetBoardCalendarSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCalendarSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCalendarSettingsQueryKey(options)
});

/**
 * Org Adopt Board Calendar Settings
 *
 * Adopt the board's calendar settings (all four). They apply to meetings sent from now
 * on; "Apply to upcoming meetings" applies them to meetings already sent.
 */
export const orgBoardOrgAdoptBoardCalendarSettingsMutation = (options?: Partial<Options<OrgBoardOrgAdoptBoardCalendarSettingsData>>): UseMutationOptions<OrgBoardOrgAdoptBoardCalendarSettingsResponse, OrgBoardOrgAdoptBoardCalendarSettingsError, Options<OrgBoardOrgAdoptBoardCalendarSettingsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAdoptBoardCalendarSettingsResponse, OrgBoardOrgAdoptBoardCalendarSettingsError, Options<OrgBoardOrgAdoptBoardCalendarSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAdoptBoardCalendarSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Apply Board Calendar Settings
 *
 * Apply the board's calendar settings to every upcoming meeting already sent from a
 * connected calendar.
 */
export const orgBoardOrgApplyBoardCalendarSettingsMutation = (options?: Partial<Options<OrgBoardOrgApplyBoardCalendarSettingsData>>): UseMutationOptions<OrgBoardOrgApplyBoardCalendarSettingsResponse, OrgBoardOrgApplyBoardCalendarSettingsError, Options<OrgBoardOrgApplyBoardCalendarSettingsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgApplyBoardCalendarSettingsResponse, OrgBoardOrgApplyBoardCalendarSettingsError, Options<OrgBoardOrgApplyBoardCalendarSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgApplyBoardCalendarSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardCarryForwardItemsQueryKey = (options: Options<OrgBoardOrgListBoardCarryForwardItemsData>) => createQueryKey('org-board-org_list_board_carry_forward_items', options);

/**
 * Org List Board Carry Forward Items
 *
 * Prior meetings' agenda items the charity marked as left open.
 *
 * Exactly what the charity marked, and nothing else. An item nobody dispositioned does
 * not appear here — deciding on the charity's behalf that a past item is unfinished
 * business would be the module making a governance judgment.
 */
export const orgBoardOrgListBoardCarryForwardItemsOptions = (options: Options<OrgBoardOrgListBoardCarryForwardItemsData>) => queryOptions<OrgBoardOrgListBoardCarryForwardItemsResponse, OrgBoardOrgListBoardCarryForwardItemsError, OrgBoardOrgListBoardCarryForwardItemsResponse, ReturnType<typeof orgBoardOrgListBoardCarryForwardItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCarryForwardItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCarryForwardItemsQueryKey(options)
});

export const orgBoardOrgListBoardCarryForwardMotionsQueryKey = (options: Options<OrgBoardOrgListBoardCarryForwardMotionsData>) => createQueryKey('org-board-org_list_board_carry_forward_motions', options);

/**
 * Org List Board Carry Forward Motions
 *
 * Motions from past meetings that are still before the board.
 *
 * The companion of the carry-forward agenda items on the meetings surface: together they
 * are what an officer building the next agenda needs to see. Both report only what the
 * charity itself left open — a motion nobody withdrew and nobody voted on — and neither
 * infers that anything else is unfinished business.
 *
 * A motion made inside a closed session this reader was not part of does not appear.
 */
export const orgBoardOrgListBoardCarryForwardMotionsOptions = (options: Options<OrgBoardOrgListBoardCarryForwardMotionsData>) => queryOptions<OrgBoardOrgListBoardCarryForwardMotionsResponse, OrgBoardOrgListBoardCarryForwardMotionsError, OrgBoardOrgListBoardCarryForwardMotionsResponse, ReturnType<typeof orgBoardOrgListBoardCarryForwardMotionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCarryForwardMotions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCarryForwardMotionsQueryKey(options)
});

export const orgBoardOrgListBoardCoiCyclesQueryKey = (options: Options<OrgBoardOrgListBoardCoiCyclesData>) => createQueryKey('org-board-org_list_board_coi_cycles', options);

/**
 * Org List Board Coi Cycles
 *
 * Every year's annual disclosures, newest first: each one's dates, status and count of
 * submissions (never a count of conflicts).
 */
export const orgBoardOrgListBoardCoiCyclesOptions = (options: Options<OrgBoardOrgListBoardCoiCyclesData>) => queryOptions<OrgBoardOrgListBoardCoiCyclesResponse, OrgBoardOrgListBoardCoiCyclesError, OrgBoardOrgListBoardCoiCyclesResponse, ReturnType<typeof orgBoardOrgListBoardCoiCyclesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCoiCycles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCoiCyclesQueryKey(options)
});

/**
 * Org Open Board Coi Cycle
 *
 * Start a year's annual conflict-of-interest disclosures: everyone on the roster is asked,
 * with Givmo's starting questionnaire (any question turned off) and the organization's own
 * policy from Governance, if it holds one. Each person is emailed the request; a seat no
 * account has joined gets an invitation to join with it.
 */
export const orgBoardOrgOpenBoardCoiCycleMutation = (options?: Partial<Options<OrgBoardOrgOpenBoardCoiCycleData>>): UseMutationOptions<OrgBoardOrgOpenBoardCoiCycleResponse, OrgBoardOrgOpenBoardCoiCycleError, Options<OrgBoardOrgOpenBoardCoiCycleData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgOpenBoardCoiCycleResponse, OrgBoardOrgOpenBoardCoiCycleError, Options<OrgBoardOrgOpenBoardCoiCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgOpenBoardCoiCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardCoiCycleQueryKey = (options: Options<OrgBoardOrgGetBoardCoiCycleData>) => createQueryKey('org-board-org_get_board_coi_cycle', options);

/**
 * Org Get Board Coi Cycle
 *
 * One year's annual disclosures: who was asked, who has submitted and when, what was sent
 * and when, and who can be reminded now.
 */
export const orgBoardOrgGetBoardCoiCycleOptions = (options: Options<OrgBoardOrgGetBoardCoiCycleData>) => queryOptions<OrgBoardOrgGetBoardCoiCycleResponse, OrgBoardOrgGetBoardCoiCycleError, OrgBoardOrgGetBoardCoiCycleResponse, ReturnType<typeof orgBoardOrgGetBoardCoiCycleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCoiCycle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCoiCycleQueryKey(options)
});

/**
 * Org Update Board Coi Cycle
 *
 * Change an open year's due date. Recorded in the year's log; sends nothing.
 */
export const orgBoardOrgUpdateBoardCoiCycleMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardCoiCycleData>>): UseMutationOptions<OrgBoardOrgUpdateBoardCoiCycleResponse, OrgBoardOrgUpdateBoardCoiCycleError, Options<OrgBoardOrgUpdateBoardCoiCycleData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardCoiCycleResponse, OrgBoardOrgUpdateBoardCoiCycleError, Options<OrgBoardOrgUpdateBoardCoiCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardCoiCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Cancel Board Coi Cycle
 *
 * Withdraw a year opened by mistake, before anyone has answered. Nothing is added to the
 * minute book.
 */
export const orgBoardOrgCancelBoardCoiCycleMutation = (options?: Partial<Options<OrgBoardOrgCancelBoardCoiCycleData>>): UseMutationOptions<OrgBoardOrgCancelBoardCoiCycleResponse, OrgBoardOrgCancelBoardCoiCycleError, Options<OrgBoardOrgCancelBoardCoiCycleData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCancelBoardCoiCycleResponse, OrgBoardOrgCancelBoardCoiCycleError, Options<OrgBoardOrgCancelBoardCoiCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCancelBoardCoiCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Close Board Coi Cycle
 *
 * Close the year. Adds one record to the minute book: who was asked, and who submitted and
 * when. It names no one's interests. Anyone who hasn't submitted can still send their answers
 * afterwards; theirs are recorded as received after the year closed.
 */
export const orgBoardOrgCloseBoardCoiCycleMutation = (options?: Partial<Options<OrgBoardOrgCloseBoardCoiCycleData>>): UseMutationOptions<OrgBoardOrgCloseBoardCoiCycleResponse, OrgBoardOrgCloseBoardCoiCycleError, Options<OrgBoardOrgCloseBoardCoiCycleData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCloseBoardCoiCycleResponse, OrgBoardOrgCloseBoardCoiCycleError, Options<OrgBoardOrgCloseBoardCoiCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCloseBoardCoiCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardCoiCycleDocumentQueryKey = (options: Options<OrgBoardOrgGetBoardCoiCycleDocumentData>) => createQueryKey('org-board-org_get_board_coi_cycle_document', options);

/**
 * Org Get Board Coi Cycle Document
 *
 * Every response submitted for the year, in one PDF.
 */
export const orgBoardOrgGetBoardCoiCycleDocumentOptions = (options: Options<OrgBoardOrgGetBoardCoiCycleDocumentData>) => queryOptions<OrgBoardOrgGetBoardCoiCycleDocumentResponse, OrgBoardOrgGetBoardCoiCycleDocumentError, OrgBoardOrgGetBoardCoiCycleDocumentResponse, ReturnType<typeof orgBoardOrgGetBoardCoiCycleDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCoiCycleDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCoiCycleDocumentQueryKey(options)
});

export const orgBoardOrgGetBoardCoiPaperFormQueryKey = (options: Options<OrgBoardOrgGetBoardCoiPaperFormData>) => createQueryKey('org-board-org_get_board_coi_paper_form', options);

/**
 * Org Get Board Coi Paper Form
 *
 * A paper form for one person to fill in and sign: the year's questions as they're asked
 * them, with their answers from last year where there are any.
 */
export const orgBoardOrgGetBoardCoiPaperFormOptions = (options: Options<OrgBoardOrgGetBoardCoiPaperFormData>) => queryOptions<OrgBoardOrgGetBoardCoiPaperFormResponse, OrgBoardOrgGetBoardCoiPaperFormError, OrgBoardOrgGetBoardCoiPaperFormResponse, ReturnType<typeof orgBoardOrgGetBoardCoiPaperFormQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCoiPaperForm({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCoiPaperFormQueryKey(options)
});

export const orgBoardOrgGetBoardCoiPersonQuestionnaireQueryKey = (options: Options<OrgBoardOrgGetBoardCoiPersonQuestionnaireData>) => createQueryKey('org-board-org_get_board_coi_person_questionnaire', options);

/**
 * Org Get Board Coi Person Questionnaire
 *
 * One person's questionnaire for the year, for entering their signed paper form: the
 * questions as they're asked them, the board's policy, their answers from last year where there
 * are any, and whether a first answer can be recorded for them now (CBG-YR2-BE5).
 */
export const orgBoardOrgGetBoardCoiPersonQuestionnaireOptions = (options: Options<OrgBoardOrgGetBoardCoiPersonQuestionnaireData>) => queryOptions<OrgBoardOrgGetBoardCoiPersonQuestionnaireResponse, OrgBoardOrgGetBoardCoiPersonQuestionnaireError, OrgBoardOrgGetBoardCoiPersonQuestionnaireResponse, ReturnType<typeof orgBoardOrgGetBoardCoiPersonQuestionnaireQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCoiPersonQuestionnaire({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCoiPersonQuestionnaireQueryKey(options)
});

/**
 * Org Remind Board Coi Cycle Recipients
 *
 * Remind people who haven't sent their answers yet. Each gets one email, at most once a day.
 * Reminders go only when you send them. Name the people in `board_member_ids`, or send null for
 * everyone who can be reminded now.
 */
export const orgBoardOrgRemindBoardCoiCycleRecipientsMutation = (options?: Partial<Options<OrgBoardOrgRemindBoardCoiCycleRecipientsData>>): UseMutationOptions<OrgBoardOrgRemindBoardCoiCycleRecipientsResponse, OrgBoardOrgRemindBoardCoiCycleRecipientsError, Options<OrgBoardOrgRemindBoardCoiCycleRecipientsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemindBoardCoiCycleRecipientsResponse, OrgBoardOrgRemindBoardCoiCycleRecipientsError, Options<OrgBoardOrgRemindBoardCoiCycleRecipientsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemindBoardCoiCycleRecipients({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Send Board Coi Cycle Requests
 *
 * Send the year's questionnaire to people who haven't been sent it — someone who joined the
 * board since it started, say. A seat that hasn't joined Board yet gets an invitation with it.
 * Name the people in `board_member_ids`, or send null for everyone it can go to.
 */
export const orgBoardOrgSendBoardCoiCycleRequestsMutation = (options?: Partial<Options<OrgBoardOrgSendBoardCoiCycleRequestsData>>): UseMutationOptions<OrgBoardOrgSendBoardCoiCycleRequestsResponse, OrgBoardOrgSendBoardCoiCycleRequestsError, Options<OrgBoardOrgSendBoardCoiCycleRequestsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSendBoardCoiCycleRequestsResponse, OrgBoardOrgSendBoardCoiCycleRequestsError, Options<OrgBoardOrgSendBoardCoiCycleRequestsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSendBoardCoiCycleRequests({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Coi Paper Response
 *
 * Record a person's signed paper form. Their answers become their disclosure for the year,
 * recorded as entered by you from paper, with your note saying where it came from. Someone who
 * joined the board after the year started is added to it by this, with no email.
 */
export const orgBoardOrgRecordBoardCoiPaperResponseMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardCoiPaperResponseData>>): UseMutationOptions<OrgBoardOrgRecordBoardCoiPaperResponseResponse, OrgBoardOrgRecordBoardCoiPaperResponseError, Options<OrgBoardOrgRecordBoardCoiPaperResponseData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardCoiPaperResponseResponse, OrgBoardOrgRecordBoardCoiPaperResponseError, Options<OrgBoardOrgRecordBoardCoiPaperResponseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardCoiPaperResponse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardCoiResponseQueryKey = (options: Options<OrgBoardOrgGetBoardCoiResponseData>) => createQueryKey('org-board-org_get_board_coi_response', options);

/**
 * Org Get Board Coi Response
 *
 * One person's answers for the year, as recorded: every question as they were asked it, with
 * their answer, how it was signed or recorded, and its fingerprint.
 */
export const orgBoardOrgGetBoardCoiResponseOptions = (options: Options<OrgBoardOrgGetBoardCoiResponseData>) => queryOptions<OrgBoardOrgGetBoardCoiResponseResponse, OrgBoardOrgGetBoardCoiResponseError, OrgBoardOrgGetBoardCoiResponseResponse, ReturnType<typeof orgBoardOrgGetBoardCoiResponseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCoiResponse({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCoiResponseQueryKey(options)
});

export const orgBoardOrgGetBoardCoiResponseChangesQueryKey = (options: Options<OrgBoardOrgGetBoardCoiResponseChangesData>) => createQueryKey('org-board-org_get_board_coi_response_changes', options);

/**
 * Org Get Board Coi Response Changes
 *
 * One person's answers for the year against their answers from the year before, question by
 * question: what changed, what was added and what was removed, with both records' fingerprints.
 * Made from the two recorded disclosures; not itself a record.
 */
export const orgBoardOrgGetBoardCoiResponseChangesOptions = (options: Options<OrgBoardOrgGetBoardCoiResponseChangesData>) => queryOptions<OrgBoardOrgGetBoardCoiResponseChangesResponse, OrgBoardOrgGetBoardCoiResponseChangesError, OrgBoardOrgGetBoardCoiResponseChangesResponse, ReturnType<typeof orgBoardOrgGetBoardCoiResponseChangesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCoiResponseChanges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCoiResponseChangesQueryKey(options)
});

export const orgBoardOrgGetBoardCoiResponseDocumentQueryKey = (options: Options<OrgBoardOrgGetBoardCoiResponseDocumentData>) => createQueryKey('org-board-org_get_board_coi_response_document', options);

/**
 * Org Get Board Coi Response Document
 *
 * One person's answers for the year as a PDF: the answers as recorded, or the changes from
 * the year before. `time_zone` (an IANA name) sets the zone its times print in; UTC otherwise.
 */
export const orgBoardOrgGetBoardCoiResponseDocumentOptions = (options: Options<OrgBoardOrgGetBoardCoiResponseDocumentData>) => queryOptions<OrgBoardOrgGetBoardCoiResponseDocumentResponse, OrgBoardOrgGetBoardCoiResponseDocumentError, OrgBoardOrgGetBoardCoiResponseDocumentResponse, ReturnType<typeof orgBoardOrgGetBoardCoiResponseDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCoiResponseDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCoiResponseDocumentQueryKey(options)
});

export const orgBoardOrgListBoardCoiQuestionnairesQueryKey = (options: Options<OrgBoardOrgListBoardCoiQuestionnairesData>) => createQueryKey('org-board-org_list_board_coi_questionnaires', options);

/**
 * Org List Board Coi Questionnaires
 *
 * Givmo's starting conflict-of-interest questionnaires this organization is offered: each
 * with its provenance, its IRS sources and the review-with-counsel line. A template, never a
 * statement that a questionnaire is required or sufficient.
 */
export const orgBoardOrgListBoardCoiQuestionnairesOptions = (options: Options<OrgBoardOrgListBoardCoiQuestionnairesData>) => queryOptions<OrgBoardOrgListBoardCoiQuestionnairesResponse, OrgBoardOrgListBoardCoiQuestionnairesError, OrgBoardOrgListBoardCoiQuestionnairesResponse, ReturnType<typeof orgBoardOrgListBoardCoiQuestionnairesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCoiQuestionnaires({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCoiQuestionnairesQueryKey(options)
});

export const orgBoardOrgGetBoardCoiQuestionnaireQueryKey = (options: Options<OrgBoardOrgGetBoardCoiQuestionnaireData>) => createQueryKey('org-board-org_get_board_coi_questionnaire', options);

/**
 * Org Get Board Coi Questionnaire
 *
 * One starting questionnaire with every question: its words, whom it is asked of (the
 * independence question is asked of directors only), the IRS text it is drawn from, and its
 * "What counts" lines.
 */
export const orgBoardOrgGetBoardCoiQuestionnaireOptions = (options: Options<OrgBoardOrgGetBoardCoiQuestionnaireData>) => queryOptions<OrgBoardOrgGetBoardCoiQuestionnaireResponse, OrgBoardOrgGetBoardCoiQuestionnaireError, OrgBoardOrgGetBoardCoiQuestionnaireResponse, ReturnType<typeof orgBoardOrgGetBoardCoiQuestionnaireQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCoiQuestionnaire({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCoiQuestionnaireQueryKey(options)
});

export const orgBoardOrgListBoardCommitteeSourcesQueryKey = (options: Options<OrgBoardOrgListBoardCommitteeSourcesData>) => createQueryKey('org-board-org_list_board_committee_sources', options);

/**
 * Org List Board Committee Sources
 *
 * What a committee's establishment, its dissolution or a member's appointment may be linked
 * to: motions recorded as carried, executed written consents and records in the minute book,
 * each one you may read, the most recent first.
 */
export const orgBoardOrgListBoardCommitteeSourcesOptions = (options: Options<OrgBoardOrgListBoardCommitteeSourcesData>) => queryOptions<OrgBoardOrgListBoardCommitteeSourcesResponse, OrgBoardOrgListBoardCommitteeSourcesError, OrgBoardOrgListBoardCommitteeSourcesResponse, ReturnType<typeof orgBoardOrgListBoardCommitteeSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCommitteeSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCommitteeSourcesQueryKey(options)
});

export const orgBoardOrgListBoardCommitteesQueryKey = (options: Options<OrgBoardOrgListBoardCommitteesData>) => createQueryKey('org-board-org_list_board_committees', options);

/**
 * Org List Board Committees
 *
 * Your board's committees: the ones that stand first, by name, then those dissolved, the
 * most recent first. Each carries its chair and, where your organization's type is asked,
 * your organization's answer about its authority to act for the board, as recorded.
 */
export const orgBoardOrgListBoardCommitteesOptions = (options: Options<OrgBoardOrgListBoardCommitteesData>) => queryOptions<OrgBoardOrgListBoardCommitteesResponse, OrgBoardOrgListBoardCommitteesError, OrgBoardOrgListBoardCommitteesResponse, ReturnType<typeof orgBoardOrgListBoardCommitteesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCommittees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCommitteesQueryKey(options)
});

/**
 * Org Create Board Committee
 *
 * Add a committee: its name, standing or ad hoc, when it was established and where that is
 * recorded. With `charter_form_id`, the committee keeps the form's id and holds the charter
 * label its name gives; its charter is then drafted from the form like any governing document.
 * No record is written here. A name an active committee already has is a 409
 * `board_committee_name_taken`.
 */
export const orgBoardOrgCreateBoardCommitteeMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardCommitteeData>>): UseMutationOptions<OrgBoardOrgCreateBoardCommitteeResponse, OrgBoardOrgCreateBoardCommitteeError, Options<OrgBoardOrgCreateBoardCommitteeData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardCommitteeResponse, OrgBoardOrgCreateBoardCommitteeError, Options<OrgBoardOrgCreateBoardCommitteeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardCommittee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardCommitteeQueryKey = (options: Options<OrgBoardOrgGetBoardCommitteeData>) => createQueryKey('org-board-org_get_board_committee', options);

/**
 * Org Get Board Committee
 *
 * One committee: its record, its members, its rules and where its acts are recorded, as far
 * as you may read them. Its charter is the committee charter recorded under its
 * `charter_label` (the governing documents read, by that label).
 */
export const orgBoardOrgGetBoardCommitteeOptions = (options: Options<OrgBoardOrgGetBoardCommitteeData>) => queryOptions<OrgBoardOrgGetBoardCommitteeResponse, OrgBoardOrgGetBoardCommitteeError, OrgBoardOrgGetBoardCommitteeResponse, ReturnType<typeof orgBoardOrgGetBoardCommitteeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCommittee({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCommitteeQueryKey(options)
});

/**
 * Org Update Board Committee
 *
 * Change a committee's name, kind, establishment date or where its establishment is
 * recorded. Send only what changes; `null` clears the date, and a `null` `recorded_in` makes
 * it your own entry. A renamed committee keeps its charter's label. A dissolved committee isn't
 * changed (409 `board_committee_dissolved`).
 */
export const orgBoardOrgUpdateBoardCommitteeMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardCommitteeData>>): UseMutationOptions<OrgBoardOrgUpdateBoardCommitteeResponse, OrgBoardOrgUpdateBoardCommitteeError, Options<OrgBoardOrgUpdateBoardCommitteeData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardCommitteeResponse, OrgBoardOrgUpdateBoardCommitteeError, Options<OrgBoardOrgUpdateBoardCommitteeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardCommittee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Link Board Committee Charter
 *
 * The committee charter a committee holds, by the label its versions are recorded under. No
 * record changes. A label another committee holds is a 409
 * `board_committee_charter_label_taken`.
 */
export const orgBoardOrgLinkBoardCommitteeCharterMutation = (options?: Partial<Options<OrgBoardOrgLinkBoardCommitteeCharterData>>): UseMutationOptions<OrgBoardOrgLinkBoardCommitteeCharterResponse, OrgBoardOrgLinkBoardCommitteeCharterError, Options<OrgBoardOrgLinkBoardCommitteeCharterData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgLinkBoardCommitteeCharterResponse, OrgBoardOrgLinkBoardCommitteeCharterError, Options<OrgBoardOrgLinkBoardCommitteeCharterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgLinkBoardCommitteeCharter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Set Board Committee Confirmation
 *
 * Whether the committee's decisions are suggested for the board's next meeting, and where the
 * organization wrote that practice down. Recorded in the committee's history, and reversible;
 * turning it off clears where it is written. Nothing waits on it: a committee's decisions stand as
 * recorded either way. A dissolved committee is a 409 `board_committee_dissolved`.
 */
export const orgBoardOrgSetBoardCommitteeConfirmationMutation = (options?: Partial<Options<OrgBoardOrgSetBoardCommitteeConfirmationData>>): UseMutationOptions<OrgBoardOrgSetBoardCommitteeConfirmationResponse, OrgBoardOrgSetBoardCommitteeConfirmationError, Options<OrgBoardOrgSetBoardCommitteeConfirmationData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSetBoardCommitteeConfirmationResponse, OrgBoardOrgSetBoardCommitteeConfirmationError, Options<OrgBoardOrgSetBoardCommitteeConfirmationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSetBoardCommitteeConfirmation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Dissolve Board Committee
 *
 * Dissolve a committee: the date, where it is recorded, and your note. Every membership ends
 * with it, and everything recorded about it stays. A dissolved committee answers as it is.
 */
export const orgBoardOrgDissolveBoardCommitteeMutation = (options?: Partial<Options<OrgBoardOrgDissolveBoardCommitteeData>>): UseMutationOptions<OrgBoardOrgDissolveBoardCommitteeResponse, OrgBoardOrgDissolveBoardCommitteeError, Options<OrgBoardOrgDissolveBoardCommitteeData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDissolveBoardCommitteeResponse, OrgBoardOrgDissolveBoardCommitteeError, Options<OrgBoardOrgDissolveBoardCommitteeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDissolveBoardCommittee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Correct Board Committee Dissolution
 *
 * Correct a dissolution made by mistake, saying why: the committee stands again, with the
 * memberships its dissolution ended, for everyone still serving on the board.
 */
export const orgBoardOrgCorrectBoardCommitteeDissolutionMutation = (options?: Partial<Options<OrgBoardOrgCorrectBoardCommitteeDissolutionData>>): UseMutationOptions<OrgBoardOrgCorrectBoardCommitteeDissolutionResponse, OrgBoardOrgCorrectBoardCommitteeDissolutionError, Options<OrgBoardOrgCorrectBoardCommitteeDissolutionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCorrectBoardCommitteeDissolutionResponse, OrgBoardOrgCorrectBoardCommitteeDissolutionError, Options<OrgBoardOrgCorrectBoardCommitteeDissolutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCorrectBoardCommitteeDissolution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Add Board Committee Member
 *
 * Add someone on your board's roster to a committee, director or not. `votes` is your
 * organization's record of whether they vote on the committee: yes unless you say otherwise.
 * Someone no longer serving is a 409 `board_committee_member_not_serving`; a second chair, a
 * 409 `board_committee_chair_taken`.
 */
export const orgBoardOrgAddBoardCommitteeMemberMutation = (options?: Partial<Options<OrgBoardOrgAddBoardCommitteeMemberData>>): UseMutationOptions<OrgBoardOrgAddBoardCommitteeMemberResponse, OrgBoardOrgAddBoardCommitteeMemberError, Options<OrgBoardOrgAddBoardCommitteeMemberData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAddBoardCommitteeMemberResponse, OrgBoardOrgAddBoardCommitteeMemberError, Options<OrgBoardOrgAddBoardCommitteeMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAddBoardCommitteeMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Update Board Committee Member
 *
 * Change a committee member's role, whether they vote on the committee, their dates, or
 * where their appointment is recorded. Send only what changes. A membership that has ended
 * isn't changed (409 `board_committee_member_ended`).
 */
export const orgBoardOrgUpdateBoardCommitteeMemberMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardCommitteeMemberData>>): UseMutationOptions<OrgBoardOrgUpdateBoardCommitteeMemberResponse, OrgBoardOrgUpdateBoardCommitteeMemberError, Options<OrgBoardOrgUpdateBoardCommitteeMemberData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardCommitteeMemberResponse, OrgBoardOrgUpdateBoardCommitteeMemberError, Options<OrgBoardOrgUpdateBoardCommitteeMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardCommitteeMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org End Board Committee Member
 *
 * End someone's membership of a committee, with their last day if you have one, and your
 * note. An ended membership answers as it is.
 */
export const orgBoardOrgEndBoardCommitteeMemberMutation = (options?: Partial<Options<OrgBoardOrgEndBoardCommitteeMemberData>>): UseMutationOptions<OrgBoardOrgEndBoardCommitteeMemberResponse, OrgBoardOrgEndBoardCommitteeMemberError, Options<OrgBoardOrgEndBoardCommitteeMemberData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgEndBoardCommitteeMemberResponse, OrgBoardOrgEndBoardCommitteeMemberError, Options<OrgBoardOrgEndBoardCommitteeMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgEndBoardCommitteeMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Committee Rule
 *
 * Record one of a committee's rules, replacing the one in force, which stays in its history:
 * its notice period, its quorum, how its minutes are approved, or your organization's answer
 * about its authority to act for the board. `citation`, the section of your governing documents
 * the rule comes from, is required. Givmo doesn't read your governing documents.
 */
export const orgBoardOrgRecordBoardCommitteeRuleMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardCommitteeRuleData>>): UseMutationOptions<OrgBoardOrgRecordBoardCommitteeRuleResponse, OrgBoardOrgRecordBoardCommitteeRuleError, Options<OrgBoardOrgRecordBoardCommitteeRuleData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardCommitteeRuleResponse, OrgBoardOrgRecordBoardCommitteeRuleError, Options<OrgBoardOrgRecordBoardCommitteeRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardCommitteeRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardCompensationDecisionsQueryKey = (options: Options<OrgBoardOrgListBoardCompensationDecisionsData>) => createQueryKey('org-board-org_list_board_compensation_decisions', options);

/**
 * Org List Board Compensation Decisions
 *
 * Every compensation decision you may read, grouped by person, newest first: each in the
 * regulation's order — the decision and its date, who took part, what the board relied on, and
 * when it was written down beside the date the regulation's rule gives. Facts the record holds;
 * Board answers no Form 990 question.
 */
export const orgBoardOrgListBoardCompensationDecisionsOptions = (options: Options<OrgBoardOrgListBoardCompensationDecisionsData>) => queryOptions<OrgBoardOrgListBoardCompensationDecisionsResponse, OrgBoardOrgListBoardCompensationDecisionsError, OrgBoardOrgListBoardCompensationDecisionsResponse, ReturnType<typeof orgBoardOrgListBoardCompensationDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardCompensationDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardCompensationDecisionsQueryKey(options)
});

/**
 * Org Record Board Compensation Index Entry
 *
 * Add a decision from your records: label minutes, a resolution or a written consent already
 * in the minute book (approved or imported) as recording the board's decision on one person's
 * pay, with where in that record it appears. The record itself never changes.
 */
export const orgBoardOrgRecordBoardCompensationIndexEntryMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardCompensationIndexEntryData>>): UseMutationOptions<OrgBoardOrgRecordBoardCompensationIndexEntryResponse, OrgBoardOrgRecordBoardCompensationIndexEntryError, Options<OrgBoardOrgRecordBoardCompensationIndexEntryData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardCompensationIndexEntryResponse, OrgBoardOrgRecordBoardCompensationIndexEntryError, Options<OrgBoardOrgRecordBoardCompensationIndexEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardCompensationIndexEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Board Compensation Index Entry
 *
 * Remove a decision added from your records. A decision recorded on a motion or a written
 * consent is removed there.
 */
export const orgBoardOrgRemoveBoardCompensationIndexEntryMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardCompensationIndexEntryData>>): UseMutationOptions<OrgBoardOrgRemoveBoardCompensationIndexEntryResponse, OrgBoardOrgRemoveBoardCompensationIndexEntryError, Options<OrgBoardOrgRemoveBoardCompensationIndexEntryData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardCompensationIndexEntryResponse, OrgBoardOrgRemoveBoardCompensationIndexEntryError, Options<OrgBoardOrgRemoveBoardCompensationIndexEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardCompensationIndexEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardCompensationDecisionQueryKey = (options: Options<OrgBoardOrgGetBoardCompensationDecisionData>) => createQueryKey('org-board-org_get_board_compensation_decision', options);

/**
 * Org Get Board Compensation Decision
 *
 * One compensation decision, in the regulation's order, with its history: who recorded and
 * changed it, and when.
 */
export const orgBoardOrgGetBoardCompensationDecisionOptions = (options: Options<OrgBoardOrgGetBoardCompensationDecisionData>) => queryOptions<OrgBoardOrgGetBoardCompensationDecisionResponse, OrgBoardOrgGetBoardCompensationDecisionError, OrgBoardOrgGetBoardCompensationDecisionResponse, ReturnType<typeof orgBoardOrgGetBoardCompensationDecisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCompensationDecision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCompensationDecisionQueryKey(options)
});

/**
 * Org Update Board Compensation Decision
 *
 * Change an index entry's details, or any decision's two labels — your Form 990 answer for
 * the person (line 15a or 15b, a charity's only) and the link to the person's seat — which print
 * nowhere and change at any time. A field you send as null is cleared; one you leave out is
 * kept.
 */
export const orgBoardOrgUpdateBoardCompensationDecisionMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardCompensationDecisionData>>): UseMutationOptions<OrgBoardOrgUpdateBoardCompensationDecisionResponse, OrgBoardOrgUpdateBoardCompensationDecisionError, Options<OrgBoardOrgUpdateBoardCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardCompensationDecisionResponse, OrgBoardOrgUpdateBoardCompensationDecisionError, Options<OrgBoardOrgUpdateBoardCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardCompensationDecisionDocumentDownloadQueryKey = (options: Options<OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadData>) => createQueryKey('org-board-org_get_board_compensation_decision_document_download', options);

/**
 * Org Get Board Compensation Decision Document Download
 *
 * A short-lived link to one document a compensation decision names, one of its meeting's
 * papers or a document uploaded onto a written consent: the exact version of the file whose
 * fingerprint the decision records, minted for this request and never stored. On a closed
 * session's motion, only for a reader that session was sent to.
 */
export const orgBoardOrgGetBoardCompensationDecisionDocumentDownloadOptions = (options: Options<OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadData>) => queryOptions<OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadResponse, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadError, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadResponse, ReturnType<typeof orgBoardOrgGetBoardCompensationDecisionDocumentDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCompensationDecisionDocumentDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCompensationDecisionDocumentDownloadQueryKey(options)
});

export const orgBoardOrgListBoardConflictRegisterQueryKey = (options: Options<OrgBoardOrgListBoardConflictRegisterData>) => createQueryKey('org-board-org_list_board_conflict_register', options);

/**
 * Org List Board Conflict Register
 *
 * The charity's conflict register — its recorded disclosures, per seat.
 *
 * `status` is DERIVED from the version pointers, not stored: `superseded` means a later
 * disclosure by the same seat replaced this one, and `active` means none has. Filter on
 * it to see what stands today, or omit it to read the whole history.
 *
 * A disclosure filed into an executive session this reader was not part of is ABSENT,
 * exactly as the session itself is — that binds charity admins as well as directors. No
 * disclosure is filed that way today: every one goes in at standard visibility, so the
 * scoping is here for the rule rather than for a case you will meet.
 */
export const orgBoardOrgListBoardConflictRegisterOptions = (options: Options<OrgBoardOrgListBoardConflictRegisterData>) => queryOptions<OrgBoardOrgListBoardConflictRegisterResponse, OrgBoardOrgListBoardConflictRegisterError, OrgBoardOrgListBoardConflictRegisterResponse, ReturnType<typeof orgBoardOrgListBoardConflictRegisterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardConflictRegister({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardConflictRegisterQueryKey(options)
});

/**
 * Org Record Board Conflict Disclosure
 *
 * Record a conflict-of-interest disclosure a director made outside the portal.
 *
 * Plan §1.7's manual path, first-class and permanent: a volunteer board hands the
 * secretary a signed form, or says it in the room, and the module has to be able to write
 * that down. `provenance_note` is required — it says where the disclosure came from, so
 * the entry can never be read as the director having acted inside their own session.
 *
 * The record names the DIRECTOR'S OWN SEAT as its approver, not the officer's account:
 * the director disclosed, and the officer wrote it down. A director recording their own
 * disclosure does it through their board session instead, where it is a signature-class
 * act on the step-up rail.
 *
 * `supersedes_record_id` records that the director's position has CHANGED — the earlier
 * disclosure stays an accurate record of what was true at its time. `corrects_record_id`
 * records that the earlier one was WRONG. They are different statements about a person
 * and a record carries one or the other, never both.
 */
export const orgBoardOrgRecordBoardConflictDisclosureMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardConflictDisclosureData>>): UseMutationOptions<OrgBoardOrgRecordBoardConflictDisclosureResponse, OrgBoardOrgRecordBoardConflictDisclosureError, Options<OrgBoardOrgRecordBoardConflictDisclosureData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardConflictDisclosureResponse, OrgBoardOrgRecordBoardConflictDisclosureError, Options<OrgBoardOrgRecordBoardConflictDisclosureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardConflictDisclosure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardConsentTemplatesQueryKey = (options: Options<OrgBoardOrgListBoardConsentTemplatesData>) => createQueryKey('org-board-org_list_board_consent_templates', options);

/**
 * Org List Board Consent Templates
 *
 * The consent and resolution forms the charity may choose from, without the full
 * text of each.
 *
 * Structurally neutral scaffolds with bracketed fields the organization fills in, each
 * naming the authority its structure is modeled on. The library is the same for every
 * charity: this route reads nothing about the organization, so it can never present a
 * form as one the organization ought to adopt.
 */
export const orgBoardOrgListBoardConsentTemplatesOptions = (options: Options<OrgBoardOrgListBoardConsentTemplatesData>) => queryOptions<OrgBoardOrgListBoardConsentTemplatesResponse, OrgBoardOrgListBoardConsentTemplatesError, OrgBoardOrgListBoardConsentTemplatesResponse, ReturnType<typeof orgBoardOrgListBoardConsentTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardConsentTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardConsentTemplatesQueryKey(options)
});

export const orgBoardOrgGetBoardConsentTemplateQueryKey = (options: Options<OrgBoardOrgGetBoardConsentTemplateData>) => createQueryKey('org-board-org_get_board_consent_template', options);

/**
 * Org Get Board Consent Template
 *
 * One form, with its full text, the fields the organization fills in, and the
 * provenance of its structure.
 *
 * Served with the line the organization should read before adopting anything from it:
 * template — review with your counsel before adopting. A form written for a committee is
 * fetched for one of the organization's committees (``committee_id``), its text naming it.
 */
export const orgBoardOrgGetBoardConsentTemplateOptions = (options: Options<OrgBoardOrgGetBoardConsentTemplateData>) => queryOptions<OrgBoardOrgGetBoardConsentTemplateResponse, OrgBoardOrgGetBoardConsentTemplateError, OrgBoardOrgGetBoardConsentTemplateResponse, ReturnType<typeof orgBoardOrgGetBoardConsentTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardConsentTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardConsentTemplateQueryKey(options)
});

export const orgBoardOrgListBoardContemporaneityQueryKey = (options: Options<OrgBoardOrgListBoardContemporaneityData>) => createQueryKey('org-board-org_list_board_contemporaneity', options);

/**
 * Org List Board Contemporaneity
 *
 * Each of the charity's held meetings and executed written consents, with its date.
 *
 * The Form 990 instructions for Part VI, line 8 describe documentation as contemporaneous
 * when it is prepared by the later of the next meeting of the governing body or 60 days
 * after the meeting or written action. This view does that arithmetic and shows the dates
 * it applied it to.
 *
 * It reports what is recorded and what the dates are, and draws no conclusion from them
 * about the charity's governance — the answer on the return is the charity's own to give.
 */
export const orgBoardOrgListBoardContemporaneityOptions = (options: Options<OrgBoardOrgListBoardContemporaneityData>) => queryOptions<OrgBoardOrgListBoardContemporaneityResponse, OrgBoardOrgListBoardContemporaneityError, OrgBoardOrgListBoardContemporaneityResponse, ReturnType<typeof orgBoardOrgListBoardContemporaneityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardContemporaneity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardContemporaneityQueryKey(options)
});

export const orgBoardOrgGetBoardDirectorAccessPolicyQueryKey = (options: Options<OrgBoardOrgGetBoardDirectorAccessPolicyData>) => createQueryKey('org-board-org_get_board_director_access_policy', options);

/**
 * Org Get Board Director Access Policy
 *
 * What this board asks of a director before it opens, and who decided it.
 *
 * `tiered` is what every board runs: what a director must prove follows the weight of
 * what they are doing, so reading and replying ride the director's own Givmo sign-in,
 * and signature-class acts need a second factor confirmed within the hour.
 *
 * `step_up_always` ("confirm before anything opens") was retired on 2026-10-05. A board
 * that adopted it before gets that adoption back as it was recorded: it asks nothing more
 * of a director than `tiered` does, and no board can adopt a policy any more.
 *
 * Executive-session material needs a second factor on every board. That is a floor
 * beneath the setting rather than part of it.
 *
 * A board that has adopted nothing answers with the default and a null adopter,
 * never a 404.
 */
export const orgBoardOrgGetBoardDirectorAccessPolicyOptions = (options: Options<OrgBoardOrgGetBoardDirectorAccessPolicyData>) => queryOptions<OrgBoardOrgGetBoardDirectorAccessPolicyResponse, OrgBoardOrgGetBoardDirectorAccessPolicyError, OrgBoardOrgGetBoardDirectorAccessPolicyResponse, ReturnType<typeof orgBoardOrgGetBoardDirectorAccessPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardDirectorAccessPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardDirectorAccessPolicyQueryKey(options)
});

export const orgBoardOrgListBoardDirectorClassesQueryKey = (options: Options<OrgBoardOrgListBoardDirectorClassesData>) => createQueryKey('org-board-org_list_board_director_classes', options);

/**
 * Org List Board Director Classes
 *
 * The board's own names for its classes of directors, active first in the board's order,
 * then retired. A board with no classes has none: nothing is added for it. A class is a label
 * on a term; it changes no vote, quorum or written consent. Reading this list never changes it.
 */
export const orgBoardOrgListBoardDirectorClassesOptions = (options: Options<OrgBoardOrgListBoardDirectorClassesData>) => queryOptions<OrgBoardOrgListBoardDirectorClassesResponse, OrgBoardOrgListBoardDirectorClassesError, OrgBoardOrgListBoardDirectorClassesResponse, ReturnType<typeof orgBoardOrgListBoardDirectorClassesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardDirectorClasses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardDirectorClassesQueryKey(options)
});

/**
 * Org Create Board Director Class
 *
 * Add one of the board's classes, last in the board's order. No two active classes share a
 * name, whatever the case or spacing: that is a 409 `board_director_class_name_taken`.
 */
export const orgBoardOrgCreateBoardDirectorClassMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardDirectorClassData>>): UseMutationOptions<OrgBoardOrgCreateBoardDirectorClassResponse, OrgBoardOrgCreateBoardDirectorClassError, Options<OrgBoardOrgCreateBoardDirectorClassData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardDirectorClassResponse, OrgBoardOrgCreateBoardDirectorClassError, Options<OrgBoardOrgCreateBoardDirectorClassData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardDirectorClass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Update Board Director Class
 *
 * Rename a class, move it in the board's order, or both. `position` is its place among the
 * active classes, counting from 1; past the last means last. A retired class is neither renamed
 * nor moved (409 `board_director_class_retired`).
 */
export const orgBoardOrgUpdateBoardDirectorClassMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardDirectorClassData>>): UseMutationOptions<OrgBoardOrgUpdateBoardDirectorClassResponse, OrgBoardOrgUpdateBoardDirectorClassError, Options<OrgBoardOrgUpdateBoardDirectorClassData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardDirectorClassResponse, OrgBoardOrgUpdateBoardDirectorClassError, Options<OrgBoardOrgUpdateBoardDirectorClassData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardDirectorClass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Retire Board Director Class
 *
 * Retire a class the board no longer uses. It is never deleted and stays on every term that
 * names it. Retiring a class already retired answers it as it is.
 */
export const orgBoardOrgRetireBoardDirectorClassMutation = (options?: Partial<Options<OrgBoardOrgRetireBoardDirectorClassData>>): UseMutationOptions<OrgBoardOrgRetireBoardDirectorClassResponse, OrgBoardOrgRetireBoardDirectorClassError, Options<OrgBoardOrgRetireBoardDirectorClassData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRetireBoardDirectorClassResponse, OrgBoardOrgRetireBoardDirectorClassError, Options<OrgBoardOrgRetireBoardDirectorClassData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRetireBoardDirectorClass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardEngagementQueryKey = (options: Options<OrgBoardOrgListBoardEngagementData>) => createQueryKey('org-board-org_list_board_engagement', options);

/**
 * Org List Board Engagement
 *
 * Who has opened what — the chair's engagement view.
 *
 * Measurement, not shaming (plan §1.7). Per-(seat, artifact) open counts and instants,
 * with deliberately nothing about how long anything was open and no ranking, so the
 * surface built on this answers "has this director opened the packet?" without becoming
 * a leaderboard. The charity configures whether it is shown at all.
 */
export const orgBoardOrgListBoardEngagementOptions = (options: Options<OrgBoardOrgListBoardEngagementData>) => queryOptions<OrgBoardOrgListBoardEngagementResponse, OrgBoardOrgListBoardEngagementError, OrgBoardOrgListBoardEngagementResponse, ReturnType<typeof orgBoardOrgListBoardEngagementQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardEngagement({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardEngagementQueryKey(options)
});

export const orgBoardOrgExportBoardMinuteBookQueryKey = (options: Options<OrgBoardOrgExportBoardMinuteBookData>) => createQueryKey('org-board-org_export_board_minute_book', options);

/**
 * Org Export Board Minute Book
 *
 * The machine-readable minute-book export, manifest-bound.
 *
 * Continuous — callable any time, no request queue and no waiting period. Every record
 * carries the content hash fixed when it became the record, and `manifest_hash` binds
 * the set, so the charity can re-derive both from the export alone, with nothing from
 * Givmo.
 */
export const orgBoardOrgExportBoardMinuteBookOptions = (options: Options<OrgBoardOrgExportBoardMinuteBookData>) => queryOptions<OrgBoardOrgExportBoardMinuteBookResponse, OrgBoardOrgExportBoardMinuteBookError, OrgBoardOrgExportBoardMinuteBookResponse, ReturnType<typeof orgBoardOrgExportBoardMinuteBookQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgExportBoardMinuteBook({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgExportBoardMinuteBookQueryKey(options)
});

export const orgBoardOrgExportBoardMinuteBookDocumentQueryKey = (options: Options<OrgBoardOrgExportBoardMinuteBookDocumentData>) => createQueryKey('org-board-org_export_board_minute_book_document', options);

/**
 * Org Export Board Minute Book Document
 *
 * The same export as a human-readable minute book — readable, printable, and
 * hand-able to counsel with no tooling at all.
 */
export const orgBoardOrgExportBoardMinuteBookDocumentOptions = (options: Options<OrgBoardOrgExportBoardMinuteBookDocumentData>) => queryOptions<OrgBoardOrgExportBoardMinuteBookDocumentResponse, OrgBoardOrgExportBoardMinuteBookDocumentError, OrgBoardOrgExportBoardMinuteBookDocumentResponse, ReturnType<typeof orgBoardOrgExportBoardMinuteBookDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgExportBoardMinuteBookDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgExportBoardMinuteBookDocumentQueryKey(options)
});

export const orgBoardOrgGetBoardFilingGovernanceFeedQueryKey = (options: Options<OrgBoardOrgGetBoardFilingGovernanceFeedData>) => createQueryKey('org-board-org_get_board_filing_governance_feed', options);

/**
 * Org Get Board Filing Governance Feed
 *
 * The filing module's current governance projection.
 *
 * While Org Machinery standing or the held D-CCM-2 legal rows are absent, the
 * operation fails typed and returns no dependent facts.
 */
export const orgBoardOrgGetBoardFilingGovernanceFeedOptions = (options: Options<OrgBoardOrgGetBoardFilingGovernanceFeedData>) => queryOptions<OrgBoardOrgGetBoardFilingGovernanceFeedResponse, OrgBoardOrgGetBoardFilingGovernanceFeedError, OrgBoardOrgGetBoardFilingGovernanceFeedResponse, ReturnType<typeof orgBoardOrgGetBoardFilingGovernanceFeedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardFilingGovernanceFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardFilingGovernanceFeedQueryKey(options)
});

export const orgBoardOrgOpenBoardFilingReceiptQueryKey = (options: Options<OrgBoardOrgOpenBoardFilingReceiptData>) => createQueryKey('org-board-org_open_board_filing_receipt', options);

/**
 * Org Open Board Filing Receipt
 *
 * Mint from an authorized current feed or exact published packet snapshot.
 */
export const orgBoardOrgOpenBoardFilingReceiptOptions = (options: Options<OrgBoardOrgOpenBoardFilingReceiptData>) => queryOptions<OrgBoardOrgOpenBoardFilingReceiptResponse, OrgBoardOrgOpenBoardFilingReceiptError, OrgBoardOrgOpenBoardFilingReceiptResponse, ReturnType<typeof orgBoardOrgOpenBoardFilingReceiptQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgOpenBoardFilingReceipt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgOpenBoardFilingReceiptQueryKey(options)
});

export const orgBoardOrgGetBoardForm990QueryKey = (options: Options<OrgBoardOrgGetBoardForm990Data>) => createQueryKey('org-board-org_get_board_form_990', options);

/**
 * Org Get Board Form 990
 *
 * One tax year of Form 990, Part VI: each question in the IRS's own words, with its
 * instructions quoted, and beside it what your board's records hold that bears on it, as far as
 * you may read them. Your organization answers each question on its return; this page doesn't.
 *
 * The tax years come from the fiscal year end your organization recorded in Givmo; with none
 * recorded, from the month and day in `year_end_month` and `year_end_day`. `tax_year_ends_on`
 * picks a year by its last day; without it, the latest year that has ended. Computed when read;
 * nothing is stored.
 */
export const orgBoardOrgGetBoardForm990Options = (options: Options<OrgBoardOrgGetBoardForm990Data>) => queryOptions<OrgBoardOrgGetBoardForm990Response, OrgBoardOrgGetBoardForm990Error, OrgBoardOrgGetBoardForm990Response, ReturnType<typeof orgBoardOrgGetBoardForm990QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardForm990({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardForm990QueryKey(options)
});

export const orgBoardOrgGetBoardScheduleODraftQueryKey = (options: Options<OrgBoardOrgGetBoardScheduleODraftData>) => createQueryKey('org-board-org_get_board_schedule_o_draft', options);

/**
 * Org Get Board Schedule O Draft
 *
 * One tax year's Schedule O draft: sentences built only from what your board recorded, for
 * you to edit into your own words — line 8b's, where no committee is recorded for the year, and
 * line 11b's (the copy of the return provided to the board, who opened and read it, and the
 * review linked to it, the board's or a committee's). The text follows the IRS e-file character
 * set. The year is the Form 990 page's, with the same address. Computed when read; never stored,
 * and never your organization's Schedule O, which is whatever it files.
 */
export const orgBoardOrgGetBoardScheduleODraftOptions = (options: Options<OrgBoardOrgGetBoardScheduleODraftData>) => queryOptions<OrgBoardOrgGetBoardScheduleODraftResponse, OrgBoardOrgGetBoardScheduleODraftError, OrgBoardOrgGetBoardScheduleODraftResponse, ReturnType<typeof orgBoardOrgGetBoardScheduleODraftQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardScheduleODraft({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardScheduleODraftQueryKey(options)
});

export const orgBoardOrgListBoardGettingStartedStepsQueryKey = (options: Options<OrgBoardOrgListBoardGettingStartedStepsData>) => createQueryKey('org-board-org_list_board_getting_started_steps', options);

/**
 * Org List Board Getting Started Steps
 *
 * New members, and the steps on their getting-started lists that are the officers' own:
 * sending the year's conflict-of-interest questionnaire, choosing a board buddy.
 */
export const orgBoardOrgListBoardGettingStartedStepsOptions = (options: Options<OrgBoardOrgListBoardGettingStartedStepsData>) => queryOptions<OrgBoardOrgListBoardGettingStartedStepsResponse, OrgBoardOrgListBoardGettingStartedStepsError, OrgBoardOrgListBoardGettingStartedStepsResponse, ReturnType<typeof orgBoardOrgListBoardGettingStartedStepsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardGettingStartedSteps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardGettingStartedStepsQueryKey(options)
});

export const orgBoardOrgGetBoardGettingStartedListQueryKey = (options: Options<OrgBoardOrgGetBoardGettingStartedListData>) => createQueryKey('org-board-org_get_board_getting_started_list', options);

/**
 * Org Get Board Getting Started List
 *
 * The board's getting-started list: the one the board adopted, or — before it adopted one —
 * Givmo's starting list, built only from the governing documents the board recorded, the first
 * disclosure and a board buddy. Nothing is in use until the board adopts a list.
 */
export const orgBoardOrgGetBoardGettingStartedListOptions = (options: Options<OrgBoardOrgGetBoardGettingStartedListData>) => queryOptions<OrgBoardOrgGetBoardGettingStartedListResponse, OrgBoardOrgGetBoardGettingStartedListError, OrgBoardOrgGetBoardGettingStartedListResponse, ReturnType<typeof orgBoardOrgGetBoardGettingStartedListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardGettingStartedList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardGettingStartedListQueryKey(options)
});

/**
 * Org Save Board Getting Started List
 *
 * Use this list (no revision yet), or change the board's list from the revision you read:
 * add, remove or reorder items. Members added after this get the list; a list a member already
 * has doesn't change. A list that changed meanwhile is refused, so no change undoes another.
 */
export const orgBoardOrgSaveBoardGettingStartedListMutation = (options?: Partial<Options<OrgBoardOrgSaveBoardGettingStartedListData>>): UseMutationOptions<OrgBoardOrgSaveBoardGettingStartedListResponse, OrgBoardOrgSaveBoardGettingStartedListError, Options<OrgBoardOrgSaveBoardGettingStartedListData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSaveBoardGettingStartedListResponse, OrgBoardOrgSaveBoardGettingStartedListError, Options<OrgBoardOrgSaveBoardGettingStartedListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSaveBoardGettingStartedList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardGovernanceParametersQueryKey = (options: Options<OrgBoardOrgListBoardGovernanceParametersData>) => createQueryKey('org-board-org_list_board_governance_parameters', options);

/**
 * Org List Board Governance Parameters
 *
 * The charity's recorded parameters — in force first, then history when asked for.
 *
 * The history is opt-in because it is what a past meeting's figures were counted
 * against: a reader checking an old meeting's notice needs the row that was in force
 * then, not only the one in force now.
 */
export const orgBoardOrgListBoardGovernanceParametersOptions = (options: Options<OrgBoardOrgListBoardGovernanceParametersData>) => queryOptions<OrgBoardOrgListBoardGovernanceParametersResponse, OrgBoardOrgListBoardGovernanceParametersError, OrgBoardOrgListBoardGovernanceParametersResponse, ReturnType<typeof orgBoardOrgListBoardGovernanceParametersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardGovernanceParameters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardGovernanceParametersQueryKey(options)
});

/**
 * Org Record Board Governance Parameter
 *
 * Record a governance parameter the charity has entered, with its bylaw attribution.
 *
 * The number is the charity's, and `bylaw_citation` — the section of its own governing
 * documents it comes from — is REQUIRED. The module computes arithmetic against what is
 * recorded here and echoes the citation in every sentence it renders; it reads no
 * governing document and derives none of these numbers.
 *
 * PUT rather than POST because the charity has exactly one parameter in force per key.
 * Recording again does not edit the old row: it writes a new one and supersedes the
 * prior, so a meeting scheduled under the earlier number keeps the figures it was given.
 */
export const orgBoardOrgRecordBoardGovernanceParameterMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardGovernanceParameterData>>): UseMutationOptions<OrgBoardOrgRecordBoardGovernanceParameterResponse, OrgBoardOrgRecordBoardGovernanceParameterError, Options<OrgBoardOrgRecordBoardGovernanceParameterData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardGovernanceParameterResponse, OrgBoardOrgRecordBoardGovernanceParameterError, Options<OrgBoardOrgRecordBoardGovernanceParameterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardGovernanceParameter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardGoverningDocumentTemplatesQueryKey = (options: Options<OrgBoardOrgListBoardGoverningDocumentTemplatesData>) => createQueryKey('org-board-org_list_board_governing_document_templates', options);

/**
 * Org List Board Governing Document Templates
 *
 * The form library the charity may choose from, without the full text of each form.
 *
 * Structurally neutral scaffolds with bracketed fields the organization fills in, each
 * naming the authority its structure is modeled on. The library is the same for every
 * charity: this route reads nothing about the organization, so it can never present a form
 * as one the organization ought to adopt.
 */
export const orgBoardOrgListBoardGoverningDocumentTemplatesOptions = (options: Options<OrgBoardOrgListBoardGoverningDocumentTemplatesData>) => queryOptions<OrgBoardOrgListBoardGoverningDocumentTemplatesResponse, OrgBoardOrgListBoardGoverningDocumentTemplatesError, OrgBoardOrgListBoardGoverningDocumentTemplatesResponse, ReturnType<typeof orgBoardOrgListBoardGoverningDocumentTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardGoverningDocumentTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardGoverningDocumentTemplatesQueryKey(options)
});

export const orgBoardOrgGetBoardGoverningDocumentTemplateQueryKey = (options: Options<OrgBoardOrgGetBoardGoverningDocumentTemplateData>) => createQueryKey('org-board-org_get_board_governing_document_template', options);

/**
 * Org Get Board Governing Document Template
 *
 * One form, with its full text, the fields the organization fills in, and the
 * provenance of its structure.
 *
 * Served with the line the organization should read before adopting anything from it:
 * template — review with your counsel before adopting.
 */
export const orgBoardOrgGetBoardGoverningDocumentTemplateOptions = (options: Options<OrgBoardOrgGetBoardGoverningDocumentTemplateData>) => queryOptions<OrgBoardOrgGetBoardGoverningDocumentTemplateResponse, OrgBoardOrgGetBoardGoverningDocumentTemplateError, OrgBoardOrgGetBoardGoverningDocumentTemplateResponse, ReturnType<typeof orgBoardOrgGetBoardGoverningDocumentTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardGoverningDocumentTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardGoverningDocumentTemplateQueryKey(options)
});

export const orgBoardOrgListBoardGoverningDocumentsQueryKey = (options: Options<OrgBoardOrgListBoardGoverningDocumentsData>) => createQueryKey('org-board-org_list_board_governing_documents', options);

/**
 * Org List Board Governing Documents
 *
 * The charity's governing documents, each as the chain of versions it adopted.
 *
 * Versions are in the order the charity recorded — each names the version it replaced —
 * and the last one is flagged as in force. A version recorded as executive session that
 * the caller did not take part in is absent from the chain, like every other board read.
 *
 * The response describes what the charity recorded and nothing else: there is no entry for
 * an instrument the charity has no version of.
 */
export const orgBoardOrgListBoardGoverningDocumentsOptions = (options: Options<OrgBoardOrgListBoardGoverningDocumentsData>) => queryOptions<OrgBoardOrgListBoardGoverningDocumentsResponse, OrgBoardOrgListBoardGoverningDocumentsError, OrgBoardOrgListBoardGoverningDocumentsResponse, ReturnType<typeof orgBoardOrgListBoardGoverningDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardGoverningDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardGoverningDocumentsQueryKey(options)
});

/**
 * Org Record Historical Board Member
 *
 * Record a FORMER seat — someone who served on this board before the module was in
 * use (CBG-RC8).
 *
 * A separate route from adding a seat, because the row it creates is already ended: the
 * status is not the caller's to choose and no removal reason is asked for, since no
 * removal happened here. `served_from` / `served_to` are the charity's own account of the
 * term and are read back beside the module's own timestamps, so a 2026 entry of a 2019
 * term reads as exactly that rather than as a director who left today.
 *
 * A former seat holds no credentials and never will — every access link and session
 * re-reads the seat's standing on use, and this seat is a former one from the moment it
 * exists. It is here for the record: attendance in historical minutes, and the term
 * lifecycle a later item builds.
 */
export const orgBoardOrgRecordHistoricalBoardMemberMutation = (options?: Partial<Options<OrgBoardOrgRecordHistoricalBoardMemberData>>): UseMutationOptions<OrgBoardOrgRecordHistoricalBoardMemberResponse, OrgBoardOrgRecordHistoricalBoardMemberError, Options<OrgBoardOrgRecordHistoricalBoardMemberData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordHistoricalBoardMemberResponse, OrgBoardOrgRecordHistoricalBoardMemberError, Options<OrgBoardOrgRecordHistoricalBoardMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordHistoricalBoardMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardImportBatchesQueryKey = (options: Options<OrgBoardOrgListBoardImportBatchesData>) => createQueryKey('org-board-org_list_board_import_batches', options);

/**
 * Org List Board Import Batches
 *
 * The charity's import sessions, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Each carries the count of what THIS reader may see in it, so a closed-session record
 * the caller was not part of is missing from the count exactly as it is missing from the
 * listing.
 */
export const orgBoardOrgListBoardImportBatchesOptions = (options: Options<OrgBoardOrgListBoardImportBatchesData>) => queryOptions<OrgBoardOrgListBoardImportBatchesResponse, OrgBoardOrgListBoardImportBatchesError, OrgBoardOrgListBoardImportBatchesResponse, ReturnType<typeof orgBoardOrgListBoardImportBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardImportBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardImportBatchesQueryKey(options)
});

/**
 * Org Open Board Import Batch
 *
 * Open a session for bringing in records from before this module was in use.
 *
 * `source_description` is the charity's own account of where the corpus came from — a box
 * of paper, a prior system, a predecessor's files. The module observed none of it, so the
 * charity's own words are the only honest source, and they travel with every record
 * entered under the session.
 */
export const orgBoardOrgOpenBoardImportBatchMutation = (options?: Partial<Options<OrgBoardOrgOpenBoardImportBatchData>>): UseMutationOptions<OrgBoardOrgOpenBoardImportBatchResponse, OrgBoardOrgOpenBoardImportBatchError, Options<OrgBoardOrgOpenBoardImportBatchData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgOpenBoardImportBatchResponse, OrgBoardOrgOpenBoardImportBatchError, Options<OrgBoardOrgOpenBoardImportBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgOpenBoardImportBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardImportBatchQueryKey = (options: Options<OrgBoardOrgGetBoardImportBatchData>) => createQueryKey('org-board-org_get_board_import_batch', options);

/**
 * Org Get Board Import Batch
 *
 * Twin of ``get_board_import_batch``.
 */
export const orgBoardOrgGetBoardImportBatchOptions = (options: Options<OrgBoardOrgGetBoardImportBatchData>) => queryOptions<OrgBoardOrgGetBoardImportBatchResponse, OrgBoardOrgGetBoardImportBatchError, OrgBoardOrgGetBoardImportBatchResponse, ReturnType<typeof orgBoardOrgGetBoardImportBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardImportBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardImportBatchQueryKey(options)
});

/**
 * Org Update Board Import Batch
 *
 * Edit an OPEN session's description. Refused once it is closed — at that point the
 * label and the source description are what every record entered under it says about its
 * own origin, and those records are themselves immutable.
 */
export const orgBoardOrgUpdateBoardImportBatchMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardImportBatchData>>): UseMutationOptions<OrgBoardOrgUpdateBoardImportBatchResponse, OrgBoardOrgUpdateBoardImportBatchError, Options<OrgBoardOrgUpdateBoardImportBatchData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardImportBatchResponse, OrgBoardOrgUpdateBoardImportBatchError, Options<OrgBoardOrgUpdateBoardImportBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardImportBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Close Board Import Batch
 *
 * Close a session — the charity saying the backfill is finished.
 *
 * Nothing further can be entered under it and the session itself stops being editable.
 * The route is named for the thing it creates (the closure), not for a verb, because the
 * closure is the durable artifact: it names who drew the boundary and when.
 */
export const orgBoardOrgCloseBoardImportBatchMutation = (options?: Partial<Options<OrgBoardOrgCloseBoardImportBatchData>>): UseMutationOptions<OrgBoardOrgCloseBoardImportBatchResponse, OrgBoardOrgCloseBoardImportBatchError, Options<OrgBoardOrgCloseBoardImportBatchData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCloseBoardImportBatchResponse, OrgBoardOrgCloseBoardImportBatchError, Options<OrgBoardOrgCloseBoardImportBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCloseBoardImportBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Issue Board Import File Upload Url
 *
 * A signed upload URL for the file of a record you're entering into an open import batch: PUT
 * the file there once, sending exactly `headers`, then send the record with `file.upload_id`. A
 * PDF or a picture, up to 50 MB. Nothing is recorded until the record is sent.
 */
export const orgBoardOrgIssueBoardImportFileUploadUrlMutation = (options?: Partial<Options<OrgBoardOrgIssueBoardImportFileUploadUrlData>>): UseMutationOptions<OrgBoardOrgIssueBoardImportFileUploadUrlResponse, OrgBoardOrgIssueBoardImportFileUploadUrlError, Options<OrgBoardOrgIssueBoardImportFileUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgIssueBoardImportFileUploadUrlResponse, OrgBoardOrgIssueBoardImportFileUploadUrlError, Options<OrgBoardOrgIssueBoardImportFileUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgIssueBoardImportFileUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Import File Upload
 *
 * Delete a file uploaded for a record you didn't send (the form was cancelled). A record's
 * own file is never deleted here.
 */
export const orgBoardOrgDeleteBoardImportFileUploadMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardImportFileUploadData>>): UseMutationOptions<OrgBoardOrgDeleteBoardImportFileUploadResponse, OrgBoardOrgDeleteBoardImportFileUploadError, Options<OrgBoardOrgDeleteBoardImportFileUploadData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardImportFileUploadResponse, OrgBoardOrgDeleteBoardImportFileUploadError, Options<OrgBoardOrgDeleteBoardImportFileUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardImportFileUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardImportBatchRecordsQueryKey = (options: Options<OrgBoardOrgListBoardImportBatchRecordsData>) => createQueryKey('org-board-org_list_board_import_batch_records', options);

/**
 * Org List Board Import Batch Records
 *
 * Everything entered under one session, in entry order — the review listing.
 *
 * This is what makes a backfill checkable: the charity reads back what it just brought
 * in, with each record's content hash beside it so a reviewer can tie a row to the page
 * of paper it came from. Records the caller may not read are ABSENT, and the total
 * reflects only what they may see.
 */
export const orgBoardOrgListBoardImportBatchRecordsOptions = (options: Options<OrgBoardOrgListBoardImportBatchRecordsData>) => queryOptions<OrgBoardOrgListBoardImportBatchRecordsResponse, OrgBoardOrgListBoardImportBatchRecordsError, OrgBoardOrgListBoardImportBatchRecordsResponse, ReturnType<typeof orgBoardOrgListBoardImportBatchRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardImportBatchRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardImportBatchRecordsQueryKey(options)
});

/**
 * Org Issue Board Import Record File Upload Url
 *
 * A signed upload URL for the file of a record you're entering by hand: PUT the file there
 * once, sending exactly `headers`, then send the record with `file.upload_id`. A PDF or a
 * picture, up to 50 MB. Nothing is recorded until the record is sent.
 */
export const orgBoardOrgIssueBoardImportRecordFileUploadUrlMutation = (options?: Partial<Options<OrgBoardOrgIssueBoardImportRecordFileUploadUrlData>>): UseMutationOptions<OrgBoardOrgIssueBoardImportRecordFileUploadUrlResponse, OrgBoardOrgIssueBoardImportRecordFileUploadUrlError, Options<OrgBoardOrgIssueBoardImportRecordFileUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgIssueBoardImportRecordFileUploadUrlResponse, OrgBoardOrgIssueBoardImportRecordFileUploadUrlError, Options<OrgBoardOrgIssueBoardImportRecordFileUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgIssueBoardImportRecordFileUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Import Record File Upload
 *
 * Delete a file uploaded for a record you didn't send (you chose another file, or left the
 * page). A record's own file is never deleted here.
 */
export const orgBoardOrgDeleteBoardImportRecordFileUploadMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardImportRecordFileUploadData>>): UseMutationOptions<OrgBoardOrgDeleteBoardImportRecordFileUploadResponse, OrgBoardOrgDeleteBoardImportRecordFileUploadError, Options<OrgBoardOrgDeleteBoardImportRecordFileUploadData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardImportRecordFileUploadResponse, OrgBoardOrgDeleteBoardImportRecordFileUploadError, Options<OrgBoardOrgDeleteBoardImportRecordFileUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardImportRecordFileUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardImportInboxQueryKey = (options: Options<OrgBoardOrgListBoardImportInboxData>) => createQueryKey('org-board-org_list_board_import_inbox', options);

/**
 * Org List Board Import Inbox
 *
 * The files uploaded for your AI: those waiting for it, those it proposed records from (each
 * waiting for you to confirm), and those in your minute book, with how many there are and how
 * many can wait at once. Nothing here is in the minute book until you confirm it.
 */
export const orgBoardOrgListBoardImportInboxOptions = (options: Options<OrgBoardOrgListBoardImportInboxData>) => queryOptions<OrgBoardOrgListBoardImportInboxResponse, OrgBoardOrgListBoardImportInboxError, OrgBoardOrgListBoardImportInboxResponse, ReturnType<typeof orgBoardOrgListBoardImportInboxQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardImportInbox({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardImportInboxQueryKey(options)
});

/**
 * Org Issue Board Import Inbox Upload Url
 *
 * A signed upload URL for one file you're uploading for your AI: PUT the file there once,
 * sending exactly `headers`, then ask Board to check it with the `upload_id` it names. A PDF or a
 * picture, up to 50 MB. Nothing is added until Board's check passes.
 */
export const orgBoardOrgIssueBoardImportInboxUploadUrlMutation = (options?: Partial<Options<OrgBoardOrgIssueBoardImportInboxUploadUrlData>>): UseMutationOptions<OrgBoardOrgIssueBoardImportInboxUploadUrlResponse, OrgBoardOrgIssueBoardImportInboxUploadUrlError, Options<OrgBoardOrgIssueBoardImportInboxUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgIssueBoardImportInboxUploadUrlResponse, OrgBoardOrgIssueBoardImportInboxUploadUrlError, Options<OrgBoardOrgIssueBoardImportInboxUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgIssueBoardImportInboxUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Board Import Inbox File
 *
 * Remove a file waiting in your uploads: it is deleted, and your AI no longer sees it. A
 * file your AI proposed a record from waits for you on the confirmation page instead. A
 * person's act.
 */
export const orgBoardOrgRemoveBoardImportInboxFileMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardImportInboxFileData>>): UseMutationOptions<OrgBoardOrgRemoveBoardImportInboxFileResponse, OrgBoardOrgRemoveBoardImportInboxFileError, Options<OrgBoardOrgRemoveBoardImportInboxFileData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardImportInboxFileResponse, OrgBoardOrgRemoveBoardImportInboxFileError, Options<OrgBoardOrgRemoveBoardImportInboxFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardImportInboxFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Check Board Import Inbox File
 *
 * Ask Board to check a file you uploaded, with its name and type. If the check passes, the
 * file waits in your uploads for your AI; if not, the answer says why and the upload is
 * deleted. A file already uploaded, or already in your minute book, is added and says so.
 */
export const orgBoardOrgCheckBoardImportInboxFileMutation = (options?: Partial<Options<OrgBoardOrgCheckBoardImportInboxFileData>>): UseMutationOptions<OrgBoardOrgCheckBoardImportInboxFileResponse, OrgBoardOrgCheckBoardImportInboxFileError, Options<OrgBoardOrgCheckBoardImportInboxFileData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCheckBoardImportInboxFileResponse, OrgBoardOrgCheckBoardImportInboxFileError, Options<OrgBoardOrgCheckBoardImportInboxFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCheckBoardImportInboxFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardImportInboxFileUrlQueryKey = (options: Options<OrgBoardOrgGetBoardImportInboxFileUrlData>) => createQueryKey('org-board-org_get_board_import_inbox_file_url', options);

/**
 * Org Get Board Import Inbox File Url
 *
 * A short-lived link that downloads a file waiting in your uploads, as Board checked it.
 */
export const orgBoardOrgGetBoardImportInboxFileUrlOptions = (options: Options<OrgBoardOrgGetBoardImportInboxFileUrlData>) => queryOptions<OrgBoardOrgGetBoardImportInboxFileUrlResponse, OrgBoardOrgGetBoardImportInboxFileUrlError, OrgBoardOrgGetBoardImportInboxFileUrlResponse, ReturnType<typeof orgBoardOrgGetBoardImportInboxFileUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardImportInboxFileUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardImportInboxFileUrlQueryKey(options)
});

/**
 * Org Import Board Record
 *
 * Bring in a pre-module historical record (CBG-RC8), one document at a time.
 *
 * A separate route from draft creation on purpose: an imported record lands immutable
 * and never passes through submit/approve, so conflating the two entry points would
 * invite a caller to think an import can be "approved" later. It cannot — the database
 * ties imported provenance to the imported state and nothing else.
 *
 * **This is the only import door.** `source_note`, the organization's own note of where
 * the record came from, is optional. A file goes in with the record (`file`, from the
 * slot `…/import-file-upload-url` named) or never. An `import_batch_id` names a backfill
 * session, which is answered as not found while the sessions are switched off.
 *
 * **The call is idempotent.** A "Record it" pressed again, or a backfill retried after a
 * dropped connection, re-sends what it already sent; a record whose content the
 * organization already holds (entered with no session, or in the named one) is not
 * written twice. The already-recorded one comes back with `already_recorded: true` and a
 * **200** rather than a 201, so a caller can tell a fresh entry from a replayed one
 * without comparing ids.
 */
export const orgBoardOrgImportBoardRecordMutation = (options?: Partial<Options<OrgBoardOrgImportBoardRecordData>>): UseMutationOptions<OrgBoardOrgImportBoardRecordResponse, OrgBoardOrgImportBoardRecordError, Options<OrgBoardOrgImportBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgImportBoardRecordResponse, OrgBoardOrgImportBoardRecordError, Options<OrgBoardOrgImportBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgImportBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardLegalHoldsQueryKey = (options: Options<OrgBoardOrgListBoardLegalHoldsData>) => createQueryKey('org-board-org_list_board_legal_holds', options);

/**
 * Org List Board Legal Holds
 *
 * Twin of ``list_board_legal_holds``.
 */
export const orgBoardOrgListBoardLegalHoldsOptions = (options: Options<OrgBoardOrgListBoardLegalHoldsData>) => queryOptions<OrgBoardOrgListBoardLegalHoldsResponse, OrgBoardOrgListBoardLegalHoldsError, OrgBoardOrgListBoardLegalHoldsResponse, ReturnType<typeof orgBoardOrgListBoardLegalHoldsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardLegalHolds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardLegalHoldsQueryKey(options)
});

/**
 * Org Place Board Legal Hold
 *
 * Twin of ``place_board_legal_hold``.
 */
export const orgBoardOrgPlaceBoardLegalHoldMutation = (options?: Partial<Options<OrgBoardOrgPlaceBoardLegalHoldData>>): UseMutationOptions<OrgBoardOrgPlaceBoardLegalHoldResponse, OrgBoardOrgPlaceBoardLegalHoldError, Options<OrgBoardOrgPlaceBoardLegalHoldData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgPlaceBoardLegalHoldResponse, OrgBoardOrgPlaceBoardLegalHoldError, Options<OrgBoardOrgPlaceBoardLegalHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgPlaceBoardLegalHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Release Board Legal Hold
 *
 * Twin of ``release_board_legal_hold``.
 */
export const orgBoardOrgReleaseBoardLegalHoldMutation = (options?: Partial<Options<OrgBoardOrgReleaseBoardLegalHoldData>>): UseMutationOptions<OrgBoardOrgReleaseBoardLegalHoldResponse, OrgBoardOrgReleaseBoardLegalHoldError, Options<OrgBoardOrgReleaseBoardLegalHoldData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReleaseBoardLegalHoldResponse, OrgBoardOrgReleaseBoardLegalHoldError, Options<OrgBoardOrgReleaseBoardLegalHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReleaseBoardLegalHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardLegalHoldReportQueryKey = (options: Options<OrgBoardOrgGetBoardLegalHoldReportData>) => createQueryKey('org-board-org_get_board_legal_hold_report', options);

/**
 * Org Get Board Legal Hold Report
 *
 * What a hold covers — the enumeration the charity can hand to whoever asked for it.
 *
 * A hold preserves records; it does not widen who may read them, so the report is
 * confidentiality-scoped like every other read.
 */
export const orgBoardOrgGetBoardLegalHoldReportOptions = (options: Options<OrgBoardOrgGetBoardLegalHoldReportData>) => queryOptions<OrgBoardOrgGetBoardLegalHoldReportResponse, OrgBoardOrgGetBoardLegalHoldReportError, OrgBoardOrgGetBoardLegalHoldReportResponse, ReturnType<typeof orgBoardOrgGetBoardLegalHoldReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardLegalHoldReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardLegalHoldReportQueryKey(options)
});

export const orgBoardOrgListBoardMeetingsQueryKey = (options: Options<OrgBoardOrgListBoardMeetingsData>) => createQueryKey('org-board-org_list_board_meetings', options);

/**
 * Org List Board Meetings
 *
 * The charity's meetings, soonest first, in the canonical `{data, meta, links}`
 * envelope.
 */
export const orgBoardOrgListBoardMeetingsOptions = (options: Options<OrgBoardOrgListBoardMeetingsData>) => queryOptions<OrgBoardOrgListBoardMeetingsResponse, OrgBoardOrgListBoardMeetingsError, OrgBoardOrgListBoardMeetingsResponse, ReturnType<typeof orgBoardOrgListBoardMeetingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMeetings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMeetingsQueryKey(options)
});

/**
 * Org Create Board Meeting
 *
 * Schedule a meeting.
 *
 * The response's `notice` block is captured here, against the notice period the charity
 * recorded for THIS meeting type. It carries the period, the section it was attributed
 * to, the day count, any shortfall in days, and the counting method — and it never says
 * a meeting was noticed correctly or otherwise. A shortfall is surfaced and never
 * blocks: the board owns its own acts.
 *
 * With no period recorded for this meeting type the block is empty and its statement
 * says so. Nothing is counted, because there is nothing recorded to count against.
 */
export const orgBoardOrgCreateBoardMeetingMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardMeetingData>>): UseMutationOptions<OrgBoardOrgCreateBoardMeetingResponse, OrgBoardOrgCreateBoardMeetingError, Options<OrgBoardOrgCreateBoardMeetingData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardMeetingResponse, OrgBoardOrgCreateBoardMeetingError, Options<OrgBoardOrgCreateBoardMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardMeetingQueryKey = (options: Options<OrgBoardOrgGetBoardMeetingData>) => createQueryKey('org-board-org_get_board_meeting', options);

/**
 * Org Get Board Meeting
 *
 * Twin of ``get_board_meeting``.
 */
export const orgBoardOrgGetBoardMeetingOptions = (options: Options<OrgBoardOrgGetBoardMeetingData>) => queryOptions<OrgBoardOrgGetBoardMeetingResponse, OrgBoardOrgGetBoardMeetingError, OrgBoardOrgGetBoardMeetingResponse, ReturnType<typeof orgBoardOrgGetBoardMeetingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardMeeting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardMeetingQueryKey(options)
});

/**
 * Org Update Board Meeting
 *
 * Edit an upcoming meeting (skip-None partial update).
 *
 * Moving the date re-counts the notice against the period recorded at that moment and
 * bumps the schedule revision, so a director's calendar updates the entry it holds
 * rather than gaining a second one. Correcting the time zone alone re-counts against the
 * SAME recorded period — the zone is what the count is taken in, so a correction can
 * legitimately move the figure by a day without the notice itself having changed.
 *
 * Cancelling is not here: it has its own route and its own required reason.
 */
export const orgBoardOrgUpdateBoardMeetingMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardMeetingData>>): UseMutationOptions<OrgBoardOrgUpdateBoardMeetingResponse, OrgBoardOrgUpdateBoardMeetingError, Options<OrgBoardOrgUpdateBoardMeetingData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardMeetingResponse, OrgBoardOrgUpdateBoardMeetingError, Options<OrgBoardOrgUpdateBoardMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardAgendaItemsQueryKey = (options: Options<OrgBoardOrgListBoardAgendaItemsData>) => createQueryKey('org-board-org_list_board_agenda_items', options);

/**
 * Org List Board Agenda Items
 *
 * One meeting's agenda, in order.
 */
export const orgBoardOrgListBoardAgendaItemsOptions = (options: Options<OrgBoardOrgListBoardAgendaItemsData>) => queryOptions<OrgBoardOrgListBoardAgendaItemsResponse, OrgBoardOrgListBoardAgendaItemsError, OrgBoardOrgListBoardAgendaItemsResponse, ReturnType<typeof orgBoardOrgListBoardAgendaItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardAgendaItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardAgendaItemsQueryKey(options)
});

/**
 * Org Create Board Agenda Item
 *
 * Add an agenda item. Omitted `position` appends to the end.
 */
export const orgBoardOrgCreateBoardAgendaItemMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardAgendaItemData>>): UseMutationOptions<OrgBoardOrgCreateBoardAgendaItemResponse, OrgBoardOrgCreateBoardAgendaItemError, Options<OrgBoardOrgCreateBoardAgendaItemData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardAgendaItemResponse, OrgBoardOrgCreateBoardAgendaItemError, Options<OrgBoardOrgCreateBoardAgendaItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardAgendaItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Add Board Committee Suggestion Items
 *
 * Add the suggested committee decisions to this meeting's agenda: one ordinary item per
 * committee, listing each decision, which can be edited, moved or deleted like any other. Nothing
 * else is filled in. Pressing again adds only decisions not yet on an agenda. A committee's
 * meeting, or one whose minutes are approved, is a 409 `board_committee_suggestion_not_offered`;
 * a suggestion put away for this meeting, a 409 `board_committee_suggestion_dismissed`.
 */
export const orgBoardOrgAddBoardCommitteeSuggestionItemsMutation = (options?: Partial<Options<OrgBoardOrgAddBoardCommitteeSuggestionItemsData>>): UseMutationOptions<OrgBoardOrgAddBoardCommitteeSuggestionItemsResponse, OrgBoardOrgAddBoardCommitteeSuggestionItemsError, Options<OrgBoardOrgAddBoardCommitteeSuggestionItemsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAddBoardCommitteeSuggestionItemsResponse, OrgBoardOrgAddBoardCommitteeSuggestionItemsError, Options<OrgBoardOrgAddBoardCommitteeSuggestionItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAddBoardCommitteeSuggestionItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Apply Board Agenda Template
 *
 * Write the sections of a neutral template the charity selected.
 *
 * `template_id` is required and has no default: the charity names the template it wants.
 * The sections land as ordinary agenda items with nothing populated — no presenter, no
 * time box, no consent-agenda placement — because each of those is a decision about this
 * charity's meeting. Which template was applied is recorded on the meeting and in its
 * event log.
 */
export const orgBoardOrgApplyBoardAgendaTemplateMutation = (options?: Partial<Options<OrgBoardOrgApplyBoardAgendaTemplateData>>): UseMutationOptions<OrgBoardOrgApplyBoardAgendaTemplateResponse, OrgBoardOrgApplyBoardAgendaTemplateError, Options<OrgBoardOrgApplyBoardAgendaTemplateData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgApplyBoardAgendaTemplateResponse, OrgBoardOrgApplyBoardAgendaTemplateError, Options<OrgBoardOrgApplyBoardAgendaTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgApplyBoardAgendaTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Add Board Term Suggestion Items
 *
 * Add the elections the annual meeting's terms suggest: "Election of directors" and
 * "Election of officers", each an ordinary item naming the people whose terms end — or, where the
 * annual template's own "Directors" or "Officers" section is on the agenda, those names added to
 * it. Nothing else is filled in. Added once: pressing again adds nothing. A meeting not typed
 * annual is a 409 `board_term_suggestion_not_offered`; a suggestion put away for this meeting, a
 * 409 `board_term_suggestion_dismissed`.
 */
export const orgBoardOrgAddBoardTermSuggestionItemsMutation = (options?: Partial<Options<OrgBoardOrgAddBoardTermSuggestionItemsData>>): UseMutationOptions<OrgBoardOrgAddBoardTermSuggestionItemsResponse, OrgBoardOrgAddBoardTermSuggestionItemsError, Options<OrgBoardOrgAddBoardTermSuggestionItemsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAddBoardTermSuggestionItemsResponse, OrgBoardOrgAddBoardTermSuggestionItemsError, Options<OrgBoardOrgAddBoardTermSuggestionItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAddBoardTermSuggestionItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Agenda Item
 *
 * Remove an agenda item, closing the gap it leaves in the ordering.
 *
 * A real delete: a planned agenda item is working content, not part of the charity's
 * record. What the board actually took up is recorded with the minutes, where nothing is
 * ever deleted.
 */
export const orgBoardOrgDeleteBoardAgendaItemMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardAgendaItemData>>): UseMutationOptions<OrgBoardOrgDeleteBoardAgendaItemResponse, OrgBoardOrgDeleteBoardAgendaItemError, Options<OrgBoardOrgDeleteBoardAgendaItemData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardAgendaItemResponse, OrgBoardOrgDeleteBoardAgendaItemError, Options<OrgBoardOrgDeleteBoardAgendaItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardAgendaItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Update Board Agenda Item
 *
 * Edit an agenda item (skip-None partial update).
 *
 * `disposition` is the mark the carry-forward read selects on: an item the charity marks
 * as left open is what resurfaces on a later agenda. It is a mark the charity applies —
 * the module never infers that an item nobody dispositioned is unfinished business.
 *
 * Editing stays open after the meeting has started, because dispositioning an item is
 * inherently something the recording officer does afterwards.
 */
export const orgBoardOrgUpdateBoardAgendaItemMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardAgendaItemData>>): UseMutationOptions<OrgBoardOrgUpdateBoardAgendaItemResponse, OrgBoardOrgUpdateBoardAgendaItemError, Options<OrgBoardOrgUpdateBoardAgendaItemData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardAgendaItemResponse, OrgBoardOrgUpdateBoardAgendaItemError, Options<OrgBoardOrgUpdateBoardAgendaItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardAgendaItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Reorder Board Agenda
 *
 * Reorder the agenda by naming every item once, in the order wanted.
 *
 * The whole agenda rather than a delta: a partial list leaves the unnamed items at
 * positions that may now collide, and reconciling that on the server means guessing at
 * an intent the caller did not state.
 */
export const orgBoardOrgReorderBoardAgendaMutation = (options?: Partial<Options<OrgBoardOrgReorderBoardAgendaData>>): UseMutationOptions<OrgBoardOrgReorderBoardAgendaResponse, OrgBoardOrgReorderBoardAgendaError, Options<OrgBoardOrgReorderBoardAgendaData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReorderBoardAgendaResponse, OrgBoardOrgReorderBoardAgendaError, Options<OrgBoardOrgReorderBoardAgendaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReorderBoardAgenda({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardApprovableMinutesQueryKey = (options: Options<OrgBoardOrgListBoardApprovableMinutesData>) => createQueryKey('org-board-org_list_board_approvable_minutes', options);

/**
 * Org List Board Approvable Minutes
 *
 * The minutes a motion at this meeting may approve: minutes of earlier meetings the board
 * hasn't approved yet, sent to this reader, whose approval way admits a vote at a meeting now.
 *
 * Named by public facts only — the meeting's title and start, and a closed session's general
 * purpose. A list, never a door: recording the motion decides again.
 */
export const orgBoardOrgListBoardApprovableMinutesOptions = (options: Options<OrgBoardOrgListBoardApprovableMinutesData>) => queryOptions<OrgBoardOrgListBoardApprovableMinutesResponse, OrgBoardOrgListBoardApprovableMinutesError, OrgBoardOrgListBoardApprovableMinutesResponse, ReturnType<typeof orgBoardOrgListBoardApprovableMinutesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardApprovableMinutes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardApprovableMinutesQueryKey(options)
});

export const orgBoardOrgListBoardMeetingAttendanceQueryKey = (options: Options<OrgBoardOrgListBoardMeetingAttendanceData>) => createQueryKey('org-board-org_list_board_meeting_attendance', options);

/**
 * Org List Board Meeting Attendance
 *
 * Who the charity recorded as present at one meeting.
 */
export const orgBoardOrgListBoardMeetingAttendanceOptions = (options: Options<OrgBoardOrgListBoardMeetingAttendanceData>) => queryOptions<OrgBoardOrgListBoardMeetingAttendanceResponse, OrgBoardOrgListBoardMeetingAttendanceError, OrgBoardOrgListBoardMeetingAttendanceResponse, ReturnType<typeof orgBoardOrgListBoardMeetingAttendanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMeetingAttendance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMeetingAttendanceQueryKey(options)
});

export const orgBoardOrgListBoardAttendanceIntentsQueryKey = (options: Options<OrgBoardOrgListBoardAttendanceIntentsData>) => createQueryKey('org-board-org_list_board_attendance_intents', options);

/**
 * Org List Board Attendance Intents
 *
 * Who has answered for one meeting, and how.
 *
 * An intent, not attendance: who was actually in the room is recorded with the minutes.
 */
export const orgBoardOrgListBoardAttendanceIntentsOptions = (options: Options<OrgBoardOrgListBoardAttendanceIntentsData>) => queryOptions<OrgBoardOrgListBoardAttendanceIntentsResponse, OrgBoardOrgListBoardAttendanceIntentsError, OrgBoardOrgListBoardAttendanceIntentsResponse, ReturnType<typeof orgBoardOrgListBoardAttendanceIntentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardAttendanceIntents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardAttendanceIntentsQueryKey(options)
});

/**
 * Org Record Board Attendance Intent On Behalf
 *
 * Record a director's attendance intent on their behalf.
 *
 * The manual path, and it is first-class rather than a fallback: a director who
 * telephones, replies to a paper notice, or tells the secretary in the corridor still
 * has an answer on record. The row is stamped as recorded by a charity admin and names
 * the person who entered it, so the charity's own record says which of the two happened.
 */
export const orgBoardOrgRecordBoardAttendanceIntentOnBehalfMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardAttendanceIntentOnBehalfData>>): UseMutationOptions<OrgBoardOrgRecordBoardAttendanceIntentOnBehalfResponse, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfError, Options<OrgBoardOrgRecordBoardAttendanceIntentOnBehalfData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardAttendanceIntentOnBehalfResponse, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfError, Options<OrgBoardOrgRecordBoardAttendanceIntentOnBehalfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardAttendanceIntentOnBehalf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Meeting Attendance
 *
 * Record who was actually in the room, one seat at a time.
 *
 * Distinct from the RSVP: that is what a director said they would do, this is what the
 * charity says happened, and it is what the quorum figures at each vote are counted from.
 *
 * `arrived_at` and `departed_at` are optional instants rather than states, so a seat that
 * came in late AND left early is expressible — and so a vote taken between those two
 * instants counts that seat as present while one taken outside them does not.
 *
 * PUT rather than POST because there is one answer per seat per meeting: recording again
 * corrects it rather than adding a second.
 */
export const orgBoardOrgRecordBoardMeetingAttendanceMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardMeetingAttendanceData>>): UseMutationOptions<OrgBoardOrgRecordBoardMeetingAttendanceResponse, OrgBoardOrgRecordBoardMeetingAttendanceError, Options<OrgBoardOrgRecordBoardMeetingAttendanceData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardMeetingAttendanceResponse, OrgBoardOrgRecordBoardMeetingAttendanceError, Options<OrgBoardOrgRecordBoardMeetingAttendanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardMeetingAttendance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardMeetingCalendarQueryKey = (options: Options<OrgBoardOrgGetBoardMeetingCalendarData>) => createQueryKey('org-board-org_get_board_meeting_calendar', options);

/**
 * Org Get Board Meeting Calendar
 *
 * The meeting as an iCalendar file, for any calendar application.
 *
 * Generated from the stored row each time it is asked for, so a rescheduled meeting's
 * file carries the new instant and a higher sequence number — which is what makes a
 * calendar application update the entry it already has instead of adding a second one.
 */
export const orgBoardOrgGetBoardMeetingCalendarOptions = (options: Options<OrgBoardOrgGetBoardMeetingCalendarData>) => queryOptions<OrgBoardOrgGetBoardMeetingCalendarResponse, OrgBoardOrgGetBoardMeetingCalendarError, OrgBoardOrgGetBoardMeetingCalendarResponse, ReturnType<typeof orgBoardOrgGetBoardMeetingCalendarQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardMeetingCalendar({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardMeetingCalendarQueryKey(options)
});

/**
 * Org Cancel Board Meeting
 *
 * Cancel a meeting, with a recorded reason.
 *
 * A POST carrying a required reason rather than a status flip on the edit route: the
 * roster was told about this meeting, so calling it off is its own act with its own
 * actor, instant, and explanation. Never a delete. Re-cancelling is a no-op, so a
 * retried request does not read as a failure.
 */
export const orgBoardOrgCancelBoardMeetingMutation = (options?: Partial<Options<OrgBoardOrgCancelBoardMeetingData>>): UseMutationOptions<OrgBoardOrgCancelBoardMeetingResponse, OrgBoardOrgCancelBoardMeetingError, Options<OrgBoardOrgCancelBoardMeetingData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCancelBoardMeetingResponse, OrgBoardOrgCancelBoardMeetingError, Options<OrgBoardOrgCancelBoardMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCancelBoardMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardCommitteeSuggestionsQueryKey = (options: Options<OrgBoardOrgGetBoardCommitteeSuggestionsData>) => createQueryKey('org-board-org_get_board_committee_suggestions', options);

/**
 * Org Get Board Committee Suggestions
 *
 * On a board meeting whose minutes are not approved, the decisions of each committee whose
 * practice is to bring them to the board's next meeting: motions recorded as carried at its own
 * meetings, in the open session, and its executed written consents (none approving minutes),
 * recorded while that practice was on, taken before the meeting's day and on no board meeting's
 * agenda yet. Worked out each time it is read; nothing is added to the agenda until someone adds
 * it. On a committee's meeting, a cancelled one or one whose minutes are approved, `offered` is
 * false and the list is empty.
 */
export const orgBoardOrgGetBoardCommitteeSuggestionsOptions = (options: Options<OrgBoardOrgGetBoardCommitteeSuggestionsData>) => queryOptions<OrgBoardOrgGetBoardCommitteeSuggestionsResponse, OrgBoardOrgGetBoardCommitteeSuggestionsError, OrgBoardOrgGetBoardCommitteeSuggestionsResponse, ReturnType<typeof orgBoardOrgGetBoardCommitteeSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCommitteeSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCommitteeSuggestionsQueryKey(options)
});

/**
 * Org Restore Board Committee Suggestion
 *
 * Bring the suggested committee decisions back after they were put away for this meeting.
 */
export const orgBoardOrgRestoreBoardCommitteeSuggestionMutation = (options?: Partial<Options<OrgBoardOrgRestoreBoardCommitteeSuggestionData>>): UseMutationOptions<OrgBoardOrgRestoreBoardCommitteeSuggestionResponse, OrgBoardOrgRestoreBoardCommitteeSuggestionError, Options<OrgBoardOrgRestoreBoardCommitteeSuggestionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRestoreBoardCommitteeSuggestionResponse, OrgBoardOrgRestoreBoardCommitteeSuggestionError, Options<OrgBoardOrgRestoreBoardCommitteeSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRestoreBoardCommitteeSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Dismiss Board Committee Suggestion
 *
 * Put the suggested committee decisions away for this meeting ("Not for this meeting"),
 * recording who and when. They can be brought back, and the next board meeting suggests them
 * again.
 */
export const orgBoardOrgDismissBoardCommitteeSuggestionMutation = (options?: Partial<Options<OrgBoardOrgDismissBoardCommitteeSuggestionData>>): UseMutationOptions<OrgBoardOrgDismissBoardCommitteeSuggestionResponse, OrgBoardOrgDismissBoardCommitteeSuggestionError, Options<OrgBoardOrgDismissBoardCommitteeSuggestionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDismissBoardCommitteeSuggestionResponse, OrgBoardOrgDismissBoardCommitteeSuggestionError, Options<OrgBoardOrgDismissBoardCommitteeSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDismissBoardCommitteeSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardMeetingCompensationDecisionsQueryKey = (options: Options<OrgBoardOrgListBoardMeetingCompensationDecisionsData>) => createQueryKey('org-board-org_list_board_meeting_compensation_decisions', options);

/**
 * Org List Board Meeting Compensation Decisions
 *
 * A meeting's compensation decisions, on the motions you may read: each with whose pay it
 * set, the documents the board relied on (by name and fingerprint), how the board obtained
 * them, the board's reason when it set pay outside the range in that information, who took
 * part, and when it was written down. With the meeting's uploaded papers a decision may name,
 * and whether its record is still open to change.
 */
export const orgBoardOrgListBoardMeetingCompensationDecisionsOptions = (options: Options<OrgBoardOrgListBoardMeetingCompensationDecisionsData>) => queryOptions<OrgBoardOrgListBoardMeetingCompensationDecisionsResponse, OrgBoardOrgListBoardMeetingCompensationDecisionsError, OrgBoardOrgListBoardMeetingCompensationDecisionsResponse, ReturnType<typeof orgBoardOrgListBoardMeetingCompensationDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMeetingCompensationDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMeetingCompensationDecisionsQueryKey(options)
});

export const orgBoardOrgListBoardConflictLinksQueryKey = (options: Options<OrgBoardOrgListBoardConflictLinksData>) => createQueryKey('org-board-org_list_board_conflict_links', options);

/**
 * Org List Board Conflict Links
 *
 * Every decision recorded for this meeting — confirmed links and dismissed ones.
 *
 * Both, because this answers what you have decided about the meeting. The pre-vote view
 * on the in-meeting record carries confirmations only: showing a dismissal beside a
 * motion would put in front of the board exactly the thing you recorded as not being
 * there.
 *
 * A link naming a motion made inside an executive session you were not part of is
 * absent, like the motion itself.
 */
export const orgBoardOrgListBoardConflictLinksOptions = (options: Options<OrgBoardOrgListBoardConflictLinksData>) => queryOptions<OrgBoardOrgListBoardConflictLinksResponse, OrgBoardOrgListBoardConflictLinksError, OrgBoardOrgListBoardConflictLinksResponse, ReturnType<typeof orgBoardOrgListBoardConflictLinksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardConflictLinks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardConflictLinksQueryKey(options)
});

/**
 * Org Record Board Conflict Link
 *
 * Record your decision about one disclosure and one agenda item or motion.
 *
 * `confirmed` records that the disclosure names this item; `dismissed` records that it
 * does not. Both are kept — a dismissal means the same candidate is not put in front of
 * you again, and it says a human looked, which a missing row does not.
 *
 * A confirmed link on a motion, or on the agenda item a motion was made under, appears
 * beside that motion on the in-meeting record so the board can read it before the vote,
 * and enters the minutes when the draft is next refreshed. What appears there is the
 * recorded facts: who disclosed what, when, when you linked it, and whether a recusal
 * for that seat has been recorded on the motion.
 *
 * A disclosure a later one has replaced can still be linked: only the suggestions filter
 * on what stands today, because a meeting may be minuting something that happened while
 * the earlier disclosure was in force.
 *
 * Refused once the minutes of the meeting are approved — from that point the link is
 * inside the record's content hash, and a change is a correction of the minutes.
 */
export const orgBoardOrgRecordBoardConflictLinkMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardConflictLinkData>>): UseMutationOptions<OrgBoardOrgRecordBoardConflictLinkResponse, OrgBoardOrgRecordBoardConflictLinkError, Options<OrgBoardOrgRecordBoardConflictLinkData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardConflictLinkResponse, OrgBoardOrgRecordBoardConflictLinkError, Options<OrgBoardOrgRecordBoardConflictLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardConflictLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Conflict Link
 *
 * Remove a link recorded in error, while the meeting's record is still open.
 *
 * There is no edit: a decision is recorded or it is not, and changing one is removing it
 * and recording the other. Refused once the minutes are approved, like every other write
 * against a closed meeting record.
 */
export const orgBoardOrgDeleteBoardConflictLinkMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardConflictLinkData>>): UseMutationOptions<OrgBoardOrgDeleteBoardConflictLinkResponse, OrgBoardOrgDeleteBoardConflictLinkError, Options<OrgBoardOrgDeleteBoardConflictLinkData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardConflictLinkResponse, OrgBoardOrgDeleteBoardConflictLinkError, Options<OrgBoardOrgDeleteBoardConflictLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardConflictLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardConflictSuggestionsQueryKey = (options: Options<OrgBoardOrgListBoardConflictSuggestionsData>) => createQueryKey('org-board-org_list_board_conflict_suggestions', options);

/**
 * Org List Board Conflict Suggestions
 *
 * Candidate links between recorded disclosures and this meeting's items.
 *
 * Each counterparty name recorded on a standing disclosure is looked for in the wording
 * of the meeting's agenda items and motions, matching whole words only. Nothing else is
 * read, and nothing is recorded here: a candidate becomes a fact when you confirm it.
 *
 * `method` says exactly that on every response, because the risky reading of an empty
 * list is that something was checked and found clear. A candidate that does not appear
 * is one this text match did not find.
 */
export const orgBoardOrgListBoardConflictSuggestionsOptions = (options: Options<OrgBoardOrgListBoardConflictSuggestionsData>) => queryOptions<OrgBoardOrgListBoardConflictSuggestionsResponse, OrgBoardOrgListBoardConflictSuggestionsError, OrgBoardOrgListBoardConflictSuggestionsResponse, ReturnType<typeof orgBoardOrgListBoardConflictSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardConflictSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardConflictSuggestionsQueryKey(options)
});

export const orgBoardOrgListBoardDocumentsQueryKey = (options: Options<OrgBoardOrgListBoardDocumentsData>) => createQueryKey('org-board-org_list_board_documents', options);

/**
 * Org List Board Documents
 *
 * One meeting's attachments. Never carries a storage key or a read URL.
 */
export const orgBoardOrgListBoardDocumentsOptions = (options: Options<OrgBoardOrgListBoardDocumentsData>) => queryOptions<OrgBoardOrgListBoardDocumentsResponse, OrgBoardOrgListBoardDocumentsError, OrgBoardOrgListBoardDocumentsResponse, ReturnType<typeof orgBoardOrgListBoardDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardDocumentsQueryKey(options)
});

/**
 * Org Confirm Board Document
 *
 * Confirm that an attachment finished uploading.
 *
 * Nothing is recorded unless the object is found where the reference says it is: a row
 * for an upload that never completed is an attachment the packet cannot render.
 * `reported_content_digest` is optional and self-reported — this API does not read the
 * object back to check it, and the field name says so.
 */
export const orgBoardOrgConfirmBoardDocumentMutation = (options?: Partial<Options<OrgBoardOrgConfirmBoardDocumentData>>): UseMutationOptions<OrgBoardOrgConfirmBoardDocumentResponse, OrgBoardOrgConfirmBoardDocumentError, Options<OrgBoardOrgConfirmBoardDocumentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgConfirmBoardDocumentResponse, OrgBoardOrgConfirmBoardDocumentError, Options<OrgBoardOrgConfirmBoardDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgConfirmBoardDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Issue Board Document Upload Url
 *
 * Issue a short-lived signed upload URL for one packet attachment.
 *
 * Two steps — issue, then confirm — so the bytes go straight to storage and never
 * through this API. The URL is bound to the content type declared here, and no row is
 * written until the confirm call finds the object actually there.
 */
export const orgBoardOrgIssueBoardDocumentUploadUrlMutation = (options?: Partial<Options<OrgBoardOrgIssueBoardDocumentUploadUrlData>>): UseMutationOptions<OrgBoardOrgIssueBoardDocumentUploadUrlResponse, OrgBoardOrgIssueBoardDocumentUploadUrlError, Options<OrgBoardOrgIssueBoardDocumentUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgIssueBoardDocumentUploadUrlResponse, OrgBoardOrgIssueBoardDocumentUploadUrlError, Options<OrgBoardOrgIssueBoardDocumentUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgIssueBoardDocumentUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardDocumentDownloadUrlQueryKey = (options: Options<OrgBoardOrgGetBoardDocumentDownloadUrlData>) => createQueryKey('org-board-org_get_board_document_download_url', options);

/**
 * Org Get Board Document Download Url
 *
 * Mint a short-lived signed read URL for one attachment. Never persisted.
 */
export const orgBoardOrgGetBoardDocumentDownloadUrlOptions = (options: Options<OrgBoardOrgGetBoardDocumentDownloadUrlData>) => queryOptions<OrgBoardOrgGetBoardDocumentDownloadUrlResponse, OrgBoardOrgGetBoardDocumentDownloadUrlError, OrgBoardOrgGetBoardDocumentDownloadUrlResponse, ReturnType<typeof orgBoardOrgGetBoardDocumentDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardDocumentDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardDocumentDownloadUrlQueryKey(options)
});

export const orgBoardOrgGetBoardInMeetingRecordQueryKey = (options: Options<OrgBoardOrgGetBoardInMeetingRecordData>) => createQueryKey('org-board-org_get_board_in_meeting_record', options);

/**
 * Org Get Board In Meeting Record
 *
 * Everything the charity recorded about one meeting, as this reader may see it.
 */
export const orgBoardOrgGetBoardInMeetingRecordOptions = (options: Options<OrgBoardOrgGetBoardInMeetingRecordData>) => queryOptions<OrgBoardOrgGetBoardInMeetingRecordResponse, OrgBoardOrgGetBoardInMeetingRecordError, OrgBoardOrgGetBoardInMeetingRecordResponse, ReturnType<typeof orgBoardOrgGetBoardInMeetingRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardInMeetingRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardInMeetingRecordQueryKey(options)
});

export const orgBoardOrgGetBoardMeetingInvitationsQueryKey = (options: Options<OrgBoardOrgGetBoardMeetingInvitationsData>) => createQueryKey('org-board-org_get_board_meeting_invitations', options);

/**
 * Org Get Board Meeting Invitations
 *
 * How a meeting reached directors' calendars: the sender, the state, and each invited
 * director with their latest reply in their calendar.
 */
export const orgBoardOrgGetBoardMeetingInvitationsOptions = (options: Options<OrgBoardOrgGetBoardMeetingInvitationsData>) => queryOptions<OrgBoardOrgGetBoardMeetingInvitationsResponse, OrgBoardOrgGetBoardMeetingInvitationsError, OrgBoardOrgGetBoardMeetingInvitationsResponse, ReturnType<typeof orgBoardOrgGetBoardMeetingInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardMeetingInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardMeetingInvitationsQueryKey(options)
});

/**
 * Org Send Board Meeting Invitations
 *
 * Send a meeting's invitations to the board's active directors from the chosen sender.
 * Scheduling a meeting sends nothing; this is the officer's act. Sending again from the same
 * sender retries what did not go out.
 */
export const orgBoardOrgSendBoardMeetingInvitationsMutation = (options?: Partial<Options<OrgBoardOrgSendBoardMeetingInvitationsData>>): UseMutationOptions<OrgBoardOrgSendBoardMeetingInvitationsResponse, OrgBoardOrgSendBoardMeetingInvitationsError, Options<OrgBoardOrgSendBoardMeetingInvitationsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSendBoardMeetingInvitationsResponse, OrgBoardOrgSendBoardMeetingInvitationsError, Options<OrgBoardOrgSendBoardMeetingInvitationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSendBoardMeetingInvitations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Directors Told
 *
 * Record that an officer told the directors about a meeting's earlier invitations, which
 * Board can't prove are gone: the warning clears and Board stops acting on those invitations.
 * Sends nothing (CBG-FIX32).
 */
export const orgBoardOrgRecordBoardDirectorsToldMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardDirectorsToldData>>): UseMutationOptions<OrgBoardOrgRecordBoardDirectorsToldResponse, OrgBoardOrgRecordBoardDirectorsToldError, Options<OrgBoardOrgRecordBoardDirectorsToldData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardDirectorsToldResponse, OrgBoardOrgRecordBoardDirectorsToldError, Options<OrgBoardOrgRecordBoardDirectorsToldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardDirectorsTold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Reinvite Board Meeting Invitee
 *
 * Invite one director again, including one removed from the invitation in a calendar.
 */
export const orgBoardOrgReinviteBoardMeetingInviteeMutation = (options?: Partial<Options<OrgBoardOrgReinviteBoardMeetingInviteeData>>): UseMutationOptions<OrgBoardOrgReinviteBoardMeetingInviteeResponse, OrgBoardOrgReinviteBoardMeetingInviteeError, Options<OrgBoardOrgReinviteBoardMeetingInviteeData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReinviteBoardMeetingInviteeResponse, OrgBoardOrgReinviteBoardMeetingInviteeError, Options<OrgBoardOrgReinviteBoardMeetingInviteeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReinviteBoardMeetingInvitee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Move Board Meeting Invitations
 *
 * Send a meeting's invitations from another sender instead (directors get one
 * cancellation and one new invitation), or stop keeping it in step with a calendar.
 */
export const orgBoardOrgMoveBoardMeetingInvitationsMutation = (options?: Partial<Options<OrgBoardOrgMoveBoardMeetingInvitationsData>>): UseMutationOptions<OrgBoardOrgMoveBoardMeetingInvitationsResponse, OrgBoardOrgMoveBoardMeetingInvitationsError, Options<OrgBoardOrgMoveBoardMeetingInvitationsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgMoveBoardMeetingInvitationsResponse, OrgBoardOrgMoveBoardMeetingInvitationsError, Options<OrgBoardOrgMoveBoardMeetingInvitationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgMoveBoardMeetingInvitations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Schedule Restored Board Meeting
 *
 * Schedule again a meeting that was cancelled in the organizer's calendar and is back
 * there: a new meeting linked to the restored event, with the old meeting's agenda. Sends no
 * invitation.
 */
export const orgBoardOrgScheduleRestoredBoardMeetingMutation = (options?: Partial<Options<OrgBoardOrgScheduleRestoredBoardMeetingData>>): UseMutationOptions<OrgBoardOrgScheduleRestoredBoardMeetingResponse, OrgBoardOrgScheduleRestoredBoardMeetingError, Options<OrgBoardOrgScheduleRestoredBoardMeetingData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgScheduleRestoredBoardMeetingResponse, OrgBoardOrgScheduleRestoredBoardMeetingError, Options<OrgBoardOrgScheduleRestoredBoardMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgScheduleRestoredBoardMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardMeetingEventsQueryKey = (options: Options<OrgBoardOrgListBoardMeetingEventsData>) => createQueryKey('org-board-org_list_board_meeting_events', options);

/**
 * Org List Board Meeting Events
 *
 * One meeting's append-only event log, oldest first.
 *
 * It exists for the notice figures: a meeting moved from twenty days out to three shows
 * its final count, and this log is where a reader sees that it was once different.
 */
export const orgBoardOrgListBoardMeetingEventsOptions = (options: Options<OrgBoardOrgListBoardMeetingEventsData>) => queryOptions<OrgBoardOrgListBoardMeetingEventsResponse, OrgBoardOrgListBoardMeetingEventsError, OrgBoardOrgListBoardMeetingEventsResponse, ReturnType<typeof orgBoardOrgListBoardMeetingEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMeetingEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMeetingEventsQueryKey(options)
});

export const orgBoardOrgGetBoardMinutesQueryKey = (options: Options<OrgBoardOrgGetBoardMinutesData>) => createQueryKey('org-board-org_get_board_minutes', options);

/**
 * Org Get Board Minutes
 *
 * The minutes of one meeting — or, with `segment_id`, of one of its closed sessions.
 */
export const orgBoardOrgGetBoardMinutesOptions = (options: Options<OrgBoardOrgGetBoardMinutesData>) => queryOptions<OrgBoardOrgGetBoardMinutesResponse, OrgBoardOrgGetBoardMinutesError, OrgBoardOrgGetBoardMinutesResponse, ReturnType<typeof orgBoardOrgGetBoardMinutesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardMinutes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardMinutesQueryKey(options)
});

/**
 * Org Write Board Minutes Draft
 *
 * Open or refresh the minutes draft for a meeting, or for one of its closed sessions.
 *
 * What the charity recorded about the meeting — who was present, the sessions, the motions
 * with their votes and recusals and the quorum figures at each — is assembled by the module
 * and returned as `structured_record`. `body` is the recording officer's own sections and
 * is theirs alone; the two are separate fields so it stays answerable afterwards which
 * words were whose.
 *
 * Call it again while the minutes are a draft and the assembled part is re-taken, so a
 * motion recorded after the draft was opened is in it. Once the board has approved them it
 * is refused: a change to approved minutes is recorded as a correction.
 */
export const orgBoardOrgWriteBoardMinutesDraftMutation = (options?: Partial<Options<OrgBoardOrgWriteBoardMinutesDraftData>>): UseMutationOptions<OrgBoardOrgWriteBoardMinutesDraftResponse, OrgBoardOrgWriteBoardMinutesDraftError, Options<OrgBoardOrgWriteBoardMinutesDraftData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgWriteBoardMinutesDraftResponse, OrgBoardOrgWriteBoardMinutesDraftError, Options<OrgBoardOrgWriteBoardMinutesDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgWriteBoardMinutesDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Approve Board Minutes
 *
 * Approve minutes as the recording officer.
 *
 * The other door is a motion the board carries at its next meeting, which records which
 * meeting approved them. Both write the same approval event and name a human.
 *
 * `content_hash` is the address of the exact minutes being approved. If they changed since
 * they were read, the approval is refused rather than applied to different words.
 */
export const orgBoardOrgApproveBoardMinutesMutation = (options?: Partial<Options<OrgBoardOrgApproveBoardMinutesData>>): UseMutationOptions<OrgBoardOrgApproveBoardMinutesResponse, OrgBoardOrgApproveBoardMinutesError, Options<OrgBoardOrgApproveBoardMinutesData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgApproveBoardMinutesResponse, OrgBoardOrgApproveBoardMinutesError, Options<OrgBoardOrgApproveBoardMinutesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgApproveBoardMinutes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Ask Board Minutes Approval Signatures
 *
 * Ask the directors who were in a closed session to sign to approve its minutes.
 *
 * Only where the board's own rule approves a closed session's minutes by the signatures of the
 * directors who were there; any other way is the typed 409 `board_minutes_approval_way`. Asked:
 * every seat recorded as in the session that is a director now, recused from a decision in it or
 * not. Not a written consent: it is never every director's. `content_hash` is the bytes read; the
 * minutes stay a draft while the request is out, and the last asked signature on the current
 * bytes approves them. Nobody to ask, or a request already out, is a typed 409; nothing written.
 */
export const orgBoardOrgAskBoardMinutesApprovalSignaturesMutation = (options?: Partial<Options<OrgBoardOrgAskBoardMinutesApprovalSignaturesData>>): UseMutationOptions<OrgBoardOrgAskBoardMinutesApprovalSignaturesResponse, OrgBoardOrgAskBoardMinutesApprovalSignaturesError, Options<OrgBoardOrgAskBoardMinutesApprovalSignaturesData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAskBoardMinutesApprovalSignaturesResponse, OrgBoardOrgAskBoardMinutesApprovalSignaturesError, Options<OrgBoardOrgAskBoardMinutesApprovalSignaturesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAskBoardMinutesApprovalSignatures({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Minutes Approval Signature On Behalf
 *
 * Record an asked director's signature to approve, given on paper or by email.
 *
 * The officer's entry, never the director's own act: it records that the officer wrote it down,
 * with a required note saying where the signature came from. The seat must be one the open
 * request asked (else the typed 409 `board_minutes_not_asked_to_sign`). It may be the last
 * signature, and then the minutes are approved.
 */
export const orgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfData>>): UseMutationOptions<OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfResponse, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfError, Options<OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfResponse, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfError, Options<OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Withdraw Board Minutes Approval Signatures
 *
 * Withdraw the open request for signatures on a closed session's minutes, with the reason.
 *
 * The signatures already given stay in the minutes' history and count for nothing; asking
 * again starts fresh. No request out is a typed 409 `board_minutes_no_signatures_asked`.
 */
export const orgBoardOrgWithdrawBoardMinutesApprovalSignaturesMutation = (options?: Partial<Options<OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesData>>): UseMutationOptions<OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesResponse, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesError, Options<OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesResponse, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesError, Options<OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgWithdrawBoardMinutesApprovalSignatures({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Send Board Minutes Reminder
 *
 * Send the board a reminder that a meeting's minutes are not yet recorded.
 *
 * An act the charity performs; nothing schedules it. The response carries the same dates
 * the in-app view shows, and `skip_reason` says why no mail went out when none did, rather
 * than leaving a count of zero to read as a failure.
 */
export const orgBoardOrgSendBoardMinutesReminderMutation = (options?: Partial<Options<OrgBoardOrgSendBoardMinutesReminderData>>): UseMutationOptions<OrgBoardOrgSendBoardMinutesReminderResponse, OrgBoardOrgSendBoardMinutesReminderError, Options<OrgBoardOrgSendBoardMinutesReminderData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSendBoardMinutesReminderResponse, OrgBoardOrgSendBoardMinutesReminderError, Options<OrgBoardOrgSendBoardMinutesReminderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSendBoardMinutesReminder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Sign Board Minutes On Behalf
 *
 * Record a signature someone on the roster gave on paper.
 *
 * The manual path, and it stays valid forever: nothing about the board's ability to record
 * its own minutes depends on a director adopting the portal. The entry records that the
 * officer wrote it down, never that the person acted inside their own session, and it
 * carries a required note saying where the signature came from.
 *
 * `capacity_title_id` (optional) records the title they signed as: one of the titles that seat
 * holds now, kept with the signature in the words it has today, so a later rename never changes
 * it. A title the seat doesn't hold is a 409 `board_signature_capacity_not_held`.
 */
export const orgBoardOrgSignBoardMinutesOnBehalfMutation = (options?: Partial<Options<OrgBoardOrgSignBoardMinutesOnBehalfData>>): UseMutationOptions<OrgBoardOrgSignBoardMinutesOnBehalfResponse, OrgBoardOrgSignBoardMinutesOnBehalfError, Options<OrgBoardOrgSignBoardMinutesOnBehalfData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSignBoardMinutesOnBehalfResponse, OrgBoardOrgSignBoardMinutesOnBehalfError, Options<OrgBoardOrgSignBoardMinutesOnBehalfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSignBoardMinutesOnBehalf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardMotionsQueryKey = (options: Options<OrgBoardOrgListBoardMotionsData>) => createQueryKey('org-board-org_list_board_motions', options);

/**
 * Org List Board Motions
 *
 * One meeting's motions, in order, as this reader may see them.
 *
 * A motion made inside a closed session this reader was not part of does not appear.
 */
export const orgBoardOrgListBoardMotionsOptions = (options: Options<OrgBoardOrgListBoardMotionsData>) => queryOptions<OrgBoardOrgListBoardMotionsResponse, OrgBoardOrgListBoardMotionsError, OrgBoardOrgListBoardMotionsResponse, ReturnType<typeof orgBoardOrgListBoardMotionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMotions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMotionsQueryKey(options)
});

/**
 * Org Create Board Motion
 *
 * Record a motion as put — its exact wording, who moved it, and who seconded it.
 *
 * An amendment names the motion it amends, so the board's own drafting history stays
 * walkable. The wording stays editable until a vote is recorded and is frozen from then on.
 */
export const orgBoardOrgCreateBoardMotionMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardMotionData>>): UseMutationOptions<OrgBoardOrgCreateBoardMotionResponse, OrgBoardOrgCreateBoardMotionError, Options<OrgBoardOrgCreateBoardMotionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardMotionResponse, OrgBoardOrgCreateBoardMotionError, Options<OrgBoardOrgCreateBoardMotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardMotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Motion
 *
 * Remove a motion recorded in error, while no vote on it has been recorded.
 */
export const orgBoardOrgDeleteBoardMotionMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardMotionData>>): UseMutationOptions<OrgBoardOrgDeleteBoardMotionResponse, OrgBoardOrgDeleteBoardMotionError, Options<OrgBoardOrgDeleteBoardMotionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardMotionResponse, OrgBoardOrgDeleteBoardMotionError, Options<OrgBoardOrgDeleteBoardMotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardMotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Update Board Motion
 *
 * Edit a motion recorded in error, before a vote on it is recorded.
 */
export const orgBoardOrgUpdateBoardMotionMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardMotionData>>): UseMutationOptions<OrgBoardOrgUpdateBoardMotionResponse, OrgBoardOrgUpdateBoardMotionError, Options<OrgBoardOrgUpdateBoardMotionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardMotionResponse, OrgBoardOrgUpdateBoardMotionError, Options<OrgBoardOrgUpdateBoardMotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardMotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Add Board Motion Compensation Decision
 *
 * Record the board's compensation decision for one person on a motion it carried, after the
 * motion's others: whose pay, their position, the meeting's papers the board relied on, how it
 * obtained them, and its reason when it set pay outside the range in that information. Board
 * reads each paper's stored bytes and records its fingerprint. Refused once the meeting's
 * minutes are approved.
 */
export const orgBoardOrgAddBoardMotionCompensationDecisionMutation = (options?: Partial<Options<OrgBoardOrgAddBoardMotionCompensationDecisionData>>): UseMutationOptions<OrgBoardOrgAddBoardMotionCompensationDecisionResponse, OrgBoardOrgAddBoardMotionCompensationDecisionError, Options<OrgBoardOrgAddBoardMotionCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAddBoardMotionCompensationDecisionResponse, OrgBoardOrgAddBoardMotionCompensationDecisionError, Options<OrgBoardOrgAddBoardMotionCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAddBoardMotionCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Board Motion Compensation Decision
 *
 * Remove one decision recorded on a motion, while the meeting's record is open. Its history
 * keeps who recorded and removed it, and when.
 */
export const orgBoardOrgRemoveBoardMotionCompensationDecisionMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardMotionCompensationDecisionData>>): UseMutationOptions<OrgBoardOrgRemoveBoardMotionCompensationDecisionResponse, OrgBoardOrgRemoveBoardMotionCompensationDecisionError, Options<OrgBoardOrgRemoveBoardMotionCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardMotionCompensationDecisionResponse, OrgBoardOrgRemoveBoardMotionCompensationDecisionError, Options<OrgBoardOrgRemoveBoardMotionCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardMotionCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Replace Board Motion Compensation Decision
 *
 * Replace one decision's details whole, while the meeting's record is open. A paper it keeps
 * keeps the fingerprint it was recorded with. Minutes drafted before the change name the old
 * details until they are refreshed.
 */
export const orgBoardOrgReplaceBoardMotionCompensationDecisionMutation = (options?: Partial<Options<OrgBoardOrgReplaceBoardMotionCompensationDecisionData>>): UseMutationOptions<OrgBoardOrgReplaceBoardMotionCompensationDecisionResponse, OrgBoardOrgReplaceBoardMotionCompensationDecisionError, Options<OrgBoardOrgReplaceBoardMotionCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReplaceBoardMotionCompensationDecisionResponse, OrgBoardOrgReplaceBoardMotionCompensationDecisionError, Options<OrgBoardOrgReplaceBoardMotionCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReplaceBoardMotionCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Minutes Approval Vote
 *
 * Record the vote on a motion that approves prior minutes.
 *
 * Its own route because a carried vote here does something the ordinary one never does: it
 * turns a draft into the charity's record. The minutes then name the seat the charity
 * recorded as presiding as the person whose declaration concluded the board's approval,
 * the instant, and the exact bytes approved.
 *
 * A vote recorded as failed is recorded exactly that way and the minutes stay a draft — the
 * board declined to approve them, which is itself something the book should say.
 */
export const orgBoardOrgRecordBoardMinutesApprovalVoteMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardMinutesApprovalVoteData>>): UseMutationOptions<OrgBoardOrgRecordBoardMinutesApprovalVoteResponse, OrgBoardOrgRecordBoardMinutesApprovalVoteError, Options<OrgBoardOrgRecordBoardMinutesApprovalVoteData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardMinutesApprovalVoteResponse, OrgBoardOrgRecordBoardMinutesApprovalVoteError, Options<OrgBoardOrgRecordBoardMinutesApprovalVoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardMinutesApprovalVote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Motion Recusal
 *
 * Record a seat as having stood out of the debate and the vote on one motion.
 *
 * Two things follow, and the second is the one boards most often get wrong. The seat's
 * vote becomes uncastable — recording one is refused. And the seat STILL counts among the
 * seats recorded as present, because standing out of a vote is not leaving the room; under
 * Delaware General Corporation Law section 144(d)(1) an interested director is counted for
 * that purpose, and dropping them would tell a board it had lost the seats it needed to act
 * every time someone was conflicted.
 */
export const orgBoardOrgRecordBoardMotionRecusalMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardMotionRecusalData>>): UseMutationOptions<OrgBoardOrgRecordBoardMotionRecusalResponse, OrgBoardOrgRecordBoardMotionRecusalError, Options<OrgBoardOrgRecordBoardMotionRecusalData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardMotionRecusalResponse, OrgBoardOrgRecordBoardMotionRecusalError, Options<OrgBoardOrgRecordBoardMotionRecusalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardMotionRecusal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Board Motion Recusal
 *
 * Remove a recusal recorded in error, before a vote on the motion is recorded.
 */
export const orgBoardOrgRemoveBoardMotionRecusalMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardMotionRecusalData>>): UseMutationOptions<OrgBoardOrgRemoveBoardMotionRecusalResponse, OrgBoardOrgRemoveBoardMotionRecusalError, Options<OrgBoardOrgRemoveBoardMotionRecusalData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardMotionRecusalResponse, OrgBoardOrgRemoveBoardMotionRecusalError, Options<OrgBoardOrgRemoveBoardMotionRecusalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardMotionRecusal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Motion Vote
 *
 * Record the vote on a motion.
 *
 * Two ways to record it, and both are first class: name each seat's own cast, or give the
 * three counts. With the casts recorded the counts are taken from them, so the two can
 * never disagree.
 *
 * The response carries the quorum figures captured at the instant of the vote — how many
 * of the board's seats were recorded as present, against the quorum the charity itself
 * recorded, with the section of its own governing instrument that number came from. A
 * shortfall is stated in seats and never blocks: the board owns its own acts.
 *
 * `outcome` is what the charity records. The module states the tally beside the recorded
 * threshold; whether a motion carried is the chair's declaration.
 *
 * A motion that approves prior minutes is refused here and belongs on the minutes-approval
 * route, which requires the authority to record the charity's own minute book.
 */
export const orgBoardOrgRecordBoardMotionVoteMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardMotionVoteData>>): UseMutationOptions<OrgBoardOrgRecordBoardMotionVoteResponse, OrgBoardOrgRecordBoardMotionVoteError, Options<OrgBoardOrgRecordBoardMotionVoteData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardMotionVoteResponse, OrgBoardOrgRecordBoardMotionVoteError, Options<OrgBoardOrgRecordBoardMotionVoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardMotionVote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Withdraw Board Motion
 *
 * Record a motion as withdrawn before it was voted on.
 *
 * Recorded rather than deleted: withdrawing is a real thing the board did. It also takes
 * the motion out of the carry-forward list, which reports only what is still open.
 */
export const orgBoardOrgWithdrawBoardMotionMutation = (options?: Partial<Options<OrgBoardOrgWithdrawBoardMotionData>>): UseMutationOptions<OrgBoardOrgWithdrawBoardMotionResponse, OrgBoardOrgWithdrawBoardMotionError, Options<OrgBoardOrgWithdrawBoardMotionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgWithdrawBoardMotionResponse, OrgBoardOrgWithdrawBoardMotionError, Options<OrgBoardOrgWithdrawBoardMotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgWithdrawBoardMotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardPacketsQueryKey = (options: Options<OrgBoardOrgListBoardPacketsData>) => createQueryKey('org-board-org_list_board_packets', options);

/**
 * Org List Board Packets
 *
 * A meeting's packet versions, newest first. Contents are not hydrated here.
 */
export const orgBoardOrgListBoardPacketsOptions = (options: Options<OrgBoardOrgListBoardPacketsData>) => queryOptions<OrgBoardOrgListBoardPacketsResponse, OrgBoardOrgListBoardPacketsError, OrgBoardOrgListBoardPacketsResponse, ReturnType<typeof orgBoardOrgListBoardPacketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardPackets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardPacketsQueryKey(options)
});

/**
 * Org Create Board Packet
 *
 * Open the next draft packet version for a meeting.
 *
 * The version number is assigned by the module. At most one draft is in flight at a
 * time: two drafts for one meeting are two people assembling different packets with no
 * way to say which is next.
 */
export const orgBoardOrgCreateBoardPacketMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardPacketData>>): UseMutationOptions<OrgBoardOrgCreateBoardPacketResponse, OrgBoardOrgCreateBoardPacketError, Options<OrgBoardOrgCreateBoardPacketData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardPacketResponse, OrgBoardOrgCreateBoardPacketError, Options<OrgBoardOrgCreateBoardPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardMeetingPresidingQueryKey = (options: Options<OrgBoardOrgGetBoardMeetingPresidingData>) => createQueryKey('org-board-org_get_board_meeting_presiding', options);

/**
 * Org Get Board Meeting Presiding
 *
 * Who presided at the meeting, the people recorded as present (each as the minutes would
 * name them presiding), and whom the board's adopted duties suggest: the person present who held,
 * on the meeting's day, a title the duties give presiding. Nothing is recorded by reading it.
 */
export const orgBoardOrgGetBoardMeetingPresidingOptions = (options: Options<OrgBoardOrgGetBoardMeetingPresidingData>) => queryOptions<OrgBoardOrgGetBoardMeetingPresidingResponse, OrgBoardOrgGetBoardMeetingPresidingError, OrgBoardOrgGetBoardMeetingPresidingResponse, ReturnType<typeof orgBoardOrgGetBoardMeetingPresidingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardMeetingPresiding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardMeetingPresidingQueryKey(options)
});

/**
 * Org Record Board Meeting Presiding
 *
 * Record who presided at the meeting, or clear it with a null.
 *
 * A recorded fact, the officer's entry in "Who was there": one of the people recorded as present,
 * never derived from a title. At most one person presides per meeting, and only someone recorded
 * as present — both held by the database. Answers the meeting's attendance rows as they now
 * stand, the presiding person's carrying `presided: true`.
 */
export const orgBoardOrgRecordBoardMeetingPresidingMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardMeetingPresidingData>>): UseMutationOptions<OrgBoardOrgRecordBoardMeetingPresidingResponse, OrgBoardOrgRecordBoardMeetingPresidingError, Options<OrgBoardOrgRecordBoardMeetingPresidingData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardMeetingPresidingResponse, OrgBoardOrgRecordBoardMeetingPresidingError, Options<OrgBoardOrgRecordBoardMeetingPresidingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardMeetingPresiding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardMeetingSegmentsQueryKey = (options: Options<OrgBoardOrgListBoardMeetingSegmentsData>) => createQueryKey('org-board-org_list_board_meeting_segments', options);

/**
 * Org List Board Meeting Segments
 *
 * The parts of one meeting, in order, as this reader may see them.
 *
 * A closed session this reader was not part of does not appear, and no ordinal is carried
 * on the wire — an index on a list that may have had entries withheld would count them.
 */
export const orgBoardOrgListBoardMeetingSegmentsOptions = (options: Options<OrgBoardOrgListBoardMeetingSegmentsData>) => queryOptions<OrgBoardOrgListBoardMeetingSegmentsResponse, OrgBoardOrgListBoardMeetingSegmentsError, OrgBoardOrgListBoardMeetingSegmentsResponse, ReturnType<typeof orgBoardOrgListBoardMeetingSegmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMeetingSegments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMeetingSegmentsQueryKey(options)
});

/**
 * Org Create Board Meeting Segment
 *
 * Record a part of a meeting — an ordinary session, or an executive session.
 *
 * An executive session carries its own participant list, and everything recorded inside it
 * is readable only by those participants. That binds charity admins as well as directors:
 * an administrator who was not in the room does not see it, and it is ABSENT for them
 * rather than refused.
 */
export const orgBoardOrgCreateBoardMeetingSegmentMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardMeetingSegmentData>>): UseMutationOptions<OrgBoardOrgCreateBoardMeetingSegmentResponse, OrgBoardOrgCreateBoardMeetingSegmentError, Options<OrgBoardOrgCreateBoardMeetingSegmentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardMeetingSegmentResponse, OrgBoardOrgCreateBoardMeetingSegmentError, Options<OrgBoardOrgCreateBoardMeetingSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardMeetingSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Reorder Board Meeting Segments
 *
 * Reorder a meeting's sessions by naming every one once, in the order wanted.
 */
export const orgBoardOrgReorderBoardMeetingSegmentsMutation = (options?: Partial<Options<OrgBoardOrgReorderBoardMeetingSegmentsData>>): UseMutationOptions<OrgBoardOrgReorderBoardMeetingSegmentsResponse, OrgBoardOrgReorderBoardMeetingSegmentsError, Options<OrgBoardOrgReorderBoardMeetingSegmentsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReorderBoardMeetingSegmentsResponse, OrgBoardOrgReorderBoardMeetingSegmentsError, Options<OrgBoardOrgReorderBoardMeetingSegmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReorderBoardMeetingSegments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Meeting Segment
 *
 * Remove a session recorded in error, while the minutes are still a draft.
 */
export const orgBoardOrgDeleteBoardMeetingSegmentMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardMeetingSegmentData>>): UseMutationOptions<OrgBoardOrgDeleteBoardMeetingSegmentResponse, OrgBoardOrgDeleteBoardMeetingSegmentError, Options<OrgBoardOrgDeleteBoardMeetingSegmentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardMeetingSegmentResponse, OrgBoardOrgDeleteBoardMeetingSegmentError, Options<OrgBoardOrgDeleteBoardMeetingSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardMeetingSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Update Board Meeting Segment
 *
 * Edit a recorded session.
 *
 * Which KIND of session it is cannot be changed here or anywhere: that would change who may
 * read everything recorded inside it, and a field flip is how a closed session gets
 * published by accident.
 */
export const orgBoardOrgUpdateBoardMeetingSegmentMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardMeetingSegmentData>>): UseMutationOptions<OrgBoardOrgUpdateBoardMeetingSegmentResponse, OrgBoardOrgUpdateBoardMeetingSegmentError, Options<OrgBoardOrgUpdateBoardMeetingSegmentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardMeetingSegmentResponse, OrgBoardOrgUpdateBoardMeetingSegmentError, Options<OrgBoardOrgUpdateBoardMeetingSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardMeetingSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Segment Participant
 *
 * Record one person as present for a session — a seat on this board, or someone else.
 *
 * A non-director the board invited in is named outright, because the point of a closed
 * session's list is who was in the room. A seat's name is taken from the roster and stored
 * as it stood then, so a later rename does not change what this says about that evening.
 */
export const orgBoardOrgRecordBoardSegmentParticipantMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardSegmentParticipantData>>): UseMutationOptions<OrgBoardOrgRecordBoardSegmentParticipantResponse, OrgBoardOrgRecordBoardSegmentParticipantError, Options<OrgBoardOrgRecordBoardSegmentParticipantData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardSegmentParticipantResponse, OrgBoardOrgRecordBoardSegmentParticipantError, Options<OrgBoardOrgRecordBoardSegmentParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardSegmentParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Board Segment Participant
 *
 * Remove someone recorded in error, while the minutes are still a draft.
 */
export const orgBoardOrgRemoveBoardSegmentParticipantMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardSegmentParticipantData>>): UseMutationOptions<OrgBoardOrgRemoveBoardSegmentParticipantResponse, OrgBoardOrgRemoveBoardSegmentParticipantError, Options<OrgBoardOrgRemoveBoardSegmentParticipantData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardSegmentParticipantResponse, OrgBoardOrgRemoveBoardSegmentParticipantError, Options<OrgBoardOrgRemoveBoardSegmentParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardSegmentParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardTermSuggestionsQueryKey = (options: Options<OrgBoardOrgGetBoardTermSuggestionsData>) => createQueryKey('org-board-org_get_board_term_suggestions', options);

/**
 * Org Get Board Term Suggestions
 *
 * On a meeting typed annual, the terms on the roster that have ended, or end within three
 * months of the meeting: directors by their current term's recorded end, officers by their
 * title's recorded end (or, when the board recorded its officers' term length, the end it gives).
 * Worked out each time it is read; nothing here is stored but a dismissal, and nothing is added
 * to the agenda until someone adds it. On any other meeting, `offered` is false and the lists
 * are empty.
 */
export const orgBoardOrgGetBoardTermSuggestionsOptions = (options: Options<OrgBoardOrgGetBoardTermSuggestionsData>) => queryOptions<OrgBoardOrgGetBoardTermSuggestionsResponse, OrgBoardOrgGetBoardTermSuggestionsError, OrgBoardOrgGetBoardTermSuggestionsResponse, ReturnType<typeof orgBoardOrgGetBoardTermSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardTermSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardTermSuggestionsQueryKey(options)
});

/**
 * Org Restore Board Term Suggestion
 *
 * Bring the annual meeting's election suggestion back after it was put away.
 */
export const orgBoardOrgRestoreBoardTermSuggestionMutation = (options?: Partial<Options<OrgBoardOrgRestoreBoardTermSuggestionData>>): UseMutationOptions<OrgBoardOrgRestoreBoardTermSuggestionResponse, OrgBoardOrgRestoreBoardTermSuggestionError, Options<OrgBoardOrgRestoreBoardTermSuggestionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRestoreBoardTermSuggestionResponse, OrgBoardOrgRestoreBoardTermSuggestionError, Options<OrgBoardOrgRestoreBoardTermSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRestoreBoardTermSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Dismiss Board Term Suggestion
 *
 * Put the annual meeting's election suggestion away for this meeting ("Not for this
 * meeting"), recording who and when. It can be brought back.
 */
export const orgBoardOrgDismissBoardTermSuggestionMutation = (options?: Partial<Options<OrgBoardOrgDismissBoardTermSuggestionData>>): UseMutationOptions<OrgBoardOrgDismissBoardTermSuggestionResponse, OrgBoardOrgDismissBoardTermSuggestionError, Options<OrgBoardOrgDismissBoardTermSuggestionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDismissBoardTermSuggestionResponse, OrgBoardOrgDismissBoardTermSuggestionError, Options<OrgBoardOrgDismissBoardTermSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDismissBoardTermSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardMemberProposalsQueryKey = (options: Options<OrgBoardOrgListBoardMemberProposalsData>) => createQueryKey('org-board-org_list_board_member_proposals', options);

/**
 * Org List Board Member Proposals
 *
 * The board members a connected AI proposed that wait for a person to add or discard them,
 * oldest first: each one's details as proposed, the AI's note on where it found them, and whose
 * connection proposed them. None of them is on the board until a person adds them.
 */
export const orgBoardOrgListBoardMemberProposalsOptions = (options: Options<OrgBoardOrgListBoardMemberProposalsData>) => queryOptions<OrgBoardOrgListBoardMemberProposalsResponse, OrgBoardOrgListBoardMemberProposalsError, OrgBoardOrgListBoardMemberProposalsResponse, ReturnType<typeof orgBoardOrgListBoardMemberProposalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMemberProposals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMemberProposalsQueryKey(options)
});

/**
 * Org Discard Board Member Proposal
 *
 * Discard a proposed board member. Nobody is added, and the proposal keeps no name or
 * address. A person's act: a connected AI cannot discard one.
 */
export const orgBoardOrgDiscardBoardMemberProposalMutation = (options?: Partial<Options<OrgBoardOrgDiscardBoardMemberProposalData>>): UseMutationOptions<OrgBoardOrgDiscardBoardMemberProposalResponse, OrgBoardOrgDiscardBoardMemberProposalError, Options<OrgBoardOrgDiscardBoardMemberProposalData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDiscardBoardMemberProposalResponse, OrgBoardOrgDiscardBoardMemberProposalError, Options<OrgBoardOrgDiscardBoardMemberProposalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDiscardBoardMemberProposal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardMembersQueryKey = (options: Options<OrgBoardOrgListBoardMembersData>) => createQueryKey('org-board-org_list_board_members', options);

/**
 * Org List Board Members
 *
 * The charity's board roster, newest first.
 *
 * Active seats only unless `include_removed` is set: the ordinary question is who is on
 * the board, and roster history — which is never deleted — is opt-in.
 */
export const orgBoardOrgListBoardMembersOptions = (options: Options<OrgBoardOrgListBoardMembersData>) => queryOptions<OrgBoardOrgListBoardMembersResponse, OrgBoardOrgListBoardMembersError, OrgBoardOrgListBoardMembersResponse, ReturnType<typeof orgBoardOrgListBoardMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMembersQueryKey(options)
});

/**
 * Org Create Board Member
 *
 * Add a seat to the roster.
 *
 * A seat is created from a name and an email of record — nothing else, and nothing about
 * a Givmo account. A director may sit on this roster, receive packets, and have acts
 * recorded on their behalf without ever signing in; their own Givmo account connects to
 * the seat later, through an invitation and a proof of the mailbox, or never.
 */
export const orgBoardOrgCreateBoardMemberMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardMemberData>>): UseMutationOptions<OrgBoardOrgCreateBoardMemberResponse, OrgBoardOrgCreateBoardMemberError, Options<OrgBoardOrgCreateBoardMemberData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardMemberResponse, OrgBoardOrgCreateBoardMemberError, Options<OrgBoardOrgCreateBoardMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardMemberQueryKey = (options: Options<OrgBoardOrgGetBoardMemberData>) => createQueryKey('org-board-org_get_board_member', options);

/**
 * Org Get Board Member
 *
 * Twin of ``get_board_member``.
 */
export const orgBoardOrgGetBoardMemberOptions = (options: Options<OrgBoardOrgGetBoardMemberData>) => queryOptions<OrgBoardOrgGetBoardMemberResponse, OrgBoardOrgGetBoardMemberError, OrgBoardOrgGetBoardMemberResponse, ReturnType<typeof orgBoardOrgGetBoardMemberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardMember({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardMemberQueryKey(options)
});

/**
 * Org Update Board Member
 *
 * Edit a seat (skip-None partial update).
 *
 * Cannot end a seat — that is its own operation, because it kills live credentials and a
 * spelling fix should not travel on the same route.
 */
export const orgBoardOrgUpdateBoardMemberMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardMemberData>>): UseMutationOptions<OrgBoardOrgUpdateBoardMemberResponse, OrgBoardOrgUpdateBoardMemberError, Options<OrgBoardOrgUpdateBoardMemberData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardMemberResponse, OrgBoardOrgUpdateBoardMemberError, Options<OrgBoardOrgUpdateBoardMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Mint Board Access Link
 *
 * Mint a director's invitation link, and mail it when the module can.
 *
 * The response carries the PLAINTEXT token — the one place it ever appears in one. That
 * is a real product path, not a fallback: the recording officer hands a director their
 * link directly (reads it out, pastes it into their own message, prints it), and a module
 * that only ever emailed links would make the volunteer's actual route in impossible. It
 * is safe to hand over: the link only lets the director join with their own Givmo account
 * and their own mailbox. The stored row keeps only the token's digest. A seat whose director
 * has already joined is refused (`board_seat_already_connected`).
 *
 * `email_sent` reports whether a mail also went out. It is false when no template or no
 * board-app base URL is configured, so the caller is told what happened rather than left
 * to assume.
 */
export const orgBoardOrgMintBoardAccessLinkMutation = (options?: Partial<Options<OrgBoardOrgMintBoardAccessLinkData>>): UseMutationOptions<OrgBoardOrgMintBoardAccessLinkResponse, OrgBoardOrgMintBoardAccessLinkError, Options<OrgBoardOrgMintBoardAccessLinkData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgMintBoardAccessLinkResponse, OrgBoardOrgMintBoardAccessLinkError, Options<OrgBoardOrgMintBoardAccessLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgMintBoardAccessLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Release Board Member Account
 *
 * Disconnect the Givmo account that joined the board through this seat, with a recorded
 * reason.
 *
 * The seat stays on the roster and can be invited and joined again; the account's next
 * request as a director is refused. Both the account's own email and the seat's address are
 * told. Changing a seat's email address never disconnects its account — this does, and only
 * this. A seat no account has joined is refused (`board_seat_not_connected`).
 */
export const orgBoardOrgReleaseBoardMemberAccountMutation = (options?: Partial<Options<OrgBoardOrgReleaseBoardMemberAccountData>>): UseMutationOptions<OrgBoardOrgReleaseBoardMemberAccountResponse, OrgBoardOrgReleaseBoardMemberAccountError, Options<OrgBoardOrgReleaseBoardMemberAccountData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReleaseBoardMemberAccountResponse, OrgBoardOrgReleaseBoardMemberAccountError, Options<OrgBoardOrgReleaseBoardMemberAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReleaseBoardMemberAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Paper Acknowledgments
 *
 * Record a signed paper form: that this member signed a paper acknowledgment of these
 * documents, on the date written on it, with a note on where it came from. Each document is
 * recorded as acknowledged, exactly the version named, as entered by you from a paper form.
 */
export const orgBoardOrgRecordBoardPaperAcknowledgmentsMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardPaperAcknowledgmentsData>>): UseMutationOptions<OrgBoardOrgRecordBoardPaperAcknowledgmentsResponse, OrgBoardOrgRecordBoardPaperAcknowledgmentsError, Options<OrgBoardOrgRecordBoardPaperAcknowledgmentsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardPaperAcknowledgmentsResponse, OrgBoardOrgRecordBoardPaperAcknowledgmentsError, Options<OrgBoardOrgRecordBoardPaperAcknowledgmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardPaperAcknowledgments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Add Board Member To Board
 *
 * Add someone who serves on a committee to the board (CBG-YR6-OUTSIDE-WIDEN): their seat,
 * one for someone who isn't on the board, becomes the board's.
 *
 * The Owner's act, its own operation, as ending a seat is: from the next request the board's
 * meetings, papers, minutes and written consents are open to the seat's account, earlier ones
 * included, and the board's year counts the person as joining today. Nothing else about the seat
 * changes — whether they're a director, and any title, are recorded afterwards — and it can't be
 * undone: a board seat never becomes a committee's alone. No body. A seat someone has joined is
 * emailed to say so.
 */
export const orgBoardOrgAddBoardMemberToBoardMutation = (options?: Partial<Options<OrgBoardOrgAddBoardMemberToBoardData>>): UseMutationOptions<OrgBoardOrgAddBoardMemberToBoardResponse, OrgBoardOrgAddBoardMemberToBoardError, Options<OrgBoardOrgAddBoardMemberToBoardData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAddBoardMemberToBoardResponse, OrgBoardOrgAddBoardMemberToBoardError, Options<OrgBoardOrgAddBoardMemberToBoardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAddBoardMemberToBoard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardMemberGettingStartedQueryKey = (options: Options<OrgBoardOrgGetBoardMemberGettingStartedData>) => createQueryKey('org-board-org_get_board_member_getting_started', options);

/**
 * Org Get Board Member Getting Started
 *
 * A member's getting-started list, each item with what the records say about it: a document
 * confirmed (in Board, from a paper form, or in their annual disclosure) or not yet, their first
 * disclosure, their board buddy, the board's own steps.
 */
export const orgBoardOrgGetBoardMemberGettingStartedOptions = (options: Options<OrgBoardOrgGetBoardMemberGettingStartedData>) => queryOptions<OrgBoardOrgGetBoardMemberGettingStartedResponse, OrgBoardOrgGetBoardMemberGettingStartedError, OrgBoardOrgGetBoardMemberGettingStartedResponse, ReturnType<typeof orgBoardOrgGetBoardMemberGettingStartedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardMemberGettingStarted({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardMemberGettingStartedQueryKey(options)
});

/**
 * Org Start Board Member Getting Started
 *
 * Start a getting-started list for a member who has none, from the board's list.
 */
export const orgBoardOrgStartBoardMemberGettingStartedMutation = (options?: Partial<Options<OrgBoardOrgStartBoardMemberGettingStartedData>>): UseMutationOptions<OrgBoardOrgStartBoardMemberGettingStartedResponse, OrgBoardOrgStartBoardMemberGettingStartedError, Options<OrgBoardOrgStartBoardMemberGettingStartedData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgStartBoardMemberGettingStartedResponse, OrgBoardOrgStartBoardMemberGettingStartedError, Options<OrgBoardOrgStartBoardMemberGettingStartedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgStartBoardMemberGettingStarted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Save Board Member Getting Started
 *
 * Change one member's list from the revision you read: an item sent with its id stays (a
 * step keeps its done date), one without is added, one left out is removed.
 */
export const orgBoardOrgSaveBoardMemberGettingStartedMutation = (options?: Partial<Options<OrgBoardOrgSaveBoardMemberGettingStartedData>>): UseMutationOptions<OrgBoardOrgSaveBoardMemberGettingStartedResponse, OrgBoardOrgSaveBoardMemberGettingStartedError, Options<OrgBoardOrgSaveBoardMemberGettingStartedData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSaveBoardMemberGettingStartedResponse, OrgBoardOrgSaveBoardMemberGettingStartedError, Options<OrgBoardOrgSaveBoardMemberGettingStartedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSaveBoardMemberGettingStarted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Choose Board Member Buddy
 *
 * Choose a member's board buddy: someone serving on the board. It's recorded on the member's
 * history; the buddy is sent nothing and asked to do nothing.
 */
export const orgBoardOrgChooseBoardMemberBuddyMutation = (options?: Partial<Options<OrgBoardOrgChooseBoardMemberBuddyData>>): UseMutationOptions<OrgBoardOrgChooseBoardMemberBuddyResponse, OrgBoardOrgChooseBoardMemberBuddyError, Options<OrgBoardOrgChooseBoardMemberBuddyData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgChooseBoardMemberBuddyResponse, OrgBoardOrgChooseBoardMemberBuddyError, Options<OrgBoardOrgChooseBoardMemberBuddyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgChooseBoardMemberBuddy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Close Board Member Getting Started
 *
 * Close a member's list — for someone who left, or a list the board considers done. It can't
 * be reopened.
 */
export const orgBoardOrgCloseBoardMemberGettingStartedMutation = (options?: Partial<Options<OrgBoardOrgCloseBoardMemberGettingStartedData>>): UseMutationOptions<OrgBoardOrgCloseBoardMemberGettingStartedResponse, OrgBoardOrgCloseBoardMemberGettingStartedError, Options<OrgBoardOrgCloseBoardMemberGettingStartedData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCloseBoardMemberGettingStartedResponse, OrgBoardOrgCloseBoardMemberGettingStartedError, Options<OrgBoardOrgCloseBoardMemberGettingStartedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCloseBoardMemberGettingStarted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Mark Board Member Getting Started Step
 *
 * Mark one of the board's own steps done on a member's list, with the date, or clear it.
 */
export const orgBoardOrgMarkBoardMemberGettingStartedStepMutation = (options?: Partial<Options<OrgBoardOrgMarkBoardMemberGettingStartedStepData>>): UseMutationOptions<OrgBoardOrgMarkBoardMemberGettingStartedStepResponse, OrgBoardOrgMarkBoardMemberGettingStartedStepError, Options<OrgBoardOrgMarkBoardMemberGettingStartedStepData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgMarkBoardMemberGettingStartedStepResponse, OrgBoardOrgMarkBoardMemberGettingStartedStepError, Options<OrgBoardOrgMarkBoardMemberGettingStartedStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgMarkBoardMemberGettingStartedStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardMemberHistoryQueryKey = (options: Options<OrgBoardOrgListBoardMemberHistoryData>) => createQueryKey('org-board-org_list_board_member_history', options);

/**
 * Org List Board Member History
 *
 * One seat's history, newest first: when it was added and edited, every change to its
 * email address (the old and the new one), every invitation and whether it was emailed, who
 * joined with which Givmo account and how, any account disconnected and why, and the
 * removal. Each entry names who did it.
 *
 * Owner-only, because the entries carry a director's addresses. Readable for a removed
 * seat too.
 */
export const orgBoardOrgListBoardMemberHistoryOptions = (options: Options<OrgBoardOrgListBoardMemberHistoryData>) => queryOptions<OrgBoardOrgListBoardMemberHistoryResponse, OrgBoardOrgListBoardMemberHistoryError, OrgBoardOrgListBoardMemberHistoryResponse, ReturnType<typeof orgBoardOrgListBoardMemberHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardMemberHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardMemberHistoryQueryKey(options)
});

/**
 * Org Remove Board Member
 *
 * End a seat, with a recorded reason.
 *
 * Never a delete: the row and its history stay, because who sat on this board and when
 * is part of the charity's record and a former director's past acts must keep resolving
 * to a named seat. Every outstanding invitation of that seat dies with it, and the seat's
 * own standing is re-read on every director request — so removal takes effect on the
 * director's very next call.
 */
export const orgBoardOrgRemoveBoardMemberMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardMemberData>>): UseMutationOptions<OrgBoardOrgRemoveBoardMemberResponse, OrgBoardOrgRemoveBoardMemberError, Options<OrgBoardOrgRemoveBoardMemberData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardMemberResponse, OrgBoardOrgRemoveBoardMemberError, Options<OrgBoardOrgRemoveBoardMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Member Term
 *
 * Record a term of this seat: the organization's own start and end (at least one), its
 * class, whether the board counts it toward its limit on consecutive terms, the minute-book
 * record it came from (`record_id`) or none, and a note. Saved as entered: dates that overlap
 * another term, or run past the term length or the limit the board recorded, are recorded as
 * they are. A term changes no vote, quorum or written consent.
 */
export const orgBoardOrgRecordBoardMemberTermMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardMemberTermData>>): UseMutationOptions<OrgBoardOrgRecordBoardMemberTermResponse, OrgBoardOrgRecordBoardMemberTermError, Options<OrgBoardOrgRecordBoardMemberTermData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardMemberTermResponse, OrgBoardOrgRecordBoardMemberTermError, Options<OrgBoardOrgRecordBoardMemberTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardMemberTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Board Member Term
 *
 * Remove a term recorded in error, such as one recorded for the wrong person. The motion,
 * written consent or record it was linked to stays exactly as recorded; the seat's history
 * notes the change.
 */
export const orgBoardOrgRemoveBoardMemberTermMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardMemberTermData>>): UseMutationOptions<OrgBoardOrgRemoveBoardMemberTermResponse, OrgBoardOrgRemoveBoardMemberTermError, Options<OrgBoardOrgRemoveBoardMemberTermData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardMemberTermResponse, OrgBoardOrgRemoveBoardMemberTermError, Options<OrgBoardOrgRemoveBoardMemberTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardMemberTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Update Board Member Term
 *
 * Correct a term. Send only what changes: a field left out keeps its value, and `null`
 * clears a date, the class or the note. A term keeps at least one date (422
 * `board_member_term_undated`) and never ends before it starts (422
 * `board_member_term_dates_out_of_order`). The record it came from is never changed here.
 */
export const orgBoardOrgUpdateBoardMemberTermMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardMemberTermData>>): UseMutationOptions<OrgBoardOrgUpdateBoardMemberTermResponse, OrgBoardOrgUpdateBoardMemberTermError, Options<OrgBoardOrgUpdateBoardMemberTermData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardMemberTermResponse, OrgBoardOrgUpdateBoardMemberTermError, Options<OrgBoardOrgUpdateBoardMemberTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardMemberTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardOfficerDutiesQueryKey = (options: Options<OrgBoardOrgGetBoardOfficerDutiesData>) => createQueryKey('org-board-org_get_board_officer_duties', options);

/**
 * Org Get Board Officer Duties
 *
 * What each officer title does in Givmo: Board's own acts the board ties to its titles.
 *
 * `adopted` is the board's adoption in force, or null before the first — then `duties` is
 * Givmo's starting point, which does nothing until the board adopts it. `earlier` lists the
 * adoptions replaced since, newest first. A duty never decides who may act: it decides whom
 * Board asks to sign the minutes, and what a few dialogs suggest. Reading this never changes it.
 */
export const orgBoardOrgGetBoardOfficerDutiesOptions = (options: Options<OrgBoardOrgGetBoardOfficerDutiesData>) => queryOptions<OrgBoardOrgGetBoardOfficerDutiesResponse, OrgBoardOrgGetBoardOfficerDutiesError, OrgBoardOrgGetBoardOfficerDutiesResponse, ReturnType<typeof orgBoardOrgGetBoardOfficerDutiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardOfficerDuties({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardOfficerDutiesQueryKey(options)
});

/**
 * Org Adopt Board Officer Duties
 *
 * Adopt the board's duties — the first time, or to change them: the WHOLE set.
 *
 * Each duty names one of Board's own acts, the title that does it (its `id`, or for one of the
 * starting four nobody has used yet its `default_key`) and, optionally, where the board's own
 * documents say so. An act left out is not assigned to a title. Saving replaces the duties in
 * force; the earlier ones stay in the history. Sending the set already in force changes nothing.
 * A retired title is a 409 `board_officer_duty_title_retired`.
 */
export const orgBoardOrgAdoptBoardOfficerDutiesMutation = (options?: Partial<Options<OrgBoardOrgAdoptBoardOfficerDutiesData>>): UseMutationOptions<OrgBoardOrgAdoptBoardOfficerDutiesResponse, OrgBoardOrgAdoptBoardOfficerDutiesError, Options<OrgBoardOrgAdoptBoardOfficerDutiesData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAdoptBoardOfficerDutiesResponse, OrgBoardOrgAdoptBoardOfficerDutiesError, Options<OrgBoardOrgAdoptBoardOfficerDutiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAdoptBoardOfficerDuties({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardOfficerTitlesQueryKey = (options: Options<OrgBoardOrgListBoardOfficerTitlesData>) => createQueryKey('org-board-org_list_board_officer_titles', options);

/**
 * Org List Board Officer Titles
 *
 * The board's officer titles, in the board's order: Chair, Vice Chair, Secretary and
 * Treasurer to start with, as the board names them.
 *
 * A title with no `id` is one of the starting four that no member has been given yet; give it
 * to someone by its `default_key`. Reading this list never changes it. A title is a label: it
 * changes no vote, quorum or written consent.
 */
export const orgBoardOrgListBoardOfficerTitlesOptions = (options: Options<OrgBoardOrgListBoardOfficerTitlesData>) => queryOptions<OrgBoardOrgListBoardOfficerTitlesResponse, OrgBoardOrgListBoardOfficerTitlesError, OrgBoardOrgListBoardOfficerTitlesResponse, ReturnType<typeof orgBoardOrgListBoardOfficerTitlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardOfficerTitles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardOfficerTitlesQueryKey(options)
});

/**
 * Org Create Board Officer Title
 *
 * Add one of the board's own officer titles, last in the board's order.
 *
 * No two active titles share a name, whatever the case or spacing — one of the starting four the
 * board hasn't used yet included: that is a 409 `board_officer_title_name_taken`. A title is a
 * label: it changes no vote, quorum or written consent. Who holds it is set on each member.
 */
export const orgBoardOrgCreateBoardOfficerTitleMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardOfficerTitleData>>): UseMutationOptions<OrgBoardOrgCreateBoardOfficerTitleResponse, OrgBoardOrgCreateBoardOfficerTitleError, Options<OrgBoardOrgCreateBoardOfficerTitleData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardOfficerTitleResponse, OrgBoardOrgCreateBoardOfficerTitleError, Options<OrgBoardOrgCreateBoardOfficerTitleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardOfficerTitle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Update Board Officer Title
 *
 * Rename a title, move it in the board's order, or both.
 *
 * `title_ref` is the title's `id`, or — for one of the starting four that has no `id` yet — its
 * `default_key`. `position` is the title's place among the board's active titles, counting from
 * 1; past the last means last. Renaming changes the title's words everywhere they are shown; a
 * signature already recorded keeps the words it was made with. A retired title is neither
 * renamed nor moved (409 `board_officer_title_retired`); a name another active title has is a
 * 409 `board_officer_title_name_taken`.
 */
export const orgBoardOrgUpdateBoardOfficerTitleMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardOfficerTitleData>>): UseMutationOptions<OrgBoardOrgUpdateBoardOfficerTitleResponse, OrgBoardOrgUpdateBoardOfficerTitleError, Options<OrgBoardOrgUpdateBoardOfficerTitleData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardOfficerTitleResponse, OrgBoardOrgUpdateBoardOfficerTitleError, Options<OrgBoardOrgUpdateBoardOfficerTitleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardOfficerTitle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Retire Board Officer Title
 *
 * Retire a title the board no longer uses.
 *
 * A retired title is never deleted and never given to anyone new; it stays in the history of
 * everyone who held it. While anyone holds it, it can't be retired (409
 * `board_officer_title_held`): take it off them on their member pages first. `title_ref` is as
 * for renaming. Retiring a title already retired answers it as it is.
 */
export const orgBoardOrgRetireBoardOfficerTitleMutation = (options?: Partial<Options<OrgBoardOrgRetireBoardOfficerTitleData>>): UseMutationOptions<OrgBoardOrgRetireBoardOfficerTitleResponse, OrgBoardOrgRetireBoardOfficerTitleError, Options<OrgBoardOrgRetireBoardOfficerTitleData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRetireBoardOfficerTitleResponse, OrgBoardOrgRetireBoardOfficerTitleError, Options<OrgBoardOrgRetireBoardOfficerTitleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRetireBoardOfficerTitle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Discard Board Packet
 *
 * Discard a DRAFT packet version.
 *
 * A published version cannot be discarded — the board already has it, so the honest move
 * is to publish a further version.
 */
export const orgBoardOrgDiscardBoardPacketMutation = (options?: Partial<Options<OrgBoardOrgDiscardBoardPacketData>>): UseMutationOptions<OrgBoardOrgDiscardBoardPacketResponse, OrgBoardOrgDiscardBoardPacketError, Options<OrgBoardOrgDiscardBoardPacketData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDiscardBoardPacketResponse, OrgBoardOrgDiscardBoardPacketError, Options<OrgBoardOrgDiscardBoardPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDiscardBoardPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardPacketQueryKey = (options: Options<OrgBoardOrgGetBoardPacketData>) => createQueryKey('org-board-org_get_board_packet', options);

/**
 * Org Get Board Packet
 *
 * One packet version with its entries.
 *
 * An entry naming a minute-book record the caller may not read is ABSENT from the list —
 * including for an Owner who was not in a closed session. `ledger_financial_pack_available`
 * says whether the treasurer's pages can be generated from the charity's own ledger;
 * while it is false the treasurer's report is attached as an ordinary document.
 */
export const orgBoardOrgGetBoardPacketOptions = (options: Options<OrgBoardOrgGetBoardPacketData>) => queryOptions<OrgBoardOrgGetBoardPacketResponse, OrgBoardOrgGetBoardPacketError, OrgBoardOrgGetBoardPacketResponse, ReturnType<typeof orgBoardOrgGetBoardPacketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardPacket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardPacketQueryKey(options)
});

export const orgBoardOrgListBoardPacketCommentsQueryKey = (options: Options<OrgBoardOrgListBoardPacketCommentsData>) => createQueryKey('org-board-org_list_board_packet_comments', options);

/**
 * Org List Board Packet Comments
 *
 * Board-visible comments on one packet version.
 *
 * A director's private note is not reachable through this read at all. The filter takes
 * no role into account, so it binds every charity administrator including an Owner.
 */
export const orgBoardOrgListBoardPacketCommentsOptions = (options: Options<OrgBoardOrgListBoardPacketCommentsData>) => queryOptions<OrgBoardOrgListBoardPacketCommentsResponse, OrgBoardOrgListBoardPacketCommentsError, OrgBoardOrgListBoardPacketCommentsResponse, ReturnType<typeof orgBoardOrgListBoardPacketCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardPacketComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardPacketCommentsQueryKey(options)
});

/**
 * Org Record Board Packet Shared Comment
 *
 * Record a board-visible comment on a director's behalf.
 *
 * The manual path for a comment a director made by telephone or in person. There is
 * deliberately no equivalent for a director's PRIVATE note: entering one on someone's
 * behalf would mean having read it, so that combination does not exist here and is
 * refused by the database as well.
 */
export const orgBoardOrgRecordBoardPacketSharedCommentMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardPacketSharedCommentData>>): UseMutationOptions<OrgBoardOrgRecordBoardPacketSharedCommentResponse, OrgBoardOrgRecordBoardPacketSharedCommentError, Options<OrgBoardOrgRecordBoardPacketSharedCommentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardPacketSharedCommentResponse, OrgBoardOrgRecordBoardPacketSharedCommentError, Options<OrgBoardOrgRecordBoardPacketSharedCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardPacketSharedComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardPacketDistributionsQueryKey = (options: Options<OrgBoardOrgListBoardPacketDistributionsData>) => createQueryKey('org-board-org_list_board_packet_distributions', options);

/**
 * Org List Board Packet Distributions
 *
 * Who was sent one packet version. Its sibling read is who has opened it.
 */
export const orgBoardOrgListBoardPacketDistributionsOptions = (options: Options<OrgBoardOrgListBoardPacketDistributionsData>) => queryOptions<OrgBoardOrgListBoardPacketDistributionsResponse, OrgBoardOrgListBoardPacketDistributionsError, OrgBoardOrgListBoardPacketDistributionsResponse, ReturnType<typeof orgBoardOrgListBoardPacketDistributionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardPacketDistributions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardPacketDistributionsQueryKey(options)
});

/**
 * Org Distribute Board Packet
 *
 * Send a published packet version to every active seat on the roster.
 *
 * Each seat gets a fresh access link, so a director follows one link and lands in a
 * session rather than at a sign-in page they have no credentials for. The response
 * carries every seat's plaintext link, once — the recording officer hands a director
 * their link directly as often as the module mails it, and a product that only ever
 * emailed the link would make the volunteer's real route in impossible.
 *
 * `emails_sent` reports how many mails actually went out; with no template or no board
 * app base URL configured it is zero and each row records why, so the caller is told
 * what happened rather than left to assume.
 */
export const orgBoardOrgDistributeBoardPacketMutation = (options?: Partial<Options<OrgBoardOrgDistributeBoardPacketData>>): UseMutationOptions<OrgBoardOrgDistributeBoardPacketResponse, OrgBoardOrgDistributeBoardPacketError, Options<OrgBoardOrgDistributeBoardPacketData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDistributeBoardPacketResponse, OrgBoardOrgDistributeBoardPacketError, Options<OrgBoardOrgDistributeBoardPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDistributeBoardPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Reorder Board Packet Items
 *
 * Reorder a draft packet version by naming every entry once, in the order wanted.
 */
export const orgBoardOrgReorderBoardPacketItemsMutation = (options?: Partial<Options<OrgBoardOrgReorderBoardPacketItemsData>>): UseMutationOptions<OrgBoardOrgReorderBoardPacketItemsResponse, OrgBoardOrgReorderBoardPacketItemsError, Options<OrgBoardOrgReorderBoardPacketItemsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReorderBoardPacketItemsResponse, OrgBoardOrgReorderBoardPacketItemsError, Options<OrgBoardOrgReorderBoardPacketItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReorderBoardPacketItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Create Board Packet Item
 *
 * Add an entry to a draft packet version.
 *
 * A minute-book record can be placed only by someone who may read it: otherwise an
 * administrator who was not in a closed session could hand the whole board a pointer to
 * content the record store withholds from them.
 */
export const orgBoardOrgCreateBoardPacketItemMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardPacketItemData>>): UseMutationOptions<OrgBoardOrgCreateBoardPacketItemResponse, OrgBoardOrgCreateBoardPacketItemError, Options<OrgBoardOrgCreateBoardPacketItemData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardPacketItemResponse, OrgBoardOrgCreateBoardPacketItemError, Options<OrgBoardOrgCreateBoardPacketItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardPacketItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Packet Item
 *
 * Remove one entry from a draft packet version, closing the gap it leaves.
 */
export const orgBoardOrgDeleteBoardPacketItemMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardPacketItemData>>): UseMutationOptions<OrgBoardOrgDeleteBoardPacketItemResponse, OrgBoardOrgDeleteBoardPacketItemError, Options<OrgBoardOrgDeleteBoardPacketItemData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardPacketItemResponse, OrgBoardOrgDeleteBoardPacketItemError, Options<OrgBoardOrgDeleteBoardPacketItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardPacketItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Refresh Board Filing Snapshot
 *
 * Append a snapshot and repoint a still-draft fifth packet item.
 */
export const orgBoardOrgRefreshBoardFilingSnapshotMutation = (options?: Partial<Options<OrgBoardOrgRefreshBoardFilingSnapshotData>>): UseMutationOptions<OrgBoardOrgRefreshBoardFilingSnapshotResponse, OrgBoardOrgRefreshBoardFilingSnapshotError, Options<OrgBoardOrgRefreshBoardFilingSnapshotData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRefreshBoardFilingSnapshotResponse, OrgBoardOrgRefreshBoardFilingSnapshotError, Options<OrgBoardOrgRefreshBoardFilingSnapshotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRefreshBoardFilingSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Publish Board Packet
 *
 * Issue a draft packet version.
 *
 * The route is named for the thing it creates, not for a verb. From here the version's
 * contents are frozen: directors may already be reading it, and a change opens the next
 * version instead.
 */
export const orgBoardOrgPublishBoardPacketMutation = (options?: Partial<Options<OrgBoardOrgPublishBoardPacketData>>): UseMutationOptions<OrgBoardOrgPublishBoardPacketResponse, OrgBoardOrgPublishBoardPacketError, Options<OrgBoardOrgPublishBoardPacketData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgPublishBoardPacketResponse, OrgBoardOrgPublishBoardPacketError, Options<OrgBoardOrgPublishBoardPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgPublishBoardPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardPastRecordBatchesQueryKey = (options: Options<OrgBoardOrgListBoardPastRecordBatchesData>) => createQueryKey('org-board-org_list_board_past_record_batches', options);

/**
 * Org List Board Past Record Batches
 *
 * The batches of past records a connected AI proposed that wait for a person to confirm or
 * discard them: how many records each holds and how many have their file, and whose connection
 * proposed them. Nothing in them is in the minute book.
 */
export const orgBoardOrgListBoardPastRecordBatchesOptions = (options: Options<OrgBoardOrgListBoardPastRecordBatchesData>) => queryOptions<OrgBoardOrgListBoardPastRecordBatchesResponse, OrgBoardOrgListBoardPastRecordBatchesError, OrgBoardOrgListBoardPastRecordBatchesResponse, ReturnType<typeof orgBoardOrgListBoardPastRecordBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardPastRecordBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardPastRecordBatchesQueryKey(options)
});

export const orgBoardOrgGetBoardPastRecordBatchQueryKey = (options: Options<OrgBoardOrgGetBoardPastRecordBatchData>) => createQueryKey('org-board-org_get_board_past_record_batch', options);

/**
 * Org Get Board Past Record Batch
 *
 * One batch of proposed past records, each record in the order it was proposed, word for word
 * as it would go into the minute book, with its file's state. A batch already confirmed or
 * discarded answers its state (and the import batch it became) with no records.
 */
export const orgBoardOrgGetBoardPastRecordBatchOptions = (options: Options<OrgBoardOrgGetBoardPastRecordBatchData>) => queryOptions<OrgBoardOrgGetBoardPastRecordBatchResponse, OrgBoardOrgGetBoardPastRecordBatchError, OrgBoardOrgGetBoardPastRecordBatchResponse, ReturnType<typeof orgBoardOrgGetBoardPastRecordBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardPastRecordBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardPastRecordBatchQueryKey(options)
});

/**
 * Org Confirm Board Past Record Batch
 *
 * Import the proposed records into the minute book together, exactly as they are on their
 * page, with their files. All of them go in or none do. Echo the `revision` you read: if
 * anything changed since, nothing goes in. A `label` and a `source_description` are optional
 * (Board names the records' internal import batch from the connection that proposed them).
 * After this a record can't be changed or take a file. A person's act: a connected AI cannot
 * confirm them.
 */
export const orgBoardOrgConfirmBoardPastRecordBatchMutation = (options?: Partial<Options<OrgBoardOrgConfirmBoardPastRecordBatchData>>): UseMutationOptions<OrgBoardOrgConfirmBoardPastRecordBatchResponse, OrgBoardOrgConfirmBoardPastRecordBatchError, Options<OrgBoardOrgConfirmBoardPastRecordBatchData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgConfirmBoardPastRecordBatchResponse, OrgBoardOrgConfirmBoardPastRecordBatchError, Options<OrgBoardOrgConfirmBoardPastRecordBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgConfirmBoardPastRecordBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Discard Board Past Record Batch
 *
 * Discard a batch: nothing goes into the minute book, and its records' text and files are
 * deleted. Echo the batch's `revision`. A person's act.
 */
export const orgBoardOrgDiscardBoardPastRecordBatchMutation = (options?: Partial<Options<OrgBoardOrgDiscardBoardPastRecordBatchData>>): UseMutationOptions<OrgBoardOrgDiscardBoardPastRecordBatchResponse, OrgBoardOrgDiscardBoardPastRecordBatchError, Options<OrgBoardOrgDiscardBoardPastRecordBatchData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDiscardBoardPastRecordBatchResponse, OrgBoardOrgDiscardBoardPastRecordBatchError, Options<OrgBoardOrgDiscardBoardPastRecordBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDiscardBoardPastRecordBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Mark Board Past Record Confidentiality
 *
 * Mark one proposed record as a closed (executive) session's own record, or not, before the
 * records are confirmed: it imports as the mark says, a closed session's record as one recorded by
 * hand. Echo the batch's `revision`; the answer carries the batch's new one. A person's act.
 */
export const orgBoardOrgMarkBoardPastRecordConfidentialityMutation = (options?: Partial<Options<OrgBoardOrgMarkBoardPastRecordConfidentialityData>>): UseMutationOptions<OrgBoardOrgMarkBoardPastRecordConfidentialityResponse, OrgBoardOrgMarkBoardPastRecordConfidentialityError, Options<OrgBoardOrgMarkBoardPastRecordConfidentialityData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgMarkBoardPastRecordConfidentialityResponse, OrgBoardOrgMarkBoardPastRecordConfidentialityError, Options<OrgBoardOrgMarkBoardPastRecordConfidentialityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgMarkBoardPastRecordConfidentiality({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardProposalFileUrlQueryKey = (options: Options<OrgBoardOrgGetBoardProposalFileUrlData>) => createQueryKey('org-board-org_get_board_proposal_file_url', options);

/**
 * Org Get Board Proposal File Url
 *
 * A short-lived link that downloads a proposed record's file, as Board checked it.
 */
export const orgBoardOrgGetBoardProposalFileUrlOptions = (options: Options<OrgBoardOrgGetBoardProposalFileUrlData>) => queryOptions<OrgBoardOrgGetBoardProposalFileUrlResponse, OrgBoardOrgGetBoardProposalFileUrlError, OrgBoardOrgGetBoardProposalFileUrlResponse, ReturnType<typeof orgBoardOrgGetBoardProposalFileUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardProposalFileUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardProposalFileUrlQueryKey(options)
});

/**
 * Org Check Board Proposal File
 *
 * Ask Board to check a proposed record's file. With the `object_ref` an upload URL named and
 * the file's name and type, the file you added: if Board's check passes it becomes the record's
 * file; if not, the answer says why and the upload is deleted. Without them, the file the
 * connected AI was asked to upload, if it has arrived.
 */
export const orgBoardOrgCheckBoardProposalFileMutation = (options?: Partial<Options<OrgBoardOrgCheckBoardProposalFileData>>): UseMutationOptions<OrgBoardOrgCheckBoardProposalFileResponse, OrgBoardOrgCheckBoardProposalFileError, Options<OrgBoardOrgCheckBoardProposalFileData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCheckBoardProposalFileResponse, OrgBoardOrgCheckBoardProposalFileError, Options<OrgBoardOrgCheckBoardProposalFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCheckBoardProposalFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Issue Board Proposal File Upload Url
 *
 * A signed upload URL for a proposed record's missing or replacement file: PUT the file there
 * once, sending exactly `headers`, then ask Board to check it with the `object_ref` it names. A
 * PDF or a picture, up to 50 MB. Nothing is recorded until Board's check passes.
 */
export const orgBoardOrgIssueBoardProposalFileUploadUrlMutation = (options?: Partial<Options<OrgBoardOrgIssueBoardProposalFileUploadUrlData>>): UseMutationOptions<OrgBoardOrgIssueBoardProposalFileUploadUrlResponse, OrgBoardOrgIssueBoardProposalFileUploadUrlError, Options<OrgBoardOrgIssueBoardProposalFileUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgIssueBoardProposalFileUploadUrlResponse, OrgBoardOrgIssueBoardProposalFileUploadUrlError, Options<OrgBoardOrgIssueBoardProposalFileUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgIssueBoardProposalFileUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Leave Out Board Past Record
 *
 * Leave one proposed record out of its batch: it won't be imported, and its text and file are
 * deleted. Echo the batch's `revision`; the answer carries the batch's new one. A person's act.
 */
export const orgBoardOrgLeaveOutBoardPastRecordMutation = (options?: Partial<Options<OrgBoardOrgLeaveOutBoardPastRecordData>>): UseMutationOptions<OrgBoardOrgLeaveOutBoardPastRecordResponse, OrgBoardOrgLeaveOutBoardPastRecordError, Options<OrgBoardOrgLeaveOutBoardPastRecordData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgLeaveOutBoardPastRecordResponse, OrgBoardOrgLeaveOutBoardPastRecordError, Options<OrgBoardOrgLeaveOutBoardPastRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgLeaveOutBoardPastRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardRecordsQueryKey = (options: Options<OrgBoardOrgListBoardRecordsData>) => createQueryKey('org-board-org_list_board_records', options);

/**
 * Org List Board Records
 *
 * The charity's board records, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Executive-session records the caller did not take part in are ABSENT, and the total
 * reflects only what they may see — reporting the unfiltered total would leak the
 * existence of withheld records through arithmetic.
 *
 * `q` narrows the list to records whose TITLE contains it, ignoring case (CBG-UX1). It is
 * applied in the same query as the executive-session rule, so a withheld record is never
 * found or counted by a search. A `q` longer than a title can be, or holding a NUL, is a
 * 422.
 */
export const orgBoardOrgListBoardRecordsOptions = (options: Options<OrgBoardOrgListBoardRecordsData>) => queryOptions<OrgBoardOrgListBoardRecordsResponse, OrgBoardOrgListBoardRecordsError, OrgBoardOrgListBoardRecordsResponse, ReturnType<typeof orgBoardOrgListBoardRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardRecordsQueryKey(options)
});

/**
 * Org Create Board Record Draft
 *
 * Twin of ``create_board_record_draft``.
 */
export const orgBoardOrgCreateBoardRecordDraftMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardRecordDraftData>>): UseMutationOptions<OrgBoardOrgCreateBoardRecordDraftResponse, OrgBoardOrgCreateBoardRecordDraftError, Options<OrgBoardOrgCreateBoardRecordDraftData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardRecordDraftResponse, OrgBoardOrgCreateBoardRecordDraftError, Options<OrgBoardOrgCreateBoardRecordDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardRecordDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardRecordQueryKey = (options: Options<OrgBoardOrgGetBoardRecordData>) => createQueryKey('org-board-org_get_board_record', options);

/**
 * Org Get Board Record
 *
 * Twin of ``get_board_record``.
 */
export const orgBoardOrgGetBoardRecordOptions = (options: Options<OrgBoardOrgGetBoardRecordData>) => queryOptions<OrgBoardOrgGetBoardRecordResponse, OrgBoardOrgGetBoardRecordError, OrgBoardOrgGetBoardRecordResponse, ReturnType<typeof orgBoardOrgGetBoardRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardRecordQueryKey(options)
});

/**
 * Org Update Board Record Draft
 *
 * Twin of ``update_board_record_draft``.
 */
export const orgBoardOrgUpdateBoardRecordDraftMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardRecordDraftData>>): UseMutationOptions<OrgBoardOrgUpdateBoardRecordDraftResponse, OrgBoardOrgUpdateBoardRecordDraftError, Options<OrgBoardOrgUpdateBoardRecordDraftData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardRecordDraftResponse, OrgBoardOrgUpdateBoardRecordDraftError, Options<OrgBoardOrgUpdateBoardRecordDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardRecordDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardRecordAcknowledgmentsQueryKey = (options: Options<OrgBoardOrgListBoardRecordAcknowledgmentsData>) => createQueryKey('org-board-org_list_board_record_acknowledgments', options);

/**
 * Org List Board Record Acknowledgments
 *
 * Who has confirmed reading a document, which version, how and when — confirmed in Board,
 * recorded from a signed paper form, or confirmed in an annual conflict-of-interest disclosure
 * (the policy only) — across the document's versions, newest first.
 */
export const orgBoardOrgListBoardRecordAcknowledgmentsOptions = (options: Options<OrgBoardOrgListBoardRecordAcknowledgmentsData>) => queryOptions<OrgBoardOrgListBoardRecordAcknowledgmentsResponse, OrgBoardOrgListBoardRecordAcknowledgmentsError, OrgBoardOrgListBoardRecordAcknowledgmentsResponse, ReturnType<typeof orgBoardOrgListBoardRecordAcknowledgmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardRecordAcknowledgments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardRecordAcknowledgmentsQueryKey(options)
});

/**
 * Org Approve Board Record
 *
 * Record the approval — the door from a draft to the charity's record.
 *
 * The body's `content_hash` is a required echo of the artifact the approver read; a
 * mismatch is a 409 and the reviewer re-reads the current version. A record is approved
 * only with the date it is about: `occurred_on` supplies a date the draft is missing or
 * confirms the one it carries, and a record left without one is a 409. The route is
 * named for the thing it creates (the approval event), not for a verb, because that
 * event is the durable artifact.
 */
export const orgBoardOrgApproveBoardRecordMutation = (options?: Partial<Options<OrgBoardOrgApproveBoardRecordData>>): UseMutationOptions<OrgBoardOrgApproveBoardRecordResponse, OrgBoardOrgApproveBoardRecordError, Options<OrgBoardOrgApproveBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgApproveBoardRecordResponse, OrgBoardOrgApproveBoardRecordError, Options<OrgBoardOrgApproveBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgApproveBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardMinutesApprovalConsentFormQueryKey = (options: Options<OrgBoardOrgGetBoardMinutesApprovalConsentFormData>) => createQueryKey('org-board-org_get_board_minutes_approval_consent_form', options);

/**
 * Org Get Board Minutes Approval Consent Form
 *
 * The form for a written consent approving one set of minutes, filled in from them.
 *
 * A neutral form whose structure is modeled on the Model Nonprofit Corporation Act's board
 * action without a meeting. The module fills in only what the organization already recorded
 * about the minutes — their title, the date of their meeting, their record reference and their
 * fingerprint — and leaves every other term as a field for the organization. The text is the
 * organization's to edit; the fingerprint stays in it, because it is how the text the
 * directors sign names the minutes they approve.
 *
 * Available for a meeting's own minutes that are still a draft.
 */
export const orgBoardOrgGetBoardMinutesApprovalConsentFormOptions = (options: Options<OrgBoardOrgGetBoardMinutesApprovalConsentFormData>) => queryOptions<OrgBoardOrgGetBoardMinutesApprovalConsentFormResponse, OrgBoardOrgGetBoardMinutesApprovalConsentFormError, OrgBoardOrgGetBoardMinutesApprovalConsentFormResponse, ReturnType<typeof orgBoardOrgGetBoardMinutesApprovalConsentFormQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardMinutesApprovalConsentForm({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardMinutesApprovalConsentFormQueryKey(options)
});

/**
 * Org Create Board Minutes Approval Consent
 *
 * Open a working consent that names the minutes it approves.
 *
 * A draft like any other: nothing is put to the board here, and the text is the
 * organization's to edit. The minutes are the ones in the path, and that never changes.
 * When the consent goes to the board, its text carries the minutes' fingerprint and the
 * version that goes out records it. When the last director it went out to signs, the
 * minutes are approved — unless they changed after it went out, were approved another way,
 * or are no longer there; then the consent is still recorded, and says the minutes were not
 * approved and why.
 */
export const orgBoardOrgCreateBoardMinutesApprovalConsentMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardMinutesApprovalConsentData>>): UseMutationOptions<OrgBoardOrgCreateBoardMinutesApprovalConsentResponse, OrgBoardOrgCreateBoardMinutesApprovalConsentError, Options<OrgBoardOrgCreateBoardMinutesApprovalConsentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardMinutesApprovalConsentResponse, OrgBoardOrgCreateBoardMinutesApprovalConsentError, Options<OrgBoardOrgCreateBoardMinutesApprovalConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardMinutesApprovalConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Record Chain
 *
 * Delete a record together with its whole correction chain, as one act.
 *
 * A correction and the record it corrects are each other's context, so they are retained
 * and deleted as a unit — the single-record route refuses a chain member and points here.
 * Any member's id resolves the chain, and the request is refused outright if any member
 * is still inside the retention floor or under an active legal hold. Every member gets
 * its own ``deleted`` event.
 */
export const orgBoardOrgDeleteBoardRecordChainMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardRecordChainData>>): UseMutationOptions<OrgBoardOrgDeleteBoardRecordChainResponse, OrgBoardOrgDeleteBoardRecordChainError, Options<OrgBoardOrgDeleteBoardRecordChainData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardRecordChainResponse, OrgBoardOrgDeleteBoardRecordChainError, Options<OrgBoardOrgDeleteBoardRecordChainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardRecordChain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Board Record
 *
 * Delete ONE board record at the charity's explicit request.
 *
 * A POST carrying a required reason rather than a bare DELETE: the reason is recorded,
 * and a deletion of the charity's legal memory should not be something a stray verb can
 * accomplish. Refused while any active legal hold covers the record, and refused before
 * the record has passed the charity's adopted retention floor — both at the service for
 * a clear message and at the database independently.
 */
export const orgBoardOrgDeleteBoardRecordMutation = (options?: Partial<Options<OrgBoardOrgDeleteBoardRecordData>>): UseMutationOptions<OrgBoardOrgDeleteBoardRecordResponse, OrgBoardOrgDeleteBoardRecordError, Options<OrgBoardOrgDeleteBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDeleteBoardRecordResponse, OrgBoardOrgDeleteBoardRecordError, Options<OrgBoardOrgDeleteBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDeleteBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Discard Board Record Draft
 *
 * Twin of ``discard_board_record_draft``.
 */
export const orgBoardOrgDiscardBoardRecordDraftMutation = (options?: Partial<Options<OrgBoardOrgDiscardBoardRecordDraftData>>): UseMutationOptions<OrgBoardOrgDiscardBoardRecordDraftResponse, OrgBoardOrgDiscardBoardRecordDraftError, Options<OrgBoardOrgDiscardBoardRecordDraftData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgDiscardBoardRecordDraftResponse, OrgBoardOrgDiscardBoardRecordDraftError, Options<OrgBoardOrgDiscardBoardRecordDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgDiscardBoardRecordDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardRecordFileUrlQueryKey = (options: Options<OrgBoardOrgGetBoardRecordFileUrlData>) => createQueryKey('org-board-org_get_board_record_file_url', options);

/**
 * Org Get Board Record File Url
 *
 * A short-lived link that downloads a record's file, the one Board checked when the record
 * was imported. A closed session's file opens only for those who may read its record.
 */
export const orgBoardOrgGetBoardRecordFileUrlOptions = (options: Options<OrgBoardOrgGetBoardRecordFileUrlData>) => queryOptions<OrgBoardOrgGetBoardRecordFileUrlResponse, OrgBoardOrgGetBoardRecordFileUrlError, OrgBoardOrgGetBoardRecordFileUrlResponse, ReturnType<typeof orgBoardOrgGetBoardRecordFileUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardRecordFileUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardRecordFileUrlQueryKey(options)
});

export const orgBoardOrgGetBoardOfficerStatementQueryKey = (options: Options<OrgBoardOrgGetBoardOfficerStatementData>) => createQueryKey('org-board-org_get_board_officer_statement', options);

/**
 * Org Get Board Officer Statement
 *
 * A statement about one record, generated for an officer of the organization to
 * execute.
 *
 * The module fills in only what the charity already recorded — the record's title, its
 * date, when it was recorded, its reference and its text — and leaves every statement
 * the officer makes, and the officer's own name, title and date, as fields for them.
 * The organization's officer signs it; this product signs nothing.
 *
 * Available for a record the charity has recorded. There is nothing to state about a
 * working draft.
 */
export const orgBoardOrgGetBoardOfficerStatementOptions = (options: Options<OrgBoardOrgGetBoardOfficerStatementData>) => queryOptions<OrgBoardOrgGetBoardOfficerStatementResponse, OrgBoardOrgGetBoardOfficerStatementError, OrgBoardOrgGetBoardOfficerStatementResponse, ReturnType<typeof orgBoardOrgGetBoardOfficerStatementQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardOfficerStatement({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardOfficerStatementQueryKey(options)
});

export const orgBoardOrgListBoardRecordEventsQueryKey = (options: Options<OrgBoardOrgListBoardRecordEventsData>) => createQueryKey('org-board-org_list_board_record_events', options);

/**
 * Org List Board Record Events
 *
 * One record's append-only record event log, oldest first — including the approval
 * event, which is the evidence of who approved what and when.
 */
export const orgBoardOrgListBoardRecordEventsOptions = (options: Options<OrgBoardOrgListBoardRecordEventsData>) => queryOptions<OrgBoardOrgListBoardRecordEventsResponse, OrgBoardOrgListBoardRecordEventsError, OrgBoardOrgListBoardRecordEventsResponse, ReturnType<typeof orgBoardOrgListBoardRecordEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardRecordEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardRecordEventsQueryKey(options)
});

/**
 * Org Submit Board Record
 *
 * Twin of ``submit_board_record``.
 */
export const orgBoardOrgSubmitBoardRecordMutation = (options?: Partial<Options<OrgBoardOrgSubmitBoardRecordData>>): UseMutationOptions<OrgBoardOrgSubmitBoardRecordResponse, OrgBoardOrgSubmitBoardRecordError, Options<OrgBoardOrgSubmitBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSubmitBoardRecordResponse, OrgBoardOrgSubmitBoardRecordError, Options<OrgBoardOrgSubmitBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSubmitBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardRetentionPoliciesQueryKey = (options: Options<OrgBoardOrgListBoardRetentionPoliciesData>) => createQueryKey('org-board-org_list_board_retention_policies', options);

/**
 * Org List Board Retention Policies
 *
 * Twin of ``list_board_retention_policies``.
 */
export const orgBoardOrgListBoardRetentionPoliciesOptions = (options: Options<OrgBoardOrgListBoardRetentionPoliciesData>) => queryOptions<OrgBoardOrgListBoardRetentionPoliciesResponse, OrgBoardOrgListBoardRetentionPoliciesError, OrgBoardOrgListBoardRetentionPoliciesResponse, ReturnType<typeof orgBoardOrgListBoardRetentionPoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardRetentionPolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardRetentionPoliciesQueryKey(options)
});

/**
 * Org Adopt Board Retention Policy
 *
 * Adopt (or replace) the charity's retention schedule for one record kind.
 *
 * `minimum_retention_years` is a FLOOR, never an expiry: reaching it deletes nothing.
 * PUT rather than POST because the charity has exactly one live schedule per record
 * kind — adopting again replaces it (and supersedes the prior row, which stays readable
 * as history).
 */
export const orgBoardOrgAdoptBoardRetentionPolicyMutation = (options?: Partial<Options<OrgBoardOrgAdoptBoardRetentionPolicyData>>): UseMutationOptions<OrgBoardOrgAdoptBoardRetentionPolicyResponse, OrgBoardOrgAdoptBoardRetentionPolicyError, Options<OrgBoardOrgAdoptBoardRetentionPolicyData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAdoptBoardRetentionPolicyResponse, OrgBoardOrgAdoptBoardRetentionPolicyError, Options<OrgBoardOrgAdoptBoardRetentionPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAdoptBoardRetentionPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardReturnDistributionsQueryKey = (options: Options<OrgBoardOrgListBoardReturnDistributionsData>) => createQueryKey('org-board-org_list_board_return_distributions', options);

/**
 * Org List Board Return Distributions
 *
 * Every copy of the return provided to the board, newest first: the tax year, who provided
 * it and when, how many people it went to, and how many of the directors were provided it.
 * `tax_year_ends_on` narrows the list to one tax year's copies.
 */
export const orgBoardOrgListBoardReturnDistributionsOptions = (options: Options<OrgBoardOrgListBoardReturnDistributionsData>) => queryOptions<OrgBoardOrgListBoardReturnDistributionsResponse, OrgBoardOrgListBoardReturnDistributionsError, OrgBoardOrgListBoardReturnDistributionsResponse, ReturnType<typeof orgBoardOrgListBoardReturnDistributionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardReturnDistributions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardReturnDistributionsQueryKey(options)
});

/**
 * Org Provide Board Return
 *
 * Provide a copy of the return to the board. Adds one record to the minute book: the copy's
 * fingerprint, who provided it and when, and everyone on the roster it went to. Each person is
 * emailed that it's available to review in Givmo; a seat no account has joined gets an
 * invitation to join with it. `follows_record_id` provides a newer copy of a return already
 * provided.
 */
export const orgBoardOrgProvideBoardReturnMutation = (options?: Partial<Options<OrgBoardOrgProvideBoardReturnData>>): UseMutationOptions<OrgBoardOrgProvideBoardReturnResponse, OrgBoardOrgProvideBoardReturnError, Options<OrgBoardOrgProvideBoardReturnData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgProvideBoardReturnResponse, OrgBoardOrgProvideBoardReturnError, Options<OrgBoardOrgProvideBoardReturnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgProvideBoardReturn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Confirm Board Return Copy
 *
 * Check an uploaded copy: Board reads it and answers its size, its number of pages and its
 * SHA-256 fingerprint, which Board computes itself. A PDF with a password to open is refused.
 * Nothing is recorded.
 */
export const orgBoardOrgConfirmBoardReturnCopyMutation = (options?: Partial<Options<OrgBoardOrgConfirmBoardReturnCopyData>>): UseMutationOptions<OrgBoardOrgConfirmBoardReturnCopyResponse, OrgBoardOrgConfirmBoardReturnCopyError, Options<OrgBoardOrgConfirmBoardReturnCopyData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgConfirmBoardReturnCopyResponse, OrgBoardOrgConfirmBoardReturnCopyError, Options<OrgBoardOrgConfirmBoardReturnCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgConfirmBoardReturnCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Issue Board Return Copy Upload Url
 *
 * A link to upload one copy of the return, a PDF of at most 50 MB, valid for 15 minutes.
 * Nothing is recorded until the copy is provided.
 */
export const orgBoardOrgIssueBoardReturnCopyUploadUrlMutation = (options?: Partial<Options<OrgBoardOrgIssueBoardReturnCopyUploadUrlData>>): UseMutationOptions<OrgBoardOrgIssueBoardReturnCopyUploadUrlResponse, OrgBoardOrgIssueBoardReturnCopyUploadUrlError, Options<OrgBoardOrgIssueBoardReturnCopyUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgIssueBoardReturnCopyUploadUrlResponse, OrgBoardOrgIssueBoardReturnCopyUploadUrlError, Options<OrgBoardOrgIssueBoardReturnCopyUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgIssueBoardReturnCopyUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgPreviewBoardReturnRecipientsQueryKey = (options: Options<OrgBoardOrgPreviewBoardReturnRecipientsData>) => createQueryKey('org-board-org_preview_board_return_recipients', options);

/**
 * Org Preview Board Return Recipients
 *
 * Who a copy provided now would go to: everyone on the board's roster today, directors first,
 * with the titles they hold on `provided_on`, the day you'll provide it (today when unsent).
 * The same list the act uses.
 */
export const orgBoardOrgPreviewBoardReturnRecipientsOptions = (options: Options<OrgBoardOrgPreviewBoardReturnRecipientsData>) => queryOptions<OrgBoardOrgPreviewBoardReturnRecipientsResponse, OrgBoardOrgPreviewBoardReturnRecipientsError, OrgBoardOrgPreviewBoardReturnRecipientsResponse, ReturnType<typeof orgBoardOrgPreviewBoardReturnRecipientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgPreviewBoardReturnRecipients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgPreviewBoardReturnRecipientsQueryKey(options)
});

export const orgBoardOrgListBoardReturnReviewCandidatesQueryKey = (options: Options<OrgBoardOrgListBoardReturnReviewCandidatesData>) => createQueryKey('org-board-org_list_board_return_review_candidates', options);

/**
 * Org List Board Return Review Candidates
 *
 * The board's acts a copy's review can name, newest first: each motion with a recorded vote,
 * carried or failed, made in a meeting's open session (its meeting's title and day, and its own
 * words), and each written consent waiting on signatures or signed by everyone. A closed
 * session's motion is never listed.
 */
export const orgBoardOrgListBoardReturnReviewCandidatesOptions = (options: Options<OrgBoardOrgListBoardReturnReviewCandidatesData>) => queryOptions<OrgBoardOrgListBoardReturnReviewCandidatesResponse, OrgBoardOrgListBoardReturnReviewCandidatesError, OrgBoardOrgListBoardReturnReviewCandidatesResponse, ReturnType<typeof orgBoardOrgListBoardReturnReviewCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardReturnReviewCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardReturnReviewCandidatesQueryKey(options)
});

export const orgBoardOrgGetBoardReturnDistributionQueryKey = (options: Options<OrgBoardOrgGetBoardReturnDistributionData>) => createQueryKey('org-board-org_get_board_return_distribution', options);

/**
 * Org Get Board Return Distribution
 *
 * One copy of the return provided to the board, and what Board recorded of each person it
 * went to: their email, when they opened it, a printed copy given to them, and their recorded
 * reading.
 */
export const orgBoardOrgGetBoardReturnDistributionOptions = (options: Options<OrgBoardOrgGetBoardReturnDistributionData>) => queryOptions<OrgBoardOrgGetBoardReturnDistributionResponse, OrgBoardOrgGetBoardReturnDistributionError, OrgBoardOrgGetBoardReturnDistributionResponse, ReturnType<typeof orgBoardOrgGetBoardReturnDistributionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardReturnDistribution({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardReturnDistributionQueryKey(options)
});

export const orgBoardOrgGetBoardReturnCopyUrlQueryKey = (options: Options<OrgBoardOrgGetBoardReturnCopyUrlData>) => createQueryKey('org-board-org_get_board_return_copy_url', options);

/**
 * Org Get Board Return Copy Url
 *
 * A link to download the copy provided, valid for 15 minutes. Your download isn't recorded
 * as anyone's receipt.
 */
export const orgBoardOrgGetBoardReturnCopyUrlOptions = (options: Options<OrgBoardOrgGetBoardReturnCopyUrlData>) => queryOptions<OrgBoardOrgGetBoardReturnCopyUrlResponse, OrgBoardOrgGetBoardReturnCopyUrlError, OrgBoardOrgGetBoardReturnCopyUrlResponse, ReturnType<typeof orgBoardOrgGetBoardReturnCopyUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardReturnCopyUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardReturnCopyUrlQueryKey(options)
});

/**
 * Org Email Board Return Again
 *
 * Email one person again after their email didn't go out. At most once a day each; no new
 * record. A seat no account has joined gets a new invitation with it.
 */
export const orgBoardOrgEmailBoardReturnAgainMutation = (options?: Partial<Options<OrgBoardOrgEmailBoardReturnAgainData>>): UseMutationOptions<OrgBoardOrgEmailBoardReturnAgainResponse, OrgBoardOrgEmailBoardReturnAgainError, Options<OrgBoardOrgEmailBoardReturnAgainData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgEmailBoardReturnAgainResponse, OrgBoardOrgEmailBoardReturnAgainError, Options<OrgBoardOrgEmailBoardReturnAgainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgEmailBoardReturnAgain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Return Printed Copy
 *
 * Record that a printed copy was given to this person: the day it was given, and how. Once
 * per person for each copy.
 */
export const orgBoardOrgRecordBoardReturnPrintedCopyMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardReturnPrintedCopyData>>): UseMutationOptions<OrgBoardOrgRecordBoardReturnPrintedCopyResponse, OrgBoardOrgRecordBoardReturnPrintedCopyError, Options<OrgBoardOrgRecordBoardReturnPrintedCopyData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardReturnPrintedCopyResponse, OrgBoardOrgRecordBoardReturnPrintedCopyError, Options<OrgBoardOrgRecordBoardReturnPrintedCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardReturnPrintedCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Link Board Return Review
 *
 * Record the board's review of this copy: one of the acts the review list names, a motion
 * or a written consent. One per copy at a time; remove it to record another. The board's own
 * record is unchanged.
 */
export const orgBoardOrgLinkBoardReturnReviewMutation = (options?: Partial<Options<OrgBoardOrgLinkBoardReturnReviewData>>): UseMutationOptions<OrgBoardOrgLinkBoardReturnReviewResponse, OrgBoardOrgLinkBoardReturnReviewError, Options<OrgBoardOrgLinkBoardReturnReviewData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgLinkBoardReturnReviewResponse, OrgBoardOrgLinkBoardReturnReviewError, Options<OrgBoardOrgLinkBoardReturnReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgLinkBoardReturnReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Unlink Board Return Review
 *
 * Remove this copy's review link. Who removed it and when is kept with the copy's earlier
 * links.
 */
export const orgBoardOrgUnlinkBoardReturnReviewMutation = (options?: Partial<Options<OrgBoardOrgUnlinkBoardReturnReviewData>>): UseMutationOptions<OrgBoardOrgUnlinkBoardReturnReviewResponse, OrgBoardOrgUnlinkBoardReturnReviewError, Options<OrgBoardOrgUnlinkBoardReturnReviewData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUnlinkBoardReturnReviewResponse, OrgBoardOrgUnlinkBoardReturnReviewError, Options<OrgBoardOrgUnlinkBoardReturnReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUnlinkBoardReturnReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Withdraw Board Return
 *
 * Withdraw this copy, with the reason directors will see. Their pages stop offering it; the
 * record, what was recorded of each person and the file stay.
 */
export const orgBoardOrgWithdrawBoardReturnMutation = (options?: Partial<Options<OrgBoardOrgWithdrawBoardReturnData>>): UseMutationOptions<OrgBoardOrgWithdrawBoardReturnResponse, OrgBoardOrgWithdrawBoardReturnError, Options<OrgBoardOrgWithdrawBoardReturnData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgWithdrawBoardReturnResponse, OrgBoardOrgWithdrawBoardReturnError, Options<OrgBoardOrgWithdrawBoardReturnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgWithdrawBoardReturn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Roster Result
 *
 * Record an election's result on the roster, from the motion recorded as carried
 * (`motion_id`) or the executed written consent (`consent_id`) that elected them: a term for
 * each director named, and the title for each officer named (ending that person's earlier
 * holding of the same title, which stays in their history). Each is linked to the motion or
 * consent; the motion, the consent and the minutes don't change. The roster never changes from
 * an election by itself; this is the officer's act. Givmo doesn't read the motion's or the
 * consent's words: whoever is named here is recorded.
 *
 * A motion not recorded as carried is a 409 `board_roster_result_not_carried`; a written
 * consent not executed, a 409 `board_roster_result_not_executed`; a director named who isn't
 * recorded as a director, a 409 `board_roster_result_not_a_director`.
 */
export const orgBoardOrgRecordBoardRosterResultMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardRosterResultData>>): UseMutationOptions<OrgBoardOrgRecordBoardRosterResultResponse, OrgBoardOrgRecordBoardRosterResultError, Options<OrgBoardOrgRecordBoardRosterResultData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardRosterResultResponse, OrgBoardOrgRecordBoardRosterResultError, Options<OrgBoardOrgRecordBoardRosterResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardRosterResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardSelfAssessmentInstrumentsQueryKey = (options: Options<OrgBoardOrgListBoardSelfAssessmentInstrumentsData>) => createQueryKey('org-board-org_list_board_self_assessment_instruments', options);

/**
 * Org List Board Self Assessment Instruments
 *
 * Givmo's starting self-assessments this organization is offered, each with where its
 * statements come from. Never a statement that one is required or recommended.
 */
export const orgBoardOrgListBoardSelfAssessmentInstrumentsOptions = (options: Options<OrgBoardOrgListBoardSelfAssessmentInstrumentsData>) => queryOptions<OrgBoardOrgListBoardSelfAssessmentInstrumentsResponse, OrgBoardOrgListBoardSelfAssessmentInstrumentsError, OrgBoardOrgListBoardSelfAssessmentInstrumentsResponse, ReturnType<typeof orgBoardOrgListBoardSelfAssessmentInstrumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardSelfAssessmentInstruments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardSelfAssessmentInstrumentsQueryKey(options)
});

export const orgBoardOrgGetBoardSelfAssessmentInstrumentQueryKey = (options: Options<OrgBoardOrgGetBoardSelfAssessmentInstrumentData>) => createQueryKey('org-board-org_get_board_self_assessment_instrument', options);

/**
 * Org Get Board Self Assessment Instrument
 *
 * One starting self-assessment with every statement, in its group, and the text each is
 * written from: the IRS's Form 990 and its instructions, or a state's statute.
 */
export const orgBoardOrgGetBoardSelfAssessmentInstrumentOptions = (options: Options<OrgBoardOrgGetBoardSelfAssessmentInstrumentData>) => queryOptions<OrgBoardOrgGetBoardSelfAssessmentInstrumentResponse, OrgBoardOrgGetBoardSelfAssessmentInstrumentError, OrgBoardOrgGetBoardSelfAssessmentInstrumentResponse, ReturnType<typeof orgBoardOrgGetBoardSelfAssessmentInstrumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardSelfAssessmentInstrument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardSelfAssessmentInstrumentQueryKey(options)
});

export const orgBoardOrgListBoardSelfAssessmentsQueryKey = (options: Options<OrgBoardOrgListBoardSelfAssessmentsData>) => createQueryKey('org-board-org_list_board_self_assessments', options);

/**
 * Org List Board Self Assessments
 *
 * Every self-assessment of the board, newest first: each one's dates, where it stands, and
 * how many were asked and how many answered.
 */
export const orgBoardOrgListBoardSelfAssessmentsOptions = (options: Options<OrgBoardOrgListBoardSelfAssessmentsData>) => queryOptions<OrgBoardOrgListBoardSelfAssessmentsResponse, OrgBoardOrgListBoardSelfAssessmentsError, OrgBoardOrgListBoardSelfAssessmentsResponse, ReturnType<typeof orgBoardOrgListBoardSelfAssessmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardSelfAssessments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardSelfAssessmentsQueryKey(options)
});

/**
 * Org Open Board Self Assessment
 *
 * Start the board's self-assessment: everyone on the roster is asked, but the people named in
 * `not_asked`, with Givmo's starting statements (any turned off). Each person is emailed the
 * ask; a seat that hasn't joined Board yet gets an invitation to join with it. Each person's
 * answers are private to them until it is closed.
 */
export const orgBoardOrgOpenBoardSelfAssessmentMutation = (options?: Partial<Options<OrgBoardOrgOpenBoardSelfAssessmentData>>): UseMutationOptions<OrgBoardOrgOpenBoardSelfAssessmentResponse, OrgBoardOrgOpenBoardSelfAssessmentError, Options<OrgBoardOrgOpenBoardSelfAssessmentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgOpenBoardSelfAssessmentResponse, OrgBoardOrgOpenBoardSelfAssessmentError, Options<OrgBoardOrgOpenBoardSelfAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgOpenBoardSelfAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardSelfAssessmentQueryKey = (options: Options<OrgBoardOrgGetBoardSelfAssessmentData>) => createQueryKey('org-board-org_get_board_self_assessment', options);

/**
 * Org Get Board Self Assessment
 *
 * One self-assessment: who was asked, who has answered and when (never what), what was sent
 * and when, who can be reminded now, what became of the answers once it closed, and the
 * board's priorities.
 */
export const orgBoardOrgGetBoardSelfAssessmentOptions = (options: Options<OrgBoardOrgGetBoardSelfAssessmentData>) => queryOptions<OrgBoardOrgGetBoardSelfAssessmentResponse, OrgBoardOrgGetBoardSelfAssessmentError, OrgBoardOrgGetBoardSelfAssessmentResponse, ReturnType<typeof orgBoardOrgGetBoardSelfAssessmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardSelfAssessment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardSelfAssessmentQueryKey(options)
});

/**
 * Org Cancel Board Self Assessment
 *
 * Withdraw a self-assessment started by mistake, before anyone has answered. Nothing is added
 * to the minute book.
 */
export const orgBoardOrgCancelBoardSelfAssessmentMutation = (options?: Partial<Options<OrgBoardOrgCancelBoardSelfAssessmentData>>): UseMutationOptions<OrgBoardOrgCancelBoardSelfAssessmentResponse, OrgBoardOrgCancelBoardSelfAssessmentError, Options<OrgBoardOrgCancelBoardSelfAssessmentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCancelBoardSelfAssessmentResponse, OrgBoardOrgCancelBoardSelfAssessmentError, Options<OrgBoardOrgCancelBoardSelfAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCancelBoardSelfAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Close Board Self Assessment
 *
 * Close the self-assessment. Adds one record to the minute book: how many people chose each
 * answer, and the comments without names, or, with fewer than three answers, only how many were
 * asked and answered. Each person's answers are then deleted, unless a legal hold covers the
 * board, which keeps them.
 */
export const orgBoardOrgCloseBoardSelfAssessmentMutation = (options?: Partial<Options<OrgBoardOrgCloseBoardSelfAssessmentData>>): UseMutationOptions<OrgBoardOrgCloseBoardSelfAssessmentResponse, OrgBoardOrgCloseBoardSelfAssessmentError, Options<OrgBoardOrgCloseBoardSelfAssessmentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCloseBoardSelfAssessmentResponse, OrgBoardOrgCloseBoardSelfAssessmentError, Options<OrgBoardOrgCloseBoardSelfAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCloseBoardSelfAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Unmark Board Self Assessment Paper Hand In
 *
 * Undo a paper hand-in marked by mistake.
 */
export const orgBoardOrgUnmarkBoardSelfAssessmentPaperHandInMutation = (options?: Partial<Options<OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInData>>): UseMutationOptions<OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInResponse, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInError, Options<OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInResponse, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInError, Options<OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUnmarkBoardSelfAssessmentPaperHandIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Mark Board Self Assessment Paper Hand In
 *
 * Mark that someone asked handed in a paper answer sheet, so they count as answered and are
 * not reminded.
 */
export const orgBoardOrgMarkBoardSelfAssessmentPaperHandInMutation = (options?: Partial<Options<OrgBoardOrgMarkBoardSelfAssessmentPaperHandInData>>): UseMutationOptions<OrgBoardOrgMarkBoardSelfAssessmentPaperHandInResponse, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInError, Options<OrgBoardOrgMarkBoardSelfAssessmentPaperHandInData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgMarkBoardSelfAssessmentPaperHandInResponse, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInError, Options<OrgBoardOrgMarkBoardSelfAssessmentPaperHandInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgMarkBoardSelfAssessmentPaperHandIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Self Assessment Paper Sheet
 *
 * Enter one paper answer sheet. It names nobody: nothing entered here ties it to a person.
 * Mark who handed one in separately.
 */
export const orgBoardOrgRecordBoardSelfAssessmentPaperSheetMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardSelfAssessmentPaperSheetData>>): UseMutationOptions<OrgBoardOrgRecordBoardSelfAssessmentPaperSheetResponse, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetError, Options<OrgBoardOrgRecordBoardSelfAssessmentPaperSheetData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardSelfAssessmentPaperSheetResponse, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetError, Options<OrgBoardOrgRecordBoardSelfAssessmentPaperSheetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardSelfAssessmentPaperSheet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Link Board Self Assessment Priorities
 *
 * Link the results to the board's own act choosing its priorities: a motion the board
 * carried, or a written consent every director signed, and the statements it addresses. Board
 * never chooses or drafts the priorities.
 */
export const orgBoardOrgLinkBoardSelfAssessmentPrioritiesMutation = (options?: Partial<Options<OrgBoardOrgLinkBoardSelfAssessmentPrioritiesData>>): UseMutationOptions<OrgBoardOrgLinkBoardSelfAssessmentPrioritiesResponse, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesError, Options<OrgBoardOrgLinkBoardSelfAssessmentPrioritiesData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgLinkBoardSelfAssessmentPrioritiesResponse, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesError, Options<OrgBoardOrgLinkBoardSelfAssessmentPrioritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgLinkBoardSelfAssessmentPriorities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardSelfAssessmentQuestionsQueryKey = (options: Options<OrgBoardOrgGetBoardSelfAssessmentQuestionsData>) => createQueryKey('org-board-org_get_board_self_assessment_questions', options);

/**
 * Org Get Board Self Assessment Questions
 *
 * What the self-assessment asks: its statements, in their groups, with their sources, the
 * answers, and the questions in a person's own words — to print a blank answer sheet, and to
 * enter one.
 */
export const orgBoardOrgGetBoardSelfAssessmentQuestionsOptions = (options: Options<OrgBoardOrgGetBoardSelfAssessmentQuestionsData>) => queryOptions<OrgBoardOrgGetBoardSelfAssessmentQuestionsResponse, OrgBoardOrgGetBoardSelfAssessmentQuestionsError, OrgBoardOrgGetBoardSelfAssessmentQuestionsResponse, ReturnType<typeof orgBoardOrgGetBoardSelfAssessmentQuestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardSelfAssessmentQuestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardSelfAssessmentQuestionsQueryKey(options)
});

/**
 * Org Remind Board Self Assessment Recipients
 *
 * Remind people who haven't answered yet. Each gets one email, at most once a day. Reminders
 * go only when you send them. Name the people in `board_member_ids`, or send null for everyone
 * who can be reminded now.
 */
export const orgBoardOrgRemindBoardSelfAssessmentRecipientsMutation = (options?: Partial<Options<OrgBoardOrgRemindBoardSelfAssessmentRecipientsData>>): UseMutationOptions<OrgBoardOrgRemindBoardSelfAssessmentRecipientsResponse, OrgBoardOrgRemindBoardSelfAssessmentRecipientsError, Options<OrgBoardOrgRemindBoardSelfAssessmentRecipientsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemindBoardSelfAssessmentRecipientsResponse, OrgBoardOrgRemindBoardSelfAssessmentRecipientsError, Options<OrgBoardOrgRemindBoardSelfAssessmentRecipientsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemindBoardSelfAssessmentRecipients({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Send Board Self Assessment Requests
 *
 * Send the self-assessment to people who haven't been sent it — someone who joined the board
 * since it started, or someone left out at the start. A seat that hasn't joined Board yet gets
 * an invitation with it. Name the people in `board_member_ids`, or send null for everyone it can
 * go to (never someone left out at the start).
 */
export const orgBoardOrgSendBoardSelfAssessmentRequestsMutation = (options?: Partial<Options<OrgBoardOrgSendBoardSelfAssessmentRequestsData>>): UseMutationOptions<OrgBoardOrgSendBoardSelfAssessmentRequestsResponse, OrgBoardOrgSendBoardSelfAssessmentRequestsError, Options<OrgBoardOrgSendBoardSelfAssessmentRequestsData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgSendBoardSelfAssessmentRequestsResponse, OrgBoardOrgSendBoardSelfAssessmentRequestsError, Options<OrgBoardOrgSendBoardSelfAssessmentRequestsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgSendBoardSelfAssessmentRequests({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardSelfAssessmentResultsQueryKey = (options: Options<OrgBoardOrgGetBoardSelfAssessmentResultsData>) => createQueryKey('org-board-org_get_board_self_assessment_results', options);

/**
 * Org Get Board Self Assessment Results
 *
 * A closed self-assessment's results, from its record in the minute book: how many people
 * chose each answer, in the statements' own order, and the comments without names, sorted. With
 * fewer than three answers, only how many were asked and answered.
 */
export const orgBoardOrgGetBoardSelfAssessmentResultsOptions = (options: Options<OrgBoardOrgGetBoardSelfAssessmentResultsData>) => queryOptions<OrgBoardOrgGetBoardSelfAssessmentResultsResponse, OrgBoardOrgGetBoardSelfAssessmentResultsError, OrgBoardOrgGetBoardSelfAssessmentResultsResponse, ReturnType<typeof orgBoardOrgGetBoardSelfAssessmentResultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardSelfAssessmentResults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardSelfAssessmentResultsQueryKey(options)
});

export const orgBoardOrgGetBoardToDoQueryKey = (options: Options<OrgBoardOrgGetBoardToDoData>) => createQueryKey('org-board-org_get_board_to_do', options);

/**
 * Org Get Board To Do
 *
 * Your to-do list on this board: what an officer can do next in Board's record-keeping, and
 * what officers did in the last 90 days. A new member's steps (the year's conflict-of-interest
 * questionnaire to send, a board buddy to choose), minutes to write and to send for approval
 * with the date the Form 990 instructions use, records waiting for approval, and members or past
 * records a connected AI proposed. Each is listed only for someone who can do it, and each keeps
 * the scoping of the page it is done on. Never what a member hasn't read or answered. Computed
 * when read from your board's own records; nothing is stored.
 */
export const orgBoardOrgGetBoardToDoOptions = (options: Options<OrgBoardOrgGetBoardToDoData>) => queryOptions<OrgBoardOrgGetBoardToDoResponse, OrgBoardOrgGetBoardToDoError, OrgBoardOrgGetBoardToDoResponse, ReturnType<typeof orgBoardOrgGetBoardToDoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardToDo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardToDoQueryKey(options)
});

export const orgBoardOrgListBoardWrittenConsentsQueryKey = (options: Options<OrgBoardOrgListBoardWrittenConsentsData>) => createQueryKey('org-board-org_list_board_written_consents', options);

/**
 * Org List Board Written Consents
 *
 * The charity's written consents, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Each entry carries where the consent stands and how many of the seats it went out to
 * have signed. The roster and the signature log come with the single-consent read
 * rather than with a page of them.
 */
export const orgBoardOrgListBoardWrittenConsentsOptions = (options: Options<OrgBoardOrgListBoardWrittenConsentsData>) => queryOptions<OrgBoardOrgListBoardWrittenConsentsResponse, OrgBoardOrgListBoardWrittenConsentsError, OrgBoardOrgListBoardWrittenConsentsResponse, ReturnType<typeof orgBoardOrgListBoardWrittenConsentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardWrittenConsents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardWrittenConsentsQueryKey(options)
});

/**
 * Org Create Board Written Consent
 *
 * Open a working consent.
 *
 * Nothing is put to the board here: a draft has no roster and nobody can sign it. That
 * is a separate act, on a separate permission.
 */
export const orgBoardOrgCreateBoardWrittenConsentMutation = (options?: Partial<Options<OrgBoardOrgCreateBoardWrittenConsentData>>): UseMutationOptions<OrgBoardOrgCreateBoardWrittenConsentResponse, OrgBoardOrgCreateBoardWrittenConsentError, Options<OrgBoardOrgCreateBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCreateBoardWrittenConsentResponse, OrgBoardOrgCreateBoardWrittenConsentError, Options<OrgBoardOrgCreateBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCreateBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardWrittenConsentQueryKey = (options: Options<OrgBoardOrgGetBoardWrittenConsentData>) => createQueryKey('org-board-org_get_board_written_consent', options);

/**
 * Org Get Board Written Consent
 *
 * One consent: the text before the board, the roster it went out to, and every
 * signature act recorded against it — who, what identity they asserted, how it was
 * captured, which text they named, and when.
 */
export const orgBoardOrgGetBoardWrittenConsentOptions = (options: Options<OrgBoardOrgGetBoardWrittenConsentData>) => queryOptions<OrgBoardOrgGetBoardWrittenConsentResponse, OrgBoardOrgGetBoardWrittenConsentError, OrgBoardOrgGetBoardWrittenConsentResponse, ReturnType<typeof orgBoardOrgGetBoardWrittenConsentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardWrittenConsent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardWrittenConsentQueryKey(options)
});

/**
 * Org Update Board Written Consent
 *
 * Edit a working consent's text (skip-None partial update).
 *
 * Refused once the consent has been circulated. From there a change is a revision: the
 * text goes out again as a new version and every signature starts again, because a
 * signature names the bytes a director read.
 */
export const orgBoardOrgUpdateBoardWrittenConsentMutation = (options?: Partial<Options<OrgBoardOrgUpdateBoardWrittenConsentData>>): UseMutationOptions<OrgBoardOrgUpdateBoardWrittenConsentResponse, OrgBoardOrgUpdateBoardWrittenConsentError, Options<OrgBoardOrgUpdateBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgUpdateBoardWrittenConsentResponse, OrgBoardOrgUpdateBoardWrittenConsentError, Options<OrgBoardOrgUpdateBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgUpdateBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Circulate Board Written Consent
 *
 * Put the consent to the board.
 *
 * Freezes the text, records the roster it is going out to, and leaves the consent
 * pending. Until every seat on that roster has signed, the response says so in as many
 * words: the consent is pending, and how many seats have signed.
 *
 * Observers are not on the roster a consent goes to — the roster records them as
 * non-voting seats.
 */
export const orgBoardOrgCirculateBoardWrittenConsentMutation = (options?: Partial<Options<OrgBoardOrgCirculateBoardWrittenConsentData>>): UseMutationOptions<OrgBoardOrgCirculateBoardWrittenConsentResponse, OrgBoardOrgCirculateBoardWrittenConsentError, Options<OrgBoardOrgCirculateBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgCirculateBoardWrittenConsentResponse, OrgBoardOrgCirculateBoardWrittenConsentError, Options<OrgBoardOrgCirculateBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgCirculateBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgListBoardConsentCompensationDecisionsQueryKey = (options: Options<OrgBoardOrgListBoardConsentCompensationDecisionsData>) => createQueryKey('org-board-org_list_board_consent_compensation_decisions', options);

/**
 * Org List Board Consent Compensation Decisions
 *
 * A written consent's compensation decisions, in order, with their documents, and the one
 * block its text must carry, exactly as shown, to go out to the board: the directors sign the
 * details in the text they read. Whether the current text carries it.
 */
export const orgBoardOrgListBoardConsentCompensationDecisionsOptions = (options: Options<OrgBoardOrgListBoardConsentCompensationDecisionsData>) => queryOptions<OrgBoardOrgListBoardConsentCompensationDecisionsResponse, OrgBoardOrgListBoardConsentCompensationDecisionsError, OrgBoardOrgListBoardConsentCompensationDecisionsResponse, ReturnType<typeof orgBoardOrgListBoardConsentCompensationDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgListBoardConsentCompensationDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgListBoardConsentCompensationDecisionsQueryKey(options)
});

/**
 * Org Add Board Consent Compensation Decision
 *
 * Record the board's compensation decision for one person on a written consent's draft,
 * after its others: whose pay, their position, how the board obtained what it relied on, and
 * its reason when it set pay outside the range in that information. Its documents are uploaded
 * onto it. Refused once the consent has gone out to the board.
 */
export const orgBoardOrgAddBoardConsentCompensationDecisionMutation = (options?: Partial<Options<OrgBoardOrgAddBoardConsentCompensationDecisionData>>): UseMutationOptions<OrgBoardOrgAddBoardConsentCompensationDecisionResponse, OrgBoardOrgAddBoardConsentCompensationDecisionError, Options<OrgBoardOrgAddBoardConsentCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgAddBoardConsentCompensationDecisionResponse, OrgBoardOrgAddBoardConsentCompensationDecisionError, Options<OrgBoardOrgAddBoardConsentCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgAddBoardConsentCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Board Consent Compensation Decision
 *
 * Remove one consent decision, with its documents, while the consent is a draft. Its
 * history keeps who recorded and removed it, and when.
 */
export const orgBoardOrgRemoveBoardConsentCompensationDecisionMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardConsentCompensationDecisionData>>): UseMutationOptions<OrgBoardOrgRemoveBoardConsentCompensationDecisionResponse, OrgBoardOrgRemoveBoardConsentCompensationDecisionError, Options<OrgBoardOrgRemoveBoardConsentCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardConsentCompensationDecisionResponse, OrgBoardOrgRemoveBoardConsentCompensationDecisionError, Options<OrgBoardOrgRemoveBoardConsentCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardConsentCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Replace Board Consent Compensation Decision
 *
 * Replace one consent decision's details whole, while the consent is a draft. Its uploaded
 * documents stay. The consent's text must then carry the block as it now reads.
 */
export const orgBoardOrgReplaceBoardConsentCompensationDecisionMutation = (options?: Partial<Options<OrgBoardOrgReplaceBoardConsentCompensationDecisionData>>): UseMutationOptions<OrgBoardOrgReplaceBoardConsentCompensationDecisionResponse, OrgBoardOrgReplaceBoardConsentCompensationDecisionError, Options<OrgBoardOrgReplaceBoardConsentCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReplaceBoardConsentCompensationDecisionResponse, OrgBoardOrgReplaceBoardConsentCompensationDecisionError, Options<OrgBoardOrgReplaceBoardConsentCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReplaceBoardConsentCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Confirm Board Compensation Document
 *
 * Confirm a document finished uploading: Board reads the stored file and records its
 * fingerprint and size, which the consent's text names. A file over 100 MB is refused.
 */
export const orgBoardOrgConfirmBoardCompensationDocumentMutation = (options?: Partial<Options<OrgBoardOrgConfirmBoardCompensationDocumentData>>): UseMutationOptions<OrgBoardOrgConfirmBoardCompensationDocumentResponse, OrgBoardOrgConfirmBoardCompensationDocumentError, Options<OrgBoardOrgConfirmBoardCompensationDocumentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgConfirmBoardCompensationDocumentResponse, OrgBoardOrgConfirmBoardCompensationDocumentError, Options<OrgBoardOrgConfirmBoardCompensationDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgConfirmBoardCompensationDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Issue Board Compensation Document Upload Url
 *
 * A short-lived signed URL to upload one document the board relied on, onto a consent
 * decision, bound to its file type. Nothing is recorded until the upload is confirmed.
 */
export const orgBoardOrgIssueBoardCompensationDocumentUploadUrlMutation = (options?: Partial<Options<OrgBoardOrgIssueBoardCompensationDocumentUploadUrlData>>): UseMutationOptions<OrgBoardOrgIssueBoardCompensationDocumentUploadUrlResponse, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlError, Options<OrgBoardOrgIssueBoardCompensationDocumentUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgIssueBoardCompensationDocumentUploadUrlResponse, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlError, Options<OrgBoardOrgIssueBoardCompensationDocumentUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgIssueBoardCompensationDocumentUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Board Compensation Document
 *
 * Remove one of a consent decision's documents, while the consent is a draft.
 */
export const orgBoardOrgRemoveBoardCompensationDocumentMutation = (options?: Partial<Options<OrgBoardOrgRemoveBoardCompensationDocumentData>>): UseMutationOptions<OrgBoardOrgRemoveBoardCompensationDocumentResponse, OrgBoardOrgRemoveBoardCompensationDocumentError, Options<OrgBoardOrgRemoveBoardCompensationDocumentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRemoveBoardCompensationDocumentResponse, OrgBoardOrgRemoveBoardCompensationDocumentError, Options<OrgBoardOrgRemoveBoardCompensationDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRemoveBoardCompensationDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgBoardOrgGetBoardCompensationDocumentDownloadQueryKey = (options: Options<OrgBoardOrgGetBoardCompensationDocumentDownloadData>) => createQueryKey('org-board-org_get_board_compensation_document_download', options);

/**
 * Org Get Board Compensation Document Download
 *
 * A short-lived link to read one of a consent decision's documents, made for this request
 * and never stored.
 */
export const orgBoardOrgGetBoardCompensationDocumentDownloadOptions = (options: Options<OrgBoardOrgGetBoardCompensationDocumentDownloadData>) => queryOptions<OrgBoardOrgGetBoardCompensationDocumentDownloadResponse, OrgBoardOrgGetBoardCompensationDocumentDownloadError, OrgBoardOrgGetBoardCompensationDocumentDownloadResponse, ReturnType<typeof orgBoardOrgGetBoardCompensationDocumentDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgBoardOrgGetBoardCompensationDocumentDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgBoardOrgGetBoardCompensationDocumentDownloadQueryKey(options)
});

/**
 * Org Record Board Consent Revocation
 *
 * Withdraw an assent recorded on a director's behalf.
 *
 * Appended as its own act with its own note, never an edit of the entry it withdraws —
 * the signature log is only ever added to.
 */
export const orgBoardOrgRecordBoardConsentRevocationMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardConsentRevocationData>>): UseMutationOptions<OrgBoardOrgRecordBoardConsentRevocationResponse, OrgBoardOrgRecordBoardConsentRevocationError, Options<OrgBoardOrgRecordBoardConsentRevocationData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardConsentRevocationResponse, OrgBoardOrgRecordBoardConsentRevocationError, Options<OrgBoardOrgRecordBoardConsentRevocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardConsentRevocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Board Consent Signature
 *
 * Record a director's assent on their behalf.
 *
 * The path a board actually needs: a director who signed on paper, or who will not use
 * the portal at all, is not thereby unable to act. The entry is labelled as one the
 * officer made, carries the officer's own identity, and requires a note saying where
 * the assent came from. It completes a consent exactly as a director's own signature
 * does.
 */
export const orgBoardOrgRecordBoardConsentSignatureMutation = (options?: Partial<Options<OrgBoardOrgRecordBoardConsentSignatureData>>): UseMutationOptions<OrgBoardOrgRecordBoardConsentSignatureResponse, OrgBoardOrgRecordBoardConsentSignatureError, Options<OrgBoardOrgRecordBoardConsentSignatureData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgRecordBoardConsentSignatureResponse, OrgBoardOrgRecordBoardConsentSignatureError, Options<OrgBoardOrgRecordBoardConsentSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgRecordBoardConsentSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Revise Board Written Consent
 *
 * Revise a consent that is before the board.
 *
 * The new text goes out as a new version to a freshly recorded roster, and **every
 * signature already given starts again** — a director who signed the earlier text has
 * not signed this one. The earlier version keeps its own signatures as history.
 */
export const orgBoardOrgReviseBoardWrittenConsentMutation = (options?: Partial<Options<OrgBoardOrgReviseBoardWrittenConsentData>>): UseMutationOptions<OrgBoardOrgReviseBoardWrittenConsentResponse, OrgBoardOrgReviseBoardWrittenConsentError, Options<OrgBoardOrgReviseBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgReviseBoardWrittenConsentResponse, OrgBoardOrgReviseBoardWrittenConsentError, Options<OrgBoardOrgReviseBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgReviseBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Withdraw Board Written Consent
 *
 * Stop a consent before every seat has signed, with a recorded reason.
 *
 * The consent and its signatures stay: how the board arrived at whatever it did
 * instead is part of the charity's own history.
 */
export const orgBoardOrgWithdrawBoardWrittenConsentMutation = (options?: Partial<Options<OrgBoardOrgWithdrawBoardWrittenConsentData>>): UseMutationOptions<OrgBoardOrgWithdrawBoardWrittenConsentResponse, OrgBoardOrgWithdrawBoardWrittenConsentError, Options<OrgBoardOrgWithdrawBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<OrgBoardOrgWithdrawBoardWrittenConsentResponse, OrgBoardOrgWithdrawBoardWrittenConsentError, Options<OrgBoardOrgWithdrawBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgBoardOrgWithdrawBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const booksGetBooksQueryKey = (options: Options<BooksGetBooksData>) => createQueryKey('books-get_books', options);

/**
 * Get Books
 *
 * Open one organization's Books read surface.
 *
 * A0 never returns 200: an authorized, provisioned organization reaches the
 * typed ``BOOKS_READ_UNAVAILABLE`` 503 until A1 installs the dedicated reader.
 */
export const booksGetBooksOptions = (options: Options<BooksGetBooksData>) => queryOptions<BooksGetBooksResponse, BooksGetBooksError, BooksGetBooksResponse, ReturnType<typeof booksGetBooksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await booksGetBooks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: booksGetBooksQueryKey(options)
});

/**
 * Activate Books
 *
 * Advance one organization's Books setup from durable enrollment truth.
 */
export const booksActivateBooksMutation = (options?: Partial<Options<BooksActivateBooksData>>): UseMutationOptions<BooksActivateBooksResponse, BooksActivateBooksError, Options<BooksActivateBooksData>> => {
    const mutationOptions: UseMutationOptions<BooksActivateBooksResponse, BooksActivateBooksError, Options<BooksActivateBooksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await booksActivateBooks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const p2pGetSupporterQueryKey = (options: Options<P2pGetSupporterData>) => createQueryKey('p2p-get_supporter', options);

/**
 * Get Supporter
 */
export const p2pGetSupporterOptions = (options: Options<P2pGetSupporterData>) => queryOptions<P2pGetSupporterResponse, P2pGetSupporterError, P2pGetSupporterResponse, ReturnType<typeof p2pGetSupporterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pGetSupporter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pGetSupporterQueryKey(options)
});

/**
 * Update Supporter
 */
export const p2pUpdateSupporterMutation = (options?: Partial<Options<P2pUpdateSupporterData>>): UseMutationOptions<P2pUpdateSupporterResponse, P2pUpdateSupporterError, Options<P2pUpdateSupporterData>> => {
    const mutationOptions: UseMutationOptions<P2pUpdateSupporterResponse, P2pUpdateSupporterError, Options<P2pUpdateSupporterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await p2pUpdateSupporter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const p2pGetTeamQueryKey = (options: Options<P2pGetTeamData>) => createQueryKey('p2p-get_team', options);

/**
 * Get Team
 */
export const p2pGetTeamOptions = (options: Options<P2pGetTeamData>) => queryOptions<P2pGetTeamResponse, P2pGetTeamError, P2pGetTeamResponse, ReturnType<typeof p2pGetTeamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pGetTeam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pGetTeamQueryKey(options)
});

export const p2pGetCampaignP2pQueryKey = (options: Options<P2pGetCampaignP2pData>) => createQueryKey('p2p-get_campaign_p2p', options);

/**
 * Get Campaign P2P
 */
export const p2pGetCampaignP2pOptions = (options: Options<P2pGetCampaignP2pData>) => queryOptions<P2pGetCampaignP2pResponse, P2pGetCampaignP2pError, P2pGetCampaignP2pResponse, ReturnType<typeof p2pGetCampaignP2pQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pGetCampaignP2P({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pGetCampaignP2pQueryKey(options)
});

export const p2pGetActivityQueryKey = (options: Options<P2pGetActivityData>) => createQueryKey('p2p-get_activity', options);

/**
 * Get Activity
 */
export const p2pGetActivityOptions = (options: Options<P2pGetActivityData>) => queryOptions<P2pGetActivityResponse, P2pGetActivityError, P2pGetActivityResponse, ReturnType<typeof p2pGetActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pGetActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pGetActivityQueryKey(options)
});

export const p2pListGiveOptionsQueryKey = (options: Options<P2pListGiveOptionsData>) => createQueryKey('p2p-list_give_options', options);

/**
 * List Give Options
 *
 * FCM-BE74 (D-FCM-33 5.5; FCM-WEB26's picker): the fundraisers under the campaign that
 * still take a gift, its campaigns first, then people's pages, each kind ranked by its
 * board and then, unranked by name, those whose own switch is off; each with the ids of
 * what it raises for and no amount. `search` narrows both by name. Anonymous, like every
 * `/campaigns` read; a campaign the public campaign read does not serve is its one
 * not-found.
 */
export const p2pListGiveOptionsOptions = (options: Options<P2pListGiveOptionsData>) => queryOptions<P2pListGiveOptionsResponse, P2pListGiveOptionsError, P2pListGiveOptionsResponse, ReturnType<typeof p2pListGiveOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pListGiveOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pListGiveOptionsQueryKey(options)
});

/**
 * Join Campaign
 */
export const p2pJoinCampaignMutation = (options?: Partial<Options<P2pJoinCampaignData>>): UseMutationOptions<P2pJoinCampaignResponse, P2pJoinCampaignError, Options<P2pJoinCampaignData>> => {
    const mutationOptions: UseMutationOptions<P2pJoinCampaignResponse, P2pJoinCampaignError, Options<P2pJoinCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await p2pJoinCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const p2pCheckCampaignJoinQueryKey = (options: Options<P2pCheckCampaignJoinData>) => createQueryKey('p2p-check_campaign_join', options);

/**
 * Check Campaign Join
 *
 * Whether the join would admit the caller now, by the join setting's own gate, as if
 * they held no invitation (D-FCM-35 6.10: the donate join page's "Members only" up front),
 * and the gate's own words when it would not. Mints, spends and reserves nothing.
 */
export const p2pCheckCampaignJoinOptions = (options: Options<P2pCheckCampaignJoinData>) => queryOptions<P2pCheckCampaignJoinResponse, P2pCheckCampaignJoinError, P2pCheckCampaignJoinResponse, ReturnType<typeof p2pCheckCampaignJoinQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pCheckCampaignJoin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pCheckCampaignJoinQueryKey(options)
});

/**
 * Request To Join Campaign
 *
 * Ask to start a supporter page under the campaign (its join setting is "Request to
 * join"): 202 with the request waiting for its organizers; 200 with what stands when the
 * person asked already (the request waiting, or a decline, which is final) or already has
 * a page (``supporter_id``). Counted against the join's own rate limit.
 */
export const p2pRequestToJoinCampaignMutation = (options?: Partial<Options<P2pRequestToJoinCampaignData>>): UseMutationOptions<P2pRequestToJoinCampaignResponse, P2pRequestToJoinCampaignError, Options<P2pRequestToJoinCampaignData>> => {
    const mutationOptions: UseMutationOptions<P2pRequestToJoinCampaignResponse, P2pRequestToJoinCampaignError, Options<P2pRequestToJoinCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await p2pRequestToJoinCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw My Campaign Join Request
 *
 * Withdraw the caller's waiting request; nothing waiting is a no-op 204.
 */
export const p2pWithdrawMyCampaignJoinRequestMutation = (options?: Partial<Options<P2pWithdrawMyCampaignJoinRequestData>>): UseMutationOptions<P2pWithdrawMyCampaignJoinRequestResponse, P2pWithdrawMyCampaignJoinRequestError, Options<P2pWithdrawMyCampaignJoinRequestData>> => {
    const mutationOptions: UseMutationOptions<P2pWithdrawMyCampaignJoinRequestResponse, P2pWithdrawMyCampaignJoinRequestError, Options<P2pWithdrawMyCampaignJoinRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await p2pWithdrawMyCampaignJoinRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const p2pGetMyCampaignJoinRequestQueryKey = (options: Options<P2pGetMyCampaignJoinRequestData>) => createQueryKey('p2p-get_my_campaign_join_request', options);

/**
 * Get My Campaign Join Request
 *
 * The caller's own standing with the campaign: their latest request (its status as
 * read: a waiting one past its 14 days reads ``expired``), and their page's link when they
 * have one.
 */
export const p2pGetMyCampaignJoinRequestOptions = (options: Options<P2pGetMyCampaignJoinRequestData>) => queryOptions<P2pGetMyCampaignJoinRequestResponse, P2pGetMyCampaignJoinRequestError, P2pGetMyCampaignJoinRequestResponse, ReturnType<typeof p2pGetMyCampaignJoinRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pGetMyCampaignJoinRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pGetMyCampaignJoinRequestQueryKey(options)
});

export const campaignsListCampaignLayerBoardQueryKey = (options: Options<CampaignsListCampaignLayerBoardData>) => createQueryKey('campaigns-list_campaign_layer_board', options);

/**
 * List Campaign Layer Board
 *
 * FCM-BE33: the campaign's board of child layers, its public subtree's totals by
 * child: by rank (amount, then donors, then when attached), or by date (each child's
 * end). A layer whose own switch is off is not a row (D-FCM-26). Anonymous; a campaign
 * the public campaign read does not serve is its one not-found.
 */
export const campaignsListCampaignLayerBoardOptions = (options: Options<CampaignsListCampaignLayerBoardData>) => queryOptions<CampaignsListCampaignLayerBoardResponse, CampaignsListCampaignLayerBoardError, CampaignsListCampaignLayerBoardResponse, ReturnType<typeof campaignsListCampaignLayerBoardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListCampaignLayerBoard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListCampaignLayerBoardQueryKey(options)
});

export const p2pGetLeaderboardQueryKey = (options: Options<P2pGetLeaderboardData>) => createQueryKey('p2p-get_leaderboard', options);

/**
 * Get Leaderboard
 */
export const p2pGetLeaderboardOptions = (options: Options<P2pGetLeaderboardData>) => queryOptions<P2pGetLeaderboardResponse, P2pGetLeaderboardError, P2pGetLeaderboardResponse, ReturnType<typeof p2pGetLeaderboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pGetLeaderboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pGetLeaderboardQueryKey(options)
});

export const campaignsListCampaignScheduleQueryKey = (options: Options<CampaignsListCampaignScheduleData>) => createQueryKey('campaigns-list_campaign_schedule', options);

/**
 * List Campaign Schedule
 *
 * FCM-BE56: what a campaign's `schedule` card draws, its child layers on a timeline:
 * each one that counts publicly, in the order they end, with its public total (null while
 * its own switch is off) and whether it has ended. Anonymous; a campaign the public
 * campaign read does not serve is its one not-found.
 */
export const campaignsListCampaignScheduleOptions = (options: Options<CampaignsListCampaignScheduleData>) => queryOptions<CampaignsListCampaignScheduleResponse, CampaignsListCampaignScheduleError, CampaignsListCampaignScheduleResponse, ReturnType<typeof campaignsListCampaignScheduleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListCampaignSchedule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListCampaignScheduleQueryKey(options)
});

export const p2pListTeamsQueryKey = (options: Options<P2pListTeamsData>) => createQueryKey('p2p-list_teams', options);

/**
 * List Teams
 */
export const p2pListTeamsOptions = (options: Options<P2pListTeamsData>) => queryOptions<P2pListTeamsResponse, P2pListTeamsError, P2pListTeamsResponse, ReturnType<typeof p2pListTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await p2pListTeams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: p2pListTeamsQueryKey(options)
});

export const causeTagsGetAllCauseTagsQueryKey = (options?: Options<CauseTagsGetAllCauseTagsData>) => createQueryKey('cause_tags-get_all_cause_tags', options);

/**
 * Get All Cause Tags
 */
export const causeTagsGetAllCauseTagsOptions = (options?: Options<CauseTagsGetAllCauseTagsData>) => queryOptions<CauseTagsGetAllCauseTagsResponse, DefaultError, CauseTagsGetAllCauseTagsResponse, ReturnType<typeof causeTagsGetAllCauseTagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await causeTagsGetAllCauseTags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: causeTagsGetAllCauseTagsQueryKey(options)
});

/**
 * Create Cause Tag
 */
export const causeTagsCreateCauseTagMutation = (options?: Partial<Options<CauseTagsCreateCauseTagData>>): UseMutationOptions<CauseTagsCreateCauseTagResponse, CauseTagsCreateCauseTagError, Options<CauseTagsCreateCauseTagData>> => {
    const mutationOptions: UseMutationOptions<CauseTagsCreateCauseTagResponse, CauseTagsCreateCauseTagError, Options<CauseTagsCreateCauseTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await causeTagsCreateCauseTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Cause Tag
 */
export const causeTagsDeleteCauseTagMutation = (options?: Partial<Options<CauseTagsDeleteCauseTagData>>): UseMutationOptions<CauseTagsDeleteCauseTagResponse, CauseTagsDeleteCauseTagError, Options<CauseTagsDeleteCauseTagData>> => {
    const mutationOptions: UseMutationOptions<CauseTagsDeleteCauseTagResponse, CauseTagsDeleteCauseTagError, Options<CauseTagsDeleteCauseTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await causeTagsDeleteCauseTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Cause Tag
 */
export const causeTagsUpdateCauseTagMutation = (options?: Partial<Options<CauseTagsUpdateCauseTagData>>): UseMutationOptions<CauseTagsUpdateCauseTagResponse, CauseTagsUpdateCauseTagError, Options<CauseTagsUpdateCauseTagData>> => {
    const mutationOptions: UseMutationOptions<CauseTagsUpdateCauseTagResponse, CauseTagsUpdateCauseTagError, Options<CauseTagsUpdateCauseTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await causeTagsUpdateCauseTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const celebrityCharitiesGetCelebrityCharitiesQueryKey = (options?: Options<CelebrityCharitiesGetCelebrityCharitiesData>) => createQueryKey('celebrity-charities-get_celebrity_charities', options);

/**
 * Get Celebrity Charities
 */
export const celebrityCharitiesGetCelebrityCharitiesOptions = (options?: Options<CelebrityCharitiesGetCelebrityCharitiesData>) => queryOptions<CelebrityCharitiesGetCelebrityCharitiesResponse, CelebrityCharitiesGetCelebrityCharitiesError, CelebrityCharitiesGetCelebrityCharitiesResponse, ReturnType<typeof celebrityCharitiesGetCelebrityCharitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await celebrityCharitiesGetCelebrityCharities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: celebrityCharitiesGetCelebrityCharitiesQueryKey(options)
});

/**
 * Create Celebrity Charity
 */
export const celebrityCharitiesCreateCelebrityCharityMutation = (options?: Partial<Options<CelebrityCharitiesCreateCelebrityCharityData>>): UseMutationOptions<CelebrityCharitiesCreateCelebrityCharityResponse, CelebrityCharitiesCreateCelebrityCharityError, Options<CelebrityCharitiesCreateCelebrityCharityData>> => {
    const mutationOptions: UseMutationOptions<CelebrityCharitiesCreateCelebrityCharityResponse, CelebrityCharitiesCreateCelebrityCharityError, Options<CelebrityCharitiesCreateCelebrityCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await celebrityCharitiesCreateCelebrityCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Celebrity Charity
 */
export const celebrityCharitiesDeleteCelebrityCharityMutation = (options?: Partial<Options<CelebrityCharitiesDeleteCelebrityCharityData>>): UseMutationOptions<CelebrityCharitiesDeleteCelebrityCharityResponse, CelebrityCharitiesDeleteCelebrityCharityError, Options<CelebrityCharitiesDeleteCelebrityCharityData>> => {
    const mutationOptions: UseMutationOptions<CelebrityCharitiesDeleteCelebrityCharityResponse, CelebrityCharitiesDeleteCelebrityCharityError, Options<CelebrityCharitiesDeleteCelebrityCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await celebrityCharitiesDeleteCelebrityCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const celebrityCharitiesGetCelebrityCharityQueryKey = (options: Options<CelebrityCharitiesGetCelebrityCharityData>) => createQueryKey('celebrity-charities-get_celebrity_charity', options);

/**
 * Get Celebrity Charity
 */
export const celebrityCharitiesGetCelebrityCharityOptions = (options: Options<CelebrityCharitiesGetCelebrityCharityData>) => queryOptions<CelebrityCharitiesGetCelebrityCharityResponse, CelebrityCharitiesGetCelebrityCharityError, CelebrityCharitiesGetCelebrityCharityResponse, ReturnType<typeof celebrityCharitiesGetCelebrityCharityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await celebrityCharitiesGetCelebrityCharity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: celebrityCharitiesGetCelebrityCharityQueryKey(options)
});

/**
 * Update Celebrity Charity
 */
export const celebrityCharitiesUpdateCelebrityCharityMutation = (options?: Partial<Options<CelebrityCharitiesUpdateCelebrityCharityData>>): UseMutationOptions<CelebrityCharitiesUpdateCelebrityCharityResponse, CelebrityCharitiesUpdateCelebrityCharityError, Options<CelebrityCharitiesUpdateCelebrityCharityData>> => {
    const mutationOptions: UseMutationOptions<CelebrityCharitiesUpdateCelebrityCharityResponse, CelebrityCharitiesUpdateCelebrityCharityError, Options<CelebrityCharitiesUpdateCelebrityCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await celebrityCharitiesUpdateCelebrityCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Celebrity Charity Poster
 */
export const celebrityCharitiesUploadCelebrityCharityPosterMutation = (options?: Partial<Options<CelebrityCharitiesUploadCelebrityCharityPosterData>>): UseMutationOptions<CelebrityCharitiesUploadCelebrityCharityPosterResponse, CelebrityCharitiesUploadCelebrityCharityPosterError, Options<CelebrityCharitiesUploadCelebrityCharityPosterData>> => {
    const mutationOptions: UseMutationOptions<CelebrityCharitiesUploadCelebrityCharityPosterResponse, CelebrityCharitiesUploadCelebrityCharityPosterError, Options<CelebrityCharitiesUploadCelebrityCharityPosterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await celebrityCharitiesUploadCelebrityCharityPoster({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const championsResolveChampionNativeQueryKey = (options: Options<ChampionsResolveChampionNativeData>) => createQueryKey('champions-resolve_champion_native', options);

/**
 * Resolve Champion Native
 *
 * Resolve a give.givmo.io ``/<segment>`` (slug | handle | retired handle) to
 * its target charity id for an installed, authenticated client (D-CQ-19).
 *
 * Flag-gated (404 dark when ``CHAMPION_GIVE_HOST_ENABLED`` is off), authenticated
 * (no user → 403), and per-user rate-limited FAIL-CLOSED (→ 429). ``segment`` is
 * the RAW path segment — ``ChampionService.resolve`` lowercases it internally, so
 * do NOT lowercase here. The returned ``charity_id`` is the champion's CURRENT
 * target when ACTIVE, else ``None`` on any fallback (D-CQ-23: no fallback
 * charity). Anti-enumeration (D-CQ-14) rests on this route being authed +
 * App-Check-gated + fail-closed-rate-limited, not on a same-shape blend.
 */
export const championsResolveChampionNativeOptions = (options: Options<ChampionsResolveChampionNativeData>) => queryOptions<ChampionsResolveChampionNativeResponse, ChampionsResolveChampionNativeError, ChampionsResolveChampionNativeResponse, ReturnType<typeof championsResolveChampionNativeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await championsResolveChampionNative({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: championsResolveChampionNativeQueryKey(options)
});

export const championsResolveChampionLandingQueryKey = (options: Options<ChampionsResolveChampionLandingData>) => createQueryKey('champions-resolve_champion_landing', options);

/**
 * Resolve Champion Landing
 *
 * Resolve a give.givmo.io ``/<segment>`` (slug | handle | retired handle) to
 * its target charity for the donate-web champion landing SSR loader (CQ3-BE4).
 *
 * ANONYMOUS + App-Check-gated. The donate-web ``/champion/<slug>`` React-Router
 * SSR loader resolves the segment SERVER-SIDE, and its only backend trust is a
 * server-minted App-Check token — NO user auth — so it cannot call the
 * authenticated ``GET /champions/{segment}`` (which 403s without a user). This is
 * that route's anonymous sibling: no ``request.state.user`` check. App-Check is
 * still auto-enforced because ``champions`` is a REGISTERED top-level path segment,
 * so ``handler_middleware`` never give-exempts this path (the give exemption only
 * fires for a bare single-segment path; this multi-segment path is not a bare
 * segment, and ``champions`` is in ``registered_top_segments`` regardless).
 *
 * Order — mirroring the authed sibling, but ANONYMOUS + FAIL-OPEN on the limit:
 * 1. Flag-gate FIRST (``CHAMPION_GIVE_HOST_ENABLED`` off → 404 dark,
 * indistinguishable from a missing route, before any other signal);
 * 2. per-IP rate limit FAIL-OPEN (the INVERSE of the authed endpoint's
 * fail-closed posture — a printed code's landing must NEVER 429 a donor);
 * 3. resolve with the RAW ``segment`` (``ChampionService.resolve`` lowercases
 * internally — do NOT lowercase here).
 *
 * Response is the 4-field ``{charity_id, outcome, attribution_token, banner}``
 * (PV1-BE1). ``outcome`` is the hit/miss discriminator, derived from the
 * internal ``ChampionResolution.outcome``: a genuine hit (``slug`` / ``handle``
 * / ``retired_handle``) → ``"resolved"`` with the champion's current
 * active-charity id; anything collapsed to ``fallback`` → ``"fallback"`` with
 * ``charity_id=None`` (D-CQ-23: there is no fallback charity).
 * ``attribution_token`` (USER-owned resolved champions only; ref-less degrade)
 * and ``banner`` (public-safe owner display) are both ``None`` on every
 * fallback. Under D-CQ-14 the banner is a DELIBERATE disclosure of owner
 * display identity: a champion link is a public artifact whose handle/QR
 * already advertises its owner, so the banner (PublicUserOut-safe fields only)
 * adds nothing scrape-worthy — anti-enumeration rests on App-Check + the rate
 * limit + the 50-bit slug space, not on shape blending (the authoritative
 * statement lives on ``ChampionBannerOut`` / ``ChampionLandingResolveOut``).
 */
export const championsResolveChampionLandingOptions = (options: Options<ChampionsResolveChampionLandingData>) => queryOptions<ChampionsResolveChampionLandingResponse, ChampionsResolveChampionLandingError, ChampionsResolveChampionLandingResponse, ReturnType<typeof championsResolveChampionLandingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await championsResolveChampionLanding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: championsResolveChampionLandingQueryKey(options)
});

export const charitiesGetCharitiesQueryKey = (options?: Options<CharitiesGetCharitiesData>) => createQueryKey('charities-get_charities', options);

/**
 * Get Charities
 */
export const charitiesGetCharitiesOptions = (options?: Options<CharitiesGetCharitiesData>) => queryOptions<CharitiesGetCharitiesResponse, CharitiesGetCharitiesError, CharitiesGetCharitiesResponse, ReturnType<typeof charitiesGetCharitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesGetCharities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesGetCharitiesQueryKey(options)
});

/**
 * Create Charity
 */
export const charitiesCreateCharityMutation = (options?: Partial<Options<CharitiesCreateCharityData>>): UseMutationOptions<CharitiesCreateCharityResponse, CharitiesCreateCharityError, Options<CharitiesCreateCharityData>> => {
    const mutationOptions: UseMutationOptions<CharitiesCreateCharityResponse, CharitiesCreateCharityError, Options<CharitiesCreateCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charitiesCreateCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charitiesGetCharitiesByCauseTagQueryKey = (options: Options<CharitiesGetCharitiesByCauseTagData>) => createQueryKey('charities-get_charities_by_cause_tag', options);

/**
 * Get Charities By Cause Tag
 */
export const charitiesGetCharitiesByCauseTagOptions = (options: Options<CharitiesGetCharitiesByCauseTagData>) => queryOptions<CharitiesGetCharitiesByCauseTagResponse, CharitiesGetCharitiesByCauseTagError, CharitiesGetCharitiesByCauseTagResponse, ReturnType<typeof charitiesGetCharitiesByCauseTagQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesGetCharitiesByCauseTag({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesGetCharitiesByCauseTagQueryKey(options)
});

export const charitiesGetFollowsChampionedCharitiesQueryKey = (options?: Options<CharitiesGetFollowsChampionedCharitiesData>) => createQueryKey('charities-get_follows_championed_charities', options);

/**
 * Get Follows Championed Charities
 */
export const charitiesGetFollowsChampionedCharitiesOptions = (options?: Options<CharitiesGetFollowsChampionedCharitiesData>) => queryOptions<CharitiesGetFollowsChampionedCharitiesResponse, CharitiesGetFollowsChampionedCharitiesError, CharitiesGetFollowsChampionedCharitiesResponse, ReturnType<typeof charitiesGetFollowsChampionedCharitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesGetFollowsChampionedCharities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesGetFollowsChampionedCharitiesQueryKey(options)
});

export const charitiesGetFollowsDonatedCharitiesQueryKey = (options?: Options<CharitiesGetFollowsDonatedCharitiesData>) => createQueryKey('charities-get_follows_donated_charities', options);

/**
 * Get Follows Donated Charities
 */
export const charitiesGetFollowsDonatedCharitiesOptions = (options?: Options<CharitiesGetFollowsDonatedCharitiesData>) => queryOptions<CharitiesGetFollowsDonatedCharitiesResponse, CharitiesGetFollowsDonatedCharitiesError, CharitiesGetFollowsDonatedCharitiesResponse, ReturnType<typeof charitiesGetFollowsDonatedCharitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesGetFollowsDonatedCharities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesGetFollowsDonatedCharitiesQueryKey(options)
});

export const charitiesLookupCharityByDomainQueryKey = (options: Options<CharitiesLookupCharityByDomainData>) => createQueryKey('charities-lookup_charity_by_domain', options);

/**
 * Lookup Charity By Domain
 *
 * Resolve a scanned/external domain to a known charity. Intentionally
 * unauthenticated and returns a reduced payload (no internal/financial fields).
 */
export const charitiesLookupCharityByDomainOptions = (options: Options<CharitiesLookupCharityByDomainData>) => queryOptions<CharitiesLookupCharityByDomainResponse, CharitiesLookupCharityByDomainError, CharitiesLookupCharityByDomainResponse, ReturnType<typeof charitiesLookupCharityByDomainQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesLookupCharityByDomain({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesLookupCharityByDomainQueryKey(options)
});

export const charitiesGetSuggestedCharitiesQueryKey = (options?: Options<CharitiesGetSuggestedCharitiesData>) => createQueryKey('charities-get_suggested_charities', options);

/**
 * Get Suggested Charities
 */
export const charitiesGetSuggestedCharitiesOptions = (options?: Options<CharitiesGetSuggestedCharitiesData>) => queryOptions<CharitiesGetSuggestedCharitiesResponse, DefaultError, CharitiesGetSuggestedCharitiesResponse, ReturnType<typeof charitiesGetSuggestedCharitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesGetSuggestedCharities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesGetSuggestedCharitiesQueryKey(options)
});

export const charitiesGetCharityQueryKey = (options: Options<CharitiesGetCharityData>) => createQueryKey('charities-get_charity', options);

/**
 * Get Charity
 *
 * One charity, with ``legal_name`` (CPA-BE44): the name the IRS records for its EIN,
 * which the "Charity details" control shows beside the EIN; ``name`` is the name donors
 * see (a claimed charity's display name when it set one). ``legal_name`` is null when no
 * IRS legal name is on file.
 */
export const charitiesGetCharityOptions = (options: Options<CharitiesGetCharityData>) => queryOptions<CharitiesGetCharityResponse, CharitiesGetCharityError, CharitiesGetCharityResponse, ReturnType<typeof charitiesGetCharityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesGetCharity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesGetCharityQueryKey(options)
});

/**
 * Update Charity
 */
export const charitiesUpdateCharityMutation = (options?: Partial<Options<CharitiesUpdateCharityData>>): UseMutationOptions<CharitiesUpdateCharityResponse, CharitiesUpdateCharityError, Options<CharitiesUpdateCharityData>> => {
    const mutationOptions: UseMutationOptions<CharitiesUpdateCharityResponse, CharitiesUpdateCharityError, Options<CharitiesUpdateCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charitiesUpdateCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charitiesGetCauseTagsForCharityQueryKey = (options: Options<CharitiesGetCauseTagsForCharityData>) => createQueryKey('charities-get_cause_tags_for_charity', options);

/**
 * Get Cause Tags For Charity
 */
export const charitiesGetCauseTagsForCharityOptions = (options: Options<CharitiesGetCauseTagsForCharityData>) => queryOptions<CharitiesGetCauseTagsForCharityResponse, CharitiesGetCauseTagsForCharityError, CharitiesGetCauseTagsForCharityResponse, ReturnType<typeof charitiesGetCauseTagsForCharityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesGetCauseTagsForCharity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesGetCauseTagsForCharityQueryKey(options)
});

/**
 * Remove Cause Tag From Charity
 */
export const charitiesRemoveCauseTagFromCharityMutation = (options?: Partial<Options<CharitiesRemoveCauseTagFromCharityData>>): UseMutationOptions<CharitiesRemoveCauseTagFromCharityResponse, CharitiesRemoveCauseTagFromCharityError, Options<CharitiesRemoveCauseTagFromCharityData>> => {
    const mutationOptions: UseMutationOptions<CharitiesRemoveCauseTagFromCharityResponse, CharitiesRemoveCauseTagFromCharityError, Options<CharitiesRemoveCauseTagFromCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charitiesRemoveCauseTagFromCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Cause Tag To Charity
 */
export const charitiesAddCauseTagToCharityMutation = (options?: Partial<Options<CharitiesAddCauseTagToCharityData>>): UseMutationOptions<CharitiesAddCauseTagToCharityResponse, CharitiesAddCauseTagToCharityError, Options<CharitiesAddCauseTagToCharityData>> => {
    const mutationOptions: UseMutationOptions<CharitiesAddCauseTagToCharityResponse, CharitiesAddCauseTagToCharityError, Options<CharitiesAddCauseTagToCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charitiesAddCauseTagToCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Charity Donation
 */
export const donationsCreateCharityDonationMutation = (options?: Partial<Options<DonationsCreateCharityDonationData>>): UseMutationOptions<DonationsCreateCharityDonationResponse, DonationsCreateCharityDonationError, Options<DonationsCreateCharityDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateCharityDonationResponse, DonationsCreateCharityDonationError, Options<DonationsCreateCharityDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateCharityDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create External Donation
 *
 * Book an EXTERNAL donation (moves no money; ``request_match`` spawns a
 * pending company match). Authenticated + ownership-gated: the caller may only
 * book their OWN external donation (body ``user_id`` must equal the caller), a
 * super-admin included (CAM-R39, D-CAM-35). Booking on another user's behalf
 * is the dedicated, money-action-guarded ``POST /super-admin/users/{user_id}/
 * donations/external`` route — the only door the COO lane and the super-admin
 * portal use. FU-01 closed this legacy path to anonymous and arbitrary-user
 * bookings.
 */
export const donationsCreateExternalDonationMutation = (options?: Partial<Options<DonationsCreateExternalDonationData>>): UseMutationOptions<DonationsCreateExternalDonationResponse, DonationsCreateExternalDonationError, Options<DonationsCreateExternalDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateExternalDonationResponse, DonationsCreateExternalDonationError, Options<DonationsCreateExternalDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateExternalDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const grantsGetGrantsByCharityQueryKey = (options: Options<GrantsGetGrantsByCharityData>) => createQueryKey('grants-get_grants_by_charity', options);

/**
 * Get Grants By Charity
 */
export const grantsGetGrantsByCharityOptions = (options: Options<GrantsGetGrantsByCharityData>) => queryOptions<GrantsGetGrantsByCharityResponse, GrantsGetGrantsByCharityError, GrantsGetGrantsByCharityResponse, ReturnType<typeof grantsGetGrantsByCharityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await grantsGetGrantsByCharity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: grantsGetGrantsByCharityQueryKey(options)
});

export const matchOffersListCharityMatchOffersQueryKey = (options: Options<MatchOffersListCharityMatchOffersData>) => createQueryKey('match-offers-list_charity_match_offers', options);

/**
 * List Charity Match Offers
 *
 * The claim-banner read (03 §2.4): the engine's claim-candidate offers for
 * the charity, oldest-first (the banner's first row IS the offer a
 * claim-eligible donation would claim — 02 §1.3 "display matches the engine"),
 * LIVE remaining off the row. PUBLIC read (``user`` may be None); when a valid
 * token IS presented, the middleware-resolved user feeds the ADDITIVE
 * ``is_own_offer`` flag (PV2-BE7 — never the offeror's user id). Each row also
 * carries ``leg_count``, the §1.3 canonical-line N ("one of N offers backed by
 * the same fund"). Respects the publicize_consent →
 * display-name-or-"A Givmo member" masking rule.
 */
export const matchOffersListCharityMatchOffersOptions = (options: Options<MatchOffersListCharityMatchOffersData>) => queryOptions<MatchOffersListCharityMatchOffersResponse, MatchOffersListCharityMatchOffersError, MatchOffersListCharityMatchOffersResponse, ReturnType<typeof matchOffersListCharityMatchOffersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await matchOffersListCharityMatchOffers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: matchOffersListCharityMatchOffersQueryKey(options)
});

/**
 * Upload Charity Profile Picture
 */
export const charitiesUploadCharityProfilePictureMutation = (options?: Partial<Options<CharitiesUploadCharityProfilePictureData>>): UseMutationOptions<CharitiesUploadCharityProfilePictureResponse, CharitiesUploadCharityProfilePictureError, Options<CharitiesUploadCharityProfilePictureData>> => {
    const mutationOptions: UseMutationOptions<CharitiesUploadCharityProfilePictureResponse, CharitiesUploadCharityProfilePictureError, Options<CharitiesUploadCharityProfilePictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charitiesUploadCharityProfilePicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Charity Recurring Donation
 */
export const donationsCreateCharityRecurringDonationMutation = (options?: Partial<Options<DonationsCreateCharityRecurringDonationData>>): UseMutationOptions<DonationsCreateCharityRecurringDonationResponse, DonationsCreateCharityRecurringDonationError, Options<DonationsCreateCharityRecurringDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateCharityRecurringDonationResponse, DonationsCreateCharityRecurringDonationError, Options<DonationsCreateCharityRecurringDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateCharityRecurringDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardAgendaTemplatesQueryKey = (options: Options<CharityBoardListBoardAgendaTemplatesData>) => createQueryKey('charity-board-list_board_agenda_templates', options);

/**
 * List Board Agenda Templates
 *
 * The neutral agenda templates a charity may select.
 *
 * Structural sections only. Nothing in a template is drawn from any charity's own
 * documents, calendar, or history, and nothing applies one — the charity names the
 * template it wants. `suggested_for` orders a human's picker and is read by nothing.
 */
export const charityBoardListBoardAgendaTemplatesOptions = (options: Options<CharityBoardListBoardAgendaTemplatesData>) => queryOptions<CharityBoardListBoardAgendaTemplatesResponse, CharityBoardListBoardAgendaTemplatesError, CharityBoardListBoardAgendaTemplatesResponse, ReturnType<typeof charityBoardListBoardAgendaTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardAgendaTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardAgendaTemplatesQueryKey(options)
});

export const charityBoardListBoardCalendarConnectionsQueryKey = (options: Options<CharityBoardListBoardCalendarConnectionsData>) => createQueryKey('charity-board-list_board_calendar_connections', options);

/**
 * List Board Calendar Connections
 *
 * Every calendar connected for the board, with the upcoming meetings each one sends (the
 * handover view), in the canonical `{data, meta, links}` envelope.
 */
export const charityBoardListBoardCalendarConnectionsOptions = (options: Options<CharityBoardListBoardCalendarConnectionsData>) => queryOptions<CharityBoardListBoardCalendarConnectionsResponse, CharityBoardListBoardCalendarConnectionsError, CharityBoardListBoardCalendarConnectionsResponse, ReturnType<typeof charityBoardListBoardCalendarConnectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCalendarConnections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCalendarConnectionsQueryKey(options)
});

/**
 * Move Board Calendar Meetings
 *
 * Move every upcoming meeting one calendar sends to another sender in one act (directors
 * get one cancellation and one new invitation each), or stop keeping them in step.
 */
export const charityBoardMoveBoardCalendarMeetingsMutation = (options?: Partial<Options<CharityBoardMoveBoardCalendarMeetingsData>>): UseMutationOptions<CharityBoardMoveBoardCalendarMeetingsResponse, CharityBoardMoveBoardCalendarMeetingsError, Options<CharityBoardMoveBoardCalendarMeetingsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardMoveBoardCalendarMeetingsResponse, CharityBoardMoveBoardCalendarMeetingsError, Options<CharityBoardMoveBoardCalendarMeetingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardMoveBoardCalendarMeetings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardCalendarSendersQueryKey = (options: Options<CharityBoardListBoardCalendarSendersData>) => createQueryKey('charity-board-list_board_calendar_senders', options);

/**
 * List Board Calendar Senders
 *
 * Who can send this charity's meeting invitations, in order: the officer's own connected
 * calendar, then the board account — and whether the officer can connect their own calendar
 * here.
 */
export const charityBoardListBoardCalendarSendersOptions = (options: Options<CharityBoardListBoardCalendarSendersData>) => queryOptions<CharityBoardListBoardCalendarSendersResponse, CharityBoardListBoardCalendarSendersError, CharityBoardListBoardCalendarSendersResponse, ReturnType<typeof charityBoardListBoardCalendarSendersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCalendarSenders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCalendarSendersQueryKey(options)
});

export const charityBoardGetBoardCalendarSettingsQueryKey = (options: Options<CharityBoardGetBoardCalendarSettingsData>) => createQueryKey('charity-board-get_board_calendar_settings', options);

/**
 * Get Board Calendar Settings
 *
 * The board's calendar settings: whether directors may change a meeting's details in
 * their calendar, propose new times and see the guest list, and whether invitations use the
 * meetings' own titles. The shipped defaults until an Owner adopts settings.
 */
export const charityBoardGetBoardCalendarSettingsOptions = (options: Options<CharityBoardGetBoardCalendarSettingsData>) => queryOptions<CharityBoardGetBoardCalendarSettingsResponse, CharityBoardGetBoardCalendarSettingsError, CharityBoardGetBoardCalendarSettingsResponse, ReturnType<typeof charityBoardGetBoardCalendarSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCalendarSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCalendarSettingsQueryKey(options)
});

/**
 * Adopt Board Calendar Settings
 *
 * Adopt the board's calendar settings (all four). They apply to meetings sent from now
 * on; "Apply to upcoming meetings" applies them to meetings already sent.
 */
export const charityBoardAdoptBoardCalendarSettingsMutation = (options?: Partial<Options<CharityBoardAdoptBoardCalendarSettingsData>>): UseMutationOptions<CharityBoardAdoptBoardCalendarSettingsResponse, CharityBoardAdoptBoardCalendarSettingsError, Options<CharityBoardAdoptBoardCalendarSettingsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAdoptBoardCalendarSettingsResponse, CharityBoardAdoptBoardCalendarSettingsError, Options<CharityBoardAdoptBoardCalendarSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAdoptBoardCalendarSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply Board Calendar Settings
 *
 * Apply the board's calendar settings to every upcoming meeting already sent from a
 * connected calendar.
 */
export const charityBoardApplyBoardCalendarSettingsMutation = (options?: Partial<Options<CharityBoardApplyBoardCalendarSettingsData>>): UseMutationOptions<CharityBoardApplyBoardCalendarSettingsResponse, CharityBoardApplyBoardCalendarSettingsError, Options<CharityBoardApplyBoardCalendarSettingsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardApplyBoardCalendarSettingsResponse, CharityBoardApplyBoardCalendarSettingsError, Options<CharityBoardApplyBoardCalendarSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardApplyBoardCalendarSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardCarryForwardItemsQueryKey = (options: Options<CharityBoardListBoardCarryForwardItemsData>) => createQueryKey('charity-board-list_board_carry_forward_items', options);

/**
 * List Board Carry Forward Items
 *
 * Prior meetings' agenda items the charity marked as left open.
 *
 * Exactly what the charity marked, and nothing else. An item nobody dispositioned does
 * not appear here — deciding on the charity's behalf that a past item is unfinished
 * business would be the module making a governance judgment.
 */
export const charityBoardListBoardCarryForwardItemsOptions = (options: Options<CharityBoardListBoardCarryForwardItemsData>) => queryOptions<CharityBoardListBoardCarryForwardItemsResponse, CharityBoardListBoardCarryForwardItemsError, CharityBoardListBoardCarryForwardItemsResponse, ReturnType<typeof charityBoardListBoardCarryForwardItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCarryForwardItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCarryForwardItemsQueryKey(options)
});

export const charityBoardListBoardCarryForwardMotionsQueryKey = (options: Options<CharityBoardListBoardCarryForwardMotionsData>) => createQueryKey('charity-board-list_board_carry_forward_motions', options);

/**
 * List Board Carry Forward Motions
 *
 * Motions from past meetings that are still before the board.
 *
 * The companion of the carry-forward agenda items on the meetings surface: together they
 * are what an officer building the next agenda needs to see. Both report only what the
 * charity itself left open — a motion nobody withdrew and nobody voted on — and neither
 * infers that anything else is unfinished business.
 *
 * A motion made inside a closed session this reader was not part of does not appear.
 */
export const charityBoardListBoardCarryForwardMotionsOptions = (options: Options<CharityBoardListBoardCarryForwardMotionsData>) => queryOptions<CharityBoardListBoardCarryForwardMotionsResponse, CharityBoardListBoardCarryForwardMotionsError, CharityBoardListBoardCarryForwardMotionsResponse, ReturnType<typeof charityBoardListBoardCarryForwardMotionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCarryForwardMotions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCarryForwardMotionsQueryKey(options)
});

export const charityBoardListBoardCoiCyclesQueryKey = (options: Options<CharityBoardListBoardCoiCyclesData>) => createQueryKey('charity-board-list_board_coi_cycles', options);

/**
 * List Board Coi Cycles
 *
 * Every year's annual disclosures, newest first: each one's dates, status and count of
 * submissions (never a count of conflicts).
 */
export const charityBoardListBoardCoiCyclesOptions = (options: Options<CharityBoardListBoardCoiCyclesData>) => queryOptions<CharityBoardListBoardCoiCyclesResponse, CharityBoardListBoardCoiCyclesError, CharityBoardListBoardCoiCyclesResponse, ReturnType<typeof charityBoardListBoardCoiCyclesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCoiCycles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCoiCyclesQueryKey(options)
});

/**
 * Open Board Coi Cycle
 *
 * Start a year's annual conflict-of-interest disclosures: everyone on the roster is asked,
 * with Givmo's starting questionnaire (any question turned off) and the organization's own
 * policy from Governance, if it holds one. Each person is emailed the request; a seat no
 * account has joined gets an invitation to join with it.
 */
export const charityBoardOpenBoardCoiCycleMutation = (options?: Partial<Options<CharityBoardOpenBoardCoiCycleData>>): UseMutationOptions<CharityBoardOpenBoardCoiCycleResponse, CharityBoardOpenBoardCoiCycleError, Options<CharityBoardOpenBoardCoiCycleData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardOpenBoardCoiCycleResponse, CharityBoardOpenBoardCoiCycleError, Options<CharityBoardOpenBoardCoiCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardOpenBoardCoiCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardCoiCycleQueryKey = (options: Options<CharityBoardGetBoardCoiCycleData>) => createQueryKey('charity-board-get_board_coi_cycle', options);

/**
 * Get Board Coi Cycle
 *
 * One year's annual disclosures: who was asked, who has submitted and when, what was sent
 * and when, and who can be reminded now.
 */
export const charityBoardGetBoardCoiCycleOptions = (options: Options<CharityBoardGetBoardCoiCycleData>) => queryOptions<CharityBoardGetBoardCoiCycleResponse, CharityBoardGetBoardCoiCycleError, CharityBoardGetBoardCoiCycleResponse, ReturnType<typeof charityBoardGetBoardCoiCycleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCoiCycle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCoiCycleQueryKey(options)
});

/**
 * Update Board Coi Cycle
 *
 * Change an open year's due date. Recorded in the year's log; sends nothing.
 */
export const charityBoardUpdateBoardCoiCycleMutation = (options?: Partial<Options<CharityBoardUpdateBoardCoiCycleData>>): UseMutationOptions<CharityBoardUpdateBoardCoiCycleResponse, CharityBoardUpdateBoardCoiCycleError, Options<CharityBoardUpdateBoardCoiCycleData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardCoiCycleResponse, CharityBoardUpdateBoardCoiCycleError, Options<CharityBoardUpdateBoardCoiCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardCoiCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Board Coi Cycle
 *
 * Withdraw a year opened by mistake, before anyone has answered. Nothing is added to the
 * minute book.
 */
export const charityBoardCancelBoardCoiCycleMutation = (options?: Partial<Options<CharityBoardCancelBoardCoiCycleData>>): UseMutationOptions<CharityBoardCancelBoardCoiCycleResponse, CharityBoardCancelBoardCoiCycleError, Options<CharityBoardCancelBoardCoiCycleData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCancelBoardCoiCycleResponse, CharityBoardCancelBoardCoiCycleError, Options<CharityBoardCancelBoardCoiCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCancelBoardCoiCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close Board Coi Cycle
 *
 * Close the year. Adds one record to the minute book: who was asked, and who submitted and
 * when. It names no one's interests. Anyone who hasn't submitted can still send their answers
 * afterwards; theirs are recorded as received after the year closed.
 */
export const charityBoardCloseBoardCoiCycleMutation = (options?: Partial<Options<CharityBoardCloseBoardCoiCycleData>>): UseMutationOptions<CharityBoardCloseBoardCoiCycleResponse, CharityBoardCloseBoardCoiCycleError, Options<CharityBoardCloseBoardCoiCycleData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCloseBoardCoiCycleResponse, CharityBoardCloseBoardCoiCycleError, Options<CharityBoardCloseBoardCoiCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCloseBoardCoiCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardCoiCycleDocumentQueryKey = (options: Options<CharityBoardGetBoardCoiCycleDocumentData>) => createQueryKey('charity-board-get_board_coi_cycle_document', options);

/**
 * Get Board Coi Cycle Document
 *
 * Every response submitted for the year, in one PDF.
 */
export const charityBoardGetBoardCoiCycleDocumentOptions = (options: Options<CharityBoardGetBoardCoiCycleDocumentData>) => queryOptions<CharityBoardGetBoardCoiCycleDocumentResponse, CharityBoardGetBoardCoiCycleDocumentError, CharityBoardGetBoardCoiCycleDocumentResponse, ReturnType<typeof charityBoardGetBoardCoiCycleDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCoiCycleDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCoiCycleDocumentQueryKey(options)
});

export const charityBoardGetBoardCoiPaperFormQueryKey = (options: Options<CharityBoardGetBoardCoiPaperFormData>) => createQueryKey('charity-board-get_board_coi_paper_form', options);

/**
 * Get Board Coi Paper Form
 *
 * A paper form for one person to fill in and sign: the year's questions as they're asked
 * them, with their answers from last year where there are any.
 */
export const charityBoardGetBoardCoiPaperFormOptions = (options: Options<CharityBoardGetBoardCoiPaperFormData>) => queryOptions<CharityBoardGetBoardCoiPaperFormResponse, CharityBoardGetBoardCoiPaperFormError, CharityBoardGetBoardCoiPaperFormResponse, ReturnType<typeof charityBoardGetBoardCoiPaperFormQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCoiPaperForm({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCoiPaperFormQueryKey(options)
});

export const charityBoardGetBoardCoiPersonQuestionnaireQueryKey = (options: Options<CharityBoardGetBoardCoiPersonQuestionnaireData>) => createQueryKey('charity-board-get_board_coi_person_questionnaire', options);

/**
 * Get Board Coi Person Questionnaire
 *
 * One person's questionnaire for the year, for entering their signed paper form: the
 * questions as they're asked them, the board's policy, their answers from last year where there
 * are any, and whether a first answer can be recorded for them now (CBG-YR2-BE5).
 */
export const charityBoardGetBoardCoiPersonQuestionnaireOptions = (options: Options<CharityBoardGetBoardCoiPersonQuestionnaireData>) => queryOptions<CharityBoardGetBoardCoiPersonQuestionnaireResponse, CharityBoardGetBoardCoiPersonQuestionnaireError, CharityBoardGetBoardCoiPersonQuestionnaireResponse, ReturnType<typeof charityBoardGetBoardCoiPersonQuestionnaireQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCoiPersonQuestionnaire({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCoiPersonQuestionnaireQueryKey(options)
});

/**
 * Remind Board Coi Cycle Recipients
 *
 * Remind people who haven't sent their answers yet. Each gets one email, at most once a day.
 * Reminders go only when you send them. Name the people in `board_member_ids`, or send null for
 * everyone who can be reminded now.
 */
export const charityBoardRemindBoardCoiCycleRecipientsMutation = (options?: Partial<Options<CharityBoardRemindBoardCoiCycleRecipientsData>>): UseMutationOptions<CharityBoardRemindBoardCoiCycleRecipientsResponse, CharityBoardRemindBoardCoiCycleRecipientsError, Options<CharityBoardRemindBoardCoiCycleRecipientsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemindBoardCoiCycleRecipientsResponse, CharityBoardRemindBoardCoiCycleRecipientsError, Options<CharityBoardRemindBoardCoiCycleRecipientsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemindBoardCoiCycleRecipients({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Board Coi Cycle Requests
 *
 * Send the year's questionnaire to people who haven't been sent it — someone who joined the
 * board since it started, say. A seat that hasn't joined Board yet gets an invitation with it.
 * Name the people in `board_member_ids`, or send null for everyone it can go to.
 */
export const charityBoardSendBoardCoiCycleRequestsMutation = (options?: Partial<Options<CharityBoardSendBoardCoiCycleRequestsData>>): UseMutationOptions<CharityBoardSendBoardCoiCycleRequestsResponse, CharityBoardSendBoardCoiCycleRequestsError, Options<CharityBoardSendBoardCoiCycleRequestsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSendBoardCoiCycleRequestsResponse, CharityBoardSendBoardCoiCycleRequestsError, Options<CharityBoardSendBoardCoiCycleRequestsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSendBoardCoiCycleRequests({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Coi Paper Response
 *
 * Record a person's signed paper form. Their answers become their disclosure for the year,
 * recorded as entered by you from paper, with your note saying where it came from. Someone who
 * joined the board after the year started is added to it by this, with no email.
 */
export const charityBoardRecordBoardCoiPaperResponseMutation = (options?: Partial<Options<CharityBoardRecordBoardCoiPaperResponseData>>): UseMutationOptions<CharityBoardRecordBoardCoiPaperResponseResponse, CharityBoardRecordBoardCoiPaperResponseError, Options<CharityBoardRecordBoardCoiPaperResponseData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardCoiPaperResponseResponse, CharityBoardRecordBoardCoiPaperResponseError, Options<CharityBoardRecordBoardCoiPaperResponseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardCoiPaperResponse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardCoiResponseQueryKey = (options: Options<CharityBoardGetBoardCoiResponseData>) => createQueryKey('charity-board-get_board_coi_response', options);

/**
 * Get Board Coi Response
 *
 * One person's answers for the year, as recorded: every question as they were asked it, with
 * their answer, how it was signed or recorded, and its fingerprint.
 */
export const charityBoardGetBoardCoiResponseOptions = (options: Options<CharityBoardGetBoardCoiResponseData>) => queryOptions<CharityBoardGetBoardCoiResponseResponse, CharityBoardGetBoardCoiResponseError, CharityBoardGetBoardCoiResponseResponse, ReturnType<typeof charityBoardGetBoardCoiResponseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCoiResponse({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCoiResponseQueryKey(options)
});

export const charityBoardGetBoardCoiResponseChangesQueryKey = (options: Options<CharityBoardGetBoardCoiResponseChangesData>) => createQueryKey('charity-board-get_board_coi_response_changes', options);

/**
 * Get Board Coi Response Changes
 *
 * One person's answers for the year against their answers from the year before, question by
 * question: what changed, what was added and what was removed, with both records' fingerprints.
 * Made from the two recorded disclosures; not itself a record.
 */
export const charityBoardGetBoardCoiResponseChangesOptions = (options: Options<CharityBoardGetBoardCoiResponseChangesData>) => queryOptions<CharityBoardGetBoardCoiResponseChangesResponse, CharityBoardGetBoardCoiResponseChangesError, CharityBoardGetBoardCoiResponseChangesResponse, ReturnType<typeof charityBoardGetBoardCoiResponseChangesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCoiResponseChanges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCoiResponseChangesQueryKey(options)
});

export const charityBoardGetBoardCoiResponseDocumentQueryKey = (options: Options<CharityBoardGetBoardCoiResponseDocumentData>) => createQueryKey('charity-board-get_board_coi_response_document', options);

/**
 * Get Board Coi Response Document
 *
 * One person's answers for the year as a PDF: the answers as recorded, or the changes from
 * the year before. `time_zone` (an IANA name) sets the zone its times print in; UTC otherwise.
 */
export const charityBoardGetBoardCoiResponseDocumentOptions = (options: Options<CharityBoardGetBoardCoiResponseDocumentData>) => queryOptions<CharityBoardGetBoardCoiResponseDocumentResponse, CharityBoardGetBoardCoiResponseDocumentError, CharityBoardGetBoardCoiResponseDocumentResponse, ReturnType<typeof charityBoardGetBoardCoiResponseDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCoiResponseDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCoiResponseDocumentQueryKey(options)
});

export const charityBoardListBoardCoiQuestionnairesQueryKey = (options: Options<CharityBoardListBoardCoiQuestionnairesData>) => createQueryKey('charity-board-list_board_coi_questionnaires', options);

/**
 * List Board Coi Questionnaires
 *
 * Givmo's starting conflict-of-interest questionnaires this organization is offered: each
 * with its provenance, its IRS sources and the review-with-counsel line. A template, never a
 * statement that a questionnaire is required or sufficient.
 */
export const charityBoardListBoardCoiQuestionnairesOptions = (options: Options<CharityBoardListBoardCoiQuestionnairesData>) => queryOptions<CharityBoardListBoardCoiQuestionnairesResponse, CharityBoardListBoardCoiQuestionnairesError, CharityBoardListBoardCoiQuestionnairesResponse, ReturnType<typeof charityBoardListBoardCoiQuestionnairesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCoiQuestionnaires({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCoiQuestionnairesQueryKey(options)
});

export const charityBoardGetBoardCoiQuestionnaireQueryKey = (options: Options<CharityBoardGetBoardCoiQuestionnaireData>) => createQueryKey('charity-board-get_board_coi_questionnaire', options);

/**
 * Get Board Coi Questionnaire
 *
 * One starting questionnaire with every question: its words, whom it is asked of (the
 * independence question is asked of directors only), the IRS text it is drawn from, and its
 * "What counts" lines.
 */
export const charityBoardGetBoardCoiQuestionnaireOptions = (options: Options<CharityBoardGetBoardCoiQuestionnaireData>) => queryOptions<CharityBoardGetBoardCoiQuestionnaireResponse, CharityBoardGetBoardCoiQuestionnaireError, CharityBoardGetBoardCoiQuestionnaireResponse, ReturnType<typeof charityBoardGetBoardCoiQuestionnaireQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCoiQuestionnaire({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCoiQuestionnaireQueryKey(options)
});

export const charityBoardListBoardCommitteeSourcesQueryKey = (options: Options<CharityBoardListBoardCommitteeSourcesData>) => createQueryKey('charity-board-list_board_committee_sources', options);

/**
 * List Board Committee Sources
 *
 * What a committee's establishment, its dissolution or a member's appointment may be linked
 * to: motions recorded as carried, executed written consents and records in the minute book,
 * each one you may read, the most recent first.
 */
export const charityBoardListBoardCommitteeSourcesOptions = (options: Options<CharityBoardListBoardCommitteeSourcesData>) => queryOptions<CharityBoardListBoardCommitteeSourcesResponse, CharityBoardListBoardCommitteeSourcesError, CharityBoardListBoardCommitteeSourcesResponse, ReturnType<typeof charityBoardListBoardCommitteeSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCommitteeSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCommitteeSourcesQueryKey(options)
});

export const charityBoardListBoardCommitteesQueryKey = (options: Options<CharityBoardListBoardCommitteesData>) => createQueryKey('charity-board-list_board_committees', options);

/**
 * List Board Committees
 *
 * Your board's committees: the ones that stand first, by name, then those dissolved, the
 * most recent first. Each carries its chair and, where your organization's type is asked,
 * your organization's answer about its authority to act for the board, as recorded.
 */
export const charityBoardListBoardCommitteesOptions = (options: Options<CharityBoardListBoardCommitteesData>) => queryOptions<CharityBoardListBoardCommitteesResponse, CharityBoardListBoardCommitteesError, CharityBoardListBoardCommitteesResponse, ReturnType<typeof charityBoardListBoardCommitteesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCommittees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCommitteesQueryKey(options)
});

/**
 * Create Board Committee
 *
 * Add a committee: its name, standing or ad hoc, when it was established and where that is
 * recorded. With `charter_form_id`, the committee keeps the form's id and holds the charter
 * label its name gives; its charter is then drafted from the form like any governing document.
 * No record is written here. A name an active committee already has is a 409
 * `board_committee_name_taken`.
 */
export const charityBoardCreateBoardCommitteeMutation = (options?: Partial<Options<CharityBoardCreateBoardCommitteeData>>): UseMutationOptions<CharityBoardCreateBoardCommitteeResponse, CharityBoardCreateBoardCommitteeError, Options<CharityBoardCreateBoardCommitteeData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardCommitteeResponse, CharityBoardCreateBoardCommitteeError, Options<CharityBoardCreateBoardCommitteeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardCommittee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardCommitteeQueryKey = (options: Options<CharityBoardGetBoardCommitteeData>) => createQueryKey('charity-board-get_board_committee', options);

/**
 * Get Board Committee
 *
 * One committee: its record, its members, its rules and where its acts are recorded, as far
 * as you may read them. Its charter is the committee charter recorded under its
 * `charter_label` (the governing documents read, by that label).
 */
export const charityBoardGetBoardCommitteeOptions = (options: Options<CharityBoardGetBoardCommitteeData>) => queryOptions<CharityBoardGetBoardCommitteeResponse, CharityBoardGetBoardCommitteeError, CharityBoardGetBoardCommitteeResponse, ReturnType<typeof charityBoardGetBoardCommitteeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCommittee({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCommitteeQueryKey(options)
});

/**
 * Update Board Committee
 *
 * Change a committee's name, kind, establishment date or where its establishment is
 * recorded. Send only what changes; `null` clears the date, and a `null` `recorded_in` makes
 * it your own entry. A renamed committee keeps its charter's label. A dissolved committee isn't
 * changed (409 `board_committee_dissolved`).
 */
export const charityBoardUpdateBoardCommitteeMutation = (options?: Partial<Options<CharityBoardUpdateBoardCommitteeData>>): UseMutationOptions<CharityBoardUpdateBoardCommitteeResponse, CharityBoardUpdateBoardCommitteeError, Options<CharityBoardUpdateBoardCommitteeData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardCommitteeResponse, CharityBoardUpdateBoardCommitteeError, Options<CharityBoardUpdateBoardCommitteeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardCommittee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link Board Committee Charter
 *
 * The committee charter a committee holds, by the label its versions are recorded under. No
 * record changes. A label another committee holds is a 409
 * `board_committee_charter_label_taken`.
 */
export const charityBoardLinkBoardCommitteeCharterMutation = (options?: Partial<Options<CharityBoardLinkBoardCommitteeCharterData>>): UseMutationOptions<CharityBoardLinkBoardCommitteeCharterResponse, CharityBoardLinkBoardCommitteeCharterError, Options<CharityBoardLinkBoardCommitteeCharterData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardLinkBoardCommitteeCharterResponse, CharityBoardLinkBoardCommitteeCharterError, Options<CharityBoardLinkBoardCommitteeCharterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardLinkBoardCommitteeCharter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Board Committee Confirmation
 *
 * Whether the committee's decisions are suggested for the board's next meeting, and where the
 * organization wrote that practice down. Recorded in the committee's history, and reversible;
 * turning it off clears where it is written. Nothing waits on it: a committee's decisions stand as
 * recorded either way. A dissolved committee is a 409 `board_committee_dissolved`.
 */
export const charityBoardSetBoardCommitteeConfirmationMutation = (options?: Partial<Options<CharityBoardSetBoardCommitteeConfirmationData>>): UseMutationOptions<CharityBoardSetBoardCommitteeConfirmationResponse, CharityBoardSetBoardCommitteeConfirmationError, Options<CharityBoardSetBoardCommitteeConfirmationData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSetBoardCommitteeConfirmationResponse, CharityBoardSetBoardCommitteeConfirmationError, Options<CharityBoardSetBoardCommitteeConfirmationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSetBoardCommitteeConfirmation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dissolve Board Committee
 *
 * Dissolve a committee: the date, where it is recorded, and your note. Every membership ends
 * with it, and everything recorded about it stays. A dissolved committee answers as it is.
 */
export const charityBoardDissolveBoardCommitteeMutation = (options?: Partial<Options<CharityBoardDissolveBoardCommitteeData>>): UseMutationOptions<CharityBoardDissolveBoardCommitteeResponse, CharityBoardDissolveBoardCommitteeError, Options<CharityBoardDissolveBoardCommitteeData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDissolveBoardCommitteeResponse, CharityBoardDissolveBoardCommitteeError, Options<CharityBoardDissolveBoardCommitteeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDissolveBoardCommittee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Correct Board Committee Dissolution
 *
 * Correct a dissolution made by mistake, saying why: the committee stands again, with the
 * memberships its dissolution ended, for everyone still serving on the board.
 */
export const charityBoardCorrectBoardCommitteeDissolutionMutation = (options?: Partial<Options<CharityBoardCorrectBoardCommitteeDissolutionData>>): UseMutationOptions<CharityBoardCorrectBoardCommitteeDissolutionResponse, CharityBoardCorrectBoardCommitteeDissolutionError, Options<CharityBoardCorrectBoardCommitteeDissolutionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCorrectBoardCommitteeDissolutionResponse, CharityBoardCorrectBoardCommitteeDissolutionError, Options<CharityBoardCorrectBoardCommitteeDissolutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCorrectBoardCommitteeDissolution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Board Committee Member
 *
 * Add someone on your board's roster to a committee, director or not. `votes` is your
 * organization's record of whether they vote on the committee: yes unless you say otherwise.
 * Someone no longer serving is a 409 `board_committee_member_not_serving`; a second chair, a
 * 409 `board_committee_chair_taken`.
 */
export const charityBoardAddBoardCommitteeMemberMutation = (options?: Partial<Options<CharityBoardAddBoardCommitteeMemberData>>): UseMutationOptions<CharityBoardAddBoardCommitteeMemberResponse, CharityBoardAddBoardCommitteeMemberError, Options<CharityBoardAddBoardCommitteeMemberData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAddBoardCommitteeMemberResponse, CharityBoardAddBoardCommitteeMemberError, Options<CharityBoardAddBoardCommitteeMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAddBoardCommitteeMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Board Committee Member
 *
 * Change a committee member's role, whether they vote on the committee, their dates, or
 * where their appointment is recorded. Send only what changes. A membership that has ended
 * isn't changed (409 `board_committee_member_ended`).
 */
export const charityBoardUpdateBoardCommitteeMemberMutation = (options?: Partial<Options<CharityBoardUpdateBoardCommitteeMemberData>>): UseMutationOptions<CharityBoardUpdateBoardCommitteeMemberResponse, CharityBoardUpdateBoardCommitteeMemberError, Options<CharityBoardUpdateBoardCommitteeMemberData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardCommitteeMemberResponse, CharityBoardUpdateBoardCommitteeMemberError, Options<CharityBoardUpdateBoardCommitteeMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardCommitteeMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * End Board Committee Member
 *
 * End someone's membership of a committee, with their last day if you have one, and your
 * note. An ended membership answers as it is.
 */
export const charityBoardEndBoardCommitteeMemberMutation = (options?: Partial<Options<CharityBoardEndBoardCommitteeMemberData>>): UseMutationOptions<CharityBoardEndBoardCommitteeMemberResponse, CharityBoardEndBoardCommitteeMemberError, Options<CharityBoardEndBoardCommitteeMemberData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardEndBoardCommitteeMemberResponse, CharityBoardEndBoardCommitteeMemberError, Options<CharityBoardEndBoardCommitteeMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardEndBoardCommitteeMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Committee Rule
 *
 * Record one of a committee's rules, replacing the one in force, which stays in its history:
 * its notice period, its quorum, how its minutes are approved, or your organization's answer
 * about its authority to act for the board. `citation`, the section of your governing documents
 * the rule comes from, is required. Givmo doesn't read your governing documents.
 */
export const charityBoardRecordBoardCommitteeRuleMutation = (options?: Partial<Options<CharityBoardRecordBoardCommitteeRuleData>>): UseMutationOptions<CharityBoardRecordBoardCommitteeRuleResponse, CharityBoardRecordBoardCommitteeRuleError, Options<CharityBoardRecordBoardCommitteeRuleData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardCommitteeRuleResponse, CharityBoardRecordBoardCommitteeRuleError, Options<CharityBoardRecordBoardCommitteeRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardCommitteeRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardCompensationDecisionsQueryKey = (options: Options<CharityBoardListBoardCompensationDecisionsData>) => createQueryKey('charity-board-list_board_compensation_decisions', options);

/**
 * List Board Compensation Decisions
 *
 * Every compensation decision you may read, grouped by person, newest first: each in the
 * regulation's order — the decision and its date, who took part, what the board relied on, and
 * when it was written down beside the date the regulation's rule gives. Facts the record holds;
 * Board answers no Form 990 question.
 */
export const charityBoardListBoardCompensationDecisionsOptions = (options: Options<CharityBoardListBoardCompensationDecisionsData>) => queryOptions<CharityBoardListBoardCompensationDecisionsResponse, CharityBoardListBoardCompensationDecisionsError, CharityBoardListBoardCompensationDecisionsResponse, ReturnType<typeof charityBoardListBoardCompensationDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardCompensationDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardCompensationDecisionsQueryKey(options)
});

/**
 * Record Board Compensation Index Entry
 *
 * Add a decision from your records: label minutes, a resolution or a written consent already
 * in the minute book (approved or imported) as recording the board's decision on one person's
 * pay, with where in that record it appears. The record itself never changes.
 */
export const charityBoardRecordBoardCompensationIndexEntryMutation = (options?: Partial<Options<CharityBoardRecordBoardCompensationIndexEntryData>>): UseMutationOptions<CharityBoardRecordBoardCompensationIndexEntryResponse, CharityBoardRecordBoardCompensationIndexEntryError, Options<CharityBoardRecordBoardCompensationIndexEntryData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardCompensationIndexEntryResponse, CharityBoardRecordBoardCompensationIndexEntryError, Options<CharityBoardRecordBoardCompensationIndexEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardCompensationIndexEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Board Compensation Index Entry
 *
 * Remove a decision added from your records. A decision recorded on a motion or a written
 * consent is removed there.
 */
export const charityBoardRemoveBoardCompensationIndexEntryMutation = (options?: Partial<Options<CharityBoardRemoveBoardCompensationIndexEntryData>>): UseMutationOptions<CharityBoardRemoveBoardCompensationIndexEntryResponse, CharityBoardRemoveBoardCompensationIndexEntryError, Options<CharityBoardRemoveBoardCompensationIndexEntryData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardCompensationIndexEntryResponse, CharityBoardRemoveBoardCompensationIndexEntryError, Options<CharityBoardRemoveBoardCompensationIndexEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardCompensationIndexEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardCompensationDecisionQueryKey = (options: Options<CharityBoardGetBoardCompensationDecisionData>) => createQueryKey('charity-board-get_board_compensation_decision', options);

/**
 * Get Board Compensation Decision
 *
 * One compensation decision, in the regulation's order, with its history: who recorded and
 * changed it, and when.
 */
export const charityBoardGetBoardCompensationDecisionOptions = (options: Options<CharityBoardGetBoardCompensationDecisionData>) => queryOptions<CharityBoardGetBoardCompensationDecisionResponse, CharityBoardGetBoardCompensationDecisionError, CharityBoardGetBoardCompensationDecisionResponse, ReturnType<typeof charityBoardGetBoardCompensationDecisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCompensationDecision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCompensationDecisionQueryKey(options)
});

/**
 * Update Board Compensation Decision
 *
 * Change an index entry's details, or any decision's two labels — your Form 990 answer for
 * the person (line 15a or 15b, a charity's only) and the link to the person's seat — which print
 * nowhere and change at any time. A field you send as null is cleared; one you leave out is
 * kept.
 */
export const charityBoardUpdateBoardCompensationDecisionMutation = (options?: Partial<Options<CharityBoardUpdateBoardCompensationDecisionData>>): UseMutationOptions<CharityBoardUpdateBoardCompensationDecisionResponse, CharityBoardUpdateBoardCompensationDecisionError, Options<CharityBoardUpdateBoardCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardCompensationDecisionResponse, CharityBoardUpdateBoardCompensationDecisionError, Options<CharityBoardUpdateBoardCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardCompensationDecisionDocumentDownloadQueryKey = (options: Options<CharityBoardGetBoardCompensationDecisionDocumentDownloadData>) => createQueryKey('charity-board-get_board_compensation_decision_document_download', options);

/**
 * Get Board Compensation Decision Document Download
 *
 * A short-lived link to one document a compensation decision names, one of its meeting's
 * papers or a document uploaded onto a written consent: the exact version of the file whose
 * fingerprint the decision records, minted for this request and never stored. On a closed
 * session's motion, only for a reader that session was sent to.
 */
export const charityBoardGetBoardCompensationDecisionDocumentDownloadOptions = (options: Options<CharityBoardGetBoardCompensationDecisionDocumentDownloadData>) => queryOptions<CharityBoardGetBoardCompensationDecisionDocumentDownloadResponse, CharityBoardGetBoardCompensationDecisionDocumentDownloadError, CharityBoardGetBoardCompensationDecisionDocumentDownloadResponse, ReturnType<typeof charityBoardGetBoardCompensationDecisionDocumentDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCompensationDecisionDocumentDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCompensationDecisionDocumentDownloadQueryKey(options)
});

export const charityBoardListBoardConflictRegisterQueryKey = (options: Options<CharityBoardListBoardConflictRegisterData>) => createQueryKey('charity-board-list_board_conflict_register', options);

/**
 * List Board Conflict Register
 *
 * The charity's conflict register — its recorded disclosures, per seat.
 *
 * `status` is DERIVED from the version pointers, not stored: `superseded` means a later
 * disclosure by the same seat replaced this one, and `active` means none has. Filter on
 * it to see what stands today, or omit it to read the whole history.
 *
 * A disclosure filed into an executive session this reader was not part of is ABSENT,
 * exactly as the session itself is — that binds charity admins as well as directors. No
 * disclosure is filed that way today: every one goes in at standard visibility, so the
 * scoping is here for the rule rather than for a case you will meet.
 */
export const charityBoardListBoardConflictRegisterOptions = (options: Options<CharityBoardListBoardConflictRegisterData>) => queryOptions<CharityBoardListBoardConflictRegisterResponse, CharityBoardListBoardConflictRegisterError, CharityBoardListBoardConflictRegisterResponse, ReturnType<typeof charityBoardListBoardConflictRegisterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardConflictRegister({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardConflictRegisterQueryKey(options)
});

/**
 * Record Board Conflict Disclosure
 *
 * Record a conflict-of-interest disclosure a director made outside the portal.
 *
 * Plan §1.7's manual path, first-class and permanent: a volunteer board hands the
 * secretary a signed form, or says it in the room, and the module has to be able to write
 * that down. `provenance_note` is required — it says where the disclosure came from, so
 * the entry can never be read as the director having acted inside their own session.
 *
 * The record names the DIRECTOR'S OWN SEAT as its approver, not the officer's account:
 * the director disclosed, and the officer wrote it down. A director recording their own
 * disclosure does it through their board session instead, where it is a signature-class
 * act on the step-up rail.
 *
 * `supersedes_record_id` records that the director's position has CHANGED — the earlier
 * disclosure stays an accurate record of what was true at its time. `corrects_record_id`
 * records that the earlier one was WRONG. They are different statements about a person
 * and a record carries one or the other, never both.
 */
export const charityBoardRecordBoardConflictDisclosureMutation = (options?: Partial<Options<CharityBoardRecordBoardConflictDisclosureData>>): UseMutationOptions<CharityBoardRecordBoardConflictDisclosureResponse, CharityBoardRecordBoardConflictDisclosureError, Options<CharityBoardRecordBoardConflictDisclosureData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardConflictDisclosureResponse, CharityBoardRecordBoardConflictDisclosureError, Options<CharityBoardRecordBoardConflictDisclosureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardConflictDisclosure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardConsentTemplatesQueryKey = (options: Options<CharityBoardListBoardConsentTemplatesData>) => createQueryKey('charity-board-list_board_consent_templates', options);

/**
 * List Board Consent Templates
 *
 * The consent and resolution forms the charity may choose from, without the full
 * text of each.
 *
 * Structurally neutral scaffolds with bracketed fields the organization fills in, each
 * naming the authority its structure is modeled on. The library is the same for every
 * charity: this route reads nothing about the organization, so it can never present a
 * form as one the organization ought to adopt.
 */
export const charityBoardListBoardConsentTemplatesOptions = (options: Options<CharityBoardListBoardConsentTemplatesData>) => queryOptions<CharityBoardListBoardConsentTemplatesResponse, CharityBoardListBoardConsentTemplatesError, CharityBoardListBoardConsentTemplatesResponse, ReturnType<typeof charityBoardListBoardConsentTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardConsentTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardConsentTemplatesQueryKey(options)
});

export const charityBoardGetBoardConsentTemplateQueryKey = (options: Options<CharityBoardGetBoardConsentTemplateData>) => createQueryKey('charity-board-get_board_consent_template', options);

/**
 * Get Board Consent Template
 *
 * One form, with its full text, the fields the organization fills in, and the
 * provenance of its structure.
 *
 * Served with the line the organization should read before adopting anything from it:
 * template — review with your counsel before adopting. A form written for a committee is
 * fetched for one of the organization's committees (``committee_id``), its text naming it.
 */
export const charityBoardGetBoardConsentTemplateOptions = (options: Options<CharityBoardGetBoardConsentTemplateData>) => queryOptions<CharityBoardGetBoardConsentTemplateResponse, CharityBoardGetBoardConsentTemplateError, CharityBoardGetBoardConsentTemplateResponse, ReturnType<typeof charityBoardGetBoardConsentTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardConsentTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardConsentTemplateQueryKey(options)
});

export const charityBoardListBoardContemporaneityQueryKey = (options: Options<CharityBoardListBoardContemporaneityData>) => createQueryKey('charity-board-list_board_contemporaneity', options);

/**
 * List Board Contemporaneity
 *
 * Each of the charity's held meetings and executed written consents, with its date.
 *
 * The Form 990 instructions for Part VI, line 8 describe documentation as contemporaneous
 * when it is prepared by the later of the next meeting of the governing body or 60 days
 * after the meeting or written action. This view does that arithmetic and shows the dates
 * it applied it to.
 *
 * It reports what is recorded and what the dates are, and draws no conclusion from them
 * about the charity's governance — the answer on the return is the charity's own to give.
 */
export const charityBoardListBoardContemporaneityOptions = (options: Options<CharityBoardListBoardContemporaneityData>) => queryOptions<CharityBoardListBoardContemporaneityResponse, CharityBoardListBoardContemporaneityError, CharityBoardListBoardContemporaneityResponse, ReturnType<typeof charityBoardListBoardContemporaneityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardContemporaneity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardContemporaneityQueryKey(options)
});

export const charityBoardGetBoardDirectorAccessPolicyQueryKey = (options: Options<CharityBoardGetBoardDirectorAccessPolicyData>) => createQueryKey('charity-board-get_board_director_access_policy', options);

/**
 * Get Board Director Access Policy
 *
 * What this board asks of a director before it opens, and who decided it.
 *
 * `tiered` is what every board runs: what a director must prove follows the weight of
 * what they are doing, so reading and replying ride the director's own Givmo sign-in,
 * and signature-class acts need a second factor confirmed within the hour.
 *
 * `step_up_always` ("confirm before anything opens") was retired on 2026-10-05. A board
 * that adopted it before gets that adoption back as it was recorded: it asks nothing more
 * of a director than `tiered` does, and no board can adopt a policy any more.
 *
 * Executive-session material needs a second factor on every board. That is a floor
 * beneath the setting rather than part of it.
 *
 * A board that has adopted nothing answers with the default and a null adopter,
 * never a 404.
 */
export const charityBoardGetBoardDirectorAccessPolicyOptions = (options: Options<CharityBoardGetBoardDirectorAccessPolicyData>) => queryOptions<CharityBoardGetBoardDirectorAccessPolicyResponse, CharityBoardGetBoardDirectorAccessPolicyError, CharityBoardGetBoardDirectorAccessPolicyResponse, ReturnType<typeof charityBoardGetBoardDirectorAccessPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardDirectorAccessPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardDirectorAccessPolicyQueryKey(options)
});

export const charityBoardListBoardDirectorClassesQueryKey = (options: Options<CharityBoardListBoardDirectorClassesData>) => createQueryKey('charity-board-list_board_director_classes', options);

/**
 * List Board Director Classes
 *
 * The board's own names for its classes of directors, active first in the board's order,
 * then retired. A board with no classes has none: nothing is added for it. A class is a label
 * on a term; it changes no vote, quorum or written consent. Reading this list never changes it.
 */
export const charityBoardListBoardDirectorClassesOptions = (options: Options<CharityBoardListBoardDirectorClassesData>) => queryOptions<CharityBoardListBoardDirectorClassesResponse, CharityBoardListBoardDirectorClassesError, CharityBoardListBoardDirectorClassesResponse, ReturnType<typeof charityBoardListBoardDirectorClassesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardDirectorClasses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardDirectorClassesQueryKey(options)
});

/**
 * Create Board Director Class
 *
 * Add one of the board's classes, last in the board's order. No two active classes share a
 * name, whatever the case or spacing: that is a 409 `board_director_class_name_taken`.
 */
export const charityBoardCreateBoardDirectorClassMutation = (options?: Partial<Options<CharityBoardCreateBoardDirectorClassData>>): UseMutationOptions<CharityBoardCreateBoardDirectorClassResponse, CharityBoardCreateBoardDirectorClassError, Options<CharityBoardCreateBoardDirectorClassData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardDirectorClassResponse, CharityBoardCreateBoardDirectorClassError, Options<CharityBoardCreateBoardDirectorClassData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardDirectorClass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Board Director Class
 *
 * Rename a class, move it in the board's order, or both. `position` is its place among the
 * active classes, counting from 1; past the last means last. A retired class is neither renamed
 * nor moved (409 `board_director_class_retired`).
 */
export const charityBoardUpdateBoardDirectorClassMutation = (options?: Partial<Options<CharityBoardUpdateBoardDirectorClassData>>): UseMutationOptions<CharityBoardUpdateBoardDirectorClassResponse, CharityBoardUpdateBoardDirectorClassError, Options<CharityBoardUpdateBoardDirectorClassData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardDirectorClassResponse, CharityBoardUpdateBoardDirectorClassError, Options<CharityBoardUpdateBoardDirectorClassData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardDirectorClass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retire Board Director Class
 *
 * Retire a class the board no longer uses. It is never deleted and stays on every term that
 * names it. Retiring a class already retired answers it as it is.
 */
export const charityBoardRetireBoardDirectorClassMutation = (options?: Partial<Options<CharityBoardRetireBoardDirectorClassData>>): UseMutationOptions<CharityBoardRetireBoardDirectorClassResponse, CharityBoardRetireBoardDirectorClassError, Options<CharityBoardRetireBoardDirectorClassData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRetireBoardDirectorClassResponse, CharityBoardRetireBoardDirectorClassError, Options<CharityBoardRetireBoardDirectorClassData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRetireBoardDirectorClass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardEngagementQueryKey = (options: Options<CharityBoardListBoardEngagementData>) => createQueryKey('charity-board-list_board_engagement', options);

/**
 * List Board Engagement
 *
 * Who has opened what — the chair's engagement view.
 *
 * Measurement, not shaming (plan §1.7). Per-(seat, artifact) open counts and instants,
 * with deliberately nothing about how long anything was open and no ranking, so the
 * surface built on this answers "has this director opened the packet?" without becoming
 * a leaderboard. The charity configures whether it is shown at all.
 */
export const charityBoardListBoardEngagementOptions = (options: Options<CharityBoardListBoardEngagementData>) => queryOptions<CharityBoardListBoardEngagementResponse, CharityBoardListBoardEngagementError, CharityBoardListBoardEngagementResponse, ReturnType<typeof charityBoardListBoardEngagementQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardEngagement({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardEngagementQueryKey(options)
});

export const charityBoardExportBoardMinuteBookQueryKey = (options: Options<CharityBoardExportBoardMinuteBookData>) => createQueryKey('charity-board-export_board_minute_book', options);

/**
 * Export Board Minute Book
 *
 * The machine-readable minute-book export, manifest-bound.
 *
 * Continuous — callable any time, no request queue and no waiting period. Every record
 * carries the content hash fixed when it became the record, and `manifest_hash` binds
 * the set, so the charity can re-derive both from the export alone, with nothing from
 * Givmo.
 */
export const charityBoardExportBoardMinuteBookOptions = (options: Options<CharityBoardExportBoardMinuteBookData>) => queryOptions<CharityBoardExportBoardMinuteBookResponse, CharityBoardExportBoardMinuteBookError, CharityBoardExportBoardMinuteBookResponse, ReturnType<typeof charityBoardExportBoardMinuteBookQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardExportBoardMinuteBook({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardExportBoardMinuteBookQueryKey(options)
});

export const charityBoardExportBoardMinuteBookDocumentQueryKey = (options: Options<CharityBoardExportBoardMinuteBookDocumentData>) => createQueryKey('charity-board-export_board_minute_book_document', options);

/**
 * Export Board Minute Book Document
 *
 * The same export as a human-readable minute book — readable, printable, and
 * hand-able to counsel with no tooling at all.
 */
export const charityBoardExportBoardMinuteBookDocumentOptions = (options: Options<CharityBoardExportBoardMinuteBookDocumentData>) => queryOptions<CharityBoardExportBoardMinuteBookDocumentResponse, CharityBoardExportBoardMinuteBookDocumentError, CharityBoardExportBoardMinuteBookDocumentResponse, ReturnType<typeof charityBoardExportBoardMinuteBookDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardExportBoardMinuteBookDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardExportBoardMinuteBookDocumentQueryKey(options)
});

export const charityBoardGetBoardFilingGovernanceFeedQueryKey = (options: Options<CharityBoardGetBoardFilingGovernanceFeedData>) => createQueryKey('charity-board-get_board_filing_governance_feed', options);

/**
 * Get Board Filing Governance Feed
 *
 * The filing module's current governance projection.
 *
 * While Org Machinery standing or the held D-CCM-2 legal rows are absent, the
 * operation fails typed and returns no dependent facts.
 */
export const charityBoardGetBoardFilingGovernanceFeedOptions = (options: Options<CharityBoardGetBoardFilingGovernanceFeedData>) => queryOptions<CharityBoardGetBoardFilingGovernanceFeedResponse, CharityBoardGetBoardFilingGovernanceFeedError, CharityBoardGetBoardFilingGovernanceFeedResponse, ReturnType<typeof charityBoardGetBoardFilingGovernanceFeedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardFilingGovernanceFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardFilingGovernanceFeedQueryKey(options)
});

export const charityBoardOpenBoardFilingReceiptQueryKey = (options: Options<CharityBoardOpenBoardFilingReceiptData>) => createQueryKey('charity-board-open_board_filing_receipt', options);

/**
 * Open Board Filing Receipt
 *
 * Mint from an authorized current feed or exact published packet snapshot.
 */
export const charityBoardOpenBoardFilingReceiptOptions = (options: Options<CharityBoardOpenBoardFilingReceiptData>) => queryOptions<CharityBoardOpenBoardFilingReceiptResponse, CharityBoardOpenBoardFilingReceiptError, CharityBoardOpenBoardFilingReceiptResponse, ReturnType<typeof charityBoardOpenBoardFilingReceiptQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardOpenBoardFilingReceipt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardOpenBoardFilingReceiptQueryKey(options)
});

export const charityBoardGetBoardForm990QueryKey = (options: Options<CharityBoardGetBoardForm990Data>) => createQueryKey('charity-board-get_board_form_990', options);

/**
 * Get Board Form 990
 *
 * One tax year of Form 990, Part VI: each question in the IRS's own words, with its
 * instructions quoted, and beside it what your board's records hold that bears on it, as far as
 * you may read them. Your organization answers each question on its return; this page doesn't.
 *
 * The tax years come from the fiscal year end your organization recorded in Givmo; with none
 * recorded, from the month and day in `year_end_month` and `year_end_day`. `tax_year_ends_on`
 * picks a year by its last day; without it, the latest year that has ended. Computed when read;
 * nothing is stored.
 */
export const charityBoardGetBoardForm990Options = (options: Options<CharityBoardGetBoardForm990Data>) => queryOptions<CharityBoardGetBoardForm990Response, CharityBoardGetBoardForm990Error, CharityBoardGetBoardForm990Response, ReturnType<typeof charityBoardGetBoardForm990QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardForm990({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardForm990QueryKey(options)
});

export const charityBoardGetBoardScheduleODraftQueryKey = (options: Options<CharityBoardGetBoardScheduleODraftData>) => createQueryKey('charity-board-get_board_schedule_o_draft', options);

/**
 * Get Board Schedule O Draft
 *
 * One tax year's Schedule O draft: sentences built only from what your board recorded, for
 * you to edit into your own words — line 8b's, where no committee is recorded for the year, and
 * line 11b's (the copy of the return provided to the board, who opened and read it, and the
 * review linked to it, the board's or a committee's). The text follows the IRS e-file character
 * set. The year is the Form 990 page's, with the same address. Computed when read; never stored,
 * and never your organization's Schedule O, which is whatever it files.
 */
export const charityBoardGetBoardScheduleODraftOptions = (options: Options<CharityBoardGetBoardScheduleODraftData>) => queryOptions<CharityBoardGetBoardScheduleODraftResponse, CharityBoardGetBoardScheduleODraftError, CharityBoardGetBoardScheduleODraftResponse, ReturnType<typeof charityBoardGetBoardScheduleODraftQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardScheduleODraft({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardScheduleODraftQueryKey(options)
});

export const charityBoardListBoardGettingStartedStepsQueryKey = (options: Options<CharityBoardListBoardGettingStartedStepsData>) => createQueryKey('charity-board-list_board_getting_started_steps', options);

/**
 * List Board Getting Started Steps
 *
 * New members, and the steps on their getting-started lists that are the officers' own:
 * sending the year's conflict-of-interest questionnaire, choosing a board buddy.
 */
export const charityBoardListBoardGettingStartedStepsOptions = (options: Options<CharityBoardListBoardGettingStartedStepsData>) => queryOptions<CharityBoardListBoardGettingStartedStepsResponse, CharityBoardListBoardGettingStartedStepsError, CharityBoardListBoardGettingStartedStepsResponse, ReturnType<typeof charityBoardListBoardGettingStartedStepsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardGettingStartedSteps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardGettingStartedStepsQueryKey(options)
});

export const charityBoardGetBoardGettingStartedListQueryKey = (options: Options<CharityBoardGetBoardGettingStartedListData>) => createQueryKey('charity-board-get_board_getting_started_list', options);

/**
 * Get Board Getting Started List
 *
 * The board's getting-started list: the one the board adopted, or — before it adopted one —
 * Givmo's starting list, built only from the governing documents the board recorded, the first
 * disclosure and a board buddy. Nothing is in use until the board adopts a list.
 */
export const charityBoardGetBoardGettingStartedListOptions = (options: Options<CharityBoardGetBoardGettingStartedListData>) => queryOptions<CharityBoardGetBoardGettingStartedListResponse, CharityBoardGetBoardGettingStartedListError, CharityBoardGetBoardGettingStartedListResponse, ReturnType<typeof charityBoardGetBoardGettingStartedListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardGettingStartedList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardGettingStartedListQueryKey(options)
});

/**
 * Save Board Getting Started List
 *
 * Use this list (no revision yet), or change the board's list from the revision you read:
 * add, remove or reorder items. Members added after this get the list; a list a member already
 * has doesn't change. A list that changed meanwhile is refused, so no change undoes another.
 */
export const charityBoardSaveBoardGettingStartedListMutation = (options?: Partial<Options<CharityBoardSaveBoardGettingStartedListData>>): UseMutationOptions<CharityBoardSaveBoardGettingStartedListResponse, CharityBoardSaveBoardGettingStartedListError, Options<CharityBoardSaveBoardGettingStartedListData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSaveBoardGettingStartedListResponse, CharityBoardSaveBoardGettingStartedListError, Options<CharityBoardSaveBoardGettingStartedListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSaveBoardGettingStartedList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardGovernanceParametersQueryKey = (options: Options<CharityBoardListBoardGovernanceParametersData>) => createQueryKey('charity-board-list_board_governance_parameters', options);

/**
 * List Board Governance Parameters
 *
 * The charity's recorded parameters — in force first, then history when asked for.
 *
 * The history is opt-in because it is what a past meeting's figures were counted
 * against: a reader checking an old meeting's notice needs the row that was in force
 * then, not only the one in force now.
 */
export const charityBoardListBoardGovernanceParametersOptions = (options: Options<CharityBoardListBoardGovernanceParametersData>) => queryOptions<CharityBoardListBoardGovernanceParametersResponse, CharityBoardListBoardGovernanceParametersError, CharityBoardListBoardGovernanceParametersResponse, ReturnType<typeof charityBoardListBoardGovernanceParametersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardGovernanceParameters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardGovernanceParametersQueryKey(options)
});

/**
 * Record Board Governance Parameter
 *
 * Record a governance parameter the charity has entered, with its bylaw attribution.
 *
 * The number is the charity's, and `bylaw_citation` — the section of its own governing
 * documents it comes from — is REQUIRED. The module computes arithmetic against what is
 * recorded here and echoes the citation in every sentence it renders; it reads no
 * governing document and derives none of these numbers.
 *
 * PUT rather than POST because the charity has exactly one parameter in force per key.
 * Recording again does not edit the old row: it writes a new one and supersedes the
 * prior, so a meeting scheduled under the earlier number keeps the figures it was given.
 */
export const charityBoardRecordBoardGovernanceParameterMutation = (options?: Partial<Options<CharityBoardRecordBoardGovernanceParameterData>>): UseMutationOptions<CharityBoardRecordBoardGovernanceParameterResponse, CharityBoardRecordBoardGovernanceParameterError, Options<CharityBoardRecordBoardGovernanceParameterData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardGovernanceParameterResponse, CharityBoardRecordBoardGovernanceParameterError, Options<CharityBoardRecordBoardGovernanceParameterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardGovernanceParameter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardGoverningDocumentTemplatesQueryKey = (options: Options<CharityBoardListBoardGoverningDocumentTemplatesData>) => createQueryKey('charity-board-list_board_governing_document_templates', options);

/**
 * List Board Governing Document Templates
 *
 * The form library the charity may choose from, without the full text of each form.
 *
 * Structurally neutral scaffolds with bracketed fields the organization fills in, each
 * naming the authority its structure is modeled on. The library is the same for every
 * charity: this route reads nothing about the organization, so it can never present a form
 * as one the organization ought to adopt.
 */
export const charityBoardListBoardGoverningDocumentTemplatesOptions = (options: Options<CharityBoardListBoardGoverningDocumentTemplatesData>) => queryOptions<CharityBoardListBoardGoverningDocumentTemplatesResponse, CharityBoardListBoardGoverningDocumentTemplatesError, CharityBoardListBoardGoverningDocumentTemplatesResponse, ReturnType<typeof charityBoardListBoardGoverningDocumentTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardGoverningDocumentTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardGoverningDocumentTemplatesQueryKey(options)
});

export const charityBoardGetBoardGoverningDocumentTemplateQueryKey = (options: Options<CharityBoardGetBoardGoverningDocumentTemplateData>) => createQueryKey('charity-board-get_board_governing_document_template', options);

/**
 * Get Board Governing Document Template
 *
 * One form, with its full text, the fields the organization fills in, and the
 * provenance of its structure.
 *
 * Served with the line the organization should read before adopting anything from it:
 * template — review with your counsel before adopting.
 */
export const charityBoardGetBoardGoverningDocumentTemplateOptions = (options: Options<CharityBoardGetBoardGoverningDocumentTemplateData>) => queryOptions<CharityBoardGetBoardGoverningDocumentTemplateResponse, CharityBoardGetBoardGoverningDocumentTemplateError, CharityBoardGetBoardGoverningDocumentTemplateResponse, ReturnType<typeof charityBoardGetBoardGoverningDocumentTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardGoverningDocumentTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardGoverningDocumentTemplateQueryKey(options)
});

export const charityBoardListBoardGoverningDocumentsQueryKey = (options: Options<CharityBoardListBoardGoverningDocumentsData>) => createQueryKey('charity-board-list_board_governing_documents', options);

/**
 * List Board Governing Documents
 *
 * The charity's governing documents, each as the chain of versions it adopted.
 *
 * Versions are in the order the charity recorded — each names the version it replaced —
 * and the last one is flagged as in force. A version recorded as executive session that
 * the caller did not take part in is absent from the chain, like every other board read.
 *
 * The response describes what the charity recorded and nothing else: there is no entry for
 * an instrument the charity has no version of.
 */
export const charityBoardListBoardGoverningDocumentsOptions = (options: Options<CharityBoardListBoardGoverningDocumentsData>) => queryOptions<CharityBoardListBoardGoverningDocumentsResponse, CharityBoardListBoardGoverningDocumentsError, CharityBoardListBoardGoverningDocumentsResponse, ReturnType<typeof charityBoardListBoardGoverningDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardGoverningDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardGoverningDocumentsQueryKey(options)
});

/**
 * Record Historical Board Member
 *
 * Record a FORMER seat — someone who served on this board before the module was in
 * use (CBG-RC8).
 *
 * A separate route from adding a seat, because the row it creates is already ended: the
 * status is not the caller's to choose and no removal reason is asked for, since no
 * removal happened here. `served_from` / `served_to` are the charity's own account of the
 * term and are read back beside the module's own timestamps, so a 2026 entry of a 2019
 * term reads as exactly that rather than as a director who left today.
 *
 * A former seat holds no credentials and never will — every access link and session
 * re-reads the seat's standing on use, and this seat is a former one from the moment it
 * exists. It is here for the record: attendance in historical minutes, and the term
 * lifecycle a later item builds.
 */
export const charityBoardRecordHistoricalBoardMemberMutation = (options?: Partial<Options<CharityBoardRecordHistoricalBoardMemberData>>): UseMutationOptions<CharityBoardRecordHistoricalBoardMemberResponse, CharityBoardRecordHistoricalBoardMemberError, Options<CharityBoardRecordHistoricalBoardMemberData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordHistoricalBoardMemberResponse, CharityBoardRecordHistoricalBoardMemberError, Options<CharityBoardRecordHistoricalBoardMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordHistoricalBoardMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardImportBatchesQueryKey = (options: Options<CharityBoardListBoardImportBatchesData>) => createQueryKey('charity-board-list_board_import_batches', options);

/**
 * List Board Import Batches
 *
 * The charity's import sessions, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Each carries the count of what THIS reader may see in it, so a closed-session record
 * the caller was not part of is missing from the count exactly as it is missing from the
 * listing.
 */
export const charityBoardListBoardImportBatchesOptions = (options: Options<CharityBoardListBoardImportBatchesData>) => queryOptions<CharityBoardListBoardImportBatchesResponse, CharityBoardListBoardImportBatchesError, CharityBoardListBoardImportBatchesResponse, ReturnType<typeof charityBoardListBoardImportBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardImportBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardImportBatchesQueryKey(options)
});

/**
 * Open Board Import Batch
 *
 * Open a session for bringing in records from before this module was in use.
 *
 * `source_description` is the charity's own account of where the corpus came from — a box
 * of paper, a prior system, a predecessor's files. The module observed none of it, so the
 * charity's own words are the only honest source, and they travel with every record
 * entered under the session.
 */
export const charityBoardOpenBoardImportBatchMutation = (options?: Partial<Options<CharityBoardOpenBoardImportBatchData>>): UseMutationOptions<CharityBoardOpenBoardImportBatchResponse, CharityBoardOpenBoardImportBatchError, Options<CharityBoardOpenBoardImportBatchData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardOpenBoardImportBatchResponse, CharityBoardOpenBoardImportBatchError, Options<CharityBoardOpenBoardImportBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardOpenBoardImportBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardImportBatchQueryKey = (options: Options<CharityBoardGetBoardImportBatchData>) => createQueryKey('charity-board-get_board_import_batch', options);

/**
 * Get Board Import Batch
 */
export const charityBoardGetBoardImportBatchOptions = (options: Options<CharityBoardGetBoardImportBatchData>) => queryOptions<CharityBoardGetBoardImportBatchResponse, CharityBoardGetBoardImportBatchError, CharityBoardGetBoardImportBatchResponse, ReturnType<typeof charityBoardGetBoardImportBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardImportBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardImportBatchQueryKey(options)
});

/**
 * Update Board Import Batch
 *
 * Edit an OPEN session's description. Refused once it is closed — at that point the
 * label and the source description are what every record entered under it says about its
 * own origin, and those records are themselves immutable.
 */
export const charityBoardUpdateBoardImportBatchMutation = (options?: Partial<Options<CharityBoardUpdateBoardImportBatchData>>): UseMutationOptions<CharityBoardUpdateBoardImportBatchResponse, CharityBoardUpdateBoardImportBatchError, Options<CharityBoardUpdateBoardImportBatchData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardImportBatchResponse, CharityBoardUpdateBoardImportBatchError, Options<CharityBoardUpdateBoardImportBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardImportBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close Board Import Batch
 *
 * Close a session — the charity saying the backfill is finished.
 *
 * Nothing further can be entered under it and the session itself stops being editable.
 * The route is named for the thing it creates (the closure), not for a verb, because the
 * closure is the durable artifact: it names who drew the boundary and when.
 */
export const charityBoardCloseBoardImportBatchMutation = (options?: Partial<Options<CharityBoardCloseBoardImportBatchData>>): UseMutationOptions<CharityBoardCloseBoardImportBatchResponse, CharityBoardCloseBoardImportBatchError, Options<CharityBoardCloseBoardImportBatchData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCloseBoardImportBatchResponse, CharityBoardCloseBoardImportBatchError, Options<CharityBoardCloseBoardImportBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCloseBoardImportBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Issue Board Import File Upload Url
 *
 * A signed upload URL for the file of a record you're entering into an open import batch: PUT
 * the file there once, sending exactly `headers`, then send the record with `file.upload_id`. A
 * PDF or a picture, up to 50 MB. Nothing is recorded until the record is sent.
 */
export const charityBoardIssueBoardImportFileUploadUrlMutation = (options?: Partial<Options<CharityBoardIssueBoardImportFileUploadUrlData>>): UseMutationOptions<CharityBoardIssueBoardImportFileUploadUrlResponse, CharityBoardIssueBoardImportFileUploadUrlError, Options<CharityBoardIssueBoardImportFileUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardIssueBoardImportFileUploadUrlResponse, CharityBoardIssueBoardImportFileUploadUrlError, Options<CharityBoardIssueBoardImportFileUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardIssueBoardImportFileUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Import File Upload
 *
 * Delete a file uploaded for a record you didn't send (the form was cancelled). A record's
 * own file is never deleted here.
 */
export const charityBoardDeleteBoardImportFileUploadMutation = (options?: Partial<Options<CharityBoardDeleteBoardImportFileUploadData>>): UseMutationOptions<CharityBoardDeleteBoardImportFileUploadResponse, CharityBoardDeleteBoardImportFileUploadError, Options<CharityBoardDeleteBoardImportFileUploadData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardImportFileUploadResponse, CharityBoardDeleteBoardImportFileUploadError, Options<CharityBoardDeleteBoardImportFileUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardImportFileUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardImportBatchRecordsQueryKey = (options: Options<CharityBoardListBoardImportBatchRecordsData>) => createQueryKey('charity-board-list_board_import_batch_records', options);

/**
 * List Board Import Batch Records
 *
 * Everything entered under one session, in entry order — the review listing.
 *
 * This is what makes a backfill checkable: the charity reads back what it just brought
 * in, with each record's content hash beside it so a reviewer can tie a row to the page
 * of paper it came from. Records the caller may not read are ABSENT, and the total
 * reflects only what they may see.
 */
export const charityBoardListBoardImportBatchRecordsOptions = (options: Options<CharityBoardListBoardImportBatchRecordsData>) => queryOptions<CharityBoardListBoardImportBatchRecordsResponse, CharityBoardListBoardImportBatchRecordsError, CharityBoardListBoardImportBatchRecordsResponse, ReturnType<typeof charityBoardListBoardImportBatchRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardImportBatchRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardImportBatchRecordsQueryKey(options)
});

/**
 * Issue Board Import Record File Upload Url
 *
 * A signed upload URL for the file of a record you're entering by hand: PUT the file there
 * once, sending exactly `headers`, then send the record with `file.upload_id`. A PDF or a
 * picture, up to 50 MB. Nothing is recorded until the record is sent.
 */
export const charityBoardIssueBoardImportRecordFileUploadUrlMutation = (options?: Partial<Options<CharityBoardIssueBoardImportRecordFileUploadUrlData>>): UseMutationOptions<CharityBoardIssueBoardImportRecordFileUploadUrlResponse, CharityBoardIssueBoardImportRecordFileUploadUrlError, Options<CharityBoardIssueBoardImportRecordFileUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardIssueBoardImportRecordFileUploadUrlResponse, CharityBoardIssueBoardImportRecordFileUploadUrlError, Options<CharityBoardIssueBoardImportRecordFileUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardIssueBoardImportRecordFileUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Import Record File Upload
 *
 * Delete a file uploaded for a record you didn't send (you chose another file, or left the
 * page). A record's own file is never deleted here.
 */
export const charityBoardDeleteBoardImportRecordFileUploadMutation = (options?: Partial<Options<CharityBoardDeleteBoardImportRecordFileUploadData>>): UseMutationOptions<CharityBoardDeleteBoardImportRecordFileUploadResponse, CharityBoardDeleteBoardImportRecordFileUploadError, Options<CharityBoardDeleteBoardImportRecordFileUploadData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardImportRecordFileUploadResponse, CharityBoardDeleteBoardImportRecordFileUploadError, Options<CharityBoardDeleteBoardImportRecordFileUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardImportRecordFileUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardImportInboxQueryKey = (options: Options<CharityBoardListBoardImportInboxData>) => createQueryKey('charity-board-list_board_import_inbox', options);

/**
 * List Board Import Inbox
 *
 * The files uploaded for your AI: those waiting for it, those it proposed records from (each
 * waiting for you to confirm), and those in your minute book, with how many there are and how
 * many can wait at once. Nothing here is in the minute book until you confirm it.
 */
export const charityBoardListBoardImportInboxOptions = (options: Options<CharityBoardListBoardImportInboxData>) => queryOptions<CharityBoardListBoardImportInboxResponse, CharityBoardListBoardImportInboxError, CharityBoardListBoardImportInboxResponse, ReturnType<typeof charityBoardListBoardImportInboxQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardImportInbox({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardImportInboxQueryKey(options)
});

/**
 * Issue Board Import Inbox Upload Url
 *
 * A signed upload URL for one file you're uploading for your AI: PUT the file there once,
 * sending exactly `headers`, then ask Board to check it with the `upload_id` it names. A PDF or a
 * picture, up to 50 MB. Nothing is added until Board's check passes.
 */
export const charityBoardIssueBoardImportInboxUploadUrlMutation = (options?: Partial<Options<CharityBoardIssueBoardImportInboxUploadUrlData>>): UseMutationOptions<CharityBoardIssueBoardImportInboxUploadUrlResponse, CharityBoardIssueBoardImportInboxUploadUrlError, Options<CharityBoardIssueBoardImportInboxUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardIssueBoardImportInboxUploadUrlResponse, CharityBoardIssueBoardImportInboxUploadUrlError, Options<CharityBoardIssueBoardImportInboxUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardIssueBoardImportInboxUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Board Import Inbox File
 *
 * Remove a file waiting in your uploads: it is deleted, and your AI no longer sees it. A
 * file your AI proposed a record from waits for you on the confirmation page instead. A
 * person's act.
 */
export const charityBoardRemoveBoardImportInboxFileMutation = (options?: Partial<Options<CharityBoardRemoveBoardImportInboxFileData>>): UseMutationOptions<CharityBoardRemoveBoardImportInboxFileResponse, CharityBoardRemoveBoardImportInboxFileError, Options<CharityBoardRemoveBoardImportInboxFileData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardImportInboxFileResponse, CharityBoardRemoveBoardImportInboxFileError, Options<CharityBoardRemoveBoardImportInboxFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardImportInboxFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check Board Import Inbox File
 *
 * Ask Board to check a file you uploaded, with its name and type. If the check passes, the
 * file waits in your uploads for your AI; if not, the answer says why and the upload is
 * deleted. A file already uploaded, or already in your minute book, is added and says so.
 */
export const charityBoardCheckBoardImportInboxFileMutation = (options?: Partial<Options<CharityBoardCheckBoardImportInboxFileData>>): UseMutationOptions<CharityBoardCheckBoardImportInboxFileResponse, CharityBoardCheckBoardImportInboxFileError, Options<CharityBoardCheckBoardImportInboxFileData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCheckBoardImportInboxFileResponse, CharityBoardCheckBoardImportInboxFileError, Options<CharityBoardCheckBoardImportInboxFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCheckBoardImportInboxFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardImportInboxFileUrlQueryKey = (options: Options<CharityBoardGetBoardImportInboxFileUrlData>) => createQueryKey('charity-board-get_board_import_inbox_file_url', options);

/**
 * Get Board Import Inbox File Url
 *
 * A short-lived link that downloads a file waiting in your uploads, as Board checked it.
 */
export const charityBoardGetBoardImportInboxFileUrlOptions = (options: Options<CharityBoardGetBoardImportInboxFileUrlData>) => queryOptions<CharityBoardGetBoardImportInboxFileUrlResponse, CharityBoardGetBoardImportInboxFileUrlError, CharityBoardGetBoardImportInboxFileUrlResponse, ReturnType<typeof charityBoardGetBoardImportInboxFileUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardImportInboxFileUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardImportInboxFileUrlQueryKey(options)
});

/**
 * Import Board Record
 *
 * Bring in a pre-module historical record (CBG-RC8), one document at a time.
 *
 * A separate route from draft creation on purpose: an imported record lands immutable
 * and never passes through submit/approve, so conflating the two entry points would
 * invite a caller to think an import can be "approved" later. It cannot — the database
 * ties imported provenance to the imported state and nothing else.
 *
 * **This is the only import door.** `source_note`, the organization's own note of where
 * the record came from, is optional. A file goes in with the record (`file`, from the
 * slot `…/import-file-upload-url` named) or never. An `import_batch_id` names a backfill
 * session, which is answered as not found while the sessions are switched off.
 *
 * **The call is idempotent.** A "Record it" pressed again, or a backfill retried after a
 * dropped connection, re-sends what it already sent; a record whose content the
 * organization already holds (entered with no session, or in the named one) is not
 * written twice. The already-recorded one comes back with `already_recorded: true` and a
 * **200** rather than a 201, so a caller can tell a fresh entry from a replayed one
 * without comparing ids.
 */
export const charityBoardImportBoardRecordMutation = (options?: Partial<Options<CharityBoardImportBoardRecordData>>): UseMutationOptions<CharityBoardImportBoardRecordResponse, CharityBoardImportBoardRecordError, Options<CharityBoardImportBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardImportBoardRecordResponse, CharityBoardImportBoardRecordError, Options<CharityBoardImportBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardImportBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardLegalHoldsQueryKey = (options: Options<CharityBoardListBoardLegalHoldsData>) => createQueryKey('charity-board-list_board_legal_holds', options);

/**
 * List Board Legal Holds
 */
export const charityBoardListBoardLegalHoldsOptions = (options: Options<CharityBoardListBoardLegalHoldsData>) => queryOptions<CharityBoardListBoardLegalHoldsResponse, CharityBoardListBoardLegalHoldsError, CharityBoardListBoardLegalHoldsResponse, ReturnType<typeof charityBoardListBoardLegalHoldsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardLegalHolds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardLegalHoldsQueryKey(options)
});

/**
 * Place Board Legal Hold
 */
export const charityBoardPlaceBoardLegalHoldMutation = (options?: Partial<Options<CharityBoardPlaceBoardLegalHoldData>>): UseMutationOptions<CharityBoardPlaceBoardLegalHoldResponse, CharityBoardPlaceBoardLegalHoldError, Options<CharityBoardPlaceBoardLegalHoldData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardPlaceBoardLegalHoldResponse, CharityBoardPlaceBoardLegalHoldError, Options<CharityBoardPlaceBoardLegalHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardPlaceBoardLegalHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Release Board Legal Hold
 */
export const charityBoardReleaseBoardLegalHoldMutation = (options?: Partial<Options<CharityBoardReleaseBoardLegalHoldData>>): UseMutationOptions<CharityBoardReleaseBoardLegalHoldResponse, CharityBoardReleaseBoardLegalHoldError, Options<CharityBoardReleaseBoardLegalHoldData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReleaseBoardLegalHoldResponse, CharityBoardReleaseBoardLegalHoldError, Options<CharityBoardReleaseBoardLegalHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReleaseBoardLegalHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardLegalHoldReportQueryKey = (options: Options<CharityBoardGetBoardLegalHoldReportData>) => createQueryKey('charity-board-get_board_legal_hold_report', options);

/**
 * Get Board Legal Hold Report
 *
 * What a hold covers — the enumeration the charity can hand to whoever asked for it.
 *
 * A hold preserves records; it does not widen who may read them, so the report is
 * confidentiality-scoped like every other read.
 */
export const charityBoardGetBoardLegalHoldReportOptions = (options: Options<CharityBoardGetBoardLegalHoldReportData>) => queryOptions<CharityBoardGetBoardLegalHoldReportResponse, CharityBoardGetBoardLegalHoldReportError, CharityBoardGetBoardLegalHoldReportResponse, ReturnType<typeof charityBoardGetBoardLegalHoldReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardLegalHoldReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardLegalHoldReportQueryKey(options)
});

export const charityBoardListBoardMeetingsQueryKey = (options: Options<CharityBoardListBoardMeetingsData>) => createQueryKey('charity-board-list_board_meetings', options);

/**
 * List Board Meetings
 *
 * The charity's meetings, soonest first, in the canonical `{data, meta, links}`
 * envelope.
 */
export const charityBoardListBoardMeetingsOptions = (options: Options<CharityBoardListBoardMeetingsData>) => queryOptions<CharityBoardListBoardMeetingsResponse, CharityBoardListBoardMeetingsError, CharityBoardListBoardMeetingsResponse, ReturnType<typeof charityBoardListBoardMeetingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMeetings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMeetingsQueryKey(options)
});

/**
 * Create Board Meeting
 *
 * Schedule a meeting.
 *
 * The response's `notice` block is captured here, against the notice period the charity
 * recorded for THIS meeting type. It carries the period, the section it was attributed
 * to, the day count, any shortfall in days, and the counting method — and it never says
 * a meeting was noticed correctly or otherwise. A shortfall is surfaced and never
 * blocks: the board owns its own acts.
 *
 * With no period recorded for this meeting type the block is empty and its statement
 * says so. Nothing is counted, because there is nothing recorded to count against.
 */
export const charityBoardCreateBoardMeetingMutation = (options?: Partial<Options<CharityBoardCreateBoardMeetingData>>): UseMutationOptions<CharityBoardCreateBoardMeetingResponse, CharityBoardCreateBoardMeetingError, Options<CharityBoardCreateBoardMeetingData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardMeetingResponse, CharityBoardCreateBoardMeetingError, Options<CharityBoardCreateBoardMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardMeetingQueryKey = (options: Options<CharityBoardGetBoardMeetingData>) => createQueryKey('charity-board-get_board_meeting', options);

/**
 * Get Board Meeting
 */
export const charityBoardGetBoardMeetingOptions = (options: Options<CharityBoardGetBoardMeetingData>) => queryOptions<CharityBoardGetBoardMeetingResponse, CharityBoardGetBoardMeetingError, CharityBoardGetBoardMeetingResponse, ReturnType<typeof charityBoardGetBoardMeetingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardMeeting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardMeetingQueryKey(options)
});

/**
 * Update Board Meeting
 *
 * Edit an upcoming meeting (skip-None partial update).
 *
 * Moving the date re-counts the notice against the period recorded at that moment and
 * bumps the schedule revision, so a director's calendar updates the entry it holds
 * rather than gaining a second one. Correcting the time zone alone re-counts against the
 * SAME recorded period — the zone is what the count is taken in, so a correction can
 * legitimately move the figure by a day without the notice itself having changed.
 *
 * Cancelling is not here: it has its own route and its own required reason.
 */
export const charityBoardUpdateBoardMeetingMutation = (options?: Partial<Options<CharityBoardUpdateBoardMeetingData>>): UseMutationOptions<CharityBoardUpdateBoardMeetingResponse, CharityBoardUpdateBoardMeetingError, Options<CharityBoardUpdateBoardMeetingData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardMeetingResponse, CharityBoardUpdateBoardMeetingError, Options<CharityBoardUpdateBoardMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardAgendaItemsQueryKey = (options: Options<CharityBoardListBoardAgendaItemsData>) => createQueryKey('charity-board-list_board_agenda_items', options);

/**
 * List Board Agenda Items
 *
 * One meeting's agenda, in order.
 */
export const charityBoardListBoardAgendaItemsOptions = (options: Options<CharityBoardListBoardAgendaItemsData>) => queryOptions<CharityBoardListBoardAgendaItemsResponse, CharityBoardListBoardAgendaItemsError, CharityBoardListBoardAgendaItemsResponse, ReturnType<typeof charityBoardListBoardAgendaItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardAgendaItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardAgendaItemsQueryKey(options)
});

/**
 * Create Board Agenda Item
 *
 * Add an agenda item. Omitted `position` appends to the end.
 */
export const charityBoardCreateBoardAgendaItemMutation = (options?: Partial<Options<CharityBoardCreateBoardAgendaItemData>>): UseMutationOptions<CharityBoardCreateBoardAgendaItemResponse, CharityBoardCreateBoardAgendaItemError, Options<CharityBoardCreateBoardAgendaItemData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardAgendaItemResponse, CharityBoardCreateBoardAgendaItemError, Options<CharityBoardCreateBoardAgendaItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardAgendaItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Board Committee Suggestion Items
 *
 * Add the suggested committee decisions to this meeting's agenda: one ordinary item per
 * committee, listing each decision, which can be edited, moved or deleted like any other. Nothing
 * else is filled in. Pressing again adds only decisions not yet on an agenda. A committee's
 * meeting, or one whose minutes are approved, is a 409 `board_committee_suggestion_not_offered`;
 * a suggestion put away for this meeting, a 409 `board_committee_suggestion_dismissed`.
 */
export const charityBoardAddBoardCommitteeSuggestionItemsMutation = (options?: Partial<Options<CharityBoardAddBoardCommitteeSuggestionItemsData>>): UseMutationOptions<CharityBoardAddBoardCommitteeSuggestionItemsResponse, CharityBoardAddBoardCommitteeSuggestionItemsError, Options<CharityBoardAddBoardCommitteeSuggestionItemsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAddBoardCommitteeSuggestionItemsResponse, CharityBoardAddBoardCommitteeSuggestionItemsError, Options<CharityBoardAddBoardCommitteeSuggestionItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAddBoardCommitteeSuggestionItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply Board Agenda Template
 *
 * Write the sections of a neutral template the charity selected.
 *
 * `template_id` is required and has no default: the charity names the template it wants.
 * The sections land as ordinary agenda items with nothing populated — no presenter, no
 * time box, no consent-agenda placement — because each of those is a decision about this
 * charity's meeting. Which template was applied is recorded on the meeting and in its
 * event log.
 */
export const charityBoardApplyBoardAgendaTemplateMutation = (options?: Partial<Options<CharityBoardApplyBoardAgendaTemplateData>>): UseMutationOptions<CharityBoardApplyBoardAgendaTemplateResponse, CharityBoardApplyBoardAgendaTemplateError, Options<CharityBoardApplyBoardAgendaTemplateData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardApplyBoardAgendaTemplateResponse, CharityBoardApplyBoardAgendaTemplateError, Options<CharityBoardApplyBoardAgendaTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardApplyBoardAgendaTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Board Term Suggestion Items
 *
 * Add the elections the annual meeting's terms suggest: "Election of directors" and
 * "Election of officers", each an ordinary item naming the people whose terms end — or, where the
 * annual template's own "Directors" or "Officers" section is on the agenda, those names added to
 * it. Nothing else is filled in. Added once: pressing again adds nothing. A meeting not typed
 * annual is a 409 `board_term_suggestion_not_offered`; a suggestion put away for this meeting, a
 * 409 `board_term_suggestion_dismissed`.
 */
export const charityBoardAddBoardTermSuggestionItemsMutation = (options?: Partial<Options<CharityBoardAddBoardTermSuggestionItemsData>>): UseMutationOptions<CharityBoardAddBoardTermSuggestionItemsResponse, CharityBoardAddBoardTermSuggestionItemsError, Options<CharityBoardAddBoardTermSuggestionItemsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAddBoardTermSuggestionItemsResponse, CharityBoardAddBoardTermSuggestionItemsError, Options<CharityBoardAddBoardTermSuggestionItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAddBoardTermSuggestionItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Agenda Item
 *
 * Remove an agenda item, closing the gap it leaves in the ordering.
 *
 * A real delete: a planned agenda item is working content, not part of the charity's
 * record. What the board actually took up is recorded with the minutes, where nothing is
 * ever deleted.
 */
export const charityBoardDeleteBoardAgendaItemMutation = (options?: Partial<Options<CharityBoardDeleteBoardAgendaItemData>>): UseMutationOptions<CharityBoardDeleteBoardAgendaItemResponse, CharityBoardDeleteBoardAgendaItemError, Options<CharityBoardDeleteBoardAgendaItemData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardAgendaItemResponse, CharityBoardDeleteBoardAgendaItemError, Options<CharityBoardDeleteBoardAgendaItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardAgendaItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Board Agenda Item
 *
 * Edit an agenda item (skip-None partial update).
 *
 * `disposition` is the mark the carry-forward read selects on: an item the charity marks
 * as left open is what resurfaces on a later agenda. It is a mark the charity applies —
 * the module never infers that an item nobody dispositioned is unfinished business.
 *
 * Editing stays open after the meeting has started, because dispositioning an item is
 * inherently something the recording officer does afterwards.
 */
export const charityBoardUpdateBoardAgendaItemMutation = (options?: Partial<Options<CharityBoardUpdateBoardAgendaItemData>>): UseMutationOptions<CharityBoardUpdateBoardAgendaItemResponse, CharityBoardUpdateBoardAgendaItemError, Options<CharityBoardUpdateBoardAgendaItemData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardAgendaItemResponse, CharityBoardUpdateBoardAgendaItemError, Options<CharityBoardUpdateBoardAgendaItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardAgendaItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder Board Agenda
 *
 * Reorder the agenda by naming every item once, in the order wanted.
 *
 * The whole agenda rather than a delta: a partial list leaves the unnamed items at
 * positions that may now collide, and reconciling that on the server means guessing at
 * an intent the caller did not state.
 */
export const charityBoardReorderBoardAgendaMutation = (options?: Partial<Options<CharityBoardReorderBoardAgendaData>>): UseMutationOptions<CharityBoardReorderBoardAgendaResponse, CharityBoardReorderBoardAgendaError, Options<CharityBoardReorderBoardAgendaData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReorderBoardAgendaResponse, CharityBoardReorderBoardAgendaError, Options<CharityBoardReorderBoardAgendaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReorderBoardAgenda({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardApprovableMinutesQueryKey = (options: Options<CharityBoardListBoardApprovableMinutesData>) => createQueryKey('charity-board-list_board_approvable_minutes', options);

/**
 * List Board Approvable Minutes
 *
 * The minutes a motion at this meeting may approve: minutes of earlier meetings the board
 * hasn't approved yet, sent to this reader, whose approval way admits a vote at a meeting now.
 *
 * Named by public facts only — the meeting's title and start, and a closed session's general
 * purpose. A list, never a door: recording the motion decides again.
 */
export const charityBoardListBoardApprovableMinutesOptions = (options: Options<CharityBoardListBoardApprovableMinutesData>) => queryOptions<CharityBoardListBoardApprovableMinutesResponse, CharityBoardListBoardApprovableMinutesError, CharityBoardListBoardApprovableMinutesResponse, ReturnType<typeof charityBoardListBoardApprovableMinutesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardApprovableMinutes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardApprovableMinutesQueryKey(options)
});

export const charityBoardListBoardMeetingAttendanceQueryKey = (options: Options<CharityBoardListBoardMeetingAttendanceData>) => createQueryKey('charity-board-list_board_meeting_attendance', options);

/**
 * List Board Meeting Attendance
 *
 * Who the charity recorded as present at one meeting.
 */
export const charityBoardListBoardMeetingAttendanceOptions = (options: Options<CharityBoardListBoardMeetingAttendanceData>) => queryOptions<CharityBoardListBoardMeetingAttendanceResponse, CharityBoardListBoardMeetingAttendanceError, CharityBoardListBoardMeetingAttendanceResponse, ReturnType<typeof charityBoardListBoardMeetingAttendanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMeetingAttendance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMeetingAttendanceQueryKey(options)
});

export const charityBoardListBoardAttendanceIntentsQueryKey = (options: Options<CharityBoardListBoardAttendanceIntentsData>) => createQueryKey('charity-board-list_board_attendance_intents', options);

/**
 * List Board Attendance Intents
 *
 * Who has answered for one meeting, and how.
 *
 * An intent, not attendance: who was actually in the room is recorded with the minutes.
 */
export const charityBoardListBoardAttendanceIntentsOptions = (options: Options<CharityBoardListBoardAttendanceIntentsData>) => queryOptions<CharityBoardListBoardAttendanceIntentsResponse, CharityBoardListBoardAttendanceIntentsError, CharityBoardListBoardAttendanceIntentsResponse, ReturnType<typeof charityBoardListBoardAttendanceIntentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardAttendanceIntents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardAttendanceIntentsQueryKey(options)
});

/**
 * Record Board Attendance Intent On Behalf
 *
 * Record a director's attendance intent on their behalf.
 *
 * The manual path, and it is first-class rather than a fallback: a director who
 * telephones, replies to a paper notice, or tells the secretary in the corridor still
 * has an answer on record. The row is stamped as recorded by a charity admin and names
 * the person who entered it, so the charity's own record says which of the two happened.
 */
export const charityBoardRecordBoardAttendanceIntentOnBehalfMutation = (options?: Partial<Options<CharityBoardRecordBoardAttendanceIntentOnBehalfData>>): UseMutationOptions<CharityBoardRecordBoardAttendanceIntentOnBehalfResponse, CharityBoardRecordBoardAttendanceIntentOnBehalfError, Options<CharityBoardRecordBoardAttendanceIntentOnBehalfData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardAttendanceIntentOnBehalfResponse, CharityBoardRecordBoardAttendanceIntentOnBehalfError, Options<CharityBoardRecordBoardAttendanceIntentOnBehalfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardAttendanceIntentOnBehalf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Meeting Attendance
 *
 * Record who was actually in the room, one seat at a time.
 *
 * Distinct from the RSVP: that is what a director said they would do, this is what the
 * charity says happened, and it is what the quorum figures at each vote are counted from.
 *
 * `arrived_at` and `departed_at` are optional instants rather than states, so a seat that
 * came in late AND left early is expressible — and so a vote taken between those two
 * instants counts that seat as present while one taken outside them does not.
 *
 * PUT rather than POST because there is one answer per seat per meeting: recording again
 * corrects it rather than adding a second.
 */
export const charityBoardRecordBoardMeetingAttendanceMutation = (options?: Partial<Options<CharityBoardRecordBoardMeetingAttendanceData>>): UseMutationOptions<CharityBoardRecordBoardMeetingAttendanceResponse, CharityBoardRecordBoardMeetingAttendanceError, Options<CharityBoardRecordBoardMeetingAttendanceData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardMeetingAttendanceResponse, CharityBoardRecordBoardMeetingAttendanceError, Options<CharityBoardRecordBoardMeetingAttendanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardMeetingAttendance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardMeetingCalendarQueryKey = (options: Options<CharityBoardGetBoardMeetingCalendarData>) => createQueryKey('charity-board-get_board_meeting_calendar', options);

/**
 * Get Board Meeting Calendar
 *
 * The meeting as an iCalendar file, for any calendar application.
 *
 * Generated from the stored row each time it is asked for, so a rescheduled meeting's
 * file carries the new instant and a higher sequence number — which is what makes a
 * calendar application update the entry it already has instead of adding a second one.
 */
export const charityBoardGetBoardMeetingCalendarOptions = (options: Options<CharityBoardGetBoardMeetingCalendarData>) => queryOptions<CharityBoardGetBoardMeetingCalendarResponse, CharityBoardGetBoardMeetingCalendarError, CharityBoardGetBoardMeetingCalendarResponse, ReturnType<typeof charityBoardGetBoardMeetingCalendarQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardMeetingCalendar({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardMeetingCalendarQueryKey(options)
});

/**
 * Cancel Board Meeting
 *
 * Cancel a meeting, with a recorded reason.
 *
 * A POST carrying a required reason rather than a status flip on the edit route: the
 * roster was told about this meeting, so calling it off is its own act with its own
 * actor, instant, and explanation. Never a delete. Re-cancelling is a no-op, so a
 * retried request does not read as a failure.
 */
export const charityBoardCancelBoardMeetingMutation = (options?: Partial<Options<CharityBoardCancelBoardMeetingData>>): UseMutationOptions<CharityBoardCancelBoardMeetingResponse, CharityBoardCancelBoardMeetingError, Options<CharityBoardCancelBoardMeetingData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCancelBoardMeetingResponse, CharityBoardCancelBoardMeetingError, Options<CharityBoardCancelBoardMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCancelBoardMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardCommitteeSuggestionsQueryKey = (options: Options<CharityBoardGetBoardCommitteeSuggestionsData>) => createQueryKey('charity-board-get_board_committee_suggestions', options);

/**
 * Get Board Committee Suggestions
 *
 * On a board meeting whose minutes are not approved, the decisions of each committee whose
 * practice is to bring them to the board's next meeting: motions recorded as carried at its own
 * meetings, in the open session, and its executed written consents (none approving minutes),
 * recorded while that practice was on, taken before the meeting's day and on no board meeting's
 * agenda yet. Worked out each time it is read; nothing is added to the agenda until someone adds
 * it. On a committee's meeting, a cancelled one or one whose minutes are approved, `offered` is
 * false and the list is empty.
 */
export const charityBoardGetBoardCommitteeSuggestionsOptions = (options: Options<CharityBoardGetBoardCommitteeSuggestionsData>) => queryOptions<CharityBoardGetBoardCommitteeSuggestionsResponse, CharityBoardGetBoardCommitteeSuggestionsError, CharityBoardGetBoardCommitteeSuggestionsResponse, ReturnType<typeof charityBoardGetBoardCommitteeSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCommitteeSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCommitteeSuggestionsQueryKey(options)
});

/**
 * Restore Board Committee Suggestion
 *
 * Bring the suggested committee decisions back after they were put away for this meeting.
 */
export const charityBoardRestoreBoardCommitteeSuggestionMutation = (options?: Partial<Options<CharityBoardRestoreBoardCommitteeSuggestionData>>): UseMutationOptions<CharityBoardRestoreBoardCommitteeSuggestionResponse, CharityBoardRestoreBoardCommitteeSuggestionError, Options<CharityBoardRestoreBoardCommitteeSuggestionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRestoreBoardCommitteeSuggestionResponse, CharityBoardRestoreBoardCommitteeSuggestionError, Options<CharityBoardRestoreBoardCommitteeSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRestoreBoardCommitteeSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss Board Committee Suggestion
 *
 * Put the suggested committee decisions away for this meeting ("Not for this meeting"),
 * recording who and when. They can be brought back, and the next board meeting suggests them
 * again.
 */
export const charityBoardDismissBoardCommitteeSuggestionMutation = (options?: Partial<Options<CharityBoardDismissBoardCommitteeSuggestionData>>): UseMutationOptions<CharityBoardDismissBoardCommitteeSuggestionResponse, CharityBoardDismissBoardCommitteeSuggestionError, Options<CharityBoardDismissBoardCommitteeSuggestionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDismissBoardCommitteeSuggestionResponse, CharityBoardDismissBoardCommitteeSuggestionError, Options<CharityBoardDismissBoardCommitteeSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDismissBoardCommitteeSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardMeetingCompensationDecisionsQueryKey = (options: Options<CharityBoardListBoardMeetingCompensationDecisionsData>) => createQueryKey('charity-board-list_board_meeting_compensation_decisions', options);

/**
 * List Board Meeting Compensation Decisions
 *
 * A meeting's compensation decisions, on the motions you may read: each with whose pay it
 * set, the documents the board relied on (by name and fingerprint), how the board obtained
 * them, the board's reason when it set pay outside the range in that information, who took
 * part, and when it was written down. With the meeting's uploaded papers a decision may name,
 * and whether its record is still open to change.
 */
export const charityBoardListBoardMeetingCompensationDecisionsOptions = (options: Options<CharityBoardListBoardMeetingCompensationDecisionsData>) => queryOptions<CharityBoardListBoardMeetingCompensationDecisionsResponse, CharityBoardListBoardMeetingCompensationDecisionsError, CharityBoardListBoardMeetingCompensationDecisionsResponse, ReturnType<typeof charityBoardListBoardMeetingCompensationDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMeetingCompensationDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMeetingCompensationDecisionsQueryKey(options)
});

export const charityBoardListBoardConflictLinksQueryKey = (options: Options<CharityBoardListBoardConflictLinksData>) => createQueryKey('charity-board-list_board_conflict_links', options);

/**
 * List Board Conflict Links
 *
 * Every decision recorded for this meeting — confirmed links and dismissed ones.
 *
 * Both, because this answers what you have decided about the meeting. The pre-vote view
 * on the in-meeting record carries confirmations only: showing a dismissal beside a
 * motion would put in front of the board exactly the thing you recorded as not being
 * there.
 *
 * A link naming a motion made inside an executive session you were not part of is
 * absent, like the motion itself.
 */
export const charityBoardListBoardConflictLinksOptions = (options: Options<CharityBoardListBoardConflictLinksData>) => queryOptions<CharityBoardListBoardConflictLinksResponse, CharityBoardListBoardConflictLinksError, CharityBoardListBoardConflictLinksResponse, ReturnType<typeof charityBoardListBoardConflictLinksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardConflictLinks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardConflictLinksQueryKey(options)
});

/**
 * Record Board Conflict Link
 *
 * Record your decision about one disclosure and one agenda item or motion.
 *
 * `confirmed` records that the disclosure names this item; `dismissed` records that it
 * does not. Both are kept — a dismissal means the same candidate is not put in front of
 * you again, and it says a human looked, which a missing row does not.
 *
 * A confirmed link on a motion, or on the agenda item a motion was made under, appears
 * beside that motion on the in-meeting record so the board can read it before the vote,
 * and enters the minutes when the draft is next refreshed. What appears there is the
 * recorded facts: who disclosed what, when, when you linked it, and whether a recusal
 * for that seat has been recorded on the motion.
 *
 * A disclosure a later one has replaced can still be linked: only the suggestions filter
 * on what stands today, because a meeting may be minuting something that happened while
 * the earlier disclosure was in force.
 *
 * Refused once the minutes of the meeting are approved — from that point the link is
 * inside the record's content hash, and a change is a correction of the minutes.
 */
export const charityBoardRecordBoardConflictLinkMutation = (options?: Partial<Options<CharityBoardRecordBoardConflictLinkData>>): UseMutationOptions<CharityBoardRecordBoardConflictLinkResponse, CharityBoardRecordBoardConflictLinkError, Options<CharityBoardRecordBoardConflictLinkData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardConflictLinkResponse, CharityBoardRecordBoardConflictLinkError, Options<CharityBoardRecordBoardConflictLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardConflictLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Conflict Link
 *
 * Remove a link recorded in error, while the meeting's record is still open.
 *
 * There is no edit: a decision is recorded or it is not, and changing one is removing it
 * and recording the other. Refused once the minutes are approved, like every other write
 * against a closed meeting record.
 */
export const charityBoardDeleteBoardConflictLinkMutation = (options?: Partial<Options<CharityBoardDeleteBoardConflictLinkData>>): UseMutationOptions<CharityBoardDeleteBoardConflictLinkResponse, CharityBoardDeleteBoardConflictLinkError, Options<CharityBoardDeleteBoardConflictLinkData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardConflictLinkResponse, CharityBoardDeleteBoardConflictLinkError, Options<CharityBoardDeleteBoardConflictLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardConflictLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardConflictSuggestionsQueryKey = (options: Options<CharityBoardListBoardConflictSuggestionsData>) => createQueryKey('charity-board-list_board_conflict_suggestions', options);

/**
 * List Board Conflict Suggestions
 *
 * Candidate links between recorded disclosures and this meeting's items.
 *
 * Each counterparty name recorded on a standing disclosure is looked for in the wording
 * of the meeting's agenda items and motions, matching whole words only. Nothing else is
 * read, and nothing is recorded here: a candidate becomes a fact when you confirm it.
 *
 * `method` says exactly that on every response, because the risky reading of an empty
 * list is that something was checked and found clear. A candidate that does not appear
 * is one this text match did not find.
 */
export const charityBoardListBoardConflictSuggestionsOptions = (options: Options<CharityBoardListBoardConflictSuggestionsData>) => queryOptions<CharityBoardListBoardConflictSuggestionsResponse, CharityBoardListBoardConflictSuggestionsError, CharityBoardListBoardConflictSuggestionsResponse, ReturnType<typeof charityBoardListBoardConflictSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardConflictSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardConflictSuggestionsQueryKey(options)
});

export const charityBoardListBoardDocumentsQueryKey = (options: Options<CharityBoardListBoardDocumentsData>) => createQueryKey('charity-board-list_board_documents', options);

/**
 * List Board Documents
 *
 * One meeting's attachments. Never carries a storage key or a read URL.
 */
export const charityBoardListBoardDocumentsOptions = (options: Options<CharityBoardListBoardDocumentsData>) => queryOptions<CharityBoardListBoardDocumentsResponse, CharityBoardListBoardDocumentsError, CharityBoardListBoardDocumentsResponse, ReturnType<typeof charityBoardListBoardDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardDocumentsQueryKey(options)
});

/**
 * Confirm Board Document
 *
 * Confirm that an attachment finished uploading.
 *
 * Nothing is recorded unless the object is found where the reference says it is: a row
 * for an upload that never completed is an attachment the packet cannot render.
 * `reported_content_digest` is optional and self-reported — this API does not read the
 * object back to check it, and the field name says so.
 */
export const charityBoardConfirmBoardDocumentMutation = (options?: Partial<Options<CharityBoardConfirmBoardDocumentData>>): UseMutationOptions<CharityBoardConfirmBoardDocumentResponse, CharityBoardConfirmBoardDocumentError, Options<CharityBoardConfirmBoardDocumentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardConfirmBoardDocumentResponse, CharityBoardConfirmBoardDocumentError, Options<CharityBoardConfirmBoardDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardConfirmBoardDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Issue Board Document Upload Url
 *
 * Issue a short-lived signed upload URL for one packet attachment.
 *
 * Two steps — issue, then confirm — so the bytes go straight to storage and never
 * through this API. The URL is bound to the content type declared here, and no row is
 * written until the confirm call finds the object actually there.
 */
export const charityBoardIssueBoardDocumentUploadUrlMutation = (options?: Partial<Options<CharityBoardIssueBoardDocumentUploadUrlData>>): UseMutationOptions<CharityBoardIssueBoardDocumentUploadUrlResponse, CharityBoardIssueBoardDocumentUploadUrlError, Options<CharityBoardIssueBoardDocumentUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardIssueBoardDocumentUploadUrlResponse, CharityBoardIssueBoardDocumentUploadUrlError, Options<CharityBoardIssueBoardDocumentUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardIssueBoardDocumentUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardDocumentDownloadUrlQueryKey = (options: Options<CharityBoardGetBoardDocumentDownloadUrlData>) => createQueryKey('charity-board-get_board_document_download_url', options);

/**
 * Get Board Document Download Url
 *
 * Mint a short-lived signed read URL for one attachment. Never persisted.
 */
export const charityBoardGetBoardDocumentDownloadUrlOptions = (options: Options<CharityBoardGetBoardDocumentDownloadUrlData>) => queryOptions<CharityBoardGetBoardDocumentDownloadUrlResponse, CharityBoardGetBoardDocumentDownloadUrlError, CharityBoardGetBoardDocumentDownloadUrlResponse, ReturnType<typeof charityBoardGetBoardDocumentDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardDocumentDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardDocumentDownloadUrlQueryKey(options)
});

export const charityBoardGetBoardInMeetingRecordQueryKey = (options: Options<CharityBoardGetBoardInMeetingRecordData>) => createQueryKey('charity-board-get_board_in_meeting_record', options);

/**
 * Get Board In Meeting Record
 *
 * Everything the charity recorded about one meeting, as this reader may see it.
 */
export const charityBoardGetBoardInMeetingRecordOptions = (options: Options<CharityBoardGetBoardInMeetingRecordData>) => queryOptions<CharityBoardGetBoardInMeetingRecordResponse, CharityBoardGetBoardInMeetingRecordError, CharityBoardGetBoardInMeetingRecordResponse, ReturnType<typeof charityBoardGetBoardInMeetingRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardInMeetingRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardInMeetingRecordQueryKey(options)
});

export const charityBoardGetBoardMeetingInvitationsQueryKey = (options: Options<CharityBoardGetBoardMeetingInvitationsData>) => createQueryKey('charity-board-get_board_meeting_invitations', options);

/**
 * Get Board Meeting Invitations
 *
 * How a meeting reached directors' calendars: the sender, the state, and each invited
 * director with their latest reply in their calendar.
 */
export const charityBoardGetBoardMeetingInvitationsOptions = (options: Options<CharityBoardGetBoardMeetingInvitationsData>) => queryOptions<CharityBoardGetBoardMeetingInvitationsResponse, CharityBoardGetBoardMeetingInvitationsError, CharityBoardGetBoardMeetingInvitationsResponse, ReturnType<typeof charityBoardGetBoardMeetingInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardMeetingInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardMeetingInvitationsQueryKey(options)
});

/**
 * Send Board Meeting Invitations
 *
 * Send a meeting's invitations to the board's active directors from the chosen sender.
 * Scheduling a meeting sends nothing; this is the officer's act. Sending again from the same
 * sender retries what did not go out.
 */
export const charityBoardSendBoardMeetingInvitationsMutation = (options?: Partial<Options<CharityBoardSendBoardMeetingInvitationsData>>): UseMutationOptions<CharityBoardSendBoardMeetingInvitationsResponse, CharityBoardSendBoardMeetingInvitationsError, Options<CharityBoardSendBoardMeetingInvitationsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSendBoardMeetingInvitationsResponse, CharityBoardSendBoardMeetingInvitationsError, Options<CharityBoardSendBoardMeetingInvitationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSendBoardMeetingInvitations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Directors Told
 *
 * Record that an officer told the directors about a meeting's earlier invitations, which
 * Board can't prove are gone: the warning clears and Board stops acting on those invitations.
 * Sends nothing (CBG-FIX32).
 */
export const charityBoardRecordBoardDirectorsToldMutation = (options?: Partial<Options<CharityBoardRecordBoardDirectorsToldData>>): UseMutationOptions<CharityBoardRecordBoardDirectorsToldResponse, CharityBoardRecordBoardDirectorsToldError, Options<CharityBoardRecordBoardDirectorsToldData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardDirectorsToldResponse, CharityBoardRecordBoardDirectorsToldError, Options<CharityBoardRecordBoardDirectorsToldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardDirectorsTold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reinvite Board Meeting Invitee
 *
 * Invite one director again, including one removed from the invitation in a calendar.
 */
export const charityBoardReinviteBoardMeetingInviteeMutation = (options?: Partial<Options<CharityBoardReinviteBoardMeetingInviteeData>>): UseMutationOptions<CharityBoardReinviteBoardMeetingInviteeResponse, CharityBoardReinviteBoardMeetingInviteeError, Options<CharityBoardReinviteBoardMeetingInviteeData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReinviteBoardMeetingInviteeResponse, CharityBoardReinviteBoardMeetingInviteeError, Options<CharityBoardReinviteBoardMeetingInviteeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReinviteBoardMeetingInvitee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move Board Meeting Invitations
 *
 * Send a meeting's invitations from another sender instead (directors get one
 * cancellation and one new invitation), or stop keeping it in step with a calendar.
 */
export const charityBoardMoveBoardMeetingInvitationsMutation = (options?: Partial<Options<CharityBoardMoveBoardMeetingInvitationsData>>): UseMutationOptions<CharityBoardMoveBoardMeetingInvitationsResponse, CharityBoardMoveBoardMeetingInvitationsError, Options<CharityBoardMoveBoardMeetingInvitationsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardMoveBoardMeetingInvitationsResponse, CharityBoardMoveBoardMeetingInvitationsError, Options<CharityBoardMoveBoardMeetingInvitationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardMoveBoardMeetingInvitations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Schedule Restored Board Meeting
 *
 * Schedule again a meeting that was cancelled in the organizer's calendar and is back
 * there: a new meeting linked to the restored event, with the old meeting's agenda. Sends no
 * invitation.
 */
export const charityBoardScheduleRestoredBoardMeetingMutation = (options?: Partial<Options<CharityBoardScheduleRestoredBoardMeetingData>>): UseMutationOptions<CharityBoardScheduleRestoredBoardMeetingResponse, CharityBoardScheduleRestoredBoardMeetingError, Options<CharityBoardScheduleRestoredBoardMeetingData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardScheduleRestoredBoardMeetingResponse, CharityBoardScheduleRestoredBoardMeetingError, Options<CharityBoardScheduleRestoredBoardMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardScheduleRestoredBoardMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardMeetingEventsQueryKey = (options: Options<CharityBoardListBoardMeetingEventsData>) => createQueryKey('charity-board-list_board_meeting_events', options);

/**
 * List Board Meeting Events
 *
 * One meeting's append-only event log, oldest first.
 *
 * It exists for the notice figures: a meeting moved from twenty days out to three shows
 * its final count, and this log is where a reader sees that it was once different.
 */
export const charityBoardListBoardMeetingEventsOptions = (options: Options<CharityBoardListBoardMeetingEventsData>) => queryOptions<CharityBoardListBoardMeetingEventsResponse, CharityBoardListBoardMeetingEventsError, CharityBoardListBoardMeetingEventsResponse, ReturnType<typeof charityBoardListBoardMeetingEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMeetingEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMeetingEventsQueryKey(options)
});

export const charityBoardGetBoardMinutesQueryKey = (options: Options<CharityBoardGetBoardMinutesData>) => createQueryKey('charity-board-get_board_minutes', options);

/**
 * Get Board Minutes
 *
 * The minutes of one meeting — or, with `segment_id`, of one of its closed sessions.
 */
export const charityBoardGetBoardMinutesOptions = (options: Options<CharityBoardGetBoardMinutesData>) => queryOptions<CharityBoardGetBoardMinutesResponse, CharityBoardGetBoardMinutesError, CharityBoardGetBoardMinutesResponse, ReturnType<typeof charityBoardGetBoardMinutesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardMinutes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardMinutesQueryKey(options)
});

/**
 * Write Board Minutes Draft
 *
 * Open or refresh the minutes draft for a meeting, or for one of its closed sessions.
 *
 * What the charity recorded about the meeting — who was present, the sessions, the motions
 * with their votes and recusals and the quorum figures at each — is assembled by the module
 * and returned as `structured_record`. `body` is the recording officer's own sections and
 * is theirs alone; the two are separate fields so it stays answerable afterwards which
 * words were whose.
 *
 * Call it again while the minutes are a draft and the assembled part is re-taken, so a
 * motion recorded after the draft was opened is in it. Once the board has approved them it
 * is refused: a change to approved minutes is recorded as a correction.
 */
export const charityBoardWriteBoardMinutesDraftMutation = (options?: Partial<Options<CharityBoardWriteBoardMinutesDraftData>>): UseMutationOptions<CharityBoardWriteBoardMinutesDraftResponse, CharityBoardWriteBoardMinutesDraftError, Options<CharityBoardWriteBoardMinutesDraftData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardWriteBoardMinutesDraftResponse, CharityBoardWriteBoardMinutesDraftError, Options<CharityBoardWriteBoardMinutesDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardWriteBoardMinutesDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Board Minutes
 *
 * Approve minutes as the recording officer.
 *
 * The other door is a motion the board carries at its next meeting, which records which
 * meeting approved them. Both write the same approval event and name a human.
 *
 * `content_hash` is the address of the exact minutes being approved. If they changed since
 * they were read, the approval is refused rather than applied to different words.
 */
export const charityBoardApproveBoardMinutesMutation = (options?: Partial<Options<CharityBoardApproveBoardMinutesData>>): UseMutationOptions<CharityBoardApproveBoardMinutesResponse, CharityBoardApproveBoardMinutesError, Options<CharityBoardApproveBoardMinutesData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardApproveBoardMinutesResponse, CharityBoardApproveBoardMinutesError, Options<CharityBoardApproveBoardMinutesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardApproveBoardMinutes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ask Board Minutes Approval Signatures
 *
 * Ask the directors who were in a closed session to sign to approve its minutes.
 *
 * Only where the board's own rule approves a closed session's minutes by the signatures of the
 * directors who were there; any other way is the typed 409 `board_minutes_approval_way`. Asked:
 * every seat recorded as in the session that is a director now, recused from a decision in it or
 * not. Not a written consent: it is never every director's. `content_hash` is the bytes read; the
 * minutes stay a draft while the request is out, and the last asked signature on the current
 * bytes approves them. Nobody to ask, or a request already out, is a typed 409; nothing written.
 */
export const charityBoardAskBoardMinutesApprovalSignaturesMutation = (options?: Partial<Options<CharityBoardAskBoardMinutesApprovalSignaturesData>>): UseMutationOptions<CharityBoardAskBoardMinutesApprovalSignaturesResponse, CharityBoardAskBoardMinutesApprovalSignaturesError, Options<CharityBoardAskBoardMinutesApprovalSignaturesData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAskBoardMinutesApprovalSignaturesResponse, CharityBoardAskBoardMinutesApprovalSignaturesError, Options<CharityBoardAskBoardMinutesApprovalSignaturesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAskBoardMinutesApprovalSignatures({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Minutes Approval Signature On Behalf
 *
 * Record an asked director's signature to approve, given on paper or by email.
 *
 * The officer's entry, never the director's own act: it records that the officer wrote it down,
 * with a required note saying where the signature came from. The seat must be one the open
 * request asked (else the typed 409 `board_minutes_not_asked_to_sign`). It may be the last
 * signature, and then the minutes are approved.
 */
export const charityBoardRecordBoardMinutesApprovalSignatureOnBehalfMutation = (options?: Partial<Options<CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfData>>): UseMutationOptions<CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfResponse, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfError, Options<CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfResponse, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfError, Options<CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardMinutesApprovalSignatureOnBehalf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Board Minutes Approval Signatures
 *
 * Withdraw the open request for signatures on a closed session's minutes, with the reason.
 *
 * The signatures already given stay in the minutes' history and count for nothing; asking
 * again starts fresh. No request out is a typed 409 `board_minutes_no_signatures_asked`.
 */
export const charityBoardWithdrawBoardMinutesApprovalSignaturesMutation = (options?: Partial<Options<CharityBoardWithdrawBoardMinutesApprovalSignaturesData>>): UseMutationOptions<CharityBoardWithdrawBoardMinutesApprovalSignaturesResponse, CharityBoardWithdrawBoardMinutesApprovalSignaturesError, Options<CharityBoardWithdrawBoardMinutesApprovalSignaturesData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardWithdrawBoardMinutesApprovalSignaturesResponse, CharityBoardWithdrawBoardMinutesApprovalSignaturesError, Options<CharityBoardWithdrawBoardMinutesApprovalSignaturesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardWithdrawBoardMinutesApprovalSignatures({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Board Minutes Reminder
 *
 * Send the board a reminder that a meeting's minutes are not yet recorded.
 *
 * An act the charity performs; nothing schedules it. The response carries the same dates
 * the in-app view shows, and `skip_reason` says why no mail went out when none did, rather
 * than leaving a count of zero to read as a failure.
 */
export const charityBoardSendBoardMinutesReminderMutation = (options?: Partial<Options<CharityBoardSendBoardMinutesReminderData>>): UseMutationOptions<CharityBoardSendBoardMinutesReminderResponse, CharityBoardSendBoardMinutesReminderError, Options<CharityBoardSendBoardMinutesReminderData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSendBoardMinutesReminderResponse, CharityBoardSendBoardMinutesReminderError, Options<CharityBoardSendBoardMinutesReminderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSendBoardMinutesReminder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign Board Minutes On Behalf
 *
 * Record a signature someone on the roster gave on paper.
 *
 * The manual path, and it stays valid forever: nothing about the board's ability to record
 * its own minutes depends on a director adopting the portal. The entry records that the
 * officer wrote it down, never that the person acted inside their own session, and it
 * carries a required note saying where the signature came from.
 *
 * `capacity_title_id` (optional) records the title they signed as: one of the titles that seat
 * holds now, kept with the signature in the words it has today, so a later rename never changes
 * it. A title the seat doesn't hold is a 409 `board_signature_capacity_not_held`.
 */
export const charityBoardSignBoardMinutesOnBehalfMutation = (options?: Partial<Options<CharityBoardSignBoardMinutesOnBehalfData>>): UseMutationOptions<CharityBoardSignBoardMinutesOnBehalfResponse, CharityBoardSignBoardMinutesOnBehalfError, Options<CharityBoardSignBoardMinutesOnBehalfData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSignBoardMinutesOnBehalfResponse, CharityBoardSignBoardMinutesOnBehalfError, Options<CharityBoardSignBoardMinutesOnBehalfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSignBoardMinutesOnBehalf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardMotionsQueryKey = (options: Options<CharityBoardListBoardMotionsData>) => createQueryKey('charity-board-list_board_motions', options);

/**
 * List Board Motions
 *
 * One meeting's motions, in order, as this reader may see them.
 *
 * A motion made inside a closed session this reader was not part of does not appear.
 */
export const charityBoardListBoardMotionsOptions = (options: Options<CharityBoardListBoardMotionsData>) => queryOptions<CharityBoardListBoardMotionsResponse, CharityBoardListBoardMotionsError, CharityBoardListBoardMotionsResponse, ReturnType<typeof charityBoardListBoardMotionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMotions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMotionsQueryKey(options)
});

/**
 * Create Board Motion
 *
 * Record a motion as put — its exact wording, who moved it, and who seconded it.
 *
 * An amendment names the motion it amends, so the board's own drafting history stays
 * walkable. The wording stays editable until a vote is recorded and is frozen from then on.
 */
export const charityBoardCreateBoardMotionMutation = (options?: Partial<Options<CharityBoardCreateBoardMotionData>>): UseMutationOptions<CharityBoardCreateBoardMotionResponse, CharityBoardCreateBoardMotionError, Options<CharityBoardCreateBoardMotionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardMotionResponse, CharityBoardCreateBoardMotionError, Options<CharityBoardCreateBoardMotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardMotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Motion
 *
 * Remove a motion recorded in error, while no vote on it has been recorded.
 */
export const charityBoardDeleteBoardMotionMutation = (options?: Partial<Options<CharityBoardDeleteBoardMotionData>>): UseMutationOptions<CharityBoardDeleteBoardMotionResponse, CharityBoardDeleteBoardMotionError, Options<CharityBoardDeleteBoardMotionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardMotionResponse, CharityBoardDeleteBoardMotionError, Options<CharityBoardDeleteBoardMotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardMotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Board Motion
 *
 * Edit a motion recorded in error, before a vote on it is recorded.
 */
export const charityBoardUpdateBoardMotionMutation = (options?: Partial<Options<CharityBoardUpdateBoardMotionData>>): UseMutationOptions<CharityBoardUpdateBoardMotionResponse, CharityBoardUpdateBoardMotionError, Options<CharityBoardUpdateBoardMotionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardMotionResponse, CharityBoardUpdateBoardMotionError, Options<CharityBoardUpdateBoardMotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardMotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Board Motion Compensation Decision
 *
 * Record the board's compensation decision for one person on a motion it carried, after the
 * motion's others: whose pay, their position, the meeting's papers the board relied on, how it
 * obtained them, and its reason when it set pay outside the range in that information. Board
 * reads each paper's stored bytes and records its fingerprint. Refused once the meeting's
 * minutes are approved.
 */
export const charityBoardAddBoardMotionCompensationDecisionMutation = (options?: Partial<Options<CharityBoardAddBoardMotionCompensationDecisionData>>): UseMutationOptions<CharityBoardAddBoardMotionCompensationDecisionResponse, CharityBoardAddBoardMotionCompensationDecisionError, Options<CharityBoardAddBoardMotionCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAddBoardMotionCompensationDecisionResponse, CharityBoardAddBoardMotionCompensationDecisionError, Options<CharityBoardAddBoardMotionCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAddBoardMotionCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Board Motion Compensation Decision
 *
 * Remove one decision recorded on a motion, while the meeting's record is open. Its history
 * keeps who recorded and removed it, and when.
 */
export const charityBoardRemoveBoardMotionCompensationDecisionMutation = (options?: Partial<Options<CharityBoardRemoveBoardMotionCompensationDecisionData>>): UseMutationOptions<CharityBoardRemoveBoardMotionCompensationDecisionResponse, CharityBoardRemoveBoardMotionCompensationDecisionError, Options<CharityBoardRemoveBoardMotionCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardMotionCompensationDecisionResponse, CharityBoardRemoveBoardMotionCompensationDecisionError, Options<CharityBoardRemoveBoardMotionCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardMotionCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace Board Motion Compensation Decision
 *
 * Replace one decision's details whole, while the meeting's record is open. A paper it keeps
 * keeps the fingerprint it was recorded with. Minutes drafted before the change name the old
 * details until they are refreshed.
 */
export const charityBoardReplaceBoardMotionCompensationDecisionMutation = (options?: Partial<Options<CharityBoardReplaceBoardMotionCompensationDecisionData>>): UseMutationOptions<CharityBoardReplaceBoardMotionCompensationDecisionResponse, CharityBoardReplaceBoardMotionCompensationDecisionError, Options<CharityBoardReplaceBoardMotionCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReplaceBoardMotionCompensationDecisionResponse, CharityBoardReplaceBoardMotionCompensationDecisionError, Options<CharityBoardReplaceBoardMotionCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReplaceBoardMotionCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Minutes Approval Vote
 *
 * Record the vote on a motion that approves prior minutes.
 *
 * Its own route because a carried vote here does something the ordinary one never does: it
 * turns a draft into the charity's record. The minutes then name the seat the charity
 * recorded as presiding as the person whose declaration concluded the board's approval,
 * the instant, and the exact bytes approved.
 *
 * A vote recorded as failed is recorded exactly that way and the minutes stay a draft — the
 * board declined to approve them, which is itself something the book should say.
 */
export const charityBoardRecordBoardMinutesApprovalVoteMutation = (options?: Partial<Options<CharityBoardRecordBoardMinutesApprovalVoteData>>): UseMutationOptions<CharityBoardRecordBoardMinutesApprovalVoteResponse, CharityBoardRecordBoardMinutesApprovalVoteError, Options<CharityBoardRecordBoardMinutesApprovalVoteData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardMinutesApprovalVoteResponse, CharityBoardRecordBoardMinutesApprovalVoteError, Options<CharityBoardRecordBoardMinutesApprovalVoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardMinutesApprovalVote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Motion Recusal
 *
 * Record a seat as having stood out of the debate and the vote on one motion.
 *
 * Two things follow, and the second is the one boards most often get wrong. The seat's
 * vote becomes uncastable — recording one is refused. And the seat STILL counts among the
 * seats recorded as present, because standing out of a vote is not leaving the room; under
 * Delaware General Corporation Law section 144(d)(1) an interested director is counted for
 * that purpose, and dropping them would tell a board it had lost the seats it needed to act
 * every time someone was conflicted.
 */
export const charityBoardRecordBoardMotionRecusalMutation = (options?: Partial<Options<CharityBoardRecordBoardMotionRecusalData>>): UseMutationOptions<CharityBoardRecordBoardMotionRecusalResponse, CharityBoardRecordBoardMotionRecusalError, Options<CharityBoardRecordBoardMotionRecusalData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardMotionRecusalResponse, CharityBoardRecordBoardMotionRecusalError, Options<CharityBoardRecordBoardMotionRecusalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardMotionRecusal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Board Motion Recusal
 *
 * Remove a recusal recorded in error, before a vote on the motion is recorded.
 */
export const charityBoardRemoveBoardMotionRecusalMutation = (options?: Partial<Options<CharityBoardRemoveBoardMotionRecusalData>>): UseMutationOptions<CharityBoardRemoveBoardMotionRecusalResponse, CharityBoardRemoveBoardMotionRecusalError, Options<CharityBoardRemoveBoardMotionRecusalData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardMotionRecusalResponse, CharityBoardRemoveBoardMotionRecusalError, Options<CharityBoardRemoveBoardMotionRecusalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardMotionRecusal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Motion Vote
 *
 * Record the vote on a motion.
 *
 * Two ways to record it, and both are first class: name each seat's own cast, or give the
 * three counts. With the casts recorded the counts are taken from them, so the two can
 * never disagree.
 *
 * The response carries the quorum figures captured at the instant of the vote — how many
 * of the board's seats were recorded as present, against the quorum the charity itself
 * recorded, with the section of its own governing instrument that number came from. A
 * shortfall is stated in seats and never blocks: the board owns its own acts.
 *
 * `outcome` is what the charity records. The module states the tally beside the recorded
 * threshold; whether a motion carried is the chair's declaration.
 *
 * A motion that approves prior minutes is refused here and belongs on the minutes-approval
 * route, which requires the authority to record the charity's own minute book.
 */
export const charityBoardRecordBoardMotionVoteMutation = (options?: Partial<Options<CharityBoardRecordBoardMotionVoteData>>): UseMutationOptions<CharityBoardRecordBoardMotionVoteResponse, CharityBoardRecordBoardMotionVoteError, Options<CharityBoardRecordBoardMotionVoteData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardMotionVoteResponse, CharityBoardRecordBoardMotionVoteError, Options<CharityBoardRecordBoardMotionVoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardMotionVote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Board Motion
 *
 * Record a motion as withdrawn before it was voted on.
 *
 * Recorded rather than deleted: withdrawing is a real thing the board did. It also takes
 * the motion out of the carry-forward list, which reports only what is still open.
 */
export const charityBoardWithdrawBoardMotionMutation = (options?: Partial<Options<CharityBoardWithdrawBoardMotionData>>): UseMutationOptions<CharityBoardWithdrawBoardMotionResponse, CharityBoardWithdrawBoardMotionError, Options<CharityBoardWithdrawBoardMotionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardWithdrawBoardMotionResponse, CharityBoardWithdrawBoardMotionError, Options<CharityBoardWithdrawBoardMotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardWithdrawBoardMotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardPacketsQueryKey = (options: Options<CharityBoardListBoardPacketsData>) => createQueryKey('charity-board-list_board_packets', options);

/**
 * List Board Packets
 *
 * A meeting's packet versions, newest first. Contents are not hydrated here.
 */
export const charityBoardListBoardPacketsOptions = (options: Options<CharityBoardListBoardPacketsData>) => queryOptions<CharityBoardListBoardPacketsResponse, CharityBoardListBoardPacketsError, CharityBoardListBoardPacketsResponse, ReturnType<typeof charityBoardListBoardPacketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardPackets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardPacketsQueryKey(options)
});

/**
 * Create Board Packet
 *
 * Open the next draft packet version for a meeting.
 *
 * The version number is assigned by the module. At most one draft is in flight at a
 * time: two drafts for one meeting are two people assembling different packets with no
 * way to say which is next.
 */
export const charityBoardCreateBoardPacketMutation = (options?: Partial<Options<CharityBoardCreateBoardPacketData>>): UseMutationOptions<CharityBoardCreateBoardPacketResponse, CharityBoardCreateBoardPacketError, Options<CharityBoardCreateBoardPacketData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardPacketResponse, CharityBoardCreateBoardPacketError, Options<CharityBoardCreateBoardPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardMeetingPresidingQueryKey = (options: Options<CharityBoardGetBoardMeetingPresidingData>) => createQueryKey('charity-board-get_board_meeting_presiding', options);

/**
 * Get Board Meeting Presiding
 *
 * Who presided at the meeting, the people recorded as present (each as the minutes would
 * name them presiding), and whom the board's adopted duties suggest: the person present who held,
 * on the meeting's day, a title the duties give presiding. Nothing is recorded by reading it.
 */
export const charityBoardGetBoardMeetingPresidingOptions = (options: Options<CharityBoardGetBoardMeetingPresidingData>) => queryOptions<CharityBoardGetBoardMeetingPresidingResponse, CharityBoardGetBoardMeetingPresidingError, CharityBoardGetBoardMeetingPresidingResponse, ReturnType<typeof charityBoardGetBoardMeetingPresidingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardMeetingPresiding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardMeetingPresidingQueryKey(options)
});

/**
 * Record Board Meeting Presiding
 *
 * Record who presided at the meeting, or clear it with a null.
 *
 * A recorded fact, the officer's entry in "Who was there": one of the people recorded as present,
 * never derived from a title. At most one person presides per meeting, and only someone recorded
 * as present — both held by the database. Answers the meeting's attendance rows as they now
 * stand, the presiding person's carrying `presided: true`.
 */
export const charityBoardRecordBoardMeetingPresidingMutation = (options?: Partial<Options<CharityBoardRecordBoardMeetingPresidingData>>): UseMutationOptions<CharityBoardRecordBoardMeetingPresidingResponse, CharityBoardRecordBoardMeetingPresidingError, Options<CharityBoardRecordBoardMeetingPresidingData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardMeetingPresidingResponse, CharityBoardRecordBoardMeetingPresidingError, Options<CharityBoardRecordBoardMeetingPresidingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardMeetingPresiding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardMeetingSegmentsQueryKey = (options: Options<CharityBoardListBoardMeetingSegmentsData>) => createQueryKey('charity-board-list_board_meeting_segments', options);

/**
 * List Board Meeting Segments
 *
 * The parts of one meeting, in order, as this reader may see them.
 *
 * A closed session this reader was not part of does not appear, and no ordinal is carried
 * on the wire — an index on a list that may have had entries withheld would count them.
 */
export const charityBoardListBoardMeetingSegmentsOptions = (options: Options<CharityBoardListBoardMeetingSegmentsData>) => queryOptions<CharityBoardListBoardMeetingSegmentsResponse, CharityBoardListBoardMeetingSegmentsError, CharityBoardListBoardMeetingSegmentsResponse, ReturnType<typeof charityBoardListBoardMeetingSegmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMeetingSegments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMeetingSegmentsQueryKey(options)
});

/**
 * Create Board Meeting Segment
 *
 * Record a part of a meeting — an ordinary session, or an executive session.
 *
 * An executive session carries its own participant list, and everything recorded inside it
 * is readable only by those participants. That binds charity admins as well as directors:
 * an administrator who was not in the room does not see it, and it is ABSENT for them
 * rather than refused.
 */
export const charityBoardCreateBoardMeetingSegmentMutation = (options?: Partial<Options<CharityBoardCreateBoardMeetingSegmentData>>): UseMutationOptions<CharityBoardCreateBoardMeetingSegmentResponse, CharityBoardCreateBoardMeetingSegmentError, Options<CharityBoardCreateBoardMeetingSegmentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardMeetingSegmentResponse, CharityBoardCreateBoardMeetingSegmentError, Options<CharityBoardCreateBoardMeetingSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardMeetingSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder Board Meeting Segments
 *
 * Reorder a meeting's sessions by naming every one once, in the order wanted.
 */
export const charityBoardReorderBoardMeetingSegmentsMutation = (options?: Partial<Options<CharityBoardReorderBoardMeetingSegmentsData>>): UseMutationOptions<CharityBoardReorderBoardMeetingSegmentsResponse, CharityBoardReorderBoardMeetingSegmentsError, Options<CharityBoardReorderBoardMeetingSegmentsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReorderBoardMeetingSegmentsResponse, CharityBoardReorderBoardMeetingSegmentsError, Options<CharityBoardReorderBoardMeetingSegmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReorderBoardMeetingSegments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Meeting Segment
 *
 * Remove a session recorded in error, while the minutes are still a draft.
 */
export const charityBoardDeleteBoardMeetingSegmentMutation = (options?: Partial<Options<CharityBoardDeleteBoardMeetingSegmentData>>): UseMutationOptions<CharityBoardDeleteBoardMeetingSegmentResponse, CharityBoardDeleteBoardMeetingSegmentError, Options<CharityBoardDeleteBoardMeetingSegmentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardMeetingSegmentResponse, CharityBoardDeleteBoardMeetingSegmentError, Options<CharityBoardDeleteBoardMeetingSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardMeetingSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Board Meeting Segment
 *
 * Edit a recorded session.
 *
 * Which KIND of session it is cannot be changed here or anywhere: that would change who may
 * read everything recorded inside it, and a field flip is how a closed session gets
 * published by accident.
 */
export const charityBoardUpdateBoardMeetingSegmentMutation = (options?: Partial<Options<CharityBoardUpdateBoardMeetingSegmentData>>): UseMutationOptions<CharityBoardUpdateBoardMeetingSegmentResponse, CharityBoardUpdateBoardMeetingSegmentError, Options<CharityBoardUpdateBoardMeetingSegmentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardMeetingSegmentResponse, CharityBoardUpdateBoardMeetingSegmentError, Options<CharityBoardUpdateBoardMeetingSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardMeetingSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Segment Participant
 *
 * Record one person as present for a session — a seat on this board, or someone else.
 *
 * A non-director the board invited in is named outright, because the point of a closed
 * session's list is who was in the room. A seat's name is taken from the roster and stored
 * as it stood then, so a later rename does not change what this says about that evening.
 */
export const charityBoardRecordBoardSegmentParticipantMutation = (options?: Partial<Options<CharityBoardRecordBoardSegmentParticipantData>>): UseMutationOptions<CharityBoardRecordBoardSegmentParticipantResponse, CharityBoardRecordBoardSegmentParticipantError, Options<CharityBoardRecordBoardSegmentParticipantData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardSegmentParticipantResponse, CharityBoardRecordBoardSegmentParticipantError, Options<CharityBoardRecordBoardSegmentParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardSegmentParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Board Segment Participant
 *
 * Remove someone recorded in error, while the minutes are still a draft.
 */
export const charityBoardRemoveBoardSegmentParticipantMutation = (options?: Partial<Options<CharityBoardRemoveBoardSegmentParticipantData>>): UseMutationOptions<CharityBoardRemoveBoardSegmentParticipantResponse, CharityBoardRemoveBoardSegmentParticipantError, Options<CharityBoardRemoveBoardSegmentParticipantData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardSegmentParticipantResponse, CharityBoardRemoveBoardSegmentParticipantError, Options<CharityBoardRemoveBoardSegmentParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardSegmentParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardTermSuggestionsQueryKey = (options: Options<CharityBoardGetBoardTermSuggestionsData>) => createQueryKey('charity-board-get_board_term_suggestions', options);

/**
 * Get Board Term Suggestions
 *
 * On a meeting typed annual, the terms on the roster that have ended, or end within three
 * months of the meeting: directors by their current term's recorded end, officers by their
 * title's recorded end (or, when the board recorded its officers' term length, the end it gives).
 * Worked out each time it is read; nothing here is stored but a dismissal, and nothing is added
 * to the agenda until someone adds it. On any other meeting, `offered` is false and the lists
 * are empty.
 */
export const charityBoardGetBoardTermSuggestionsOptions = (options: Options<CharityBoardGetBoardTermSuggestionsData>) => queryOptions<CharityBoardGetBoardTermSuggestionsResponse, CharityBoardGetBoardTermSuggestionsError, CharityBoardGetBoardTermSuggestionsResponse, ReturnType<typeof charityBoardGetBoardTermSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardTermSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardTermSuggestionsQueryKey(options)
});

/**
 * Restore Board Term Suggestion
 *
 * Bring the annual meeting's election suggestion back after it was put away.
 */
export const charityBoardRestoreBoardTermSuggestionMutation = (options?: Partial<Options<CharityBoardRestoreBoardTermSuggestionData>>): UseMutationOptions<CharityBoardRestoreBoardTermSuggestionResponse, CharityBoardRestoreBoardTermSuggestionError, Options<CharityBoardRestoreBoardTermSuggestionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRestoreBoardTermSuggestionResponse, CharityBoardRestoreBoardTermSuggestionError, Options<CharityBoardRestoreBoardTermSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRestoreBoardTermSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss Board Term Suggestion
 *
 * Put the annual meeting's election suggestion away for this meeting ("Not for this
 * meeting"), recording who and when. It can be brought back.
 */
export const charityBoardDismissBoardTermSuggestionMutation = (options?: Partial<Options<CharityBoardDismissBoardTermSuggestionData>>): UseMutationOptions<CharityBoardDismissBoardTermSuggestionResponse, CharityBoardDismissBoardTermSuggestionError, Options<CharityBoardDismissBoardTermSuggestionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDismissBoardTermSuggestionResponse, CharityBoardDismissBoardTermSuggestionError, Options<CharityBoardDismissBoardTermSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDismissBoardTermSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardMemberProposalsQueryKey = (options: Options<CharityBoardListBoardMemberProposalsData>) => createQueryKey('charity-board-list_board_member_proposals', options);

/**
 * List Board Member Proposals
 *
 * The board members a connected AI proposed that wait for a person to add or discard them,
 * oldest first: each one's details as proposed, the AI's note on where it found them, and whose
 * connection proposed them. None of them is on the board until a person adds them.
 */
export const charityBoardListBoardMemberProposalsOptions = (options: Options<CharityBoardListBoardMemberProposalsData>) => queryOptions<CharityBoardListBoardMemberProposalsResponse, CharityBoardListBoardMemberProposalsError, CharityBoardListBoardMemberProposalsResponse, ReturnType<typeof charityBoardListBoardMemberProposalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMemberProposals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMemberProposalsQueryKey(options)
});

/**
 * Discard Board Member Proposal
 *
 * Discard a proposed board member. Nobody is added, and the proposal keeps no name or
 * address. A person's act: a connected AI cannot discard one.
 */
export const charityBoardDiscardBoardMemberProposalMutation = (options?: Partial<Options<CharityBoardDiscardBoardMemberProposalData>>): UseMutationOptions<CharityBoardDiscardBoardMemberProposalResponse, CharityBoardDiscardBoardMemberProposalError, Options<CharityBoardDiscardBoardMemberProposalData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDiscardBoardMemberProposalResponse, CharityBoardDiscardBoardMemberProposalError, Options<CharityBoardDiscardBoardMemberProposalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDiscardBoardMemberProposal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardMembersQueryKey = (options: Options<CharityBoardListBoardMembersData>) => createQueryKey('charity-board-list_board_members', options);

/**
 * List Board Members
 *
 * The charity's board roster, newest first.
 *
 * Active seats only unless `include_removed` is set: the ordinary question is who is on
 * the board, and roster history — which is never deleted — is opt-in.
 */
export const charityBoardListBoardMembersOptions = (options: Options<CharityBoardListBoardMembersData>) => queryOptions<CharityBoardListBoardMembersResponse, CharityBoardListBoardMembersError, CharityBoardListBoardMembersResponse, ReturnType<typeof charityBoardListBoardMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMembersQueryKey(options)
});

/**
 * Create Board Member
 *
 * Add a seat to the roster.
 *
 * A seat is created from a name and an email of record — nothing else, and nothing about
 * a Givmo account. A director may sit on this roster, receive packets, and have acts
 * recorded on their behalf without ever signing in; their own Givmo account connects to
 * the seat later, through an invitation and a proof of the mailbox, or never.
 */
export const charityBoardCreateBoardMemberMutation = (options?: Partial<Options<CharityBoardCreateBoardMemberData>>): UseMutationOptions<CharityBoardCreateBoardMemberResponse, CharityBoardCreateBoardMemberError, Options<CharityBoardCreateBoardMemberData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardMemberResponse, CharityBoardCreateBoardMemberError, Options<CharityBoardCreateBoardMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardMemberQueryKey = (options: Options<CharityBoardGetBoardMemberData>) => createQueryKey('charity-board-get_board_member', options);

/**
 * Get Board Member
 */
export const charityBoardGetBoardMemberOptions = (options: Options<CharityBoardGetBoardMemberData>) => queryOptions<CharityBoardGetBoardMemberResponse, CharityBoardGetBoardMemberError, CharityBoardGetBoardMemberResponse, ReturnType<typeof charityBoardGetBoardMemberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardMember({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardMemberQueryKey(options)
});

/**
 * Update Board Member
 *
 * Edit a seat (skip-None partial update).
 *
 * Cannot end a seat — that is its own operation, because it kills live credentials and a
 * spelling fix should not travel on the same route.
 */
export const charityBoardUpdateBoardMemberMutation = (options?: Partial<Options<CharityBoardUpdateBoardMemberData>>): UseMutationOptions<CharityBoardUpdateBoardMemberResponse, CharityBoardUpdateBoardMemberError, Options<CharityBoardUpdateBoardMemberData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardMemberResponse, CharityBoardUpdateBoardMemberError, Options<CharityBoardUpdateBoardMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mint Board Access Link
 *
 * Mint a director's invitation link, and mail it when the module can.
 *
 * The response carries the PLAINTEXT token — the one place it ever appears in one. That
 * is a real product path, not a fallback: the recording officer hands a director their
 * link directly (reads it out, pastes it into their own message, prints it), and a module
 * that only ever emailed links would make the volunteer's actual route in impossible. It
 * is safe to hand over: the link only lets the director join with their own Givmo account
 * and their own mailbox. The stored row keeps only the token's digest. A seat whose director
 * has already joined is refused (`board_seat_already_connected`).
 *
 * `email_sent` reports whether a mail also went out. It is false when no template or no
 * board-app base URL is configured, so the caller is told what happened rather than left
 * to assume.
 */
export const charityBoardMintBoardAccessLinkMutation = (options?: Partial<Options<CharityBoardMintBoardAccessLinkData>>): UseMutationOptions<CharityBoardMintBoardAccessLinkResponse, CharityBoardMintBoardAccessLinkError, Options<CharityBoardMintBoardAccessLinkData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardMintBoardAccessLinkResponse, CharityBoardMintBoardAccessLinkError, Options<CharityBoardMintBoardAccessLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardMintBoardAccessLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Release Board Member Account
 *
 * Disconnect the Givmo account that joined the board through this seat, with a recorded
 * reason.
 *
 * The seat stays on the roster and can be invited and joined again; the account's next
 * request as a director is refused. Both the account's own email and the seat's address are
 * told. Changing a seat's email address never disconnects its account — this does, and only
 * this. A seat no account has joined is refused (`board_seat_not_connected`).
 */
export const charityBoardReleaseBoardMemberAccountMutation = (options?: Partial<Options<CharityBoardReleaseBoardMemberAccountData>>): UseMutationOptions<CharityBoardReleaseBoardMemberAccountResponse, CharityBoardReleaseBoardMemberAccountError, Options<CharityBoardReleaseBoardMemberAccountData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReleaseBoardMemberAccountResponse, CharityBoardReleaseBoardMemberAccountError, Options<CharityBoardReleaseBoardMemberAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReleaseBoardMemberAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Paper Acknowledgments
 *
 * Record a signed paper form: that this member signed a paper acknowledgment of these
 * documents, on the date written on it, with a note on where it came from. Each document is
 * recorded as acknowledged, exactly the version named, as entered by you from a paper form.
 */
export const charityBoardRecordBoardPaperAcknowledgmentsMutation = (options?: Partial<Options<CharityBoardRecordBoardPaperAcknowledgmentsData>>): UseMutationOptions<CharityBoardRecordBoardPaperAcknowledgmentsResponse, CharityBoardRecordBoardPaperAcknowledgmentsError, Options<CharityBoardRecordBoardPaperAcknowledgmentsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardPaperAcknowledgmentsResponse, CharityBoardRecordBoardPaperAcknowledgmentsError, Options<CharityBoardRecordBoardPaperAcknowledgmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardPaperAcknowledgments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Board Member To Board
 *
 * Add someone who serves on a committee to the board (CBG-YR6-OUTSIDE-WIDEN): their seat,
 * one for someone who isn't on the board, becomes the board's.
 *
 * The Owner's act, its own operation, as ending a seat is: from the next request the board's
 * meetings, papers, minutes and written consents are open to the seat's account, earlier ones
 * included, and the board's year counts the person as joining today. Nothing else about the seat
 * changes — whether they're a director, and any title, are recorded afterwards — and it can't be
 * undone: a board seat never becomes a committee's alone. No body. A seat someone has joined is
 * emailed to say so.
 */
export const charityBoardAddBoardMemberToBoardMutation = (options?: Partial<Options<CharityBoardAddBoardMemberToBoardData>>): UseMutationOptions<CharityBoardAddBoardMemberToBoardResponse, CharityBoardAddBoardMemberToBoardError, Options<CharityBoardAddBoardMemberToBoardData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAddBoardMemberToBoardResponse, CharityBoardAddBoardMemberToBoardError, Options<CharityBoardAddBoardMemberToBoardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAddBoardMemberToBoard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardMemberGettingStartedQueryKey = (options: Options<CharityBoardGetBoardMemberGettingStartedData>) => createQueryKey('charity-board-get_board_member_getting_started', options);

/**
 * Get Board Member Getting Started
 *
 * A member's getting-started list, each item with what the records say about it: a document
 * confirmed (in Board, from a paper form, or in their annual disclosure) or not yet, their first
 * disclosure, their board buddy, the board's own steps.
 */
export const charityBoardGetBoardMemberGettingStartedOptions = (options: Options<CharityBoardGetBoardMemberGettingStartedData>) => queryOptions<CharityBoardGetBoardMemberGettingStartedResponse, CharityBoardGetBoardMemberGettingStartedError, CharityBoardGetBoardMemberGettingStartedResponse, ReturnType<typeof charityBoardGetBoardMemberGettingStartedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardMemberGettingStarted({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardMemberGettingStartedQueryKey(options)
});

/**
 * Start Board Member Getting Started
 *
 * Start a getting-started list for a member who has none, from the board's list.
 */
export const charityBoardStartBoardMemberGettingStartedMutation = (options?: Partial<Options<CharityBoardStartBoardMemberGettingStartedData>>): UseMutationOptions<CharityBoardStartBoardMemberGettingStartedResponse, CharityBoardStartBoardMemberGettingStartedError, Options<CharityBoardStartBoardMemberGettingStartedData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardStartBoardMemberGettingStartedResponse, CharityBoardStartBoardMemberGettingStartedError, Options<CharityBoardStartBoardMemberGettingStartedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardStartBoardMemberGettingStarted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save Board Member Getting Started
 *
 * Change one member's list from the revision you read: an item sent with its id stays (a
 * step keeps its done date), one without is added, one left out is removed.
 */
export const charityBoardSaveBoardMemberGettingStartedMutation = (options?: Partial<Options<CharityBoardSaveBoardMemberGettingStartedData>>): UseMutationOptions<CharityBoardSaveBoardMemberGettingStartedResponse, CharityBoardSaveBoardMemberGettingStartedError, Options<CharityBoardSaveBoardMemberGettingStartedData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSaveBoardMemberGettingStartedResponse, CharityBoardSaveBoardMemberGettingStartedError, Options<CharityBoardSaveBoardMemberGettingStartedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSaveBoardMemberGettingStarted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Choose Board Member Buddy
 *
 * Choose a member's board buddy: someone serving on the board. It's recorded on the member's
 * history; the buddy is sent nothing and asked to do nothing.
 */
export const charityBoardChooseBoardMemberBuddyMutation = (options?: Partial<Options<CharityBoardChooseBoardMemberBuddyData>>): UseMutationOptions<CharityBoardChooseBoardMemberBuddyResponse, CharityBoardChooseBoardMemberBuddyError, Options<CharityBoardChooseBoardMemberBuddyData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardChooseBoardMemberBuddyResponse, CharityBoardChooseBoardMemberBuddyError, Options<CharityBoardChooseBoardMemberBuddyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardChooseBoardMemberBuddy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close Board Member Getting Started
 *
 * Close a member's list — for someone who left, or a list the board considers done. It can't
 * be reopened.
 */
export const charityBoardCloseBoardMemberGettingStartedMutation = (options?: Partial<Options<CharityBoardCloseBoardMemberGettingStartedData>>): UseMutationOptions<CharityBoardCloseBoardMemberGettingStartedResponse, CharityBoardCloseBoardMemberGettingStartedError, Options<CharityBoardCloseBoardMemberGettingStartedData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCloseBoardMemberGettingStartedResponse, CharityBoardCloseBoardMemberGettingStartedError, Options<CharityBoardCloseBoardMemberGettingStartedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCloseBoardMemberGettingStarted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Board Member Getting Started Step
 *
 * Mark one of the board's own steps done on a member's list, with the date, or clear it.
 */
export const charityBoardMarkBoardMemberGettingStartedStepMutation = (options?: Partial<Options<CharityBoardMarkBoardMemberGettingStartedStepData>>): UseMutationOptions<CharityBoardMarkBoardMemberGettingStartedStepResponse, CharityBoardMarkBoardMemberGettingStartedStepError, Options<CharityBoardMarkBoardMemberGettingStartedStepData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardMarkBoardMemberGettingStartedStepResponse, CharityBoardMarkBoardMemberGettingStartedStepError, Options<CharityBoardMarkBoardMemberGettingStartedStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardMarkBoardMemberGettingStartedStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardMemberHistoryQueryKey = (options: Options<CharityBoardListBoardMemberHistoryData>) => createQueryKey('charity-board-list_board_member_history', options);

/**
 * List Board Member History
 *
 * One seat's history, newest first: when it was added and edited, every change to its
 * email address (the old and the new one), every invitation and whether it was emailed, who
 * joined with which Givmo account and how, any account disconnected and why, and the
 * removal. Each entry names who did it.
 *
 * Owner-only, because the entries carry a director's addresses. Readable for a removed
 * seat too.
 */
export const charityBoardListBoardMemberHistoryOptions = (options: Options<CharityBoardListBoardMemberHistoryData>) => queryOptions<CharityBoardListBoardMemberHistoryResponse, CharityBoardListBoardMemberHistoryError, CharityBoardListBoardMemberHistoryResponse, ReturnType<typeof charityBoardListBoardMemberHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardMemberHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardMemberHistoryQueryKey(options)
});

/**
 * Remove Board Member
 *
 * End a seat, with a recorded reason.
 *
 * Never a delete: the row and its history stay, because who sat on this board and when
 * is part of the charity's record and a former director's past acts must keep resolving
 * to a named seat. Every outstanding invitation of that seat dies with it, and the seat's
 * own standing is re-read on every director request — so removal takes effect on the
 * director's very next call.
 */
export const charityBoardRemoveBoardMemberMutation = (options?: Partial<Options<CharityBoardRemoveBoardMemberData>>): UseMutationOptions<CharityBoardRemoveBoardMemberResponse, CharityBoardRemoveBoardMemberError, Options<CharityBoardRemoveBoardMemberData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardMemberResponse, CharityBoardRemoveBoardMemberError, Options<CharityBoardRemoveBoardMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Member Term
 *
 * Record a term of this seat: the organization's own start and end (at least one), its
 * class, whether the board counts it toward its limit on consecutive terms, the minute-book
 * record it came from (`record_id`) or none, and a note. Saved as entered: dates that overlap
 * another term, or run past the term length or the limit the board recorded, are recorded as
 * they are. A term changes no vote, quorum or written consent.
 */
export const charityBoardRecordBoardMemberTermMutation = (options?: Partial<Options<CharityBoardRecordBoardMemberTermData>>): UseMutationOptions<CharityBoardRecordBoardMemberTermResponse, CharityBoardRecordBoardMemberTermError, Options<CharityBoardRecordBoardMemberTermData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardMemberTermResponse, CharityBoardRecordBoardMemberTermError, Options<CharityBoardRecordBoardMemberTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardMemberTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Board Member Term
 *
 * Remove a term recorded in error, such as one recorded for the wrong person. The motion,
 * written consent or record it was linked to stays exactly as recorded; the seat's history
 * notes the change.
 */
export const charityBoardRemoveBoardMemberTermMutation = (options?: Partial<Options<CharityBoardRemoveBoardMemberTermData>>): UseMutationOptions<CharityBoardRemoveBoardMemberTermResponse, CharityBoardRemoveBoardMemberTermError, Options<CharityBoardRemoveBoardMemberTermData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardMemberTermResponse, CharityBoardRemoveBoardMemberTermError, Options<CharityBoardRemoveBoardMemberTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardMemberTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Board Member Term
 *
 * Correct a term. Send only what changes: a field left out keeps its value, and `null`
 * clears a date, the class or the note. A term keeps at least one date (422
 * `board_member_term_undated`) and never ends before it starts (422
 * `board_member_term_dates_out_of_order`). The record it came from is never changed here.
 */
export const charityBoardUpdateBoardMemberTermMutation = (options?: Partial<Options<CharityBoardUpdateBoardMemberTermData>>): UseMutationOptions<CharityBoardUpdateBoardMemberTermResponse, CharityBoardUpdateBoardMemberTermError, Options<CharityBoardUpdateBoardMemberTermData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardMemberTermResponse, CharityBoardUpdateBoardMemberTermError, Options<CharityBoardUpdateBoardMemberTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardMemberTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardOfficerDutiesQueryKey = (options: Options<CharityBoardGetBoardOfficerDutiesData>) => createQueryKey('charity-board-get_board_officer_duties', options);

/**
 * Get Board Officer Duties
 *
 * What each officer title does in Givmo: Board's own acts the board ties to its titles.
 *
 * `adopted` is the board's adoption in force, or null before the first — then `duties` is
 * Givmo's starting point, which does nothing until the board adopts it. `earlier` lists the
 * adoptions replaced since, newest first. A duty never decides who may act: it decides whom
 * Board asks to sign the minutes, and what a few dialogs suggest. Reading this never changes it.
 */
export const charityBoardGetBoardOfficerDutiesOptions = (options: Options<CharityBoardGetBoardOfficerDutiesData>) => queryOptions<CharityBoardGetBoardOfficerDutiesResponse, CharityBoardGetBoardOfficerDutiesError, CharityBoardGetBoardOfficerDutiesResponse, ReturnType<typeof charityBoardGetBoardOfficerDutiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardOfficerDuties({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardOfficerDutiesQueryKey(options)
});

/**
 * Adopt Board Officer Duties
 *
 * Adopt the board's duties — the first time, or to change them: the WHOLE set.
 *
 * Each duty names one of Board's own acts, the title that does it (its `id`, or for one of the
 * starting four nobody has used yet its `default_key`) and, optionally, where the board's own
 * documents say so. An act left out is not assigned to a title. Saving replaces the duties in
 * force; the earlier ones stay in the history. Sending the set already in force changes nothing.
 * A retired title is a 409 `board_officer_duty_title_retired`.
 */
export const charityBoardAdoptBoardOfficerDutiesMutation = (options?: Partial<Options<CharityBoardAdoptBoardOfficerDutiesData>>): UseMutationOptions<CharityBoardAdoptBoardOfficerDutiesResponse, CharityBoardAdoptBoardOfficerDutiesError, Options<CharityBoardAdoptBoardOfficerDutiesData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAdoptBoardOfficerDutiesResponse, CharityBoardAdoptBoardOfficerDutiesError, Options<CharityBoardAdoptBoardOfficerDutiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAdoptBoardOfficerDuties({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardOfficerTitlesQueryKey = (options: Options<CharityBoardListBoardOfficerTitlesData>) => createQueryKey('charity-board-list_board_officer_titles', options);

/**
 * List Board Officer Titles
 *
 * The board's officer titles, in the board's order: Chair, Vice Chair, Secretary and
 * Treasurer to start with, as the board names them.
 *
 * A title with no `id` is one of the starting four that no member has been given yet; give it
 * to someone by its `default_key`. Reading this list never changes it. A title is a label: it
 * changes no vote, quorum or written consent.
 */
export const charityBoardListBoardOfficerTitlesOptions = (options: Options<CharityBoardListBoardOfficerTitlesData>) => queryOptions<CharityBoardListBoardOfficerTitlesResponse, CharityBoardListBoardOfficerTitlesError, CharityBoardListBoardOfficerTitlesResponse, ReturnType<typeof charityBoardListBoardOfficerTitlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardOfficerTitles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardOfficerTitlesQueryKey(options)
});

/**
 * Create Board Officer Title
 *
 * Add one of the board's own officer titles, last in the board's order.
 *
 * No two active titles share a name, whatever the case or spacing — one of the starting four the
 * board hasn't used yet included: that is a 409 `board_officer_title_name_taken`. A title is a
 * label: it changes no vote, quorum or written consent. Who holds it is set on each member.
 */
export const charityBoardCreateBoardOfficerTitleMutation = (options?: Partial<Options<CharityBoardCreateBoardOfficerTitleData>>): UseMutationOptions<CharityBoardCreateBoardOfficerTitleResponse, CharityBoardCreateBoardOfficerTitleError, Options<CharityBoardCreateBoardOfficerTitleData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardOfficerTitleResponse, CharityBoardCreateBoardOfficerTitleError, Options<CharityBoardCreateBoardOfficerTitleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardOfficerTitle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Board Officer Title
 *
 * Rename a title, move it in the board's order, or both.
 *
 * `title_ref` is the title's `id`, or — for one of the starting four that has no `id` yet — its
 * `default_key`. `position` is the title's place among the board's active titles, counting from
 * 1; past the last means last. Renaming changes the title's words everywhere they are shown; a
 * signature already recorded keeps the words it was made with. A retired title is neither
 * renamed nor moved (409 `board_officer_title_retired`); a name another active title has is a
 * 409 `board_officer_title_name_taken`.
 */
export const charityBoardUpdateBoardOfficerTitleMutation = (options?: Partial<Options<CharityBoardUpdateBoardOfficerTitleData>>): UseMutationOptions<CharityBoardUpdateBoardOfficerTitleResponse, CharityBoardUpdateBoardOfficerTitleError, Options<CharityBoardUpdateBoardOfficerTitleData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardOfficerTitleResponse, CharityBoardUpdateBoardOfficerTitleError, Options<CharityBoardUpdateBoardOfficerTitleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardOfficerTitle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retire Board Officer Title
 *
 * Retire a title the board no longer uses.
 *
 * A retired title is never deleted and never given to anyone new; it stays in the history of
 * everyone who held it. While anyone holds it, it can't be retired (409
 * `board_officer_title_held`): take it off them on their member pages first. `title_ref` is as
 * for renaming. Retiring a title already retired answers it as it is.
 */
export const charityBoardRetireBoardOfficerTitleMutation = (options?: Partial<Options<CharityBoardRetireBoardOfficerTitleData>>): UseMutationOptions<CharityBoardRetireBoardOfficerTitleResponse, CharityBoardRetireBoardOfficerTitleError, Options<CharityBoardRetireBoardOfficerTitleData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRetireBoardOfficerTitleResponse, CharityBoardRetireBoardOfficerTitleError, Options<CharityBoardRetireBoardOfficerTitleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRetireBoardOfficerTitle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Discard Board Packet
 *
 * Discard a DRAFT packet version.
 *
 * A published version cannot be discarded — the board already has it, so the honest move
 * is to publish a further version.
 */
export const charityBoardDiscardBoardPacketMutation = (options?: Partial<Options<CharityBoardDiscardBoardPacketData>>): UseMutationOptions<CharityBoardDiscardBoardPacketResponse, CharityBoardDiscardBoardPacketError, Options<CharityBoardDiscardBoardPacketData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDiscardBoardPacketResponse, CharityBoardDiscardBoardPacketError, Options<CharityBoardDiscardBoardPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDiscardBoardPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardPacketQueryKey = (options: Options<CharityBoardGetBoardPacketData>) => createQueryKey('charity-board-get_board_packet', options);

/**
 * Get Board Packet
 *
 * One packet version with its entries.
 *
 * An entry naming a minute-book record the caller may not read is ABSENT from the list —
 * including for an Owner who was not in a closed session. `ledger_financial_pack_available`
 * says whether the treasurer's pages can be generated from the charity's own ledger;
 * while it is false the treasurer's report is attached as an ordinary document.
 */
export const charityBoardGetBoardPacketOptions = (options: Options<CharityBoardGetBoardPacketData>) => queryOptions<CharityBoardGetBoardPacketResponse, CharityBoardGetBoardPacketError, CharityBoardGetBoardPacketResponse, ReturnType<typeof charityBoardGetBoardPacketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardPacket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardPacketQueryKey(options)
});

export const charityBoardListBoardPacketCommentsQueryKey = (options: Options<CharityBoardListBoardPacketCommentsData>) => createQueryKey('charity-board-list_board_packet_comments', options);

/**
 * List Board Packet Comments
 *
 * Board-visible comments on one packet version.
 *
 * A director's private note is not reachable through this read at all. The filter takes
 * no role into account, so it binds every charity administrator including an Owner.
 */
export const charityBoardListBoardPacketCommentsOptions = (options: Options<CharityBoardListBoardPacketCommentsData>) => queryOptions<CharityBoardListBoardPacketCommentsResponse, CharityBoardListBoardPacketCommentsError, CharityBoardListBoardPacketCommentsResponse, ReturnType<typeof charityBoardListBoardPacketCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardPacketComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardPacketCommentsQueryKey(options)
});

/**
 * Record Board Packet Shared Comment
 *
 * Record a board-visible comment on a director's behalf.
 *
 * The manual path for a comment a director made by telephone or in person. There is
 * deliberately no equivalent for a director's PRIVATE note: entering one on someone's
 * behalf would mean having read it, so that combination does not exist here and is
 * refused by the database as well.
 */
export const charityBoardRecordBoardPacketSharedCommentMutation = (options?: Partial<Options<CharityBoardRecordBoardPacketSharedCommentData>>): UseMutationOptions<CharityBoardRecordBoardPacketSharedCommentResponse, CharityBoardRecordBoardPacketSharedCommentError, Options<CharityBoardRecordBoardPacketSharedCommentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardPacketSharedCommentResponse, CharityBoardRecordBoardPacketSharedCommentError, Options<CharityBoardRecordBoardPacketSharedCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardPacketSharedComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardPacketDistributionsQueryKey = (options: Options<CharityBoardListBoardPacketDistributionsData>) => createQueryKey('charity-board-list_board_packet_distributions', options);

/**
 * List Board Packet Distributions
 *
 * Who was sent one packet version. Its sibling read is who has opened it.
 */
export const charityBoardListBoardPacketDistributionsOptions = (options: Options<CharityBoardListBoardPacketDistributionsData>) => queryOptions<CharityBoardListBoardPacketDistributionsResponse, CharityBoardListBoardPacketDistributionsError, CharityBoardListBoardPacketDistributionsResponse, ReturnType<typeof charityBoardListBoardPacketDistributionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardPacketDistributions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardPacketDistributionsQueryKey(options)
});

/**
 * Distribute Board Packet
 *
 * Send a published packet version to every active seat on the roster.
 *
 * Each seat gets a fresh access link, so a director follows one link and lands in a
 * session rather than at a sign-in page they have no credentials for. The response
 * carries every seat's plaintext link, once — the recording officer hands a director
 * their link directly as often as the module mails it, and a product that only ever
 * emailed the link would make the volunteer's real route in impossible.
 *
 * `emails_sent` reports how many mails actually went out; with no template or no board
 * app base URL configured it is zero and each row records why, so the caller is told
 * what happened rather than left to assume.
 */
export const charityBoardDistributeBoardPacketMutation = (options?: Partial<Options<CharityBoardDistributeBoardPacketData>>): UseMutationOptions<CharityBoardDistributeBoardPacketResponse, CharityBoardDistributeBoardPacketError, Options<CharityBoardDistributeBoardPacketData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDistributeBoardPacketResponse, CharityBoardDistributeBoardPacketError, Options<CharityBoardDistributeBoardPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDistributeBoardPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder Board Packet Items
 *
 * Reorder a draft packet version by naming every entry once, in the order wanted.
 */
export const charityBoardReorderBoardPacketItemsMutation = (options?: Partial<Options<CharityBoardReorderBoardPacketItemsData>>): UseMutationOptions<CharityBoardReorderBoardPacketItemsResponse, CharityBoardReorderBoardPacketItemsError, Options<CharityBoardReorderBoardPacketItemsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReorderBoardPacketItemsResponse, CharityBoardReorderBoardPacketItemsError, Options<CharityBoardReorderBoardPacketItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReorderBoardPacketItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Board Packet Item
 *
 * Add an entry to a draft packet version.
 *
 * A minute-book record can be placed only by someone who may read it: otherwise an
 * administrator who was not in a closed session could hand the whole board a pointer to
 * content the record store withholds from them.
 */
export const charityBoardCreateBoardPacketItemMutation = (options?: Partial<Options<CharityBoardCreateBoardPacketItemData>>): UseMutationOptions<CharityBoardCreateBoardPacketItemResponse, CharityBoardCreateBoardPacketItemError, Options<CharityBoardCreateBoardPacketItemData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardPacketItemResponse, CharityBoardCreateBoardPacketItemError, Options<CharityBoardCreateBoardPacketItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardPacketItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Packet Item
 *
 * Remove one entry from a draft packet version, closing the gap it leaves.
 */
export const charityBoardDeleteBoardPacketItemMutation = (options?: Partial<Options<CharityBoardDeleteBoardPacketItemData>>): UseMutationOptions<CharityBoardDeleteBoardPacketItemResponse, CharityBoardDeleteBoardPacketItemError, Options<CharityBoardDeleteBoardPacketItemData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardPacketItemResponse, CharityBoardDeleteBoardPacketItemError, Options<CharityBoardDeleteBoardPacketItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardPacketItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh Board Filing Snapshot
 *
 * Append a snapshot and repoint a still-draft fifth packet item.
 */
export const charityBoardRefreshBoardFilingSnapshotMutation = (options?: Partial<Options<CharityBoardRefreshBoardFilingSnapshotData>>): UseMutationOptions<CharityBoardRefreshBoardFilingSnapshotResponse, CharityBoardRefreshBoardFilingSnapshotError, Options<CharityBoardRefreshBoardFilingSnapshotData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRefreshBoardFilingSnapshotResponse, CharityBoardRefreshBoardFilingSnapshotError, Options<CharityBoardRefreshBoardFilingSnapshotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRefreshBoardFilingSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Board Packet
 *
 * Issue a draft packet version.
 *
 * The route is named for the thing it creates, not for a verb. From here the version's
 * contents are frozen: directors may already be reading it, and a change opens the next
 * version instead.
 */
export const charityBoardPublishBoardPacketMutation = (options?: Partial<Options<CharityBoardPublishBoardPacketData>>): UseMutationOptions<CharityBoardPublishBoardPacketResponse, CharityBoardPublishBoardPacketError, Options<CharityBoardPublishBoardPacketData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardPublishBoardPacketResponse, CharityBoardPublishBoardPacketError, Options<CharityBoardPublishBoardPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardPublishBoardPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardPastRecordBatchesQueryKey = (options: Options<CharityBoardListBoardPastRecordBatchesData>) => createQueryKey('charity-board-list_board_past_record_batches', options);

/**
 * List Board Past Record Batches
 *
 * The batches of past records a connected AI proposed that wait for a person to confirm or
 * discard them: how many records each holds and how many have their file, and whose connection
 * proposed them. Nothing in them is in the minute book.
 */
export const charityBoardListBoardPastRecordBatchesOptions = (options: Options<CharityBoardListBoardPastRecordBatchesData>) => queryOptions<CharityBoardListBoardPastRecordBatchesResponse, CharityBoardListBoardPastRecordBatchesError, CharityBoardListBoardPastRecordBatchesResponse, ReturnType<typeof charityBoardListBoardPastRecordBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardPastRecordBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardPastRecordBatchesQueryKey(options)
});

export const charityBoardGetBoardPastRecordBatchQueryKey = (options: Options<CharityBoardGetBoardPastRecordBatchData>) => createQueryKey('charity-board-get_board_past_record_batch', options);

/**
 * Get Board Past Record Batch
 *
 * One batch of proposed past records, each record in the order it was proposed, word for word
 * as it would go into the minute book, with its file's state. A batch already confirmed or
 * discarded answers its state (and the import batch it became) with no records.
 */
export const charityBoardGetBoardPastRecordBatchOptions = (options: Options<CharityBoardGetBoardPastRecordBatchData>) => queryOptions<CharityBoardGetBoardPastRecordBatchResponse, CharityBoardGetBoardPastRecordBatchError, CharityBoardGetBoardPastRecordBatchResponse, ReturnType<typeof charityBoardGetBoardPastRecordBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardPastRecordBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardPastRecordBatchQueryKey(options)
});

/**
 * Confirm Board Past Record Batch
 *
 * Import the proposed records into the minute book together, exactly as they are on their
 * page, with their files. All of them go in or none do. Echo the `revision` you read: if
 * anything changed since, nothing goes in. A `label` and a `source_description` are optional
 * (Board names the records' internal import batch from the connection that proposed them).
 * After this a record can't be changed or take a file. A person's act: a connected AI cannot
 * confirm them.
 */
export const charityBoardConfirmBoardPastRecordBatchMutation = (options?: Partial<Options<CharityBoardConfirmBoardPastRecordBatchData>>): UseMutationOptions<CharityBoardConfirmBoardPastRecordBatchResponse, CharityBoardConfirmBoardPastRecordBatchError, Options<CharityBoardConfirmBoardPastRecordBatchData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardConfirmBoardPastRecordBatchResponse, CharityBoardConfirmBoardPastRecordBatchError, Options<CharityBoardConfirmBoardPastRecordBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardConfirmBoardPastRecordBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Discard Board Past Record Batch
 *
 * Discard a batch: nothing goes into the minute book, and its records' text and files are
 * deleted. Echo the batch's `revision`. A person's act.
 */
export const charityBoardDiscardBoardPastRecordBatchMutation = (options?: Partial<Options<CharityBoardDiscardBoardPastRecordBatchData>>): UseMutationOptions<CharityBoardDiscardBoardPastRecordBatchResponse, CharityBoardDiscardBoardPastRecordBatchError, Options<CharityBoardDiscardBoardPastRecordBatchData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDiscardBoardPastRecordBatchResponse, CharityBoardDiscardBoardPastRecordBatchError, Options<CharityBoardDiscardBoardPastRecordBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDiscardBoardPastRecordBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Board Past Record Confidentiality
 *
 * Mark one proposed record as a closed (executive) session's own record, or not, before the
 * records are confirmed: it imports as the mark says, a closed session's record as one recorded by
 * hand. Echo the batch's `revision`; the answer carries the batch's new one. A person's act.
 */
export const charityBoardMarkBoardPastRecordConfidentialityMutation = (options?: Partial<Options<CharityBoardMarkBoardPastRecordConfidentialityData>>): UseMutationOptions<CharityBoardMarkBoardPastRecordConfidentialityResponse, CharityBoardMarkBoardPastRecordConfidentialityError, Options<CharityBoardMarkBoardPastRecordConfidentialityData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardMarkBoardPastRecordConfidentialityResponse, CharityBoardMarkBoardPastRecordConfidentialityError, Options<CharityBoardMarkBoardPastRecordConfidentialityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardMarkBoardPastRecordConfidentiality({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardProposalFileUrlQueryKey = (options: Options<CharityBoardGetBoardProposalFileUrlData>) => createQueryKey('charity-board-get_board_proposal_file_url', options);

/**
 * Get Board Proposal File Url
 *
 * A short-lived link that downloads a proposed record's file, as Board checked it.
 */
export const charityBoardGetBoardProposalFileUrlOptions = (options: Options<CharityBoardGetBoardProposalFileUrlData>) => queryOptions<CharityBoardGetBoardProposalFileUrlResponse, CharityBoardGetBoardProposalFileUrlError, CharityBoardGetBoardProposalFileUrlResponse, ReturnType<typeof charityBoardGetBoardProposalFileUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardProposalFileUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardProposalFileUrlQueryKey(options)
});

/**
 * Check Board Proposal File
 *
 * Ask Board to check a proposed record's file. With the `object_ref` an upload URL named and
 * the file's name and type, the file you added: if Board's check passes it becomes the record's
 * file; if not, the answer says why and the upload is deleted. Without them, the file the
 * connected AI was asked to upload, if it has arrived.
 */
export const charityBoardCheckBoardProposalFileMutation = (options?: Partial<Options<CharityBoardCheckBoardProposalFileData>>): UseMutationOptions<CharityBoardCheckBoardProposalFileResponse, CharityBoardCheckBoardProposalFileError, Options<CharityBoardCheckBoardProposalFileData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCheckBoardProposalFileResponse, CharityBoardCheckBoardProposalFileError, Options<CharityBoardCheckBoardProposalFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCheckBoardProposalFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Issue Board Proposal File Upload Url
 *
 * A signed upload URL for a proposed record's missing or replacement file: PUT the file there
 * once, sending exactly `headers`, then ask Board to check it with the `object_ref` it names. A
 * PDF or a picture, up to 50 MB. Nothing is recorded until Board's check passes.
 */
export const charityBoardIssueBoardProposalFileUploadUrlMutation = (options?: Partial<Options<CharityBoardIssueBoardProposalFileUploadUrlData>>): UseMutationOptions<CharityBoardIssueBoardProposalFileUploadUrlResponse, CharityBoardIssueBoardProposalFileUploadUrlError, Options<CharityBoardIssueBoardProposalFileUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardIssueBoardProposalFileUploadUrlResponse, CharityBoardIssueBoardProposalFileUploadUrlError, Options<CharityBoardIssueBoardProposalFileUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardIssueBoardProposalFileUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Leave Out Board Past Record
 *
 * Leave one proposed record out of its batch: it won't be imported, and its text and file are
 * deleted. Echo the batch's `revision`; the answer carries the batch's new one. A person's act.
 */
export const charityBoardLeaveOutBoardPastRecordMutation = (options?: Partial<Options<CharityBoardLeaveOutBoardPastRecordData>>): UseMutationOptions<CharityBoardLeaveOutBoardPastRecordResponse, CharityBoardLeaveOutBoardPastRecordError, Options<CharityBoardLeaveOutBoardPastRecordData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardLeaveOutBoardPastRecordResponse, CharityBoardLeaveOutBoardPastRecordError, Options<CharityBoardLeaveOutBoardPastRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardLeaveOutBoardPastRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardRecordsQueryKey = (options: Options<CharityBoardListBoardRecordsData>) => createQueryKey('charity-board-list_board_records', options);

/**
 * List Board Records
 *
 * The charity's board records, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Executive-session records the caller did not take part in are ABSENT, and the total
 * reflects only what they may see — reporting the unfiltered total would leak the
 * existence of withheld records through arithmetic.
 *
 * `q` narrows the list to records whose TITLE contains it, ignoring case (CBG-UX1). It is
 * applied in the same query as the executive-session rule, so a withheld record is never
 * found or counted by a search. A `q` longer than a title can be, or holding a NUL, is a
 * 422.
 */
export const charityBoardListBoardRecordsOptions = (options: Options<CharityBoardListBoardRecordsData>) => queryOptions<CharityBoardListBoardRecordsResponse, CharityBoardListBoardRecordsError, CharityBoardListBoardRecordsResponse, ReturnType<typeof charityBoardListBoardRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardRecordsQueryKey(options)
});

/**
 * Create Board Record Draft
 */
export const charityBoardCreateBoardRecordDraftMutation = (options?: Partial<Options<CharityBoardCreateBoardRecordDraftData>>): UseMutationOptions<CharityBoardCreateBoardRecordDraftResponse, CharityBoardCreateBoardRecordDraftError, Options<CharityBoardCreateBoardRecordDraftData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardRecordDraftResponse, CharityBoardCreateBoardRecordDraftError, Options<CharityBoardCreateBoardRecordDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardRecordDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardRecordQueryKey = (options: Options<CharityBoardGetBoardRecordData>) => createQueryKey('charity-board-get_board_record', options);

/**
 * Get Board Record
 */
export const charityBoardGetBoardRecordOptions = (options: Options<CharityBoardGetBoardRecordData>) => queryOptions<CharityBoardGetBoardRecordResponse, CharityBoardGetBoardRecordError, CharityBoardGetBoardRecordResponse, ReturnType<typeof charityBoardGetBoardRecordQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardRecord({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardRecordQueryKey(options)
});

/**
 * Update Board Record Draft
 */
export const charityBoardUpdateBoardRecordDraftMutation = (options?: Partial<Options<CharityBoardUpdateBoardRecordDraftData>>): UseMutationOptions<CharityBoardUpdateBoardRecordDraftResponse, CharityBoardUpdateBoardRecordDraftError, Options<CharityBoardUpdateBoardRecordDraftData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardRecordDraftResponse, CharityBoardUpdateBoardRecordDraftError, Options<CharityBoardUpdateBoardRecordDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardRecordDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardRecordAcknowledgmentsQueryKey = (options: Options<CharityBoardListBoardRecordAcknowledgmentsData>) => createQueryKey('charity-board-list_board_record_acknowledgments', options);

/**
 * List Board Record Acknowledgments
 *
 * Who has confirmed reading a document, which version, how and when — confirmed in Board,
 * recorded from a signed paper form, or confirmed in an annual conflict-of-interest disclosure
 * (the policy only) — across the document's versions, newest first.
 */
export const charityBoardListBoardRecordAcknowledgmentsOptions = (options: Options<CharityBoardListBoardRecordAcknowledgmentsData>) => queryOptions<CharityBoardListBoardRecordAcknowledgmentsResponse, CharityBoardListBoardRecordAcknowledgmentsError, CharityBoardListBoardRecordAcknowledgmentsResponse, ReturnType<typeof charityBoardListBoardRecordAcknowledgmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardRecordAcknowledgments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardRecordAcknowledgmentsQueryKey(options)
});

/**
 * Approve Board Record
 *
 * Record the approval — the door from a draft to the charity's record.
 *
 * The body's `content_hash` is a required echo of the artifact the approver read; a
 * mismatch is a 409 and the reviewer re-reads the current version. A record is approved
 * only with the date it is about: `occurred_on` supplies a date the draft is missing or
 * confirms the one it carries, and a record left without one is a 409. The route is
 * named for the thing it creates (the approval event), not for a verb, because that
 * event is the durable artifact.
 */
export const charityBoardApproveBoardRecordMutation = (options?: Partial<Options<CharityBoardApproveBoardRecordData>>): UseMutationOptions<CharityBoardApproveBoardRecordResponse, CharityBoardApproveBoardRecordError, Options<CharityBoardApproveBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardApproveBoardRecordResponse, CharityBoardApproveBoardRecordError, Options<CharityBoardApproveBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardApproveBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardMinutesApprovalConsentFormQueryKey = (options: Options<CharityBoardGetBoardMinutesApprovalConsentFormData>) => createQueryKey('charity-board-get_board_minutes_approval_consent_form', options);

/**
 * Get Board Minutes Approval Consent Form
 *
 * The form for a written consent approving one set of minutes, filled in from them.
 *
 * A neutral form whose structure is modeled on the Model Nonprofit Corporation Act's board
 * action without a meeting. The module fills in only what the organization already recorded
 * about the minutes — their title, the date of their meeting, their record reference and their
 * fingerprint — and leaves every other term as a field for the organization. The text is the
 * organization's to edit; the fingerprint stays in it, because it is how the text the
 * directors sign names the minutes they approve.
 *
 * Available for a meeting's own minutes that are still a draft.
 */
export const charityBoardGetBoardMinutesApprovalConsentFormOptions = (options: Options<CharityBoardGetBoardMinutesApprovalConsentFormData>) => queryOptions<CharityBoardGetBoardMinutesApprovalConsentFormResponse, CharityBoardGetBoardMinutesApprovalConsentFormError, CharityBoardGetBoardMinutesApprovalConsentFormResponse, ReturnType<typeof charityBoardGetBoardMinutesApprovalConsentFormQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardMinutesApprovalConsentForm({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardMinutesApprovalConsentFormQueryKey(options)
});

/**
 * Create Board Minutes Approval Consent
 *
 * Open a working consent that names the minutes it approves.
 *
 * A draft like any other: nothing is put to the board here, and the text is the
 * organization's to edit. The minutes are the ones in the path, and that never changes.
 * When the consent goes to the board, its text carries the minutes' fingerprint and the
 * version that goes out records it. When the last director it went out to signs, the
 * minutes are approved — unless they changed after it went out, were approved another way,
 * or are no longer there; then the consent is still recorded, and says the minutes were not
 * approved and why.
 */
export const charityBoardCreateBoardMinutesApprovalConsentMutation = (options?: Partial<Options<CharityBoardCreateBoardMinutesApprovalConsentData>>): UseMutationOptions<CharityBoardCreateBoardMinutesApprovalConsentResponse, CharityBoardCreateBoardMinutesApprovalConsentError, Options<CharityBoardCreateBoardMinutesApprovalConsentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardMinutesApprovalConsentResponse, CharityBoardCreateBoardMinutesApprovalConsentError, Options<CharityBoardCreateBoardMinutesApprovalConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardMinutesApprovalConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Record Chain
 *
 * Delete a record together with its whole correction chain, as one act.
 *
 * A correction and the record it corrects are each other's context, so they are retained
 * and deleted as a unit — the single-record route refuses a chain member and points here.
 * Any member's id resolves the chain, and the request is refused outright if any member
 * is still inside the retention floor or under an active legal hold. Every member gets
 * its own ``deleted`` event.
 */
export const charityBoardDeleteBoardRecordChainMutation = (options?: Partial<Options<CharityBoardDeleteBoardRecordChainData>>): UseMutationOptions<CharityBoardDeleteBoardRecordChainResponse, CharityBoardDeleteBoardRecordChainError, Options<CharityBoardDeleteBoardRecordChainData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardRecordChainResponse, CharityBoardDeleteBoardRecordChainError, Options<CharityBoardDeleteBoardRecordChainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardRecordChain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Board Record
 *
 * Delete ONE board record at the charity's explicit request.
 *
 * A POST carrying a required reason rather than a bare DELETE: the reason is recorded,
 * and a deletion of the charity's legal memory should not be something a stray verb can
 * accomplish. Refused while any active legal hold covers the record, and refused before
 * the record has passed the charity's adopted retention floor — both at the service for
 * a clear message and at the database independently.
 */
export const charityBoardDeleteBoardRecordMutation = (options?: Partial<Options<CharityBoardDeleteBoardRecordData>>): UseMutationOptions<CharityBoardDeleteBoardRecordResponse, CharityBoardDeleteBoardRecordError, Options<CharityBoardDeleteBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDeleteBoardRecordResponse, CharityBoardDeleteBoardRecordError, Options<CharityBoardDeleteBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDeleteBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Discard Board Record Draft
 */
export const charityBoardDiscardBoardRecordDraftMutation = (options?: Partial<Options<CharityBoardDiscardBoardRecordDraftData>>): UseMutationOptions<CharityBoardDiscardBoardRecordDraftResponse, CharityBoardDiscardBoardRecordDraftError, Options<CharityBoardDiscardBoardRecordDraftData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardDiscardBoardRecordDraftResponse, CharityBoardDiscardBoardRecordDraftError, Options<CharityBoardDiscardBoardRecordDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardDiscardBoardRecordDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardRecordFileUrlQueryKey = (options: Options<CharityBoardGetBoardRecordFileUrlData>) => createQueryKey('charity-board-get_board_record_file_url', options);

/**
 * Get Board Record File Url
 *
 * A short-lived link that downloads a record's file, the one Board checked when the record
 * was imported. A closed session's file opens only for those who may read its record.
 */
export const charityBoardGetBoardRecordFileUrlOptions = (options: Options<CharityBoardGetBoardRecordFileUrlData>) => queryOptions<CharityBoardGetBoardRecordFileUrlResponse, CharityBoardGetBoardRecordFileUrlError, CharityBoardGetBoardRecordFileUrlResponse, ReturnType<typeof charityBoardGetBoardRecordFileUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardRecordFileUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardRecordFileUrlQueryKey(options)
});

export const charityBoardGetBoardOfficerStatementQueryKey = (options: Options<CharityBoardGetBoardOfficerStatementData>) => createQueryKey('charity-board-get_board_officer_statement', options);

/**
 * Get Board Officer Statement
 *
 * A statement about one record, generated for an officer of the organization to
 * execute.
 *
 * The module fills in only what the charity already recorded — the record's title, its
 * date, when it was recorded, its reference and its text — and leaves every statement
 * the officer makes, and the officer's own name, title and date, as fields for them.
 * The organization's officer signs it; this product signs nothing.
 *
 * Available for a record the charity has recorded. There is nothing to state about a
 * working draft.
 */
export const charityBoardGetBoardOfficerStatementOptions = (options: Options<CharityBoardGetBoardOfficerStatementData>) => queryOptions<CharityBoardGetBoardOfficerStatementResponse, CharityBoardGetBoardOfficerStatementError, CharityBoardGetBoardOfficerStatementResponse, ReturnType<typeof charityBoardGetBoardOfficerStatementQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardOfficerStatement({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardOfficerStatementQueryKey(options)
});

export const charityBoardListBoardRecordEventsQueryKey = (options: Options<CharityBoardListBoardRecordEventsData>) => createQueryKey('charity-board-list_board_record_events', options);

/**
 * List Board Record Events
 *
 * One record's append-only record event log, oldest first — including the approval
 * event, which is the evidence of who approved what and when.
 */
export const charityBoardListBoardRecordEventsOptions = (options: Options<CharityBoardListBoardRecordEventsData>) => queryOptions<CharityBoardListBoardRecordEventsResponse, CharityBoardListBoardRecordEventsError, CharityBoardListBoardRecordEventsResponse, ReturnType<typeof charityBoardListBoardRecordEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardRecordEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardRecordEventsQueryKey(options)
});

/**
 * Submit Board Record
 */
export const charityBoardSubmitBoardRecordMutation = (options?: Partial<Options<CharityBoardSubmitBoardRecordData>>): UseMutationOptions<CharityBoardSubmitBoardRecordResponse, CharityBoardSubmitBoardRecordError, Options<CharityBoardSubmitBoardRecordData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSubmitBoardRecordResponse, CharityBoardSubmitBoardRecordError, Options<CharityBoardSubmitBoardRecordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSubmitBoardRecord({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardRetentionPoliciesQueryKey = (options: Options<CharityBoardListBoardRetentionPoliciesData>) => createQueryKey('charity-board-list_board_retention_policies', options);

/**
 * List Board Retention Policies
 */
export const charityBoardListBoardRetentionPoliciesOptions = (options: Options<CharityBoardListBoardRetentionPoliciesData>) => queryOptions<CharityBoardListBoardRetentionPoliciesResponse, CharityBoardListBoardRetentionPoliciesError, CharityBoardListBoardRetentionPoliciesResponse, ReturnType<typeof charityBoardListBoardRetentionPoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardRetentionPolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardRetentionPoliciesQueryKey(options)
});

/**
 * Adopt Board Retention Policy
 *
 * Adopt (or replace) the charity's retention schedule for one record kind.
 *
 * `minimum_retention_years` is a FLOOR, never an expiry: reaching it deletes nothing.
 * PUT rather than POST because the charity has exactly one live schedule per record
 * kind — adopting again replaces it (and supersedes the prior row, which stays readable
 * as history).
 */
export const charityBoardAdoptBoardRetentionPolicyMutation = (options?: Partial<Options<CharityBoardAdoptBoardRetentionPolicyData>>): UseMutationOptions<CharityBoardAdoptBoardRetentionPolicyResponse, CharityBoardAdoptBoardRetentionPolicyError, Options<CharityBoardAdoptBoardRetentionPolicyData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAdoptBoardRetentionPolicyResponse, CharityBoardAdoptBoardRetentionPolicyError, Options<CharityBoardAdoptBoardRetentionPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAdoptBoardRetentionPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardReturnDistributionsQueryKey = (options: Options<CharityBoardListBoardReturnDistributionsData>) => createQueryKey('charity-board-list_board_return_distributions', options);

/**
 * List Board Return Distributions
 *
 * Every copy of the return provided to the board, newest first: the tax year, who provided
 * it and when, how many people it went to, and how many of the directors were provided it.
 * `tax_year_ends_on` narrows the list to one tax year's copies.
 */
export const charityBoardListBoardReturnDistributionsOptions = (options: Options<CharityBoardListBoardReturnDistributionsData>) => queryOptions<CharityBoardListBoardReturnDistributionsResponse, CharityBoardListBoardReturnDistributionsError, CharityBoardListBoardReturnDistributionsResponse, ReturnType<typeof charityBoardListBoardReturnDistributionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardReturnDistributions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardReturnDistributionsQueryKey(options)
});

/**
 * Provide Board Return
 *
 * Provide a copy of the return to the board. Adds one record to the minute book: the copy's
 * fingerprint, who provided it and when, and everyone on the roster it went to. Each person is
 * emailed that it's available to review in Givmo; a seat no account has joined gets an
 * invitation to join with it. `follows_record_id` provides a newer copy of a return already
 * provided.
 */
export const charityBoardProvideBoardReturnMutation = (options?: Partial<Options<CharityBoardProvideBoardReturnData>>): UseMutationOptions<CharityBoardProvideBoardReturnResponse, CharityBoardProvideBoardReturnError, Options<CharityBoardProvideBoardReturnData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardProvideBoardReturnResponse, CharityBoardProvideBoardReturnError, Options<CharityBoardProvideBoardReturnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardProvideBoardReturn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Board Return Copy
 *
 * Check an uploaded copy: Board reads it and answers its size, its number of pages and its
 * SHA-256 fingerprint, which Board computes itself. A PDF with a password to open is refused.
 * Nothing is recorded.
 */
export const charityBoardConfirmBoardReturnCopyMutation = (options?: Partial<Options<CharityBoardConfirmBoardReturnCopyData>>): UseMutationOptions<CharityBoardConfirmBoardReturnCopyResponse, CharityBoardConfirmBoardReturnCopyError, Options<CharityBoardConfirmBoardReturnCopyData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardConfirmBoardReturnCopyResponse, CharityBoardConfirmBoardReturnCopyError, Options<CharityBoardConfirmBoardReturnCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardConfirmBoardReturnCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Issue Board Return Copy Upload Url
 *
 * A link to upload one copy of the return, a PDF of at most 50 MB, valid for 15 minutes.
 * Nothing is recorded until the copy is provided.
 */
export const charityBoardIssueBoardReturnCopyUploadUrlMutation = (options?: Partial<Options<CharityBoardIssueBoardReturnCopyUploadUrlData>>): UseMutationOptions<CharityBoardIssueBoardReturnCopyUploadUrlResponse, CharityBoardIssueBoardReturnCopyUploadUrlError, Options<CharityBoardIssueBoardReturnCopyUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardIssueBoardReturnCopyUploadUrlResponse, CharityBoardIssueBoardReturnCopyUploadUrlError, Options<CharityBoardIssueBoardReturnCopyUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardIssueBoardReturnCopyUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardPreviewBoardReturnRecipientsQueryKey = (options: Options<CharityBoardPreviewBoardReturnRecipientsData>) => createQueryKey('charity-board-preview_board_return_recipients', options);

/**
 * Preview Board Return Recipients
 *
 * Who a copy provided now would go to: everyone on the board's roster today, directors first,
 * with the titles they hold on `provided_on`, the day you'll provide it (today when unsent).
 * The same list the act uses.
 */
export const charityBoardPreviewBoardReturnRecipientsOptions = (options: Options<CharityBoardPreviewBoardReturnRecipientsData>) => queryOptions<CharityBoardPreviewBoardReturnRecipientsResponse, CharityBoardPreviewBoardReturnRecipientsError, CharityBoardPreviewBoardReturnRecipientsResponse, ReturnType<typeof charityBoardPreviewBoardReturnRecipientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardPreviewBoardReturnRecipients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardPreviewBoardReturnRecipientsQueryKey(options)
});

export const charityBoardListBoardReturnReviewCandidatesQueryKey = (options: Options<CharityBoardListBoardReturnReviewCandidatesData>) => createQueryKey('charity-board-list_board_return_review_candidates', options);

/**
 * List Board Return Review Candidates
 *
 * The board's acts a copy's review can name, newest first: each motion with a recorded vote,
 * carried or failed, made in a meeting's open session (its meeting's title and day, and its own
 * words), and each written consent waiting on signatures or signed by everyone. A closed
 * session's motion is never listed.
 */
export const charityBoardListBoardReturnReviewCandidatesOptions = (options: Options<CharityBoardListBoardReturnReviewCandidatesData>) => queryOptions<CharityBoardListBoardReturnReviewCandidatesResponse, CharityBoardListBoardReturnReviewCandidatesError, CharityBoardListBoardReturnReviewCandidatesResponse, ReturnType<typeof charityBoardListBoardReturnReviewCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardReturnReviewCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardReturnReviewCandidatesQueryKey(options)
});

export const charityBoardGetBoardReturnDistributionQueryKey = (options: Options<CharityBoardGetBoardReturnDistributionData>) => createQueryKey('charity-board-get_board_return_distribution', options);

/**
 * Get Board Return Distribution
 *
 * One copy of the return provided to the board, and what Board recorded of each person it
 * went to: their email, when they opened it, a printed copy given to them, and their recorded
 * reading.
 */
export const charityBoardGetBoardReturnDistributionOptions = (options: Options<CharityBoardGetBoardReturnDistributionData>) => queryOptions<CharityBoardGetBoardReturnDistributionResponse, CharityBoardGetBoardReturnDistributionError, CharityBoardGetBoardReturnDistributionResponse, ReturnType<typeof charityBoardGetBoardReturnDistributionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardReturnDistribution({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardReturnDistributionQueryKey(options)
});

export const charityBoardGetBoardReturnCopyUrlQueryKey = (options: Options<CharityBoardGetBoardReturnCopyUrlData>) => createQueryKey('charity-board-get_board_return_copy_url', options);

/**
 * Get Board Return Copy Url
 *
 * A link to download the copy provided, valid for 15 minutes. Your download isn't recorded
 * as anyone's receipt.
 */
export const charityBoardGetBoardReturnCopyUrlOptions = (options: Options<CharityBoardGetBoardReturnCopyUrlData>) => queryOptions<CharityBoardGetBoardReturnCopyUrlResponse, CharityBoardGetBoardReturnCopyUrlError, CharityBoardGetBoardReturnCopyUrlResponse, ReturnType<typeof charityBoardGetBoardReturnCopyUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardReturnCopyUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardReturnCopyUrlQueryKey(options)
});

/**
 * Email Board Return Again
 *
 * Email one person again after their email didn't go out. At most once a day each; no new
 * record. A seat no account has joined gets a new invitation with it.
 */
export const charityBoardEmailBoardReturnAgainMutation = (options?: Partial<Options<CharityBoardEmailBoardReturnAgainData>>): UseMutationOptions<CharityBoardEmailBoardReturnAgainResponse, CharityBoardEmailBoardReturnAgainError, Options<CharityBoardEmailBoardReturnAgainData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardEmailBoardReturnAgainResponse, CharityBoardEmailBoardReturnAgainError, Options<CharityBoardEmailBoardReturnAgainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardEmailBoardReturnAgain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Return Printed Copy
 *
 * Record that a printed copy was given to this person: the day it was given, and how. Once
 * per person for each copy.
 */
export const charityBoardRecordBoardReturnPrintedCopyMutation = (options?: Partial<Options<CharityBoardRecordBoardReturnPrintedCopyData>>): UseMutationOptions<CharityBoardRecordBoardReturnPrintedCopyResponse, CharityBoardRecordBoardReturnPrintedCopyError, Options<CharityBoardRecordBoardReturnPrintedCopyData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardReturnPrintedCopyResponse, CharityBoardRecordBoardReturnPrintedCopyError, Options<CharityBoardRecordBoardReturnPrintedCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardReturnPrintedCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link Board Return Review
 *
 * Record the board's review of this copy: one of the acts the review list names, a motion
 * or a written consent. One per copy at a time; remove it to record another. The board's own
 * record is unchanged.
 */
export const charityBoardLinkBoardReturnReviewMutation = (options?: Partial<Options<CharityBoardLinkBoardReturnReviewData>>): UseMutationOptions<CharityBoardLinkBoardReturnReviewResponse, CharityBoardLinkBoardReturnReviewError, Options<CharityBoardLinkBoardReturnReviewData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardLinkBoardReturnReviewResponse, CharityBoardLinkBoardReturnReviewError, Options<CharityBoardLinkBoardReturnReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardLinkBoardReturnReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlink Board Return Review
 *
 * Remove this copy's review link. Who removed it and when is kept with the copy's earlier
 * links.
 */
export const charityBoardUnlinkBoardReturnReviewMutation = (options?: Partial<Options<CharityBoardUnlinkBoardReturnReviewData>>): UseMutationOptions<CharityBoardUnlinkBoardReturnReviewResponse, CharityBoardUnlinkBoardReturnReviewError, Options<CharityBoardUnlinkBoardReturnReviewData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUnlinkBoardReturnReviewResponse, CharityBoardUnlinkBoardReturnReviewError, Options<CharityBoardUnlinkBoardReturnReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUnlinkBoardReturnReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Board Return
 *
 * Withdraw this copy, with the reason directors will see. Their pages stop offering it; the
 * record, what was recorded of each person and the file stay.
 */
export const charityBoardWithdrawBoardReturnMutation = (options?: Partial<Options<CharityBoardWithdrawBoardReturnData>>): UseMutationOptions<CharityBoardWithdrawBoardReturnResponse, CharityBoardWithdrawBoardReturnError, Options<CharityBoardWithdrawBoardReturnData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardWithdrawBoardReturnResponse, CharityBoardWithdrawBoardReturnError, Options<CharityBoardWithdrawBoardReturnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardWithdrawBoardReturn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Roster Result
 *
 * Record an election's result on the roster, from the motion recorded as carried
 * (`motion_id`) or the executed written consent (`consent_id`) that elected them: a term for
 * each director named, and the title for each officer named (ending that person's earlier
 * holding of the same title, which stays in their history). Each is linked to the motion or
 * consent; the motion, the consent and the minutes don't change. The roster never changes from
 * an election by itself; this is the officer's act. Givmo doesn't read the motion's or the
 * consent's words: whoever is named here is recorded.
 *
 * A motion not recorded as carried is a 409 `board_roster_result_not_carried`; a written
 * consent not executed, a 409 `board_roster_result_not_executed`; a director named who isn't
 * recorded as a director, a 409 `board_roster_result_not_a_director`.
 */
export const charityBoardRecordBoardRosterResultMutation = (options?: Partial<Options<CharityBoardRecordBoardRosterResultData>>): UseMutationOptions<CharityBoardRecordBoardRosterResultResponse, CharityBoardRecordBoardRosterResultError, Options<CharityBoardRecordBoardRosterResultData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardRosterResultResponse, CharityBoardRecordBoardRosterResultError, Options<CharityBoardRecordBoardRosterResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardRosterResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardSelfAssessmentInstrumentsQueryKey = (options: Options<CharityBoardListBoardSelfAssessmentInstrumentsData>) => createQueryKey('charity-board-list_board_self_assessment_instruments', options);

/**
 * List Board Self Assessment Instruments
 *
 * Givmo's starting self-assessments this organization is offered, each with where its
 * statements come from. Never a statement that one is required or recommended.
 */
export const charityBoardListBoardSelfAssessmentInstrumentsOptions = (options: Options<CharityBoardListBoardSelfAssessmentInstrumentsData>) => queryOptions<CharityBoardListBoardSelfAssessmentInstrumentsResponse, CharityBoardListBoardSelfAssessmentInstrumentsError, CharityBoardListBoardSelfAssessmentInstrumentsResponse, ReturnType<typeof charityBoardListBoardSelfAssessmentInstrumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardSelfAssessmentInstruments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardSelfAssessmentInstrumentsQueryKey(options)
});

export const charityBoardGetBoardSelfAssessmentInstrumentQueryKey = (options: Options<CharityBoardGetBoardSelfAssessmentInstrumentData>) => createQueryKey('charity-board-get_board_self_assessment_instrument', options);

/**
 * Get Board Self Assessment Instrument
 *
 * One starting self-assessment with every statement, in its group, and the text each is
 * written from: the IRS's Form 990 and its instructions, or a state's statute.
 */
export const charityBoardGetBoardSelfAssessmentInstrumentOptions = (options: Options<CharityBoardGetBoardSelfAssessmentInstrumentData>) => queryOptions<CharityBoardGetBoardSelfAssessmentInstrumentResponse, CharityBoardGetBoardSelfAssessmentInstrumentError, CharityBoardGetBoardSelfAssessmentInstrumentResponse, ReturnType<typeof charityBoardGetBoardSelfAssessmentInstrumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardSelfAssessmentInstrument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardSelfAssessmentInstrumentQueryKey(options)
});

export const charityBoardListBoardSelfAssessmentsQueryKey = (options: Options<CharityBoardListBoardSelfAssessmentsData>) => createQueryKey('charity-board-list_board_self_assessments', options);

/**
 * List Board Self Assessments
 *
 * Every self-assessment of the board, newest first: each one's dates, where it stands, and
 * how many were asked and how many answered.
 */
export const charityBoardListBoardSelfAssessmentsOptions = (options: Options<CharityBoardListBoardSelfAssessmentsData>) => queryOptions<CharityBoardListBoardSelfAssessmentsResponse, CharityBoardListBoardSelfAssessmentsError, CharityBoardListBoardSelfAssessmentsResponse, ReturnType<typeof charityBoardListBoardSelfAssessmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardSelfAssessments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardSelfAssessmentsQueryKey(options)
});

/**
 * Open Board Self Assessment
 *
 * Start the board's self-assessment: everyone on the roster is asked, but the people named in
 * `not_asked`, with Givmo's starting statements (any turned off). Each person is emailed the
 * ask; a seat that hasn't joined Board yet gets an invitation to join with it. Each person's
 * answers are private to them until it is closed.
 */
export const charityBoardOpenBoardSelfAssessmentMutation = (options?: Partial<Options<CharityBoardOpenBoardSelfAssessmentData>>): UseMutationOptions<CharityBoardOpenBoardSelfAssessmentResponse, CharityBoardOpenBoardSelfAssessmentError, Options<CharityBoardOpenBoardSelfAssessmentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardOpenBoardSelfAssessmentResponse, CharityBoardOpenBoardSelfAssessmentError, Options<CharityBoardOpenBoardSelfAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardOpenBoardSelfAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardSelfAssessmentQueryKey = (options: Options<CharityBoardGetBoardSelfAssessmentData>) => createQueryKey('charity-board-get_board_self_assessment', options);

/**
 * Get Board Self Assessment
 *
 * One self-assessment: who was asked, who has answered and when (never what), what was sent
 * and when, who can be reminded now, what became of the answers once it closed, and the
 * board's priorities.
 */
export const charityBoardGetBoardSelfAssessmentOptions = (options: Options<CharityBoardGetBoardSelfAssessmentData>) => queryOptions<CharityBoardGetBoardSelfAssessmentResponse, CharityBoardGetBoardSelfAssessmentError, CharityBoardGetBoardSelfAssessmentResponse, ReturnType<typeof charityBoardGetBoardSelfAssessmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardSelfAssessment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardSelfAssessmentQueryKey(options)
});

/**
 * Cancel Board Self Assessment
 *
 * Withdraw a self-assessment started by mistake, before anyone has answered. Nothing is added
 * to the minute book.
 */
export const charityBoardCancelBoardSelfAssessmentMutation = (options?: Partial<Options<CharityBoardCancelBoardSelfAssessmentData>>): UseMutationOptions<CharityBoardCancelBoardSelfAssessmentResponse, CharityBoardCancelBoardSelfAssessmentError, Options<CharityBoardCancelBoardSelfAssessmentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCancelBoardSelfAssessmentResponse, CharityBoardCancelBoardSelfAssessmentError, Options<CharityBoardCancelBoardSelfAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCancelBoardSelfAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close Board Self Assessment
 *
 * Close the self-assessment. Adds one record to the minute book: how many people chose each
 * answer, and the comments without names, or, with fewer than three answers, only how many were
 * asked and answered. Each person's answers are then deleted, unless a legal hold covers the
 * board, which keeps them.
 */
export const charityBoardCloseBoardSelfAssessmentMutation = (options?: Partial<Options<CharityBoardCloseBoardSelfAssessmentData>>): UseMutationOptions<CharityBoardCloseBoardSelfAssessmentResponse, CharityBoardCloseBoardSelfAssessmentError, Options<CharityBoardCloseBoardSelfAssessmentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCloseBoardSelfAssessmentResponse, CharityBoardCloseBoardSelfAssessmentError, Options<CharityBoardCloseBoardSelfAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCloseBoardSelfAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unmark Board Self Assessment Paper Hand In
 *
 * Undo a paper hand-in marked by mistake.
 */
export const charityBoardUnmarkBoardSelfAssessmentPaperHandInMutation = (options?: Partial<Options<CharityBoardUnmarkBoardSelfAssessmentPaperHandInData>>): UseMutationOptions<CharityBoardUnmarkBoardSelfAssessmentPaperHandInResponse, CharityBoardUnmarkBoardSelfAssessmentPaperHandInError, Options<CharityBoardUnmarkBoardSelfAssessmentPaperHandInData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUnmarkBoardSelfAssessmentPaperHandInResponse, CharityBoardUnmarkBoardSelfAssessmentPaperHandInError, Options<CharityBoardUnmarkBoardSelfAssessmentPaperHandInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUnmarkBoardSelfAssessmentPaperHandIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Board Self Assessment Paper Hand In
 *
 * Mark that someone asked handed in a paper answer sheet, so they count as answered and are
 * not reminded.
 */
export const charityBoardMarkBoardSelfAssessmentPaperHandInMutation = (options?: Partial<Options<CharityBoardMarkBoardSelfAssessmentPaperHandInData>>): UseMutationOptions<CharityBoardMarkBoardSelfAssessmentPaperHandInResponse, CharityBoardMarkBoardSelfAssessmentPaperHandInError, Options<CharityBoardMarkBoardSelfAssessmentPaperHandInData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardMarkBoardSelfAssessmentPaperHandInResponse, CharityBoardMarkBoardSelfAssessmentPaperHandInError, Options<CharityBoardMarkBoardSelfAssessmentPaperHandInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardMarkBoardSelfAssessmentPaperHandIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Self Assessment Paper Sheet
 *
 * Enter one paper answer sheet. It names nobody: nothing entered here ties it to a person.
 * Mark who handed one in separately.
 */
export const charityBoardRecordBoardSelfAssessmentPaperSheetMutation = (options?: Partial<Options<CharityBoardRecordBoardSelfAssessmentPaperSheetData>>): UseMutationOptions<CharityBoardRecordBoardSelfAssessmentPaperSheetResponse, CharityBoardRecordBoardSelfAssessmentPaperSheetError, Options<CharityBoardRecordBoardSelfAssessmentPaperSheetData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardSelfAssessmentPaperSheetResponse, CharityBoardRecordBoardSelfAssessmentPaperSheetError, Options<CharityBoardRecordBoardSelfAssessmentPaperSheetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardSelfAssessmentPaperSheet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link Board Self Assessment Priorities
 *
 * Link the results to the board's own act choosing its priorities: a motion the board
 * carried, or a written consent every director signed, and the statements it addresses. Board
 * never chooses or drafts the priorities.
 */
export const charityBoardLinkBoardSelfAssessmentPrioritiesMutation = (options?: Partial<Options<CharityBoardLinkBoardSelfAssessmentPrioritiesData>>): UseMutationOptions<CharityBoardLinkBoardSelfAssessmentPrioritiesResponse, CharityBoardLinkBoardSelfAssessmentPrioritiesError, Options<CharityBoardLinkBoardSelfAssessmentPrioritiesData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardLinkBoardSelfAssessmentPrioritiesResponse, CharityBoardLinkBoardSelfAssessmentPrioritiesError, Options<CharityBoardLinkBoardSelfAssessmentPrioritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardLinkBoardSelfAssessmentPriorities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardSelfAssessmentQuestionsQueryKey = (options: Options<CharityBoardGetBoardSelfAssessmentQuestionsData>) => createQueryKey('charity-board-get_board_self_assessment_questions', options);

/**
 * Get Board Self Assessment Questions
 *
 * What the self-assessment asks: its statements, in their groups, with their sources, the
 * answers, and the questions in a person's own words — to print a blank answer sheet, and to
 * enter one.
 */
export const charityBoardGetBoardSelfAssessmentQuestionsOptions = (options: Options<CharityBoardGetBoardSelfAssessmentQuestionsData>) => queryOptions<CharityBoardGetBoardSelfAssessmentQuestionsResponse, CharityBoardGetBoardSelfAssessmentQuestionsError, CharityBoardGetBoardSelfAssessmentQuestionsResponse, ReturnType<typeof charityBoardGetBoardSelfAssessmentQuestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardSelfAssessmentQuestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardSelfAssessmentQuestionsQueryKey(options)
});

/**
 * Remind Board Self Assessment Recipients
 *
 * Remind people who haven't answered yet. Each gets one email, at most once a day. Reminders
 * go only when you send them. Name the people in `board_member_ids`, or send null for everyone
 * who can be reminded now.
 */
export const charityBoardRemindBoardSelfAssessmentRecipientsMutation = (options?: Partial<Options<CharityBoardRemindBoardSelfAssessmentRecipientsData>>): UseMutationOptions<CharityBoardRemindBoardSelfAssessmentRecipientsResponse, CharityBoardRemindBoardSelfAssessmentRecipientsError, Options<CharityBoardRemindBoardSelfAssessmentRecipientsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemindBoardSelfAssessmentRecipientsResponse, CharityBoardRemindBoardSelfAssessmentRecipientsError, Options<CharityBoardRemindBoardSelfAssessmentRecipientsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemindBoardSelfAssessmentRecipients({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Board Self Assessment Requests
 *
 * Send the self-assessment to people who haven't been sent it — someone who joined the board
 * since it started, or someone left out at the start. A seat that hasn't joined Board yet gets
 * an invitation with it. Name the people in `board_member_ids`, or send null for everyone it can
 * go to (never someone left out at the start).
 */
export const charityBoardSendBoardSelfAssessmentRequestsMutation = (options?: Partial<Options<CharityBoardSendBoardSelfAssessmentRequestsData>>): UseMutationOptions<CharityBoardSendBoardSelfAssessmentRequestsResponse, CharityBoardSendBoardSelfAssessmentRequestsError, Options<CharityBoardSendBoardSelfAssessmentRequestsData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardSendBoardSelfAssessmentRequestsResponse, CharityBoardSendBoardSelfAssessmentRequestsError, Options<CharityBoardSendBoardSelfAssessmentRequestsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardSendBoardSelfAssessmentRequests({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardSelfAssessmentResultsQueryKey = (options: Options<CharityBoardGetBoardSelfAssessmentResultsData>) => createQueryKey('charity-board-get_board_self_assessment_results', options);

/**
 * Get Board Self Assessment Results
 *
 * A closed self-assessment's results, from its record in the minute book: how many people
 * chose each answer, in the statements' own order, and the comments without names, sorted. With
 * fewer than three answers, only how many were asked and answered.
 */
export const charityBoardGetBoardSelfAssessmentResultsOptions = (options: Options<CharityBoardGetBoardSelfAssessmentResultsData>) => queryOptions<CharityBoardGetBoardSelfAssessmentResultsResponse, CharityBoardGetBoardSelfAssessmentResultsError, CharityBoardGetBoardSelfAssessmentResultsResponse, ReturnType<typeof charityBoardGetBoardSelfAssessmentResultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardSelfAssessmentResults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardSelfAssessmentResultsQueryKey(options)
});

export const charityBoardGetBoardToDoQueryKey = (options: Options<CharityBoardGetBoardToDoData>) => createQueryKey('charity-board-get_board_to_do', options);

/**
 * Get Board To Do
 *
 * Your to-do list on this board: what an officer can do next in Board's record-keeping, and
 * what officers did in the last 90 days. A new member's steps (the year's conflict-of-interest
 * questionnaire to send, a board buddy to choose), minutes to write and to send for approval
 * with the date the Form 990 instructions use, records waiting for approval, and members or past
 * records a connected AI proposed. Each is listed only for someone who can do it, and each keeps
 * the scoping of the page it is done on. Never what a member hasn't read or answered. Computed
 * when read from your board's own records; nothing is stored.
 */
export const charityBoardGetBoardToDoOptions = (options: Options<CharityBoardGetBoardToDoData>) => queryOptions<CharityBoardGetBoardToDoResponse, CharityBoardGetBoardToDoError, CharityBoardGetBoardToDoResponse, ReturnType<typeof charityBoardGetBoardToDoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardToDo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardToDoQueryKey(options)
});

export const charityBoardListBoardWrittenConsentsQueryKey = (options: Options<CharityBoardListBoardWrittenConsentsData>) => createQueryKey('charity-board-list_board_written_consents', options);

/**
 * List Board Written Consents
 *
 * The charity's written consents, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Each entry carries where the consent stands and how many of the seats it went out to
 * have signed. The roster and the signature log come with the single-consent read
 * rather than with a page of them.
 */
export const charityBoardListBoardWrittenConsentsOptions = (options: Options<CharityBoardListBoardWrittenConsentsData>) => queryOptions<CharityBoardListBoardWrittenConsentsResponse, CharityBoardListBoardWrittenConsentsError, CharityBoardListBoardWrittenConsentsResponse, ReturnType<typeof charityBoardListBoardWrittenConsentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardWrittenConsents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardWrittenConsentsQueryKey(options)
});

/**
 * Create Board Written Consent
 *
 * Open a working consent.
 *
 * Nothing is put to the board here: a draft has no roster and nobody can sign it. That
 * is a separate act, on a separate permission.
 */
export const charityBoardCreateBoardWrittenConsentMutation = (options?: Partial<Options<CharityBoardCreateBoardWrittenConsentData>>): UseMutationOptions<CharityBoardCreateBoardWrittenConsentResponse, CharityBoardCreateBoardWrittenConsentError, Options<CharityBoardCreateBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCreateBoardWrittenConsentResponse, CharityBoardCreateBoardWrittenConsentError, Options<CharityBoardCreateBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCreateBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardWrittenConsentQueryKey = (options: Options<CharityBoardGetBoardWrittenConsentData>) => createQueryKey('charity-board-get_board_written_consent', options);

/**
 * Get Board Written Consent
 *
 * One consent: the text before the board, the roster it went out to, and every
 * signature act recorded against it — who, what identity they asserted, how it was
 * captured, which text they named, and when.
 */
export const charityBoardGetBoardWrittenConsentOptions = (options: Options<CharityBoardGetBoardWrittenConsentData>) => queryOptions<CharityBoardGetBoardWrittenConsentResponse, CharityBoardGetBoardWrittenConsentError, CharityBoardGetBoardWrittenConsentResponse, ReturnType<typeof charityBoardGetBoardWrittenConsentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardWrittenConsent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardWrittenConsentQueryKey(options)
});

/**
 * Update Board Written Consent
 *
 * Edit a working consent's text (skip-None partial update).
 *
 * Refused once the consent has been circulated. From there a change is a revision: the
 * text goes out again as a new version and every signature starts again, because a
 * signature names the bytes a director read.
 */
export const charityBoardUpdateBoardWrittenConsentMutation = (options?: Partial<Options<CharityBoardUpdateBoardWrittenConsentData>>): UseMutationOptions<CharityBoardUpdateBoardWrittenConsentResponse, CharityBoardUpdateBoardWrittenConsentError, Options<CharityBoardUpdateBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardUpdateBoardWrittenConsentResponse, CharityBoardUpdateBoardWrittenConsentError, Options<CharityBoardUpdateBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardUpdateBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Circulate Board Written Consent
 *
 * Put the consent to the board.
 *
 * Freezes the text, records the roster it is going out to, and leaves the consent
 * pending. Until every seat on that roster has signed, the response says so in as many
 * words: the consent is pending, and how many seats have signed.
 *
 * Observers are not on the roster a consent goes to — the roster records them as
 * non-voting seats.
 */
export const charityBoardCirculateBoardWrittenConsentMutation = (options?: Partial<Options<CharityBoardCirculateBoardWrittenConsentData>>): UseMutationOptions<CharityBoardCirculateBoardWrittenConsentResponse, CharityBoardCirculateBoardWrittenConsentError, Options<CharityBoardCirculateBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardCirculateBoardWrittenConsentResponse, CharityBoardCirculateBoardWrittenConsentError, Options<CharityBoardCirculateBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardCirculateBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardListBoardConsentCompensationDecisionsQueryKey = (options: Options<CharityBoardListBoardConsentCompensationDecisionsData>) => createQueryKey('charity-board-list_board_consent_compensation_decisions', options);

/**
 * List Board Consent Compensation Decisions
 *
 * A written consent's compensation decisions, in order, with their documents, and the one
 * block its text must carry, exactly as shown, to go out to the board: the directors sign the
 * details in the text they read. Whether the current text carries it.
 */
export const charityBoardListBoardConsentCompensationDecisionsOptions = (options: Options<CharityBoardListBoardConsentCompensationDecisionsData>) => queryOptions<CharityBoardListBoardConsentCompensationDecisionsResponse, CharityBoardListBoardConsentCompensationDecisionsError, CharityBoardListBoardConsentCompensationDecisionsResponse, ReturnType<typeof charityBoardListBoardConsentCompensationDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardListBoardConsentCompensationDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardListBoardConsentCompensationDecisionsQueryKey(options)
});

/**
 * Add Board Consent Compensation Decision
 *
 * Record the board's compensation decision for one person on a written consent's draft,
 * after its others: whose pay, their position, how the board obtained what it relied on, and
 * its reason when it set pay outside the range in that information. Its documents are uploaded
 * onto it. Refused once the consent has gone out to the board.
 */
export const charityBoardAddBoardConsentCompensationDecisionMutation = (options?: Partial<Options<CharityBoardAddBoardConsentCompensationDecisionData>>): UseMutationOptions<CharityBoardAddBoardConsentCompensationDecisionResponse, CharityBoardAddBoardConsentCompensationDecisionError, Options<CharityBoardAddBoardConsentCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardAddBoardConsentCompensationDecisionResponse, CharityBoardAddBoardConsentCompensationDecisionError, Options<CharityBoardAddBoardConsentCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardAddBoardConsentCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Board Consent Compensation Decision
 *
 * Remove one consent decision, with its documents, while the consent is a draft. Its
 * history keeps who recorded and removed it, and when.
 */
export const charityBoardRemoveBoardConsentCompensationDecisionMutation = (options?: Partial<Options<CharityBoardRemoveBoardConsentCompensationDecisionData>>): UseMutationOptions<CharityBoardRemoveBoardConsentCompensationDecisionResponse, CharityBoardRemoveBoardConsentCompensationDecisionError, Options<CharityBoardRemoveBoardConsentCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardConsentCompensationDecisionResponse, CharityBoardRemoveBoardConsentCompensationDecisionError, Options<CharityBoardRemoveBoardConsentCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardConsentCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace Board Consent Compensation Decision
 *
 * Replace one consent decision's details whole, while the consent is a draft. Its uploaded
 * documents stay. The consent's text must then carry the block as it now reads.
 */
export const charityBoardReplaceBoardConsentCompensationDecisionMutation = (options?: Partial<Options<CharityBoardReplaceBoardConsentCompensationDecisionData>>): UseMutationOptions<CharityBoardReplaceBoardConsentCompensationDecisionResponse, CharityBoardReplaceBoardConsentCompensationDecisionError, Options<CharityBoardReplaceBoardConsentCompensationDecisionData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReplaceBoardConsentCompensationDecisionResponse, CharityBoardReplaceBoardConsentCompensationDecisionError, Options<CharityBoardReplaceBoardConsentCompensationDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReplaceBoardConsentCompensationDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Board Compensation Document
 *
 * Confirm a document finished uploading: Board reads the stored file and records its
 * fingerprint and size, which the consent's text names. A file over 100 MB is refused.
 */
export const charityBoardConfirmBoardCompensationDocumentMutation = (options?: Partial<Options<CharityBoardConfirmBoardCompensationDocumentData>>): UseMutationOptions<CharityBoardConfirmBoardCompensationDocumentResponse, CharityBoardConfirmBoardCompensationDocumentError, Options<CharityBoardConfirmBoardCompensationDocumentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardConfirmBoardCompensationDocumentResponse, CharityBoardConfirmBoardCompensationDocumentError, Options<CharityBoardConfirmBoardCompensationDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardConfirmBoardCompensationDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Issue Board Compensation Document Upload Url
 *
 * A short-lived signed URL to upload one document the board relied on, onto a consent
 * decision, bound to its file type. Nothing is recorded until the upload is confirmed.
 */
export const charityBoardIssueBoardCompensationDocumentUploadUrlMutation = (options?: Partial<Options<CharityBoardIssueBoardCompensationDocumentUploadUrlData>>): UseMutationOptions<CharityBoardIssueBoardCompensationDocumentUploadUrlResponse, CharityBoardIssueBoardCompensationDocumentUploadUrlError, Options<CharityBoardIssueBoardCompensationDocumentUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardIssueBoardCompensationDocumentUploadUrlResponse, CharityBoardIssueBoardCompensationDocumentUploadUrlError, Options<CharityBoardIssueBoardCompensationDocumentUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardIssueBoardCompensationDocumentUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Board Compensation Document
 *
 * Remove one of a consent decision's documents, while the consent is a draft.
 */
export const charityBoardRemoveBoardCompensationDocumentMutation = (options?: Partial<Options<CharityBoardRemoveBoardCompensationDocumentData>>): UseMutationOptions<CharityBoardRemoveBoardCompensationDocumentResponse, CharityBoardRemoveBoardCompensationDocumentError, Options<CharityBoardRemoveBoardCompensationDocumentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRemoveBoardCompensationDocumentResponse, CharityBoardRemoveBoardCompensationDocumentError, Options<CharityBoardRemoveBoardCompensationDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRemoveBoardCompensationDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityBoardGetBoardCompensationDocumentDownloadQueryKey = (options: Options<CharityBoardGetBoardCompensationDocumentDownloadData>) => createQueryKey('charity-board-get_board_compensation_document_download', options);

/**
 * Get Board Compensation Document Download
 *
 * A short-lived link to read one of a consent decision's documents, made for this request
 * and never stored.
 */
export const charityBoardGetBoardCompensationDocumentDownloadOptions = (options: Options<CharityBoardGetBoardCompensationDocumentDownloadData>) => queryOptions<CharityBoardGetBoardCompensationDocumentDownloadResponse, CharityBoardGetBoardCompensationDocumentDownloadError, CharityBoardGetBoardCompensationDocumentDownloadResponse, ReturnType<typeof charityBoardGetBoardCompensationDocumentDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityBoardGetBoardCompensationDocumentDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityBoardGetBoardCompensationDocumentDownloadQueryKey(options)
});

/**
 * Record Board Consent Revocation
 *
 * Withdraw an assent recorded on a director's behalf.
 *
 * Appended as its own act with its own note, never an edit of the entry it withdraws —
 * the signature log is only ever added to.
 */
export const charityBoardRecordBoardConsentRevocationMutation = (options?: Partial<Options<CharityBoardRecordBoardConsentRevocationData>>): UseMutationOptions<CharityBoardRecordBoardConsentRevocationResponse, CharityBoardRecordBoardConsentRevocationError, Options<CharityBoardRecordBoardConsentRevocationData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardConsentRevocationResponse, CharityBoardRecordBoardConsentRevocationError, Options<CharityBoardRecordBoardConsentRevocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardConsentRevocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Board Consent Signature
 *
 * Record a director's assent on their behalf.
 *
 * The path a board actually needs: a director who signed on paper, or who will not use
 * the portal at all, is not thereby unable to act. The entry is labelled as one the
 * officer made, carries the officer's own identity, and requires a note saying where
 * the assent came from. It completes a consent exactly as a director's own signature
 * does.
 */
export const charityBoardRecordBoardConsentSignatureMutation = (options?: Partial<Options<CharityBoardRecordBoardConsentSignatureData>>): UseMutationOptions<CharityBoardRecordBoardConsentSignatureResponse, CharityBoardRecordBoardConsentSignatureError, Options<CharityBoardRecordBoardConsentSignatureData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardRecordBoardConsentSignatureResponse, CharityBoardRecordBoardConsentSignatureError, Options<CharityBoardRecordBoardConsentSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardRecordBoardConsentSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revise Board Written Consent
 *
 * Revise a consent that is before the board.
 *
 * The new text goes out as a new version to a freshly recorded roster, and **every
 * signature already given starts again** — a director who signed the earlier text has
 * not signed this one. The earlier version keeps its own signatures as history.
 */
export const charityBoardReviseBoardWrittenConsentMutation = (options?: Partial<Options<CharityBoardReviseBoardWrittenConsentData>>): UseMutationOptions<CharityBoardReviseBoardWrittenConsentResponse, CharityBoardReviseBoardWrittenConsentError, Options<CharityBoardReviseBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardReviseBoardWrittenConsentResponse, CharityBoardReviseBoardWrittenConsentError, Options<CharityBoardReviseBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardReviseBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Board Written Consent
 *
 * Stop a consent before every seat has signed, with a recorded reason.
 *
 * The consent and its signatures stay: how the board arrived at whatever it did
 * instead is part of the charity's own history.
 */
export const charityBoardWithdrawBoardWrittenConsentMutation = (options?: Partial<Options<CharityBoardWithdrawBoardWrittenConsentData>>): UseMutationOptions<CharityBoardWithdrawBoardWrittenConsentResponse, CharityBoardWithdrawBoardWrittenConsentError, Options<CharityBoardWithdrawBoardWrittenConsentData>> => {
    const mutationOptions: UseMutationOptions<CharityBoardWithdrawBoardWrittenConsentResponse, CharityBoardWithdrawBoardWrittenConsentError, Options<CharityBoardWithdrawBoardWrittenConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityBoardWithdrawBoardWrittenConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminListCharityAdminsQueryKey = (options: Options<CharityAdminListCharityAdminsData>) => createQueryKey('charity-admin-list_charity_admins', options);

/**
 * List Charity Admins
 */
export const charityAdminListCharityAdminsOptions = (options: Options<CharityAdminListCharityAdminsData>) => queryOptions<CharityAdminListCharityAdminsResponse, CharityAdminListCharityAdminsError, CharityAdminListCharityAdminsResponse, ReturnType<typeof charityAdminListCharityAdminsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListCharityAdmins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListCharityAdminsQueryKey(options)
});

/**
 * Add Charity Admin
 */
export const charityAdminAddCharityAdminMutation = (options?: Partial<Options<CharityAdminAddCharityAdminData>>): UseMutationOptions<CharityAdminAddCharityAdminResponse, CharityAdminAddCharityAdminError, Options<CharityAdminAddCharityAdminData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminAddCharityAdminResponse, CharityAdminAddCharityAdminError, Options<CharityAdminAddCharityAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminAddCharityAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Charity Admin
 */
export const charityAdminRemoveCharityAdminMutation = (options?: Partial<Options<CharityAdminRemoveCharityAdminData>>): UseMutationOptions<CharityAdminRemoveCharityAdminResponse, CharityAdminRemoveCharityAdminError, Options<CharityAdminRemoveCharityAdminData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminRemoveCharityAdminResponse, CharityAdminRemoveCharityAdminError, Options<CharityAdminRemoveCharityAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminRemoveCharityAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Charity Admin Role
 */
export const charityAdminUpdateCharityAdminRoleMutation = (options?: Partial<Options<CharityAdminUpdateCharityAdminRoleData>>): UseMutationOptions<CharityAdminUpdateCharityAdminRoleResponse, CharityAdminUpdateCharityAdminRoleError, Options<CharityAdminUpdateCharityAdminRoleData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminUpdateCharityAdminRoleResponse, CharityAdminUpdateCharityAdminRoleError, Options<CharityAdminUpdateCharityAdminRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminUpdateCharityAdminRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminGetCrmRetentionQueryKey = (options: Options<CharityAdminGetCrmRetentionData>) => createQueryKey('charity-admin-get_crm_retention', options);

/**
 * Get Crm Retention
 *
 * THIS charity's donor retention grouped by FIRST-DONATION YEAR: per group,
 * how many of those donors gave again in each later year through the latest year
 * with data (zero years included — an honest decay curve). Anonymous counts
 * only. 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminGetCrmRetentionOptions = (options: Options<CharityAdminGetCrmRetentionData>) => queryOptions<CharityAdminGetCrmRetentionResponse, CharityAdminGetCrmRetentionError, CharityAdminGetCrmRetentionResponse, ReturnType<typeof charityAdminGetCrmRetentionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCrmRetention({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCrmRetentionQueryKey(options)
});

export const charityAdminGetCrmAnalyticsSummaryQueryKey = (options: Options<CharityAdminGetCrmAnalyticsSummaryData>) => createQueryKey('charity-admin-get_crm_analytics_summary', options);

/**
 * Get Crm Analytics Summary
 *
 * THIS charity's lifetime + per-year donation analytics: counts, gross/net
 * sums, distinct/new/returning donor counts, recurring-donor counts, and the
 * first/last gift dates. Aggregate only — no donor identity — so it is available
 * to a claimed charity that has not yet accepted the donor-data terms. The
 * numbers tie to the §321 dashboard exactly. 404 when the CRM flag is off; scoped
 * to the caller's membership.
 */
export const charityAdminGetCrmAnalyticsSummaryOptions = (options: Options<CharityAdminGetCrmAnalyticsSummaryData>) => queryOptions<CharityAdminGetCrmAnalyticsSummaryResponse, CharityAdminGetCrmAnalyticsSummaryError, CharityAdminGetCrmAnalyticsSummaryResponse, ReturnType<typeof charityAdminGetCrmAnalyticsSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCrmAnalyticsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCrmAnalyticsSummaryQueryKey(options)
});

export const charityAdminExportCrmAnalyticsCsvQueryKey = (options: Options<CharityAdminExportCrmAnalyticsCsvData>) => createQueryKey('charity-admin-export_crm_analytics_csv', options);

/**
 * Export Crm Analytics Csv
 *
 * CSV export of THIS charity's per-year analytics (one row per year). Built
 * from the same pipeline as the JSON summary, so the two can never disagree. 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminExportCrmAnalyticsCsvOptions = (options: Options<CharityAdminExportCrmAnalyticsCsvData>) => queryOptions<CharityAdminExportCrmAnalyticsCsvResponse, CharityAdminExportCrmAnalyticsCsvError, CharityAdminExportCrmAnalyticsCsvResponse, ReturnType<typeof charityAdminExportCrmAnalyticsCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminExportCrmAnalyticsCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminExportCrmAnalyticsCsvQueryKey(options)
});

/**
 * Submit Charity Claim
 *
 * Submit a claim for a charity, then run the Tier-1 auto-verify engine.
 *
 * The claimant's VERIFIED email is read from the Firebase ID token
 * (``request.state.idp_user`` — the ``email`` whose ``email_verified`` claim
 * applies), NEVER from the request body: the verified-email domain is conjunct
 * (a) of the SAFETY-CRITICAL Tier-1 conjunction, so it must be the authenticated
 * claim, not a client-asserted value. The result's ``outcome`` discriminates
 * AUTO_VERIFIED (claim approved in this call) / PENDING_REVIEW (Tier-2 queue) /
 * CANNOT_CLAIM (deactivated/screened dead-end). Returns 200 in all three cases —
 * a Tier-2 route and a cannot-claim dead-end are valid outcomes, not errors.
 */
export const charityAdminSubmitCharityClaimMutation = (options?: Partial<Options<CharityAdminSubmitCharityClaimData>>): UseMutationOptions<CharityAdminSubmitCharityClaimResponse, CharityAdminSubmitCharityClaimError, Options<CharityAdminSubmitCharityClaimData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminSubmitCharityClaimResponse, CharityAdminSubmitCharityClaimError, Options<CharityAdminSubmitCharityClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminSubmitCharityClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminGetCharityTermsForClaimQueryKey = (options: Options<CharityAdminGetCharityTermsForClaimData>) => createQueryKey('charity-admin-get_charity_terms_for_claim', options);

/**
 * Get Charity Terms For Claim
 *
 * The CURRENT effective Charity Terms for a charity the caller is about to
 * CLAIM: the canonical body with that organization's legal name / EIN /
 * registered domain substituted, plus the ``version_number`` + CANONICAL
 * (pre-substitution) ``content_hash`` to echo on the claim submit.
 *
 * Signed in, and that is the whole authorization — **no membership**, because a
 * claimant has none until their claim is approved. Byte-identical response shape
 * to ``GET /charity-admin/charities/{charity_id}/terms`` (the same
 * ``CharityTermsOut``, the same projection), so a client that already decodes
 * the portal's terms read needs no second decoder.
 *
 * ``content_hash`` is a RECORD, not display copy: it exists so the acceptance
 * row pins exactly the bytes that were shown. Echo it; never render it.
 *
 * 404 when no effective version exists. Serves normally for a charity with no
 * EIN on file (the body renders "not on file") — only the submit refuses that
 * case, with its own 409.
 *
 * ⚠ It ALSO serves normally for a TERMINALLY-REMOVED charity, which the consumer
 * ``GET /charities/{id}`` refuses as not-found — a known, bounded, test-pinned
 * disclosure of that organization's legal name / EIN / registered domain. The
 * reasoning, the bound (the claim funnel's own search cannot reach such a
 * charity, so a caller must already hold its UUID) and what would change it are
 * recorded in full on ``CharityTermsService.get_current_terms_for_claim``; read
 * that before adding a second no-membership door on this prefix.
 */
export const charityAdminGetCharityTermsForClaimOptions = (options: Options<CharityAdminGetCharityTermsForClaimData>) => queryOptions<CharityAdminGetCharityTermsForClaimResponse, CharityAdminGetCharityTermsForClaimError, CharityAdminGetCharityTermsForClaimResponse, ReturnType<typeof charityAdminGetCharityTermsForClaimQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCharityTermsForClaim({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCharityTermsForClaimQueryKey(options)
});

export const charityAdminListCrmDonorsQueryKey = (options: Options<CharityAdminListCrmDonorsData>) => createQueryKey('charity-admin-list_crm_donors', options);

/**
 * List Crm Donors
 *
 * THIS charity's consented, sharing donors with their CRM tags and recurring
 * flag. Donor identity appears ONLY when the charity holds an operative Charity
 * Terms acceptance AND the specific donation carries the share flag; otherwise
 * an honest, PII-free empty state. 404 when the CRM flag is off; scoped to the
 * caller's membership.
 */
export const charityAdminListCrmDonorsOptions = (options: Options<CharityAdminListCrmDonorsData>) => queryOptions<CharityAdminListCrmDonorsResponse, CharityAdminListCrmDonorsError, CharityAdminListCrmDonorsResponse, ReturnType<typeof charityAdminListCrmDonorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListCrmDonors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListCrmDonorsQueryKey(options)
});

export const charityAdminExportCrmDonorsCsvQueryKey = (options: Options<CharityAdminExportCrmDonorsCsvData>) => createQueryKey('charity-admin-export_crm_donors_csv', options);

/**
 * Export Crm Donors Csv
 *
 * CSV of the CRM donor list. SAME gate as the JSON read — a charity without
 * an operative acceptance gets a HEADER-ONLY CSV (no donor PII, never an
 * error). 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminExportCrmDonorsCsvOptions = (options: Options<CharityAdminExportCrmDonorsCsvData>) => queryOptions<CharityAdminExportCrmDonorsCsvResponse, CharityAdminExportCrmDonorsCsvError, CharityAdminExportCrmDonorsCsvResponse, ReturnType<typeof charityAdminExportCrmDonorsCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminExportCrmDonorsCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminExportCrmDonorsCsvQueryKey(options)
});

export const charityAdminGetCrmDonorQueryKey = (options: Options<CharityAdminGetCrmDonorData>) => createQueryKey('charity-admin-get_crm_donor', options);

/**
 * Get Crm Donor
 *
 * One donor's CRM record: rollup + per-donation lines + notes (newest
 * first). A gate-closed charity, a donor who never shared, and a donor who does
 * not exist all resolve to the SAME not-found failure — no existence oracle —
 * which surfaces as 400, not 404 (``CharityNotFoundException`` is a
 * ``ValidationException`` fallthrough). 404 is reserved for the flag gate:
 * the CRM flag off and the route does not exist. Scoped to the caller's
 * membership.
 */
export const charityAdminGetCrmDonorOptions = (options: Options<CharityAdminGetCrmDonorData>) => queryOptions<CharityAdminGetCrmDonorResponse, CharityAdminGetCrmDonorError, CharityAdminGetCrmDonorResponse, ReturnType<typeof charityAdminGetCrmDonorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCrmDonor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCrmDonorQueryKey(options)
});

/**
 * Create Crm Donor Note
 *
 * Append a timestamped note to a qualifying donor's CRM record.
 */
export const charityAdminCreateCrmDonorNoteMutation = (options?: Partial<Options<CharityAdminCreateCrmDonorNoteData>>): UseMutationOptions<CharityAdminCreateCrmDonorNoteResponse, CharityAdminCreateCrmDonorNoteError, Options<CharityAdminCreateCrmDonorNoteData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminCreateCrmDonorNoteResponse, CharityAdminCreateCrmDonorNoteError, Options<CharityAdminCreateCrmDonorNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminCreateCrmDonorNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Crm Donor Note
 *
 * Delete one note of this charity, on this donor.
 */
export const charityAdminDeleteCrmDonorNoteMutation = (options?: Partial<Options<CharityAdminDeleteCrmDonorNoteData>>): UseMutationOptions<CharityAdminDeleteCrmDonorNoteResponse, CharityAdminDeleteCrmDonorNoteError, Options<CharityAdminDeleteCrmDonorNoteData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminDeleteCrmDonorNoteResponse, CharityAdminDeleteCrmDonorNoteError, Options<CharityAdminDeleteCrmDonorNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminDeleteCrmDonorNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Crm Donor Note
 *
 * Rewrite one note's body. A note belonging to another charity or another
 * donor resolves to not-found.
 */
export const charityAdminUpdateCrmDonorNoteMutation = (options?: Partial<Options<CharityAdminUpdateCrmDonorNoteData>>): UseMutationOptions<CharityAdminUpdateCrmDonorNoteResponse, CharityAdminUpdateCrmDonorNoteError, Options<CharityAdminUpdateCrmDonorNoteData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminUpdateCrmDonorNoteResponse, CharityAdminUpdateCrmDonorNoteError, Options<CharityAdminUpdateCrmDonorNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminUpdateCrmDonorNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Crm Donor Tag
 *
 * Attach a tag to a qualifying donor and return the donor with its updated
 * tags. A case-insensitive duplicate is a 409. 404 when the CRM flag is off.
 */
export const charityAdminAddCrmDonorTagMutation = (options?: Partial<Options<CharityAdminAddCrmDonorTagData>>): UseMutationOptions<CharityAdminAddCrmDonorTagResponse, CharityAdminAddCrmDonorTagError, Options<CharityAdminAddCrmDonorTagData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminAddCrmDonorTagResponse, CharityAdminAddCrmDonorTagError, Options<CharityAdminAddCrmDonorTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminAddCrmDonorTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Crm Donor Tag
 *
 * Detach a tag (case-insensitive) from a qualifying donor. 404 when the CRM flag is off; a donor or tag that does not qualify is a not-found FAILURE that
 * surfaces as 400 (``CharityNotFoundException`` is a ``ValidationException``
 * fallthrough, not a registered 404).
 */
export const charityAdminRemoveCrmDonorTagMutation = (options?: Partial<Options<CharityAdminRemoveCrmDonorTagData>>): UseMutationOptions<CharityAdminRemoveCrmDonorTagResponse, CharityAdminRemoveCrmDonorTagError, Options<CharityAdminRemoveCrmDonorTagData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminRemoveCrmDonorTagResponse, CharityAdminRemoveCrmDonorTagError, Options<CharityAdminRemoveCrmDonorTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminRemoveCrmDonorTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminListCrmImportedContactsQueryKey = (options: Options<CharityAdminListCrmImportedContactsData>) => createQueryKey('charity-admin-list_crm_imported_contacts', options);

/**
 * List Crm Imported Contacts
 *
 * THIS charity's own imported contacts. ``q`` searches display name / email
 * WITHIN this charity's rows only — never a lookup against Givmo identity, and
 * these records are never matched or combined with donor accounts. Reads stay
 * available even when the terms gate is closed (it is the charity's own data).
 * 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminListCrmImportedContactsOptions = (options: Options<CharityAdminListCrmImportedContactsData>) => queryOptions<CharityAdminListCrmImportedContactsResponse, CharityAdminListCrmImportedContactsError, CharityAdminListCrmImportedContactsResponse, ReturnType<typeof charityAdminListCrmImportedContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListCrmImportedContacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListCrmImportedContactsQueryKey(options)
});

export const charityAdminListCrmImportedContactsInfiniteQueryKey = (options: Options<CharityAdminListCrmImportedContactsData>): QueryKey<Options<CharityAdminListCrmImportedContactsData>> => createQueryKey('charity-admin-list_crm_imported_contacts', options, true);

/**
 * List Crm Imported Contacts
 *
 * THIS charity's own imported contacts. ``q`` searches display name / email
 * WITHIN this charity's rows only — never a lookup against Givmo identity, and
 * these records are never matched or combined with donor accounts. Reads stay
 * available even when the terms gate is closed (it is the charity's own data).
 * 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminListCrmImportedContactsInfiniteOptions = (options: Options<CharityAdminListCrmImportedContactsData>) => {
    const opts = infiniteQueryOptions<CharityAdminListCrmImportedContactsResponse, CharityAdminListCrmImportedContactsError, InfiniteData<CharityAdminListCrmImportedContactsResponse>, QueryKey<Options<CharityAdminListCrmImportedContactsData>>, number | Pick<QueryKey<Options<CharityAdminListCrmImportedContactsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CharityAdminListCrmImportedContactsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await charityAdminListCrmImportedContacts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: charityAdminListCrmImportedContactsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Crm Imported Contact
 *
 * Add one charity-supplied contact. Requires an operative Charity Terms
 * acceptance (409 otherwise — the charity processes its own uploaded records
 * under the terms it accepted). ``source`` is server-stamped 'manual'.
 */
export const charityAdminCreateCrmImportedContactMutation = (options?: Partial<Options<CharityAdminCreateCrmImportedContactData>>): UseMutationOptions<CharityAdminCreateCrmImportedContactResponse, CharityAdminCreateCrmImportedContactError, Options<CharityAdminCreateCrmImportedContactData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminCreateCrmImportedContactResponse, CharityAdminCreateCrmImportedContactError, Options<CharityAdminCreateCrmImportedContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminCreateCrmImportedContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminExportCrmImportedContactsCsvQueryKey = (options: Options<CharityAdminExportCrmImportedContactsCsvData>) => createQueryKey('charity-admin-export_crm_imported_contacts_csv', options);

/**
 * Export Crm Imported Contacts Csv
 *
 * CSV of the charity's imported contacts. Carries NO donation or identity
 * column — there is nothing to join.
 */
export const charityAdminExportCrmImportedContactsCsvOptions = (options: Options<CharityAdminExportCrmImportedContactsCsvData>) => queryOptions<CharityAdminExportCrmImportedContactsCsvResponse, CharityAdminExportCrmImportedContactsCsvError, CharityAdminExportCrmImportedContactsCsvResponse, ReturnType<typeof charityAdminExportCrmImportedContactsCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminExportCrmImportedContactsCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminExportCrmImportedContactsCsvQueryKey(options)
});

/**
 * Delete Crm Imported Contact
 *
 * Delete one contact of THIS charity. Deliberately NOT terms-gated —
 * removing your own uploaded data is never blocked by a lapsed acceptance.
 */
export const charityAdminDeleteCrmImportedContactMutation = (options?: Partial<Options<CharityAdminDeleteCrmImportedContactData>>): UseMutationOptions<CharityAdminDeleteCrmImportedContactResponse, CharityAdminDeleteCrmImportedContactError, Options<CharityAdminDeleteCrmImportedContactData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminDeleteCrmImportedContactResponse, CharityAdminDeleteCrmImportedContactError, Options<CharityAdminDeleteCrmImportedContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminDeleteCrmImportedContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Crm Imported Contact
 *
 * Patch one contact — absent ≠ null, so an omitted field is left alone.
 * Requires an operative Charity Terms acceptance (409 otherwise).
 */
export const charityAdminUpdateCrmImportedContactMutation = (options?: Partial<Options<CharityAdminUpdateCrmImportedContactData>>): UseMutationOptions<CharityAdminUpdateCrmImportedContactResponse, CharityAdminUpdateCrmImportedContactError, Options<CharityAdminUpdateCrmImportedContactData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminUpdateCrmImportedContactResponse, CharityAdminUpdateCrmImportedContactError, Options<CharityAdminUpdateCrmImportedContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminUpdateCrmImportedContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Charity Display Name
 *
 * Go back to the charity's catalog name — OWNER-only: the live display name ends and a
 * request waiting for review is withdrawn. Idempotent. Served whatever
 * ``CHARITY_DISPLAY_NAME_ENABLED`` says, so a charity can always end one; the returned block
 * is null while the flag is off. The console ends a live name by saving the catalog name
 * through the PUT instead, and withdraws a request alone through ``…/display-name/request``.
 */
export const charityAdminClearCharityDisplayNameMutation = (options?: Partial<Options<CharityAdminClearCharityDisplayNameData>>): UseMutationOptions<CharityAdminClearCharityDisplayNameResponse, CharityAdminClearCharityDisplayNameError, Options<CharityAdminClearCharityDisplayNameData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminClearCharityDisplayNameResponse, CharityAdminClearCharityDisplayNameError, Options<CharityAdminClearCharityDisplayNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminClearCharityDisplayName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Charity Display Name
 *
 * Set the charity's display name, the name donors see on Givmo — OWNER-only
 * (``charity_profile:write``), and only while the charity is claimed, has accepted the
 * Charity Terms, has its IRS legal name on file and is listed. The name is checked against
 * other organizations' names first: a clear name goes live at once; a name close to
 * another organization's answers 409 ``CHARITY_DISPLAY_NAME_NEEDS_REVIEW`` with what it is
 * close to, and with ``submit_for_review`` true waits for Givmo's review instead; another
 * organization's name answers 422 ``CHARITY_DISPLAY_NAME_REFUSED``; a charity that cannot
 * carry one now answers 409 ``CHARITY_DISPLAY_NAME_NOT_AVAILABLE``. Every refusal's
 * ``detail`` is a sentence to show as it is. The catalog name sent while a display name is
 * live ends the display name and withdraws a request waiting beside it, even for a charity
 * that can no longer carry one. Returns the ``display_name`` block. Dark behind
 * ``CHARITY_DISPLAY_NAME_ENABLED`` (the absent-route 404).
 */
export const charityAdminSetCharityDisplayNameMutation = (options?: Partial<Options<CharityAdminSetCharityDisplayNameData>>): UseMutationOptions<CharityAdminSetCharityDisplayNameResponse, CharityAdminSetCharityDisplayNameError, Options<CharityAdminSetCharityDisplayNameData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminSetCharityDisplayNameResponse, CharityAdminSetCharityDisplayNameError, Options<CharityAdminSetCharityDisplayNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminSetCharityDisplayName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Charity Display Name Request
 *
 * Withdraw the request waiting for Givmo's review and nothing else (CPA-BE65) — OWNER-only:
 * a live display name stays as it is. 409 ``CHARITY_DISPLAY_NAME_NOT_AVAILABLE`` with a
 * sentence when no request is waiting. Returns the ``display_name`` block (null while the flag
 * is off). Served whatever ``CHARITY_DISPLAY_NAME_ENABLED`` says, as the DELETE above is: the
 * flag gates only the writes that grow exposure, and its definition keeps every act that ends
 * or withdraws one served "so exposure can always shrink".
 */
export const charityAdminWithdrawCharityDisplayNameRequestMutation = (options?: Partial<Options<CharityAdminWithdrawCharityDisplayNameRequestData>>): UseMutationOptions<CharityAdminWithdrawCharityDisplayNameRequestResponse, CharityAdminWithdrawCharityDisplayNameRequestError, Options<CharityAdminWithdrawCharityDisplayNameRequestData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminWithdrawCharityDisplayNameRequestResponse, CharityAdminWithdrawCharityDisplayNameRequestError, Options<CharityAdminWithdrawCharityDisplayNameRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminWithdrawCharityDisplayNameRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminGetCharityFollowerCountQueryKey = (options: Options<CharityAdminGetCharityFollowerCountData>) => createQueryKey('charity-admin-get_charity_follower_count', options);

/**
 * Get Charity Follower Count
 *
 * CPB-BE15 (D-CP-27) — the AGGREGATE follower count for THIS charity: an
 * integer, never identities (invariant 2 — no wire anywhere carries follower
 * identities to a charity). Owner or Member (`charity:read`). 404 when the follows flag is off; scoped to the caller's membership.
 */
export const charityAdminGetCharityFollowerCountOptions = (options: Options<CharityAdminGetCharityFollowerCountData>) => queryOptions<CharityAdminGetCharityFollowerCountResponse, CharityAdminGetCharityFollowerCountError, CharityAdminGetCharityFollowerCountResponse, ReturnType<typeof charityAdminGetCharityFollowerCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCharityFollowerCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCharityFollowerCountQueryKey(options)
});

export const charityAdminListCharityInvitesQueryKey = (options: Options<CharityAdminListCharityInvitesData>) => createQueryKey('charity-admin-list_charity_invites', options);

/**
 * List Charity Invites
 *
 * List a charity's PENDING invites (newest first). **Owner-only**. NEVER
 * carries a token or its hash.
 */
export const charityAdminListCharityInvitesOptions = (options: Options<CharityAdminListCharityInvitesData>) => queryOptions<CharityAdminListCharityInvitesResponse, CharityAdminListCharityInvitesError, CharityAdminListCharityInvitesResponse, ReturnType<typeof charityAdminListCharityInvitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListCharityInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListCharityInvitesQueryKey(options)
});

/**
 * Create Charity Invite
 *
 * Owner invites a colleague to a charity by email + role → mint a single-use,
 * email-bound, expiring invite token + record. **Owner-only** (the service's
 * ``@has_charity_permission("charity_admin:add")`` — a Member is 403'd). The
 * plaintext token is the CPA-BE11 email hand-off and is NEVER returned on the
 * wire (``CharityInviteOut`` omits it). If the invited email already administers
 * the charity, no token is minted — the existing invite/membership stands and
 * the response echoes the (no-op) state.
 */
export const charityAdminCreateCharityInviteMutation = (options?: Partial<Options<CharityAdminCreateCharityInviteData>>): UseMutationOptions<CharityAdminCreateCharityInviteResponse, CharityAdminCreateCharityInviteError, Options<CharityAdminCreateCharityInviteData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminCreateCharityInviteResponse, CharityAdminCreateCharityInviteError, Options<CharityAdminCreateCharityInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminCreateCharityInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Charity Invite
 *
 * Revoke a PENDING invite (**Owner-only**). The invite must belong to the
 * scoped charity (a cross-charity id → 404).
 */
export const charityAdminRevokeCharityInviteMutation = (options?: Partial<Options<CharityAdminRevokeCharityInviteData>>): UseMutationOptions<CharityAdminRevokeCharityInviteResponse, CharityAdminRevokeCharityInviteError, Options<CharityAdminRevokeCharityInviteData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminRevokeCharityInviteResponse, CharityAdminRevokeCharityInviteError, Options<CharityAdminRevokeCharityInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminRevokeCharityInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminProfilePageGetCharityPageQueryKey = (options: Options<CharityAdminProfilePageGetCharityPageData>) => createQueryKey('charity-admin-profile-page-get_charity_page', options);

/**
 * Get Charity Page
 *
 * The charity's OWNER view of its page: every block, unlisted ones included
 * with their takedown state (``profile:read`` — every admin of the org).
 */
export const charityAdminProfilePageGetCharityPageOptions = (options: Options<CharityAdminProfilePageGetCharityPageData>) => queryOptions<CharityAdminProfilePageGetCharityPageResponse, CharityAdminProfilePageGetCharityPageError, CharityAdminProfilePageGetCharityPageResponse, ReturnType<typeof charityAdminProfilePageGetCharityPageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminProfilePageGetCharityPage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminProfilePageGetCharityPageQueryKey(options)
});

/**
 * Replace Charity Page
 *
 * The id-preserving full-list replace (``profile:write`` — a Global Admin or
 * any Owner-tier module grant holder, D-PE-14 — behind the three-conjunct
 * Charity Terms gate).
 */
export const charityAdminProfilePageReplaceCharityPageMutation = (options?: Partial<Options<CharityAdminProfilePageReplaceCharityPageData>>): UseMutationOptions<CharityAdminProfilePageReplaceCharityPageResponse, CharityAdminProfilePageReplaceCharityPageError, Options<CharityAdminProfilePageReplaceCharityPageData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminProfilePageReplaceCharityPageResponse, CharityAdminProfilePageReplaceCharityPageError, Options<CharityAdminProfilePageReplaceCharityPageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminProfilePageReplaceCharityPage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Charity Page Image
 *
 * Upload one page image (sniff-validated; stored as a private object KEY under
 * ``charity/{EIN}/page/…``; signed on read). A charity with no EIN on file 409s.
 */
export const charityAdminProfilePageUploadCharityPageImageMutation = (options?: Partial<Options<CharityAdminProfilePageUploadCharityPageImageData>>): UseMutationOptions<CharityAdminProfilePageUploadCharityPageImageResponse, CharityAdminProfilePageUploadCharityPageImageError, Options<CharityAdminProfilePageUploadCharityPageImageData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminProfilePageUploadCharityPageImageResponse, CharityAdminProfilePageUploadCharityPageImageError, Options<CharityAdminProfilePageUploadCharityPageImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminProfilePageUploadCharityPageImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminListCharityPaymentEventsQueryKey = (options: Options<CharityAdminListCharityPaymentEventsData>) => createQueryKey('charity-admin-list_charity_payment_events', options);

/**
 * List Charity Payment Events
 *
 * The charity's append-only payment audit history (create/change/verify/flag),
 * newest first. Vocabulary-clean; carries NO bank data. permission-scoped to the caller's membership.
 */
export const charityAdminListCharityPaymentEventsOptions = (options: Options<CharityAdminListCharityPaymentEventsData>) => queryOptions<CharityAdminListCharityPaymentEventsResponse, CharityAdminListCharityPaymentEventsError, CharityAdminListCharityPaymentEventsResponse, ReturnType<typeof charityAdminListCharityPaymentEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListCharityPaymentEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListCharityPaymentEventsQueryKey(options)
});

export const charityAdminGetCharityPaymentProfileQueryKey = (options: Options<CharityAdminGetCharityPaymentProfileData>) => createQueryKey('charity-admin-get_charity_payment_profile', options);

/**
 * Get Charity Payment Profile
 *
 * The charity's CURRENT (active) MASKED payment profile, or a null profile
 * (clean empty state) when it has never set one. NEVER returns full bank numbers.
 * ``check_address`` is populated (read-only IRS address) when the active election
 * is CHECK. permission-scoped to the caller's
 * membership for this charity.
 */
export const charityAdminGetCharityPaymentProfileOptions = (options: Options<CharityAdminGetCharityPaymentProfileData>) => queryOptions<CharityAdminGetCharityPaymentProfileResponse, CharityAdminGetCharityPaymentProfileError, CharityAdminGetCharityPaymentProfileResponse, ReturnType<typeof charityAdminGetCharityPaymentProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCharityPaymentProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCharityPaymentProfileQueryKey(options)
});

/**
 * Submit Charity Ach
 *
 * Enter ACH bank details into the vault for THIS charity (OWNER-only).
 *
 * The routing/account numbers are WRITE-ONLY: they are validated, KMS-encrypted
 * into the vault, and NEVER echoed back — the response is a MASKED confirmation
 * (last-4 + status). If the account-holder name doesn't match the charity's legal
 * name the profile is saved FLAGGED for human review and never auto-bound (rail
 * §3.4) — still a 201 (saved), with an honest ``flagged``/message. OWNER-scoped to this charity.
 */
export const charityAdminSubmitCharityAchMutation = (options?: Partial<Options<CharityAdminSubmitCharityAchData>>): UseMutationOptions<CharityAdminSubmitCharityAchResponse, CharityAdminSubmitCharityAchError, Options<CharityAdminSubmitCharityAchData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminSubmitCharityAchResponse, CharityAdminSubmitCharityAchError, Options<CharityAdminSubmitCharityAchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminSubmitCharityAch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Elect Charity Check
 *
 * Elect the mailed-CHECK rail for THIS charity (OWNER-only). The request body
 * carries NO address — the mailing address is ALWAYS the IRS address on file,
 * returned read-only in ``check_address``. OWNER-scoped to this charity.
 */
export const charityAdminElectCharityCheckMutation = (options?: Partial<Options<CharityAdminElectCharityCheckData>>): UseMutationOptions<CharityAdminElectCharityCheckResponse, CharityAdminElectCharityCheckError, Options<CharityAdminElectCharityCheckData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminElectCharityCheckResponse, CharityAdminElectCharityCheckError, Options<CharityAdminElectCharityCheckData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminElectCharityCheck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminGetCharityCheckAddressQueryKey = (options: Options<CharityAdminGetCharityCheckAddressData>) => createQueryKey('charity-admin-get_charity_check_address', options);

/**
 * Get Charity Check Address
 *
 * The READ-ONLY IRS address a mailed check would go to (from the IRS record on
 * file), so the check-election UI can show it BEFORE electing. A user-typed
 * address is never accepted anywhere.
 */
export const charityAdminGetCharityCheckAddressOptions = (options: Options<CharityAdminGetCharityCheckAddressData>) => queryOptions<CharityAdminGetCharityCheckAddressResponse, CharityAdminGetCharityCheckAddressError, CharityAdminGetCharityCheckAddressResponse, ReturnType<typeof charityAdminGetCharityCheckAddressQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCharityCheckAddress({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCharityCheckAddressQueryKey(options)
});

export const charityAdminGetCharityProfileQueryKey = (options: Options<CharityAdminGetCharityProfileData>) => createQueryKey('charity-admin-get_charity_profile', options);

/**
 * Get Charity Profile
 *
 * The charity's editable public profile (mission / contact / logo / the
 * organization domain) plus per-field PROVENANCE (which values were charity-entered
 * vs machine-sourced). ``organization_domain`` is the verification trust anchor AND
 * the charity's website, returned as the normalized eTLD+1 — a console renders
 * ``https://`` + it. readable by Owner or Member (``charity:read``).
 */
export const charityAdminGetCharityProfileOptions = (options: Options<CharityAdminGetCharityProfileData>) => queryOptions<CharityAdminGetCharityProfileResponse, CharityAdminGetCharityProfileError, CharityAdminGetCharityProfileResponse, ReturnType<typeof charityAdminGetCharityProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCharityProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCharityProfileQueryKey(options)
});

/**
 * Update Charity Profile
 *
 * Edit the charity's profile (mission / contact / the organization domain) —
 * OWNER-only. PATCH semantics: only the fields present in the body change (absent =
 * unchanged; null = cleared). Every human edit of a provenance-tracked field records
 * a ``human`` provenance row (sacred — never overwritten by ETL).
 *
 * ``organization_domain`` is the charity's WEBSITE and its verification trust anchor
 * at once (D-CP-73), editable here since CPA-BE20: send the website URL (or a
 * hostname) and the stored value is its eTLD+1. It cannot be cleared, it 422s when
 * the charity's claim is not approved, it 409s when that claim no longer stands or
 * when another active charity already holds that domain, and a successful change
 * alerts EVERY admin of the org. OWNER-scoped to this charity.
 */
export const charityAdminUpdateCharityProfileMutation = (options?: Partial<Options<CharityAdminUpdateCharityProfileData>>): UseMutationOptions<CharityAdminUpdateCharityProfileResponse, CharityAdminUpdateCharityProfileError, Options<CharityAdminUpdateCharityProfileData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminUpdateCharityProfileResponse, CharityAdminUpdateCharityProfileError, Options<CharityAdminUpdateCharityProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminUpdateCharityProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Charity Profile Logo
 *
 * Upload/replace the charity's logo image — OWNER-only. Reuses the EXISTING
 * charity-logo GCS path (EIN-keyed public bucket); the ``logo_url`` is computed off
 * the EIN (never a stored column), and a ``logo`` ``human`` provenance row is
 * recorded. OWNER-scoped to this charity.
 */
export const charityAdminUploadCharityProfileLogoMutation = (options?: Partial<Options<CharityAdminUploadCharityProfileLogoData>>): UseMutationOptions<CharityAdminUploadCharityProfileLogoResponse, CharityAdminUploadCharityProfileLogoError, Options<CharityAdminUploadCharityProfileLogoData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminUploadCharityProfileLogoResponse, CharityAdminUploadCharityProfileLogoError, Options<CharityAdminUploadCharityProfileLogoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminUploadCharityProfileLogo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request Charity Removal
 *
 * Request removal of THIS charity from the platform (OWNER-only). Records the
 * required ``written_request_reason`` (the "support for written requests" note) and
 * starts the 3-business-day identity-verify SLA; a super-admin then verifies +
 * processes the removal. Idempotent — a second request while one is already in
 * progress returns 409. OWNER-scoped to this
 * charity.
 */
export const charityAdminRequestCharityRemovalMutation = (options?: Partial<Options<CharityAdminRequestCharityRemovalData>>): UseMutationOptions<CharityAdminRequestCharityRemovalResponse, CharityAdminRequestCharityRemovalError, Options<CharityAdminRequestCharityRemovalData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminRequestCharityRemovalResponse, CharityAdminRequestCharityRemovalError, Options<CharityAdminRequestCharityRemovalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminRequestCharityRemoval({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminListCharityRemovalRequestsQueryKey = (options: Options<CharityAdminListCharityRemovalRequestsData>) => createQueryKey('charity-admin-list_charity_removal_requests', options);

/**
 * List Charity Removal Requests
 *
 * The removal-request history for THIS charity (newest first), with each
 * request's SLA deadlines. Owner or Member (``charity:read``). permission-scoped to the caller's membership for this charity.
 */
export const charityAdminListCharityRemovalRequestsOptions = (options: Options<CharityAdminListCharityRemovalRequestsData>) => queryOptions<CharityAdminListCharityRemovalRequestsResponse, CharityAdminListCharityRemovalRequestsError, CharityAdminListCharityRemovalRequestsResponse, ReturnType<typeof charityAdminListCharityRemovalRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListCharityRemovalRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListCharityRemovalRequestsQueryKey(options)
});

export const charityAdminGetSection321ConsentingDonorsQueryKey = (options: Options<CharityAdminGetSection321ConsentingDonorsData>) => createQueryKey('charity-admin-get_section321_consenting_donors', options);

/**
 * Get Section321 Consenting Donors
 *
 * The consent-gated §321(a)(6) consenting-donor report for THIS charity: donors
 * who chose to share, with name / contact / total-donated + per-donation detail.
 * Donor identity is surfaced ONLY when the charity is CONSENTED (has accepted the
 * donor-data terms); otherwise an honest, PII-free empty state. scoped to the caller's membership.
 */
export const charityAdminGetSection321ConsentingDonorsOptions = (options: Options<CharityAdminGetSection321ConsentingDonorsData>) => queryOptions<CharityAdminGetSection321ConsentingDonorsResponse, CharityAdminGetSection321ConsentingDonorsError, CharityAdminGetSection321ConsentingDonorsResponse, ReturnType<typeof charityAdminGetSection321ConsentingDonorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetSection321ConsentingDonors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetSection321ConsentingDonorsQueryKey(options)
});

export const charityAdminGetSection321DashboardQueryKey = (options: Options<CharityAdminGetSection321DashboardData>) => createQueryKey('charity-admin-get_section321_dashboard', options);

/**
 * Get Section321 Dashboard
 *
 * The always-available §321 dashboard aggregates for THIS charity: donation
 * count, covered period, gross-before-fees / total-fees / net-after-fees /
 * total-sent / net-pending, plus the platform legal name (from config). Zero-data
 * is an honest empty state, scoped to the caller's membership.
 */
export const charityAdminGetSection321DashboardOptions = (options: Options<CharityAdminGetSection321DashboardData>) => queryOptions<CharityAdminGetSection321DashboardResponse, CharityAdminGetSection321DashboardError, CharityAdminGetSection321DashboardResponse, ReturnType<typeof charityAdminGetSection321DashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetSection321Dashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetSection321DashboardQueryKey(options)
});

export const charityAdminListSection321FundraisersQueryKey = (options: Options<CharityAdminListSection321FundraisersData>) => createQueryKey('charity-admin-list_section321_fundraisers', options);

/**
 * List Section321 Fundraisers
 *
 * THIS charity's §321-attributed fundraisers (FCA-BE1): one decorated
 * rollup row per fundraiser whose creator opted IN to charity-facing
 * attribution (D-ATT-2) — name, public URL, image, donor count, gross/net/
 * fee totals, first/last donation dates. NO donor identity here (aggregates
 * only). Canonical {data, meta, links} paginated envelope (`page[limit]`/
 * `page[offset]`, house default/cap) — pagination slices the ALREADY-grouped
 * per-fundraiser rollup rows, never the underlying per-leg rows (grouping
 * must see every leg to tie exactly; see
 * `CharitySection321Service.list_fundraisers`). scoped to the caller's
 * membership.
 */
export const charityAdminListSection321FundraisersOptions = (options: Options<CharityAdminListSection321FundraisersData>) => queryOptions<CharityAdminListSection321FundraisersResponse, CharityAdminListSection321FundraisersError, CharityAdminListSection321FundraisersResponse, ReturnType<typeof charityAdminListSection321FundraisersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListSection321Fundraisers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListSection321FundraisersQueryKey(options)
});

export const charityAdminGetSection321FundraiserDetailQueryKey = (options: Options<CharityAdminGetSection321FundraiserDetailData>) => createQueryKey('charity-admin-get_section321_fundraiser_detail', options);

/**
 * Get Section321 Fundraiser Detail
 *
 * One attributed fundraiser's §321 detail for THIS charity: its rollup +
 * constituent donation lines. Donor identity per line is revealed ONLY when
 * BOTH the charity's §318-qualifying consent gate is open AND that leg's own
 * `share_with_charities` is set (D-ATT-3) — never a third path. A
 * toggle-off, non-existent, or cross-charity fundraiser id all collapse to
 * the SAME not-found (no existence oracle). scoped to the caller's membership.
 */
export const charityAdminGetSection321FundraiserDetailOptions = (options: Options<CharityAdminGetSection321FundraiserDetailData>) => queryOptions<CharityAdminGetSection321FundraiserDetailResponse, CharityAdminGetSection321FundraiserDetailError, CharityAdminGetSection321FundraiserDetailResponse, ReturnType<typeof charityAdminGetSection321FundraiserDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetSection321FundraiserDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetSection321FundraiserDetailQueryKey(options)
});

/**
 * Object To Fundraiser Message
 *
 * Object to a fundraiser's creator-message (FCA-BE9). One click — no body
 * required (an optional ``reason`` ≤500 chars may be sent). The fundraiser must be
 * attributed + visible to THIS charity per the §321 read semantics AND carry a
 * non-empty stored message; otherwise the SAME not-found the read raises (no
 * existence oracle) or a 409 when there is no message to object to. Idempotent — a
 * repeat while one objection is OPEN returns the existing one. 404 when the portal
 * flag, the fundraiser-attribution flag, OR the message flag
 * (``FUNDRAISER_CHARITY_MESSAGE_ENABLED``) is off — pre-flip a charity that cannot
 * read any message must not learn one exists via this route; scoped to the caller's
 * membership.
 */
export const charityAdminObjectToFundraiserMessageMutation = (options?: Partial<Options<CharityAdminObjectToFundraiserMessageData>>): UseMutationOptions<CharityAdminObjectToFundraiserMessageResponse, CharityAdminObjectToFundraiserMessageError, Options<CharityAdminObjectToFundraiserMessageData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminObjectToFundraiserMessageResponse, CharityAdminObjectToFundraiserMessageError, Options<CharityAdminObjectToFundraiserMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminObjectToFundraiserMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminListSection321GrantsQueryKey = (options: Options<CharityAdminListSection321GrantsData>) => createQueryKey('charity-admin-list_section321_grants', options);

/**
 * List Section321 Grants
 *
 * THIS charity's grants, each summarized over its constituent donations
 * (gross/fee/net totals + a vocab-clean disclosure status; amount/date/method sent
 * only when truly sent). scoped to the caller's
 * membership.
 */
export const charityAdminListSection321GrantsOptions = (options: Options<CharityAdminListSection321GrantsData>) => queryOptions<CharityAdminListSection321GrantsResponse, CharityAdminListSection321GrantsError, CharityAdminListSection321GrantsResponse, ReturnType<typeof charityAdminListSection321GrantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListSection321Grants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListSection321GrantsQueryKey(options)
});

export const charityAdminGetSection321GrantDetailQueryKey = (options: Options<CharityAdminGetSection321GrantDetailData>) => createQueryKey('charity-admin-get_section321_grant_detail', options);

/**
 * Get Section321 Grant Detail
 *
 * One grant's §321 detail: its summary + the constituent donations (per-donation
 * gross/fee/net/sent + designation-instructions ((a)(8))). The grant MUST belong to
 * THIS charity — a cross-charity grant id resolves to not-found (no leak). scoped to the caller's membership.
 */
export const charityAdminGetSection321GrantDetailOptions = (options: Options<CharityAdminGetSection321GrantDetailData>) => queryOptions<CharityAdminGetSection321GrantDetailResponse, CharityAdminGetSection321GrantDetailError, CharityAdminGetSection321GrantDetailResponse, ReturnType<typeof charityAdminGetSection321GrantDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetSection321GrantDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetSection321GrantDetailQueryKey(options)
});

export const charityAdminGetSection321StatementQueryKey = (options: Options<CharityAdminGetSection321StatementData>) => createQueryKey('charity-admin-get_section321_statement', options);

/**
 * Get Section321 Statement
 *
 * CPA-BE14 — THE unified §321 statement for THIS charity: the donation set
 * plus every per-dimension aggregate needed to render it grouped by grant, by
 * fundraiser, or by donor. All three groupings are complete partitions of one
 * set, so all three reconcile to the same charity total (and to the dashboard
 * tiles). Every subtotal is computed server-side — the client never sums money.
 *
 * A COMPOSITE STATEMENT RESOURCE, not a paginated list: donation rows plus
 * aggregate blocks keyed by refs (the `/section321/grants/{grant_id}` detail
 * response is the in-repo precedent for the shape). It therefore carries no
 * `{data, meta, links}` envelope and takes no pagination/sort/filter query
 * parameters — group-by, sort, search and filter are client-side lenses over
 * ONE payload, and group subtotals deliberately never recompute under a filter.
 *
 * Donor name/email appear ONLY behind the existing §321(a)(6) conjunction
 * (§318-qualifying Terms acceptance AND the leg's own `share_with_charities`
 * AND the minor-protection backstop) — never a third path; the opaque
 * `donor_ref` grouping key rides the same conjunction so a gated read leaks no
 * linkage either. scoped to the caller's
 * membership. `consent_available` is that conjunction's organization half, as
 * this read resolved it (CPA-BE84). Deliberately NOT gated on the
 * fundraiser-attribution flag: the grant -> donations levels must work
 * regardless, and that flag instead conditions whether an opted-in fundraiser
 * may be NAMED here.
 *
 * Private, non-cacheable: this body carries donor names and emails, and it is a
 * NEW PII-bearing route — the header is set here at its creation rather than
 * inherited from the JSON siblings' (older, unheadered) posture.
 */
export const charityAdminGetSection321StatementOptions = (options: Options<CharityAdminGetSection321StatementData>) => queryOptions<CharityAdminGetSection321StatementResponse, CharityAdminGetSection321StatementError, CharityAdminGetSection321StatementResponse, ReturnType<typeof charityAdminGetSection321StatementQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetSection321Statement({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetSection321StatementQueryKey(options)
});

export const charityAdminExportSection321StatementWorkbookQueryKey = (options: Options<CharityAdminExportSection321StatementWorkbookData>) => createQueryKey('charity-admin-export_section321_statement_workbook', options);

/**
 * Export Section321 Statement Workbook
 *
 * CPA-BE15 — THE Grants & donations download for THIS charity: one `.xlsx`
 * with four sheets (Summary · Grants · Donations · Donors), replacing the two
 * CSVs a charity had to download separately and join on a UUID by hand.
 *
 * A BINARY DOWNLOAD, not a list endpoint: it declares its media type explicitly
 * and carries no `{data, meta, links}` envelope, because there is no JSON body to
 * envelope. The canonical-envelope rule governs JSON list responses; this route's
 * response schema is `{type: string, format: binary}`, the same shape the two
 * sibling CSV exports declare.
 *
 * Built from the same unified statement read the screen uses, but **whole-history
 * always** — never the screen's recent-N window. Every sheet's money ties to the
 * ledger to the penny and to the dashboard tiles above the table.
 *
 * Donor name/email appear ONLY behind the existing §321(a)(6) conjunction, and
 * with the gate closed the Donors sheet carries its header plus the same
 * server-authored explanation the screen shows — never a silently empty tab.
 *
 * The filename's date is the generation date **in UTC** — the same instant, and
 * the same zone choice, as the Summary sheet's "Generated on" cell (which names
 * its zone explicitly) and as the grant label BE14 already composes. So a
 * US-Pacific charity downloading at 6pm on Aug 20 gets an Aug 21 filename; the
 * artifact is internally consistent, and the alternative — a server composing a
 * date in an unstated zone — is the thing this surface has ruled out everywhere
 * else.
 *
 * Private, non-cacheable: this body carries donor names and emails. scoped to the caller's membership.
 */
export const charityAdminExportSection321StatementWorkbookOptions = (options: Options<CharityAdminExportSection321StatementWorkbookData>) => queryOptions<CharityAdminExportSection321StatementWorkbookResponse, CharityAdminExportSection321StatementWorkbookError, CharityAdminExportSection321StatementWorkbookResponse, ReturnType<typeof charityAdminExportSection321StatementWorkbookQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminExportSection321StatementWorkbook({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminExportSection321StatementWorkbookQueryKey(options)
});

export const charityAdminGetCharityTermsQueryKey = (options: Options<CharityAdminGetCharityTermsData>) => createQueryKey('charity-admin-get_charity_terms', options);

/**
 * Get Charity Terms
 *
 * The CURRENT effective Charity Terms for THIS charity: the canonical body
 * with the org's legal name / EIN / registered domain substituted, plus the
 * ``version_number`` + CANONICAL (pre-substitution) ``content_hash`` the client
 * must echo back on acceptance. Owner or Member (``charity:read``). 404 when no effective version exists.
 */
export const charityAdminGetCharityTermsOptions = (options: Options<CharityAdminGetCharityTermsData>) => queryOptions<CharityAdminGetCharityTermsResponse, CharityAdminGetCharityTermsError, CharityAdminGetCharityTermsResponse, ReturnType<typeof charityAdminGetCharityTermsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCharityTerms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCharityTermsQueryKey(options)
});

export const charityAdminGetCharityTermsAcceptanceStateQueryKey = (options: Options<CharityAdminGetCharityTermsAcceptanceStateData>) => createQueryKey('charity-admin-get_charity_terms_acceptance_state', options);

/**
 * Get Charity Terms Acceptance State
 *
 * Whether THIS organization has an operative acceptance of the CURRENT
 * effective Charity Terms (CPA-UIX1 / UIX-02) — the read the portal dashboard's
 * "Terms" onboarding step needs, and the GET counterpart of the POST below.
 * Distinguishes never-accepted / accepted-an-older-version / accepted-the-
 * current-version. ``accepted`` is the §318 seam's own verdict
 * (``is_section_318_consent``), never a bare overlay-status comparison. Owner or
 * Member (``charity:read``) — a Member sees the state even though only an Owner
 * can act on it. Version metadata and timestamps only: never the accepting
 * representative's identity. 404 when no effective version exists.
 */
export const charityAdminGetCharityTermsAcceptanceStateOptions = (options: Options<CharityAdminGetCharityTermsAcceptanceStateData>) => queryOptions<CharityAdminGetCharityTermsAcceptanceStateResponse, CharityAdminGetCharityTermsAcceptanceStateError, CharityAdminGetCharityTermsAcceptanceStateResponse, ReturnType<typeof charityAdminGetCharityTermsAcceptanceStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminGetCharityTermsAcceptanceState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminGetCharityTermsAcceptanceStateQueryKey(options)
});

/**
 * Accept Charity Terms
 *
 * Accept the Charity Terms on the organization's behalf (**OWNER-only**,
 * ``charity_terms:accept`` — acceptance binds the org contractually). The body
 * ECHOES the ``version_number`` + ``content_hash`` the client displayed; a
 * mismatch against the current effective version is a 409 (re-fetch and
 * re-present — never accept-anyway). On success the acceptance record + the
 * CONSENTED overlay write + the claim-trail audit event commit atomically;
 * re-accepting the same version is idempotent (appends another record).
 */
export const charityAdminAcceptCharityTermsMutation = (options?: Partial<Options<CharityAdminAcceptCharityTermsData>>): UseMutationOptions<CharityAdminAcceptCharityTermsResponse, CharityAdminAcceptCharityTermsError, Options<CharityAdminAcceptCharityTermsData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminAcceptCharityTermsResponse, CharityAdminAcceptCharityTermsError, Options<CharityAdminAcceptCharityTermsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminAcceptCharityTerms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminListMyCharityClaimsQueryKey = (options?: Options<CharityAdminListMyCharityClaimsData>) => createQueryKey('charity-admin-list_my_charity_claims', options);

/**
 * List My Charity Claims
 *
 * The calling user's own claim requests (newest first). Self-scoped — a
 * caller can only ever see their own claims.
 */
export const charityAdminListMyCharityClaimsOptions = (options?: Options<CharityAdminListMyCharityClaimsData>) => queryOptions<CharityAdminListMyCharityClaimsResponse, DefaultError, CharityAdminListMyCharityClaimsResponse, ReturnType<typeof charityAdminListMyCharityClaimsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListMyCharityClaims({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListMyCharityClaimsQueryKey(options)
});

export const charityAdminListMyVerificationDocumentsQueryKey = (options: Options<CharityAdminListMyVerificationDocumentsData>) => createQueryKey('charity-admin-list_my_verification_documents', options);

/**
 * List My Verification Documents
 *
 * The verification documents on the CALLER'S OWN claim (identity + type +
 * status only — never a read URL or the raw object key; the sensitive bytes are
 * super-admin-review-only). Self-scoped.
 */
export const charityAdminListMyVerificationDocumentsOptions = (options: Options<CharityAdminListMyVerificationDocumentsData>) => queryOptions<CharityAdminListMyVerificationDocumentsResponse, CharityAdminListMyVerificationDocumentsError, CharityAdminListMyVerificationDocumentsResponse, ReturnType<typeof charityAdminListMyVerificationDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListMyVerificationDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListMyVerificationDocumentsQueryKey(options)
});

/**
 * Confirm Verification Upload
 *
 * Confirm a completed upload → record the ``charity_verification_document``
 * row + audit. Self-scoped. The service verifies the object exists in the
 * restricted bucket before recording (no dangling evidence ref).
 */
export const charityAdminConfirmVerificationUploadMutation = (options?: Partial<Options<CharityAdminConfirmVerificationUploadData>>): UseMutationOptions<CharityAdminConfirmVerificationUploadResponse, CharityAdminConfirmVerificationUploadError, Options<CharityAdminConfirmVerificationUploadData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminConfirmVerificationUploadResponse, CharityAdminConfirmVerificationUploadError, Options<CharityAdminConfirmVerificationUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminConfirmVerificationUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request Verification Upload Url
 *
 * Issue a short-lived signed UPLOAD URL for a Tier-2 verification document on
 * the CALLER'S OWN ``PENDING_REVIEW`` claim. Self-scoped: the service 404s if
 * the claim is not the caller's, so a user can never attach evidence to another
 * claim. The document bytes go straight to the RESTRICTED bucket via the signed
 * PUT — never through this backend.
 */
export const charityAdminRequestVerificationUploadUrlMutation = (options?: Partial<Options<CharityAdminRequestVerificationUploadUrlData>>): UseMutationOptions<CharityAdminRequestVerificationUploadUrlResponse, CharityAdminRequestVerificationUploadUrlError, Options<CharityAdminRequestVerificationUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminRequestVerificationUploadUrlResponse, CharityAdminRequestVerificationUploadUrlError, Options<CharityAdminRequestVerificationUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminRequestVerificationUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceArtifactsQueryKey = (options: Options<CharityComplianceListComplianceArtifactsData>) => createQueryKey('charity-compliance-list_compliance_artifacts', options);

/**
 * List Compliance Artifacts
 *
 * The documents your organization has recorded, most recent first.
 *
 * `attached_at` is set once a document has been recorded as the confirmation on a
 * filing or against an imported registration. From that point it is part of your
 * organization's filing record and stays there — it cannot be removed, and that does
 * not change if the filing it backed is later withdrawn.
 */
export const charityComplianceListComplianceArtifactsOptions = (options: Options<CharityComplianceListComplianceArtifactsData>) => queryOptions<CharityComplianceListComplianceArtifactsResponse, CharityComplianceListComplianceArtifactsError, CharityComplianceListComplianceArtifactsResponse, ReturnType<typeof charityComplianceListComplianceArtifactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceArtifacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceArtifactsQueryKey(options)
});

/**
 * Confirm Compliance Artifact
 *
 * Confirm an upload finished, recording the document in your organization's records.
 *
 * The document has to actually be there: a reference to an upload that did not finish
 * is refused and nothing is recorded. That is what lets the id this returns be used as
 * the confirmation on a filing record — the register never points at a document that
 * is not in your records.
 *
 * A document is recorded once and is never edited afterwards. Uploading a corrected
 * version records a separate document rather than changing this one.
 */
export const charityComplianceConfirmComplianceArtifactMutation = (options?: Partial<Options<CharityComplianceConfirmComplianceArtifactData>>): UseMutationOptions<CharityComplianceConfirmComplianceArtifactResponse, CharityComplianceConfirmComplianceArtifactError, Options<CharityComplianceConfirmComplianceArtifactData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceConfirmComplianceArtifactResponse, CharityComplianceConfirmComplianceArtifactError, Options<CharityComplianceConfirmComplianceArtifactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceConfirmComplianceArtifact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Issue Compliance Artifact Upload Url
 *
 * Get a short-lived link for uploading one document.
 *
 * Upload the file straight to the returned link with a PUT, using exactly the content
 * type you declared here, then confirm it with the object reference this returns.
 * Nothing is recorded until you confirm — the document is not in your records until
 * the upload has finished and you say so.
 *
 * PDFs, Word files and images only. A macro-enabled Word file (.docm) is stored as a
 * .docx with its macros removed; a Word file is always downloaded, never shown inline.
 */
export const charityComplianceIssueComplianceArtifactUploadUrlMutation = (options?: Partial<Options<CharityComplianceIssueComplianceArtifactUploadUrlData>>): UseMutationOptions<CharityComplianceIssueComplianceArtifactUploadUrlResponse, CharityComplianceIssueComplianceArtifactUploadUrlError, Options<CharityComplianceIssueComplianceArtifactUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceIssueComplianceArtifactUploadUrlResponse, CharityComplianceIssueComplianceArtifactUploadUrlError, Options<CharityComplianceIssueComplianceArtifactUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceIssueComplianceArtifactUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Compliance Artifact
 *
 * Remove a document your organization has not recorded against anything yet.
 *
 * A document that has been recorded as the confirmation on a filing, or against an
 * imported registration, is part of your organization's filing record and cannot be
 * removed. That stays true afterwards: withdrawing the filing, dismissing the
 * obligation, or recording a later submission does not make the document removable
 * again, because the record of what was filed still refers to it.
 */
export const charityComplianceDeleteComplianceArtifactMutation = (options?: Partial<Options<CharityComplianceDeleteComplianceArtifactData>>): UseMutationOptions<CharityComplianceDeleteComplianceArtifactResponse, CharityComplianceDeleteComplianceArtifactError, Options<CharityComplianceDeleteComplianceArtifactData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceDeleteComplianceArtifactResponse, CharityComplianceDeleteComplianceArtifactError, Options<CharityComplianceDeleteComplianceArtifactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceDeleteComplianceArtifact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceArtifactDownloadQueryKey = (options: Options<CharityComplianceGetComplianceArtifactDownloadData>) => createQueryKey('charity-compliance-get_compliance_artifact_download', options);

/**
 * Get Compliance Artifact Download
 *
 * A short-lived link for downloading one document.
 *
 * Minted for this request and not stored anywhere: fetch a new one each time rather
 * than keeping the link.
 */
export const charityComplianceGetComplianceArtifactDownloadOptions = (options: Options<CharityComplianceGetComplianceArtifactDownloadData>) => queryOptions<CharityComplianceGetComplianceArtifactDownloadResponse, CharityComplianceGetComplianceArtifactDownloadError, CharityComplianceGetComplianceArtifactDownloadResponse, ReturnType<typeof charityComplianceGetComplianceArtifactDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceArtifactDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceArtifactDownloadQueryKey(options)
});

export const charityComplianceListComplianceCandidatesQueryKey = (options: Options<CharityComplianceListComplianceCandidatesData>) => createQueryKey('charity-compliance-list_compliance_candidates', options);

/**
 * List Compliance Candidates
 *
 * Candidate obligations awaiting the organization's review.
 *
 * Each row carries the jurisdiction's rule, its citation and source date, and the
 * parameters the organization recorded — review each with your counsel. A source date
 * is the day the official source was checked live where `rule_source_date_basis` is
 * `checked_live`, and the day Givmo's research notes recorded the rule where it is
 * `research_notes`. Candidates resting on the nationwide-or-online answer are marked.
 */
export const charityComplianceListComplianceCandidatesOptions = (options: Options<CharityComplianceListComplianceCandidatesData>) => queryOptions<CharityComplianceListComplianceCandidatesResponse, CharityComplianceListComplianceCandidatesError, CharityComplianceListComplianceCandidatesResponse, ReturnType<typeof charityComplianceListComplianceCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceCandidatesQueryKey(options)
});

/**
 * Confirm Compliance Candidate
 *
 * Confirm ONE candidate into the organization's register.
 *
 * This route takes exactly one candidate. Confirmation pins the rule version reviewed,
 * and a later change to that rule is flagged for re-review rather than applied.
 */
export const charityComplianceConfirmComplianceCandidateMutation = (options?: Partial<Options<CharityComplianceConfirmComplianceCandidateData>>): UseMutationOptions<CharityComplianceConfirmComplianceCandidateResponse, CharityComplianceConfirmComplianceCandidateError, Options<CharityComplianceConfirmComplianceCandidateData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceConfirmComplianceCandidateResponse, CharityComplianceConfirmComplianceCandidateError, Options<CharityComplianceConfirmComplianceCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceConfirmComplianceCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss Compliance Candidate
 *
 * Dismiss ONE candidate, with the organization's reason.
 *
 * The mirror of confirmation — one candidate, the same shape, the same cost. A
 * dismissed candidate returns only if the recorded facts behind it change.
 */
export const charityComplianceDismissComplianceCandidateMutation = (options?: Partial<Options<CharityComplianceDismissComplianceCandidateData>>): UseMutationOptions<CharityComplianceDismissComplianceCandidateResponse, CharityComplianceDismissComplianceCandidateError, Options<CharityComplianceDismissComplianceCandidateData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceDismissComplianceCandidateResponse, CharityComplianceDismissComplianceCandidateError, Options<CharityComplianceDismissComplianceCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceDismissComplianceCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Run Compliance Derivation
 *
 * Re-derive candidate obligations from the organization's recorded profile.
 *
 * Each candidate pairs one jurisdiction's transcribed rule — with its citation and
 * source date — against the parameters the organization recorded. A candidate is not
 * a determination that the organization is required to register or is eligible for an
 * exemption in any state, and nothing becomes a deadline or a calendar entry until
 * someone at the organization confirms it.
 *
 * Candidates derived from the nationwide-or-online answer are marked and returned
 * first: whether an online presence alone amounts to soliciting in a particular state
 * is treated differently by different states and is not settled, so those are the ones
 * to review with counsel first.
 *
 * Idempotent — an open candidate stays open, a confirmed obligation is untouched, and
 * a dismissal stands unless the recorded facts behind it changed.
 */
export const charityComplianceRunComplianceDerivationMutation = (options?: Partial<Options<CharityComplianceRunComplianceDerivationData>>): UseMutationOptions<CharityComplianceRunComplianceDerivationResponse, CharityComplianceRunComplianceDerivationError, Options<CharityComplianceRunComplianceDerivationData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRunComplianceDerivationResponse, CharityComplianceRunComplianceDerivationError, Options<CharityComplianceRunComplianceDerivationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRunComplianceDerivation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceDeskAuthorizationQueryKey = (options: Options<CharityComplianceGetComplianceDeskAuthorizationData>) => createQueryKey('charity-compliance-get_compliance_desk_authorization', options);

/**
 * Get Compliance Desk Authorization
 */
export const charityComplianceGetComplianceDeskAuthorizationOptions = (options: Options<CharityComplianceGetComplianceDeskAuthorizationData>) => queryOptions<CharityComplianceGetComplianceDeskAuthorizationResponse, CharityComplianceGetComplianceDeskAuthorizationError, CharityComplianceGetComplianceDeskAuthorizationResponse, ReturnType<typeof charityComplianceGetComplianceDeskAuthorizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceDeskAuthorization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceDeskAuthorizationQueryKey(options)
});

/**
 * Revoke Compliance Desk Authorization
 */
export const charityComplianceRevokeComplianceDeskAuthorizationMutation = (options?: Partial<Options<CharityComplianceRevokeComplianceDeskAuthorizationData>>): UseMutationOptions<CharityComplianceRevokeComplianceDeskAuthorizationResponse, CharityComplianceRevokeComplianceDeskAuthorizationError, Options<CharityComplianceRevokeComplianceDeskAuthorizationData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRevokeComplianceDeskAuthorizationResponse, CharityComplianceRevokeComplianceDeskAuthorizationError, Options<CharityComplianceRevokeComplianceDeskAuthorizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRevokeComplianceDeskAuthorization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceFilingCasesQueryKey = (options: Options<CharityComplianceListComplianceFilingCasesData>) => createQueryKey('charity-compliance-list_compliance_filing_cases', options);

/**
 * List Compliance Filing Cases
 *
 * The organization's filing cases, oldest first; with `obligation_id`, one filing's.
 *
 * A filing case is one filing the organization is preparing — a filing on its register, for
 * a year or licence period where the filing has them — and holds the documents the filing
 * is made of. Each case says how many documents it holds.
 */
export const charityComplianceListComplianceFilingCasesOptions = (options: Options<CharityComplianceListComplianceFilingCasesData>) => queryOptions<CharityComplianceListComplianceFilingCasesResponse, CharityComplianceListComplianceFilingCasesError, CharityComplianceListComplianceFilingCasesResponse, ReturnType<typeof charityComplianceListComplianceFilingCasesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceFilingCases({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceFilingCasesQueryKey(options)
});

export const charityComplianceGetComplianceFilingCaseQueryKey = (options: Options<CharityComplianceGetComplianceFilingCaseData>) => createQueryKey('charity-compliance-get_compliance_filing_case', options);

/**
 * Get Compliance Filing Case
 *
 * One filing case with the documents it holds, in the order they were added.
 *
 * Each document shows its latest version and who added it to the case, and when.
 */
export const charityComplianceGetComplianceFilingCaseOptions = (options: Options<CharityComplianceGetComplianceFilingCaseData>) => queryOptions<CharityComplianceGetComplianceFilingCaseResponse, CharityComplianceGetComplianceFilingCaseError, CharityComplianceGetComplianceFilingCaseResponse, ReturnType<typeof charityComplianceGetComplianceFilingCaseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceFilingCase({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceFilingCaseQueryKey(options)
});

export const charityComplianceGetComplianceFilingCaseChecklistQueryKey = (options: Options<CharityComplianceGetComplianceFilingCaseChecklistData>) => createQueryKey('charity-compliance-get_compliance_filing_case_checklist', options);

/**
 * Get Compliance Filing Case Checklist
 *
 * What goes with the filing: the rule's attachment list, item by item, with the
 * documents attached to each and whether the organization marked it not needed.
 */
export const charityComplianceGetComplianceFilingCaseChecklistOptions = (options: Options<CharityComplianceGetComplianceFilingCaseChecklistData>) => queryOptions<CharityComplianceGetComplianceFilingCaseChecklistResponse, CharityComplianceGetComplianceFilingCaseChecklistError, CharityComplianceGetComplianceFilingCaseChecklistResponse, ReturnType<typeof charityComplianceGetComplianceFilingCaseChecklistQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceFilingCaseChecklist({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceFilingCaseChecklistQueryKey(options)
});

/**
 * Record Compliance Checklist Act
 *
 * Remove a document from one checklist item, or mark the item not needed for this
 * filing, or needed after all. An act that changes nothing records nothing.
 */
export const charityComplianceRecordComplianceChecklistActMutation = (options?: Partial<Options<CharityComplianceRecordComplianceChecklistActData>>): UseMutationOptions<CharityComplianceRecordComplianceChecklistActResponse, CharityComplianceRecordComplianceChecklistActError, Options<CharityComplianceRecordComplianceChecklistActData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceChecklistActResponse, CharityComplianceRecordComplianceChecklistActError, Options<CharityComplianceRecordComplianceChecklistActData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceChecklistAct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attach Compliance Checklist Document
 *
 * Attach a PDF from the organization's documents to one checklist item.
 *
 * It goes with the filing as uploaded, never changed. Refused for a PDF protected with
 * encryption, and for anything but a PDF; the document stays in the organization's
 * documents as uploaded.
 */
export const charityComplianceAttachComplianceChecklistDocumentMutation = (options?: Partial<Options<CharityComplianceAttachComplianceChecklistDocumentData>>): UseMutationOptions<CharityComplianceAttachComplianceChecklistDocumentResponse, CharityComplianceAttachComplianceChecklistDocumentError, Options<CharityComplianceAttachComplianceChecklistDocumentData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAttachComplianceChecklistDocumentResponse, CharityComplianceAttachComplianceChecklistDocumentError, Options<CharityComplianceAttachComplianceChecklistDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAttachComplianceChecklistDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Hand Compliance Filing To Desk
 */
export const charityComplianceHandComplianceFilingToDeskMutation = (options?: Partial<Options<CharityComplianceHandComplianceFilingToDeskData>>): UseMutationOptions<CharityComplianceHandComplianceFilingToDeskResponse, CharityComplianceHandComplianceFilingToDeskError, Options<CharityComplianceHandComplianceFilingToDeskData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceHandComplianceFilingToDeskResponse, CharityComplianceHandComplianceFilingToDeskError, Options<CharityComplianceHandComplianceFilingToDeskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceHandComplianceFilingToDesk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Compliance Desk
 */
export const charityComplianceResumeComplianceDeskMutation = (options?: Partial<Options<CharityComplianceResumeComplianceDeskData>>): UseMutationOptions<CharityComplianceResumeComplianceDeskResponse, CharityComplianceResumeComplianceDeskError, Options<CharityComplianceResumeComplianceDeskData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceResumeComplianceDeskResponse, CharityComplianceResumeComplianceDeskError, Options<CharityComplianceResumeComplianceDeskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceResumeComplianceDesk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Take Compliance Filing From Desk
 */
export const charityComplianceTakeComplianceFilingFromDeskMutation = (options?: Partial<Options<CharityComplianceTakeComplianceFilingFromDeskData>>): UseMutationOptions<CharityComplianceTakeComplianceFilingFromDeskResponse, CharityComplianceTakeComplianceFilingFromDeskError, Options<CharityComplianceTakeComplianceFilingFromDeskData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceTakeComplianceFilingFromDeskResponse, CharityComplianceTakeComplianceFilingFromDeskError, Options<CharityComplianceTakeComplianceFilingFromDeskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceTakeComplianceFilingFromDesk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attach Compliance Filing Case Document
 *
 * Add one of the organization's filing documents to an open filing case.
 *
 * A document stays in the first case it is added to; adding it to the same case again
 * changes nothing. Refused, with nothing recorded, for a withdrawn case, or a document that
 * is already in another case. Answers with the case and its documents.
 */
export const charityComplianceAttachComplianceFilingCaseDocumentMutation = (options?: Partial<Options<CharityComplianceAttachComplianceFilingCaseDocumentData>>): UseMutationOptions<CharityComplianceAttachComplianceFilingCaseDocumentResponse, CharityComplianceAttachComplianceFilingCaseDocumentError, Options<CharityComplianceAttachComplianceFilingCaseDocumentData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAttachComplianceFilingCaseDocumentResponse, CharityComplianceAttachComplianceFilingCaseDocumentError, Options<CharityComplianceAttachComplianceFilingCaseDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAttachComplianceFilingCaseDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceFormPreparationsQueryKey = (options: Options<CharityComplianceListComplianceFormPreparationsData>) => createQueryKey('charity-compliance-list_compliance_form_preparations', options);

/**
 * List Compliance Form Preparations
 *
 * A filing case's form preparations, oldest first.
 *
 * Each names its preparation, the form document and the form it started on, and who started
 * it and when. Starting a preparation is its own request; the preparation read says what the
 * form says.
 */
export const charityComplianceListComplianceFormPreparationsOptions = (options: Options<CharityComplianceListComplianceFormPreparationsData>) => queryOptions<CharityComplianceListComplianceFormPreparationsResponse, CharityComplianceListComplianceFormPreparationsError, CharityComplianceListComplianceFormPreparationsResponse, ReturnType<typeof charityComplianceListComplianceFormPreparationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceFormPreparations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceFormPreparationsQueryKey(options)
});

/**
 * Start Compliance Form Preparation
 *
 * Start preparing the form of a filing case's filing.
 *
 * Adds the form to the case as a filing document and answers the preparation: every item of
 * the form, filled from the organization's records where they hold the answer. When the
 * case's form is already being prepared, answers that preparation.
 */
export const charityComplianceStartComplianceFormPreparationMutation = (options?: Partial<Options<CharityComplianceStartComplianceFormPreparationData>>): UseMutationOptions<CharityComplianceStartComplianceFormPreparationResponse, CharityComplianceStartComplianceFormPreparationError, Options<CharityComplianceStartComplianceFormPreparationData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceStartComplianceFormPreparationResponse, CharityComplianceStartComplianceFormPreparationError, Options<CharityComplianceStartComplianceFormPreparationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceStartComplianceFormPreparation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceSubmissionQueryKey = (options: Options<CharityComplianceGetComplianceSubmissionData>) => createQueryKey('charity-compliance-get_compliance_submission', options);

/**
 * Get Compliance Submission
 *
 * A filing case's submission: whether Givmo can email it and, if not, why.
 *
 * The files exactly as they would go and the SHA-256 that binds them, the email's subject
 * and body, the agency's address, the fee as the form states it, the signed forms'
 * request, the addresses the agency's replies can go to, who the email actually goes to,
 * the latest authorization and every send. Reading it sends nothing.
 */
export const charityComplianceGetComplianceSubmissionOptions = (options: Options<CharityComplianceGetComplianceSubmissionData>) => queryOptions<CharityComplianceGetComplianceSubmissionResponse, CharityComplianceGetComplianceSubmissionError, CharityComplianceGetComplianceSubmissionResponse, ReturnType<typeof charityComplianceGetComplianceSubmissionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceSubmission({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceSubmissionQueryKey(options)
});

/**
 * Authorize Compliance Submission
 *
 * Authorize Givmo to send this filing exactly as you reviewed it.
 *
 * For a Compliance Owner or a Global Admin, at your organization's sign-in check. The
 * authorization binds the files, the email, the agency's address, the reply contact and the
 * fee statement, and sends nothing by itself. Refused when anything differs from what you
 * were shown, and while another package is authorized.
 */
export const charityComplianceAuthorizeComplianceSubmissionMutation = (options?: Partial<Options<CharityComplianceAuthorizeComplianceSubmissionData>>): UseMutationOptions<CharityComplianceAuthorizeComplianceSubmissionResponse, CharityComplianceAuthorizeComplianceSubmissionError, Options<CharityComplianceAuthorizeComplianceSubmissionData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAuthorizeComplianceSubmissionResponse, CharityComplianceAuthorizeComplianceSubmissionError, Options<CharityComplianceAuthorizeComplianceSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAuthorizeComplianceSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Submission Evidence
 *
 * Record the agency's answer about a send of this filing, as your organization's record.
 *
 * That it acknowledged the filing, rejected it or asked for changes, and the day it did: from
 * its own message, attached, or from your organization's own account. It's labelled as
 * recorded by you, and it doesn't record the filing as accepted: attaching the confirmation
 * does that. Refused for a send nothing shows went out, and for a date before it was sent or
 * after today.
 */
export const charityComplianceRecordComplianceSubmissionEvidenceMutation = (options?: Partial<Options<CharityComplianceRecordComplianceSubmissionEvidenceData>>): UseMutationOptions<CharityComplianceRecordComplianceSubmissionEvidenceResponse, CharityComplianceRecordComplianceSubmissionEvidenceError, Options<CharityComplianceRecordComplianceSubmissionEvidenceData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceSubmissionEvidenceResponse, CharityComplianceRecordComplianceSubmissionEvidenceError, Options<CharityComplianceRecordComplianceSubmissionEvidenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceSubmissionEvidence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Answer Compliance Submission Evidence
 *
 * Say a record about a send of this filing is wrong.
 *
 * The email service's report about the agency's address, or a record someone in your
 * organization made: say what you found. The record stays, shown with what you said, and
 * nothing counts it any more. For a Compliance Owner or a Global Admin, in Givmo.
 */
export const charityComplianceAnswerComplianceSubmissionEvidenceMutation = (options?: Partial<Options<CharityComplianceAnswerComplianceSubmissionEvidenceData>>): UseMutationOptions<CharityComplianceAnswerComplianceSubmissionEvidenceResponse, CharityComplianceAnswerComplianceSubmissionEvidenceError, Options<CharityComplianceAnswerComplianceSubmissionEvidenceData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAnswerComplianceSubmissionEvidenceResponse, CharityComplianceAnswerComplianceSubmissionEvidenceError, Options<CharityComplianceAnswerComplianceSubmissionEvidenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAnswerComplianceSubmissionEvidence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Submission Handoff
 *
 * Record what your organization sent itself, as its own act.
 *
 * The way it went (one the agency's sources record for this filing) and the date; and what:
 * the package, named by the SHA-256 this filing's submission read served, or one of your
 * organization's documents. A proof of sending is optional. Givmo sends nothing, and the
 * record doesn't show that the agency received it. Refused for a package already recorded
 * or already sent by Givmo, or while Givmo's own send of it is in progress or uncertain.
 */
export const charityComplianceRecordComplianceSubmissionHandoffMutation = (options?: Partial<Options<CharityComplianceRecordComplianceSubmissionHandoffData>>): UseMutationOptions<CharityComplianceRecordComplianceSubmissionHandoffResponse, CharityComplianceRecordComplianceSubmissionHandoffError, Options<CharityComplianceRecordComplianceSubmissionHandoffData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceSubmissionHandoffResponse, CharityComplianceRecordComplianceSubmissionHandoffError, Options<CharityComplianceRecordComplianceSubmissionHandoffData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceSubmissionHandoff({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceSubmissionPackageQueryKey = (options: Options<CharityComplianceGetComplianceSubmissionPackageData>) => createQueryKey('charity-compliance-get_compliance_submission_package', options);

/**
 * Get Compliance Submission Package
 *
 * The package as one zip: a short-lived link to exactly its files.
 *
 * The files keep the names the email gives them, and nothing else goes in. Name the package
 * by the SHA-256 its submission read served: the one the case holds now, or one an
 * authorization bound. Each file is matched to its SHA-256 first, and each one's reading is
 * recorded. Downloading it sends nothing.
 */
export const charityComplianceGetComplianceSubmissionPackageOptions = (options: Options<CharityComplianceGetComplianceSubmissionPackageData>) => queryOptions<CharityComplianceGetComplianceSubmissionPackageResponse, CharityComplianceGetComplianceSubmissionPackageError, CharityComplianceGetComplianceSubmissionPackageResponse, ReturnType<typeof charityComplianceGetComplianceSubmissionPackageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceSubmissionPackage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceSubmissionPackageQueryKey(options)
});

/**
 * Withdraw Compliance Filing Case
 *
 * Withdraw a filing case: the organization stops preparing this filing in it.
 *
 * The case keeps its documents and takes no new one, and a new case can be opened for the
 * same filing. Withdrawing a case already withdrawn changes nothing. Answers with the case
 * and its documents.
 */
export const charityComplianceWithdrawComplianceFilingCaseMutation = (options?: Partial<Options<CharityComplianceWithdrawComplianceFilingCaseData>>): UseMutationOptions<CharityComplianceWithdrawComplianceFilingCaseResponse, CharityComplianceWithdrawComplianceFilingCaseError, Options<CharityComplianceWithdrawComplianceFilingCaseData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceWithdrawComplianceFilingCaseResponse, CharityComplianceWithdrawComplianceFilingCaseError, Options<CharityComplianceWithdrawComplianceFilingCaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceWithdrawComplianceFilingCase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceFilingDocumentsQueryKey = (options: Options<CharityComplianceListComplianceFilingDocumentsData>) => createQueryKey('charity-compliance-list_compliance_filing_documents', options);

/**
 * List Compliance Filing Documents
 *
 * The organization's filing documents, oldest first, each with its latest version.
 *
 * A filing document is a PDF the organization's filings use, kept as versions that never
 * change: the PDF as it was uploaded, and the copy Givmo prepared from it.
 */
export const charityComplianceListComplianceFilingDocumentsOptions = (options: Options<CharityComplianceListComplianceFilingDocumentsData>) => queryOptions<CharityComplianceListComplianceFilingDocumentsResponse, CharityComplianceListComplianceFilingDocumentsError, CharityComplianceListComplianceFilingDocumentsResponse, ReturnType<typeof charityComplianceListComplianceFilingDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceFilingDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceFilingDocumentsQueryKey(options)
});

/**
 * Create Compliance Filing Document
 *
 * Start a filing document, with the organization's title for it.
 *
 * It has no version until an uploaded PDF is recorded as one.
 */
export const charityComplianceCreateComplianceFilingDocumentMutation = (options?: Partial<Options<CharityComplianceCreateComplianceFilingDocumentData>>): UseMutationOptions<CharityComplianceCreateComplianceFilingDocumentResponse, CharityComplianceCreateComplianceFilingDocumentError, Options<CharityComplianceCreateComplianceFilingDocumentData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceCreateComplianceFilingDocumentResponse, CharityComplianceCreateComplianceFilingDocumentError, Options<CharityComplianceCreateComplianceFilingDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceCreateComplianceFilingDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceFilingDocumentQueryKey = (options: Options<CharityComplianceGetComplianceFilingDocumentData>) => createQueryKey('charity-compliance-get_compliance_filing_document', options);

/**
 * Get Compliance Filing Document
 *
 * One filing document with every version, oldest first.
 *
 * Each version is named by the SHA-256 of its exact bytes. A version Givmo prepared begins
 * with the exact bytes of what it was made from: the version it was prepared from, which it
 * names, or, for a form Givmo fills, the agency's official template.
 */
export const charityComplianceGetComplianceFilingDocumentOptions = (options: Options<CharityComplianceGetComplianceFilingDocumentData>) => queryOptions<CharityComplianceGetComplianceFilingDocumentResponse, CharityComplianceGetComplianceFilingDocumentError, CharityComplianceGetComplianceFilingDocumentResponse, ReturnType<typeof charityComplianceGetComplianceFilingDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceFilingDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceFilingDocumentQueryKey(options)
});

/**
 * Register Compliance Filing Document Version
 *
 * Record an uploaded PDF as the document's next version.
 *
 * The PDF is one the organization already uploaded to its documents. Givmo reads its
 * exact bytes and records the version under their SHA-256; from then on the uploaded
 * document stays in the organization's records. When the PDF carries filled form fields,
 * or text and drawings added with a PDF app's tools, Givmo also records a copy that draws
 * each one's saved appearance into the page, as the version after: the upload is an exact
 * byte prefix of that copy.
 *
 * Refused, with nothing recorded, for a PDF protected with encryption (a restrictions-only
 * password included), a filled field or an added drawing with no saved appearance,
 * comments or other added content Givmo can't make part of the page, a dynamic form, or a
 * PDF Givmo can't read. Recording the same PDF again changes nothing. Answers with the
 * document and every version.
 */
export const charityComplianceRegisterComplianceFilingDocumentVersionMutation = (options?: Partial<Options<CharityComplianceRegisterComplianceFilingDocumentVersionData>>): UseMutationOptions<CharityComplianceRegisterComplianceFilingDocumentVersionResponse, CharityComplianceRegisterComplianceFilingDocumentVersionError, Options<CharityComplianceRegisterComplianceFilingDocumentVersionData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRegisterComplianceFilingDocumentVersionResponse, CharityComplianceRegisterComplianceFilingDocumentVersionError, Options<CharityComplianceRegisterComplianceFilingDocumentVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRegisterComplianceFilingDocumentVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceFilingDocumentVersionDownloadQueryKey = (options: Options<CharityComplianceGetComplianceFilingDocumentVersionDownloadData>) => createQueryKey('charity-compliance-get_compliance_filing_document_version_download', options);

/**
 * Get Compliance Filing Document Version Download
 *
 * A short-lived link to one version's exact bytes.
 *
 * The link names those exact bytes, whatever else is uploaded later. Each download link
 * Givmo issues is recorded: who asked, when, and the SHA-256 of the bytes it names. The
 * record is not an approval of anything. Fetch a new link each time rather than keeping
 * one.
 */
export const charityComplianceGetComplianceFilingDocumentVersionDownloadOptions = (options: Options<CharityComplianceGetComplianceFilingDocumentVersionDownloadData>) => queryOptions<CharityComplianceGetComplianceFilingDocumentVersionDownloadResponse, CharityComplianceGetComplianceFilingDocumentVersionDownloadError, CharityComplianceGetComplianceFilingDocumentVersionDownloadResponse, ReturnType<typeof charityComplianceGetComplianceFilingDocumentVersionDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceFilingDocumentVersionDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceFilingDocumentVersionDownloadQueryKey(options)
});

/**
 * Record Compliance Executed Copy
 *
 * Record the organization's upload of this version as it was signed outside Givmo, with who
 * signed it, in what capacity and when, as the organization states. This isn't a Givmo
 * signature, and Givmo doesn't check the signatures or that the copy matches this version. Only
 * a form Givmo prepared takes one, and not while it is out for signature or once it was signed
 * in Givmo; a PDF that is already a version of the form is refused. The same copy again changes
 * nothing; a different copy is recorded beside the first, and the newer one stands.
 */
export const charityComplianceRecordComplianceExecutedCopyMutation = (options?: Partial<Options<CharityComplianceRecordComplianceExecutedCopyData>>): UseMutationOptions<CharityComplianceRecordComplianceExecutedCopyResponse, CharityComplianceRecordComplianceExecutedCopyError, Options<CharityComplianceRecordComplianceExecutedCopyData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceExecutedCopyResponse, CharityComplianceRecordComplianceExecutedCopyError, Options<CharityComplianceRecordComplianceExecutedCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceExecutedCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceFilingDocumentVersionRenditionQueryKey = (options: Options<CharityComplianceGetComplianceFilingDocumentVersionRenditionData>) => createQueryKey('charity-compliance-get_compliance_filing_document_version_rendition', options);

/**
 * Get Compliance Filing Document Version Rendition
 *
 * What one version looks like, page by page.
 *
 * Each page was drawn once, with its form fields shown as a form-aware viewer shows
 * them, when the version was recorded; viewing draws nothing new. Each page is a
 * short-lived link to its image.
 */
export const charityComplianceGetComplianceFilingDocumentVersionRenditionOptions = (options: Options<CharityComplianceGetComplianceFilingDocumentVersionRenditionData>) => queryOptions<CharityComplianceGetComplianceFilingDocumentVersionRenditionResponse, CharityComplianceGetComplianceFilingDocumentVersionRenditionError, CharityComplianceGetComplianceFilingDocumentVersionRenditionResponse, ReturnType<typeof charityComplianceGetComplianceFilingDocumentVersionRenditionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceFilingDocumentVersionRendition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceFilingDocumentVersionRenditionQueryKey(options)
});

export const charityComplianceGetComplianceFilingDocumentSigningPlacesQueryKey = (options: Options<CharityComplianceGetComplianceFilingDocumentSigningPlacesData>) => createQueryKey('charity-compliance-get_compliance_filing_document_signing_places', options);

/**
 * Get Compliance Filing Document Signing Places
 *
 * What the person sending a filing document out for signature needs before they send it:
 * the document's filing case, the form Givmo matched this version to among that filing's
 * own forms, every signature place the form has (its page, where it is, and where the
 * printed name, the title and the date go), each page's draw scale, whether Givmo can sign
 * it for each way the filing is sent (with the line that says when the agency hasn't
 * confirmed it accepts e-signatures), and why sending it would be refused now, if it would.
 * Writes nothing.
 */
export const charityComplianceGetComplianceFilingDocumentSigningPlacesOptions = (options: Options<CharityComplianceGetComplianceFilingDocumentSigningPlacesData>) => queryOptions<CharityComplianceGetComplianceFilingDocumentSigningPlacesResponse, CharityComplianceGetComplianceFilingDocumentSigningPlacesError, CharityComplianceGetComplianceFilingDocumentSigningPlacesResponse, ReturnType<typeof charityComplianceGetComplianceFilingDocumentSigningPlacesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceFilingDocumentSigningPlaces({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceFilingDocumentSigningPlacesQueryKey(options)
});

export const charityComplianceListComplianceFilingGroupsQueryKey = (options: Options<CharityComplianceListComplianceFilingGroupsData>) => createQueryKey('charity-compliance-list_compliance_filing_groups', options);

/**
 * List Compliance Filing Groups
 *
 * The organization's filing groups, in its order, each with the filings moved into it.
 *
 * Filings group automatically by family (fundraising registrations, corporate filings
 * and so on); the organization can rename a family's group, reorder the groups, make
 * groups of its own and move a filing between them. Every member of the organization
 * sees the same groups. A filing not listed as a member of any group sits in its
 * family's group.
 */
export const charityComplianceListComplianceFilingGroupsOptions = (options: Options<CharityComplianceListComplianceFilingGroupsData>) => queryOptions<CharityComplianceListComplianceFilingGroupsResponse, CharityComplianceListComplianceFilingGroupsError, CharityComplianceListComplianceFilingGroupsResponse, ReturnType<typeof charityComplianceListComplianceFilingGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceFilingGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceFilingGroupsQueryKey(options)
});

/**
 * Create Compliance Filing Group
 *
 * Make a group, named by the organization, with the one filing that starts it.
 *
 * The new group goes last in the organization's order and the filing moves into it.
 * Answers with the new group.
 */
export const charityComplianceCreateComplianceFilingGroupMutation = (options?: Partial<Options<CharityComplianceCreateComplianceFilingGroupData>>): UseMutationOptions<CharityComplianceCreateComplianceFilingGroupResponse, CharityComplianceCreateComplianceFilingGroupError, Options<CharityComplianceCreateComplianceFilingGroupData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceCreateComplianceFilingGroupResponse, CharityComplianceCreateComplianceFilingGroupError, Options<CharityComplianceCreateComplianceFilingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceCreateComplianceFilingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Compliance Filing Group
 *
 * Remove a group the organization made. Its filings go back to their families' groups.
 *
 * A family's group is never removed; it leaves the page when it holds no filing.
 */
export const charityComplianceRemoveComplianceFilingGroupMutation = (options?: Partial<Options<CharityComplianceRemoveComplianceFilingGroupData>>): UseMutationOptions<CharityComplianceRemoveComplianceFilingGroupResponse, CharityComplianceRemoveComplianceFilingGroupError, Options<CharityComplianceRemoveComplianceFilingGroupData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRemoveComplianceFilingGroupResponse, CharityComplianceRemoveComplianceFilingGroupError, Options<CharityComplianceRemoveComplianceFilingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRemoveComplianceFilingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move Compliance Filing To Group
 *
 * Move one filing into this group.
 *
 * Moving a filing into its own family's group puts it back there. Answers with the
 * group the filing is now in.
 */
export const charityComplianceMoveComplianceFilingToGroupMutation = (options?: Partial<Options<CharityComplianceMoveComplianceFilingToGroupData>>): UseMutationOptions<CharityComplianceMoveComplianceFilingToGroupResponse, CharityComplianceMoveComplianceFilingToGroupError, Options<CharityComplianceMoveComplianceFilingToGroupData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceMoveComplianceFilingToGroupResponse, CharityComplianceMoveComplianceFilingToGroupError, Options<CharityComplianceMoveComplianceFilingToGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceMoveComplianceFilingToGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move Compliance Filing Group
 *
 * Move one group one place up or down among the groups the Filings page shows.
 *
 * A family's group holding no filing is not shown, so a move passes it. At the top or
 * the bottom the order stays as it is. Answers with the group at its new place.
 */
export const charityComplianceMoveComplianceFilingGroupMutation = (options?: Partial<Options<CharityComplianceMoveComplianceFilingGroupData>>): UseMutationOptions<CharityComplianceMoveComplianceFilingGroupResponse, CharityComplianceMoveComplianceFilingGroupError, Options<CharityComplianceMoveComplianceFilingGroupData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceMoveComplianceFilingGroupResponse, CharityComplianceMoveComplianceFilingGroupError, Options<CharityComplianceMoveComplianceFilingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceMoveComplianceFilingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rename Compliance Filing Group
 *
 * Rename one group.
 *
 * A family's group goes back to its family's own name when no name is given; a group
 * the organization made always has one. Answers with the group.
 */
export const charityComplianceRenameComplianceFilingGroupMutation = (options?: Partial<Options<CharityComplianceRenameComplianceFilingGroupData>>): UseMutationOptions<CharityComplianceRenameComplianceFilingGroupResponse, CharityComplianceRenameComplianceFilingGroupError, Options<CharityComplianceRenameComplianceFilingGroupData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRenameComplianceFilingGroupResponse, CharityComplianceRenameComplianceFilingGroupError, Options<CharityComplianceRenameComplianceFilingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRenameComplianceFilingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceFilingOptionsQueryKey = (options: Options<CharityComplianceListComplianceFilingOptionsData>) => createQueryKey('charity-compliance-list_compliance_filing_options', options);

/**
 * List Compliance Filing Options
 *
 * The filings Givmo's rules library offers for adding, one jurisdiction's or all.
 *
 * Each option is a jurisdiction's current rule with its citation and source date, and
 * how the Filings page presents it: its family (fundraising registrations, corporate
 * filings and so on), a short title and what the organization's own number is called.
 * Each option also carries, in `next_dates`, its next date for each deadline the rule
 * records, worked out from the organization's recorded facts with the rule's own deadline
 * entry as its basis, or the reason no date could be worked out; an entry whose dates have
 * all passed is left out. An option says what kind of filing a rule describes; it never
 * says the organization must make it. Ordered by jurisdiction, then as the library lists
 * that jurisdiction's filings.
 */
export const charityComplianceListComplianceFilingOptionsOptions = (options: Options<CharityComplianceListComplianceFilingOptionsData>) => queryOptions<CharityComplianceListComplianceFilingOptionsResponse, CharityComplianceListComplianceFilingOptionsError, CharityComplianceListComplianceFilingOptionsResponse, ReturnType<typeof charityComplianceListComplianceFilingOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceFilingOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceFilingOptionsQueryKey(options)
});

export const charityComplianceListComplianceFormAdaptersQueryKey = (options: Options<CharityComplianceListComplianceFormAdaptersData>) => createQueryKey('charity-compliance-list_compliance_form_adapters', options);

/**
 * List Compliance Form Adapters
 *
 * The agency forms Givmo prepares from their official templates.
 *
 * Each names the rule it is filed under, the form's own number, the template (where it was
 * taken from, when, and the SHA-256 of its exact bytes) and its pages.
 */
export const charityComplianceListComplianceFormAdaptersOptions = (options: Options<CharityComplianceListComplianceFormAdaptersData>) => queryOptions<CharityComplianceListComplianceFormAdaptersResponse, CharityComplianceListComplianceFormAdaptersError, CharityComplianceListComplianceFormAdaptersResponse, ReturnType<typeof charityComplianceListComplianceFormAdaptersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceFormAdapters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceFormAdaptersQueryKey(options)
});

export const charityComplianceGetComplianceFormPreparationQueryKey = (options: Options<CharityComplianceGetComplianceFormPreparationData>) => createQueryKey('charity-compliance-get_compliance_form_preparation', options);

/**
 * Get Compliance Form Preparation
 *
 * A form being prepared: every item in the form's order and own words, where it stands,
 * what goes on the form for it and where, and the records it comes from.
 *
 * ``values_sha256`` binds everything the form says; recording a version echoes it.
 */
export const charityComplianceGetComplianceFormPreparationOptions = (options: Options<CharityComplianceGetComplianceFormPreparationData>) => queryOptions<CharityComplianceGetComplianceFormPreparationResponse, CharityComplianceGetComplianceFormPreparationError, CharityComplianceGetComplianceFormPreparationResponse, ReturnType<typeof charityComplianceGetComplianceFormPreparationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceFormPreparation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceFormPreparationQueryKey(options)
});

/**
 * Answer Compliance Form Item
 *
 * The organization's answer to one item of the form.
 *
 * Recorded beside the earlier ones, with who gave it and when; the newest stands. An answer
 * that changes nothing records nothing. Refused for an answer the item does not take, a
 * character the form can't be printed with, or a value too long for the form's line, and
 * while the form is out for signature.
 */
export const charityComplianceAnswerComplianceFormItemMutation = (options?: Partial<Options<CharityComplianceAnswerComplianceFormItemData>>): UseMutationOptions<CharityComplianceAnswerComplianceFormItemResponse, CharityComplianceAnswerComplianceFormItemError, Options<CharityComplianceAnswerComplianceFormItemData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAnswerComplianceFormItemResponse, CharityComplianceAnswerComplianceFormItemError, Options<CharityComplianceAnswerComplianceFormItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAnswerComplianceFormItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceFormPagePreviewQueryKey = (options: Options<CharityComplianceGetComplianceFormPagePreviewData>) => createQueryKey('charity-compliance-get_compliance_form_page_preview', options);

/**
 * Get Compliance Form Page Preview
 *
 * One page of the form as it stands, drawn as a form-aware viewer shows it.
 *
 * Not a version: recording one is its own request.
 */
export const charityComplianceGetComplianceFormPagePreviewOptions = (options: Options<CharityComplianceGetComplianceFormPagePreviewData>) => queryOptions<CharityComplianceGetComplianceFormPagePreviewResponse, CharityComplianceGetComplianceFormPagePreviewError, CharityComplianceGetComplianceFormPagePreviewResponse, ReturnType<typeof charityComplianceGetComplianceFormPagePreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceFormPagePreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceFormPagePreviewQueryKey(options)
});

export const charityComplianceGetComplianceFormPagePreviewInfiniteQueryKey = (options: Options<CharityComplianceGetComplianceFormPagePreviewData>): QueryKey<Options<CharityComplianceGetComplianceFormPagePreviewData>> => createQueryKey('charity-compliance-get_compliance_form_page_preview', options, true);

/**
 * Get Compliance Form Page Preview
 *
 * One page of the form as it stands, drawn as a form-aware viewer shows it.
 *
 * Not a version: recording one is its own request.
 */
export const charityComplianceGetComplianceFormPagePreviewInfiniteOptions = (options: Options<CharityComplianceGetComplianceFormPagePreviewData>) => {
    const opts = infiniteQueryOptions<CharityComplianceGetComplianceFormPagePreviewResponse, CharityComplianceGetComplianceFormPagePreviewError, InfiniteData<CharityComplianceGetComplianceFormPagePreviewResponse>, QueryKey<Options<CharityComplianceGetComplianceFormPagePreviewData>>, number | Pick<QueryKey<Options<CharityComplianceGetComplianceFormPagePreviewData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CharityComplianceGetComplianceFormPagePreviewData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                path: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await charityComplianceGetComplianceFormPagePreview({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: charityComplianceGetComplianceFormPagePreviewInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Mint Compliance Form Version
 *
 * Record the prepared form as it stands as a version of its document.
 *
 * The version is the agency's template and one appended change carrying the form's values;
 * it never changes, and the same answers record the same version. Anyone who can read the
 * module may record it, as downloading it does. Refused when the form changed since it was
 * read (``expected_values_sha256``) and while it is out for signature.
 */
export const charityComplianceMintComplianceFormVersionMutation = (options?: Partial<Options<CharityComplianceMintComplianceFormVersionData>>): UseMutationOptions<CharityComplianceMintComplianceFormVersionResponse, CharityComplianceMintComplianceFormVersionError, Options<CharityComplianceMintComplianceFormVersionData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceMintComplianceFormVersionResponse, CharityComplianceMintComplianceFormVersionError, Options<CharityComplianceMintComplianceFormVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceMintComplianceFormVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceObligationsQueryKey = (options: Options<CharityComplianceListComplianceObligationsData>) => createQueryKey('charity-compliance-list_compliance_obligations', options);

/**
 * List Compliance Obligations
 *
 * The organization's register.
 *
 * Each row records what the organization filed and when, and the confirmation the
 * state issued for it. It records filings; it is not a statement that the
 * organization is registered, exempt, in good standing, or in compliance anywhere —
 * only the state that issued a confirmation can say that.
 */
export const charityComplianceListComplianceObligationsOptions = (options: Options<CharityComplianceListComplianceObligationsData>) => queryOptions<CharityComplianceListComplianceObligationsResponse, CharityComplianceListComplianceObligationsError, CharityComplianceListComplianceObligationsResponse, ReturnType<typeof charityComplianceListComplianceObligationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceObligations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceObligationsQueryKey(options)
});

export const charityComplianceGetComplianceObligationQueryKey = (options: Options<CharityComplianceGetComplianceObligationData>) => createQueryKey('charity-compliance-get_compliance_obligation', options);

/**
 * Get Compliance Obligation
 *
 * One obligation, its computed dates, and everything recorded about it.
 *
 * Each date is calculated from a filing period transcribed from the cited source,
 * applied to the fiscal year end the organization recorded. Confirm the current due
 * date with the state before filing.
 */
export const charityComplianceGetComplianceObligationOptions = (options: Options<CharityComplianceGetComplianceObligationData>) => queryOptions<CharityComplianceGetComplianceObligationResponse, CharityComplianceGetComplianceObligationError, CharityComplianceGetComplianceObligationResponse, ReturnType<typeof charityComplianceGetComplianceObligationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceObligation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceObligationQueryKey(options)
});

export const charityComplianceListComplianceObligationArtifactsQueryKey = (options: Options<CharityComplianceListComplianceObligationArtifactsData>) => createQueryKey('charity-compliance-list_compliance_obligation_artifacts', options);

/**
 * List Compliance Obligation Artifacts
 *
 * Every document recorded against this obligation — currently and historically.
 *
 * `reference_role` says what each document was recorded AS: `confirmation`, the
 * confirmation the state issued; `submission_proof`, your organization's own proof of a
 * submission; `filed_copy`, the filing itself as your organization sent it; or
 * `attachment`, another document kept with the filing. Only a confirmation is the
 * state's answer. `is_current` says whether this obligation itself still carries the
 * reference: a document stays listed after a candidate is dismissed or a later
 * submission is recorded, because the history of what was recorded does not change when
 * the current record does, and a document one of its renewal cycles holds is listed as
 * not current here.
 */
export const charityComplianceListComplianceObligationArtifactsOptions = (options: Options<CharityComplianceListComplianceObligationArtifactsData>) => queryOptions<CharityComplianceListComplianceObligationArtifactsResponse, CharityComplianceListComplianceObligationArtifactsError, CharityComplianceListComplianceObligationArtifactsResponse, ReturnType<typeof charityComplianceListComplianceObligationArtifactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceObligationArtifacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceObligationArtifactsQueryKey(options)
});

/**
 * Add Compliance Obligation Attachment
 *
 * Keep one more document with a filing made once rather than each period, or with
 * the first filing of one that also recurs (the filing due before the first
 * solicitation). The document must already be uploaded for your organization; adding it
 * again changes nothing.
 */
export const charityComplianceAddComplianceObligationAttachmentMutation = (options?: Partial<Options<CharityComplianceAddComplianceObligationAttachmentData>>): UseMutationOptions<CharityComplianceAddComplianceObligationAttachmentResponse, CharityComplianceAddComplianceObligationAttachmentError, Options<CharityComplianceAddComplianceObligationAttachmentData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAddComplianceObligationAttachmentResponse, CharityComplianceAddComplianceObligationAttachmentError, Options<CharityComplianceAddComplianceObligationAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAddComplianceObligationAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Compliance Earlier Renewal Cycle
 *
 * Add an earlier year to one filing's history: a renewal cycle for a year the
 * calendar does not show, before the latest one it does, dated by the same cited rule and
 * your organization's recorded fiscal year end. It starts with nothing recorded, and no
 * reminder is sent for it; record the year's filing on the cycle it returns. A year
 * already shown returns its own cycle.
 */
export const charityComplianceAddComplianceEarlierRenewalCycleMutation = (options?: Partial<Options<CharityComplianceAddComplianceEarlierRenewalCycleData>>): UseMutationOptions<CharityComplianceAddComplianceEarlierRenewalCycleResponse, CharityComplianceAddComplianceEarlierRenewalCycleError, Options<CharityComplianceAddComplianceEarlierRenewalCycleData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAddComplianceEarlierRenewalCycleResponse, CharityComplianceAddComplianceEarlierRenewalCycleError, Options<CharityComplianceAddComplianceEarlierRenewalCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAddComplianceEarlierRenewalCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attach Compliance Obligation Filed Copy
 *
 * Attach the filing itself, as your organization sent it, to a filing made once
 * rather than each period, or to the first filing of one that also recurs (the filing
 * due before the first solicitation). It keeps one; the document must already be
 * uploaded for your organization. It is not the jurisdiction's confirmation. Each later
 * period keeps its own filing as sent on its renewal cycle.
 */
export const charityComplianceAttachComplianceObligationFiledCopyMutation = (options?: Partial<Options<CharityComplianceAttachComplianceObligationFiledCopyData>>): UseMutationOptions<CharityComplianceAttachComplianceObligationFiledCopyResponse, CharityComplianceAttachComplianceObligationFiledCopyError, Options<CharityComplianceAttachComplianceObligationFiledCopyData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAttachComplianceObligationFiledCopyResponse, CharityComplianceAttachComplianceObligationFiledCopyError, Options<CharityComplianceAttachComplianceObligationFiledCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAttachComplianceObligationFiledCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Open Compliance Filing Case
 *
 * Open a filing case for one filing on the organization's register.
 *
 * Say what kind of filing it is. For a filing made each year or each licence period, name
 * the year's record on its calendar; leave it out for a filing made once, or for the first
 * filing of one that also recurs. One case of each kind can be open for a filing and
 * period at a time: withdraw the open one to start over. Refused, with nothing recorded,
 * for a filing that is not confirmed on the register or a year's record that was replaced.
 */
export const charityComplianceOpenComplianceFilingCaseMutation = (options?: Partial<Options<CharityComplianceOpenComplianceFilingCaseData>>): UseMutationOptions<CharityComplianceOpenComplianceFilingCaseResponse, CharityComplianceOpenComplianceFilingCaseError, Options<CharityComplianceOpenComplianceFilingCaseData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceOpenComplianceFilingCaseResponse, CharityComplianceOpenComplianceFilingCaseError, Options<CharityComplianceOpenComplianceFilingCaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceOpenComplianceFilingCase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Filing
 *
 * Record a filing the organization made, with the confirmation the state issued.
 *
 * The confirmation is required — there is no path on this surface that records a
 * filing without one, and the database refuses such a row independently. What is
 * recorded is that the organization filed, on the date it gives, with the
 * confirmation it uploaded.
 */
export const charityComplianceRecordComplianceFilingMutation = (options?: Partial<Options<CharityComplianceRecordComplianceFilingData>>): UseMutationOptions<CharityComplianceRecordComplianceFilingResponse, CharityComplianceRecordComplianceFilingError, Options<CharityComplianceRecordComplianceFilingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceFilingResponse, CharityComplianceRecordComplianceFilingError, Options<CharityComplianceRecordComplianceFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListCompliancePacketsQueryKey = (options: Options<CharityComplianceListCompliancePacketsData>) => createQueryKey('charity-compliance-list_compliance_packets', options);

/**
 * List Compliance Packets
 *
 * The versions of one obligation's packet, newest first.
 *
 * Every version stays readable — a superseded one keeps its content address and its
 * download history. Items and execution steps are read per version. `download_state`
 * says what asking for each version's document would actually do, and `download_count`
 * how many times this organization has fetched it.
 */
export const charityComplianceListCompliancePacketsOptions = (options: Options<CharityComplianceListCompliancePacketsData>) => queryOptions<CharityComplianceListCompliancePacketsResponse, CharityComplianceListCompliancePacketsError, CharityComplianceListCompliancePacketsResponse, ReturnType<typeof charityComplianceListCompliancePacketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListCompliancePackets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListCompliancePacketsQueryKey(options)
});

/**
 * Assemble Compliance Packet
 *
 * Assemble a new packet version for one confirmed obligation.
 *
 * The packet pairs the jurisdiction's rule as transcribed — form, agency, channel and
 * address, fee, attachments, signature requirement, prerequisites, filing period — each
 * with its source date and, where one was recorded, its citation, against the parameters
 * the organization recorded and the documents it has cited. Where the rule records no
 * form, channel, fee, attachment, signature requirement or filing period, the packet
 * records a gap rather than supplying one. Signer instructions may also appear in
 * recorded form or submission notes.
 *
 * Each step is carried with the source date and, where recorded, the citation of the rule
 * field it restates, or marked as this product's own instruction where it restates no
 * rule. Each item carries the source line frozen when its version was assembled: its
 * source date, `rule_source_date`, worded by `rule_source_date_basis` (an item assembled
 * without them dates its source by `rule_source_checked_on`, a live check only where
 * `rule_source_check_status` is `read_live`), and its citation, `rule_display_citation`,
 * where one was recorded.
 *
 * Assembling again supersedes the previous version: a new version is a new set of
 * bytes, and a download record names the exact bytes it served. Optionally cite ONE
 * more document of the organization's own; documents cited on earlier versions carry
 * forward. Nothing is filed anywhere by this or any other operation here.
 */
export const charityComplianceAssembleCompliancePacketMutation = (options?: Partial<Options<CharityComplianceAssembleCompliancePacketData>>): UseMutationOptions<CharityComplianceAssembleCompliancePacketResponse, CharityComplianceAssembleCompliancePacketError, Options<CharityComplianceAssembleCompliancePacketData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAssembleCompliancePacketResponse, CharityComplianceAssembleCompliancePacketError, Options<CharityComplianceAssembleCompliancePacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAssembleCompliancePacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Registration Date
 *
 * Record the dates this obligation's renewal runs from: its registration date
 * (CCM-BE2), the expiry date printed on its licence (CCM-R1-INTAKE-ANCHOR), or both.
 *
 * Recorded on the obligation itself rather than by declining it and confirming it
 * again — an obligation's recorded filings and its whole history stay where they are
 * while the date under its renewal corrects. Where a licence expiry is recorded, the
 * licence period ends on it. The dates it computes are recomputed; nothing about what
 * your organization filed changes, and no confirmation is needed to correct a date.
 */
export const charityComplianceRecordComplianceRegistrationDateMutation = (options?: Partial<Options<CharityComplianceRecordComplianceRegistrationDateData>>): UseMutationOptions<CharityComplianceRecordComplianceRegistrationDateResponse, CharityComplianceRecordComplianceRegistrationDateError, Options<CharityComplianceRecordComplianceRegistrationDateData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceRegistrationDateResponse, CharityComplianceRecordComplianceRegistrationDateError, Options<CharityComplianceRecordComplianceRegistrationDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceRegistrationDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceObligationRuleChangeQueryKey = (options: Options<CharityComplianceGetComplianceObligationRuleChangeData>) => createQueryKey('charity-compliance-get_compliance_obligation_rule_change', options);

/**
 * Get Compliance Obligation Rule Change
 *
 * What changed between the rule version a filing is pinned to and its rule's current
 * version (CCM-OPS1-REPIN): each kind of change, with the deadline entry it is about, and
 * each deadline entry's next date under each version. Structure only.
 */
export const charityComplianceGetComplianceObligationRuleChangeOptions = (options: Options<CharityComplianceGetComplianceObligationRuleChangeData>) => queryOptions<CharityComplianceGetComplianceObligationRuleChangeResponse, CharityComplianceGetComplianceObligationRuleChangeError, CharityComplianceGetComplianceObligationRuleChangeResponse, ReturnType<typeof charityComplianceGetComplianceObligationRuleChangeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceObligationRuleChange({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceObligationRuleChangeQueryKey(options)
});

/**
 * Repin Compliance Obligation
 *
 * Move a filing to its rule's current version, the version named (CCM-OPS1-REPIN): the
 * organization's own act, attributed on the filing's history, which clears the filing's
 * rule-change flag and works its dates out again from that version. Its record is kept.
 * Refused, with nothing written, unless the version named is still the rule's current one;
 * a filing already there is answered as it stands.
 */
export const charityComplianceRepinComplianceObligationMutation = (options?: Partial<Options<CharityComplianceRepinComplianceObligationData>>): UseMutationOptions<CharityComplianceRepinComplianceObligationResponse, CharityComplianceRepinComplianceObligationError, Options<CharityComplianceRepinComplianceObligationData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRepinComplianceObligationResponse, CharityComplianceRepinComplianceObligationError, Options<CharityComplianceRepinComplianceObligationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRepinComplianceObligation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Submission
 *
 * Record that the organization submitted a filing, on the date it gives.
 *
 * This records the organization's own act and nothing about the jurisdiction's
 * answer. Render it as "submission recorded «date» — awaiting the state's
 * confirmation": the register does not know whether the submission arrived, was
 * accepted, or was returned, and it does not become a recorded filing until the
 * organization records the confirmation the state issued, on the filing-records
 * route, with that confirmation attached.
 *
 * Its own route because it takes no confirmation — the filing route's confirmation is
 * required and has no nullable form. The optional proof reference here is the
 * organization's own paperwork and is never read as a confirmation.
 *
 * Dates the organization is working toward are recomputed, and the notices for the
 * cycle this submission was for change voice accordingly. If the recorded window
 * closes with no confirmation recorded against it, the register still reports the
 * closed window.
 */
export const charityComplianceRecordComplianceSubmissionMutation = (options?: Partial<Options<CharityComplianceRecordComplianceSubmissionData>>): UseMutationOptions<CharityComplianceRecordComplianceSubmissionResponse, CharityComplianceRecordComplianceSubmissionError, Options<CharityComplianceRecordComplianceSubmissionData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceSubmissionResponse, CharityComplianceRecordComplianceSubmissionError, Options<CharityComplianceRecordComplianceSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Tracking Compliance Obligation
 *
 * Start tracking a stopped filing again (CCM-R1-TRACKING-PANEL, D-CCM-58): the
 * organization's own act, attributed on the filing's history. It goes back onto the calendar
 * on its own rule version and its dates are worked out again. A filing being tracked is
 * answered as it stands. Refused, with nothing written, for a filing not on the calendar.
 */
export const charityComplianceResumeTrackingComplianceObligationMutation = (options?: Partial<Options<CharityComplianceResumeTrackingComplianceObligationData>>): UseMutationOptions<CharityComplianceResumeTrackingComplianceObligationResponse, CharityComplianceResumeTrackingComplianceObligationError, Options<CharityComplianceResumeTrackingComplianceObligationData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceResumeTrackingComplianceObligationResponse, CharityComplianceResumeTrackingComplianceObligationError, Options<CharityComplianceResumeTrackingComplianceObligationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceResumeTrackingComplianceObligation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop Tracking Compliance Obligation
 *
 * Stop tracking a filing on the calendar (CCM-R1-TRACKING-PANEL, D-CCM-58): the
 * organization's own act, attributed on the filing's history. Its record and history stay;
 * Givmo works out no new dates for it, so nothing reminds. A filing already stopped is
 * answered as it stands. Refused, with nothing written, for a filing not on the calendar.
 */
export const charityComplianceStopTrackingComplianceObligationMutation = (options?: Partial<Options<CharityComplianceStopTrackingComplianceObligationData>>): UseMutationOptions<CharityComplianceStopTrackingComplianceObligationResponse, CharityComplianceStopTrackingComplianceObligationError, Options<CharityComplianceStopTrackingComplianceObligationData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceStopTrackingComplianceObligationResponse, CharityComplianceStopTrackingComplianceObligationError, Options<CharityComplianceStopTrackingComplianceObligationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceStopTrackingComplianceObligation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Window Closed
 *
 * Record that a refiling window the organization recorded closed with no filing
 * recorded against it.
 *
 * A dated fact. The register does not assess what a closed window means for the
 * organization.
 */
export const charityComplianceRecordComplianceWindowClosedMutation = (options?: Partial<Options<CharityComplianceRecordComplianceWindowClosedData>>): UseMutationOptions<CharityComplianceRecordComplianceWindowClosedResponse, CharityComplianceRecordComplianceWindowClosedError, Options<CharityComplianceRecordComplianceWindowClosedData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceWindowClosedResponse, CharityComplianceRecordComplianceWindowClosedError, Options<CharityComplianceRecordComplianceWindowClosedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceWindowClosed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceOccurrencesQueryKey = (options: Options<CharityComplianceListComplianceOccurrencesData>) => createQueryKey('charity-compliance-list_compliance_occurrences', options);

/**
 * List Compliance Occurrences
 *
 * Computed dates across the organization's confirmed obligations.
 *
 * Each date is calculated from a filing period transcribed from the cited source,
 * applied to the fiscal year end the organization recorded, and travels with both.
 * Some obligations have no calendar date at all — a filing due before the first
 * solicitation has no date to compute — and those rows say so rather than being
 * omitted.
 *
 * `due_before` bounds the window; rows with no computable date are returned
 * regardless.
 */
export const charityComplianceListComplianceOccurrencesOptions = (options: Options<CharityComplianceListComplianceOccurrencesData>) => queryOptions<CharityComplianceListComplianceOccurrencesResponse, CharityComplianceListComplianceOccurrencesError, CharityComplianceListComplianceOccurrencesResponse, ReturnType<typeof charityComplianceListComplianceOccurrencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceOccurrences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceOccurrencesQueryKey(options)
});

export const charityComplianceListComplianceOrganizationFilingsQueryKey = (options: Options<CharityComplianceListComplianceOrganizationFilingsData>) => createQueryKey('charity-compliance-list_compliance_organization_filings', options);

/**
 * List Compliance Organization Filings
 *
 * The filings the organization records itself, oldest first, each with its latest
 * period.
 *
 * These are filings Givmo's rules library does not have. Their dates are the ones the
 * organization entered, and nothing on them was checked against a source.
 */
export const charityComplianceListComplianceOrganizationFilingsOptions = (options: Options<CharityComplianceListComplianceOrganizationFilingsData>) => queryOptions<CharityComplianceListComplianceOrganizationFilingsResponse, CharityComplianceListComplianceOrganizationFilingsError, CharityComplianceListComplianceOrganizationFilingsResponse, ReturnType<typeof charityComplianceListComplianceOrganizationFilingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceOrganizationFilings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceOrganizationFilingsQueryKey(options)
});

/**
 * Add Compliance Organization Filing
 *
 * Add a filing Givmo's rules library does not have.
 *
 * The organization gives its title, who it is filed with, its family, how often it
 * comes round and its next date; its first period opens at that date. Answers with the
 * filing and that period.
 */
export const charityComplianceAddComplianceOrganizationFilingMutation = (options?: Partial<Options<CharityComplianceAddComplianceOrganizationFilingData>>): UseMutationOptions<CharityComplianceAddComplianceOrganizationFilingResponse, CharityComplianceAddComplianceOrganizationFilingError, Options<CharityComplianceAddComplianceOrganizationFilingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAddComplianceOrganizationFilingResponse, CharityComplianceAddComplianceOrganizationFilingError, Options<CharityComplianceAddComplianceOrganizationFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAddComplianceOrganizationFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceOrganizationFilingQueryKey = (options: Options<CharityComplianceGetComplianceOrganizationFilingData>) => createQueryKey('charity-compliance-get_compliance_organization_filing', options);

/**
 * Get Compliance Organization Filing
 *
 * One filing the organization records itself, with every period, latest date
 * first, its history, the number it first entered, and each change to that number.
 */
export const charityComplianceGetComplianceOrganizationFilingOptions = (options: Options<CharityComplianceGetComplianceOrganizationFilingData>) => queryOptions<CharityComplianceGetComplianceOrganizationFilingResponse, CharityComplianceGetComplianceOrganizationFilingError, CharityComplianceGetComplianceOrganizationFilingResponse, ReturnType<typeof charityComplianceGetComplianceOrganizationFilingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceOrganizationFiling({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceOrganizationFilingQueryKey(options)
});

/**
 * Update Compliance Organization Filing
 *
 * Change a filing the organization records itself.
 *
 * A field left out stays as it is; the agency and the number are cleared with null.
 * Changing how often it comes round, or its next date, re-dates only the period nothing
 * is recorded for yet. Each change is kept in the filing's history. A reason, in the
 * person's own words, is kept with each change.
 */
export const charityComplianceUpdateComplianceOrganizationFilingMutation = (options?: Partial<Options<CharityComplianceUpdateComplianceOrganizationFilingData>>): UseMutationOptions<CharityComplianceUpdateComplianceOrganizationFilingResponse, CharityComplianceUpdateComplianceOrganizationFilingError, Options<CharityComplianceUpdateComplianceOrganizationFilingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceUpdateComplianceOrganizationFilingResponse, CharityComplianceUpdateComplianceOrganizationFilingError, Options<CharityComplianceUpdateComplianceOrganizationFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceUpdateComplianceOrganizationFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Compliance Organization Filing Cycle
 *
 * Add an earlier period of a filing the organization records itself, at a date
 * before its latest period that no period already there covers. It opens nothing new.
 * An earlier date a period already holds returns that period.
 */
export const charityComplianceAddComplianceOrganizationFilingCycleMutation = (options?: Partial<Options<CharityComplianceAddComplianceOrganizationFilingCycleData>>): UseMutationOptions<CharityComplianceAddComplianceOrganizationFilingCycleResponse, CharityComplianceAddComplianceOrganizationFilingCycleError, Options<CharityComplianceAddComplianceOrganizationFilingCycleData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAddComplianceOrganizationFilingCycleResponse, CharityComplianceAddComplianceOrganizationFilingCycleError, Options<CharityComplianceAddComplianceOrganizationFilingCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAddComplianceOrganizationFilingCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Compliance Organization Filing Attachment
 *
 * Keep one more document with one period of a filing your organization records
 * itself, beside its filing and confirmation. The document must already be uploaded for
 * your organization; adding it again changes nothing.
 */
export const charityComplianceAddComplianceOrganizationFilingAttachmentMutation = (options?: Partial<Options<CharityComplianceAddComplianceOrganizationFilingAttachmentData>>): UseMutationOptions<CharityComplianceAddComplianceOrganizationFilingAttachmentResponse, CharityComplianceAddComplianceOrganizationFilingAttachmentError, Options<CharityComplianceAddComplianceOrganizationFilingAttachmentData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAddComplianceOrganizationFilingAttachmentResponse, CharityComplianceAddComplianceOrganizationFilingAttachmentError, Options<CharityComplianceAddComplianceOrganizationFilingAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAddComplianceOrganizationFilingAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attach Compliance Organization Filing Filed Copy
 *
 * Keep the filing itself, as your organization sent it, with one period of a filing
 * your organization records itself. A period keeps one; the document must already be
 * uploaded for your organization. It is kept with the period's records and is not the
 * agency's confirmation: the period reads as filed only with that.
 */
export const charityComplianceAttachComplianceOrganizationFilingFiledCopyMutation = (options?: Partial<Options<CharityComplianceAttachComplianceOrganizationFilingFiledCopyData>>): UseMutationOptions<CharityComplianceAttachComplianceOrganizationFilingFiledCopyResponse, CharityComplianceAttachComplianceOrganizationFilingFiledCopyError, Options<CharityComplianceAttachComplianceOrganizationFilingFiledCopyData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAttachComplianceOrganizationFilingFiledCopyResponse, CharityComplianceAttachComplianceOrganizationFilingFiledCopyError, Options<CharityComplianceAttachComplianceOrganizationFilingFiledCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAttachComplianceOrganizationFilingFiledCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Organization Filing Filed
 *
 * Record that one period was filed, with the confirmation the agency issued.
 *
 * The confirmation document is required: a period reads as filed only with it. A copy
 * of the filing as sent may ride along; a period keeps one. Recording the same filing
 * again changes nothing. When this is the latest period, the next opens by the
 * filing's cadence.
 */
export const charityComplianceRecordComplianceOrganizationFilingFiledMutation = (options?: Partial<Options<CharityComplianceRecordComplianceOrganizationFilingFiledData>>): UseMutationOptions<CharityComplianceRecordComplianceOrganizationFilingFiledResponse, CharityComplianceRecordComplianceOrganizationFilingFiledError, Options<CharityComplianceRecordComplianceOrganizationFilingFiledData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceOrganizationFilingFiledResponse, CharityComplianceRecordComplianceOrganizationFilingFiledError, Options<CharityComplianceRecordComplianceOrganizationFilingFiledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceOrganizationFilingFiled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Organization Filing Sent
 *
 * Record that one period's filing was sent, on the date the organization gives.
 *
 * Sent is not filed. Recording it again corrects the date and the proof; recording it
 * exactly as it stands changes nothing. A period keeps one filing as sent: a different
 * copy is refused. When this is the latest period, the next opens by the filing's
 * cadence.
 */
export const charityComplianceRecordComplianceOrganizationFilingSentMutation = (options?: Partial<Options<CharityComplianceRecordComplianceOrganizationFilingSentData>>): UseMutationOptions<CharityComplianceRecordComplianceOrganizationFilingSentResponse, CharityComplianceRecordComplianceOrganizationFilingSentError, Options<CharityComplianceRecordComplianceOrganizationFilingSentData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceOrganizationFilingSentResponse, CharityComplianceRecordComplianceOrganizationFilingSentError, Options<CharityComplianceRecordComplianceOrganizationFilingSentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceOrganizationFilingSent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retire Compliance Organization Filing
 *
 * Stop tracking a filing the organization records itself: it gets no more reminders
 * and opens no next period.
 *
 * The record is kept as it was, with its periods and history, and takes no further
 * changes. A filing already stopped answers as it is.
 */
export const charityComplianceRetireComplianceOrganizationFilingMutation = (options?: Partial<Options<CharityComplianceRetireComplianceOrganizationFilingData>>): UseMutationOptions<CharityComplianceRetireComplianceOrganizationFilingResponse, CharityComplianceRetireComplianceOrganizationFilingError, Options<CharityComplianceRetireComplianceOrganizationFilingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRetireComplianceOrganizationFilingResponse, CharityComplianceRetireComplianceOrganizationFilingError, Options<CharityComplianceRetireComplianceOrganizationFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRetireComplianceOrganizationFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Switch Compliance Organization Filing
 *
 * Switch a filing the organization records itself to the same filing from Givmo's
 * rules library, once the organization has that one on its register.
 *
 * The record is kept as it was, with its periods and history, and takes no further
 * changes. If it was moved into a group, the library filing takes its place there.
 */
export const charityComplianceSwitchComplianceOrganizationFilingMutation = (options?: Partial<Options<CharityComplianceSwitchComplianceOrganizationFilingData>>): UseMutationOptions<CharityComplianceSwitchComplianceOrganizationFilingResponse, CharityComplianceSwitchComplianceOrganizationFilingError, Options<CharityComplianceSwitchComplianceOrganizationFilingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceSwitchComplianceOrganizationFilingResponse, CharityComplianceSwitchComplianceOrganizationFilingError, Options<CharityComplianceSwitchComplianceOrganizationFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceSwitchComplianceOrganizationFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetCompliancePacketQueryKey = (options: Options<CharityComplianceGetCompliancePacketData>) => createQueryKey('charity-compliance-get_compliance_packet', options);

/**
 * Get Compliance Packet
 *
 * One packet version with its items.
 *
 * The items are the rule elements with their source dates and, where recorded, citations,
 * the organization's cited documents, and the steps it performs on the jurisdiction's own
 * channel — each step carrying the source date and, where recorded, the citation of the
 * rule field it restates, or marked as this product's own instruction where it restates
 * no rule. Each item carries the source line frozen when its version was assembled: its
 * source date, `rule_source_date`, worded by `rule_source_date_basis` (an item assembled
 * without them dates its source by `rule_source_checked_on`, a live check only where
 * `rule_source_check_status` is `read_live`), and its citation, `rule_display_citation`,
 * where one was recorded. All of them are listed in every packet state. `download_state`
 * says what asking for this version's document would actually do, and `download_count`
 * how many times it has been fetched.
 */
export const charityComplianceGetCompliancePacketOptions = (options: Options<CharityComplianceGetCompliancePacketData>) => queryOptions<CharityComplianceGetCompliancePacketResponse, CharityComplianceGetCompliancePacketError, CharityComplianceGetCompliancePacketResponse, ReturnType<typeof charityComplianceGetCompliancePacketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetCompliancePacket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetCompliancePacketQueryKey(options)
});

export const charityComplianceGetCompliancePacketChecklistQueryKey = (options: Options<CharityComplianceGetCompliancePacketChecklistData>) => createQueryKey('charity-compliance-get_compliance_packet_checklist', options);

/**
 * Get Compliance Packet Checklist
 *
 * The checklist for one packet version.
 *
 * The full working state at any time: the rule elements with their source dates and,
 * where recorded, citations, the organization's cited documents, and the steps it
 * performs on the jurisdiction's own channel — gather the cited documents, obtain the
 * recorded signatures, execute on the recorded channel, remit the recorded amount where
 * one is transcribed, then record the submission in the register. Each step built from
 * the rule carries that rule's source date and, where recorded, its citation; the
 * register step is this product's own instruction and says so. Each item carries the
 * source line frozen when its version was assembled: its source date, `rule_source_date`,
 * worded by `rule_source_date_basis` (an item assembled without them dates its source by
 * `rule_source_checked_on`, a live check only where `rule_source_check_status` is
 * `read_live`), and its citation, `rule_display_citation`, where one was recorded. Where
 * the rule records no channel, fee or signature requirement, the step records a gap
 * rather than supplying one. Signer instructions may also appear in recorded form or
 * submission notes. `download_state` says what asking for this version's document would
 * actually do, and `download_count` how many times it has been fetched.
 */
export const charityComplianceGetCompliancePacketChecklistOptions = (options: Options<CharityComplianceGetCompliancePacketChecklistData>) => queryOptions<CharityComplianceGetCompliancePacketChecklistResponse, CharityComplianceGetCompliancePacketChecklistError, CharityComplianceGetCompliancePacketChecklistResponse, ReturnType<typeof charityComplianceGetCompliancePacketChecklistQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetCompliancePacketChecklist({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetCompliancePacketChecklistQueryKey(options)
});

export const charityComplianceGetCompliancePacketRenderQueryKey = (options: Options<CharityComplianceGetCompliancePacketRenderData>) => createQueryKey('charity-compliance-get_compliance_packet_render', options);

/**
 * Get Compliance Packet Render
 *
 * Download one packet version's document.
 *
 * Anyone the organization has admitted to this module may download it. There is
 * nothing to confirm and nothing to type. Every download is recorded when it is asked
 * for — who asked, when, and which bytes it names: the content address of the frozen
 * payload the document is rendered from — and that record says exactly that: it is not
 * a signature, an approval, or a statement that anyone is an officer of the
 * organization.
 *
 * Above its download record, the document says that it is not signed, and that who must
 * sign, and how, is set by the jurisdiction's own form and instructions: the rule shows
 * the signer requirements recorded from those sources, and where it shows none they
 * have not been recorded, which does not mean the source is silent.
 *
 * Rendered deterministically from the frozen payload; nothing is stored. Refused for a
 * version whose pinned rule was revised or whose recorded parameters changed since it
 * was assembled — each of those calls for a new version. Nothing is filed anywhere by
 * this or any other operation here.
 */
export const charityComplianceGetCompliancePacketRenderOptions = (options: Options<CharityComplianceGetCompliancePacketRenderData>) => queryOptions<CharityComplianceGetCompliancePacketRenderResponse, CharityComplianceGetCompliancePacketRenderError, CharityComplianceGetCompliancePacketRenderResponse, ReturnType<typeof charityComplianceGetCompliancePacketRenderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetCompliancePacketRender({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetCompliancePacketRenderQueryKey(options)
});

export const charityComplianceGetComplianceProfileQueryKey = (options: Options<CharityComplianceGetComplianceProfileData>) => createQueryKey('charity-compliance-get_compliance_profile', options);

/**
 * Get Compliance Profile
 *
 * The facts your organization has recorded about itself.
 *
 * Each one was entered by someone at your organization and is shown with who recorded
 * it and when. Givmo does not confirm these facts; the register's candidates and every
 * computed date rest on them, so keeping them current is what keeps those accurate.
 *
 * `missing_required_parameter_keys` lists what still has to be recorded before
 * candidate obligations can be worked out at all.
 */
export const charityComplianceGetComplianceProfileOptions = (options: Options<CharityComplianceGetComplianceProfileData>) => queryOptions<CharityComplianceGetComplianceProfileResponse, CharityComplianceGetComplianceProfileError, CharityComplianceGetComplianceProfileResponse, ReturnType<typeof charityComplianceGetComplianceProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceProfileQueryKey(options)
});

export const charityComplianceListComplianceProfileParametersQueryKey = (options: Options<CharityComplianceListComplianceProfileParametersData>) => createQueryKey('charity-compliance-list_compliance_profile_parameters', options);

/**
 * List Compliance Profile Parameters
 *
 * The facts your organization recorded — in force first, then their history.
 *
 * Recording a fact again does not edit what was there: it writes a new entry and
 * marks the previous one superseded, so an obligation your organization confirmed
 * against an earlier value still shows the value it was confirmed against.
 */
export const charityComplianceListComplianceProfileParametersOptions = (options: Options<CharityComplianceListComplianceProfileParametersData>) => queryOptions<CharityComplianceListComplianceProfileParametersResponse, CharityComplianceListComplianceProfileParametersError, CharityComplianceListComplianceProfileParametersResponse, ReturnType<typeof charityComplianceListComplianceProfileParametersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceProfileParameters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceProfileParametersQueryKey(options)
});

/**
 * Record Compliance Profile Parameter
 *
 * Record ONE fact about your organization.
 *
 * PUT rather than POST because your organization has exactly one value in force for
 * each fact. Recording again does not edit the previous entry — it writes a new one
 * and supersedes the old, so anything already computed can still show the value it
 * was computed from.
 *
 * When the fact you record is one the register reads, the response says so and links
 * the re-derivation. Nothing is re-derived for you: a re-derivation puts candidate
 * obligations in front of your organization to review, and that is a step someone at
 * your organization takes.
 */
export const charityComplianceRecordComplianceProfileParameterMutation = (options?: Partial<Options<CharityComplianceRecordComplianceProfileParameterData>>): UseMutationOptions<CharityComplianceRecordComplianceProfileParameterResponse, CharityComplianceRecordComplianceProfileParameterError, Options<CharityComplianceRecordComplianceProfileParameterData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceProfileParameterResponse, CharityComplianceRecordComplianceProfileParameterError, Options<CharityComplianceRecordComplianceProfileParameterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceProfileParameter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceRegistrationImportsQueryKey = (options: Options<CharityComplianceListComplianceRegistrationImportsData>) => createQueryKey('charity-compliance-list_compliance_registration_imports', options);

/**
 * List Compliance Registration Imports
 *
 * Registrations your organization already held when it started here.
 *
 * `artifact_state` is `requested` where the confirmation the state issued has not
 * been supplied yet. Those obligations are in the register and confirmed; they carry
 * no filing record, because the register records filings it can show the state's own
 * document for.
 */
export const charityComplianceListComplianceRegistrationImportsOptions = (options: Options<CharityComplianceListComplianceRegistrationImportsData>) => queryOptions<CharityComplianceListComplianceRegistrationImportsResponse, CharityComplianceListComplianceRegistrationImportsError, CharityComplianceListComplianceRegistrationImportsResponse, ReturnType<typeof charityComplianceListComplianceRegistrationImportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceRegistrationImports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceRegistrationImportsQueryKey(options)
});

/**
 * Import Compliance Registration
 *
 * Record ONE registration your organization already holds.
 *
 * This route takes exactly one registration — importing puts the obligation into your
 * organization's register.
 *
 * Supplying the confirmation the state issued records the filing, exactly as
 * recording any other filing does. Importing without one is fully supported: the
 * obligation goes into the register with no filing record against it, and the
 * confirmation is noted as still to be supplied.
 */
export const charityComplianceImportComplianceRegistrationMutation = (options?: Partial<Options<CharityComplianceImportComplianceRegistrationData>>): UseMutationOptions<CharityComplianceImportComplianceRegistrationResponse, CharityComplianceImportComplianceRegistrationError, Options<CharityComplianceImportComplianceRegistrationData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceImportComplianceRegistrationResponse, CharityComplianceImportComplianceRegistrationError, Options<CharityComplianceImportComplianceRegistrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceImportComplianceRegistration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceRegistrationImportAmendmentsQueryKey = (options: Options<CharityComplianceListComplianceRegistrationImportAmendmentsData>) => createQueryKey('charity-compliance-list_compliance_registration_import_amendments', options);

/**
 * List Compliance Registration Import Amendments
 *
 * Every correction recorded against this imported registration, oldest first.
 *
 * The whole chain, not a page of it: this is the answer to what your organization has
 * said about this registration over time, and half of it would be a different answer.
 * Each entry names the field, what the record said before, what it says now, who
 * recorded it and when.
 */
export const charityComplianceListComplianceRegistrationImportAmendmentsOptions = (options: Options<CharityComplianceListComplianceRegistrationImportAmendmentsData>) => queryOptions<CharityComplianceListComplianceRegistrationImportAmendmentsResponse, CharityComplianceListComplianceRegistrationImportAmendmentsError, CharityComplianceListComplianceRegistrationImportAmendmentsResponse, ReturnType<typeof charityComplianceListComplianceRegistrationImportAmendmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceRegistrationImportAmendments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceRegistrationImportAmendmentsQueryKey(options)
});

/**
 * Amend Compliance Registration Import
 *
 * Correct a detail your organization typed when it recorded this registration.
 *
 * The correction is recorded BESIDE the original, not over it. The imported record
 * keeps saying what your organization first entered, this amendment says what it says
 * now, and both are shown with who recorded them and when.
 *
 * It changes nothing about the filing itself: not the confirmation the state issued,
 * not the date it was filed, not what the register shows about this obligation. Only
 * details your organization typed can be amended, and the recorded confirmation is
 * never one of them.
 */
export const charityComplianceAmendComplianceRegistrationImportMutation = (options?: Partial<Options<CharityComplianceAmendComplianceRegistrationImportData>>): UseMutationOptions<CharityComplianceAmendComplianceRegistrationImportResponse, CharityComplianceAmendComplianceRegistrationImportError, Options<CharityComplianceAmendComplianceRegistrationImportData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAmendComplianceRegistrationImportResponse, CharityComplianceAmendComplianceRegistrationImportError, Options<CharityComplianceAmendComplianceRegistrationImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAmendComplianceRegistrationImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceProfileReviewFlagsQueryKey = (options: Options<CharityComplianceListComplianceProfileReviewFlagsData>) => createQueryKey('charity-compliance-list_compliance_profile_review_flags', options);

/**
 * List Compliance Profile Review Flags
 *
 * Where a figure your organization recorded and a figure Givmo measured differ.
 *
 * Each row shows both numbers and where each came from. Givmo does not decide which
 * is correct and does not change what your organization recorded — the two figures
 * can legitimately differ, for instance where most of your revenue does not come
 * through Givmo.
 */
export const charityComplianceListComplianceProfileReviewFlagsOptions = (options: Options<CharityComplianceListComplianceProfileReviewFlagsData>) => queryOptions<CharityComplianceListComplianceProfileReviewFlagsResponse, CharityComplianceListComplianceProfileReviewFlagsError, CharityComplianceListComplianceProfileReviewFlagsResponse, ReturnType<typeof charityComplianceListComplianceProfileReviewFlagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceProfileReviewFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceProfileReviewFlagsQueryKey(options)
});

/**
 * Resolve Compliance Profile Review Flag
 *
 * Close ONE flagged difference, recording what your organization decided.
 *
 * Either your organization stands by the figure it recorded, or it records the figure
 * again. Closing a flag changes nothing about the fact itself — to change the fact,
 * record it again.
 */
export const charityComplianceResolveComplianceProfileReviewFlagMutation = (options?: Partial<Options<CharityComplianceResolveComplianceProfileReviewFlagData>>): UseMutationOptions<CharityComplianceResolveComplianceProfileReviewFlagResponse, CharityComplianceResolveComplianceProfileReviewFlagError, Options<CharityComplianceResolveComplianceProfileReviewFlagData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceResolveComplianceProfileReviewFlagResponse, CharityComplianceResolveComplianceProfileReviewFlagError, Options<CharityComplianceResolveComplianceProfileReviewFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceResolveComplianceProfileReviewFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceProfileSuggestionsQueryKey = (options: Options<CharityComplianceListComplianceProfileSuggestionsData>) => createQueryKey('charity-compliance-list_compliance_profile_suggestions', options);

/**
 * List Compliance Profile Suggestions
 *
 * Values read off documents your organization uploaded, for it to check.
 *
 * Each row shows what was read and where it was read from. None of them is recorded
 * against your organization until someone at your organization confirms it — or
 * enters a different value, which is recorded as theirs.
 */
export const charityComplianceListComplianceProfileSuggestionsOptions = (options: Options<CharityComplianceListComplianceProfileSuggestionsData>) => queryOptions<CharityComplianceListComplianceProfileSuggestionsResponse, CharityComplianceListComplianceProfileSuggestionsError, CharityComplianceListComplianceProfileSuggestionsResponse, ReturnType<typeof charityComplianceListComplianceProfileSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceProfileSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceProfileSuggestionsQueryKey(options)
});

/**
 * Resolve Compliance Profile Suggestion
 *
 * Confirm, correct or decline ONE value read off a document.
 *
 * Your organization's answer is what is recorded. Confirming records the value that
 * was read; correcting records the value you enter instead; declining records
 * nothing. In every case the entry names the person who answered, not the reading.
 *
 * Accepting a value has the same consequences as typing it: the dates of obligations
 * your organization has already confirmed are recalculated against it, and the
 * response says whether re-deriving candidate obligations is now worth doing.
 */
export const charityComplianceResolveComplianceProfileSuggestionMutation = (options?: Partial<Options<CharityComplianceResolveComplianceProfileSuggestionData>>): UseMutationOptions<CharityComplianceResolveComplianceProfileSuggestionResponse, CharityComplianceResolveComplianceProfileSuggestionError, Options<CharityComplianceResolveComplianceProfileSuggestionData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceResolveComplianceProfileSuggestionResponse, CharityComplianceResolveComplianceProfileSuggestionError, Options<CharityComplianceResolveComplianceProfileSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceResolveComplianceProfileSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceProposalQueryKey = (options: Options<CharityComplianceGetComplianceProposalData>) => createQueryKey('charity-compliance-get_compliance_proposal', options);

/**
 * Get Compliance Proposal
 *
 * The organization's open proposal and its newest revision.
 *
 * A proposal presents an assessment of the organization's rules over its recorded facts:
 * the filings identified, the rules excluded, the facts still to record and the conditions
 * left unresolved. It is a record of what was computed, and it changes nothing by itself.
 * None exists until one is generated.
 */
export const charityComplianceGetComplianceProposalOptions = (options: Options<CharityComplianceGetComplianceProposalData>) => queryOptions<CharityComplianceGetComplianceProposalResponse, CharityComplianceGetComplianceProposalError, CharityComplianceGetComplianceProposalResponse, ReturnType<typeof charityComplianceGetComplianceProposalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceProposal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceProposalQueryKey(options)
});

export const charityComplianceListComplianceReviewAsksQueryKey = (options: Options<CharityComplianceListComplianceReviewAsksData>) => createQueryKey('charity-compliance-list_compliance_review_asks', options);

/**
 * List Compliance Review Asks
 *
 * The organization's asks about items of its review, newest first; with `asked_user_id`,
 * those of one person, and with `state`, those `open`, `resolved` (the item was decided),
 * `withdrawn` or `replaced`.
 */
export const charityComplianceListComplianceReviewAsksOptions = (options: Options<CharityComplianceListComplianceReviewAsksData>) => queryOptions<CharityComplianceListComplianceReviewAsksResponse, CharityComplianceListComplianceReviewAsksError, CharityComplianceListComplianceReviewAsksResponse, ReturnType<typeof charityComplianceListComplianceReviewAsksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceReviewAsks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceReviewAsksQueryKey(options)
});

/**
 * Ask About Compliance Review Item
 *
 * Ask a teammate who can make changes in Compliance about one item of the revision being
 * reviewed, with an optional note; they get an email with a link to the review.
 *
 * Asking again about the item replaces the open ask, and the same ask sent again answers the
 * open one. An ask decides nothing: the item stays open until the organization decides it.
 */
export const charityComplianceAskAboutComplianceReviewItemMutation = (options?: Partial<Options<CharityComplianceAskAboutComplianceReviewItemData>>): UseMutationOptions<CharityComplianceAskAboutComplianceReviewItemResponse, CharityComplianceAskAboutComplianceReviewItemError, Options<CharityComplianceAskAboutComplianceReviewItemData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAskAboutComplianceReviewItemResponse, CharityComplianceAskAboutComplianceReviewItemError, Options<CharityComplianceAskAboutComplianceReviewItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAskAboutComplianceReviewItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Compliance Review Ask
 *
 * Withdraw an ask of a teammate. An ask already withdrawn or replaced is answered as it
 * stands.
 */
export const charityComplianceWithdrawComplianceReviewAskMutation = (options?: Partial<Options<CharityComplianceWithdrawComplianceReviewAskData>>): UseMutationOptions<CharityComplianceWithdrawComplianceReviewAskResponse, CharityComplianceWithdrawComplianceReviewAskError, Options<CharityComplianceWithdrawComplianceReviewAskData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceWithdrawComplianceReviewAskResponse, CharityComplianceWithdrawComplianceReviewAskError, Options<CharityComplianceWithdrawComplianceReviewAskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceWithdrawComplianceReviewAsk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate Compliance Proposal Revision
 *
 * Assess the organization's rules over its recorded facts, as of today, and present the
 * result as the proposal's next revision.
 *
 * Each rule in scope gets one result, with its basis: the rule's conditions, how each came
 * out and the facts used. When nothing has moved since the newest revision, that revision
 * is returned and nothing new is recorded. Generating a revision adopts no fact, puts
 * nothing on the calendar and sends nothing.
 */
export const charityComplianceGenerateComplianceProposalRevisionMutation = (options?: Partial<Options<CharityComplianceGenerateComplianceProposalRevisionData>>): UseMutationOptions<CharityComplianceGenerateComplianceProposalRevisionResponse, CharityComplianceGenerateComplianceProposalRevisionError, Options<CharityComplianceGenerateComplianceProposalRevisionData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceGenerateComplianceProposalRevisionResponse, CharityComplianceGenerateComplianceProposalRevisionError, Options<CharityComplianceGenerateComplianceProposalRevisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceGenerateComplianceProposalRevision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceProposalRevisionQueryKey = (options: Options<CharityComplianceGetComplianceProposalRevisionData>) => createQueryKey('charity-compliance-get_compliance_proposal_revision', options);

/**
 * Get Compliance Proposal Revision
 *
 * One revision of the organization's proposal.
 *
 * It says what moved since the previous revision, how many results and items of each kind it
 * holds, and whether it still reads what it was computed from: a fact recorded or corrected,
 * a rule re-versioned, the calendar changed, or the date moving into another period each
 * make it stale. A stale revision is shown as it was; the organization generates a new one.
 */
export const charityComplianceGetComplianceProposalRevisionOptions = (options: Options<CharityComplianceGetComplianceProposalRevisionData>) => queryOptions<CharityComplianceGetComplianceProposalRevisionResponse, CharityComplianceGetComplianceProposalRevisionError, CharityComplianceGetComplianceProposalRevisionResponse, ReturnType<typeof charityComplianceGetComplianceProposalRevisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceProposalRevision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceProposalRevisionQueryKey(options)
});

export const charityComplianceListComplianceProposalItemsQueryKey = (options: Options<CharityComplianceListComplianceProposalItemsData>) => createQueryKey('charity-compliance-list_compliance_proposal_items', options);

/**
 * List Compliance Proposal Items
 *
 * A revision's items, in the order they are presented; with `kind`, one kind's.
 *
 * The kinds are a filing identified (`filing_work`, with the dates it would take on the
 * calendar), a rule excluded (`exclusion`), a fact to record (`question`, with the rules
 * its answer decides), an unresolved condition (`issue`), and a filing already on the
 * calendar that the evaluation now reads otherwise (`change`). A rule's item carries its
 * result.
 */
export const charityComplianceListComplianceProposalItemsOptions = (options: Options<CharityComplianceListComplianceProposalItemsData>) => queryOptions<CharityComplianceListComplianceProposalItemsResponse, CharityComplianceListComplianceProposalItemsError, CharityComplianceListComplianceProposalItemsResponse, ReturnType<typeof charityComplianceListComplianceProposalItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceProposalItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceProposalItemsQueryKey(options)
});

export const charityComplianceListComplianceProposalResultsQueryKey = (options: Options<CharityComplianceListComplianceProposalResultsData>) => createQueryKey('charity-compliance-list_compliance_proposal_results', options);

/**
 * List Compliance Proposal Results
 *
 * The results of a revision's assessment, one per rule in scope, in the rules' order;
 * with `result`, one result's.
 *
 * Each is `filing_identified`, `rule_excluded`, `facts_missing`, `unresolved` or
 * `not_supported`, with its basis on the same object: the rule's citation and source, each
 * condition's outcome, the facts used, the facts missing, and the reason where the rule
 * calls for no filing, is unresolved or is not evaluated.
 */
export const charityComplianceListComplianceProposalResultsOptions = (options: Options<CharityComplianceListComplianceProposalResultsData>) => queryOptions<CharityComplianceListComplianceProposalResultsResponse, CharityComplianceListComplianceProposalResultsError, CharityComplianceListComplianceProposalResultsResponse, ReturnType<typeof charityComplianceListComplianceProposalResultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceProposalResults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceProposalResultsQueryKey(options)
});

export const charityComplianceGetComplianceProposalReviewQueryKey = (options: Options<CharityComplianceGetComplianceProposalReviewData>) => createQueryKey('charity-compliance-get_compliance_proposal_review', options);

/**
 * Get Compliance Proposal Review
 *
 * The review recorded on one revision: each item the organization decided, what the
 * decision did, who decided and when, and the version of the not-a-substitute sentence shown
 * when it was recorded.
 */
export const charityComplianceGetComplianceProposalReviewOptions = (options: Options<CharityComplianceGetComplianceProposalReviewData>) => queryOptions<CharityComplianceGetComplianceProposalReviewResponse, CharityComplianceGetComplianceProposalReviewError, CharityComplianceGetComplianceProposalReviewResponse, ReturnType<typeof charityComplianceGetComplianceProposalReviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceProposalReview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceProposalReviewQueryKey(options)
});

/**
 * Record Compliance Proposal Review
 *
 * Record the organization's decisions on the items of one revision it was shown, with
 * that revision's digest as it was shown.
 *
 * Each decision names an item of the revision: accept or deny a filing identified or a rule
 * excluded, or defer any item. Only the items listed are decided. Accepting a filing puts it
 * on the calendar as the organization's decision; denying one records that the organization
 * chose not to, beside the assessment, which stays as it was computed. A revision is reviewed
 * once: one that changed since it was shown, or already carries a review, is refused so it can
 * be shown again, and the same decisions sent again answer the review already recorded. It
 * signs nothing, authorizes no submission and sends nothing.
 */
export const charityComplianceRecordComplianceProposalReviewMutation = (options?: Partial<Options<CharityComplianceRecordComplianceProposalReviewData>>): UseMutationOptions<CharityComplianceRecordComplianceProposalReviewResponse, CharityComplianceRecordComplianceProposalReviewError, Options<CharityComplianceRecordComplianceProposalReviewData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceProposalReviewResponse, CharityComplianceRecordComplianceProposalReviewError, Options<CharityComplianceRecordComplianceProposalReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceProposalReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceRenewalCyclesQueryKey = (options: Options<CharityComplianceListComplianceRenewalCyclesData>) => createQueryKey('charity-compliance-list_compliance_renewal_cycles', options);

/**
 * List Compliance Renewal Cycles
 *
 * Recorded renewal cycles, including earlier dates and their confirmations.
 */
export const charityComplianceListComplianceRenewalCyclesOptions = (options: Options<CharityComplianceListComplianceRenewalCyclesData>) => queryOptions<CharityComplianceListComplianceRenewalCyclesResponse, CharityComplianceListComplianceRenewalCyclesError, CharityComplianceListComplianceRenewalCyclesResponse, ReturnType<typeof charityComplianceListComplianceRenewalCyclesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceRenewalCycles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceRenewalCyclesQueryKey(options)
});

export const charityComplianceGetComplianceRenewalCycleQueryKey = (options: Options<CharityComplianceGetComplianceRenewalCycleData>) => createQueryKey('charity-compliance-get_compliance_renewal_cycle', options);

/**
 * Get Compliance Renewal Cycle
 *
 * One recorded cycle with its dated changes and confirmation history.
 */
export const charityComplianceGetComplianceRenewalCycleOptions = (options: Options<CharityComplianceGetComplianceRenewalCycleData>) => queryOptions<CharityComplianceGetComplianceRenewalCycleResponse, CharityComplianceGetComplianceRenewalCycleError, CharityComplianceGetComplianceRenewalCycleResponse, ReturnType<typeof charityComplianceGetComplianceRenewalCycleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceRenewalCycle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceRenewalCycleQueryKey(options)
});

/**
 * Add Compliance Renewal Attachment
 *
 * Keep one more document with one renewal cycle, beside its filing and confirmation.
 * The document must already be uploaded for your organization; adding it again changes
 * nothing.
 */
export const charityComplianceAddComplianceRenewalAttachmentMutation = (options?: Partial<Options<CharityComplianceAddComplianceRenewalAttachmentData>>): UseMutationOptions<CharityComplianceAddComplianceRenewalAttachmentResponse, CharityComplianceAddComplianceRenewalAttachmentError, Options<CharityComplianceAddComplianceRenewalAttachmentData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAddComplianceRenewalAttachmentResponse, CharityComplianceAddComplianceRenewalAttachmentError, Options<CharityComplianceAddComplianceRenewalAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAddComplianceRenewalAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attach Compliance Renewal Filed Copy
 *
 * Attach the filing itself, as your organization sent it, to one renewal cycle. A
 * cycle keeps one; the document must already be uploaded for your organization. It is
 * kept with the cycle's records and is not the jurisdiction's confirmation.
 */
export const charityComplianceAttachComplianceRenewalFiledCopyMutation = (options?: Partial<Options<CharityComplianceAttachComplianceRenewalFiledCopyData>>): UseMutationOptions<CharityComplianceAttachComplianceRenewalFiledCopyResponse, CharityComplianceAttachComplianceRenewalFiledCopyError, Options<CharityComplianceAttachComplianceRenewalFiledCopyData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceAttachComplianceRenewalFiledCopyResponse, CharityComplianceAttachComplianceRenewalFiledCopyError, Options<CharityComplianceAttachComplianceRenewalFiledCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceAttachComplianceRenewalFiledCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Renewal Filing
 *
 * Record the jurisdiction's confirmation for one selected renewal cycle.
 */
export const charityComplianceRecordComplianceRenewalFilingMutation = (options?: Partial<Options<CharityComplianceRecordComplianceRenewalFilingData>>): UseMutationOptions<CharityComplianceRecordComplianceRenewalFilingResponse, CharityComplianceRecordComplianceRenewalFilingError, Options<CharityComplianceRecordComplianceRenewalFilingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceRenewalFilingResponse, CharityComplianceRecordComplianceRenewalFilingError, Options<CharityComplianceRecordComplianceRenewalFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceRenewalFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Compliance Renewal Submission
 *
 * Record that your organization sent one renewal cycle's filing, on the date you give,
 * with your own proof of sending if you have one. It records what your organization did
 * and says nothing about what the jurisdiction did; the cycle is not marked filed until
 * the jurisdiction's confirmation is recorded.
 */
export const charityComplianceRecordComplianceRenewalSubmissionMutation = (options?: Partial<Options<CharityComplianceRecordComplianceRenewalSubmissionData>>): UseMutationOptions<CharityComplianceRecordComplianceRenewalSubmissionResponse, CharityComplianceRecordComplianceRenewalSubmissionError, Options<CharityComplianceRecordComplianceRenewalSubmissionData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceRenewalSubmissionResponse, CharityComplianceRecordComplianceRenewalSubmissionError, Options<CharityComplianceRecordComplianceRenewalSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceRenewalSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceAiSettingQueryKey = (options: Options<CharityComplianceGetComplianceAiSettingData>) => createQueryKey('charity-compliance-get_compliance_ai_setting', options);

/**
 * Get Compliance Ai Setting
 *
 * The organization's "Use AI on your organization's data" setting.
 *
 * It covers Givmo's AI only. While it is off, Givmo reads no document with AI, drafts
 * nothing with AI, and prepares or files nothing with AI; everything the organization adds
 * itself works the same. The organization's own connected AI is not governed by it. It is
 * on until the organization turns it off: revision 0 means it was never changed, and then
 * nobody is named.
 */
export const charityComplianceGetComplianceAiSettingOptions = (options: Options<CharityComplianceGetComplianceAiSettingData>) => queryOptions<CharityComplianceGetComplianceAiSettingResponse, CharityComplianceGetComplianceAiSettingError, CharityComplianceGetComplianceAiSettingResponse, ReturnType<typeof charityComplianceGetComplianceAiSettingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceAiSetting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceAiSettingQueryKey(options)
});

/**
 * Set Compliance Ai Setting
 *
 * Turn Givmo's AI on or off for the organization.
 *
 * A Compliance Owner or a Global Admin changes it. The change is made from the revision it
 * was read at: a change made from an older one is refused and nothing is recorded, so it
 * never lands over a change its author did not see. Each change records who made it and
 * when; asking for the value already in force records nothing. Answers with the setting.
 */
export const charityComplianceSetComplianceAiSettingMutation = (options?: Partial<Options<CharityComplianceSetComplianceAiSettingData>>): UseMutationOptions<CharityComplianceSetComplianceAiSettingResponse, CharityComplianceSetComplianceAiSettingError, Options<CharityComplianceSetComplianceAiSettingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceSetComplianceAiSettingResponse, CharityComplianceSetComplianceAiSettingError, Options<CharityComplianceSetComplianceAiSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceSetComplianceAiSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceSigningSettingQueryKey = (options: Options<CharityComplianceGetComplianceSigningSettingData>) => createQueryKey('charity-compliance-get_compliance_signing_setting', options);

/**
 * Get Compliance Signing Setting
 *
 * The organization's sign-in check before signing.
 *
 * None by default: a signed-in member signs by one deliberate act, and the record of the
 * signature names when they last signed in, and how. An organization may require a sign-in
 * again within the last day, within the last 30 minutes, or for every signature. Revision 0
 * means it was never changed.
 */
export const charityComplianceGetComplianceSigningSettingOptions = (options: Options<CharityComplianceGetComplianceSigningSettingData>) => queryOptions<CharityComplianceGetComplianceSigningSettingResponse, CharityComplianceGetComplianceSigningSettingError, CharityComplianceGetComplianceSigningSettingResponse, ReturnType<typeof charityComplianceGetComplianceSigningSettingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceSigningSetting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceSigningSettingQueryKey(options)
});

/**
 * Set Compliance Signing Setting
 *
 * Change the organization's sign-in check before signing.
 *
 * A Compliance Owner or a Global Admin changes it, from the revision it was read at: a
 * change made from an older one is refused and nothing is recorded. Making it stricter
 * asks for nothing; making it less strict asks the person to meet the check in force first.
 * Each change records who made it, when, and what the person showed.
 */
export const charityComplianceSetComplianceSigningSettingMutation = (options?: Partial<Options<CharityComplianceSetComplianceSigningSettingData>>): UseMutationOptions<CharityComplianceSetComplianceSigningSettingResponse, CharityComplianceSetComplianceSigningSettingError, Options<CharityComplianceSetComplianceSigningSettingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceSetComplianceSigningSettingResponse, CharityComplianceSetComplianceSigningSettingError, Options<CharityComplianceSetComplianceSigningSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceSetComplianceSigningSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceSigningPeopleQueryKey = (options: Options<CharityComplianceListComplianceSigningPeopleData>) => createQueryKey('charity-compliance-list_compliance_signing_people', options);

/**
 * List Compliance Signing People
 *
 * Everyone the organization's signing requests hold sign-in details for, newest first:
 * each person who signed, declined or withdrew a signature on a request, completed or not,
 * and each person who sent one. Each comes with how many requests hold their details and the
 * request to direct their removal on.
 */
export const charityComplianceListComplianceSigningPeopleOptions = (options: Options<CharityComplianceListComplianceSigningPeopleData>) => queryOptions<CharityComplianceListComplianceSigningPeopleResponse, CharityComplianceListComplianceSigningPeopleError, CharityComplianceListComplianceSigningPeopleResponse, ReturnType<typeof charityComplianceListComplianceSigningPeopleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceSigningPeople({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceSigningPeopleQueryKey(options)
});

export const charityComplianceListComplianceSigningRequestsQueryKey = (options: Options<CharityComplianceListComplianceSigningRequestsData>) => createQueryKey('charity-compliance-list_compliance_signing_requests', options);

/**
 * List Compliance Signing Requests
 *
 * The organization's signing requests, oldest first; with `filing_case_id`, one filing
 * case's; with `state`, the requests in that state (a request whose sign-by date has passed
 * reads expired).
 */
export const charityComplianceListComplianceSigningRequestsOptions = (options: Options<CharityComplianceListComplianceSigningRequestsData>) => queryOptions<CharityComplianceListComplianceSigningRequestsResponse, CharityComplianceListComplianceSigningRequestsError, CharityComplianceListComplianceSigningRequestsResponse, ReturnType<typeof charityComplianceListComplianceSigningRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceSigningRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceSigningRequestsQueryKey(options)
});

/**
 * Issue Compliance Signing Request
 *
 * Send a filing case's documents out for signature.
 *
 * Name each document at the version its signers sign (Givmo's flattened copy, where the
 * upload had filled fields), a signer for every signature place the form has and the
 * capacity the organization states for each, how the filing will be sent, and the time zone
 * its dates are written in. A note for the signers and a sign-by date are optional.
 * Everyone named needs access to Compliance. One request can be open for a filing case: a
 * package of other documents replaces the open one, and the same package again is refused.
 * Refused, with nothing recorded, where Givmo can't sign a document of the package.
 */
export const charityComplianceIssueComplianceSigningRequestMutation = (options?: Partial<Options<CharityComplianceIssueComplianceSigningRequestData>>): UseMutationOptions<CharityComplianceIssueComplianceSigningRequestResponse, CharityComplianceIssueComplianceSigningRequestError, Options<CharityComplianceIssueComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceIssueComplianceSigningRequestResponse, CharityComplianceIssueComplianceSigningRequestError, Options<CharityComplianceIssueComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceIssueComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceSigningRequestQueryKey = (options: Options<CharityComplianceGetComplianceSigningRequestData>) => createQueryKey('charity-compliance-get_compliance_signing_request', options);

/**
 * Get Compliance Signing Request
 *
 * One signing request with its live version: each document and whether Givmo can sign
 * it, its pages as the signers see them, every signature place and where it stands, the
 * acts on this version, the caller's own places and what they can do now, and what changed
 * around it since it was sent.
 */
export const charityComplianceGetComplianceSigningRequestOptions = (options: Options<CharityComplianceGetComplianceSigningRequestData>) => queryOptions<CharityComplianceGetComplianceSigningRequestResponse, CharityComplianceGetComplianceSigningRequestError, CharityComplianceGetComplianceSigningRequestResponse, ReturnType<typeof charityComplianceGetComplianceSigningRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceSigningRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceSigningRequestQueryKey(options)
});

/**
 * Cancel Compliance Signing Request
 *
 * Cancel an open request, with an optional reason. Cancelling a cancelled request
 * changes nothing.
 */
export const charityComplianceCancelComplianceSigningRequestMutation = (options?: Partial<Options<CharityComplianceCancelComplianceSigningRequestData>>): UseMutationOptions<CharityComplianceCancelComplianceSigningRequestResponse, CharityComplianceCancelComplianceSigningRequestError, Options<CharityComplianceCancelComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceCancelComplianceSigningRequestResponse, CharityComplianceCancelComplianceSigningRequestError, Options<CharityComplianceCancelComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceCancelComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline Compliance Signing Request
 *
 * Decline to sign the live version, with an optional reason for the sender. A decline
 * is not final: the caller can sign later, and the request stays open.
 */
export const charityComplianceDeclineComplianceSigningRequestMutation = (options?: Partial<Options<CharityComplianceDeclineComplianceSigningRequestData>>): UseMutationOptions<CharityComplianceDeclineComplianceSigningRequestResponse, CharityComplianceDeclineComplianceSigningRequestError, Options<CharityComplianceDeclineComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceDeclineComplianceSigningRequestResponse, CharityComplianceDeclineComplianceSigningRequestError, Options<CharityComplianceDeclineComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceDeclineComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceSigningEvidenceQueryKey = (options: Options<CharityComplianceGetComplianceSigningEvidenceData>) => createQueryKey('charity-compliance-get_compliance_signing_evidence', options);

/**
 * Get Compliance Signing Evidence
 *
 * A completed request's signing record: who signed which document, and when, with the
 * sign-in facts each signature's session showed (or when they were removed at the
 * organization's direction), the versions sent, what the signers were shown and the checks on
 * the signed forms. A short-lived link to its exact bytes, as a PDF (the default) or as data
 * (`format=json`), and the record of issuing the link. A request that is not completed has
 * none.
 */
export const charityComplianceGetComplianceSigningEvidenceOptions = (options: Options<CharityComplianceGetComplianceSigningEvidenceData>) => queryOptions<CharityComplianceGetComplianceSigningEvidenceResponse, CharityComplianceGetComplianceSigningEvidenceError, CharityComplianceGetComplianceSigningEvidenceResponse, ReturnType<typeof charityComplianceGetComplianceSigningEvidenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceSigningEvidence({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceSigningEvidenceQueryKey(options)
});

/**
 * Extend Compliance Signing Request
 *
 * Move an open request's sign-by date later. The same date again changes nothing; an
 * earlier one is refused, and so is any change once the date has passed.
 */
export const charityComplianceExtendComplianceSigningRequestMutation = (options?: Partial<Options<CharityComplianceExtendComplianceSigningRequestData>>): UseMutationOptions<CharityComplianceExtendComplianceSigningRequestResponse, CharityComplianceExtendComplianceSigningRequestError, Options<CharityComplianceExtendComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceExtendComplianceSigningRequestResponse, CharityComplianceExtendComplianceSigningRequestError, Options<CharityComplianceExtendComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceExtendComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceSigningExportQueryKey = (options: Options<CharityComplianceGetComplianceSigningExportData>) => createQueryKey('charity-compliance-get_compliance_signing_export', options);

/**
 * Get Compliance Signing Export
 *
 * A completed request's export: one zip holding each signed form, each form as it was
 * prepared, the signing record as a PDF and as data, and a list of each file's SHA-256. A
 * short-lived link to it and the record of issuing the link. Every file is read back and
 * matched to its record first: one that does not match refuses the export rather than hand
 * over something else.
 */
export const charityComplianceGetComplianceSigningExportOptions = (options: Options<CharityComplianceGetComplianceSigningExportData>) => queryOptions<CharityComplianceGetComplianceSigningExportResponse, CharityComplianceGetComplianceSigningExportError, CharityComplianceGetComplianceSigningExportResponse, ReturnType<typeof charityComplianceGetComplianceSigningExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceSigningExport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceSigningExportQueryKey(options)
});

/**
 * Remove Compliance Signing Identity
 *
 * At the organization's direction, remove the sign-in email, IP address and browser of a
 * person who acted on this request or sent it from every signing record the organization holds.
 * The signatures and the signed forms stay as they are. Each record is written again and says
 * the details were removed, and the removal keeps the digests of the files it replaced.
 */
export const charityComplianceRemoveComplianceSigningIdentityMutation = (options?: Partial<Options<CharityComplianceRemoveComplianceSigningIdentityData>>): UseMutationOptions<CharityComplianceRemoveComplianceSigningIdentityResponse, CharityComplianceRemoveComplianceSigningIdentityError, Options<CharityComplianceRemoveComplianceSigningIdentityData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRemoveComplianceSigningIdentityResponse, CharityComplianceRemoveComplianceSigningIdentityError, Options<CharityComplianceRemoveComplianceSigningIdentityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRemoveComplianceSigningIdentity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceGetComplianceSigningRecordLinesQueryKey = (options: Options<CharityComplianceGetComplianceSigningRecordLinesData>) => createQueryKey('charity-compliance-get_compliance_signing_record_lines', options);

/**
 * Get Compliance Signing Record Lines
 *
 * A completed request's signing record as a page shows it beside the signed form: the
 * record's own first-page lines, read from the stored record and matched to it first, each
 * SHA-256 shortened to its first and last four characters. Nothing is handed over, so
 * nothing is added to the download record. A request that is not completed has none.
 */
export const charityComplianceGetComplianceSigningRecordLinesOptions = (options: Options<CharityComplianceGetComplianceSigningRecordLinesData>) => queryOptions<CharityComplianceGetComplianceSigningRecordLinesResponse, CharityComplianceGetComplianceSigningRecordLinesError, CharityComplianceGetComplianceSigningRecordLinesResponse, ReturnType<typeof charityComplianceGetComplianceSigningRecordLinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceSigningRecordLines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceSigningRecordLinesQueryKey(options)
});

/**
 * Revise Compliance Signing Request
 *
 * A new version of an open request: its signers and capacities, the channel, the time
 * zone and the note, from the version it was read at. Every signature starts over. The
 * documents change only by sending a new request.
 */
export const charityComplianceReviseComplianceSigningRequestMutation = (options?: Partial<Options<CharityComplianceReviseComplianceSigningRequestData>>): UseMutationOptions<CharityComplianceReviseComplianceSigningRequestResponse, CharityComplianceReviseComplianceSigningRequestError, Options<CharityComplianceReviseComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceReviseComplianceSigningRequestResponse, CharityComplianceReviseComplianceSigningRequestError, Options<CharityComplianceReviseComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceReviseComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Compliance Signature
 *
 * Withdraw the caller's own signature from the live version, before the request is
 * completed.
 */
export const charityComplianceWithdrawComplianceSignatureMutation = (options?: Partial<Options<CharityComplianceWithdrawComplianceSignatureData>>): UseMutationOptions<CharityComplianceWithdrawComplianceSignatureResponse, CharityComplianceWithdrawComplianceSignatureError, Options<CharityComplianceWithdrawComplianceSignatureData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceWithdrawComplianceSignatureResponse, CharityComplianceWithdrawComplianceSignatureError, Options<CharityComplianceWithdrawComplianceSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceWithdrawComplianceSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign Compliance Signing Request
 *
 * Sign every place the caller holds on the live version, by their typed name, under the
 * statement shown above the button.
 *
 * Name the version as it was read: a request that changed since is refused, and so is a
 * signature already made (the answer names it). Where the organization asks for a recent
 * sign-in, the caller signs in again first.
 */
export const charityComplianceSignComplianceSigningRequestMutation = (options?: Partial<Options<CharityComplianceSignComplianceSigningRequestData>>): UseMutationOptions<CharityComplianceSignComplianceSigningRequestResponse, CharityComplianceSignComplianceSigningRequestError, Options<CharityComplianceSignComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceSignComplianceSigningRequestResponse, CharityComplianceSignComplianceSigningRequestError, Options<CharityComplianceSignComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceSignComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reconcile Compliance Submission Attempt
 *
 * Record what you found about a send whose outcome is uncertain.
 *
 * That the copy arrived, or Givmo staff saw it in the email service's records, records it as
 * sent; that the copy never arrived records it as not sent. Nothing is sent again.
 */
export const charityComplianceReconcileComplianceSubmissionAttemptMutation = (options?: Partial<Options<CharityComplianceReconcileComplianceSubmissionAttemptData>>): UseMutationOptions<CharityComplianceReconcileComplianceSubmissionAttemptResponse, CharityComplianceReconcileComplianceSubmissionAttemptError, Options<CharityComplianceReconcileComplianceSubmissionAttemptData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceReconcileComplianceSubmissionAttemptResponse, CharityComplianceReconcileComplianceSubmissionAttemptError, Options<CharityComplianceReconcileComplianceSubmissionAttemptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceReconcileComplianceSubmissionAttempt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dispatch Compliance Submission
 *
 * Send the authorized filing by email, once.
 *
 * The send is recorded before the email leaves, then what Givmo's email service answered.
 * Repeating a send already made answers it and sends nothing again.
 */
export const charityComplianceDispatchComplianceSubmissionMutation = (options?: Partial<Options<CharityComplianceDispatchComplianceSubmissionData>>): UseMutationOptions<CharityComplianceDispatchComplianceSubmissionResponse, CharityComplianceDispatchComplianceSubmissionError, Options<CharityComplianceDispatchComplianceSubmissionData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceDispatchComplianceSubmissionResponse, CharityComplianceDispatchComplianceSubmissionError, Options<CharityComplianceDispatchComplianceSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceDispatchComplianceSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Compliance Submission Authorization
 *
 * Revoke an authorization to send, so nothing goes under it.
 *
 * Refused while a send under it is in progress or its outcome is uncertain.
 */
export const charityComplianceRevokeComplianceSubmissionAuthorizationMutation = (options?: Partial<Options<CharityComplianceRevokeComplianceSubmissionAuthorizationData>>): UseMutationOptions<CharityComplianceRevokeComplianceSubmissionAuthorizationResponse, CharityComplianceRevokeComplianceSubmissionAuthorizationError, Options<CharityComplianceRevokeComplianceSubmissionAuthorizationData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRevokeComplianceSubmissionAuthorizationResponse, CharityComplianceRevokeComplianceSubmissionAuthorizationError, Options<CharityComplianceRevokeComplianceSubmissionAuthorizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRevokeComplianceSubmissionAuthorization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityComplianceListComplianceSubmissionFollowThroughQueryKey = (options: Options<CharityComplianceListComplianceSubmissionFollowThroughData>) => createQueryKey('charity-compliance-list_compliance_submission_follow_through', options);

/**
 * List Compliance Submission Follow Through
 *
 * What is known about each filing's latest send, newest first.
 *
 * For each filing case with something sent, by Givmo or recorded by your organization: the
 * day it went, how many of the case's sends went before it, and what is known so far, such as
 * the email service's report of its delivery, a record someone in your organization made of
 * the agency's answer, the filing's confirmation on file, or that Givmo can't tell whether
 * its email went. Reading it sends nothing.
 */
export const charityComplianceListComplianceSubmissionFollowThroughOptions = (options: Options<CharityComplianceListComplianceSubmissionFollowThroughData>) => queryOptions<CharityComplianceListComplianceSubmissionFollowThroughResponse, CharityComplianceListComplianceSubmissionFollowThroughError, CharityComplianceListComplianceSubmissionFollowThroughResponse, ReturnType<typeof charityComplianceListComplianceSubmissionFollowThroughQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceSubmissionFollowThrough({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceSubmissionFollowThroughQueryKey(options)
});

export const charityComplianceListComplianceVendorsQueryKey = (options: Options<CharityComplianceListComplianceVendorsData>) => createQueryKey('charity-compliance-list_compliance_vendors', options);

/**
 * List Compliance Vendors
 *
 * Recorded registered-agent and foreign-qualification facts, with provenance.
 */
export const charityComplianceListComplianceVendorsOptions = (options: Options<CharityComplianceListComplianceVendorsData>) => queryOptions<CharityComplianceListComplianceVendorsResponse, CharityComplianceListComplianceVendorsError, CharityComplianceListComplianceVendorsResponse, ReturnType<typeof charityComplianceListComplianceVendorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceListComplianceVendors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceListComplianceVendorsQueryKey(options)
});

export const charityComplianceGetComplianceVendorQueryKey = (options: Options<CharityComplianceGetComplianceVendorData>) => createQueryKey('charity-compliance-get_compliance_vendor', options);

/**
 * Get Compliance Vendor
 *
 * One factual vendor record and each attributed correction.
 */
export const charityComplianceGetComplianceVendorOptions = (options: Options<CharityComplianceGetComplianceVendorData>) => queryOptions<CharityComplianceGetComplianceVendorResponse, CharityComplianceGetComplianceVendorError, CharityComplianceGetComplianceVendorResponse, ReturnType<typeof charityComplianceGetComplianceVendorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityComplianceGetComplianceVendor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityComplianceGetComplianceVendorQueryKey(options)
});

/**
 * Record Compliance Vendor
 *
 * Record or correct one row. Zero revision creates a new caller-chosen id.
 */
export const charityComplianceRecordComplianceVendorMutation = (options?: Partial<Options<CharityComplianceRecordComplianceVendorData>>): UseMutationOptions<CharityComplianceRecordComplianceVendorResponse, CharityComplianceRecordComplianceVendorError, Options<CharityComplianceRecordComplianceVendorData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceRecordComplianceVendorResponse, CharityComplianceRecordComplianceVendorError, Options<CharityComplianceRecordComplianceVendorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceRecordComplianceVendor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link Compliance Vendor Filing
 *
 * Link a record to the library filing it is (CCM-MOD5-RECORD-FILING-LINK): the
 * organization's own statement, recorded on both histories with who made it. The filing
 * then shows the record's renewal date where the library has none. The same link again is
 * answered as it stands.
 */
export const charityComplianceLinkComplianceVendorFilingMutation = (options?: Partial<Options<CharityComplianceLinkComplianceVendorFilingData>>): UseMutationOptions<CharityComplianceLinkComplianceVendorFilingResponse, CharityComplianceLinkComplianceVendorFilingError, Options<CharityComplianceLinkComplianceVendorFilingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceLinkComplianceVendorFilingResponse, CharityComplianceLinkComplianceVendorFilingError, Options<CharityComplianceLinkComplianceVendorFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceLinkComplianceVendorFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlink Compliance Vendor Filing
 *
 * Undo the link between a record and a filing (CCM-MOD5-RECORD-FILING-LINK). Both
 * histories keep the link and record the unlink. A pair no longer linked is answered with the
 * link as it was closed; a pair never linked is refused.
 */
export const charityComplianceUnlinkComplianceVendorFilingMutation = (options?: Partial<Options<CharityComplianceUnlinkComplianceVendorFilingData>>): UseMutationOptions<CharityComplianceUnlinkComplianceVendorFilingResponse, CharityComplianceUnlinkComplianceVendorFilingError, Options<CharityComplianceUnlinkComplianceVendorFilingData>> => {
    const mutationOptions: UseMutationOptions<CharityComplianceUnlinkComplianceVendorFilingResponse, CharityComplianceUnlinkComplianceVendorFilingError, Options<CharityComplianceUnlinkComplianceVendorFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityComplianceUnlinkComplianceVendorFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityEnrollmentListEnrollmentsQueryKey = (options: Options<CharityEnrollmentListEnrollmentsData>) => createQueryKey('charity-enrollment-list_enrollments', options);

/**
 * List Enrollments
 *
 * The organization's own records, newest first.
 *
 * The canonical `{data, meta, links}` envelope, like every other `/charity-admin`
 * listing — a new consumer-surface list takes shape 1, and the bare `{data}` form is
 * reserved for the grandfathered reference lists. Worth noting because the
 * conformance test cannot catch the difference (a bare `{data}` still carries a
 * `data` key), so this is a rule a reader enforces.
 *
 * Paginated for a real reason, not for symmetry: enrollment is a once-ever act, but
 * withdrawn and rejected records accumulate without bound because withdrawing is the
 * sanctioned way to start over.
 */
export const charityEnrollmentListEnrollmentsOptions = (options: Options<CharityEnrollmentListEnrollmentsData>) => queryOptions<CharityEnrollmentListEnrollmentsResponse, CharityEnrollmentListEnrollmentsError, CharityEnrollmentListEnrollmentsResponse, ReturnType<typeof charityEnrollmentListEnrollmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityEnrollmentListEnrollments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityEnrollmentListEnrollmentsQueryKey(options)
});

/**
 * Create Enrollment Draft
 *
 * Start the organization's enrollment record.
 *
 * 201 with a `Location` header, because this mints a resource the caller then works
 * against by id. A second live record is refused rather than silently created:
 * enrollment is a once-ever act per entity.
 *
 * Both of the draft's optional fields are applied. `fiscal_year_end_month` was
 * accepted, range-checked, and then never passed to the command, so a caller who
 * stated a June year-end at creation got a record carrying nothing and had to PATCH
 * the same value in afterwards. The field is settled at submission either way, so
 * nothing downstream was wrong — it was the caller's stated answer that was dropped.
 */
export const charityEnrollmentCreateEnrollmentDraftMutation = (options?: Partial<Options<CharityEnrollmentCreateEnrollmentDraftData>>): UseMutationOptions<CharityEnrollmentCreateEnrollmentDraftResponse, CharityEnrollmentCreateEnrollmentDraftError, Options<CharityEnrollmentCreateEnrollmentDraftData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentCreateEnrollmentDraftResponse, CharityEnrollmentCreateEnrollmentDraftError, Options<CharityEnrollmentCreateEnrollmentDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentCreateEnrollmentDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityEnrollmentGetEnrollmentQueryKey = (options: Options<CharityEnrollmentGetEnrollmentData>) => createQueryKey('charity-enrollment-get_enrollment', options);

/**
 * Get Enrollment
 *
 * One record and its event log.
 *
 * The log is the record of what happened and in what order; it is what makes the
 * surface able to say where the record has got to without asserting anything about
 * what happens next.
 */
export const charityEnrollmentGetEnrollmentOptions = (options: Options<CharityEnrollmentGetEnrollmentData>) => queryOptions<CharityEnrollmentGetEnrollmentResponse, CharityEnrollmentGetEnrollmentError, CharityEnrollmentGetEnrollmentResponse, ReturnType<typeof charityEnrollmentGetEnrollmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityEnrollmentGetEnrollment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityEnrollmentGetEnrollmentQueryKey(options)
});

/**
 * Update Enrollment Draft
 *
 * Edit the record's content while it is still editable.
 *
 * PATCH, and absent-vs-null is load-bearing: only fields the caller actually sent are
 * applied, so a partial update cannot blank a field the caller never mentioned. The
 * command's `model_fields_set` is what carries that through to the service.
 */
export const charityEnrollmentUpdateEnrollmentDraftMutation = (options?: Partial<Options<CharityEnrollmentUpdateEnrollmentDraftData>>): UseMutationOptions<CharityEnrollmentUpdateEnrollmentDraftResponse, CharityEnrollmentUpdateEnrollmentDraftError, Options<CharityEnrollmentUpdateEnrollmentDraftData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentUpdateEnrollmentDraftResponse, CharityEnrollmentUpdateEnrollmentDraftError, Options<CharityEnrollmentUpdateEnrollmentDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentUpdateEnrollmentDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Backfill Choice
 *
 * Record how this organization's history comes in.
 *
 * Once. Opening balances and full history are different shapes, and the choice decides
 * which doors render and which rails a run may drive — so recording a DIFFERENT one
 * afterwards answers 409 and is an operator-mediated correction. Recording the same one
 * again is a replay and answers with the record's current state.
 */
export const charityEnrollmentRecordBackfillChoiceMutation = (options?: Partial<Options<CharityEnrollmentRecordBackfillChoiceData>>): UseMutationOptions<CharityEnrollmentRecordBackfillChoiceResponse, CharityEnrollmentRecordBackfillChoiceError, Options<CharityEnrollmentRecordBackfillChoiceData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentRecordBackfillChoiceResponse, CharityEnrollmentRecordBackfillChoiceError, Options<CharityEnrollmentRecordBackfillChoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentRecordBackfillChoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Import Run
 *
 * Post into your organization's books — a cut-in, or a month of your bank activity.
 *
 * `idempotency_key` is required: sending the same key again answers with the run it
 * already named rather than running a second time. A second import over the same window
 * is a real second act, and only the caller knows which one this is.
 *
 * The rails take opposite inputs. A cut-in states a position as at a date, so it carries
 * `effective_date` and reads its figures from this record. A STANDING run covers one
 * `period` and carries that period's own population: `bank_export_csv` for the bank rail
 * (the institution's own CSV, unedited, classified through the bank-flow map recorded for
 * this organization) and `platform_facts` + `platform_facts_digest` for the platform rail.
 * A field the answering rail does not read is refused rather than dropped.
 *
 * A month may carry BOTH standing rails, and then it is ONE run: send both payloads and
 * the period posts as a single act. `rail` names the rail you are declaring and must be
 * one of the rails you sent — the run row records that declaration, while the bound
 * record is what carries the full per-rail account of what posted.
 *
 * The response is the run's TRUTHFUL state — it may have bound its record, or it may name
 * why it did not. Runs are refused, not queued: nothing here retries in the background.
 */
export const charityEnrollmentStartImportRunMutation = (options?: Partial<Options<CharityEnrollmentStartImportRunData>>): UseMutationOptions<CharityEnrollmentStartImportRunResponse, CharityEnrollmentStartImportRunError, Options<CharityEnrollmentStartImportRunData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentStartImportRunResponse, CharityEnrollmentStartImportRunError, Options<CharityEnrollmentStartImportRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentStartImportRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityEnrollmentListMappingRowsQueryKey = (options: Options<CharityEnrollmentListMappingRowsData>) => createQueryKey('charity-enrollment-list_mapping_rows', options);

/**
 * List Mapping Rows
 *
 * Every source account and merchant, and where each one posts.
 *
 * `unresolved_only=true` is the working view: what still stands between this
 * organization and a run. It includes DECLINED rows as well as untouched ones — a row
 * somebody looked at and would not answer still blocks, and hiding it would leave a run
 * refused by something nobody could find.
 */
export const charityEnrollmentListMappingRowsOptions = (options: Options<CharityEnrollmentListMappingRowsData>) => queryOptions<CharityEnrollmentListMappingRowsResponse, CharityEnrollmentListMappingRowsError, CharityEnrollmentListMappingRowsResponse, ReturnType<typeof charityEnrollmentListMappingRowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityEnrollmentListMappingRows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityEnrollmentListMappingRowsQueryKey(options)
});

/**
 * Resolve Mapping Row
 *
 * Confirm, correct or decline ONE source account or merchant.
 *
 * One row per call, and there is no bulk form. The tie a run computes proves that
 * everything the source held came across and that each source account's total matches;
 * it proves nothing at all about whether an account was mapped to the right place. This
 * is where that gets decided.
 */
export const charityEnrollmentResolveMappingRowMutation = (options?: Partial<Options<CharityEnrollmentResolveMappingRowData>>): UseMutationOptions<CharityEnrollmentResolveMappingRowResponse, CharityEnrollmentResolveMappingRowError, Options<CharityEnrollmentResolveMappingRowData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentResolveMappingRowResponse, CharityEnrollmentResolveMappingRowError, Options<CharityEnrollmentResolveMappingRowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentResolveMappingRow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert Entity Maps
 *
 * Record one rail's map and put every subject it names in front of a reviewer.
 *
 * PUT because an organization has exactly one map in force per rail. Recording again
 * does not edit the previous version — it writes a new one and supersedes the old, so an
 * import record that pinned an earlier version still names content that exists.
 *
 * The document is built through the accounting engine's own strict loader: an unknown
 * key, a missing required key, or a map naming other books is a 400 carrying the
 * loader's own message.
 */
export const charityEnrollmentUpsertEntityMapsMutation = (options?: Partial<Options<CharityEnrollmentUpsertEntityMapsData>>): UseMutationOptions<CharityEnrollmentUpsertEntityMapsResponse, CharityEnrollmentUpsertEntityMapsError, Options<CharityEnrollmentUpsertEntityMapsData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentUpsertEntityMapsResponse, CharityEnrollmentUpsertEntityMapsError, Options<CharityEnrollmentUpsertEntityMapsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentUpsertEntityMaps({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityEnrollmentListOnboardingRecordsQueryKey = (options: Options<CharityEnrollmentListOnboardingRecordsData>) => createQueryKey('charity-enrollment-list_onboarding_records', options);

/**
 * List Onboarding Records
 *
 * Your organization's onboarding records, oldest first.
 *
 * A stack, and only that: one entry for the books being opened, then one
 * for each import that brought something in. It grows whenever something real is added,
 * and nothing in it says setup is finished — no organization arrives with complete
 * historical books, and the books' own open items are where readiness is read from.
 */
export const charityEnrollmentListOnboardingRecordsOptions = (options: Options<CharityEnrollmentListOnboardingRecordsData>) => queryOptions<CharityEnrollmentListOnboardingRecordsResponse, CharityEnrollmentListOnboardingRecordsError, CharityEnrollmentListOnboardingRecordsResponse, ReturnType<typeof charityEnrollmentListOnboardingRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityEnrollmentListOnboardingRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityEnrollmentListOnboardingRecordsQueryKey(options)
});

export const charityEnrollmentListOpeningBalanceFieldsQueryKey = (options: Options<CharityEnrollmentListOpeningBalanceFieldsData>) => createQueryKey('charity-enrollment-list_opening_balance_fields', options);

/**
 * List Opening Balance Fields
 *
 * Each account's opening figure — what was proposed, and what you recorded.
 *
 * Amounts are debit-positive cents; a credit balance is negative, which is the same
 * convention a trial balance uses.
 */
export const charityEnrollmentListOpeningBalanceFieldsOptions = (options: Options<CharityEnrollmentListOpeningBalanceFieldsData>) => queryOptions<CharityEnrollmentListOpeningBalanceFieldsResponse, CharityEnrollmentListOpeningBalanceFieldsError, CharityEnrollmentListOpeningBalanceFieldsResponse, ReturnType<typeof charityEnrollmentListOpeningBalanceFieldsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityEnrollmentListOpeningBalanceFields({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityEnrollmentListOpeningBalanceFieldsQueryKey(options)
});

/**
 * Seed Opening Balance Fields
 *
 * Put accounts in front of your organization, each with the figure proposed for it.
 *
 * This PROPOSES; it records nothing against the organization. Every account is then
 * answered on its own through the resolution route below, and the row keeps which of
 * the three answers a person gave.
 *
 * Re-seeding an account whose proposed figure has changed returns it to unanswered — a
 * figure that moved has not been agreed to.
 */
export const charityEnrollmentSeedOpeningBalanceFieldsMutation = (options?: Partial<Options<CharityEnrollmentSeedOpeningBalanceFieldsData>>): UseMutationOptions<CharityEnrollmentSeedOpeningBalanceFieldsResponse, CharityEnrollmentSeedOpeningBalanceFieldsError, Options<CharityEnrollmentSeedOpeningBalanceFieldsData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentSeedOpeningBalanceFieldsResponse, CharityEnrollmentSeedOpeningBalanceFieldsError, Options<CharityEnrollmentSeedOpeningBalanceFieldsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentSeedOpeningBalanceFields({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Opening Balance Field
 *
 * Confirm, correct or decline ONE account's opening figure.
 *
 * One account per call. What your organization records here becomes a line of an entry
 * that cannot be edited afterwards, so each figure is somebody's own answer rather than
 * a page they agreed with. Confirming takes the proposed figure; correcting records
 * yours instead; declining records that you would not state one, and the import waits.
 */
export const charityEnrollmentConfirmOpeningBalanceFieldMutation = (options?: Partial<Options<CharityEnrollmentConfirmOpeningBalanceFieldData>>): UseMutationOptions<CharityEnrollmentConfirmOpeningBalanceFieldResponse, CharityEnrollmentConfirmOpeningBalanceFieldError, Options<CharityEnrollmentConfirmOpeningBalanceFieldData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentConfirmOpeningBalanceFieldResponse, CharityEnrollmentConfirmOpeningBalanceFieldError, Options<CharityEnrollmentConfirmOpeningBalanceFieldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentConfirmOpeningBalanceField({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Enrollment
 *
 * Submit the record.
 *
 * The response is the record's TRUTHFUL state afterwards, which may be `submitted` or
 * `approved` — approval fires automatically the moment the precondition set is
 * satisfied, and does not when it is not. The caller renders what it is given rather
 * than assuming submission means approval.
 *
 * A replay returns the current state rather than refusing, so a caller who lost the
 * response and retried gets the outcome instead of an error about the retry.
 */
export const charityEnrollmentSubmitEnrollmentMutation = (options?: Partial<Options<CharityEnrollmentSubmitEnrollmentData>>): UseMutationOptions<CharityEnrollmentSubmitEnrollmentResponse, CharityEnrollmentSubmitEnrollmentError, Options<CharityEnrollmentSubmitEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentSubmitEnrollmentResponse, CharityEnrollmentSubmitEnrollmentError, Options<CharityEnrollmentSubmitEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentSubmitEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Enrollment
 *
 * Withdraw a draft or submitted record.
 *
 * An approved record refuses with a 400 — by approval it carries a permanent ledger
 * identity a committed store row may already be using, and the store never reuses
 * one. A withdrawn record does not block a fresh enrollment; that is what the state
 * is for.
 */
export const charityEnrollmentWithdrawEnrollmentMutation = (options?: Partial<Options<CharityEnrollmentWithdrawEnrollmentData>>): UseMutationOptions<CharityEnrollmentWithdrawEnrollmentResponse, CharityEnrollmentWithdrawEnrollmentError, Options<CharityEnrollmentWithdrawEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<CharityEnrollmentWithdrawEnrollmentResponse, CharityEnrollmentWithdrawEnrollmentError, Options<CharityEnrollmentWithdrawEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityEnrollmentWithdrawEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept Charity Invite
 *
 * Redeem an invite token → create a ``charity_admin`` membership with the
 * invited role (``@is_authenticated``; the caller need not have a membership
 * yet). The caller's VERIFIED email (from the Firebase ID token —
 * ``request.state.idp_user``, NEVER the body) must match the invite's bound
 * email. Single-use + expiry enforced; every invalid condition (unknown / spent
 * / expired / wrong email) collapses to the SAME 400 (no oracle). Returns the
 * new membership (charity + role).
 */
export const charityAdminAcceptCharityInviteMutation = (options?: Partial<Options<CharityAdminAcceptCharityInviteData>>): UseMutationOptions<CharityAdminAcceptCharityInviteResponse, CharityAdminAcceptCharityInviteError, Options<CharityAdminAcceptCharityInviteData>> => {
    const mutationOptions: UseMutationOptions<CharityAdminAcceptCharityInviteResponse, CharityAdminAcceptCharityInviteError, Options<CharityAdminAcceptCharityInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAdminAcceptCharityInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityAdminListMyMembershipsQueryKey = (options?: Options<CharityAdminListMyMembershipsData>) => createQueryKey('charity-admin-list_my_memberships', options);

/**
 * List My Memberships
 */
export const charityAdminListMyMembershipsOptions = (options?: Options<CharityAdminListMyMembershipsData>) => queryOptions<CharityAdminListMyMembershipsResponse, DefaultError, CharityAdminListMyMembershipsResponse, ReturnType<typeof charityAdminListMyMembershipsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityAdminListMyMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityAdminListMyMembershipsQueryKey(options)
});

export const charityCollectionsDiscoverCharityCollectionsQueryKey = (options?: Options<CharityCollectionsDiscoverCharityCollectionsData>) => createQueryKey('charity-collections-discover_charity_collections', options);

/**
 * Discover Charity Collections
 *
 * CC-BE18: GLOBAL discovery browse — the token-permissive, cross-creator
 * no-login funnel. NO `@is_authenticated` (mirrors `get_charity_collection` /
 * the fundraiser browse): `user` may be None (anonymous).
 *
 * The service/repo apply the SERVER-SIDE discoverable-set filter
 * (`visibility == PUBLIC AND status == ACTIVE AND unlisted_at IS NULL`). The
 * visibility clause is `== PUBLIC` — DELIBERATELY STRICTER than
 * `is_publicly_visible` (`!= PRIVATE`, which includes UNLISTED): UNLISTED
 * (link-only) collections are intentionally NOT browsable here (do not loosen
 * it to `!= PRIVATE` — see the repo `discover` docstring). That filter is
 * requester-independent and is the ONLY gate, so an anonymous and an
 * authenticated non-owner caller both see EXACTLY the discoverable set: a
 * private, unlisted-visibility, creator-deactivated, or super-admin-unlisted
 * collection can NEVER appear here. `show_on_profile` does NOT gate discovery
 * (it gates only the profile row).
 * Optional `q` is a simple name match; newest-first by default.
 */
export const charityCollectionsDiscoverCharityCollectionsOptions = (options?: Options<CharityCollectionsDiscoverCharityCollectionsData>) => queryOptions<CharityCollectionsDiscoverCharityCollectionsResponse, CharityCollectionsDiscoverCharityCollectionsError, CharityCollectionsDiscoverCharityCollectionsResponse, ReturnType<typeof charityCollectionsDiscoverCharityCollectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityCollectionsDiscoverCharityCollections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityCollectionsDiscoverCharityCollectionsQueryKey(options)
});

/**
 * Create Charity Collection
 */
export const charityCollectionsCreateCharityCollectionMutation = (options?: Partial<Options<CharityCollectionsCreateCharityCollectionData>>): UseMutationOptions<CharityCollectionsCreateCharityCollectionResponse, CharityCollectionsCreateCharityCollectionError, Options<CharityCollectionsCreateCharityCollectionData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsCreateCharityCollectionResponse, CharityCollectionsCreateCharityCollectionError, Options<CharityCollectionsCreateCharityCollectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsCreateCharityCollection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Charity Collection
 */
export const charityCollectionsDeleteCharityCollectionMutation = (options?: Partial<Options<CharityCollectionsDeleteCharityCollectionData>>): UseMutationOptions<CharityCollectionsDeleteCharityCollectionResponse, CharityCollectionsDeleteCharityCollectionError, Options<CharityCollectionsDeleteCharityCollectionData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsDeleteCharityCollectionResponse, CharityCollectionsDeleteCharityCollectionError, Options<CharityCollectionsDeleteCharityCollectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsDeleteCharityCollection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityCollectionsGetCharityCollectionQueryKey = (options: Options<CharityCollectionsGetCharityCollectionData>) => createQueryKey('charity-collections-get_charity_collection', options);

/**
 * Get Charity Collection
 *
 * Token-permissive detail — NO `@is_authenticated` (mirrors `get_etf`):
 * `user` may be None. The service applies the server-side visibility gate
 * (public → anyone; unlisted → by direct id; private → owner-only; else 404).
 */
export const charityCollectionsGetCharityCollectionOptions = (options: Options<CharityCollectionsGetCharityCollectionData>) => queryOptions<CharityCollectionsGetCharityCollectionResponse, CharityCollectionsGetCharityCollectionError, CharityCollectionsGetCharityCollectionResponse, ReturnType<typeof charityCollectionsGetCharityCollectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityCollectionsGetCharityCollection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityCollectionsGetCharityCollectionQueryKey(options)
});

/**
 * Update Charity Collection
 */
export const charityCollectionsUpdateCharityCollectionMutation = (options?: Partial<Options<CharityCollectionsUpdateCharityCollectionData>>): UseMutationOptions<CharityCollectionsUpdateCharityCollectionResponse, CharityCollectionsUpdateCharityCollectionError, Options<CharityCollectionsUpdateCharityCollectionData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsUpdateCharityCollectionResponse, CharityCollectionsUpdateCharityCollectionError, Options<CharityCollectionsUpdateCharityCollectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsUpdateCharityCollection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Charity To Collection
 */
export const charityCollectionsAddCharityToCollectionMutation = (options?: Partial<Options<CharityCollectionsAddCharityToCollectionData>>): UseMutationOptions<CharityCollectionsAddCharityToCollectionResponse, CharityCollectionsAddCharityToCollectionError, Options<CharityCollectionsAddCharityToCollectionData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsAddCharityToCollectionResponse, CharityCollectionsAddCharityToCollectionError, Options<CharityCollectionsAddCharityToCollectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsAddCharityToCollection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Charity From Collection
 */
export const charityCollectionsRemoveCharityFromCollectionMutation = (options?: Partial<Options<CharityCollectionsRemoveCharityFromCollectionData>>): UseMutationOptions<CharityCollectionsRemoveCharityFromCollectionResponse, CharityCollectionsRemoveCharityFromCollectionError, Options<CharityCollectionsRemoveCharityFromCollectionData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsRemoveCharityFromCollectionResponse, CharityCollectionsRemoveCharityFromCollectionError, Options<CharityCollectionsRemoveCharityFromCollectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsRemoveCharityFromCollection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Charity Collection Donation
 *
 * Authenticated Collection donation: ONE charge → equal-weight penny-exact
 * split → N sub-donations + ONE consolidated receipt. The service re-reads the
 * collection (404 if unreadable). Mirrors `create_fundraiser_donation` —
 * INCLUDING the mandatory per-sub-donation grant-dispatch loop below.
 */
export const charityCollectionsCreateCharityCollectionDonationMutation = (options?: Partial<Options<CharityCollectionsCreateCharityCollectionDonationData>>): UseMutationOptions<CharityCollectionsCreateCharityCollectionDonationResponse, CharityCollectionsCreateCharityCollectionDonationError, Options<CharityCollectionsCreateCharityCollectionDonationData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsCreateCharityCollectionDonationResponse, CharityCollectionsCreateCharityCollectionDonationError, Options<CharityCollectionsCreateCharityCollectionDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsCreateCharityCollectionDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityCollectionsGetCharityCollectionPostsQueryKey = (options: Options<CharityCollectionsGetCharityCollectionPostsData>) => createQueryKey('charity-collections-get_charity_collection_posts', options);

/**
 * Get Charity Collection Posts
 *
 * CC-BE9: the Charity Collection activity feed. Direct mirror of
 * `/fundraiser/{fundraiser_id}/posts` (posts.py), placed on the collections
 * router — only authenticated users can list a collection's posts.
 *
 * The service (`get_collection_posts`) reuses the SAME server-side visibility
 * gate as the collection detail GET (public→anyone, unlisted→by direct id,
 * private→owner-only/404), so a private/unlisted collection's feed 404s for a
 * non-owner and never leaks posts of a non-public collection.
 */
export const charityCollectionsGetCharityCollectionPostsOptions = (options: Options<CharityCollectionsGetCharityCollectionPostsData>) => queryOptions<CharityCollectionsGetCharityCollectionPostsResponse, CharityCollectionsGetCharityCollectionPostsError, CharityCollectionsGetCharityCollectionPostsResponse, ReturnType<typeof charityCollectionsGetCharityCollectionPostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityCollectionsGetCharityCollectionPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityCollectionsGetCharityCollectionPostsQueryKey(options)
});

/**
 * Upload Charity Collection Picture
 */
export const charityCollectionsUploadCharityCollectionPictureMutation = (options?: Partial<Options<CharityCollectionsUploadCharityCollectionPictureData>>): UseMutationOptions<CharityCollectionsUploadCharityCollectionPictureResponse, CharityCollectionsUploadCharityCollectionPictureError, Options<CharityCollectionsUploadCharityCollectionPictureData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsUploadCharityCollectionPictureResponse, CharityCollectionsUploadCharityCollectionPictureError, Options<CharityCollectionsUploadCharityCollectionPictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsUploadCharityCollectionPicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Charity Collection Visibility
 */
export const charityCollectionsSetCharityCollectionVisibilityMutation = (options?: Partial<Options<CharityCollectionsSetCharityCollectionVisibilityData>>): UseMutationOptions<CharityCollectionsSetCharityCollectionVisibilityResponse, CharityCollectionsSetCharityCollectionVisibilityError, Options<CharityCollectionsSetCharityCollectionVisibilityData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsSetCharityCollectionVisibilityResponse, CharityCollectionsSetCharityCollectionVisibilityError, Options<CharityCollectionsSetCharityCollectionVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsSetCharityCollectionVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postsGetCharityPostsQueryKey = (options: Options<PostsGetCharityPostsData>) => createQueryKey('posts-get_charity_posts', options);

/**
 * Get Charity Posts
 */
export const postsGetCharityPostsOptions = (options: Options<PostsGetCharityPostsData>) => queryOptions<PostsGetCharityPostsResponse, PostsGetCharityPostsError, PostsGetCharityPostsResponse, ReturnType<typeof postsGetCharityPostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetCharityPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetCharityPostsQueryKey(options)
});

export const companiesGetPublicCompanyQueryKey = (options: Options<CompaniesGetPublicCompanyData>) => createQueryKey('companies-get_public_company', options);

/**
 * Get Public Company
 */
export const companiesGetPublicCompanyOptions = (options: Options<CompaniesGetPublicCompanyData>) => queryOptions<CompaniesGetPublicCompanyResponse, CompaniesGetPublicCompanyError, CompaniesGetPublicCompanyResponse, ReturnType<typeof companiesGetPublicCompanyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetPublicCompany({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetPublicCompanyQueryKey(options)
});

export const companiesGetPublicCompanyStatisticsQueryKey = (options: Options<CompaniesGetPublicCompanyStatisticsData>) => createQueryKey('companies-get_public_company_statistics', options);

/**
 * Get Public Company Statistics
 */
export const companiesGetPublicCompanyStatisticsOptions = (options: Options<CompaniesGetPublicCompanyStatisticsData>) => queryOptions<CompaniesGetPublicCompanyStatisticsResponse, CompaniesGetPublicCompanyStatisticsError, CompaniesGetPublicCompanyStatisticsResponse, ReturnType<typeof companiesGetPublicCompanyStatisticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetPublicCompanyStatistics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetPublicCompanyStatisticsQueryKey(options)
});

export const stepsCompetitionsGetCompanyPublicStepsCompetitionsQueryKey = (options: Options<StepsCompetitionsGetCompanyPublicStepsCompetitionsData>) => createQueryKey('steps-competitions-get_company_public_steps_competitions', options);

/**
 * Get Company Public Steps Competitions
 *
 * PUBLIC competitions for a company's public profile (§2.4). Any signed-in
 * user may read (PUBLIC-visibility competitions are, by definition, visible to
 * any signed-in user); only PUBLIC, non-DRAFT competitions appear.
 */
export const stepsCompetitionsGetCompanyPublicStepsCompetitionsOptions = (options: Options<StepsCompetitionsGetCompanyPublicStepsCompetitionsData>) => queryOptions<StepsCompetitionsGetCompanyPublicStepsCompetitionsResponse, StepsCompetitionsGetCompanyPublicStepsCompetitionsError, StepsCompetitionsGetCompanyPublicStepsCompetitionsResponse, ReturnType<typeof stepsCompetitionsGetCompanyPublicStepsCompetitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepsCompetitionsGetCompanyPublicStepsCompetitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepsCompetitionsGetCompanyPublicStepsCompetitionsQueryKey(options)
});

export const orgComplianceOrgListComplianceArtifactsQueryKey = (options: Options<OrgComplianceOrgListComplianceArtifactsData>) => createQueryKey('org-compliance-org_list_compliance_artifacts', options);

/**
 * Org List Compliance Artifacts
 *
 * The documents your organization has recorded, most recent first.
 *
 * `attached_at` is set once a document has been recorded as the confirmation on a
 * filing or against an imported registration. From that point it is part of your
 * organization's filing record and stays there — it cannot be removed, and that does
 * not change if the filing it backed is later withdrawn.
 */
export const orgComplianceOrgListComplianceArtifactsOptions = (options: Options<OrgComplianceOrgListComplianceArtifactsData>) => queryOptions<OrgComplianceOrgListComplianceArtifactsResponse, OrgComplianceOrgListComplianceArtifactsError, OrgComplianceOrgListComplianceArtifactsResponse, ReturnType<typeof orgComplianceOrgListComplianceArtifactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceArtifacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceArtifactsQueryKey(options)
});

/**
 * Org Confirm Compliance Artifact
 *
 * Confirm an upload finished, recording the document in your organization's records.
 *
 * The document has to actually be there: a reference to an upload that did not finish
 * is refused and nothing is recorded. That is what lets the id this returns be used as
 * the confirmation on a filing record — the register never points at a document that
 * is not in your records.
 *
 * A document is recorded once and is never edited afterwards. Uploading a corrected
 * version records a separate document rather than changing this one.
 */
export const orgComplianceOrgConfirmComplianceArtifactMutation = (options?: Partial<Options<OrgComplianceOrgConfirmComplianceArtifactData>>): UseMutationOptions<OrgComplianceOrgConfirmComplianceArtifactResponse, OrgComplianceOrgConfirmComplianceArtifactError, Options<OrgComplianceOrgConfirmComplianceArtifactData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgConfirmComplianceArtifactResponse, OrgComplianceOrgConfirmComplianceArtifactError, Options<OrgComplianceOrgConfirmComplianceArtifactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgConfirmComplianceArtifact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Issue Compliance Artifact Upload Url
 *
 * Get a short-lived link for uploading one document.
 *
 * Upload the file straight to the returned link with a PUT, using exactly the content
 * type you declared here, then confirm it with the object reference this returns.
 * Nothing is recorded until you confirm — the document is not in your records until
 * the upload has finished and you say so.
 *
 * PDFs, Word files and images only. A macro-enabled Word file (.docm) is stored as a
 * .docx with its macros removed; a Word file is always downloaded, never shown inline.
 */
export const orgComplianceOrgIssueComplianceArtifactUploadUrlMutation = (options?: Partial<Options<OrgComplianceOrgIssueComplianceArtifactUploadUrlData>>): UseMutationOptions<OrgComplianceOrgIssueComplianceArtifactUploadUrlResponse, OrgComplianceOrgIssueComplianceArtifactUploadUrlError, Options<OrgComplianceOrgIssueComplianceArtifactUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgIssueComplianceArtifactUploadUrlResponse, OrgComplianceOrgIssueComplianceArtifactUploadUrlError, Options<OrgComplianceOrgIssueComplianceArtifactUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgIssueComplianceArtifactUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Delete Compliance Artifact
 *
 * Remove a document your organization has not recorded against anything yet.
 *
 * A document that has been recorded as the confirmation on a filing, or against an
 * imported registration, is part of your organization's filing record and cannot be
 * removed. That stays true afterwards: withdrawing the filing, dismissing the
 * obligation, or recording a later submission does not make the document removable
 * again, because the record of what was filed still refers to it.
 */
export const orgComplianceOrgDeleteComplianceArtifactMutation = (options?: Partial<Options<OrgComplianceOrgDeleteComplianceArtifactData>>): UseMutationOptions<OrgComplianceOrgDeleteComplianceArtifactResponse, OrgComplianceOrgDeleteComplianceArtifactError, Options<OrgComplianceOrgDeleteComplianceArtifactData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgDeleteComplianceArtifactResponse, OrgComplianceOrgDeleteComplianceArtifactError, Options<OrgComplianceOrgDeleteComplianceArtifactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgDeleteComplianceArtifact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceArtifactDownloadQueryKey = (options: Options<OrgComplianceOrgGetComplianceArtifactDownloadData>) => createQueryKey('org-compliance-org_get_compliance_artifact_download', options);

/**
 * Org Get Compliance Artifact Download
 *
 * A short-lived link for downloading one document.
 *
 * Minted for this request and not stored anywhere: fetch a new one each time rather
 * than keeping the link.
 */
export const orgComplianceOrgGetComplianceArtifactDownloadOptions = (options: Options<OrgComplianceOrgGetComplianceArtifactDownloadData>) => queryOptions<OrgComplianceOrgGetComplianceArtifactDownloadResponse, OrgComplianceOrgGetComplianceArtifactDownloadError, OrgComplianceOrgGetComplianceArtifactDownloadResponse, ReturnType<typeof orgComplianceOrgGetComplianceArtifactDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceArtifactDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceArtifactDownloadQueryKey(options)
});

export const orgComplianceOrgListComplianceCandidatesQueryKey = (options: Options<OrgComplianceOrgListComplianceCandidatesData>) => createQueryKey('org-compliance-org_list_compliance_candidates', options);

/**
 * Org List Compliance Candidates
 *
 * Candidate obligations awaiting the organization's review.
 *
 * Each row carries the jurisdiction's rule, its citation and source date, and the
 * parameters the organization recorded — review each with your counsel. A source date
 * is the day the official source was checked live where `rule_source_date_basis` is
 * `checked_live`, and the day Givmo's research notes recorded the rule where it is
 * `research_notes`. Candidates resting on the nationwide-or-online answer are marked.
 */
export const orgComplianceOrgListComplianceCandidatesOptions = (options: Options<OrgComplianceOrgListComplianceCandidatesData>) => queryOptions<OrgComplianceOrgListComplianceCandidatesResponse, OrgComplianceOrgListComplianceCandidatesError, OrgComplianceOrgListComplianceCandidatesResponse, ReturnType<typeof orgComplianceOrgListComplianceCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceCandidatesQueryKey(options)
});

/**
 * Org Confirm Compliance Candidate
 *
 * Confirm ONE candidate into the organization's register.
 *
 * This route takes exactly one candidate. Confirmation pins the rule version reviewed,
 * and a later change to that rule is flagged for re-review rather than applied.
 */
export const orgComplianceOrgConfirmComplianceCandidateMutation = (options?: Partial<Options<OrgComplianceOrgConfirmComplianceCandidateData>>): UseMutationOptions<OrgComplianceOrgConfirmComplianceCandidateResponse, OrgComplianceOrgConfirmComplianceCandidateError, Options<OrgComplianceOrgConfirmComplianceCandidateData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgConfirmComplianceCandidateResponse, OrgComplianceOrgConfirmComplianceCandidateError, Options<OrgComplianceOrgConfirmComplianceCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgConfirmComplianceCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Dismiss Compliance Candidate
 *
 * Dismiss ONE candidate, with the organization's reason.
 *
 * The mirror of confirmation — one candidate, the same shape, the same cost. A
 * dismissed candidate returns only if the recorded facts behind it change.
 */
export const orgComplianceOrgDismissComplianceCandidateMutation = (options?: Partial<Options<OrgComplianceOrgDismissComplianceCandidateData>>): UseMutationOptions<OrgComplianceOrgDismissComplianceCandidateResponse, OrgComplianceOrgDismissComplianceCandidateError, Options<OrgComplianceOrgDismissComplianceCandidateData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgDismissComplianceCandidateResponse, OrgComplianceOrgDismissComplianceCandidateError, Options<OrgComplianceOrgDismissComplianceCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgDismissComplianceCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Run Compliance Derivation
 *
 * Re-derive candidate obligations from the organization's recorded profile.
 *
 * Each candidate pairs one jurisdiction's transcribed rule — with its citation and
 * source date — against the parameters the organization recorded. A candidate is not
 * a determination that the organization is required to register or is eligible for an
 * exemption in any state, and nothing becomes a deadline or a calendar entry until
 * someone at the organization confirms it.
 *
 * Candidates derived from the nationwide-or-online answer are marked and returned
 * first: whether an online presence alone amounts to soliciting in a particular state
 * is treated differently by different states and is not settled, so those are the ones
 * to review with counsel first.
 *
 * Idempotent — an open candidate stays open, a confirmed obligation is untouched, and
 * a dismissal stands unless the recorded facts behind it changed.
 */
export const orgComplianceOrgRunComplianceDerivationMutation = (options?: Partial<Options<OrgComplianceOrgRunComplianceDerivationData>>): UseMutationOptions<OrgComplianceOrgRunComplianceDerivationResponse, OrgComplianceOrgRunComplianceDerivationError, Options<OrgComplianceOrgRunComplianceDerivationData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRunComplianceDerivationResponse, OrgComplianceOrgRunComplianceDerivationError, Options<OrgComplianceOrgRunComplianceDerivationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRunComplianceDerivation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceDeskAuthorizationQueryKey = (options: Options<OrgComplianceOrgGetComplianceDeskAuthorizationData>) => createQueryKey('org-compliance-org_get_compliance_desk_authorization', options);

/**
 * Org Get Compliance Desk Authorization
 */
export const orgComplianceOrgGetComplianceDeskAuthorizationOptions = (options: Options<OrgComplianceOrgGetComplianceDeskAuthorizationData>) => queryOptions<OrgComplianceOrgGetComplianceDeskAuthorizationResponse, OrgComplianceOrgGetComplianceDeskAuthorizationError, OrgComplianceOrgGetComplianceDeskAuthorizationResponse, ReturnType<typeof orgComplianceOrgGetComplianceDeskAuthorizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceDeskAuthorization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceDeskAuthorizationQueryKey(options)
});

/**
 * Org Revoke Compliance Desk Authorization
 */
export const orgComplianceOrgRevokeComplianceDeskAuthorizationMutation = (options?: Partial<Options<OrgComplianceOrgRevokeComplianceDeskAuthorizationData>>): UseMutationOptions<OrgComplianceOrgRevokeComplianceDeskAuthorizationResponse, OrgComplianceOrgRevokeComplianceDeskAuthorizationError, Options<OrgComplianceOrgRevokeComplianceDeskAuthorizationData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRevokeComplianceDeskAuthorizationResponse, OrgComplianceOrgRevokeComplianceDeskAuthorizationError, Options<OrgComplianceOrgRevokeComplianceDeskAuthorizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRevokeComplianceDeskAuthorization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceFilingCasesQueryKey = (options: Options<OrgComplianceOrgListComplianceFilingCasesData>) => createQueryKey('org-compliance-org_list_compliance_filing_cases', options);

/**
 * Org List Compliance Filing Cases
 *
 * The organization's filing cases, oldest first; with `obligation_id`, one filing's.
 *
 * A filing case is one filing the organization is preparing — a filing on its register, for
 * a year or licence period where the filing has them — and holds the documents the filing
 * is made of. Each case says how many documents it holds.
 */
export const orgComplianceOrgListComplianceFilingCasesOptions = (options: Options<OrgComplianceOrgListComplianceFilingCasesData>) => queryOptions<OrgComplianceOrgListComplianceFilingCasesResponse, OrgComplianceOrgListComplianceFilingCasesError, OrgComplianceOrgListComplianceFilingCasesResponse, ReturnType<typeof orgComplianceOrgListComplianceFilingCasesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceFilingCases({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceFilingCasesQueryKey(options)
});

export const orgComplianceOrgGetComplianceFilingCaseQueryKey = (options: Options<OrgComplianceOrgGetComplianceFilingCaseData>) => createQueryKey('org-compliance-org_get_compliance_filing_case', options);

/**
 * Org Get Compliance Filing Case
 *
 * One filing case with the documents it holds, in the order they were added.
 *
 * Each document shows its latest version and who added it to the case, and when.
 */
export const orgComplianceOrgGetComplianceFilingCaseOptions = (options: Options<OrgComplianceOrgGetComplianceFilingCaseData>) => queryOptions<OrgComplianceOrgGetComplianceFilingCaseResponse, OrgComplianceOrgGetComplianceFilingCaseError, OrgComplianceOrgGetComplianceFilingCaseResponse, ReturnType<typeof orgComplianceOrgGetComplianceFilingCaseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceFilingCase({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceFilingCaseQueryKey(options)
});

export const orgComplianceOrgGetComplianceFilingCaseChecklistQueryKey = (options: Options<OrgComplianceOrgGetComplianceFilingCaseChecklistData>) => createQueryKey('org-compliance-org_get_compliance_filing_case_checklist', options);

/**
 * Org Get Compliance Filing Case Checklist
 *
 * What goes with the filing: the rule's attachment list, item by item, with the
 * documents attached to each and whether the organization marked it not needed.
 */
export const orgComplianceOrgGetComplianceFilingCaseChecklistOptions = (options: Options<OrgComplianceOrgGetComplianceFilingCaseChecklistData>) => queryOptions<OrgComplianceOrgGetComplianceFilingCaseChecklistResponse, OrgComplianceOrgGetComplianceFilingCaseChecklistError, OrgComplianceOrgGetComplianceFilingCaseChecklistResponse, ReturnType<typeof orgComplianceOrgGetComplianceFilingCaseChecklistQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceFilingCaseChecklist({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceFilingCaseChecklistQueryKey(options)
});

/**
 * Org Record Compliance Checklist Act
 *
 * Remove a document from one checklist item, or mark the item not needed for this
 * filing, or needed after all. An act that changes nothing records nothing.
 */
export const orgComplianceOrgRecordComplianceChecklistActMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceChecklistActData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceChecklistActResponse, OrgComplianceOrgRecordComplianceChecklistActError, Options<OrgComplianceOrgRecordComplianceChecklistActData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceChecklistActResponse, OrgComplianceOrgRecordComplianceChecklistActError, Options<OrgComplianceOrgRecordComplianceChecklistActData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceChecklistAct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Attach Compliance Checklist Document
 *
 * Attach a PDF from the organization's documents to one checklist item.
 *
 * It goes with the filing as uploaded, never changed. Refused for a PDF protected with
 * encryption, and for anything but a PDF; the document stays in the organization's
 * documents as uploaded.
 */
export const orgComplianceOrgAttachComplianceChecklistDocumentMutation = (options?: Partial<Options<OrgComplianceOrgAttachComplianceChecklistDocumentData>>): UseMutationOptions<OrgComplianceOrgAttachComplianceChecklistDocumentResponse, OrgComplianceOrgAttachComplianceChecklistDocumentError, Options<OrgComplianceOrgAttachComplianceChecklistDocumentData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAttachComplianceChecklistDocumentResponse, OrgComplianceOrgAttachComplianceChecklistDocumentError, Options<OrgComplianceOrgAttachComplianceChecklistDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAttachComplianceChecklistDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Hand Compliance Filing To Desk
 */
export const orgComplianceOrgHandComplianceFilingToDeskMutation = (options?: Partial<Options<OrgComplianceOrgHandComplianceFilingToDeskData>>): UseMutationOptions<OrgComplianceOrgHandComplianceFilingToDeskResponse, OrgComplianceOrgHandComplianceFilingToDeskError, Options<OrgComplianceOrgHandComplianceFilingToDeskData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgHandComplianceFilingToDeskResponse, OrgComplianceOrgHandComplianceFilingToDeskError, Options<OrgComplianceOrgHandComplianceFilingToDeskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgHandComplianceFilingToDesk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Resume Compliance Desk
 */
export const orgComplianceOrgResumeComplianceDeskMutation = (options?: Partial<Options<OrgComplianceOrgResumeComplianceDeskData>>): UseMutationOptions<OrgComplianceOrgResumeComplianceDeskResponse, OrgComplianceOrgResumeComplianceDeskError, Options<OrgComplianceOrgResumeComplianceDeskData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgResumeComplianceDeskResponse, OrgComplianceOrgResumeComplianceDeskError, Options<OrgComplianceOrgResumeComplianceDeskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgResumeComplianceDesk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Take Compliance Filing From Desk
 */
export const orgComplianceOrgTakeComplianceFilingFromDeskMutation = (options?: Partial<Options<OrgComplianceOrgTakeComplianceFilingFromDeskData>>): UseMutationOptions<OrgComplianceOrgTakeComplianceFilingFromDeskResponse, OrgComplianceOrgTakeComplianceFilingFromDeskError, Options<OrgComplianceOrgTakeComplianceFilingFromDeskData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgTakeComplianceFilingFromDeskResponse, OrgComplianceOrgTakeComplianceFilingFromDeskError, Options<OrgComplianceOrgTakeComplianceFilingFromDeskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgTakeComplianceFilingFromDesk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Attach Compliance Filing Case Document
 *
 * Add one of the organization's filing documents to an open filing case.
 *
 * A document stays in the first case it is added to; adding it to the same case again
 * changes nothing. Refused, with nothing recorded, for a withdrawn case, or a document that
 * is already in another case. Answers with the case and its documents.
 */
export const orgComplianceOrgAttachComplianceFilingCaseDocumentMutation = (options?: Partial<Options<OrgComplianceOrgAttachComplianceFilingCaseDocumentData>>): UseMutationOptions<OrgComplianceOrgAttachComplianceFilingCaseDocumentResponse, OrgComplianceOrgAttachComplianceFilingCaseDocumentError, Options<OrgComplianceOrgAttachComplianceFilingCaseDocumentData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAttachComplianceFilingCaseDocumentResponse, OrgComplianceOrgAttachComplianceFilingCaseDocumentError, Options<OrgComplianceOrgAttachComplianceFilingCaseDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAttachComplianceFilingCaseDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceFormPreparationsQueryKey = (options: Options<OrgComplianceOrgListComplianceFormPreparationsData>) => createQueryKey('org-compliance-org_list_compliance_form_preparations', options);

/**
 * Org List Compliance Form Preparations
 *
 * A filing case's form preparations, oldest first.
 *
 * Each names its preparation, the form document and the form it started on, and who started
 * it and when. Starting a preparation is its own request; the preparation read says what the
 * form says.
 */
export const orgComplianceOrgListComplianceFormPreparationsOptions = (options: Options<OrgComplianceOrgListComplianceFormPreparationsData>) => queryOptions<OrgComplianceOrgListComplianceFormPreparationsResponse, OrgComplianceOrgListComplianceFormPreparationsError, OrgComplianceOrgListComplianceFormPreparationsResponse, ReturnType<typeof orgComplianceOrgListComplianceFormPreparationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceFormPreparations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceFormPreparationsQueryKey(options)
});

/**
 * Org Start Compliance Form Preparation
 *
 * Start preparing the form of a filing case's filing.
 *
 * Adds the form to the case as a filing document and answers the preparation: every item of
 * the form, filled from the organization's records where they hold the answer. When the
 * case's form is already being prepared, answers that preparation.
 */
export const orgComplianceOrgStartComplianceFormPreparationMutation = (options?: Partial<Options<OrgComplianceOrgStartComplianceFormPreparationData>>): UseMutationOptions<OrgComplianceOrgStartComplianceFormPreparationResponse, OrgComplianceOrgStartComplianceFormPreparationError, Options<OrgComplianceOrgStartComplianceFormPreparationData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgStartComplianceFormPreparationResponse, OrgComplianceOrgStartComplianceFormPreparationError, Options<OrgComplianceOrgStartComplianceFormPreparationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgStartComplianceFormPreparation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceSubmissionQueryKey = (options: Options<OrgComplianceOrgGetComplianceSubmissionData>) => createQueryKey('org-compliance-org_get_compliance_submission', options);

/**
 * Org Get Compliance Submission
 *
 * A filing case's submission: whether Givmo can email it and, if not, why.
 *
 * The files exactly as they would go and the SHA-256 that binds them, the email's subject
 * and body, the agency's address, the fee as the form states it, the signed forms'
 * request, the addresses the agency's replies can go to, who the email actually goes to,
 * the latest authorization and every send. Reading it sends nothing.
 */
export const orgComplianceOrgGetComplianceSubmissionOptions = (options: Options<OrgComplianceOrgGetComplianceSubmissionData>) => queryOptions<OrgComplianceOrgGetComplianceSubmissionResponse, OrgComplianceOrgGetComplianceSubmissionError, OrgComplianceOrgGetComplianceSubmissionResponse, ReturnType<typeof orgComplianceOrgGetComplianceSubmissionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceSubmission({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceSubmissionQueryKey(options)
});

/**
 * Org Authorize Compliance Submission
 *
 * Authorize Givmo to send this filing exactly as you reviewed it.
 *
 * For a Compliance Owner or a Global Admin, at your organization's sign-in check. The
 * authorization binds the files, the email, the agency's address, the reply contact and the
 * fee statement, and sends nothing by itself. Refused when anything differs from what you
 * were shown, and while another package is authorized.
 */
export const orgComplianceOrgAuthorizeComplianceSubmissionMutation = (options?: Partial<Options<OrgComplianceOrgAuthorizeComplianceSubmissionData>>): UseMutationOptions<OrgComplianceOrgAuthorizeComplianceSubmissionResponse, OrgComplianceOrgAuthorizeComplianceSubmissionError, Options<OrgComplianceOrgAuthorizeComplianceSubmissionData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAuthorizeComplianceSubmissionResponse, OrgComplianceOrgAuthorizeComplianceSubmissionError, Options<OrgComplianceOrgAuthorizeComplianceSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAuthorizeComplianceSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Submission Evidence
 *
 * Record the agency's answer about a send of this filing, as your organization's record.
 *
 * That it acknowledged the filing, rejected it or asked for changes, and the day it did: from
 * its own message, attached, or from your organization's own account. It's labelled as
 * recorded by you, and it doesn't record the filing as accepted: attaching the confirmation
 * does that. Refused for a send nothing shows went out, and for a date before it was sent or
 * after today.
 */
export const orgComplianceOrgRecordComplianceSubmissionEvidenceMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceSubmissionEvidenceData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceSubmissionEvidenceResponse, OrgComplianceOrgRecordComplianceSubmissionEvidenceError, Options<OrgComplianceOrgRecordComplianceSubmissionEvidenceData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceSubmissionEvidenceResponse, OrgComplianceOrgRecordComplianceSubmissionEvidenceError, Options<OrgComplianceOrgRecordComplianceSubmissionEvidenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceSubmissionEvidence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Answer Compliance Submission Evidence
 *
 * Say a record about a send of this filing is wrong.
 *
 * The email service's report about the agency's address, or a record someone in your
 * organization made: say what you found. The record stays, shown with what you said, and
 * nothing counts it any more. For a Compliance Owner or a Global Admin, in Givmo.
 */
export const orgComplianceOrgAnswerComplianceSubmissionEvidenceMutation = (options?: Partial<Options<OrgComplianceOrgAnswerComplianceSubmissionEvidenceData>>): UseMutationOptions<OrgComplianceOrgAnswerComplianceSubmissionEvidenceResponse, OrgComplianceOrgAnswerComplianceSubmissionEvidenceError, Options<OrgComplianceOrgAnswerComplianceSubmissionEvidenceData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAnswerComplianceSubmissionEvidenceResponse, OrgComplianceOrgAnswerComplianceSubmissionEvidenceError, Options<OrgComplianceOrgAnswerComplianceSubmissionEvidenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAnswerComplianceSubmissionEvidence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Submission Handoff
 *
 * Record what your organization sent itself, as its own act.
 *
 * The way it went (one the agency's sources record for this filing) and the date; and what:
 * the package, named by the SHA-256 this filing's submission read served, or one of your
 * organization's documents. A proof of sending is optional. Givmo sends nothing, and the
 * record doesn't show that the agency received it. Refused for a package already recorded
 * or already sent by Givmo, or while Givmo's own send of it is in progress or uncertain.
 */
export const orgComplianceOrgRecordComplianceSubmissionHandoffMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceSubmissionHandoffData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceSubmissionHandoffResponse, OrgComplianceOrgRecordComplianceSubmissionHandoffError, Options<OrgComplianceOrgRecordComplianceSubmissionHandoffData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceSubmissionHandoffResponse, OrgComplianceOrgRecordComplianceSubmissionHandoffError, Options<OrgComplianceOrgRecordComplianceSubmissionHandoffData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceSubmissionHandoff({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceSubmissionPackageQueryKey = (options: Options<OrgComplianceOrgGetComplianceSubmissionPackageData>) => createQueryKey('org-compliance-org_get_compliance_submission_package', options);

/**
 * Org Get Compliance Submission Package
 *
 * The package as one zip: a short-lived link to exactly its files.
 *
 * The files keep the names the email gives them, and nothing else goes in. Name the package
 * by the SHA-256 its submission read served: the one the case holds now, or one an
 * authorization bound. Each file is matched to its SHA-256 first, and each one's reading is
 * recorded. Downloading it sends nothing.
 */
export const orgComplianceOrgGetComplianceSubmissionPackageOptions = (options: Options<OrgComplianceOrgGetComplianceSubmissionPackageData>) => queryOptions<OrgComplianceOrgGetComplianceSubmissionPackageResponse, OrgComplianceOrgGetComplianceSubmissionPackageError, OrgComplianceOrgGetComplianceSubmissionPackageResponse, ReturnType<typeof orgComplianceOrgGetComplianceSubmissionPackageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceSubmissionPackage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceSubmissionPackageQueryKey(options)
});

/**
 * Org Withdraw Compliance Filing Case
 *
 * Withdraw a filing case: the organization stops preparing this filing in it.
 *
 * The case keeps its documents and takes no new one, and a new case can be opened for the
 * same filing. Withdrawing a case already withdrawn changes nothing. Answers with the case
 * and its documents.
 */
export const orgComplianceOrgWithdrawComplianceFilingCaseMutation = (options?: Partial<Options<OrgComplianceOrgWithdrawComplianceFilingCaseData>>): UseMutationOptions<OrgComplianceOrgWithdrawComplianceFilingCaseResponse, OrgComplianceOrgWithdrawComplianceFilingCaseError, Options<OrgComplianceOrgWithdrawComplianceFilingCaseData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgWithdrawComplianceFilingCaseResponse, OrgComplianceOrgWithdrawComplianceFilingCaseError, Options<OrgComplianceOrgWithdrawComplianceFilingCaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgWithdrawComplianceFilingCase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceFilingDocumentsQueryKey = (options: Options<OrgComplianceOrgListComplianceFilingDocumentsData>) => createQueryKey('org-compliance-org_list_compliance_filing_documents', options);

/**
 * Org List Compliance Filing Documents
 *
 * The organization's filing documents, oldest first, each with its latest version.
 *
 * A filing document is a PDF the organization's filings use, kept as versions that never
 * change: the PDF as it was uploaded, and the copy Givmo prepared from it.
 */
export const orgComplianceOrgListComplianceFilingDocumentsOptions = (options: Options<OrgComplianceOrgListComplianceFilingDocumentsData>) => queryOptions<OrgComplianceOrgListComplianceFilingDocumentsResponse, OrgComplianceOrgListComplianceFilingDocumentsError, OrgComplianceOrgListComplianceFilingDocumentsResponse, ReturnType<typeof orgComplianceOrgListComplianceFilingDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceFilingDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceFilingDocumentsQueryKey(options)
});

/**
 * Org Create Compliance Filing Document
 *
 * Start a filing document, with the organization's title for it.
 *
 * It has no version until an uploaded PDF is recorded as one.
 */
export const orgComplianceOrgCreateComplianceFilingDocumentMutation = (options?: Partial<Options<OrgComplianceOrgCreateComplianceFilingDocumentData>>): UseMutationOptions<OrgComplianceOrgCreateComplianceFilingDocumentResponse, OrgComplianceOrgCreateComplianceFilingDocumentError, Options<OrgComplianceOrgCreateComplianceFilingDocumentData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgCreateComplianceFilingDocumentResponse, OrgComplianceOrgCreateComplianceFilingDocumentError, Options<OrgComplianceOrgCreateComplianceFilingDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgCreateComplianceFilingDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceFilingDocumentQueryKey = (options: Options<OrgComplianceOrgGetComplianceFilingDocumentData>) => createQueryKey('org-compliance-org_get_compliance_filing_document', options);

/**
 * Org Get Compliance Filing Document
 *
 * One filing document with every version, oldest first.
 *
 * Each version is named by the SHA-256 of its exact bytes. A version Givmo prepared begins
 * with the exact bytes of what it was made from: the version it was prepared from, which it
 * names, or, for a form Givmo fills, the agency's official template.
 */
export const orgComplianceOrgGetComplianceFilingDocumentOptions = (options: Options<OrgComplianceOrgGetComplianceFilingDocumentData>) => queryOptions<OrgComplianceOrgGetComplianceFilingDocumentResponse, OrgComplianceOrgGetComplianceFilingDocumentError, OrgComplianceOrgGetComplianceFilingDocumentResponse, ReturnType<typeof orgComplianceOrgGetComplianceFilingDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceFilingDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceFilingDocumentQueryKey(options)
});

/**
 * Org Register Compliance Filing Document Version
 *
 * Record an uploaded PDF as the document's next version.
 *
 * The PDF is one the organization already uploaded to its documents. Givmo reads its
 * exact bytes and records the version under their SHA-256; from then on the uploaded
 * document stays in the organization's records. When the PDF carries filled form fields,
 * or text and drawings added with a PDF app's tools, Givmo also records a copy that draws
 * each one's saved appearance into the page, as the version after: the upload is an exact
 * byte prefix of that copy.
 *
 * Refused, with nothing recorded, for a PDF protected with encryption (a restrictions-only
 * password included), a filled field or an added drawing with no saved appearance,
 * comments or other added content Givmo can't make part of the page, a dynamic form, or a
 * PDF Givmo can't read. Recording the same PDF again changes nothing. Answers with the
 * document and every version.
 */
export const orgComplianceOrgRegisterComplianceFilingDocumentVersionMutation = (options?: Partial<Options<OrgComplianceOrgRegisterComplianceFilingDocumentVersionData>>): UseMutationOptions<OrgComplianceOrgRegisterComplianceFilingDocumentVersionResponse, OrgComplianceOrgRegisterComplianceFilingDocumentVersionError, Options<OrgComplianceOrgRegisterComplianceFilingDocumentVersionData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRegisterComplianceFilingDocumentVersionResponse, OrgComplianceOrgRegisterComplianceFilingDocumentVersionError, Options<OrgComplianceOrgRegisterComplianceFilingDocumentVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRegisterComplianceFilingDocumentVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceFilingDocumentVersionDownloadQueryKey = (options: Options<OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadData>) => createQueryKey('org-compliance-org_get_compliance_filing_document_version_download', options);

/**
 * Org Get Compliance Filing Document Version Download
 *
 * A short-lived link to one version's exact bytes.
 *
 * The link names those exact bytes, whatever else is uploaded later. Each download link
 * Givmo issues is recorded: who asked, when, and the SHA-256 of the bytes it names. The
 * record is not an approval of anything. Fetch a new link each time rather than keeping
 * one.
 */
export const orgComplianceOrgGetComplianceFilingDocumentVersionDownloadOptions = (options: Options<OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadData>) => queryOptions<OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadResponse, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadError, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadResponse, ReturnType<typeof orgComplianceOrgGetComplianceFilingDocumentVersionDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceFilingDocumentVersionDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceFilingDocumentVersionDownloadQueryKey(options)
});

/**
 * Org Record Compliance Executed Copy
 *
 * Record the organization's upload of this version as it was signed outside Givmo, with who
 * signed it, in what capacity and when, as the organization states. This isn't a Givmo
 * signature, and Givmo doesn't check the signatures or that the copy matches this version. Only
 * a form Givmo prepared takes one, and not while it is out for signature or once it was signed
 * in Givmo; a PDF that is already a version of the form is refused. The same copy again changes
 * nothing; a different copy is recorded beside the first, and the newer one stands.
 */
export const orgComplianceOrgRecordComplianceExecutedCopyMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceExecutedCopyData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceExecutedCopyResponse, OrgComplianceOrgRecordComplianceExecutedCopyError, Options<OrgComplianceOrgRecordComplianceExecutedCopyData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceExecutedCopyResponse, OrgComplianceOrgRecordComplianceExecutedCopyError, Options<OrgComplianceOrgRecordComplianceExecutedCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceExecutedCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceFilingDocumentVersionRenditionQueryKey = (options: Options<OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionData>) => createQueryKey('org-compliance-org_get_compliance_filing_document_version_rendition', options);

/**
 * Org Get Compliance Filing Document Version Rendition
 *
 * What one version looks like, page by page.
 *
 * Each page was drawn once, with its form fields shown as a form-aware viewer shows
 * them, when the version was recorded; viewing draws nothing new. Each page is a
 * short-lived link to its image.
 */
export const orgComplianceOrgGetComplianceFilingDocumentVersionRenditionOptions = (options: Options<OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionData>) => queryOptions<OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionResponse, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionError, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionResponse, ReturnType<typeof orgComplianceOrgGetComplianceFilingDocumentVersionRenditionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceFilingDocumentVersionRendition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceFilingDocumentVersionRenditionQueryKey(options)
});

export const orgComplianceOrgGetComplianceFilingDocumentSigningPlacesQueryKey = (options: Options<OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesData>) => createQueryKey('org-compliance-org_get_compliance_filing_document_signing_places', options);

/**
 * Org Get Compliance Filing Document Signing Places
 *
 * What the person sending a filing document out for signature needs before they send it:
 * the document's filing case, the form Givmo matched this version to among that filing's
 * own forms, every signature place the form has (its page, where it is, and where the
 * printed name, the title and the date go), each page's draw scale, whether Givmo can sign
 * it for each way the filing is sent (with the line that says when the agency hasn't
 * confirmed it accepts e-signatures), and why sending it would be refused now, if it would.
 * Writes nothing.
 */
export const orgComplianceOrgGetComplianceFilingDocumentSigningPlacesOptions = (options: Options<OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesData>) => queryOptions<OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesResponse, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesError, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesResponse, ReturnType<typeof orgComplianceOrgGetComplianceFilingDocumentSigningPlacesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceFilingDocumentSigningPlaces({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceFilingDocumentSigningPlacesQueryKey(options)
});

export const orgComplianceOrgListComplianceFilingGroupsQueryKey = (options: Options<OrgComplianceOrgListComplianceFilingGroupsData>) => createQueryKey('org-compliance-org_list_compliance_filing_groups', options);

/**
 * Org List Compliance Filing Groups
 *
 * The organization's filing groups, in its order, each with the filings moved into it.
 *
 * Filings group automatically by family (fundraising registrations, corporate filings
 * and so on); the organization can rename a family's group, reorder the groups, make
 * groups of its own and move a filing between them. Every member of the organization
 * sees the same groups. A filing not listed as a member of any group sits in its
 * family's group.
 */
export const orgComplianceOrgListComplianceFilingGroupsOptions = (options: Options<OrgComplianceOrgListComplianceFilingGroupsData>) => queryOptions<OrgComplianceOrgListComplianceFilingGroupsResponse, OrgComplianceOrgListComplianceFilingGroupsError, OrgComplianceOrgListComplianceFilingGroupsResponse, ReturnType<typeof orgComplianceOrgListComplianceFilingGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceFilingGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceFilingGroupsQueryKey(options)
});

/**
 * Org Create Compliance Filing Group
 *
 * Make a group, named by the organization, with the one filing that starts it.
 *
 * The new group goes last in the organization's order and the filing moves into it.
 * Answers with the new group.
 */
export const orgComplianceOrgCreateComplianceFilingGroupMutation = (options?: Partial<Options<OrgComplianceOrgCreateComplianceFilingGroupData>>): UseMutationOptions<OrgComplianceOrgCreateComplianceFilingGroupResponse, OrgComplianceOrgCreateComplianceFilingGroupError, Options<OrgComplianceOrgCreateComplianceFilingGroupData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgCreateComplianceFilingGroupResponse, OrgComplianceOrgCreateComplianceFilingGroupError, Options<OrgComplianceOrgCreateComplianceFilingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgCreateComplianceFilingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Remove Compliance Filing Group
 *
 * Remove a group the organization made. Its filings go back to their families' groups.
 *
 * A family's group is never removed; it leaves the page when it holds no filing.
 */
export const orgComplianceOrgRemoveComplianceFilingGroupMutation = (options?: Partial<Options<OrgComplianceOrgRemoveComplianceFilingGroupData>>): UseMutationOptions<OrgComplianceOrgRemoveComplianceFilingGroupResponse, OrgComplianceOrgRemoveComplianceFilingGroupError, Options<OrgComplianceOrgRemoveComplianceFilingGroupData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRemoveComplianceFilingGroupResponse, OrgComplianceOrgRemoveComplianceFilingGroupError, Options<OrgComplianceOrgRemoveComplianceFilingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRemoveComplianceFilingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Move Compliance Filing To Group
 *
 * Move one filing into this group.
 *
 * Moving a filing into its own family's group puts it back there. Answers with the
 * group the filing is now in.
 */
export const orgComplianceOrgMoveComplianceFilingToGroupMutation = (options?: Partial<Options<OrgComplianceOrgMoveComplianceFilingToGroupData>>): UseMutationOptions<OrgComplianceOrgMoveComplianceFilingToGroupResponse, OrgComplianceOrgMoveComplianceFilingToGroupError, Options<OrgComplianceOrgMoveComplianceFilingToGroupData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgMoveComplianceFilingToGroupResponse, OrgComplianceOrgMoveComplianceFilingToGroupError, Options<OrgComplianceOrgMoveComplianceFilingToGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgMoveComplianceFilingToGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Move Compliance Filing Group
 *
 * Move one group one place up or down among the groups the Filings page shows.
 *
 * A family's group holding no filing is not shown, so a move passes it. At the top or
 * the bottom the order stays as it is. Answers with the group at its new place.
 */
export const orgComplianceOrgMoveComplianceFilingGroupMutation = (options?: Partial<Options<OrgComplianceOrgMoveComplianceFilingGroupData>>): UseMutationOptions<OrgComplianceOrgMoveComplianceFilingGroupResponse, OrgComplianceOrgMoveComplianceFilingGroupError, Options<OrgComplianceOrgMoveComplianceFilingGroupData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgMoveComplianceFilingGroupResponse, OrgComplianceOrgMoveComplianceFilingGroupError, Options<OrgComplianceOrgMoveComplianceFilingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgMoveComplianceFilingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Rename Compliance Filing Group
 *
 * Rename one group.
 *
 * A family's group goes back to its family's own name when no name is given; a group
 * the organization made always has one. Answers with the group.
 */
export const orgComplianceOrgRenameComplianceFilingGroupMutation = (options?: Partial<Options<OrgComplianceOrgRenameComplianceFilingGroupData>>): UseMutationOptions<OrgComplianceOrgRenameComplianceFilingGroupResponse, OrgComplianceOrgRenameComplianceFilingGroupError, Options<OrgComplianceOrgRenameComplianceFilingGroupData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRenameComplianceFilingGroupResponse, OrgComplianceOrgRenameComplianceFilingGroupError, Options<OrgComplianceOrgRenameComplianceFilingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRenameComplianceFilingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceFilingOptionsQueryKey = (options: Options<OrgComplianceOrgListComplianceFilingOptionsData>) => createQueryKey('org-compliance-org_list_compliance_filing_options', options);

/**
 * Org List Compliance Filing Options
 *
 * The filings Givmo's rules library offers for adding, one jurisdiction's or all.
 *
 * Each option is a jurisdiction's current rule with its citation and source date, and
 * how the Filings page presents it: its family (fundraising registrations, corporate
 * filings and so on), a short title and what the organization's own number is called.
 * Each option also carries, in `next_dates`, its next date for each deadline the rule
 * records, worked out from the organization's recorded facts with the rule's own deadline
 * entry as its basis, or the reason no date could be worked out; an entry whose dates have
 * all passed is left out. An option says what kind of filing a rule describes; it never
 * says the organization must make it. Ordered by jurisdiction, then as the library lists
 * that jurisdiction's filings.
 */
export const orgComplianceOrgListComplianceFilingOptionsOptions = (options: Options<OrgComplianceOrgListComplianceFilingOptionsData>) => queryOptions<OrgComplianceOrgListComplianceFilingOptionsResponse, OrgComplianceOrgListComplianceFilingOptionsError, OrgComplianceOrgListComplianceFilingOptionsResponse, ReturnType<typeof orgComplianceOrgListComplianceFilingOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceFilingOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceFilingOptionsQueryKey(options)
});

export const orgComplianceOrgListComplianceFormAdaptersQueryKey = (options: Options<OrgComplianceOrgListComplianceFormAdaptersData>) => createQueryKey('org-compliance-org_list_compliance_form_adapters', options);

/**
 * Org List Compliance Form Adapters
 *
 * The agency forms Givmo prepares from their official templates.
 *
 * Each names the rule it is filed under, the form's own number, the template (where it was
 * taken from, when, and the SHA-256 of its exact bytes) and its pages.
 */
export const orgComplianceOrgListComplianceFormAdaptersOptions = (options: Options<OrgComplianceOrgListComplianceFormAdaptersData>) => queryOptions<OrgComplianceOrgListComplianceFormAdaptersResponse, OrgComplianceOrgListComplianceFormAdaptersError, OrgComplianceOrgListComplianceFormAdaptersResponse, ReturnType<typeof orgComplianceOrgListComplianceFormAdaptersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceFormAdapters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceFormAdaptersQueryKey(options)
});

export const orgComplianceOrgGetComplianceFormPreparationQueryKey = (options: Options<OrgComplianceOrgGetComplianceFormPreparationData>) => createQueryKey('org-compliance-org_get_compliance_form_preparation', options);

/**
 * Org Get Compliance Form Preparation
 *
 * A form being prepared: every item in the form's order and own words, where it stands,
 * what goes on the form for it and where, and the records it comes from.
 *
 * ``values_sha256`` binds everything the form says; recording a version echoes it.
 */
export const orgComplianceOrgGetComplianceFormPreparationOptions = (options: Options<OrgComplianceOrgGetComplianceFormPreparationData>) => queryOptions<OrgComplianceOrgGetComplianceFormPreparationResponse, OrgComplianceOrgGetComplianceFormPreparationError, OrgComplianceOrgGetComplianceFormPreparationResponse, ReturnType<typeof orgComplianceOrgGetComplianceFormPreparationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceFormPreparation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceFormPreparationQueryKey(options)
});

/**
 * Org Answer Compliance Form Item
 *
 * The organization's answer to one item of the form.
 *
 * Recorded beside the earlier ones, with who gave it and when; the newest stands. An answer
 * that changes nothing records nothing. Refused for an answer the item does not take, a
 * character the form can't be printed with, or a value too long for the form's line, and
 * while the form is out for signature.
 */
export const orgComplianceOrgAnswerComplianceFormItemMutation = (options?: Partial<Options<OrgComplianceOrgAnswerComplianceFormItemData>>): UseMutationOptions<OrgComplianceOrgAnswerComplianceFormItemResponse, OrgComplianceOrgAnswerComplianceFormItemError, Options<OrgComplianceOrgAnswerComplianceFormItemData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAnswerComplianceFormItemResponse, OrgComplianceOrgAnswerComplianceFormItemError, Options<OrgComplianceOrgAnswerComplianceFormItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAnswerComplianceFormItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceFormPagePreviewQueryKey = (options: Options<OrgComplianceOrgGetComplianceFormPagePreviewData>) => createQueryKey('org-compliance-org_get_compliance_form_page_preview', options);

/**
 * Org Get Compliance Form Page Preview
 *
 * One page of the form as it stands, drawn as a form-aware viewer shows it.
 *
 * Not a version: recording one is its own request.
 */
export const orgComplianceOrgGetComplianceFormPagePreviewOptions = (options: Options<OrgComplianceOrgGetComplianceFormPagePreviewData>) => queryOptions<OrgComplianceOrgGetComplianceFormPagePreviewResponse, OrgComplianceOrgGetComplianceFormPagePreviewError, OrgComplianceOrgGetComplianceFormPagePreviewResponse, ReturnType<typeof orgComplianceOrgGetComplianceFormPagePreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceFormPagePreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceFormPagePreviewQueryKey(options)
});

export const orgComplianceOrgGetComplianceFormPagePreviewInfiniteQueryKey = (options: Options<OrgComplianceOrgGetComplianceFormPagePreviewData>): QueryKey<Options<OrgComplianceOrgGetComplianceFormPagePreviewData>> => createQueryKey('org-compliance-org_get_compliance_form_page_preview', options, true);

/**
 * Org Get Compliance Form Page Preview
 *
 * One page of the form as it stands, drawn as a form-aware viewer shows it.
 *
 * Not a version: recording one is its own request.
 */
export const orgComplianceOrgGetComplianceFormPagePreviewInfiniteOptions = (options: Options<OrgComplianceOrgGetComplianceFormPagePreviewData>) => {
    const opts = infiniteQueryOptions<OrgComplianceOrgGetComplianceFormPagePreviewResponse, OrgComplianceOrgGetComplianceFormPagePreviewError, InfiniteData<OrgComplianceOrgGetComplianceFormPagePreviewResponse>, QueryKey<Options<OrgComplianceOrgGetComplianceFormPagePreviewData>>, number | Pick<QueryKey<Options<OrgComplianceOrgGetComplianceFormPagePreviewData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<OrgComplianceOrgGetComplianceFormPagePreviewData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                path: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await orgComplianceOrgGetComplianceFormPagePreview({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: orgComplianceOrgGetComplianceFormPagePreviewInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Org Mint Compliance Form Version
 *
 * Record the prepared form as it stands as a version of its document.
 *
 * The version is the agency's template and one appended change carrying the form's values;
 * it never changes, and the same answers record the same version. Anyone who can read the
 * module may record it, as downloading it does. Refused when the form changed since it was
 * read (``expected_values_sha256``) and while it is out for signature.
 */
export const orgComplianceOrgMintComplianceFormVersionMutation = (options?: Partial<Options<OrgComplianceOrgMintComplianceFormVersionData>>): UseMutationOptions<OrgComplianceOrgMintComplianceFormVersionResponse, OrgComplianceOrgMintComplianceFormVersionError, Options<OrgComplianceOrgMintComplianceFormVersionData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgMintComplianceFormVersionResponse, OrgComplianceOrgMintComplianceFormVersionError, Options<OrgComplianceOrgMintComplianceFormVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgMintComplianceFormVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceObligationsQueryKey = (options: Options<OrgComplianceOrgListComplianceObligationsData>) => createQueryKey('org-compliance-org_list_compliance_obligations', options);

/**
 * Org List Compliance Obligations
 *
 * The organization's register.
 *
 * Each row records what the organization filed and when, and the confirmation the
 * state issued for it. It records filings; it is not a statement that the
 * organization is registered, exempt, in good standing, or in compliance anywhere —
 * only the state that issued a confirmation can say that.
 */
export const orgComplianceOrgListComplianceObligationsOptions = (options: Options<OrgComplianceOrgListComplianceObligationsData>) => queryOptions<OrgComplianceOrgListComplianceObligationsResponse, OrgComplianceOrgListComplianceObligationsError, OrgComplianceOrgListComplianceObligationsResponse, ReturnType<typeof orgComplianceOrgListComplianceObligationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceObligations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceObligationsQueryKey(options)
});

export const orgComplianceOrgGetComplianceObligationQueryKey = (options: Options<OrgComplianceOrgGetComplianceObligationData>) => createQueryKey('org-compliance-org_get_compliance_obligation', options);

/**
 * Org Get Compliance Obligation
 *
 * One obligation, its computed dates, and everything recorded about it.
 *
 * Each date is calculated from a filing period transcribed from the cited source,
 * applied to the fiscal year end the organization recorded. Confirm the current due
 * date with the state before filing.
 */
export const orgComplianceOrgGetComplianceObligationOptions = (options: Options<OrgComplianceOrgGetComplianceObligationData>) => queryOptions<OrgComplianceOrgGetComplianceObligationResponse, OrgComplianceOrgGetComplianceObligationError, OrgComplianceOrgGetComplianceObligationResponse, ReturnType<typeof orgComplianceOrgGetComplianceObligationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceObligation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceObligationQueryKey(options)
});

export const orgComplianceOrgListComplianceObligationArtifactsQueryKey = (options: Options<OrgComplianceOrgListComplianceObligationArtifactsData>) => createQueryKey('org-compliance-org_list_compliance_obligation_artifacts', options);

/**
 * Org List Compliance Obligation Artifacts
 *
 * Every document recorded against this obligation — currently and historically.
 *
 * `reference_role` says what each document was recorded AS: `confirmation`, the
 * confirmation the state issued; `submission_proof`, your organization's own proof of a
 * submission; `filed_copy`, the filing itself as your organization sent it; or
 * `attachment`, another document kept with the filing. Only a confirmation is the
 * state's answer. `is_current` says whether this obligation itself still carries the
 * reference: a document stays listed after a candidate is dismissed or a later
 * submission is recorded, because the history of what was recorded does not change when
 * the current record does, and a document one of its renewal cycles holds is listed as
 * not current here.
 */
export const orgComplianceOrgListComplianceObligationArtifactsOptions = (options: Options<OrgComplianceOrgListComplianceObligationArtifactsData>) => queryOptions<OrgComplianceOrgListComplianceObligationArtifactsResponse, OrgComplianceOrgListComplianceObligationArtifactsError, OrgComplianceOrgListComplianceObligationArtifactsResponse, ReturnType<typeof orgComplianceOrgListComplianceObligationArtifactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceObligationArtifacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceObligationArtifactsQueryKey(options)
});

/**
 * Org Add Compliance Obligation Attachment
 *
 * Keep one more document with a filing made once rather than each period, or with
 * the first filing of one that also recurs (the filing due before the first
 * solicitation). The document must already be uploaded for your organization; adding it
 * again changes nothing.
 */
export const orgComplianceOrgAddComplianceObligationAttachmentMutation = (options?: Partial<Options<OrgComplianceOrgAddComplianceObligationAttachmentData>>): UseMutationOptions<OrgComplianceOrgAddComplianceObligationAttachmentResponse, OrgComplianceOrgAddComplianceObligationAttachmentError, Options<OrgComplianceOrgAddComplianceObligationAttachmentData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAddComplianceObligationAttachmentResponse, OrgComplianceOrgAddComplianceObligationAttachmentError, Options<OrgComplianceOrgAddComplianceObligationAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAddComplianceObligationAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Add Compliance Earlier Renewal Cycle
 *
 * Add an earlier year to one filing's history: a renewal cycle for a year the
 * calendar does not show, before the latest one it does, dated by the same cited rule and
 * your organization's recorded fiscal year end. It starts with nothing recorded, and no
 * reminder is sent for it; record the year's filing on the cycle it returns. A year
 * already shown returns its own cycle.
 */
export const orgComplianceOrgAddComplianceEarlierRenewalCycleMutation = (options?: Partial<Options<OrgComplianceOrgAddComplianceEarlierRenewalCycleData>>): UseMutationOptions<OrgComplianceOrgAddComplianceEarlierRenewalCycleResponse, OrgComplianceOrgAddComplianceEarlierRenewalCycleError, Options<OrgComplianceOrgAddComplianceEarlierRenewalCycleData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAddComplianceEarlierRenewalCycleResponse, OrgComplianceOrgAddComplianceEarlierRenewalCycleError, Options<OrgComplianceOrgAddComplianceEarlierRenewalCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAddComplianceEarlierRenewalCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Attach Compliance Obligation Filed Copy
 *
 * Attach the filing itself, as your organization sent it, to a filing made once
 * rather than each period, or to the first filing of one that also recurs (the filing
 * due before the first solicitation). It keeps one; the document must already be
 * uploaded for your organization. It is not the jurisdiction's confirmation. Each later
 * period keeps its own filing as sent on its renewal cycle.
 */
export const orgComplianceOrgAttachComplianceObligationFiledCopyMutation = (options?: Partial<Options<OrgComplianceOrgAttachComplianceObligationFiledCopyData>>): UseMutationOptions<OrgComplianceOrgAttachComplianceObligationFiledCopyResponse, OrgComplianceOrgAttachComplianceObligationFiledCopyError, Options<OrgComplianceOrgAttachComplianceObligationFiledCopyData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAttachComplianceObligationFiledCopyResponse, OrgComplianceOrgAttachComplianceObligationFiledCopyError, Options<OrgComplianceOrgAttachComplianceObligationFiledCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAttachComplianceObligationFiledCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Open Compliance Filing Case
 *
 * Open a filing case for one filing on the organization's register.
 *
 * Say what kind of filing it is. For a filing made each year or each licence period, name
 * the year's record on its calendar; leave it out for a filing made once, or for the first
 * filing of one that also recurs. One case of each kind can be open for a filing and
 * period at a time: withdraw the open one to start over. Refused, with nothing recorded,
 * for a filing that is not confirmed on the register or a year's record that was replaced.
 */
export const orgComplianceOrgOpenComplianceFilingCaseMutation = (options?: Partial<Options<OrgComplianceOrgOpenComplianceFilingCaseData>>): UseMutationOptions<OrgComplianceOrgOpenComplianceFilingCaseResponse, OrgComplianceOrgOpenComplianceFilingCaseError, Options<OrgComplianceOrgOpenComplianceFilingCaseData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgOpenComplianceFilingCaseResponse, OrgComplianceOrgOpenComplianceFilingCaseError, Options<OrgComplianceOrgOpenComplianceFilingCaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgOpenComplianceFilingCase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Filing
 *
 * Record a filing the organization made, with the confirmation the state issued.
 *
 * The confirmation is required — there is no path on this surface that records a
 * filing without one, and the database refuses such a row independently. What is
 * recorded is that the organization filed, on the date it gives, with the
 * confirmation it uploaded.
 */
export const orgComplianceOrgRecordComplianceFilingMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceFilingData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceFilingResponse, OrgComplianceOrgRecordComplianceFilingError, Options<OrgComplianceOrgRecordComplianceFilingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceFilingResponse, OrgComplianceOrgRecordComplianceFilingError, Options<OrgComplianceOrgRecordComplianceFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListCompliancePacketsQueryKey = (options: Options<OrgComplianceOrgListCompliancePacketsData>) => createQueryKey('org-compliance-org_list_compliance_packets', options);

/**
 * Org List Compliance Packets
 *
 * The versions of one obligation's packet, newest first.
 *
 * Every version stays readable — a superseded one keeps its content address and its
 * download history. Items and execution steps are read per version. `download_state`
 * says what asking for each version's document would actually do, and `download_count`
 * how many times this organization has fetched it.
 */
export const orgComplianceOrgListCompliancePacketsOptions = (options: Options<OrgComplianceOrgListCompliancePacketsData>) => queryOptions<OrgComplianceOrgListCompliancePacketsResponse, OrgComplianceOrgListCompliancePacketsError, OrgComplianceOrgListCompliancePacketsResponse, ReturnType<typeof orgComplianceOrgListCompliancePacketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListCompliancePackets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListCompliancePacketsQueryKey(options)
});

/**
 * Org Assemble Compliance Packet
 *
 * Assemble a new packet version for one confirmed obligation.
 *
 * The packet pairs the jurisdiction's rule as transcribed — form, agency, channel and
 * address, fee, attachments, signature requirement, prerequisites, filing period — each
 * with its source date and, where one was recorded, its citation, against the parameters
 * the organization recorded and the documents it has cited. Where the rule records no
 * form, channel, fee, attachment, signature requirement or filing period, the packet
 * records a gap rather than supplying one. Signer instructions may also appear in
 * recorded form or submission notes.
 *
 * Each step is carried with the source date and, where recorded, the citation of the rule
 * field it restates, or marked as this product's own instruction where it restates no
 * rule. Each item carries the source line frozen when its version was assembled: its
 * source date, `rule_source_date`, worded by `rule_source_date_basis` (an item assembled
 * without them dates its source by `rule_source_checked_on`, a live check only where
 * `rule_source_check_status` is `read_live`), and its citation, `rule_display_citation`,
 * where one was recorded.
 *
 * Assembling again supersedes the previous version: a new version is a new set of
 * bytes, and a download record names the exact bytes it served. Optionally cite ONE
 * more document of the organization's own; documents cited on earlier versions carry
 * forward. Nothing is filed anywhere by this or any other operation here.
 */
export const orgComplianceOrgAssembleCompliancePacketMutation = (options?: Partial<Options<OrgComplianceOrgAssembleCompliancePacketData>>): UseMutationOptions<OrgComplianceOrgAssembleCompliancePacketResponse, OrgComplianceOrgAssembleCompliancePacketError, Options<OrgComplianceOrgAssembleCompliancePacketData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAssembleCompliancePacketResponse, OrgComplianceOrgAssembleCompliancePacketError, Options<OrgComplianceOrgAssembleCompliancePacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAssembleCompliancePacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Registration Date
 *
 * Record the dates this obligation's renewal runs from: its registration date
 * (CCM-BE2), the expiry date printed on its licence (CCM-R1-INTAKE-ANCHOR), or both.
 *
 * Recorded on the obligation itself rather than by declining it and confirming it
 * again — an obligation's recorded filings and its whole history stay where they are
 * while the date under its renewal corrects. Where a licence expiry is recorded, the
 * licence period ends on it. The dates it computes are recomputed; nothing about what
 * your organization filed changes, and no confirmation is needed to correct a date.
 */
export const orgComplianceOrgRecordComplianceRegistrationDateMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceRegistrationDateData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceRegistrationDateResponse, OrgComplianceOrgRecordComplianceRegistrationDateError, Options<OrgComplianceOrgRecordComplianceRegistrationDateData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceRegistrationDateResponse, OrgComplianceOrgRecordComplianceRegistrationDateError, Options<OrgComplianceOrgRecordComplianceRegistrationDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceRegistrationDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceObligationRuleChangeQueryKey = (options: Options<OrgComplianceOrgGetComplianceObligationRuleChangeData>) => createQueryKey('org-compliance-org_get_compliance_obligation_rule_change', options);

/**
 * Org Get Compliance Obligation Rule Change
 *
 * What changed between the rule version a filing is pinned to and its rule's current
 * version (CCM-OPS1-REPIN): each kind of change, with the deadline entry it is about, and
 * each deadline entry's next date under each version. Structure only.
 */
export const orgComplianceOrgGetComplianceObligationRuleChangeOptions = (options: Options<OrgComplianceOrgGetComplianceObligationRuleChangeData>) => queryOptions<OrgComplianceOrgGetComplianceObligationRuleChangeResponse, OrgComplianceOrgGetComplianceObligationRuleChangeError, OrgComplianceOrgGetComplianceObligationRuleChangeResponse, ReturnType<typeof orgComplianceOrgGetComplianceObligationRuleChangeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceObligationRuleChange({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceObligationRuleChangeQueryKey(options)
});

/**
 * Org Repin Compliance Obligation
 *
 * Move a filing to its rule's current version, the version named (CCM-OPS1-REPIN): the
 * organization's own act, attributed on the filing's history, which clears the filing's
 * rule-change flag and works its dates out again from that version. Its record is kept.
 * Refused, with nothing written, unless the version named is still the rule's current one;
 * a filing already there is answered as it stands.
 */
export const orgComplianceOrgRepinComplianceObligationMutation = (options?: Partial<Options<OrgComplianceOrgRepinComplianceObligationData>>): UseMutationOptions<OrgComplianceOrgRepinComplianceObligationResponse, OrgComplianceOrgRepinComplianceObligationError, Options<OrgComplianceOrgRepinComplianceObligationData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRepinComplianceObligationResponse, OrgComplianceOrgRepinComplianceObligationError, Options<OrgComplianceOrgRepinComplianceObligationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRepinComplianceObligation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Submission
 *
 * Record that the organization submitted a filing, on the date it gives.
 *
 * This records the organization's own act and nothing about the jurisdiction's
 * answer. Render it as "submission recorded «date» — awaiting the state's
 * confirmation": the register does not know whether the submission arrived, was
 * accepted, or was returned, and it does not become a recorded filing until the
 * organization records the confirmation the state issued, on the filing-records
 * route, with that confirmation attached.
 *
 * Its own route because it takes no confirmation — the filing route's confirmation is
 * required and has no nullable form. The optional proof reference here is the
 * organization's own paperwork and is never read as a confirmation.
 *
 * Dates the organization is working toward are recomputed, and the notices for the
 * cycle this submission was for change voice accordingly. If the recorded window
 * closes with no confirmation recorded against it, the register still reports the
 * closed window.
 */
export const orgComplianceOrgRecordComplianceSubmissionMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceSubmissionData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceSubmissionResponse, OrgComplianceOrgRecordComplianceSubmissionError, Options<OrgComplianceOrgRecordComplianceSubmissionData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceSubmissionResponse, OrgComplianceOrgRecordComplianceSubmissionError, Options<OrgComplianceOrgRecordComplianceSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Resume Tracking Compliance Obligation
 *
 * Start tracking a stopped filing again (CCM-R1-TRACKING-PANEL, D-CCM-58): the
 * organization's own act, attributed on the filing's history. It goes back onto the calendar
 * on its own rule version and its dates are worked out again. A filing being tracked is
 * answered as it stands. Refused, with nothing written, for a filing not on the calendar.
 */
export const orgComplianceOrgResumeTrackingComplianceObligationMutation = (options?: Partial<Options<OrgComplianceOrgResumeTrackingComplianceObligationData>>): UseMutationOptions<OrgComplianceOrgResumeTrackingComplianceObligationResponse, OrgComplianceOrgResumeTrackingComplianceObligationError, Options<OrgComplianceOrgResumeTrackingComplianceObligationData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgResumeTrackingComplianceObligationResponse, OrgComplianceOrgResumeTrackingComplianceObligationError, Options<OrgComplianceOrgResumeTrackingComplianceObligationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgResumeTrackingComplianceObligation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Stop Tracking Compliance Obligation
 *
 * Stop tracking a filing on the calendar (CCM-R1-TRACKING-PANEL, D-CCM-58): the
 * organization's own act, attributed on the filing's history. Its record and history stay;
 * Givmo works out no new dates for it, so nothing reminds. A filing already stopped is
 * answered as it stands. Refused, with nothing written, for a filing not on the calendar.
 */
export const orgComplianceOrgStopTrackingComplianceObligationMutation = (options?: Partial<Options<OrgComplianceOrgStopTrackingComplianceObligationData>>): UseMutationOptions<OrgComplianceOrgStopTrackingComplianceObligationResponse, OrgComplianceOrgStopTrackingComplianceObligationError, Options<OrgComplianceOrgStopTrackingComplianceObligationData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgStopTrackingComplianceObligationResponse, OrgComplianceOrgStopTrackingComplianceObligationError, Options<OrgComplianceOrgStopTrackingComplianceObligationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgStopTrackingComplianceObligation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Window Closed
 *
 * Record that a refiling window the organization recorded closed with no filing
 * recorded against it.
 *
 * A dated fact. The register does not assess what a closed window means for the
 * organization.
 */
export const orgComplianceOrgRecordComplianceWindowClosedMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceWindowClosedData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceWindowClosedResponse, OrgComplianceOrgRecordComplianceWindowClosedError, Options<OrgComplianceOrgRecordComplianceWindowClosedData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceWindowClosedResponse, OrgComplianceOrgRecordComplianceWindowClosedError, Options<OrgComplianceOrgRecordComplianceWindowClosedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceWindowClosed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceOccurrencesQueryKey = (options: Options<OrgComplianceOrgListComplianceOccurrencesData>) => createQueryKey('org-compliance-org_list_compliance_occurrences', options);

/**
 * Org List Compliance Occurrences
 *
 * Computed dates across the organization's confirmed obligations.
 *
 * Each date is calculated from a filing period transcribed from the cited source,
 * applied to the fiscal year end the organization recorded, and travels with both.
 * Some obligations have no calendar date at all — a filing due before the first
 * solicitation has no date to compute — and those rows say so rather than being
 * omitted.
 *
 * `due_before` bounds the window; rows with no computable date are returned
 * regardless.
 */
export const orgComplianceOrgListComplianceOccurrencesOptions = (options: Options<OrgComplianceOrgListComplianceOccurrencesData>) => queryOptions<OrgComplianceOrgListComplianceOccurrencesResponse, OrgComplianceOrgListComplianceOccurrencesError, OrgComplianceOrgListComplianceOccurrencesResponse, ReturnType<typeof orgComplianceOrgListComplianceOccurrencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceOccurrences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceOccurrencesQueryKey(options)
});

export const orgComplianceOrgListComplianceOrganizationFilingsQueryKey = (options: Options<OrgComplianceOrgListComplianceOrganizationFilingsData>) => createQueryKey('org-compliance-org_list_compliance_organization_filings', options);

/**
 * Org List Compliance Organization Filings
 *
 * The filings the organization records itself, oldest first, each with its latest
 * period.
 *
 * These are filings Givmo's rules library does not have. Their dates are the ones the
 * organization entered, and nothing on them was checked against a source.
 */
export const orgComplianceOrgListComplianceOrganizationFilingsOptions = (options: Options<OrgComplianceOrgListComplianceOrganizationFilingsData>) => queryOptions<OrgComplianceOrgListComplianceOrganizationFilingsResponse, OrgComplianceOrgListComplianceOrganizationFilingsError, OrgComplianceOrgListComplianceOrganizationFilingsResponse, ReturnType<typeof orgComplianceOrgListComplianceOrganizationFilingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceOrganizationFilings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceOrganizationFilingsQueryKey(options)
});

/**
 * Org Add Compliance Organization Filing
 *
 * Add a filing Givmo's rules library does not have.
 *
 * The organization gives its title, who it is filed with, its family, how often it
 * comes round and its next date; its first period opens at that date. Answers with the
 * filing and that period.
 */
export const orgComplianceOrgAddComplianceOrganizationFilingMutation = (options?: Partial<Options<OrgComplianceOrgAddComplianceOrganizationFilingData>>): UseMutationOptions<OrgComplianceOrgAddComplianceOrganizationFilingResponse, OrgComplianceOrgAddComplianceOrganizationFilingError, Options<OrgComplianceOrgAddComplianceOrganizationFilingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAddComplianceOrganizationFilingResponse, OrgComplianceOrgAddComplianceOrganizationFilingError, Options<OrgComplianceOrgAddComplianceOrganizationFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAddComplianceOrganizationFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceOrganizationFilingQueryKey = (options: Options<OrgComplianceOrgGetComplianceOrganizationFilingData>) => createQueryKey('org-compliance-org_get_compliance_organization_filing', options);

/**
 * Org Get Compliance Organization Filing
 *
 * One filing the organization records itself, with every period, latest date
 * first, its history, the number it first entered, and each change to that number.
 */
export const orgComplianceOrgGetComplianceOrganizationFilingOptions = (options: Options<OrgComplianceOrgGetComplianceOrganizationFilingData>) => queryOptions<OrgComplianceOrgGetComplianceOrganizationFilingResponse, OrgComplianceOrgGetComplianceOrganizationFilingError, OrgComplianceOrgGetComplianceOrganizationFilingResponse, ReturnType<typeof orgComplianceOrgGetComplianceOrganizationFilingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceOrganizationFiling({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceOrganizationFilingQueryKey(options)
});

/**
 * Org Update Compliance Organization Filing
 *
 * Change a filing the organization records itself.
 *
 * A field left out stays as it is; the agency and the number are cleared with null.
 * Changing how often it comes round, or its next date, re-dates only the period nothing
 * is recorded for yet. Each change is kept in the filing's history. A reason, in the
 * person's own words, is kept with each change.
 */
export const orgComplianceOrgUpdateComplianceOrganizationFilingMutation = (options?: Partial<Options<OrgComplianceOrgUpdateComplianceOrganizationFilingData>>): UseMutationOptions<OrgComplianceOrgUpdateComplianceOrganizationFilingResponse, OrgComplianceOrgUpdateComplianceOrganizationFilingError, Options<OrgComplianceOrgUpdateComplianceOrganizationFilingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgUpdateComplianceOrganizationFilingResponse, OrgComplianceOrgUpdateComplianceOrganizationFilingError, Options<OrgComplianceOrgUpdateComplianceOrganizationFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgUpdateComplianceOrganizationFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Add Compliance Organization Filing Cycle
 *
 * Add an earlier period of a filing the organization records itself, at a date
 * before its latest period that no period already there covers. It opens nothing new.
 * An earlier date a period already holds returns that period.
 */
export const orgComplianceOrgAddComplianceOrganizationFilingCycleMutation = (options?: Partial<Options<OrgComplianceOrgAddComplianceOrganizationFilingCycleData>>): UseMutationOptions<OrgComplianceOrgAddComplianceOrganizationFilingCycleResponse, OrgComplianceOrgAddComplianceOrganizationFilingCycleError, Options<OrgComplianceOrgAddComplianceOrganizationFilingCycleData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAddComplianceOrganizationFilingCycleResponse, OrgComplianceOrgAddComplianceOrganizationFilingCycleError, Options<OrgComplianceOrgAddComplianceOrganizationFilingCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAddComplianceOrganizationFilingCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Add Compliance Organization Filing Attachment
 *
 * Keep one more document with one period of a filing your organization records
 * itself, beside its filing and confirmation. The document must already be uploaded for
 * your organization; adding it again changes nothing.
 */
export const orgComplianceOrgAddComplianceOrganizationFilingAttachmentMutation = (options?: Partial<Options<OrgComplianceOrgAddComplianceOrganizationFilingAttachmentData>>): UseMutationOptions<OrgComplianceOrgAddComplianceOrganizationFilingAttachmentResponse, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentError, Options<OrgComplianceOrgAddComplianceOrganizationFilingAttachmentData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAddComplianceOrganizationFilingAttachmentResponse, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentError, Options<OrgComplianceOrgAddComplianceOrganizationFilingAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAddComplianceOrganizationFilingAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Attach Compliance Organization Filing Filed Copy
 *
 * Keep the filing itself, as your organization sent it, with one period of a filing
 * your organization records itself. A period keeps one; the document must already be
 * uploaded for your organization. It is kept with the period's records and is not the
 * agency's confirmation: the period reads as filed only with that.
 */
export const orgComplianceOrgAttachComplianceOrganizationFilingFiledCopyMutation = (options?: Partial<Options<OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyData>>): UseMutationOptions<OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyResponse, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyError, Options<OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyResponse, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyError, Options<OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAttachComplianceOrganizationFilingFiledCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Organization Filing Filed
 *
 * Record that one period was filed, with the confirmation the agency issued.
 *
 * The confirmation document is required: a period reads as filed only with it. A copy
 * of the filing as sent may ride along; a period keeps one. Recording the same filing
 * again changes nothing. When this is the latest period, the next opens by the
 * filing's cadence.
 */
export const orgComplianceOrgRecordComplianceOrganizationFilingFiledMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceOrganizationFilingFiledData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceOrganizationFilingFiledResponse, OrgComplianceOrgRecordComplianceOrganizationFilingFiledError, Options<OrgComplianceOrgRecordComplianceOrganizationFilingFiledData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceOrganizationFilingFiledResponse, OrgComplianceOrgRecordComplianceOrganizationFilingFiledError, Options<OrgComplianceOrgRecordComplianceOrganizationFilingFiledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceOrganizationFilingFiled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Organization Filing Sent
 *
 * Record that one period's filing was sent, on the date the organization gives.
 *
 * Sent is not filed. Recording it again corrects the date and the proof; recording it
 * exactly as it stands changes nothing. A period keeps one filing as sent: a different
 * copy is refused. When this is the latest period, the next opens by the filing's
 * cadence.
 */
export const orgComplianceOrgRecordComplianceOrganizationFilingSentMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceOrganizationFilingSentData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceOrganizationFilingSentResponse, OrgComplianceOrgRecordComplianceOrganizationFilingSentError, Options<OrgComplianceOrgRecordComplianceOrganizationFilingSentData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceOrganizationFilingSentResponse, OrgComplianceOrgRecordComplianceOrganizationFilingSentError, Options<OrgComplianceOrgRecordComplianceOrganizationFilingSentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceOrganizationFilingSent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Retire Compliance Organization Filing
 *
 * Stop tracking a filing the organization records itself: it gets no more reminders
 * and opens no next period.
 *
 * The record is kept as it was, with its periods and history, and takes no further
 * changes. A filing already stopped answers as it is.
 */
export const orgComplianceOrgRetireComplianceOrganizationFilingMutation = (options?: Partial<Options<OrgComplianceOrgRetireComplianceOrganizationFilingData>>): UseMutationOptions<OrgComplianceOrgRetireComplianceOrganizationFilingResponse, OrgComplianceOrgRetireComplianceOrganizationFilingError, Options<OrgComplianceOrgRetireComplianceOrganizationFilingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRetireComplianceOrganizationFilingResponse, OrgComplianceOrgRetireComplianceOrganizationFilingError, Options<OrgComplianceOrgRetireComplianceOrganizationFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRetireComplianceOrganizationFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Switch Compliance Organization Filing
 *
 * Switch a filing the organization records itself to the same filing from Givmo's
 * rules library, once the organization has that one on its register.
 *
 * The record is kept as it was, with its periods and history, and takes no further
 * changes. If it was moved into a group, the library filing takes its place there.
 */
export const orgComplianceOrgSwitchComplianceOrganizationFilingMutation = (options?: Partial<Options<OrgComplianceOrgSwitchComplianceOrganizationFilingData>>): UseMutationOptions<OrgComplianceOrgSwitchComplianceOrganizationFilingResponse, OrgComplianceOrgSwitchComplianceOrganizationFilingError, Options<OrgComplianceOrgSwitchComplianceOrganizationFilingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgSwitchComplianceOrganizationFilingResponse, OrgComplianceOrgSwitchComplianceOrganizationFilingError, Options<OrgComplianceOrgSwitchComplianceOrganizationFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgSwitchComplianceOrganizationFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetCompliancePacketQueryKey = (options: Options<OrgComplianceOrgGetCompliancePacketData>) => createQueryKey('org-compliance-org_get_compliance_packet', options);

/**
 * Org Get Compliance Packet
 *
 * One packet version with its items.
 *
 * The items are the rule elements with their source dates and, where recorded, citations,
 * the organization's cited documents, and the steps it performs on the jurisdiction's own
 * channel — each step carrying the source date and, where recorded, the citation of the
 * rule field it restates, or marked as this product's own instruction where it restates
 * no rule. Each item carries the source line frozen when its version was assembled: its
 * source date, `rule_source_date`, worded by `rule_source_date_basis` (an item assembled
 * without them dates its source by `rule_source_checked_on`, a live check only where
 * `rule_source_check_status` is `read_live`), and its citation, `rule_display_citation`,
 * where one was recorded. All of them are listed in every packet state. `download_state`
 * says what asking for this version's document would actually do, and `download_count`
 * how many times it has been fetched.
 */
export const orgComplianceOrgGetCompliancePacketOptions = (options: Options<OrgComplianceOrgGetCompliancePacketData>) => queryOptions<OrgComplianceOrgGetCompliancePacketResponse, OrgComplianceOrgGetCompliancePacketError, OrgComplianceOrgGetCompliancePacketResponse, ReturnType<typeof orgComplianceOrgGetCompliancePacketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetCompliancePacket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetCompliancePacketQueryKey(options)
});

export const orgComplianceOrgGetCompliancePacketChecklistQueryKey = (options: Options<OrgComplianceOrgGetCompliancePacketChecklistData>) => createQueryKey('org-compliance-org_get_compliance_packet_checklist', options);

/**
 * Org Get Compliance Packet Checklist
 *
 * The checklist for one packet version.
 *
 * The full working state at any time: the rule elements with their source dates and,
 * where recorded, citations, the organization's cited documents, and the steps it
 * performs on the jurisdiction's own channel — gather the cited documents, obtain the
 * recorded signatures, execute on the recorded channel, remit the recorded amount where
 * one is transcribed, then record the submission in the register. Each step built from
 * the rule carries that rule's source date and, where recorded, its citation; the
 * register step is this product's own instruction and says so. Each item carries the
 * source line frozen when its version was assembled: its source date, `rule_source_date`,
 * worded by `rule_source_date_basis` (an item assembled without them dates its source by
 * `rule_source_checked_on`, a live check only where `rule_source_check_status` is
 * `read_live`), and its citation, `rule_display_citation`, where one was recorded. Where
 * the rule records no channel, fee or signature requirement, the step records a gap
 * rather than supplying one. Signer instructions may also appear in recorded form or
 * submission notes. `download_state` says what asking for this version's document would
 * actually do, and `download_count` how many times it has been fetched.
 */
export const orgComplianceOrgGetCompliancePacketChecklistOptions = (options: Options<OrgComplianceOrgGetCompliancePacketChecklistData>) => queryOptions<OrgComplianceOrgGetCompliancePacketChecklistResponse, OrgComplianceOrgGetCompliancePacketChecklistError, OrgComplianceOrgGetCompliancePacketChecklistResponse, ReturnType<typeof orgComplianceOrgGetCompliancePacketChecklistQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetCompliancePacketChecklist({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetCompliancePacketChecklistQueryKey(options)
});

export const orgComplianceOrgGetCompliancePacketRenderQueryKey = (options: Options<OrgComplianceOrgGetCompliancePacketRenderData>) => createQueryKey('org-compliance-org_get_compliance_packet_render', options);

/**
 * Org Get Compliance Packet Render
 *
 * Download one packet version's document.
 *
 * Anyone the organization has admitted to this module may download it. There is
 * nothing to confirm and nothing to type. Every download is recorded when it is asked
 * for — who asked, when, and which bytes it names: the content address of the frozen
 * payload the document is rendered from — and that record says exactly that: it is not
 * a signature, an approval, or a statement that anyone is an officer of the
 * organization.
 *
 * Above its download record, the document says that it is not signed, and that who must
 * sign, and how, is set by the jurisdiction's own form and instructions: the rule shows
 * the signer requirements recorded from those sources, and where it shows none they
 * have not been recorded, which does not mean the source is silent.
 *
 * Rendered deterministically from the frozen payload; nothing is stored. Refused for a
 * version whose pinned rule was revised or whose recorded parameters changed since it
 * was assembled — each of those calls for a new version. Nothing is filed anywhere by
 * this or any other operation here.
 */
export const orgComplianceOrgGetCompliancePacketRenderOptions = (options: Options<OrgComplianceOrgGetCompliancePacketRenderData>) => queryOptions<OrgComplianceOrgGetCompliancePacketRenderResponse, OrgComplianceOrgGetCompliancePacketRenderError, OrgComplianceOrgGetCompliancePacketRenderResponse, ReturnType<typeof orgComplianceOrgGetCompliancePacketRenderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetCompliancePacketRender({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetCompliancePacketRenderQueryKey(options)
});

export const orgComplianceOrgGetComplianceProfileQueryKey = (options: Options<OrgComplianceOrgGetComplianceProfileData>) => createQueryKey('org-compliance-org_get_compliance_profile', options);

/**
 * Org Get Compliance Profile
 *
 * The facts your organization has recorded about itself.
 *
 * Each one was entered by someone at your organization and is shown with who recorded
 * it and when. Givmo does not confirm these facts; the register's candidates and every
 * computed date rest on them, so keeping them current is what keeps those accurate.
 *
 * `missing_required_parameter_keys` lists what still has to be recorded before
 * candidate obligations can be worked out at all.
 */
export const orgComplianceOrgGetComplianceProfileOptions = (options: Options<OrgComplianceOrgGetComplianceProfileData>) => queryOptions<OrgComplianceOrgGetComplianceProfileResponse, OrgComplianceOrgGetComplianceProfileError, OrgComplianceOrgGetComplianceProfileResponse, ReturnType<typeof orgComplianceOrgGetComplianceProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceProfileQueryKey(options)
});

export const orgComplianceOrgListComplianceProfileParametersQueryKey = (options: Options<OrgComplianceOrgListComplianceProfileParametersData>) => createQueryKey('org-compliance-org_list_compliance_profile_parameters', options);

/**
 * Org List Compliance Profile Parameters
 *
 * The facts your organization recorded — in force first, then their history.
 *
 * Recording a fact again does not edit what was there: it writes a new entry and
 * marks the previous one superseded, so an obligation your organization confirmed
 * against an earlier value still shows the value it was confirmed against.
 */
export const orgComplianceOrgListComplianceProfileParametersOptions = (options: Options<OrgComplianceOrgListComplianceProfileParametersData>) => queryOptions<OrgComplianceOrgListComplianceProfileParametersResponse, OrgComplianceOrgListComplianceProfileParametersError, OrgComplianceOrgListComplianceProfileParametersResponse, ReturnType<typeof orgComplianceOrgListComplianceProfileParametersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceProfileParameters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceProfileParametersQueryKey(options)
});

/**
 * Org Record Compliance Profile Parameter
 *
 * Record ONE fact about your organization.
 *
 * PUT rather than POST because your organization has exactly one value in force for
 * each fact. Recording again does not edit the previous entry — it writes a new one
 * and supersedes the old, so anything already computed can still show the value it
 * was computed from.
 *
 * When the fact you record is one the register reads, the response says so and links
 * the re-derivation. Nothing is re-derived for you: a re-derivation puts candidate
 * obligations in front of your organization to review, and that is a step someone at
 * your organization takes.
 */
export const orgComplianceOrgRecordComplianceProfileParameterMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceProfileParameterData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceProfileParameterResponse, OrgComplianceOrgRecordComplianceProfileParameterError, Options<OrgComplianceOrgRecordComplianceProfileParameterData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceProfileParameterResponse, OrgComplianceOrgRecordComplianceProfileParameterError, Options<OrgComplianceOrgRecordComplianceProfileParameterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceProfileParameter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceRegistrationImportsQueryKey = (options: Options<OrgComplianceOrgListComplianceRegistrationImportsData>) => createQueryKey('org-compliance-org_list_compliance_registration_imports', options);

/**
 * Org List Compliance Registration Imports
 *
 * Registrations your organization already held when it started here.
 *
 * `artifact_state` is `requested` where the confirmation the state issued has not
 * been supplied yet. Those obligations are in the register and confirmed; they carry
 * no filing record, because the register records filings it can show the state's own
 * document for.
 */
export const orgComplianceOrgListComplianceRegistrationImportsOptions = (options: Options<OrgComplianceOrgListComplianceRegistrationImportsData>) => queryOptions<OrgComplianceOrgListComplianceRegistrationImportsResponse, OrgComplianceOrgListComplianceRegistrationImportsError, OrgComplianceOrgListComplianceRegistrationImportsResponse, ReturnType<typeof orgComplianceOrgListComplianceRegistrationImportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceRegistrationImports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceRegistrationImportsQueryKey(options)
});

/**
 * Org Import Compliance Registration
 *
 * Record ONE registration your organization already holds.
 *
 * This route takes exactly one registration — importing puts the obligation into your
 * organization's register.
 *
 * Supplying the confirmation the state issued records the filing, exactly as
 * recording any other filing does. Importing without one is fully supported: the
 * obligation goes into the register with no filing record against it, and the
 * confirmation is noted as still to be supplied.
 */
export const orgComplianceOrgImportComplianceRegistrationMutation = (options?: Partial<Options<OrgComplianceOrgImportComplianceRegistrationData>>): UseMutationOptions<OrgComplianceOrgImportComplianceRegistrationResponse, OrgComplianceOrgImportComplianceRegistrationError, Options<OrgComplianceOrgImportComplianceRegistrationData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgImportComplianceRegistrationResponse, OrgComplianceOrgImportComplianceRegistrationError, Options<OrgComplianceOrgImportComplianceRegistrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgImportComplianceRegistration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceRegistrationImportAmendmentsQueryKey = (options: Options<OrgComplianceOrgListComplianceRegistrationImportAmendmentsData>) => createQueryKey('org-compliance-org_list_compliance_registration_import_amendments', options);

/**
 * Org List Compliance Registration Import Amendments
 *
 * Every correction recorded against this imported registration, oldest first.
 *
 * The whole chain, not a page of it: this is the answer to what your organization has
 * said about this registration over time, and half of it would be a different answer.
 * Each entry names the field, what the record said before, what it says now, who
 * recorded it and when.
 */
export const orgComplianceOrgListComplianceRegistrationImportAmendmentsOptions = (options: Options<OrgComplianceOrgListComplianceRegistrationImportAmendmentsData>) => queryOptions<OrgComplianceOrgListComplianceRegistrationImportAmendmentsResponse, OrgComplianceOrgListComplianceRegistrationImportAmendmentsError, OrgComplianceOrgListComplianceRegistrationImportAmendmentsResponse, ReturnType<typeof orgComplianceOrgListComplianceRegistrationImportAmendmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceRegistrationImportAmendments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceRegistrationImportAmendmentsQueryKey(options)
});

/**
 * Org Amend Compliance Registration Import
 *
 * Correct a detail your organization typed when it recorded this registration.
 *
 * The correction is recorded BESIDE the original, not over it. The imported record
 * keeps saying what your organization first entered, this amendment says what it says
 * now, and both are shown with who recorded them and when.
 *
 * It changes nothing about the filing itself: not the confirmation the state issued,
 * not the date it was filed, not what the register shows about this obligation. Only
 * details your organization typed can be amended, and the recorded confirmation is
 * never one of them.
 */
export const orgComplianceOrgAmendComplianceRegistrationImportMutation = (options?: Partial<Options<OrgComplianceOrgAmendComplianceRegistrationImportData>>): UseMutationOptions<OrgComplianceOrgAmendComplianceRegistrationImportResponse, OrgComplianceOrgAmendComplianceRegistrationImportError, Options<OrgComplianceOrgAmendComplianceRegistrationImportData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAmendComplianceRegistrationImportResponse, OrgComplianceOrgAmendComplianceRegistrationImportError, Options<OrgComplianceOrgAmendComplianceRegistrationImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAmendComplianceRegistrationImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceProfileReviewFlagsQueryKey = (options: Options<OrgComplianceOrgListComplianceProfileReviewFlagsData>) => createQueryKey('org-compliance-org_list_compliance_profile_review_flags', options);

/**
 * Org List Compliance Profile Review Flags
 *
 * Where a figure your organization recorded and a figure Givmo measured differ.
 *
 * Each row shows both numbers and where each came from. Givmo does not decide which
 * is correct and does not change what your organization recorded — the two figures
 * can legitimately differ, for instance where most of your revenue does not come
 * through Givmo.
 */
export const orgComplianceOrgListComplianceProfileReviewFlagsOptions = (options: Options<OrgComplianceOrgListComplianceProfileReviewFlagsData>) => queryOptions<OrgComplianceOrgListComplianceProfileReviewFlagsResponse, OrgComplianceOrgListComplianceProfileReviewFlagsError, OrgComplianceOrgListComplianceProfileReviewFlagsResponse, ReturnType<typeof orgComplianceOrgListComplianceProfileReviewFlagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceProfileReviewFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceProfileReviewFlagsQueryKey(options)
});

/**
 * Org Resolve Compliance Profile Review Flag
 *
 * Close ONE flagged difference, recording what your organization decided.
 *
 * Either your organization stands by the figure it recorded, or it records the figure
 * again. Closing a flag changes nothing about the fact itself — to change the fact,
 * record it again.
 */
export const orgComplianceOrgResolveComplianceProfileReviewFlagMutation = (options?: Partial<Options<OrgComplianceOrgResolveComplianceProfileReviewFlagData>>): UseMutationOptions<OrgComplianceOrgResolveComplianceProfileReviewFlagResponse, OrgComplianceOrgResolveComplianceProfileReviewFlagError, Options<OrgComplianceOrgResolveComplianceProfileReviewFlagData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgResolveComplianceProfileReviewFlagResponse, OrgComplianceOrgResolveComplianceProfileReviewFlagError, Options<OrgComplianceOrgResolveComplianceProfileReviewFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgResolveComplianceProfileReviewFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceProfileSuggestionsQueryKey = (options: Options<OrgComplianceOrgListComplianceProfileSuggestionsData>) => createQueryKey('org-compliance-org_list_compliance_profile_suggestions', options);

/**
 * Org List Compliance Profile Suggestions
 *
 * Values read off documents your organization uploaded, for it to check.
 *
 * Each row shows what was read and where it was read from. None of them is recorded
 * against your organization until someone at your organization confirms it — or
 * enters a different value, which is recorded as theirs.
 */
export const orgComplianceOrgListComplianceProfileSuggestionsOptions = (options: Options<OrgComplianceOrgListComplianceProfileSuggestionsData>) => queryOptions<OrgComplianceOrgListComplianceProfileSuggestionsResponse, OrgComplianceOrgListComplianceProfileSuggestionsError, OrgComplianceOrgListComplianceProfileSuggestionsResponse, ReturnType<typeof orgComplianceOrgListComplianceProfileSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceProfileSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceProfileSuggestionsQueryKey(options)
});

/**
 * Org Resolve Compliance Profile Suggestion
 *
 * Confirm, correct or decline ONE value read off a document.
 *
 * Your organization's answer is what is recorded. Confirming records the value that
 * was read; correcting records the value you enter instead; declining records
 * nothing. In every case the entry names the person who answered, not the reading.
 *
 * Accepting a value has the same consequences as typing it: the dates of obligations
 * your organization has already confirmed are recalculated against it, and the
 * response says whether re-deriving candidate obligations is now worth doing.
 */
export const orgComplianceOrgResolveComplianceProfileSuggestionMutation = (options?: Partial<Options<OrgComplianceOrgResolveComplianceProfileSuggestionData>>): UseMutationOptions<OrgComplianceOrgResolveComplianceProfileSuggestionResponse, OrgComplianceOrgResolveComplianceProfileSuggestionError, Options<OrgComplianceOrgResolveComplianceProfileSuggestionData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgResolveComplianceProfileSuggestionResponse, OrgComplianceOrgResolveComplianceProfileSuggestionError, Options<OrgComplianceOrgResolveComplianceProfileSuggestionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgResolveComplianceProfileSuggestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceProposalQueryKey = (options: Options<OrgComplianceOrgGetComplianceProposalData>) => createQueryKey('org-compliance-org_get_compliance_proposal', options);

/**
 * Org Get Compliance Proposal
 *
 * The organization's open proposal and its newest revision.
 *
 * A proposal presents an assessment of the organization's rules over its recorded facts:
 * the filings identified, the rules excluded, the facts still to record and the conditions
 * left unresolved. It is a record of what was computed, and it changes nothing by itself.
 * None exists until one is generated.
 */
export const orgComplianceOrgGetComplianceProposalOptions = (options: Options<OrgComplianceOrgGetComplianceProposalData>) => queryOptions<OrgComplianceOrgGetComplianceProposalResponse, OrgComplianceOrgGetComplianceProposalError, OrgComplianceOrgGetComplianceProposalResponse, ReturnType<typeof orgComplianceOrgGetComplianceProposalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceProposal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceProposalQueryKey(options)
});

export const orgComplianceOrgListComplianceReviewAsksQueryKey = (options: Options<OrgComplianceOrgListComplianceReviewAsksData>) => createQueryKey('org-compliance-org_list_compliance_review_asks', options);

/**
 * Org List Compliance Review Asks
 *
 * The organization's asks about items of its review, newest first; with `asked_user_id`,
 * those of one person, and with `state`, those `open`, `resolved` (the item was decided),
 * `withdrawn` or `replaced`.
 */
export const orgComplianceOrgListComplianceReviewAsksOptions = (options: Options<OrgComplianceOrgListComplianceReviewAsksData>) => queryOptions<OrgComplianceOrgListComplianceReviewAsksResponse, OrgComplianceOrgListComplianceReviewAsksError, OrgComplianceOrgListComplianceReviewAsksResponse, ReturnType<typeof orgComplianceOrgListComplianceReviewAsksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceReviewAsks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceReviewAsksQueryKey(options)
});

/**
 * Org Ask About Compliance Review Item
 *
 * Ask a teammate who can make changes in Compliance about one item of the revision being
 * reviewed, with an optional note; they get an email with a link to the review.
 *
 * Asking again about the item replaces the open ask, and the same ask sent again answers the
 * open one. An ask decides nothing: the item stays open until the organization decides it.
 */
export const orgComplianceOrgAskAboutComplianceReviewItemMutation = (options?: Partial<Options<OrgComplianceOrgAskAboutComplianceReviewItemData>>): UseMutationOptions<OrgComplianceOrgAskAboutComplianceReviewItemResponse, OrgComplianceOrgAskAboutComplianceReviewItemError, Options<OrgComplianceOrgAskAboutComplianceReviewItemData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAskAboutComplianceReviewItemResponse, OrgComplianceOrgAskAboutComplianceReviewItemError, Options<OrgComplianceOrgAskAboutComplianceReviewItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAskAboutComplianceReviewItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Withdraw Compliance Review Ask
 *
 * Withdraw an ask of a teammate. An ask already withdrawn or replaced is answered as it
 * stands.
 */
export const orgComplianceOrgWithdrawComplianceReviewAskMutation = (options?: Partial<Options<OrgComplianceOrgWithdrawComplianceReviewAskData>>): UseMutationOptions<OrgComplianceOrgWithdrawComplianceReviewAskResponse, OrgComplianceOrgWithdrawComplianceReviewAskError, Options<OrgComplianceOrgWithdrawComplianceReviewAskData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgWithdrawComplianceReviewAskResponse, OrgComplianceOrgWithdrawComplianceReviewAskError, Options<OrgComplianceOrgWithdrawComplianceReviewAskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgWithdrawComplianceReviewAsk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Generate Compliance Proposal Revision
 *
 * Assess the organization's rules over its recorded facts, as of today, and present the
 * result as the proposal's next revision.
 *
 * Each rule in scope gets one result, with its basis: the rule's conditions, how each came
 * out and the facts used. When nothing has moved since the newest revision, that revision
 * is returned and nothing new is recorded. Generating a revision adopts no fact, puts
 * nothing on the calendar and sends nothing.
 */
export const orgComplianceOrgGenerateComplianceProposalRevisionMutation = (options?: Partial<Options<OrgComplianceOrgGenerateComplianceProposalRevisionData>>): UseMutationOptions<OrgComplianceOrgGenerateComplianceProposalRevisionResponse, OrgComplianceOrgGenerateComplianceProposalRevisionError, Options<OrgComplianceOrgGenerateComplianceProposalRevisionData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgGenerateComplianceProposalRevisionResponse, OrgComplianceOrgGenerateComplianceProposalRevisionError, Options<OrgComplianceOrgGenerateComplianceProposalRevisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgGenerateComplianceProposalRevision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceProposalRevisionQueryKey = (options: Options<OrgComplianceOrgGetComplianceProposalRevisionData>) => createQueryKey('org-compliance-org_get_compliance_proposal_revision', options);

/**
 * Org Get Compliance Proposal Revision
 *
 * One revision of the organization's proposal.
 *
 * It says what moved since the previous revision, how many results and items of each kind it
 * holds, and whether it still reads what it was computed from: a fact recorded or corrected,
 * a rule re-versioned, the calendar changed, or the date moving into another period each
 * make it stale. A stale revision is shown as it was; the organization generates a new one.
 */
export const orgComplianceOrgGetComplianceProposalRevisionOptions = (options: Options<OrgComplianceOrgGetComplianceProposalRevisionData>) => queryOptions<OrgComplianceOrgGetComplianceProposalRevisionResponse, OrgComplianceOrgGetComplianceProposalRevisionError, OrgComplianceOrgGetComplianceProposalRevisionResponse, ReturnType<typeof orgComplianceOrgGetComplianceProposalRevisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceProposalRevision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceProposalRevisionQueryKey(options)
});

export const orgComplianceOrgListComplianceProposalItemsQueryKey = (options: Options<OrgComplianceOrgListComplianceProposalItemsData>) => createQueryKey('org-compliance-org_list_compliance_proposal_items', options);

/**
 * Org List Compliance Proposal Items
 *
 * A revision's items, in the order they are presented; with `kind`, one kind's.
 *
 * The kinds are a filing identified (`filing_work`, with the dates it would take on the
 * calendar), a rule excluded (`exclusion`), a fact to record (`question`, with the rules
 * its answer decides), an unresolved condition (`issue`), and a filing already on the
 * calendar that the evaluation now reads otherwise (`change`). A rule's item carries its
 * result.
 */
export const orgComplianceOrgListComplianceProposalItemsOptions = (options: Options<OrgComplianceOrgListComplianceProposalItemsData>) => queryOptions<OrgComplianceOrgListComplianceProposalItemsResponse, OrgComplianceOrgListComplianceProposalItemsError, OrgComplianceOrgListComplianceProposalItemsResponse, ReturnType<typeof orgComplianceOrgListComplianceProposalItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceProposalItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceProposalItemsQueryKey(options)
});

export const orgComplianceOrgListComplianceProposalResultsQueryKey = (options: Options<OrgComplianceOrgListComplianceProposalResultsData>) => createQueryKey('org-compliance-org_list_compliance_proposal_results', options);

/**
 * Org List Compliance Proposal Results
 *
 * The results of a revision's assessment, one per rule in scope, in the rules' order;
 * with `result`, one result's.
 *
 * Each is `filing_identified`, `rule_excluded`, `facts_missing`, `unresolved` or
 * `not_supported`, with its basis on the same object: the rule's citation and source, each
 * condition's outcome, the facts used, the facts missing, and the reason where the rule
 * calls for no filing, is unresolved or is not evaluated.
 */
export const orgComplianceOrgListComplianceProposalResultsOptions = (options: Options<OrgComplianceOrgListComplianceProposalResultsData>) => queryOptions<OrgComplianceOrgListComplianceProposalResultsResponse, OrgComplianceOrgListComplianceProposalResultsError, OrgComplianceOrgListComplianceProposalResultsResponse, ReturnType<typeof orgComplianceOrgListComplianceProposalResultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceProposalResults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceProposalResultsQueryKey(options)
});

export const orgComplianceOrgGetComplianceProposalReviewQueryKey = (options: Options<OrgComplianceOrgGetComplianceProposalReviewData>) => createQueryKey('org-compliance-org_get_compliance_proposal_review', options);

/**
 * Org Get Compliance Proposal Review
 *
 * The review recorded on one revision: each item the organization decided, what the
 * decision did, who decided and when, and the version of the not-a-substitute sentence shown
 * when it was recorded.
 */
export const orgComplianceOrgGetComplianceProposalReviewOptions = (options: Options<OrgComplianceOrgGetComplianceProposalReviewData>) => queryOptions<OrgComplianceOrgGetComplianceProposalReviewResponse, OrgComplianceOrgGetComplianceProposalReviewError, OrgComplianceOrgGetComplianceProposalReviewResponse, ReturnType<typeof orgComplianceOrgGetComplianceProposalReviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceProposalReview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceProposalReviewQueryKey(options)
});

/**
 * Org Record Compliance Proposal Review
 *
 * Record the organization's decisions on the items of one revision it was shown, with
 * that revision's digest as it was shown.
 *
 * Each decision names an item of the revision: accept or deny a filing identified or a rule
 * excluded, or defer any item. Only the items listed are decided. Accepting a filing puts it
 * on the calendar as the organization's decision; denying one records that the organization
 * chose not to, beside the assessment, which stays as it was computed. A revision is reviewed
 * once: one that changed since it was shown, or already carries a review, is refused so it can
 * be shown again, and the same decisions sent again answer the review already recorded. It
 * signs nothing, authorizes no submission and sends nothing.
 */
export const orgComplianceOrgRecordComplianceProposalReviewMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceProposalReviewData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceProposalReviewResponse, OrgComplianceOrgRecordComplianceProposalReviewError, Options<OrgComplianceOrgRecordComplianceProposalReviewData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceProposalReviewResponse, OrgComplianceOrgRecordComplianceProposalReviewError, Options<OrgComplianceOrgRecordComplianceProposalReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceProposalReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceRenewalCyclesQueryKey = (options: Options<OrgComplianceOrgListComplianceRenewalCyclesData>) => createQueryKey('org-compliance-org_list_compliance_renewal_cycles', options);

/**
 * Org List Compliance Renewal Cycles
 *
 * Recorded renewal cycles, including earlier dates and their confirmations.
 */
export const orgComplianceOrgListComplianceRenewalCyclesOptions = (options: Options<OrgComplianceOrgListComplianceRenewalCyclesData>) => queryOptions<OrgComplianceOrgListComplianceRenewalCyclesResponse, OrgComplianceOrgListComplianceRenewalCyclesError, OrgComplianceOrgListComplianceRenewalCyclesResponse, ReturnType<typeof orgComplianceOrgListComplianceRenewalCyclesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceRenewalCycles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceRenewalCyclesQueryKey(options)
});

export const orgComplianceOrgGetComplianceRenewalCycleQueryKey = (options: Options<OrgComplianceOrgGetComplianceRenewalCycleData>) => createQueryKey('org-compliance-org_get_compliance_renewal_cycle', options);

/**
 * Org Get Compliance Renewal Cycle
 *
 * One recorded cycle with its dated changes and confirmation history.
 */
export const orgComplianceOrgGetComplianceRenewalCycleOptions = (options: Options<OrgComplianceOrgGetComplianceRenewalCycleData>) => queryOptions<OrgComplianceOrgGetComplianceRenewalCycleResponse, OrgComplianceOrgGetComplianceRenewalCycleError, OrgComplianceOrgGetComplianceRenewalCycleResponse, ReturnType<typeof orgComplianceOrgGetComplianceRenewalCycleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceRenewalCycle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceRenewalCycleQueryKey(options)
});

/**
 * Org Add Compliance Renewal Attachment
 *
 * Keep one more document with one renewal cycle, beside its filing and confirmation.
 * The document must already be uploaded for your organization; adding it again changes
 * nothing.
 */
export const orgComplianceOrgAddComplianceRenewalAttachmentMutation = (options?: Partial<Options<OrgComplianceOrgAddComplianceRenewalAttachmentData>>): UseMutationOptions<OrgComplianceOrgAddComplianceRenewalAttachmentResponse, OrgComplianceOrgAddComplianceRenewalAttachmentError, Options<OrgComplianceOrgAddComplianceRenewalAttachmentData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAddComplianceRenewalAttachmentResponse, OrgComplianceOrgAddComplianceRenewalAttachmentError, Options<OrgComplianceOrgAddComplianceRenewalAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAddComplianceRenewalAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Attach Compliance Renewal Filed Copy
 *
 * Attach the filing itself, as your organization sent it, to one renewal cycle. A
 * cycle keeps one; the document must already be uploaded for your organization. It is
 * kept with the cycle's records and is not the jurisdiction's confirmation.
 */
export const orgComplianceOrgAttachComplianceRenewalFiledCopyMutation = (options?: Partial<Options<OrgComplianceOrgAttachComplianceRenewalFiledCopyData>>): UseMutationOptions<OrgComplianceOrgAttachComplianceRenewalFiledCopyResponse, OrgComplianceOrgAttachComplianceRenewalFiledCopyError, Options<OrgComplianceOrgAttachComplianceRenewalFiledCopyData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgAttachComplianceRenewalFiledCopyResponse, OrgComplianceOrgAttachComplianceRenewalFiledCopyError, Options<OrgComplianceOrgAttachComplianceRenewalFiledCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgAttachComplianceRenewalFiledCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Renewal Filing
 *
 * Record the jurisdiction's confirmation for one selected renewal cycle.
 */
export const orgComplianceOrgRecordComplianceRenewalFilingMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceRenewalFilingData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceRenewalFilingResponse, OrgComplianceOrgRecordComplianceRenewalFilingError, Options<OrgComplianceOrgRecordComplianceRenewalFilingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceRenewalFilingResponse, OrgComplianceOrgRecordComplianceRenewalFilingError, Options<OrgComplianceOrgRecordComplianceRenewalFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceRenewalFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Record Compliance Renewal Submission
 *
 * Record that your organization sent one renewal cycle's filing, on the date you give,
 * with your own proof of sending if you have one. It records what your organization did
 * and says nothing about what the jurisdiction did; the cycle is not marked filed until
 * the jurisdiction's confirmation is recorded.
 */
export const orgComplianceOrgRecordComplianceRenewalSubmissionMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceRenewalSubmissionData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceRenewalSubmissionResponse, OrgComplianceOrgRecordComplianceRenewalSubmissionError, Options<OrgComplianceOrgRecordComplianceRenewalSubmissionData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceRenewalSubmissionResponse, OrgComplianceOrgRecordComplianceRenewalSubmissionError, Options<OrgComplianceOrgRecordComplianceRenewalSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceRenewalSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceAiSettingQueryKey = (options: Options<OrgComplianceOrgGetComplianceAiSettingData>) => createQueryKey('org-compliance-org_get_compliance_ai_setting', options);

/**
 * Org Get Compliance Ai Setting
 *
 * The organization's "Use AI on your organization's data" setting.
 *
 * It covers Givmo's AI only. While it is off, Givmo reads no document with AI, drafts
 * nothing with AI, and prepares or files nothing with AI; everything the organization adds
 * itself works the same. The organization's own connected AI is not governed by it. It is
 * on until the organization turns it off: revision 0 means it was never changed, and then
 * nobody is named.
 */
export const orgComplianceOrgGetComplianceAiSettingOptions = (options: Options<OrgComplianceOrgGetComplianceAiSettingData>) => queryOptions<OrgComplianceOrgGetComplianceAiSettingResponse, OrgComplianceOrgGetComplianceAiSettingError, OrgComplianceOrgGetComplianceAiSettingResponse, ReturnType<typeof orgComplianceOrgGetComplianceAiSettingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceAiSetting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceAiSettingQueryKey(options)
});

/**
 * Org Set Compliance Ai Setting
 *
 * Turn Givmo's AI on or off for the organization.
 *
 * A Compliance Owner or a Global Admin changes it. The change is made from the revision it
 * was read at: a change made from an older one is refused and nothing is recorded, so it
 * never lands over a change its author did not see. Each change records who made it and
 * when; asking for the value already in force records nothing. Answers with the setting.
 */
export const orgComplianceOrgSetComplianceAiSettingMutation = (options?: Partial<Options<OrgComplianceOrgSetComplianceAiSettingData>>): UseMutationOptions<OrgComplianceOrgSetComplianceAiSettingResponse, OrgComplianceOrgSetComplianceAiSettingError, Options<OrgComplianceOrgSetComplianceAiSettingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgSetComplianceAiSettingResponse, OrgComplianceOrgSetComplianceAiSettingError, Options<OrgComplianceOrgSetComplianceAiSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgSetComplianceAiSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceSigningSettingQueryKey = (options: Options<OrgComplianceOrgGetComplianceSigningSettingData>) => createQueryKey('org-compliance-org_get_compliance_signing_setting', options);

/**
 * Org Get Compliance Signing Setting
 *
 * The organization's sign-in check before signing.
 *
 * None by default: a signed-in member signs by one deliberate act, and the record of the
 * signature names when they last signed in, and how. An organization may require a sign-in
 * again within the last day, within the last 30 minutes, or for every signature. Revision 0
 * means it was never changed.
 */
export const orgComplianceOrgGetComplianceSigningSettingOptions = (options: Options<OrgComplianceOrgGetComplianceSigningSettingData>) => queryOptions<OrgComplianceOrgGetComplianceSigningSettingResponse, OrgComplianceOrgGetComplianceSigningSettingError, OrgComplianceOrgGetComplianceSigningSettingResponse, ReturnType<typeof orgComplianceOrgGetComplianceSigningSettingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceSigningSetting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceSigningSettingQueryKey(options)
});

/**
 * Org Set Compliance Signing Setting
 *
 * Change the organization's sign-in check before signing.
 *
 * A Compliance Owner or a Global Admin changes it, from the revision it was read at: a
 * change made from an older one is refused and nothing is recorded. Making it stricter
 * asks for nothing; making it less strict asks the person to meet the check in force first.
 * Each change records who made it, when, and what the person showed.
 */
export const orgComplianceOrgSetComplianceSigningSettingMutation = (options?: Partial<Options<OrgComplianceOrgSetComplianceSigningSettingData>>): UseMutationOptions<OrgComplianceOrgSetComplianceSigningSettingResponse, OrgComplianceOrgSetComplianceSigningSettingError, Options<OrgComplianceOrgSetComplianceSigningSettingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgSetComplianceSigningSettingResponse, OrgComplianceOrgSetComplianceSigningSettingError, Options<OrgComplianceOrgSetComplianceSigningSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgSetComplianceSigningSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceSigningPeopleQueryKey = (options: Options<OrgComplianceOrgListComplianceSigningPeopleData>) => createQueryKey('org-compliance-org_list_compliance_signing_people', options);

/**
 * Org List Compliance Signing People
 *
 * Everyone the organization's signing requests hold sign-in details for, newest first:
 * each person who signed, declined or withdrew a signature on a request, completed or not,
 * and each person who sent one. Each comes with how many requests hold their details and the
 * request to direct their removal on.
 */
export const orgComplianceOrgListComplianceSigningPeopleOptions = (options: Options<OrgComplianceOrgListComplianceSigningPeopleData>) => queryOptions<OrgComplianceOrgListComplianceSigningPeopleResponse, OrgComplianceOrgListComplianceSigningPeopleError, OrgComplianceOrgListComplianceSigningPeopleResponse, ReturnType<typeof orgComplianceOrgListComplianceSigningPeopleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceSigningPeople({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceSigningPeopleQueryKey(options)
});

export const orgComplianceOrgListComplianceSigningRequestsQueryKey = (options: Options<OrgComplianceOrgListComplianceSigningRequestsData>) => createQueryKey('org-compliance-org_list_compliance_signing_requests', options);

/**
 * Org List Compliance Signing Requests
 *
 * The organization's signing requests, oldest first; with `filing_case_id`, one filing
 * case's; with `state`, the requests in that state (a request whose sign-by date has passed
 * reads expired).
 */
export const orgComplianceOrgListComplianceSigningRequestsOptions = (options: Options<OrgComplianceOrgListComplianceSigningRequestsData>) => queryOptions<OrgComplianceOrgListComplianceSigningRequestsResponse, OrgComplianceOrgListComplianceSigningRequestsError, OrgComplianceOrgListComplianceSigningRequestsResponse, ReturnType<typeof orgComplianceOrgListComplianceSigningRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceSigningRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceSigningRequestsQueryKey(options)
});

/**
 * Org Issue Compliance Signing Request
 *
 * Send a filing case's documents out for signature.
 *
 * Name each document at the version its signers sign (Givmo's flattened copy, where the
 * upload had filled fields), a signer for every signature place the form has and the
 * capacity the organization states for each, how the filing will be sent, and the time zone
 * its dates are written in. A note for the signers and a sign-by date are optional.
 * Everyone named needs access to Compliance. One request can be open for a filing case: a
 * package of other documents replaces the open one, and the same package again is refused.
 * Refused, with nothing recorded, where Givmo can't sign a document of the package.
 */
export const orgComplianceOrgIssueComplianceSigningRequestMutation = (options?: Partial<Options<OrgComplianceOrgIssueComplianceSigningRequestData>>): UseMutationOptions<OrgComplianceOrgIssueComplianceSigningRequestResponse, OrgComplianceOrgIssueComplianceSigningRequestError, Options<OrgComplianceOrgIssueComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgIssueComplianceSigningRequestResponse, OrgComplianceOrgIssueComplianceSigningRequestError, Options<OrgComplianceOrgIssueComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgIssueComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceSigningRequestQueryKey = (options: Options<OrgComplianceOrgGetComplianceSigningRequestData>) => createQueryKey('org-compliance-org_get_compliance_signing_request', options);

/**
 * Org Get Compliance Signing Request
 *
 * One signing request with its live version: each document and whether Givmo can sign
 * it, its pages as the signers see them, every signature place and where it stands, the
 * acts on this version, the caller's own places and what they can do now, and what changed
 * around it since it was sent.
 */
export const orgComplianceOrgGetComplianceSigningRequestOptions = (options: Options<OrgComplianceOrgGetComplianceSigningRequestData>) => queryOptions<OrgComplianceOrgGetComplianceSigningRequestResponse, OrgComplianceOrgGetComplianceSigningRequestError, OrgComplianceOrgGetComplianceSigningRequestResponse, ReturnType<typeof orgComplianceOrgGetComplianceSigningRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceSigningRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceSigningRequestQueryKey(options)
});

/**
 * Org Cancel Compliance Signing Request
 *
 * Cancel an open request, with an optional reason. Cancelling a cancelled request
 * changes nothing.
 */
export const orgComplianceOrgCancelComplianceSigningRequestMutation = (options?: Partial<Options<OrgComplianceOrgCancelComplianceSigningRequestData>>): UseMutationOptions<OrgComplianceOrgCancelComplianceSigningRequestResponse, OrgComplianceOrgCancelComplianceSigningRequestError, Options<OrgComplianceOrgCancelComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgCancelComplianceSigningRequestResponse, OrgComplianceOrgCancelComplianceSigningRequestError, Options<OrgComplianceOrgCancelComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgCancelComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Decline Compliance Signing Request
 *
 * Decline to sign the live version, with an optional reason for the sender. A decline
 * is not final: the caller can sign later, and the request stays open.
 */
export const orgComplianceOrgDeclineComplianceSigningRequestMutation = (options?: Partial<Options<OrgComplianceOrgDeclineComplianceSigningRequestData>>): UseMutationOptions<OrgComplianceOrgDeclineComplianceSigningRequestResponse, OrgComplianceOrgDeclineComplianceSigningRequestError, Options<OrgComplianceOrgDeclineComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgDeclineComplianceSigningRequestResponse, OrgComplianceOrgDeclineComplianceSigningRequestError, Options<OrgComplianceOrgDeclineComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgDeclineComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceSigningEvidenceQueryKey = (options: Options<OrgComplianceOrgGetComplianceSigningEvidenceData>) => createQueryKey('org-compliance-org_get_compliance_signing_evidence', options);

/**
 * Org Get Compliance Signing Evidence
 *
 * A completed request's signing record: who signed which document, and when, with the
 * sign-in facts each signature's session showed (or when they were removed at the
 * organization's direction), the versions sent, what the signers were shown and the checks on
 * the signed forms. A short-lived link to its exact bytes, as a PDF (the default) or as data
 * (`format=json`), and the record of issuing the link. A request that is not completed has
 * none.
 */
export const orgComplianceOrgGetComplianceSigningEvidenceOptions = (options: Options<OrgComplianceOrgGetComplianceSigningEvidenceData>) => queryOptions<OrgComplianceOrgGetComplianceSigningEvidenceResponse, OrgComplianceOrgGetComplianceSigningEvidenceError, OrgComplianceOrgGetComplianceSigningEvidenceResponse, ReturnType<typeof orgComplianceOrgGetComplianceSigningEvidenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceSigningEvidence({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceSigningEvidenceQueryKey(options)
});

/**
 * Org Extend Compliance Signing Request
 *
 * Move an open request's sign-by date later. The same date again changes nothing; an
 * earlier one is refused, and so is any change once the date has passed.
 */
export const orgComplianceOrgExtendComplianceSigningRequestMutation = (options?: Partial<Options<OrgComplianceOrgExtendComplianceSigningRequestData>>): UseMutationOptions<OrgComplianceOrgExtendComplianceSigningRequestResponse, OrgComplianceOrgExtendComplianceSigningRequestError, Options<OrgComplianceOrgExtendComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgExtendComplianceSigningRequestResponse, OrgComplianceOrgExtendComplianceSigningRequestError, Options<OrgComplianceOrgExtendComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgExtendComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceSigningExportQueryKey = (options: Options<OrgComplianceOrgGetComplianceSigningExportData>) => createQueryKey('org-compliance-org_get_compliance_signing_export', options);

/**
 * Org Get Compliance Signing Export
 *
 * A completed request's export: one zip holding each signed form, each form as it was
 * prepared, the signing record as a PDF and as data, and a list of each file's SHA-256. A
 * short-lived link to it and the record of issuing the link. Every file is read back and
 * matched to its record first: one that does not match refuses the export rather than hand
 * over something else.
 */
export const orgComplianceOrgGetComplianceSigningExportOptions = (options: Options<OrgComplianceOrgGetComplianceSigningExportData>) => queryOptions<OrgComplianceOrgGetComplianceSigningExportResponse, OrgComplianceOrgGetComplianceSigningExportError, OrgComplianceOrgGetComplianceSigningExportResponse, ReturnType<typeof orgComplianceOrgGetComplianceSigningExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceSigningExport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceSigningExportQueryKey(options)
});

/**
 * Org Remove Compliance Signing Identity
 *
 * At the organization's direction, remove the sign-in email, IP address and browser of a
 * person who acted on this request or sent it from every signing record the organization holds.
 * The signatures and the signed forms stay as they are. Each record is written again and says
 * the details were removed, and the removal keeps the digests of the files it replaced.
 */
export const orgComplianceOrgRemoveComplianceSigningIdentityMutation = (options?: Partial<Options<OrgComplianceOrgRemoveComplianceSigningIdentityData>>): UseMutationOptions<OrgComplianceOrgRemoveComplianceSigningIdentityResponse, OrgComplianceOrgRemoveComplianceSigningIdentityError, Options<OrgComplianceOrgRemoveComplianceSigningIdentityData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRemoveComplianceSigningIdentityResponse, OrgComplianceOrgRemoveComplianceSigningIdentityError, Options<OrgComplianceOrgRemoveComplianceSigningIdentityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRemoveComplianceSigningIdentity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgGetComplianceSigningRecordLinesQueryKey = (options: Options<OrgComplianceOrgGetComplianceSigningRecordLinesData>) => createQueryKey('org-compliance-org_get_compliance_signing_record_lines', options);

/**
 * Org Get Compliance Signing Record Lines
 *
 * A completed request's signing record as a page shows it beside the signed form: the
 * record's own first-page lines, read from the stored record and matched to it first, each
 * SHA-256 shortened to its first and last four characters. Nothing is handed over, so
 * nothing is added to the download record. A request that is not completed has none.
 */
export const orgComplianceOrgGetComplianceSigningRecordLinesOptions = (options: Options<OrgComplianceOrgGetComplianceSigningRecordLinesData>) => queryOptions<OrgComplianceOrgGetComplianceSigningRecordLinesResponse, OrgComplianceOrgGetComplianceSigningRecordLinesError, OrgComplianceOrgGetComplianceSigningRecordLinesResponse, ReturnType<typeof orgComplianceOrgGetComplianceSigningRecordLinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceSigningRecordLines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceSigningRecordLinesQueryKey(options)
});

/**
 * Org Revise Compliance Signing Request
 *
 * A new version of an open request: its signers and capacities, the channel, the time
 * zone and the note, from the version it was read at. Every signature starts over. The
 * documents change only by sending a new request.
 */
export const orgComplianceOrgReviseComplianceSigningRequestMutation = (options?: Partial<Options<OrgComplianceOrgReviseComplianceSigningRequestData>>): UseMutationOptions<OrgComplianceOrgReviseComplianceSigningRequestResponse, OrgComplianceOrgReviseComplianceSigningRequestError, Options<OrgComplianceOrgReviseComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgReviseComplianceSigningRequestResponse, OrgComplianceOrgReviseComplianceSigningRequestError, Options<OrgComplianceOrgReviseComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgReviseComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Withdraw Compliance Signature
 *
 * Withdraw the caller's own signature from the live version, before the request is
 * completed.
 */
export const orgComplianceOrgWithdrawComplianceSignatureMutation = (options?: Partial<Options<OrgComplianceOrgWithdrawComplianceSignatureData>>): UseMutationOptions<OrgComplianceOrgWithdrawComplianceSignatureResponse, OrgComplianceOrgWithdrawComplianceSignatureError, Options<OrgComplianceOrgWithdrawComplianceSignatureData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgWithdrawComplianceSignatureResponse, OrgComplianceOrgWithdrawComplianceSignatureError, Options<OrgComplianceOrgWithdrawComplianceSignatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgWithdrawComplianceSignature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Sign Compliance Signing Request
 *
 * Sign every place the caller holds on the live version, by their typed name, under the
 * statement shown above the button.
 *
 * Name the version as it was read: a request that changed since is refused, and so is a
 * signature already made (the answer names it). Where the organization asks for a recent
 * sign-in, the caller signs in again first.
 */
export const orgComplianceOrgSignComplianceSigningRequestMutation = (options?: Partial<Options<OrgComplianceOrgSignComplianceSigningRequestData>>): UseMutationOptions<OrgComplianceOrgSignComplianceSigningRequestResponse, OrgComplianceOrgSignComplianceSigningRequestError, Options<OrgComplianceOrgSignComplianceSigningRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgSignComplianceSigningRequestResponse, OrgComplianceOrgSignComplianceSigningRequestError, Options<OrgComplianceOrgSignComplianceSigningRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgSignComplianceSigningRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Reconcile Compliance Submission Attempt
 *
 * Record what you found about a send whose outcome is uncertain.
 *
 * That the copy arrived, or Givmo staff saw it in the email service's records, records it as
 * sent; that the copy never arrived records it as not sent. Nothing is sent again.
 */
export const orgComplianceOrgReconcileComplianceSubmissionAttemptMutation = (options?: Partial<Options<OrgComplianceOrgReconcileComplianceSubmissionAttemptData>>): UseMutationOptions<OrgComplianceOrgReconcileComplianceSubmissionAttemptResponse, OrgComplianceOrgReconcileComplianceSubmissionAttemptError, Options<OrgComplianceOrgReconcileComplianceSubmissionAttemptData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgReconcileComplianceSubmissionAttemptResponse, OrgComplianceOrgReconcileComplianceSubmissionAttemptError, Options<OrgComplianceOrgReconcileComplianceSubmissionAttemptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgReconcileComplianceSubmissionAttempt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Dispatch Compliance Submission
 *
 * Send the authorized filing by email, once.
 *
 * The send is recorded before the email leaves, then what Givmo's email service answered.
 * Repeating a send already made answers it and sends nothing again.
 */
export const orgComplianceOrgDispatchComplianceSubmissionMutation = (options?: Partial<Options<OrgComplianceOrgDispatchComplianceSubmissionData>>): UseMutationOptions<OrgComplianceOrgDispatchComplianceSubmissionResponse, OrgComplianceOrgDispatchComplianceSubmissionError, Options<OrgComplianceOrgDispatchComplianceSubmissionData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgDispatchComplianceSubmissionResponse, OrgComplianceOrgDispatchComplianceSubmissionError, Options<OrgComplianceOrgDispatchComplianceSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgDispatchComplianceSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Revoke Compliance Submission Authorization
 *
 * Revoke an authorization to send, so nothing goes under it.
 *
 * Refused while a send under it is in progress or its outcome is uncertain.
 */
export const orgComplianceOrgRevokeComplianceSubmissionAuthorizationMutation = (options?: Partial<Options<OrgComplianceOrgRevokeComplianceSubmissionAuthorizationData>>): UseMutationOptions<OrgComplianceOrgRevokeComplianceSubmissionAuthorizationResponse, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationError, Options<OrgComplianceOrgRevokeComplianceSubmissionAuthorizationData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRevokeComplianceSubmissionAuthorizationResponse, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationError, Options<OrgComplianceOrgRevokeComplianceSubmissionAuthorizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRevokeComplianceSubmissionAuthorization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgComplianceOrgListComplianceSubmissionFollowThroughQueryKey = (options: Options<OrgComplianceOrgListComplianceSubmissionFollowThroughData>) => createQueryKey('org-compliance-org_list_compliance_submission_follow_through', options);

/**
 * Org List Compliance Submission Follow Through
 *
 * What is known about each filing's latest send, newest first.
 *
 * For each filing case with something sent, by Givmo or recorded by your organization: the
 * day it went, how many of the case's sends went before it, and what is known so far, such as
 * the email service's report of its delivery, a record someone in your organization made of
 * the agency's answer, the filing's confirmation on file, or that Givmo can't tell whether
 * its email went. Reading it sends nothing.
 */
export const orgComplianceOrgListComplianceSubmissionFollowThroughOptions = (options: Options<OrgComplianceOrgListComplianceSubmissionFollowThroughData>) => queryOptions<OrgComplianceOrgListComplianceSubmissionFollowThroughResponse, OrgComplianceOrgListComplianceSubmissionFollowThroughError, OrgComplianceOrgListComplianceSubmissionFollowThroughResponse, ReturnType<typeof orgComplianceOrgListComplianceSubmissionFollowThroughQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceSubmissionFollowThrough({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceSubmissionFollowThroughQueryKey(options)
});

export const orgComplianceOrgListComplianceVendorsQueryKey = (options: Options<OrgComplianceOrgListComplianceVendorsData>) => createQueryKey('org-compliance-org_list_compliance_vendors', options);

/**
 * Org List Compliance Vendors
 *
 * Recorded registered-agent and foreign-qualification facts, with provenance.
 */
export const orgComplianceOrgListComplianceVendorsOptions = (options: Options<OrgComplianceOrgListComplianceVendorsData>) => queryOptions<OrgComplianceOrgListComplianceVendorsResponse, OrgComplianceOrgListComplianceVendorsError, OrgComplianceOrgListComplianceVendorsResponse, ReturnType<typeof orgComplianceOrgListComplianceVendorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgListComplianceVendors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgListComplianceVendorsQueryKey(options)
});

export const orgComplianceOrgGetComplianceVendorQueryKey = (options: Options<OrgComplianceOrgGetComplianceVendorData>) => createQueryKey('org-compliance-org_get_compliance_vendor', options);

/**
 * Org Get Compliance Vendor
 *
 * One factual vendor record and each attributed correction.
 */
export const orgComplianceOrgGetComplianceVendorOptions = (options: Options<OrgComplianceOrgGetComplianceVendorData>) => queryOptions<OrgComplianceOrgGetComplianceVendorResponse, OrgComplianceOrgGetComplianceVendorError, OrgComplianceOrgGetComplianceVendorResponse, ReturnType<typeof orgComplianceOrgGetComplianceVendorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgComplianceOrgGetComplianceVendor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgComplianceOrgGetComplianceVendorQueryKey(options)
});

/**
 * Org Record Compliance Vendor
 *
 * Record or correct one row. Zero revision creates a new caller-chosen id.
 */
export const orgComplianceOrgRecordComplianceVendorMutation = (options?: Partial<Options<OrgComplianceOrgRecordComplianceVendorData>>): UseMutationOptions<OrgComplianceOrgRecordComplianceVendorResponse, OrgComplianceOrgRecordComplianceVendorError, Options<OrgComplianceOrgRecordComplianceVendorData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgRecordComplianceVendorResponse, OrgComplianceOrgRecordComplianceVendorError, Options<OrgComplianceOrgRecordComplianceVendorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgRecordComplianceVendor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Link Compliance Vendor Filing
 *
 * Link a record to the library filing it is (CCM-MOD5-RECORD-FILING-LINK): the
 * organization's own statement, recorded on both histories with who made it. The filing
 * then shows the record's renewal date where the library has none. The same link again is
 * answered as it stands.
 */
export const orgComplianceOrgLinkComplianceVendorFilingMutation = (options?: Partial<Options<OrgComplianceOrgLinkComplianceVendorFilingData>>): UseMutationOptions<OrgComplianceOrgLinkComplianceVendorFilingResponse, OrgComplianceOrgLinkComplianceVendorFilingError, Options<OrgComplianceOrgLinkComplianceVendorFilingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgLinkComplianceVendorFilingResponse, OrgComplianceOrgLinkComplianceVendorFilingError, Options<OrgComplianceOrgLinkComplianceVendorFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgLinkComplianceVendorFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Org Unlink Compliance Vendor Filing
 *
 * Undo the link between a record and a filing (CCM-MOD5-RECORD-FILING-LINK). Both
 * histories keep the link and record the unlink. A pair no longer linked is answered with the
 * link as it was closed; a pair never linked is refused.
 */
export const orgComplianceOrgUnlinkComplianceVendorFilingMutation = (options?: Partial<Options<OrgComplianceOrgUnlinkComplianceVendorFilingData>>): UseMutationOptions<OrgComplianceOrgUnlinkComplianceVendorFilingResponse, OrgComplianceOrgUnlinkComplianceVendorFilingError, Options<OrgComplianceOrgUnlinkComplianceVendorFilingData>> => {
    const mutationOptions: UseMutationOptions<OrgComplianceOrgUnlinkComplianceVendorFilingResponse, OrgComplianceOrgUnlinkComplianceVendorFilingError, Options<OrgComplianceOrgUnlinkComplianceVendorFilingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgComplianceOrgUnlinkComplianceVendorFiling({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contentCategoriesGetContentCategoriesQueryKey = (options?: Options<ContentCategoriesGetContentCategoriesData>) => createQueryKey('content-categories-get_content_categories', options);

/**
 * Get Content Categories
 */
export const contentCategoriesGetContentCategoriesOptions = (options?: Options<ContentCategoriesGetContentCategoriesData>) => queryOptions<ContentCategoriesGetContentCategoriesResponse, ContentCategoriesGetContentCategoriesError, ContentCategoriesGetContentCategoriesResponse, ReturnType<typeof contentCategoriesGetContentCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentCategoriesGetContentCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentCategoriesGetContentCategoriesQueryKey(options)
});

/**
 * Create Content Category
 */
export const contentCategoriesCreateContentCategoryMutation = (options?: Partial<Options<ContentCategoriesCreateContentCategoryData>>): UseMutationOptions<ContentCategoriesCreateContentCategoryResponse, ContentCategoriesCreateContentCategoryError, Options<ContentCategoriesCreateContentCategoryData>> => {
    const mutationOptions: UseMutationOptions<ContentCategoriesCreateContentCategoryResponse, ContentCategoriesCreateContentCategoryError, Options<ContentCategoriesCreateContentCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentCategoriesCreateContentCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contentCategoriesGetCauseTagsCuratedContentItemsQueryKey = (options?: Options<ContentCategoriesGetCauseTagsCuratedContentItemsData>) => createQueryKey('content-categories-get_cause_tags_curated_content_items', options);

/**
 * Get Cause Tags Curated Content Items
 */
export const contentCategoriesGetCauseTagsCuratedContentItemsOptions = (options?: Options<ContentCategoriesGetCauseTagsCuratedContentItemsData>) => queryOptions<ContentCategoriesGetCauseTagsCuratedContentItemsResponse, DefaultError, ContentCategoriesGetCauseTagsCuratedContentItemsResponse, ReturnType<typeof contentCategoriesGetCauseTagsCuratedContentItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentCategoriesGetCauseTagsCuratedContentItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentCategoriesGetCauseTagsCuratedContentItemsQueryKey(options)
});

export const contentCategoriesGetCelebrityCharitiesCuratedContentItemsQueryKey = (options?: Options<ContentCategoriesGetCelebrityCharitiesCuratedContentItemsData>) => createQueryKey('content-categories-get_celebrity_charities_curated_content_items', options);

/**
 * Get Celebrity Charities Curated Content Items
 */
export const contentCategoriesGetCelebrityCharitiesCuratedContentItemsOptions = (options?: Options<ContentCategoriesGetCelebrityCharitiesCuratedContentItemsData>) => queryOptions<ContentCategoriesGetCelebrityCharitiesCuratedContentItemsResponse, DefaultError, ContentCategoriesGetCelebrityCharitiesCuratedContentItemsResponse, ReturnType<typeof contentCategoriesGetCelebrityCharitiesCuratedContentItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentCategoriesGetCelebrityCharitiesCuratedContentItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentCategoriesGetCelebrityCharitiesCuratedContentItemsQueryKey(options)
});

export const contentCategoriesGetCharitiesCuratedContentItemsQueryKey = (options?: Options<ContentCategoriesGetCharitiesCuratedContentItemsData>) => createQueryKey('content-categories-get_charities_curated_content_items', options);

/**
 * Get Charities Curated Content Items
 */
export const contentCategoriesGetCharitiesCuratedContentItemsOptions = (options?: Options<ContentCategoriesGetCharitiesCuratedContentItemsData>) => queryOptions<ContentCategoriesGetCharitiesCuratedContentItemsResponse, DefaultError, ContentCategoriesGetCharitiesCuratedContentItemsResponse, ReturnType<typeof contentCategoriesGetCharitiesCuratedContentItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentCategoriesGetCharitiesCuratedContentItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentCategoriesGetCharitiesCuratedContentItemsQueryKey(options)
});

export const contentCategoriesGetEtfsCuratedContentItemsQueryKey = (options?: Options<ContentCategoriesGetEtfsCuratedContentItemsData>) => createQueryKey('content-categories-get_etfs_curated_content_items', options);

/**
 * Get Etfs Curated Content Items
 */
export const contentCategoriesGetEtfsCuratedContentItemsOptions = (options?: Options<ContentCategoriesGetEtfsCuratedContentItemsData>) => queryOptions<ContentCategoriesGetEtfsCuratedContentItemsResponse, DefaultError, ContentCategoriesGetEtfsCuratedContentItemsResponse, ReturnType<typeof contentCategoriesGetEtfsCuratedContentItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentCategoriesGetEtfsCuratedContentItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentCategoriesGetEtfsCuratedContentItemsQueryKey(options)
});

export const contentCategoriesGetFeaturedContentItemsQueryKey = (options?: Options<ContentCategoriesGetFeaturedContentItemsData>) => createQueryKey('content-categories-get_featured_content_items', options);

/**
 * Get Featured Content Items
 *
 * Consumer Today-feed featured row. Missing category or zero items
 * returns `{"data": []}` with HTTP 200 (unlike the legacy typed feeds).
 */
export const contentCategoriesGetFeaturedContentItemsOptions = (options?: Options<ContentCategoriesGetFeaturedContentItemsData>) => queryOptions<ContentCategoriesGetFeaturedContentItemsResponse, DefaultError, ContentCategoriesGetFeaturedContentItemsResponse, ReturnType<typeof contentCategoriesGetFeaturedContentItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentCategoriesGetFeaturedContentItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentCategoriesGetFeaturedContentItemsQueryKey(options)
});

export const contentCategoriesGetFundraisersCuratedContentItemsQueryKey = (options?: Options<ContentCategoriesGetFundraisersCuratedContentItemsData>) => createQueryKey('content-categories-get_fundraisers_curated_content_items', options);

/**
 * Get Fundraisers Curated Content Items
 */
export const contentCategoriesGetFundraisersCuratedContentItemsOptions = (options?: Options<ContentCategoriesGetFundraisersCuratedContentItemsData>) => queryOptions<ContentCategoriesGetFundraisersCuratedContentItemsResponse, DefaultError, ContentCategoriesGetFundraisersCuratedContentItemsResponse, ReturnType<typeof contentCategoriesGetFundraisersCuratedContentItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentCategoriesGetFundraisersCuratedContentItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentCategoriesGetFundraisersCuratedContentItemsQueryKey(options)
});

/**
 * Delete Content Category
 *
 * Super-admin only. Deletes a content category outright; the DB-level
 * `ON DELETE CASCADE` on `curated_content_item.content_category_id` and
 * `featured_item_override.content_category_id` removes its items and
 * per-item overrides with it. Deleting the ONLY category of a content type
 * makes that type's consumer feed answer `{"data": []}` (the MIXED
 * `/featured`, `celebrity-charities` and `fundraisers` feeds — see
 * `ContentCategoryService.get_featured_content`) or 404 (the legacy
 * `charities` / `etfs` / `cause-tags` feeds) until a new one is created.
 * This is the operator cure for the repository's duplicate-category
 * warning: delete the EXTRA row, never the one the warning says it serves
 * (the lowest id). Unknown id -> 404.
 */
export const contentCategoriesDeleteContentCategoryMutation = (options?: Partial<Options<ContentCategoriesDeleteContentCategoryData>>): UseMutationOptions<ContentCategoriesDeleteContentCategoryResponse, ContentCategoriesDeleteContentCategoryError, Options<ContentCategoriesDeleteContentCategoryData>> => {
    const mutationOptions: UseMutationOptions<ContentCategoriesDeleteContentCategoryResponse, ContentCategoriesDeleteContentCategoryError, Options<ContentCategoriesDeleteContentCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentCategoriesDeleteContentCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contentCategoriesGetContentCategoryItemsQueryKey = (options: Options<ContentCategoriesGetContentCategoryItemsData>) => createQueryKey('content-categories-get_content_category_items', options);

/**
 * Get Content Category Items
 */
export const contentCategoriesGetContentCategoryItemsOptions = (options: Options<ContentCategoriesGetContentCategoryItemsData>) => queryOptions<ContentCategoriesGetContentCategoryItemsResponse, ContentCategoriesGetContentCategoryItemsError, ContentCategoriesGetContentCategoryItemsResponse, ReturnType<typeof contentCategoriesGetContentCategoryItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentCategoriesGetContentCategoryItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentCategoriesGetContentCategoryItemsQueryKey(options)
});

/**
 * Update Category Items
 */
export const contentCategoriesUpdateCategoryItemsMutation = (options?: Partial<Options<ContentCategoriesUpdateCategoryItemsData>>): UseMutationOptions<ContentCategoriesUpdateCategoryItemsResponse, ContentCategoriesUpdateCategoryItemsError, Options<ContentCategoriesUpdateCategoryItemsData>> => {
    const mutationOptions: UseMutationOptions<ContentCategoriesUpdateCategoryItemsResponse, ContentCategoriesUpdateCategoryItemsError, Options<ContentCategoriesUpdateCategoryItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentCategoriesUpdateCategoryItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Featured Item Override
 */
export const contentCategoriesDeleteFeaturedItemOverrideMutation = (options?: Partial<Options<ContentCategoriesDeleteFeaturedItemOverrideData>>): UseMutationOptions<ContentCategoriesDeleteFeaturedItemOverrideResponse, ContentCategoriesDeleteFeaturedItemOverrideError, Options<ContentCategoriesDeleteFeaturedItemOverrideData>> => {
    const mutationOptions: UseMutationOptions<ContentCategoriesDeleteFeaturedItemOverrideResponse, ContentCategoriesDeleteFeaturedItemOverrideError, Options<ContentCategoriesDeleteFeaturedItemOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentCategoriesDeleteFeaturedItemOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert Featured Item Override
 */
export const contentCategoriesUpsertFeaturedItemOverrideMutation = (options?: Partial<Options<ContentCategoriesUpsertFeaturedItemOverrideData>>): UseMutationOptions<ContentCategoriesUpsertFeaturedItemOverrideResponse, ContentCategoriesUpsertFeaturedItemOverrideError, Options<ContentCategoriesUpsertFeaturedItemOverrideData>> => {
    const mutationOptions: UseMutationOptions<ContentCategoriesUpsertFeaturedItemOverrideResponse, ContentCategoriesUpsertFeaturedItemOverrideError, Options<ContentCategoriesUpsertFeaturedItemOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentCategoriesUpsertFeaturedItemOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Featured Item Image
 */
export const contentCategoriesDeleteFeaturedItemImageMutation = (options?: Partial<Options<ContentCategoriesDeleteFeaturedItemImageData>>): UseMutationOptions<ContentCategoriesDeleteFeaturedItemImageResponse, ContentCategoriesDeleteFeaturedItemImageError, Options<ContentCategoriesDeleteFeaturedItemImageData>> => {
    const mutationOptions: UseMutationOptions<ContentCategoriesDeleteFeaturedItemImageResponse, ContentCategoriesDeleteFeaturedItemImageError, Options<ContentCategoriesDeleteFeaturedItemImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentCategoriesDeleteFeaturedItemImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Featured Item Image
 */
export const contentCategoriesUploadFeaturedItemImageMutation = (options?: Partial<Options<ContentCategoriesUploadFeaturedItemImageData>>): UseMutationOptions<ContentCategoriesUploadFeaturedItemImageResponse, ContentCategoriesUploadFeaturedItemImageError, Options<ContentCategoriesUploadFeaturedItemImageData>> => {
    const mutationOptions: UseMutationOptions<ContentCategoriesUploadFeaturedItemImageResponse, ContentCategoriesUploadFeaturedItemImageError, Options<ContentCategoriesUploadFeaturedItemImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentCategoriesUploadFeaturedItemImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const disclaimersBundleDisclaimerQueryKey = (options: Options<DisclaimersBundleDisclaimerData>) => createQueryKey('disclaimers-bundle_disclaimer', options);

/**
 * Bundle Disclaimer
 *
 * Resolve the disclaimer for a surface plus the current T&C so mobile can
 * render the T&C in-app. Conditional GET keys on the disclaimer's
 * content_hash (same semantics as /resolve).
 */
export const disclaimersBundleDisclaimerOptions = (options: Options<DisclaimersBundleDisclaimerData>) => queryOptions<DisclaimersBundleDisclaimerResponse, DisclaimersBundleDisclaimerError, DisclaimersBundleDisclaimerResponse, ReturnType<typeof disclaimersBundleDisclaimerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await disclaimersBundleDisclaimer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: disclaimersBundleDisclaimerQueryKey(options)
});

export const disclaimersResolveDisclaimerQueryKey = (options: Options<DisclaimersResolveDisclaimerData>) => createQueryKey('disclaimers-resolve_disclaimer', options);

/**
 * Resolve Disclaimer
 *
 * Resolve the live disclaimer for a surface, optionally for a donation
 * TARGET (LCG-GT19). At most ONE of ``fundraiser_id`` / ``charity_id`` /
 * ``etf_id`` / ``collection_id`` may be supplied: the server rolls the target
 * up to its beneficiary charity set and derives the per-charity AB-488 variant
 * (A_UNCLAIMED vs B_VERIFIED), instead of the client resolving the bare surface
 * (which always yields A_UNCLAIMED). With no target, the bare-surface behaviour
 * is unchanged.
 *
 * PV3-BE8: for a FUNDING-SOURCE-keyed surface (``PLEDGE_CONSENT``, and since
 * RD-BE23 ``RECURRING_CONSENT``), the client instead supplies ``funding``
 * (``card`` / ``wallet``, case-insensitive) to DISPLAY the exact consent body
 * the server will pin at capture. ``funding`` alone is valid ONLY for those
 * surfaces and is MUTUALLY EXCLUSIVE with the four target params (funding is a
 * different key entirely — the funding source chosen, not a charity-consent
 * posture).
 *
 * RD-BE23: ``recurring=true`` selects the RECURRING (e)-block variant on
 * ``DONATE_CONFIRMATION`` / ``CAUSE_ETF``. Those bodies are keyed on BOTH
 * discriminators, so this is the one shape where ``funding`` and a target
 * travel together: ``funding`` is REQUIRED with it (without a rail the server
 * would have to guess which of the tax/fee statements is true), and the target
 * may only be ``charity_id`` or ``etf_id`` — the only two a recurring schedule
 * can have — so a client can never display a body the server would never pin.
 *
 * RD-C9: with ``recurring=true`` the rail vocabulary is ``card`` / ``wallet`` /
 * ``apple_pay``. Apple Pay is accepted ONLY there, because only the (e) block
 * has an Apple-Pay variant: its bodies are the card bodies minus the
 * backup-funding segment, which that rail never offers. The Apple-Pay consent
 * LABEL is still read as ``funding=card`` on ``RECURRING_CONSENT`` — that row
 * is the card/Apple-Pay consent state, and it is the row capture pins.
 *
 * CAM-X3: on the ONE-TIME ``DONATE_CONFIRMATION`` / ``CAUSE_ETF`` bodies,
 * ``funding`` (``card`` / ``wallet``) names the gift's rail and the optional
 * ``payer`` (``person``, the default, or ``company``) who pays, with any one
 * target. A wallet gift is a grant (no new receipt) for anyone, and a company
 * card on ``CAUSE_ETF`` drops the individual-only tax language. ``payer`` on
 * those surfaces requires ``funding`` (the rail decides the body). On
 * ``ADD_FUNDS``, ``payer=company`` alone selects the company deposit body.
 * Apple Pay and Google Pay ask for ``card``.
 *
 * GFU-BE78: ``pledge=true`` selects the AB 488 set's PLEDGE states on
 * ``DONATE_CONFIRMATION``, the set a pledge checkout composes above its consent: by
 * ``fundraiser_id`` (required; a pledge is always made on a fundraiser) and ``funding``
 * (required: ``card`` / ``apple_pay`` / ``wallet``), derived over every charity the pledge
 * would pay, a collection's active members included, hard-pinned to US/en (display equals
 * capture). Nothing published on the key → 404: never the gift body.
 *
 * Absent ``funding``, ``recurring``, ``payer`` and ``pledge``, behaviour is byte-identical
 * to before.
 *
 * Conditional GET: if ``If-None-Match`` equals the resolved content_hash,
 * returns 304; otherwise 200 with the ETag response header set to the
 * content_hash.
 */
export const disclaimersResolveDisclaimerOptions = (options: Options<DisclaimersResolveDisclaimerData>) => queryOptions<DisclaimersResolveDisclaimerResponse, DisclaimersResolveDisclaimerError, DisclaimersResolveDisclaimerResponse, ReturnType<typeof disclaimersResolveDisclaimerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await disclaimersResolveDisclaimer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: disclaimersResolveDisclaimerQueryKey(options)
});

export const disclaimersDisclaimerVersionsQueryKey = (options?: Options<DisclaimersDisclaimerVersionsData>) => createQueryKey('disclaimers-disclaimer_versions', options);

/**
 * Disclaimer Versions
 *
 * Manifest of every current LIVE disclaimer keyed by
 * ``surface|state|jurisdiction|locale`` plus the current T&C entries.
 */
export const disclaimersDisclaimerVersionsOptions = (options?: Options<DisclaimersDisclaimerVersionsData>) => queryOptions<DisclaimersDisclaimerVersionsResponse, DefaultError, DisclaimersDisclaimerVersionsResponse, ReturnType<typeof disclaimersDisclaimerVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await disclaimersDisclaimerVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: disclaimersDisclaimerVersionsQueryKey(options)
});

/**
 * Claim Donation
 *
 * Redeem a guest-donation claim token (FWD-BE1 / D4): attach the token's
 * checkout to the authenticated caller — regardless of signup email/method —
 * and backfill a default-Private feed Post. Idempotent: a same-user replay
 * (or a donation already the caller's via email-match) returns success
 * without re-homing or creating a second Post. NET-NEW endpoint consumed only
 * by NEW iOS/Android builds; the response model is additive and small.
 */
export const donationsClaimDonationMutation = (options?: Partial<Options<DonationsClaimDonationData>>): UseMutationOptions<DonationsClaimDonationResponse, DonationsClaimDonationError, Options<DonationsClaimDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsClaimDonationResponse, DonationsClaimDonationError, Options<DonationsClaimDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsClaimDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationsGetDonationGrantConfirmationQueryKey = (options: Options<DonationsGetDonationGrantConfirmationData>) => createQueryKey('donations-get_donation_grant_confirmation', options);

/**
 * Get Donation Grant Confirmation
 *
 * Return the authenticated owner's wallet grant confirmation.
 *
 * The shared service collapses flag-off, malformed, missing, foreign,
 * company-funded, and non-wallet donations into one constant-detail 404.
 * This handler performs no writes.
 */
export const donationsGetDonationGrantConfirmationOptions = (options: Options<DonationsGetDonationGrantConfirmationData>) => queryOptions<DonationsGetDonationGrantConfirmationResponse, DonationsGetDonationGrantConfirmationError, DonationsGetDonationGrantConfirmationResponse, ReturnType<typeof donationsGetDonationGrantConfirmationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationsGetDonationGrantConfirmation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationsGetDonationGrantConfirmationQueryKey(options)
});

/**
 * Resend Donation Grant Confirmation
 *
 * Re-deliver the grant confirmation to the owner's current email.
 */
export const donationsResendDonationGrantConfirmationMutation = (options?: Partial<Options<DonationsResendDonationGrantConfirmationData>>): UseMutationOptions<DonationsResendDonationGrantConfirmationResponse, DonationsResendDonationGrantConfirmationError, Options<DonationsResendDonationGrantConfirmationData>> => {
    const mutationOptions: UseMutationOptions<DonationsResendDonationGrantConfirmationResponse, DonationsResendDonationGrantConfirmationError, Options<DonationsResendDonationGrantConfirmationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsResendDonationGrantConfirmation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationMatchesGetDonationMatchesQueryKey = (options: Options<DonationMatchesGetDonationMatchesData>) => createQueryKey('donation-matches-get_donation_matches', options);

/**
 * Get Donation Matches
 */
export const donationMatchesGetDonationMatchesOptions = (options: Options<DonationMatchesGetDonationMatchesData>) => queryOptions<DonationMatchesGetDonationMatchesResponse, DonationMatchesGetDonationMatchesError, DonationMatchesGetDonationMatchesResponse, ReturnType<typeof donationMatchesGetDonationMatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationMatchesGetDonationMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationMatchesGetDonationMatchesQueryKey(options)
});

/**
 * Create User Match
 */
export const donationMatchesCreateUserMatchMutation = (options?: Partial<Options<DonationMatchesCreateUserMatchData>>): UseMutationOptions<DonationMatchesCreateUserMatchResponse, DonationMatchesCreateUserMatchError, Options<DonationMatchesCreateUserMatchData>> => {
    const mutationOptions: UseMutationOptions<DonationMatchesCreateUserMatchResponse, DonationMatchesCreateUserMatchError, Options<DonationMatchesCreateUserMatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationMatchesCreateUserMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationsGetDonationReceiptQueryKey = (options: Options<DonationsGetDonationReceiptData>) => createQueryKey('donations-get_donation_receipt', options);

/**
 * Get Donation Receipt
 *
 * Return the authenticated donor's snapshot-frozen receipt of record.
 *
 * The shared service collapses flag-off, malformed/missing/foreign donations,
 * wallet grants, missing receipts, and company-donor receipts into the same
 * constant-detail 404. This handler performs no writes.
 */
export const donationsGetDonationReceiptOptions = (options: Options<DonationsGetDonationReceiptData>) => queryOptions<DonationsGetDonationReceiptResponse, DonationsGetDonationReceiptError, DonationsGetDonationReceiptResponse, ReturnType<typeof donationsGetDonationReceiptQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationsGetDonationReceipt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationsGetDonationReceiptQueryKey(options)
});

/**
 * Resend Donation Receipt
 *
 * Re-deliver the frozen receipt to the authenticated owner's current email.
 */
export const donationsResendDonationReceiptMutation = (options?: Partial<Options<DonationsResendDonationReceiptData>>): UseMutationOptions<DonationsResendDonationReceiptResponse, DonationsResendDonationReceiptError, Options<DonationsResendDonationReceiptData>> => {
    const mutationOptions: UseMutationOptions<DonationsResendDonationReceiptResponse, DonationsResendDonationReceiptError, Options<DonationsResendDonationReceiptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsResendDonationReceipt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postsGetEtfPostsQueryKey = (options: Options<PostsGetEtfPostsData>) => createQueryKey('posts-get_etf_posts', options);

/**
 * Get Etf Posts
 */
export const postsGetEtfPostsOptions = (options: Options<PostsGetEtfPostsData>) => queryOptions<PostsGetEtfPostsResponse, PostsGetEtfPostsError, PostsGetEtfPostsResponse, ReturnType<typeof postsGetEtfPostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetEtfPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetEtfPostsQueryKey(options)
});

export const etfsGetEtfsQueryKey = (options?: Options<EtfsGetEtfsData>) => createQueryKey('etfs-get_etfs', options);

/**
 * Get Etfs
 */
export const etfsGetEtfsOptions = (options?: Options<EtfsGetEtfsData>) => queryOptions<EtfsGetEtfsResponse, EtfsGetEtfsError, EtfsGetEtfsResponse, ReturnType<typeof etfsGetEtfsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await etfsGetEtfs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: etfsGetEtfsQueryKey(options)
});

/**
 * Create Etf
 */
export const etfsCreateEtfMutation = (options?: Partial<Options<EtfsCreateEtfData>>): UseMutationOptions<EtfsCreateEtfResponse, EtfsCreateEtfError, Options<EtfsCreateEtfData>> => {
    const mutationOptions: UseMutationOptions<EtfsCreateEtfResponse, EtfsCreateEtfError, Options<EtfsCreateEtfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await etfsCreateEtf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Etf
 */
export const etfsDeleteEtfMutation = (options?: Partial<Options<EtfsDeleteEtfData>>): UseMutationOptions<EtfsDeleteEtfResponse, EtfsDeleteEtfError, Options<EtfsDeleteEtfData>> => {
    const mutationOptions: UseMutationOptions<EtfsDeleteEtfResponse, EtfsDeleteEtfError, Options<EtfsDeleteEtfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await etfsDeleteEtf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const etfsGetEtfQueryKey = (options: Options<EtfsGetEtfData>) => createQueryKey('etfs-get_etf', options);

/**
 * Get Etf
 */
export const etfsGetEtfOptions = (options: Options<EtfsGetEtfData>) => queryOptions<EtfsGetEtfResponse, EtfsGetEtfError, EtfsGetEtfResponse, ReturnType<typeof etfsGetEtfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await etfsGetEtf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: etfsGetEtfQueryKey(options)
});

/**
 * Update Etf
 */
export const etfsUpdateEtfMutation = (options?: Partial<Options<EtfsUpdateEtfData>>): UseMutationOptions<EtfsUpdateEtfResponse, EtfsUpdateEtfError, Options<EtfsUpdateEtfData>> => {
    const mutationOptions: UseMutationOptions<EtfsUpdateEtfResponse, EtfsUpdateEtfError, Options<EtfsUpdateEtfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await etfsUpdateEtf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Charity From Etf
 */
export const etfsRemoveCharityFromEtfMutation = (options?: Partial<Options<EtfsRemoveCharityFromEtfData>>): UseMutationOptions<EtfsRemoveCharityFromEtfResponse, EtfsRemoveCharityFromEtfError, Options<EtfsRemoveCharityFromEtfData>> => {
    const mutationOptions: UseMutationOptions<EtfsRemoveCharityFromEtfResponse, EtfsRemoveCharityFromEtfError, Options<EtfsRemoveCharityFromEtfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await etfsRemoveCharityFromEtf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Charity To Etf
 */
export const etfsAddCharityToEtfMutation = (options?: Partial<Options<EtfsAddCharityToEtfData>>): UseMutationOptions<EtfsAddCharityToEtfResponse, EtfsAddCharityToEtfError, Options<EtfsAddCharityToEtfData>> => {
    const mutationOptions: UseMutationOptions<EtfsAddCharityToEtfResponse, EtfsAddCharityToEtfError, Options<EtfsAddCharityToEtfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await etfsAddCharityToEtf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Etf Donation
 */
export const donationsCreateEtfDonationMutation = (options?: Partial<Options<DonationsCreateEtfDonationData>>): UseMutationOptions<DonationsCreateEtfDonationResponse, DonationsCreateEtfDonationError, Options<DonationsCreateEtfDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateEtfDonationResponse, DonationsCreateEtfDonationError, Options<DonationsCreateEtfDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateEtfDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Etf Profile Picture
 */
export const etfsUploadEtfProfilePictureMutation = (options?: Partial<Options<EtfsUploadEtfProfilePictureData>>): UseMutationOptions<EtfsUploadEtfProfilePictureResponse, EtfsUploadEtfProfilePictureError, Options<EtfsUploadEtfProfilePictureData>> => {
    const mutationOptions: UseMutationOptions<EtfsUploadEtfProfilePictureResponse, EtfsUploadEtfProfilePictureError, Options<EtfsUploadEtfProfilePictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await etfsUploadEtfProfilePicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Etf Recurring Donation
 */
export const donationsCreateEtfRecurringDonationMutation = (options?: Partial<Options<DonationsCreateEtfRecurringDonationData>>): UseMutationOptions<DonationsCreateEtfRecurringDonationResponse, DonationsCreateEtfRecurringDonationError, Options<DonationsCreateEtfRecurringDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateEtfRecurringDonationResponse, DonationsCreateEtfRecurringDonationError, Options<DonationsCreateEtfRecurringDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateEtfRecurringDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const feesGetFeesQueryKey = (options?: Options<FeesGetFeesData>) => createQueryKey('fees-get_fees', options);

/**
 * Get Fees
 */
export const feesGetFeesOptions = (options?: Options<FeesGetFeesData>) => queryOptions<FeesGetFeesResponse, DefaultError, FeesGetFeesResponse, ReturnType<typeof feesGetFeesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await feesGetFees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: feesGetFeesQueryKey(options)
});

export const feesGetProcessorFeesQueryKey = (options?: Options<FeesGetProcessorFeesData>) => createQueryKey('fees-get_processor_fees', options);

/**
 * Get Processor Fees
 */
export const feesGetProcessorFeesOptions = (options?: Options<FeesGetProcessorFeesData>) => queryOptions<FeesGetProcessorFeesResponse, DefaultError, FeesGetProcessorFeesResponse, ReturnType<typeof feesGetProcessorFeesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await feesGetProcessorFees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: feesGetProcessorFeesQueryKey(options)
});

/**
 * Update Fee
 */
export const feesUpdateFeeMutation = (options?: Partial<Options<FeesUpdateFeeData>>): UseMutationOptions<FeesUpdateFeeResponse, FeesUpdateFeeError, Options<FeesUpdateFeeData>> => {
    const mutationOptions: UseMutationOptions<FeesUpdateFeeResponse, FeesUpdateFeeError, Options<FeesUpdateFeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await feesUpdateFee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postsGetFundraiserPostsQueryKey = (options: Options<PostsGetFundraiserPostsData>) => createQueryKey('posts-get_fundraiser_posts', options);

/**
 * Get Fundraiser Posts
 *
 * Mirror of `/etf/{etf_id}/posts` (swarm MUSTFIX-5). Only authenticated
 * users can list a fundraiser's posts (iOS feed surface). DRAFT and
 * DEACTIVATED fundraisers return 404.
 */
export const postsGetFundraiserPostsOptions = (options: Options<PostsGetFundraiserPostsData>) => queryOptions<PostsGetFundraiserPostsResponse, PostsGetFundraiserPostsError, PostsGetFundraiserPostsResponse, ReturnType<typeof postsGetFundraiserPostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetFundraiserPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetFundraiserPostsQueryKey(options)
});

export const fundraisersGetFundraisersQueryKey = (options?: Options<FundraisersGetFundraisersData>) => createQueryKey('fundraisers-get_fundraisers', options);

/**
 * Get Fundraisers
 */
export const fundraisersGetFundraisersOptions = (options?: Options<FundraisersGetFundraisersData>) => queryOptions<FundraisersGetFundraisersResponse, FundraisersGetFundraisersError, FundraisersGetFundraisersResponse, ReturnType<typeof fundraisersGetFundraisersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetFundraisers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetFundraisersQueryKey(options)
});

/**
 * Create Fundraiser
 */
export const fundraisersCreateFundraiserMutation = (options?: Partial<Options<FundraisersCreateFundraiserData>>): UseMutationOptions<FundraisersCreateFundraiserResponse, FundraisersCreateFundraiserError, Options<FundraisersCreateFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersCreateFundraiserResponse, FundraisersCreateFundraiserError, Options<FundraisersCreateFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersCreateFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundraisersGetStartedByFriendsQueryKey = (options?: Options<FundraisersGetStartedByFriendsData>) => createQueryKey('fundraisers-get_started_by_friends', options);

/**
 * Get Started By Friends
 */
export const fundraisersGetStartedByFriendsOptions = (options?: Options<FundraisersGetStartedByFriendsData>) => queryOptions<FundraisersGetStartedByFriendsResponse, FundraisersGetStartedByFriendsError, FundraisersGetStartedByFriendsResponse, ReturnType<typeof fundraisersGetStartedByFriendsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetStartedByFriends({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetStartedByFriendsQueryKey(options)
});

export const fundraisersGetSupportedByFriendsQueryKey = (options?: Options<FundraisersGetSupportedByFriendsData>) => createQueryKey('fundraisers-get_supported_by_friends', options);

/**
 * Get Supported By Friends
 */
export const fundraisersGetSupportedByFriendsOptions = (options?: Options<FundraisersGetSupportedByFriendsData>) => queryOptions<FundraisersGetSupportedByFriendsResponse, FundraisersGetSupportedByFriendsError, FundraisersGetSupportedByFriendsResponse, ReturnType<typeof fundraisersGetSupportedByFriendsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetSupportedByFriends({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetSupportedByFriendsQueryKey(options)
});

/**
 * Delete Fundraiser
 */
export const fundraisersDeleteFundraiserMutation = (options?: Partial<Options<FundraisersDeleteFundraiserData>>): UseMutationOptions<FundraisersDeleteFundraiserResponse, FundraisersDeleteFundraiserError, Options<FundraisersDeleteFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersDeleteFundraiserResponse, FundraisersDeleteFundraiserError, Options<FundraisersDeleteFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersDeleteFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundraisersGetFundraiserQueryKey = (options: Options<FundraisersGetFundraiserData>) => createQueryKey('fundraisers-get_fundraiser', options);

/**
 * Get Fundraiser
 */
export const fundraisersGetFundraiserOptions = (options: Options<FundraisersGetFundraiserData>) => queryOptions<FundraisersGetFundraiserResponse, FundraisersGetFundraiserError, FundraisersGetFundraiserResponse, ReturnType<typeof fundraisersGetFundraiserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetFundraiser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetFundraiserQueryKey(options)
});

/**
 * Update Fundraiser
 */
export const fundraisersUpdateFundraiserMutation = (options?: Partial<Options<FundraisersUpdateFundraiserData>>): UseMutationOptions<FundraisersUpdateFundraiserResponse, FundraisersUpdateFundraiserError, Options<FundraisersUpdateFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersUpdateFundraiserResponse, FundraisersUpdateFundraiserError, Options<FundraisersUpdateFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersUpdateFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Campaign
 */
export const campaignsUpdateCampaignMutation = (options?: Partial<Options<CampaignsUpdateCampaignData>>): UseMutationOptions<CampaignsUpdateCampaignResponse, CampaignsUpdateCampaignError, Options<CampaignsUpdateCampaignData>> => {
    const mutationOptions: UseMutationOptions<CampaignsUpdateCampaignResponse, CampaignsUpdateCampaignError, Options<CampaignsUpdateCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsUpdateCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable Campaign
 */
export const campaignsEnableCampaignMutation = (options?: Partial<Options<CampaignsEnableCampaignData>>): UseMutationOptions<CampaignsEnableCampaignResponse, CampaignsEnableCampaignError, Options<CampaignsEnableCampaignData>> => {
    const mutationOptions: UseMutationOptions<CampaignsEnableCampaignResponse, CampaignsEnableCampaignError, Options<CampaignsEnableCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsEnableCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignsListCampaignJoinInvitesQueryKey = (options: Options<CampaignsListCampaignJoinInvitesData>) => createQueryKey('campaigns-list_campaign_join_invites', options);

/**
 * List Campaign Join Invites
 *
 * This umbrella's invites, newest first. **OWNER rank, not EDITOR** — it is the
 * one management read carrying invited EMAIL ADDRESSES, which the overview
 * deliberately never exposes. Never carries a token or its hash.
 *
 * Exists so revoke is drivable: `DELETE .../invites/{invite_id}` needs an id, and
 * the mint response alone cannot supply one to a session that did not just mint.
 *
 * Serves the canonical `{data, meta, links}` envelope (R-35) — a new list surface
 * must not mint another per-client unwrap key, so it paginates like the other
 * campaign reads rather than wrapping the rows in a named field.
 */
export const campaignsListCampaignJoinInvitesOptions = (options: Options<CampaignsListCampaignJoinInvitesData>) => queryOptions<CampaignsListCampaignJoinInvitesResponse, CampaignsListCampaignJoinInvitesError, CampaignsListCampaignJoinInvitesResponse, ReturnType<typeof campaignsListCampaignJoinInvitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListCampaignJoinInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListCampaignJoinInvitesQueryKey(options)
});

/**
 * Create Campaign Join Invite
 *
 * Mint a single-use, email-bound, expiring invite to JOIN this umbrella
 * (CPB-BE22 PR-7). OWNER rank.
 *
 * The plaintext token is the EMAIL hand-off and is **never returned on the wire**
 * — `P2PJoinInviteOut` omits it, matching `CharityInviteOut`. Re-inviting the same
 * address supersedes the prior live invite rather than stacking a second
 * redeemable token.
 */
export const campaignsCreateCampaignJoinInviteMutation = (options?: Partial<Options<CampaignsCreateCampaignJoinInviteData>>): UseMutationOptions<CampaignsCreateCampaignJoinInviteResponse, CampaignsCreateCampaignJoinInviteError, Options<CampaignsCreateCampaignJoinInviteData>> => {
    const mutationOptions: UseMutationOptions<CampaignsCreateCampaignJoinInviteResponse, CampaignsCreateCampaignJoinInviteError, Options<CampaignsCreateCampaignJoinInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsCreateCampaignJoinInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Campaign Join Invite
 *
 * Withdraw a pending invite. OWNER rank. Idempotent on an already-terminal
 * invite (204); an unknown id, or one belonging to another umbrella, is 404.
 */
export const campaignsRevokeCampaignJoinInviteMutation = (options?: Partial<Options<CampaignsRevokeCampaignJoinInviteData>>): UseMutationOptions<CampaignsRevokeCampaignJoinInviteResponse, CampaignsRevokeCampaignJoinInviteError, Options<CampaignsRevokeCampaignJoinInviteData>> => {
    const mutationOptions: UseMutationOptions<CampaignsRevokeCampaignJoinInviteResponse, CampaignsRevokeCampaignJoinInviteError, Options<CampaignsRevokeCampaignJoinInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsRevokeCampaignJoinInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignsPreviewCampaignJoinParentQueryKey = (options: Options<CampaignsPreviewCampaignJoinParentData>) => createQueryKey('campaigns-preview_campaign_join_parent', options);

/**
 * Preview Campaign Join Parent
 *
 * What this campaign may do about joining the campaign named, before it acts: how that
 * campaign's join setting lets it join, whether it takes campaigns now, when it removed this
 * one, whether the attach would link now, and what it requires. The moderation rank.
 */
export const campaignsPreviewCampaignJoinParentOptions = (options: Options<CampaignsPreviewCampaignJoinParentData>) => queryOptions<CampaignsPreviewCampaignJoinParentResponse, CampaignsPreviewCampaignJoinParentError, CampaignsPreviewCampaignJoinParentResponse, ReturnType<typeof campaignsPreviewCampaignJoinParentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsPreviewCampaignJoinParent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsPreviewCampaignJoinParentQueryKey(options)
});

/**
 * Join Campaign Parent
 *
 * Join another campaign as one of its layers, or ask to, as its join setting allows:
 * 201 ``joined`` (the attach ran), 202 ``asked`` (a request waits for its organizers), or
 * 200 ``asked`` for a repeat, answering the request that already waits. Joining, or
 * asking, is this campaign's consent to the layer terms. The console's door only, never a
 * tool.
 */
export const campaignsJoinCampaignParentMutation = (options?: Partial<Options<CampaignsJoinCampaignParentData>>): UseMutationOptions<CampaignsJoinCampaignParentResponse, CampaignsJoinCampaignParentError, Options<CampaignsJoinCampaignParentData>> => {
    const mutationOptions: UseMutationOptions<CampaignsJoinCampaignParentResponse, CampaignsJoinCampaignParentError, Options<CampaignsJoinCampaignParentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsJoinCampaignParent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignsListCampaignJoinRequestsQueryKey = (options: Options<CampaignsListCampaignJoinRequestsData>) => createQueryKey('campaigns-list_campaign_join_requests', options);

/**
 * List Campaign Join Requests
 *
 * The people asking to start a page under this campaign, those waiting first: the name
 * and team each typed, never their account, email or goal. The read rank.
 */
export const campaignsListCampaignJoinRequestsOptions = (options: Options<CampaignsListCampaignJoinRequestsData>) => queryOptions<CampaignsListCampaignJoinRequestsResponse, CampaignsListCampaignJoinRequestsError, CampaignsListCampaignJoinRequestsResponse, ReturnType<typeof campaignsListCampaignJoinRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListCampaignJoinRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListCampaignJoinRequestsQueryKey(options)
});

/**
 * Approve Campaign Join Request
 *
 * Approve a person's request: their page is made now, by the join, with what they
 * asked, and they are emailed. A refusal at approval is the join's own 4xx, and the request
 * stays waiting. A repeat answers the approved request.
 */
export const campaignsApproveCampaignJoinRequestMutation = (options?: Partial<Options<CampaignsApproveCampaignJoinRequestData>>): UseMutationOptions<CampaignsApproveCampaignJoinRequestResponse, CampaignsApproveCampaignJoinRequestError, Options<CampaignsApproveCampaignJoinRequestData>> => {
    const mutationOptions: UseMutationOptions<CampaignsApproveCampaignJoinRequestResponse, CampaignsApproveCampaignJoinRequestError, Options<CampaignsApproveCampaignJoinRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsApproveCampaignJoinRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline Campaign Join Request
 *
 * Decline a person's request: final for them and this campaign, with no reason sent;
 * they are emailed that no page was made. A repeat answers the declined request.
 */
export const campaignsDeclineCampaignJoinRequestMutation = (options?: Partial<Options<CampaignsDeclineCampaignJoinRequestData>>): UseMutationOptions<CampaignsDeclineCampaignJoinRequestResponse, CampaignsDeclineCampaignJoinRequestError, Options<CampaignsDeclineCampaignJoinRequestData>> => {
    const mutationOptions: UseMutationOptions<CampaignsDeclineCampaignJoinRequestResponse, CampaignsDeclineCampaignJoinRequestError, Options<CampaignsDeclineCampaignJoinRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsDeclineCampaignJoinRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignsListCampaignLayerCandidatesQueryKey = (options: Options<CampaignsListCampaignLayerCandidatesData>) => createQueryKey('campaigns-list_campaign_layer_candidates', options);

/**
 * List Campaign Layer Candidates
 *
 * FCM-BE63: "A campaign you run": the organization's open campaigns outside this one's
 * chain and layers, the tops of their own trees first, each with whether it fits below or
 * above this one and why not. The moderation rank. Serves the canonical envelope.
 *
 * With ``move`` (one of this campaign's layers): the ruled Move dialog's list (frame 05),
 * the campaigns that layer's organization runs outside the layer's own subtree, other than
 * this campaign, each with where it sits and no fit: the move decides at submit. The
 * moderation rank on this campaign and on the layer; a layer not under this campaign is
 * the surface's not-found.
 */
export const campaignsListCampaignLayerCandidatesOptions = (options: Options<CampaignsListCampaignLayerCandidatesData>) => queryOptions<CampaignsListCampaignLayerCandidatesResponse, CampaignsListCampaignLayerCandidatesError, CampaignsListCampaignLayerCandidatesResponse, ReturnType<typeof campaignsListCampaignLayerCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListCampaignLayerCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListCampaignLayerCandidatesQueryKey(options)
});

export const campaignsListSentCampaignLayerInvitesQueryKey = (options: Options<CampaignsListSentCampaignLayerInvitesData>) => createQueryKey('campaigns-list_sent_campaign_layer_invites', options);

/**
 * List Sent Campaign Layer Invites
 *
 * The layer invites this campaign sent, newest first. The read rank.
 */
export const campaignsListSentCampaignLayerInvitesOptions = (options: Options<CampaignsListSentCampaignLayerInvitesData>) => queryOptions<CampaignsListSentCampaignLayerInvitesResponse, CampaignsListSentCampaignLayerInvitesError, CampaignsListSentCampaignLayerInvitesResponse, ReturnType<typeof campaignsListSentCampaignLayerInvitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListSentCampaignLayerInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListSentCampaignLayerInvitesQueryKey(options)
});

/**
 * Send Campaign Layer Invite
 *
 * Invite another organization's campaign to become a layer of this one. A repeat for
 * the same campaign answers the pending invite, with no second email.
 */
export const campaignsSendCampaignLayerInviteMutation = (options?: Partial<Options<CampaignsSendCampaignLayerInviteData>>): UseMutationOptions<CampaignsSendCampaignLayerInviteResponse, CampaignsSendCampaignLayerInviteError, Options<CampaignsSendCampaignLayerInviteData>> => {
    const mutationOptions: UseMutationOptions<CampaignsSendCampaignLayerInviteResponse, CampaignsSendCampaignLayerInviteError, Options<CampaignsSendCampaignLayerInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsSendCampaignLayerInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Campaign Layer Invite
 *
 * Withdraw a pending layer invite this campaign sent. A closed one is a no-op 204.
 */
export const campaignsRevokeCampaignLayerInviteMutation = (options?: Partial<Options<CampaignsRevokeCampaignLayerInviteData>>): UseMutationOptions<CampaignsRevokeCampaignLayerInviteResponse, CampaignsRevokeCampaignLayerInviteError, Options<CampaignsRevokeCampaignLayerInviteData>> => {
    const mutationOptions: UseMutationOptions<CampaignsRevokeCampaignLayerInviteResponse, CampaignsRevokeCampaignLayerInviteError, Options<CampaignsRevokeCampaignLayerInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsRevokeCampaignLayerInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Campaign Layer Request
 *
 * Withdraw this campaign's waiting request; nothing waiting is a no-op 204. The
 * console's door only.
 */
export const campaignsWithdrawCampaignLayerRequestMutation = (options?: Partial<Options<CampaignsWithdrawCampaignLayerRequestData>>): UseMutationOptions<CampaignsWithdrawCampaignLayerRequestResponse, CampaignsWithdrawCampaignLayerRequestError, Options<CampaignsWithdrawCampaignLayerRequestData>> => {
    const mutationOptions: UseMutationOptions<CampaignsWithdrawCampaignLayerRequestResponse, CampaignsWithdrawCampaignLayerRequestError, Options<CampaignsWithdrawCampaignLayerRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsWithdrawCampaignLayerRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignsGetOwnCampaignLayerRequestQueryKey = (options: Options<CampaignsGetOwnCampaignLayerRequestData>) => createQueryKey('campaigns-get_own_campaign_layer_request', options);

/**
 * Get Own Campaign Layer Request
 *
 * This campaign's own request to join another: the one waiting, else the latest answer
 * within the last 14 days, else none. The read rank.
 */
export const campaignsGetOwnCampaignLayerRequestOptions = (options: Options<CampaignsGetOwnCampaignLayerRequestData>) => queryOptions<CampaignsGetOwnCampaignLayerRequestResponse, CampaignsGetOwnCampaignLayerRequestError, CampaignsGetOwnCampaignLayerRequestResponse, ReturnType<typeof campaignsGetOwnCampaignLayerRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsGetOwnCampaignLayerRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsGetOwnCampaignLayerRequestQueryKey(options)
});

export const campaignsListCampaignLayerRequestsQueryKey = (options: Options<CampaignsListCampaignLayerRequestsData>) => createQueryKey('campaigns-list_campaign_layer_requests', options);

/**
 * List Campaign Layer Requests
 *
 * The requests other organizations' campaigns sent to become this campaign's layers,
 * those waiting first, each with whether the attach would link now. The read rank; pages
 * by at most 25, as the layer invitations' lists do.
 */
export const campaignsListCampaignLayerRequestsOptions = (options: Options<CampaignsListCampaignLayerRequestsData>) => queryOptions<CampaignsListCampaignLayerRequestsResponse, CampaignsListCampaignLayerRequestsError, CampaignsListCampaignLayerRequestsResponse, ReturnType<typeof campaignsListCampaignLayerRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListCampaignLayerRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListCampaignLayerRequestsQueryKey(options)
});

/**
 * Approve Campaign Layer Request
 *
 * Approve another campaign's request: it becomes a layer of this one, with every check
 * an attach makes (a failed one is its 409, and the request stays waiting). The console's
 * door only, never a tool.
 */
export const campaignsApproveCampaignLayerRequestMutation = (options?: Partial<Options<CampaignsApproveCampaignLayerRequestData>>): UseMutationOptions<CampaignsApproveCampaignLayerRequestResponse, CampaignsApproveCampaignLayerRequestError, Options<CampaignsApproveCampaignLayerRequestData>> => {
    const mutationOptions: UseMutationOptions<CampaignsApproveCampaignLayerRequestResponse, CampaignsApproveCampaignLayerRequestError, Options<CampaignsApproveCampaignLayerRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsApproveCampaignLayerRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline Campaign Layer Request
 *
 * Decline another campaign's request: final for the pair; an invitation still brings it
 * in. The console's door only.
 */
export const campaignsDeclineCampaignLayerRequestMutation = (options?: Partial<Options<CampaignsDeclineCampaignLayerRequestData>>): UseMutationOptions<CampaignsDeclineCampaignLayerRequestResponse, CampaignsDeclineCampaignLayerRequestError, Options<CampaignsDeclineCampaignLayerRequestData>> => {
    const mutationOptions: UseMutationOptions<CampaignsDeclineCampaignLayerRequestResponse, CampaignsDeclineCampaignLayerRequestError, Options<CampaignsDeclineCampaignLayerRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsDeclineCampaignLayerRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignsListCampaignLayersQueryKey = (options: Options<CampaignsListCampaignLayersData>) => createQueryKey('campaigns-list_campaign_layers', options);

/**
 * List Campaign Layers
 *
 * This campaign's child layers, oldest link first: each one's name and state. The
 * read rank, like the overview. Serves the canonical `{data, meta, links}` envelope.
 */
export const campaignsListCampaignLayersOptions = (options: Options<CampaignsListCampaignLayersData>) => queryOptions<CampaignsListCampaignLayersResponse, CampaignsListCampaignLayersError, CampaignsListCampaignLayersResponse, ReturnType<typeof campaignsListCampaignLayersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListCampaignLayers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListCampaignLayersQueryKey(options)
});

/**
 * Attach Campaign Layer
 *
 * Attach a campaign the caller also organizes under this one. A repeat answers the
 * same link.
 */
export const campaignsAttachCampaignLayerMutation = (options?: Partial<Options<CampaignsAttachCampaignLayerData>>): UseMutationOptions<CampaignsAttachCampaignLayerResponse, CampaignsAttachCampaignLayerError, Options<CampaignsAttachCampaignLayerData>> => {
    const mutationOptions: UseMutationOptions<CampaignsAttachCampaignLayerResponse, CampaignsAttachCampaignLayerError, Options<CampaignsAttachCampaignLayerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsAttachCampaignLayer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Campaign Layer
 *
 * Remove one of this campaign's layers; it becomes a campaign of its own. A layer no
 * longer under this campaign is a no-op 204.
 */
export const campaignsRemoveCampaignLayerMutation = (options?: Partial<Options<CampaignsRemoveCampaignLayerData>>): UseMutationOptions<CampaignsRemoveCampaignLayerResponse, CampaignsRemoveCampaignLayerError, Options<CampaignsRemoveCampaignLayerData>> => {
    const mutationOptions: UseMutationOptions<CampaignsRemoveCampaignLayerResponse, CampaignsRemoveCampaignLayerError, Options<CampaignsRemoveCampaignLayerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsRemoveCampaignLayer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Leave Campaign Layer
 *
 * Leave the campaign this one is part of: only when no one can bring that campaign
 * back (its group dissolved, or its organizer deleted their account); otherwise only its
 * organizers can remove this one (409). A campaign with no parent is a no-op 204.
 */
export const campaignsLeaveCampaignLayerMutation = (options?: Partial<Options<CampaignsLeaveCampaignLayerData>>): UseMutationOptions<CampaignsLeaveCampaignLayerResponse, CampaignsLeaveCampaignLayerError, Options<CampaignsLeaveCampaignLayerData>> => {
    const mutationOptions: UseMutationOptions<CampaignsLeaveCampaignLayerResponse, CampaignsLeaveCampaignLayerError, Options<CampaignsLeaveCampaignLayerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsLeaveCampaignLayer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move Campaign Layer
 *
 * Move this campaign under another campaign, holding the organizer rank on all three.
 * A repeat answers the same link.
 */
export const campaignsMoveCampaignLayerMutation = (options?: Partial<Options<CampaignsMoveCampaignLayerData>>): UseMutationOptions<CampaignsMoveCampaignLayerResponse, CampaignsMoveCampaignLayerError, Options<CampaignsMoveCampaignLayerData>> => {
    const mutationOptions: UseMutationOptions<CampaignsMoveCampaignLayerResponse, CampaignsMoveCampaignLayerError, Options<CampaignsMoveCampaignLayerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsMoveCampaignLayer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignsGetCampaignOverviewQueryKey = (options: Options<CampaignsGetCampaignOverviewData>) => createQueryKey('campaigns-get_campaign_overview', options);

/**
 * Get Campaign Overview
 */
export const campaignsGetCampaignOverviewOptions = (options: Options<CampaignsGetCampaignOverviewData>) => queryOptions<CampaignsGetCampaignOverviewResponse, CampaignsGetCampaignOverviewError, CampaignsGetCampaignOverviewResponse, ReturnType<typeof campaignsGetCampaignOverviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsGetCampaignOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsGetCampaignOverviewQueryKey(options)
});

export const campaignsGetCampaignLayerParentQueryKey = (options: Options<CampaignsGetCampaignLayerParentData>) => createQueryKey('campaigns-get_campaign_layer_parent', options);

/**
 * Get Campaign Layer Parent
 *
 * The campaigns this one is part of, top first, and whether its organizers may leave
 * its parent. The read rank.
 */
export const campaignsGetCampaignLayerParentOptions = (options: Options<CampaignsGetCampaignLayerParentData>) => queryOptions<CampaignsGetCampaignLayerParentResponse, CampaignsGetCampaignLayerParentError, CampaignsGetCampaignLayerParentResponse, ReturnType<typeof campaignsGetCampaignLayerParentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsGetCampaignLayerParent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsGetCampaignLayerParentQueryKey(options)
});

export const campaignsListReceivedCampaignLayerInvitesQueryKey = (options: Options<CampaignsListReceivedCampaignLayerInvitesData>) => createQueryKey('campaigns-list_received_campaign_layer_invites', options);

/**
 * List Received Campaign Layer Invites
 *
 * The layer invites this campaign received, newest first, each with the inviting
 * campaign's charities and whether this campaign could accept it now. The read rank.
 */
export const campaignsListReceivedCampaignLayerInvitesOptions = (options: Options<CampaignsListReceivedCampaignLayerInvitesData>) => queryOptions<CampaignsListReceivedCampaignLayerInvitesResponse, CampaignsListReceivedCampaignLayerInvitesError, CampaignsListReceivedCampaignLayerInvitesResponse, ReturnType<typeof campaignsListReceivedCampaignLayerInvitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListReceivedCampaignLayerInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListReceivedCampaignLayerInvitesQueryKey(options)
});

/**
 * Accept Campaign Layer Invite
 *
 * Accept a layer invite this campaign received: it becomes a layer of the inviting
 * campaign, with every check an attach makes (a failed one is its 409, and the invite stays
 * pending). Accepting is the consent (Q3). The console's door only, never a tool.
 */
export const campaignsAcceptCampaignLayerInviteMutation = (options?: Partial<Options<CampaignsAcceptCampaignLayerInviteData>>): UseMutationOptions<CampaignsAcceptCampaignLayerInviteResponse, CampaignsAcceptCampaignLayerInviteError, Options<CampaignsAcceptCampaignLayerInviteData>> => {
    const mutationOptions: UseMutationOptions<CampaignsAcceptCampaignLayerInviteResponse, CampaignsAcceptCampaignLayerInviteError, Options<CampaignsAcceptCampaignLayerInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsAcceptCampaignLayerInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline Campaign Layer Invite
 *
 * Decline a layer invite this campaign received. The console's door only.
 */
export const campaignsDeclineCampaignLayerInviteMutation = (options?: Partial<Options<CampaignsDeclineCampaignLayerInviteData>>): UseMutationOptions<CampaignsDeclineCampaignLayerInviteResponse, CampaignsDeclineCampaignLayerInviteError, Options<CampaignsDeclineCampaignLayerInviteData>> => {
    const mutationOptions: UseMutationOptions<CampaignsDeclineCampaignLayerInviteResponse, CampaignsDeclineCampaignLayerInviteError, Options<CampaignsDeclineCampaignLayerInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsDeclineCampaignLayerInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Up Campaign Season
 *
 * Make a season's games, one transaction per game. For each game: its page, a campaign
 * under the season named for it, raising for the season's charities where the season picks
 * them (a page whose donors pick theirs where its supporters pick); its nightly pledge
 * fundraiser, a campaign under the game with joining shut, raising for `nightly_recipients`
 * where the season's supporters pick (from the list that binds them; none sent where the
 * season picks); both published; the season's pledge template copied onto the two, dated by
 * the game (the count on the game, the offer on the nightly fundraiser); the opponent's side
 * of the game's scoreboard, a `fan` count of the same unit, when the copy is a count the
 * organizer enters and the game names an `opponent`; and the nightly fundraiser featured on
 * the game's page. On the season's first setup, while nothing is under it yet, the first game
 * made also makes the season the level its games' pages show, in the Schedule look; games
 * added later leave the card as the season's organizers last set it. A game the writes
 * refuse, or one that meets a fault, is made not at all and listed in `refused` with the
 * refusing write's own sentence (null for a fault); the others are made, so sending the
 * refused games again makes the season whole. For the
 * season's organizers at its moderation rank; anyone else, or a missing fundraiser, 404. A
 * fundraiser that is not a campaign, 404. A season with no pledge template, 404; one this
 * server cannot read, one that names no one it counts, or one that counts a total, 400,
 * before any game is made; so is a season whose games could not be its own organizer's.
 * When any game names an opponent on a season that counts, Terms of Use evidence that is not
 * the current Terms answers 409 `PLEDGE_CREATOR_TERMS_CHANGED` (no current Terms, 409
 * `PLEDGE_CREATOR_TERMS_UNAVAILABLE`), before any game is made.
 * `Idempotency-Key` REQUIRED (fail-closed 422).
 *
 * The season's own settings are not this act's: the console saves them first, in this order,
 * its deadline and what its campaigns are called (`PATCH /fundraisers/{fundraiser_id}/
 * campaign`), then its pledge template (`PUT /fundraisers/{fundraiser_id}/pledge-template`),
 * and then sends this act, each game's `opponent` as an object and the nightly picks as
 * `nightly_recipients`. A retry: an answer that was lost is asked again with the same
 * `Idempotency-Key` and the same body, which answers the stored answer (or 409 while the act
 * still runs); the games `refused` names are sent again under a new key, alone or with the
 * whole schedule: a game the season already holds under the same page name and first pitch
 * is answered among `games` as it stands, and none of it is made again (FCM-BE130). The
 * season deleted mid-act ends it: 404 while no game of it was made, else the games left are
 * `refused` with no sentence.
 */
export const campaignsSetUpCampaignSeasonMutation = (options?: Partial<Options<CampaignsSetUpCampaignSeasonData>>): UseMutationOptions<CampaignsSetUpCampaignSeasonResponse, CampaignsSetUpCampaignSeasonError, Options<CampaignsSetUpCampaignSeasonData>> => {
    const mutationOptions: UseMutationOptions<CampaignsSetUpCampaignSeasonResponse, CampaignsSetUpCampaignSeasonError, Options<CampaignsSetUpCampaignSeasonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsSetUpCampaignSeason({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const campaignsGetCampaignLayerStructureQueryKey = (options: Options<CampaignsGetCampaignLayerStructureData>) => createQueryKey('campaigns-get_campaign_layer_structure', options);

/**
 * Get Campaign Layer Structure
 *
 * FCM-BE63: where this campaign sits and its tree's default expansion. The read rank.
 */
export const campaignsGetCampaignLayerStructureOptions = (options: Options<CampaignsGetCampaignLayerStructureData>) => queryOptions<CampaignsGetCampaignLayerStructureResponse, CampaignsGetCampaignLayerStructureError, CampaignsGetCampaignLayerStructureResponse, ReturnType<typeof campaignsGetCampaignLayerStructureQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsGetCampaignLayerStructure({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsGetCampaignLayerStructureQueryKey(options)
});

export const campaignsListCampaignStructureLayersQueryKey = (options: Options<CampaignsListCampaignStructureLayersData>) => createQueryKey('campaigns-list_campaign_structure_layers', options);

/**
 * List Campaign Structure Layers
 *
 * FCM-BE63: a page of one node's layers in this campaign's tree, oldest link first.
 * Serves the canonical `{data, meta, links}` envelope.
 */
export const campaignsListCampaignStructureLayersOptions = (options: Options<CampaignsListCampaignStructureLayersData>) => queryOptions<CampaignsListCampaignStructureLayersResponse, CampaignsListCampaignStructureLayersError, CampaignsListCampaignStructureLayersResponse, ReturnType<typeof campaignsListCampaignStructureLayersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await campaignsListCampaignStructureLayers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: campaignsListCampaignStructureLayersQueryKey(options)
});

/**
 * Update Campaign Supporter
 */
export const campaignsUpdateCampaignSupporterMutation = (options?: Partial<Options<CampaignsUpdateCampaignSupporterData>>): UseMutationOptions<CampaignsUpdateCampaignSupporterResponse, CampaignsUpdateCampaignSupporterError, Options<CampaignsUpdateCampaignSupporterData>> => {
    const mutationOptions: UseMutationOptions<CampaignsUpdateCampaignSupporterResponse, CampaignsUpdateCampaignSupporterError, Options<CampaignsUpdateCampaignSupporterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsUpdateCampaignSupporter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Campaign Team
 */
export const campaignsCreateCampaignTeamMutation = (options?: Partial<Options<CampaignsCreateCampaignTeamData>>): UseMutationOptions<CampaignsCreateCampaignTeamResponse, CampaignsCreateCampaignTeamError, Options<CampaignsCreateCampaignTeamData>> => {
    const mutationOptions: UseMutationOptions<CampaignsCreateCampaignTeamResponse, CampaignsCreateCampaignTeamError, Options<CampaignsCreateCampaignTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsCreateCampaignTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Campaign Team
 */
export const campaignsUpdateCampaignTeamMutation = (options?: Partial<Options<CampaignsUpdateCampaignTeamData>>): UseMutationOptions<CampaignsUpdateCampaignTeamResponse, CampaignsUpdateCampaignTeamError, Options<CampaignsUpdateCampaignTeamData>> => {
    const mutationOptions: UseMutationOptions<CampaignsUpdateCampaignTeamResponse, CampaignsUpdateCampaignTeamError, Options<CampaignsUpdateCampaignTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await campaignsUpdateCampaignTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Charity From Fundraiser
 */
export const fundraisersRemoveCharityFromFundraiserMutation = (options?: Partial<Options<FundraisersRemoveCharityFromFundraiserData>>): UseMutationOptions<FundraisersRemoveCharityFromFundraiserResponse, FundraisersRemoveCharityFromFundraiserError, Options<FundraisersRemoveCharityFromFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersRemoveCharityFromFundraiserResponse, FundraisersRemoveCharityFromFundraiserError, Options<FundraisersRemoveCharityFromFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersRemoveCharityFromFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Charity To Fundraiser
 *
 * Empty 201 body per plan §12 and swarm SHOULDFIX-5 (matches the
 * DELETE sibling, which returns 204 with no body).
 */
export const fundraisersAddCharityToFundraiserMutation = (options?: Partial<Options<FundraisersAddCharityToFundraiserData>>): UseMutationOptions<unknown, FundraisersAddCharityToFundraiserError, Options<FundraisersAddCharityToFundraiserData>> => {
    const mutationOptions: UseMutationOptions<unknown, FundraisersAddCharityToFundraiserError, Options<FundraisersAddCharityToFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersAddCharityToFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Collection From Fundraiser
 */
export const fundraisersRemoveCollectionFromFundraiserMutation = (options?: Partial<Options<FundraisersRemoveCollectionFromFundraiserData>>): UseMutationOptions<FundraisersRemoveCollectionFromFundraiserResponse, FundraisersRemoveCollectionFromFundraiserError, Options<FundraisersRemoveCollectionFromFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersRemoveCollectionFromFundraiserResponse, FundraisersRemoveCollectionFromFundraiserError, Options<FundraisersRemoveCollectionFromFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersRemoveCollectionFromFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Collection To Fundraiser
 *
 * CC-BE7: target a Charity Collection on a fundraiser. Empty 201 body,
 * mirroring the etf sub-resource. Path matches CC-IOS6's
 * `/fundraisers/{id}/charity-collections/{collectionId}`.
 */
export const fundraisersAddCollectionToFundraiserMutation = (options?: Partial<Options<FundraisersAddCollectionToFundraiserData>>): UseMutationOptions<unknown, FundraisersAddCollectionToFundraiserError, Options<FundraisersAddCollectionToFundraiserData>> => {
    const mutationOptions: UseMutationOptions<unknown, FundraisersAddCollectionToFundraiserError, Options<FundraisersAddCollectionToFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersAddCollectionToFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close Fundraiser
 *
 * Close a fundraiser: its page stays up with its final total and new donations
 * stop. Reversible with Reopen. A repeated Close is a no-op; a draft or deactivated
 * fundraiser is a conflict.
 */
export const fundraisersCloseFundraiserMutation = (options?: Partial<Options<FundraisersCloseFundraiserData>>): UseMutationOptions<FundraisersCloseFundraiserResponse, FundraisersCloseFundraiserError, Options<FundraisersCloseFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersCloseFundraiserResponse, FundraisersCloseFundraiserError, Options<FundraisersCloseFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersCloseFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Fundraiser Donation
 */
export const donationsCreateFundraiserDonationMutation = (options?: Partial<Options<DonationsCreateFundraiserDonationData>>): UseMutationOptions<DonationsCreateFundraiserDonationResponse, DonationsCreateFundraiserDonationError, Options<DonationsCreateFundraiserDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateFundraiserDonationResponse, DonationsCreateFundraiserDonationError, Options<DonationsCreateFundraiserDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateFundraiserDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Etf From Fundraiser
 */
export const fundraisersRemoveEtfFromFundraiserMutation = (options?: Partial<Options<FundraisersRemoveEtfFromFundraiserData>>): UseMutationOptions<FundraisersRemoveEtfFromFundraiserResponse, FundraisersRemoveEtfFromFundraiserError, Options<FundraisersRemoveEtfFromFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersRemoveEtfFromFundraiserResponse, FundraisersRemoveEtfFromFundraiserError, Options<FundraisersRemoveEtfFromFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersRemoveEtfFromFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Etf To Fundraiser
 *
 * Empty 201 body per plan §12 and swarm SHOULDFIX-5.
 */
export const fundraisersAddEtfToFundraiserMutation = (options?: Partial<Options<FundraisersAddEtfToFundraiserData>>): UseMutationOptions<unknown, FundraisersAddEtfToFundraiserError, Options<FundraisersAddEtfToFundraiserData>> => {
    const mutationOptions: UseMutationOptions<unknown, FundraisersAddEtfToFundraiserError, Options<FundraisersAddEtfToFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersAddEtfToFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Match Offer Request
 */
export const fundraiserMatchOfferRequestsCreateMatchOfferRequestMutation = (options?: Partial<Options<FundraiserMatchOfferRequestsCreateMatchOfferRequestData>>): UseMutationOptions<FundraiserMatchOfferRequestsCreateMatchOfferRequestResponse, FundraiserMatchOfferRequestsCreateMatchOfferRequestError, Options<FundraiserMatchOfferRequestsCreateMatchOfferRequestData>> => {
    const mutationOptions: UseMutationOptions<FundraiserMatchOfferRequestsCreateMatchOfferRequestResponse, FundraiserMatchOfferRequestsCreateMatchOfferRequestError, Options<FundraiserMatchOfferRequestsCreateMatchOfferRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraiserMatchOfferRequestsCreateMatchOfferRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundraisersGetFundraiserMembersQueryKey = (options: Options<FundraisersGetFundraiserMembersData>) => createQueryKey('fundraisers-get_fundraiser_members', options);

/**
 * Get Fundraiser Members
 */
export const fundraisersGetFundraiserMembersOptions = (options: Options<FundraisersGetFundraiserMembersData>) => queryOptions<FundraisersGetFundraiserMembersResponse, FundraisersGetFundraiserMembersError, FundraisersGetFundraiserMembersResponse, ReturnType<typeof fundraisersGetFundraiserMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetFundraiserMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetFundraiserMembersQueryKey(options)
});

/**
 * Invite Fundraiser Member
 */
export const fundraisersInviteFundraiserMemberMutation = (options?: Partial<Options<FundraisersInviteFundraiserMemberData>>): UseMutationOptions<FundraisersInviteFundraiserMemberResponse, FundraisersInviteFundraiserMemberError, Options<FundraisersInviteFundraiserMemberData>> => {
    const mutationOptions: UseMutationOptions<FundraisersInviteFundraiserMemberResponse, FundraisersInviteFundraiserMemberError, Options<FundraisersInviteFundraiserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersInviteFundraiserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept Fundraiser Membership
 */
export const fundraisersAcceptFundraiserMembershipMutation = (options?: Partial<Options<FundraisersAcceptFundraiserMembershipData>>): UseMutationOptions<FundraisersAcceptFundraiserMembershipResponse, FundraisersAcceptFundraiserMembershipError, Options<FundraisersAcceptFundraiserMembershipData>> => {
    const mutationOptions: UseMutationOptions<FundraisersAcceptFundraiserMembershipResponse, FundraisersAcceptFundraiserMembershipError, Options<FundraisersAcceptFundraiserMembershipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersAcceptFundraiserMembership({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline Or Leave Fundraiser Membership
 */
export const fundraisersDeclineOrLeaveFundraiserMembershipMutation = (options?: Partial<Options<FundraisersDeclineOrLeaveFundraiserMembershipData>>): UseMutationOptions<FundraisersDeclineOrLeaveFundraiserMembershipResponse, FundraisersDeclineOrLeaveFundraiserMembershipError, Options<FundraisersDeclineOrLeaveFundraiserMembershipData>> => {
    const mutationOptions: UseMutationOptions<FundraisersDeclineOrLeaveFundraiserMembershipResponse, FundraisersDeclineOrLeaveFundraiserMembershipError, Options<FundraisersDeclineOrLeaveFundraiserMembershipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersDeclineOrLeaveFundraiserMembership({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Fundraiser Member
 */
export const fundraisersRemoveFundraiserMemberMutation = (options?: Partial<Options<FundraisersRemoveFundraiserMemberData>>): UseMutationOptions<FundraisersRemoveFundraiserMemberResponse, FundraisersRemoveFundraiserMemberError, Options<FundraisersRemoveFundraiserMemberData>> => {
    const mutationOptions: UseMutationOptions<FundraisersRemoveFundraiserMemberResponse, FundraisersRemoveFundraiserMemberError, Options<FundraisersRemoveFundraiserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersRemoveFundraiserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pledgesListFundraiserPledgeOffersQueryKey = (options: Options<PledgesListFundraiserPledgeOffersData>) => createQueryKey('pledges-list_fundraiser_pledge_offers', options);

/**
 * List Fundraiser Pledge Offers
 *
 * A page's pledges (plan §1.2f, §1.9.7): every pledge offer the fundraiser hosts, oldest
 * first, in every status (at most 25: a page carries no more), and every measure it owns or
 * its offers read. An offer with
 * ``measure_shown`` false is not pledgeable here: no measure of it is served, nor its status,
 * window, close or last update, and no pledge button is shown. Live pledged figures are
 * ``GET /pledges/live``'s. A fundraiser that is
 * missing, hidden from the caller, a draft, or not public → 404, except to its own
 * organizers. Anonymous or signed in; dark behind the flag.
 */
export const pledgesListFundraiserPledgeOffersOptions = (options: Options<PledgesListFundraiserPledgeOffersData>) => queryOptions<PledgesListFundraiserPledgeOffersResponse, PledgesListFundraiserPledgeOffersError, PledgesListFundraiserPledgeOffersResponse, ReturnType<typeof pledgesListFundraiserPledgeOffersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pledgesListFundraiserPledgeOffers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pledgesListFundraiserPledgeOffersQueryKey(options)
});

/**
 * Clear Pledge Template
 *
 * Clear the pledge template a campaign layer carries (plan §1.2b), for an organizer of the
 * layer at its OWNER rank; anyone else, or a fundraiser that is missing, → 404. A layer that
 * carries none answers the same 204. Copies already made never change. ``Idempotency-Key``
 * REQUIRED (fail-closed 422).
 */
export const pledgesClearPledgeTemplateMutation = (options?: Partial<Options<PledgesClearPledgeTemplateData>>): UseMutationOptions<PledgesClearPledgeTemplateResponse, PledgesClearPledgeTemplateError, Options<PledgesClearPledgeTemplateData>> => {
    const mutationOptions: UseMutationOptions<PledgesClearPledgeTemplateResponse, PledgesClearPledgeTemplateError, Options<PledgesClearPledgeTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesClearPledgeTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pledgesGetPledgeTemplateQueryKey = (options: Options<PledgesGetPledgeTemplateData>) => createQueryKey('pledges-get_pledge_template', options);

/**
 * Get Pledge Template
 *
 * The pledge template a campaign layer carries (plan §1.2b), for an organizer of the layer
 * at its OWNER rank: its measure, its offer, where its copies land (``copy_scope``) and when
 * it was last set. Anyone else, or a fundraiser that is missing, → 404, whether or not a
 * template exists; a layer that carries none → 404 to its organizer. Signed in; dark behind
 * the flag.
 */
export const pledgesGetPledgeTemplateOptions = (options: Options<PledgesGetPledgeTemplateData>) => queryOptions<PledgesGetPledgeTemplateResponse, PledgesGetPledgeTemplateError, PledgesGetPledgeTemplateResponse, ReturnType<typeof pledgesGetPledgeTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pledgesGetPledgeTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pledgesGetPledgeTemplateQueryKey(options)
});

/**
 * Set Pledge Template
 *
 * Set the ONE pledge template a campaign layer carries, replacing any it carried (plan
 * §1.2b): a measure and an offer, in ``POST /pledge-offers``' shapes, copied onto each page or
 * layer created beneath the layer (each joiner's page; each game of a season's setup). For an
 * organizer of the layer at its OWNER rank; anyone else, or a fundraiser that is missing, →
 * 404. A fundraiser that is not a campaign → 400. A layer that has ended → 409
 * ``PLEDGING_CLOSED``. An opening offset (``offer.opens_before_start_minutes``) of 0 to 10080
 * minutes → 400 ``PLEDGE_TEMPLATE_OPENING_REFUSED``: pledging on each copy opens when the copy
 * is published (D-GFU-57); one outside them is the request's own 422. What every copy would
 * refuse is refused now (400): a health-type count
 * (``health_data`` true), words naming a health subject or a candidate's election or using a
 * betting word (GFU-BE84), ending at
 * a target it lacks, of zero, or above its most likely count, a yes/no's other settings, a
 * count without its declared maximum, terms that don't fit their count, a rate or a lowest rate
 * above the cap (``PLEDGE_RATE_ABOVE_CAP``), a condition its
 * target alone decides or a rule that would pay nothing even at that target, and for a
 * template carrying its own dates, an end
 * that has passed, a window already closed, or an end past
 * the layer's own deadline. A total (``measure.rollup``) adds up, in each copy, the counts
 * beneath the page or layer that copy lands on (``scope`` ``beneath``), so one naming
 * particular counts or games is refused (400), as is any setting the measure writer refuses a
 * total; a copy onto a fundraiser with nothing beneath it is refused at the copy. Where copies
 * land (``copy_scope``): a template that names its
 * subject (``measure.subject_name``, or for a total the subject of the counts it adds up,
 * ``measure.rollup.subject_name``) is copied ONLY onto fundraisers the layer's own organizer
 * runs, never onto anyone else's page, a supporter's join included; one that leaves it unset
 * takes each copy's own subject. Copies already made never change. ``Idempotency-Key``
 * REQUIRED (fail-closed 422).
 */
export const pledgesSetPledgeTemplateMutation = (options?: Partial<Options<PledgesSetPledgeTemplateData>>): UseMutationOptions<PledgesSetPledgeTemplateResponse, PledgesSetPledgeTemplateError, Options<PledgesSetPledgeTemplateData>> => {
    const mutationOptions: UseMutationOptions<PledgesSetPledgeTemplateResponse, PledgesSetPledgeTemplateError, Options<PledgesSetPledgeTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesSetPledgeTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Fundraiser Picture
 */
export const fundraisersUploadFundraiserPictureMutation = (options?: Partial<Options<FundraisersUploadFundraiserPictureData>>): UseMutationOptions<FundraisersUploadFundraiserPictureResponse, FundraisersUploadFundraiserPictureError, Options<FundraisersUploadFundraiserPictureData>> => {
    const mutationOptions: UseMutationOptions<FundraisersUploadFundraiserPictureResponse, FundraisersUploadFundraiserPictureError, Options<FundraisersUploadFundraiserPictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersUploadFundraiserPicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Fundraiser
 */
export const fundraisersPublishFundraiserMutation = (options?: Partial<Options<FundraisersPublishFundraiserData>>): UseMutationOptions<FundraisersPublishFundraiserResponse, FundraisersPublishFundraiserError, Options<FundraisersPublishFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersPublishFundraiserResponse, FundraisersPublishFundraiserError, Options<FundraisersPublishFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersPublishFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reactivate Fundraiser
 */
export const fundraisersReactivateFundraiserMutation = (options?: Partial<Options<FundraisersReactivateFundraiserData>>): UseMutationOptions<FundraisersReactivateFundraiserResponse, FundraisersReactivateFundraiserError, Options<FundraisersReactivateFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersReactivateFundraiserResponse, FundraisersReactivateFundraiserError, Options<FundraisersReactivateFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersReactivateFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reopen Fundraiser
 *
 * Reopen a closed fundraiser so it accepts donations again. Reopening an open
 * fundraiser is a no-op; a fundraiser closed by its group's dissolution, or by its
 * organizer's account deletion, cannot be reopened.
 */
export const fundraisersReopenFundraiserMutation = (options?: Partial<Options<FundraisersReopenFundraiserData>>): UseMutationOptions<FundraisersReopenFundraiserResponse, FundraisersReopenFundraiserError, Options<FundraisersReopenFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersReopenFundraiserResponse, FundraisersReopenFundraiserError, Options<FundraisersReopenFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersReopenFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Transfer Fundraiser Ownership
 */
export const fundraisersTransferFundraiserOwnershipMutation = (options?: Partial<Options<FundraisersTransferFundraiserOwnershipData>>): UseMutationOptions<FundraisersTransferFundraiserOwnershipResponse, FundraisersTransferFundraiserOwnershipError, Options<FundraisersTransferFundraiserOwnershipData>> => {
    const mutationOptions: UseMutationOptions<FundraisersTransferFundraiserOwnershipResponse, FundraisersTransferFundraiserOwnershipError, Options<FundraisersTransferFundraiserOwnershipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersTransferFundraiserOwnership({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gameGetGameCatalogQueryKey = (options?: Options<GameGetGameCatalogData>) => createQueryKey('game-get_game_catalog', options);

/**
 * Get Game Catalog
 *
 * The server-authoritative economy + template sheet (plan §2.3/§2.9):
 * building types/prices, earn amounts + caps, mini-game rows, decor/sign
 * SKUs, template copy, `world_seed`, `schema_version`. Constant per deploy
 * (no DB read) — served with `Cache-Control: public, max-age=300`. Values
 * change only via plan-§2.9 updates (`app/domain/game_catalog.py`).
 */
export const gameGetGameCatalogOptions = (options?: Options<GameGetGameCatalogData>) => queryOptions<GameGetGameCatalogResponse, DefaultError, GameGetGameCatalogResponse, ReturnType<typeof gameGetGameCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameCatalogQueryKey(options)
});

export const gameGetGameCharityFoundationQueryKey = (options: Options<GameGetGameCharityFoundationData>) => createQueryKey('game-get_game_charity_foundation', options);

/**
 * Get Game Charity Foundation
 *
 * A charity's game foundation, get-or-create (plan §1.5/§2.3, GME-BE6):
 * template (§2.7 category mapping), world placement (null geo while the
 * charity's centroid is unresolved — plan §4), the template-seeded donor
 * objects with LIVE claim state, the real-charity block (name /
 * deterministic GCS logo URL / Verified badge / status), and the §1.8
 * "Givmo visited" badge. First read materializes the row race-safely;
 * 404s: unknown charity, or caller not yet onboarded (the FTUE gate).
 */
export const gameGetGameCharityFoundationOptions = (options: Options<GameGetGameCharityFoundationData>) => queryOptions<GameGetGameCharityFoundationResponse, GameGetGameCharityFoundationError, GameGetGameCharityFoundationResponse, ReturnType<typeof gameGetGameCharityFoundationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameCharityFoundation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameCharityFoundationQueryKey(options)
});

/**
 * Remove Charity Foundation Reaction
 *
 * Remove the caller's reaction from a charity foundation (GME-BE15).
 * Convergent — "ensure absent" (`changed: false` when nothing was held);
 * no target validation, 200 with the post-write counts block (the PUT
 * twin's state read).
 */
export const gameRemoveCharityFoundationReactionMutation = (options?: Partial<Options<GameRemoveCharityFoundationReactionData>>): UseMutationOptions<GameRemoveCharityFoundationReactionResponse, GameRemoveCharityFoundationReactionError, Options<GameRemoveCharityFoundationReactionData>> => {
    const mutationOptions: UseMutationOptions<GameRemoveCharityFoundationReactionResponse, GameRemoveCharityFoundationReactionError, Options<GameRemoveCharityFoundationReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameRemoveCharityFoundationReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Charity Foundation Reaction
 *
 * Set (insert-or-replace) the caller's single preset-emoji reaction on
 * a charity foundation (GME-BE15 — charity foundations are reaction
 * targets too, the plan-§5 polymorphic pair). Same contract as the player
 * twin, minus the self check (a charity foundation has no in-game owner):
 * unknown emoji → 400 INVALID_REACTION; unknown charity (or caller not
 * onboarded) → 404; foundation never materialized → 400
 * CHARITY_NOT_MATERIALIZED (you react to a scene you visited — the
 * GME-BE7 earn posture); over the daily cap → 429.
 */
export const gameSetCharityFoundationReactionMutation = (options?: Partial<Options<GameSetCharityFoundationReactionData>>): UseMutationOptions<GameSetCharityFoundationReactionResponse, GameSetCharityFoundationReactionError, Options<GameSetCharityFoundationReactionData>> => {
    const mutationOptions: UseMutationOptions<GameSetCharityFoundationReactionResponse, GameSetCharityFoundationReactionError, Options<GameSetCharityFoundationReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameSetCharityFoundationReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim Game Object
 *
 * Bind a donation to a donor-recognition object (plan §3.2, GME-BE8): the
 * body carries only `{donation_id}`; the server runs the whole §3.2
 * validation chain under the donation-row FOR-UPDATE lock — the donation
 * exists AND belongs to the caller, its charity is THIS charity, its amount
 * clears the object's tier, it is unbound across claims AND treats, and the
 * object is unclaimed — then inserts the (permanent) claim atomically.
 *
 * Typed errors: 404 (unknown charity / OBJECT_NOT_FOUND object_key), 400
 * (CHARITY_NOT_MATERIALIZED / DONATION_NOT_FOUND / DONATION_CHARITY_MISMATCH
 * / DONATION_BELOW_TIER), 409 (DONATION_ALREADY_USED / OBJECT_ALREADY_CLAIMED
 * — plan §4: the donation stays bindable to other objects). The donation is
 * never created/modified/refunded (plan §3, law). Returns the claimed
 * object's post-bind state so the client celebrates the RECOGNITION without
 * a foundation refetch; deliberately 200 (the recognition record, not a
 * fresh addressable resource the client will GET back by id).
 */
export const gameClaimGameObjectMutation = (options?: Partial<Options<GameClaimGameObjectData>>): UseMutationOptions<GameClaimGameObjectResponse, GameClaimGameObjectError, Options<GameClaimGameObjectData>> => {
    const mutationOptions: UseMutationOptions<GameClaimGameObjectResponse, GameClaimGameObjectError, Options<GameClaimGameObjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameClaimGameObject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gameSearchGameCitiesQueryKey = (options?: Options<GameSearchGameCitiesData>) => createQueryKey('game-search_game_cities', options);

/**
 * Search Game Cities
 *
 * Onboarding city type-ahead (plan §2.3, D-GME-33): population-ranked
 * prefix search over the Census-places `game_city` table (name, or
 * "name, st"), capped results. With no `q`: the coarse onboarding
 * suggestion list (`suggestion_source` says how it was derived — see the
 * service's IP-geo seam note). Never reads device location.
 */
export const gameSearchGameCitiesOptions = (options?: Options<GameSearchGameCitiesData>) => queryOptions<GameSearchGameCitiesResponse, GameSearchGameCitiesError, GameSearchGameCitiesResponse, ReturnType<typeof gameSearchGameCitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameSearchGameCities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameSearchGameCitiesQueryKey(options)
});

export const gameGetGameCoinsQueryKey = (options?: Options<GameGetGameCoinsData>) => createQueryKey('game-get_game_coins', options);

/**
 * Get Game Coins
 *
 * The caller's coin balance + ledger history (plan §2.3, GME-BE7): the
 * standard paginated `{data, meta, links}` envelope (newest first;
 * `page[limit]`/`page[offset]`) with the additive top-level `balance`
 * (ledger-summed, server-authoritative §3.1). Entries are a projection —
 * `reason` (tolerant OPEN-set string), the HISTORY-projected `subject`
 * (`history_subject`: `foundation_visited` masks to the date only —
 * STORAGE keeps the visitor-day idempotency key; every other reason
 * serves verbatim), signed `amount`, `created_at`. 404 before onboarding;
 * served `private, no-store` (per-user, moving data — the map-read
 * posture).
 */
export const gameGetGameCoinsOptions = (options?: Options<GameGetGameCoinsData>) => queryOptions<GameGetGameCoinsResponse, GameGetGameCoinsError, GameGetGameCoinsResponse, ReturnType<typeof gameGetGameCoinsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameCoins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameCoinsQueryKey(options)
});

/**
 * Earn Game Coins
 *
 * Record a client-reported coin earn (plan §1.4/§2.3/§3.1, GME-BE7;
 * mini-games GME-BE13): `{reason, subject}` → the server re-derives the
 * amount from the §2.9 catalog, enforces the reason's validity rules
 * (typed 400s UNKNOWN_REASON / INVALID_SUBJECT / CHARITY_NOT_MATERIALIZED
 * / NOT_FOLLOWED / TARGET_NOT_IN_GAME / TEMPLATE_MISMATCH /
 * REASON_DISABLED) and daily cap, and appends the idempotent ledger row.
 * A repeat report or a reached cap is a NO-OP SUCCESS (`earned: false` —
 * play never errors), discriminated by the additive `capped` field
 * (true ⟺ the day's cap is exhausted and this report never will credit —
 * the client's "just for fun" card; a replayed already-credited report
 * stays false); deliberately 200, not 201: the endpoint converges, it
 * doesn't create a canonical resource. 404 before onboarding (the FTUE
 * gate).
 */
export const gameEarnGameCoinsMutation = (options?: Partial<Options<GameEarnGameCoinsData>>): UseMutationOptions<GameEarnGameCoinsResponse, GameEarnGameCoinsError, Options<GameEarnGameCoinsData>> => {
    const mutationOptions: UseMutationOptions<GameEarnGameCoinsResponse, GameEarnGameCoinsError, Options<GameEarnGameCoinsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameEarnGameCoins({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gameGetGameConfigQueryKey = (options?: Options<GameGetGameConfigData>) => createQueryKey('game-get_game_config', options);

/**
 * Get Game Config
 *
 * The client gate (plan §2.3): `{enabled, min_client_version,
 * rollout_percent}` straight from the env flags — cheap, no DB read. Behind
 * the global Firebase/App Check auth like `GET /assistant/config` (the
 * caller must be an authenticated user).
 */
export const gameGetGameConfigOptions = (options?: Options<GameGetGameConfigData>) => queryOptions<GameGetGameConfigResponse, DefaultError, GameGetGameConfigResponse, ReturnType<typeof gameGetGameConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameConfigQueryKey(options)
});

/**
 * Catch Game Dog
 *
 * Catch the month's Givmo Dog (plan §1.8/§3.3, GME-BE9): atomic
 * first-catch-wins — a single conditional UPDATE on the UNIQUE month row
 * elects exactly one winner, structurally (one event per month + one catch
 * per event = the $100/month cap). NO body: the server derives the month,
 * validates the spawn day, and stamps everything (§3.1 — the client
 * asserts nothing). Catching is FREE — no coin/treat/donation coupling of
 * any kind.
 *
 * Typed errors: 400 NOT_SPAWN_DAY (no dog out today), 409 ALREADY_CAUGHT
 * (the envelope carries the winner's live `caught_by_username` for the
 * "someone caught him!" moment). Success returns the catch + payout state
 * (REQUESTED with the caller's championed charity, or PENDING_CHAMPION →
 * the client prompts the champion picker). Deliberately 200 (a converging
 * action on the month event, not a fresh addressable resource — the
 * earn/claim posture). 404 before onboarding.
 */
export const gameCatchGameDogMutation = (options?: Partial<Options<GameCatchGameDogData>>): UseMutationOptions<GameCatchGameDogResponse, DefaultError, Options<GameCatchGameDogData>> => {
    const mutationOptions: UseMutationOptions<GameCatchGameDogResponse, DefaultError, Options<GameCatchGameDogData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameCatchGameDog({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gameGetGameDogStatusQueryKey = (options?: Options<GameGetGameDogStatusData>) => createQueryKey('game-get_game_dog_status', options);

/**
 * Get Game Dog Status
 *
 * The current month's Givmo Dog view (plan §1.8, GME-BE9): whether he's
 * loose today, where he spawned (revealed on/after the spawn day only),
 * who caught him (live username + follow-window expiry; the catcher also
 * sees their payout state so the client keeps offering the champion picker
 * while PENDING_CHAMPION), and the permanent visited-badge history. A
 * catcher whose championed charity is now set gets their pick reconciled
 * lazily on this read (PENDING_CHAMPION → REQUESTED — the only
 * programmatic payout transition; SENT/CONFIRMED are operator-runbook-only,
 * §3.3). 404 before onboarding (the FTUE gate).
 */
export const gameGetGameDogStatusOptions = (options?: Options<GameGetGameDogStatusData>) => queryOptions<GameGetGameDogStatusResponse, DefaultError, GameGetGameDogStatusResponse, ReturnType<typeof gameGetGameDogStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameDogStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameDogStatusQueryKey(options)
});

export const gameGetGameFoundationQueryKey = (options?: Options<GameGetGameFoundationData>) => createQueryKey('game-get_game_foundation', options);

/**
 * Get Game Foundation
 *
 * The caller's own foundation document (plan §2.3, GME-BE5): the stored
 * canonical-v2 spec (served verbatim), the version the next PUT carries as
 * `expected_version`, and the ledger-summed coin balance. 404 before
 * onboarding; the §1.3 starter baseline seeds idempotently on first
 * read — never an empty lot.
 */
export const gameGetGameFoundationOptions = (options?: Options<GameGetGameFoundationData>) => queryOptions<GameGetGameFoundationResponse, DefaultError, GameGetGameFoundationResponse, ReturnType<typeof gameGetGameFoundationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameFoundation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameFoundationQueryKey(options)
});

/**
 * Put Game Foundation
 *
 * Write the caller's foundation document (plan §2.3/§3.1, GME-BE5 — the
 * economy's spend path): `{spec, expected_version}` → version check first
 * (409 VERSION_CONFLICT), v1-view merge-preserve vs v2 full-document
 * routing, typed validation (INVALID_SPEC / INVALID_PALETTE /
 * INVALID_DECOR_ITEM / DECOR_BUDGET_EXCEEDED / UNSUPPORTED_SCHEMA_VERSION),
 * catalog delta pricing, atomic coin debit (409 INSUFFICIENT_COINS) +
 * document write + version bump — all-or-nothing. Returns the same body as
 * GET, post-edit.
 */
export const gamePutGameFoundationMutation = (options?: Partial<Options<GamePutGameFoundationData>>): UseMutationOptions<GamePutGameFoundationResponse, GamePutGameFoundationError, Options<GamePutGameFoundationData>> => {
    const mutationOptions: UseMutationOptions<GamePutGameFoundationResponse, GamePutGameFoundationError, Options<GamePutGameFoundationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gamePutGameFoundation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gameGetGamePendingGiftsQueryKey = (options?: Options<GameGetGamePendingGiftsData>) => createQueryKey('game-get_game_pending_gifts', options);

/**
 * Get Game Pending Gifts
 *
 * The caller's claimable donation gifts (GME-BE23, D-GME-36): the standard
 * paginated `{data, meta, links}` envelope of the caller's OWN personal
 * donations at the ≥ $1 bonus tier that have NOT yet earned their
 * `donation_bonus` coins, newest first (`page[limit]`/`page[offset]`), each
 * with the donation id (the CLAIM subject), the charity's honest display name
 * (a DEACTIVATED charity renders its historical name — never crashes), the
 * entered amount, and the date. Server-derived (an anti-join against the
 * coin ledger) — no client-side "celebrated" state; survives reinstall /
 * device switch.
 *
 * Claiming a gift is the EXISTING earn path (`POST /game/coins/earn`
 * reason=donation_bonus subject=donation_id) — the donation row is STRICTLY
 * READ-ONLY here (plan §3, law). 404 before onboarding, or while the
 * `GAME_DONATION_COINS_ENABLED` sub-flag is dark (layered under GAME_ENABLED).
 * Served `private, no-store` (per-user, moving data — the coins/scrapbook
 * posture).
 */
export const gameGetGamePendingGiftsOptions = (options?: Options<GameGetGamePendingGiftsData>) => queryOptions<GameGetGamePendingGiftsResponse, GameGetGamePendingGiftsError, GameGetGamePendingGiftsResponse, ReturnType<typeof gameGetGamePendingGiftsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGamePendingGifts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGamePendingGiftsQueryKey(options)
});

export const gameGetGameMapEntitiesQueryKey = (options: Options<GameGetGameMapEntitiesData>) => createQueryKey('game-get_game_map_entities', options);

/**
 * Get Game Map Entities
 *
 * Map entities in a viewport bbox (plan §2.3, GME-BE6): charity pins
 * (active charities with resolved geo, + materialized-foundation flag) and
 * player plots (self + followed players with game profiles — §1.6). The
 * bbox is validated + area-clamped with typed 400s (INVALID_BBOX /
 * BBOX_TOO_LARGE) and each list is count-capped with `*_truncated` flags
 * (plan §4's abuse posture); a missing/non-numeric coordinate is a plain
 * 422 before the handler runs. Served uncacheable — the payload is
 * per-user (follow-scoped plots) and moving data (the champions-read
 * `private, no-store` precedent).
 */
export const gameGetGameMapEntitiesOptions = (options: Options<GameGetGameMapEntitiesData>) => queryOptions<GameGetGameMapEntitiesResponse, GameGetGameMapEntitiesError, GameGetGameMapEntitiesResponse, ReturnType<typeof gameGetGameMapEntitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameMapEntities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameMapEntitiesQueryKey(options)
});

export const gameGetGameProfileQueryKey = (options?: Options<GameGetGameProfileData>) => createQueryKey('game-get_game_profile', options);

/**
 * Get Game Profile
 *
 * The caller's own game profile (plan §2.3): city snapshot, plot cell,
 * ledger-summed coin balance, championed charity id (read live from the
 * user row). 404 before onboarding — the client reads it as "run the
 * FTUE".
 */
export const gameGetGameProfileOptions = (options?: Options<GameGetGameProfileData>) => queryOptions<GameGetGameProfileResponse, DefaultError, GameGetGameProfileResponse, ReturnType<typeof gameGetGameProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameProfileQueryKey(options)
});

/**
 * Create Game Profile
 *
 * Onboarding (plan §2.3): `{city_key}` → snapshot the city, allocate the
 * plot near its center (GME-BE3 allocator), grant the §2.9 starting coins
 * idempotently. Deliberately 200 (not 201): the endpoint is an idempotent
 * create-or-get — a duplicate call returns the existing profile with the
 * same body as GET (plan §5 GME-BE4 exit criteria).
 */
export const gameCreateGameProfileMutation = (options?: Partial<Options<GameCreateGameProfileData>>): UseMutationOptions<GameCreateGameProfileResponse, GameCreateGameProfileError, Options<GameCreateGameProfileData>> => {
    const mutationOptions: UseMutationOptions<GameCreateGameProfileResponse, GameCreateGameProfileError, Options<GameCreateGameProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameCreateGameProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Game Rescue Visitor
 *
 * Set the caller's Animal Rescue foundation visitor (GME-BE13, the
 * D-GME-23 one-pager §2 persistence hook): `{animal_key}` → the napping
 * animal at the player's foundation, one slot, overwritten by each later
 * round (pure valueless cosmetic; deliberately decoupled from the earn so
 * capped just-for-fun rounds still update it). The key is validated
 * against the closed server-known animal vocabulary (typed 400
 * INVALID_ANIMAL); 404 before onboarding (the FTUE gate). Idempotent
 * last-writer-wins PUT; the visitor serves on the foundation reads
 * (`rescue_visitor`).
 */
export const gameSetGameRescueVisitorMutation = (options?: Partial<Options<GameSetGameRescueVisitorData>>): UseMutationOptions<GameSetGameRescueVisitorResponse, GameSetGameRescueVisitorError, Options<GameSetGameRescueVisitorData>> => {
    const mutationOptions: UseMutationOptions<GameSetGameRescueVisitorResponse, GameSetGameRescueVisitorError, Options<GameSetGameRescueVisitorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameSetGameRescueVisitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gameGetGameScrapbookQueryKey = (options?: Options<GameGetGameScrapbookData>) => createQueryKey('game-get_game_scrapbook', options);

/**
 * Get Game Scrapbook
 *
 * The caller's PRIVATE cosmetic scrapbook (GME-BE19 §9): the standard
 * paginated `{data, meta, links}` envelope of cosmetic grants, newest first
 * (`page[limit]`/`page[offset]`), each with its category, source, date, and a
 * cozy where-found place label. A memory book that fills in as life happens —
 * NO completion %, NO counts, NO greyed-out silhouettes of unowned items (§9
 * law: blank pages are just blank). Never visible to visitors (a diary, not
 * the garden). 404 before onboarding; served `private, no-store`.
 */
export const gameGetGameScrapbookOptions = (options?: Options<GameGetGameScrapbookData>) => queryOptions<GameGetGameScrapbookResponse, GameGetGameScrapbookError, GameGetGameScrapbookResponse, ReturnType<typeof gameGetGameScrapbookQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameScrapbook({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameScrapbookQueryKey(options)
});

/**
 * Claim Game Surprise
 *
 * Claim one free-action surprise (GME-BE19, D-GME-32): the body carries
 * only the `source` (mystery_spot / critter_visit / balloon / sky_moment).
 * The server re-derives availability as a pure function of (user, date,
 * world_seed) — the client cannot mint a surprise, only claim what the server
 * already decided existed today. The mystery spot grants a FIXED 15 coins + a
 * cosmetic in ONE transaction; the others grant a cosmetic only. A retried
 * claim of an already-claimed surprise is a NO-OP SUCCESS (`granted: false`).
 *
 * Typed errors: 400 (UNKNOWN_SOURCE / SURPRISE_UNAVAILABLE); 404 before
 * onboarding. NOT gated by GAME_LOOT_ENABLED (that flag scopes the donation
 * gift only, one-pager §2/§7) — the free-action sources ride the router-level
 * GAME_ENABLED gate + the per-source catalog `enabled` switch. Deliberately
 * 200 (a converging claim, the earn/treat posture); cosmetics are valueless
 * forever and coins here are FIXED (§4 — never variable).
 */
export const gameClaimGameSurpriseMutation = (options?: Partial<Options<GameClaimGameSurpriseData>>): UseMutationOptions<GameClaimGameSurpriseResponse, GameClaimGameSurpriseError, Options<GameClaimGameSurpriseData>> => {
    const mutationOptions: UseMutationOptions<GameClaimGameSurpriseResponse, GameClaimGameSurpriseError, Options<GameClaimGameSurpriseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameClaimGameSurprise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gameGetGameTreatsQueryKey = (options?: Options<GameGetGameTreatsData>) => createQueryKey('game-get_game_treats', options);

/**
 * Get Game Treats
 *
 * The caller's PRIVATE applying-treat count (GME-BE10, D-GME-10(d)):
 * the still-applying total for the month the next award would bias, and
 * that month — never anyone else's numbers, no visitor-visible surface
 * anywhere. Returns to 0 after spawn-day consumption (no carryover,
 * ever). 404 before onboarding, or while either flag is dark. Served
 * `private, no-store` (per-user, moving data — the coins-read posture).
 */
export const gameGetGameTreatsOptions = (options?: Options<GameGetGameTreatsData>) => queryOptions<GameGetGameTreatsResponse, DefaultError, GameGetGameTreatsResponse, ReturnType<typeof gameGetGameTreatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetGameTreats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetGameTreatsQueryKey(options)
});

/**
 * Award Game Treats
 *
 * Award Dog Treats for a donation (GME-BE10, D-GME-10): the body carries
 * only `{donation_id}`; the server runs the whole award chain under the
 * donation-row FOR-UPDATE lock — the donation exists AND belongs to the
 * caller, is not already treat-awarded (a replay is a NO-OP SUCCESS,
 * `awarded: false` — the earn posture, never an error), was made this
 * calendar month (server UTC), and clears the $1 minimum — then inserts
 * the award atomically. COEXISTS with the donation's claim (D-GME-10(e)):
 * the same donation may back one claim AND one treat award.
 *
 * Typed errors: 400 (DONATION_NOT_FOUND / DONATION_OUTSIDE_MONTH /
 * DONATION_BELOW_TIER); 404 before onboarding, or while either flag is
 * dark. The donation is never created/modified/refunded (plan §3, law).
 * Returns this call's `quantity`, the `applies_month` it biases, and the
 * caller's post-award `month_quantity` total. Deliberately 200 (a
 * converging award on the donation, not a fresh addressable resource —
 * the earn/claim posture). Treats bias WHERE Givmo spawns, never who can
 * catch him (§3.3).
 */
export const gameAwardGameTreatsMutation = (options?: Partial<Options<GameAwardGameTreatsData>>): UseMutationOptions<GameAwardGameTreatsResponse, GameAwardGameTreatsError, Options<GameAwardGameTreatsData>> => {
    const mutationOptions: UseMutationOptions<GameAwardGameTreatsResponse, GameAwardGameTreatsError, Options<GameAwardGameTreatsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameAwardGameTreats({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gameGetUserGameFoundationQueryKey = (options: Options<GameGetUserGameFoundationData>) => createQueryKey('game-get_user_game_foundation', options);

/**
 * Get User Game Foundation
 *
 * Another player's foundation, read-only (plan §2.3, GME-BE5): profile
 * city/plot + document + the has-dog flag (§1.8; served False until the
 * GME-BE9 dog lifecycle exists). Any authenticated user; 404 when the
 * target has no game profile. Never writes — a never-edited target serves
 * the starter baseline without seeding it.
 */
export const gameGetUserGameFoundationOptions = (options: Options<GameGetUserGameFoundationData>) => queryOptions<GameGetUserGameFoundationResponse, GameGetUserGameFoundationError, GameGetUserGameFoundationResponse, ReturnType<typeof gameGetUserGameFoundationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gameGetUserGameFoundation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gameGetUserGameFoundationQueryKey(options)
});

/**
 * Remove User Foundation Reaction
 *
 * Remove the caller's reaction from another player's foundation
 * (GME-BE15). Convergent — "ensure absent": nothing held is a no-op
 * success (`changed: false`), and no target validation runs (a reaction
 * whose target left the game stays removable). Deliberately 200 with the
 * post-write counts block, not a bare 204 — the response is the PUT twin's
 * state read, not a resource tombstone.
 */
export const gameRemoveUserFoundationReactionMutation = (options?: Partial<Options<GameRemoveUserFoundationReactionData>>): UseMutationOptions<GameRemoveUserFoundationReactionResponse, GameRemoveUserFoundationReactionError, Options<GameRemoveUserFoundationReactionData>> => {
    const mutationOptions: UseMutationOptions<GameRemoveUserFoundationReactionResponse, GameRemoveUserFoundationReactionError, Options<GameRemoveUserFoundationReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameRemoveUserFoundationReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set User Foundation Reaction
 *
 * Set (insert-or-replace) the caller's single preset-emoji reaction on
 * another player's foundation (plan §1.6/§1.14, GME-BE15, D-GME-31 —
 * "Reactions, not chat"). PUT because the caller's reaction on a target is
 * a SINGLETON slot: re-sending the held emoji is a no-op success
 * (`changed: false`), a different emoji replaces it. The body carries only
 * the vocabulary `emoji_key` — unknown key → 400 INVALID_REACTION; own
 * foundation → 400 SELF_REACTION; target not in the game (or caller not
 * onboarded) → 404; over the daily set cap → 429. The response carries the
 * post-write counts block. NEVER notifies the owner (bible §9 — they
 * discover counts on next visit) and never serves reactor identities.
 */
export const gameSetUserFoundationReactionMutation = (options?: Partial<Options<GameSetUserFoundationReactionData>>): UseMutationOptions<GameSetUserFoundationReactionResponse, GameSetUserFoundationReactionError, Options<GameSetUserFoundationReactionData>> => {
    const mutationOptions: UseMutationOptions<GameSetUserFoundationReactionResponse, GameSetUserFoundationReactionError, Options<GameSetUserFoundationReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gameSetUserFoundationReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim Gift Card
 *
 * Redeem the delivered card without its code: exactly face into the caller's wallet
 * through code entry's own transition. Returns the updated wallet (the redeem
 * precedent). A retry by the same user is idempotent (200, nothing moves); 409
 * ``ALREADY_REDEEMED`` for a card someone else redeemed; 404 (the same uniform body
 * as the preview) for every other case; 429 past the caller's hourly cap (shared with
 * the preview).
 */
export const giftCardsClaimGiftCardMutation = (options?: Partial<Options<GiftCardsClaimGiftCardData>>): UseMutationOptions<GiftCardsClaimGiftCardResponse, GiftCardsClaimGiftCardError, Options<GiftCardsClaimGiftCardData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsClaimGiftCardResponse, GiftCardsClaimGiftCardError, Options<GiftCardsClaimGiftCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsClaimGiftCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Gift Card Claim
 *
 * May the caller redeem this delivered card without its code? 200 with the card
 * the claim would redeem (a support reissue followed forward), its amount and its
 * sender line; 409 ``ALREADY_REDEEMED`` when it is spent; 404 (one uniform body) for
 * every other case; 429 past the caller's hourly cap. Reads only.
 */
export const giftCardsPreviewGiftCardClaimMutation = (options?: Partial<Options<GiftCardsPreviewGiftCardClaimData>>): UseMutationOptions<GiftCardsPreviewGiftCardClaimResponse, GiftCardsPreviewGiftCardClaimError, Options<GiftCardsPreviewGiftCardClaimData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsPreviewGiftCardClaimResponse, GiftCardsPreviewGiftCardClaimError, Options<GiftCardsPreviewGiftCardClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsPreviewGiftCardClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Gift Card
 *
 * Resolve a gift-card code to its confirm-screen presentation data.
 *
 * The code travels in the request body, never the URL — server logs must
 * not capture plaintext codes.
 */
export const giftCardsPreviewGiftCardMutation = (options?: Partial<Options<GiftCardsPreviewGiftCardData>>): UseMutationOptions<GiftCardsPreviewGiftCardResponse, GiftCardsPreviewGiftCardError, Options<GiftCardsPreviewGiftCardData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsPreviewGiftCardResponse, GiftCardsPreviewGiftCardError, Options<GiftCardsPreviewGiftCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsPreviewGiftCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Purchase Gift Card Authenticated
 *
 * Authenticated in-app purchase with new money (D-GC-6). A donation-first
 * product: the charge is the gross (mandatory cover-fees gross-up) and the
 * card is funded at exactly face. The payment shape is deposit-flow — a saved
 * Shift4 ``card_id`` against the caller's ``customer_id``, or an Apple/Google
 * Pay token. Terms acceptance is recorded server-side against the session
 * user. The response NEVER carries the plaintext code, so the idempotent
 * replay of a duplicate purchase_request_id is safe.
 */
export const giftCardsPurchaseGiftCardAuthenticatedMutation = (options?: Partial<Options<GiftCardsPurchaseGiftCardAuthenticatedData>>): UseMutationOptions<GiftCardsPurchaseGiftCardAuthenticatedResponse, GiftCardsPurchaseGiftCardAuthenticatedError, Options<GiftCardsPurchaseGiftCardAuthenticatedData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsPurchaseGiftCardAuthenticatedResponse, GiftCardsPurchaseGiftCardAuthenticatedError, Options<GiftCardsPurchaseGiftCardAuthenticatedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsPurchaseGiftCardAuthenticated({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Redeem Gift Card
 *
 * Redeem a gift card into the caller's wallet at exactly printed face
 * value. Returns the updated wallet (the deposit-endpoint precedent —
 * clients refresh their balance from this response).
 */
export const giftCardsRedeemGiftCardMutation = (options?: Partial<Options<GiftCardsRedeemGiftCardData>>): UseMutationOptions<GiftCardsRedeemGiftCardResponse, GiftCardsRedeemGiftCardError, Options<GiftCardsRedeemGiftCardData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsRedeemGiftCardResponse, GiftCardsRedeemGiftCardError, Options<GiftCardsRedeemGiftCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsRedeemGiftCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const grantsGetGrantsQueryKey = (options?: Options<GrantsGetGrantsData>) => createQueryKey('grants-get_grants', options);

/**
 * Get Grants
 */
export const grantsGetGrantsOptions = (options?: Options<GrantsGetGrantsData>) => queryOptions<GrantsGetGrantsResponse, GrantsGetGrantsError, GrantsGetGrantsResponse, ReturnType<typeof grantsGetGrantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await grantsGetGrants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: grantsGetGrantsQueryKey(options)
});

/**
 * Mint Cohort
 *
 * Explicit, idempotent disbursement-time cohort mint step (GD R2 mint-trigger,
 * D-GD-19): mint one charity's FUNDABLE undisbursed recommendations for a
 * receipt_month into MINTED cohort grant(s). The off-box brain orchestrates
 * ``mint -> read disbursable -> disburse -> mark-sent``; this is the mint step.
 *
 * COLLECTION-level (no ``grant_id`` — the mint CREATES the cohort(s)). Under GF-A19
 * a fundable set that overflows the per-cohort ceiling FIFO-splits into N distinct
 * content-hash cohorts; the common under-ceiling set mints as ONE. The mint is
 * idempotent and "nothing fundable" is a valid no-op, so the response is ALWAYS 200
 * across THREE distinct cases: (1) a re-issue AFTER a successful mint returns
 * ``minted=False, grants=[]`` — the first mint already re-pointed the constituents
 * OFF the PENDING accumulator bucket, so the in-month bucket scan now finds nothing.
 * This is the normal **paid-once** no-op, NOT an error: a caller that needs the
 * cohort reads it from the disbursable read / ``GET /grants/{id}``, never from this
 * mint response. (2) The SAME cohort(s) are returned (``minted=True``, same
 * ``grant_id``(s), no duplicate) ONLY for the recs-STILL-on-bucket RETRY shape — a
 * crash before the guarded re-point committed, or an un-mint that re-pointed the
 * constituents back onto the bucket — via the content-hash ``grant_id`` ``get()``
 * short-circuit (the ns-1001 lock + guarded re-point in ``CohortMintService`` own the
 * idempotency, the endpoint adds none). (3) A receipt month with nothing
 * settled/fundable is the same valid ``minted=False, grants=[]`` no-op. ``grants``
 * carries the full set; ``grant`` (singular) is retained as the first cohort for the
 * brain's current ``{minted, grant}`` client.
 *
 * GF-A22 donation-scoped mint (OPTIONAL): supplying ``donation_ids`` + ``reason``
 * isolates an explicit subset of the charity-month's fundable recommendations into
 * their own cohort (``reason`` required iff ``donation_ids`` present — 422 otherwise;
 * the reason is recorded durably on the minted cohort's notes). A named id that is
 * not a fundable-bucket recommendation, or is not currently fundable, is refused
 * fail-closed (400, naming it) rather than silently dropped. INERT — no in-process
 * caller; reachable only by a super-admin / scoped-MCP principal (mirrors how
 * ``mark-sent`` / ``mark-returned`` sit dormant). Super-admin write (mirrors the
 * mark-sent path).
 *
 * GF-A52 operator merge (D-GD-36): with ``donation_ids``, ``receipt_month`` may be
 * omitted, and the named donations of this one charity may then come from several
 * receipt months — one operator payment covered them, and one payment is one grant.
 * They mint into one cohort whose ``receipt_month`` (its §320 anchor) is the earliest
 * donation's month. A merge whose total exceeds the per-cohort ceiling is refused
 * (400, nothing minted) rather than split. Without ``donation_ids`` the month is
 * required (422).
 */
export const grantsMintCohortMutation = (options?: Partial<Options<GrantsMintCohortData>>): UseMutationOptions<GrantsMintCohortResponse, GrantsMintCohortError, Options<GrantsMintCohortData>> => {
    const mutationOptions: UseMutationOptions<GrantsMintCohortResponse, GrantsMintCohortError, Options<GrantsMintCohortData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantsMintCohort({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const grantsGetGrantQueryKey = (options: Options<GrantsGetGrantData>) => createQueryKey('grants-get_grant', options);

/**
 * Get Grant
 */
export const grantsGetGrantOptions = (options: Options<GrantsGetGrantData>) => queryOptions<GrantsGetGrantResponse, GrantsGetGrantError, GrantsGetGrantResponse, ReturnType<typeof grantsGetGrantQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await grantsGetGrant({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: grantsGetGrantQueryKey(options)
});

/**
 * Update Grant
 */
export const grantsUpdateGrantMutation = (options?: Partial<Options<GrantsUpdateGrantData>>): UseMutationOptions<GrantsUpdateGrantResponse, GrantsUpdateGrantError, Options<GrantsUpdateGrantData>> => {
    const mutationOptions: UseMutationOptions<GrantsUpdateGrantResponse, GrantsUpdateGrantError, Options<GrantsUpdateGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantsUpdateGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Grant Returned
 *
 * Record a charity ACH/check RETURN of an already-disbursed (SENT) cohort grant
 * (GD R2): transition SENT -> RETURNED, restore the cohort's settled reservations
 * (donors re-credited), write an ACH_RETURN recovery_owed marker, and record the
 * re-queue decision (RE_OFFER re-points the donations back to the per-charity
 * PENDING bucket; HOLD leaves them). Idempotent + fail-closed: a same-
 * ``return_reference`` re-deliver is a benign no-op; a different/NULL reference on
 * an already-RETURNED grant, or any non-SENT status, is a 409 conflict.
 *
 * INERT — no prod caller; the R3 return detector will call this once built. Wired
 * now (dormant) so R3 only has to point at it. Super-admin write (mirrors the
 * mark-sent path).
 */
export const grantsMarkGrantReturnedMutation = (options?: Partial<Options<GrantsMarkGrantReturnedData>>): UseMutationOptions<GrantsMarkGrantReturnedResponse, GrantsMarkGrantReturnedError, Options<GrantsMarkGrantReturnedData>> => {
    const mutationOptions: UseMutationOptions<GrantsMarkGrantReturnedResponse, GrantsMarkGrantReturnedError, Options<GrantsMarkGrantReturnedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantsMarkGrantReturned({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Grant Sent
 *
 * Record that a CLOSED grant batch was disbursed via Mercury (GD-BB1):
 * transition CLOSED -> SENT, stamp the Mercury txn id / actual disbursed amount /
 * rail / date_sent. Idempotent + fail-closed (paid-once): a same-txn re-POST is a
 * benign 200 no-op; a different/NULL txn id on an already-SENT batch, or a
 * PENDING/COMPLETED/REJECTED batch, is a 409 conflict. Super-admin write (mirrors
 * the grant PUT path; the brain calls it via a scoped MCP at go-live).
 */
export const grantsMarkGrantSentMutation = (options?: Partial<Options<GrantsMarkGrantSentData>>): UseMutationOptions<GrantsMarkGrantSentResponse, GrantsMarkGrantSentError, Options<GrantsMarkGrantSentData>> => {
    const mutationOptions: UseMutationOptions<GrantsMarkGrantSentResponse, GrantsMarkGrantSentError, Options<GrantsMarkGrantSentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantsMarkGrantSent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unmint Grant
 *
 * Un-mint a MINTED (disbursement-ready, never-disbursed) cohort grant whose Mercury
 * payment was declined/rejected (GF-A18): transition MINTED -> REJECTED, RELEASE the
 * cohort's settled reservations (donors re-credited), and RE-POINT its constituent
 * recommendations back to the per-charity PENDING accumulator bucket so they retry on a
 * future mint cycle — all atomic under the money-path lock order. This is the ONLY
 * sanctioned MINTED -> REJECTED path; the generic PUT rejects a manual MINTED
 * disposition (it would strand the reservations + orphan the recommendations).
 *
 * Idempotent + fail-closed: a re-call on an already-REJECTED grant is a benign no-op
 * (the release does not run twice); any non-MINTED status is a 409 conflict (only a
 * MINTED cohort can be un-minted). INERT — no prod caller; the disbursement lane's
 * human-approval decline flow calls it once the lane arms. Super-admin write (mirrors
 * the mark-returned path).
 */
export const grantsUnmintGrantMutation = (options?: Partial<Options<GrantsUnmintGrantData>>): UseMutationOptions<GrantsUnmintGrantResponse, GrantsUnmintGrantError, Options<GrantsUnmintGrantData>> => {
    const mutationOptions: UseMutationOptions<GrantsUnmintGrantResponse, GrantsUnmintGrantError, Options<GrantsUnmintGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantsUnmintGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsDiscoverGroupsQueryKey = (options?: Options<GroupsDiscoverGroupsData>) => createQueryKey('groups-discover_groups', options);

/**
 * Discover Groups
 *
 * Browse or ``q``-search PUBLIC, ACTIVE, moderation-listed groups.
 */
export const groupsDiscoverGroupsOptions = (options?: Options<GroupsDiscoverGroupsData>) => queryOptions<GroupsDiscoverGroupsResponse, GroupsDiscoverGroupsError, GroupsDiscoverGroupsResponse, ReturnType<typeof groupsDiscoverGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsDiscoverGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsDiscoverGroupsQueryKey(options)
});

/**
 * Create Group
 *
 * Create a group as a DRAFT (creator → sole Owner; explicit visibility,
 * default PUBLIC; NO wallet/Shift4 customer minted yet). The creator is minted
 * as OWNER — an advisory role — so creation is 18+/DOB-gated (GRP-REM3): a
 * minor or NULL-DOB creator gets a 422 with nothing persisted.
 */
export const groupsCreateGroupMutation = (options?: Partial<Options<GroupsCreateGroupData>>): UseMutationOptions<GroupsCreateGroupResponse, GroupsCreateGroupError, Options<GroupsCreateGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsCreateGroupResponse, GroupsCreateGroupError, Options<GroupsCreateGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsCreateGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsGetGroupByHandleQueryKey = (options: Options<GroupsGetGroupByHandleData>) => createQueryKey('groups-get_group_by_handle', options);

/**
 * Get Group By Handle
 *
 * Group profile by `@handle` (case-insensitive). Same visibility/authz +
 * balance-gating as the by-id read.
 */
export const groupsGetGroupByHandleOptions = (options: Options<GroupsGetGroupByHandleData>) => queryOptions<GroupsGetGroupByHandleResponse, GroupsGetGroupByHandleError, GroupsGetGroupByHandleResponse, ReturnType<typeof groupsGetGroupByHandleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsGetGroupByHandle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsGetGroupByHandleQueryKey(options)
});

/**
 * Accept Group Invite By Token
 *
 * GRP-BE14: the unregistered-email invitee redeems the single-use token from
 * their invite-email link (`go.givmo.io/s/group-invite/<token>`), after signing
 * up / signing in with the invited email. The caller's email + verified state
 * come from the Firebase ID token (`request.state.idp_user`), NEVER the body —
 * the redemption requires a VERIFIED email equal to the invite's bound email.
 * Every non-redeemable condition collapses to ONE constant 400 (no oracle).
 * Returns the joined group (the identity-accept response shape).
 */
export const groupsAcceptGroupInviteByTokenMutation = (options?: Partial<Options<GroupsAcceptGroupInviteByTokenData>>): UseMutationOptions<GroupsAcceptGroupInviteByTokenResponse, GroupsAcceptGroupInviteByTokenError, Options<GroupsAcceptGroupInviteByTokenData>> => {
    const mutationOptions: UseMutationOptions<GroupsAcceptGroupInviteByTokenResponse, GroupsAcceptGroupInviteByTokenError, Options<GroupsAcceptGroupInviteByTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsAcceptGroupInviteByToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Group
 *
 * Owner-only. A DRAFT hard-deletes; an ACTIVE group soft-dissolves under the
 * wallet-locked zero-balance guard (balance>0 → actionable 400).
 */
export const groupsDeleteGroupMutation = (options?: Partial<Options<GroupsDeleteGroupData>>): UseMutationOptions<GroupsDeleteGroupResponse, GroupsDeleteGroupError, Options<GroupsDeleteGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsDeleteGroupResponse, GroupsDeleteGroupError, Options<GroupsDeleteGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsDeleteGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsGetGroupQueryKey = (options: Options<GroupsGetGroupData>) => createQueryKey('groups-get_group', options);

/**
 * Get Group
 *
 * Group profile by id. Balance shown ONLY to Owner/Admin; a non-member of a
 * PRIVATE group / a DRAFT to a non-creator → 404 (existence never leaked).
 */
export const groupsGetGroupOptions = (options: Options<GroupsGetGroupData>) => queryOptions<GroupsGetGroupResponse, GroupsGetGroupError, GroupsGetGroupResponse, ReturnType<typeof groupsGetGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsGetGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsGetGroupQueryKey(options)
});

/**
 * Update Group
 *
 * Owner/Admin edit — name/handle/description/`members_can_donate`/
 * `allowed_member_post_displays` AND the Owner/Admin-only privacy settings
 * `visibility`/`stats_visible`/`default_donation_visibility`.
 */
export const groupsUpdateGroupMutation = (options?: Partial<Options<GroupsUpdateGroupData>>): UseMutationOptions<GroupsUpdateGroupResponse, GroupsUpdateGroupError, Options<GroupsUpdateGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsUpdateGroupResponse, GroupsUpdateGroupError, Options<GroupsUpdateGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsUpdateGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsGetGroupActivityQueryKey = (options: Options<GroupsGetGroupActivityData>) => createQueryKey('groups-get_group_activity', options);

/**
 * Get Group Activity
 *
 * The group's PUBLIC activity feed (GRP-BE12): the group's group-attributed
 * posts, paginated. Public per the SAME visibility gate as the roster — a
 * non-member of a PRIVATE/DRAFT group → 404. Each page's group logos are
 * signed-hydrated (`_stamp_group_logos`) so `attributed_owner.logo_url` renders
 * the GROUP's logo, and the body is the SAME `PostOut` envelope the sibling
 * charity/ETF/fundraiser feeds emit.
 */
export const groupsGetGroupActivityOptions = (options: Options<GroupsGetGroupActivityData>) => queryOptions<GroupsGetGroupActivityResponse, GroupsGetGroupActivityError, GroupsGetGroupActivityResponse, ReturnType<typeof groupsGetGroupActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsGetGroupActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsGetGroupActivityQueryKey(options)
});

export const groupsListGroupDonationRequestsQueryKey = (options: Options<GroupsListGroupDonationRequestsData>) => createQueryKey('groups-list_group_donation_requests', options);

/**
 * List Group Donation Requests
 *
 * The group's donation proposals, paginated newest-first. **Owner/Admin see
 * every request; any other member sees ONLY their own rows** (R14 own-data
 * discipline — the isolation is the repository SQL predicate). A visible
 * non-member → 403; a group the caller cannot see → 404.
 */
export const groupsListGroupDonationRequestsOptions = (options: Options<GroupsListGroupDonationRequestsData>) => queryOptions<GroupsListGroupDonationRequestsResponse, GroupsListGroupDonationRequestsError, GroupsListGroupDonationRequestsResponse, ReturnType<typeof groupsListGroupDonationRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsListGroupDonationRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsListGroupDonationRequestsQueryKey(options)
});

/**
 * Create Group Donation Request
 *
 * A full member (Owner/Admin/Member — a **CONTRIBUTOR is blocked**, 403)
 * PROPOSES a donation from the group's pooled wallet to a charity / ETF /
 * group-fundraiser / collection. Requires the group be ACTIVE; the
 * `members_can_donate` switch gates MEMBER proposers only (GRP-WT1 — an
 * Owner/Admin proposes regardless, the v4 four-eyes workflow), and the chosen
 * `post_display` must be within the group's `allowed_member_post_displays`
 * subset. Proposal creation is velocity-capped per (group, member) over a
 * rolling 24h (GRP-WT1; deliberately NO same-target dedup). NOT a money
 * route — nothing
 * moves until an Owner/Admin approves — so there is no `Idempotency-Key`
 * guard here (that is only for the two charge routes; the approve's locked
 * PENDING re-assert is the money-path idempotency fence).
 */
export const groupsCreateGroupDonationRequestMutation = (options?: Partial<Options<GroupsCreateGroupDonationRequestData>>): UseMutationOptions<GroupsCreateGroupDonationRequestResponse, GroupsCreateGroupDonationRequestError, Options<GroupsCreateGroupDonationRequestData>> => {
    const mutationOptions: UseMutationOptions<GroupsCreateGroupDonationRequestResponse, GroupsCreateGroupDonationRequestError, Options<GroupsCreateGroupDonationRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsCreateGroupDonationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Group Donation Request
 *
 * **Owner/Admin only**: approve a member's PENDING donation proposal — the
 * approval EXECUTES the proposed wallet grant (fee-free, `domain_type='group'`,
 * riding the existing DAF grant-disbursement pipeline) atomically with the
 * PENDING→APPROVED flip, so an APPROVED request is always a funded one. The
 * money-path idempotency fence is the locked PENDING re-assert (a retry / a
 * concurrent second approve → 409, never a second withdrawal), so — unlike the
 * two charge routes — there is deliberately no `Idempotency-Key` dependency.
 * Wrapped in the group-donation observability (it IS a group-donation money
 * event: `group_donation_success`/`_failure`, wallet-mode empty label set).
 */
export const groupsApproveGroupDonationRequestMutation = (options?: Partial<Options<GroupsApproveGroupDonationRequestData>>): UseMutationOptions<GroupsApproveGroupDonationRequestResponse, GroupsApproveGroupDonationRequestError, Options<GroupsApproveGroupDonationRequestData>> => {
    const mutationOptions: UseMutationOptions<GroupsApproveGroupDonationRequestResponse, GroupsApproveGroupDonationRequestError, Options<GroupsApproveGroupDonationRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsApproveGroupDonationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Group Donation Request
 *
 * **Owner/Admin only**: decline a member's PENDING donation proposal
 * (records decided_by/decided_at). No money moves. A no-longer-PENDING request
 * → 409 (already decided — incl. CLOSED rows a dissolve tombstoned).
 */
export const groupsRejectGroupDonationRequestMutation = (options?: Partial<Options<GroupsRejectGroupDonationRequestData>>): UseMutationOptions<GroupsRejectGroupDonationRequestResponse, GroupsRejectGroupDonationRequestError, Options<GroupsRejectGroupDonationRequestData>> => {
    const mutationOptions: UseMutationOptions<GroupsRejectGroupDonationRequestResponse, GroupsRejectGroupDonationRequestError, Options<GroupsRejectGroupDonationRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsRejectGroupDonationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Donate From Group
 *
 * **Owner/Admin only** (R8): direct a donation OUT to a charity / ETF /
 * group-fundraiser / collection, funded EITHER from the group's pooled (DAF-advised)
 * wallet (GRP-BE7, the default — FEE-FREE, `givmo_fee == 0`, riding the DAF
 * grant-disbursement pipeline) OR from the admin's OWN personal payment method
 * (GRP-BE7b — a REAL personal charge with NORMAL fees, receipted to the admin,
 * matched via the NORMAL personal path, writing NO group-wallet ledger; R9). The
 * funding mode is chosen by `payment_method` (WALLET → the grant; card/Apple/Google
 * → the personal charge). A Member/Contributor who can see the group → 403; a
 * non-member of a PRIVATE group → 404. ``Idempotency-Key`` is REQUIRED (fail-closed
 * 422 if absent).
 */
export const groupsDonateFromGroupMutation = (options?: Partial<Options<GroupsDonateFromGroupData>>): UseMutationOptions<GroupsDonateFromGroupResponse, GroupsDonateFromGroupError, Options<GroupsDonateFromGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsDonateFromGroupResponse, GroupsDonateFromGroupError, Options<GroupsDonateFromGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsDonateFromGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unfollow Group
 *
 * The authenticated caller explicitly unfollows (STATE FLIP, never a delete).
 * Records an EXPLICIT UNFOLLOW even with no prior FOLLOW (GRP-BE13 revival guard).
 * Same visibility gate as follow. Returns the resulting state.
 */
export const groupsUnfollowGroupMutation = (options?: Partial<Options<GroupsUnfollowGroupData>>): UseMutationOptions<GroupsUnfollowGroupResponse, GroupsUnfollowGroupError, Options<GroupsUnfollowGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsUnfollowGroupResponse, GroupsUnfollowGroupError, Options<GroupsUnfollowGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsUnfollowGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Follow Group
 *
 * The authenticated caller explicitly follows a group they can SEE (a
 * non-member of a PRIVATE group → 404). Idempotent create-or-refollow with
 * `source=EXPLICIT`. Returns the resulting follow state.
 */
export const groupsFollowGroupMutation = (options?: Partial<Options<GroupsFollowGroupData>>): UseMutationOptions<GroupsFollowGroupResponse, GroupsFollowGroupError, Options<GroupsFollowGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsFollowGroupResponse, GroupsFollowGroupError, Options<GroupsFollowGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsFollowGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Group Fundraiser
 *
 * **Owner/Admin only**: create a fundraiser OWNED by the group (§5). A
 * Member/Contributor who can see the group → 403; a non-member of a PRIVATE
 * group / a DRAFT to a non-Owner → 404 (the shared authz predicate); flag off →
 * 404.
 *
 * This REUSES the existing fundraiser creation lifecycle unmodified — same
 * `FundraiserCreate` body, same DRAFT + item-split + cardinality cap — only
 * stamping `owner_group_id=group_id` so the group is the owner (the acting admin
 * remains the fundraiser's `creator_user_id` / OWNER member of record). The
 * response is the ordinary `FundraiserOut` (a fundraiser is a fundraiser);
 * `owner_group_id` is an internal ownership axis and is NOT on the wire. NOT a
 * money route (fundraiser CRUD touches no wallet).
 */
export const groupsCreateGroupFundraiserMutation = (options?: Partial<Options<GroupsCreateGroupFundraiserData>>): UseMutationOptions<GroupsCreateGroupFundraiserResponse, GroupsCreateGroupFundraiserError, Options<GroupsCreateGroupFundraiserData>> => {
    const mutationOptions: UseMutationOptions<GroupsCreateGroupFundraiserResponse, GroupsCreateGroupFundraiserError, Options<GroupsCreateGroupFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsCreateGroupFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Invite Group Member
 *
 * Owner/Admin invites an email at a role. Registered invitees get a pending
 * roster row; unregistered invitees redeem the R-37 token after registration.
 * A guardian-designated minor invite also captures the acting adult's exact
 * terms and attestation evidence. Re-invite is idempotent only for an exact
 * role/designation/evidence match.
 */
export const groupsInviteGroupMemberMutation = (options?: Partial<Options<GroupsInviteGroupMemberData>>): UseMutationOptions<GroupsInviteGroupMemberResponse, GroupsInviteGroupMemberError, Options<GroupsInviteGroupMemberData>> => {
    const mutationOptions: UseMutationOptions<GroupsInviteGroupMemberResponse, GroupsInviteGroupMemberError, Options<GroupsInviteGroupMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsInviteGroupMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Group Invite
 *
 * Owner/Admin deletes/revokes a PENDING invite.
 */
export const groupsDeleteGroupInviteMutation = (options?: Partial<Options<GroupsDeleteGroupInviteData>>): UseMutationOptions<GroupsDeleteGroupInviteResponse, GroupsDeleteGroupInviteError, Options<GroupsDeleteGroupInviteData>> => {
    const mutationOptions: UseMutationOptions<GroupsDeleteGroupInviteResponse, GroupsDeleteGroupInviteError, Options<GroupsDeleteGroupInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsDeleteGroupInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsListGroupJoinRequestsQueryKey = (options: Options<GroupsListGroupJoinRequestsData>) => createQueryKey('groups-list_group_join_requests', options);

/**
 * List Group Join Requests
 *
 * **Owner/Admin only**: the group's PENDING join requests (the approval
 * queue), newest first, with each requester's public preview. A
 * Member/Contributor who can see the group → 403; a non-member of a PRIVATE
 * group → 404 (the shared authz predicate).
 */
export const groupsListGroupJoinRequestsOptions = (options: Options<GroupsListGroupJoinRequestsData>) => queryOptions<GroupsListGroupJoinRequestsResponse, GroupsListGroupJoinRequestsError, GroupsListGroupJoinRequestsResponse, ReturnType<typeof groupsListGroupJoinRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsListGroupJoinRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsListGroupJoinRequestsQueryKey(options)
});

/**
 * Request To Join Group
 *
 * An authenticated member-candidate asks to join a PUBLIC ACTIVE group. A
 * PRIVATE/DRAFT group the caller can't see → 404 (the BE3 authz contract); a
 * DISSOLVED group → 410; an ACTIVE member → 409; re-request while PENDING →
 * idempotent (the existing request); re-request after a rejection → a NEW
 * request. No body — the requester's ip/user-agent are captured server-side
 * (they back the consent record on approve).
 */
export const groupsRequestToJoinGroupMutation = (options?: Partial<Options<GroupsRequestToJoinGroupData>>): UseMutationOptions<GroupsRequestToJoinGroupResponse, GroupsRequestToJoinGroupError, Options<GroupsRequestToJoinGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsRequestToJoinGroupResponse, GroupsRequestToJoinGroupError, Options<GroupsRequestToJoinGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsRequestToJoinGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Group Join Request
 *
 * **Owner/Admin only**: approve a PENDING join request → membership (MEMBER)
 * + consent row (the REQUESTER's captured ip/ua) in one transaction. Races with
 * a concurrent invite-accept / second approve resolve to ONE membership.
 * Returns the resulting roster row.
 */
export const groupsApproveGroupJoinRequestMutation = (options?: Partial<Options<GroupsApproveGroupJoinRequestData>>): UseMutationOptions<GroupsApproveGroupJoinRequestResponse, GroupsApproveGroupJoinRequestError, Options<GroupsApproveGroupJoinRequestData>> => {
    const mutationOptions: UseMutationOptions<GroupsApproveGroupJoinRequestResponse, GroupsApproveGroupJoinRequestError, Options<GroupsApproveGroupJoinRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsApproveGroupJoinRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Group Join Request
 *
 * **Owner/Admin only**: decline a PENDING join request (REJECTED — the
 * requester may request again). Returns the resolved request.
 */
export const groupsRejectGroupJoinRequestMutation = (options?: Partial<Options<GroupsRejectGroupJoinRequestData>>): UseMutationOptions<GroupsRejectGroupJoinRequestResponse, GroupsRejectGroupJoinRequestError, Options<GroupsRejectGroupJoinRequestData>> => {
    const mutationOptions: UseMutationOptions<GroupsRejectGroupJoinRequestResponse, GroupsRejectGroupJoinRequestError, Options<GroupsRejectGroupJoinRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsRejectGroupJoinRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsGetMyGroupContributionQueryKey = (options: Options<GroupsGetMyGroupContributionData>) => createQueryKey('groups-get_my_group_contribution', options);

/**
 * Get My Group Contribution
 *
 * Any **member**: the caller's OWN lifetime contribution to this group (total
 * gross/net + count). R14 — never another member's amount (a non-member who can
 * see the group → 403; a group the caller cannot see → 404).
 */
export const groupsGetMyGroupContributionOptions = (options: Options<GroupsGetMyGroupContributionData>) => queryOptions<GroupsGetMyGroupContributionResponse, GroupsGetMyGroupContributionError, GroupsGetMyGroupContributionResponse, ReturnType<typeof groupsGetMyGroupContributionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsGetMyGroupContribution({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsGetMyGroupContributionQueryKey(options)
});

export const groupsGetMyGroupStatsQueryKey = (options: Options<GroupsGetMyGroupStatsData>) => createQueryKey('groups-get_my_group_stats', options);

/**
 * Get My Group Stats
 *
 * Any **member**: the caller's OWN YTD contributed + matched for this group.
 * GRP-BE18 employer batch approvals populate `matched`; it remains surfaced when
 * zero. R14 (own data only; a non-member who can see the group → 403; a group the
 * caller cannot see → 404).
 */
export const groupsGetMyGroupStatsOptions = (options: Options<GroupsGetMyGroupStatsData>) => queryOptions<GroupsGetMyGroupStatsResponse, GroupsGetMyGroupStatsError, GroupsGetMyGroupStatsResponse, ReturnType<typeof groupsGetMyGroupStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsGetMyGroupStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsGetMyGroupStatsQueryKey(options)
});

export const groupsListGroupMembersQueryKey = (options: Options<GroupsListGroupMembersData>) => createQueryKey('groups-list_group_members', options);

/**
 * List Group Members
 *
 * The roster (public per visibility; a non-member of a PRIVATE/DRAFT group →
 * 404). Never exposes a per-member contribution amount.
 */
export const groupsListGroupMembersOptions = (options: Options<GroupsListGroupMembersData>) => queryOptions<GroupsListGroupMembersResponse, GroupsListGroupMembersError, GroupsListGroupMembersResponse, ReturnType<typeof groupsListGroupMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsListGroupMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsListGroupMembersQueryKey(options)
});

/**
 * Accept Group Invite
 *
 * The invitee accepts an invite → member ACTIVE + consent row. Accept into a
 * DRAFT the caller can't see → 404; into a DISSOLVED group → 410.
 */
export const groupsAcceptGroupInviteMutation = (options?: Partial<Options<GroupsAcceptGroupInviteData>>): UseMutationOptions<GroupsAcceptGroupInviteResponse, GroupsAcceptGroupInviteError, Options<GroupsAcceptGroupInviteData>> => {
    const mutationOptions: UseMutationOptions<GroupsAcceptGroupInviteResponse, GroupsAcceptGroupInviteError, Options<GroupsAcceptGroupInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsAcceptGroupInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Leave Group
 *
 * The caller leaves the group. Last-owner protection: the sole Owner cannot
 * leave until ownership transfers or the group dissolves (409).
 */
export const groupsLeaveGroupMutation = (options?: Partial<Options<GroupsLeaveGroupData>>): UseMutationOptions<GroupsLeaveGroupResponse, GroupsLeaveGroupError, Options<GroupsLeaveGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsLeaveGroupResponse, GroupsLeaveGroupError, Options<GroupsLeaveGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsLeaveGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Group Match Setting
 *
 * Update the authenticated member's private per-group employer-match
 * preference. Any ACTIVE member role may toggle it, but the caller must have a
 * linked company. This is a setting change, not a money route, so it has no
 * `Idempotency-Key` dependency.
 */
export const groupsUpdateGroupMatchSettingMutation = (options?: Partial<Options<GroupsUpdateGroupMatchSettingData>>): UseMutationOptions<GroupsUpdateGroupMatchSettingResponse, GroupsUpdateGroupMatchSettingError, Options<GroupsUpdateGroupMatchSettingData>> => {
    const mutationOptions: UseMutationOptions<GroupsUpdateGroupMatchSettingResponse, GroupsUpdateGroupMatchSettingError, Options<GroupsUpdateGroupMatchSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsUpdateGroupMatchSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Group Member
 *
 * Owner/Admin changes a member's role OR removes them (`remove=true`). Enforces
 * the §4 legal role-transition graph (illegal edges → 403/422), the 18+/NULL-DOB
 * gate on promotion to ADMIN, and last-owner protection (409). Returns the updated
 * member (role change) or 204 (remove).
 */
export const groupsUpdateGroupMemberMutation = (options?: Partial<Options<GroupsUpdateGroupMemberData>>): UseMutationOptions<GroupsUpdateGroupMemberResponse, GroupsUpdateGroupMemberError, Options<GroupsUpdateGroupMemberData>> => {
    const mutationOptions: UseMutationOptions<GroupsUpdateGroupMemberResponse, GroupsUpdateGroupMemberError, Options<GroupsUpdateGroupMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsUpdateGroupMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Group Picture
 *
 * Owner/Admin logo upload (signed-on-read; GCS key `group/{id}/logo.png`).
 */
export const groupsUploadGroupPictureMutation = (options?: Partial<Options<GroupsUploadGroupPictureData>>): UseMutationOptions<GroupsUploadGroupPictureResponse, GroupsUploadGroupPictureError, Options<GroupsUploadGroupPictureData>> => {
    const mutationOptions: UseMutationOptions<GroupsUploadGroupPictureResponse, GroupsUploadGroupPictureError, Options<GroupsUploadGroupPictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsUploadGroupPicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Group
 *
 * Owner-only: DRAFT → ACTIVE (validate required fields; mint the group wallet
 * + Shift4 customer single-shot).
 */
export const groupsPublishGroupMutation = (options?: Partial<Options<GroupsPublishGroupData>>): UseMutationOptions<GroupsPublishGroupResponse, GroupsPublishGroupError, Options<GroupsPublishGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsPublishGroupResponse, GroupsPublishGroupError, Options<GroupsPublishGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsPublishGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Group Recurring Contribution
 *
 * Create the caller's saved-card recurring contribution.
 *
 * WALLET remains represented in the source-tolerant input vocabulary but is
 * rejected with a named D-GRP-21 gate until settled-backing is designed.
 */
export const groupsCreateGroupRecurringContributionMutation = (options?: Partial<Options<GroupsCreateGroupRecurringContributionData>>): UseMutationOptions<GroupsCreateGroupRecurringContributionResponse, GroupsCreateGroupRecurringContributionError, Options<GroupsCreateGroupRecurringContributionData>> => {
    const mutationOptions: UseMutationOptions<GroupsCreateGroupRecurringContributionResponse, GroupsCreateGroupRecurringContributionError, Options<GroupsCreateGroupRecurringContributionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsCreateGroupRecurringContribution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Group Recurring Contribution
 */
export const groupsCancelGroupRecurringContributionMutation = (options?: Partial<Options<GroupsCancelGroupRecurringContributionData>>): UseMutationOptions<GroupsCancelGroupRecurringContributionResponse, GroupsCancelGroupRecurringContributionError, Options<GroupsCancelGroupRecurringContributionData>> => {
    const mutationOptions: UseMutationOptions<GroupsCancelGroupRecurringContributionResponse, GroupsCancelGroupRecurringContributionError, Options<GroupsCancelGroupRecurringContributionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsCancelGroupRecurringContribution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Group Ownership Transfer
 *
 * Owner-only: withdraw the pending ownership-transfer offer (404 when none
 * is pending). Nothing has swapped yet; a later accept 404s.
 */
export const groupsRevokeGroupOwnershipTransferMutation = (options?: Partial<Options<GroupsRevokeGroupOwnershipTransferData>>): UseMutationOptions<GroupsRevokeGroupOwnershipTransferResponse, GroupsRevokeGroupOwnershipTransferError, Options<GroupsRevokeGroupOwnershipTransferData>> => {
    const mutationOptions: UseMutationOptions<GroupsRevokeGroupOwnershipTransferResponse, GroupsRevokeGroupOwnershipTransferError, Options<GroupsRevokeGroupOwnershipTransferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsRevokeGroupOwnershipTransfer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsGetGroupOwnershipTransferQueryKey = (options: Options<GroupsGetGroupOwnershipTransferData>) => createQueryKey('groups-get_group_ownership_transfer', options);

/**
 * Get Group Ownership Transfer
 *
 * The pending ownership-transfer offer — visible to the OWNER (404 when
 * none) and the offer's TARGET only (R14). Any other caller who can see the
 * group gets a constant 403, the same whether or not an offer exists.
 */
export const groupsGetGroupOwnershipTransferOptions = (options: Options<GroupsGetGroupOwnershipTransferData>) => queryOptions<GroupsGetGroupOwnershipTransferResponse, GroupsGetGroupOwnershipTransferError, GroupsGetGroupOwnershipTransferResponse, ReturnType<typeof groupsGetGroupOwnershipTransferQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsGetGroupOwnershipTransfer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsGetGroupOwnershipTransferQueryKey(options)
});

/**
 * Offer Group Ownership Transfer
 *
 * Owner-only: offer to transfer group ownership to an ACTIVE full member
 * (`user_id`). Two-step by design — the target must ACCEPT before any role
 * changes (a member is never silently promoted into an advisory role). One
 * live offer per group: a new offer REPLACES the pending one. The target must
 * be 18+ with a known DOB (the §4 advisor gate, re-checked at accept);
 * CONTRIBUTOR targets are rejected (422). Offer creation (replaces included)
 * is velocity-capped per group over a rolling 24h (GRP-WT1 → 429).
 */
export const groupsOfferGroupOwnershipTransferMutation = (options?: Partial<Options<GroupsOfferGroupOwnershipTransferData>>): UseMutationOptions<GroupsOfferGroupOwnershipTransferResponse, GroupsOfferGroupOwnershipTransferError, Options<GroupsOfferGroupOwnershipTransferData>> => {
    const mutationOptions: UseMutationOptions<GroupsOfferGroupOwnershipTransferResponse, GroupsOfferGroupOwnershipTransferError, Options<GroupsOfferGroupOwnershipTransferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsOfferGroupOwnershipTransfer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept Group Ownership Transfer
 *
 * The offer's TARGET accepts: the atomic swap (current Owner → ADMIN,
 * caller → OWNER) + the consent record, one transaction under the group row
 * lock — exactly one OWNER at every observable point. Anyone but the target
 * gets a constant 404 (no offer-existence oracle); a retry by the now-current
 * Owner is a no-op 200. NOT a money route — no Idempotency-Key guard (the
 * locked offer re-read is the fence). Returns the caller's new roster row.
 */
export const groupsAcceptGroupOwnershipTransferMutation = (options?: Partial<Options<GroupsAcceptGroupOwnershipTransferData>>): UseMutationOptions<GroupsAcceptGroupOwnershipTransferResponse, GroupsAcceptGroupOwnershipTransferError, Options<GroupsAcceptGroupOwnershipTransferData>> => {
    const mutationOptions: UseMutationOptions<GroupsAcceptGroupOwnershipTransferResponse, GroupsAcceptGroupOwnershipTransferError, Options<GroupsAcceptGroupOwnershipTransferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsAcceptGroupOwnershipTransfer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsGetGroupWalletQueryKey = (options: Options<GroupsGetGroupWalletData>) => createQueryKey('groups-get_group_wallet', options);

/**
 * Get Group Wallet
 *
 * **Owner/Admin only** (R14): the group's optimistic pooled-wallet balance +
 * a PAGINATED transaction history — contributions IN and wallet-funded grants
 * OUT (`direction="GRANT"`, one row per grant incl. evacuations; amount +
 * timestamp only per D-GRP-17), interleaved newest-first. A Member/Contributor
 * who can see the group → 403; a non-member of a PRIVATE group → 404 (the
 * shared authz predicate). The balance is the donor-honest `wallet.balance` —
 * never any settled/reserved/minted/cohort/mercury vocabulary (grant-vocab
 * quarantine).
 */
export const groupsGetGroupWalletOptions = (options: Options<GroupsGetGroupWalletData>) => queryOptions<GroupsGetGroupWalletResponse, GroupsGetGroupWalletError, GroupsGetGroupWalletResponse, ReturnType<typeof groupsGetGroupWalletQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsGetGroupWallet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsGetGroupWalletQueryKey(options)
});

/**
 * Contribute To Group
 *
 * Contribute (a DAF deposit) to a group's pooled wallet — any ACTIVE member.
 * Card / Apple / Google only (gift-card-to-group is coming soon → 422). An
 * irrevocable gift (R11, no refunds); both processor + platform fee apply at
 * top-up. ``Idempotency-Key`` is REQUIRED (fail-closed 422 if absent).
 */
export const groupsContributeToGroupMutation = (options?: Partial<Options<GroupsContributeToGroupData>>): UseMutationOptions<GroupsContributeToGroupResponse, GroupsContributeToGroupError, Options<GroupsContributeToGroupData>> => {
    const mutationOptions: UseMutationOptions<GroupsContributeToGroupResponse, GroupsContributeToGroupError, Options<GroupsContributeToGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsContributeToGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept Org Invite
 *
 * Redeem an invite token → become an administrator of the inviting organization.
 *
 * ⚠ **UN-scoped, and that is the design.** The invitee holds a token and nothing
 * else; resolving WHICH organization invited them is exactly what the token is for,
 * and the invite email never told them an `org_ref`. Requiring one would also let a
 * caller assert the scope their token is judged under.
 *
 * Authenticated, but carries NO org permission — the invitee has none by
 * definition. The accepting identity comes from `request.state.idp_user`, NEVER
 * from the body: the token is email-BOUND, so letting a caller name the email they
 * are redeeming as would defeat the binding entirely.
 *
 * Every non-redeemable condition — unknown, spent, expired, wrong email — answers
 * ONE constant 400, so a leaked link cannot be probed. The single exception is the
 * caller's OWN unverified email, which answers a TYPED refusal because it discloses
 * only their own account state and is otherwise a dead end for a legitimately
 * invited person.
 */
export const orgConsoleAcceptOrgInviteMutation = (options?: Partial<Options<OrgConsoleAcceptOrgInviteData>>): UseMutationOptions<OrgConsoleAcceptOrgInviteResponse, OrgConsoleAcceptOrgInviteError, Options<OrgConsoleAcceptOrgInviteData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleAcceptOrgInviteResponse, OrgConsoleAcceptOrgInviteError, Options<OrgConsoleAcceptOrgInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleAcceptOrgInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConsoleListOrgAccessRequestsQueryKey = (options: Options<OrgConsoleListOrgAccessRequestsData>) => createQueryKey('org-console-list_org_access_requests', options);

/**
 * List Org Access Requests
 *
 * This organization's access requests — PENDING first, then newest — each with
 * the requester's identity, the app, the role asked for, the explanation, and, on a
 * decided row, who decided and the note.
 *
 * TWO admissions (R9): a holder of the org-wide member-access capability (a Global
 * Admin) lists every app; an app's Owner holding its approve string lists exactly
 * the app they name in `?module=` — REQUIRED for such a caller (422 without it),
 * and 403 for an app whose string they lack or whose approval policy is
 * `global_admins_only`. `?status=` narrows to one state.
 *
 * The canonical `{data, meta, links}` envelope, like every `/org` list read.
 */
export const orgConsoleListOrgAccessRequestsOptions = (options: Options<OrgConsoleListOrgAccessRequestsData>) => queryOptions<OrgConsoleListOrgAccessRequestsResponse, OrgConsoleListOrgAccessRequestsError, OrgConsoleListOrgAccessRequestsResponse, ReturnType<typeof orgConsoleListOrgAccessRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleListOrgAccessRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleListOrgAccessRequestsQueryKey(options)
});

/**
 * Create Org Access Request
 *
 * Ask for a role in one of this organization's apps (R4, R8).
 *
 * Any admin of the organization may ask — the capability maps to the class's
 * baseline read string. `requested_role` defaults to the app's Member tier;
 * `explanation` is the optional note the approvers see. A module the class does
 * not carry is 422; one the caller ALREADY holds (a Global Admin holds every one)
 * is 409 `ALREADY_HAS_ACCESS`.
 *
 * IDEMPOTENT: an open request for the same app is returned unchanged with 200; a
 * new one is created with 201. The Global Admins and the app's Owners who may
 * approve are mailed post-commit (dark until the template is created).
 */
export const orgConsoleCreateOrgAccessRequestMutation = (options?: Partial<Options<OrgConsoleCreateOrgAccessRequestData>>): UseMutationOptions<OrgConsoleCreateOrgAccessRequestResponse, OrgConsoleCreateOrgAccessRequestError, Options<OrgConsoleCreateOrgAccessRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleCreateOrgAccessRequestResponse, OrgConsoleCreateOrgAccessRequestError, Options<OrgConsoleCreateOrgAccessRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleCreateOrgAccessRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Org Access Request
 *
 * Approve one request: grant the requested tier — or the approver's override
 * (R6) — through the ONE grant writer, flip the row, and record both the grant and
 * the decision in the access event log, in one unit of work.
 *
 * Same two admissions as the list. Approve NEVER turns the app on for the
 * organization: an app that is off or setting up refuses with 409
 * `MODULE_NOT_ENABLED` and the inbox reads "Turn on <app> first". Already approved
 * is idempotent (200). The requester is mailed post-commit with a link into the
 * app.
 */
export const orgConsoleApproveOrgAccessRequestMutation = (options?: Partial<Options<OrgConsoleApproveOrgAccessRequestData>>): UseMutationOptions<OrgConsoleApproveOrgAccessRequestResponse, OrgConsoleApproveOrgAccessRequestError, Options<OrgConsoleApproveOrgAccessRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleApproveOrgAccessRequestResponse, OrgConsoleApproveOrgAccessRequestError, Options<OrgConsoleApproveOrgAccessRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleApproveOrgAccessRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deny Org Access Request
 *
 * Deny one request, with an optional note the requester sees (R4, D4). Same two
 * admissions as the list. Already denied is idempotent (200; the first note
 * stands). The requester is mailed post-commit with a link to their app list.
 */
export const orgConsoleDenyOrgAccessRequestMutation = (options?: Partial<Options<OrgConsoleDenyOrgAccessRequestData>>): UseMutationOptions<OrgConsoleDenyOrgAccessRequestResponse, OrgConsoleDenyOrgAccessRequestError, Options<OrgConsoleDenyOrgAccessRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleDenyOrgAccessRequestResponse, OrgConsoleDenyOrgAccessRequestError, Options<OrgConsoleDenyOrgAccessRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleDenyOrgAccessRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConsoleGetOrgAccessCatalogQueryKey = (options: Options<OrgConsoleGetOrgAccessCatalogData>) => createQueryKey('org-console-get_org_access_catalog', options);

/**
 * Get Org Access Catalog
 *
 * The customizable permission catalog, per module, with each key's tier.
 *
 * These are the ONLY strings a per-admin custom set may name; every other
 * permission the organization's class carries is org-level and tier-only.
 * ``default_allow`` tells the console whether a new admin gets the module
 * automatically. No portal URL is served — the web app owns its own routing
 * table.
 */
export const orgConsoleGetOrgAccessCatalogOptions = (options: Options<OrgConsoleGetOrgAccessCatalogData>) => queryOptions<OrgConsoleGetOrgAccessCatalogResponse, OrgConsoleGetOrgAccessCatalogError, OrgConsoleGetOrgAccessCatalogResponse, ReturnType<typeof orgConsoleGetOrgAccessCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleGetOrgAccessCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleGetOrgAccessCatalogQueryKey(options)
});

export const orgConsoleListOrgAccessEventsQueryKey = (options: Options<OrgConsoleListOrgAccessEventsData>) => createQueryKey('org-console-list_org_access_events', options);

/**
 * List Org Access Events
 *
 * The append-only access event log, newest first. Global-Admin only, matching
 * who may change access in the first place.
 */
export const orgConsoleListOrgAccessEventsOptions = (options: Options<OrgConsoleListOrgAccessEventsData>) => queryOptions<OrgConsoleListOrgAccessEventsResponse, OrgConsoleListOrgAccessEventsError, OrgConsoleListOrgAccessEventsResponse, ReturnType<typeof orgConsoleListOrgAccessEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleListOrgAccessEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleListOrgAccessEventsQueryKey(options)
});

export const orgConsoleGetOrgAccessSettingsQueryKey = (options: Options<OrgConsoleGetOrgAccessSettingsData>) => createQueryKey('org-console-get_org_access_settings', options);

/**
 * Get Org Access Settings
 *
 * The org-wide module switches, defaults already applied — every module the
 * organization's class knows is present, and one it has never touched reads
 * ``enabled: true``.
 */
export const orgConsoleGetOrgAccessSettingsOptions = (options: Options<OrgConsoleGetOrgAccessSettingsData>) => queryOptions<OrgConsoleGetOrgAccessSettingsResponse, OrgConsoleGetOrgAccessSettingsError, OrgConsoleGetOrgAccessSettingsResponse, ReturnType<typeof orgConsoleGetOrgAccessSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleGetOrgAccessSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleGetOrgAccessSettingsQueryKey(options)
});

/**
 * Update Org Access Settings
 *
 * Switch modules on/off org-wide. Generic modules require Global Admin.
 *
 * A provisioning-hook module Owner may use this route only for that hook's
 * management act: OFF clears/displaces its attempt; ON receives the typed
 * activation-path refusal. That authority never extends to another module.
 * PARTIAL; every actual change appends one access-event row.
 */
export const orgConsoleUpdateOrgAccessSettingsMutation = (options?: Partial<Options<OrgConsoleUpdateOrgAccessSettingsData>>): UseMutationOptions<OrgConsoleUpdateOrgAccessSettingsResponse, OrgConsoleUpdateOrgAccessSettingsError, Options<OrgConsoleUpdateOrgAccessSettingsData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleUpdateOrgAccessSettingsResponse, OrgConsoleUpdateOrgAccessSettingsError, Options<OrgConsoleUpdateOrgAccessSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleUpdateOrgAccessSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Org Assistant Consent
 *
 * Revoke the organization's consent — the off switch. Same write capability as
 * accepting: ending the organization's binding is as much an org-binding act as
 * making it.
 *
 * DELETE is the verb because this withdraws a standing grant; the ledger row is
 * APPENDED, never deleted, so what was accepted and when it was withdrawn both
 * survive. It takes effect on the very next turn — the gate reads the ledger's
 * latest event, so nothing is cached between an admin flipping this off and
 * the assistant refusing.
 *
 * Idempotent, and deliberately NOT blocked when no instrument is available:
 * turning the feature OFF must never depend on the state of the copy registry.
 * It is the one operation on this path that answers 200 in the unseeded state.
 */
export const orgConsoleRevokeOrgAssistantConsentMutation = (options?: Partial<Options<OrgConsoleRevokeOrgAssistantConsentData>>): UseMutationOptions<OrgConsoleRevokeOrgAssistantConsentResponse, OrgConsoleRevokeOrgAssistantConsentError, Options<OrgConsoleRevokeOrgAssistantConsentData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleRevokeOrgAssistantConsentResponse, OrgConsoleRevokeOrgAssistantConsentError, Options<OrgConsoleRevokeOrgAssistantConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleRevokeOrgAssistantConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConsoleGetOrgAssistantConsentQueryKey = (options: Options<OrgConsoleGetOrgAssistantConsentData>) => createQueryKey('org-console-get_org_assistant_consent', options);

/**
 * Get Org Assistant Consent
 *
 * The CURRENT assistant consent instrument for this organization's class, plus
 * whether the organization has accepted it.
 *
 * Any admin of the organization may read it, for the same reason any admin may
 * read the roster or the connected-AI list: seeing whether the assistant may act
 * on your own organization's data is not privileged, and the per-admin first-use
 * NOTICE needs it. BINDING the organization takes the write capability (below).
 *
 * The same shape rides the send gate's 428 ``context.org_consent``, so one decoder
 * serves both. 404 — the console's own, byte-identical to a route miss — when the
 * class binds no instrument or none is effective.
 */
export const orgConsoleGetOrgAssistantConsentOptions = (options: Options<OrgConsoleGetOrgAssistantConsentData>) => queryOptions<OrgConsoleGetOrgAssistantConsentResponse, OrgConsoleGetOrgAssistantConsentError, OrgConsoleGetOrgAssistantConsentResponse, ReturnType<typeof orgConsoleGetOrgAssistantConsentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleGetOrgAssistantConsent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleGetOrgAssistantConsentQueryKey(options)
});

/**
 * Accept Org Assistant Consent
 *
 * Accept the instrument on the ORGANIZATION's behalf.
 *
 * Owner-tier: the write string sits in `COMPANY_OWNER_PERMISSIONS` and in the
 * employer module's Owner catalog, so a base-role Global Admin and a per-module
 * employer Owner both hold it, and a Global Admin may deliberately delegate it to
 * a Member through a per-admin custom set — the console's uniform delegation
 * semantics, identical to `company:edit_match_policy`. All three are inside the
 * determination's "an Owner/Global Admin acting as the organization's agent";
 * what none of them is, is every admin by default.
 *
 * The acceptance is the organization's, taken ONCE by an authorized
 * representative — not once per admin; there are no per-admin consent rows.
 * The acting user and the instant are server-side; the body carries only the hash
 * of the copy the client displayed, and a stale one is refused (409) so a sheet
 * showing outdated text can never bind the organization. Idempotent at the
 * current version.
 */
export const orgConsoleAcceptOrgAssistantConsentMutation = (options?: Partial<Options<OrgConsoleAcceptOrgAssistantConsentData>>): UseMutationOptions<OrgConsoleAcceptOrgAssistantConsentResponse, OrgConsoleAcceptOrgAssistantConsentError, Options<OrgConsoleAcceptOrgAssistantConsentData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleAcceptOrgAssistantConsentResponse, OrgConsoleAcceptOrgAssistantConsentError, Options<OrgConsoleAcceptOrgAssistantConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleAcceptOrgAssistantConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConfirmationRequestsListOrgConfirmationRequestsQueryKey = (options: Options<OrgConfirmationRequestsListOrgConfirmationRequestsData>) => createQueryKey('org-confirmation-requests-list_org_confirmation_requests', options);

/**
 * List Org Confirmation Requests
 *
 * The organization's confirmation requests this person may confirm, newest first,
 * in the states asked for (every state when none). An expired or void request is shown
 * as such: the read records the transition, once.
 */
export const orgConfirmationRequestsListOrgConfirmationRequestsOptions = (options: Options<OrgConfirmationRequestsListOrgConfirmationRequestsData>) => queryOptions<OrgConfirmationRequestsListOrgConfirmationRequestsResponse, OrgConfirmationRequestsListOrgConfirmationRequestsError, OrgConfirmationRequestsListOrgConfirmationRequestsResponse, ReturnType<typeof orgConfirmationRequestsListOrgConfirmationRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConfirmationRequestsListOrgConfirmationRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConfirmationRequestsListOrgConfirmationRequestsQueryKey(options)
});

export const orgConfirmationRequestsGetOrgConfirmationRequestQueryKey = (options: Options<OrgConfirmationRequestsGetOrgConfirmationRequestData>) => createQueryKey('org-confirmation-requests-get_org_confirmation_request', options);

/**
 * Get Org Confirmation Request
 *
 * One request, rendered by Givmo from the server's record, with the content hash a
 * confirm must carry and the step-up it will ask for.
 */
export const orgConfirmationRequestsGetOrgConfirmationRequestOptions = (options: Options<OrgConfirmationRequestsGetOrgConfirmationRequestData>) => queryOptions<OrgConfirmationRequestsGetOrgConfirmationRequestResponse, OrgConfirmationRequestsGetOrgConfirmationRequestError, OrgConfirmationRequestsGetOrgConfirmationRequestResponse, ReturnType<typeof orgConfirmationRequestsGetOrgConfirmationRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConfirmationRequestsGetOrgConfirmationRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConfirmationRequestsGetOrgConfirmationRequestQueryKey(options)
});

/**
 * Confirm Org Confirmation Request
 *
 * Confirm exactly what was shown: the act runs, in this transaction, when this is the
 * last confirmation the request needs. ``step_up_required`` (400) when the sign-in is not
 * recent enough; ``confirmation_request_changed`` (409, with the fresh render and hash)
 * when the request is no longer what was shown.
 */
export const orgConfirmationRequestsConfirmOrgConfirmationRequestMutation = (options?: Partial<Options<OrgConfirmationRequestsConfirmOrgConfirmationRequestData>>): UseMutationOptions<OrgConfirmationRequestsConfirmOrgConfirmationRequestResponse, OrgConfirmationRequestsConfirmOrgConfirmationRequestError, Options<OrgConfirmationRequestsConfirmOrgConfirmationRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgConfirmationRequestsConfirmOrgConfirmationRequestResponse, OrgConfirmationRequestsConfirmOrgConfirmationRequestError, Options<OrgConfirmationRequestsConfirmOrgConfirmationRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConfirmationRequestsConfirmOrgConfirmationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline Org Confirmation Request
 *
 * Decline the request: it ends and nothing runs.
 */
export const orgConfirmationRequestsDeclineOrgConfirmationRequestMutation = (options?: Partial<Options<OrgConfirmationRequestsDeclineOrgConfirmationRequestData>>): UseMutationOptions<OrgConfirmationRequestsDeclineOrgConfirmationRequestResponse, OrgConfirmationRequestsDeclineOrgConfirmationRequestError, Options<OrgConfirmationRequestsDeclineOrgConfirmationRequestData>> => {
    const mutationOptions: UseMutationOptions<OrgConfirmationRequestsDeclineOrgConfirmationRequestResponse, OrgConfirmationRequestsDeclineOrgConfirmationRequestError, Options<OrgConfirmationRequestsDeclineOrgConfirmationRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConfirmationRequestsDeclineOrgConfirmationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConsoleListOrgConnectedAiQueryKey = (options: Options<OrgConsoleListOrgConnectedAiData>) => createQueryKey('org-console-list_org_connected_ai', options);

/**
 * List Org Connected Ai
 *
 * The AIs currently connected to this organization — one row per consent grant,
 * newest first.
 *
 * A connected AI acts for the organization with the DELEGATING HUMAN's own live
 * authority, re-resolved on every call; the scopes on a row are the consent-time
 * ceiling, not what it may do. That is why each row names the admin it acts as.
 *
 * Any admin of the organization may read this, for the same reason any admin may
 * read the roster: seeing what acts on your own organization's behalf is not
 * privileged. It is also what this route exists to fix — a connector delegated by one
 * admin used to be visible only on THAT person's own account page, and therefore
 * invisible to the organization it acts for. Ending one is Global-Admin only.
 *
 * No token material appears here on any path — no bearer, no hash, no credential id.
 */
export const orgConsoleListOrgConnectedAiOptions = (options: Options<OrgConsoleListOrgConnectedAiData>) => queryOptions<OrgConsoleListOrgConnectedAiResponse, OrgConsoleListOrgConnectedAiError, OrgConsoleListOrgConnectedAiResponse, ReturnType<typeof orgConsoleListOrgConnectedAiQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleListOrgConnectedAi({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleListOrgConnectedAiQueryKey(options)
});

/**
 * Revoke Org Connected Ai
 *
 * End one connected AI's grant, on the ORGANIZATION's authority. Global-Admin only.
 *
 * Revoking a connector is an access change — it ends an integration acting for the
 * organization — so it takes the same authority as changing who administers it.
 *
 * The kill is immediate and total: every refresh token in the grant's family AND
 * every live access token for that grant's client, in ONE unit of work. Bearers are
 * resolved against the database on each call, so a session in flight stops working on
 * its very next request rather than at its next expiry.
 *
 * It is the SAME family revoke the delegating human can perform from their own
 * account page, with the authorization boundary moved from that person to the
 * organization — one grant, one revocation semantics, two doors. Idempotent on a
 * grant this organization owns; an unknown grant and another organization's grant are
 * the same 404, never a 403, so grant ids stay un-enumerable.
 */
export const orgConsoleRevokeOrgConnectedAiMutation = (options?: Partial<Options<OrgConsoleRevokeOrgConnectedAiData>>): UseMutationOptions<OrgConsoleRevokeOrgConnectedAiResponse, OrgConsoleRevokeOrgConnectedAiError, Options<OrgConsoleRevokeOrgConnectedAiData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleRevokeOrgConnectedAiResponse, OrgConsoleRevokeOrgConnectedAiError, Options<OrgConsoleRevokeOrgConnectedAiData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleRevokeOrgConnectedAi({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deactivate Org
 *
 * End the organization's account — the sole-Owner exit (OM-9, D-CPO-32).
 *
 * `DEACTIVATE_ORG`, the Global-Admin tier in both classes. ONE transaction ends
 * every administrator's standing (both company membership stores; the charity
 * roster), every org-plane grant and custom set, every pending invite and access
 * request, every admin preference and every connected AI, applies the class's
 * declared effects (the for-profit `company.status` dual-write) and writes the
 * deactivation fact plus one `ORG_DEACTIVATED` event — then, after the commit,
 * revokes every former admin's sessions, COUNTED on the wire (`sessions_revoked`
 * / `session_failures`). The caller's own standing ends with everyone else's:
 * after a 200 their next `/org` call answers the console's 404. No body; no
 * undo — a deactivated organization is re-enrolled (charity: re-claim), not
 * restored. Dark under `ORG_DEACTIVATION_ENABLED` as well as the console flag,
 * with the byte-identical route-miss answer.
 */
export const orgConsoleDeactivateOrgMutation = (options?: Partial<Options<OrgConsoleDeactivateOrgData>>): UseMutationOptions<OrgConsoleDeactivateOrgResponse, OrgConsoleDeactivateOrgError, Options<OrgConsoleDeactivateOrgData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleDeactivateOrgResponse, OrgConsoleDeactivateOrgError, Options<OrgConsoleDeactivateOrgData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleDeactivateOrg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgFundraisersListOrgFundraisersQueryKey = (options: Options<OrgFundraisersListOrgFundraisersData>) => createQueryKey('org-fundraisers-list_org_fundraisers', options);

/**
 * List Org Fundraisers
 *
 * The organization's portfolio with owner statistics in the canonical
 * paginated envelope. Both console and module release gates must be open.
 */
export const orgFundraisersListOrgFundraisersOptions = (options: Options<OrgFundraisersListOrgFundraisersData>) => queryOptions<OrgFundraisersListOrgFundraisersResponse, OrgFundraisersListOrgFundraisersError, OrgFundraisersListOrgFundraisersResponse, ReturnType<typeof orgFundraisersListOrgFundraisersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersListOrgFundraisers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersListOrgFundraisersQueryKey(options)
});

/**
 * Create Org Fundraiser
 *
 * Create an organization-owned draft under WRITE_FUNDRAISERS.
 * The service applies the resolved class's standing and recipient rules.
 */
export const orgFundraisersCreateOrgFundraiserMutation = (options?: Partial<Options<OrgFundraisersCreateOrgFundraiserData>>): UseMutationOptions<OrgFundraisersCreateOrgFundraiserResponse, OrgFundraisersCreateOrgFundraiserError, Options<OrgFundraisersCreateOrgFundraiserData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersCreateOrgFundraiserResponse, OrgFundraisersCreateOrgFundraiserError, Options<OrgFundraisersCreateOrgFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersCreateOrgFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgFundraisersListOrgSupporterFundraisersQueryKey = (options: Options<OrgFundraisersListOrgSupporterFundraisersData>) => createQueryKey('org-fundraisers-list_org_supporter_fundraisers', options);

/**
 * List Org Supporter Fundraisers
 *
 * FCM-BE11: the fundraisers other people started for this organization — directly,
 * through a collection or Cause fund it belongs to, or that already sent it a gift —
 * each as its public page shows it, newest publication first. A class that is never a
 * recipient, the retirement flag off, or a closed Charity Terms gate all answer the
 * family's route miss.
 */
export const orgFundraisersListOrgSupporterFundraisersOptions = (options: Options<OrgFundraisersListOrgSupporterFundraisersData>) => queryOptions<OrgFundraisersListOrgSupporterFundraisersResponse, OrgFundraisersListOrgSupporterFundraisersError, OrgFundraisersListOrgSupporterFundraisersResponse, ReturnType<typeof orgFundraisersListOrgSupporterFundraisersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersListOrgSupporterFundraisers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersListOrgSupporterFundraisersQueryKey(options)
});

/**
 * Delete Org Fundraiser
 *
 * FCM-BE39: delete a draft, or delete forever a deactivated fundraiser no one funded.
 * An active fundraiser is a conflict (deactivate it first); a funded one is never
 * deleted (409 FUNDRAISER_HAS_DONATIONS), and under the take-down lock neither is a
 * Givmo takedown (409 FUNDRAISER_REMOVED_BY_GIVMO).
 */
export const orgFundraisersDeleteOrgFundraiserMutation = (options?: Partial<Options<OrgFundraisersDeleteOrgFundraiserData>>): UseMutationOptions<OrgFundraisersDeleteOrgFundraiserResponse, OrgFundraisersDeleteOrgFundraiserError, Options<OrgFundraisersDeleteOrgFundraiserData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersDeleteOrgFundraiserResponse, OrgFundraisersDeleteOrgFundraiserError, Options<OrgFundraisersDeleteOrgFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersDeleteOrgFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgFundraisersGetOrgFundraiserQueryKey = (options: Options<OrgFundraisersGetOrgFundraiserData>) => createQueryKey('org-fundraisers-get_org_fundraiser', options);

/**
 * Get Org Fundraiser
 *
 * Organization-scoped fundraiser details, with one route-miss answer
 * for a missing or foreign resource.
 */
export const orgFundraisersGetOrgFundraiserOptions = (options: Options<OrgFundraisersGetOrgFundraiserData>) => queryOptions<OrgFundraisersGetOrgFundraiserResponse, OrgFundraisersGetOrgFundraiserError, OrgFundraisersGetOrgFundraiserResponse, ReturnType<typeof orgFundraisersGetOrgFundraiserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersGetOrgFundraiser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersGetOrgFundraiserQueryKey(options)
});

/**
 * Update Org Fundraiser
 *
 * Update name, description, narrative, goal or statistics visibility.
 * Omitted values remain; the supported explicit nulls clear their fields.
 */
export const orgFundraisersUpdateOrgFundraiserMutation = (options?: Partial<Options<OrgFundraisersUpdateOrgFundraiserData>>): UseMutationOptions<OrgFundraisersUpdateOrgFundraiserResponse, OrgFundraisersUpdateOrgFundraiserError, Options<OrgFundraisersUpdateOrgFundraiserData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersUpdateOrgFundraiserResponse, OrgFundraisersUpdateOrgFundraiserError, Options<OrgFundraisersUpdateOrgFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersUpdateOrgFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close Org Fundraiser
 *
 * End an active fundraiser without changing the frozen status enum.
 * Closing is reversible with Reopen, and an exact repeated close is a no-op.
 */
export const orgFundraisersCloseOrgFundraiserMutation = (options?: Partial<Options<OrgFundraisersCloseOrgFundraiserData>>): UseMutationOptions<OrgFundraisersCloseOrgFundraiserResponse, OrgFundraisersCloseOrgFundraiserError, Options<OrgFundraisersCloseOrgFundraiserData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersCloseOrgFundraiserResponse, OrgFundraisersCloseOrgFundraiserError, Options<OrgFundraisersCloseOrgFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersCloseOrgFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deactivate Org Fundraiser
 *
 * FCM-BE39: take an active fundraiser's page down, by the consumer lifecycle's own
 * rules: under the take-down lock a funded fundraiser is refused (409
 * FUNDRAISER_HAS_DONATIONS; Close is the way to end it) and a Givmo takedown answers
 * 409 FUNDRAISER_REMOVED_BY_GIVMO. Repeating it on a deactivated fundraiser changes
 * nothing; a draft is a conflict (it is deleted, never deactivated).
 */
export const orgFundraisersDeactivateOrgFundraiserMutation = (options?: Partial<Options<OrgFundraisersDeactivateOrgFundraiserData>>): UseMutationOptions<OrgFundraisersDeactivateOrgFundraiserResponse, OrgFundraisersDeactivateOrgFundraiserError, Options<OrgFundraisersDeactivateOrgFundraiserData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersDeactivateOrgFundraiserResponse, OrgFundraisersDeactivateOrgFundraiserError, Options<OrgFundraisersDeactivateOrgFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersDeactivateOrgFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Org Fundraiser Designations
 *
 * Reconcile the complete designation list for a flavor supporting it.
 * Donation-referenced labels are retained; an unsupported flavor is absent.
 */
export const orgFundraisersPutOrgFundraiserDesignationsMutation = (options?: Partial<Options<OrgFundraisersPutOrgFundraiserDesignationsData>>): UseMutationOptions<OrgFundraisersPutOrgFundraiserDesignationsResponse, OrgFundraisersPutOrgFundraiserDesignationsError, Options<OrgFundraisersPutOrgFundraiserDesignationsData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersPutOrgFundraiserDesignationsResponse, OrgFundraisersPutOrgFundraiserDesignationsError, Options<OrgFundraisersPutOrgFundraiserDesignationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersPutOrgFundraiserDesignations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgFundraisersListOrgFundraiserDonorMessagesQueryKey = (options: Options<OrgFundraisersListOrgFundraiserDonorMessagesData>) => createQueryKey('org-fundraisers-list_org_fundraiser_donor_messages', options);

/**
 * List Org Fundraiser Donor Messages
 *
 * FCM-BE84 (plan §FC-17.5): an organization's fundraiser's messages to its donors, newest
 * first, for a holder of the module's READ_FUNDRAISERS. Dark under the messages gate as well
 * as the donor list's; every miss is the family's route miss.
 */
export const orgFundraisersListOrgFundraiserDonorMessagesOptions = (options: Options<OrgFundraisersListOrgFundraiserDonorMessagesData>) => queryOptions<OrgFundraisersListOrgFundraiserDonorMessagesResponse, OrgFundraisersListOrgFundraiserDonorMessagesError, OrgFundraisersListOrgFundraiserDonorMessagesResponse, ReturnType<typeof orgFundraisersListOrgFundraiserDonorMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersListOrgFundraiserDonorMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersListOrgFundraiserDonorMessagesQueryKey(options)
});

/**
 * Send Org Fundraiser Donor Message
 *
 * FCM-BE84 (plan §FC-17.1, §FC-17.5): an organization's message to its fundraiser's donors,
 * or, with `dry_run`, the server's render of exactly what donors get and how many it would go
 * to. The module's OWNER tier sends (MANAGE_CAMPAIGNS); a charity only to donors who shared
 * with it, while its Charity Terms are in place. Web-only (no AI tool, R-11).
 */
export const orgFundraisersSendOrgFundraiserDonorMessageMutation = (options?: Partial<Options<OrgFundraisersSendOrgFundraiserDonorMessageData>>): UseMutationOptions<OrgFundraisersSendOrgFundraiserDonorMessageResponse, OrgFundraisersSendOrgFundraiserDonorMessageError, Options<OrgFundraisersSendOrgFundraiserDonorMessageData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersSendOrgFundraiserDonorMessageResponse, OrgFundraisersSendOrgFundraiserDonorMessageError, Options<OrgFundraisersSendOrgFundraiserDonorMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersSendOrgFundraiserDonorMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgFundraisersListOrgFundraiserDonorsQueryKey = (options: Options<OrgFundraisersListOrgFundraiserDonorsData>) => createQueryKey('org-fundraisers-list_org_fundraiser_donors', options);

/**
 * List Org Fundraiser Donors
 *
 * FCM-BE83 (plan §FC-17.3): an organization's fundraiser's private donor list, a row
 * per gift, for a holder of the module's READ_FUNDRAISERS. Dark under
 * FUNDRAISER_DONOR_LIST_ENABLED as well as the family's two flags; every miss is the
 * family's route miss. Paged; no export.
 */
export const orgFundraisersListOrgFundraiserDonorsOptions = (options: Options<OrgFundraisersListOrgFundraiserDonorsData>) => queryOptions<OrgFundraisersListOrgFundraiserDonorsResponse, OrgFundraisersListOrgFundraiserDonorsError, OrgFundraisersListOrgFundraiserDonorsResponse, ReturnType<typeof orgFundraisersListOrgFundraiserDonorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersListOrgFundraiserDonors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersListOrgFundraiserDonorsQueryKey(options)
});

/**
 * Publish Org Fundraiser
 *
 * Publish a draft after rechecking organization standing and recipients.
 */
export const orgFundraisersPublishOrgFundraiserMutation = (options?: Partial<Options<OrgFundraisersPublishOrgFundraiserData>>): UseMutationOptions<OrgFundraisersPublishOrgFundraiserResponse, OrgFundraisersPublishOrgFundraiserError, Options<OrgFundraisersPublishOrgFundraiserData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersPublishOrgFundraiserResponse, OrgFundraisersPublishOrgFundraiserError, Options<OrgFundraisersPublishOrgFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersPublishOrgFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reactivate Org Fundraiser
 *
 * FCM-BE39: bring a deactivated fundraiser's page back, after the consumer
 * reactivate's checks (a charity's standing, the per-person cap). Under the take-down
 * lock a Givmo takedown is Givmo's to reinstate (409 FUNDRAISER_REMOVED_BY_GIVMO).
 * Repeating it on an active fundraiser changes nothing; a draft is a conflict.
 */
export const orgFundraisersReactivateOrgFundraiserMutation = (options?: Partial<Options<OrgFundraisersReactivateOrgFundraiserData>>): UseMutationOptions<OrgFundraisersReactivateOrgFundraiserResponse, OrgFundraisersReactivateOrgFundraiserError, Options<OrgFundraisersReactivateOrgFundraiserData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersReactivateOrgFundraiserResponse, OrgFundraisersReactivateOrgFundraiserError, Options<OrgFundraisersReactivateOrgFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersReactivateOrgFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reopen Org Fundraiser
 *
 * Reopen a closed fundraiser so it accepts donations again, after the same
 * standing and per-person cap checks as the consumer door. Reopening an open
 * fundraiser is a no-op; a draft or deactivated one is a conflict.
 */
export const orgFundraisersReopenOrgFundraiserMutation = (options?: Partial<Options<OrgFundraisersReopenOrgFundraiserData>>): UseMutationOptions<OrgFundraisersReopenOrgFundraiserResponse, OrgFundraisersReopenOrgFundraiserError, Options<OrgFundraisersReopenOrgFundraiserData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersReopenOrgFundraiserResponse, OrgFundraisersReopenOrgFundraiserError, Options<OrgFundraisersReopenOrgFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersReopenOrgFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgFundraisersGetOrgFundraiserShareQueryKey = (options: Options<OrgFundraisersGetOrgFundraiserShareData>) => createQueryKey('org-fundraisers-get_org_fundraiser_share', options);

/**
 * Get Org Fundraiser Share
 *
 * Read or ensure the organization's canonical short link.
 * A first direct request may insert that redirect record after standing checks.
 */
export const orgFundraisersGetOrgFundraiserShareOptions = (options: Options<OrgFundraisersGetOrgFundraiserShareData>) => queryOptions<OrgFundraisersGetOrgFundraiserShareResponse, OrgFundraisersGetOrgFundraiserShareError, OrgFundraisersGetOrgFundraiserShareResponse, ReturnType<typeof orgFundraisersGetOrgFundraiserShareQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersGetOrgFundraiserShare({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersGetOrgFundraiserShareQueryKey(options)
});

export const orgFundraisersGetOrgFundraiserShareKitQueryKey = (options: Options<OrgFundraisersGetOrgFundraiserShareKitData>) => createQueryKey('org-fundraisers-get_org_fundraiser_share_kit', options);

/**
 * Get Org Fundraiser Share Kit
 *
 * CPB-BE8: the organization's share kit for one of its fundraisers (the campaign
 * editor's share card): its canonical link (the same record `…/share` reads or ensures),
 * captions in its voice and its library's current graphics. Its QR is `…/share/qr`.
 */
export const orgFundraisersGetOrgFundraiserShareKitOptions = (options: Options<OrgFundraisersGetOrgFundraiserShareKitData>) => queryOptions<OrgFundraisersGetOrgFundraiserShareKitResponse, OrgFundraisersGetOrgFundraiserShareKitError, OrgFundraisersGetOrgFundraiserShareKitResponse, ReturnType<typeof orgFundraisersGetOrgFundraiserShareKitQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersGetOrgFundraiserShareKit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersGetOrgFundraiserShareKitQueryKey(options)
});

export const orgFundraisersDownloadOrgFundraiserShareKitGraphicsQueryKey = (options: Options<OrgFundraisersDownloadOrgFundraiserShareKitGraphicsData>) => createQueryKey('org-fundraisers-download_org_fundraiser_share_kit_graphics', options);

/**
 * Download Org Fundraiser Share Kit Graphics
 *
 * CPB-BE8: "Download all" on the organization's card. Shares the downloads' per-network
 * budget, fail-closed, before any storage read.
 */
export const orgFundraisersDownloadOrgFundraiserShareKitGraphicsOptions = (options: Options<OrgFundraisersDownloadOrgFundraiserShareKitGraphicsData>) => queryOptions<OrgFundraisersDownloadOrgFundraiserShareKitGraphicsResponse, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsError, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsResponse, ReturnType<typeof orgFundraisersDownloadOrgFundraiserShareKitGraphicsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersDownloadOrgFundraiserShareKitGraphics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersDownloadOrgFundraiserShareKitGraphicsQueryKey(options)
});

export const orgFundraisersRenderOrgFundraiserShareQrQueryKey = (options: Options<OrgFundraisersRenderOrgFundraiserShareQrData>) => createQueryKey('org-fundraisers-render_org_fundraiser_share_qr', options);

/**
 * Render Org Fundraiser Share Qr
 *
 * Render the canonical organization link as a styled QR.
 * Its bounded first-use ensure shares the link endpoint's exact semantics.
 */
export const orgFundraisersRenderOrgFundraiserShareQrOptions = (options: Options<OrgFundraisersRenderOrgFundraiserShareQrData>) => queryOptions<OrgFundraisersRenderOrgFundraiserShareQrResponse, OrgFundraisersRenderOrgFundraiserShareQrError, OrgFundraisersRenderOrgFundraiserShareQrResponse, ReturnType<typeof orgFundraisersRenderOrgFundraiserShareQrQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgFundraisersRenderOrgFundraiserShareQr({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgFundraisersRenderOrgFundraiserShareQrQueryKey(options)
});

/**
 * Render Supplied Org Fundraiser Share Qr
 *
 * Render this fundraiser's canonical link in a SUPPLIED design — the QR editor's
 * preview and its download-without-saving. Saves no design; the link is the
 * server's own, never the caller's.
 */
export const orgFundraisersRenderSuppliedOrgFundraiserShareQrMutation = (options?: Partial<Options<OrgFundraisersRenderSuppliedOrgFundraiserShareQrData>>): UseMutationOptions<OrgFundraisersRenderSuppliedOrgFundraiserShareQrResponse, OrgFundraisersRenderSuppliedOrgFundraiserShareQrError, Options<OrgFundraisersRenderSuppliedOrgFundraiserShareQrData>> => {
    const mutationOptions: UseMutationOptions<OrgFundraisersRenderSuppliedOrgFundraiserShareQrResponse, OrgFundraisersRenderSuppliedOrgFundraiserShareQrError, Options<OrgFundraisersRenderSuppliedOrgFundraiserShareQrData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgFundraisersRenderSuppliedOrgFundraiserShareQr({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgIntegrationsListOrgIntegrationsQueryKey = (options: Options<OrgIntegrationsListOrgIntegrationsData>) => createQueryKey('org-integrations-list_org_integrations', options);

/**
 * List Org Integrations
 *
 * The purpose's connections the caller may see: every one with the purpose's manage
 * capability; otherwise one's own personal connection and the organization's account. The
 * canonical `{data, meta, links}` envelope, paginated by `page[limit]` / `page[offset]`.
 */
export const orgIntegrationsListOrgIntegrationsOptions = (options: Options<OrgIntegrationsListOrgIntegrationsData>) => queryOptions<OrgIntegrationsListOrgIntegrationsResponse, OrgIntegrationsListOrgIntegrationsError, OrgIntegrationsListOrgIntegrationsResponse, ReturnType<typeof orgIntegrationsListOrgIntegrationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgIntegrationsListOrgIntegrations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgIntegrationsListOrgIntegrationsQueryKey(options)
});

/**
 * Complete Org Integration Oauth
 *
 * Finish a connect the console started: the single-use state must have been minted for
 * this person, this organization and this return address.
 */
export const orgIntegrationsCompleteOrgIntegrationOauthMutation = (options?: Partial<Options<OrgIntegrationsCompleteOrgIntegrationOauthData>>): UseMutationOptions<OrgIntegrationsCompleteOrgIntegrationOauthResponse, OrgIntegrationsCompleteOrgIntegrationOauthError, Options<OrgIntegrationsCompleteOrgIntegrationOauthData>> => {
    const mutationOptions: UseMutationOptions<OrgIntegrationsCompleteOrgIntegrationOauthResponse, OrgIntegrationsCompleteOrgIntegrationOauthError, Options<OrgIntegrationsCompleteOrgIntegrationOauthData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgIntegrationsCompleteOrgIntegrationOauth({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Org Integration Oauth
 *
 * Start connecting an external account for one purpose: answers the provider's
 * authorization URL. A personal account is connected only by its own person (the purpose's
 * personal capability); the organization's account needs the purpose's manage capability.
 */
export const orgIntegrationsStartOrgIntegrationOauthMutation = (options?: Partial<Options<OrgIntegrationsStartOrgIntegrationOauthData>>): UseMutationOptions<OrgIntegrationsStartOrgIntegrationOauthResponse, OrgIntegrationsStartOrgIntegrationOauthError, Options<OrgIntegrationsStartOrgIntegrationOauthData>> => {
    const mutationOptions: UseMutationOptions<OrgIntegrationsStartOrgIntegrationOauthResponse, OrgIntegrationsStartOrgIntegrationOauthError, Options<OrgIntegrationsStartOrgIntegrationOauthData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgIntegrationsStartOrgIntegrationOauth({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disconnect Org Integration
 *
 * Disconnect: the token deleted (and revoked at the provider), the connection kept as
 * history. A person may always disconnect their own; anyone else's needs the purpose's manage
 * capability.
 */
export const orgIntegrationsDisconnectOrgIntegrationMutation = (options?: Partial<Options<OrgIntegrationsDisconnectOrgIntegrationData>>): UseMutationOptions<OrgIntegrationsDisconnectOrgIntegrationResponse, OrgIntegrationsDisconnectOrgIntegrationError, Options<OrgIntegrationsDisconnectOrgIntegrationData>> => {
    const mutationOptions: UseMutationOptions<OrgIntegrationsDisconnectOrgIntegrationResponse, OrgIntegrationsDisconnectOrgIntegrationError, Options<OrgIntegrationsDisconnectOrgIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgIntegrationsDisconnectOrgIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgIntegrationsGetOrgIntegrationQueryKey = (options: Options<OrgIntegrationsGetOrgIntegrationData>) => createQueryKey('org-integrations-get_org_integration', options);

/**
 * Get Org Integration
 *
 * One connection's status (and, at most once a day, its token kept alive).
 */
export const orgIntegrationsGetOrgIntegrationOptions = (options: Options<OrgIntegrationsGetOrgIntegrationData>) => queryOptions<OrgIntegrationsGetOrgIntegrationResponse, OrgIntegrationsGetOrgIntegrationError, OrgIntegrationsGetOrgIntegrationResponse, ReturnType<typeof orgIntegrationsGetOrgIntegrationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgIntegrationsGetOrgIntegration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgIntegrationsGetOrgIntegrationQueryKey(options)
});

export const orgConsoleGetOrgSelfAccessQueryKey = (options: Options<OrgConsoleGetOrgSelfAccessData>) => createQueryKey('org-console-get_org_self_access', options);

/**
 * Get Org Self Access
 *
 * The CALLER's own standing for THIS organization — the one answer to "what may
 * I do here".
 *
 * Flag-gated like the rest, unlike the company console's ``GET /admin/company/me``.
 * That route is deliberately ungated because it is an EXISTING route that merely
 * GAINED additive fields, so gating would hide accurate information a client
 * already had. This route is NEW: there is no accurate information to preserve, so
 * it goes dark with the surface it belongs to.
 */
export const orgConsoleGetOrgSelfAccessOptions = (options: Options<OrgConsoleGetOrgSelfAccessData>) => queryOptions<OrgConsoleGetOrgSelfAccessResponse, OrgConsoleGetOrgSelfAccessError, OrgConsoleGetOrgSelfAccessResponse, ReturnType<typeof orgConsoleGetOrgSelfAccessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleGetOrgSelfAccess({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleGetOrgSelfAccessQueryKey(options)
});

export const orgConsoleGetOrgAdminPreferencesQueryKey = (options: Options<OrgConsoleGetOrgAdminPreferencesData>) => createQueryKey('org-console-get_org_admin_preferences', options);

/**
 * Get Org Admin Preferences
 *
 * The caller's preferences PAGE: `{definitions, values}` — every definition
 * THIS caller is served (the org group's, plus those of the apps they hold, each
 * filtered by its audience — e.g. the access-request mail toggle only for someone
 * who can approve requests) and the caller's STORED values for those keys. A key
 * absent from `values` means the definition's `default`.
 *
 * ⚠ **Never a landing input.** The chosen landing app rides the ONE standing read
 * (`GET /org/{org_ref}/me` → `default_landing_module`, and the same field on
 * `GET /admin/company/me`), which the root already awaits; this read exists for
 * the preferences page and nothing else consults it.
 */
export const orgConsoleGetOrgAdminPreferencesOptions = (options: Options<OrgConsoleGetOrgAdminPreferencesData>) => queryOptions<OrgConsoleGetOrgAdminPreferencesResponse, OrgConsoleGetOrgAdminPreferencesError, OrgConsoleGetOrgAdminPreferencesResponse, ReturnType<typeof orgConsoleGetOrgAdminPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleGetOrgAdminPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleGetOrgAdminPreferencesQueryKey(options)
});

/**
 * Update Org Admin Preferences
 *
 * Set the caller's own preferences. Any admin — a person may always edit
 * their own.
 *
 * PARTIAL and THREE-VALUED per key: `{values: {key: value | null}}` — a key not
 * sent is left alone, an explicit `null` RESETS it to the definition's default
 * (the row is deleted), a value is validated against the definition and stored.
 * An unknown key is 422 `UNKNOWN_PREFERENCE_KEY`; a key whose app the caller does
 * not hold, or whose audience does not include them, is 422
 * `PREFERENCE_NOT_SERVED`; a value outside the definition's shape is 422
 * `INVALID_PREFERENCE_VALUE`; an unknown top-level field is 422
 * (`extra="forbid"`). The whole body is validated before any write, and the
 * writes land together. No access-event row: a personal preference is not an
 * access change. Answers the page's read so it can re-render from the body.
 */
export const orgConsoleUpdateOrgAdminPreferencesMutation = (options?: Partial<Options<OrgConsoleUpdateOrgAdminPreferencesData>>): UseMutationOptions<OrgConsoleUpdateOrgAdminPreferencesResponse, OrgConsoleUpdateOrgAdminPreferencesError, Options<OrgConsoleUpdateOrgAdminPreferencesData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleUpdateOrgAdminPreferencesResponse, OrgConsoleUpdateOrgAdminPreferencesError, Options<OrgConsoleUpdateOrgAdminPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleUpdateOrgAdminPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConsoleGetOrgMeasurementConfigQueryKey = (options: Options<OrgConsoleGetOrgMeasurementConfigData>) => createQueryKey('org-console-get_org_measurement_config', options);

/**
 * Get Org Measurement Config
 *
 * The organization's measurement configuration — the three vendor ids, plus
 * when and by whom they were last changed.
 *
 * Any admin of the organization may read it, for the same reason any admin may
 * read the module switches: seeing how your own organization's donation surfaces
 * are instrumented is not privileged. CHANGING it is Owner/Global-Admin tier.
 *
 * **200 with every field null for an organization that has never configured
 * anything** — never a resource 404. On this surface a 404 is reserved for the
 * dark gate and the route miss, so answering one here would be indistinguishable
 * from "there is no such route" and would make an empty form look broken.
 */
export const orgConsoleGetOrgMeasurementConfigOptions = (options: Options<OrgConsoleGetOrgMeasurementConfigData>) => queryOptions<OrgConsoleGetOrgMeasurementConfigResponse, OrgConsoleGetOrgMeasurementConfigError, OrgConsoleGetOrgMeasurementConfigResponse, ReturnType<typeof orgConsoleGetOrgMeasurementConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleGetOrgMeasurementConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleGetOrgMeasurementConfigQueryKey(options)
});

/**
 * Update Org Measurement Config
 *
 * Set the organization's measurement ids. Owner/Global-Admin tier.
 *
 * PARTIAL and THREE-VALUED per field: an ABSENT field is left alone, an explicit
 * ``null`` CLEARS it, and a string is whitespace-stripped, upper-cased,
 * format-validated and stored. An invalid id answers 422 naming the field; an
 * unknown key answers 422 too (``extra="forbid"``).
 *
 * Idempotent: a field patched to the value it already holds is not a change, so
 * a save of an unedited form writes nothing at all — no row, no stamp, no event.
 * Every field that DOES change appends one ``MEASUREMENT_CONFIG_CHANGED`` access
 * event carrying its before and after, in the same unit of work as the write.
 *
 * The ids are STORED and WELL-FORMED, and nothing more: no call is made to Google
 * or Meta, so a syntactically perfect id for a property that does not exist is
 * accepted like any other. Emission belongs to the surfaces that READ this — the
 * donate pages and the embedded checkout — not to this operation.
 */
export const orgConsoleUpdateOrgMeasurementConfigMutation = (options?: Partial<Options<OrgConsoleUpdateOrgMeasurementConfigData>>): UseMutationOptions<OrgConsoleUpdateOrgMeasurementConfigResponse, OrgConsoleUpdateOrgMeasurementConfigError, Options<OrgConsoleUpdateOrgMeasurementConfigData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleUpdateOrgMeasurementConfigResponse, OrgConsoleUpdateOrgMeasurementConfigError, Options<OrgConsoleUpdateOrgMeasurementConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleUpdateOrgMeasurementConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConsoleListOrgConsoleMembersQueryKey = (options: Options<OrgConsoleListOrgConsoleMembersData>) => createQueryKey('org-console-list_org_console_members', options);

/**
 * List Org Console Members
 *
 * The admin roster, each row carrying that admin's per-module standing (access,
 * tier, whether the organization has the module on, whether they carry a custom
 * permission set, and their effective permissions for it).
 *
 * Any admin of the organization may read the roster — seeing who else administers
 * your own organization is not privileged. CHANGING it is Global-Admin only.
 */
export const orgConsoleListOrgConsoleMembersOptions = (options: Options<OrgConsoleListOrgConsoleMembersData>) => queryOptions<OrgConsoleListOrgConsoleMembersResponse, OrgConsoleListOrgConsoleMembersError, OrgConsoleListOrgConsoleMembersResponse, ReturnType<typeof orgConsoleListOrgConsoleMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleListOrgConsoleMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleListOrgConsoleMembersQueryKey(options)
});

export const orgConsoleListOrgInvitesQueryKey = (options: Options<OrgConsoleListOrgInvitesData>) => createQueryKey('org-console-list_org_invites', options);

/**
 * List Org Invites
 *
 * This organization's LIVE invites — PENDING and not past expiry, newest first.
 *
 * Same authority as creating one: seeing who has been offered administration is the
 * same question as offering it. TWO admissions (clause 7, CPA-WEB40 W6-BE): a Global
 * Admin lists every invite and may narrow with `?module=<slug>` to the invites that
 * CARRY that module — issued from inside it, or offering it (the module Team page's
 * view); a module Owner holding its `<module>:invite_admins` string lists exactly the
 * module they name, and `?module=` is REQUIRED for such a caller — 422
 * `INVITE_MODULE_REQUIRED` without it (the access-request family's answer to the
 * same omission), since an unfiltered list is the org-wide read. A module the class
 * does not carry is 422 by name.
 *
 * The canonical `{data, meta, links}` envelope, like every other `/org` list read —
 * NOT the predecessor's `{invites: [...]}` named wrapper, which is a grandfathered
 * frozen shape on `/charity-admin`. `/org` is deliberately absent from
 * `lint_untyped_operations`'s informational-prefix list, so a non-canonical list
 * read here blocks the fail-closed contract gate on a staging or main promote.
 *
 * NEVER carries a token or its hash.
 */
export const orgConsoleListOrgInvitesOptions = (options: Options<OrgConsoleListOrgInvitesData>) => queryOptions<OrgConsoleListOrgInvitesResponse, OrgConsoleListOrgInvitesError, OrgConsoleListOrgInvitesResponse, ReturnType<typeof orgConsoleListOrgInvitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleListOrgInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleListOrgInvitesQueryKey(options)
});

/**
 * Create Org Invite
 *
 * Offer someone administration of this organization.
 *
 * `role='Owner'` invites a GLOBAL ADMIN and must carry no `module_grants`;
 * `role='Member'` invites a non-GA whose access is EXACTLY the offered grants
 * (D-CPO-24 — under the invitation model there is no fan-out, so the list IS the
 * access). `issued_module`'s presence makes the invite MODULE-issued and binds it to
 * clause 7's scope: that one module, a tier no higher than the issuer's own, never
 * Global Admin.
 *
 * TWO admissions (clause 7, CPA-WEB40 W6-BE): a Global Admin (the org-wide invite
 * capability) may make any offer; a module Owner holding that module's
 * `<module>:invite_admins` string may make a MODULE-ISSUED one — `issued_module`
 * set to their module — and nothing else: without `issued_module` they are refused
 * (an org-issued invite stays a Global Admin's), and an offer outside clause 7's
 * scope is refused by name with 400.
 *
 * Re-inviting an address SUPERSEDES its live invite rather than stacking a second
 * token — and a supersede is a revoke, so a module Owner may supersede only an invite
 * they could revoke (module-issued for their module); a Global Admin's org-issued
 * offer, or another module's, is refused by name (400) and stays pending. Inviting someone who ALREADY administers this organization mints nothing —
 * giving an existing admin more modules is a direct grant, not something to accept —
 * and answers 201 with `{already_admin: true, invite: null}`, so a composer that
 * asks the wrong question gets an honest answer, and the signal it needs to switch
 * to the direct-grant path, rather than a duplicate membership.
 *
 * ⚠ The response is DISCRIMINATED, not a bare nullable invite: a handler annotated
 * `-> OrgInviteOut` returning `None` answers 500, not a null body (FastAPI validates
 * the return against the declared model). See `OrgInviteCreatedOut`.
 *
 * ⚠ **The response NEVER carries the token.** The plaintext exists only in the
 * emailed accept link; the database stores only its SHA-256 hash.
 */
export const orgConsoleCreateOrgInviteMutation = (options?: Partial<Options<OrgConsoleCreateOrgInviteData>>): UseMutationOptions<OrgConsoleCreateOrgInviteResponse, OrgConsoleCreateOrgInviteError, Options<OrgConsoleCreateOrgInviteData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleCreateOrgInviteResponse, OrgConsoleCreateOrgInviteError, Options<OrgConsoleCreateOrgInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleCreateOrgInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Org Invite
 *
 * Rescind a live invite before it is redeemed.
 *
 * TWO admissions (clause 7, CPA-WEB40 W6-BE): a Global Admin may revoke any live
 * invite of the organization; a module Owner holding its `<module>:invite_admins`
 * string may revoke only an invite that was MODULE-ISSUED for that module — an
 * org-issued offer stays a Global Admin's to rescind (403).
 *
 * The invite must belong to THIS organization and class; a cross-org id answers the
 * same not-found as an unknown one, so ids are not enumerable across organizations
 * — and since `org_ref` carries no foreign key, that scoping is the only thing
 * keeping the id spaces apart. An already-terminal invite is likewise a not-found:
 * only a live invite is revocable.
 */
export const orgConsoleRevokeOrgInviteMutation = (options?: Partial<Options<OrgConsoleRevokeOrgInviteData>>): UseMutationOptions<OrgConsoleRevokeOrgInviteResponse, OrgConsoleRevokeOrgInviteError, Options<OrgConsoleRevokeOrgInviteData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleRevokeOrgInviteResponse, OrgConsoleRevokeOrgInviteError, Options<OrgConsoleRevokeOrgInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleRevokeOrgInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Org Member
 *
 * Take someone off this organization's admin team entirely. Global-Admin only.
 *
 * The REMOVE half of the invite family's ADD: who administers an organization is the
 * organization's own question, so it is answered here rather than in a class module
 * the other class will never open.
 *
 * The class's own removal writer does the membership work — this door and the
 * class's door are ONE writer — and the org console additionally tears down the
 * org-plane records (module grants and custom permission sets) in the same unit of
 * work, so a re-added person starts clean.
 *
 * **The last-Global-Admin guard binds**: you may remove yourself, but not the last
 * Global Admin. A person who is not an admin of this organization — unknown, or an
 * admin of a different one — answers the family's one constant 400, which is also
 * what a repeated removal answers; nothing is audited twice.
 *
 * Pending INVITES are untouched: an invite is addressed to an email, is TTL-bounded,
 * and re-validates its issuer's standing at accept. Sessions, lock claims and
 * employment rows are untouched too, exactly as the class doors leave them.
 */
export const orgConsoleRemoveOrgMemberMutation = (options?: Partial<Options<OrgConsoleRemoveOrgMemberData>>): UseMutationOptions<OrgConsoleRemoveOrgMemberResponse, OrgConsoleRemoveOrgMemberError, Options<OrgConsoleRemoveOrgMemberData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleRemoveOrgMemberResponse, OrgConsoleRemoveOrgMemberError, Options<OrgConsoleRemoveOrgMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleRemoveOrgMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Org Member Module Access
 *
 * Revoke ONE module's grant from ONE admin — the access-update family's scoped
 * member, over the SAME writer as `PUT …/access` (`has_access: false`).
 *
 * Idempotent, and it deletes any custom permission set with the grant, exactly as the
 * PUT does. Every change appends the same `MODULE_ACCESS_REVOKED` row the PUT
 * appends — this route mints no audit vocabulary of its own.
 *
 * ⚠ **Revoking an admin's LAST stored module is refused (422)**, on this route for
 * the same reason as on the PUT: zero stored facts read back as "never enrolled" and
 * resolve DEFAULT access through the legacy fallback, which is wider than what was
 * just revoked. The honest acts are removing them from the organization, or waiting
 * for OM-4's choreography, which deletes the refusal from both doors together.
 *
 * ⚠ **A Global Admin target is refused (422).** They hold every module by tier and
 * the resolver ignores their grant rows, so deleting one would change nothing while
 * recording that it did. Removing the Global-Admin flag is the PUT's job.
 *
 * `module` is validated against the addressed organization's CLASS catalog — the
 * module vocabulary is per-class data, so an unknown slug answers the PUT's own 422
 * rather than a route miss.
 */
export const orgConsoleRemoveOrgMemberModuleAccessMutation = (options?: Partial<Options<OrgConsoleRemoveOrgMemberModuleAccessData>>): UseMutationOptions<OrgConsoleRemoveOrgMemberModuleAccessResponse, OrgConsoleRemoveOrgMemberModuleAccessError, Options<OrgConsoleRemoveOrgMemberModuleAccessData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleRemoveOrgMemberModuleAccessResponse, OrgConsoleRemoveOrgMemberModuleAccessError, Options<OrgConsoleRemoveOrgMemberModuleAccessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleRemoveOrgMemberModuleAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Org Member Access
 *
 * Patch ONE admin's access. Global-Admin only.
 *
 * PARTIAL and idempotent: an absent field is left alone. ``permissions`` is
 * three-valued — absent leaves the custom set, ``null`` CLEARS it (back to tier
 * defaults), a list sets it. An unknown key 422s with the offending keys and writes
 * nothing. Every change appends one access-event row.
 *
 * ``is_global_admin`` rides the organization's EXISTING role-change path, so the
 * last-Global-Admin guard still binds: you may demote yourself, but not the last
 * one. Revoking an admin's LAST module is refused (422) — see
 * ``OrgLastModuleRevokeException``.
 */
export const orgConsoleUpdateOrgMemberAccessMutation = (options?: Partial<Options<OrgConsoleUpdateOrgMemberAccessData>>): UseMutationOptions<OrgConsoleUpdateOrgMemberAccessResponse, OrgConsoleUpdateOrgMemberAccessError, Options<OrgConsoleUpdateOrgMemberAccessData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleUpdateOrgMemberAccessResponse, OrgConsoleUpdateOrgMemberAccessError, Options<OrgConsoleUpdateOrgMemberAccessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleUpdateOrgMemberAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConsoleGetOrgModuleTermsQueryKey = (options: Options<OrgConsoleGetOrgModuleTermsData>) => createQueryKey('org-console-get_org_module_terms', options);

/**
 * Get Org Module Terms
 *
 * The CURRENT instrument one module carries for this organization's class,
 * plus whether the organization has accepted it — the Turn On modal's read.
 *
 * `accepted` is a standing acceptance of ANY version, which is exactly the
 * switch's predicate: a newer effective version never re-arms it and never turns
 * a live module off (OQ5) — versions ride the main Terms' publish-and-notice
 * rail, so there is nothing here to nag about. 404 — the console's own,
 * byte-identical to a route miss — when the pair binds no instrument (every
 * pair at birth) or none is effective.
 */
export const orgConsoleGetOrgModuleTermsOptions = (options: Options<OrgConsoleGetOrgModuleTermsData>) => queryOptions<OrgConsoleGetOrgModuleTermsResponse, OrgConsoleGetOrgModuleTermsError, OrgConsoleGetOrgModuleTermsResponse, ReturnType<typeof orgConsoleGetOrgModuleTermsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConsoleGetOrgModuleTerms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConsoleGetOrgModuleTermsQueryKey(options)
});

/**
 * Accept Org Module Terms
 *
 * Accept the module's instrument on the ORGANIZATION's behalf — the step
 * between Turn On and the switch write.
 *
 * `WRITE_SETTINGS`, the switch's tier: only a Global Admin turns a module on, so
 * only a Global Admin accepts, as the organization's agent — ONCE; admins added
 * to the module later do not re-accept, and there are no per-person rows. The
 * acting user and the instant are server-side; the body carries only the hash of
 * the copy the modal displayed, and a stale one is refused (409) so outdated
 * text can never bind the organization. Idempotent at the current version.
 * After a 200 the settings write's `enabled: true` (or the hook's start) is
 * admitted for this module.
 */
export const orgConsoleAcceptOrgModuleTermsMutation = (options?: Partial<Options<OrgConsoleAcceptOrgModuleTermsData>>): UseMutationOptions<OrgConsoleAcceptOrgModuleTermsResponse, OrgConsoleAcceptOrgModuleTermsError, Options<OrgConsoleAcceptOrgModuleTermsData>> => {
    const mutationOptions: UseMutationOptions<OrgConsoleAcceptOrgModuleTermsResponse, OrgConsoleAcceptOrgModuleTermsError, Options<OrgConsoleAcceptOrgModuleTermsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConsoleAcceptOrgModuleTerms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgConfirmationRequestsGetOrgMoneyFloorsQueryKey = (options: Options<OrgConfirmationRequestsGetOrgMoneyFloorsData>) => createQueryKey('org-confirmation-requests-get_org_money_floors', options);

/**
 * Get Org Money Floors
 *
 * The organization's floors on one money surface: what it set, what binds now, and
 * what its agents used of each period floor. For a person who may set them.
 */
export const orgConfirmationRequestsGetOrgMoneyFloorsOptions = (options: Options<OrgConfirmationRequestsGetOrgMoneyFloorsData>) => queryOptions<OrgConfirmationRequestsGetOrgMoneyFloorsResponse, OrgConfirmationRequestsGetOrgMoneyFloorsError, OrgConfirmationRequestsGetOrgMoneyFloorsResponse, ReturnType<typeof orgConfirmationRequestsGetOrgMoneyFloorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgConfirmationRequestsGetOrgMoneyFloors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgConfirmationRequestsGetOrgMoneyFloorsQueryKey(options)
});

/**
 * Save Org Money Floor
 *
 * A person's direct save of one floor. A save that loosens it needs a sign-in within
 * the floor-loosening window (``step_up_required``); one that only narrows needs none; a
 * stale ``expected_version`` is the 409.
 */
export const orgConfirmationRequestsSaveOrgMoneyFloorMutation = (options?: Partial<Options<OrgConfirmationRequestsSaveOrgMoneyFloorData>>): UseMutationOptions<OrgConfirmationRequestsSaveOrgMoneyFloorResponse, OrgConfirmationRequestsSaveOrgMoneyFloorError, Options<OrgConfirmationRequestsSaveOrgMoneyFloorData>> => {
    const mutationOptions: UseMutationOptions<OrgConfirmationRequestsSaveOrgMoneyFloorResponse, OrgConfirmationRequestsSaveOrgMoneyFloorError, Options<OrgConfirmationRequestsSaveOrgMoneyFloorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgConfirmationRequestsSaveOrgMoneyFloor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgQrDesignGetOrgQrDesignQueryKey = (options: Options<OrgQrDesignGetOrgQrDesignData>) => createQueryKey('org-qr-design-get_org_qr_design', options);

/**
 * Get Org Qr Design
 *
 * The organization's default QR design — the one design every QR it generates
 * renders in — with whether the organization has a stored logo a design may
 * choose. Any administrator may read it.
 */
export const orgQrDesignGetOrgQrDesignOptions = (options: Options<OrgQrDesignGetOrgQrDesignData>) => queryOptions<OrgQrDesignGetOrgQrDesignResponse, OrgQrDesignGetOrgQrDesignError, OrgQrDesignGetOrgQrDesignResponse, ReturnType<typeof orgQrDesignGetOrgQrDesignQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgQrDesignGetOrgQrDesign({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgQrDesignGetOrgQrDesignQueryKey(options)
});

/**
 * Update Org Qr Design
 *
 * Save the organization's ONE default QR design (the body is the design). An
 * unscannable design is the validator's 422. For a company this is the same design
 * the Givmo apps edit for it.
 */
export const orgQrDesignUpdateOrgQrDesignMutation = (options?: Partial<Options<OrgQrDesignUpdateOrgQrDesignData>>): UseMutationOptions<OrgQrDesignUpdateOrgQrDesignResponse, OrgQrDesignUpdateOrgQrDesignError, Options<OrgQrDesignUpdateOrgQrDesignData>> => {
    const mutationOptions: UseMutationOptions<OrgQrDesignUpdateOrgQrDesignResponse, OrgQrDesignUpdateOrgQrDesignError, Options<OrgQrDesignUpdateOrgQrDesignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgQrDesignUpdateOrgQrDesign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgQrDesignRenderOrgPublicQrQueryKey = (options: Options<OrgQrDesignRenderOrgPublicQrData>) => createQueryKey('org-qr-design-render_org_public_qr', options);

/**
 * Render Org Public Qr
 *
 * The organization's public QR in its saved default design. A charity's encodes
 * its canonical link to its public page; a company's is its giving-link QR. This
 * GET is write-class: the first render may allocate that one target (the redirect
 * record, or the company's giving link), a bounded and idempotent write.
 */
export const orgQrDesignRenderOrgPublicQrOptions = (options: Options<OrgQrDesignRenderOrgPublicQrData>) => queryOptions<OrgQrDesignRenderOrgPublicQrResponse, OrgQrDesignRenderOrgPublicQrError, OrgQrDesignRenderOrgPublicQrResponse, ReturnType<typeof orgQrDesignRenderOrgPublicQrQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgQrDesignRenderOrgPublicQr({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgQrDesignRenderOrgPublicQrQueryKey(options)
});

/**
 * Render Supplied Org Public Qr
 *
 * The organization's public QR in a SUPPLIED design — the editor's preview and
 * its download-without-saving. Saves no design, but is write-class like the saved
 * render: it may make the same bounded, idempotent allocation.
 */
export const orgQrDesignRenderSuppliedOrgPublicQrMutation = (options?: Partial<Options<OrgQrDesignRenderSuppliedOrgPublicQrData>>): UseMutationOptions<OrgQrDesignRenderSuppliedOrgPublicQrResponse, OrgQrDesignRenderSuppliedOrgPublicQrError, Options<OrgQrDesignRenderSuppliedOrgPublicQrData>> => {
    const mutationOptions: UseMutationOptions<OrgQrDesignRenderSuppliedOrgPublicQrResponse, OrgQrDesignRenderSuppliedOrgPublicQrError, Options<OrgQrDesignRenderSuppliedOrgPublicQrData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgQrDesignRenderSuppliedOrgPublicQr({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Pledge Campaign
 *
 * Create a pledge-per-unit campaign on a fundraiser the caller organizes (02 §4.1):
 * its owner-agnostic organizer rank, whoever owns it (a person, a group, a company or
 * a charity). ``attested`` mode only at v1 (oracle is Phase 4). One campaign per
 * fundraiser. A fundraiser the caller does not organize, or an absent one → 404
 * (non-enumeration); a duplicate campaign or an oracle-mode request → 400.
 */
export const pledgesCreatePledgeCampaignMutation = (options?: Partial<Options<PledgesCreatePledgeCampaignData>>): UseMutationOptions<PledgesCreatePledgeCampaignResponse, PledgesCreatePledgeCampaignError, Options<PledgesCreatePledgeCampaignData>> => {
    const mutationOptions: UseMutationOptions<PledgesCreatePledgeCampaignResponse, PledgesCreatePledgeCampaignError, Options<PledgesCreatePledgeCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesCreatePledgeCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pledgesGetPledgeCampaignQueryKey = (options: Options<PledgesGetPledgeCampaignData>) => createQueryKey('pledges-get_pledge_campaign', options);

/**
 * Get Pledge Campaign
 *
 * Public campaign-page read (02 §4.1 — the campaign page is public). The
 * presented user, if any, decides only whether a members-only group's campaign
 * shows: to a non-member or an anonymous caller it is the same 404 as a missing
 * campaign. A miss → 404. Dark behind the flag.
 */
export const pledgesGetPledgeCampaignOptions = (options: Options<PledgesGetPledgeCampaignData>) => queryOptions<PledgesGetPledgeCampaignResponse, PledgesGetPledgeCampaignError, PledgesGetPledgeCampaignResponse, ReturnType<typeof pledgesGetPledgeCampaignQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pledgesGetPledgeCampaign({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pledgesGetPledgeCampaignQueryKey(options)
});

/**
 * Submit Attestation
 *
 * Submit a result value for a campaign (02 §4.4). The organizer (or a
 * participant self-entry) records ``submitted_units``; the value lands on an
 * append-only audit row and moves the campaign OPEN → PROVISIONAL (or →
 * NEEDS_REVIEW on a tripped outlier). It NEVER locks or charges — organizer
 * ACCEPTANCE is the write-once lock trigger. Organizer-only (the fundraiser's
 * owner-agnostic organizer rank); a campaign the caller does not organize, or an
 * absent one → 404; a wrong-state campaign → 409.
 * ``Idempotency-Key`` REQUIRED (fail-closed 422).
 */
export const pledgesSubmitAttestationMutation = (options?: Partial<Options<PledgesSubmitAttestationData>>): UseMutationOptions<PledgesSubmitAttestationResponse, PledgesSubmitAttestationError, Options<PledgesSubmitAttestationData>> => {
    const mutationOptions: UseMutationOptions<PledgesSubmitAttestationResponse, PledgesSubmitAttestationError, Options<PledgesSubmitAttestationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesSubmitAttestation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept Attestation
 *
 * Organizer ACCEPTANCE — the write-once permanent lock (02 §4.4 / D-PV-1
 * §3.3 c.6). The organizer accepts ``submitted_units`` as the final result: zero
 * tripped outlier flags → LOCKED (``final_units`` + ``locked_at`` +
 * ``attestor_user_id`` stamped write-once; the 48h notice/objection clock
 * starts); any trip → NEEDS_REVIEW (the lock is BLOCKED — only the audited
 * adjudication exits it → 409). Organizer-only; a campaign the caller does not
 * organize, or an absent one → 404; an already-locked / wrong-state campaign → 409. ``Idempotency-Key``
 * REQUIRED (fail-closed 422).
 */
export const pledgesAcceptAttestationMutation = (options?: Partial<Options<PledgesAcceptAttestationData>>): UseMutationOptions<PledgesAcceptAttestationResponse, PledgesAcceptAttestationError, Options<PledgesAcceptAttestationData>> => {
    const mutationOptions: UseMutationOptions<PledgesAcceptAttestationResponse, PledgesAcceptAttestationError, Options<PledgesAcceptAttestationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesAcceptAttestation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Pledge
 *
 * Create a unit pledge WITH atomic consent capture (02 §4.2 / the signed
 * consent artifact). A pledge is STRUCTURALLY impossible without a pinned consent
 * record: the SAME UoW writes ``pledge_consent_record`` + the ``unit_pledge``
 * (``consent_record_id`` FK). Card funding establishes the stored credential via
 * the existing card-save tokenization (NO charge at card-save); wallet funding
 * (sub-flag-gated) mints the cap-amount hold. A consent copy not-yet-LIVE → 409
 * ``CONSENT_UNAVAILABLE``; wallet funding while the sub-flag is off → 409
 * ``WALLET_FUNDING_DISABLED``; pledging closed here (the campaign, its window or its
 * fundraiser takes no new pledge) → 409 ``PLEDGING_CLOSED``; the fundraiser's
 * recipients changed since the client read them, or differ from the optional
 * ``displayed_recipients`` it showed the pledgor → 409 ``PLEDGE_RECIPIENTS_CHANGED``
 * (refetch, show them again, then retry). ``Idempotency-Key`` REQUIRED (fail-closed
 * 422).
 *
 * GFU-BE24 (dark behind ``PLEDGE_APPLE_PAY_ENABLED``): ``card_kind`` ``apple_pay`` with
 * the token from Apple's deferred sheet at $0 today
 * (``alternative_payment_method_token``) funds a card pledge by Apple Pay. A request
 * whose parts disagree → 400; the sub-flag off → 409 ``APPLE_PAY_FUNDING_DISABLED``; a
 * card not from a $0 deferred sheet with a merchant token → 400
 * ``APPLE_PAY_CARD_UNSUPPORTED``; a card that fails its $0 check → 409
 * ``PLEDGE_ESTABLISHMENT_FAILED``. The answer's ``card_kind`` says which kind of card
 * funds the pledge.
 */
export const pledgesCreatePledgeMutation = (options?: Partial<Options<PledgesCreatePledgeData>>): UseMutationOptions<PledgesCreatePledgeResponse, PledgesCreatePledgeError, Options<PledgesCreatePledgeData>> => {
    const mutationOptions: UseMutationOptions<PledgesCreatePledgeResponse, PledgesCreatePledgeError, Options<PledgesCreatePledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesCreatePledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pledgesGetPledgeProjectedTotalQueryKey = (options: Options<PledgesGetPledgeProjectedTotalData>) => createQueryKey('pledges-get_pledge_projected_total', options);

/**
 * Get Pledge Projected Total
 *
 * ORGANIZER-ONLY projected-total read for the mandatory pre-lock review
 * screen (PV3-BE10 / UX review #5): "locking at N units charges M pledgors up to
 * $X total". Given a hypothetical ``units`` result the organizer is about to
 * lock, returns the campaign-wide charge projection — ``pledge_count``
 * settle-eligible (``active``/``failed``) pledges, ``projected_total_cents`` =
 * ``Σ min(units × rate, cap)``, and ``cap_total_cents`` = ``Σ cap`` — all EXACT
 * integer cents from a pure SQL SUM. ``units`` is a REQUIRED, non-negative query
 * param (mirroring the attestation ``submitted_units`` bound; missing / negative
 * → 422).
 *
 * Organizer ONLY (the SAME 404-collapsing rail the attestation accept endpoint
 * uses): a pledgor / guest / any non-organizer gets 404, and there is NO
 * public route — a campaign-wide dollar projection is the "betting-board"
 * artifact the no-betting posture forbids on any public/pledgor surface (UX
 * review #2). Dark behind the flag (the route-level ``_require_pledges_enabled``
 * dependency 404s a flag-off call before the ``units`` validation can leak the
 * route).
 */
export const pledgesGetPledgeProjectedTotalOptions = (options: Options<PledgesGetPledgeProjectedTotalData>) => queryOptions<PledgesGetPledgeProjectedTotalResponse, PledgesGetPledgeProjectedTotalError, PledgesGetPledgeProjectedTotalResponse, ReturnType<typeof pledgesGetPledgeProjectedTotalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pledgesGetPledgeProjectedTotal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pledgesGetPledgeProjectedTotalQueryKey(options)
});

/**
 * Preview Pledge Offer Rule
 *
 * Preview the sentence a pledge would be shown (plan §1.5a; D-GFU-46): for the body ``POST
 * /pledge-offers`` would take, the rule sentence (composed at ``rate_cents``, else the offer's
 * suggested or fixed rate; null with neither, when ``rule_sentence_rate_free`` carries its
 * rate-free form instead, GFU-BE103), the precision line and the unit's plural, exactly
 * as the offer would serve them and every pledge on it would pin them. Nothing is written. The
 * caller organizes the fundraisers at their OWNER rank, and the body is asked what the create
 * asks of it: a new measure's settings and words (a betting, health or candidate word, a
 * phrase naming an amount, health-type data, a fundraiser that already has a measure → 400;
 * a ``stat_key`` → 400 ``PLEDGE_STAT_KEY_REFUSED``), an existing measure the fundraiser may
 * read (404, 409, 400 as on the create), and terms that settle (400), a rate no more than the
 * cap among them (400 ``PLEDGE_RATE_ABOVE_CAP``, as on the create). Also the source line a
 * pledge on it would be shown and pin, for every kind of measure (``source_line``, null where
 * none can be composed), and on a total of other counts how many it adds up now
 * (``rollup_part_count``); a new total is asked what its create asks. Signed in; dark behind
 * the flag.
 */
export const pledgesPreviewPledgeOfferRuleMutation = (options?: Partial<Options<PledgesPreviewPledgeOfferRuleData>>): UseMutationOptions<PledgesPreviewPledgeOfferRuleResponse, PledgesPreviewPledgeOfferRuleError, Options<PledgesPreviewPledgeOfferRuleData>> => {
    const mutationOptions: UseMutationOptions<PledgesPreviewPledgeOfferRuleResponse, PledgesPreviewPledgeOfferRuleError, Options<PledgesPreviewPledgeOfferRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesPreviewPledgeOfferRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pledgesGetPledgeOfferQueryKey = (options: Options<PledgesGetPledgeOfferData>) => createQueryKey('pledges-get_pledge_offer', options);

/**
 * Get Pledge Offer
 *
 * One pledge offer, public (plan §1.5): its terms, its window and status, the measures it
 * reads, and ``viewer_is_organizer``. ``measure_shown`` false means it is not pledgeable
 * here: no measure of it is served, nor its status, window, close or last update, its rule
 * sentence or precision line, and no pledge button is shown. ``rule_sentence`` is composed at
 * ``rate_cents`` when given (the pledgor's own rate, which the checkout shows and the pledge
 * create echoes), else at the offer's suggested or fixed rate (null with neither). An offer
 * whose fundraiser is missing, hidden from the caller, a draft, or not public → 404, except to
 * that fundraiser's own organizers. Anonymous or signed in; dark behind the flag.
 */
export const pledgesGetPledgeOfferOptions = (options: Options<PledgesGetPledgeOfferData>) => queryOptions<PledgesGetPledgeOfferResponse, PledgesGetPledgeOfferError, PledgesGetPledgeOfferResponse, ReturnType<typeof pledgesGetPledgeOfferQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pledgesGetPledgeOffer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pledgesGetPledgeOfferQueryKey(options)
});

export const pledgesGetPledgesLiveQueryKey = (options: Options<PledgesGetPledgesLiveData>) => createQueryKey('pledges-get_pledges_live', options);

/**
 * Get Pledges Live
 *
 * The public live read (GFU-BE19, plan §1.4): for each fundraiser named (1 to 25; a page
 * and the pages on its board), its pledge offers' live PLEDGED figures — what their pledges
 * would be charged at the count they read, each capped, never money raised — and the counts
 * of the measures they read, unofficial until locked. A measure the page owns (a game's
 * scoreboard) also carries its crowd: every offer counting on it across the pages its public
 * total counts. A condition not yet decided shows what its pledges give if it holds, and
 * joins no sum. A fundraiser that is missing, not public, or not visible to the caller is
 * absent from ``data``; one whose "Show dollars raised" is off shows no dollar figure. Served
 * from a short-lived cache, a few seconds old at most. Anonymous or signed in; dark behind
 * the flag.
 */
export const pledgesGetPledgesLiveOptions = (options: Options<PledgesGetPledgesLiveData>) => queryOptions<PledgesGetPledgesLiveResponse, PledgesGetPledgesLiveError, PledgesGetPledgesLiveResponse, ReturnType<typeof pledgesGetPledgesLiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pledgesGetPledgesLive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pledgesGetPledgesLiveQueryKey(options)
});

export const postsGetPostQueryKey = (options: Options<PostsGetPostData>) => createQueryKey('posts-get_post', options);

/**
 * Get Post
 *
 * A single post by id — the self-sufficient PostDetail load path.
 *
 * PostDetail is normally handed its post object through navigation (the feed
 * passes the already-loaded `DonationActivity`/`PostOut`). But a `post_liked`/
 * `post_commented` push tap on a COLD START routes to PostDetail keyed by id
 * alone, before any feed has seeded the client's post cache — so both clients
 * need a fetch-by-id fallback, and there was no endpoint to serve it (a blank
 * PostDetail screen). This is that endpoint.
 *
 * Authenticated (like the fundraiser/follows feeds). Owner-or-PUBLIC
 * visibility via the shared `_require_visible_post` gate (in the service): the
 * push recipient IS the owner, so they always get their own post (even
 * PRIVATE); a non-owner on a non-PUBLIC post gets the uniform missing-post 400
 * so a private post's existence never leaks (see `_require_visible_post` — do
 * NOT turn that into a 404).
 *
 * FOP-BE1: the wire is one feed row widened to `MyPostOut`. For the post's
 * OWNER (plain user-attributed posts only), the owner-only fields (donation_id /
 * amount / instructions / request_match / match_status / hide_name /
 * cover_fees) are stamped via the same `_stamp_owner_post_fields` hydration `GET
 * /users/me/posts` uses, so the feed's own-post tap can open the
 * donation-management view without a second endpoint. For every OTHER reader
 * the fields serialize as null — additive, information-free keys that frozen
 * feed-row decoders ignore.
 */
export const postsGetPostOptions = (options: Options<PostsGetPostData>) => queryOptions<PostsGetPostResponse, PostsGetPostError, PostsGetPostResponse, ReturnType<typeof postsGetPostQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetPost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetPostQueryKey(options)
});

/**
 * Comment Post
 */
export const postsCommentPostMutation = (options?: Partial<Options<PostsCommentPostData>>): UseMutationOptions<PostsCommentPostResponse, PostsCommentPostError, Options<PostsCommentPostData>> => {
    const mutationOptions: UseMutationOptions<PostsCommentPostResponse, PostsCommentPostError, Options<PostsCommentPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsCommentPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postsGetPostCommentsQueryKey = (options: Options<PostsGetPostCommentsData>) => createQueryKey('posts-get_post_comments', options);

/**
 * Get Post Comments
 */
export const postsGetPostCommentsOptions = (options: Options<PostsGetPostCommentsData>) => queryOptions<PostsGetPostCommentsResponse, PostsGetPostCommentsError, PostsGetPostCommentsResponse, ReturnType<typeof postsGetPostCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetPostComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetPostCommentsQueryKey(options)
});

/**
 * Delete Comment
 *
 * Author-delete of one's own comment (GF-BE8 / D-GF-11) → 204. Author-only:
 * a comment owned by another user → 403; a missing comment (or one not on this
 * post) → 404 with a constant detail. Post-owner deletion of OTHERS' comments
 * is deferred. Dark until the clients ship the delete-own-comment affordance.
 */
export const postsDeleteCommentMutation = (options?: Partial<Options<PostsDeleteCommentData>>): UseMutationOptions<PostsDeleteCommentResponse, PostsDeleteCommentError, Options<PostsDeleteCommentData>> => {
    const mutationOptions: UseMutationOptions<PostsDeleteCommentResponse, PostsDeleteCommentError, Options<PostsDeleteCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsDeleteComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Like Comment
 */
export const postsLikeCommentMutation = (options?: Partial<Options<PostsLikeCommentData>>): UseMutationOptions<PostsLikeCommentResponse, PostsLikeCommentError, Options<PostsLikeCommentData>> => {
    const mutationOptions: UseMutationOptions<PostsLikeCommentResponse, PostsLikeCommentError, Options<PostsLikeCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsLikeComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postsGetCommentLikesQueryKey = (options: Options<PostsGetCommentLikesData>) => createQueryKey('posts-get_comment_likes', options);

/**
 * Get Comment Likes
 */
export const postsGetCommentLikesOptions = (options: Options<PostsGetCommentLikesData>) => queryOptions<PostsGetCommentLikesResponse, PostsGetCommentLikesError, PostsGetCommentLikesResponse, ReturnType<typeof postsGetCommentLikesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetCommentLikes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetCommentLikesQueryKey(options)
});

/**
 * Unlike Comment
 */
export const postsUnlikeCommentMutation = (options?: Partial<Options<PostsUnlikeCommentData>>): UseMutationOptions<PostsUnlikeCommentResponse, PostsUnlikeCommentError, Options<PostsUnlikeCommentData>> => {
    const mutationOptions: UseMutationOptions<PostsUnlikeCommentResponse, PostsUnlikeCommentError, Options<PostsUnlikeCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsUnlikeComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Like Post
 */
export const postsLikePostMutation = (options?: Partial<Options<PostsLikePostData>>): UseMutationOptions<PostsLikePostResponse, PostsLikePostError, Options<PostsLikePostData>> => {
    const mutationOptions: UseMutationOptions<PostsLikePostResponse, PostsLikePostError, Options<PostsLikePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsLikePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postsGetPostLikesQueryKey = (options: Options<PostsGetPostLikesData>) => createQueryKey('posts-get_post_likes', options);

/**
 * Get Post Likes
 */
export const postsGetPostLikesOptions = (options: Options<PostsGetPostLikesData>) => queryOptions<PostsGetPostLikesResponse, PostsGetPostLikesError, PostsGetPostLikesResponse, ReturnType<typeof postsGetPostLikesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetPostLikes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetPostLikesQueryKey(options)
});

/**
 * Update Post Message
 */
export const postsUpdatePostMessageMutation = (options?: Partial<Options<PostsUpdatePostMessageData>>): UseMutationOptions<PostsUpdatePostMessageResponse, PostsUpdatePostMessageError, Options<PostsUpdatePostMessageData>> => {
    const mutationOptions: UseMutationOptions<PostsUpdatePostMessageResponse, PostsUpdatePostMessageError, Options<PostsUpdatePostMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsUpdatePostMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Report Post
 *
 * Report a post (GF-BE6 / D-GF-9 — the in-app "Report post" control required
 * by Apple Guideline 1.2, mirroring the assistant AI-content report endpoint).
 * Auth required; append-only (a repeat report inserts another row). Body
 * `{category, comment?}`: an off-set `category` / a `comment` over 500 chars /
 * an unknown field → 422 at the schema layer (`PostReportIn`). A missing post →
 * 404 with a constant detail (`ReportPostNotFoundException`, no id echo). Dark
 * until the clients ship the Report action.
 */
export const postsReportPostMutation = (options?: Partial<Options<PostsReportPostData>>): UseMutationOptions<PostsReportPostResponse, PostsReportPostError, Options<PostsReportPostData>> => {
    const mutationOptions: UseMutationOptions<PostsReportPostResponse, PostsReportPostError, Options<PostsReportPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsReportPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlike Post
 */
export const postsUnlikePostMutation = (options?: Partial<Options<PostsUnlikePostData>>): UseMutationOptions<PostsUnlikePostResponse, PostsUnlikePostError, Options<PostsUnlikePostData>> => {
    const mutationOptions: UseMutationOptions<PostsUnlikePostResponse, PostsUnlikePostError, Options<PostsUnlikePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsUnlikePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Post Visibility
 */
export const postsUpdatePostVisibilityMutation = (options?: Partial<Options<PostsUpdatePostVisibilityData>>): UseMutationOptions<PostsUpdatePostVisibilityResponse, PostsUpdatePostVisibilityError, Options<PostsUpdatePostVisibilityData>> => {
    const mutationOptions: UseMutationOptions<PostsUpdatePostVisibilityResponse, PostsUpdatePostVisibilityError, Options<PostsUpdatePostVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsUpdatePostVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Report Profile Block
 *
 * Report one page block (the ``profile_block`` subject type). Auth required;
 * append-only. Body ``{category, comment?}`` validated at the schema layer; a
 * missing block → 404 with a constant detail.
 */
export const profileReportsReportProfileBlockMutation = (options?: Partial<Options<ProfileReportsReportProfileBlockData>>): UseMutationOptions<ProfileReportsReportProfileBlockResponse, ProfileReportsReportProfileBlockError, Options<ProfileReportsReportProfileBlockData>> => {
    const mutationOptions: UseMutationOptions<ProfileReportsReportProfileBlockResponse, ProfileReportsReportProfileBlockError, Options<ProfileReportsReportProfileBlockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await profileReportsReportProfileBlock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const profilePagesGetConsumerPageQueryKey = (options: Options<ProfilePagesGetConsumerPageData>) => createQueryKey('profile-pages-get_consumer_page', options);

/**
 * Get Consumer Page
 *
 * The OWNER view of a user's (self) or a group's (OWNER/ADMIN) page.
 */
export const profilePagesGetConsumerPageOptions = (options: Options<ProfilePagesGetConsumerPageData>) => queryOptions<ProfilePagesGetConsumerPageResponse, ProfilePagesGetConsumerPageError, ProfilePagesGetConsumerPageResponse, ReturnType<typeof profilePagesGetConsumerPageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await profilePagesGetConsumerPage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: profilePagesGetConsumerPageQueryKey(options)
});

/**
 * Replace Consumer Page
 *
 * The id-preserving full-list replace for a user (self) or a group (OWNER/ADMIN).
 */
export const profilePagesReplaceConsumerPageMutation = (options?: Partial<Options<ProfilePagesReplaceConsumerPageData>>): UseMutationOptions<ProfilePagesReplaceConsumerPageResponse, ProfilePagesReplaceConsumerPageError, Options<ProfilePagesReplaceConsumerPageData>> => {
    const mutationOptions: UseMutationOptions<ProfilePagesReplaceConsumerPageResponse, ProfilePagesReplaceConsumerPageError, Options<ProfilePagesReplaceConsumerPageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await profilePagesReplaceConsumerPage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Consumer Page Image
 *
 * Upload one page image under ``user/{id}/page/…`` / ``group/{id}/page/…``.
 */
export const profilePagesUploadConsumerPageImageMutation = (options?: Partial<Options<ProfilePagesUploadConsumerPageImageData>>): UseMutationOptions<ProfilePagesUploadConsumerPageImageResponse, ProfilePagesUploadConsumerPageImageError, Options<ProfilePagesUploadConsumerPageImageData>> => {
    const mutationOptions: UseMutationOptions<ProfilePagesUploadConsumerPageImageResponse, ProfilePagesUploadConsumerPageImageError, Options<ProfilePagesUploadConsumerPageImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await profilePagesUploadConsumerPageImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Unauthenticated Donation
 */
export const donationsCreateUnauthenticatedDonationMutation = (options?: Partial<Options<DonationsCreateUnauthenticatedDonationData>>): UseMutationOptions<DonationsCreateUnauthenticatedDonationResponse, DonationsCreateUnauthenticatedDonationError, Options<DonationsCreateUnauthenticatedDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateUnauthenticatedDonationResponse, DonationsCreateUnauthenticatedDonationError, Options<DonationsCreateUnauthenticatedDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateUnauthenticatedDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Unauthenticated Charity Collection Donation
 *
 * Public/anonymous Collection donation (App Check still applies; per-IP
 * rate-limited in the service). The collection must be PUBLIC/UNLISTED +
 * ACTIVE (the service 404s otherwise). Same mandatory grant-dispatch loop as
 * the authed route, WITHOUT `user`.
 */
export const charityCollectionsCreateUnauthenticatedCharityCollectionDonationMutation = (options?: Partial<Options<CharityCollectionsCreateUnauthenticatedCharityCollectionDonationData>>): UseMutationOptions<CharityCollectionsCreateUnauthenticatedCharityCollectionDonationResponse, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationError, Options<CharityCollectionsCreateUnauthenticatedCharityCollectionDonationData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsCreateUnauthenticatedCharityCollectionDonationResponse, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationError, Options<CharityCollectionsCreateUnauthenticatedCharityCollectionDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsCreateUnauthenticatedCharityCollectionDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolve Donation Link
 *
 * What the donate site's landing shows for an AI's donation link (MCP-A29b, Route
 * A, D-MCP-51), WITHOUT consuming it: the target, the amount the intent fixed, when the
 * link stops working, and "Giving as First L." with the account's photo. Never an
 * email, a full last name, an account id or a profile link.
 *
 * ANONYMOUS and App-Check-gated (``/public`` is a Firebase-path prefix, so
 * ``handler_middleware`` verifies App Check in staging and prod), per-IP limited, and a
 * consumer-serving surface, so the charity read applies the Hawaii name rule and the
 * terminal-removal exclusion. Every failure is the ONE 404
 * (``DonationLinkUnavailableException``): an unknown, used or expired token, a token not
 * minted for a consumer MCP intent (a partner widget's never resolves here), a closed
 * intent, a gone account, or a target this request may not show or pay.
 */
export const donationsResolveDonationLinkMutation = (options?: Partial<Options<DonationsResolveDonationLinkData>>): UseMutationOptions<DonationsResolveDonationLinkResponse, DonationsResolveDonationLinkError, Options<DonationsResolveDonationLinkData>> => {
    const mutationOptions: UseMutationOptions<DonationsResolveDonationLinkResponse, DonationsResolveDonationLinkError, Options<DonationsResolveDonationLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsResolveDonationLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Unauthenticated Etf Donation
 */
export const donationsCreateUnauthenticatedEtfDonationMutation = (options?: Partial<Options<DonationsCreateUnauthenticatedEtfDonationData>>): UseMutationOptions<DonationsCreateUnauthenticatedEtfDonationResponse, DonationsCreateUnauthenticatedEtfDonationError, Options<DonationsCreateUnauthenticatedEtfDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateUnauthenticatedEtfDonationResponse, DonationsCreateUnauthenticatedEtfDonationError, Options<DonationsCreateUnauthenticatedEtfDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateUnauthenticatedEtfDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Telemetry Event
 */
export const telemetryEventsRecordTelemetryEventMutation = (options?: Partial<Options<TelemetryEventsRecordTelemetryEventData>>): UseMutationOptions<TelemetryEventsRecordTelemetryEventResponse, TelemetryEventsRecordTelemetryEventError, Options<TelemetryEventsRecordTelemetryEventData>> => {
    const mutationOptions: UseMutationOptions<TelemetryEventsRecordTelemetryEventResponse, TelemetryEventsRecordTelemetryEventError, Options<TelemetryEventsRecordTelemetryEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await telemetryEventsRecordTelemetryEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Unauthenticated Fundraiser Donation
 */
export const donationsCreateUnauthenticatedFundraiserDonationMutation = (options?: Partial<Options<DonationsCreateUnauthenticatedFundraiserDonationData>>): UseMutationOptions<DonationsCreateUnauthenticatedFundraiserDonationResponse, DonationsCreateUnauthenticatedFundraiserDonationError, Options<DonationsCreateUnauthenticatedFundraiserDonationData>> => {
    const mutationOptions: UseMutationOptions<DonationsCreateUnauthenticatedFundraiserDonationResponse, DonationsCreateUnauthenticatedFundraiserDonationError, Options<DonationsCreateUnauthenticatedFundraiserDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsCreateUnauthenticatedFundraiserDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Purchase Gift Card
 *
 * Public purchase with new money — no account required; App Check is
 * the trust boundary (staging/prod). The charge is the gross (face +
 * mandatory cover-fees gross-up); the response NEVER carries the
 * plaintext code, so the idempotent replay of a duplicate
 * purchase_request_id is safe.
 */
export const giftCardsPurchaseGiftCardMutation = (options?: Partial<Options<GiftCardsPurchaseGiftCardData>>): UseMutationOptions<GiftCardsPurchaseGiftCardResponse, GiftCardsPurchaseGiftCardError, Options<GiftCardsPurchaseGiftCardData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsPurchaseGiftCardResponse, GiftCardsPurchaseGiftCardError, Options<GiftCardsPurchaseGiftCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsPurchaseGiftCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizerMessagesGetOrganizerMessageUnsubscribeQueryKey = (options: Options<OrganizerMessagesGetOrganizerMessageUnsubscribeData>) => createQueryKey('organizer-messages-get_organizer_message_unsubscribe', options);

/**
 * Get Organizer Message Unsubscribe
 *
 * The unsubscribe page's data: the fundraiser's name, and which stops hold.
 */
export const organizerMessagesGetOrganizerMessageUnsubscribeOptions = (options: Options<OrganizerMessagesGetOrganizerMessageUnsubscribeData>) => queryOptions<OrganizerMessagesGetOrganizerMessageUnsubscribeResponse, OrganizerMessagesGetOrganizerMessageUnsubscribeError, OrganizerMessagesGetOrganizerMessageUnsubscribeResponse, ReturnType<typeof organizerMessagesGetOrganizerMessageUnsubscribeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizerMessagesGetOrganizerMessageUnsubscribe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizerMessagesGetOrganizerMessageUnsubscribeQueryKey(options)
});

/**
 * Post Organizer Message Unsubscribe
 *
 * Apply one stop. JSON from the page names it; a mail provider's one-click form POST
 * applies "Stop messages from this fundraiser".
 */
export const organizerMessagesPostOrganizerMessageUnsubscribeMutation = (options?: Partial<Options<OrganizerMessagesPostOrganizerMessageUnsubscribeData>>): UseMutationOptions<OrganizerMessagesPostOrganizerMessageUnsubscribeResponse, OrganizerMessagesPostOrganizerMessageUnsubscribeError, Options<OrganizerMessagesPostOrganizerMessageUnsubscribeData>> => {
    const mutationOptions: UseMutationOptions<OrganizerMessagesPostOrganizerMessageUnsubscribeResponse, OrganizerMessagesPostOrganizerMessageUnsubscribeError, Options<OrganizerMessagesPostOrganizerMessageUnsubscribeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizerMessagesPostOrganizerMessageUnsubscribe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const paymentsGetPaymentsConfigQueryKey = (options?: Options<PaymentsGetPaymentsConfigData>) => createQueryKey('payments-get_payments_config', options);

/**
 * Get Payments Config
 *
 * Public, App-Check-gated payments config for client wallet rendering (F5).
 *
 * Returns the active processor + the PUBLIC Shift4 publishable key + the
 * Apple/Google Pay ids every client needs to render the wallet buttons.
 * Deliberately PUBLIC: the payload is non-secret and per-environment (not
 * per-user), so it carries NO Firebase auth — donate-web sends no ID token at
 * all. It still runs through ``handler_middleware`` (mounted as a plain
 * ``/public*`` route, not in ``_NON_FIREBASE_PREFIXES``), so App Check still
 * applies in staging/prod. The handler never reads ``request.state.user``,
 * which is what keeps it public (cf. ``GET /assistant/config``, which does and
 * is therefore auth-required).
 *
 * The secret server key (``SHIFT4_API_KEY`` / ``sk_…``) is NEVER returned.
 * ``gateway_merchant_id`` is derived from the publishable key — Shift4 couples
 * the two — rather than stored separately, so they cannot drift.
 *
 * ``pages`` is the surface-keyed map of hosted-page URLs (card form / wallet
 * pages) resolved for the current ``GIVMO_ENV`` (``config.PAYMENT_PAGES``);
 * each client reads only its own surface key. All public frontend URLs.
 */
export const paymentsGetPaymentsConfigOptions = (options?: Options<PaymentsGetPaymentsConfigData>) => queryOptions<PaymentsGetPaymentsConfigResponse, DefaultError, PaymentsGetPaymentsConfigResponse, ReturnType<typeof paymentsGetPaymentsConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await paymentsGetPaymentsConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: paymentsGetPaymentsConfigQueryKey(options)
});

/**
 * Create Guest Pledge
 *
 * Create a GUEST pledge (02 §4.2, PV3-BE5) — a pledgor with NO account (email +
 * name + card token) on the SHIPPED claim-token substrate (never a third guest
 * identity). UNAUTHENTICATED. The FULL authed safety stack is composed: atomic
 * version-pinned consent capture, $0-CIT establishment, the mandatory cap,
 * idempotency, a per-IP anti-abuse floor. CARD funding only (wallet needs a
 * signed-in user). The pledge is claimable into an account later via the emailed
 * bearer link. A registered email → 409 ``GUEST_EMAIL_REGISTERED`` (sign in
 * instead); a consent copy not-yet-LIVE → 409 ``CONSENT_UNAVAILABLE``; a card that
 * won't verify → 409 ``PLEDGE_ESTABLISHMENT_FAILED``; pledging closed here → 409
 * ``PLEDGING_CLOSED``; recipients changed, or other than the optional
 * ``displayed_recipients`` the page showed → 409 ``PLEDGE_RECIPIENTS_CHANGED``; too many
 * attempts → 429. ``Idempotency-Key`` REQUIRED (fail-closed 422).
 */
export const pledgesCreateGuestPledgeMutation = (options?: Partial<Options<PledgesCreateGuestPledgeData>>): UseMutationOptions<PledgesCreateGuestPledgeResponse, PledgesCreateGuestPledgeError, Options<PledgesCreateGuestPledgeData>> => {
    const mutationOptions: UseMutationOptions<PledgesCreateGuestPledgeResponse, PledgesCreateGuestPledgeError, Options<PledgesCreateGuestPledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesCreateGuestPledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Guest Offer Pledge
 *
 * Create a GUEST pledge on THIS offer: ``POST /public/pledge-campaigns/{campaign_id}/
 * pledges``' guest pledge (no account; card only; the per-IP floor; the emailed bearer link)
 * on the offer the path names, with its answers. The disclosure echoes are REQUIRED here
 * (``displayed_recipients``, ``displayed_source_line``, ``displayed_rule_sentence``,
 * ``displayed_precision_line``: others → 409 ``PLEDGE_RECIPIENTS_CHANGED`` /
 * ``PLEDGE_SOURCE_CHANGED`` / ``PLEDGE_RULE_CHANGED``; GFU-BE77's ``displayed_dates``,
 * ``shown_consent_*``, ``shown_disclaimer_*`` and ``presentation``, as on the signed-in offer
 * create); a flat pledge's cap is its
 * amount (409 ``PLEDGE_CAP_OUT_OF_RANGE``). An offer that is missing, or whose fundraiser the
 * offer read hides from a guest (a draft, a Deactivated page, a charity's page behind its
 * gate, a members-only group's page) → 404, the offer read's own. UNAUTHENTICATED.
 * ``Idempotency-Key`` REQUIRED (fail-closed 422).
 */
export const pledgesCreateGuestOfferPledgeMutation = (options?: Partial<Options<PledgesCreateGuestOfferPledgeData>>): UseMutationOptions<PledgesCreateGuestOfferPledgeResponse, PledgesCreateGuestOfferPledgeError, Options<PledgesCreateGuestOfferPledgeData>> => {
    const mutationOptions: UseMutationOptions<PledgesCreateGuestOfferPledgeResponse, PledgesCreateGuestOfferPledgeError, Options<PledgesCreateGuestOfferPledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesCreateGuestOfferPledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pledgesGetGuestPledgeQueryKey = (options: Options<PledgesGetGuestPledgeData>) => createQueryKey('pledges-get_guest_pledge', options);

/**
 * Get Guest Pledge
 *
 * A GUEST reads the ONE pledge the link their 48-hour notice carries names, to see
 * its three choices (D-GFU-30): pay the amount due, pay a lower amount from $1 up to
 * it, or cancel, until ``charge_eligible_at``. UNAUTHENTICATED — the ``token`` (the
 * notice link's plaintext) IS the authorization. Every refusal — a forged, expired or
 * spent link, a pledge an account now owns — collapses to the guest cancel's constant
 * 400 ``INVALID_PLEDGE_CLAIM_TOKEN`` (anti-enumeration). The path sits under the guest
 * cancel's bearer root, so the token is scrubbed from the app's logs and dropped from
 * Cloud Run's request log by the existing ``pledge-cancel`` exclusion.
 */
export const pledgesGetGuestPledgeOptions = (options: Options<PledgesGetGuestPledgeData>) => queryOptions<PledgesGetGuestPledgeResponse, PledgesGetGuestPledgeError, PledgesGetGuestPledgeResponse, ReturnType<typeof pledgesGetGuestPledgeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pledgesGetGuestPledge({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pledgesGetGuestPledgeQueryKey(options)
});

/**
 * Choose Guest Pledge Amount
 *
 * A GUEST chooses what their pledge pays through the link their 48-hour notice
 * carries (D-GFU-30), until its charge gate: exactly the amount due, or a lower amount
 * from $1 up to it; the third choice is the link's cancel. UNAUTHENTICATED — the
 * ``token`` IS the authorization, and the link stays live for another choice or the
 * cancel. Every refusal of the link — forged, expired or spent, a pledge an account now
 * owns or no longer active, the window closed — collapses to the guest cancel's
 * constant 400 ``INVALID_PLEDGE_CLAIM_TOKEN`` (anti-enumeration); an amount outside the
 * range is the 409 ``PLEDGE_AMOUNT_OUT_OF_RANGE``. Choosing the same amount again
 * changes nothing. NO idempotency-key required (the bearer and the choice's idempotence
 * are the safety). Answers the pledge as the read does.
 */
export const pledgesChooseGuestPledgeAmountMutation = (options?: Partial<Options<PledgesChooseGuestPledgeAmountData>>): UseMutationOptions<PledgesChooseGuestPledgeAmountResponse, PledgesChooseGuestPledgeAmountError, Options<PledgesChooseGuestPledgeAmountData>> => {
    const mutationOptions: UseMutationOptions<PledgesChooseGuestPledgeAmountResponse, PledgesChooseGuestPledgeAmountError, Options<PledgesChooseGuestPledgeAmountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesChooseGuestPledgeAmount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Guest Pledge
 *
 * Cancel a GUEST pledge via the single-use BEARER link, free pre-charge (02
 * §4.2.3, PV3-BE5). UNAUTHENTICATED — the ``token`` (the emailed claim link's
 * plaintext) IS the authorization; it cancels EVERY still-cancellable pledge it
 * covers. A bad/expired/claimed token, or one covering no cancellable pledge,
 * collapses to a constant 400 ``INVALID_PLEDGE_CLAIM_TOKEN`` (anti-enumeration —
 * never reveals whether a token exists). Idempotent (a re-cancel is a no-op
 * success). NO idempotency-key required (the bearer + the idempotent cancel are
 * the safety).
 *
 * GFU-BE27: the ``token`` may instead be the short-lived link a guest's 48-hour
 * notice carries. It cancels the ONE pledge it names, until the charge gate, and is
 * spent by it: a second use is the same constant 400.
 */
export const pledgesCancelGuestPledgeMutation = (options?: Partial<Options<PledgesCancelGuestPledgeData>>): UseMutationOptions<PledgesCancelGuestPledgeResponse, PledgesCancelGuestPledgeError, Options<PledgesCancelGuestPledgeData>> => {
    const mutationOptions: UseMutationOptions<PledgesCancelGuestPledgeResponse, PledgesCancelGuestPledgeError, Options<PledgesCancelGuestPledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesCancelGuestPledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Object To Guest Pledge
 *
 * Retired (GFU-BE45, D-GFU-30): a guest who disagrees with the amount no longer
 * sends it to a review. Through the link their 48-hour notice carries, they pay a
 * lower amount they choose (``POST /public/pledges/claim/{token}/amount``) or cancel
 * (``POST /public/pledges/claim/{token}/cancel``), until their pledge's charge gate.
 * The path stays while the surface is dark and always answers 409
 * ``PLEDGE_OBJECTION_RETIRED``, whatever the link, reading and changing nothing.
 */
export const pledgesObjectToGuestPledgeMutation = (options?: Partial<Options<PledgesObjectToGuestPledgeData>>): UseMutationOptions<PledgesObjectToGuestPledgeResponse, PledgesObjectToGuestPledgeError, Options<PledgesObjectToGuestPledgeData>> => {
    const mutationOptions: UseMutationOptions<PledgesObjectToGuestPledgeResponse, PledgesObjectToGuestPledgeError, Options<PledgesObjectToGuestPledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesObjectToGuestPledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const profilePagesPublicGetPublicProfilePageQueryKey = (options: Options<ProfilePagesPublicGetPublicProfilePageData>) => createQueryKey('profile-pages-public-get_public_profile_page', options);

/**
 * Get Public Profile Page
 *
 * The public composition of an entity's page: ``facts`` (the catalog projection
 * — a company's bio / signed cover / website; ``null`` for the other classes),
 * the LISTED blocks in owner order (image URLs signed per request), and the
 * updates rail (empty until the Social rail lands). Anonymous for a charity, a
 * user or a group; a company page needs a signed-in caller. A suppressed or
 * nonexistent page is one constant 404.
 */
export const profilePagesPublicGetPublicProfilePageOptions = (options: Options<ProfilePagesPublicGetPublicProfilePageData>) => queryOptions<ProfilePagesPublicGetPublicProfilePageResponse, ProfilePagesPublicGetPublicProfilePageError, ProfilePagesPublicGetPublicProfilePageResponse, ReturnType<typeof profilePagesPublicGetPublicProfilePageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await profilePagesPublicGetPublicProfilePage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: profilePagesPublicGetPublicProfilePageQueryKey(options)
});

export const searchGetSearchFeedQueryKey = (options?: Options<SearchGetSearchFeedData>) => createQueryKey('search-get_search_feed', options);

/**
 * Get Search Feed
 */
export const searchGetSearchFeedOptions = (options?: Options<SearchGetSearchFeedData>) => queryOptions<SearchGetSearchFeedResponse, SearchGetSearchFeedError, SearchGetSearchFeedResponse, ReturnType<typeof searchGetSearchFeedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchGetSearchFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchGetSearchFeedQueryKey(options)
});

export const stepsCompetitionsListStepsCompetitionsQueryKey = (options?: Options<StepsCompetitionsListStepsCompetitionsData>) => createQueryKey('steps-competitions-list_steps_competitions', options);

/**
 * List Steps Competitions
 *
 * My linked company's competitions + my entry summary (§2.4). Token-permissive
 * at the route level, but a signed-in user is required to have a company scope —
 * a user linked to no company simply gets an empty page.
 */
export const stepsCompetitionsListStepsCompetitionsOptions = (options?: Options<StepsCompetitionsListStepsCompetitionsData>) => queryOptions<StepsCompetitionsListStepsCompetitionsResponse, StepsCompetitionsListStepsCompetitionsError, StepsCompetitionsListStepsCompetitionsResponse, ReturnType<typeof stepsCompetitionsListStepsCompetitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepsCompetitionsListStepsCompetitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepsCompetitionsListStepsCompetitionsQueryKey(options)
});

export const stepsCompetitionsGetStepsCompetitionQueryKey = (options: Options<StepsCompetitionsGetStepsCompetitionData>) => createQueryKey('steps-competitions-get_steps_competition', options);

/**
 * Get Steps Competition
 *
 * Detail + my entry (§2.4). Audience per the competition's visibility axis;
 * byte-identical 404 for a viewer not entitled (existence never leaked).
 */
export const stepsCompetitionsGetStepsCompetitionOptions = (options: Options<StepsCompetitionsGetStepsCompetitionData>) => queryOptions<StepsCompetitionsGetStepsCompetitionResponse, StepsCompetitionsGetStepsCompetitionError, StepsCompetitionsGetStepsCompetitionResponse, ReturnType<typeof stepsCompetitionsGetStepsCompetitionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepsCompetitionsGetStepsCompetition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepsCompetitionsGetStepsCompetitionQueryKey(options)
});

/**
 * Join Steps Competition
 *
 * Join (§1.3): ``{charity_id, visibility}`` → 201. Consent is recorded
 * server-side; one-entry-per-user → 409.
 */
export const stepsCompetitionsJoinStepsCompetitionMutation = (options?: Partial<Options<StepsCompetitionsJoinStepsCompetitionData>>): UseMutationOptions<StepsCompetitionsJoinStepsCompetitionResponse, StepsCompetitionsJoinStepsCompetitionError, Options<StepsCompetitionsJoinStepsCompetitionData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsJoinStepsCompetitionResponse, StepsCompetitionsJoinStepsCompetitionError, Options<StepsCompetitionsJoinStepsCompetitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsJoinStepsCompetition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw From Steps Competition
 *
 * Withdraw (§2.4): status → WITHDRAWN, hidden from the leaderboard
 * immediately; day data retained while the competition is live (§3.1 #5).
 */
export const stepsCompetitionsWithdrawFromStepsCompetitionMutation = (options?: Partial<Options<StepsCompetitionsWithdrawFromStepsCompetitionData>>): UseMutationOptions<StepsCompetitionsWithdrawFromStepsCompetitionResponse, StepsCompetitionsWithdrawFromStepsCompetitionError, Options<StepsCompetitionsWithdrawFromStepsCompetitionData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsWithdrawFromStepsCompetitionResponse, StepsCompetitionsWithdrawFromStepsCompetitionError, Options<StepsCompetitionsWithdrawFromStepsCompetitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsWithdrawFromStepsCompetition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update My Steps Entry
 *
 * Change charity (PUBLISHED/ACTIVE) and/or visibility (until finalize), §2.4.
 * Entry-ownership scoped (the caller's own entry only). A request with neither
 * field is a no-op that echoes the current entry.
 */
export const stepsCompetitionsUpdateMyStepsEntryMutation = (options?: Partial<Options<StepsCompetitionsUpdateMyStepsEntryData>>): UseMutationOptions<StepsCompetitionsUpdateMyStepsEntryResponse, StepsCompetitionsUpdateMyStepsEntryError, Options<StepsCompetitionsUpdateMyStepsEntryData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsUpdateMyStepsEntryResponse, StepsCompetitionsUpdateMyStepsEntryError, Options<StepsCompetitionsUpdateMyStepsEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsUpdateMyStepsEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restate My Steps
 *
 * Restate the full window (§2.5): ``[{local_date, steps}]`` →
 * ``{accepted_days, total_steps, rank}`` with per-day ``rejected`` reasons. Never
 * a whole-batch failure for a single bad day.
 */
export const stepsCompetitionsRestateMyStepsMutation = (options?: Partial<Options<StepsCompetitionsRestateMyStepsData>>): UseMutationOptions<StepsCompetitionsRestateMyStepsResponse, StepsCompetitionsRestateMyStepsError, Options<StepsCompetitionsRestateMyStepsData>> => {
    const mutationOptions: UseMutationOptions<StepsCompetitionsRestateMyStepsResponse, StepsCompetitionsRestateMyStepsError, Options<StepsCompetitionsRestateMyStepsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepsCompetitionsRestateMySteps({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stepsCompetitionsGetStepsCompetitionLeaderboardQueryKey = (options: Options<StepsCompetitionsGetStepsCompetitionLeaderboardData>) => createQueryKey('steps-competitions-get_steps_competition_leaderboard', options);

/**
 * Get Steps Competition Leaderboard
 *
 * Paginated leaderboard (§1.4/§2.4). Rows carry rank + steps; PRIVATE rows are
 * anonymized SERVER-SIDE for non-admin viewers (identity fields never leave the
 * server). ``meta`` carries ``my_rank``/``my_total`` + ``provisional``.
 */
export const stepsCompetitionsGetStepsCompetitionLeaderboardOptions = (options: Options<StepsCompetitionsGetStepsCompetitionLeaderboardData>) => queryOptions<StepsCompetitionsGetStepsCompetitionLeaderboardResponse, StepsCompetitionsGetStepsCompetitionLeaderboardError, StepsCompetitionsGetStepsCompetitionLeaderboardResponse, ReturnType<typeof stepsCompetitionsGetStepsCompetitionLeaderboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepsCompetitionsGetStepsCompetitionLeaderboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepsCompetitionsGetStepsCompetitionLeaderboardQueryKey(options)
});

/**
 * Export Gcf Accounting
 */
export const accountingExportExportGcfAccountingMutation = (options?: Partial<Options<AccountingExportExportGcfAccountingData>>): UseMutationOptions<AccountingExportExportGcfAccountingResponse, AccountingExportExportGcfAccountingError, Options<AccountingExportExportGcfAccountingData>> => {
    const mutationOptions: UseMutationOptions<AccountingExportExportGcfAccountingResponse, AccountingExportExportGcfAccountingError, Options<AccountingExportExportGcfAccountingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingExportExportGcfAccounting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assistantGetAssistantSuperadminConfigQueryKey = (options?: Options<AssistantGetAssistantSuperadminConfigData>) => createQueryKey('assistant-get_assistant_superadmin_config', options);

/**
 * Get Assistant Superadmin Config
 *
 * Read the raw stored `assistant_config` row for the edit UI (02 §C2).
 * Returns the dark defaults when no row exists yet. Super-admin only.
 */
export const assistantGetAssistantSuperadminConfigOptions = (options?: Options<AssistantGetAssistantSuperadminConfigData>) => queryOptions<AssistantGetAssistantSuperadminConfigResponse, DefaultError, AssistantGetAssistantSuperadminConfigResponse, ReturnType<typeof assistantGetAssistantSuperadminConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantGetAssistantSuperadminConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantGetAssistantSuperadminConfigQueryKey(options)
});

/**
 * Update Assistant Superadmin Config
 *
 * Partial upsert of the `assistant_config` singleton — the runtime kill
 * switch edit (02 §C2). Only the fields present in the body are applied
 * (absent = unchanged, explicit null clears); creates the row from dark
 * defaults on first write. Super-admin only.
 */
export const assistantUpdateAssistantSuperadminConfigMutation = (options?: Partial<Options<AssistantUpdateAssistantSuperadminConfigData>>): UseMutationOptions<AssistantUpdateAssistantSuperadminConfigResponse, AssistantUpdateAssistantSuperadminConfigError, Options<AssistantUpdateAssistantSuperadminConfigData>> => {
    const mutationOptions: UseMutationOptions<AssistantUpdateAssistantSuperadminConfigResponse, AssistantUpdateAssistantSuperadminConfigError, Options<AssistantUpdateAssistantSuperadminConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantUpdateAssistantSuperadminConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assistantListAssistantTurnsAdminQueryKey = (options: Options<AssistantListAssistantTurnsAdminData>) => createQueryKey('assistant-list_assistant_turns_admin', options);

/**
 * List Assistant Turns Admin
 *
 * Paginated turn list for a conversation (D6-3a), newest first. Metadata-only
 * projection (content-free). `page[limit]` hard-capped at 200 (over-cap → 422).
 * An unknown conversation id returns an empty page. Super-admin only.
 */
export const assistantListAssistantTurnsAdminOptions = (options: Options<AssistantListAssistantTurnsAdminData>) => queryOptions<AssistantListAssistantTurnsAdminResponse, AssistantListAssistantTurnsAdminError, AssistantListAssistantTurnsAdminResponse, ReturnType<typeof assistantListAssistantTurnsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantListAssistantTurnsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantListAssistantTurnsAdminQueryKey(options)
});

export const assistantListAssistantEscalationsAdminQueryKey = (options?: Options<AssistantListAssistantEscalationsAdminData>) => createQueryKey('assistant-list_assistant_escalations_admin', options);

/**
 * List Assistant Escalations Admin
 *
 * Paginated escalation list for the ops view (D6-1), newest first. Optional
 * `status` filter (an `AssistantEscalationStatus` value, or `awaiting_human` —
 * confirmed, sent or failed: the operator-queue class's predicate, SAPD-AH1;
 * off-set → 422). Each row names the requesting user (name + email) and, once
 * resolved, the resolver. `page[limit]` is hard-capped at 200 (over-cap → 422).
 * Super-admin only.
 */
export const assistantListAssistantEscalationsAdminOptions = (options?: Options<AssistantListAssistantEscalationsAdminData>) => queryOptions<AssistantListAssistantEscalationsAdminResponse, AssistantListAssistantEscalationsAdminError, AssistantListAssistantEscalationsAdminResponse, ReturnType<typeof assistantListAssistantEscalationsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantListAssistantEscalationsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantListAssistantEscalationsAdminQueryKey(options)
});

export const assistantGetAssistantEscalationAdminQueryKey = (options: Options<AssistantGetAssistantEscalationAdminData>) => createQueryKey('assistant-get_assistant_escalation_admin', options);

/**
 * Get Assistant Escalation Admin
 *
 * Single-escalation detail for the ops view (D6-1). 404 when missing.
 * Super-admin only.
 */
export const assistantGetAssistantEscalationAdminOptions = (options: Options<AssistantGetAssistantEscalationAdminData>) => queryOptions<AssistantGetAssistantEscalationAdminResponse, AssistantGetAssistantEscalationAdminError, AssistantGetAssistantEscalationAdminResponse, ReturnType<typeof assistantGetAssistantEscalationAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantGetAssistantEscalationAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantGetAssistantEscalationAdminQueryKey(options)
});

/**
 * Resolve Assistant Escalation Admin
 *
 * Mark resolved (SAPD-AH1, D-SAPD-6): the operator handled this handoff, so it
 * leaves the operator queue. Super-admin only; non-money, so NOT enrolled in the
 * money-action guard. Idempotent: an already-resolved row is a 200 no-op that keeps
 * the first resolver and time. Records who resolved it and when; sends nothing to
 * the user or anyone else. 404 when missing; 409 (`ESCALATION_NOT_CONFIRMED`) for a
 * `proposed` row the user never confirmed. Answers the escalation as the detail
 * read does, so the portal re-renders from the response.
 */
export const assistantResolveAssistantEscalationAdminMutation = (options?: Partial<Options<AssistantResolveAssistantEscalationAdminData>>): UseMutationOptions<AssistantResolveAssistantEscalationAdminResponse, AssistantResolveAssistantEscalationAdminError, Options<AssistantResolveAssistantEscalationAdminData>> => {
    const mutationOptions: UseMutationOptions<AssistantResolveAssistantEscalationAdminResponse, AssistantResolveAssistantEscalationAdminError, Options<AssistantResolveAssistantEscalationAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantResolveAssistantEscalationAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assistantListAssistantFeedbackAdminQueryKey = (options?: Options<AssistantListAssistantFeedbackAdminData>) => createQueryKey('assistant-list_assistant_feedback_admin', options);

/**
 * List Assistant Feedback Admin
 *
 * Paginated feedback/report review queue for the ops view (D6-1), newest
 * first. `rating` narrows to a single thumbs value (off-set → 422);
 * `reports_only=true` keeps only rows carrying a `report_category` (the
 * actionable AI-content reports). The two filters compose. `page[limit]` is
 * hard-capped at 200 (over-cap → 422). Super-admin only.
 */
export const assistantListAssistantFeedbackAdminOptions = (options?: Options<AssistantListAssistantFeedbackAdminData>) => queryOptions<AssistantListAssistantFeedbackAdminResponse, AssistantListAssistantFeedbackAdminError, AssistantListAssistantFeedbackAdminResponse, ReturnType<typeof assistantListAssistantFeedbackAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantListAssistantFeedbackAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantListAssistantFeedbackAdminQueryKey(options)
});

export const assistantListAssistantTurnEventsAdminQueryKey = (options: Options<AssistantListAssistantTurnEventsAdminData>) => createQueryKey('assistant-list_assistant_turn_events_admin', options);

/**
 * List Assistant Turn Events Admin
 *
 * Content-free event trace for a turn (D6-3a), ordered by `(attempt, seq)`,
 * paginated/bounded (the same bounded posture as the turn list — `page[limit]`
 * hard-capped, over-cap → 422 — so an admin read never pulls an unbounded event
 * stream). Projection drops the raw event `payload` (the message/reply text). An
 * unknown turn id returns an empty page. Super-admin only.
 */
export const assistantListAssistantTurnEventsAdminOptions = (options: Options<AssistantListAssistantTurnEventsAdminData>) => queryOptions<AssistantListAssistantTurnEventsAdminResponse, AssistantListAssistantTurnEventsAdminError, AssistantListAssistantTurnEventsAdminResponse, ReturnType<typeof assistantListAssistantTurnEventsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantListAssistantTurnEventsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantListAssistantTurnEventsAdminQueryKey(options)
});

export const assistantListAssistantTurnToolCallsAdminQueryKey = (options: Options<AssistantListAssistantTurnToolCallsAdminData>) => createQueryKey('assistant-list_assistant_turn_tool_calls_admin', options);

/**
 * List Assistant Turn Tool Calls Admin
 *
 * Content-free tool-call trace for a turn (D6-3a), oldest first,
 * paginated/bounded (`page[limit]` hard-capped, over-cap → 422). Projection omits
 * the raw tool `input`; `result_digest` is the upstream-redacted structural digest.
 * An unknown turn id returns an empty page. Super-admin only.
 */
export const assistantListAssistantTurnToolCallsAdminOptions = (options: Options<AssistantListAssistantTurnToolCallsAdminData>) => queryOptions<AssistantListAssistantTurnToolCallsAdminResponse, AssistantListAssistantTurnToolCallsAdminError, AssistantListAssistantTurnToolCallsAdminResponse, ReturnType<typeof assistantListAssistantTurnToolCallsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantListAssistantTurnToolCallsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantListAssistantTurnToolCallsAdminQueryKey(options)
});

export const assistantGetAssistantUsageAdminQueryKey = (options?: Options<AssistantGetAssistantUsageAdminData>) => createQueryKey('assistant-get_assistant_usage_admin', options);

/**
 * Get Assistant Usage Admin
 *
 * ORG usage/spend per day over `[start, end]` (D6-4a), ascending — one row per
 * day that has usage (sparse). `start`/`end` are `YYYY-MM-DD`; both omitted →
 * last 30 days (ET). `start>end` or a span over the cap → 422. Includes a range
 * `summary` (each metric summed over the window). Super-admin only.
 */
export const assistantGetAssistantUsageAdminOptions = (options?: Options<AssistantGetAssistantUsageAdminData>) => queryOptions<AssistantGetAssistantUsageAdminResponse, AssistantGetAssistantUsageAdminError, AssistantGetAssistantUsageAdminResponse, ReturnType<typeof assistantGetAssistantUsageAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantGetAssistantUsageAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantGetAssistantUsageAdminQueryKey(options)
});

export const assistantGetAssistantUsageAdminInfiniteQueryKey = (options?: Options<AssistantGetAssistantUsageAdminData>): QueryKey<Options<AssistantGetAssistantUsageAdminData>> => createQueryKey('assistant-get_assistant_usage_admin', options, true);

/**
 * Get Assistant Usage Admin
 *
 * ORG usage/spend per day over `[start, end]` (D6-4a), ascending — one row per
 * day that has usage (sparse). `start`/`end` are `YYYY-MM-DD`; both omitted →
 * last 30 days (ET). `start>end` or a span over the cap → 422. Includes a range
 * `summary` (each metric summed over the window). Super-admin only.
 */
export const assistantGetAssistantUsageAdminInfiniteOptions = (options?: Options<AssistantGetAssistantUsageAdminData>) => {
    const opts = infiniteQueryOptions<AssistantGetAssistantUsageAdminResponse, AssistantGetAssistantUsageAdminError, InfiniteData<AssistantGetAssistantUsageAdminResponse>, QueryKey<Options<AssistantGetAssistantUsageAdminData>>, string | null | Pick<QueryKey<Options<AssistantGetAssistantUsageAdminData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AssistantGetAssistantUsageAdminData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await assistantGetAssistantUsageAdmin({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assistantGetAssistantUsageAdminInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const superAdminChampionOpsListChampionsQueryKey = (options?: Options<SuperAdminChampionOpsListChampionsData>) => createQueryKey('super-admin-champion-ops-list_champions', options);

/**
 * List Champions
 *
 * The super-admin champion list — newest first, optionally filtered by
 * ``owner_type``, each row carrying its current live handle and the target the
 * link is CONFIGURED to point at. Paginated.
 */
export const superAdminChampionOpsListChampionsOptions = (options?: Options<SuperAdminChampionOpsListChampionsData>) => queryOptions<SuperAdminChampionOpsListChampionsResponse, SuperAdminChampionOpsListChampionsError, SuperAdminChampionOpsListChampionsResponse, ReturnType<typeof superAdminChampionOpsListChampionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminChampionOpsListChampions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminChampionOpsListChampionsQueryKey(options)
});

export const superAdminChampionOpsListChampionsInfiniteQueryKey = (options?: Options<SuperAdminChampionOpsListChampionsData>): QueryKey<Options<SuperAdminChampionOpsListChampionsData>> => createQueryKey('super-admin-champion-ops-list_champions', options, true);

/**
 * List Champions
 *
 * The super-admin champion list — newest first, optionally filtered by
 * ``owner_type``, each row carrying its current live handle and the target the
 * link is CONFIGURED to point at. Paginated.
 */
export const superAdminChampionOpsListChampionsInfiniteOptions = (options?: Options<SuperAdminChampionOpsListChampionsData>) => {
    const opts = infiniteQueryOptions<SuperAdminChampionOpsListChampionsResponse, SuperAdminChampionOpsListChampionsError, InfiniteData<SuperAdminChampionOpsListChampionsResponse>, QueryKey<Options<SuperAdminChampionOpsListChampionsData>>, number | Pick<QueryKey<Options<SuperAdminChampionOpsListChampionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SuperAdminChampionOpsListChampionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await superAdminChampionOpsListChampions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: superAdminChampionOpsListChampionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const superAdminChampionOpsInspectChampionByHandleQueryKey = (options: Options<SuperAdminChampionOpsInspectChampionByHandleData>) => createQueryKey('super-admin-champion-ops-inspect_champion_by_handle', options);

/**
 * Inspect Champion By Handle
 *
 * Inspect the champion that owns ``handle`` (normalized on the way in — a
 * mixed-case/whitespace handle still resolves the stored lowercase row), matching
 * the whole handle history so a retired or disabled handle still inspects. 404
 * when the handle is unknown or its owning champion is gone.
 */
export const superAdminChampionOpsInspectChampionByHandleOptions = (options: Options<SuperAdminChampionOpsInspectChampionByHandleData>) => queryOptions<SuperAdminChampionOpsInspectChampionByHandleResponse, SuperAdminChampionOpsInspectChampionByHandleError, SuperAdminChampionOpsInspectChampionByHandleResponse, ReturnType<typeof superAdminChampionOpsInspectChampionByHandleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminChampionOpsInspectChampionByHandle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminChampionOpsInspectChampionByHandleQueryKey(options)
});

/**
 * Reclaim Champion Handle
 *
 * DISABLE (reclaim) an abusive/squatted handle — the core SA1 anti-abuse
 * lever. Reclaim sets ``disabled_at`` + clears ``is_current`` (D-CQ-10:
 * reclaim = disable, never-recycle, NOT freed — the string is not returned to the
 * open pool), so a printed QR for that handle falls through to the safe fallback
 * landing rather than the abuser's target; printed media never dead-ends.
 * Reuses ``ChampionService.reclaim_handle``, which NORMALIZES the handle (so
 * ``"RedCross"`` / ``" redcross "`` reclaim the stored ``redcross`` row) and is
 * IDEMPOTENT (re-reclaiming a disabled handle is a no-op). A handle-not-found is
 * a uniform 404. Returns the reclaimed handle row's state.
 */
export const superAdminChampionOpsReclaimChampionHandleMutation = (options?: Partial<Options<SuperAdminChampionOpsReclaimChampionHandleData>>): UseMutationOptions<SuperAdminChampionOpsReclaimChampionHandleResponse, SuperAdminChampionOpsReclaimChampionHandleError, Options<SuperAdminChampionOpsReclaimChampionHandleData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminChampionOpsReclaimChampionHandleResponse, SuperAdminChampionOpsReclaimChampionHandleError, Options<SuperAdminChampionOpsReclaimChampionHandleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminChampionOpsReclaimChampionHandle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * File Champion Report
 *
 * Record an out-of-band champion abuse complaint (impersonation, squatting, a
 * takedown demand) against a handle and/or champion.
 *
 * The record lands on the CROSS-SURFACE ``content_report`` aggregate, not a
 * champion-private table (the UGC-BE1/BE2 mandated-adoption contract), so it
 * inherits the shared ``pending → reviewing → actioned → dismissed`` lifecycle
 * and appears in ``GET /super-admin/content-reports`` alongside every other
 * reported surface with no extra wiring. Filing DISABLES NOTHING — the
 * anti-abuse lever is the reclaim route below.
 *
 * NB the ``report_count``/``last_reported_at`` fields on the CREATE response are
 * aggregate-read transients stamped only by the queue read — this response
 * always says ``report_count: 1`` even for a champion's third report. Read
 * ``GET /super-admin/content-reports`` for the true aggregate.
 */
export const superAdminChampionOpsFileChampionReportMutation = (options?: Partial<Options<SuperAdminChampionOpsFileChampionReportData>>): UseMutationOptions<SuperAdminChampionOpsFileChampionReportResponse, SuperAdminChampionOpsFileChampionReportError, Options<SuperAdminChampionOpsFileChampionReportData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminChampionOpsFileChampionReportResponse, SuperAdminChampionOpsFileChampionReportError, Options<SuperAdminChampionOpsFileChampionReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminChampionOpsFileChampionReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminChampionOpsInspectChampionQueryKey = (options: Options<SuperAdminChampionOpsInspectChampionData>) => createQueryKey('super-admin-champion-ops-inspect_champion', options);

/**
 * Inspect Champion
 *
 * One champion's full inspect view: identity + owner + configured target + the
 * ENTIRE handle history (current, retired, disabled). 404 when the champion does
 * not exist.
 */
export const superAdminChampionOpsInspectChampionOptions = (options: Options<SuperAdminChampionOpsInspectChampionData>) => queryOptions<SuperAdminChampionOpsInspectChampionResponse, SuperAdminChampionOpsInspectChampionError, SuperAdminChampionOpsInspectChampionResponse, ReturnType<typeof superAdminChampionOpsInspectChampionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminChampionOpsInspectChampion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminChampionOpsInspectChampionQueryKey(options)
});

export const charitiesGetCharityDomainCoverageQueryKey = (options?: Options<CharitiesGetCharityDomainCoverageData>) => createQueryKey('charities-get_charity_domain_coverage', options);

/**
 * Get Charity Domain Coverage
 *
 * Superadmin observability: how many charities have organization_domain
 * populated (total + ACTIVE) — distinguishes a 'lookup column empty' state from
 * 'healthy but sparsely populated' as the enrichment import fills domains in.
 */
export const charitiesGetCharityDomainCoverageOptions = (options?: Options<CharitiesGetCharityDomainCoverageData>) => queryOptions<CharitiesGetCharityDomainCoverageResponse, DefaultError, CharitiesGetCharityDomainCoverageResponse, ReturnType<typeof charitiesGetCharityDomainCoverageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charitiesGetCharityDomainCoverage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charitiesGetCharityDomainCoverageQueryKey(options)
});

/**
 * End Charity Display Name
 *
 * End a charity's live display name (``ended_by_operator``) and withdraw a request
 * waiting for review; ``charity.name`` returns to the catalog name. The ``reason`` is kept
 * on the ended row and never shown to the charity. Idempotent. Served whatever
 * ``CHARITY_DISPLAY_NAME_ENABLED`` says. A super-admin's own ``PUT /charities/{id}``
 * refuses a name change while a display name is live: end it here first.
 */
export const superAdminCharityDisplayNamesEndCharityDisplayNameMutation = (options?: Partial<Options<SuperAdminCharityDisplayNamesEndCharityDisplayNameData>>): UseMutationOptions<SuperAdminCharityDisplayNamesEndCharityDisplayNameResponse, SuperAdminCharityDisplayNamesEndCharityDisplayNameError, Options<SuperAdminCharityDisplayNamesEndCharityDisplayNameData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityDisplayNamesEndCharityDisplayNameResponse, SuperAdminCharityDisplayNamesEndCharityDisplayNameError, Options<SuperAdminCharityDisplayNamesEndCharityDisplayNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityDisplayNamesEndCharityDisplayName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminPlatformGrantFactsGetPlatformGrantFactsQueryKey = (options: Options<SuperAdminPlatformGrantFactsGetPlatformGrantFactsData>) => createQueryKey('super-admin-platform-grant-facts-get_platform_grant_facts', options);

/**
 * Get Platform Grant Facts
 */
export const superAdminPlatformGrantFactsGetPlatformGrantFactsOptions = (options: Options<SuperAdminPlatformGrantFactsGetPlatformGrantFactsData>) => queryOptions<SuperAdminPlatformGrantFactsGetPlatformGrantFactsResponse, SuperAdminPlatformGrantFactsGetPlatformGrantFactsError, SuperAdminPlatformGrantFactsGetPlatformGrantFactsResponse, ReturnType<typeof superAdminPlatformGrantFactsGetPlatformGrantFactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminPlatformGrantFactsGetPlatformGrantFacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminPlatformGrantFactsGetPlatformGrantFactsQueryKey(options)
});

export const superAdminCharityClaimsListPendingCharityClaimsQueryKey = (options?: Options<SuperAdminCharityClaimsListPendingCharityClaimsData>) => createQueryKey('super-admin-charity-claims-list_pending_charity_claims', options);

/**
 * List Pending Charity Claims
 *
 * The Charity Claims list, newest first, with the claimant + charity identity,
 * submission age (the 1–3-day SLA), and an evidence count. By default the Tier-2
 * review queue: every PENDING_REVIEW claim. CPA-SA4: ``?status=APPROVED|REJECTED``
 * lists the decided claims in that status, ``?status=ALL`` every claim, and
 * ``?tier=TIER_1|TIER_2`` narrows to one tier (APPROVED + TIER_1 is the
 * auto-verified claims, APPROVED + TIER_2 the ones a reviewer approved). A decided
 * view is capped, keeping the newest claims, and sets ``truncated`` when it held
 * more than it returns; the queue is never capped. A decided row carries
 * ``resolved_at`` and reads ``is_takeover`` False.
 */
export const superAdminCharityClaimsListPendingCharityClaimsOptions = (options?: Options<SuperAdminCharityClaimsListPendingCharityClaimsData>) => queryOptions<SuperAdminCharityClaimsListPendingCharityClaimsResponse, SuperAdminCharityClaimsListPendingCharityClaimsError, SuperAdminCharityClaimsListPendingCharityClaimsResponse, ReturnType<typeof superAdminCharityClaimsListPendingCharityClaimsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityClaimsListPendingCharityClaims({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityClaimsListPendingCharityClaimsQueryKey(options)
});

export const superAdminCharityClaimsGetCharityClaimDetailQueryKey = (options: Options<SuperAdminCharityClaimsGetCharityClaimDetailData>) => createQueryKey('super-admin-charity-claims-get_charity_claim_detail', options);

/**
 * Get Charity Claim Detail
 *
 * One claim's review detail, including SHORT-LIVED signed READ URLs for its
 * uploaded verification documents. The read URLs are minted per-request and
 * never persisted.
 */
export const superAdminCharityClaimsGetCharityClaimDetailOptions = (options: Options<SuperAdminCharityClaimsGetCharityClaimDetailData>) => queryOptions<SuperAdminCharityClaimsGetCharityClaimDetailResponse, SuperAdminCharityClaimsGetCharityClaimDetailError, SuperAdminCharityClaimsGetCharityClaimDetailResponse, ReturnType<typeof superAdminCharityClaimsGetCharityClaimDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityClaimsGetCharityClaimDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityClaimsGetCharityClaimDetailQueryKey(options)
});

/**
 * Approve Charity Claim
 *
 * APPROVE a pending claim → reuse slice-1's ``approve_claim``: write the
 * ``charity_claim`` overlay CLAIMED (NEVER CONSENTED — D-CP-8) + an Owner
 * membership for the claimant + audit, atomically. Returns the APPROVED
 * request.
 */
export const superAdminCharityClaimsApproveCharityClaimMutation = (options?: Partial<Options<SuperAdminCharityClaimsApproveCharityClaimData>>): UseMutationOptions<SuperAdminCharityClaimsApproveCharityClaimResponse, SuperAdminCharityClaimsApproveCharityClaimError, Options<SuperAdminCharityClaimsApproveCharityClaimData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityClaimsApproveCharityClaimResponse, SuperAdminCharityClaimsApproveCharityClaimError, Options<SuperAdminCharityClaimsApproveCharityClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityClaimsApproveCharityClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Charity Claim Transfer
 *
 * APPROVE-WITH-OWNERSHIP-TRANSFER — the DELIBERATE takeover adjudication for
 * an already-claimed charity: install the claimant as the new Owner AND
 * atomically REVOKE the prior Owner membership(s), fully audited (who removed,
 * who added, reviewer). Distinct from the ordinary approve (which never removes
 * an existing Owner). Atomic: the new Owner is installed before the old ones are
 * removed, so the charity is never left with zero Owners. Still writes CLAIMED,
 * NEVER CONSENTED (D-CP-8). Returns the APPROVED request.
 */
export const superAdminCharityClaimsApproveCharityClaimTransferMutation = (options?: Partial<Options<SuperAdminCharityClaimsApproveCharityClaimTransferData>>): UseMutationOptions<SuperAdminCharityClaimsApproveCharityClaimTransferResponse, SuperAdminCharityClaimsApproveCharityClaimTransferError, Options<SuperAdminCharityClaimsApproveCharityClaimTransferData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityClaimsApproveCharityClaimTransferResponse, SuperAdminCharityClaimsApproveCharityClaimTransferError, Options<SuperAdminCharityClaimsApproveCharityClaimTransferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityClaimsApproveCharityClaimTransfer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Charity Claim
 *
 * REJECT a pending claim with a required reason → status REJECTED + audit.
 * NEVER writes a ``charity_claim`` overlay row and NEVER creates a membership —
 * a rejected claim confers no access.
 */
export const superAdminCharityClaimsRejectCharityClaimMutation = (options?: Partial<Options<SuperAdminCharityClaimsRejectCharityClaimData>>): UseMutationOptions<SuperAdminCharityClaimsRejectCharityClaimResponse, SuperAdminCharityClaimsRejectCharityClaimError, Options<SuperAdminCharityClaimsRejectCharityClaimData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityClaimsRejectCharityClaimResponse, SuperAdminCharityClaimsRejectCharityClaimError, Options<SuperAdminCharityClaimsRejectCharityClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityClaimsRejectCharityClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityCollectionsGetSuperAdminRecentCollectionsQueryKey = (options?: Options<CharityCollectionsGetSuperAdminRecentCollectionsData>) => createQueryKey('charity-collections-get_super_admin_recent_collections', options);

/**
 * Get Super Admin Recent Collections
 *
 * Super-admin moderation list (CC-BE6): recent collections newest-first,
 * INCLUDING super-admin-unlisted ones (with the `unlisted_at`/
 * `unlisted_by_user_id`/`unlisted_reason` audit fields) so an admin can review
 * the surface and unlist/relist.
 *
 * `q` is a case-insensitive substring match across the collection name, owner
 * (creator) name, collection id, and any member-charity name, applied
 * server-side (with `page[limit]`/`page[offset]`) so the moderation client can
 * search + page the whole corpus instead of loading everything and searching
 * in-memory.
 */
export const charityCollectionsGetSuperAdminRecentCollectionsOptions = (options?: Options<CharityCollectionsGetSuperAdminRecentCollectionsData>) => queryOptions<CharityCollectionsGetSuperAdminRecentCollectionsResponse, CharityCollectionsGetSuperAdminRecentCollectionsError, CharityCollectionsGetSuperAdminRecentCollectionsResponse, ReturnType<typeof charityCollectionsGetSuperAdminRecentCollectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityCollectionsGetSuperAdminRecentCollections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityCollectionsGetSuperAdminRecentCollectionsQueryKey(options)
});

/**
 * Relist Charity Collection
 *
 * Super-admin relist (CC-BE6): clear the moderation trio so a previously
 * unlisted collection is served/discoverable/donatable again.
 */
export const charityCollectionsRelistCharityCollectionMutation = (options?: Partial<Options<CharityCollectionsRelistCharityCollectionData>>): UseMutationOptions<CharityCollectionsRelistCharityCollectionResponse, CharityCollectionsRelistCharityCollectionError, Options<CharityCollectionsRelistCharityCollectionData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsRelistCharityCollectionResponse, CharityCollectionsRelistCharityCollectionError, Options<CharityCollectionsRelistCharityCollectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsRelistCharityCollection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlist Charity Collection
 *
 * Super-admin unlist (CC-BE6): drop a collection from every consumer/
 * discovery read and hard-block new gifts. Idempotent. Never touches a settled
 * donation. An OPTIONAL `{"reason": "..."}` body stamps the audit
 * `unlisted_reason`; a request with no body still unlists with `reason=None`
 * (backward-compatible).
 */
export const charityCollectionsUnlistCharityCollectionMutation = (options?: Partial<Options<CharityCollectionsUnlistCharityCollectionData>>): UseMutationOptions<CharityCollectionsUnlistCharityCollectionResponse, CharityCollectionsUnlistCharityCollectionError, Options<CharityCollectionsUnlistCharityCollectionData>> => {
    const mutationOptions: UseMutationOptions<CharityCollectionsUnlistCharityCollectionResponse, CharityCollectionsUnlistCharityCollectionError, Options<CharityCollectionsUnlistCharityCollectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityCollectionsUnlistCharityCollection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminCharityConsentOpsListCharityConsentStatesQueryKey = (options?: Options<SuperAdminCharityConsentOpsListCharityConsentStatesData>) => createQueryKey('super-admin-charity-consent-ops-list_charity_consent_states', options);

/**
 * List Charity Consent States
 *
 * The consent-state list — every claimed charity + its overlay consent state,
 * newest first, paginated (``page[limit]``/``page[offset]``). Optionally narrow to
 * one state with ``?consent_status=CLAIMED|CONSENTED|REMOVED``. A compliance-ops
 * view of who has / hasn't signed the §318(a) Terms; consent is read VERBATIM off
 * the overlay.
 *
 * ``q`` is a case-insensitive substring match across the charity name, charity
 * id, claimant email, and claimant user id, applied server-side (composing with
 * ``consent_status``) so the client can search + page the whole corpus instead
 * of loading everything and searching in-memory.
 */
export const superAdminCharityConsentOpsListCharityConsentStatesOptions = (options?: Options<SuperAdminCharityConsentOpsListCharityConsentStatesData>) => queryOptions<SuperAdminCharityConsentOpsListCharityConsentStatesResponse, SuperAdminCharityConsentOpsListCharityConsentStatesError, SuperAdminCharityConsentOpsListCharityConsentStatesResponse, ReturnType<typeof superAdminCharityConsentOpsListCharityConsentStatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityConsentOpsListCharityConsentStates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityConsentOpsListCharityConsentStatesQueryKey(options)
});

export const superAdminCharityConsentOpsGetClaimVelocityReportQueryKey = (options?: Options<SuperAdminCharityConsentOpsGetClaimVelocityReportData>) => createQueryKey('super-admin-charity-consent-ops-get_claim_velocity_report', options);

/**
 * Get Claim Velocity Report
 *
 * The global rolling 1-hour / 24-hour claim-velocity report, grouped by EIN,
 * claimant email domain, and audited client IP. Counts and alert booleans are
 * read-only operator signals; this endpoint never changes claim admission.
 */
export const superAdminCharityConsentOpsGetClaimVelocityReportOptions = (options?: Options<SuperAdminCharityConsentOpsGetClaimVelocityReportData>) => queryOptions<SuperAdminCharityConsentOpsGetClaimVelocityReportResponse, DefaultError, SuperAdminCharityConsentOpsGetClaimVelocityReportResponse, ReturnType<typeof superAdminCharityConsentOpsGetClaimVelocityReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityConsentOpsGetClaimVelocityReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityConsentOpsGetClaimVelocityReportQueryKey(options)
});

export const superAdminCharityConsentOpsGetCharityAuditTrailQueryKey = (options: Options<SuperAdminCharityConsentOpsGetCharityAuditTrailData>) => createQueryKey('super-admin-charity-consent-ops-get_charity_audit_trail', options);

/**
 * Get Charity Audit Trail
 *
 * The merged claim + removal audit trail for one charity, oldest event first —
 * every ``charity_claim_event`` (CPA-BE2) and ``charity_removal_event`` (CPA-BE4)
 * transition for the charity, each tagged with its ``kind``, actor, timestamp, and
 * from/to status. A charity with no claim/removal history returns an empty trail.
 */
export const superAdminCharityConsentOpsGetCharityAuditTrailOptions = (options: Options<SuperAdminCharityConsentOpsGetCharityAuditTrailData>) => queryOptions<SuperAdminCharityConsentOpsGetCharityAuditTrailResponse, SuperAdminCharityConsentOpsGetCharityAuditTrailError, SuperAdminCharityConsentOpsGetCharityAuditTrailResponse, ReturnType<typeof superAdminCharityConsentOpsGetCharityAuditTrailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityConsentOpsGetCharityAuditTrail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityConsentOpsGetCharityAuditTrailQueryKey(options)
});

export const superAdminCharityDisplayNamesListCharityDisplayNamesQueryKey = (options?: Options<SuperAdminCharityDisplayNamesListCharityDisplayNamesData>) => createQueryKey('super-admin-charity-display-names-list_charity_display_names', options);

/**
 * List Charity Display Names
 *
 * Display-name rows newest first, narrowed by ``status`` (``pending_review`` is the
 * review queue) and ``charity_id`` (one charity's history), with the exact total. Each
 * row carries the request, what the look-alike check said (``check_detail``: the rules
 * that fired, the names and EINs they matched, and a chapter network's entry with the
 * website to check membership at), the decision, and the charity's three names.
 */
export const superAdminCharityDisplayNamesListCharityDisplayNamesOptions = (options?: Options<SuperAdminCharityDisplayNamesListCharityDisplayNamesData>) => queryOptions<SuperAdminCharityDisplayNamesListCharityDisplayNamesResponse, SuperAdminCharityDisplayNamesListCharityDisplayNamesError, SuperAdminCharityDisplayNamesListCharityDisplayNamesResponse, ReturnType<typeof superAdminCharityDisplayNamesListCharityDisplayNamesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityDisplayNamesListCharityDisplayNames({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityDisplayNamesListCharityDisplayNamesQueryKey(options)
});

/**
 * Approve Charity Display Name
 *
 * Approve a held display name: it goes live as a clear one would. 409
 * ``CHARITY_DISPLAY_NAME_NOT_AVAILABLE`` when the request is no longer pending, when the
 * charity can no longer carry a display name (the request is withdrawn), or when the
 * check now refuses the name (the request stays pending: reject it with a note). Dark
 * behind ``CHARITY_DISPLAY_NAME_ENABLED`` (the absent-route 404).
 */
export const superAdminCharityDisplayNamesApproveCharityDisplayNameMutation = (options?: Partial<Options<SuperAdminCharityDisplayNamesApproveCharityDisplayNameData>>): UseMutationOptions<SuperAdminCharityDisplayNamesApproveCharityDisplayNameResponse, SuperAdminCharityDisplayNamesApproveCharityDisplayNameError, Options<SuperAdminCharityDisplayNamesApproveCharityDisplayNameData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityDisplayNamesApproveCharityDisplayNameResponse, SuperAdminCharityDisplayNamesApproveCharityDisplayNameError, Options<SuperAdminCharityDisplayNamesApproveCharityDisplayNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityDisplayNamesApproveCharityDisplayName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Charity Display Name
 *
 * Reject a held display name with a ``note`` the charity reads in its console. 409
 * ``CHARITY_DISPLAY_NAME_NOT_AVAILABLE`` when the request is no longer pending.
 */
export const superAdminCharityDisplayNamesRejectCharityDisplayNameMutation = (options?: Partial<Options<SuperAdminCharityDisplayNamesRejectCharityDisplayNameData>>): UseMutationOptions<SuperAdminCharityDisplayNamesRejectCharityDisplayNameResponse, SuperAdminCharityDisplayNamesRejectCharityDisplayNameError, Options<SuperAdminCharityDisplayNamesRejectCharityDisplayNameData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityDisplayNamesRejectCharityDisplayNameResponse, SuperAdminCharityDisplayNamesRejectCharityDisplayNameError, Options<SuperAdminCharityDisplayNamesRejectCharityDisplayNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityDisplayNamesRejectCharityDisplayName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminCharityInstantClaimListCharityInstantClaimAllowancesQueryKey = (options?: Options<SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesData>) => createQueryKey('super-admin-charity-instant-claim-list_charity_instant_claim_allowances', options);

/**
 * List Charity Instant Claim Allowances
 *
 * One charity's instant-claim allowances, newest first, live and revoked; with no
 * ``charity_id``, every live allowance across charities, newest first. Each says whether
 * it is in effect: live, and vetted for the website on file now.
 */
export const superAdminCharityInstantClaimListCharityInstantClaimAllowancesOptions = (options?: Options<SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesData>) => queryOptions<SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesResponse, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesError, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesResponse, ReturnType<typeof superAdminCharityInstantClaimListCharityInstantClaimAllowancesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityInstantClaimListCharityInstantClaimAllowances({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityInstantClaimListCharityInstantClaimAllowancesQueryKey(options)
});

/**
 * Allow Charity Instant Claim
 *
 * Allow instant claim for a charity after vetting its website: a verified email at
 * that website then becomes the charity's Owner on claiming, with no review. The
 * ``domain`` must be the charity's website on file (409 otherwise, and 409 for a charity
 * with no website or that is not active); an allowance already in effect is returned
 * unchanged. Returns the allowance.
 */
export const superAdminCharityInstantClaimAllowCharityInstantClaimMutation = (options?: Partial<Options<SuperAdminCharityInstantClaimAllowCharityInstantClaimData>>): UseMutationOptions<SuperAdminCharityInstantClaimAllowCharityInstantClaimResponse, SuperAdminCharityInstantClaimAllowCharityInstantClaimError, Options<SuperAdminCharityInstantClaimAllowCharityInstantClaimData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityInstantClaimAllowCharityInstantClaimResponse, SuperAdminCharityInstantClaimAllowCharityInstantClaimError, Options<SuperAdminCharityInstantClaimAllowCharityInstantClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityInstantClaimAllowCharityInstantClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Charity Instant Claim
 *
 * Revoke instant claim for the allowance's charity, with the reason: its claims go
 * to review again. Claims already approved are untouched. 409 when it was already
 * revoked. Returns the revoked allowance.
 */
export const superAdminCharityInstantClaimRevokeCharityInstantClaimMutation = (options?: Partial<Options<SuperAdminCharityInstantClaimRevokeCharityInstantClaimData>>): UseMutationOptions<SuperAdminCharityInstantClaimRevokeCharityInstantClaimResponse, SuperAdminCharityInstantClaimRevokeCharityInstantClaimError, Options<SuperAdminCharityInstantClaimRevokeCharityInstantClaimData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityInstantClaimRevokeCharityInstantClaimResponse, SuperAdminCharityInstantClaimRevokeCharityInstantClaimError, Options<SuperAdminCharityInstantClaimRevokeCharityInstantClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityInstantClaimRevokeCharityInstantClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminCharityOnboardingTestGetCharityOnboardingTestQueryKey = (options?: Options<SuperAdminCharityOnboardingTestGetCharityOnboardingTestData>) => createQueryKey('super-admin-charity-onboarding-test-get_charity_onboarding_test', options);

/**
 * Get Charity Onboarding Test
 */
export const superAdminCharityOnboardingTestGetCharityOnboardingTestOptions = (options?: Options<SuperAdminCharityOnboardingTestGetCharityOnboardingTestData>) => queryOptions<SuperAdminCharityOnboardingTestGetCharityOnboardingTestResponse, DefaultError, SuperAdminCharityOnboardingTestGetCharityOnboardingTestResponse, ReturnType<typeof superAdminCharityOnboardingTestGetCharityOnboardingTestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityOnboardingTestGetCharityOnboardingTest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityOnboardingTestGetCharityOnboardingTestQueryKey(options)
});

/**
 * Reset Charity Onboarding Test
 */
export const superAdminCharityOnboardingTestResetCharityOnboardingTestMutation = (options?: Partial<Options<SuperAdminCharityOnboardingTestResetCharityOnboardingTestData>>): UseMutationOptions<SuperAdminCharityOnboardingTestResetCharityOnboardingTestResponse, SuperAdminCharityOnboardingTestResetCharityOnboardingTestError, Options<SuperAdminCharityOnboardingTestResetCharityOnboardingTestData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityOnboardingTestResetCharityOnboardingTestResponse, SuperAdminCharityOnboardingTestResetCharityOnboardingTestError, Options<SuperAdminCharityOnboardingTestResetCharityOnboardingTestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityOnboardingTestResetCharityOnboardingTest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminCharityPayeeFlagsListCharityPayeeFlagsQueryKey = (options?: Options<SuperAdminCharityPayeeFlagsListCharityPayeeFlagsData>) => createQueryKey('super-admin-charity-payee-flags-list_charity_payee_flags', options);

/**
 * List Charity Payee Flags
 *
 * The OPEN payee-flag queue — every unresolved anomaly (name mismatch / screening
 * / ineligible / ambiguous EIN), oldest first (FIFO), with the charity identity, the
 * vault-MASKED payment context, and the current binding status.
 */
export const superAdminCharityPayeeFlagsListCharityPayeeFlagsOptions = (options?: Options<SuperAdminCharityPayeeFlagsListCharityPayeeFlagsData>) => queryOptions<SuperAdminCharityPayeeFlagsListCharityPayeeFlagsResponse, DefaultError, SuperAdminCharityPayeeFlagsListCharityPayeeFlagsResponse, ReturnType<typeof superAdminCharityPayeeFlagsListCharityPayeeFlagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityPayeeFlagsListCharityPayeeFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityPayeeFlagsListCharityPayeeFlagsQueryKey(options)
});

export const superAdminCharityPayeeFlagsGetCharityPayeeFlagDetailQueryKey = (options: Options<SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailData>) => createQueryKey('super-admin-charity-payee-flags-get_charity_payee_flag_detail', options);

/**
 * Get Charity Payee Flag Detail
 *
 * One payee flag's full detail (queue-row fields + resolution fields).
 */
export const superAdminCharityPayeeFlagsGetCharityPayeeFlagDetailOptions = (options: Options<SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailData>) => queryOptions<SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailResponse, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailError, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailResponse, ReturnType<typeof superAdminCharityPayeeFlagsGetCharityPayeeFlagDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityPayeeFlagsGetCharityPayeeFlagDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityPayeeFlagsGetCharityPayeeFlagDetailQueryKey(options)
});

/**
 * Approve Charity Payee Flag
 *
 * APPROVE a flagged payee (D-CP-19): record the human clearance, then re-evaluate
 * the deterministic floor with ONLY that reason cleared — a bind follows IFF every
 * OTHER conjunct still passes. Only a NAME_MISMATCH flag is approvable (else 400); a
 * missing flag 404s; an already-resolved flag 400s. The response's ``bind_outcome``
 * reports BOUND / STILL_BLOCKED / PENDING / GATE_OFF.
 */
export const superAdminCharityPayeeFlagsApproveCharityPayeeFlagMutation = (options?: Partial<Options<SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagData>>): UseMutationOptions<SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagResponse, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagError, Options<SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagResponse, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagError, Options<SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityPayeeFlagsApproveCharityPayeeFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Charity Payee Flag
 *
 * REJECT a flagged payee with a required reason → RESOLVED/REJECTED + audit; NO
 * bind. A missing flag 404s; an already-resolved flag 400s.
 */
export const superAdminCharityPayeeFlagsRejectCharityPayeeFlagMutation = (options?: Partial<Options<SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagData>>): UseMutationOptions<SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagResponse, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagError, Options<SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagResponse, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagError, Options<SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityPayeeFlagsRejectCharityPayeeFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminCharityRemovalsListCharityRemovalQueueQueryKey = (options?: Options<SuperAdminCharityRemovalsListCharityRemovalQueueData>) => createQueryKey('super-admin-charity-removals-list_charity_removal_queue', options);

/**
 * List Charity Removal Queue
 *
 * The OPEN removal queue — every REQUESTED / IDENTITY_VERIFIED removal request,
 * oldest first (most SLA-pressured), with the requester + charity identity and the
 * SLA timers (age / deadlines / past-due).
 */
export const superAdminCharityRemovalsListCharityRemovalQueueOptions = (options?: Options<SuperAdminCharityRemovalsListCharityRemovalQueueData>) => queryOptions<SuperAdminCharityRemovalsListCharityRemovalQueueResponse, DefaultError, SuperAdminCharityRemovalsListCharityRemovalQueueResponse, ReturnType<typeof superAdminCharityRemovalsListCharityRemovalQueueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityRemovalsListCharityRemovalQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityRemovalsListCharityRemovalQueueQueryKey(options)
});

export const superAdminCharityRemovalsGetCharityRemovalDetailQueryKey = (options: Options<SuperAdminCharityRemovalsGetCharityRemovalDetailData>) => createQueryKey('super-admin-charity-removals-get_charity_removal_detail', options);

/**
 * Get Charity Removal Detail
 *
 * One removal request's full detail (queue-row fields + resolution fields).
 */
export const superAdminCharityRemovalsGetCharityRemovalDetailOptions = (options: Options<SuperAdminCharityRemovalsGetCharityRemovalDetailData>) => queryOptions<SuperAdminCharityRemovalsGetCharityRemovalDetailResponse, SuperAdminCharityRemovalsGetCharityRemovalDetailError, SuperAdminCharityRemovalsGetCharityRemovalDetailResponse, ReturnType<typeof superAdminCharityRemovalsGetCharityRemovalDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminCharityRemovalsGetCharityRemovalDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminCharityRemovalsGetCharityRemovalDetailQueryKey(options)
});

/**
 * Cancel Charity Removal
 *
 * CANCEL an OPEN removal request with a required reason → status CANCELLED +
 * audit. NO overlay change (``consent_status`` untouched; the charity is NOT
 * removed). A terminal request cannot be cancelled (else 400).
 */
export const superAdminCharityRemovalsCancelCharityRemovalMutation = (options?: Partial<Options<SuperAdminCharityRemovalsCancelCharityRemovalData>>): UseMutationOptions<SuperAdminCharityRemovalsCancelCharityRemovalResponse, SuperAdminCharityRemovalsCancelCharityRemovalError, Options<SuperAdminCharityRemovalsCancelCharityRemovalData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityRemovalsCancelCharityRemovalResponse, SuperAdminCharityRemovalsCancelCharityRemovalError, Options<SuperAdminCharityRemovalsCancelCharityRemovalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityRemovalsCancelCharityRemoval({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Process Charity Removal
 *
 * PROCESS: IDENTITY_VERIFIED → REMOVED. Flips the ``charity_claim`` overlay to
 * REMOVED (suppresses the unconsented solicitation state; the org reverts to its
 * unclaimed disclosure posture) + stamps ``removed_at``. Removal affects ONLY the
 * disclosure/§318 state — it NEVER blocks payout of money already owed (D-CP-11).
 * Only an IDENTITY_VERIFIED request can be processed (else 400). Returns the REMOVED
 * request.
 */
export const superAdminCharityRemovalsProcessCharityRemovalMutation = (options?: Partial<Options<SuperAdminCharityRemovalsProcessCharityRemovalData>>): UseMutationOptions<SuperAdminCharityRemovalsProcessCharityRemovalResponse, SuperAdminCharityRemovalsProcessCharityRemovalError, Options<SuperAdminCharityRemovalsProcessCharityRemovalData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityRemovalsProcessCharityRemovalResponse, SuperAdminCharityRemovalsProcessCharityRemovalError, Options<SuperAdminCharityRemovalsProcessCharityRemovalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityRemovalsProcessCharityRemoval({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify Charity Removal Identity
 *
 * VERIFY-IDENTITY: REQUESTED → IDENTITY_VERIFIED. Confirms the requester's
 * authority and starts the 3-business-day process SLA. Only a REQUESTED request can
 * be verified (else 400). Returns the updated request.
 */
export const superAdminCharityRemovalsVerifyCharityRemovalIdentityMutation = (options?: Partial<Options<SuperAdminCharityRemovalsVerifyCharityRemovalIdentityData>>): UseMutationOptions<SuperAdminCharityRemovalsVerifyCharityRemovalIdentityResponse, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityError, Options<SuperAdminCharityRemovalsVerifyCharityRemovalIdentityData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminCharityRemovalsVerifyCharityRemovalIdentityResponse, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityError, Options<SuperAdminCharityRemovalsVerifyCharityRemovalIdentityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminCharityRemovalsVerifyCharityRemovalIdentity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Hide Comment
 *
 * Super-admin hide (GF-BE8 / D-GF-11): drop a comment from every consumer
 * comment payload. SAA double-guard — the router `require_superadmin` dependency
 * (403 for a non-super-admin) AND the service `@has_superadmin_permission`.
 * A missing comment → 404. Dark: the drop is a no-op until a comment is hidden.
 */
export const postsHideCommentMutation = (options?: Partial<Options<PostsHideCommentData>>): UseMutationOptions<PostsHideCommentResponse, PostsHideCommentError, Options<PostsHideCommentData>> => {
    const mutationOptions: UseMutationOptions<PostsHideCommentResponse, PostsHideCommentError, Options<PostsHideCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsHideComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unhide Comment
 *
 * Super-admin unhide (GF-BE8 / D-GF-11): restore a previously hidden comment
 * to consumer payloads. SAA double-guard (router dependency + service decorator).
 * A missing comment → 404.
 */
export const postsUnhideCommentMutation = (options?: Partial<Options<PostsUnhideCommentData>>): UseMutationOptions<PostsUnhideCommentResponse, PostsUnhideCommentError, Options<PostsUnhideCommentData>> => {
    const mutationOptions: UseMutationOptions<PostsUnhideCommentResponse, PostsUnhideCommentError, Options<PostsUnhideCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsUnhideComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const connectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsQueryKey = (options?: Options<ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsData>) => createQueryKey('connect-partner-category-exclusions-list_charity_partner_category_exclusions', options);

/**
 * List Charity Partner Category Exclusions
 */
export const connectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsOptions = (options?: Options<ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsData>) => queryOptions<ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsResponse, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsError, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsResponse, ReturnType<typeof connectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await connectPartnerCategoryExclusionsListCharityPartnerCategoryExclusions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: connectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsQueryKey(options)
});

/**
 * Create Charity Partner Category Exclusion
 */
export const connectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionMutation = (options?: Partial<Options<ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionData>>): UseMutationOptions<ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionResponse, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionError, Options<ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionResponse, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionError, Options<ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Charity Partner Category Exclusion
 */
export const connectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionMutation = (options?: Partial<Options<ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionData>>): UseMutationOptions<ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionResponse, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionError, Options<ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionResponse, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionError, Options<ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Re Advise Connect Donation Intent
 *
 * Support-only wrong-charity correction for an already-charged direct
 * Connect intent. The router-wide super-admin marker, the service-level
 * ``@has_superadmin_permission()`` gate, the money-action guard, and the
 * mandatory idempotency key all bind before any grant routing changes.
 */
export const superAdminDonationOpsReAdviseConnectDonationIntentMutation = (options?: Partial<Options<SuperAdminDonationOpsReAdviseConnectDonationIntentData>>): UseMutationOptions<SuperAdminDonationOpsReAdviseConnectDonationIntentResponse, SuperAdminDonationOpsReAdviseConnectDonationIntentError, Options<SuperAdminDonationOpsReAdviseConnectDonationIntentData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDonationOpsReAdviseConnectDonationIntentResponse, SuperAdminDonationOpsReAdviseConnectDonationIntentError, Options<SuperAdminDonationOpsReAdviseConnectDonationIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDonationOpsReAdviseConnectDonationIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const connectPartnerApplicationsListPartnerApplicationsQueryKey = (options?: Options<ConnectPartnerApplicationsListPartnerApplicationsData>) => createQueryKey('connect-partner-applications-list_partner_applications', options);

/**
 * List Partner Applications
 */
export const connectPartnerApplicationsListPartnerApplicationsOptions = (options?: Options<ConnectPartnerApplicationsListPartnerApplicationsData>) => queryOptions<ConnectPartnerApplicationsListPartnerApplicationsResponse, ConnectPartnerApplicationsListPartnerApplicationsError, ConnectPartnerApplicationsListPartnerApplicationsResponse, ReturnType<typeof connectPartnerApplicationsListPartnerApplicationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await connectPartnerApplicationsListPartnerApplications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: connectPartnerApplicationsListPartnerApplicationsQueryKey(options)
});

/**
 * Create Partner Application
 */
export const connectPartnerApplicationsCreatePartnerApplicationMutation = (options?: Partial<Options<ConnectPartnerApplicationsCreatePartnerApplicationData>>): UseMutationOptions<ConnectPartnerApplicationsCreatePartnerApplicationResponse, ConnectPartnerApplicationsCreatePartnerApplicationError, Options<ConnectPartnerApplicationsCreatePartnerApplicationData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerApplicationsCreatePartnerApplicationResponse, ConnectPartnerApplicationsCreatePartnerApplicationError, Options<ConnectPartnerApplicationsCreatePartnerApplicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerApplicationsCreatePartnerApplication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const connectPartnerApplicationsGetPartnerApplicationQueryKey = (options: Options<ConnectPartnerApplicationsGetPartnerApplicationData>) => createQueryKey('connect-partner-applications-get_partner_application', options);

/**
 * Get Partner Application
 */
export const connectPartnerApplicationsGetPartnerApplicationOptions = (options: Options<ConnectPartnerApplicationsGetPartnerApplicationData>) => queryOptions<ConnectPartnerApplicationsGetPartnerApplicationResponse, ConnectPartnerApplicationsGetPartnerApplicationError, ConnectPartnerApplicationsGetPartnerApplicationResponse, ReturnType<typeof connectPartnerApplicationsGetPartnerApplicationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await connectPartnerApplicationsGetPartnerApplication({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: connectPartnerApplicationsGetPartnerApplicationQueryKey(options)
});

/**
 * Update Partner Application
 */
export const connectPartnerApplicationsUpdatePartnerApplicationMutation = (options?: Partial<Options<ConnectPartnerApplicationsUpdatePartnerApplicationData>>): UseMutationOptions<ConnectPartnerApplicationsUpdatePartnerApplicationResponse, ConnectPartnerApplicationsUpdatePartnerApplicationError, Options<ConnectPartnerApplicationsUpdatePartnerApplicationData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerApplicationsUpdatePartnerApplicationResponse, ConnectPartnerApplicationsUpdatePartnerApplicationError, Options<ConnectPartnerApplicationsUpdatePartnerApplicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerApplicationsUpdatePartnerApplication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decide Partner Application
 */
export const connectPartnerApplicationsDecidePartnerApplicationMutation = (options?: Partial<Options<ConnectPartnerApplicationsDecidePartnerApplicationData>>): UseMutationOptions<ConnectPartnerApplicationsDecidePartnerApplicationResponse, ConnectPartnerApplicationsDecidePartnerApplicationError, Options<ConnectPartnerApplicationsDecidePartnerApplicationData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerApplicationsDecidePartnerApplicationResponse, ConnectPartnerApplicationsDecidePartnerApplicationError, Options<ConnectPartnerApplicationsDecidePartnerApplicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerApplicationsDecidePartnerApplication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Provision Partner Application
 */
export const connectPartnerApplicationsProvisionPartnerApplicationMutation = (options?: Partial<Options<ConnectPartnerApplicationsProvisionPartnerApplicationData>>): UseMutationOptions<ConnectPartnerApplicationsProvisionPartnerApplicationResponse, ConnectPartnerApplicationsProvisionPartnerApplicationError, Options<ConnectPartnerApplicationsProvisionPartnerApplicationData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerApplicationsProvisionPartnerApplicationResponse, ConnectPartnerApplicationsProvisionPartnerApplicationError, Options<ConnectPartnerApplicationsProvisionPartnerApplicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerApplicationsProvisionPartnerApplication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Dashboard Invite
 */
export const connectDashboardInvitesCreateDashboardInviteMutation = (options?: Partial<Options<ConnectDashboardInvitesCreateDashboardInviteData>>): UseMutationOptions<ConnectDashboardInvitesCreateDashboardInviteResponse, ConnectDashboardInvitesCreateDashboardInviteError, Options<ConnectDashboardInvitesCreateDashboardInviteData>> => {
    const mutationOptions: UseMutationOptions<ConnectDashboardInvitesCreateDashboardInviteResponse, ConnectDashboardInvitesCreateDashboardInviteError, Options<ConnectDashboardInvitesCreateDashboardInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectDashboardInvitesCreateDashboardInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const connectPartnerPromotionsListPartnerPromotionReviewsQueryKey = (options?: Options<ConnectPartnerPromotionsListPartnerPromotionReviewsData>) => createQueryKey('connect-partner-promotions-list_partner_promotion_reviews', options);

/**
 * List Partner Promotion Reviews
 */
export const connectPartnerPromotionsListPartnerPromotionReviewsOptions = (options?: Options<ConnectPartnerPromotionsListPartnerPromotionReviewsData>) => queryOptions<ConnectPartnerPromotionsListPartnerPromotionReviewsResponse, ConnectPartnerPromotionsListPartnerPromotionReviewsError, ConnectPartnerPromotionsListPartnerPromotionReviewsResponse, ReturnType<typeof connectPartnerPromotionsListPartnerPromotionReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await connectPartnerPromotionsListPartnerPromotionReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: connectPartnerPromotionsListPartnerPromotionReviewsQueryKey(options)
});

/**
 * Open Partner Promotion Review
 */
export const connectPartnerPromotionsOpenPartnerPromotionReviewMutation = (options?: Partial<Options<ConnectPartnerPromotionsOpenPartnerPromotionReviewData>>): UseMutationOptions<ConnectPartnerPromotionsOpenPartnerPromotionReviewResponse, ConnectPartnerPromotionsOpenPartnerPromotionReviewError, Options<ConnectPartnerPromotionsOpenPartnerPromotionReviewData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerPromotionsOpenPartnerPromotionReviewResponse, ConnectPartnerPromotionsOpenPartnerPromotionReviewError, Options<ConnectPartnerPromotionsOpenPartnerPromotionReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerPromotionsOpenPartnerPromotionReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const connectPartnerPromotionsGetPartnerPromotionReviewQueryKey = (options: Options<ConnectPartnerPromotionsGetPartnerPromotionReviewData>) => createQueryKey('connect-partner-promotions-get_partner_promotion_review', options);

/**
 * Get Partner Promotion Review
 */
export const connectPartnerPromotionsGetPartnerPromotionReviewOptions = (options: Options<ConnectPartnerPromotionsGetPartnerPromotionReviewData>) => queryOptions<ConnectPartnerPromotionsGetPartnerPromotionReviewResponse, ConnectPartnerPromotionsGetPartnerPromotionReviewError, ConnectPartnerPromotionsGetPartnerPromotionReviewResponse, ReturnType<typeof connectPartnerPromotionsGetPartnerPromotionReviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await connectPartnerPromotionsGetPartnerPromotionReview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: connectPartnerPromotionsGetPartnerPromotionReviewQueryKey(options)
});

/**
 * Decide Partner Promotion Review
 */
export const connectPartnerPromotionsDecidePartnerPromotionReviewMutation = (options?: Partial<Options<ConnectPartnerPromotionsDecidePartnerPromotionReviewData>>): UseMutationOptions<ConnectPartnerPromotionsDecidePartnerPromotionReviewResponse, ConnectPartnerPromotionsDecidePartnerPromotionReviewError, Options<ConnectPartnerPromotionsDecidePartnerPromotionReviewData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerPromotionsDecidePartnerPromotionReviewResponse, ConnectPartnerPromotionsDecidePartnerPromotionReviewError, Options<ConnectPartnerPromotionsDecidePartnerPromotionReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerPromotionsDecidePartnerPromotionReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Partner Promotion Review Item
 */
export const connectPartnerPromotionsUpdatePartnerPromotionReviewItemMutation = (options?: Partial<Options<ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemData>>): UseMutationOptions<ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemResponse, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemError, Options<ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemData>> => {
    const mutationOptions: UseMutationOptions<ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemResponse, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemError, Options<ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectPartnerPromotionsUpdatePartnerPromotionReviewItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminContentReportsListContentReportsQueryKey = (options?: Options<SuperAdminContentReportsListContentReportsData>) => createQueryKey('super-admin-content-reports-list_content_reports', options);

/**
 * List Content Reports
 *
 * Newest-first surface-agnostic content-report moderation queue.
 *
 * Filters (all optional, composing): ``subject_type``, ``category``, ``status``,
 * ``subject_id`` (every report on ONE subject). Pagination ``page[limit]``
 * (hard-capped at 200 — over-cap → 422) / ``page[offset]``. Sorted ``created_at``
 * desc with an ``-id`` tiebreaker. Each row carries the per-subject aggregate
 * ``report_count`` — the TOTAL reports on that ``(subject_type, subject_id)``,
 * independent of the active filters (a ``status`` / ``category`` filter narrows the
 * listed rows, not the per-subject total), mirroring the SA post queue — plus
 * ``last_reported_at``.
 *
 * ``q`` is a case-insensitive substring match over ``comment`` +
 * ``subject_id``::text + ``reporter_user_id``::text. LIMITATION: unlike the
 * post-specific ``GET /super-admin/posts`` ``q`` (which joins post text / author /
 * target names), this generalized queue CANNOT search the subject's CONTENT — the
 * ``content_report`` aggregate stores only the subject REFERENCE, not its text.
 * Cross-surface content search (per-``subject_type`` content joins) is a future
 * enhancement the aggregate deliberately does not carry.
 *
 * Empty aggregate ⇒ empty list (never an error): the aggregate is dark until the
 * dual-write flag flips + reads cut over (UGC-BE1c). Super-admin only.
 */
export const superAdminContentReportsListContentReportsOptions = (options?: Options<SuperAdminContentReportsListContentReportsData>) => queryOptions<SuperAdminContentReportsListContentReportsResponse, SuperAdminContentReportsListContentReportsError, SuperAdminContentReportsListContentReportsResponse, ReturnType<typeof superAdminContentReportsListContentReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminContentReportsListContentReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminContentReportsListContentReportsQueryKey(options)
});

export const superAdminDafTransfersListDafTransferArrivalsQueryKey = (options?: Options<SuperAdminDafTransfersListDafTransferArrivalsData>) => createQueryKey('super-admin-daf-transfers-list_daf_transfer_arrivals', options);

/**
 * List Daf Transfer Arrivals
 */
export const superAdminDafTransfersListDafTransferArrivalsOptions = (options?: Options<SuperAdminDafTransfersListDafTransferArrivalsData>) => queryOptions<SuperAdminDafTransfersListDafTransferArrivalsResponse, SuperAdminDafTransfersListDafTransferArrivalsError, SuperAdminDafTransfersListDafTransferArrivalsResponse, ReturnType<typeof superAdminDafTransfersListDafTransferArrivalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDafTransfersListDafTransferArrivals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDafTransfersListDafTransferArrivalsQueryKey(options)
});

/**
 * Register Daf Transfer Arrival
 */
export const superAdminDafTransfersRegisterDafTransferArrivalMutation = (options?: Partial<Options<SuperAdminDafTransfersRegisterDafTransferArrivalData>>): UseMutationOptions<SuperAdminDafTransfersRegisterDafTransferArrivalResponse, SuperAdminDafTransfersRegisterDafTransferArrivalError, Options<SuperAdminDafTransfersRegisterDafTransferArrivalData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDafTransfersRegisterDafTransferArrivalResponse, SuperAdminDafTransfersRegisterDafTransferArrivalError, Options<SuperAdminDafTransfersRegisterDafTransferArrivalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDafTransfersRegisterDafTransferArrival({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminDafTransfersListDafTransferArrivalAgingQueryKey = (options?: Options<SuperAdminDafTransfersListDafTransferArrivalAgingData>) => createQueryKey('super-admin-daf-transfers-list_daf_transfer_arrival_aging', options);

/**
 * List Daf Transfer Arrival Aging
 */
export const superAdminDafTransfersListDafTransferArrivalAgingOptions = (options?: Options<SuperAdminDafTransfersListDafTransferArrivalAgingData>) => queryOptions<SuperAdminDafTransfersListDafTransferArrivalAgingResponse, SuperAdminDafTransfersListDafTransferArrivalAgingError, SuperAdminDafTransfersListDafTransferArrivalAgingResponse, ReturnType<typeof superAdminDafTransfersListDafTransferArrivalAgingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDafTransfersListDafTransferArrivalAging({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDafTransfersListDafTransferArrivalAgingQueryKey(options)
});

export const superAdminDafTransfersGetDafTransferArrivalQueryKey = (options: Options<SuperAdminDafTransfersGetDafTransferArrivalData>) => createQueryKey('super-admin-daf-transfers-get_daf_transfer_arrival', options);

/**
 * Get Daf Transfer Arrival
 */
export const superAdminDafTransfersGetDafTransferArrivalOptions = (options: Options<SuperAdminDafTransfersGetDafTransferArrivalData>) => queryOptions<SuperAdminDafTransfersGetDafTransferArrivalResponse, SuperAdminDafTransfersGetDafTransferArrivalError, SuperAdminDafTransfersGetDafTransferArrivalResponse, ReturnType<typeof superAdminDafTransfersGetDafTransferArrivalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDafTransfersGetDafTransferArrival({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDafTransfersGetDafTransferArrivalQueryKey(options)
});

export const superAdminDafTransfersListDafTransferArrivalCandidatesQueryKey = (options: Options<SuperAdminDafTransfersListDafTransferArrivalCandidatesData>) => createQueryKey('super-admin-daf-transfers-list_daf_transfer_arrival_candidates', options);

/**
 * List Daf Transfer Arrival Candidates
 */
export const superAdminDafTransfersListDafTransferArrivalCandidatesOptions = (options: Options<SuperAdminDafTransfersListDafTransferArrivalCandidatesData>) => queryOptions<SuperAdminDafTransfersListDafTransferArrivalCandidatesResponse, SuperAdminDafTransfersListDafTransferArrivalCandidatesError, SuperAdminDafTransfersListDafTransferArrivalCandidatesResponse, ReturnType<typeof superAdminDafTransfersListDafTransferArrivalCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDafTransfersListDafTransferArrivalCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDafTransfersListDafTransferArrivalCandidatesQueryKey(options)
});

/**
 * Credit Daf Transfer Arrival
 */
export const superAdminDafTransfersCreditDafTransferArrivalMutation = (options?: Partial<Options<SuperAdminDafTransfersCreditDafTransferArrivalData>>): UseMutationOptions<SuperAdminDafTransfersCreditDafTransferArrivalResponse, SuperAdminDafTransfersCreditDafTransferArrivalError, Options<SuperAdminDafTransfersCreditDafTransferArrivalData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDafTransfersCreditDafTransferArrivalResponse, SuperAdminDafTransfersCreditDafTransferArrivalError, Options<SuperAdminDafTransfersCreditDafTransferArrivalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDafTransfersCreditDafTransferArrival({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link Daf Transfer Arrival
 *
 * IDT-BE16: record a GCF officer's attested link between a paper arrival and a
 * donor's transfer intent (decision D-IDT-24).
 *
 * The officer states, in one act, that they read the instrument once, that its
 * designation is precatory, the amount it states, and the account intent it names.
 * That recorded reading is what lets the automated lane execute the credit at
 * settlement on evidence rather than on a named residual — and it is why the two
 * assertions are required True at the wire: a False is not a weaker attestation, it is
 * the absence of one.
 *
 * Outcomes: `201` on BOTH the first link (`created=true`) and an identical repeat
 * (`created=false`) — the vertical's `created` convention, matching its sibling
 * `POST /daf-transfers/arrivals`, which also answers 201 to an idempotent duplicate.
 * Branch on the `created` field, never on the status code. `409` when the arrival is
 * no longer pre-credit, or when a
 * different live attestation already stands; `400` when the intent is missing,
 * malformed, or not OPEN; `422` with `attestation_memo_restriction_language` when the
 * memo carries mandatory or restrictive language — surface that one verbatim, because
 * the operator is holding the letter and the next step is a clean re-issue from the
 * sponsor, not a retry.
 *
 * Does NOT transition the intent. The intent closes at CREDIT, via `mark_matched`, and
 * closing it here would strand the donor's tracker on an attribution that has not been
 * paid yet.
 */
export const superAdminDafTransfersLinkDafTransferArrivalMutation = (options?: Partial<Options<SuperAdminDafTransfersLinkDafTransferArrivalData>>): UseMutationOptions<SuperAdminDafTransfersLinkDafTransferArrivalResponse, SuperAdminDafTransfersLinkDafTransferArrivalError, Options<SuperAdminDafTransfersLinkDafTransferArrivalData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDafTransfersLinkDafTransferArrivalResponse, SuperAdminDafTransfersLinkDafTransferArrivalError, Options<SuperAdminDafTransfersLinkDafTransferArrivalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDafTransfersLinkDafTransferArrival({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Daf Transfer Arrival Link
 *
 * IDT-BE17: withdraw a GCF officer's attested link — the mis-link correction.
 *
 * In ONE unit of work: the attestation is revoked and kept as history; the arrival
 * returns to `SUSPENSE` with `intent_id` cleared and `deposited_date` KEPT; this
 * instrument's `RECEIVED`/`DEPOSITED` on the wrongly-linked intent are voided
 * (first-wins) so that donor's tracker, the aging queue and the learned median stop
 * seeing them; the REQUIRED, donor-visible `donor_note` lands on that intent as an
 * `OPS_NOTE` — write it to the donor, never naming the other donor, sponsor or amount;
 * and the REQUIRED, internal `internal_note` (the real cause) lands on the ARRIVAL's
 * operator-only outreach log, never on a donor surface.
 *
 * Outcomes: `200` with the attestation as it now stands (`revoked_at` set) plus
 * `events_voided`; `409` `arrival_already_credited` when money already moved; `409`
 * `arrival_not_linked` when no live link stands — never linked, or already revoked
 * (a second revoke is a conflict, not a silent success); `404` (no oracle) on an
 * unknown or malformed arrival id; `422` on a missing or blank note of either kind.
 * Re-linking afterwards — to the right intent, or the same one — is the ordinary link
 * route.
 */
export const superAdminDafTransfersRevokeDafTransferArrivalLinkMutation = (options?: Partial<Options<SuperAdminDafTransfersRevokeDafTransferArrivalLinkData>>): UseMutationOptions<SuperAdminDafTransfersRevokeDafTransferArrivalLinkResponse, SuperAdminDafTransfersRevokeDafTransferArrivalLinkError, Options<SuperAdminDafTransfersRevokeDafTransferArrivalLinkData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDafTransfersRevokeDafTransferArrivalLinkResponse, SuperAdminDafTransfersRevokeDafTransferArrivalLinkError, Options<SuperAdminDafTransfersRevokeDafTransferArrivalLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDafTransfersRevokeDafTransferArrivalLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminDafTransfersListDafTransferArrivalNotesQueryKey = (options: Options<SuperAdminDafTransfersListDafTransferArrivalNotesData>) => createQueryKey('super-admin-daf-transfers-list_daf_transfer_arrival_notes', options);

/**
 * List Daf Transfer Arrival Notes
 */
export const superAdminDafTransfersListDafTransferArrivalNotesOptions = (options: Options<SuperAdminDafTransfersListDafTransferArrivalNotesData>) => queryOptions<SuperAdminDafTransfersListDafTransferArrivalNotesResponse, SuperAdminDafTransfersListDafTransferArrivalNotesError, SuperAdminDafTransfersListDafTransferArrivalNotesResponse, ReturnType<typeof superAdminDafTransfersListDafTransferArrivalNotesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDafTransfersListDafTransferArrivalNotes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDafTransfersListDafTransferArrivalNotesQueryKey(options)
});

/**
 * Append Daf Transfer Arrival Note
 */
export const superAdminDafTransfersAppendDafTransferArrivalNoteMutation = (options?: Partial<Options<SuperAdminDafTransfersAppendDafTransferArrivalNoteData>>): UseMutationOptions<SuperAdminDafTransfersAppendDafTransferArrivalNoteResponse, SuperAdminDafTransfersAppendDafTransferArrivalNoteError, Options<SuperAdminDafTransfersAppendDafTransferArrivalNoteData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDafTransfersAppendDafTransferArrivalNoteResponse, SuperAdminDafTransfersAppendDafTransferArrivalNoteError, Options<SuperAdminDafTransfersAppendDafTransferArrivalNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDafTransfersAppendDafTransferArrivalNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register Daf Transfer Intent
 */
export const superAdminDafTransfersRegisterDafTransferIntentMutation = (options?: Partial<Options<SuperAdminDafTransfersRegisterDafTransferIntentData>>): UseMutationOptions<SuperAdminDafTransfersRegisterDafTransferIntentResponse, SuperAdminDafTransfersRegisterDafTransferIntentError, Options<SuperAdminDafTransfersRegisterDafTransferIntentData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDafTransfersRegisterDafTransferIntentResponse, SuperAdminDafTransfersRegisterDafTransferIntentError, Options<SuperAdminDafTransfersRegisterDafTransferIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDafTransfersRegisterDafTransferIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminDafTransfersListDafTransferIntentAgingQueryKey = (options?: Options<SuperAdminDafTransfersListDafTransferIntentAgingData>) => createQueryKey('super-admin-daf-transfers-list_daf_transfer_intent_aging', options);

/**
 * List Daf Transfer Intent Aging
 *
 * PII-minimal, cross-user OPEN-intent aging queue, oldest clock first.
 */
export const superAdminDafTransfersListDafTransferIntentAgingOptions = (options?: Options<SuperAdminDafTransfersListDafTransferIntentAgingData>) => queryOptions<SuperAdminDafTransfersListDafTransferIntentAgingResponse, SuperAdminDafTransfersListDafTransferIntentAgingError, SuperAdminDafTransfersListDafTransferIntentAgingResponse, ReturnType<typeof superAdminDafTransfersListDafTransferIntentAgingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDafTransfersListDafTransferIntentAging({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDafTransfersListDafTransferIntentAgingQueryKey(options)
});

/**
 * Close Daf Transfer Intent
 *
 * IDT-BE15: close an OPEN intent no chokepoint will ever close by itself.
 *
 * Every other terminal transition needs something this intent does not have: the
 * consumer `DELETE .../intents/{id}` cancel is the OWNER's, and BE5's
 * `mark_matched` fires only when a credit carries the `intent_id` linkage. The
 * console credit flow does not send one (IDT-WEB3), so a console-credited case
 * strands its intent OPEN forever — it keeps aging on the super-admin intent
 * queue, keeps minting operator-review rows, and keeps its owner in the BE4
 * candidate pool for later arrivals from the same sponsor. This is the operator's
 * way out, and closing removes the intent from all three at once because every one
 * of them reads the same OPEN-only repository predicate.
 *
 * Disposition semantics: `MATCHED` = fulfilled out of band; `EXPIRED` = the
 * transfer never arrived / abandoned after the aging window; `CANCELLED` =
 * registered in error, or the donor withdrew the notice through support.
 *
 * ⚠ `note` is REQUIRED and **donor-visible** — see `DafTransferIntentCloseRequest`.
 * Closing freezes the donor's tracker where it stood, and this note is the only
 * thing that explains why; write it to the donor.
 *
 * Closing is NOT idempotent: a second close returns 409, like any other attempt
 * against a terminal status.
 */
export const superAdminDafTransfersCloseDafTransferIntentMutation = (options?: Partial<Options<SuperAdminDafTransfersCloseDafTransferIntentData>>): UseMutationOptions<SuperAdminDafTransfersCloseDafTransferIntentResponse, SuperAdminDafTransfersCloseDafTransferIntentError, Options<SuperAdminDafTransfersCloseDafTransferIntentData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDafTransfersCloseDafTransferIntentResponse, SuperAdminDafTransfersCloseDafTransferIntentError, Options<SuperAdminDafTransfersCloseDafTransferIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDafTransfersCloseDafTransferIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Append Daf Transfer Event
 */
export const superAdminDafTransfersAppendDafTransferEventMutation = (options?: Partial<Options<SuperAdminDafTransfersAppendDafTransferEventData>>): UseMutationOptions<SuperAdminDafTransfersAppendDafTransferEventResponse, SuperAdminDafTransfersAppendDafTransferEventError, Options<SuperAdminDafTransfersAppendDafTransferEventData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDafTransfersAppendDafTransferEventResponse, SuperAdminDafTransfersAppendDafTransferEventError, Options<SuperAdminDafTransfersAppendDafTransferEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDafTransfersAppendDafTransferEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminDafTransfersSearchDafTransferUserCandidatesByNameQueryKey = (options: Options<SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameData>) => createQueryKey('super-admin-daf-transfers-search_daf_transfer_user_candidates_by_name', options);

/**
 * Search Daf Transfer User Candidates By Name
 *
 * IDT-BE11: the users a name off DAF grant paperwork could refer to.
 *
 * Hosted on the DAF `super_admin_router` — not beside the other super-admin
 * user surfaces in `super_admin_donation_ops.py` — for two reasons. (1) It
 * inherits this router's STRUCTURAL dark gate: while `DAF_TRANSFER_INTAKE_
 * ENABLED` is off the path 404s before super-admin auth can reveal it exists,
 * so the operator surface and the internal MCP tool are gated identically
 * rather than one being live in prod while the other is dark. (2) A name
 * search over the user directory is a broader PII read than the exact-email
 * lookup (which requires already knowing the address), and this is the DAF
 * triage use case that justifies it — keeping it here keeps that scope visible.
 *
 * Read-only and money-free: candidates only. It resolves nothing, and the
 * credit chokepoint is elsewhere and unchanged.
 *
 * ⚠ `total_matched == 0` means "no stored name normalizes to exactly this",
 * NOT "this person has no Givmo account". Matching is exact, so a married,
 * hyphenated or suffixed surname, or a nickname on the paperwork, reads as
 * zero. Search `last_name` alone first — it is the selective and more stable
 * term — and add `first_name` only to narrow a multi-hit.
 */
export const superAdminDafTransfersSearchDafTransferUserCandidatesByNameOptions = (options: Options<SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameData>) => queryOptions<SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameResponse, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameError, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameResponse, ReturnType<typeof superAdminDafTransfersSearchDafTransferUserCandidatesByNameQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDafTransfersSearchDafTransferUserCandidatesByName({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDafTransfersSearchDafTransferUserCandidatesByNameQueryKey(options)
});

export const disclaimersListDisclaimersQueryKey = (options?: Options<DisclaimersListDisclaimersData>) => createQueryKey('disclaimers-list_disclaimers', options);

/**
 * List Disclaimers
 */
export const disclaimersListDisclaimersOptions = (options?: Options<DisclaimersListDisclaimersData>) => queryOptions<DisclaimersListDisclaimersResponse, DisclaimersListDisclaimersError, DisclaimersListDisclaimersResponse, ReturnType<typeof disclaimersListDisclaimersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await disclaimersListDisclaimers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: disclaimersListDisclaimersQueryKey(options)
});

/**
 * Publish Disclaimer At Super Admin
 *
 * Create a DRAFT disclaimer. Publisher-gated (TERMS_PUBLISHERS_WHITE_LIST,
 * enforced at the service layer).
 */
export const disclaimersPublishDisclaimerAtSuperAdminMutation = (options?: Partial<Options<DisclaimersPublishDisclaimerAtSuperAdminData>>): UseMutationOptions<DisclaimersPublishDisclaimerAtSuperAdminResponse, DisclaimersPublishDisclaimerAtSuperAdminError, Options<DisclaimersPublishDisclaimerAtSuperAdminData>> => {
    const mutationOptions: UseMutationOptions<DisclaimersPublishDisclaimerAtSuperAdminResponse, DisclaimersPublishDisclaimerAtSuperAdminError, Options<DisclaimersPublishDisclaimerAtSuperAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disclaimersPublishDisclaimerAtSuperAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const disclaimersGetDisclaimerDetailQueryKey = (options: Options<DisclaimersGetDisclaimerDetailData>) => createQueryKey('disclaimers-get_disclaimer_detail', options);

/**
 * Get Disclaimer Detail
 */
export const disclaimersGetDisclaimerDetailOptions = (options: Options<DisclaimersGetDisclaimerDetailData>) => queryOptions<DisclaimersGetDisclaimerDetailResponse, DisclaimersGetDisclaimerDetailError, DisclaimersGetDisclaimerDetailResponse, ReturnType<typeof disclaimersGetDisclaimerDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await disclaimersGetDisclaimerDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: disclaimersGetDisclaimerDetailQueryKey(options)
});

/**
 * Patch Disclaimer Draft At Super Admin
 *
 * Update a DRAFT document's content. Immutable once LIVE (409).
 */
export const disclaimersPatchDisclaimerDraftAtSuperAdminMutation = (options?: Partial<Options<DisclaimersPatchDisclaimerDraftAtSuperAdminData>>): UseMutationOptions<DisclaimersPatchDisclaimerDraftAtSuperAdminResponse, DisclaimersPatchDisclaimerDraftAtSuperAdminError, Options<DisclaimersPatchDisclaimerDraftAtSuperAdminData>> => {
    const mutationOptions: UseMutationOptions<DisclaimersPatchDisclaimerDraftAtSuperAdminResponse, DisclaimersPatchDisclaimerDraftAtSuperAdminError, Options<DisclaimersPatchDisclaimerDraftAtSuperAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disclaimersPatchDisclaimerDraftAtSuperAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Disclaimer Effective At Super Admin
 *
 * Flip a DRAFT document LIVE. Requires a non-empty sign-off.
 */
export const disclaimersSetDisclaimerEffectiveAtSuperAdminMutation = (options?: Partial<Options<DisclaimersSetDisclaimerEffectiveAtSuperAdminData>>): UseMutationOptions<DisclaimersSetDisclaimerEffectiveAtSuperAdminResponse, DisclaimersSetDisclaimerEffectiveAtSuperAdminError, Options<DisclaimersSetDisclaimerEffectiveAtSuperAdminData>> => {
    const mutationOptions: UseMutationOptions<DisclaimersSetDisclaimerEffectiveAtSuperAdminResponse, DisclaimersSetDisclaimerEffectiveAtSuperAdminError, Options<DisclaimersSetDisclaimerEffectiveAtSuperAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disclaimersSetDisclaimerEffectiveAtSuperAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminDonationOpsGetPaymentMethodReportQueryKey = (options: Options<SuperAdminDonationOpsGetPaymentMethodReportData>) => createQueryKey('super-admin-donation-ops-get_payment_method_report', options);

/**
 * Get Payment Method Report
 *
 * ER-BE54: the donations and the wallet deposits booked in a window, each counted
 * and summed by payment method and counted by amount band.
 *
 * The window is ``from_date`` through ``to_date``, whole days in ``tz``, read on each
 * row's ``created_at``. A donation payment is one gift's legs on one payment (a gift
 * split across charities counts once; ``row_count`` counts its rows), and a wallet
 * deposit is one row. ``amount_charged`` is what the payment method was charged,
 * ``amount_entered`` the amount chosen, and a payment's band is read from its
 * ``amount_entered``. An EXTERNAL donation, a gift made off Givmo and only recorded on
 * it, is no payment: Givmo charged nothing for it, so it is counted apart in
 * ``external_donations`` (with no charged figure) and is in none of ``donations``'
 * figures. Every row booked in the window counts, a test account's included; a later
 * refund is not subtracted. The two payment sections are never added together: a
 * wallet donation spends a balance a wallet deposit funded.
 */
export const superAdminDonationOpsGetPaymentMethodReportOptions = (options: Options<SuperAdminDonationOpsGetPaymentMethodReportData>) => queryOptions<SuperAdminDonationOpsGetPaymentMethodReportResponse, SuperAdminDonationOpsGetPaymentMethodReportError, SuperAdminDonationOpsGetPaymentMethodReportResponse, ReturnType<typeof superAdminDonationOpsGetPaymentMethodReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDonationOpsGetPaymentMethodReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDonationOpsGetPaymentMethodReportQueryKey(options)
});

export const superAdminDonationOpsGetClaimConversionQueryKey = (options?: Options<SuperAdminDonationOpsGetClaimConversionData>) => createQueryKey('super-admin-donation-ops-get_claim_conversion', options);

/**
 * Get Claim Conversion
 *
 * GCR-READ1: guest→account conversion rate over ``donation_claim_token``.
 * ``from_date`` / ``to_date`` (ISO ``YYYY-MM-DD``) bound an inclusive-day
 * ``created_at`` window; both optional → no lower / upper bound respectively.
 */
export const superAdminDonationOpsGetClaimConversionOptions = (options?: Options<SuperAdminDonationOpsGetClaimConversionData>) => queryOptions<SuperAdminDonationOpsGetClaimConversionResponse, SuperAdminDonationOpsGetClaimConversionError, SuperAdminDonationOpsGetClaimConversionResponse, ReturnType<typeof superAdminDonationOpsGetClaimConversionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDonationOpsGetClaimConversion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDonationOpsGetClaimConversionQueryKey(options)
});

/**
 * Clear Donation Disbursement Hold
 *
 * Clear all disbursement-hold fields; already-clear rows are unchanged.
 */
export const superAdminDonationOpsClearDonationDisbursementHoldMutation = (options?: Partial<Options<SuperAdminDonationOpsClearDonationDisbursementHoldData>>): UseMutationOptions<SuperAdminDonationOpsClearDonationDisbursementHoldResponse, SuperAdminDonationOpsClearDonationDisbursementHoldError, Options<SuperAdminDonationOpsClearDonationDisbursementHoldData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDonationOpsClearDonationDisbursementHoldResponse, SuperAdminDonationOpsClearDonationDisbursementHoldError, Options<SuperAdminDonationOpsClearDonationDisbursementHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDonationOpsClearDonationDisbursementHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Donation Disbursement Hold
 *
 * Set or replace the structured hold on automatic cohort admission.
 */
export const superAdminDonationOpsSetDonationDisbursementHoldMutation = (options?: Partial<Options<SuperAdminDonationOpsSetDonationDisbursementHoldData>>): UseMutationOptions<SuperAdminDonationOpsSetDonationDisbursementHoldResponse, SuperAdminDonationOpsSetDonationDisbursementHoldError, Options<SuperAdminDonationOpsSetDonationDisbursementHoldData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDonationOpsSetDonationDisbursementHoldResponse, SuperAdminDonationOpsSetDonationDisbursementHoldError, Options<SuperAdminDonationOpsSetDonationDisbursementHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDonationOpsSetDonationDisbursementHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminEntityEnrollmentsOperatorListEnrollmentsQueryKey = (options?: Options<SuperAdminEntityEnrollmentsOperatorListEnrollmentsData>) => createQueryKey('super-admin-entity-enrollments-operator_list_enrollments', options);

/**
 * Operator List Enrollments
 *
 * Every enrollment record, newest first.
 *
 * `store_copy_pending=true` is the COPY BACKLOG: provisioned records whose second
 * home is unwritten. Neither filter defaults to a subset — an unfiltered read is
 * every record, so an operator who asks for nothing in particular is not shown a
 * silently narrowed view.
 */
export const superAdminEntityEnrollmentsOperatorListEnrollmentsOptions = (options?: Options<SuperAdminEntityEnrollmentsOperatorListEnrollmentsData>) => queryOptions<SuperAdminEntityEnrollmentsOperatorListEnrollmentsResponse, SuperAdminEntityEnrollmentsOperatorListEnrollmentsError, SuperAdminEntityEnrollmentsOperatorListEnrollmentsResponse, ReturnType<typeof superAdminEntityEnrollmentsOperatorListEnrollmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminEntityEnrollmentsOperatorListEnrollments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminEntityEnrollmentsOperatorListEnrollmentsQueryKey(options)
});

/**
 * Operator Create For Profit Enrollment
 *
 * Create a for_profit enrollment. Creation IS the approval act.
 *
 * Both halves land in one unit of work, so a creation that cannot be approved leaves
 * no record at all — while the rule-pack provider is unfilled this answers 503 and
 * writes nothing, rather than leaving behind an unapproved record holding a permanent
 * ledger identity nothing can use.
 *
 * ⚠ `fiscal_year_end_month` is passed through, and it is worth stating why the line
 * matters: this handler used to accept, document and range-check it and then DROP it.
 * On the charity path the same defect had a cure — the field settles at submission and
 * a PATCH can supply it — but this record is born past `draft`, there is no submission
 * and there is no operator PATCH route, so a dropped answer silently became the
 * calendar-year default with no way back. The books fold a period into a fiscal year
 * with it, and after they are opened it can no longer be changed.
 */
export const superAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentMutation = (options?: Partial<Options<SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentData>>): UseMutationOptions<SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentResponse, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentError, Options<SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentResponse, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentError, Options<SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminEntityEnrollmentsOperatorCreateForProfitEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminEntityEnrollmentsOperatorGetEnrollmentQueryKey = (options: Options<SuperAdminEntityEnrollmentsOperatorGetEnrollmentData>) => createQueryKey('super-admin-entity-enrollments-operator_get_enrollment', options);

/**
 * Operator Get Enrollment
 *
 * One record with its full event log and the platform facts behind it.
 */
export const superAdminEntityEnrollmentsOperatorGetEnrollmentOptions = (options: Options<SuperAdminEntityEnrollmentsOperatorGetEnrollmentData>) => queryOptions<SuperAdminEntityEnrollmentsOperatorGetEnrollmentResponse, SuperAdminEntityEnrollmentsOperatorGetEnrollmentError, SuperAdminEntityEnrollmentsOperatorGetEnrollmentResponse, ReturnType<typeof superAdminEntityEnrollmentsOperatorGetEnrollmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminEntityEnrollmentsOperatorGetEnrollment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminEntityEnrollmentsOperatorGetEnrollmentQueryKey(options)
});

/**
 * Operator Start Import Run
 *
 * Bring history in for a record with no charity membership behind it (CBO-IN4).
 *
 * The for_profit class's door onto the same run the charity surface drives — GivFi's,
 * in practice. It exists because that class has no charity membership, so its caller
 * cannot reach the charity-scoped function at all; the operator's provisioning re-drive
 * beside it has exactly the same shape for exactly the same reason.
 *
 * `idempotency_key` is required here too. The operator is not exempt from the guard that
 * stops a second run posting a second copy of a window's history.
 */
export const superAdminEntityEnrollmentsOperatorStartImportRunMutation = (options?: Partial<Options<SuperAdminEntityEnrollmentsOperatorStartImportRunData>>): UseMutationOptions<SuperAdminEntityEnrollmentsOperatorStartImportRunResponse, SuperAdminEntityEnrollmentsOperatorStartImportRunError, Options<SuperAdminEntityEnrollmentsOperatorStartImportRunData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminEntityEnrollmentsOperatorStartImportRunResponse, SuperAdminEntityEnrollmentsOperatorStartImportRunError, Options<SuperAdminEntityEnrollmentsOperatorStartImportRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminEntityEnrollmentsOperatorStartImportRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Operator Redrive Provision
 *
 * Re-run the provisioning protocol from the record's approved anchor.
 *
 * The cure for every crash window the protocol has: a first drive that never reached
 * the store, a store leg that committed with nothing bound on this side, or books that
 * want re-folding. The same act as a first drive rather than a special one — the store
 * leg settles idempotently and re-folds the whole chain on the way.
 *
 * No body: everything the act needs is already on the record and its approval row, and
 * a body would be a place for a caller to supply something the approval did not pin.
 */
export const superAdminEntityEnrollmentsOperatorRedriveProvisionMutation = (options?: Partial<Options<SuperAdminEntityEnrollmentsOperatorRedriveProvisionData>>): UseMutationOptions<SuperAdminEntityEnrollmentsOperatorRedriveProvisionResponse, SuperAdminEntityEnrollmentsOperatorRedriveProvisionError, Options<SuperAdminEntityEnrollmentsOperatorRedriveProvisionData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminEntityEnrollmentsOperatorRedriveProvisionResponse, SuperAdminEntityEnrollmentsOperatorRedriveProvisionError, Options<SuperAdminEntityEnrollmentsOperatorRedriveProvisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminEntityEnrollmentsOperatorRedriveProvision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Operator Reject Enrollment
 *
 * Reject a submitted record, with the recorded reason.
 *
 * From `submitted` and nowhere else: a rejection disposes of a request that was
 * actually made, so there is no path from a draft nobody has submitted and none from
 * an approved record whose ledger identity may already be in the store.
 */
export const superAdminEntityEnrollmentsOperatorRejectEnrollmentMutation = (options?: Partial<Options<SuperAdminEntityEnrollmentsOperatorRejectEnrollmentData>>): UseMutationOptions<SuperAdminEntityEnrollmentsOperatorRejectEnrollmentResponse, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentError, Options<SuperAdminEntityEnrollmentsOperatorRejectEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminEntityEnrollmentsOperatorRejectEnrollmentResponse, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentError, Options<SuperAdminEntityEnrollmentsOperatorRejectEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminEntityEnrollmentsOperatorRejectEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Operator Redrive Store Copy
 *
 * Write the second home for a provisioned record whose done-flag is still NULL.
 *
 * The act the `store_copy_pending=true` listing exists to make reachable. Separate from
 * the provision re-drive above because the record is already bound and canonical: the
 * only thing missing is the entity's own copy.
 */
export const superAdminEntityEnrollmentsOperatorRedriveStoreCopyMutation = (options?: Partial<Options<SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyData>>): UseMutationOptions<SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyResponse, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyError, Options<SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyResponse, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyError, Options<SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminEntityEnrollmentsOperatorRedriveStoreCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundraisersGetSuperAdminFundraisersQueryKey = (options?: Options<FundraisersGetSuperAdminFundraisersData>) => createQueryKey('fundraisers-get_super_admin_fundraisers', options);

/**
 * Get Super Admin Fundraisers
 */
export const fundraisersGetSuperAdminFundraisersOptions = (options?: Options<FundraisersGetSuperAdminFundraisersData>) => queryOptions<FundraisersGetSuperAdminFundraisersResponse, FundraisersGetSuperAdminFundraisersError, FundraisersGetSuperAdminFundraisersResponse, ReturnType<typeof fundraisersGetSuperAdminFundraisersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetSuperAdminFundraisers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetSuperAdminFundraisersQueryKey(options)
});

export const superAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsQueryKey = (options?: Options<SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsData>) => createQueryKey('super-admin-fundraiser-message-objections-list_fundraiser_message_objections', options);

/**
 * List Fundraiser Message Objections
 *
 * The objection review queue (FCA-BE9), narrowed by ``status`` (default OPEN),
 * oldest first (most-aged = most SLA-pressured), each row carrying the objecting
 * charity id, the fundraiser name, the intake reason, and the queue age. An unknown
 * ``status`` value 422s.
 */
export const superAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsOptions = (options?: Options<SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsData>) => queryOptions<SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsResponse, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsError, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsResponse, ReturnType<typeof superAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminFundraiserMessageObjectionsListFundraiserMessageObjections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsQueryKey(options)
});

/**
 * Admin Deactivate Fundraiser
 */
export const fundraisersAdminDeactivateFundraiserMutation = (options?: Partial<Options<FundraisersAdminDeactivateFundraiserData>>): UseMutationOptions<FundraisersAdminDeactivateFundraiserResponse, FundraisersAdminDeactivateFundraiserError, Options<FundraisersAdminDeactivateFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersAdminDeactivateFundraiserResponse, FundraisersAdminDeactivateFundraiserError, Options<FundraisersAdminDeactivateFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersAdminDeactivateFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundraisersGetSuperAdminFundraiserDonationsQueryKey = (options: Options<FundraisersGetSuperAdminFundraiserDonationsData>) => createQueryKey('fundraisers-get_super_admin_fundraiser_donations', options);

/**
 * Get Super Admin Fundraiser Donations
 */
export const fundraisersGetSuperAdminFundraiserDonationsOptions = (options: Options<FundraisersGetSuperAdminFundraiserDonationsData>) => queryOptions<FundraisersGetSuperAdminFundraiserDonationsResponse, FundraisersGetSuperAdminFundraiserDonationsError, FundraisersGetSuperAdminFundraiserDonationsResponse, ReturnType<typeof fundraisersGetSuperAdminFundraiserDonationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetSuperAdminFundraiserDonations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetSuperAdminFundraiserDonationsQueryKey(options)
});

/**
 * Resolve Fundraiser Message Objection
 *
 * RESOLVE an objection (FCA-BE9): ``takedown`` keeps the message dark (status
 * TAKEN_DOWN, still suppresses); ``reinstate`` restores it (status REINSTATED, no
 * longer suppresses). ``objection_id`` MUST belong to ``fundraiser_id`` (else 404,
 * no cross-fundraiser oracle). ``note`` is optional audit context. Suppression is
 * ``EXISTS(OPEN or TAKEN_DOWN)`` across a fundraiser's objections, so reinstating
 * one lifts suppression only when no other OPEN/TAKEN_DOWN objection remains.
 */
export const superAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionMutation = (options?: Partial<Options<SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionData>>): UseMutationOptions<SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionResponse, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionError, Options<SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionResponse, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionError, Options<SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminFundraiserMessageObjectionsResolveFundraiserMessageObjection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Reinstate Fundraiser
 *
 * Undo Givmo's takedown of a fundraiser: it returns to the state it had before the
 * takedown (a closed one stays closed, a never-published one a draft), and its
 * organizers are emailed. The pending invites the takedown revoked do not come back,
 * and neither does a cover the admin deleted with the takedown's `delete_cover_image`.
 */
export const fundraisersAdminReinstateFundraiserMutation = (options?: Partial<Options<FundraisersAdminReinstateFundraiserData>>): UseMutationOptions<FundraisersAdminReinstateFundraiserResponse, FundraisersAdminReinstateFundraiserError, Options<FundraisersAdminReinstateFundraiserData>> => {
    const mutationOptions: UseMutationOptions<FundraisersAdminReinstateFundraiserResponse, FundraisersAdminReinstateFundraiserError, Options<FundraisersAdminReinstateFundraiserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraisersAdminReinstateFundraiser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const giftCardsListGiftCardsSuperAdminQueryKey = (options?: Options<GiftCardsListGiftCardsSuperAdminData>) => createQueryKey('gift-cards-list_gift_cards_super_admin', options);

/**
 * List Gift Cards Super Admin
 *
 * Paginated list of gift cards for the super-admin portal, with optional
 * status / channel / funding / batch_id filters. The response never carries
 * a plaintext code or code_hash (GiftCardAdminOut exposes code_last4 only).
 *
 * `q` is a case-insensitive substring match across code_last4, purchaser name,
 * purchaser email, recipient name, recipient email, and id, applied server-side
 * (composing with the status/channel/funding/batch filters) so the client can
 * search + page the whole corpus instead of loading everything and searching
 * in-memory.
 */
export const giftCardsListGiftCardsSuperAdminOptions = (options?: Options<GiftCardsListGiftCardsSuperAdminData>) => queryOptions<GiftCardsListGiftCardsSuperAdminResponse, GiftCardsListGiftCardsSuperAdminError, GiftCardsListGiftCardsSuperAdminResponse, ReturnType<typeof giftCardsListGiftCardsSuperAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await giftCardsListGiftCardsSuperAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: giftCardsListGiftCardsSuperAdminQueryKey(options)
});

/**
 * Manual Issue Gift Card
 *
 * Manually issue an ADMIN_ISSUED card (soft-launch / B2B / promo). No
 * charge, no receipt, no velocity window; a delivery email carries the
 * code.
 */
export const giftCardsManualIssueGiftCardMutation = (options?: Partial<Options<GiftCardsManualIssueGiftCardData>>): UseMutationOptions<GiftCardsManualIssueGiftCardResponse, GiftCardsManualIssueGiftCardError, Options<GiftCardsManualIssueGiftCardData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsManualIssueGiftCardResponse, GiftCardsManualIssueGiftCardError, Options<GiftCardsManualIssueGiftCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsManualIssueGiftCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reissue Failed Batch Deliveries
 *
 * EP-BE4 bulk recovery: void + reissue every card in this employer batch whose
 * async delivery is terminally FAILED and which is still ACTIVE, re-delivering the
 * replacements through the SAME async Cloud Tasks path the original bulk send used
 * (never N synchronous sends). 202 with the per-stage counts + the replacement ids.
 *
 * Modeled on `POST /super-admin/terms/{id}/notify/retry-failed-batches`: 202,
 * failed units only, in-flight units untouched. `Idempotency-Key` is REQUIRED (a
 * missing header 422s) and `claim_idempotency` replays the original 202 for a
 * retried call, so a lost response never re-mints a second set of codes.
 *
 * Recovery is void+reissue rather than a re-drive because a gift card's plaintext
 * code is request-scoped and never stored — no sweep can ever re-deliver the code
 * a failed card was carrying, so the only honest repair is a fresh one.
 *
 * NO money moves: no charge, no wallet debit, no receipt, no velocity check. A
 * re-run is safe by construction (the ACTIVE half of the selector drops
 * already-recovered cards), and per-card transactionality means one bad row never
 * strands the rest of the batch's recipients. Deliberately NOT gated on
 * `COMPANY_GIFT_CARDS_ENABLED`: it is the bulk form of the un-gated per-card
 * `PUT .../void` + `POST .../reissue` recovery pair, and an operator flipping the
 * employer kill switch during an incident must not thereby lose the remediation
 * tool. With no batches in an environment it simply 404s.
 */
export const giftCardsReissueFailedBatchDeliveriesMutation = (options?: Partial<Options<GiftCardsReissueFailedBatchDeliveriesData>>): UseMutationOptions<GiftCardsReissueFailedBatchDeliveriesResponse, GiftCardsReissueFailedBatchDeliveriesError, Options<GiftCardsReissueFailedBatchDeliveriesData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsReissueFailedBatchDeliveriesResponse, GiftCardsReissueFailedBatchDeliveriesError, Options<GiftCardsReissueFailedBatchDeliveriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsReissueFailedBatchDeliveries({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reissue Gift Card
 *
 * Void the original and mint a fresh ACTIVE card with a new code,
 * redelivering it. Returns the new card.
 *
 * GC-FU7: the optional body corrects the replacement's recipient (support's remedy
 * for a mistyped address, D-GC-8). Each field given replaces the original's; absent
 * or null keeps it, so no body (or ``{}``) reissues exactly as before, and a field equal
 * to the card's own value counts as absent. An unknown key is a 422. The voided
 * original keeps its old address, the purchaser never changes, and no money moves.
 * A code-less scheduled card, refused without a correction, takes one: its
 * replacement stays scheduled for the same date, at the corrected address.
 *
 * Honors the ``Idempotency-Key`` header (presence-triggered, 02·F2): a
 * retried reissue carrying the same key replays the original 201 rather than
 * re-voiding/re-minting and re-sending the delivery email, so a lost response
 * is safe to retry. The fingerprint covers the body, so the same key with a
 * different correction is a 409 ``IDEMPOTENCY_KEY_REUSED`` that runs nothing;
 * the super-admin client mints one key per intent (the card and its correction),
 * so a changed address is a new key. The response is ``GiftCardAdminOut``, which
 * never carries the plaintext code, so the cached replay is safe. An unkeyed
 * request passes through unprotected (its retry still 400s on the already-voided
 * original — the void state machine remains the floor).
 */
export const giftCardsReissueGiftCardMutation = (options?: Partial<Options<GiftCardsReissueGiftCardData>>): UseMutationOptions<GiftCardsReissueGiftCardResponse, GiftCardsReissueGiftCardError, Options<GiftCardsReissueGiftCardData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsReissueGiftCardResponse, GiftCardsReissueGiftCardError, Options<GiftCardsReissueGiftCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsReissueGiftCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Void Gift Card
 *
 * Void an INACTIVE/ACTIVE card. A REDEEMED card cannot be voided (400).
 */
export const giftCardsVoidGiftCardMutation = (options?: Partial<Options<GiftCardsVoidGiftCardData>>): UseMutationOptions<GiftCardsVoidGiftCardResponse, GiftCardsVoidGiftCardError, Options<GiftCardsVoidGiftCardData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsVoidGiftCardResponse, GiftCardsVoidGiftCardError, Options<GiftCardsVoidGiftCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsVoidGiftCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const grantsGetSuperAdminGrantsQueryKey = (options?: Options<GrantsGetSuperAdminGrantsData>) => createQueryKey('grants-get_super_admin_grants', options);

/**
 * Get Super Admin Grants
 */
export const grantsGetSuperAdminGrantsOptions = (options?: Options<GrantsGetSuperAdminGrantsData>) => queryOptions<GrantsGetSuperAdminGrantsResponse, GrantsGetSuperAdminGrantsError, GrantsGetSuperAdminGrantsResponse, ReturnType<typeof grantsGetSuperAdminGrantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await grantsGetSuperAdminGrants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: grantsGetSuperAdminGrantsQueryKey(options)
});

export const superAdminGrantsOpsListGroupExemptionCuresQueryKey = (options: Options<SuperAdminGrantsOpsListGroupExemptionCuresData>) => createQueryKey('super-admin-grants-ops-list_group_exemption_cures', options);

/**
 * List Group Exemption Cures
 *
 * GD-A9: the charity's attestations (newest first, each with its revocation), its
 * current cure as it stands now, and the letters on record for its GEN.
 */
export const superAdminGrantsOpsListGroupExemptionCuresOptions = (options: Options<SuperAdminGrantsOpsListGroupExemptionCuresData>) => queryOptions<SuperAdminGrantsOpsListGroupExemptionCuresResponse, SuperAdminGrantsOpsListGroupExemptionCuresError, SuperAdminGrantsOpsListGroupExemptionCuresResponse, ReturnType<typeof superAdminGrantsOpsListGroupExemptionCuresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsListGroupExemptionCures({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsListGroupExemptionCuresQueryKey(options)
});

/**
 * Attest Group Exemption Cure
 *
 * GD-A9: record the President's attestation of one charity's cure packet.
 *
 * Only an attester's own signed-in session completes it (``@human_only(2)`` and the
 * committed attester list; another super-admin is refused 403). ``201`` on both a new
 * attestation (``created=true``) and an identical repeat (``created=false``) — branch
 * on ``created``. ``409`` when the charity's verdict is not
 * ``SUBORDINATE_RELIANCE_UNAVAILABLE``, the EIN, GEN or foundation code differs from
 * the IRS file, a later letter of the central is on record, a § 320(a)(3) cascade is
 * active, or ``supersedes_id`` does not name the current attestation. After it commits,
 * the charity's FULL payee floor re-runs (a bank account it already entered may now
 * bind), never a direct bind.
 */
export const superAdminGrantsOpsAttestGroupExemptionCureMutation = (options?: Partial<Options<SuperAdminGrantsOpsAttestGroupExemptionCureData>>): UseMutationOptions<SuperAdminGrantsOpsAttestGroupExemptionCureResponse, SuperAdminGrantsOpsAttestGroupExemptionCureError, Options<SuperAdminGrantsOpsAttestGroupExemptionCureData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGrantsOpsAttestGroupExemptionCureResponse, SuperAdminGrantsOpsAttestGroupExemptionCureError, Options<SuperAdminGrantsOpsAttestGroupExemptionCureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGrantsOpsAttestGroupExemptionCure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminGrantsOpsListCharityBucketsQueryKey = (options?: Options<SuperAdminGrantsOpsListCharityBucketsData>) => createQueryKey('super-admin-grants-ops-list_charity_buckets', options);

/**
 * List Charity Buckets
 *
 * View 2 list: charities with a live PENDING accumulator bucket, each with its
 * settled-and-fundable-tonight, settled-but-held and unsettled (awaiting payout)
 * money, earliest §320 deadline + eligibility + payee-linked flags. Detail:
 * ``/charity-buckets/{id}``.
 */
export const superAdminGrantsOpsListCharityBucketsOptions = (options?: Options<SuperAdminGrantsOpsListCharityBucketsData>) => queryOptions<SuperAdminGrantsOpsListCharityBucketsResponse, SuperAdminGrantsOpsListCharityBucketsError, SuperAdminGrantsOpsListCharityBucketsResponse, ReturnType<typeof superAdminGrantsOpsListCharityBucketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsListCharityBuckets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsListCharityBucketsQueryKey(options)
});

export const superAdminGrantsOpsGetCharityBucketQueryKey = (options: Options<SuperAdminGrantsOpsGetCharityBucketData>) => createQueryKey('super-admin-grants-ops-get_charity_bucket', options);

/**
 * Get Charity Bucket
 *
 * View 2 detail: one charity's undisbursed pool — fundable tonight, settled but
 * held, and unsettled; FIFO-ordered constituents, each with its money state and its
 * hold; deadline-risk list, payee status (Mercury recipient /
 * IRS-address fallback / open flags), eligibility snapshot, cumulative disbursed.
 */
export const superAdminGrantsOpsGetCharityBucketOptions = (options: Options<SuperAdminGrantsOpsGetCharityBucketData>) => queryOptions<SuperAdminGrantsOpsGetCharityBucketResponse, SuperAdminGrantsOpsGetCharityBucketError, SuperAdminGrantsOpsGetCharityBucketResponse, ReturnType<typeof superAdminGrantsOpsGetCharityBucketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsGetCharityBucket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsGetCharityBucketQueryKey(options)
});

export const superAdminGrantsOpsListCohortsQueryKey = (options?: Options<SuperAdminGrantsOpsListCohortsData>) => createQueryKey('super-admin-grants-ops-list_cohorts', options);

/**
 * List Cohorts
 *
 * View 3 list: the cohort & disbursement ledger — MINTED (awaiting payment),
 * SENT/COMPLETED history (keyed by Mercury txn), and disposed RETURNED/REJECTED
 * husks. Filter with ``status``. Detail (chunk lineage, constituents→donors,
 * reservation coverage, evidence, successor chain): ``/cohorts/{grant_id}``.
 */
export const superAdminGrantsOpsListCohortsOptions = (options?: Options<SuperAdminGrantsOpsListCohortsData>) => queryOptions<SuperAdminGrantsOpsListCohortsResponse, SuperAdminGrantsOpsListCohortsError, SuperAdminGrantsOpsListCohortsResponse, ReturnType<typeof superAdminGrantsOpsListCohortsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsListCohorts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsListCohortsQueryKey(options)
});

export const superAdminGrantsOpsGetCohortQueryKey = (options: Options<SuperAdminGrantsOpsGetCohortData>) => createQueryKey('super-admin-grants-ops-get_cohort', options);

/**
 * Get Cohort
 *
 * View 3 detail: one cohort grant — chunk lineage, constituents expandable to
 * donors, reservation coverage, the Mercury sent record-back + eligibility
 * evidence, recovery markers, and (for a disposed husk) the content-hash successor
 * chain.
 */
export const superAdminGrantsOpsGetCohortOptions = (options: Options<SuperAdminGrantsOpsGetCohortData>) => queryOptions<SuperAdminGrantsOpsGetCohortResponse, SuperAdminGrantsOpsGetCohortError, SuperAdminGrantsOpsGetCohortResponse, ReturnType<typeof superAdminGrantsOpsGetCohortQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsGetCohort({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsGetCohortQueryKey(options)
});

export const superAdminDisbursementApprovalsListDisbursementApprovalsQueryKey = (options?: Options<SuperAdminDisbursementApprovalsListDisbursementApprovalsData>) => createQueryKey('super-admin-disbursement-approvals-list_disbursement_approvals', options);

/**
 * List Disbursement Approvals
 *
 * The §5.2 portal read (SAPD-WEB5/BE1 rendering): newest-first, paginated
 * ``{data, meta, links}`` envelope, ``status`` served as the EFFECTIVE status
 * (a stored-approved row past its 7-day TTL reads ``expired``). Read-only,
 * superadmin-gated, deliberately NOT money-guarded.
 */
export const superAdminDisbursementApprovalsListDisbursementApprovalsOptions = (options?: Options<SuperAdminDisbursementApprovalsListDisbursementApprovalsData>) => queryOptions<SuperAdminDisbursementApprovalsListDisbursementApprovalsResponse, SuperAdminDisbursementApprovalsListDisbursementApprovalsError, SuperAdminDisbursementApprovalsListDisbursementApprovalsResponse, ReturnType<typeof superAdminDisbursementApprovalsListDisbursementApprovalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDisbursementApprovalsListDisbursementApprovals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDisbursementApprovalsListDisbursementApprovalsQueryKey(options)
});

/**
 * Record Disbursement Approval
 *
 * Record a ``disburse`` approval (SAPD-S1 §5.4): verify the referenced
 * escalation row + the REQUIRED stored-hash equality + the live cohort, then
 * record the write-once hash-bound row. 201 created; 200 idempotent repeat;
 * typed 409/422 refusals record NOTHING.
 */
export const superAdminDisbursementApprovalsRecordDisbursementApprovalMutation = (options?: Partial<Options<SuperAdminDisbursementApprovalsRecordDisbursementApprovalData>>): UseMutationOptions<SuperAdminDisbursementApprovalsRecordDisbursementApprovalResponse, SuperAdminDisbursementApprovalsRecordDisbursementApprovalError, Options<SuperAdminDisbursementApprovalsRecordDisbursementApprovalData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDisbursementApprovalsRecordDisbursementApprovalResponse, SuperAdminDisbursementApprovalsRecordDisbursementApprovalError, Options<SuperAdminDisbursementApprovalsRecordDisbursementApprovalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDisbursementApprovalsRecordDisbursementApproval({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Manual Payment Confirmation
 *
 * Record a ``manual_payment_confirmation`` (SAPD-S1 §7.4): the operator
 * confirms an outbound Mercury transaction as his own payment for the
 * proposal. The lane's existing fail-closed ``mark_operator_payment_sent``
 * verification runs before any record-back; this records state only.
 */
export const superAdminDisbursementApprovalsRecordManualPaymentConfirmationMutation = (options?: Partial<Options<SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationData>>): UseMutationOptions<SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationResponse, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationError, Options<SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationResponse, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationError, Options<SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDisbursementApprovalsRecordManualPaymentConfirmation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Disbursement Approval
 *
 * Revoke a standing approval (operator changed his mind before the lane
 * ran): ``approved`` → ``revoked``. Idempotent on repeat; a consumed /
 * superseded row refuses 409 ``approval_not_revocable``.
 */
export const superAdminDisbursementApprovalsRevokeDisbursementApprovalMutation = (options?: Partial<Options<SuperAdminDisbursementApprovalsRevokeDisbursementApprovalData>>): UseMutationOptions<SuperAdminDisbursementApprovalsRevokeDisbursementApprovalResponse, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalError, Options<SuperAdminDisbursementApprovalsRevokeDisbursementApprovalData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDisbursementApprovalsRevokeDisbursementApprovalResponse, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalError, Options<SuperAdminDisbursementApprovalsRevokeDisbursementApprovalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDisbursementApprovalsRevokeDisbursementApproval({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminGrantsOpsSearchDonationsQueryKey = (options?: Options<SuperAdminGrantsOpsSearchDonationsData>) => createQueryKey('super-admin-grants-ops-search_donations', options);

/**
 * Search Donations
 *
 * View 1 entry point: search donations by donor email/name, donation id, or
 * charge id (the ``q`` query param). An absent/blank ``q`` browses recent donations,
 * newest first. Flat, paginated hits; the full per-leg trail is
 * ``GET /donations/{id}/trail``.
 */
export const superAdminGrantsOpsSearchDonationsOptions = (options?: Options<SuperAdminGrantsOpsSearchDonationsData>) => queryOptions<SuperAdminGrantsOpsSearchDonationsResponse, SuperAdminGrantsOpsSearchDonationsError, SuperAdminGrantsOpsSearchDonationsResponse, ReturnType<typeof superAdminGrantsOpsSearchDonationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsSearchDonations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsSearchDonationsQueryKey(options)
});

export const superAdminGrantsOpsGetDonationTrailQueryKey = (options: Options<SuperAdminGrantsOpsGetDonationTrailData>) => createQueryKey('super-admin-grants-ops-get_donation_trail', options);

/**
 * Get Donation Trail
 *
 * View 1 detail: the full money-trail for a donation's whole gift — one trail
 * per charity leg (basket/ETF/collection splits fan the charge to N legs), each a
 * charged → contribution → settlement → bucket/cohort → sent → terminal timeline
 * with every record id.
 */
export const superAdminGrantsOpsGetDonationTrailOptions = (options: Options<SuperAdminGrantsOpsGetDonationTrailData>) => queryOptions<SuperAdminGrantsOpsGetDonationTrailResponse, SuperAdminGrantsOpsGetDonationTrailError, SuperAdminGrantsOpsGetDonationTrailResponse, ReturnType<typeof superAdminGrantsOpsGetDonationTrailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsGetDonationTrail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsGetDonationTrailQueryKey(options)
});

export const superAdminGrantsOpsGetEligibilityEvidenceQueryKey = (options: Options<SuperAdminGrantsOpsGetEligibilityEvidenceData>) => createQueryKey('super-admin-grants-ops-get_eligibility_evidence', options);

/**
 * Get Eligibility Evidence
 *
 * The immutable eligibility-evidence rows soft-correlated to a grant/cohort id
 * (the IRS-signal snapshot the money lane records at disbursement time).
 */
export const superAdminGrantsOpsGetEligibilityEvidenceOptions = (options: Options<SuperAdminGrantsOpsGetEligibilityEvidenceData>) => queryOptions<SuperAdminGrantsOpsGetEligibilityEvidenceResponse, SuperAdminGrantsOpsGetEligibilityEvidenceError, SuperAdminGrantsOpsGetEligibilityEvidenceResponse, ReturnType<typeof superAdminGrantsOpsGetEligibilityEvidenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsGetEligibilityEvidence({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsGetEligibilityEvidenceQueryKey(options)
});

/**
 * Revoke Group Exemption Cure
 *
 * GD-A9: withdraw the charity's current attestation (a trigger fired, or it was made
 * in error). In the same act the charity's BOUND payee binding pauses. ``409`` when it
 * was already revoked or is not the current attestation; ``SUPERSEDED`` is recorded by
 * a new attestation, never here (422).
 */
export const superAdminGrantsOpsRevokeGroupExemptionCureMutation = (options?: Partial<Options<SuperAdminGrantsOpsRevokeGroupExemptionCureData>>): UseMutationOptions<SuperAdminGrantsOpsRevokeGroupExemptionCureResponse, SuperAdminGrantsOpsRevokeGroupExemptionCureError, Options<SuperAdminGrantsOpsRevokeGroupExemptionCureData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGrantsOpsRevokeGroupExemptionCureResponse, SuperAdminGrantsOpsRevokeGroupExemptionCureError, Options<SuperAdminGrantsOpsRevokeGroupExemptionCureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGrantsOpsRevokeGroupExemptionCure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Group Ruling Letter
 *
 * GD-A9: record that a central's IRS group-ruling letter has issued. Every cure on
 * its GEN read against an older letter lapses at once, and each such charity's BOUND
 * payee binding pauses in the same act.
 */
export const superAdminGrantsOpsRecordGroupRulingLetterMutation = (options?: Partial<Options<SuperAdminGrantsOpsRecordGroupRulingLetterData>>): UseMutationOptions<SuperAdminGrantsOpsRecordGroupRulingLetterResponse, SuperAdminGrantsOpsRecordGroupRulingLetterError, Options<SuperAdminGrantsOpsRecordGroupRulingLetterData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGrantsOpsRecordGroupRulingLetterResponse, SuperAdminGrantsOpsRecordGroupRulingLetterError, Options<SuperAdminGrantsOpsRecordGroupRulingLetterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGrantsOpsRecordGroupRulingLetter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw Group Ruling Letter
 *
 * GD-A9: withdraw a letter record made in error. Cures it lapsed may stand again, so
 * only a person completes it (``@human_only(2)``), and each such charity's FULL payee
 * floor re-runs after it commits.
 */
export const superAdminGrantsOpsWithdrawGroupRulingLetterMutation = (options?: Partial<Options<SuperAdminGrantsOpsWithdrawGroupRulingLetterData>>): UseMutationOptions<SuperAdminGrantsOpsWithdrawGroupRulingLetterResponse, SuperAdminGrantsOpsWithdrawGroupRulingLetterError, Options<SuperAdminGrantsOpsWithdrawGroupRulingLetterData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGrantsOpsWithdrawGroupRulingLetterResponse, SuperAdminGrantsOpsWithdrawGroupRulingLetterError, Options<SuperAdminGrantsOpsWithdrawGroupRulingLetterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGrantsOpsWithdrawGroupRulingLetter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Ineligibility Determination
 *
 * Explicitly record held-funds determinations; never blocks or moves funds.
 */
export const superAdminGrantsOpsRecordIneligibilityDeterminationMutation = (options?: Partial<Options<SuperAdminGrantsOpsRecordIneligibilityDeterminationData>>): UseMutationOptions<SuperAdminGrantsOpsRecordIneligibilityDeterminationResponse, SuperAdminGrantsOpsRecordIneligibilityDeterminationError, Options<SuperAdminGrantsOpsRecordIneligibilityDeterminationData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGrantsOpsRecordIneligibilityDeterminationResponse, SuperAdminGrantsOpsRecordIneligibilityDeterminationError, Options<SuperAdminGrantsOpsRecordIneligibilityDeterminationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGrantsOpsRecordIneligibilityDetermination({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Ineligibility Alternate
 *
 * Book a donor's alternate; does not re-point, select, or execute funds.
 */
export const superAdminGrantsOpsRecordIneligibilityAlternateMutation = (options?: Partial<Options<SuperAdminGrantsOpsRecordIneligibilityAlternateData>>): UseMutationOptions<SuperAdminGrantsOpsRecordIneligibilityAlternateResponse, SuperAdminGrantsOpsRecordIneligibilityAlternateError, Options<SuperAdminGrantsOpsRecordIneligibilityAlternateData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGrantsOpsRecordIneligibilityAlternateResponse, SuperAdminGrantsOpsRecordIneligibilityAlternateError, Options<SuperAdminGrantsOpsRecordIneligibilityAlternateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGrantsOpsRecordIneligibilityAlternate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Ineligibility Notice
 *
 * Record the actual written-notice t0; this endpoint does not send it.
 */
export const superAdminGrantsOpsRecordIneligibilityNoticeMutation = (options?: Partial<Options<SuperAdminGrantsOpsRecordIneligibilityNoticeData>>): UseMutationOptions<SuperAdminGrantsOpsRecordIneligibilityNoticeResponse, SuperAdminGrantsOpsRecordIneligibilityNoticeError, Options<SuperAdminGrantsOpsRecordIneligibilityNoticeData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGrantsOpsRecordIneligibilityNoticeResponse, SuperAdminGrantsOpsRecordIneligibilityNoticeError, Options<SuperAdminGrantsOpsRecordIneligibilityNoticeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGrantsOpsRecordIneligibilityNotice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminGrantsOpsGetOpsStripQueryKey = (options?: Options<SuperAdminGrantsOpsGetOpsStripData>) => createQueryKey('super-admin-grants-ops-get_ops_strip', options);

/**
 * Get Ops Strip
 *
 * View 4: the "what will happen tonight" header — BACKEND-DERIVABLE aggregates
 * only (MINTED-awaiting-payment count+amount, deadline-risk buckets, the fundable-
 * tonight, settled-but-held and unsettled pool totals, per-status breakdown).
 * Brain-only state (kill switch,
 * sweep/low-water markers, Mercury pending-approval count, cap config) is OUT of
 * backend v1 and not mirrored here.
 */
export const superAdminGrantsOpsGetOpsStripOptions = (options?: Options<SuperAdminGrantsOpsGetOpsStripData>) => queryOptions<SuperAdminGrantsOpsGetOpsStripResponse, DefaultError, SuperAdminGrantsOpsGetOpsStripResponse, ReturnType<typeof superAdminGrantsOpsGetOpsStripQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGrantsOpsGetOpsStrip({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGrantsOpsGetOpsStripQueryKey(options)
});

export const grantsGetSuperAdminGrantDonationsQueryKey = (options: Options<GrantsGetSuperAdminGrantDonationsData>) => createQueryKey('grants-get_super_admin_grant_donations', options);

/**
 * Get Super Admin Grant Donations
 */
export const grantsGetSuperAdminGrantDonationsOptions = (options: Options<GrantsGetSuperAdminGrantDonationsData>) => queryOptions<GrantsGetSuperAdminGrantDonationsResponse, GrantsGetSuperAdminGrantDonationsError, GrantsGetSuperAdminGrantDonationsResponse, ReturnType<typeof grantsGetSuperAdminGrantDonationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await grantsGetSuperAdminGrantDonations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: grantsGetSuperAdminGrantDonationsQueryKey(options)
});

export const superAdminGroupOpsGetGroupsForModerationQueryKey = (options?: Options<SuperAdminGroupOpsGetGroupsForModerationData>) => createQueryKey('super-admin-group-ops-get_groups_for_moderation', options);

/**
 * Get Groups For Moderation
 *
 * List/search DRAFT, ACTIVE, DISSOLVED, listed, and unlisted groups.
 *
 * ``q`` is a case-insensitive substring over handle/name/id. This operator
 * endpoint is deliberately usable while ``GROUPS_ENABLED`` is off.
 */
export const superAdminGroupOpsGetGroupsForModerationOptions = (options?: Options<SuperAdminGroupOpsGetGroupsForModerationData>) => queryOptions<SuperAdminGroupOpsGetGroupsForModerationResponse, SuperAdminGroupOpsGetGroupsForModerationError, SuperAdminGroupOpsGetGroupsForModerationResponse, ReturnType<typeof superAdminGroupOpsGetGroupsForModerationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminGroupOpsGetGroupsForModeration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminGroupOpsGetGroupsForModerationQueryKey(options)
});

/**
 * Evacuate Group Funds
 *
 * GRP-BE20c break-glass: grant OUT the group's pooled-wallet balance to
 * ``target_charity_id`` (a fee-free wallet grant riding the existing GD pipeline)
 * so the group can then be normally dissolved. Omit ``amount`` to evacuate the FULL
 * available balance (zero the wallet). UN-flagged (works while ``GROUPS_ENABLED`` is
 * off); super-admin-gated. Moves no Shift4 charge.
 */
export const superAdminGroupOpsEvacuateGroupFundsMutation = (options?: Partial<Options<SuperAdminGroupOpsEvacuateGroupFundsData>>): UseMutationOptions<SuperAdminGroupOpsEvacuateGroupFundsResponse, SuperAdminGroupOpsEvacuateGroupFundsError, Options<SuperAdminGroupOpsEvacuateGroupFundsData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGroupOpsEvacuateGroupFundsResponse, SuperAdminGroupOpsEvacuateGroupFundsError, Options<SuperAdminGroupOpsEvacuateGroupFundsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGroupOpsEvacuateGroupFunds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Moderate Group
 *
 * Reset one group identity field: name, neutral handle, or stored image.
 */
export const superAdminGroupOpsModerateGroupMutation = (options?: Partial<Options<SuperAdminGroupOpsModerateGroupData>>): UseMutationOptions<SuperAdminGroupOpsModerateGroupResponse, SuperAdminGroupOpsModerateGroupError, Options<SuperAdminGroupOpsModerateGroupData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGroupOpsModerateGroupResponse, SuperAdminGroupOpsModerateGroupError, Options<SuperAdminGroupOpsModerateGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGroupOpsModerateGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Relist Group
 *
 * Clear the moderation trio and restore normal public reach.
 */
export const superAdminGroupOpsRelistGroupMutation = (options?: Partial<Options<SuperAdminGroupOpsRelistGroupData>>): UseMutationOptions<SuperAdminGroupOpsRelistGroupResponse, SuperAdminGroupOpsRelistGroupError, Options<SuperAdminGroupOpsRelistGroupData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGroupOpsRelistGroupResponse, SuperAdminGroupOpsRelistGroupError, Options<SuperAdminGroupOpsRelistGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGroupOpsRelistGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlist Group
 *
 * Hide a group from discovery/non-member direct reads without dissolving it.
 */
export const superAdminGroupOpsUnlistGroupMutation = (options?: Partial<Options<SuperAdminGroupOpsUnlistGroupData>>): UseMutationOptions<SuperAdminGroupOpsUnlistGroupResponse, SuperAdminGroupOpsUnlistGroupError, Options<SuperAdminGroupOpsUnlistGroupData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminGroupOpsUnlistGroupResponse, SuperAdminGroupOpsUnlistGroupError, Options<SuperAdminGroupOpsUnlistGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminGroupOpsUnlistGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminMatchOffersListMatchOffersQueryKey = (options?: Options<SuperAdminMatchOffersListMatchOffersData>) => createQueryKey('super-admin-match-offers-list_match_offers', options);

/**
 * List Match Offers
 *
 * The CROSS-USER offer list (03 §6), newest-first, all statuses, paginated —
 * the whole point of the super-admin surface (any offeror's offer appears, not
 * just the caller's). Each item carries its legs + display consent-status.
 * Optionally narrow with ``?status=`` and/or ``?offeror_user_id=``. Domain-scoped,
 * no wallet-history breakout.
 */
export const superAdminMatchOffersListMatchOffersOptions = (options?: Options<SuperAdminMatchOffersListMatchOffersData>) => queryOptions<SuperAdminMatchOffersListMatchOffersResponse, SuperAdminMatchOffersListMatchOffersError, SuperAdminMatchOffersListMatchOffersResponse, ReturnType<typeof superAdminMatchOffersListMatchOffersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminMatchOffersListMatchOffers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminMatchOffersListMatchOffersQueryKey(options)
});

export const superAdminMatchOffersGetMatchOfferDetailQueryKey = (options: Options<SuperAdminMatchOffersGetMatchOfferDetailData>) => createQueryKey('super-admin-match-offers-get_match_offer_detail', options);

/**
 * Get Match Offer Detail
 *
 * One offer + its legs (03 §6), NO ownership filter (a super-admin reads any
 * offer). An absent id → 404. The claims list is a SEPARATE paginated drill-down
 * (``/claims``) — an offer can carry unbounded claim counts.
 */
export const superAdminMatchOffersGetMatchOfferDetailOptions = (options: Options<SuperAdminMatchOffersGetMatchOfferDetailData>) => queryOptions<SuperAdminMatchOffersGetMatchOfferDetailResponse, SuperAdminMatchOffersGetMatchOfferDetailError, SuperAdminMatchOffersGetMatchOfferDetailResponse, ReturnType<typeof superAdminMatchOffersGetMatchOfferDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminMatchOffersGetMatchOfferDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminMatchOffersGetMatchOfferDetailQueryKey(options)
});

export const superAdminMatchOffersListMatchOfferClaimsQueryKey = (options: Options<SuperAdminMatchOffersListMatchOfferClaimsData>) => createQueryKey('super-admin-match-offers-list_match_offer_claims', options);

/**
 * List Match Offer Claims
 *
 * The paginated claims drill-down for one offer (03 §6), newest-claim-first.
 * Each claim carries a resolved + MASKED claimer identity (resolved via
 * donation→domain→user, BATCHED; the mask is a backend-computed "First L." plus the
 * raw ``claimer_user_id`` for a full-record drill-in) + ``amount`` +
 * ``settlement_status``. A SEPARATE route from detail — an offer can accrue
 * unbounded claim counts.
 */
export const superAdminMatchOffersListMatchOfferClaimsOptions = (options: Options<SuperAdminMatchOffersListMatchOfferClaimsData>) => queryOptions<SuperAdminMatchOffersListMatchOfferClaimsResponse, SuperAdminMatchOffersListMatchOfferClaimsError, SuperAdminMatchOffersListMatchOfferClaimsResponse, ReturnType<typeof superAdminMatchOffersListMatchOfferClaimsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminMatchOffersListMatchOfferClaims({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminMatchOffersListMatchOfferClaimsQueryKey(options)
});

/**
 * Redirect Match Claim Admin
 *
 * The X.3 GCF-SELECTS fallback (PV2-BE8 — "if you do not, Givmo Charitable may
 * select an eligible alternate charity consistent with your charitable intent"):
 * redirect any offeror's DECLINED (needs_review) claim to the admin-chosen
 * eligible alternate. NOT ownership-scoped; allowed on a SUSPENDED/VOIDED offer
 * (the admin IS the review). Same execution primitive + screens + machine-coded
 * conflicts as the consumer redirect; idempotent/replay-safe (re-submitting the
 * granted alternate returns the recorded success; anything else on a settled
 * claim → 409 ``CLAIM_NOT_REDIRECTABLE``). Audited: acting admin + ``reason``
 * stamp the claim row and the ``match_offer_claim_redirected`` structured log;
 * the offeror is notified via the non-receipt grant confirmation.
 */
export const superAdminMatchOffersRedirectMatchClaimAdminMutation = (options?: Partial<Options<SuperAdminMatchOffersRedirectMatchClaimAdminData>>): UseMutationOptions<SuperAdminMatchOffersRedirectMatchClaimAdminResponse, SuperAdminMatchOffersRedirectMatchClaimAdminError, Options<SuperAdminMatchOffersRedirectMatchClaimAdminData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminMatchOffersRedirectMatchClaimAdminResponse, SuperAdminMatchOffersRedirectMatchClaimAdminError, Options<SuperAdminMatchOffersRedirectMatchClaimAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminMatchOffersRedirectMatchClaimAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Match Offer Leg
 *
 * RESUME a suspended LEG (03 §6): SUSPENDED→ACTIVE. Idempotent. Missing
 * offer/leg → 404; a non-SUSPENDED (ENDED/ACTIVE) leg → 409/no-op.
 */
export const superAdminMatchOffersResumeMatchOfferLegMutation = (options?: Partial<Options<SuperAdminMatchOffersResumeMatchOfferLegData>>): UseMutationOptions<SuperAdminMatchOffersResumeMatchOfferLegResponse, SuperAdminMatchOffersResumeMatchOfferLegError, Options<SuperAdminMatchOffersResumeMatchOfferLegData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminMatchOffersResumeMatchOfferLegResponse, SuperAdminMatchOffersResumeMatchOfferLegError, Options<SuperAdminMatchOffersResumeMatchOfferLegData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminMatchOffersResumeMatchOfferLeg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Suspend Match Offer Leg
 *
 * SUSPEND a single LEG on an eligibility event (03 §6 / 02 §1.7): the leg stops
 * taking claims; the pool + the other legs are unaffected. Idempotent. Missing
 * offer/leg → 404; an ENDED leg → 409. Returns the offer (the module re-reads
 * the offer's legs from it).
 */
export const superAdminMatchOffersSuspendMatchOfferLegMutation = (options?: Partial<Options<SuperAdminMatchOffersSuspendMatchOfferLegData>>): UseMutationOptions<SuperAdminMatchOffersSuspendMatchOfferLegResponse, SuperAdminMatchOffersSuspendMatchOfferLegError, Options<SuperAdminMatchOffersSuspendMatchOfferLegData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminMatchOffersSuspendMatchOfferLegResponse, SuperAdminMatchOffersSuspendMatchOfferLegError, Options<SuperAdminMatchOffersSuspendMatchOfferLegData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminMatchOffersSuspendMatchOfferLeg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Match Offer
 *
 * RESUME a suspended offer (03 §6): SUSPENDED→ACTIVE, restore solicitation.
 * Idempotent. Missing offer → 404; non-SUSPENDED → 409.
 */
export const superAdminMatchOffersResumeMatchOfferMutation = (options?: Partial<Options<SuperAdminMatchOffersResumeMatchOfferData>>): UseMutationOptions<SuperAdminMatchOffersResumeMatchOfferResponse, SuperAdminMatchOffersResumeMatchOfferError, Options<SuperAdminMatchOffersResumeMatchOfferData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminMatchOffersResumeMatchOfferResponse, SuperAdminMatchOffersResumeMatchOfferError, Options<SuperAdminMatchOffersResumeMatchOfferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminMatchOffersResumeMatchOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Suspend Match Offer
 *
 * PAUSE an offer's solicitation WITHOUT releasing the hold (03 §6): stop taking
 * claims, keep the reservation. Idempotent. Missing offer → 404; non-ACTIVE → 409.
 */
export const superAdminMatchOffersSuspendMatchOfferMutation = (options?: Partial<Options<SuperAdminMatchOffersSuspendMatchOfferData>>): UseMutationOptions<SuperAdminMatchOffersSuspendMatchOfferResponse, SuperAdminMatchOffersSuspendMatchOfferError, Options<SuperAdminMatchOffersSuspendMatchOfferData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminMatchOffersSuspendMatchOfferResponse, SuperAdminMatchOffersSuspendMatchOfferError, Options<SuperAdminMatchOffersSuspendMatchOfferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminMatchOffersSuspendMatchOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Void Match Offer
 *
 * FORCE-TERMINATE an offer (03 §6): release ONLY the unclaimed remainder (a
 * claimed dollar is never un-held — irrevocability), end every leg, set VOIDED.
 * Idempotent. A missing offer → 404; a claim-terminal offer → 409.
 */
export const superAdminMatchOffersVoidMatchOfferMutation = (options?: Partial<Options<SuperAdminMatchOffersVoidMatchOfferData>>): UseMutationOptions<SuperAdminMatchOffersVoidMatchOfferResponse, SuperAdminMatchOffersVoidMatchOfferError, Options<SuperAdminMatchOffersVoidMatchOfferData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminMatchOffersVoidMatchOfferResponse, SuperAdminMatchOffersVoidMatchOfferError, Options<SuperAdminMatchOffersVoidMatchOfferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminMatchOffersVoidMatchOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminOperatorDashboardGetTelemetryEventSummaryQueryKey = (options?: Options<SuperAdminOperatorDashboardGetTelemetryEventSummaryData>) => createQueryKey('super-admin-operator-dashboard-get_telemetry_event_summary', options);

/**
 * Get Telemetry Event Summary
 */
export const superAdminOperatorDashboardGetTelemetryEventSummaryOptions = (options?: Options<SuperAdminOperatorDashboardGetTelemetryEventSummaryData>) => queryOptions<SuperAdminOperatorDashboardGetTelemetryEventSummaryResponse, SuperAdminOperatorDashboardGetTelemetryEventSummaryError, SuperAdminOperatorDashboardGetTelemetryEventSummaryResponse, ReturnType<typeof superAdminOperatorDashboardGetTelemetryEventSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminOperatorDashboardGetTelemetryEventSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminOperatorDashboardGetTelemetryEventSummaryQueryKey(options)
});

/**
 * Acknowledge Machine Credit Alarm
 *
 * Acknowledge the dashboard's machine-credit alarm for one arrival.
 *
 * The automated lane credits under the President's standing authorization, so the
 * operator is TOLD rather than asked — and the queue class holds each credit until
 * he says he has seen it. This is that act, and nothing else: it stamps
 * ``acknowledged_at``/``acknowledged_by`` on the evidence row and removes it from the
 * class. It moves no money, changes no credit, no arrival and no wallet.
 *
 * ⚠ ``require_money_action_guard`` deliberately does NOT apply, and the reasoning is
 * the guard's own scope rather than convenience: the guard is for money-MOVING
 * super-admin mutations (step-up auth, per-actor rate limit, single-use App Check),
 * and acknowledging a notice moves nothing. The money already moved, at the credit
 * chokepoint, under the guard the console credit carries. Putting a step-up ceremony
 * in front of "I saw this" would train the operator to click through step-up, which
 * is how the guard stops meaning anything where it does matter.
 *
 * Auth is the surface's usual triple gate: router-level ``require_superadmin``, the
 * inline ``_require_user``, and the service method's own
 * ``@has_superadmin_permission``.
 *
 * Idempotent forward-only: acknowledging an already-acknowledged alarm returns
 * ``acknowledged: False`` and leaves the FIRST operator's name on the row, rather
 * than re-stamping and losing who actually saw it.
 */
export const superAdminOperatorDashboardAcknowledgeMachineCreditAlarmMutation = (options?: Partial<Options<SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmData>>): UseMutationOptions<SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmResponse, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmError, Options<SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmResponse, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmError, Options<SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminOperatorDashboardAcknowledgeMachineCreditAlarm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminOperatorDashboardGetOperatorQueueQueryKey = (options?: Options<SuperAdminOperatorDashboardGetOperatorQueueData>) => createQueryKey('super-admin-operator-dashboard-get_operator_queue', options);

/**
 * Get Operator Queue
 *
 * The operator action queue over every application-DB operator-pending class.
 *
 * Complete by construction: every registered class is attempted on every call,
 * with no admitted-type allowlist and no cap that hides work. Each class reports
 * ``ok``/``empty``/``dark``/``error``/``unsupported`` independently, so a
 * flag-dark feature or a failed sub-query can never render as a zero and one
 * class failing cannot zero the page.
 */
export const superAdminOperatorDashboardGetOperatorQueueOptions = (options?: Options<SuperAdminOperatorDashboardGetOperatorQueueData>) => queryOptions<SuperAdminOperatorDashboardGetOperatorQueueResponse, SuperAdminOperatorDashboardGetOperatorQueueError, SuperAdminOperatorDashboardGetOperatorQueueResponse, ReturnType<typeof superAdminOperatorDashboardGetOperatorQueueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminOperatorDashboardGetOperatorQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminOperatorDashboardGetOperatorQueueQueryKey(options)
});

export const superAdminOperatorDashboardGetOperatorStatsQueryKey = (options?: Options<SuperAdminOperatorDashboardGetOperatorStatsData>) => createQueryKey('super-admin-operator-dashboard-get_operator_stats', options);

/**
 * Get Operator Stats
 *
 * The operator dashboard's stuck-money alarms and operator statistics.
 *
 * Sibling of ``/queue`` and governed by the same contract: every alarm and every
 * statistic reports ``ok``/``empty``/``dark``/``error``/``unsupported``
 * independently, so a flag-dark feature or a failed sub-query can never render as
 * a zero — or as ``$0.00`` — and one failing read cannot zero the page. Composed
 * money figures are stricter still: a headline appears only when every component
 * behind it established a figure.
 *
 * The three window parameters are additive and defaulted: a caller that sends
 * none gets exactly the month-to-date response this route has always returned.
 * ``period=day`` resolves through the same ``day_periods`` helper the unattended
 * ``metrics_daily_read`` tool uses, so the day Jonathan eyeballs here and the day
 * the nightly record writes are the same day.
 */
export const superAdminOperatorDashboardGetOperatorStatsOptions = (options?: Options<SuperAdminOperatorDashboardGetOperatorStatsData>) => queryOptions<SuperAdminOperatorDashboardGetOperatorStatsResponse, SuperAdminOperatorDashboardGetOperatorStatsError, SuperAdminOperatorDashboardGetOperatorStatsResponse, ReturnType<typeof superAdminOperatorDashboardGetOperatorStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminOperatorDashboardGetOperatorStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminOperatorDashboardGetOperatorStatsQueryKey(options)
});

export const paymentsGetPaymentReconciliationQueryKey = (options?: Options<PaymentsGetPaymentReconciliationData>) => createQueryKey('payments-get_payment_reconciliation', options);

/**
 * Get Payment Reconciliation
 *
 * Super-admin reconciliation view: runs the diff for a window on demand and
 * returns the full report (counts + discrepancy details).
 */
export const paymentsGetPaymentReconciliationOptions = (options?: Options<PaymentsGetPaymentReconciliationData>) => queryOptions<PaymentsGetPaymentReconciliationResponse, PaymentsGetPaymentReconciliationError, PaymentsGetPaymentReconciliationResponse, ReturnType<typeof paymentsGetPaymentReconciliationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await paymentsGetPaymentReconciliation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: paymentsGetPaymentReconciliationQueryKey(options)
});

export const superAdminPledgesListHeldPledgesQueryKey = (options?: Options<SuperAdminPledgesListHeldPledgesData>) => createQueryKey('super-admin-pledges-list_held_pledges', options);

/**
 * List Held Pledges
 *
 * GFU-BE55: every pledge charge held for an operator, oldest first, paginated: sent more
 * than a day ago, its answer never recorded, so past Shift4's replay of its key. Each item
 * names the charge record (key, attempt, amount, when written and last sent) and its pledge
 * and campaign, with the pledgor masked. Cross-user, READ-ONLY.
 */
export const superAdminPledgesListHeldPledgesOptions = (options?: Options<SuperAdminPledgesListHeldPledgesData>) => queryOptions<SuperAdminPledgesListHeldPledgesResponse, SuperAdminPledgesListHeldPledgesError, SuperAdminPledgesListHeldPledgesResponse, ReturnType<typeof superAdminPledgesListHeldPledgesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminPledgesListHeldPledges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminPledgesListHeldPledgesQueryKey(options)
});

export const superAdminPledgesListPublishReviewCampaignsQueryKey = (options?: Options<SuperAdminPledgesListPublishReviewCampaignsData>) => createQueryKey('super-admin-pledges-list_publish_review_campaigns', options);

/**
 * List Publish Review Campaigns
 *
 * Retired blanket preapproval queue, returning an empty paginated response.
 * Targeted detail/VOID and attestation/objection review remain available.
 */
export const superAdminPledgesListPublishReviewCampaignsOptions = (options?: Options<SuperAdminPledgesListPublishReviewCampaignsData>) => queryOptions<SuperAdminPledgesListPublishReviewCampaignsResponse, SuperAdminPledgesListPublishReviewCampaignsError, SuperAdminPledgesListPublishReviewCampaignsResponse, ReturnType<typeof superAdminPledgesListPublishReviewCampaignsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminPledgesListPublishReviewCampaigns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminPledgesListPublishReviewCampaignsQueryKey(options)
});

export const superAdminPledgesListReviewCampaignsQueryKey = (options?: Options<SuperAdminPledgesListReviewCampaignsData>) => createQueryKey('super-admin-pledges-list_review_campaigns', options);

/**
 * List Review Campaigns
 *
 * The adjudication REVIEW QUEUE (03 §6), newest-first, paginated: campaigns in
 * ``needs_review`` (the BE3 outlier block) UNION campaigns with objected pledges.
 * Each item carries the campaign + its outlier ``pledge_attestation_audit`` flags
 * + a ``review_reason`` (outlier / objection / both). Cross-user, READ-ONLY.
 */
export const superAdminPledgesListReviewCampaignsOptions = (options?: Options<SuperAdminPledgesListReviewCampaignsData>) => queryOptions<SuperAdminPledgesListReviewCampaignsResponse, SuperAdminPledgesListReviewCampaignsError, SuperAdminPledgesListReviewCampaignsResponse, ReturnType<typeof superAdminPledgesListReviewCampaignsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminPledgesListReviewCampaigns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminPledgesListReviewCampaignsQueryKey(options)
});

/**
 * Accept Campaign
 *
 * ACCEPT (D-PV-1 §3.3#6 exit (a)): ``needs_review → locked`` through the SAME
 * write-once ``lock()`` seam BE3 uses, at the value the result's source submitted
 * (GFU-BE80): ``final_units`` echoes it, and any other number is a 409
 * ``PLEDGE_RESULT_NOT_FROM_SOURCE`` naming the source's value. NEVER an edit of a locked
 * value (a non-``needs_review`` campaign → 409). An absent campaign → 404. Writes an
 * ``adjudicated`` audit row in the same UoW.
 */
export const superAdminPledgesAcceptCampaignMutation = (options?: Partial<Options<SuperAdminPledgesAcceptCampaignData>>): UseMutationOptions<SuperAdminPledgesAcceptCampaignResponse, SuperAdminPledgesAcceptCampaignError, Options<SuperAdminPledgesAcceptCampaignData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminPledgesAcceptCampaignResponse, SuperAdminPledgesAcceptCampaignError, Options<SuperAdminPledgesAcceptCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminPledgesAcceptCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Pledge
 *
 * CANCEL an objected pledge (D-PV-1 §3.3#7): ``needs_review → cancelled``,
 * wallet hold released, NEVER charged. Idempotent. A cross-campaign / absent
 * pledge → 404; a non-review pledge → 409. Writes an ``adjudicated`` audit row in
 * the same UoW.
 */
export const superAdminPledgesCancelPledgeMutation = (options?: Partial<Options<SuperAdminPledgesCancelPledgeData>>): UseMutationOptions<SuperAdminPledgesCancelPledgeResponse, SuperAdminPledgesCancelPledgeError, Options<SuperAdminPledgesCancelPledgeData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminPledgesCancelPledgeResponse, SuperAdminPledgesCancelPledgeError, Options<SuperAdminPledgesCancelPledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminPledgesCancelPledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss Objection
 *
 * DISMISS an objection (D-PV-1 §3.3#7): an objected pledge ``needs_review →
 * active`` (chargeable again — the sweep re-selects it, gated by the SAME
 * notice+clock fences). Idempotent. A cross-campaign / absent pledge → 404; a
 * non-review pledge → 409. Writes an ``adjudicated`` audit row in the same UoW.
 */
export const superAdminPledgesDismissObjectionMutation = (options?: Partial<Options<SuperAdminPledgesDismissObjectionData>>): UseMutationOptions<SuperAdminPledgesDismissObjectionResponse, SuperAdminPledgesDismissObjectionError, Options<SuperAdminPledgesDismissObjectionData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminPledgesDismissObjectionResponse, SuperAdminPledgesDismissObjectionError, Options<SuperAdminPledgesDismissObjectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminPledgesDismissObjection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Partial Settle Pledge
 *
 * PARTIAL-SETTLE (D-PV-1 §3.3#6, the audited disposition): settle an objected
 * pledge at an ADJUDICATED amount (≤ cap) that REPLACES the formula amount for
 * that pledge, booked through the BE4 collection settle primitives (REUSED — all
 * five artifacts stay correct). A cross-campaign / absent pledge → 404; a
 * non-review pledge or an over-cap amount → 409; a declined charge /
 * unavailable-beneficiary → 409 ``PLEDGE_ADJUDICATION_FAILED`` (nothing moved).
 * Writes an ``adjudicated`` audit row recording the before/after amounts.
 */
export const superAdminPledgesPartialSettlePledgeMutation = (options?: Partial<Options<SuperAdminPledgesPartialSettlePledgeData>>): UseMutationOptions<SuperAdminPledgesPartialSettlePledgeResponse, SuperAdminPledgesPartialSettlePledgeError, Options<SuperAdminPledgesPartialSettlePledgeData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminPledgesPartialSettlePledgeResponse, SuperAdminPledgesPartialSettlePledgeError, Options<SuperAdminPledgesPartialSettlePledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminPledgesPartialSettlePledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolve Held Pledge
 *
 * GFU-BE55: resolve a held pledge charge after checking Shift4. ``capture`` books the
 * capture named, verified against a fresh read of Shift4 as the one capture under the key
 * (a disputed one only while its dispute is open or won); ``no_capture`` records that none
 * exists, which a complete read of Shift4 must bear out; ``returned`` records that the
 * capture named went back to the donor, refunded in full or lost to a chargeback as a fresh
 * read of Shift4 shows, and ends the pledge with nothing booked, its pledgor told which.
 * A cross-campaign / absent pledge → 404; refused → 409 ``PLEDGE_HOLD_NOT_RESOLVED``,
 * nothing moved (a refusal after the decision row adds a ``resolve_hold_refused`` row).
 * Writes an ``adjudicated`` audit row before the charge record moves. Returns the
 * pledge.
 */
export const superAdminPledgesResolveHeldPledgeMutation = (options?: Partial<Options<SuperAdminPledgesResolveHeldPledgeData>>): UseMutationOptions<SuperAdminPledgesResolveHeldPledgeResponse, SuperAdminPledgesResolveHeldPledgeError, Options<SuperAdminPledgesResolveHeldPledgeData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminPledgesResolveHeldPledgeResponse, SuperAdminPledgesResolveHeldPledgeError, Options<SuperAdminPledgesResolveHeldPledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminPledgesResolveHeldPledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Publish Review
 *
 * Legacy raw pending → approved decision, idempotent if already approved.
 * Historical rejected cannot reopen. Routine FAN eligibility needs no call here.
 */
export const superAdminPledgesApprovePublishReviewMutation = (options?: Partial<Options<SuperAdminPledgesApprovePublishReviewData>>): UseMutationOptions<SuperAdminPledgesApprovePublishReviewResponse, SuperAdminPledgesApprovePublishReviewError, Options<SuperAdminPledgesApprovePublishReviewData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminPledgesApprovePublishReviewResponse, SuperAdminPledgesApprovePublishReviewError, Options<SuperAdminPledgesApprovePublishReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminPledgesApprovePublishReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Publish Review
 *
 * Legacy raw pending → rejected decision, idempotent if already rejected.
 * Approved campaigns cannot transition here. Existing pledges are untouched;
 * targeted campaign disposition uses VOID. Public GET remains available.
 */
export const superAdminPledgesRejectPublishReviewMutation = (options?: Partial<Options<SuperAdminPledgesRejectPublishReviewData>>): UseMutationOptions<SuperAdminPledgesRejectPublishReviewResponse, SuperAdminPledgesRejectPublishReviewError, Options<SuperAdminPledgesRejectPublishReviewData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminPledgesRejectPublishReviewResponse, SuperAdminPledgesRejectPublishReviewError, Options<SuperAdminPledgesRejectPublishReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminPledgesRejectPublishReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminPledgesGetReviewCampaignDetailQueryKey = (options: Options<SuperAdminPledgesGetReviewCampaignDetailData>) => createQueryKey('super-admin-pledges-get_review_campaign_detail', options);

/**
 * Get Review Campaign Detail
 *
 * One campaign's adjudication DETAIL (03 §6): the campaign + its pledges (with
 * MASKED pledgor identity + dunning visibility + notice state) + the full
 * append-only attestation audit trail. NO ownership filter (a super-admin reads
 * any campaign). An absent id → 404.
 *
 * GFU-WEB4: beside the trail, the value an accept would confirm, the source's own
 * (GFU-BE80): ``source_submission`` ``{audit_id, count}`` (the count a decimal string at
 * the measure's precision; an accept sends it as ``final_count``, its whole-unit floor as
 * ``final_units``), or null with ``source_submission_missing``: ``none_entered`` or
 * ``entered_before_organizer_change``.
 */
export const superAdminPledgesGetReviewCampaignDetailOptions = (options: Options<SuperAdminPledgesGetReviewCampaignDetailData>) => queryOptions<SuperAdminPledgesGetReviewCampaignDetailResponse, SuperAdminPledgesGetReviewCampaignDetailError, SuperAdminPledgesGetReviewCampaignDetailResponse, ReturnType<typeof superAdminPledgesGetReviewCampaignDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminPledgesGetReviewCampaignDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminPledgesGetReviewCampaignDetailQueryKey(options)
});

/**
 * Void Campaign
 *
 * VOID (D-PV-1 §3.3#6 exit (b)): ``needs_review|open|provisional|locked →
 * voided`` (audited). Disposes the campaign's pledges money-safely (holds
 * released, nothing charged). Idempotent. A mid-CHARGING / terminal campaign →
 * 409; an absent campaign → 404. Writes an ``adjudicated`` (voided) audit row in
 * the same UoW.
 */
export const superAdminPledgesVoidCampaignMutation = (options?: Partial<Options<SuperAdminPledgesVoidCampaignData>>): UseMutationOptions<SuperAdminPledgesVoidCampaignResponse, SuperAdminPledgesVoidCampaignError, Options<SuperAdminPledgesVoidCampaignData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminPledgesVoidCampaignResponse, SuperAdminPledgesVoidCampaignError, Options<SuperAdminPledgesVoidCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminPledgesVoidCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postsGetSuperAdminRecentPublicPostsQueryKey = (options?: Options<PostsGetSuperAdminRecentPublicPostsData>) => createQueryKey('posts-get_super_admin_recent_public_posts', options);

/**
 * Get Super Admin Recent Public Posts
 *
 * Super-admin moderation list (D-GF-4): recent PUBLIC posts, newest first,
 * INCLUDING hidden ones (with the `hidden_at`/`hidden_by_user_id` audit
 * fields) so an admin can review the public surface and hide/unhide.
 *
 * GF-BE6 (D-GF-9): each row additionally carries `report_count` +
 * `last_reported_at`; `filter[reported]=true` narrows to posts with ≥1 report
 * (the SA reported queue).
 *
 * `q` is a case-insensitive substring match across post text, donor (author)
 * name, target (charity/ETF/fundraiser) name, and post id, applied server-side
 * (with `page[limit]`/`page[offset]`) so the moderation client can search +
 * page the whole corpus instead of loading everything and searching
 * in-memory.
 */
export const postsGetSuperAdminRecentPublicPostsOptions = (options?: Options<PostsGetSuperAdminRecentPublicPostsData>) => queryOptions<PostsGetSuperAdminRecentPublicPostsResponse, PostsGetSuperAdminRecentPublicPostsError, PostsGetSuperAdminRecentPublicPostsResponse, ReturnType<typeof postsGetSuperAdminRecentPublicPostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetSuperAdminRecentPublicPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetSuperAdminRecentPublicPostsQueryKey(options)
});

/**
 * Hide Post
 *
 * Super-admin hide (D-GF-4): suppress a post from every shared feed.
 */
export const postsHidePostMutation = (options?: Partial<Options<PostsHidePostData>>): UseMutationOptions<PostsHidePostResponse, PostsHidePostError, Options<PostsHidePostData>> => {
    const mutationOptions: UseMutationOptions<PostsHidePostResponse, PostsHidePostError, Options<PostsHidePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsHidePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unhide Post
 *
 * Super-admin unhide (D-GF-4): restore a previously hidden post.
 */
export const postsUnhidePostMutation = (options?: Partial<Options<PostsUnhidePostData>>): UseMutationOptions<PostsUnhidePostResponse, PostsUnhidePostError, Options<PostsUnhidePostData>> => {
    const mutationOptions: UseMutationOptions<PostsUnhidePostResponse, PostsUnhidePostError, Options<PostsUnhidePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postsUnhidePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminProfileBlocksListProfileBlocksForModerationQueryKey = (options?: Options<SuperAdminProfileBlocksListProfileBlocksForModerationData>) => createQueryKey('super-admin-profile-blocks-list_profile_blocks_for_moderation', options);

/**
 * List Profile Blocks For Moderation
 *
 * The moderation review list — unlisted rows INCLUDED, with the whole
 * moderation trio; image rows carry a signed read URL so a reviewer can look.
 */
export const superAdminProfileBlocksListProfileBlocksForModerationOptions = (options?: Options<SuperAdminProfileBlocksListProfileBlocksForModerationData>) => queryOptions<SuperAdminProfileBlocksListProfileBlocksForModerationResponse, SuperAdminProfileBlocksListProfileBlocksForModerationError, SuperAdminProfileBlocksListProfileBlocksForModerationResponse, ReturnType<typeof superAdminProfileBlocksListProfileBlocksForModerationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminProfileBlocksListProfileBlocksForModeration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminProfileBlocksListProfileBlocksForModerationQueryKey(options)
});

/**
 * Relist Profile Block
 *
 * Clear the moderation trio so the block serves publicly again exactly as it
 * was. Idempotent.
 */
export const superAdminProfileBlocksRelistProfileBlockMutation = (options?: Partial<Options<SuperAdminProfileBlocksRelistProfileBlockData>>): UseMutationOptions<SuperAdminProfileBlocksRelistProfileBlockResponse, SuperAdminProfileBlocksRelistProfileBlockError, Options<SuperAdminProfileBlocksRelistProfileBlockData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminProfileBlocksRelistProfileBlockResponse, SuperAdminProfileBlocksRelistProfileBlockError, Options<SuperAdminProfileBlocksRelistProfileBlockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminProfileBlocksRelistProfileBlock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlist Profile Block
 *
 * Take one block down: it drops from every public read on the next request,
 * the owner sees the takedown state, the object (if an image) keeps having no
 * stable public URL. Idempotent (re-unlisting refreshes actor / time / reason).
 */
export const superAdminProfileBlocksUnlistProfileBlockMutation = (options?: Partial<Options<SuperAdminProfileBlocksUnlistProfileBlockData>>): UseMutationOptions<SuperAdminProfileBlocksUnlistProfileBlockResponse, SuperAdminProfileBlocksUnlistProfileBlockError, Options<SuperAdminProfileBlocksUnlistProfileBlockData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminProfileBlocksUnlistProfileBlockResponse, SuperAdminProfileBlocksUnlistProfileBlockError, Options<SuperAdminProfileBlocksUnlistProfileBlockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminProfileBlocksUnlistProfileBlock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const receiptFinePrintListReceiptFinePrintQueryKey = (options?: Options<ReceiptFinePrintListReceiptFinePrintData>) => createQueryKey('receipt-fine-print-list_receipt_fine_print', options);

/**
 * List Receipt Fine Print
 *
 * List every receipt-fine-print document — all kinds, all versions, DRAFT
 * and LIVE — newest first. Super-admin gated.
 */
export const receiptFinePrintListReceiptFinePrintOptions = (options?: Options<ReceiptFinePrintListReceiptFinePrintData>) => queryOptions<ReceiptFinePrintListReceiptFinePrintResponse, DefaultError, ReceiptFinePrintListReceiptFinePrintResponse, ReturnType<typeof receiptFinePrintListReceiptFinePrintQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await receiptFinePrintListReceiptFinePrint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: receiptFinePrintListReceiptFinePrintQueryKey(options)
});

export const receiptFinePrintGetReceiptFinePrintDetailQueryKey = (options: Options<ReceiptFinePrintGetReceiptFinePrintDetailData>) => createQueryKey('receipt-fine-print-get_receipt_fine_print_detail', options);

/**
 * Get Receipt Fine Print Detail
 *
 * A single receipt-fine-print document by id. Super-admin gated.
 */
export const receiptFinePrintGetReceiptFinePrintDetailOptions = (options: Options<ReceiptFinePrintGetReceiptFinePrintDetailData>) => queryOptions<ReceiptFinePrintGetReceiptFinePrintDetailResponse, ReceiptFinePrintGetReceiptFinePrintDetailError, ReceiptFinePrintGetReceiptFinePrintDetailResponse, ReturnType<typeof receiptFinePrintGetReceiptFinePrintDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await receiptFinePrintGetReceiptFinePrintDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: receiptFinePrintGetReceiptFinePrintDetailQueryKey(options)
});

/**
 * Retry Failed Report Generations
 *
 * Plan §6 task 13 / D7. Re-enqueue stuck annual-report rows (FAILED,
 * orphaned PENDING, stale IN_PROGRESS). Superadmin-gated (inline check in the
 * service). Powers the one-time D7 post-launch make-good and the
 * enqueue-failure recovery path. Mirrors the user-deletion
 * ``/super-admin/users/deletions/retry-failed`` endpoint.
 */
export const donationsRetryFailedReportGenerationsMutation = (options?: Partial<Options<DonationsRetryFailedReportGenerationsData>>): UseMutationOptions<DonationsRetryFailedReportGenerationsResponse, DefaultError, Options<DonationsRetryFailedReportGenerationsData>> => {
    const mutationOptions: UseMutationOptions<DonationsRetryFailedReportGenerationsResponse, DefaultError, Options<DonationsRetryFailedReportGenerationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsRetryFailedReportGenerations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const termsListTermsQueryKey = (options?: Options<TermsListTermsData>) => createQueryKey('terms-list_terms', options);

/**
 * List Terms
 */
export const termsListTermsOptions = (options?: Options<TermsListTermsData>) => queryOptions<TermsListTermsResponse, TermsListTermsError, TermsListTermsResponse, ReturnType<typeof termsListTermsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsListTerms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsListTermsQueryKey(options)
});

/**
 * Publish Terms At Super Admin
 */
export const termsPublishTermsAtSuperAdminMutation = (options?: Partial<Options<TermsPublishTermsAtSuperAdminData>>): UseMutationOptions<TermsPublishTermsAtSuperAdminResponse, TermsPublishTermsAtSuperAdminError, Options<TermsPublishTermsAtSuperAdminData>> => {
    const mutationOptions: UseMutationOptions<TermsPublishTermsAtSuperAdminResponse, TermsPublishTermsAtSuperAdminError, Options<TermsPublishTermsAtSuperAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsPublishTermsAtSuperAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const termsGetRecentNotificationsQueryKey = (options?: Options<TermsGetRecentNotificationsData>) => createQueryKey('terms-get_recent_notifications', options);

/**
 * Get Recent Notifications
 *
 * Plan §6.6. Recent-notifications panel data. Auth enforced inline
 * (lightweight read-only endpoint, no command required).
 */
export const termsGetRecentNotificationsOptions = (options?: Options<TermsGetRecentNotificationsData>) => queryOptions<TermsGetRecentNotificationsResponse, TermsGetRecentNotificationsError, TermsGetRecentNotificationsResponse, ReturnType<typeof termsGetRecentNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsGetRecentNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsGetRecentNotificationsQueryKey(options)
});

export const termsGetTermsDetailQueryKey = (options: Options<TermsGetTermsDetailData>) => createQueryKey('terms-get_terms_detail', options);

/**
 * Get Terms Detail
 */
export const termsGetTermsDetailOptions = (options: Options<TermsGetTermsDetailData>) => queryOptions<TermsGetTermsDetailResponse, TermsGetTermsDetailError, TermsGetTermsDetailResponse, ReturnType<typeof termsGetTermsDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsGetTermsDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsGetTermsDetailQueryKey(options)
});

/**
 * Notify Terms At Super Admin
 *
 * Plan §3.5. Cloud Tasks fan-out notify. Requires Idempotency-Key
 * header (UUIDv4). Auth, rate-limit, env gate, and kill switch are all
 * enforced at the service layer.
 */
export const termsNotifyTermsAtSuperAdminMutation = (options?: Partial<Options<TermsNotifyTermsAtSuperAdminData>>): UseMutationOptions<TermsNotifyTermsAtSuperAdminResponse, TermsNotifyTermsAtSuperAdminError, Options<TermsNotifyTermsAtSuperAdminData>> => {
    const mutationOptions: UseMutationOptions<TermsNotifyTermsAtSuperAdminResponse, TermsNotifyTermsAtSuperAdminError, Options<TermsNotifyTermsAtSuperAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsNotifyTermsAtSuperAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const termsGetTermsNotifyAudienceCountQueryKey = (options: Options<TermsGetTermsNotifyAudienceCountData>) => createQueryKey('terms-get_terms_notify_audience_count', options);

/**
 * Get Terms Notify Audience Count
 *
 * Plan §3.3. Returns recipient count + skip breakdown + suppression
 * availability flag. Auth enforced at the service layer.
 */
export const termsGetTermsNotifyAudienceCountOptions = (options: Options<TermsGetTermsNotifyAudienceCountData>) => queryOptions<TermsGetTermsNotifyAudienceCountResponse, TermsGetTermsNotifyAudienceCountError, TermsGetTermsNotifyAudienceCountResponse, ReturnType<typeof termsGetTermsNotifyAudienceCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsGetTermsNotifyAudienceCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsGetTermsNotifyAudienceCountQueryKey(options)
});

export const termsGetTermsNotifyPreviewQueryKey = (options: Options<TermsGetTermsNotifyPreviewData>) => createQueryKey('terms-get_terms_notify_preview', options);

/**
 * Get Terms Notify Preview
 *
 * Plan §3.2. Returns rendered email HTML (text/html) with the preview
 * banner prepended. Auth enforced at the service layer.
 */
export const termsGetTermsNotifyPreviewOptions = (options: Options<TermsGetTermsNotifyPreviewData>) => queryOptions<TermsGetTermsNotifyPreviewResponse, TermsGetTermsNotifyPreviewError, TermsGetTermsNotifyPreviewResponse, ReturnType<typeof termsGetTermsNotifyPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsGetTermsNotifyPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsGetTermsNotifyPreviewQueryKey(options)
});

/**
 * Retry Failed Batches At Super Admin
 *
 * Plan §3.10 (v7). Re-enqueue all status='failed' batches for this
 * document. In-flight (pending/in_progress) batches are untouched.
 */
export const termsRetryFailedBatchesAtSuperAdminMutation = (options?: Partial<Options<TermsRetryFailedBatchesAtSuperAdminData>>): UseMutationOptions<TermsRetryFailedBatchesAtSuperAdminResponse, TermsRetryFailedBatchesAtSuperAdminError, Options<TermsRetryFailedBatchesAtSuperAdminData>> => {
    const mutationOptions: UseMutationOptions<TermsRetryFailedBatchesAtSuperAdminResponse, TermsRetryFailedBatchesAtSuperAdminError, Options<TermsRetryFailedBatchesAtSuperAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsRetryFailedBatchesAtSuperAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const termsGetNotificationStatusQueryKey = (options: Options<TermsGetNotificationStatusData>) => createQueryKey('terms-get_notification_status', options);

/**
 * Get Notification Status
 *
 * Plan §3.10. Dedicated status endpoint for frontend polling.
 */
export const termsGetNotificationStatusOptions = (options: Options<TermsGetNotificationStatusData>) => queryOptions<TermsGetNotificationStatusResponse, TermsGetNotificationStatusError, TermsGetNotificationStatusResponse, ReturnType<typeof termsGetNotificationStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsGetNotificationStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsGetNotificationStatusQueryKey(options)
});

/**
 * Post Terms Notify Test At Super Admin
 *
 * Plan §3.11. Send the rendered email to the caller's own email only.
 */
export const termsPostTermsNotifyTestAtSuperAdminMutation = (options?: Partial<Options<TermsPostTermsNotifyTestAtSuperAdminData>>): UseMutationOptions<TermsPostTermsNotifyTestAtSuperAdminResponse, TermsPostTermsNotifyTestAtSuperAdminError, Options<TermsPostTermsNotifyTestAtSuperAdminData>> => {
    const mutationOptions: UseMutationOptions<TermsPostTermsNotifyTestAtSuperAdminResponse, TermsPostTermsNotifyTestAtSuperAdminError, Options<TermsPostTermsNotifyTestAtSuperAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsPostTermsNotifyTestAtSuperAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch Terms Summary At Super Admin
 *
 * Plan §3.1. Update summary_of_changes and/or effective_at on a
 * not-yet-notified document. Auth, 14-day gate, bleach sanitization, and
 * post-notify lock are all enforced at the service layer.
 */
export const termsPatchTermsSummaryAtSuperAdminMutation = (options?: Partial<Options<TermsPatchTermsSummaryAtSuperAdminData>>): UseMutationOptions<TermsPatchTermsSummaryAtSuperAdminResponse, TermsPatchTermsSummaryAtSuperAdminError, Options<TermsPatchTermsSummaryAtSuperAdminData>> => {
    const mutationOptions: UseMutationOptions<TermsPatchTermsSummaryAtSuperAdminResponse, TermsPatchTermsSummaryAtSuperAdminError, Options<TermsPatchTermsSummaryAtSuperAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await termsPatchTermsSummaryAtSuperAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry Failed User Deletions
 *
 * Plan §6.10. Re-enqueue failed and stale-in-progress user-deletion
 * outbox rows. Superadmin-gated.
 */
export const usersRetryFailedUserDeletionsMutation = (options?: Partial<Options<UsersRetryFailedUserDeletionsData>>): UseMutationOptions<UsersRetryFailedUserDeletionsResponse, DefaultError, Options<UsersRetryFailedUserDeletionsData>> => {
    const mutationOptions: UseMutationOptions<UsersRetryFailedUserDeletionsResponse, DefaultError, Options<UsersRetryFailedUserDeletionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersRetryFailedUserDeletions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersListStuckUserDeletionsQueryKey = (options?: Options<UsersListStuckUserDeletionsData>) => createQueryKey('users-list_stuck_user_deletions', options);

/**
 * List Stuck User Deletions
 *
 * Plan §6.10b. Inspect endpoint — non-terminal outbox rows for ops
 * triage. Superadmin-gated.
 */
export const usersListStuckUserDeletionsOptions = (options?: Options<UsersListStuckUserDeletionsData>) => queryOptions<UsersListStuckUserDeletionsResponse, DefaultError, UsersListStuckUserDeletionsResponse, ReturnType<typeof usersListStuckUserDeletionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersListStuckUserDeletions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersListStuckUserDeletionsQueryKey(options)
});

export const superAdminDonationOpsSearchUserByEmailQueryKey = (options: Options<SuperAdminDonationOpsSearchUserByEmailData>) => createQueryKey('super-admin-donation-ops-search_user_by_email', options);

/**
 * Search User By Email
 *
 * CDO-BE2 (a): resolve a user by signup email OR employer-link work email.
 * 404 when neither matches (the COO decision-tree "not found" branch).
 */
export const superAdminDonationOpsSearchUserByEmailOptions = (options: Options<SuperAdminDonationOpsSearchUserByEmailData>) => queryOptions<SuperAdminDonationOpsSearchUserByEmailResponse, SuperAdminDonationOpsSearchUserByEmailError, SuperAdminDonationOpsSearchUserByEmailResponse, ReturnType<typeof superAdminDonationOpsSearchUserByEmailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDonationOpsSearchUserByEmail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDonationOpsSearchUserByEmailQueryKey(options)
});

export const superAdminDonationOpsSearchUsersByNameQueryKey = (options: Options<SuperAdminDonationOpsSearchUsersByNameData>) => createQueryKey('super-admin-donation-ops-search_users_by_name', options);

/**
 * Search Users By Name
 *
 * SAPD-USR1 (f): the users a name could refer to, for the user page's lookup.
 *
 * IDT-BE11's search (exact normalized equality, an exact uncapped
 * ``total_matched``, at most 25 candidates newest first), served here outside the
 * DAF intake flag so the lookup works whatever that flag says. The DAF corroborator
 * is not evaluated, so ``has_open_daf_transfer_intent`` is always null. Matching is
 * exact: a married, hyphenated or suffixed surname reads as zero.
 */
export const superAdminDonationOpsSearchUsersByNameOptions = (options: Options<SuperAdminDonationOpsSearchUsersByNameData>) => queryOptions<SuperAdminDonationOpsSearchUsersByNameResponse, SuperAdminDonationOpsSearchUsersByNameError, SuperAdminDonationOpsSearchUsersByNameResponse, ReturnType<typeof superAdminDonationOpsSearchUsersByNameQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDonationOpsSearchUsersByName({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDonationOpsSearchUsersByNameQueryKey(options)
});

export const superAdminDonationOpsGetUserProfileQueryKey = (options: Options<SuperAdminDonationOpsGetUserProfileData>) => createQueryKey('super-admin-donation-ops-get_user_profile', options);

/**
 * Get User Profile
 *
 * SAPD-USR1 (g): the user page's identity block — name, email, account status,
 * created date and the last app seen. 404 (``error_code=USER_NOT_FOUND``) when the
 * id names no user.
 */
export const superAdminDonationOpsGetUserProfileOptions = (options: Options<SuperAdminDonationOpsGetUserProfileData>) => queryOptions<SuperAdminDonationOpsGetUserProfileResponse, SuperAdminDonationOpsGetUserProfileError, SuperAdminDonationOpsGetUserProfileResponse, ReturnType<typeof superAdminDonationOpsGetUserProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDonationOpsGetUserProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDonationOpsGetUserProfileQueryKey(options)
});

/**
 * Correct User Birth Date
 *
 * Correct an established DOB with super-admin auth and a durable audit.
 */
export const superAdminDonationOpsCorrectUserBirthDateMutation = (options?: Partial<Options<SuperAdminDonationOpsCorrectUserBirthDateData>>): UseMutationOptions<SuperAdminDonationOpsCorrectUserBirthDateResponse, SuperAdminDonationOpsCorrectUserBirthDateError, Options<SuperAdminDonationOpsCorrectUserBirthDateData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDonationOpsCorrectUserBirthDateResponse, SuperAdminDonationOpsCorrectUserBirthDateError, Options<SuperAdminDonationOpsCorrectUserBirthDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDonationOpsCorrectUserBirthDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link Company Attested
 *
 * GF-A27: link a user to the ACTIVE company derived from their signup
 * email domain after an operator records external verification evidence.
 */
export const superAdminDonationOpsLinkCompanyAttestedMutation = (options?: Partial<Options<SuperAdminDonationOpsLinkCompanyAttestedData>>): UseMutationOptions<SuperAdminDonationOpsLinkCompanyAttestedResponse, SuperAdminDonationOpsLinkCompanyAttestedError, Options<SuperAdminDonationOpsLinkCompanyAttestedData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDonationOpsLinkCompanyAttestedResponse, SuperAdminDonationOpsLinkCompanyAttestedError, Options<SuperAdminDonationOpsLinkCompanyAttestedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDonationOpsLinkCompanyAttested({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminDonationOpsListUserDonationsQueryKey = (options: Options<SuperAdminDonationOpsListUserDonationsData>) => createQueryKey('super-admin-donation-ops-list_user_donations', options);

/**
 * List User Donations
 *
 * SAPD-USR1 (h): one page of the user's donations, newest first, each with
 * every match row on it. ``page[limit]`` defaults to 25 and is capped at 100;
 * ``meta.total_items`` is the exact count of the user's donations. 404
 * (``error_code=USER_NOT_FOUND``) when the id names no user.
 */
export const superAdminDonationOpsListUserDonationsOptions = (options: Options<SuperAdminDonationOpsListUserDonationsData>) => queryOptions<SuperAdminDonationOpsListUserDonationsResponse, SuperAdminDonationOpsListUserDonationsError, SuperAdminDonationOpsListUserDonationsResponse, ReturnType<typeof superAdminDonationOpsListUserDonationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDonationOpsListUserDonations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDonationOpsListUserDonationsQueryKey(options)
});

/**
 * Create External Donation On Behalf
 *
 * CDO-BE2 (d): book an external donation on a user's behalf. EXTERNAL,
 * zero fees, moves no money; ``request_match`` registers a pending company
 * match routed to the employer's own approval. No grant assignment is
 * scheduled — an EXTERNAL booking has no charge/grant of its own; the grant
 * is created only when the employer approves the resulting match.
 *
 * CAM-R149: the answer says whether a match request was recorded and, when none was,
 * why (`AdminExternalDonationOut`): while ``COMPANY_MATCH_REQUEST_BUDGET_ENABLED`` is
 * on, nothing left to match records none (CAM-R147). ``Idempotency-Key`` is honoured:
 * a same-key replay answers the first booking, byte for byte.
 */
export const superAdminDonationOpsCreateExternalDonationOnBehalfMutation = (options?: Partial<Options<SuperAdminDonationOpsCreateExternalDonationOnBehalfData>>): UseMutationOptions<SuperAdminDonationOpsCreateExternalDonationOnBehalfResponse, SuperAdminDonationOpsCreateExternalDonationOnBehalfError, Options<SuperAdminDonationOpsCreateExternalDonationOnBehalfData>> => {
    const mutationOptions: UseMutationOptions<SuperAdminDonationOpsCreateExternalDonationOnBehalfResponse, SuperAdminDonationOpsCreateExternalDonationOnBehalfError, Options<SuperAdminDonationOpsCreateExternalDonationOnBehalfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await superAdminDonationOpsCreateExternalDonationOnBehalf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const superAdminDonationOpsGetEmployerLinkageQueryKey = (options: Options<SuperAdminDonationOpsGetEmployerLinkageData>) => createQueryKey('super-admin-donation-ops-get_employer_linkage', options);

/**
 * Get Employer Linkage
 *
 * CDO-BE2 (b)+(c): a user's employer linkage + per-employee match budget.
 */
export const superAdminDonationOpsGetEmployerLinkageOptions = (options: Options<SuperAdminDonationOpsGetEmployerLinkageData>) => queryOptions<SuperAdminDonationOpsGetEmployerLinkageResponse, SuperAdminDonationOpsGetEmployerLinkageError, SuperAdminDonationOpsGetEmployerLinkageResponse, ReturnType<typeof superAdminDonationOpsGetEmployerLinkageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await superAdminDonationOpsGetEmployerLinkage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: superAdminDonationOpsGetEmployerLinkageQueryKey(options)
});

/**
 * Submit Survey Answer
 */
export const surveysSubmitSurveyAnswerMutation = (options?: Partial<Options<SurveysSubmitSurveyAnswerData>>): UseMutationOptions<SurveysSubmitSurveyAnswerResponse, SurveysSubmitSurveyAnswerError, Options<SurveysSubmitSurveyAnswerData>> => {
    const mutationOptions: UseMutationOptions<SurveysSubmitSurveyAnswerResponse, SurveysSubmitSurveyAnswerError, Options<SurveysSubmitSurveyAnswerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await surveysSubmitSurveyAnswer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const surveysGetCharityRecommendationsQueryKey = (options?: Options<SurveysGetCharityRecommendationsData>) => createQueryKey('surveys-get_charity_recommendations', options);

/**
 * Get Charity Recommendations
 */
export const surveysGetCharityRecommendationsOptions = (options?: Options<SurveysGetCharityRecommendationsData>) => queryOptions<SurveysGetCharityRecommendationsResponse, DefaultError, SurveysGetCharityRecommendationsResponse, ReturnType<typeof surveysGetCharityRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await surveysGetCharityRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: surveysGetCharityRecommendationsQueryKey(options)
});

export const surveysGetSavedRecommendationsQueryKey = (options?: Options<SurveysGetSavedRecommendationsData>) => createQueryKey('surveys-get_saved_recommendations', options);

/**
 * Get Saved Recommendations
 */
export const surveysGetSavedRecommendationsOptions = (options?: Options<SurveysGetSavedRecommendationsData>) => queryOptions<SurveysGetSavedRecommendationsResponse, DefaultError, SurveysGetSavedRecommendationsResponse, ReturnType<typeof surveysGetSavedRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await surveysGetSavedRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: surveysGetSavedRecommendationsQueryKey(options)
});

export const termsGetCurrentTermsQueryKey = (options?: Options<TermsGetCurrentTermsData>) => createQueryKey('terms-get_current_terms', options);

/**
 * Get Current Terms
 */
export const termsGetCurrentTermsOptions = (options?: Options<TermsGetCurrentTermsData>) => queryOptions<TermsGetCurrentTermsResponse, DefaultError, TermsGetCurrentTermsResponse, ReturnType<typeof termsGetCurrentTermsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsGetCurrentTerms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsGetCurrentTermsQueryKey(options)
});

export const termsGetLatestTermsQueryKey = (options: Options<TermsGetLatestTermsData>) => createQueryKey('terms-get_latest_terms', options);

/**
 * Get Latest Terms
 */
export const termsGetLatestTermsOptions = (options: Options<TermsGetLatestTermsData>) => queryOptions<TermsGetLatestTermsResponse, TermsGetLatestTermsError, TermsGetLatestTermsResponse, ReturnType<typeof termsGetLatestTermsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsGetLatestTerms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsGetLatestTermsQueryKey(options)
});

export const termsGetTermsVersionQueryKey = (options: Options<TermsGetTermsVersionData>) => createQueryKey('terms-get_terms_version', options);

/**
 * Get Terms Version
 */
export const termsGetTermsVersionOptions = (options: Options<TermsGetTermsVersionData>) => queryOptions<TermsGetTermsVersionResponse, TermsGetTermsVersionError, TermsGetTermsVersionResponse, ReturnType<typeof termsGetTermsVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termsGetTermsVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termsGetTermsVersionQueryKey(options)
});

export const usersGetUsersQueryKey = (options?: Options<UsersGetUsersData>) => createQueryKey('users-get_users', options);

/**
 * Get Users
 */
export const usersGetUsersOptions = (options?: Options<UsersGetUsersData>) => queryOptions<UsersGetUsersResponse, UsersGetUsersError, UsersGetUsersResponse, ReturnType<typeof usersGetUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUsersQueryKey(options)
});

/**
 * Create User
 */
export const usersCreateUserMutation = (options?: Partial<Options<UsersCreateUserData>>): UseMutationOptions<UsersCreateUserResponse, UsersCreateUserError, Options<UsersCreateUserData>> => {
    const mutationOptions: UseMutationOptions<UsersCreateUserResponse, UsersCreateUserError, Options<UsersCreateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersCreateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersCheckEmailAvailableQueryKey = (options: Options<UsersCheckEmailAvailableData>) => createQueryKey('users-check_email_available', options);

/**
 * Check Email Available
 */
export const usersCheckEmailAvailableOptions = (options: Options<UsersCheckEmailAvailableData>) => queryOptions<UsersCheckEmailAvailableResponse, UsersCheckEmailAvailableError, UsersCheckEmailAvailableResponse, ReturnType<typeof usersCheckEmailAvailableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersCheckEmailAvailable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersCheckEmailAvailableQueryKey(options)
});

/**
 * Delete User
 */
export const usersDeleteUserMutation = (options?: Partial<Options<UsersDeleteUserData>>): UseMutationOptions<UsersDeleteUserResponse, UsersDeleteUserError, Options<UsersDeleteUserData>> => {
    const mutationOptions: UseMutationOptions<UsersDeleteUserResponse, UsersDeleteUserError, Options<UsersDeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersDeleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMeQueryKey = (options?: Options<UsersGetMeData>) => createQueryKey('users-get_me', options);

/**
 * Get Me
 */
export const usersGetMeOptions = (options?: Options<UsersGetMeData>) => queryOptions<UsersGetMeResponse, DefaultError, UsersGetMeResponse, ReturnType<typeof usersGetMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetMeQueryKey(options)
});

/**
 * Update User
 */
export const usersUpdateUserMutation = (options?: Partial<Options<UsersUpdateUserData>>): UseMutationOptions<UsersUpdateUserResponse, UsersUpdateUserError, Options<UsersUpdateUserData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserResponse, UsersUpdateUserError, Options<UsersUpdateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const aiGivingGetMyAiGivingLimitQueryKey = (options?: Options<AiGivingGetMyAiGivingLimitData>) => createQueryKey('ai-giving-get_my_ai_giving_limit', options);

/**
 * Get My Ai Giving Limit
 */
export const aiGivingGetMyAiGivingLimitOptions = (options?: Options<AiGivingGetMyAiGivingLimitData>) => queryOptions<AiGivingGetMyAiGivingLimitResponse, DefaultError, AiGivingGetMyAiGivingLimitResponse, ReturnType<typeof aiGivingGetMyAiGivingLimitQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await aiGivingGetMyAiGivingLimit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: aiGivingGetMyAiGivingLimitQueryKey(options)
});

/**
 * Set My Ai Giving Limit
 */
export const aiGivingSetMyAiGivingLimitMutation = (options?: Partial<Options<AiGivingSetMyAiGivingLimitData>>): UseMutationOptions<AiGivingSetMyAiGivingLimitResponse, AiGivingSetMyAiGivingLimitError, Options<AiGivingSetMyAiGivingLimitData>> => {
    const mutationOptions: UseMutationOptions<AiGivingSetMyAiGivingLimitResponse, AiGivingSetMyAiGivingLimitError, Options<AiGivingSetMyAiGivingLimitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await aiGivingSetMyAiGivingLimit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const birthdayGiftsListBirthdayGiftsQueryKey = (options?: Options<BirthdayGiftsListBirthdayGiftsData>) => createQueryKey('birthday-gifts-list_birthday_gifts', options);

/**
 * List Birthday Gifts
 */
export const birthdayGiftsListBirthdayGiftsOptions = (options?: Options<BirthdayGiftsListBirthdayGiftsData>) => queryOptions<BirthdayGiftsListBirthdayGiftsResponse, DefaultError, BirthdayGiftsListBirthdayGiftsResponse, ReturnType<typeof birthdayGiftsListBirthdayGiftsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await birthdayGiftsListBirthdayGifts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: birthdayGiftsListBirthdayGiftsQueryKey(options)
});

/**
 * Create Birthday Gift
 */
export const birthdayGiftsCreateBirthdayGiftMutation = (options?: Partial<Options<BirthdayGiftsCreateBirthdayGiftData>>): UseMutationOptions<BirthdayGiftsCreateBirthdayGiftResponse, BirthdayGiftsCreateBirthdayGiftError, Options<BirthdayGiftsCreateBirthdayGiftData>> => {
    const mutationOptions: UseMutationOptions<BirthdayGiftsCreateBirthdayGiftResponse, BirthdayGiftsCreateBirthdayGiftError, Options<BirthdayGiftsCreateBirthdayGiftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await birthdayGiftsCreateBirthdayGift({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const birthdayGiftsGetBirthdayGiftQueryKey = (options: Options<BirthdayGiftsGetBirthdayGiftData>) => createQueryKey('birthday-gifts-get_birthday_gift', options);

/**
 * Get Birthday Gift
 */
export const birthdayGiftsGetBirthdayGiftOptions = (options: Options<BirthdayGiftsGetBirthdayGiftData>) => queryOptions<BirthdayGiftsGetBirthdayGiftResponse, BirthdayGiftsGetBirthdayGiftError, BirthdayGiftsGetBirthdayGiftResponse, ReturnType<typeof birthdayGiftsGetBirthdayGiftQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await birthdayGiftsGetBirthdayGift({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: birthdayGiftsGetBirthdayGiftQueryKey(options)
});

/**
 * Update Birthday Gift
 */
export const birthdayGiftsUpdateBirthdayGiftMutation = (options?: Partial<Options<BirthdayGiftsUpdateBirthdayGiftData>>): UseMutationOptions<BirthdayGiftsUpdateBirthdayGiftResponse, BirthdayGiftsUpdateBirthdayGiftError, Options<BirthdayGiftsUpdateBirthdayGiftData>> => {
    const mutationOptions: UseMutationOptions<BirthdayGiftsUpdateBirthdayGiftResponse, BirthdayGiftsUpdateBirthdayGiftError, Options<BirthdayGiftsUpdateBirthdayGiftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await birthdayGiftsUpdateBirthdayGift({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Birthday Gift
 */
export const birthdayGiftsCancelBirthdayGiftMutation = (options?: Partial<Options<BirthdayGiftsCancelBirthdayGiftData>>): UseMutationOptions<BirthdayGiftsCancelBirthdayGiftResponse, BirthdayGiftsCancelBirthdayGiftError, Options<BirthdayGiftsCancelBirthdayGiftData>> => {
    const mutationOptions: UseMutationOptions<BirthdayGiftsCancelBirthdayGiftResponse, BirthdayGiftsCancelBirthdayGiftError, Options<BirthdayGiftsCancelBirthdayGiftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await birthdayGiftsCancelBirthdayGift({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Birthday Visibility
 */
export const usersUpdateBirthdayVisibilityMutation = (options?: Partial<Options<UsersUpdateBirthdayVisibilityData>>): UseMutationOptions<UsersUpdateBirthdayVisibilityResponse, UsersUpdateBirthdayVisibilityError, Options<UsersUpdateBirthdayVisibilityData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateBirthdayVisibilityResponse, UsersUpdateBirthdayVisibilityError, Options<UsersUpdateBirthdayVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateBirthdayVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetUpcomingBirthdaysQueryKey = (options?: Options<UsersGetUpcomingBirthdaysData>) => createQueryKey('users-get_upcoming_birthdays', options);

/**
 * Get Upcoming Birthdays
 */
export const usersGetUpcomingBirthdaysOptions = (options?: Options<UsersGetUpcomingBirthdaysData>) => queryOptions<UsersGetUpcomingBirthdaysResponse, DefaultError, UsersGetUpcomingBirthdaysResponse, ReturnType<typeof usersGetUpcomingBirthdaysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUpcomingBirthdays({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUpcomingBirthdaysQueryKey(options)
});

export const usersListBlockedUsersQueryKey = (options?: Options<UsersListBlockedUsersData>) => createQueryKey('users-list_blocked_users', options);

/**
 * List Blocked Users
 *
 * The caller's blocked users, paginated, as PUBLIC projections (name/logo —
 * no PII). Logos are hydrated per page through the cached wrapper (one read per
 * distinct user, bounded page), then narrowed via `PublicUserOut` and returned
 * as an ORJSONResponse so FastAPI does not re-coerce PII back through
 * `UserOut` (same posture as the public path of `GET /users`).
 */
export const usersListBlockedUsersOptions = (options?: Options<UsersListBlockedUsersData>) => queryOptions<UsersListBlockedUsersResponse, UsersListBlockedUsersError, UsersListBlockedUsersResponse, ReturnType<typeof usersListBlockedUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersListBlockedUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersListBlockedUsersQueryKey(options)
});

/**
 * Unblock User
 */
export const usersUnblockUserMutation = (options?: Partial<Options<UsersUnblockUserData>>): UseMutationOptions<UsersUnblockUserResponse, UsersUnblockUserError, Options<UsersUnblockUserData>> => {
    const mutationOptions: UseMutationOptions<UsersUnblockUserResponse, UsersUnblockUserError, Options<UsersUnblockUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUnblockUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Block User
 */
export const usersBlockUserMutation = (options?: Partial<Options<UsersBlockUserData>>): UseMutationOptions<UsersBlockUserResponse, UsersBlockUserError, Options<UsersBlockUserData>> => {
    const mutationOptions: UseMutationOptions<UsersBlockUserResponse, UsersBlockUserError, Options<UsersBlockUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersBlockUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMyChampionQueryKey = (options?: Options<UsersGetMyChampionData>) => createQueryKey('users-get_my_champion', options);

/**
 * Get My Champion
 *
 * CQ2-BE1: the caller's champion (get-or-create) — the immutable slug + the
 * current live handle. Minting is idempotent; a repeat call returns the same
 * champion.
 */
export const usersGetMyChampionOptions = (options?: Options<UsersGetMyChampionData>) => queryOptions<UsersGetMyChampionResponse, DefaultError, UsersGetMyChampionResponse, ReturnType<typeof usersGetMyChampionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetMyChampion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetMyChampionQueryKey(options)
});

/**
 * Set My Champion Target
 *
 * PV1-BE2 (D-PV-5): set the caller's CURRENT champion target — POLYMORPHIC
 * over charity | cause_etf | collection | fundraiser (ensures the champion is
 * minted). Validates the target exists AND is live/shareable with the SHARED
 * share-ref rules; keeps the wire-frozen `user.championed_charity_id` alias in
 * sync (`= champion_id` for a charity target, NULL otherwise) so old readers
 * never break; stamps `championed_since` only when the target actually
 * changes. Shares ONE retarget rate limit with the legacy champion-surface
 * charity setter above (both funnel into the same service path).
 */
export const usersSetMyChampionTargetMutation = (options?: Partial<Options<UsersSetMyChampionTargetData>>): UseMutationOptions<UsersSetMyChampionTargetResponse, UsersSetMyChampionTargetError, Options<UsersSetMyChampionTargetData>> => {
    const mutationOptions: UseMutationOptions<UsersSetMyChampionTargetResponse, UsersSetMyChampionTargetError, Options<UsersSetMyChampionTargetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersSetMyChampionTarget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set My Champion Charity
 *
 * CQ2-BE1: set the caller's CURRENT championed charity through the champion
 * surface (ensures the champion is minted). The current target lives on the
 * existing `user.championed_charity_id` column the resolver reads — this route
 * is the NEW champion-surface setter and does NOT replace
 * PUT /users/me/championed_charity (which is frozen + returns UseDetailedOut).
 */
export const usersSetMyChampionCharityMutation = (options?: Partial<Options<UsersSetMyChampionCharityData>>): UseMutationOptions<UsersSetMyChampionCharityResponse, UsersSetMyChampionCharityError, Options<UsersSetMyChampionCharityData>> => {
    const mutationOptions: UseMutationOptions<UsersSetMyChampionCharityResponse, UsersSetMyChampionCharityError, Options<UsersSetMyChampionCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersSetMyChampionCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersDownloadMyChampionQrQueryKey = (options: Options<UsersDownloadMyChampionQrData>) => createQueryKey('users-download_my_champion_qr', options);

/**
 * Download My Champion Qr
 *
 * CQ2-BE2b: render + download the caller's OWN champion QR in
 * `{format}` ∈ {svg, png, pdf}. All three formats derive from the one
 * hand-built SVG (PNG == SVG == PDF). Gated dark by `CHAMPION_GIVE_HOST_ENABLED`
 * (404 off). The QR encodes the caller's immutable slug on the LITERAL prod give
 * host (`GIVE.GIVMO.IO` in every env — a printed QR must resolve against
 * production; D-CQ-18/20); the design is the caller's saved spec or
 * `DEFAULT_GIVMO_PRESET`. Per-IP rate
 * limit FAILS CLOSED (the inverse of the public resolver) and is enforced BEFORE
 * the expensive render. No client-supplied size param (render-DoS guard).
 */
export const usersDownloadMyChampionQrOptions = (options: Options<UsersDownloadMyChampionQrData>) => queryOptions<UsersDownloadMyChampionQrResponse, UsersDownloadMyChampionQrError, UsersDownloadMyChampionQrResponse, ReturnType<typeof usersDownloadMyChampionQrQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersDownloadMyChampionQr({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersDownloadMyChampionQrQueryKey(options)
});

/**
 * Update User Championed Charity
 */
export const usersUpdateUserChampionedCharityMutation = (options?: Partial<Options<UsersUpdateUserChampionedCharityData>>): UseMutationOptions<UsersUpdateUserChampionedCharityResponse, UsersUpdateUserChampionedCharityError, Options<UsersUpdateUserChampionedCharityData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserChampionedCharityResponse, UsersUpdateUserChampionedCharityError, Options<UsersUpdateUserChampionedCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateUserChampionedCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetUserChampionedCharityDonatedAmountQueryKey = (options?: Options<UsersGetUserChampionedCharityDonatedAmountData>) => createQueryKey('users-get_user_championed_charity_donated_amount', options);

/**
 * Get User Championed Charity Donated Amount
 */
export const usersGetUserChampionedCharityDonatedAmountOptions = (options?: Options<UsersGetUserChampionedCharityDonatedAmountData>) => queryOptions<UsersGetUserChampionedCharityDonatedAmountResponse, DefaultError, UsersGetUserChampionedCharityDonatedAmountResponse, ReturnType<typeof usersGetUserChampionedCharityDonatedAmountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUserChampionedCharityDonatedAmount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserChampionedCharityDonatedAmountQueryKey(options)
});

/**
 * Create Charity Alternative Recommendation
 *
 * Record only; selection/execution of the recommendation is out of scope.
 */
export const charityAlternativesCreateCharityAlternativeRecommendationMutation = (options?: Partial<Options<CharityAlternativesCreateCharityAlternativeRecommendationData>>): UseMutationOptions<CharityAlternativesCreateCharityAlternativeRecommendationResponse, CharityAlternativesCreateCharityAlternativeRecommendationError, Options<CharityAlternativesCreateCharityAlternativeRecommendationData>> => {
    const mutationOptions: UseMutationOptions<CharityAlternativesCreateCharityAlternativeRecommendationResponse, CharityAlternativesCreateCharityAlternativeRecommendationError, Options<CharityAlternativesCreateCharityAlternativeRecommendationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await charityAlternativesCreateCharityAlternativeRecommendation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityCollectionsGetOwnCharityCollectionQueryKey = (options: Options<CharityCollectionsGetOwnCharityCollectionData>) => createQueryKey('charity-collections-get_own_charity_collection', options);

/**
 * Get Own Charity Collection
 *
 * Owner's own Collection at ANY visibility; 404 if not owned. Mirrors
 * `get_own_fundraiser`.
 */
export const charityCollectionsGetOwnCharityCollectionOptions = (options: Options<CharityCollectionsGetOwnCharityCollectionData>) => queryOptions<CharityCollectionsGetOwnCharityCollectionResponse, CharityCollectionsGetOwnCharityCollectionError, CharityCollectionsGetOwnCharityCollectionResponse, ReturnType<typeof charityCollectionsGetOwnCharityCollectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityCollectionsGetOwnCharityCollection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityCollectionsGetOwnCharityCollectionQueryKey(options)
});

export const followsGetFollowedCharitiesQueryKey = (options?: Options<FollowsGetFollowedCharitiesData>) => createQueryKey('follows-get_followed_charities', options);

/**
 * Get Followed Charities
 */
export const followsGetFollowedCharitiesOptions = (options?: Options<FollowsGetFollowedCharitiesData>) => queryOptions<FollowsGetFollowedCharitiesResponse, FollowsGetFollowedCharitiesError, FollowsGetFollowedCharitiesResponse, ReturnType<typeof followsGetFollowedCharitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await followsGetFollowedCharities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: followsGetFollowedCharitiesQueryKey(options)
});

/**
 * Follow Charity
 */
export const followsFollowCharityMutation = (options?: Partial<Options<FollowsFollowCharityData>>): UseMutationOptions<FollowsFollowCharityResponse, FollowsFollowCharityError, Options<FollowsFollowCharityData>> => {
    const mutationOptions: UseMutationOptions<FollowsFollowCharityResponse, FollowsFollowCharityError, Options<FollowsFollowCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await followsFollowCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unfollow Charity
 */
export const followsUnfollowCharityMutation = (options?: Partial<Options<FollowsUnfollowCharityData>>): UseMutationOptions<FollowsUnfollowCharityResponse, FollowsUnfollowCharityError, Options<FollowsUnfollowCharityData>> => {
    const mutationOptions: UseMutationOptions<FollowsUnfollowCharityResponse, FollowsUnfollowCharityError, Options<FollowsUnfollowCharityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await followsUnfollowCharity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlink Company
 */
export const usersUnlinkCompanyMutation = (options?: Partial<Options<UsersUnlinkCompanyData>>): UseMutationOptions<UsersUnlinkCompanyResponse, DefaultError, Options<UsersUnlinkCompanyData>> => {
    const mutationOptions: UseMutationOptions<UsersUnlinkCompanyResponse, DefaultError, Options<UsersUnlinkCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUnlinkCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companiesGetMyCompanyQueryKey = (options?: Options<CompaniesGetMyCompanyData>) => createQueryKey('companies-get_my_company', options);

/**
 * Get My Company
 */
export const companiesGetMyCompanyOptions = (options?: Options<CompaniesGetMyCompanyData>) => queryOptions<CompaniesGetMyCompanyResponse, DefaultError, CompaniesGetMyCompanyResponse, ReturnType<typeof companiesGetMyCompanyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetMyCompany({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetMyCompanyQueryKey(options)
});

/**
 * Link Company
 */
export const usersLinkCompanyMutation = (options?: Partial<Options<UsersLinkCompanyData>>): UseMutationOptions<UsersLinkCompanyResponse, UsersLinkCompanyError, Options<UsersLinkCompanyData>> => {
    const mutationOptions: UseMutationOptions<UsersLinkCompanyResponse, UsersLinkCompanyError, Options<UsersLinkCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersLinkCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationsGetUserCompanyDonationsQueryKey = (options?: Options<DonationsGetUserCompanyDonationsData>) => createQueryKey('donations-get_user_company_donations', options);

/**
 * Get User Company Donations
 */
export const donationsGetUserCompanyDonationsOptions = (options?: Options<DonationsGetUserCompanyDonationsData>) => queryOptions<DonationsGetUserCompanyDonationsResponse, DefaultError, DonationsGetUserCompanyDonationsResponse, ReturnType<typeof donationsGetUserCompanyDonationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationsGetUserCompanyDonations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationsGetUserCompanyDonationsQueryKey(options)
});

export const donationsListCompanyStatsReportsQueryKey = (options?: Options<DonationsListCompanyStatsReportsData>) => createQueryKey('donations-list_company_stats_reports', options);

/**
 * List Company Stats Reports
 *
 * List the reports for the requesting admin's company (plan §3.6).
 */
export const donationsListCompanyStatsReportsOptions = (options?: Options<DonationsListCompanyStatsReportsData>) => queryOptions<DonationsListCompanyStatsReportsResponse, DefaultError, DonationsListCompanyStatsReportsResponse, ReturnType<typeof donationsListCompanyStatsReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationsListCompanyStatsReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationsListCompanyStatsReportsQueryKey(options)
});

/**
 * Generate Company Stats Report
 */
export const donationsGenerateCompanyStatsReportMutation = (options?: Partial<Options<DonationsGenerateCompanyStatsReportData>>): UseMutationOptions<DonationsGenerateCompanyStatsReportResponse, DonationsGenerateCompanyStatsReportError, Options<DonationsGenerateCompanyStatsReportData>> => {
    const mutationOptions: UseMutationOptions<DonationsGenerateCompanyStatsReportResponse, DonationsGenerateCompanyStatsReportError, Options<DonationsGenerateCompanyStatsReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsGenerateCompanyStatsReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Follow Company Employees
 */
export const followsFollowCompanyEmployeesMutation = (options?: Partial<Options<FollowsFollowCompanyEmployeesData>>): UseMutationOptions<FollowsFollowCompanyEmployeesResponse, DefaultError, Options<FollowsFollowCompanyEmployeesData>> => {
    const mutationOptions: UseMutationOptions<FollowsFollowCompanyEmployeesResponse, DefaultError, Options<FollowsFollowCompanyEmployeesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await followsFollowCompanyEmployees({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm User Email
 */
export const usersConfirmUserEmailMutation = (options?: Partial<Options<UsersConfirmUserEmailData>>): UseMutationOptions<UsersConfirmUserEmailResponse, UsersConfirmUserEmailError, Options<UsersConfirmUserEmailData>> => {
    const mutationOptions: UseMutationOptions<UsersConfirmUserEmailResponse, UsersConfirmUserEmailError, Options<UsersConfirmUserEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersConfirmUserEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMyConnectedAppsQueryKey = (options?: Options<UsersGetMyConnectedAppsData>) => createQueryKey('users-get_my_connected_apps', options);

/**
 * Get My Connected Apps
 *
 * The caller's ACTIVE linked agent grants (one item per consent grant),
 * ordered by linked_at DESC. Wrapped in the standard ``{"data": [...]}``
 * envelope.
 *
 * Annotated ``-> ConnectedAppsListResponse`` so the Tier-1 contract-diff gate
 * sees this frozen consumer surface in the OpenAPI schema, but returns an
 * ``ORJSONResponse`` built from ``asdict()`` at runtime so the wire bytes stay
 * byte-identical to the golden (mirrors ``get_users -> UserPaginatedResponse``).
 */
export const usersGetMyConnectedAppsOptions = (options?: Options<UsersGetMyConnectedAppsData>) => queryOptions<UsersGetMyConnectedAppsResponse, DefaultError, UsersGetMyConnectedAppsResponse, ReturnType<typeof usersGetMyConnectedAppsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetMyConnectedApps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetMyConnectedAppsQueryKey(options)
});

/**
 * Delete My Connected App
 *
 * Disconnect (family-revoke) one of the caller's grants: every refresh token
 * in the family AND every live access token for that grant's client are revoked
 * so the grant is dead server-side immediately. 404 (not 403) when the grant is
 * unknown or owned by another donor — no grant enumeration. Idempotent on an
 * owned grant → 204.
 */
export const usersDeleteMyConnectedAppMutation = (options?: Partial<Options<UsersDeleteMyConnectedAppData>>): UseMutationOptions<UsersDeleteMyConnectedAppResponse, UsersDeleteMyConnectedAppError, Options<UsersDeleteMyConnectedAppData>> => {
    const mutationOptions: UseMutationOptions<UsersDeleteMyConnectedAppResponse, UsersDeleteMyConnectedAppError, Options<UsersDeleteMyConnectedAppData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersDeleteMyConnectedApp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync User Facebook Contacts
 */
export const followsSyncUserFacebookContactsMutation = (options?: Partial<Options<FollowsSyncUserFacebookContactsData>>): UseMutationOptions<FollowsSyncUserFacebookContactsResponse, FollowsSyncUserFacebookContactsError, Options<FollowsSyncUserFacebookContactsData>> => {
    const mutationOptions: UseMutationOptions<FollowsSyncUserFacebookContactsResponse, FollowsSyncUserFacebookContactsError, Options<FollowsSyncUserFacebookContactsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await followsSyncUserFacebookContacts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync User Phone Contacts
 */
export const followsSyncUserPhoneContactsMutation = (options?: Partial<Options<FollowsSyncUserPhoneContactsData>>): UseMutationOptions<FollowsSyncUserPhoneContactsResponse, FollowsSyncUserPhoneContactsError, Options<FollowsSyncUserPhoneContactsData>> => {
    const mutationOptions: UseMutationOptions<FollowsSyncUserPhoneContactsResponse, FollowsSyncUserPhoneContactsError, Options<FollowsSyncUserPhoneContactsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await followsSyncUserPhoneContacts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update User Customer Id
 */
export const usersUpdateUserCustomerIdMutation = (options?: Partial<Options<UsersUpdateUserCustomerIdData>>): UseMutationOptions<UsersUpdateUserCustomerIdResponse, UsersUpdateUserCustomerIdError, Options<UsersUpdateUserCustomerIdData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserCustomerIdResponse, UsersUpdateUserCustomerIdError, Options<UsersUpdateUserCustomerIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateUserCustomerId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dafTransfersListDafTransferIntentsQueryKey = (options?: Options<DafTransfersListDafTransferIntentsData>) => createQueryKey('daf-transfers-list_daf_transfer_intents', options);

/**
 * List Daf Transfer Intents
 */
export const dafTransfersListDafTransferIntentsOptions = (options?: Options<DafTransfersListDafTransferIntentsData>) => queryOptions<DafTransfersListDafTransferIntentsResponse, DafTransfersListDafTransferIntentsError, DafTransfersListDafTransferIntentsResponse, ReturnType<typeof dafTransfersListDafTransferIntentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dafTransfersListDafTransferIntents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dafTransfersListDafTransferIntentsQueryKey(options)
});

/**
 * Create Daf Transfer Intent
 */
export const dafTransfersCreateDafTransferIntentMutation = (options?: Partial<Options<DafTransfersCreateDafTransferIntentData>>): UseMutationOptions<DafTransfersCreateDafTransferIntentResponse, DafTransfersCreateDafTransferIntentError, Options<DafTransfersCreateDafTransferIntentData>> => {
    const mutationOptions: UseMutationOptions<DafTransfersCreateDafTransferIntentResponse, DafTransfersCreateDafTransferIntentError, Options<DafTransfersCreateDafTransferIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dafTransfersCreateDafTransferIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Daf Transfer Intent
 */
export const dafTransfersCancelDafTransferIntentMutation = (options?: Partial<Options<DafTransfersCancelDafTransferIntentData>>): UseMutationOptions<DafTransfersCancelDafTransferIntentResponse, DafTransfersCancelDafTransferIntentError, Options<DafTransfersCancelDafTransferIntentData>> => {
    const mutationOptions: UseMutationOptions<DafTransfersCancelDafTransferIntentResponse, DafTransfersCancelDafTransferIntentError, Options<DafTransfersCancelDafTransferIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dafTransfersCancelDafTransferIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dafTransfersGetDafTransferTrackerQueryKey = (options: Options<DafTransfersGetDafTransferTrackerData>) => createQueryKey('daf-transfers-get_daf_transfer_tracker', options);

/**
 * Get Daf Transfer Tracker
 */
export const dafTransfersGetDafTransferTrackerOptions = (options: Options<DafTransfersGetDafTransferTrackerData>) => queryOptions<DafTransfersGetDafTransferTrackerResponse, DafTransfersGetDafTransferTrackerError, DafTransfersGetDafTransferTrackerResponse, ReturnType<typeof dafTransfersGetDafTransferTrackerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dafTransfersGetDafTransferTracker({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dafTransfersGetDafTransferTrackerQueryKey(options)
});

/**
 * Register Device Token
 */
export const notificationsRegisterDeviceTokenMutation = (options?: Partial<Options<NotificationsRegisterDeviceTokenData>>): UseMutationOptions<NotificationsRegisterDeviceTokenResponse, NotificationsRegisterDeviceTokenError, Options<NotificationsRegisterDeviceTokenData>> => {
    const mutationOptions: UseMutationOptions<NotificationsRegisterDeviceTokenResponse, NotificationsRegisterDeviceTokenError, Options<NotificationsRegisterDeviceTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationsRegisterDeviceToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unregister Device Token
 */
export const notificationsUnregisterDeviceTokenMutation = (options?: Partial<Options<NotificationsUnregisterDeviceTokenData>>): UseMutationOptions<NotificationsUnregisterDeviceTokenResponse, NotificationsUnregisterDeviceTokenError, Options<NotificationsUnregisterDeviceTokenData>> => {
    const mutationOptions: UseMutationOptions<NotificationsUnregisterDeviceTokenResponse, NotificationsUnregisterDeviceTokenError, Options<NotificationsUnregisterDeviceTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationsUnregisterDeviceToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationsGetUserDonationsQueryKey = (options?: Options<DonationsGetUserDonationsData>) => createQueryKey('donations-get_user_donations', options);

/**
 * Get User Donations
 */
export const donationsGetUserDonationsOptions = (options?: Options<DonationsGetUserDonationsData>) => queryOptions<DonationsGetUserDonationsResponse, DefaultError, DonationsGetUserDonationsResponse, ReturnType<typeof donationsGetUserDonationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationsGetUserDonations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationsGetUserDonationsQueryKey(options)
});

export const donationsListUserStatsReportsQueryKey = (options?: Options<DonationsListUserStatsReportsData>) => createQueryKey('donations-list_user_stats_reports', options);

/**
 * List User Stats Reports
 *
 * List the requester's own annual reports (plan §3.6). Inherently owner-
 * scoped — only the authenticated user's user-reports are returned.
 */
export const donationsListUserStatsReportsOptions = (options?: Options<DonationsListUserStatsReportsData>) => queryOptions<DonationsListUserStatsReportsResponse, DefaultError, DonationsListUserStatsReportsResponse, ReturnType<typeof donationsListUserStatsReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationsListUserStatsReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationsListUserStatsReportsQueryKey(options)
});

/**
 * Generate User Stats Report
 */
export const donationsGenerateUserStatsReportMutation = (options?: Partial<Options<DonationsGenerateUserStatsReportData>>): UseMutationOptions<DonationsGenerateUserStatsReportResponse, DonationsGenerateUserStatsReportError, Options<DonationsGenerateUserStatsReportData>> => {
    const mutationOptions: UseMutationOptions<DonationsGenerateUserStatsReportResponse, DonationsGenerateUserStatsReportError, Options<DonationsGenerateUserStatsReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await donationsGenerateUserStatsReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationsDownloadStatsReportQueryKey = (options: Options<DonationsDownloadStatsReportData>) => createQueryKey('donations-download_stats_report', options);

/**
 * Download Stats Report
 *
 * Stream a completed report's PDF (plan §3.6). 404 unless the requester
 * owns it (or admins the report's company) AND it is COMPLETED — the service
 * collapses all three into a 404 so existence is never revealed. Handles both
 * user and company reports.
 */
export const donationsDownloadStatsReportOptions = (options: Options<DonationsDownloadStatsReportData>) => queryOptions<DonationsDownloadStatsReportResponse, DonationsDownloadStatsReportError, DonationsDownloadStatsReportResponse, ReturnType<typeof donationsDownloadStatsReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationsDownloadStatsReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationsDownloadStatsReportQueryKey(options)
});

export const donationsGetDonationJourneyQueryKey = (options: Options<DonationsGetDonationJourneyData>) => createQueryKey('donations-get_donation_journey', options);

/**
 * Get Donation Journey
 *
 * Return the authenticated donor's persisted per-charity journey status.
 */
export const donationsGetDonationJourneyOptions = (options: Options<DonationsGetDonationJourneyData>) => queryOptions<DonationsGetDonationJourneyResponse, DonationsGetDonationJourneyError, DonationsGetDonationJourneyResponse, ReturnType<typeof donationsGetDonationJourneyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationsGetDonationJourney({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationsGetDonationJourneyQueryKey(options)
});

/**
 * Send Email Verification
 */
export const usersSendEmailVerificationMutation = (options?: Partial<Options<UsersSendEmailVerificationData>>): UseMutationOptions<UsersSendEmailVerificationResponse, UsersSendEmailVerificationError, Options<UsersSendEmailVerificationData>> => {
    const mutationOptions: UseMutationOptions<UsersSendEmailVerificationResponse, UsersSendEmailVerificationError, Options<UsersSendEmailVerificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersSendEmailVerification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update User Facebook Id
 */
export const usersUpdateUserFacebookIdMutation = (options?: Partial<Options<UsersUpdateUserFacebookIdData>>): UseMutationOptions<UsersUpdateUserFacebookIdResponse, UsersUpdateUserFacebookIdError, Options<UsersUpdateUserFacebookIdData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserFacebookIdResponse, UsersUpdateUserFacebookIdError, Options<UsersUpdateUserFacebookIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateUserFacebookId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const followsGetUserFollowsQueryKey = (options?: Options<FollowsGetUserFollowsData>) => createQueryKey('follows-get_user_follows', options);

/**
 * Get User Follows
 */
export const followsGetUserFollowsOptions = (options?: Options<FollowsGetUserFollowsData>) => queryOptions<FollowsGetUserFollowsResponse, FollowsGetUserFollowsError, FollowsGetUserFollowsResponse, ReturnType<typeof followsGetUserFollowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await followsGetUserFollows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: followsGetUserFollowsQueryKey(options)
});

export const postsGetFollowsPostsQueryKey = (options?: Options<PostsGetFollowsPostsData>) => createQueryKey('posts-get_follows_posts', options);

/**
 * Get Follows Posts
 */
export const postsGetFollowsPostsOptions = (options?: Options<PostsGetFollowsPostsData>) => queryOptions<PostsGetFollowsPostsResponse, PostsGetFollowsPostsError, PostsGetFollowsPostsResponse, ReturnType<typeof postsGetFollowsPostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetFollowsPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetFollowsPostsQueryKey(options)
});

/**
 * Follow User
 */
export const followsFollowUserMutation = (options?: Partial<Options<FollowsFollowUserData>>): UseMutationOptions<FollowsFollowUserResponse, FollowsFollowUserError, Options<FollowsFollowUserData>> => {
    const mutationOptions: UseMutationOptions<FollowsFollowUserResponse, FollowsFollowUserError, Options<FollowsFollowUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await followsFollowUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundraisersGetFundraiserInvitationsQueryKey = (options?: Options<FundraisersGetFundraiserInvitationsData>) => createQueryKey('fundraisers-get_fundraiser_invitations', options);

/**
 * Get Fundraiser Invitations
 */
export const fundraisersGetFundraiserInvitationsOptions = (options?: Options<FundraisersGetFundraiserInvitationsData>) => queryOptions<FundraisersGetFundraiserInvitationsResponse, FundraisersGetFundraiserInvitationsError, FundraisersGetFundraiserInvitationsResponse, ReturnType<typeof fundraisersGetFundraiserInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetFundraiserInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetFundraiserInvitationsQueryKey(options)
});

export const fundraisersGetFundraiserInvitationQueryKey = (options: Options<FundraisersGetFundraiserInvitationData>) => createQueryKey('fundraisers-get_fundraiser_invitation', options);

/**
 * Get Fundraiser Invitation
 */
export const fundraisersGetFundraiserInvitationOptions = (options: Options<FundraisersGetFundraiserInvitationData>) => queryOptions<FundraisersGetFundraiserInvitationResponse, FundraisersGetFundraiserInvitationError, FundraisersGetFundraiserInvitationResponse, ReturnType<typeof fundraisersGetFundraiserInvitationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetFundraiserInvitation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetFundraiserInvitationQueryKey(options)
});

export const fundraisersGetOwnFundraisersQueryKey = (options?: Options<FundraisersGetOwnFundraisersData>) => createQueryKey('fundraisers-get_own_fundraisers', options);

/**
 * Get Own Fundraisers
 */
export const fundraisersGetOwnFundraisersOptions = (options?: Options<FundraisersGetOwnFundraisersData>) => queryOptions<FundraisersGetOwnFundraisersResponse, FundraisersGetOwnFundraisersError, FundraisersGetOwnFundraisersResponse, ReturnType<typeof fundraisersGetOwnFundraisersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetOwnFundraisers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetOwnFundraisersQueryKey(options)
});

export const fundraisersGetOwnFundraiserQueryKey = (options: Options<FundraisersGetOwnFundraiserData>) => createQueryKey('fundraisers-get_own_fundraiser', options);

/**
 * Get Own Fundraiser
 */
export const fundraisersGetOwnFundraiserOptions = (options: Options<FundraisersGetOwnFundraiserData>) => queryOptions<FundraisersGetOwnFundraiserResponse, FundraisersGetOwnFundraiserError, FundraisersGetOwnFundraiserResponse, ReturnType<typeof fundraisersGetOwnFundraiserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraisersGetOwnFundraiser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraisersGetOwnFundraiserQueryKey(options)
});

export const fundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsQueryKey = (options: Options<FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsData>) => createQueryKey('fundraiser-match-offer-requests-list_fundraiser_match_offer_requests', options);

/**
 * List Fundraiser Match Offer Requests
 */
export const fundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsOptions = (options: Options<FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsData>) => queryOptions<FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsResponse, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsError, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsResponse, ReturnType<typeof fundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraiserMatchOfferRequestsListFundraiserMatchOfferRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsQueryKey(options)
});

/**
 * Accept Match Offer Request
 */
export const fundraiserMatchOfferRequestsAcceptMatchOfferRequestMutation = (options?: Partial<Options<FundraiserMatchOfferRequestsAcceptMatchOfferRequestData>>): UseMutationOptions<FundraiserMatchOfferRequestsAcceptMatchOfferRequestResponse, FundraiserMatchOfferRequestsAcceptMatchOfferRequestError, Options<FundraiserMatchOfferRequestsAcceptMatchOfferRequestData>> => {
    const mutationOptions: UseMutationOptions<FundraiserMatchOfferRequestsAcceptMatchOfferRequestResponse, FundraiserMatchOfferRequestsAcceptMatchOfferRequestError, Options<FundraiserMatchOfferRequestsAcceptMatchOfferRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraiserMatchOfferRequestsAcceptMatchOfferRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline Match Offer Request
 */
export const fundraiserMatchOfferRequestsDeclineMatchOfferRequestMutation = (options?: Partial<Options<FundraiserMatchOfferRequestsDeclineMatchOfferRequestData>>): UseMutationOptions<FundraiserMatchOfferRequestsDeclineMatchOfferRequestResponse, FundraiserMatchOfferRequestsDeclineMatchOfferRequestError, Options<FundraiserMatchOfferRequestsDeclineMatchOfferRequestData>> => {
    const mutationOptions: UseMutationOptions<FundraiserMatchOfferRequestsDeclineMatchOfferRequestResponse, FundraiserMatchOfferRequestsDeclineMatchOfferRequestError, Options<FundraiserMatchOfferRequestsDeclineMatchOfferRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraiserMatchOfferRequestsDeclineMatchOfferRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Fundraiser Match Offer
 */
export const fundraiserMatchOfferRequestsCreateFundraiserMatchOfferMutation = (options?: Partial<Options<FundraiserMatchOfferRequestsCreateFundraiserMatchOfferData>>): UseMutationOptions<FundraiserMatchOfferRequestsCreateFundraiserMatchOfferResponse, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferError, Options<FundraiserMatchOfferRequestsCreateFundraiserMatchOfferData>> => {
    const mutationOptions: UseMutationOptions<FundraiserMatchOfferRequestsCreateFundraiserMatchOfferResponse, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferError, Options<FundraiserMatchOfferRequestsCreateFundraiserMatchOfferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraiserMatchOfferRequestsCreateFundraiserMatchOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const giftCardsListMyGiftCardsQueryKey = (options?: Options<GiftCardsListMyGiftCardsData>) => createQueryKey('gift-cards-list_my_gift_cards', options);

/**
 * List My Gift Cards
 *
 * Paginated list of the gift cards the caller ISSUED/sent (GC2-BE3).
 *
 * Consumer (sender-facing) read: shows EVERY gift card the caller issued
 * regardless of funding source — wallet-funded sends AND card-funded
 * purchases both appear (funding is an implementation detail, not a
 * user-visible filter). Scoped server-side to ``purchaser_user_id ==
 * <caller>``; newest-first by default. The response maps each card to
 * ``GiftCardSentOut`` and NEVER carries a plaintext code / ``code_hash`` /
 * the recipient's ``redeemed_by_user_id``.
 */
export const giftCardsListMyGiftCardsOptions = (options?: Options<GiftCardsListMyGiftCardsData>) => queryOptions<GiftCardsListMyGiftCardsResponse, GiftCardsListMyGiftCardsError, GiftCardsListMyGiftCardsResponse, ReturnType<typeof giftCardsListMyGiftCardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await giftCardsListMyGiftCards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: giftCardsListMyGiftCardsQueryKey(options)
});

export const givingPacketListGivingPacketReportsQueryKey = (options?: Options<GivingPacketListGivingPacketReportsData>) => createQueryKey('giving-packet-list_giving_packet_reports', options);

/**
 * List Giving Packet Reports
 *
 * The caller's giving-packet rows (wire contract §2.11): the house
 * paginated envelope of `giving_packet_report` (= StatisticsReportOut with
 * the additive `report_type`), ONLY report_type='giving_packet' rows — the
 * AR list stays annual-scoped, neither leaks into the other.
 */
export const givingPacketListGivingPacketReportsOptions = (options?: Options<GivingPacketListGivingPacketReportsData>) => queryOptions<GivingPacketListGivingPacketReportsResponse, GivingPacketListGivingPacketReportsError, GivingPacketListGivingPacketReportsResponse, ReturnType<typeof givingPacketListGivingPacketReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await givingPacketListGivingPacketReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: givingPacketListGivingPacketReportsQueryKey(options)
});

/**
 * Request Giving Packet
 *
 * Request one tax-year Giving Packet (wire contract §2.10): 204, creates
 * the `report_type='giving_packet'` statistics_report row for the calendar
 * year and enqueues the existing report queue (AR-style 24h dedupe per
 * (user, year, TYPE) — an active AR request never blocks a packet, nor the
 * reverse). 400 {40004} outside 2020..current ET year. The worker's packet
 * branch is ER-BE13; until then the worker short-circuits the row.
 */
export const givingPacketRequestGivingPacketMutation = (options?: Partial<Options<GivingPacketRequestGivingPacketData>>): UseMutationOptions<GivingPacketRequestGivingPacketResponse, GivingPacketRequestGivingPacketError, Options<GivingPacketRequestGivingPacketData>> => {
    const mutationOptions: UseMutationOptions<GivingPacketRequestGivingPacketResponse, GivingPacketRequestGivingPacketError, Options<GivingPacketRequestGivingPacketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await givingPacketRequestGivingPacket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMyGivingProfileQueryKey = (options?: Options<UsersGetMyGivingProfileData>) => createQueryKey('users-get_my_giving_profile', options);

/**
 * Get My Giving Profile
 *
 * CW-BE4: the caller's own giving-profile curation — share flags, module
 * toggles, amount display policy, and the pin/hide/collection selections.
 *
 * GET-OR-DEFAULT: a user who has never saved reads the canonical default-off
 * profile (sharing off, all modules on, bucketed amounts, empty curation), NOT
 * a 404 — so the editor renders identically before and after the first save and
 * the client needs no absent-profile branch.
 */
export const usersGetMyGivingProfileOptions = (options?: Options<UsersGetMyGivingProfileData>) => queryOptions<UsersGetMyGivingProfileResponse, DefaultError, UsersGetMyGivingProfileResponse, ReturnType<typeof usersGetMyGivingProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetMyGivingProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetMyGivingProfileQueryKey(options)
});

/**
 * Update My Giving Profile
 *
 * CW-BE4: partial update of the caller's giving profile, returning the
 * stored profile.
 *
 * Only the keys the client SENT are applied (`exclude_unset`), so omitted !=
 * cleared — a client flipping `sharing_enabled` off never disturbs the pins.
 * The owner is `user.id`, router-injected; `extra="forbid"` on the body means
 * nothing server-owned can be spread in, and an unknown `modules` key is a 400
 * rather than a silently-ignored toggle.
 */
export const usersUpdateMyGivingProfileMutation = (options?: Partial<Options<UsersUpdateMyGivingProfileData>>): UseMutationOptions<UsersUpdateMyGivingProfileResponse, UsersUpdateMyGivingProfileError, Options<UsersUpdateMyGivingProfileData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateMyGivingProfileResponse, UsersUpdateMyGivingProfileError, Options<UsersUpdateMyGivingProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateMyGivingProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Graduate User
 *
 * Explicit authenticated age-of-majority terms re-acceptance ceremony.
 */
export const usersGraduateUserMutation = (options?: Partial<Options<UsersGraduateUserData>>): UseMutationOptions<UsersGraduateUserResponse, UsersGraduateUserError, Options<UsersGraduateUserData>> => {
    const mutationOptions: UseMutationOptions<UsersGraduateUserResponse, UsersGraduateUserError, Options<UsersGraduateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersGraduateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsListMyGroupInvitationsQueryKey = (options?: Options<GroupsListMyGroupInvitationsData>) => createQueryKey('groups-list_my_group_invitations', options);

/**
 * List My Group Invitations
 *
 * My pending group invitations (analog `GET /users/me/fundraiser-invitations`).
 */
export const groupsListMyGroupInvitationsOptions = (options?: Options<GroupsListMyGroupInvitationsData>) => queryOptions<GroupsListMyGroupInvitationsResponse, GroupsListMyGroupInvitationsError, GroupsListMyGroupInvitationsResponse, ReturnType<typeof groupsListMyGroupInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsListMyGroupInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsListMyGroupInvitationsQueryKey(options)
});

export const groupsListMyGroupsQueryKey = (options?: Options<GroupsListMyGroupsData>) => createQueryKey('groups-list_my_groups', options);

/**
 * List My Groups
 *
 * A single paginated list of the caller's groups INCLUDING DRAFT rows (each
 * with an explicit `status`; never a separate undocumented draft array).
 */
export const groupsListMyGroupsOptions = (options?: Options<GroupsListMyGroupsData>) => queryOptions<GroupsListMyGroupsResponse, GroupsListMyGroupsError, GroupsListMyGroupsResponse, ReturnType<typeof groupsListMyGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsListMyGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsListMyGroupsQueryKey(options)
});

export const groupsListGuardianApprovalsQueryKey = (options?: Options<GroupsListGuardianApprovalsData>) => createQueryKey('groups-list_guardian_approvals', options);

/**
 * List Guardian Approvals
 */
export const groupsListGuardianApprovalsOptions = (options?: Options<GroupsListGuardianApprovalsData>) => queryOptions<GroupsListGuardianApprovalsResponse, GroupsListGuardianApprovalsError, GroupsListGuardianApprovalsResponse, ReturnType<typeof groupsListGuardianApprovalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsListGuardianApprovals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsListGuardianApprovalsQueryKey(options)
});

/**
 * Approve Guardian Membership
 */
export const groupsApproveGuardianMembershipMutation = (options?: Partial<Options<GroupsApproveGuardianMembershipData>>): UseMutationOptions<GroupsApproveGuardianMembershipResponse, GroupsApproveGuardianMembershipError, Options<GroupsApproveGuardianMembershipData>> => {
    const mutationOptions: UseMutationOptions<GroupsApproveGuardianMembershipResponse, GroupsApproveGuardianMembershipError, Options<GroupsApproveGuardianMembershipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsApproveGuardianMembership({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Guardian Membership
 */
export const groupsRejectGuardianMembershipMutation = (options?: Partial<Options<GroupsRejectGuardianMembershipData>>): UseMutationOptions<GroupsRejectGuardianMembershipResponse, GroupsRejectGuardianMembershipError, Options<GroupsRejectGuardianMembershipData>> => {
    const mutationOptions: UseMutationOptions<GroupsRejectGuardianMembershipResponse, GroupsRejectGuardianMembershipError, Options<GroupsRejectGuardianMembershipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsRejectGuardianMembership({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const groupsListGuardianMinorsQueryKey = (options?: Options<GroupsListGuardianMinorsData>) => createQueryKey('groups-list_guardian_minors', options);

/**
 * List Guardian Minors
 */
export const groupsListGuardianMinorsOptions = (options?: Options<GroupsListGuardianMinorsData>) => queryOptions<GroupsListGuardianMinorsResponse, GroupsListGuardianMinorsError, GroupsListGuardianMinorsResponse, ReturnType<typeof groupsListGuardianMinorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await groupsListGuardianMinors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: groupsListGuardianMinorsQueryKey(options)
});

/**
 * Update Guardian Minor Settings
 */
export const groupsUpdateGuardianMinorSettingsMutation = (options?: Partial<Options<GroupsUpdateGuardianMinorSettingsData>>): UseMutationOptions<GroupsUpdateGuardianMinorSettingsResponse, GroupsUpdateGuardianMinorSettingsError, Options<GroupsUpdateGuardianMinorSettingsData>> => {
    const mutationOptions: UseMutationOptions<GroupsUpdateGuardianMinorSettingsResponse, GroupsUpdateGuardianMinorSettingsError, Options<GroupsUpdateGuardianMinorSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsUpdateGuardianMinorSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetUserImpactQueryKey = (options?: Options<UsersGetUserImpactData>) => createQueryKey('users-get_user_impact', options);

/**
 * Get User Impact
 *
 * The self-only expanded Impact statistic (Pledges & Impact v2 — PV1-BE4 /
 * 02 §2.1 / 03 §3.4): the three buckets (Donated / Matched / Mobilized), each
 * ALL-time + YTD dollars + gift-event counts, plus the server-summed private
 * headline. Computed by SQL aggregation (never loading donation rows into
 * Python); ``GET /users/me/statistics`` is a SEPARATE, unchanged endpoint for
 * old clients. A brand-new additive endpoint — frozen-client-safe by
 * construction, ships dark (no client calls it yet). An ENGAGEMENT statistic,
 * never a tax/receipt artifact (tax firewall 02 §2.4 / 04 §3).
 */
export const usersGetUserImpactOptions = (options?: Options<UsersGetUserImpactData>) => queryOptions<UsersGetUserImpactResponse, DefaultError, UsersGetUserImpactResponse, ReturnType<typeof usersGetUserImpactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUserImpact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserImpactQueryKey(options)
});

export const usersGetUserImpactMethodologyQueryKey = (options?: Options<UsersGetUserImpactMethodologyData>) => createQueryKey('users-get_user_impact_methodology', options);

/**
 * Get User Impact Methodology
 *
 * Versioned, backend-served methodology copy for the Impact statistic ("How
 * is this calculated?", PV1-BE4 / 03 §3.4). Served as a versioned CONSTANT (not
 * a DB registry — display copy, not a legal-consent artifact) so labeling /
 * methodology wording changes ship with a deploy and need NO app release. The
 * copy never implies tax deductibility and is never an "Impact Statement" (tax
 * firewall 02 §2.4 / 04 §3). App-Check-gated but ANONYMOUS-TOLERANT: despite
 * the ``/users/me`` mount, the handler deliberately never checks
 * ``request.state.user`` — the copy is public display text, per-environment
 * not per-user, so there is nothing caller-specific to protect. Do NOT add an
 * auth check (a shipped client fetching it pre-auth must keep working).
 */
export const usersGetUserImpactMethodologyOptions = (options?: Options<UsersGetUserImpactMethodologyData>) => queryOptions<UsersGetUserImpactMethodologyResponse, DefaultError, UsersGetUserImpactMethodologyResponse, ReturnType<typeof usersGetUserImpactMethodologyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUserImpactMethodology({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserImpactMethodologyQueryKey(options)
});

export const importedReceiptsListImportedDonationsQueryKey = (options?: Options<ImportedReceiptsListImportedDonationsData>) => createQueryKey('imported-receipts-list_imported_donations', options);

/**
 * List Imported Donations
 *
 * The confirmed-entries timeline feed (wire contract §2.6): the house
 * paginated envelope of §1 ``imported_donation`` rows, newest donation-date
 * first, optional ``filter[tax_year]``.
 */
export const importedReceiptsListImportedDonationsOptions = (options?: Options<ImportedReceiptsListImportedDonationsData>) => queryOptions<ImportedReceiptsListImportedDonationsResponse, ImportedReceiptsListImportedDonationsError, ImportedReceiptsListImportedDonationsResponse, ReturnType<typeof importedReceiptsListImportedDonationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await importedReceiptsListImportedDonations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: importedReceiptsListImportedDonationsQueryKey(options)
});

export const importedReceiptsExportImportedDonationsCsvQueryKey = (options?: Options<ImportedReceiptsExportImportedDonationsCsvData>) => createQueryKey('imported-receipts-export_imported_donations_csv', options);

/**
 * Export Imported Donations Csv
 *
 * The giving-rows CSV (wire contract §2.9 / plan §1.6): row 1 = the fixed
 * header note, row 2 = the exact column list, then ``source=givmo`` platform
 * rows + ``source=imported`` entries — as stated, RFC-4180, streamed. No
 * totals row, no deductible column, ever. Optional ``filter[tax_year]``
 * scopes the rows and names the file. Declared BEFORE any `{id}` sibling path
 * so `export.csv` can never be captured as a path param (today the only one
 * is the ER-BE9 entry DELETE — a different method).
 */
export const importedReceiptsExportImportedDonationsCsvOptions = (options?: Options<ImportedReceiptsExportImportedDonationsCsvData>) => queryOptions<ImportedReceiptsExportImportedDonationsCsvResponse, ImportedReceiptsExportImportedDonationsCsvError, ImportedReceiptsExportImportedDonationsCsvResponse, ReturnType<typeof importedReceiptsExportImportedDonationsCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await importedReceiptsExportImportedDonationsCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: importedReceiptsExportImportedDonationsCsvQueryKey(options)
});

/**
 * Delete Imported Donation
 *
 * Delete one confirmed entry (wire contract §2.7): 204. The entry only —
 * its document stays in the vault with ``imported_donation_id`` null again and
 * can be confirmed again.
 */
export const importedReceiptsDeleteImportedDonationMutation = (options?: Partial<Options<ImportedReceiptsDeleteImportedDonationData>>): UseMutationOptions<ImportedReceiptsDeleteImportedDonationResponse, ImportedReceiptsDeleteImportedDonationError, Options<ImportedReceiptsDeleteImportedDonationData>> => {
    const mutationOptions: UseMutationOptions<ImportedReceiptsDeleteImportedDonationResponse, ImportedReceiptsDeleteImportedDonationError, Options<ImportedReceiptsDeleteImportedDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importedReceiptsDeleteImportedDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const importedReceiptsListImportedReceiptsQueryKey = (options?: Options<ImportedReceiptsListImportedReceiptsData>) => createQueryKey('imported-receipts-list_imported_receipts', options);

/**
 * List Imported Receipts
 *
 * The caller's vault, newest-first (wire contract §2.3): the house
 * paginated envelope of §1 documents in the LIST projection (no
 * ``document_url``/``derivative_urls`` keys), optional ``filter[status]``.
 * Match display is re-resolved for THIS request (F1b — the Hawaii rail is
 * viewer-conditional and never trusted from the bake).
 */
export const importedReceiptsListImportedReceiptsOptions = (options?: Options<ImportedReceiptsListImportedReceiptsData>) => queryOptions<ImportedReceiptsListImportedReceiptsResponse, ImportedReceiptsListImportedReceiptsError, ImportedReceiptsListImportedReceiptsResponse, ReturnType<typeof importedReceiptsListImportedReceiptsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await importedReceiptsListImportedReceipts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: importedReceiptsListImportedReceiptsQueryKey(options)
});

/**
 * Request Imported Receipt Upload Url
 *
 * Mint a short-lived signed PUT into the restricted imported-receipts
 * bucket + the ``awaiting_upload`` document row. The signed URL is bound to
 * the declared content type, carries ``Content-Disposition: attachment``, and
 * bakes the 1..max_bytes ``x-goog-content-length-range`` condition into the
 * signature, so GCS itself refuses an oversize body. Per-user quotas
 * (rolling-24h + vault total) 429 here; the caller's expired orphan mints are
 * lazily GC'd first so they never eat quota.
 */
export const importedReceiptsRequestImportedReceiptUploadUrlMutation = (options?: Partial<Options<ImportedReceiptsRequestImportedReceiptUploadUrlData>>): UseMutationOptions<ImportedReceiptsRequestImportedReceiptUploadUrlResponse, ImportedReceiptsRequestImportedReceiptUploadUrlError, Options<ImportedReceiptsRequestImportedReceiptUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<ImportedReceiptsRequestImportedReceiptUploadUrlResponse, ImportedReceiptsRequestImportedReceiptUploadUrlError, Options<ImportedReceiptsRequestImportedReceiptUploadUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importedReceiptsRequestImportedReceiptUploadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Imported Receipt
 *
 * Delete one document (wire contract §2.8): 204. The row, any linked entry
 * (CASCADE), and every stored generation of the original and its page rasters
 * on the versioned bucket (removed after the row's commit, best-effort).
 */
export const importedReceiptsDeleteImportedReceiptMutation = (options?: Partial<Options<ImportedReceiptsDeleteImportedReceiptData>>): UseMutationOptions<ImportedReceiptsDeleteImportedReceiptResponse, ImportedReceiptsDeleteImportedReceiptError, Options<ImportedReceiptsDeleteImportedReceiptData>> => {
    const mutationOptions: UseMutationOptions<ImportedReceiptsDeleteImportedReceiptResponse, ImportedReceiptsDeleteImportedReceiptError, Options<ImportedReceiptsDeleteImportedReceiptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importedReceiptsDeleteImportedReceipt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const importedReceiptsGetImportedReceiptQueryKey = (options: Options<ImportedReceiptsGetImportedReceiptData>) => createQueryKey('imported-receipts-get_imported_receipt', options);

/**
 * Get Imported Receipt
 *
 * The owner's document detail (wire contract §2.4): the §1 document WITH
 * the per-request ~15-min signed GETs (``document_url`` +
 * ``derivative_urls``) — minted per request, never persisted, owner-only
 * (another user's id 404s indistinguishably).
 */
export const importedReceiptsGetImportedReceiptOptions = (options: Options<ImportedReceiptsGetImportedReceiptData>) => queryOptions<ImportedReceiptsGetImportedReceiptResponse, ImportedReceiptsGetImportedReceiptError, ImportedReceiptsGetImportedReceiptResponse, ReturnType<typeof importedReceiptsGetImportedReceiptQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await importedReceiptsGetImportedReceipt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: importedReceiptsGetImportedReceiptQueryKey(options)
});

/**
 * Confirm Imported Receipt
 *
 * Confirm the reviewed document into an imported donation (wire contract
 * §2.5): 201 with the entry + non-blocking warnings. The tier is
 * server-computed (a client-sent tier field 400s); the
 * ``RECEIPT_IMPORT_CONFIRM`` impression records in the same UoW (fail-closed
 * 409 40903 without a LIVE disclosure); GCF's own receipt 422s (absorb).
 */
export const importedReceiptsConfirmImportedReceiptMutation = (options?: Partial<Options<ImportedReceiptsConfirmImportedReceiptData>>): UseMutationOptions<ImportedReceiptsConfirmImportedReceiptResponse, ImportedReceiptsConfirmImportedReceiptError, Options<ImportedReceiptsConfirmImportedReceiptData>> => {
    const mutationOptions: UseMutationOptions<ImportedReceiptsConfirmImportedReceiptResponse, ImportedReceiptsConfirmImportedReceiptError, Options<ImportedReceiptsConfirmImportedReceiptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importedReceiptsConfirmImportedReceipt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register Imported Receipt
 *
 * Register a completed upload on the caller's OWN ``awaiting_upload`` row:
 * blob exists-check, libmagic sniff of the STORED bytes (must be allow-listed
 * AND match the bound type's family), sha256, per-user dedup (409 with the
 * existing document id), signed-PUT-window expiry (410, row GC'd). 202 with
 * the ``registered`` document; the fresh path enqueues the ER-BE6 extraction
 * worker post-commit (the idempotent replay never re-enqueues).
 */
export const importedReceiptsRegisterImportedReceiptMutation = (options?: Partial<Options<ImportedReceiptsRegisterImportedReceiptData>>): UseMutationOptions<ImportedReceiptsRegisterImportedReceiptResponse, ImportedReceiptsRegisterImportedReceiptError, Options<ImportedReceiptsRegisterImportedReceiptData>> => {
    const mutationOptions: UseMutationOptions<ImportedReceiptsRegisterImportedReceiptResponse, ImportedReceiptsRegisterImportedReceiptError, Options<ImportedReceiptsRegisterImportedReceiptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importedReceiptsRegisterImportedReceipt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fundraiserMatchOfferRequestsListOwnMatchOfferRequestsQueryKey = (options?: Options<FundraiserMatchOfferRequestsListOwnMatchOfferRequestsData>) => createQueryKey('fundraiser-match-offer-requests-list_own_match_offer_requests', options);

/**
 * List Own Match Offer Requests
 */
export const fundraiserMatchOfferRequestsListOwnMatchOfferRequestsOptions = (options?: Options<FundraiserMatchOfferRequestsListOwnMatchOfferRequestsData>) => queryOptions<FundraiserMatchOfferRequestsListOwnMatchOfferRequestsResponse, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsError, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsResponse, ReturnType<typeof fundraiserMatchOfferRequestsListOwnMatchOfferRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fundraiserMatchOfferRequestsListOwnMatchOfferRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fundraiserMatchOfferRequestsListOwnMatchOfferRequestsQueryKey(options)
});

/**
 * Withdraw Match Offer Request
 */
export const fundraiserMatchOfferRequestsWithdrawMatchOfferRequestMutation = (options?: Partial<Options<FundraiserMatchOfferRequestsWithdrawMatchOfferRequestData>>): UseMutationOptions<FundraiserMatchOfferRequestsWithdrawMatchOfferRequestResponse, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestError, Options<FundraiserMatchOfferRequestsWithdrawMatchOfferRequestData>> => {
    const mutationOptions: UseMutationOptions<FundraiserMatchOfferRequestsWithdrawMatchOfferRequestResponse, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestError, Options<FundraiserMatchOfferRequestsWithdrawMatchOfferRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fundraiserMatchOfferRequestsWithdrawMatchOfferRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const matchOffersListMyMatchOffersQueryKey = (options?: Options<MatchOffersListMyMatchOffersData>) => createQueryKey('match-offers-list_my_match_offers', options);

/**
 * List My Match Offers
 *
 * The offeror's own offers (03 §2.4), newest-first, all statuses — each item
 * carries its legs (per-leg claimed totals + display consent-status). Domain-
 * scoped, no wallet-history breakout.
 */
export const matchOffersListMyMatchOffersOptions = (options?: Options<MatchOffersListMyMatchOffersData>) => queryOptions<MatchOffersListMyMatchOffersResponse, MatchOffersListMyMatchOffersError, MatchOffersListMyMatchOffersResponse, ReturnType<typeof matchOffersListMyMatchOffersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await matchOffersListMyMatchOffers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: matchOffersListMyMatchOffersQueryKey(options)
});

/**
 * Create Match Offer
 *
 * Create a match offer + its backing HARD wallet-hold reservation (02 §1.2).
 * Atomic: the offer + legs + the ``match_offer`` wallet_hold commit together or
 * not at all. A short ``available_balance`` → 409 ``DEPOSIT_FUNDS_REQUIRED`` with
 * nothing persisted. ``Idempotency-Key`` is REQUIRED (fail-closed 422 if absent).
 */
export const matchOffersCreateMatchOfferMutation = (options?: Partial<Options<MatchOffersCreateMatchOfferData>>): UseMutationOptions<MatchOffersCreateMatchOfferResponse, MatchOffersCreateMatchOfferError, Options<MatchOffersCreateMatchOfferData>> => {
    const mutationOptions: UseMutationOptions<MatchOffersCreateMatchOfferResponse, MatchOffersCreateMatchOfferError, Options<MatchOffersCreateMatchOfferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await matchOffersCreateMatchOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const matchOffersGetMyMatchOfferQueryKey = (options: Options<MatchOffersGetMyMatchOfferData>) => createQueryKey('match-offers-get_my_match_offer', options);

/**
 * Get My Match Offer
 *
 * One owned offer with per-leg claimed totals + the claims list (03 §2.4).
 * A non-owned/absent id → 404 (non-enumeration).
 */
export const matchOffersGetMyMatchOfferOptions = (options: Options<MatchOffersGetMyMatchOfferData>) => queryOptions<MatchOffersGetMyMatchOfferResponse, MatchOffersGetMyMatchOfferError, MatchOffersGetMyMatchOfferResponse, ReturnType<typeof matchOffersGetMyMatchOfferQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await matchOffersGetMyMatchOffer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: matchOffersGetMyMatchOfferQueryKey(options)
});

/**
 * Cancel Match Offer
 *
 * Cancel a match offer (02 §1.3). Offeror-only. Releases ONLY the unclaimed
 * remainder (claimed amounts stay reserved — irrevocable), sets the offer
 * ``cancelled`` + every leg ``ended``. A non-owned/absent id → 404; an already-
 * exhausted/expired offer → 409. Idempotent (a re-cancel is a no-op).
 */
export const matchOffersCancelMatchOfferMutation = (options?: Partial<Options<MatchOffersCancelMatchOfferData>>): UseMutationOptions<MatchOffersCancelMatchOfferResponse, MatchOffersCancelMatchOfferError, Options<MatchOffersCancelMatchOfferData>> => {
    const mutationOptions: UseMutationOptions<MatchOffersCancelMatchOfferResponse, MatchOffersCancelMatchOfferError, Options<MatchOffersCancelMatchOfferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await matchOffersCancelMatchOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Redirect Match Claim
 *
 * Redirect a DECLINED match claim to an alternate eligible charity (PV2-BE8 —
 * the Terms X.3 ask's answer; the D-PV-9 decline/redirect path). Offeror-only
 * (non-owned/absent offer or claim → 404, non-enumeration). The alternate must
 * differ from the declined charity and pass the SAME settlement-time screens;
 * on success the held claim amount is consumed into a wallet-funded grant leg
 * to the alternate and the claim settles with a durable audit trail. A claim
 * not awaiting an alternate → 409 ``CLAIM_NOT_REDIRECTABLE`` (a replay naming
 * the already-granted alternate returns the recorded success); an offer under
 * admin review → 409 ``OFFER_UNDER_ADMIN_REVIEW``. ``Idempotency-Key`` is
 * REQUIRED (fail-closed 422 if absent).
 */
export const matchOffersRedirectMatchClaimMutation = (options?: Partial<Options<MatchOffersRedirectMatchClaimData>>): UseMutationOptions<MatchOffersRedirectMatchClaimResponse, MatchOffersRedirectMatchClaimError, Options<MatchOffersRedirectMatchClaimData>> => {
    const mutationOptions: UseMutationOptions<MatchOffersRedirectMatchClaimResponse, MatchOffersRedirectMatchClaimError, Options<MatchOffersRedirectMatchClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await matchOffersRedirectMatchClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const donationMatchesGetMyMatchesQueryKey = (options?: Options<DonationMatchesGetMyMatchesData>) => createQueryKey('donation-matches-get_my_matches', options);

/**
 * Get My Matches
 */
export const donationMatchesGetMyMatchesOptions = (options?: Options<DonationMatchesGetMyMatchesData>) => queryOptions<DonationMatchesGetMyMatchesResponse, DefaultError, DonationMatchesGetMyMatchesResponse, ReturnType<typeof donationMatchesGetMyMatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await donationMatchesGetMyMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: donationMatchesGetMyMatchesQueryKey(options)
});

export const usersGetMyMembershipsQueryKey = (options?: Options<UsersGetMyMembershipsData>) => createQueryKey('users-get_my_memberships', options);

/**
 * Get My Memberships
 *
 * CAM-BE2: the caller's entity memberships. v1 returns the single
 * company-admin membership as a one-element list, or [] for a non-admin.
 */
export const usersGetMyMembershipsOptions = (options?: Options<UsersGetMyMembershipsData>) => queryOptions<UsersGetMyMembershipsResponse, DefaultError, UsersGetMyMembershipsResponse, ReturnType<typeof usersGetMyMembershipsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetMyMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetMyMembershipsQueryKey(options)
});

export const notificationsGetNotificationsQueryKey = (options?: Options<NotificationsGetNotificationsData>) => createQueryKey('notifications-get_notifications', options);

/**
 * Get Notifications
 */
export const notificationsGetNotificationsOptions = (options?: Options<NotificationsGetNotificationsData>) => queryOptions<NotificationsGetNotificationsResponse, NotificationsGetNotificationsError, NotificationsGetNotificationsResponse, ReturnType<typeof notificationsGetNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notificationsGetNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: notificationsGetNotificationsQueryKey(options)
});

/**
 * Mark All Notifications Read
 */
export const notificationsMarkAllNotificationsReadMutation = (options?: Partial<Options<NotificationsMarkAllNotificationsReadData>>): UseMutationOptions<NotificationsMarkAllNotificationsReadResponse, DefaultError, Options<NotificationsMarkAllNotificationsReadData>> => {
    const mutationOptions: UseMutationOptions<NotificationsMarkAllNotificationsReadResponse, DefaultError, Options<NotificationsMarkAllNotificationsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationsMarkAllNotificationsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationsGetUnreadCountQueryKey = (options?: Options<NotificationsGetUnreadCountData>) => createQueryKey('notifications-get_unread_count', options);

/**
 * Get Unread Count
 */
export const notificationsGetUnreadCountOptions = (options?: Options<NotificationsGetUnreadCountData>) => queryOptions<NotificationsGetUnreadCountResponse, DefaultError, NotificationsGetUnreadCountResponse, ReturnType<typeof notificationsGetUnreadCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notificationsGetUnreadCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: notificationsGetUnreadCountQueryKey(options)
});

/**
 * Mark Notification Read
 */
export const notificationsMarkNotificationReadMutation = (options?: Partial<Options<NotificationsMarkNotificationReadData>>): UseMutationOptions<NotificationsMarkNotificationReadResponse, NotificationsMarkNotificationReadError, Options<NotificationsMarkNotificationReadData>> => {
    const mutationOptions: UseMutationOptions<NotificationsMarkNotificationReadResponse, NotificationsMarkNotificationReadError, Options<NotificationsMarkNotificationReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationsMarkNotificationRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const passkeysListMyPasskeysQueryKey = (options?: Options<PasskeysListMyPasskeysData>) => createQueryKey('passkeys-list_my_passkeys', options);

/**
 * List My Passkeys
 *
 * The caller's registered passkeys.
 *
 * Deliberately omits `credential_id` and `public_key`. Neither is secret, but
 * neither is useful to a client either, and the credential id is the one handle
 * an attacker holding a stolen response would want.
 */
export const passkeysListMyPasskeysOptions = (options?: Options<PasskeysListMyPasskeysData>) => queryOptions<PasskeysListMyPasskeysResponse, DefaultError, PasskeysListMyPasskeysResponse, ReturnType<typeof passkeysListMyPasskeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await passkeysListMyPasskeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: passkeysListMyPasskeysQueryKey(options)
});

/**
 * Finish Passkey Reauthentication
 *
 * Complete the re-confirmation: a Firebase custom token for the SAME account,
 * carrying `gvm_amr: ["passkey_uv"]` (CBG-SEC2 SEC2-AS).
 *
 * A credential this account does not own fails exactly like an unknown one
 * (`PASSKEY_CEREMONY_FAILED`), and the token is minted for the caller's own
 * identity whatever credential was presented, so this route cannot switch
 * accounts. The client checks the account did not change, calls
 * `signInWithCustomToken`, and re-runs the suite session login.
 */
export const passkeysFinishPasskeyReauthenticationMutation = (options?: Partial<Options<PasskeysFinishPasskeyReauthenticationData>>): UseMutationOptions<PasskeysFinishPasskeyReauthenticationResponse, PasskeysFinishPasskeyReauthenticationError, Options<PasskeysFinishPasskeyReauthenticationData>> => {
    const mutationOptions: UseMutationOptions<PasskeysFinishPasskeyReauthenticationResponse, PasskeysFinishPasskeyReauthenticationError, Options<PasskeysFinishPasskeyReauthenticationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passkeysFinishPasskeyReauthentication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Passkey Reauthentication
 *
 * Begin an account-bound passkey re-confirmation (CBG-SEC2 SEC2-AS).
 *
 * The challenge is bound to the signed-in account and `allowCredentials` lists
 * exactly its passkeys, so the platform offers only those — unlike the signed-out
 * assertion, which offers every account's. `PASSKEY_NONE_REGISTERED` (400) when
 * the account holds none; `COMPANY_SSO_REQUIRED` (400) for an employee under the
 * L4 sign-in lock. Not step-up gated: it IS the re-proof.
 */
export const passkeysStartPasskeyReauthenticationMutation = (options?: Partial<Options<PasskeysStartPasskeyReauthenticationData>>): UseMutationOptions<PasskeysStartPasskeyReauthenticationResponse, DefaultError, Options<PasskeysStartPasskeyReauthenticationData>> => {
    const mutationOptions: UseMutationOptions<PasskeysStartPasskeyReauthenticationResponse, DefaultError, Options<PasskeysStartPasskeyReauthenticationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passkeysStartPasskeyReauthentication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Finish Passkey Registration
 *
 * Complete registration — verify the attestation and store the credential.
 *
 * Requires user verification: a credential that cannot user-verify could never
 * mint a session on the assertion path, so registering one would hand the user
 * a passkey they believe protects them and which this backend always refuses.
 *
 * AS-BE50: when this sign-in still owes an employer's two-factor confirmation
 * (D-AS-28), the body also carries `custom_token`, the sign-in re-issued for the
 * same account exactly as the bound re-confirmation re-issues it; absent otherwise.
 *
 * The passkey-added email, and the Firebase read that words it (AS-BE62 #14), run
 * AFTER this 201 is sent (`BackgroundTasks`), so a slow Identity Toolkit read never
 * holds the registration's answer.
 */
export const passkeysFinishPasskeyRegistrationMutation = (options?: Partial<Options<PasskeysFinishPasskeyRegistrationData>>): UseMutationOptions<PasskeysFinishPasskeyRegistrationResponse, PasskeysFinishPasskeyRegistrationError, Options<PasskeysFinishPasskeyRegistrationData>> => {
    const mutationOptions: UseMutationOptions<PasskeysFinishPasskeyRegistrationResponse, PasskeysFinishPasskeyRegistrationError, Options<PasskeysFinishPasskeyRegistrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passkeysFinishPasskeyRegistration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Passkey Registration
 *
 * Begin registration — mint a challenge and return the creation options.
 *
 * The `options` payload is py_webauthn's own serialization, passed through
 * verbatim for the client to hand straight to the platform API. Not
 * re-modelled field by field: it is a spec structure we do not own, and any
 * transcription of ours is a chance to corrupt it.
 *
 * Rule 1 of the signing-grade factor rules (CBG-SEC2 SEC2-AS) runs here first: an
 * account that holds a passkey adds another only on a sign-in that confirmed a
 * passkey ≤ 10 minutes ago (`passkey_confirmation_required` otherwise), and an
 * account with none adds its first only ≤ 10 minutes after a sign-in that answered
 * its authenticator if it has one (`step_up_required`, action `add_passkey`,
 * otherwise). SEC2-AS2 H1-C: a phone or employer sign-in adds an account's first
 * passkey only when it is the account's only way to sign in
 * (`first_passkey_other_sign_in_required`, action `add_passkey`, otherwise; its
 * `detail` says to sign in another way).
 */
export const passkeysStartPasskeyRegistrationMutation = (options?: Partial<Options<PasskeysStartPasskeyRegistrationData>>): UseMutationOptions<PasskeysStartPasskeyRegistrationResponse, DefaultError, Options<PasskeysStartPasskeyRegistrationData>> => {
    const mutationOptions: UseMutationOptions<PasskeysStartPasskeyRegistrationResponse, DefaultError, Options<PasskeysStartPasskeyRegistrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passkeysStartPasskeyRegistration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete My Passkey
 *
 * Remove a passkey.
 *
 * Not gated on keeping at least one: a user who wants a credential gone — a
 * lost laptop, a resold phone — must be able to remove it immediately, and
 * refusing would be lock-in dressed as a safety rail.
 *
 * STEP-UP GATED (AS-BE9), at the SERVICE layer: `PasskeyService.delete_passkey`
 * carries `@require_recent_auth("delete_passkey")` beneath its
 * `@has_self_permission`. Factor removal is on the D-AS-5 set because it is the
 * move an attacker on a live session makes before taking the account, and it is
 * silent — the owner finds out when a key they still have stops working.
 *
 * The gate is DARK until `STEP_UP_AUTH_ENABLED` flips (the decorator is a pure
 * pass-through while the flag is off), so this route's behaviour is unchanged
 * today. Dark is not absent: on the flip, a stale session hitting this route
 * starts receiving a typed `step_up_required` 400 rather than a 204, and a
 * client that treats any non-204 here as a failed delete will report the wrong
 * thing to the user.
 *
 * The LAST passkey (CBG-SEC2 SEC2-AS, rule 2) goes only on a sign-in that
 * confirmed a passkey ≤ 10 minutes ago; otherwise a typed
 * `passkey_confirmation_required` 400 (action `delete_passkey`), whose cure is
 * the re-confirmation below or, for a lost passkey, the 24-hour factor reset.
 */
export const passkeysDeleteMyPasskeyMutation = (options?: Partial<Options<PasskeysDeleteMyPasskeyData>>): UseMutationOptions<PasskeysDeleteMyPasskeyResponse, PasskeysDeleteMyPasskeyError, Options<PasskeysDeleteMyPasskeyData>> => {
    const mutationOptions: UseMutationOptions<PasskeysDeleteMyPasskeyResponse, PasskeysDeleteMyPasskeyError, Options<PasskeysDeleteMyPasskeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passkeysDeleteMyPasskey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rename My Passkey
 *
 * Relabel a passkey. 404s for an unknown id AND for one belonging to another
 * user — a 403 would confirm the id exists.
 */
export const passkeysRenameMyPasskeyMutation = (options?: Partial<Options<PasskeysRenameMyPasskeyData>>): UseMutationOptions<PasskeysRenameMyPasskeyResponse, PasskeysRenameMyPasskeyError, Options<PasskeysRenameMyPasskeyData>> => {
    const mutationOptions: UseMutationOptions<PasskeysRenameMyPasskeyResponse, PasskeysRenameMyPasskeyError, Options<PasskeysRenameMyPasskeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passkeysRenameMyPasskey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update User Payment Method
 */
export const usersUpdateUserPaymentMethodMutation = (options?: Partial<Options<UsersUpdateUserPaymentMethodData>>): UseMutationOptions<UsersUpdateUserPaymentMethodResponse, UsersUpdateUserPaymentMethodError, Options<UsersUpdateUserPaymentMethodData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserPaymentMethodResponse, UsersUpdateUserPaymentMethodError, Options<UsersUpdateUserPaymentMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateUserPaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pledgesListOwnPledgesQueryKey = (options?: Options<PledgesListOwnPledgesData>) => createQueryKey('pledges-list_own_pledges', options);

/**
 * List Own Pledges
 *
 * The caller's own pledges (02 §4 "my pledges"), newest-first. Dark behind the
 * flag; authed-only.
 */
export const pledgesListOwnPledgesOptions = (options?: Options<PledgesListOwnPledgesData>) => queryOptions<PledgesListOwnPledgesResponse, DefaultError, PledgesListOwnPledgesResponse, ReturnType<typeof pledgesListOwnPledgesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pledgesListOwnPledges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pledgesListOwnPledgesQueryKey(options)
});

/**
 * Choose Pledge Amount
 *
 * Choose what your pledge pays (D-GFU-30), until its charge gate: exactly the
 * amount due (``amount_due_cents``: the locked result times your rate, at most your
 * cap), or a lower amount from $1 up to it. The third choice is the free cancel. The
 * pledge is charged the amount chosen, once, at its gate. Pledgor-only. Outside the
 * window (before the result locks, or at or after ``charge_eligible_at``) → 409
 * ``PLEDGE_CHOICE_WINDOW_CLOSED``; an amount outside the range (or any lower amount
 * when the amount due is $1 or less) → 409 ``PLEDGE_AMOUNT_OUT_OF_RANGE``; a pledge
 * no longer active → 409; a non-owned/absent id → 404. Choosing the same amount again
 * changes nothing. ``Idempotency-Key`` REQUIRED (fail-closed 422).
 */
export const pledgesChoosePledgeAmountMutation = (options?: Partial<Options<PledgesChoosePledgeAmountData>>): UseMutationOptions<PledgesChoosePledgeAmountResponse, PledgesChoosePledgeAmountError, Options<PledgesChoosePledgeAmountData>> => {
    const mutationOptions: UseMutationOptions<PledgesChoosePledgeAmountResponse, PledgesChoosePledgeAmountError, Options<PledgesChoosePledgeAmountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesChoosePledgeAmount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Pledge
 *
 * Cancel a pledge, free pre-charge (02 §4.2.3 "you control it until you're
 * charged"). Pledgor-only. Flips ACTIVE|NEEDS_REVIEW → CANCELLED; a wallet pledge
 * additionally RELEASES its hold. A non-owned/absent id → 404; an
 * already-CHARGED/FAILED/WRITTEN_OFF pledge → 409. Idempotent (a re-cancel is a
 * no-op).
 */
export const pledgesCancelPledgeMutation = (options?: Partial<Options<PledgesCancelPledgeData>>): UseMutationOptions<PledgesCancelPledgeResponse, PledgesCancelPledgeError, Options<PledgesCancelPledgeData>> => {
    const mutationOptions: UseMutationOptions<PledgesCancelPledgeResponse, PledgesCancelPledgeError, Options<PledgesCancelPledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesCancelPledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Object To Pledge
 *
 * Retired (GFU-BE45, D-GFU-30): a pledgor who disagrees with the amount no longer
 * sends it to a review. They pay a lower amount they choose
 * (``POST /users/me/pledges/{pledge_id}/amount``) or cancel
 * (``POST /users/me/pledges/{pledge_id}/cancel``), until their pledge's charge gate.
 * The path stays while the surface is dark and always answers 409
 * ``PLEDGE_OBJECTION_RETIRED``, changing nothing. ``Idempotency-Key`` REQUIRED
 * (fail-closed 422).
 */
export const pledgesObjectToPledgeMutation = (options?: Partial<Options<PledgesObjectToPledgeData>>): UseMutationOptions<PledgesObjectToPledgeResponse, PledgesObjectToPledgeError, Options<PledgesObjectToPledgeData>> => {
    const mutationOptions: UseMutationOptions<PledgesObjectToPledgeResponse, PledgesObjectToPledgeError, Options<PledgesObjectToPledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pledgesObjectToPledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postsGetMyPostsQueryKey = (options?: Options<PostsGetMyPostsData>) => createQueryKey('posts-get_my_posts', options);

/**
 * Get My Posts
 */
export const postsGetMyPostsOptions = (options?: Options<PostsGetMyPostsData>) => queryOptions<PostsGetMyPostsResponse, PostsGetMyPostsError, PostsGetMyPostsResponse, ReturnType<typeof postsGetMyPostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetMyPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetMyPostsQueryKey(options)
});

/**
 * Update User Preferences
 */
export const usersUpdateUserPreferencesMutation = (options?: Partial<Options<UsersUpdateUserPreferencesData>>): UseMutationOptions<UsersUpdateUserPreferencesResponse, UsersUpdateUserPreferencesError, Options<UsersUpdateUserPreferencesData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserPreferencesResponse, UsersUpdateUserPreferencesError, Options<UsersUpdateUserPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateUserPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload User Profile Picture
 */
export const usersUploadUserProfilePictureMutation = (options?: Partial<Options<UsersUploadUserProfilePictureData>>): UseMutationOptions<UsersUploadUserProfilePictureResponse, UsersUploadUserProfilePictureError, Options<UsersUploadUserProfilePictureData>> => {
    const mutationOptions: UseMutationOptions<UsersUploadUserProfilePictureResponse, UsersUploadUserProfilePictureError, Options<UsersUploadUserProfilePictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUploadUserProfilePicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMyQrDesignQueryKey = (options?: Options<UsersGetMyQrDesignData>) => createQueryKey('users-get_my_qr_design', options);

/**
 * Get My Qr Design
 *
 * CQ1-BE1: the caller's saved QR design spec, or DEFAULT_GIVMO_PRESET when
 * none is saved. The response is the spec object only (snake_case) — no
 * created_at/updated_at, so the wire is fully deterministic.
 */
export const usersGetMyQrDesignOptions = (options?: Options<UsersGetMyQrDesignData>) => queryOptions<UsersGetMyQrDesignResponse, DefaultError, UsersGetMyQrDesignResponse, ReturnType<typeof usersGetMyQrDesignQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetMyQrDesign({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetMyQrDesignQueryKey(options)
});

/**
 * Save My Qr Design
 *
 * CQ1-BE1: upsert the caller's QR design spec (validated by `QrDesignSpec`)
 * and return the stored spec. owner = (user, user.id), router-injected — never
 * spread from the body.
 */
export const usersSaveMyQrDesignMutation = (options?: Partial<Options<UsersSaveMyQrDesignData>>): UseMutationOptions<UsersSaveMyQrDesignResponse, UsersSaveMyQrDesignError, Options<UsersSaveMyQrDesignData>> => {
    const mutationOptions: UseMutationOptions<UsersSaveMyQrDesignResponse, UsersSaveMyQrDesignError, Options<UsersSaveMyQrDesignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersSaveMyQrDesign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMyRecurringDonationsQueryKey = (options?: Options<UsersGetMyRecurringDonationsData>) => createQueryKey('users-get_my_recurring_donations', options);

/**
 * Get My Recurring Donations
 */
export const usersGetMyRecurringDonationsOptions = (options?: Options<UsersGetMyRecurringDonationsData>) => queryOptions<UsersGetMyRecurringDonationsResponse, DefaultError, UsersGetMyRecurringDonationsResponse, ReturnType<typeof usersGetMyRecurringDonationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetMyRecurringDonations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetMyRecurringDonationsQueryKey(options)
});

/**
 * Update My Recurring Donation
 */
export const usersUpdateMyRecurringDonationMutation = (options?: Partial<Options<UsersUpdateMyRecurringDonationData>>): UseMutationOptions<UsersUpdateMyRecurringDonationResponse, UsersUpdateMyRecurringDonationError, Options<UsersUpdateMyRecurringDonationData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateMyRecurringDonationResponse, UsersUpdateMyRecurringDonationError, Options<UsersUpdateMyRecurringDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateMyRecurringDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Activate My Recurring Donation
 */
export const usersActivateMyRecurringDonationMutation = (options?: Partial<Options<UsersActivateMyRecurringDonationData>>): UseMutationOptions<UsersActivateMyRecurringDonationResponse, UsersActivateMyRecurringDonationError, Options<UsersActivateMyRecurringDonationData>> => {
    const mutationOptions: UseMutationOptions<UsersActivateMyRecurringDonationResponse, UsersActivateMyRecurringDonationError, Options<UsersActivateMyRecurringDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersActivateMyRecurringDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel My Recurring Donation
 */
export const usersCancelMyRecurringDonationMutation = (options?: Partial<Options<UsersCancelMyRecurringDonationData>>): UseMutationOptions<UsersCancelMyRecurringDonationResponse, UsersCancelMyRecurringDonationError, Options<UsersCancelMyRecurringDonationData>> => {
    const mutationOptions: UseMutationOptions<UsersCancelMyRecurringDonationResponse, UsersCancelMyRecurringDonationError, Options<UsersCancelMyRecurringDonationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersCancelMyRecurringDonation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userSecurityGetMySecurityQueryKey = (options?: Options<UserSecurityGetMySecurityData>) => createQueryKey('user-security-get_my_security', options);

/**
 * Get My Security
 *
 * The caller's factor state + per-capability client gating (AS-BE5).
 *
 * Lazily reconciles the Postgres mirror from Firebase before answering, so the
 * state reflects an enrollment the client completed without ever calling sync
 * (or that it completed and then crashed before it could).
 *
 * The response is nested (`mfa`, `capabilities`) rather than flat so P3 can add
 * an `employer_policy` block as a new sibling key. Adding a key is additive for
 * every shipped decoder; promoting a flat field into an object is not.
 */
export const userSecurityGetMySecurityOptions = (options?: Options<UserSecurityGetMySecurityData>) => queryOptions<UserSecurityGetMySecurityResponse, DefaultError, UserSecurityGetMySecurityResponse, ReturnType<typeof userSecurityGetMySecurityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userSecurityGetMySecurity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userSecurityGetMySecurityQueryKey(options)
});

/**
 * Cancel My Factor Reset
 *
 * Cancel a pending email-verified factor reset (AS-BE7b).
 *
 * The in-app half of the delayed reset's safety design: the request-time
 * security email tells the owner to come here and stop it. Without this the
 * notification could only tell them what was about to happen.
 *
 * Idempotent — cancelling with nothing pending returns the current state rather
 * than an error, so a double tap or a stale screen is not a failure.
 */
export const userSecurityCancelMyFactorResetMutation = (options?: Partial<Options<UserSecurityCancelMyFactorResetData>>): UseMutationOptions<UserSecurityCancelMyFactorResetResponse, DefaultError, Options<UserSecurityCancelMyFactorResetData>> => {
    const mutationOptions: UseMutationOptions<UserSecurityCancelMyFactorResetResponse, DefaultError, Options<UserSecurityCancelMyFactorResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecurityCancelMyFactorReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync My Factors
 *
 * Reconcile this user's factor mirror from Firebase now (AS-BE5).
 *
 * Called by the client right after it enrolls or unenrolls a factor, so the
 * mirror is right within milliseconds rather than at the next read. It cannot
 * change the user's factors — it only updates our record of them — so it is
 * safe to call at will and safe to retry.
 *
 * Returns the same body as `GET /users/me/security`, so a client can enroll →
 * sync → render without a second call.
 */
export const userSecuritySyncMyFactorsMutation = (options?: Partial<Options<UserSecuritySyncMyFactorsData>>): UseMutationOptions<UserSecuritySyncMyFactorsResponse, DefaultError, Options<UserSecuritySyncMyFactorsData>> => {
    const mutationOptions: UseMutationOptions<UserSecuritySyncMyFactorsResponse, DefaultError, Options<UserSecuritySyncMyFactorsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecuritySyncMyFactors({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mint My Recovery Codes
 *
 * Issue this account's recovery codes, once, at enrollment (AS-BE7a).
 *
 * **This response is the only time the plaintext codes exist.** They are stored
 * hashed and cannot be re-read — a client that loses this response must rotate,
 * not re-fetch. The client is expected to display them with a "I've saved
 * these" gate before leaving the screen.
 *
 * 409 (`MFA_RECOVERY_CODES_ALREADY_ISSUED`) when unused codes already exist: a
 * retried enrollment must never silently invalidate a list the user already
 * wrote down. Use the regenerate route to rotate deliberately.
 */
export const userSecurityMintMyRecoveryCodesMutation = (options?: Partial<Options<UserSecurityMintMyRecoveryCodesData>>): UseMutationOptions<UserSecurityMintMyRecoveryCodesResponse, DefaultError, Options<UserSecurityMintMyRecoveryCodesData>> => {
    const mutationOptions: UseMutationOptions<UserSecurityMintMyRecoveryCodesResponse, DefaultError, Options<UserSecurityMintMyRecoveryCodesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecurityMintMyRecoveryCodes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Regenerate My Recovery Codes
 *
 * Replace this account's recovery codes (AS-BE7a).
 *
 * Invalidates every previously-issued code, used or not — which is the point:
 * a user who thinks their list leaked must be able to kill it.
 *
 * STEP-UP GATED (AS-BE9), at the SERVICE layer:
 * `UserSecurityService.regenerate_recovery_codes` carries
 * `@require_recent_auth("regenerate_recovery_codes")`. Recovery codes are a
 * standing bypass of the second factor, so minting a fresh set is exactly as
 * sensitive as removing the factor.
 *
 * The gate is DARK until `STEP_UP_AUTH_ENABLED` flips (the decorator is a pure
 * pass-through while the flag is off), so this route's behaviour is unchanged
 * today — but on the flip a stale session gets a typed `step_up_required` 400
 * here instead of a fresh code list.
 */
export const userSecurityRegenerateMyRecoveryCodesMutation = (options?: Partial<Options<UserSecurityRegenerateMyRecoveryCodesData>>): UseMutationOptions<UserSecurityRegenerateMyRecoveryCodesResponse, DefaultError, Options<UserSecurityRegenerateMyRecoveryCodesData>> => {
    const mutationOptions: UseMutationOptions<UserSecurityRegenerateMyRecoveryCodesResponse, DefaultError, Options<UserSecurityRegenerateMyRecoveryCodesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecurityRegenerateMyRecoveryCodes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign Out Everywhere
 *
 * End every session of the caller's account — THIS one included — and every AI
 * connection and Connect partner link it holds (AS-PWL-2, R9 D-AS-27; D-AS-32; D-AS-37).
 *
 * Every notice the emailed code sends offers it. Open to every session, an emailed-code
 * one included: it is the panic button. `completed`, or `partial` when an AI-connection
 * or partner-link sweep failed (every session still ended; retry is safe); a typed,
 * retryable 503 when the session revoke itself failed and nothing was ended. After a
 * success this session's next request answers 401: signing out IS the intent.
 */
export const userSecuritySignOutEverywhereMutation = (options?: Partial<Options<UserSecuritySignOutEverywhereData>>): UseMutationOptions<UserSecuritySignOutEverywhereResponse, DefaultError, Options<UserSecuritySignOutEverywhereData>> => {
    const mutationOptions: UseMutationOptions<UserSecuritySignOutEverywhereResponse, DefaultError, Options<UserSecuritySignOutEverywhereData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecuritySignOutEverywhere({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Opt In To My Sms Notices
 *
 * Turn on account-security alert texts for this account's number (AS-BE24).
 *
 * The affirmative, unbundled, default-OFF election the §6C extension requires.
 * **It conditions nothing** — 2FA enrollment, account creation and every other
 * flow complete identically whether or not this is ever called — and there is
 * no companion endpoint that makes it mandatory.
 *
 * Takes NO phone number: the number is whatever is on the account, so there is
 * nothing for a caller to supply and nothing to point at a handset that is not
 * theirs.
 *
 * `disclosure_version` must echo the `sms_notices.disclosure.version` the
 * server served, and `surface` must name the consent experience that was
 * rendered. Both land on the consent record, which is the proof of consent
 * Twilio can demand in writing.
 *
 * **409 (`sms_opt_in_disclosure_stale`)** when the echoed version is not the
 * one currently served: the client is holding stale copy, and the cure is to
 * refetch `GET /users/me/security` and re-render the disclosure — never to
 * retry with a value it did not display.
 *
 * **429 (`sms_opt_in_throttled`)** when a confirmation text was already sent to
 * this number inside the last hour. Nothing is recorded in that case: neither
 * the consent nor the send happened, which is the only outcome that does not
 * misreport one of them.
 *
 * Returns the same body as `GET /users/me/security`. **Read the returned
 * `sms_notices` rather than treating 200 as "texts are on"** — an opt-in on a
 * number that is not OTP-verified is recorded honestly and still sends nothing
 * (`number_not_verified`), and a confirmation that could not be sent reports
 * `confirmation_failed`. Only `active` means a security text would arrive.
 */
export const userSecurityOptInToMySmsNoticesMutation = (options?: Partial<Options<UserSecurityOptInToMySmsNoticesData>>): UseMutationOptions<UserSecurityOptInToMySmsNoticesResponse, UserSecurityOptInToMySmsNoticesError, Options<UserSecurityOptInToMySmsNoticesData>> => {
    const mutationOptions: UseMutationOptions<UserSecurityOptInToMySmsNoticesResponse, UserSecurityOptInToMySmsNoticesError, Options<UserSecurityOptInToMySmsNoticesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecurityOptInToMySmsNotices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Opt Out Of My Sms Notices
 *
 * Turn off account-security alert texts for this account (AS-BE24).
 *
 * **Sends nothing.** The permitted message set is closed at exactly two types
 * by the amended §6C — the opt-in confirmation and the factor-reset alert — so
 * an acknowledgement text would be a third type and would void the
 * determination's holdings. The holder sees the toggle move; that is the
 * confirmation.
 *
 * Takes no body: consent must be withdrawable in one tap on the same surface
 * that took it, and there is nothing to parameterise.
 *
 * Does NOT touch the suppression store. A suppression records what the HANDSET
 * said; this records what the ACCOUNT HOLDER decided. They are different facts
 * with different cures, and conflating them would make a later in-app opt-in
 * look like it had lifted a carrier STOP that only START can lift.
 *
 * Idempotent — withdrawing with nothing on file returns the current state
 * rather than an error.
 */
export const userSecurityOptOutOfMySmsNoticesMutation = (options?: Partial<Options<UserSecurityOptOutOfMySmsNoticesData>>): UseMutationOptions<UserSecurityOptOutOfMySmsNoticesResponse, DefaultError, Options<UserSecurityOptOutOfMySmsNoticesData>> => {
    const mutationOptions: UseMutationOptions<UserSecurityOptOutOfMySmsNoticesResponse, DefaultError, Options<UserSecurityOptOutOfMySmsNoticesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecurityOptOutOfMySmsNotices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Re Enable My Sms Notices
 *
 * Turn security-notice texts back on for this account's current number
 * (AS-BE23).
 *
 * The user-facing half of the suppression design. A STOP — or any reply the
 * inbound handler could not read as HELP, or a permanent delivery failure —
 * suppresses the number immediately and permanently; without this route the
 * only way back would be to change the number.
 *
 * Returns the same body as `GET /users/me/security`, so the client re-renders
 * the security card from one response. Read `sms_notices.status` on the way
 * back rather than assuming success: a re-enable on a number that is not
 * OTP-verified lifts nothing that matters, and the block says so
 * (`number_not_verified`) instead of implying texts will now arrive.
 *
 * Idempotent — re-enabling with nothing suppressed returns the current state
 * rather than an error, and still records the consent. Takes no body: the
 * number is whatever is on the account, so there is nothing for a caller to
 * supply and nothing for one to point at someone else's phone.
 */
export const userSecurityReEnableMySmsNoticesMutation = (options?: Partial<Options<UserSecurityReEnableMySmsNoticesData>>): UseMutationOptions<UserSecurityReEnableMySmsNoticesResponse, DefaultError, Options<UserSecurityReEnableMySmsNoticesData>> => {
    const mutationOptions: UseMutationOptions<UserSecurityReEnableMySmsNoticesResponse, DefaultError, Options<UserSecurityReEnableMySmsNoticesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecurityReEnableMySmsNotices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm My Sso Link
 *
 * Complete the ceremony: bind the asserted identity to this employment.
 *
 * **The explicit confirm of plan §5 AS-BE13** — a separate authenticated act,
 * taken after the browser ceremony returned, by the same person who started it.
 *
 * Takes no subject. The identity being bound comes from the flow row the callback
 * wrote after verifying the assertion; a body-supplied subject would let an
 * authenticated caller bind any identity they could name, which is the auto-link
 * the program forbids with a ceremony wrapped around it.
 *
 * Mints nothing. A link ceremony ends in a database row, never a credential.
 *
 * Two variants, both landing here: an existing employee binds their identity to
 * their current employment, and a new employee's assertion substitutes for the
 * 6-digit work-email code (the link itself still goes through the single
 * post-verification link writer, so `work_email` uniqueness, domain resolution,
 * the grace clock and the invite flip behave exactly as on the OTP path).
 *
 * Read `subject_matches_work_email` on the way back: FALSE is a warning to
 * surface, never a failure (plan §4). A UPN that differs from the mail alias
 * inside the same verified domain is an ordinary Entra configuration, and the
 * subject is the identity either way.
 */
export const userSecurityConfirmMySsoLinkMutation = (options?: Partial<Options<UserSecurityConfirmMySsoLinkData>>): UseMutationOptions<UserSecurityConfirmMySsoLinkResponse, UserSecurityConfirmMySsoLinkError, Options<UserSecurityConfirmMySsoLinkData>> => {
    const mutationOptions: UseMutationOptions<UserSecurityConfirmMySsoLinkResponse, UserSecurityConfirmMySsoLinkError, Options<UserSecurityConfirmMySsoLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecurityConfirmMySsoLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start My Sso Link
 *
 * Begin the ceremony: returns the URL to open in a system browser.
 *
 * **Step-up gated** (`@require_recent_auth("link_sso_identity")` on the service
 * method), and it is the ceremony's only step-up — deliberately. Step-up grants
 * are single-use AND scoped to one named action, so gating the confirm call under
 * a second action name would demand two separate re-proofs for one user-visible
 * gesture. The confirm step inherits this gate through two things a caller cannot
 * forge: the PKCE verifier that never left this device, and the check that the
 * flow's initiator is the authenticated caller.
 *
 * Takes no company id. An already-linked employee's employer is read from their
 * employment and `work_email` is ignored — a body-supplied company would let a
 * linked employee aim the ceremony at somebody else's identity provider.
 *
 * `work_email` is read ONLY by the new-employee variant, where there is no
 * employment for the employer to come from. It decides which identity provider
 * the browser is sent to and nothing else: it proves nothing and links nothing,
 * and the binding that eventually happens uses the SUBJECT the IdP asserts.
 */
export const userSecurityStartMySsoLinkMutation = (options?: Partial<Options<UserSecurityStartMySsoLinkData>>): UseMutationOptions<UserSecurityStartMySsoLinkResponse, UserSecurityStartMySsoLinkError, Options<UserSecurityStartMySsoLinkData>> => {
    const mutationOptions: UseMutationOptions<UserSecurityStartMySsoLinkResponse, UserSecurityStartMySsoLinkError, Options<UserSecurityStartMySsoLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSecurityStartMySsoLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareKitGetMyShareKitQueryKey = (options: Options<ShareKitGetMyShareKitData>) => createQueryKey('share-kit-get_my_share_kit', options);

/**
 * Get My Share Kit
 *
 * The caller's share kit for a page. The first call may mint the caller's link (the
 * share-ref family's get-or-create).
 */
export const shareKitGetMyShareKitOptions = (options: Options<ShareKitGetMyShareKitData>) => queryOptions<ShareKitGetMyShareKitResponse, ShareKitGetMyShareKitError, ShareKitGetMyShareKitResponse, ReturnType<typeof shareKitGetMyShareKitQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareKitGetMyShareKit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareKitGetMyShareKitQueryKey(options)
});

export const shareKitDownloadMyShareKitGraphicsQueryKey = (options: Options<ShareKitDownloadMyShareKitGraphicsData>) => createQueryKey('share-kit-download_my_share_kit_graphics', options);

/**
 * Download My Share Kit Graphics
 *
 * The kit's graphics as one zip: the items the kit shows for the same parameters. Shares
 * the downloads' per-network budget, fail-closed, before any storage read.
 */
export const shareKitDownloadMyShareKitGraphicsOptions = (options: Options<ShareKitDownloadMyShareKitGraphicsData>) => queryOptions<ShareKitDownloadMyShareKitGraphicsResponse, ShareKitDownloadMyShareKitGraphicsError, ShareKitDownloadMyShareKitGraphicsResponse, ReturnType<typeof shareKitDownloadMyShareKitGraphicsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareKitDownloadMyShareKitGraphics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareKitDownloadMyShareKitGraphicsQueryKey(options)
});

export const shareKitRenderMyShareKitQrQueryKey = (options: Options<ShareKitRenderMyShareKitQrData>) => createQueryKey('share-kit-render_my_share_kit_qr', options);

/**
 * Render My Share Kit Qr
 *
 * The caller's link as a QR in the organization's saved design (Givmo's preset for a page
 * no organization owns). The render limit runs first: svg per person, png and pdf per
 * network, fail-closed (the org QR's).
 */
export const shareKitRenderMyShareKitQrOptions = (options: Options<ShareKitRenderMyShareKitQrData>) => queryOptions<ShareKitRenderMyShareKitQrResponse, ShareKitRenderMyShareKitQrError, ShareKitRenderMyShareKitQrResponse, ReturnType<typeof shareKitRenderMyShareKitQrQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shareKitRenderMyShareKitQr({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shareKitRenderMyShareKitQrQueryKey(options)
});

/**
 * Mint My Share Ref
 *
 * PV1-BE3: mint (get-or-create) the caller's personal share-ref for an entity
 * (charity / cause_etf / collection / fundraiser). The share/QR sheet calls this
 * to embed the caller's attribution ref in every link/QR they generate — a
 * repeat call for the same entity returns the SAME slug (dedupe). Returns
 * ``{slug, url}`` where ``url`` is the first-party ``go.givmo.io/s/<slug>``
 * (D-PV-4). Validates the entity exists + is shareable server-side.
 */
export const usersMintMyShareRefMutation = (options?: Partial<Options<UsersMintMyShareRefData>>): UseMutationOptions<UsersMintMyShareRefResponse, UsersMintMyShareRefError, Options<UsersMintMyShareRefData>> => {
    const mutationOptions: UseMutationOptions<UsersMintMyShareRefResponse, UsersMintMyShareRefError, Options<UsersMintMyShareRefData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersMintMyShareRef({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetUserPrivateStatisticsQueryKey = (options?: Options<UsersGetUserPrivateStatisticsData>) => createQueryKey('users-get_user_private_statistics', options);

/**
 * Get User Private Statistics
 */
export const usersGetUserPrivateStatisticsOptions = (options?: Options<UsersGetUserPrivateStatisticsData>) => queryOptions<UsersGetUserPrivateStatisticsResponse, DefaultError, UsersGetUserPrivateStatisticsResponse, ReturnType<typeof usersGetUserPrivateStatisticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUserPrivateStatistics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserPrivateStatisticsQueryKey(options)
});

/**
 * Mint Step Up From Reauth
 *
 * Convert a freshly re-authenticated session into a step-up grant.
 *
 * Takes NO PROOF in the body, deliberately. The proof is the caller's OWN ID
 * token: the service re-reads its `auth_time` from the request's assurance and
 * refuses if the session is not actually fresh. Accepting a client-supplied
 * claim here would be a step-up bypass wearing the gate's clothes — the client
 * would simply assert freshness.
 *
 * What the body DOES carry (AS-BE22) is the `action` the grant is for, and the
 * body is optional in both directions — absent entirely, or present with no
 * `action`. That is not laxity: the route shipped taking no body, so a call
 * without one must keep working, and what it mints is an UNSCOPED grant that
 * satisfies no gate. A client that omits the scope therefore gets a refusal at
 * the action it retries, never a grant that opens everything.
 *
 * So the client flow is: hit a gated action → receive `step_up_required` with
 * its `action` → re-authenticate with Firebase (which mints a token with a new
 * `auth_time`) → call this with that token, echoing that same `action` → retry
 * the original action.
 *
 * Returns no token: the grant is server-side state keyed to the user, so there
 * is nothing for a client to hold, replay, or leak.
 */
export const stepUpMintStepUpFromReauthMutation = (options?: Partial<Options<StepUpMintStepUpFromReauthData>>): UseMutationOptions<StepUpMintStepUpFromReauthResponse, StepUpMintStepUpFromReauthError, Options<StepUpMintStepUpFromReauthData>> => {
    const mutationOptions: UseMutationOptions<StepUpMintStepUpFromReauthResponse, StepUpMintStepUpFromReauthError, Options<StepUpMintStepUpFromReauthData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepUpMintStepUpFromReauth({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unfollow User
 */
export const followsUnfollowUserMutation = (options?: Partial<Options<FollowsUnfollowUserData>>): UseMutationOptions<FollowsUnfollowUserResponse, FollowsUnfollowUserError, Options<FollowsUnfollowUserData>> => {
    const mutationOptions: UseMutationOptions<FollowsUnfollowUserResponse, FollowsUnfollowUserError, Options<FollowsUnfollowUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await followsUnfollowUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetUserWalletQueryKey = (options?: Options<UsersGetUserWalletData>) => createQueryKey('users-get_user_wallet', options);

/**
 * Get User Wallet
 */
export const usersGetUserWalletOptions = (options?: Options<UsersGetUserWalletData>) => queryOptions<UsersGetUserWalletResponse, DefaultError, UsersGetUserWalletResponse, ReturnType<typeof usersGetUserWalletQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUserWallet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserWalletQueryKey(options)
});

export const usersGetUserCardsQueryKey = (options?: Options<UsersGetUserCardsData>) => createQueryKey('users-get_user_cards', options);

/**
 * Get User Cards
 */
export const usersGetUserCardsOptions = (options?: Options<UsersGetUserCardsData>) => queryOptions<UsersGetUserCardsResponse, DefaultError, UsersGetUserCardsResponse, ReturnType<typeof usersGetUserCardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUserCards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserCardsQueryKey(options)
});

/**
 * Create User Card
 */
export const usersCreateUserCardMutation = (options?: Partial<Options<UsersCreateUserCardData>>): UseMutationOptions<UsersCreateUserCardResponse, UsersCreateUserCardError, Options<UsersCreateUserCardData>> => {
    const mutationOptions: UseMutationOptions<UsersCreateUserCardResponse, UsersCreateUserCardError, Options<UsersCreateUserCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersCreateUserCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete User Card
 */
export const usersDeleteUserCardMutation = (options?: Partial<Options<UsersDeleteUserCardData>>): UseMutationOptions<UsersDeleteUserCardResponse, UsersDeleteUserCardError, Options<UsersDeleteUserCardData>> => {
    const mutationOptions: UseMutationOptions<UsersDeleteUserCardResponse, UsersDeleteUserCardError, Options<UsersDeleteUserCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersDeleteUserCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deposit Funds
 */
export const usersDepositFundsMutation = (options?: Partial<Options<UsersDepositFundsData>>): UseMutationOptions<UsersDepositFundsResponse, UsersDepositFundsError, Options<UsersDepositFundsData>> => {
    const mutationOptions: UseMutationOptions<UsersDepositFundsResponse, UsersDepositFundsError, Options<UsersDepositFundsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersDepositFunds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Gift Card From Wallet
 *
 * Send a gift card funded from the caller's EXISTING wallet balance
 * (GC2-BE1 / Phase 2). An internal value transfer, NOT a new contribution:
 * the wallet is debited by exactly face (``wallet.withdraw`` through the
 * wallet-hold chokepoint), with NO Shift4 charge, NO fees, and NO tax
 * receipt. Returns the updated wallet (the redeem/deposit precedent —
 * clients refresh their balance from this response). The response NEVER
 * carries the plaintext code, so the idempotent replay of a duplicate
 * purchase_request_id is safe (no double-debit).
 */
export const giftCardsSendGiftCardFromWalletMutation = (options?: Partial<Options<GiftCardsSendGiftCardFromWalletData>>): UseMutationOptions<GiftCardsSendGiftCardFromWalletResponse, GiftCardsSendGiftCardFromWalletError, Options<GiftCardsSendGiftCardFromWalletData>> => {
    const mutationOptions: UseMutationOptions<GiftCardsSendGiftCardFromWalletResponse, GiftCardsSendGiftCardFromWalletError, Options<GiftCardsSendGiftCardFromWalletData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giftCardsSendGiftCardFromWallet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify Work Email
 */
export const usersVerifyWorkEmailMutation = (options?: Partial<Options<UsersVerifyWorkEmailData>>): UseMutationOptions<UsersVerifyWorkEmailResponse, UsersVerifyWorkEmailError, Options<UsersVerifyWorkEmailData>> => {
    const mutationOptions: UseMutationOptions<UsersVerifyWorkEmailResponse, UsersVerifyWorkEmailError, Options<UsersVerifyWorkEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersVerifyWorkEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersCheckPhoneAvailableQueryKey = (options: Options<UsersCheckPhoneAvailableData>) => createQueryKey('users-check_phone_available', options);

/**
 * Check Phone Available
 */
export const usersCheckPhoneAvailableOptions = (options: Options<UsersCheckPhoneAvailableData>) => queryOptions<UsersCheckPhoneAvailableResponse, UsersCheckPhoneAvailableError, UsersCheckPhoneAvailableResponse, ReturnType<typeof usersCheckPhoneAvailableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersCheckPhoneAvailable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersCheckPhoneAvailableQueryKey(options)
});

export const usersCheckUsernameAvailableQueryKey = (options: Options<UsersCheckUsernameAvailableData>) => createQueryKey('users-check_username_available', options);

/**
 * Check Username Available
 *
 * Username availability under the champion-handle grammar (CQ3-TIE1,
 * D-CQ-27: the username IS the champion handle). OPTIONAL auth: this path is
 * not auth-exempt, so `handler_middleware` sets `request.state.user` for a
 * valid bearer, None for a tokenless request (an invalid token still 401s).
 * The caller, when known, lets the check answer `caller_has_champion` (without
 * minting) and treat their own un-disabled RETIRED handle as available (the
 * rename-back); their own current username reads "already in use".
 */
export const usersCheckUsernameAvailableOptions = (options: Options<UsersCheckUsernameAvailableData>) => queryOptions<UsersCheckUsernameAvailableResponse, UsersCheckUsernameAvailableError, UsersCheckUsernameAvailableResponse, ReturnType<typeof usersCheckUsernameAvailableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersCheckUsernameAvailable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersCheckUsernameAvailableQueryKey(options)
});

export const usersVerifyAccessQueryKey = (options?: Options<UsersVerifyAccessData>) => createQueryKey('users-verify_access', options);

/**
 * Verify Access
 */
export const usersVerifyAccessOptions = (options?: Options<UsersVerifyAccessData>) => queryOptions<UsersVerifyAccessResponse, DefaultError, UsersVerifyAccessResponse, ReturnType<typeof usersVerifyAccessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersVerifyAccess({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersVerifyAccessQueryKey(options)
});

export const usersCheckWorkEmailQueryKey = (options: Options<UsersCheckWorkEmailData>) => createQueryKey('users-check_work_email', options);

/**
 * Check Work Email
 */
export const usersCheckWorkEmailOptions = (options: Options<UsersCheckWorkEmailData>) => queryOptions<UsersCheckWorkEmailResponse, UsersCheckWorkEmailError, UsersCheckWorkEmailResponse, ReturnType<typeof usersCheckWorkEmailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersCheckWorkEmail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersCheckWorkEmailQueryKey(options)
});

export const usersGetUserQueryKey = (options: Options<UsersGetUserData>) => createQueryKey('users-get_user', options);

/**
 * Get User
 */
export const usersGetUserOptions = (options: Options<UsersGetUserData>) => queryOptions<UsersGetUserResponse, UsersGetUserError, UsersGetUserResponse, ReturnType<typeof usersGetUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserQueryKey(options)
});

/**
 * Update User By Id
 */
export const usersUpdateUserByIdMutation = (options?: Partial<Options<UsersUpdateUserByIdData>>): UseMutationOptions<UsersUpdateUserByIdResponse, UsersUpdateUserByIdError, Options<UsersUpdateUserByIdData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserByIdResponse, UsersUpdateUserByIdError, Options<UsersUpdateUserByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdateUserById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const charityCollectionsListUserCharityCollectionsQueryKey = (options: Options<CharityCollectionsListUserCharityCollectionsData>) => createQueryKey('charity-collections-list_user_charity_collections', options);

/**
 * List User Charity Collections
 *
 * Server-side visibility-filtered list for `user_id`'s Collections — the
 * PUBLIC PROFILE ROW. The repository filters (owner sees all; a non-owner/anon
 * sees PUBLIC + ACTIVE + on-profile only — `show_on_profile == False` is dropped
 * for non-owners per D-CC-6). Token-permissive — a logged-in requester narrows
 * ownership.
 */
export const charityCollectionsListUserCharityCollectionsOptions = (options: Options<CharityCollectionsListUserCharityCollectionsData>) => queryOptions<CharityCollectionsListUserCharityCollectionsResponse, CharityCollectionsListUserCharityCollectionsError, CharityCollectionsListUserCharityCollectionsResponse, ReturnType<typeof charityCollectionsListUserCharityCollectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await charityCollectionsListUserCharityCollections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: charityCollectionsListUserCharityCollectionsQueryKey(options)
});

export const postsGetUsersPublicPostsQueryKey = (options: Options<PostsGetUsersPublicPostsData>) => createQueryKey('posts-get_users_public_posts', options);

/**
 * Get Users Public Posts
 */
export const postsGetUsersPublicPostsOptions = (options: Options<PostsGetUsersPublicPostsData>) => queryOptions<PostsGetUsersPublicPostsResponse, PostsGetUsersPublicPostsError, PostsGetUsersPublicPostsResponse, ReturnType<typeof postsGetUsersPublicPostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postsGetUsersPublicPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postsGetUsersPublicPostsQueryKey(options)
});

/**
 * Report User Profile
 *
 * Report a user's page at the ACCOUNT grain (the ``user_profile`` subject type
 * — the one that carries ``impersonation``). Auth required; append-only; a
 * missing or deleted user → 404 with a constant detail.
 */
export const profileReportsReportUserProfileMutation = (options?: Partial<Options<ProfileReportsReportUserProfileData>>): UseMutationOptions<ProfileReportsReportUserProfileResponse, ProfileReportsReportUserProfileError, Options<ProfileReportsReportUserProfileData>> => {
    const mutationOptions: UseMutationOptions<ProfileReportsReportUserProfileResponse, ProfileReportsReportUserProfileError, Options<ProfileReportsReportUserProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await profileReportsReportUserProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetUserStatisticsQueryKey = (options: Options<UsersGetUserStatisticsData>) => createQueryKey('users-get_user_statistics', options);

/**
 * Get User Statistics
 */
export const usersGetUserStatisticsOptions = (options: Options<UsersGetUserStatisticsData>) => queryOptions<UsersGetUserStatisticsResponse, UsersGetUserStatisticsError, UsersGetUserStatisticsResponse, ReturnType<typeof usersGetUserStatisticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUserStatistics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserStatisticsQueryKey(options)
});

export const companiesGetCompanyCardsV2QueryKey = (options?: Options<CompaniesGetCompanyCardsV2Data>) => createQueryKey('companies-get_company_cards_v2', options);

/**
 * Get Company Cards V2
 */
export const companiesGetCompanyCardsV2Options = (options?: Options<CompaniesGetCompanyCardsV2Data>) => queryOptions<CompaniesGetCompanyCardsV2Response, DefaultError, CompaniesGetCompanyCardsV2Response, ReturnType<typeof companiesGetCompanyCardsV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companiesGetCompanyCardsV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companiesGetCompanyCardsV2QueryKey(options)
});

/**
 * Create Company Card V2
 */
export const companiesCreateCompanyCardV2Mutation = (options?: Partial<Options<CompaniesCreateCompanyCardV2Data>>): UseMutationOptions<CompaniesCreateCompanyCardV2Response, CompaniesCreateCompanyCardV2Error, Options<CompaniesCreateCompanyCardV2Data>> => {
    const mutationOptions: UseMutationOptions<CompaniesCreateCompanyCardV2Response, CompaniesCreateCompanyCardV2Error, Options<CompaniesCreateCompanyCardV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companiesCreateCompanyCardV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetUserCardsV2QueryKey = (options?: Options<UsersGetUserCardsV2Data>) => createQueryKey('users-get_user_cards_v2', options);

/**
 * Get User Cards V2
 */
export const usersGetUserCardsV2Options = (options?: Options<UsersGetUserCardsV2Data>) => queryOptions<UsersGetUserCardsV2Response, DefaultError, UsersGetUserCardsV2Response, ReturnType<typeof usersGetUserCardsV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGetUserCardsV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetUserCardsV2QueryKey(options)
});

/**
 * Create User Card V2
 */
export const usersCreateUserCardV2Mutation = (options?: Partial<Options<UsersCreateUserCardV2Data>>): UseMutationOptions<UsersCreateUserCardV2Response, UsersCreateUserCardV2Error, Options<UsersCreateUserCardV2Data>> => {
    const mutationOptions: UseMutationOptions<UsersCreateUserCardV2Response, UsersCreateUserCardV2Error, Options<UsersCreateUserCardV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersCreateUserCardV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
